(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb13c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb13c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2PPWI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("d5yqR"));

});
parcelRegister("d5yqR", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $98767380a4764855$export$ffb0004e005737fa; }, function (v) { return $98767380a4764855$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $98767380a4764855$export$34b9dba7ce09269b; }, function (v) { return $98767380a4764855$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $98767380a4764855$export$25062201e9e25d76; }, function (v) { return $98767380a4764855$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $98767380a4764855$export$ffb0004e005737fa;
var $98767380a4764855$export$34b9dba7ce09269b;
var $98767380a4764855$export$25062201e9e25d76;
'use strict';

var $8FY87 = parcelRequire("8FY87");
var $98767380a4764855$var$k = Symbol.for("react.element"), $98767380a4764855$var$l = Symbol.for("react.fragment"), $98767380a4764855$var$m = Object.prototype.hasOwnProperty, $98767380a4764855$var$n = $8FY87.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $98767380a4764855$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $98767380a4764855$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$98767380a4764855$var$m.call(a, b) && !$98767380a4764855$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $98767380a4764855$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $98767380a4764855$var$n.current
    };
}
$98767380a4764855$export$ffb0004e005737fa = $98767380a4764855$var$l;
$98767380a4764855$export$34b9dba7ce09269b = $98767380a4764855$var$q;
$98767380a4764855$export$25062201e9e25d76 = $98767380a4764855$var$q;

});
parcelRegister("8FY87", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4rNqi"));

});
parcelRegister("4rNqi", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $33d0057184af2d0e$export$dca3b0875bd9a954; }, function (v) { return $33d0057184af2d0e$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $33d0057184af2d0e$export$16fa2f45be04daa8; }, function (v) { return $33d0057184af2d0e$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $33d0057184af2d0e$export$ffb0004e005737fa; }, function (v) { return $33d0057184af2d0e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $33d0057184af2d0e$export$e2c29f18771995cb; }, function (v) { return $33d0057184af2d0e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $33d0057184af2d0e$export$221d75b3f55bb0bd; }, function (v) { return $33d0057184af2d0e$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $33d0057184af2d0e$export$5f8d39834fd61797; }, function (v) { return $33d0057184af2d0e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $33d0057184af2d0e$export$74bf444e3cd11ea5; }, function (v) { return $33d0057184af2d0e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $33d0057184af2d0e$export$ae55be85d98224ed; }, function (v) { return $33d0057184af2d0e$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $33d0057184af2d0e$export$3ba232387fd5d6dd; }, function (v) { return $33d0057184af2d0e$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $33d0057184af2d0e$export$e530037191fcd5d7; }, function (v) { return $33d0057184af2d0e$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $33d0057184af2d0e$export$fd42f52fd3ae1109; }, function (v) { return $33d0057184af2d0e$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $33d0057184af2d0e$export$c8a8987d4410bf2d; }, function (v) { return $33d0057184af2d0e$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $33d0057184af2d0e$export$d38cd72104c1f0e9; }, function (v) { return $33d0057184af2d0e$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $33d0057184af2d0e$export$7d1e3a5e95ceca43; }, function (v) { return $33d0057184af2d0e$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $33d0057184af2d0e$export$257a8862b851cb5b; }, function (v) { return $33d0057184af2d0e$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $33d0057184af2d0e$export$a8257692ac88316c; }, function (v) { return $33d0057184af2d0e$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $33d0057184af2d0e$export$488013bae63b21da; }, function (v) { return $33d0057184af2d0e$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $33d0057184af2d0e$export$7c73462e0d25e514; }, function (v) { return $33d0057184af2d0e$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $33d0057184af2d0e$export$7568632d0d33d16d; }, function (v) { return $33d0057184af2d0e$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $33d0057184af2d0e$export$88948ce120ea2619; }, function (v) { return $33d0057184af2d0e$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $33d0057184af2d0e$export$35808ee640e87ca7; }, function (v) { return $33d0057184af2d0e$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $33d0057184af2d0e$export$fae74005e78b1a27; }, function (v) { return $33d0057184af2d0e$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $33d0057184af2d0e$export$dc8fbce3eb94dc1e; }, function (v) { return $33d0057184af2d0e$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $33d0057184af2d0e$export$6a7bc4e911dc01cf; }, function (v) { return $33d0057184af2d0e$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $33d0057184af2d0e$export$6d9c69b0de29b591; }, function (v) { return $33d0057184af2d0e$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $33d0057184af2d0e$export$f680877a34711e37; }, function (v) { return $33d0057184af2d0e$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $33d0057184af2d0e$export$d5a552a76deda3c2; }, function (v) { return $33d0057184af2d0e$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $33d0057184af2d0e$export$aaabe4eda9ed9969; }, function (v) { return $33d0057184af2d0e$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $33d0057184af2d0e$export$e5c5a5f917a5871c; }, function (v) { return $33d0057184af2d0e$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $33d0057184af2d0e$export$1538c33de8887b59; }, function (v) { return $33d0057184af2d0e$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $33d0057184af2d0e$export$13e3392192263954; }, function (v) { return $33d0057184af2d0e$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $33d0057184af2d0e$export$b8f5890fc79d6aca; }, function (v) { return $33d0057184af2d0e$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $33d0057184af2d0e$export$60241385465d0a34; }, function (v) { return $33d0057184af2d0e$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $33d0057184af2d0e$export$306c0aa65ff9ec16; }, function (v) { return $33d0057184af2d0e$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $33d0057184af2d0e$export$7b286972b8d8ccbf; }, function (v) { return $33d0057184af2d0e$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $33d0057184af2d0e$export$83d89fbfd8236492; }, function (v) { return $33d0057184af2d0e$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $33d0057184af2d0e$export$dca3b0875bd9a954;
var $33d0057184af2d0e$export$16fa2f45be04daa8;
var $33d0057184af2d0e$export$ffb0004e005737fa;
var $33d0057184af2d0e$export$e2c29f18771995cb;
var $33d0057184af2d0e$export$221d75b3f55bb0bd;
var $33d0057184af2d0e$export$5f8d39834fd61797;
var $33d0057184af2d0e$export$74bf444e3cd11ea5;
var $33d0057184af2d0e$export$ae55be85d98224ed;
var $33d0057184af2d0e$export$3ba232387fd5d6dd;
var $33d0057184af2d0e$export$e530037191fcd5d7;
var $33d0057184af2d0e$export$fd42f52fd3ae1109;
var $33d0057184af2d0e$export$c8a8987d4410bf2d;
var $33d0057184af2d0e$export$d38cd72104c1f0e9;
var $33d0057184af2d0e$export$7d1e3a5e95ceca43;
var $33d0057184af2d0e$export$257a8862b851cb5b;
var $33d0057184af2d0e$export$a8257692ac88316c;
var $33d0057184af2d0e$export$488013bae63b21da;
var $33d0057184af2d0e$export$7c73462e0d25e514;
var $33d0057184af2d0e$export$7568632d0d33d16d;
var $33d0057184af2d0e$export$88948ce120ea2619;
var $33d0057184af2d0e$export$35808ee640e87ca7;
var $33d0057184af2d0e$export$fae74005e78b1a27;
var $33d0057184af2d0e$export$dc8fbce3eb94dc1e;
var $33d0057184af2d0e$export$6a7bc4e911dc01cf;
var $33d0057184af2d0e$export$6d9c69b0de29b591;
var $33d0057184af2d0e$export$f680877a34711e37;
var $33d0057184af2d0e$export$d5a552a76deda3c2;
var $33d0057184af2d0e$export$aaabe4eda9ed9969;
var $33d0057184af2d0e$export$e5c5a5f917a5871c;
var $33d0057184af2d0e$export$1538c33de8887b59;
var $33d0057184af2d0e$export$13e3392192263954;
var $33d0057184af2d0e$export$b8f5890fc79d6aca;
var $33d0057184af2d0e$export$60241385465d0a34;
var $33d0057184af2d0e$export$306c0aa65ff9ec16;
var $33d0057184af2d0e$export$7b286972b8d8ccbf;
var $33d0057184af2d0e$export$83d89fbfd8236492;
'use strict';
var $33d0057184af2d0e$var$l = Symbol.for("react.element"), $33d0057184af2d0e$var$n = Symbol.for("react.portal"), $33d0057184af2d0e$var$p = Symbol.for("react.fragment"), $33d0057184af2d0e$var$q = Symbol.for("react.strict_mode"), $33d0057184af2d0e$var$r = Symbol.for("react.profiler"), $33d0057184af2d0e$var$t = Symbol.for("react.provider"), $33d0057184af2d0e$var$u = Symbol.for("react.context"), $33d0057184af2d0e$var$v = Symbol.for("react.forward_ref"), $33d0057184af2d0e$var$w = Symbol.for("react.suspense"), $33d0057184af2d0e$var$x = Symbol.for("react.memo"), $33d0057184af2d0e$var$y = Symbol.for("react.lazy"), $33d0057184af2d0e$var$z = Symbol.iterator;
function $33d0057184af2d0e$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $33d0057184af2d0e$var$z && a[$33d0057184af2d0e$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $33d0057184af2d0e$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $33d0057184af2d0e$var$C = Object.assign, $33d0057184af2d0e$var$D = {};
function $33d0057184af2d0e$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $33d0057184af2d0e$var$D;
    this.updater = e || $33d0057184af2d0e$var$B;
}
$33d0057184af2d0e$var$E.prototype.isReactComponent = {};
$33d0057184af2d0e$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$33d0057184af2d0e$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $33d0057184af2d0e$var$F() {}
$33d0057184af2d0e$var$F.prototype = $33d0057184af2d0e$var$E.prototype;
function $33d0057184af2d0e$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $33d0057184af2d0e$var$D;
    this.updater = e || $33d0057184af2d0e$var$B;
}
var $33d0057184af2d0e$var$H = $33d0057184af2d0e$var$G.prototype = new $33d0057184af2d0e$var$F;
$33d0057184af2d0e$var$H.constructor = $33d0057184af2d0e$var$G;
$33d0057184af2d0e$var$C($33d0057184af2d0e$var$H, $33d0057184af2d0e$var$E.prototype);
$33d0057184af2d0e$var$H.isPureReactComponent = !0;
var $33d0057184af2d0e$var$I = Array.isArray, $33d0057184af2d0e$var$J = Object.prototype.hasOwnProperty, $33d0057184af2d0e$var$K = {
    current: null
}, $33d0057184af2d0e$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $33d0057184af2d0e$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$33d0057184af2d0e$var$J.call(b, d) && !$33d0057184af2d0e$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $33d0057184af2d0e$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $33d0057184af2d0e$var$K.current
    };
}
function $33d0057184af2d0e$var$N(a, b) {
    return {
        $$typeof: $33d0057184af2d0e$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $33d0057184af2d0e$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $33d0057184af2d0e$var$l;
}
function $33d0057184af2d0e$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $33d0057184af2d0e$var$P = /\/+/g;
function $33d0057184af2d0e$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $33d0057184af2d0e$var$escape("" + a.key) : b.toString(36);
}
function $33d0057184af2d0e$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $33d0057184af2d0e$var$l:
                case $33d0057184af2d0e$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $33d0057184af2d0e$var$Q(h, 0) : d, $33d0057184af2d0e$var$I(c) ? (e = "", null != a && (e = a.replace($33d0057184af2d0e$var$P, "$&/") + "/"), $33d0057184af2d0e$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($33d0057184af2d0e$var$O(c) && (c = $33d0057184af2d0e$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($33d0057184af2d0e$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($33d0057184af2d0e$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $33d0057184af2d0e$var$Q(k, g);
        h += $33d0057184af2d0e$var$R(k, b, e, f, c);
    }
    else if (f = $33d0057184af2d0e$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $33d0057184af2d0e$var$Q(k, g++), h += $33d0057184af2d0e$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $33d0057184af2d0e$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $33d0057184af2d0e$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $33d0057184af2d0e$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $33d0057184af2d0e$var$U = {
    current: null
}, $33d0057184af2d0e$var$V = {
    transition: null
}, $33d0057184af2d0e$var$W = {
    ReactCurrentDispatcher: $33d0057184af2d0e$var$U,
    ReactCurrentBatchConfig: $33d0057184af2d0e$var$V,
    ReactCurrentOwner: $33d0057184af2d0e$var$K
};
function $33d0057184af2d0e$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$33d0057184af2d0e$export$dca3b0875bd9a954 = {
    map: $33d0057184af2d0e$var$S,
    forEach: function(a, b, e) {
        $33d0057184af2d0e$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $33d0057184af2d0e$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $33d0057184af2d0e$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$33d0057184af2d0e$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$33d0057184af2d0e$export$16fa2f45be04daa8 = $33d0057184af2d0e$var$E;
$33d0057184af2d0e$export$ffb0004e005737fa = $33d0057184af2d0e$var$p;
$33d0057184af2d0e$export$e2c29f18771995cb = $33d0057184af2d0e$var$r;
$33d0057184af2d0e$export$221d75b3f55bb0bd = $33d0057184af2d0e$var$G;
$33d0057184af2d0e$export$5f8d39834fd61797 = $33d0057184af2d0e$var$q;
$33d0057184af2d0e$export$74bf444e3cd11ea5 = $33d0057184af2d0e$var$w;
$33d0057184af2d0e$export$ae55be85d98224ed = $33d0057184af2d0e$var$W;
$33d0057184af2d0e$export$3ba232387fd5d6dd = $33d0057184af2d0e$var$X;
$33d0057184af2d0e$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $33d0057184af2d0e$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $33d0057184af2d0e$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$33d0057184af2d0e$var$J.call(b, f) && !$33d0057184af2d0e$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $33d0057184af2d0e$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$33d0057184af2d0e$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $33d0057184af2d0e$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $33d0057184af2d0e$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$33d0057184af2d0e$export$c8a8987d4410bf2d = $33d0057184af2d0e$var$M;
$33d0057184af2d0e$export$d38cd72104c1f0e9 = function(a) {
    var b = $33d0057184af2d0e$var$M.bind(null, a);
    b.type = a;
    return b;
};
$33d0057184af2d0e$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$33d0057184af2d0e$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $33d0057184af2d0e$var$v,
        render: a
    };
};
$33d0057184af2d0e$export$a8257692ac88316c = $33d0057184af2d0e$var$O;
$33d0057184af2d0e$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $33d0057184af2d0e$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $33d0057184af2d0e$var$T
    };
};
$33d0057184af2d0e$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $33d0057184af2d0e$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$33d0057184af2d0e$export$7568632d0d33d16d = function(a) {
    var b = $33d0057184af2d0e$var$V.transition;
    $33d0057184af2d0e$var$V.transition = {};
    try {
        a();
    } finally{
        $33d0057184af2d0e$var$V.transition = b;
    }
};
$33d0057184af2d0e$export$88948ce120ea2619 = $33d0057184af2d0e$var$X;
$33d0057184af2d0e$export$35808ee640e87ca7 = function(a, b) {
    return $33d0057184af2d0e$var$U.current.useCallback(a, b);
};
$33d0057184af2d0e$export$fae74005e78b1a27 = function(a) {
    return $33d0057184af2d0e$var$U.current.useContext(a);
};
$33d0057184af2d0e$export$dc8fbce3eb94dc1e = function() {};
$33d0057184af2d0e$export$6a7bc4e911dc01cf = function(a) {
    return $33d0057184af2d0e$var$U.current.useDeferredValue(a);
};
$33d0057184af2d0e$export$6d9c69b0de29b591 = function(a, b) {
    return $33d0057184af2d0e$var$U.current.useEffect(a, b);
};
$33d0057184af2d0e$export$f680877a34711e37 = function() {
    return $33d0057184af2d0e$var$U.current.useId();
};
$33d0057184af2d0e$export$d5a552a76deda3c2 = function(a, b, e) {
    return $33d0057184af2d0e$var$U.current.useImperativeHandle(a, b, e);
};
$33d0057184af2d0e$export$aaabe4eda9ed9969 = function(a, b) {
    return $33d0057184af2d0e$var$U.current.useInsertionEffect(a, b);
};
$33d0057184af2d0e$export$e5c5a5f917a5871c = function(a, b) {
    return $33d0057184af2d0e$var$U.current.useLayoutEffect(a, b);
};
$33d0057184af2d0e$export$1538c33de8887b59 = function(a, b) {
    return $33d0057184af2d0e$var$U.current.useMemo(a, b);
};
$33d0057184af2d0e$export$13e3392192263954 = function(a, b, e) {
    return $33d0057184af2d0e$var$U.current.useReducer(a, b, e);
};
$33d0057184af2d0e$export$b8f5890fc79d6aca = function(a) {
    return $33d0057184af2d0e$var$U.current.useRef(a);
};
$33d0057184af2d0e$export$60241385465d0a34 = function(a) {
    return $33d0057184af2d0e$var$U.current.useState(a);
};
$33d0057184af2d0e$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $33d0057184af2d0e$var$U.current.useSyncExternalStore(a, b, e);
};
$33d0057184af2d0e$export$7b286972b8d8ccbf = function() {
    return $33d0057184af2d0e$var$U.current.useTransition();
};
$33d0057184af2d0e$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("f30MD", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $af47be6906de36aa$export$ae55be85d98224ed; }, function (v) { return $af47be6906de36aa$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $af47be6906de36aa$export$d39a5bbd09211389; }, function (v) { return $af47be6906de36aa$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $af47be6906de36aa$export$882461b6382ed46c; }, function (v) { return $af47be6906de36aa$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $af47be6906de36aa$export$466bfc07425424d5; }, function (v) { return $af47be6906de36aa$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $af47be6906de36aa$export$cd75ccfd720a3cd4; }, function (v) { return $af47be6906de36aa$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $af47be6906de36aa$export$fa8d919ba61d84db; }, function (v) { return $af47be6906de36aa$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $af47be6906de36aa$export$757ceba2d55c277e; }, function (v) { return $af47be6906de36aa$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $af47be6906de36aa$export$b3890eb0ae9dca99; }, function (v) { return $af47be6906de36aa$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $af47be6906de36aa$export$502457920280e6be; }, function (v) { return $af47be6906de36aa$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $af47be6906de36aa$export$c78a37762a8d58e1; }, function (v) { return $af47be6906de36aa$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $af47be6906de36aa$export$dc54d992c10e8a18; }, function (v) { return $af47be6906de36aa$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $af47be6906de36aa$export$83d89fbfd8236492; }, function (v) { return $af47be6906de36aa$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $af47be6906de36aa$export$ae55be85d98224ed;
var $af47be6906de36aa$export$d39a5bbd09211389;
var $af47be6906de36aa$export$882461b6382ed46c;
var $af47be6906de36aa$export$466bfc07425424d5;
var $af47be6906de36aa$export$cd75ccfd720a3cd4;
var $af47be6906de36aa$export$fa8d919ba61d84db;
var $af47be6906de36aa$export$757ceba2d55c277e;
var $af47be6906de36aa$export$b3890eb0ae9dca99;
var $af47be6906de36aa$export$502457920280e6be;
var $af47be6906de36aa$export$c78a37762a8d58e1;
var $af47be6906de36aa$export$dc54d992c10e8a18;
var $af47be6906de36aa$export$83d89fbfd8236492;
'use strict';

var $8FY87 = parcelRequire("8FY87");

var $9LPgQ = parcelRequire("9LPgQ");
function $af47be6906de36aa$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $af47be6906de36aa$var$da = new Set, $af47be6906de36aa$var$ea = {};
function $af47be6906de36aa$var$fa(a, b) {
    $af47be6906de36aa$var$ha(a, b);
    $af47be6906de36aa$var$ha(a + "Capture", b);
}
function $af47be6906de36aa$var$ha(a, b) {
    $af47be6906de36aa$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$af47be6906de36aa$var$da.add(b[a]);
}
var $af47be6906de36aa$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $af47be6906de36aa$var$ja = Object.prototype.hasOwnProperty, $af47be6906de36aa$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $af47be6906de36aa$var$la = {}, $af47be6906de36aa$var$ma = {};
function $af47be6906de36aa$var$oa(a) {
    if ($af47be6906de36aa$var$ja.call($af47be6906de36aa$var$ma, a)) return !0;
    if ($af47be6906de36aa$var$ja.call($af47be6906de36aa$var$la, a)) return !1;
    if ($af47be6906de36aa$var$ka.test(a)) return $af47be6906de36aa$var$ma[a] = !0;
    $af47be6906de36aa$var$la[a] = !0;
    return !1;
}
function $af47be6906de36aa$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $af47be6906de36aa$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $af47be6906de36aa$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $af47be6906de36aa$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $af47be6906de36aa$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $af47be6906de36aa$var$z[b] = new $af47be6906de36aa$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $af47be6906de36aa$var$ra = /[\-:]([a-z])/g;
function $af47be6906de36aa$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($af47be6906de36aa$var$ra, $af47be6906de36aa$var$sa);
    $af47be6906de36aa$var$z[b] = new $af47be6906de36aa$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($af47be6906de36aa$var$ra, $af47be6906de36aa$var$sa);
    $af47be6906de36aa$var$z[b] = new $af47be6906de36aa$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($af47be6906de36aa$var$ra, $af47be6906de36aa$var$sa);
    $af47be6906de36aa$var$z[b] = new $af47be6906de36aa$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$af47be6906de36aa$var$z.xlinkHref = new $af47be6906de36aa$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $af47be6906de36aa$var$z[a] = new $af47be6906de36aa$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $af47be6906de36aa$var$ta(a, b, c, d) {
    var e = $af47be6906de36aa$var$z.hasOwnProperty(b) ? $af47be6906de36aa$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $af47be6906de36aa$var$qa(b, c, e, d) && (c = null), d || null === e ? $af47be6906de36aa$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $af47be6906de36aa$var$ua = $8FY87.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $af47be6906de36aa$var$va = Symbol.for("react.element"), $af47be6906de36aa$var$wa = Symbol.for("react.portal"), $af47be6906de36aa$var$ya = Symbol.for("react.fragment"), $af47be6906de36aa$var$za = Symbol.for("react.strict_mode"), $af47be6906de36aa$var$Aa = Symbol.for("react.profiler"), $af47be6906de36aa$var$Ba = Symbol.for("react.provider"), $af47be6906de36aa$var$Ca = Symbol.for("react.context"), $af47be6906de36aa$var$Da = Symbol.for("react.forward_ref"), $af47be6906de36aa$var$Ea = Symbol.for("react.suspense"), $af47be6906de36aa$var$Fa = Symbol.for("react.suspense_list"), $af47be6906de36aa$var$Ga = Symbol.for("react.memo"), $af47be6906de36aa$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $af47be6906de36aa$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $af47be6906de36aa$var$Ja = Symbol.iterator;
function $af47be6906de36aa$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $af47be6906de36aa$var$Ja && a[$af47be6906de36aa$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $af47be6906de36aa$var$A = Object.assign, $af47be6906de36aa$var$La;
function $af47be6906de36aa$var$Ma(a) {
    if (void 0 === $af47be6906de36aa$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $af47be6906de36aa$var$La = b && b[1] || "";
    }
    return "\n" + $af47be6906de36aa$var$La + a;
}
var $af47be6906de36aa$var$Na = !1;
function $af47be6906de36aa$var$Oa(a, b) {
    if (!a || $af47be6906de36aa$var$Na) return "";
    $af47be6906de36aa$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $af47be6906de36aa$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $af47be6906de36aa$var$Ma(a) : "";
}
function $af47be6906de36aa$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $af47be6906de36aa$var$Ma(a.type);
        case 16:
            return $af47be6906de36aa$var$Ma("Lazy");
        case 13:
            return $af47be6906de36aa$var$Ma("Suspense");
        case 19:
            return $af47be6906de36aa$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $af47be6906de36aa$var$Oa(a.type, !1), a;
        case 11:
            return a = $af47be6906de36aa$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $af47be6906de36aa$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $af47be6906de36aa$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $af47be6906de36aa$var$ya:
            return "Fragment";
        case $af47be6906de36aa$var$wa:
            return "Portal";
        case $af47be6906de36aa$var$Aa:
            return "Profiler";
        case $af47be6906de36aa$var$za:
            return "StrictMode";
        case $af47be6906de36aa$var$Ea:
            return "Suspense";
        case $af47be6906de36aa$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $af47be6906de36aa$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $af47be6906de36aa$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $af47be6906de36aa$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $af47be6906de36aa$var$Ga:
            return b = a.displayName || null, null !== b ? b : $af47be6906de36aa$var$Qa(a.type) || "Memo";
        case $af47be6906de36aa$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $af47be6906de36aa$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $af47be6906de36aa$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $af47be6906de36aa$var$Qa(b);
        case 8:
            return b === $af47be6906de36aa$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $af47be6906de36aa$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $af47be6906de36aa$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $af47be6906de36aa$var$Ua(a) {
    var b = $af47be6906de36aa$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $af47be6906de36aa$var$Va(a) {
    a._valueTracker || (a._valueTracker = $af47be6906de36aa$var$Ua(a));
}
function $af47be6906de36aa$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $af47be6906de36aa$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $af47be6906de36aa$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $af47be6906de36aa$var$Ya(a, b) {
    var c = b.checked;
    return $af47be6906de36aa$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $af47be6906de36aa$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $af47be6906de36aa$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $af47be6906de36aa$var$ab(a, b) {
    b = b.checked;
    null != b && $af47be6906de36aa$var$ta(a, "checked", b, !1);
}
function $af47be6906de36aa$var$bb(a, b) {
    $af47be6906de36aa$var$ab(a, b);
    var c = $af47be6906de36aa$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $af47be6906de36aa$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $af47be6906de36aa$var$cb(a, b.type, $af47be6906de36aa$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $af47be6906de36aa$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $af47be6906de36aa$var$cb(a, b, c) {
    if ("number" !== b || $af47be6906de36aa$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $af47be6906de36aa$var$eb = Array.isArray;
function $af47be6906de36aa$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $af47be6906de36aa$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $af47be6906de36aa$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($af47be6906de36aa$var$p(91));
    return $af47be6906de36aa$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $af47be6906de36aa$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($af47be6906de36aa$var$p(92));
            if ($af47be6906de36aa$var$eb(c)) {
                if (1 < c.length) throw Error($af47be6906de36aa$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $af47be6906de36aa$var$Sa(c)
    };
}
function $af47be6906de36aa$var$ib(a, b) {
    var c = $af47be6906de36aa$var$Sa(b.value), d = $af47be6906de36aa$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $af47be6906de36aa$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $af47be6906de36aa$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $af47be6906de36aa$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $af47be6906de36aa$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $af47be6906de36aa$var$mb, $af47be6906de36aa$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $af47be6906de36aa$var$mb = $af47be6906de36aa$var$mb || document.createElement("div");
        $af47be6906de36aa$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $af47be6906de36aa$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $af47be6906de36aa$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $af47be6906de36aa$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $af47be6906de36aa$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($af47be6906de36aa$var$pb).forEach(function(a) {
    $af47be6906de36aa$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $af47be6906de36aa$var$pb[b] = $af47be6906de36aa$var$pb[a];
    });
});
function $af47be6906de36aa$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $af47be6906de36aa$var$pb.hasOwnProperty(a) && $af47be6906de36aa$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $af47be6906de36aa$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $af47be6906de36aa$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $af47be6906de36aa$var$tb = $af47be6906de36aa$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $af47be6906de36aa$var$ub(a, b) {
    if (b) {
        if ($af47be6906de36aa$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($af47be6906de36aa$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($af47be6906de36aa$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($af47be6906de36aa$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($af47be6906de36aa$var$p(62));
    }
}
function $af47be6906de36aa$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $af47be6906de36aa$var$wb = null;
function $af47be6906de36aa$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $af47be6906de36aa$var$yb = null, $af47be6906de36aa$var$zb = null, $af47be6906de36aa$var$Ab = null;
function $af47be6906de36aa$var$Bb(a) {
    if (a = $af47be6906de36aa$var$Cb(a)) {
        if ("function" !== typeof $af47be6906de36aa$var$yb) throw Error($af47be6906de36aa$var$p(280));
        var b = a.stateNode;
        b && (b = $af47be6906de36aa$var$Db(b), $af47be6906de36aa$var$yb(a.stateNode, a.type, b));
    }
}
function $af47be6906de36aa$var$Eb(a) {
    $af47be6906de36aa$var$zb ? $af47be6906de36aa$var$Ab ? $af47be6906de36aa$var$Ab.push(a) : $af47be6906de36aa$var$Ab = [
        a
    ] : $af47be6906de36aa$var$zb = a;
}
function $af47be6906de36aa$var$Fb() {
    if ($af47be6906de36aa$var$zb) {
        var a = $af47be6906de36aa$var$zb, b = $af47be6906de36aa$var$Ab;
        $af47be6906de36aa$var$Ab = $af47be6906de36aa$var$zb = null;
        $af47be6906de36aa$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$af47be6906de36aa$var$Bb(b[a]);
    }
}
function $af47be6906de36aa$var$Gb(a, b) {
    return a(b);
}
function $af47be6906de36aa$var$Hb() {}
var $af47be6906de36aa$var$Ib = !1;
function $af47be6906de36aa$var$Jb(a, b, c) {
    if ($af47be6906de36aa$var$Ib) return a(b, c);
    $af47be6906de36aa$var$Ib = !0;
    try {
        return $af47be6906de36aa$var$Gb(a, b, c);
    } finally{
        if ($af47be6906de36aa$var$Ib = !1, null !== $af47be6906de36aa$var$zb || null !== $af47be6906de36aa$var$Ab) $af47be6906de36aa$var$Hb(), $af47be6906de36aa$var$Fb();
    }
}
function $af47be6906de36aa$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $af47be6906de36aa$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($af47be6906de36aa$var$p(231, b, typeof c));
    return c;
}
var $af47be6906de36aa$var$Lb = !1;
if ($af47be6906de36aa$var$ia) try {
    var $af47be6906de36aa$var$Mb = {};
    Object.defineProperty($af47be6906de36aa$var$Mb, "passive", {
        get: function() {
            $af47be6906de36aa$var$Lb = !0;
        }
    });
    window.addEventListener("test", $af47be6906de36aa$var$Mb, $af47be6906de36aa$var$Mb);
    window.removeEventListener("test", $af47be6906de36aa$var$Mb, $af47be6906de36aa$var$Mb);
} catch (a) {
    $af47be6906de36aa$var$Lb = !1;
}
function $af47be6906de36aa$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $af47be6906de36aa$var$Ob = !1, $af47be6906de36aa$var$Pb = null, $af47be6906de36aa$var$Qb = !1, $af47be6906de36aa$var$Rb = null, $af47be6906de36aa$var$Sb = {
    onError: function(a) {
        $af47be6906de36aa$var$Ob = !0;
        $af47be6906de36aa$var$Pb = a;
    }
};
function $af47be6906de36aa$var$Tb(a, b, c, d, e, f, g, h, k) {
    $af47be6906de36aa$var$Ob = !1;
    $af47be6906de36aa$var$Pb = null;
    $af47be6906de36aa$var$Nb.apply($af47be6906de36aa$var$Sb, arguments);
}
function $af47be6906de36aa$var$Ub(a, b, c, d, e, f, g, h, k) {
    $af47be6906de36aa$var$Tb.apply(this, arguments);
    if ($af47be6906de36aa$var$Ob) {
        if ($af47be6906de36aa$var$Ob) {
            var l = $af47be6906de36aa$var$Pb;
            $af47be6906de36aa$var$Ob = !1;
            $af47be6906de36aa$var$Pb = null;
        } else throw Error($af47be6906de36aa$var$p(198));
        $af47be6906de36aa$var$Qb || ($af47be6906de36aa$var$Qb = !0, $af47be6906de36aa$var$Rb = l);
    }
}
function $af47be6906de36aa$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $af47be6906de36aa$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $af47be6906de36aa$var$Xb(a) {
    if ($af47be6906de36aa$var$Vb(a) !== a) throw Error($af47be6906de36aa$var$p(188));
}
function $af47be6906de36aa$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $af47be6906de36aa$var$Vb(a);
        if (null === b) throw Error($af47be6906de36aa$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $af47be6906de36aa$var$Xb(e), a;
                if (f === d) return $af47be6906de36aa$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($af47be6906de36aa$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($af47be6906de36aa$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($af47be6906de36aa$var$p(190));
    }
    if (3 !== c.tag) throw Error($af47be6906de36aa$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $af47be6906de36aa$var$Zb(a) {
    a = $af47be6906de36aa$var$Yb(a);
    return null !== a ? $af47be6906de36aa$var$$b(a) : null;
}
function $af47be6906de36aa$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $af47be6906de36aa$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $af47be6906de36aa$var$ac = $9LPgQ.unstable_scheduleCallback, $af47be6906de36aa$var$bc = $9LPgQ.unstable_cancelCallback, $af47be6906de36aa$var$cc = $9LPgQ.unstable_shouldYield, $af47be6906de36aa$var$dc = $9LPgQ.unstable_requestPaint, $af47be6906de36aa$var$B = $9LPgQ.unstable_now, $af47be6906de36aa$var$ec = $9LPgQ.unstable_getCurrentPriorityLevel, $af47be6906de36aa$var$fc = $9LPgQ.unstable_ImmediatePriority, $af47be6906de36aa$var$gc = $9LPgQ.unstable_UserBlockingPriority, $af47be6906de36aa$var$hc = $9LPgQ.unstable_NormalPriority, $af47be6906de36aa$var$ic = $9LPgQ.unstable_LowPriority, $af47be6906de36aa$var$jc = $9LPgQ.unstable_IdlePriority, $af47be6906de36aa$var$kc = null, $af47be6906de36aa$var$lc = null;
function $af47be6906de36aa$var$mc(a) {
    if ($af47be6906de36aa$var$lc && "function" === typeof $af47be6906de36aa$var$lc.onCommitFiberRoot) try {
        $af47be6906de36aa$var$lc.onCommitFiberRoot($af47be6906de36aa$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $af47be6906de36aa$var$oc = Math.clz32 ? Math.clz32 : $af47be6906de36aa$var$nc, $af47be6906de36aa$var$pc = Math.log, $af47be6906de36aa$var$qc = Math.LN2;
function $af47be6906de36aa$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($af47be6906de36aa$var$pc(a) / $af47be6906de36aa$var$qc | 0) | 0;
}
var $af47be6906de36aa$var$rc = 64, $af47be6906de36aa$var$sc = 4194304;
function $af47be6906de36aa$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $af47be6906de36aa$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $af47be6906de36aa$var$tc(h) : (f &= g, 0 !== f && (d = $af47be6906de36aa$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $af47be6906de36aa$var$tc(g) : 0 !== f && (d = $af47be6906de36aa$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $af47be6906de36aa$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $af47be6906de36aa$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $af47be6906de36aa$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $af47be6906de36aa$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $af47be6906de36aa$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $af47be6906de36aa$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $af47be6906de36aa$var$yc() {
    var a = $af47be6906de36aa$var$rc;
    $af47be6906de36aa$var$rc <<= 1;
    0 === ($af47be6906de36aa$var$rc & 4194240) && ($af47be6906de36aa$var$rc = 64);
    return a;
}
function $af47be6906de36aa$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $af47be6906de36aa$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $af47be6906de36aa$var$oc(b);
    a[b] = c;
}
function $af47be6906de36aa$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $af47be6906de36aa$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $af47be6906de36aa$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $af47be6906de36aa$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $af47be6906de36aa$var$C = 0;
function $af47be6906de36aa$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $af47be6906de36aa$var$Ec, $af47be6906de36aa$var$Fc, $af47be6906de36aa$var$Gc, $af47be6906de36aa$var$Hc, $af47be6906de36aa$var$Ic, $af47be6906de36aa$var$Jc = !1, $af47be6906de36aa$var$Kc = [], $af47be6906de36aa$var$Lc = null, $af47be6906de36aa$var$Mc = null, $af47be6906de36aa$var$Nc = null, $af47be6906de36aa$var$Oc = new Map, $af47be6906de36aa$var$Pc = new Map, $af47be6906de36aa$var$Qc = [], $af47be6906de36aa$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $af47be6906de36aa$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $af47be6906de36aa$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $af47be6906de36aa$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $af47be6906de36aa$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $af47be6906de36aa$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $af47be6906de36aa$var$Pc.delete(b.pointerId);
    }
}
function $af47be6906de36aa$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $af47be6906de36aa$var$Cb(b), null !== b && $af47be6906de36aa$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $af47be6906de36aa$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $af47be6906de36aa$var$Lc = $af47be6906de36aa$var$Tc($af47be6906de36aa$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $af47be6906de36aa$var$Mc = $af47be6906de36aa$var$Tc($af47be6906de36aa$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $af47be6906de36aa$var$Nc = $af47be6906de36aa$var$Tc($af47be6906de36aa$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $af47be6906de36aa$var$Oc.set(f, $af47be6906de36aa$var$Tc($af47be6906de36aa$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $af47be6906de36aa$var$Pc.set(f, $af47be6906de36aa$var$Tc($af47be6906de36aa$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $af47be6906de36aa$var$Vc(a) {
    var b = $af47be6906de36aa$var$Wc(a.target);
    if (null !== b) {
        var c = $af47be6906de36aa$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $af47be6906de36aa$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $af47be6906de36aa$var$Ic(a.priority, function() {
                        $af47be6906de36aa$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $af47be6906de36aa$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $af47be6906de36aa$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $af47be6906de36aa$var$wb = d;
            c.target.dispatchEvent(d);
            $af47be6906de36aa$var$wb = null;
        } else return b = $af47be6906de36aa$var$Cb(c), null !== b && $af47be6906de36aa$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $af47be6906de36aa$var$Zc(a, b, c) {
    $af47be6906de36aa$var$Xc(a) && c.delete(b);
}
function $af47be6906de36aa$var$$c() {
    $af47be6906de36aa$var$Jc = !1;
    null !== $af47be6906de36aa$var$Lc && $af47be6906de36aa$var$Xc($af47be6906de36aa$var$Lc) && ($af47be6906de36aa$var$Lc = null);
    null !== $af47be6906de36aa$var$Mc && $af47be6906de36aa$var$Xc($af47be6906de36aa$var$Mc) && ($af47be6906de36aa$var$Mc = null);
    null !== $af47be6906de36aa$var$Nc && $af47be6906de36aa$var$Xc($af47be6906de36aa$var$Nc) && ($af47be6906de36aa$var$Nc = null);
    $af47be6906de36aa$var$Oc.forEach($af47be6906de36aa$var$Zc);
    $af47be6906de36aa$var$Pc.forEach($af47be6906de36aa$var$Zc);
}
function $af47be6906de36aa$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $af47be6906de36aa$var$Jc || ($af47be6906de36aa$var$Jc = !0, $9LPgQ.unstable_scheduleCallback($9LPgQ.unstable_NormalPriority, $af47be6906de36aa$var$$c)));
}
function $af47be6906de36aa$var$bd(a) {
    function b(b) {
        return $af47be6906de36aa$var$ad(b, a);
    }
    if (0 < $af47be6906de36aa$var$Kc.length) {
        $af47be6906de36aa$var$ad($af47be6906de36aa$var$Kc[0], a);
        for(var c = 1; c < $af47be6906de36aa$var$Kc.length; c++){
            var d = $af47be6906de36aa$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $af47be6906de36aa$var$Lc && $af47be6906de36aa$var$ad($af47be6906de36aa$var$Lc, a);
    null !== $af47be6906de36aa$var$Mc && $af47be6906de36aa$var$ad($af47be6906de36aa$var$Mc, a);
    null !== $af47be6906de36aa$var$Nc && $af47be6906de36aa$var$ad($af47be6906de36aa$var$Nc, a);
    $af47be6906de36aa$var$Oc.forEach(b);
    $af47be6906de36aa$var$Pc.forEach(b);
    for(c = 0; c < $af47be6906de36aa$var$Qc.length; c++)d = $af47be6906de36aa$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $af47be6906de36aa$var$Qc.length && (c = $af47be6906de36aa$var$Qc[0], null === c.blockedOn);)$af47be6906de36aa$var$Vc(c), null === c.blockedOn && $af47be6906de36aa$var$Qc.shift();
}
var $af47be6906de36aa$var$cd = $af47be6906de36aa$var$ua.ReactCurrentBatchConfig, $af47be6906de36aa$var$dd = !0;
function $af47be6906de36aa$var$ed(a, b, c, d) {
    var e = $af47be6906de36aa$var$C, f = $af47be6906de36aa$var$cd.transition;
    $af47be6906de36aa$var$cd.transition = null;
    try {
        $af47be6906de36aa$var$C = 1, $af47be6906de36aa$var$fd(a, b, c, d);
    } finally{
        $af47be6906de36aa$var$C = e, $af47be6906de36aa$var$cd.transition = f;
    }
}
function $af47be6906de36aa$var$gd(a, b, c, d) {
    var e = $af47be6906de36aa$var$C, f = $af47be6906de36aa$var$cd.transition;
    $af47be6906de36aa$var$cd.transition = null;
    try {
        $af47be6906de36aa$var$C = 4, $af47be6906de36aa$var$fd(a, b, c, d);
    } finally{
        $af47be6906de36aa$var$C = e, $af47be6906de36aa$var$cd.transition = f;
    }
}
function $af47be6906de36aa$var$fd(a, b, c, d) {
    if ($af47be6906de36aa$var$dd) {
        var e = $af47be6906de36aa$var$Yc(a, b, c, d);
        if (null === e) $af47be6906de36aa$var$hd(a, b, d, $af47be6906de36aa$var$id, c), $af47be6906de36aa$var$Sc(a, d);
        else if ($af47be6906de36aa$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($af47be6906de36aa$var$Sc(a, d), b & 4 && -1 < $af47be6906de36aa$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $af47be6906de36aa$var$Cb(e);
                null !== f && $af47be6906de36aa$var$Ec(f);
                f = $af47be6906de36aa$var$Yc(a, b, c, d);
                null === f && $af47be6906de36aa$var$hd(a, b, d, $af47be6906de36aa$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $af47be6906de36aa$var$hd(a, b, d, null, c);
    }
}
var $af47be6906de36aa$var$id = null;
function $af47be6906de36aa$var$Yc(a, b, c, d) {
    $af47be6906de36aa$var$id = null;
    a = $af47be6906de36aa$var$xb(d);
    a = $af47be6906de36aa$var$Wc(a);
    if (null !== a) {
        if (b = $af47be6906de36aa$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $af47be6906de36aa$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $af47be6906de36aa$var$id = a;
    return null;
}
function $af47be6906de36aa$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($af47be6906de36aa$var$ec()){
                case $af47be6906de36aa$var$fc:
                    return 1;
                case $af47be6906de36aa$var$gc:
                    return 4;
                case $af47be6906de36aa$var$hc:
                case $af47be6906de36aa$var$ic:
                    return 16;
                case $af47be6906de36aa$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $af47be6906de36aa$var$kd = null, $af47be6906de36aa$var$ld = null, $af47be6906de36aa$var$md = null;
function $af47be6906de36aa$var$nd() {
    if ($af47be6906de36aa$var$md) return $af47be6906de36aa$var$md;
    var a, b = $af47be6906de36aa$var$ld, c = b.length, d, e = "value" in $af47be6906de36aa$var$kd ? $af47be6906de36aa$var$kd.value : $af47be6906de36aa$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $af47be6906de36aa$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $af47be6906de36aa$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $af47be6906de36aa$var$pd() {
    return !0;
}
function $af47be6906de36aa$var$qd() {
    return !1;
}
function $af47be6906de36aa$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $af47be6906de36aa$var$pd : $af47be6906de36aa$var$qd;
        this.isPropagationStopped = $af47be6906de36aa$var$qd;
        return this;
    }
    $af47be6906de36aa$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $af47be6906de36aa$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $af47be6906de36aa$var$pd);
        },
        persist: function() {},
        isPersistent: $af47be6906de36aa$var$pd
    });
    return b;
}
var $af47be6906de36aa$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $af47be6906de36aa$var$td = $af47be6906de36aa$var$rd($af47be6906de36aa$var$sd), $af47be6906de36aa$var$ud = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$sd, {
    view: 0,
    detail: 0
}), $af47be6906de36aa$var$vd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$ud), $af47be6906de36aa$var$wd, $af47be6906de36aa$var$xd, $af47be6906de36aa$var$yd, $af47be6906de36aa$var$Ad = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $af47be6906de36aa$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $af47be6906de36aa$var$yd && ($af47be6906de36aa$var$yd && "mousemove" === a.type ? ($af47be6906de36aa$var$wd = a.screenX - $af47be6906de36aa$var$yd.screenX, $af47be6906de36aa$var$xd = a.screenY - $af47be6906de36aa$var$yd.screenY) : $af47be6906de36aa$var$xd = $af47be6906de36aa$var$wd = 0, $af47be6906de36aa$var$yd = a);
        return $af47be6906de36aa$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $af47be6906de36aa$var$xd;
    }
}), $af47be6906de36aa$var$Bd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Ad), $af47be6906de36aa$var$Cd = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$Ad, {
    dataTransfer: 0
}), $af47be6906de36aa$var$Dd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Cd), $af47be6906de36aa$var$Ed = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$ud, {
    relatedTarget: 0
}), $af47be6906de36aa$var$Fd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Ed), $af47be6906de36aa$var$Gd = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $af47be6906de36aa$var$Hd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Gd), $af47be6906de36aa$var$Id = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $af47be6906de36aa$var$Jd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Id), $af47be6906de36aa$var$Kd = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$sd, {
    data: 0
}), $af47be6906de36aa$var$Ld = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Kd), $af47be6906de36aa$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $af47be6906de36aa$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $af47be6906de36aa$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $af47be6906de36aa$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $af47be6906de36aa$var$Od[a]) ? !!b[a] : !1;
}
function $af47be6906de36aa$var$zd() {
    return $af47be6906de36aa$var$Pd;
}
var $af47be6906de36aa$var$Qd = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $af47be6906de36aa$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $af47be6906de36aa$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $af47be6906de36aa$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $af47be6906de36aa$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $af47be6906de36aa$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $af47be6906de36aa$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $af47be6906de36aa$var$Rd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Qd), $af47be6906de36aa$var$Sd = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $af47be6906de36aa$var$Td = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Sd), $af47be6906de36aa$var$Ud = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $af47be6906de36aa$var$zd
}), $af47be6906de36aa$var$Vd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Ud), $af47be6906de36aa$var$Wd = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $af47be6906de36aa$var$Xd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Wd), $af47be6906de36aa$var$Yd = $af47be6906de36aa$var$A({}, $af47be6906de36aa$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $af47be6906de36aa$var$Zd = $af47be6906de36aa$var$rd($af47be6906de36aa$var$Yd), $af47be6906de36aa$var$$d = [
    9,
    13,
    27,
    32
], $af47be6906de36aa$var$ae = $af47be6906de36aa$var$ia && "CompositionEvent" in window, $af47be6906de36aa$var$be = null;
$af47be6906de36aa$var$ia && "documentMode" in document && ($af47be6906de36aa$var$be = document.documentMode);
var $af47be6906de36aa$var$ce = $af47be6906de36aa$var$ia && "TextEvent" in window && !$af47be6906de36aa$var$be, $af47be6906de36aa$var$de = $af47be6906de36aa$var$ia && (!$af47be6906de36aa$var$ae || $af47be6906de36aa$var$be && 8 < $af47be6906de36aa$var$be && 11 >= $af47be6906de36aa$var$be), $af47be6906de36aa$var$ee = String.fromCharCode(32), $af47be6906de36aa$var$fe = !1;
function $af47be6906de36aa$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $af47be6906de36aa$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $af47be6906de36aa$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $af47be6906de36aa$var$ie = !1;
function $af47be6906de36aa$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $af47be6906de36aa$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $af47be6906de36aa$var$fe = !0;
            return $af47be6906de36aa$var$ee;
        case "textInput":
            return a = b.data, a === $af47be6906de36aa$var$ee && $af47be6906de36aa$var$fe ? null : a;
        default:
            return null;
    }
}
function $af47be6906de36aa$var$ke(a, b) {
    if ($af47be6906de36aa$var$ie) return "compositionend" === a || !$af47be6906de36aa$var$ae && $af47be6906de36aa$var$ge(a, b) ? (a = $af47be6906de36aa$var$nd(), $af47be6906de36aa$var$md = $af47be6906de36aa$var$ld = $af47be6906de36aa$var$kd = null, $af47be6906de36aa$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $af47be6906de36aa$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $af47be6906de36aa$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $af47be6906de36aa$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$af47be6906de36aa$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $af47be6906de36aa$var$ne(a, b, c, d) {
    $af47be6906de36aa$var$Eb(d);
    b = $af47be6906de36aa$var$oe(b, "onChange");
    0 < b.length && (c = new $af47be6906de36aa$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $af47be6906de36aa$var$pe = null, $af47be6906de36aa$var$qe = null;
function $af47be6906de36aa$var$re(a) {
    $af47be6906de36aa$var$se(a, 0);
}
function $af47be6906de36aa$var$te(a) {
    var b = $af47be6906de36aa$var$ue(a);
    if ($af47be6906de36aa$var$Wa(b)) return a;
}
function $af47be6906de36aa$var$ve(a, b) {
    if ("change" === a) return b;
}
var $af47be6906de36aa$var$we = !1;
if ($af47be6906de36aa$var$ia) {
    var $af47be6906de36aa$var$xe;
    if ($af47be6906de36aa$var$ia) {
        var $af47be6906de36aa$var$ye = "oninput" in document;
        if (!$af47be6906de36aa$var$ye) {
            var $af47be6906de36aa$var$ze = document.createElement("div");
            $af47be6906de36aa$var$ze.setAttribute("oninput", "return;");
            $af47be6906de36aa$var$ye = "function" === typeof $af47be6906de36aa$var$ze.oninput;
        }
        $af47be6906de36aa$var$xe = $af47be6906de36aa$var$ye;
    } else $af47be6906de36aa$var$xe = !1;
    $af47be6906de36aa$var$we = $af47be6906de36aa$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $af47be6906de36aa$var$Ae() {
    $af47be6906de36aa$var$pe && ($af47be6906de36aa$var$pe.detachEvent("onpropertychange", $af47be6906de36aa$var$Be), $af47be6906de36aa$var$qe = $af47be6906de36aa$var$pe = null);
}
function $af47be6906de36aa$var$Be(a) {
    if ("value" === a.propertyName && $af47be6906de36aa$var$te($af47be6906de36aa$var$qe)) {
        var b = [];
        $af47be6906de36aa$var$ne(b, $af47be6906de36aa$var$qe, a, $af47be6906de36aa$var$xb(a));
        $af47be6906de36aa$var$Jb($af47be6906de36aa$var$re, b);
    }
}
function $af47be6906de36aa$var$Ce(a, b, c) {
    "focusin" === a ? ($af47be6906de36aa$var$Ae(), $af47be6906de36aa$var$pe = b, $af47be6906de36aa$var$qe = c, $af47be6906de36aa$var$pe.attachEvent("onpropertychange", $af47be6906de36aa$var$Be)) : "focusout" === a && $af47be6906de36aa$var$Ae();
}
function $af47be6906de36aa$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $af47be6906de36aa$var$te($af47be6906de36aa$var$qe);
}
function $af47be6906de36aa$var$Ee(a, b) {
    if ("click" === a) return $af47be6906de36aa$var$te(b);
}
function $af47be6906de36aa$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $af47be6906de36aa$var$te(b);
}
function $af47be6906de36aa$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $af47be6906de36aa$var$He = "function" === typeof Object.is ? Object.is : $af47be6906de36aa$var$Ge;
function $af47be6906de36aa$var$Ie(a, b) {
    if ($af47be6906de36aa$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$af47be6906de36aa$var$ja.call(b, e) || !$af47be6906de36aa$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $af47be6906de36aa$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $af47be6906de36aa$var$Ke(a, b) {
    var c = $af47be6906de36aa$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $af47be6906de36aa$var$Je(c);
    }
}
function $af47be6906de36aa$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $af47be6906de36aa$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $af47be6906de36aa$var$Me() {
    for(var a = window, b = $af47be6906de36aa$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $af47be6906de36aa$var$Xa(a.document);
    }
    return b;
}
function $af47be6906de36aa$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $af47be6906de36aa$var$Oe(a) {
    var b = $af47be6906de36aa$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $af47be6906de36aa$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $af47be6906de36aa$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $af47be6906de36aa$var$Ke(c, f);
                var g = $af47be6906de36aa$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $af47be6906de36aa$var$Pe = $af47be6906de36aa$var$ia && "documentMode" in document && 11 >= document.documentMode, $af47be6906de36aa$var$Qe = null, $af47be6906de36aa$var$Re = null, $af47be6906de36aa$var$Se = null, $af47be6906de36aa$var$Te = !1;
function $af47be6906de36aa$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $af47be6906de36aa$var$Te || null == $af47be6906de36aa$var$Qe || $af47be6906de36aa$var$Qe !== $af47be6906de36aa$var$Xa(d) || (d = $af47be6906de36aa$var$Qe, "selectionStart" in d && $af47be6906de36aa$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $af47be6906de36aa$var$Se && $af47be6906de36aa$var$Ie($af47be6906de36aa$var$Se, d) || ($af47be6906de36aa$var$Se = d, d = $af47be6906de36aa$var$oe($af47be6906de36aa$var$Re, "onSelect"), 0 < d.length && (b = new $af47be6906de36aa$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $af47be6906de36aa$var$Qe)));
}
function $af47be6906de36aa$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $af47be6906de36aa$var$We = {
    animationend: $af47be6906de36aa$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $af47be6906de36aa$var$Ve("Animation", "AnimationIteration"),
    animationstart: $af47be6906de36aa$var$Ve("Animation", "AnimationStart"),
    transitionend: $af47be6906de36aa$var$Ve("Transition", "TransitionEnd")
}, $af47be6906de36aa$var$Xe = {}, $af47be6906de36aa$var$Ye = {};
$af47be6906de36aa$var$ia && ($af47be6906de36aa$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $af47be6906de36aa$var$We.animationend.animation, delete $af47be6906de36aa$var$We.animationiteration.animation, delete $af47be6906de36aa$var$We.animationstart.animation), "TransitionEvent" in window || delete $af47be6906de36aa$var$We.transitionend.transition);
function $af47be6906de36aa$var$Ze(a) {
    if ($af47be6906de36aa$var$Xe[a]) return $af47be6906de36aa$var$Xe[a];
    if (!$af47be6906de36aa$var$We[a]) return a;
    var b = $af47be6906de36aa$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $af47be6906de36aa$var$Ye) return $af47be6906de36aa$var$Xe[a] = b[c];
    return a;
}
var $af47be6906de36aa$var$$e = $af47be6906de36aa$var$Ze("animationend"), $af47be6906de36aa$var$af = $af47be6906de36aa$var$Ze("animationiteration"), $af47be6906de36aa$var$bf = $af47be6906de36aa$var$Ze("animationstart"), $af47be6906de36aa$var$cf = $af47be6906de36aa$var$Ze("transitionend"), $af47be6906de36aa$var$df = new Map, $af47be6906de36aa$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $af47be6906de36aa$var$ff(a, b) {
    $af47be6906de36aa$var$df.set(a, b);
    $af47be6906de36aa$var$fa(b, [
        a
    ]);
}
for(var $af47be6906de36aa$var$gf = 0; $af47be6906de36aa$var$gf < $af47be6906de36aa$var$ef.length; $af47be6906de36aa$var$gf++){
    var $af47be6906de36aa$var$hf = $af47be6906de36aa$var$ef[$af47be6906de36aa$var$gf], $af47be6906de36aa$var$jf = $af47be6906de36aa$var$hf.toLowerCase(), $af47be6906de36aa$var$kf = $af47be6906de36aa$var$hf[0].toUpperCase() + $af47be6906de36aa$var$hf.slice(1);
    $af47be6906de36aa$var$ff($af47be6906de36aa$var$jf, "on" + $af47be6906de36aa$var$kf);
}
$af47be6906de36aa$var$ff($af47be6906de36aa$var$$e, "onAnimationEnd");
$af47be6906de36aa$var$ff($af47be6906de36aa$var$af, "onAnimationIteration");
$af47be6906de36aa$var$ff($af47be6906de36aa$var$bf, "onAnimationStart");
$af47be6906de36aa$var$ff("dblclick", "onDoubleClick");
$af47be6906de36aa$var$ff("focusin", "onFocus");
$af47be6906de36aa$var$ff("focusout", "onBlur");
$af47be6906de36aa$var$ff($af47be6906de36aa$var$cf, "onTransitionEnd");
$af47be6906de36aa$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$af47be6906de36aa$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$af47be6906de36aa$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$af47be6906de36aa$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$af47be6906de36aa$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$af47be6906de36aa$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$af47be6906de36aa$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$af47be6906de36aa$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$af47be6906de36aa$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$af47be6906de36aa$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $af47be6906de36aa$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $af47be6906de36aa$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($af47be6906de36aa$var$lf));
function $af47be6906de36aa$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $af47be6906de36aa$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $af47be6906de36aa$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $af47be6906de36aa$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $af47be6906de36aa$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($af47be6906de36aa$var$Qb) throw a = $af47be6906de36aa$var$Rb, $af47be6906de36aa$var$Qb = !1, $af47be6906de36aa$var$Rb = null, a;
}
function $af47be6906de36aa$var$D(a, b) {
    var c = b[$af47be6906de36aa$var$of];
    void 0 === c && (c = b[$af47be6906de36aa$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($af47be6906de36aa$var$pf(b, a, 2, !1), c.add(d));
}
function $af47be6906de36aa$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $af47be6906de36aa$var$pf(c, a, d, b);
}
var $af47be6906de36aa$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $af47be6906de36aa$var$sf(a) {
    if (!a[$af47be6906de36aa$var$rf]) {
        a[$af47be6906de36aa$var$rf] = !0;
        $af47be6906de36aa$var$da.forEach(function(b) {
            "selectionchange" !== b && ($af47be6906de36aa$var$mf.has(b) || $af47be6906de36aa$var$qf(b, !1, a), $af47be6906de36aa$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$af47be6906de36aa$var$rf] || (b[$af47be6906de36aa$var$rf] = !0, $af47be6906de36aa$var$qf("selectionchange", !1, b));
    }
}
function $af47be6906de36aa$var$pf(a, b, c, d) {
    switch($af47be6906de36aa$var$jd(b)){
        case 1:
            var e = $af47be6906de36aa$var$ed;
            break;
        case 4:
            e = $af47be6906de36aa$var$gd;
            break;
        default:
            e = $af47be6906de36aa$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$af47be6906de36aa$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $af47be6906de36aa$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $af47be6906de36aa$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $af47be6906de36aa$var$Jb(function() {
        var d = f, e = $af47be6906de36aa$var$xb(c), g = [];
        a: {
            var h = $af47be6906de36aa$var$df.get(a);
            if (void 0 !== h) {
                var k = $af47be6906de36aa$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $af47be6906de36aa$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $af47be6906de36aa$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $af47be6906de36aa$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $af47be6906de36aa$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $af47be6906de36aa$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $af47be6906de36aa$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $af47be6906de36aa$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $af47be6906de36aa$var$Vd;
                        break;
                    case $af47be6906de36aa$var$$e:
                    case $af47be6906de36aa$var$af:
                    case $af47be6906de36aa$var$bf:
                        k = $af47be6906de36aa$var$Hd;
                        break;
                    case $af47be6906de36aa$var$cf:
                        k = $af47be6906de36aa$var$Xd;
                        break;
                    case "scroll":
                        k = $af47be6906de36aa$var$vd;
                        break;
                    case "wheel":
                        k = $af47be6906de36aa$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $af47be6906de36aa$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $af47be6906de36aa$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $af47be6906de36aa$var$Kb(w, x), null != F && t.push($af47be6906de36aa$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $af47be6906de36aa$var$wb && (n = c.relatedTarget || c.fromElement) && ($af47be6906de36aa$var$Wc(n) || n[$af47be6906de36aa$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $af47be6906de36aa$var$Wc(n) : null, null !== n && (J = $af47be6906de36aa$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $af47be6906de36aa$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $af47be6906de36aa$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $af47be6906de36aa$var$ue(k);
                        u = null == n ? h : $af47be6906de36aa$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $af47be6906de36aa$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $af47be6906de36aa$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $af47be6906de36aa$var$vf(F))u++;
                            for(; 0 < w - u;)t = $af47be6906de36aa$var$vf(t), w--;
                            for(; 0 < u - w;)x = $af47be6906de36aa$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $af47be6906de36aa$var$vf(t);
                                x = $af47be6906de36aa$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $af47be6906de36aa$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $af47be6906de36aa$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $af47be6906de36aa$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $af47be6906de36aa$var$ve;
                else if ($af47be6906de36aa$var$me(h)) {
                    if ($af47be6906de36aa$var$we) na = $af47be6906de36aa$var$Fe;
                    else {
                        na = $af47be6906de36aa$var$De;
                        var xa = $af47be6906de36aa$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $af47be6906de36aa$var$Ee);
                if (na && (na = na(a, d))) {
                    $af47be6906de36aa$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $af47be6906de36aa$var$cb(h, "number", h.value);
            }
            xa = d ? $af47be6906de36aa$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($af47be6906de36aa$var$me(xa) || "true" === xa.contentEditable) $af47be6906de36aa$var$Qe = xa, $af47be6906de36aa$var$Re = d, $af47be6906de36aa$var$Se = null;
                    break;
                case "focusout":
                    $af47be6906de36aa$var$Se = $af47be6906de36aa$var$Re = $af47be6906de36aa$var$Qe = null;
                    break;
                case "mousedown":
                    $af47be6906de36aa$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $af47be6906de36aa$var$Te = !1;
                    $af47be6906de36aa$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($af47be6906de36aa$var$Pe) break;
                case "keydown":
                case "keyup":
                    $af47be6906de36aa$var$Ue(g, c, e);
            }
            var $a;
            if ($af47be6906de36aa$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $af47be6906de36aa$var$ie ? $af47be6906de36aa$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($af47be6906de36aa$var$de && "ko" !== c.locale && ($af47be6906de36aa$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $af47be6906de36aa$var$ie && ($a = $af47be6906de36aa$var$nd()) : ($af47be6906de36aa$var$kd = e, $af47be6906de36aa$var$ld = "value" in $af47be6906de36aa$var$kd ? $af47be6906de36aa$var$kd.value : $af47be6906de36aa$var$kd.textContent, $af47be6906de36aa$var$ie = !0)), xa = $af47be6906de36aa$var$oe(d, ba), 0 < xa.length && (ba = new $af47be6906de36aa$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $af47be6906de36aa$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $af47be6906de36aa$var$ce ? $af47be6906de36aa$var$je(a, c) : $af47be6906de36aa$var$ke(a, c)) d = $af47be6906de36aa$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $af47be6906de36aa$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $af47be6906de36aa$var$se(g, b);
    });
}
function $af47be6906de36aa$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $af47be6906de36aa$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $af47be6906de36aa$var$Kb(a, c), null != f && d.unshift($af47be6906de36aa$var$tf(a, f, e)), f = $af47be6906de36aa$var$Kb(a, b), null != f && d.push($af47be6906de36aa$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $af47be6906de36aa$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $af47be6906de36aa$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $af47be6906de36aa$var$Kb(c, f), null != k && g.unshift($af47be6906de36aa$var$tf(c, k, h))) : e || (k = $af47be6906de36aa$var$Kb(c, f), null != k && g.push($af47be6906de36aa$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $af47be6906de36aa$var$xf = /\r\n?/g, $af47be6906de36aa$var$yf = /\u0000|\uFFFD/g;
function $af47be6906de36aa$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($af47be6906de36aa$var$xf, "\n").replace($af47be6906de36aa$var$yf, "");
}
function $af47be6906de36aa$var$Af(a, b, c) {
    b = $af47be6906de36aa$var$zf(b);
    if ($af47be6906de36aa$var$zf(a) !== b && c) throw Error($af47be6906de36aa$var$p(425));
}
function $af47be6906de36aa$var$Bf() {}
var $af47be6906de36aa$var$Cf = null, $af47be6906de36aa$var$Df = null;
function $af47be6906de36aa$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $af47be6906de36aa$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $af47be6906de36aa$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $af47be6906de36aa$var$Hf = "function" === typeof Promise ? Promise : void 0, $af47be6906de36aa$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $af47be6906de36aa$var$Hf ? function(a) {
    return $af47be6906de36aa$var$Hf.resolve(null).then(a).catch($af47be6906de36aa$var$If);
} : $af47be6906de36aa$var$Ff;
function $af47be6906de36aa$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $af47be6906de36aa$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $af47be6906de36aa$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $af47be6906de36aa$var$bd(b);
}
function $af47be6906de36aa$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $af47be6906de36aa$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $af47be6906de36aa$var$Nf = Math.random().toString(36).slice(2), $af47be6906de36aa$var$Of = "__reactFiber$" + $af47be6906de36aa$var$Nf, $af47be6906de36aa$var$Pf = "__reactProps$" + $af47be6906de36aa$var$Nf, $af47be6906de36aa$var$uf = "__reactContainer$" + $af47be6906de36aa$var$Nf, $af47be6906de36aa$var$of = "__reactEvents$" + $af47be6906de36aa$var$Nf, $af47be6906de36aa$var$Qf = "__reactListeners$" + $af47be6906de36aa$var$Nf, $af47be6906de36aa$var$Rf = "__reactHandles$" + $af47be6906de36aa$var$Nf;
function $af47be6906de36aa$var$Wc(a) {
    var b = a[$af47be6906de36aa$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$af47be6906de36aa$var$uf] || c[$af47be6906de36aa$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $af47be6906de36aa$var$Mf(a); null !== a;){
                if (c = a[$af47be6906de36aa$var$Of]) return c;
                a = $af47be6906de36aa$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $af47be6906de36aa$var$Cb(a) {
    a = a[$af47be6906de36aa$var$Of] || a[$af47be6906de36aa$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $af47be6906de36aa$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($af47be6906de36aa$var$p(33));
}
function $af47be6906de36aa$var$Db(a) {
    return a[$af47be6906de36aa$var$Pf] || null;
}
var $af47be6906de36aa$var$Sf = [], $af47be6906de36aa$var$Tf = -1;
function $af47be6906de36aa$var$Uf(a) {
    return {
        current: a
    };
}
function $af47be6906de36aa$var$E(a) {
    0 > $af47be6906de36aa$var$Tf || (a.current = $af47be6906de36aa$var$Sf[$af47be6906de36aa$var$Tf], $af47be6906de36aa$var$Sf[$af47be6906de36aa$var$Tf] = null, $af47be6906de36aa$var$Tf--);
}
function $af47be6906de36aa$var$G(a, b) {
    $af47be6906de36aa$var$Tf++;
    $af47be6906de36aa$var$Sf[$af47be6906de36aa$var$Tf] = a.current;
    a.current = b;
}
var $af47be6906de36aa$var$Vf = {}, $af47be6906de36aa$var$H = $af47be6906de36aa$var$Uf($af47be6906de36aa$var$Vf), $af47be6906de36aa$var$Wf = $af47be6906de36aa$var$Uf(!1), $af47be6906de36aa$var$Xf = $af47be6906de36aa$var$Vf;
function $af47be6906de36aa$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $af47be6906de36aa$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $af47be6906de36aa$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $af47be6906de36aa$var$$f() {
    $af47be6906de36aa$var$E($af47be6906de36aa$var$Wf);
    $af47be6906de36aa$var$E($af47be6906de36aa$var$H);
}
function $af47be6906de36aa$var$ag(a, b, c) {
    if ($af47be6906de36aa$var$H.current !== $af47be6906de36aa$var$Vf) throw Error($af47be6906de36aa$var$p(168));
    $af47be6906de36aa$var$G($af47be6906de36aa$var$H, b);
    $af47be6906de36aa$var$G($af47be6906de36aa$var$Wf, c);
}
function $af47be6906de36aa$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($af47be6906de36aa$var$p(108, $af47be6906de36aa$var$Ra(a) || "Unknown", e));
    return $af47be6906de36aa$var$A({}, c, d);
}
function $af47be6906de36aa$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $af47be6906de36aa$var$Vf;
    $af47be6906de36aa$var$Xf = $af47be6906de36aa$var$H.current;
    $af47be6906de36aa$var$G($af47be6906de36aa$var$H, a);
    $af47be6906de36aa$var$G($af47be6906de36aa$var$Wf, $af47be6906de36aa$var$Wf.current);
    return !0;
}
function $af47be6906de36aa$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($af47be6906de36aa$var$p(169));
    c ? (a = $af47be6906de36aa$var$bg(a, b, $af47be6906de36aa$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $af47be6906de36aa$var$E($af47be6906de36aa$var$Wf), $af47be6906de36aa$var$E($af47be6906de36aa$var$H), $af47be6906de36aa$var$G($af47be6906de36aa$var$H, a)) : $af47be6906de36aa$var$E($af47be6906de36aa$var$Wf);
    $af47be6906de36aa$var$G($af47be6906de36aa$var$Wf, c);
}
var $af47be6906de36aa$var$eg = null, $af47be6906de36aa$var$fg = !1, $af47be6906de36aa$var$gg = !1;
function $af47be6906de36aa$var$hg(a) {
    null === $af47be6906de36aa$var$eg ? $af47be6906de36aa$var$eg = [
        a
    ] : $af47be6906de36aa$var$eg.push(a);
}
function $af47be6906de36aa$var$ig(a) {
    $af47be6906de36aa$var$fg = !0;
    $af47be6906de36aa$var$hg(a);
}
function $af47be6906de36aa$var$jg() {
    if (!$af47be6906de36aa$var$gg && null !== $af47be6906de36aa$var$eg) {
        $af47be6906de36aa$var$gg = !0;
        var a = 0, b = $af47be6906de36aa$var$C;
        try {
            var c = $af47be6906de36aa$var$eg;
            for($af47be6906de36aa$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $af47be6906de36aa$var$eg = null;
            $af47be6906de36aa$var$fg = !1;
        } catch (e) {
            throw null !== $af47be6906de36aa$var$eg && ($af47be6906de36aa$var$eg = $af47be6906de36aa$var$eg.slice(a + 1)), $af47be6906de36aa$var$ac($af47be6906de36aa$var$fc, $af47be6906de36aa$var$jg), e;
        } finally{
            $af47be6906de36aa$var$C = b, $af47be6906de36aa$var$gg = !1;
        }
    }
    return null;
}
var $af47be6906de36aa$var$kg = [], $af47be6906de36aa$var$lg = 0, $af47be6906de36aa$var$mg = null, $af47be6906de36aa$var$ng = 0, $af47be6906de36aa$var$og = [], $af47be6906de36aa$var$pg = 0, $af47be6906de36aa$var$qg = null, $af47be6906de36aa$var$rg = 1, $af47be6906de36aa$var$sg = "";
function $af47be6906de36aa$var$tg(a, b) {
    $af47be6906de36aa$var$kg[$af47be6906de36aa$var$lg++] = $af47be6906de36aa$var$ng;
    $af47be6906de36aa$var$kg[$af47be6906de36aa$var$lg++] = $af47be6906de36aa$var$mg;
    $af47be6906de36aa$var$mg = a;
    $af47be6906de36aa$var$ng = b;
}
function $af47be6906de36aa$var$ug(a, b, c) {
    $af47be6906de36aa$var$og[$af47be6906de36aa$var$pg++] = $af47be6906de36aa$var$rg;
    $af47be6906de36aa$var$og[$af47be6906de36aa$var$pg++] = $af47be6906de36aa$var$sg;
    $af47be6906de36aa$var$og[$af47be6906de36aa$var$pg++] = $af47be6906de36aa$var$qg;
    $af47be6906de36aa$var$qg = a;
    var d = $af47be6906de36aa$var$rg;
    a = $af47be6906de36aa$var$sg;
    var e = 32 - $af47be6906de36aa$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $af47be6906de36aa$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $af47be6906de36aa$var$rg = 1 << 32 - $af47be6906de36aa$var$oc(b) + e | c << e | d;
        $af47be6906de36aa$var$sg = f + a;
    } else $af47be6906de36aa$var$rg = 1 << f | c << e | d, $af47be6906de36aa$var$sg = a;
}
function $af47be6906de36aa$var$vg(a) {
    null !== a.return && ($af47be6906de36aa$var$tg(a, 1), $af47be6906de36aa$var$ug(a, 1, 0));
}
function $af47be6906de36aa$var$wg(a) {
    for(; a === $af47be6906de36aa$var$mg;)$af47be6906de36aa$var$mg = $af47be6906de36aa$var$kg[--$af47be6906de36aa$var$lg], $af47be6906de36aa$var$kg[$af47be6906de36aa$var$lg] = null, $af47be6906de36aa$var$ng = $af47be6906de36aa$var$kg[--$af47be6906de36aa$var$lg], $af47be6906de36aa$var$kg[$af47be6906de36aa$var$lg] = null;
    for(; a === $af47be6906de36aa$var$qg;)$af47be6906de36aa$var$qg = $af47be6906de36aa$var$og[--$af47be6906de36aa$var$pg], $af47be6906de36aa$var$og[$af47be6906de36aa$var$pg] = null, $af47be6906de36aa$var$sg = $af47be6906de36aa$var$og[--$af47be6906de36aa$var$pg], $af47be6906de36aa$var$og[$af47be6906de36aa$var$pg] = null, $af47be6906de36aa$var$rg = $af47be6906de36aa$var$og[--$af47be6906de36aa$var$pg], $af47be6906de36aa$var$og[$af47be6906de36aa$var$pg] = null;
}
var $af47be6906de36aa$var$xg = null, $af47be6906de36aa$var$yg = null, $af47be6906de36aa$var$I = !1, $af47be6906de36aa$var$zg = null;
function $af47be6906de36aa$var$Ag(a, b) {
    var c = $af47be6906de36aa$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $af47be6906de36aa$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $af47be6906de36aa$var$xg = a, $af47be6906de36aa$var$yg = $af47be6906de36aa$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $af47be6906de36aa$var$xg = a, $af47be6906de36aa$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $af47be6906de36aa$var$qg ? {
                id: $af47be6906de36aa$var$rg,
                overflow: $af47be6906de36aa$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $af47be6906de36aa$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $af47be6906de36aa$var$xg = a, $af47be6906de36aa$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $af47be6906de36aa$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $af47be6906de36aa$var$Eg(a) {
    if ($af47be6906de36aa$var$I) {
        var b = $af47be6906de36aa$var$yg;
        if (b) {
            var c = b;
            if (!$af47be6906de36aa$var$Cg(a, b)) {
                if ($af47be6906de36aa$var$Dg(a)) throw Error($af47be6906de36aa$var$p(418));
                b = $af47be6906de36aa$var$Lf(c.nextSibling);
                var d = $af47be6906de36aa$var$xg;
                b && $af47be6906de36aa$var$Cg(a, b) ? $af47be6906de36aa$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $af47be6906de36aa$var$I = !1, $af47be6906de36aa$var$xg = a);
            }
        } else {
            if ($af47be6906de36aa$var$Dg(a)) throw Error($af47be6906de36aa$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $af47be6906de36aa$var$I = !1;
            $af47be6906de36aa$var$xg = a;
        }
    }
}
function $af47be6906de36aa$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $af47be6906de36aa$var$xg = a;
}
function $af47be6906de36aa$var$Gg(a) {
    if (a !== $af47be6906de36aa$var$xg) return !1;
    if (!$af47be6906de36aa$var$I) return $af47be6906de36aa$var$Fg(a), $af47be6906de36aa$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$af47be6906de36aa$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $af47be6906de36aa$var$yg)) {
        if ($af47be6906de36aa$var$Dg(a)) throw $af47be6906de36aa$var$Hg(), Error($af47be6906de36aa$var$p(418));
        for(; b;)$af47be6906de36aa$var$Ag(a, b), b = $af47be6906de36aa$var$Lf(b.nextSibling);
    }
    $af47be6906de36aa$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($af47be6906de36aa$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $af47be6906de36aa$var$yg = $af47be6906de36aa$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $af47be6906de36aa$var$yg = null;
        }
    } else $af47be6906de36aa$var$yg = $af47be6906de36aa$var$xg ? $af47be6906de36aa$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $af47be6906de36aa$var$Hg() {
    for(var a = $af47be6906de36aa$var$yg; a;)a = $af47be6906de36aa$var$Lf(a.nextSibling);
}
function $af47be6906de36aa$var$Ig() {
    $af47be6906de36aa$var$yg = $af47be6906de36aa$var$xg = null;
    $af47be6906de36aa$var$I = !1;
}
function $af47be6906de36aa$var$Jg(a) {
    null === $af47be6906de36aa$var$zg ? $af47be6906de36aa$var$zg = [
        a
    ] : $af47be6906de36aa$var$zg.push(a);
}
var $af47be6906de36aa$var$Kg = $af47be6906de36aa$var$ua.ReactCurrentBatchConfig;
function $af47be6906de36aa$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($af47be6906de36aa$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($af47be6906de36aa$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($af47be6906de36aa$var$p(284));
        if (!c._owner) throw Error($af47be6906de36aa$var$p(290, a));
    }
    return a;
}
function $af47be6906de36aa$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($af47be6906de36aa$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $af47be6906de36aa$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $af47be6906de36aa$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $af47be6906de36aa$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $af47be6906de36aa$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $af47be6906de36aa$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $af47be6906de36aa$var$Ha && $af47be6906de36aa$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $af47be6906de36aa$var$Lg(a, b, c), d.return = a, d;
        d = $af47be6906de36aa$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $af47be6906de36aa$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $af47be6906de36aa$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $af47be6906de36aa$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $af47be6906de36aa$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $af47be6906de36aa$var$va:
                    return c = $af47be6906de36aa$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $af47be6906de36aa$var$Lg(a, null, b), c.return = a, c;
                case $af47be6906de36aa$var$wa:
                    return b = $af47be6906de36aa$var$Sg(b, a.mode, c), b.return = a, b;
                case $af47be6906de36aa$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($af47be6906de36aa$var$eb(b) || $af47be6906de36aa$var$Ka(b)) return b = $af47be6906de36aa$var$Tg(b, a.mode, c, null), b.return = a, b;
            $af47be6906de36aa$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $af47be6906de36aa$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $af47be6906de36aa$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $af47be6906de36aa$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($af47be6906de36aa$var$eb(c) || $af47be6906de36aa$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $af47be6906de36aa$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $af47be6906de36aa$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $af47be6906de36aa$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $af47be6906de36aa$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($af47be6906de36aa$var$eb(d) || $af47be6906de36aa$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $af47be6906de36aa$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $af47be6906de36aa$var$I && $af47be6906de36aa$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $af47be6906de36aa$var$I && $af47be6906de36aa$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $af47be6906de36aa$var$I && $af47be6906de36aa$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $af47be6906de36aa$var$Ka(h);
        if ("function" !== typeof l) throw Error($af47be6906de36aa$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($af47be6906de36aa$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $af47be6906de36aa$var$I && $af47be6906de36aa$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $af47be6906de36aa$var$I && $af47be6906de36aa$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $af47be6906de36aa$var$I && $af47be6906de36aa$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $af47be6906de36aa$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $af47be6906de36aa$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $af47be6906de36aa$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $af47be6906de36aa$var$Ha && $af47be6906de36aa$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $af47be6906de36aa$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $af47be6906de36aa$var$ya ? (d = $af47be6906de36aa$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $af47be6906de36aa$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $af47be6906de36aa$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $af47be6906de36aa$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $af47be6906de36aa$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $af47be6906de36aa$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($af47be6906de36aa$var$eb(f)) return n(a, d, f, h);
            if ($af47be6906de36aa$var$Ka(f)) return t(a, d, f, h);
            $af47be6906de36aa$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $af47be6906de36aa$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $af47be6906de36aa$var$Ug = $af47be6906de36aa$var$Og(!0), $af47be6906de36aa$var$Vg = $af47be6906de36aa$var$Og(!1), $af47be6906de36aa$var$Wg = $af47be6906de36aa$var$Uf(null), $af47be6906de36aa$var$Xg = null, $af47be6906de36aa$var$Yg = null, $af47be6906de36aa$var$Zg = null;
function $af47be6906de36aa$var$$g() {
    $af47be6906de36aa$var$Zg = $af47be6906de36aa$var$Yg = $af47be6906de36aa$var$Xg = null;
}
function $af47be6906de36aa$var$ah(a) {
    var b = $af47be6906de36aa$var$Wg.current;
    $af47be6906de36aa$var$E($af47be6906de36aa$var$Wg);
    a._currentValue = b;
}
function $af47be6906de36aa$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $af47be6906de36aa$var$ch(a, b) {
    $af47be6906de36aa$var$Xg = a;
    $af47be6906de36aa$var$Zg = $af47be6906de36aa$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($af47be6906de36aa$var$dh = !0), a.firstContext = null);
}
function $af47be6906de36aa$var$eh(a) {
    var b = a._currentValue;
    if ($af47be6906de36aa$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $af47be6906de36aa$var$Yg) {
            if (null === $af47be6906de36aa$var$Xg) throw Error($af47be6906de36aa$var$p(308));
            $af47be6906de36aa$var$Yg = a;
            $af47be6906de36aa$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $af47be6906de36aa$var$Yg = $af47be6906de36aa$var$Yg.next = a;
    }
    return b;
}
var $af47be6906de36aa$var$fh = null;
function $af47be6906de36aa$var$gh(a) {
    null === $af47be6906de36aa$var$fh ? $af47be6906de36aa$var$fh = [
        a
    ] : $af47be6906de36aa$var$fh.push(a);
}
function $af47be6906de36aa$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $af47be6906de36aa$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $af47be6906de36aa$var$ih(a, d);
}
function $af47be6906de36aa$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $af47be6906de36aa$var$jh = !1;
function $af47be6906de36aa$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $af47be6906de36aa$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $af47be6906de36aa$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $af47be6906de36aa$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($af47be6906de36aa$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $af47be6906de36aa$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $af47be6906de36aa$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $af47be6906de36aa$var$ih(a, c);
}
function $af47be6906de36aa$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $af47be6906de36aa$var$Cc(a, c);
    }
}
function $af47be6906de36aa$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $af47be6906de36aa$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $af47be6906de36aa$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $af47be6906de36aa$var$A({}, q, r);
                            break a;
                        case 2:
                            $af47be6906de36aa$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $af47be6906de36aa$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $af47be6906de36aa$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($af47be6906de36aa$var$p(191, e));
            e.call(d);
        }
    }
}
var $af47be6906de36aa$var$th = {}, $af47be6906de36aa$var$uh = $af47be6906de36aa$var$Uf($af47be6906de36aa$var$th), $af47be6906de36aa$var$vh = $af47be6906de36aa$var$Uf($af47be6906de36aa$var$th), $af47be6906de36aa$var$wh = $af47be6906de36aa$var$Uf($af47be6906de36aa$var$th);
function $af47be6906de36aa$var$xh(a) {
    if (a === $af47be6906de36aa$var$th) throw Error($af47be6906de36aa$var$p(174));
    return a;
}
function $af47be6906de36aa$var$yh(a, b) {
    $af47be6906de36aa$var$G($af47be6906de36aa$var$wh, b);
    $af47be6906de36aa$var$G($af47be6906de36aa$var$vh, a);
    $af47be6906de36aa$var$G($af47be6906de36aa$var$uh, $af47be6906de36aa$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $af47be6906de36aa$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $af47be6906de36aa$var$lb(b, a);
    }
    $af47be6906de36aa$var$E($af47be6906de36aa$var$uh);
    $af47be6906de36aa$var$G($af47be6906de36aa$var$uh, b);
}
function $af47be6906de36aa$var$zh() {
    $af47be6906de36aa$var$E($af47be6906de36aa$var$uh);
    $af47be6906de36aa$var$E($af47be6906de36aa$var$vh);
    $af47be6906de36aa$var$E($af47be6906de36aa$var$wh);
}
function $af47be6906de36aa$var$Ah(a) {
    $af47be6906de36aa$var$xh($af47be6906de36aa$var$wh.current);
    var b = $af47be6906de36aa$var$xh($af47be6906de36aa$var$uh.current);
    var c = $af47be6906de36aa$var$lb(b, a.type);
    b !== c && ($af47be6906de36aa$var$G($af47be6906de36aa$var$vh, a), $af47be6906de36aa$var$G($af47be6906de36aa$var$uh, c));
}
function $af47be6906de36aa$var$Bh(a) {
    $af47be6906de36aa$var$vh.current === a && ($af47be6906de36aa$var$E($af47be6906de36aa$var$uh), $af47be6906de36aa$var$E($af47be6906de36aa$var$vh));
}
var $af47be6906de36aa$var$L = $af47be6906de36aa$var$Uf(0);
function $af47be6906de36aa$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $af47be6906de36aa$var$Dh = [];
function $af47be6906de36aa$var$Eh() {
    for(var a = 0; a < $af47be6906de36aa$var$Dh.length; a++)$af47be6906de36aa$var$Dh[a]._workInProgressVersionPrimary = null;
    $af47be6906de36aa$var$Dh.length = 0;
}
var $af47be6906de36aa$var$Fh = $af47be6906de36aa$var$ua.ReactCurrentDispatcher, $af47be6906de36aa$var$Gh = $af47be6906de36aa$var$ua.ReactCurrentBatchConfig, $af47be6906de36aa$var$Hh = 0, $af47be6906de36aa$var$M = null, $af47be6906de36aa$var$N = null, $af47be6906de36aa$var$O = null, $af47be6906de36aa$var$Ih = !1, $af47be6906de36aa$var$Jh = !1, $af47be6906de36aa$var$Kh = 0, $af47be6906de36aa$var$Lh = 0;
function $af47be6906de36aa$var$P() {
    throw Error($af47be6906de36aa$var$p(321));
}
function $af47be6906de36aa$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$af47be6906de36aa$var$He(a[c], b[c])) return !1;
    return !0;
}
function $af47be6906de36aa$var$Nh(a, b, c, d, e, f) {
    $af47be6906de36aa$var$Hh = f;
    $af47be6906de36aa$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $af47be6906de36aa$var$Fh.current = null === a || null === a.memoizedState ? $af47be6906de36aa$var$Oh : $af47be6906de36aa$var$Ph;
    a = c(d, e);
    if ($af47be6906de36aa$var$Jh) {
        f = 0;
        do {
            $af47be6906de36aa$var$Jh = !1;
            $af47be6906de36aa$var$Kh = 0;
            if (25 <= f) throw Error($af47be6906de36aa$var$p(301));
            f += 1;
            $af47be6906de36aa$var$O = $af47be6906de36aa$var$N = null;
            b.updateQueue = null;
            $af47be6906de36aa$var$Fh.current = $af47be6906de36aa$var$Qh;
            a = c(d, e);
        }while ($af47be6906de36aa$var$Jh);
    }
    $af47be6906de36aa$var$Fh.current = $af47be6906de36aa$var$Rh;
    b = null !== $af47be6906de36aa$var$N && null !== $af47be6906de36aa$var$N.next;
    $af47be6906de36aa$var$Hh = 0;
    $af47be6906de36aa$var$O = $af47be6906de36aa$var$N = $af47be6906de36aa$var$M = null;
    $af47be6906de36aa$var$Ih = !1;
    if (b) throw Error($af47be6906de36aa$var$p(300));
    return a;
}
function $af47be6906de36aa$var$Sh() {
    var a = 0 !== $af47be6906de36aa$var$Kh;
    $af47be6906de36aa$var$Kh = 0;
    return a;
}
function $af47be6906de36aa$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $af47be6906de36aa$var$O ? $af47be6906de36aa$var$M.memoizedState = $af47be6906de36aa$var$O = a : $af47be6906de36aa$var$O = $af47be6906de36aa$var$O.next = a;
    return $af47be6906de36aa$var$O;
}
function $af47be6906de36aa$var$Uh() {
    if (null === $af47be6906de36aa$var$N) {
        var a = $af47be6906de36aa$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $af47be6906de36aa$var$N.next;
    var b = null === $af47be6906de36aa$var$O ? $af47be6906de36aa$var$M.memoizedState : $af47be6906de36aa$var$O.next;
    if (null !== b) $af47be6906de36aa$var$O = b, $af47be6906de36aa$var$N = a;
    else {
        if (null === a) throw Error($af47be6906de36aa$var$p(310));
        $af47be6906de36aa$var$N = a;
        a = {
            memoizedState: $af47be6906de36aa$var$N.memoizedState,
            baseState: $af47be6906de36aa$var$N.baseState,
            baseQueue: $af47be6906de36aa$var$N.baseQueue,
            queue: $af47be6906de36aa$var$N.queue,
            next: null
        };
        null === $af47be6906de36aa$var$O ? $af47be6906de36aa$var$M.memoizedState = $af47be6906de36aa$var$O = a : $af47be6906de36aa$var$O = $af47be6906de36aa$var$O.next = a;
    }
    return $af47be6906de36aa$var$O;
}
function $af47be6906de36aa$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $af47be6906de36aa$var$Wh(a) {
    var b = $af47be6906de36aa$var$Uh(), c = b.queue;
    if (null === c) throw Error($af47be6906de36aa$var$p(311));
    c.lastRenderedReducer = a;
    var d = $af47be6906de36aa$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($af47be6906de36aa$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $af47be6906de36aa$var$M.lanes |= m;
                $af47be6906de36aa$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $af47be6906de36aa$var$He(d, b.memoizedState) || ($af47be6906de36aa$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $af47be6906de36aa$var$M.lanes |= f, $af47be6906de36aa$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $af47be6906de36aa$var$Xh(a) {
    var b = $af47be6906de36aa$var$Uh(), c = b.queue;
    if (null === c) throw Error($af47be6906de36aa$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $af47be6906de36aa$var$He(f, b.memoizedState) || ($af47be6906de36aa$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $af47be6906de36aa$var$Yh() {}
function $af47be6906de36aa$var$Zh(a, b) {
    var c = $af47be6906de36aa$var$M, d = $af47be6906de36aa$var$Uh(), e = b(), f = !$af47be6906de36aa$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $af47be6906de36aa$var$dh = !0);
    d = d.queue;
    $af47be6906de36aa$var$$h($af47be6906de36aa$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $af47be6906de36aa$var$O && $af47be6906de36aa$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $af47be6906de36aa$var$bi(9, $af47be6906de36aa$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $af47be6906de36aa$var$Q) throw Error($af47be6906de36aa$var$p(349));
        0 !== ($af47be6906de36aa$var$Hh & 30) || $af47be6906de36aa$var$di(c, b, e);
    }
    return e;
}
function $af47be6906de36aa$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $af47be6906de36aa$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $af47be6906de36aa$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $af47be6906de36aa$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $af47be6906de36aa$var$ei(b) && $af47be6906de36aa$var$fi(a);
}
function $af47be6906de36aa$var$ai(a, b, c) {
    return c(function() {
        $af47be6906de36aa$var$ei(b) && $af47be6906de36aa$var$fi(a);
    });
}
function $af47be6906de36aa$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$af47be6906de36aa$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $af47be6906de36aa$var$fi(a) {
    var b = $af47be6906de36aa$var$ih(a, 1);
    null !== b && $af47be6906de36aa$var$gi(b, a, 1, -1);
}
function $af47be6906de36aa$var$hi(a) {
    var b = $af47be6906de36aa$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $af47be6906de36aa$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $af47be6906de36aa$var$ii.bind(null, $af47be6906de36aa$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $af47be6906de36aa$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $af47be6906de36aa$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $af47be6906de36aa$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $af47be6906de36aa$var$ji() {
    return $af47be6906de36aa$var$Uh().memoizedState;
}
function $af47be6906de36aa$var$ki(a, b, c, d) {
    var e = $af47be6906de36aa$var$Th();
    $af47be6906de36aa$var$M.flags |= a;
    e.memoizedState = $af47be6906de36aa$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $af47be6906de36aa$var$li(a, b, c, d) {
    var e = $af47be6906de36aa$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $af47be6906de36aa$var$N) {
        var g = $af47be6906de36aa$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $af47be6906de36aa$var$Mh(d, g.deps)) {
            e.memoizedState = $af47be6906de36aa$var$bi(b, c, f, d);
            return;
        }
    }
    $af47be6906de36aa$var$M.flags |= a;
    e.memoizedState = $af47be6906de36aa$var$bi(1 | b, c, f, d);
}
function $af47be6906de36aa$var$mi(a, b) {
    return $af47be6906de36aa$var$ki(8390656, 8, a, b);
}
function $af47be6906de36aa$var$$h(a, b) {
    return $af47be6906de36aa$var$li(2048, 8, a, b);
}
function $af47be6906de36aa$var$ni(a, b) {
    return $af47be6906de36aa$var$li(4, 2, a, b);
}
function $af47be6906de36aa$var$oi(a, b) {
    return $af47be6906de36aa$var$li(4, 4, a, b);
}
function $af47be6906de36aa$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $af47be6906de36aa$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $af47be6906de36aa$var$li(4, 4, $af47be6906de36aa$var$pi.bind(null, b, a), c);
}
function $af47be6906de36aa$var$ri() {}
function $af47be6906de36aa$var$si(a, b) {
    var c = $af47be6906de36aa$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $af47be6906de36aa$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $af47be6906de36aa$var$ti(a, b) {
    var c = $af47be6906de36aa$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $af47be6906de36aa$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $af47be6906de36aa$var$ui(a, b, c) {
    if (0 === ($af47be6906de36aa$var$Hh & 21)) return a.baseState && (a.baseState = !1, $af47be6906de36aa$var$dh = !0), a.memoizedState = c;
    $af47be6906de36aa$var$He(c, b) || (c = $af47be6906de36aa$var$yc(), $af47be6906de36aa$var$M.lanes |= c, $af47be6906de36aa$var$rh |= c, a.baseState = !0);
    return b;
}
function $af47be6906de36aa$var$vi(a, b) {
    var c = $af47be6906de36aa$var$C;
    $af47be6906de36aa$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $af47be6906de36aa$var$Gh.transition;
    $af47be6906de36aa$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $af47be6906de36aa$var$C = c, $af47be6906de36aa$var$Gh.transition = d;
    }
}
function $af47be6906de36aa$var$wi() {
    return $af47be6906de36aa$var$Uh().memoizedState;
}
function $af47be6906de36aa$var$xi(a, b, c) {
    var d = $af47be6906de36aa$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($af47be6906de36aa$var$zi(a)) $af47be6906de36aa$var$Ai(b, c);
    else if (c = $af47be6906de36aa$var$hh(a, b, c, d), null !== c) {
        var e = $af47be6906de36aa$var$R();
        $af47be6906de36aa$var$gi(c, a, d, e);
        $af47be6906de36aa$var$Bi(c, b, d);
    }
}
function $af47be6906de36aa$var$ii(a, b, c) {
    var d = $af47be6906de36aa$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($af47be6906de36aa$var$zi(a)) $af47be6906de36aa$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($af47be6906de36aa$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $af47be6906de36aa$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $af47be6906de36aa$var$hh(a, b, e, d);
        null !== c && (e = $af47be6906de36aa$var$R(), $af47be6906de36aa$var$gi(c, a, d, e), $af47be6906de36aa$var$Bi(c, b, d));
    }
}
function $af47be6906de36aa$var$zi(a) {
    var b = a.alternate;
    return a === $af47be6906de36aa$var$M || null !== b && b === $af47be6906de36aa$var$M;
}
function $af47be6906de36aa$var$Ai(a, b) {
    $af47be6906de36aa$var$Jh = $af47be6906de36aa$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $af47be6906de36aa$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $af47be6906de36aa$var$Cc(a, c);
    }
}
var $af47be6906de36aa$var$Rh = {
    readContext: $af47be6906de36aa$var$eh,
    useCallback: $af47be6906de36aa$var$P,
    useContext: $af47be6906de36aa$var$P,
    useEffect: $af47be6906de36aa$var$P,
    useImperativeHandle: $af47be6906de36aa$var$P,
    useInsertionEffect: $af47be6906de36aa$var$P,
    useLayoutEffect: $af47be6906de36aa$var$P,
    useMemo: $af47be6906de36aa$var$P,
    useReducer: $af47be6906de36aa$var$P,
    useRef: $af47be6906de36aa$var$P,
    useState: $af47be6906de36aa$var$P,
    useDebugValue: $af47be6906de36aa$var$P,
    useDeferredValue: $af47be6906de36aa$var$P,
    useTransition: $af47be6906de36aa$var$P,
    useMutableSource: $af47be6906de36aa$var$P,
    useSyncExternalStore: $af47be6906de36aa$var$P,
    useId: $af47be6906de36aa$var$P,
    unstable_isNewReconciler: !1
}, $af47be6906de36aa$var$Oh = {
    readContext: $af47be6906de36aa$var$eh,
    useCallback: function(a, b) {
        $af47be6906de36aa$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $af47be6906de36aa$var$eh,
    useEffect: $af47be6906de36aa$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $af47be6906de36aa$var$ki(4194308, 4, $af47be6906de36aa$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $af47be6906de36aa$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $af47be6906de36aa$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $af47be6906de36aa$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $af47be6906de36aa$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $af47be6906de36aa$var$xi.bind(null, $af47be6906de36aa$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $af47be6906de36aa$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $af47be6906de36aa$var$hi,
    useDebugValue: $af47be6906de36aa$var$ri,
    useDeferredValue: function(a) {
        return $af47be6906de36aa$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $af47be6906de36aa$var$hi(!1), b = a[0];
        a = $af47be6906de36aa$var$vi.bind(null, a[1]);
        $af47be6906de36aa$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $af47be6906de36aa$var$M, e = $af47be6906de36aa$var$Th();
        if ($af47be6906de36aa$var$I) {
            if (void 0 === c) throw Error($af47be6906de36aa$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $af47be6906de36aa$var$Q) throw Error($af47be6906de36aa$var$p(349));
            0 !== ($af47be6906de36aa$var$Hh & 30) || $af47be6906de36aa$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $af47be6906de36aa$var$mi($af47be6906de36aa$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $af47be6906de36aa$var$bi(9, $af47be6906de36aa$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $af47be6906de36aa$var$Th(), b = $af47be6906de36aa$var$Q.identifierPrefix;
        if ($af47be6906de36aa$var$I) {
            var c = $af47be6906de36aa$var$sg;
            var d = $af47be6906de36aa$var$rg;
            c = (d & ~(1 << 32 - $af47be6906de36aa$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $af47be6906de36aa$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $af47be6906de36aa$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $af47be6906de36aa$var$Ph = {
    readContext: $af47be6906de36aa$var$eh,
    useCallback: $af47be6906de36aa$var$si,
    useContext: $af47be6906de36aa$var$eh,
    useEffect: $af47be6906de36aa$var$$h,
    useImperativeHandle: $af47be6906de36aa$var$qi,
    useInsertionEffect: $af47be6906de36aa$var$ni,
    useLayoutEffect: $af47be6906de36aa$var$oi,
    useMemo: $af47be6906de36aa$var$ti,
    useReducer: $af47be6906de36aa$var$Wh,
    useRef: $af47be6906de36aa$var$ji,
    useState: function() {
        return $af47be6906de36aa$var$Wh($af47be6906de36aa$var$Vh);
    },
    useDebugValue: $af47be6906de36aa$var$ri,
    useDeferredValue: function(a) {
        var b = $af47be6906de36aa$var$Uh();
        return $af47be6906de36aa$var$ui(b, $af47be6906de36aa$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $af47be6906de36aa$var$Wh($af47be6906de36aa$var$Vh)[0], b = $af47be6906de36aa$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $af47be6906de36aa$var$Yh,
    useSyncExternalStore: $af47be6906de36aa$var$Zh,
    useId: $af47be6906de36aa$var$wi,
    unstable_isNewReconciler: !1
}, $af47be6906de36aa$var$Qh = {
    readContext: $af47be6906de36aa$var$eh,
    useCallback: $af47be6906de36aa$var$si,
    useContext: $af47be6906de36aa$var$eh,
    useEffect: $af47be6906de36aa$var$$h,
    useImperativeHandle: $af47be6906de36aa$var$qi,
    useInsertionEffect: $af47be6906de36aa$var$ni,
    useLayoutEffect: $af47be6906de36aa$var$oi,
    useMemo: $af47be6906de36aa$var$ti,
    useReducer: $af47be6906de36aa$var$Xh,
    useRef: $af47be6906de36aa$var$ji,
    useState: function() {
        return $af47be6906de36aa$var$Xh($af47be6906de36aa$var$Vh);
    },
    useDebugValue: $af47be6906de36aa$var$ri,
    useDeferredValue: function(a) {
        var b = $af47be6906de36aa$var$Uh();
        return null === $af47be6906de36aa$var$N ? b.memoizedState = a : $af47be6906de36aa$var$ui(b, $af47be6906de36aa$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $af47be6906de36aa$var$Xh($af47be6906de36aa$var$Vh)[0], b = $af47be6906de36aa$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $af47be6906de36aa$var$Yh,
    useSyncExternalStore: $af47be6906de36aa$var$Zh,
    useId: $af47be6906de36aa$var$wi,
    unstable_isNewReconciler: !1
};
function $af47be6906de36aa$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $af47be6906de36aa$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $af47be6906de36aa$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $af47be6906de36aa$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $af47be6906de36aa$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $af47be6906de36aa$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $af47be6906de36aa$var$R(), e = $af47be6906de36aa$var$yi(a), f = $af47be6906de36aa$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $af47be6906de36aa$var$nh(a, f, e);
        null !== b && ($af47be6906de36aa$var$gi(b, a, e, d), $af47be6906de36aa$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $af47be6906de36aa$var$R(), e = $af47be6906de36aa$var$yi(a), f = $af47be6906de36aa$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $af47be6906de36aa$var$nh(a, f, e);
        null !== b && ($af47be6906de36aa$var$gi(b, a, e, d), $af47be6906de36aa$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $af47be6906de36aa$var$R(), d = $af47be6906de36aa$var$yi(a), e = $af47be6906de36aa$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $af47be6906de36aa$var$nh(a, e, d);
        null !== b && ($af47be6906de36aa$var$gi(b, a, d, c), $af47be6906de36aa$var$oh(b, a, d));
    }
};
function $af47be6906de36aa$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$af47be6906de36aa$var$Ie(c, d) || !$af47be6906de36aa$var$Ie(e, f) : !0;
}
function $af47be6906de36aa$var$Gi(a, b, c) {
    var d = !1, e = $af47be6906de36aa$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $af47be6906de36aa$var$eh(f) : (e = $af47be6906de36aa$var$Zf(b) ? $af47be6906de36aa$var$Xf : $af47be6906de36aa$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $af47be6906de36aa$var$Yf(a, e) : $af47be6906de36aa$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $af47be6906de36aa$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $af47be6906de36aa$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $af47be6906de36aa$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $af47be6906de36aa$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $af47be6906de36aa$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $af47be6906de36aa$var$eh(f) : (f = $af47be6906de36aa$var$Zf(b) ? $af47be6906de36aa$var$Xf : $af47be6906de36aa$var$H.current, e.context = $af47be6906de36aa$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($af47be6906de36aa$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $af47be6906de36aa$var$Ei.enqueueReplaceState(e, e.state, null), $af47be6906de36aa$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $af47be6906de36aa$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $af47be6906de36aa$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $af47be6906de36aa$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $af47be6906de36aa$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $af47be6906de36aa$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $af47be6906de36aa$var$Ni(a, b, c) {
    c = $af47be6906de36aa$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $af47be6906de36aa$var$Oi || ($af47be6906de36aa$var$Oi = !0, $af47be6906de36aa$var$Pi = d);
        $af47be6906de36aa$var$Li(a, b);
    };
    return c;
}
function $af47be6906de36aa$var$Qi(a, b, c) {
    c = $af47be6906de36aa$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $af47be6906de36aa$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $af47be6906de36aa$var$Li(a, b);
        "function" !== typeof d && (null === $af47be6906de36aa$var$Ri ? $af47be6906de36aa$var$Ri = new Set([
            this
        ]) : $af47be6906de36aa$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $af47be6906de36aa$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $af47be6906de36aa$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $af47be6906de36aa$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $af47be6906de36aa$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $af47be6906de36aa$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $af47be6906de36aa$var$mh(-1, 1), b.tag = 2, $af47be6906de36aa$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $af47be6906de36aa$var$Wi = $af47be6906de36aa$var$ua.ReactCurrentOwner, $af47be6906de36aa$var$dh = !1;
function $af47be6906de36aa$var$Xi(a, b, c, d) {
    b.child = null === a ? $af47be6906de36aa$var$Vg(b, null, c, d) : $af47be6906de36aa$var$Ug(b, a.child, c, d);
}
function $af47be6906de36aa$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $af47be6906de36aa$var$ch(b, e);
    d = $af47be6906de36aa$var$Nh(a, b, c, d, f, e);
    c = $af47be6906de36aa$var$Sh();
    if (null !== a && !$af47be6906de36aa$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $af47be6906de36aa$var$Zi(a, b, e);
    $af47be6906de36aa$var$I && c && $af47be6906de36aa$var$vg(b);
    b.flags |= 1;
    $af47be6906de36aa$var$Xi(a, b, d, e);
    return b.child;
}
function $af47be6906de36aa$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$af47be6906de36aa$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $af47be6906de36aa$var$bj(a, b, f, d, e);
        a = $af47be6906de36aa$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $af47be6906de36aa$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $af47be6906de36aa$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $af47be6906de36aa$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $af47be6906de36aa$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($af47be6906de36aa$var$Ie(f, d) && a.ref === b.ref) {
            if ($af47be6906de36aa$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($af47be6906de36aa$var$dh = !0);
            else return b.lanes = a.lanes, $af47be6906de36aa$var$Zi(a, b, e);
        }
    }
    return $af47be6906de36aa$var$cj(a, b, c, d, e);
}
function $af47be6906de36aa$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $af47be6906de36aa$var$G($af47be6906de36aa$var$ej, $af47be6906de36aa$var$fj), $af47be6906de36aa$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $af47be6906de36aa$var$G($af47be6906de36aa$var$ej, $af47be6906de36aa$var$fj), $af47be6906de36aa$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $af47be6906de36aa$var$G($af47be6906de36aa$var$ej, $af47be6906de36aa$var$fj);
            $af47be6906de36aa$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $af47be6906de36aa$var$G($af47be6906de36aa$var$ej, $af47be6906de36aa$var$fj), $af47be6906de36aa$var$fj |= d;
    $af47be6906de36aa$var$Xi(a, b, e, c);
    return b.child;
}
function $af47be6906de36aa$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $af47be6906de36aa$var$cj(a, b, c, d, e) {
    var f = $af47be6906de36aa$var$Zf(c) ? $af47be6906de36aa$var$Xf : $af47be6906de36aa$var$H.current;
    f = $af47be6906de36aa$var$Yf(b, f);
    $af47be6906de36aa$var$ch(b, e);
    c = $af47be6906de36aa$var$Nh(a, b, c, d, f, e);
    d = $af47be6906de36aa$var$Sh();
    if (null !== a && !$af47be6906de36aa$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $af47be6906de36aa$var$Zi(a, b, e);
    $af47be6906de36aa$var$I && d && $af47be6906de36aa$var$vg(b);
    b.flags |= 1;
    $af47be6906de36aa$var$Xi(a, b, c, e);
    return b.child;
}
function $af47be6906de36aa$var$hj(a, b, c, d, e) {
    if ($af47be6906de36aa$var$Zf(c)) {
        var f = !0;
        $af47be6906de36aa$var$cg(b);
    } else f = !1;
    $af47be6906de36aa$var$ch(b, e);
    if (null === b.stateNode) $af47be6906de36aa$var$ij(a, b), $af47be6906de36aa$var$Gi(b, c, d), $af47be6906de36aa$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $af47be6906de36aa$var$eh(l) : (l = $af47be6906de36aa$var$Zf(c) ? $af47be6906de36aa$var$Xf : $af47be6906de36aa$var$H.current, l = $af47be6906de36aa$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $af47be6906de36aa$var$Hi(b, g, d, l);
        $af47be6906de36aa$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $af47be6906de36aa$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $af47be6906de36aa$var$Wf.current || $af47be6906de36aa$var$jh ? ("function" === typeof m && ($af47be6906de36aa$var$Di(b, c, m, d), k = b.memoizedState), (h = $af47be6906de36aa$var$jh || $af47be6906de36aa$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $af47be6906de36aa$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $af47be6906de36aa$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $af47be6906de36aa$var$eh(k) : (k = $af47be6906de36aa$var$Zf(c) ? $af47be6906de36aa$var$Xf : $af47be6906de36aa$var$H.current, k = $af47be6906de36aa$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $af47be6906de36aa$var$Hi(b, g, d, k);
        $af47be6906de36aa$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $af47be6906de36aa$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $af47be6906de36aa$var$Wf.current || $af47be6906de36aa$var$jh ? ("function" === typeof y && ($af47be6906de36aa$var$Di(b, c, y, d), n = b.memoizedState), (l = $af47be6906de36aa$var$jh || $af47be6906de36aa$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $af47be6906de36aa$var$jj(a, b, c, d, f, e);
}
function $af47be6906de36aa$var$jj(a, b, c, d, e, f) {
    $af47be6906de36aa$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $af47be6906de36aa$var$dg(b, c, !1), $af47be6906de36aa$var$Zi(a, b, f);
    d = b.stateNode;
    $af47be6906de36aa$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $af47be6906de36aa$var$Ug(b, a.child, null, f), b.child = $af47be6906de36aa$var$Ug(b, null, h, f)) : $af47be6906de36aa$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $af47be6906de36aa$var$dg(b, c, !0);
    return b.child;
}
function $af47be6906de36aa$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $af47be6906de36aa$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $af47be6906de36aa$var$ag(a, b.context, !1);
    $af47be6906de36aa$var$yh(a, b.containerInfo);
}
function $af47be6906de36aa$var$lj(a, b, c, d, e) {
    $af47be6906de36aa$var$Ig();
    $af47be6906de36aa$var$Jg(e);
    b.flags |= 256;
    $af47be6906de36aa$var$Xi(a, b, c, d);
    return b.child;
}
var $af47be6906de36aa$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $af47be6906de36aa$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $af47be6906de36aa$var$oj(a, b, c) {
    var d = b.pendingProps, e = $af47be6906de36aa$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $af47be6906de36aa$var$G($af47be6906de36aa$var$L, e & 1);
    if (null === a) {
        $af47be6906de36aa$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $af47be6906de36aa$var$pj(g, d, 0, null), a = $af47be6906de36aa$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $af47be6906de36aa$var$nj(c), b.memoizedState = $af47be6906de36aa$var$mj, a) : $af47be6906de36aa$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $af47be6906de36aa$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $af47be6906de36aa$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $af47be6906de36aa$var$Pg(h, f) : (f = $af47be6906de36aa$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $af47be6906de36aa$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $af47be6906de36aa$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $af47be6906de36aa$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $af47be6906de36aa$var$qj(a, b) {
    b = $af47be6906de36aa$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $af47be6906de36aa$var$sj(a, b, c, d) {
    null !== d && $af47be6906de36aa$var$Jg(d);
    $af47be6906de36aa$var$Ug(b, a.child, null, c);
    a = $af47be6906de36aa$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $af47be6906de36aa$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $af47be6906de36aa$var$Ki(Error($af47be6906de36aa$var$p(422))), $af47be6906de36aa$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $af47be6906de36aa$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $af47be6906de36aa$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $af47be6906de36aa$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $af47be6906de36aa$var$nj(g);
        b.memoizedState = $af47be6906de36aa$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $af47be6906de36aa$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($af47be6906de36aa$var$p(419));
        d = $af47be6906de36aa$var$Ki(f, d, void 0);
        return $af47be6906de36aa$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($af47be6906de36aa$var$dh || h) {
        d = $af47be6906de36aa$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $af47be6906de36aa$var$ih(a, e), $af47be6906de36aa$var$gi(d, a, e, -1));
        }
        $af47be6906de36aa$var$tj();
        d = $af47be6906de36aa$var$Ki(Error($af47be6906de36aa$var$p(421)));
        return $af47be6906de36aa$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $af47be6906de36aa$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $af47be6906de36aa$var$yg = $af47be6906de36aa$var$Lf(e.nextSibling);
    $af47be6906de36aa$var$xg = b;
    $af47be6906de36aa$var$I = !0;
    $af47be6906de36aa$var$zg = null;
    null !== a && ($af47be6906de36aa$var$og[$af47be6906de36aa$var$pg++] = $af47be6906de36aa$var$rg, $af47be6906de36aa$var$og[$af47be6906de36aa$var$pg++] = $af47be6906de36aa$var$sg, $af47be6906de36aa$var$og[$af47be6906de36aa$var$pg++] = $af47be6906de36aa$var$qg, $af47be6906de36aa$var$rg = a.id, $af47be6906de36aa$var$sg = a.overflow, $af47be6906de36aa$var$qg = b);
    b = $af47be6906de36aa$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $af47be6906de36aa$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $af47be6906de36aa$var$bh(a.return, b, c);
}
function $af47be6906de36aa$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $af47be6906de36aa$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $af47be6906de36aa$var$Xi(a, b, d.children, c);
    d = $af47be6906de36aa$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $af47be6906de36aa$var$vj(a, c, b);
            else if (19 === a.tag) $af47be6906de36aa$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $af47be6906de36aa$var$G($af47be6906de36aa$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $af47be6906de36aa$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $af47be6906de36aa$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $af47be6906de36aa$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $af47be6906de36aa$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $af47be6906de36aa$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $af47be6906de36aa$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $af47be6906de36aa$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $af47be6906de36aa$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($af47be6906de36aa$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $af47be6906de36aa$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $af47be6906de36aa$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $af47be6906de36aa$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $af47be6906de36aa$var$kj(b);
            $af47be6906de36aa$var$Ig();
            break;
        case 5:
            $af47be6906de36aa$var$Ah(b);
            break;
        case 1:
            $af47be6906de36aa$var$Zf(b.type) && $af47be6906de36aa$var$cg(b);
            break;
        case 4:
            $af47be6906de36aa$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $af47be6906de36aa$var$G($af47be6906de36aa$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $af47be6906de36aa$var$G($af47be6906de36aa$var$L, $af47be6906de36aa$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $af47be6906de36aa$var$oj(a, b, c);
                $af47be6906de36aa$var$G($af47be6906de36aa$var$L, $af47be6906de36aa$var$L.current & 1);
                a = $af47be6906de36aa$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $af47be6906de36aa$var$G($af47be6906de36aa$var$L, $af47be6906de36aa$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $af47be6906de36aa$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $af47be6906de36aa$var$G($af47be6906de36aa$var$L, $af47be6906de36aa$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $af47be6906de36aa$var$dj(a, b, c);
    }
    return $af47be6906de36aa$var$Zi(a, b, c);
}
var $af47be6906de36aa$var$zj, $af47be6906de36aa$var$Aj, $af47be6906de36aa$var$Bj, $af47be6906de36aa$var$Cj;
$af47be6906de36aa$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$af47be6906de36aa$var$Aj = function() {};
$af47be6906de36aa$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $af47be6906de36aa$var$xh($af47be6906de36aa$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $af47be6906de36aa$var$Ya(a, e);
                d = $af47be6906de36aa$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $af47be6906de36aa$var$A({}, e, {
                    value: void 0
                });
                d = $af47be6906de36aa$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $af47be6906de36aa$var$gb(a, e);
                d = $af47be6906de36aa$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $af47be6906de36aa$var$Bf);
        }
        $af47be6906de36aa$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($af47be6906de36aa$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($af47be6906de36aa$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $af47be6906de36aa$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$af47be6906de36aa$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $af47be6906de36aa$var$Dj(a, b) {
    if (!$af47be6906de36aa$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $af47be6906de36aa$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $af47be6906de36aa$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $af47be6906de36aa$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $af47be6906de36aa$var$S(b), null;
        case 1:
            return $af47be6906de36aa$var$Zf(b.type) && $af47be6906de36aa$var$$f(), $af47be6906de36aa$var$S(b), null;
        case 3:
            d = b.stateNode;
            $af47be6906de36aa$var$zh();
            $af47be6906de36aa$var$E($af47be6906de36aa$var$Wf);
            $af47be6906de36aa$var$E($af47be6906de36aa$var$H);
            $af47be6906de36aa$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $af47be6906de36aa$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $af47be6906de36aa$var$zg && ($af47be6906de36aa$var$Fj($af47be6906de36aa$var$zg), $af47be6906de36aa$var$zg = null));
            $af47be6906de36aa$var$Aj(a, b);
            $af47be6906de36aa$var$S(b);
            return null;
        case 5:
            $af47be6906de36aa$var$Bh(b);
            var e = $af47be6906de36aa$var$xh($af47be6906de36aa$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $af47be6906de36aa$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($af47be6906de36aa$var$p(166));
                    $af47be6906de36aa$var$S(b);
                    return null;
                }
                a = $af47be6906de36aa$var$xh($af47be6906de36aa$var$uh.current);
                if ($af47be6906de36aa$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$af47be6906de36aa$var$Of] = b;
                    d[$af47be6906de36aa$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $af47be6906de36aa$var$D("cancel", d);
                            $af47be6906de36aa$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $af47be6906de36aa$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $af47be6906de36aa$var$lf.length; e++)$af47be6906de36aa$var$D($af47be6906de36aa$var$lf[e], d);
                            break;
                        case "source":
                            $af47be6906de36aa$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $af47be6906de36aa$var$D("error", d);
                            $af47be6906de36aa$var$D("load", d);
                            break;
                        case "details":
                            $af47be6906de36aa$var$D("toggle", d);
                            break;
                        case "input":
                            $af47be6906de36aa$var$Za(d, f);
                            $af47be6906de36aa$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $af47be6906de36aa$var$D("invalid", d);
                            break;
                        case "textarea":
                            $af47be6906de36aa$var$hb(d, f), $af47be6906de36aa$var$D("invalid", d);
                    }
                    $af47be6906de36aa$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $af47be6906de36aa$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $af47be6906de36aa$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $af47be6906de36aa$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $af47be6906de36aa$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $af47be6906de36aa$var$Va(d);
                            $af47be6906de36aa$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $af47be6906de36aa$var$Va(d);
                            $af47be6906de36aa$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $af47be6906de36aa$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $af47be6906de36aa$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$af47be6906de36aa$var$Of] = b;
                    a[$af47be6906de36aa$var$Pf] = d;
                    $af47be6906de36aa$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $af47be6906de36aa$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $af47be6906de36aa$var$D("cancel", a);
                                $af47be6906de36aa$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $af47be6906de36aa$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $af47be6906de36aa$var$lf.length; e++)$af47be6906de36aa$var$D($af47be6906de36aa$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $af47be6906de36aa$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $af47be6906de36aa$var$D("error", a);
                                $af47be6906de36aa$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $af47be6906de36aa$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $af47be6906de36aa$var$Za(a, d);
                                e = $af47be6906de36aa$var$Ya(a, d);
                                $af47be6906de36aa$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $af47be6906de36aa$var$A({}, d, {
                                    value: void 0
                                });
                                $af47be6906de36aa$var$D("invalid", a);
                                break;
                            case "textarea":
                                $af47be6906de36aa$var$hb(a, d);
                                e = $af47be6906de36aa$var$gb(a, d);
                                $af47be6906de36aa$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $af47be6906de36aa$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $af47be6906de36aa$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $af47be6906de36aa$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $af47be6906de36aa$var$ob(a, k) : "number" === typeof k && $af47be6906de36aa$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($af47be6906de36aa$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $af47be6906de36aa$var$D("scroll", a) : null != k && $af47be6906de36aa$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $af47be6906de36aa$var$Va(a);
                                $af47be6906de36aa$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $af47be6906de36aa$var$Va(a);
                                $af47be6906de36aa$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $af47be6906de36aa$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $af47be6906de36aa$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $af47be6906de36aa$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $af47be6906de36aa$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $af47be6906de36aa$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $af47be6906de36aa$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($af47be6906de36aa$var$p(166));
                c = $af47be6906de36aa$var$xh($af47be6906de36aa$var$wh.current);
                $af47be6906de36aa$var$xh($af47be6906de36aa$var$uh.current);
                if ($af47be6906de36aa$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$af47be6906de36aa$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $af47be6906de36aa$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $af47be6906de36aa$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $af47be6906de36aa$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$af47be6906de36aa$var$Of] = b, b.stateNode = d;
            }
            $af47be6906de36aa$var$S(b);
            return null;
        case 13:
            $af47be6906de36aa$var$E($af47be6906de36aa$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($af47be6906de36aa$var$I && null !== $af47be6906de36aa$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $af47be6906de36aa$var$Hg(), $af47be6906de36aa$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $af47be6906de36aa$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($af47be6906de36aa$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($af47be6906de36aa$var$p(317));
                        f[$af47be6906de36aa$var$Of] = b;
                    } else $af47be6906de36aa$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $af47be6906de36aa$var$S(b);
                    f = !1;
                } else null !== $af47be6906de36aa$var$zg && ($af47be6906de36aa$var$Fj($af47be6906de36aa$var$zg), $af47be6906de36aa$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($af47be6906de36aa$var$L.current & 1) ? 0 === $af47be6906de36aa$var$T && ($af47be6906de36aa$var$T = 3) : $af47be6906de36aa$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $af47be6906de36aa$var$S(b);
            return null;
        case 4:
            return $af47be6906de36aa$var$zh(), $af47be6906de36aa$var$Aj(a, b), null === a && $af47be6906de36aa$var$sf(b.stateNode.containerInfo), $af47be6906de36aa$var$S(b), null;
        case 10:
            return $af47be6906de36aa$var$ah(b.type._context), $af47be6906de36aa$var$S(b), null;
        case 17:
            return $af47be6906de36aa$var$Zf(b.type) && $af47be6906de36aa$var$$f(), $af47be6906de36aa$var$S(b), null;
        case 19:
            $af47be6906de36aa$var$E($af47be6906de36aa$var$L);
            f = b.memoizedState;
            if (null === f) return $af47be6906de36aa$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $af47be6906de36aa$var$Dj(f, !1);
                else {
                    if (0 !== $af47be6906de36aa$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $af47be6906de36aa$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $af47be6906de36aa$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $af47be6906de36aa$var$G($af47be6906de36aa$var$L, $af47be6906de36aa$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $af47be6906de36aa$var$B() > $af47be6906de36aa$var$Gj && (b.flags |= 128, d = !0, $af47be6906de36aa$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $af47be6906de36aa$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $af47be6906de36aa$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$af47be6906de36aa$var$I) return $af47be6906de36aa$var$S(b), null;
                    } else 2 * $af47be6906de36aa$var$B() - f.renderingStartTime > $af47be6906de36aa$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $af47be6906de36aa$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $af47be6906de36aa$var$B(), b.sibling = null, c = $af47be6906de36aa$var$L.current, $af47be6906de36aa$var$G($af47be6906de36aa$var$L, d ? c & 1 | 2 : c & 1), b;
            $af47be6906de36aa$var$S(b);
            return null;
        case 22:
        case 23:
            return $af47be6906de36aa$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($af47be6906de36aa$var$fj & 1073741824) && ($af47be6906de36aa$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $af47be6906de36aa$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($af47be6906de36aa$var$p(156, b.tag));
}
function $af47be6906de36aa$var$Ij(a, b) {
    $af47be6906de36aa$var$wg(b);
    switch(b.tag){
        case 1:
            return $af47be6906de36aa$var$Zf(b.type) && $af47be6906de36aa$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $af47be6906de36aa$var$zh(), $af47be6906de36aa$var$E($af47be6906de36aa$var$Wf), $af47be6906de36aa$var$E($af47be6906de36aa$var$H), $af47be6906de36aa$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $af47be6906de36aa$var$Bh(b), null;
        case 13:
            $af47be6906de36aa$var$E($af47be6906de36aa$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($af47be6906de36aa$var$p(340));
                $af47be6906de36aa$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $af47be6906de36aa$var$E($af47be6906de36aa$var$L), null;
        case 4:
            return $af47be6906de36aa$var$zh(), null;
        case 10:
            return $af47be6906de36aa$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $af47be6906de36aa$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $af47be6906de36aa$var$Jj = !1, $af47be6906de36aa$var$U = !1, $af47be6906de36aa$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $af47be6906de36aa$var$V = null;
function $af47be6906de36aa$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $af47be6906de36aa$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $af47be6906de36aa$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $af47be6906de36aa$var$W(a, b, d);
    }
}
var $af47be6906de36aa$var$Nj = !1;
function $af47be6906de36aa$var$Oj(a, b) {
    $af47be6906de36aa$var$Cf = $af47be6906de36aa$var$dd;
    a = $af47be6906de36aa$var$Me();
    if ($af47be6906de36aa$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $af47be6906de36aa$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $af47be6906de36aa$var$dd = !1;
    for($af47be6906de36aa$var$V = b; null !== $af47be6906de36aa$var$V;)if (b = $af47be6906de36aa$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $af47be6906de36aa$var$V = a;
    else for(; null !== $af47be6906de36aa$var$V;){
        b = $af47be6906de36aa$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $af47be6906de36aa$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($af47be6906de36aa$var$p(163));
            }
        } catch (F) {
            $af47be6906de36aa$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $af47be6906de36aa$var$V = a;
            break;
        }
        $af47be6906de36aa$var$V = b.return;
    }
    n = $af47be6906de36aa$var$Nj;
    $af47be6906de36aa$var$Nj = !1;
    return n;
}
function $af47be6906de36aa$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $af47be6906de36aa$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $af47be6906de36aa$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $af47be6906de36aa$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $af47be6906de36aa$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $af47be6906de36aa$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$af47be6906de36aa$var$Of], delete b[$af47be6906de36aa$var$Pf], delete b[$af47be6906de36aa$var$of], delete b[$af47be6906de36aa$var$Qf], delete b[$af47be6906de36aa$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $af47be6906de36aa$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $af47be6906de36aa$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $af47be6906de36aa$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $af47be6906de36aa$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $af47be6906de36aa$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($af47be6906de36aa$var$Vj(a, b, c), a = a.sibling; null !== a;)$af47be6906de36aa$var$Vj(a, b, c), a = a.sibling;
}
function $af47be6906de36aa$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($af47be6906de36aa$var$Wj(a, b, c), a = a.sibling; null !== a;)$af47be6906de36aa$var$Wj(a, b, c), a = a.sibling;
}
var $af47be6906de36aa$var$X = null, $af47be6906de36aa$var$Xj = !1;
function $af47be6906de36aa$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$af47be6906de36aa$var$Zj(a, b, c), c = c.sibling;
}
function $af47be6906de36aa$var$Zj(a, b, c) {
    if ($af47be6906de36aa$var$lc && "function" === typeof $af47be6906de36aa$var$lc.onCommitFiberUnmount) try {
        $af47be6906de36aa$var$lc.onCommitFiberUnmount($af47be6906de36aa$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $af47be6906de36aa$var$U || $af47be6906de36aa$var$Lj(c, b);
        case 6:
            var d = $af47be6906de36aa$var$X, e = $af47be6906de36aa$var$Xj;
            $af47be6906de36aa$var$X = null;
            $af47be6906de36aa$var$Yj(a, b, c);
            $af47be6906de36aa$var$X = d;
            $af47be6906de36aa$var$Xj = e;
            null !== $af47be6906de36aa$var$X && ($af47be6906de36aa$var$Xj ? (a = $af47be6906de36aa$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $af47be6906de36aa$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $af47be6906de36aa$var$X && ($af47be6906de36aa$var$Xj ? (a = $af47be6906de36aa$var$X, c = c.stateNode, 8 === a.nodeType ? $af47be6906de36aa$var$Kf(a.parentNode, c) : 1 === a.nodeType && $af47be6906de36aa$var$Kf(a, c), $af47be6906de36aa$var$bd(a)) : $af47be6906de36aa$var$Kf($af47be6906de36aa$var$X, c.stateNode));
            break;
        case 4:
            d = $af47be6906de36aa$var$X;
            e = $af47be6906de36aa$var$Xj;
            $af47be6906de36aa$var$X = c.stateNode.containerInfo;
            $af47be6906de36aa$var$Xj = !0;
            $af47be6906de36aa$var$Yj(a, b, c);
            $af47be6906de36aa$var$X = d;
            $af47be6906de36aa$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$af47be6906de36aa$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $af47be6906de36aa$var$Mj(c, b, g) : 0 !== (f & 4) && $af47be6906de36aa$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $af47be6906de36aa$var$Yj(a, b, c);
            break;
        case 1:
            if (!$af47be6906de36aa$var$U && ($af47be6906de36aa$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $af47be6906de36aa$var$W(c, b, h);
            }
            $af47be6906de36aa$var$Yj(a, b, c);
            break;
        case 21:
            $af47be6906de36aa$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($af47be6906de36aa$var$U = (d = $af47be6906de36aa$var$U) || null !== c.memoizedState, $af47be6906de36aa$var$Yj(a, b, c), $af47be6906de36aa$var$U = d) : $af47be6906de36aa$var$Yj(a, b, c);
            break;
        default:
            $af47be6906de36aa$var$Yj(a, b, c);
    }
}
function $af47be6906de36aa$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $af47be6906de36aa$var$Kj);
        b.forEach(function(b) {
            var d = $af47be6906de36aa$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $af47be6906de36aa$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $af47be6906de36aa$var$X = h.stateNode;
                        $af47be6906de36aa$var$Xj = !1;
                        break a;
                    case 3:
                        $af47be6906de36aa$var$X = h.stateNode.containerInfo;
                        $af47be6906de36aa$var$Xj = !0;
                        break a;
                    case 4:
                        $af47be6906de36aa$var$X = h.stateNode.containerInfo;
                        $af47be6906de36aa$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $af47be6906de36aa$var$X) throw Error($af47be6906de36aa$var$p(160));
            $af47be6906de36aa$var$Zj(f, g, e);
            $af47be6906de36aa$var$X = null;
            $af47be6906de36aa$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $af47be6906de36aa$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$af47be6906de36aa$var$dk(b, a), b = b.sibling;
}
function $af47be6906de36aa$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            if (d & 4) {
                try {
                    $af47be6906de36aa$var$Pj(3, a, a.return), $af47be6906de36aa$var$Qj(3, a);
                } catch (t) {
                    $af47be6906de36aa$var$W(a, a.return, t);
                }
                try {
                    $af47be6906de36aa$var$Pj(5, a, a.return);
                } catch (t) {
                    $af47be6906de36aa$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            d & 512 && null !== c && $af47be6906de36aa$var$Lj(c, c.return);
            break;
        case 5:
            $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            d & 512 && null !== c && $af47be6906de36aa$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $af47be6906de36aa$var$ob(e, "");
                } catch (t) {
                    $af47be6906de36aa$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $af47be6906de36aa$var$ab(e, f);
                    $af47be6906de36aa$var$vb(h, g);
                    var l = $af47be6906de36aa$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $af47be6906de36aa$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $af47be6906de36aa$var$nb(e, q) : "children" === m ? $af47be6906de36aa$var$ob(e, q) : $af47be6906de36aa$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $af47be6906de36aa$var$bb(e, f);
                            break;
                        case "textarea":
                            $af47be6906de36aa$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $af47be6906de36aa$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $af47be6906de36aa$var$fb(e, !!f.multiple, f.defaultValue, !0) : $af47be6906de36aa$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$af47be6906de36aa$var$Pf] = f;
                } catch (t) {
                    $af47be6906de36aa$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($af47be6906de36aa$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $af47be6906de36aa$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $af47be6906de36aa$var$bd(b.containerInfo);
            } catch (t) {
                $af47be6906de36aa$var$W(a, a.return, t);
            }
            break;
        case 4:
            $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            break;
        case 13:
            $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($af47be6906de36aa$var$fk = $af47be6906de36aa$var$B()));
            d & 4 && $af47be6906de36aa$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($af47be6906de36aa$var$U = (l = $af47be6906de36aa$var$U) || m, $af47be6906de36aa$var$ck(b, a), $af47be6906de36aa$var$U = l) : $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($af47be6906de36aa$var$V = a, m = a.child; null !== m;){
                    for(q = $af47be6906de36aa$var$V = m; null !== $af47be6906de36aa$var$V;){
                        r = $af47be6906de36aa$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $af47be6906de36aa$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $af47be6906de36aa$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $af47be6906de36aa$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $af47be6906de36aa$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $af47be6906de36aa$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $af47be6906de36aa$var$V = y) : $af47be6906de36aa$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $af47be6906de36aa$var$rb("display", g));
                            } catch (t) {
                                $af47be6906de36aa$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $af47be6906de36aa$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $af47be6906de36aa$var$ck(b, a);
            $af47be6906de36aa$var$ek(a);
            d & 4 && $af47be6906de36aa$var$ak(a);
            break;
        case 21:
            break;
        default:
            $af47be6906de36aa$var$ck(b, a), $af47be6906de36aa$var$ek(a);
    }
}
function $af47be6906de36aa$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($af47be6906de36aa$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($af47be6906de36aa$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($af47be6906de36aa$var$ob(e, ""), d.flags &= -33);
                    var f = $af47be6906de36aa$var$Uj(a);
                    $af47be6906de36aa$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $af47be6906de36aa$var$Uj(a);
                    $af47be6906de36aa$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($af47be6906de36aa$var$p(161));
            }
        } catch (k) {
            $af47be6906de36aa$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $af47be6906de36aa$var$hk(a, b, c) {
    $af47be6906de36aa$var$V = a;
    $af47be6906de36aa$var$ik(a, b, c);
}
function $af47be6906de36aa$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $af47be6906de36aa$var$V;){
        var e = $af47be6906de36aa$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $af47be6906de36aa$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $af47be6906de36aa$var$U;
                h = $af47be6906de36aa$var$Jj;
                var l = $af47be6906de36aa$var$U;
                $af47be6906de36aa$var$Jj = g;
                if (($af47be6906de36aa$var$U = k) && !l) for($af47be6906de36aa$var$V = e; null !== $af47be6906de36aa$var$V;)g = $af47be6906de36aa$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $af47be6906de36aa$var$jk(e) : null !== k ? (k.return = g, $af47be6906de36aa$var$V = k) : $af47be6906de36aa$var$jk(e);
                for(; null !== f;)$af47be6906de36aa$var$V = f, $af47be6906de36aa$var$ik(f, b, c), f = f.sibling;
                $af47be6906de36aa$var$V = e;
                $af47be6906de36aa$var$Jj = h;
                $af47be6906de36aa$var$U = l;
            }
            $af47be6906de36aa$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $af47be6906de36aa$var$V = f) : $af47be6906de36aa$var$kk(a, b, c);
    }
}
function $af47be6906de36aa$var$kk(a) {
    for(; null !== $af47be6906de36aa$var$V;){
        var b = $af47be6906de36aa$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $af47be6906de36aa$var$U || $af47be6906de36aa$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$af47be6906de36aa$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $af47be6906de36aa$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $af47be6906de36aa$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $af47be6906de36aa$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $af47be6906de36aa$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($af47be6906de36aa$var$p(163));
                }
                $af47be6906de36aa$var$U || b.flags & 512 && $af47be6906de36aa$var$Rj(b);
            } catch (r) {
                $af47be6906de36aa$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $af47be6906de36aa$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $af47be6906de36aa$var$V = c;
            break;
        }
        $af47be6906de36aa$var$V = b.return;
    }
}
function $af47be6906de36aa$var$gk(a) {
    for(; null !== $af47be6906de36aa$var$V;){
        var b = $af47be6906de36aa$var$V;
        if (b === a) {
            $af47be6906de36aa$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $af47be6906de36aa$var$V = c;
            break;
        }
        $af47be6906de36aa$var$V = b.return;
    }
}
function $af47be6906de36aa$var$jk(a) {
    for(; null !== $af47be6906de36aa$var$V;){
        var b = $af47be6906de36aa$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $af47be6906de36aa$var$Qj(4, b);
                    } catch (k) {
                        $af47be6906de36aa$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $af47be6906de36aa$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $af47be6906de36aa$var$Rj(b);
                    } catch (k) {
                        $af47be6906de36aa$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $af47be6906de36aa$var$Rj(b);
                    } catch (k) {
                        $af47be6906de36aa$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $af47be6906de36aa$var$W(b, b.return, k);
        }
        if (b === a) {
            $af47be6906de36aa$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $af47be6906de36aa$var$V = h;
            break;
        }
        $af47be6906de36aa$var$V = b.return;
    }
}
var $af47be6906de36aa$var$lk = Math.ceil, $af47be6906de36aa$var$mk = $af47be6906de36aa$var$ua.ReactCurrentDispatcher, $af47be6906de36aa$var$nk = $af47be6906de36aa$var$ua.ReactCurrentOwner, $af47be6906de36aa$var$ok = $af47be6906de36aa$var$ua.ReactCurrentBatchConfig, $af47be6906de36aa$var$K = 0, $af47be6906de36aa$var$Q = null, $af47be6906de36aa$var$Y = null, $af47be6906de36aa$var$Z = 0, $af47be6906de36aa$var$fj = 0, $af47be6906de36aa$var$ej = $af47be6906de36aa$var$Uf(0), $af47be6906de36aa$var$T = 0, $af47be6906de36aa$var$pk = null, $af47be6906de36aa$var$rh = 0, $af47be6906de36aa$var$qk = 0, $af47be6906de36aa$var$rk = 0, $af47be6906de36aa$var$sk = null, $af47be6906de36aa$var$tk = null, $af47be6906de36aa$var$fk = 0, $af47be6906de36aa$var$Gj = Infinity, $af47be6906de36aa$var$uk = null, $af47be6906de36aa$var$Oi = !1, $af47be6906de36aa$var$Pi = null, $af47be6906de36aa$var$Ri = null, $af47be6906de36aa$var$vk = !1, $af47be6906de36aa$var$wk = null, $af47be6906de36aa$var$xk = 0, $af47be6906de36aa$var$yk = 0, $af47be6906de36aa$var$zk = null, $af47be6906de36aa$var$Ak = -1, $af47be6906de36aa$var$Bk = 0;
function $af47be6906de36aa$var$R() {
    return 0 !== ($af47be6906de36aa$var$K & 6) ? $af47be6906de36aa$var$B() : -1 !== $af47be6906de36aa$var$Ak ? $af47be6906de36aa$var$Ak : $af47be6906de36aa$var$Ak = $af47be6906de36aa$var$B();
}
function $af47be6906de36aa$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($af47be6906de36aa$var$K & 2) && 0 !== $af47be6906de36aa$var$Z) return $af47be6906de36aa$var$Z & -$af47be6906de36aa$var$Z;
    if (null !== $af47be6906de36aa$var$Kg.transition) return 0 === $af47be6906de36aa$var$Bk && ($af47be6906de36aa$var$Bk = $af47be6906de36aa$var$yc()), $af47be6906de36aa$var$Bk;
    a = $af47be6906de36aa$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $af47be6906de36aa$var$jd(a.type);
    return a;
}
function $af47be6906de36aa$var$gi(a, b, c, d) {
    if (50 < $af47be6906de36aa$var$yk) throw $af47be6906de36aa$var$yk = 0, $af47be6906de36aa$var$zk = null, Error($af47be6906de36aa$var$p(185));
    $af47be6906de36aa$var$Ac(a, c, d);
    if (0 === ($af47be6906de36aa$var$K & 2) || a !== $af47be6906de36aa$var$Q) a === $af47be6906de36aa$var$Q && (0 === ($af47be6906de36aa$var$K & 2) && ($af47be6906de36aa$var$qk |= c), 4 === $af47be6906de36aa$var$T && $af47be6906de36aa$var$Ck(a, $af47be6906de36aa$var$Z)), $af47be6906de36aa$var$Dk(a, d), 1 === c && 0 === $af47be6906de36aa$var$K && 0 === (b.mode & 1) && ($af47be6906de36aa$var$Gj = $af47be6906de36aa$var$B() + 500, $af47be6906de36aa$var$fg && $af47be6906de36aa$var$jg());
}
function $af47be6906de36aa$var$Dk(a, b) {
    var c = a.callbackNode;
    $af47be6906de36aa$var$wc(a, b);
    var d = $af47be6906de36aa$var$uc(a, a === $af47be6906de36aa$var$Q ? $af47be6906de36aa$var$Z : 0);
    if (0 === d) null !== c && $af47be6906de36aa$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $af47be6906de36aa$var$bc(c);
        if (1 === b) 0 === a.tag ? $af47be6906de36aa$var$ig($af47be6906de36aa$var$Ek.bind(null, a)) : $af47be6906de36aa$var$hg($af47be6906de36aa$var$Ek.bind(null, a)), $af47be6906de36aa$var$Jf(function() {
            0 === ($af47be6906de36aa$var$K & 6) && $af47be6906de36aa$var$jg();
        }), c = null;
        else {
            switch($af47be6906de36aa$var$Dc(d)){
                case 1:
                    c = $af47be6906de36aa$var$fc;
                    break;
                case 4:
                    c = $af47be6906de36aa$var$gc;
                    break;
                case 16:
                    c = $af47be6906de36aa$var$hc;
                    break;
                case 536870912:
                    c = $af47be6906de36aa$var$jc;
                    break;
                default:
                    c = $af47be6906de36aa$var$hc;
            }
            c = $af47be6906de36aa$var$Fk(c, $af47be6906de36aa$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $af47be6906de36aa$var$Gk(a, b) {
    $af47be6906de36aa$var$Ak = -1;
    $af47be6906de36aa$var$Bk = 0;
    if (0 !== ($af47be6906de36aa$var$K & 6)) throw Error($af47be6906de36aa$var$p(327));
    var c = a.callbackNode;
    if ($af47be6906de36aa$var$Hk() && a.callbackNode !== c) return null;
    var d = $af47be6906de36aa$var$uc(a, a === $af47be6906de36aa$var$Q ? $af47be6906de36aa$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $af47be6906de36aa$var$Ik(a, d);
    else {
        b = d;
        var e = $af47be6906de36aa$var$K;
        $af47be6906de36aa$var$K |= 2;
        var f = $af47be6906de36aa$var$Jk();
        if ($af47be6906de36aa$var$Q !== a || $af47be6906de36aa$var$Z !== b) $af47be6906de36aa$var$uk = null, $af47be6906de36aa$var$Gj = $af47be6906de36aa$var$B() + 500, $af47be6906de36aa$var$Kk(a, b);
        for(;;)try {
            $af47be6906de36aa$var$Lk();
            break;
        } catch (h) {
            $af47be6906de36aa$var$Mk(a, h);
        }
        $af47be6906de36aa$var$$g();
        $af47be6906de36aa$var$mk.current = f;
        $af47be6906de36aa$var$K = e;
        null !== $af47be6906de36aa$var$Y ? b = 0 : ($af47be6906de36aa$var$Q = null, $af47be6906de36aa$var$Z = 0, b = $af47be6906de36aa$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $af47be6906de36aa$var$xc(a), 0 !== e && (d = e, b = $af47be6906de36aa$var$Nk(a, e)));
        if (1 === b) throw c = $af47be6906de36aa$var$pk, $af47be6906de36aa$var$Kk(a, 0), $af47be6906de36aa$var$Ck(a, d), $af47be6906de36aa$var$Dk(a, $af47be6906de36aa$var$B()), c;
        if (6 === b) $af47be6906de36aa$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$af47be6906de36aa$var$Ok(e) && (b = $af47be6906de36aa$var$Ik(a, d), 2 === b && (f = $af47be6906de36aa$var$xc(a), 0 !== f && (d = f, b = $af47be6906de36aa$var$Nk(a, f))), 1 === b)) throw c = $af47be6906de36aa$var$pk, $af47be6906de36aa$var$Kk(a, 0), $af47be6906de36aa$var$Ck(a, d), $af47be6906de36aa$var$Dk(a, $af47be6906de36aa$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($af47be6906de36aa$var$p(345));
                case 2:
                    $af47be6906de36aa$var$Pk(a, $af47be6906de36aa$var$tk, $af47be6906de36aa$var$uk);
                    break;
                case 3:
                    $af47be6906de36aa$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $af47be6906de36aa$var$fk + 500 - $af47be6906de36aa$var$B(), 10 < b)) {
                        if (0 !== $af47be6906de36aa$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $af47be6906de36aa$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $af47be6906de36aa$var$Ff($af47be6906de36aa$var$Pk.bind(null, a, $af47be6906de36aa$var$tk, $af47be6906de36aa$var$uk), b);
                        break;
                    }
                    $af47be6906de36aa$var$Pk(a, $af47be6906de36aa$var$tk, $af47be6906de36aa$var$uk);
                    break;
                case 4:
                    $af47be6906de36aa$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $af47be6906de36aa$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $af47be6906de36aa$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $af47be6906de36aa$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $af47be6906de36aa$var$Ff($af47be6906de36aa$var$Pk.bind(null, a, $af47be6906de36aa$var$tk, $af47be6906de36aa$var$uk), d);
                        break;
                    }
                    $af47be6906de36aa$var$Pk(a, $af47be6906de36aa$var$tk, $af47be6906de36aa$var$uk);
                    break;
                case 5:
                    $af47be6906de36aa$var$Pk(a, $af47be6906de36aa$var$tk, $af47be6906de36aa$var$uk);
                    break;
                default:
                    throw Error($af47be6906de36aa$var$p(329));
            }
        }
    }
    $af47be6906de36aa$var$Dk(a, $af47be6906de36aa$var$B());
    return a.callbackNode === c ? $af47be6906de36aa$var$Gk.bind(null, a) : null;
}
function $af47be6906de36aa$var$Nk(a, b) {
    var c = $af47be6906de36aa$var$sk;
    a.current.memoizedState.isDehydrated && ($af47be6906de36aa$var$Kk(a, b).flags |= 256);
    a = $af47be6906de36aa$var$Ik(a, b);
    2 !== a && (b = $af47be6906de36aa$var$tk, $af47be6906de36aa$var$tk = c, null !== b && $af47be6906de36aa$var$Fj(b));
    return a;
}
function $af47be6906de36aa$var$Fj(a) {
    null === $af47be6906de36aa$var$tk ? $af47be6906de36aa$var$tk = a : $af47be6906de36aa$var$tk.push.apply($af47be6906de36aa$var$tk, a);
}
function $af47be6906de36aa$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$af47be6906de36aa$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $af47be6906de36aa$var$Ck(a, b) {
    b &= ~$af47be6906de36aa$var$rk;
    b &= ~$af47be6906de36aa$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $af47be6906de36aa$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $af47be6906de36aa$var$Ek(a) {
    if (0 !== ($af47be6906de36aa$var$K & 6)) throw Error($af47be6906de36aa$var$p(327));
    $af47be6906de36aa$var$Hk();
    var b = $af47be6906de36aa$var$uc(a, 0);
    if (0 === (b & 1)) return $af47be6906de36aa$var$Dk(a, $af47be6906de36aa$var$B()), null;
    var c = $af47be6906de36aa$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $af47be6906de36aa$var$xc(a);
        0 !== d && (b = d, c = $af47be6906de36aa$var$Nk(a, d));
    }
    if (1 === c) throw c = $af47be6906de36aa$var$pk, $af47be6906de36aa$var$Kk(a, 0), $af47be6906de36aa$var$Ck(a, b), $af47be6906de36aa$var$Dk(a, $af47be6906de36aa$var$B()), c;
    if (6 === c) throw Error($af47be6906de36aa$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $af47be6906de36aa$var$Pk(a, $af47be6906de36aa$var$tk, $af47be6906de36aa$var$uk);
    $af47be6906de36aa$var$Dk(a, $af47be6906de36aa$var$B());
    return null;
}
function $af47be6906de36aa$var$Qk(a, b) {
    var c = $af47be6906de36aa$var$K;
    $af47be6906de36aa$var$K |= 1;
    try {
        return a(b);
    } finally{
        $af47be6906de36aa$var$K = c, 0 === $af47be6906de36aa$var$K && ($af47be6906de36aa$var$Gj = $af47be6906de36aa$var$B() + 500, $af47be6906de36aa$var$fg && $af47be6906de36aa$var$jg());
    }
}
function $af47be6906de36aa$var$Rk(a) {
    null !== $af47be6906de36aa$var$wk && 0 === $af47be6906de36aa$var$wk.tag && 0 === ($af47be6906de36aa$var$K & 6) && $af47be6906de36aa$var$Hk();
    var b = $af47be6906de36aa$var$K;
    $af47be6906de36aa$var$K |= 1;
    var c = $af47be6906de36aa$var$ok.transition, d = $af47be6906de36aa$var$C;
    try {
        if ($af47be6906de36aa$var$ok.transition = null, $af47be6906de36aa$var$C = 1, a) return a();
    } finally{
        $af47be6906de36aa$var$C = d, $af47be6906de36aa$var$ok.transition = c, $af47be6906de36aa$var$K = b, 0 === ($af47be6906de36aa$var$K & 6) && $af47be6906de36aa$var$jg();
    }
}
function $af47be6906de36aa$var$Hj() {
    $af47be6906de36aa$var$fj = $af47be6906de36aa$var$ej.current;
    $af47be6906de36aa$var$E($af47be6906de36aa$var$ej);
}
function $af47be6906de36aa$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $af47be6906de36aa$var$Gf(c));
    if (null !== $af47be6906de36aa$var$Y) for(c = $af47be6906de36aa$var$Y.return; null !== c;){
        var d = c;
        $af47be6906de36aa$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $af47be6906de36aa$var$$f();
                break;
            case 3:
                $af47be6906de36aa$var$zh();
                $af47be6906de36aa$var$E($af47be6906de36aa$var$Wf);
                $af47be6906de36aa$var$E($af47be6906de36aa$var$H);
                $af47be6906de36aa$var$Eh();
                break;
            case 5:
                $af47be6906de36aa$var$Bh(d);
                break;
            case 4:
                $af47be6906de36aa$var$zh();
                break;
            case 13:
                $af47be6906de36aa$var$E($af47be6906de36aa$var$L);
                break;
            case 19:
                $af47be6906de36aa$var$E($af47be6906de36aa$var$L);
                break;
            case 10:
                $af47be6906de36aa$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $af47be6906de36aa$var$Hj();
        }
        c = c.return;
    }
    $af47be6906de36aa$var$Q = a;
    $af47be6906de36aa$var$Y = a = $af47be6906de36aa$var$Pg(a.current, null);
    $af47be6906de36aa$var$Z = $af47be6906de36aa$var$fj = b;
    $af47be6906de36aa$var$T = 0;
    $af47be6906de36aa$var$pk = null;
    $af47be6906de36aa$var$rk = $af47be6906de36aa$var$qk = $af47be6906de36aa$var$rh = 0;
    $af47be6906de36aa$var$tk = $af47be6906de36aa$var$sk = null;
    if (null !== $af47be6906de36aa$var$fh) {
        for(b = 0; b < $af47be6906de36aa$var$fh.length; b++)if (c = $af47be6906de36aa$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $af47be6906de36aa$var$fh = null;
    }
    return a;
}
function $af47be6906de36aa$var$Mk(a, b) {
    do {
        var c = $af47be6906de36aa$var$Y;
        try {
            $af47be6906de36aa$var$$g();
            $af47be6906de36aa$var$Fh.current = $af47be6906de36aa$var$Rh;
            if ($af47be6906de36aa$var$Ih) {
                for(var d = $af47be6906de36aa$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $af47be6906de36aa$var$Ih = !1;
            }
            $af47be6906de36aa$var$Hh = 0;
            $af47be6906de36aa$var$O = $af47be6906de36aa$var$N = $af47be6906de36aa$var$M = null;
            $af47be6906de36aa$var$Jh = !1;
            $af47be6906de36aa$var$Kh = 0;
            $af47be6906de36aa$var$nk.current = null;
            if (null === c || null === c.return) {
                $af47be6906de36aa$var$T = 1;
                $af47be6906de36aa$var$pk = b;
                $af47be6906de36aa$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $af47be6906de36aa$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $af47be6906de36aa$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $af47be6906de36aa$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $af47be6906de36aa$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $af47be6906de36aa$var$Si(f, l, b);
                            $af47be6906de36aa$var$tj();
                            break a;
                        }
                        k = Error($af47be6906de36aa$var$p(426));
                    }
                } else if ($af47be6906de36aa$var$I && h.mode & 1) {
                    var J = $af47be6906de36aa$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $af47be6906de36aa$var$Vi(J, g, h, f, b);
                        $af47be6906de36aa$var$Jg($af47be6906de36aa$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $af47be6906de36aa$var$Ji(k, h);
                4 !== $af47be6906de36aa$var$T && ($af47be6906de36aa$var$T = 2);
                null === $af47be6906de36aa$var$sk ? $af47be6906de36aa$var$sk = [
                    f
                ] : $af47be6906de36aa$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $af47be6906de36aa$var$Ni(f, k, b);
                            $af47be6906de36aa$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $af47be6906de36aa$var$Ri || !$af47be6906de36aa$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $af47be6906de36aa$var$Qi(f, h, b);
                                $af47be6906de36aa$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $af47be6906de36aa$var$Sk(c);
        } catch (na) {
            b = na;
            $af47be6906de36aa$var$Y === c && null !== c && ($af47be6906de36aa$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $af47be6906de36aa$var$Jk() {
    var a = $af47be6906de36aa$var$mk.current;
    $af47be6906de36aa$var$mk.current = $af47be6906de36aa$var$Rh;
    return null === a ? $af47be6906de36aa$var$Rh : a;
}
function $af47be6906de36aa$var$tj() {
    if (0 === $af47be6906de36aa$var$T || 3 === $af47be6906de36aa$var$T || 2 === $af47be6906de36aa$var$T) $af47be6906de36aa$var$T = 4;
    null === $af47be6906de36aa$var$Q || 0 === ($af47be6906de36aa$var$rh & 268435455) && 0 === ($af47be6906de36aa$var$qk & 268435455) || $af47be6906de36aa$var$Ck($af47be6906de36aa$var$Q, $af47be6906de36aa$var$Z);
}
function $af47be6906de36aa$var$Ik(a, b) {
    var c = $af47be6906de36aa$var$K;
    $af47be6906de36aa$var$K |= 2;
    var d = $af47be6906de36aa$var$Jk();
    if ($af47be6906de36aa$var$Q !== a || $af47be6906de36aa$var$Z !== b) $af47be6906de36aa$var$uk = null, $af47be6906de36aa$var$Kk(a, b);
    for(;;)try {
        $af47be6906de36aa$var$Tk();
        break;
    } catch (e) {
        $af47be6906de36aa$var$Mk(a, e);
    }
    $af47be6906de36aa$var$$g();
    $af47be6906de36aa$var$K = c;
    $af47be6906de36aa$var$mk.current = d;
    if (null !== $af47be6906de36aa$var$Y) throw Error($af47be6906de36aa$var$p(261));
    $af47be6906de36aa$var$Q = null;
    $af47be6906de36aa$var$Z = 0;
    return $af47be6906de36aa$var$T;
}
function $af47be6906de36aa$var$Tk() {
    for(; null !== $af47be6906de36aa$var$Y;)$af47be6906de36aa$var$Uk($af47be6906de36aa$var$Y);
}
function $af47be6906de36aa$var$Lk() {
    for(; null !== $af47be6906de36aa$var$Y && !$af47be6906de36aa$var$cc();)$af47be6906de36aa$var$Uk($af47be6906de36aa$var$Y);
}
function $af47be6906de36aa$var$Uk(a) {
    var b = $af47be6906de36aa$var$Vk(a.alternate, a, $af47be6906de36aa$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $af47be6906de36aa$var$Sk(a) : $af47be6906de36aa$var$Y = b;
    $af47be6906de36aa$var$nk.current = null;
}
function $af47be6906de36aa$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $af47be6906de36aa$var$Ej(c, b, $af47be6906de36aa$var$fj), null !== c) {
                $af47be6906de36aa$var$Y = c;
                return;
            }
        } else {
            c = $af47be6906de36aa$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $af47be6906de36aa$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $af47be6906de36aa$var$T = 6;
                $af47be6906de36aa$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $af47be6906de36aa$var$Y = b;
            return;
        }
        $af47be6906de36aa$var$Y = b = a;
    }while (null !== b);
    0 === $af47be6906de36aa$var$T && ($af47be6906de36aa$var$T = 5);
}
function $af47be6906de36aa$var$Pk(a, b, c) {
    var d = $af47be6906de36aa$var$C, e = $af47be6906de36aa$var$ok.transition;
    try {
        $af47be6906de36aa$var$ok.transition = null, $af47be6906de36aa$var$C = 1, $af47be6906de36aa$var$Wk(a, b, c, d);
    } finally{
        $af47be6906de36aa$var$ok.transition = e, $af47be6906de36aa$var$C = d;
    }
    return null;
}
function $af47be6906de36aa$var$Wk(a, b, c, d) {
    do $af47be6906de36aa$var$Hk();
    while (null !== $af47be6906de36aa$var$wk);
    if (0 !== ($af47be6906de36aa$var$K & 6)) throw Error($af47be6906de36aa$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($af47be6906de36aa$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $af47be6906de36aa$var$Bc(a, f);
    a === $af47be6906de36aa$var$Q && ($af47be6906de36aa$var$Y = $af47be6906de36aa$var$Q = null, $af47be6906de36aa$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $af47be6906de36aa$var$vk || ($af47be6906de36aa$var$vk = !0, $af47be6906de36aa$var$Fk($af47be6906de36aa$var$hc, function() {
        $af47be6906de36aa$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $af47be6906de36aa$var$ok.transition;
        $af47be6906de36aa$var$ok.transition = null;
        var g = $af47be6906de36aa$var$C;
        $af47be6906de36aa$var$C = 1;
        var h = $af47be6906de36aa$var$K;
        $af47be6906de36aa$var$K |= 4;
        $af47be6906de36aa$var$nk.current = null;
        $af47be6906de36aa$var$Oj(a, c);
        $af47be6906de36aa$var$dk(c, a);
        $af47be6906de36aa$var$Oe($af47be6906de36aa$var$Df);
        $af47be6906de36aa$var$dd = !!$af47be6906de36aa$var$Cf;
        $af47be6906de36aa$var$Df = $af47be6906de36aa$var$Cf = null;
        a.current = c;
        $af47be6906de36aa$var$hk(c, a, e);
        $af47be6906de36aa$var$dc();
        $af47be6906de36aa$var$K = h;
        $af47be6906de36aa$var$C = g;
        $af47be6906de36aa$var$ok.transition = f;
    } else a.current = c;
    $af47be6906de36aa$var$vk && ($af47be6906de36aa$var$vk = !1, $af47be6906de36aa$var$wk = a, $af47be6906de36aa$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($af47be6906de36aa$var$Ri = null);
    $af47be6906de36aa$var$mc(c.stateNode, d);
    $af47be6906de36aa$var$Dk(a, $af47be6906de36aa$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($af47be6906de36aa$var$Oi) throw $af47be6906de36aa$var$Oi = !1, a = $af47be6906de36aa$var$Pi, $af47be6906de36aa$var$Pi = null, a;
    0 !== ($af47be6906de36aa$var$xk & 1) && 0 !== a.tag && $af47be6906de36aa$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $af47be6906de36aa$var$zk ? $af47be6906de36aa$var$yk++ : ($af47be6906de36aa$var$yk = 0, $af47be6906de36aa$var$zk = a) : $af47be6906de36aa$var$yk = 0;
    $af47be6906de36aa$var$jg();
    return null;
}
function $af47be6906de36aa$var$Hk() {
    if (null !== $af47be6906de36aa$var$wk) {
        var a = $af47be6906de36aa$var$Dc($af47be6906de36aa$var$xk), b = $af47be6906de36aa$var$ok.transition, c = $af47be6906de36aa$var$C;
        try {
            $af47be6906de36aa$var$ok.transition = null;
            $af47be6906de36aa$var$C = 16 > a ? 16 : a;
            if (null === $af47be6906de36aa$var$wk) var d = !1;
            else {
                a = $af47be6906de36aa$var$wk;
                $af47be6906de36aa$var$wk = null;
                $af47be6906de36aa$var$xk = 0;
                if (0 !== ($af47be6906de36aa$var$K & 6)) throw Error($af47be6906de36aa$var$p(331));
                var e = $af47be6906de36aa$var$K;
                $af47be6906de36aa$var$K |= 4;
                for($af47be6906de36aa$var$V = a.current; null !== $af47be6906de36aa$var$V;){
                    var f = $af47be6906de36aa$var$V, g = f.child;
                    if (0 !== ($af47be6906de36aa$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($af47be6906de36aa$var$V = l; null !== $af47be6906de36aa$var$V;){
                                    var m = $af47be6906de36aa$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $af47be6906de36aa$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $af47be6906de36aa$var$V = q;
                                    else for(; null !== $af47be6906de36aa$var$V;){
                                        m = $af47be6906de36aa$var$V;
                                        var r = m.sibling, y = m.return;
                                        $af47be6906de36aa$var$Sj(m);
                                        if (m === l) {
                                            $af47be6906de36aa$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $af47be6906de36aa$var$V = r;
                                            break;
                                        }
                                        $af47be6906de36aa$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $af47be6906de36aa$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $af47be6906de36aa$var$V = g;
                    else b: for(; null !== $af47be6906de36aa$var$V;){
                        f = $af47be6906de36aa$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $af47be6906de36aa$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $af47be6906de36aa$var$V = x;
                            break b;
                        }
                        $af47be6906de36aa$var$V = f.return;
                    }
                }
                var w = a.current;
                for($af47be6906de36aa$var$V = w; null !== $af47be6906de36aa$var$V;){
                    g = $af47be6906de36aa$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $af47be6906de36aa$var$V = u;
                    else b: for(g = w; null !== $af47be6906de36aa$var$V;){
                        h = $af47be6906de36aa$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $af47be6906de36aa$var$Qj(9, h);
                            }
                        } catch (na) {
                            $af47be6906de36aa$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $af47be6906de36aa$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $af47be6906de36aa$var$V = F;
                            break b;
                        }
                        $af47be6906de36aa$var$V = h.return;
                    }
                }
                $af47be6906de36aa$var$K = e;
                $af47be6906de36aa$var$jg();
                if ($af47be6906de36aa$var$lc && "function" === typeof $af47be6906de36aa$var$lc.onPostCommitFiberRoot) try {
                    $af47be6906de36aa$var$lc.onPostCommitFiberRoot($af47be6906de36aa$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $af47be6906de36aa$var$C = c, $af47be6906de36aa$var$ok.transition = b;
        }
    }
    return !1;
}
function $af47be6906de36aa$var$Xk(a, b, c) {
    b = $af47be6906de36aa$var$Ji(c, b);
    b = $af47be6906de36aa$var$Ni(a, b, 1);
    a = $af47be6906de36aa$var$nh(a, b, 1);
    b = $af47be6906de36aa$var$R();
    null !== a && ($af47be6906de36aa$var$Ac(a, 1, b), $af47be6906de36aa$var$Dk(a, b));
}
function $af47be6906de36aa$var$W(a, b, c) {
    if (3 === a.tag) $af47be6906de36aa$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $af47be6906de36aa$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $af47be6906de36aa$var$Ri || !$af47be6906de36aa$var$Ri.has(d))) {
                a = $af47be6906de36aa$var$Ji(c, a);
                a = $af47be6906de36aa$var$Qi(b, a, 1);
                b = $af47be6906de36aa$var$nh(b, a, 1);
                a = $af47be6906de36aa$var$R();
                null !== b && ($af47be6906de36aa$var$Ac(b, 1, a), $af47be6906de36aa$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $af47be6906de36aa$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $af47be6906de36aa$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $af47be6906de36aa$var$Q === a && ($af47be6906de36aa$var$Z & c) === c && (4 === $af47be6906de36aa$var$T || 3 === $af47be6906de36aa$var$T && ($af47be6906de36aa$var$Z & 130023424) === $af47be6906de36aa$var$Z && 500 > $af47be6906de36aa$var$B() - $af47be6906de36aa$var$fk ? $af47be6906de36aa$var$Kk(a, 0) : $af47be6906de36aa$var$rk |= c);
    $af47be6906de36aa$var$Dk(a, b);
}
function $af47be6906de36aa$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $af47be6906de36aa$var$sc, $af47be6906de36aa$var$sc <<= 1, 0 === ($af47be6906de36aa$var$sc & 130023424) && ($af47be6906de36aa$var$sc = 4194304)));
    var c = $af47be6906de36aa$var$R();
    a = $af47be6906de36aa$var$ih(a, b);
    null !== a && ($af47be6906de36aa$var$Ac(a, b, c), $af47be6906de36aa$var$Dk(a, c));
}
function $af47be6906de36aa$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $af47be6906de36aa$var$Yk(a, c);
}
function $af47be6906de36aa$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($af47be6906de36aa$var$p(314));
    }
    null !== d && d.delete(b);
    $af47be6906de36aa$var$Yk(a, c);
}
var $af47be6906de36aa$var$Vk;
$af47be6906de36aa$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $af47be6906de36aa$var$Wf.current) $af47be6906de36aa$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $af47be6906de36aa$var$dh = !1, $af47be6906de36aa$var$yj(a, b, c);
            $af47be6906de36aa$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $af47be6906de36aa$var$dh = !1, $af47be6906de36aa$var$I && 0 !== (b.flags & 1048576) && $af47be6906de36aa$var$ug(b, $af47be6906de36aa$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $af47be6906de36aa$var$ij(a, b);
            a = b.pendingProps;
            var e = $af47be6906de36aa$var$Yf(b, $af47be6906de36aa$var$H.current);
            $af47be6906de36aa$var$ch(b, c);
            e = $af47be6906de36aa$var$Nh(null, b, d, a, e, c);
            var f = $af47be6906de36aa$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $af47be6906de36aa$var$Zf(d) ? (f = !0, $af47be6906de36aa$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $af47be6906de36aa$var$kh(b), e.updater = $af47be6906de36aa$var$Ei, b.stateNode = e, e._reactInternals = b, $af47be6906de36aa$var$Ii(b, d, a, c), b = $af47be6906de36aa$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $af47be6906de36aa$var$I && f && $af47be6906de36aa$var$vg(b), $af47be6906de36aa$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $af47be6906de36aa$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $af47be6906de36aa$var$Zk(d);
                a = $af47be6906de36aa$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $af47be6906de36aa$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $af47be6906de36aa$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $af47be6906de36aa$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $af47be6906de36aa$var$$i(null, b, d, $af47be6906de36aa$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($af47be6906de36aa$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af47be6906de36aa$var$Ci(d, e), $af47be6906de36aa$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af47be6906de36aa$var$Ci(d, e), $af47be6906de36aa$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $af47be6906de36aa$var$kj(b);
                if (null === a) throw Error($af47be6906de36aa$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $af47be6906de36aa$var$lh(a, b);
                $af47be6906de36aa$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $af47be6906de36aa$var$Ji(Error($af47be6906de36aa$var$p(423)), b);
                        b = $af47be6906de36aa$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $af47be6906de36aa$var$Ji(Error($af47be6906de36aa$var$p(424)), b);
                        b = $af47be6906de36aa$var$lj(a, b, d, c, e);
                        break a;
                    } else for($af47be6906de36aa$var$yg = $af47be6906de36aa$var$Lf(b.stateNode.containerInfo.firstChild), $af47be6906de36aa$var$xg = b, $af47be6906de36aa$var$I = !0, $af47be6906de36aa$var$zg = null, c = $af47be6906de36aa$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $af47be6906de36aa$var$Ig();
                    if (d === e) {
                        b = $af47be6906de36aa$var$Zi(a, b, c);
                        break a;
                    }
                    $af47be6906de36aa$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $af47be6906de36aa$var$Ah(b), null === a && $af47be6906de36aa$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $af47be6906de36aa$var$Ef(d, e) ? g = null : null !== f && $af47be6906de36aa$var$Ef(d, f) && (b.flags |= 32), $af47be6906de36aa$var$gj(a, b), $af47be6906de36aa$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $af47be6906de36aa$var$Eg(b), null;
        case 13:
            return $af47be6906de36aa$var$oj(a, b, c);
        case 4:
            return $af47be6906de36aa$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $af47be6906de36aa$var$Ug(b, null, d, c) : $af47be6906de36aa$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af47be6906de36aa$var$Ci(d, e), $af47be6906de36aa$var$Yi(a, b, d, e, c);
        case 7:
            return $af47be6906de36aa$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $af47be6906de36aa$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $af47be6906de36aa$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $af47be6906de36aa$var$G($af47be6906de36aa$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($af47be6906de36aa$var$He(f.value, g)) {
                        if (f.children === e.children && !$af47be6906de36aa$var$Wf.current) {
                            b = $af47be6906de36aa$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $af47be6906de36aa$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $af47be6906de36aa$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($af47be6906de36aa$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $af47be6906de36aa$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $af47be6906de36aa$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $af47be6906de36aa$var$ch(b, c), e = $af47be6906de36aa$var$eh(e), d = d(e), b.flags |= 1, $af47be6906de36aa$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $af47be6906de36aa$var$Ci(d, b.pendingProps), e = $af47be6906de36aa$var$Ci(d.type, e), $af47be6906de36aa$var$$i(a, b, d, e, c);
        case 15:
            return $af47be6906de36aa$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af47be6906de36aa$var$Ci(d, e), $af47be6906de36aa$var$ij(a, b), b.tag = 1, $af47be6906de36aa$var$Zf(d) ? (a = !0, $af47be6906de36aa$var$cg(b)) : a = !1, $af47be6906de36aa$var$ch(b, c), $af47be6906de36aa$var$Gi(b, d, e), $af47be6906de36aa$var$Ii(b, d, e, c), $af47be6906de36aa$var$jj(null, b, d, !0, a, c);
        case 19:
            return $af47be6906de36aa$var$xj(a, b, c);
        case 22:
            return $af47be6906de36aa$var$dj(a, b, c);
    }
    throw Error($af47be6906de36aa$var$p(156, b.tag));
};
function $af47be6906de36aa$var$Fk(a, b) {
    return $af47be6906de36aa$var$ac(a, b);
}
function $af47be6906de36aa$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $af47be6906de36aa$var$Bg(a, b, c, d) {
    return new $af47be6906de36aa$var$$k(a, b, c, d);
}
function $af47be6906de36aa$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $af47be6906de36aa$var$Zk(a) {
    if ("function" === typeof a) return $af47be6906de36aa$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $af47be6906de36aa$var$Da) return 11;
        if (a === $af47be6906de36aa$var$Ga) return 14;
    }
    return 2;
}
function $af47be6906de36aa$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $af47be6906de36aa$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $af47be6906de36aa$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $af47be6906de36aa$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $af47be6906de36aa$var$ya:
            return $af47be6906de36aa$var$Tg(c.children, e, f, b);
        case $af47be6906de36aa$var$za:
            g = 8;
            e |= 8;
            break;
        case $af47be6906de36aa$var$Aa:
            return a = $af47be6906de36aa$var$Bg(12, c, b, e | 2), a.elementType = $af47be6906de36aa$var$Aa, a.lanes = f, a;
        case $af47be6906de36aa$var$Ea:
            return a = $af47be6906de36aa$var$Bg(13, c, b, e), a.elementType = $af47be6906de36aa$var$Ea, a.lanes = f, a;
        case $af47be6906de36aa$var$Fa:
            return a = $af47be6906de36aa$var$Bg(19, c, b, e), a.elementType = $af47be6906de36aa$var$Fa, a.lanes = f, a;
        case $af47be6906de36aa$var$Ia:
            return $af47be6906de36aa$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $af47be6906de36aa$var$Ba:
                    g = 10;
                    break a;
                case $af47be6906de36aa$var$Ca:
                    g = 9;
                    break a;
                case $af47be6906de36aa$var$Da:
                    g = 11;
                    break a;
                case $af47be6906de36aa$var$Ga:
                    g = 14;
                    break a;
                case $af47be6906de36aa$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($af47be6906de36aa$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $af47be6906de36aa$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $af47be6906de36aa$var$Tg(a, b, c, d) {
    a = $af47be6906de36aa$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $af47be6906de36aa$var$pj(a, b, c, d) {
    a = $af47be6906de36aa$var$Bg(22, a, d, b);
    a.elementType = $af47be6906de36aa$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $af47be6906de36aa$var$Qg(a, b, c) {
    a = $af47be6906de36aa$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $af47be6906de36aa$var$Sg(a, b, c) {
    b = $af47be6906de36aa$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $af47be6906de36aa$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $af47be6906de36aa$var$zc(0);
    this.expirationTimes = $af47be6906de36aa$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $af47be6906de36aa$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $af47be6906de36aa$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $af47be6906de36aa$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $af47be6906de36aa$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $af47be6906de36aa$var$kh(f);
    return a;
}
function $af47be6906de36aa$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $af47be6906de36aa$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $af47be6906de36aa$var$dl(a) {
    if (!a) return $af47be6906de36aa$var$Vf;
    a = a._reactInternals;
    a: {
        if ($af47be6906de36aa$var$Vb(a) !== a || 1 !== a.tag) throw Error($af47be6906de36aa$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($af47be6906de36aa$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($af47be6906de36aa$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($af47be6906de36aa$var$Zf(c)) return $af47be6906de36aa$var$bg(a, c, b);
    }
    return b;
}
function $af47be6906de36aa$var$el(a, b, c, d, e, f, g, h, k) {
    a = $af47be6906de36aa$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $af47be6906de36aa$var$dl(null);
    c = a.current;
    d = $af47be6906de36aa$var$R();
    e = $af47be6906de36aa$var$yi(c);
    f = $af47be6906de36aa$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $af47be6906de36aa$var$nh(c, f, e);
    a.current.lanes = e;
    $af47be6906de36aa$var$Ac(a, e, d);
    $af47be6906de36aa$var$Dk(a, d);
    return a;
}
function $af47be6906de36aa$var$fl(a, b, c, d) {
    var e = b.current, f = $af47be6906de36aa$var$R(), g = $af47be6906de36aa$var$yi(e);
    c = $af47be6906de36aa$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $af47be6906de36aa$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $af47be6906de36aa$var$nh(e, b, g);
    null !== a && ($af47be6906de36aa$var$gi(a, e, g, f), $af47be6906de36aa$var$oh(a, e, g));
    return g;
}
function $af47be6906de36aa$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $af47be6906de36aa$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $af47be6906de36aa$var$il(a, b) {
    $af47be6906de36aa$var$hl(a, b);
    (a = a.alternate) && $af47be6906de36aa$var$hl(a, b);
}
function $af47be6906de36aa$var$jl() {
    return null;
}
var $af47be6906de36aa$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $af47be6906de36aa$var$ll(a) {
    this._internalRoot = a;
}
$af47be6906de36aa$var$ml.prototype.render = $af47be6906de36aa$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($af47be6906de36aa$var$p(409));
    $af47be6906de36aa$var$fl(a, b, null, null);
};
$af47be6906de36aa$var$ml.prototype.unmount = $af47be6906de36aa$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $af47be6906de36aa$var$Rk(function() {
            $af47be6906de36aa$var$fl(null, a, null, null);
        });
        b[$af47be6906de36aa$var$uf] = null;
    }
};
function $af47be6906de36aa$var$ml(a) {
    this._internalRoot = a;
}
$af47be6906de36aa$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $af47be6906de36aa$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $af47be6906de36aa$var$Qc.length && 0 !== b && b < $af47be6906de36aa$var$Qc[c].priority; c++);
        $af47be6906de36aa$var$Qc.splice(c, 0, a);
        0 === c && $af47be6906de36aa$var$Vc(a);
    }
};
function $af47be6906de36aa$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $af47be6906de36aa$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $af47be6906de36aa$var$pl() {}
function $af47be6906de36aa$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $af47be6906de36aa$var$gl(g);
                f.call(a);
            };
        }
        var g = $af47be6906de36aa$var$el(b, d, a, 0, null, !1, !1, "", $af47be6906de36aa$var$pl);
        a._reactRootContainer = g;
        a[$af47be6906de36aa$var$uf] = g.current;
        $af47be6906de36aa$var$sf(8 === a.nodeType ? a.parentNode : a);
        $af47be6906de36aa$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $af47be6906de36aa$var$gl(k);
            h.call(a);
        };
    }
    var k = $af47be6906de36aa$var$bl(a, 0, !1, null, null, !1, !1, "", $af47be6906de36aa$var$pl);
    a._reactRootContainer = k;
    a[$af47be6906de36aa$var$uf] = k.current;
    $af47be6906de36aa$var$sf(8 === a.nodeType ? a.parentNode : a);
    $af47be6906de36aa$var$Rk(function() {
        $af47be6906de36aa$var$fl(b, k, c, d);
    });
    return k;
}
function $af47be6906de36aa$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $af47be6906de36aa$var$gl(g);
                h.call(a);
            };
        }
        $af47be6906de36aa$var$fl(b, g, a, e);
    } else g = $af47be6906de36aa$var$ql(c, b, a, e, d);
    return $af47be6906de36aa$var$gl(g);
}
$af47be6906de36aa$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $af47be6906de36aa$var$tc(b.pendingLanes);
                0 !== c && ($af47be6906de36aa$var$Cc(b, c | 1), $af47be6906de36aa$var$Dk(b, $af47be6906de36aa$var$B()), 0 === ($af47be6906de36aa$var$K & 6) && ($af47be6906de36aa$var$Gj = $af47be6906de36aa$var$B() + 500, $af47be6906de36aa$var$jg()));
            }
            break;
        case 13:
            $af47be6906de36aa$var$Rk(function() {
                var b = $af47be6906de36aa$var$ih(a, 1);
                if (null !== b) {
                    var c = $af47be6906de36aa$var$R();
                    $af47be6906de36aa$var$gi(b, a, 1, c);
                }
            }), $af47be6906de36aa$var$il(a, 1);
    }
};
$af47be6906de36aa$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $af47be6906de36aa$var$ih(a, 134217728);
        if (null !== b) {
            var c = $af47be6906de36aa$var$R();
            $af47be6906de36aa$var$gi(b, a, 134217728, c);
        }
        $af47be6906de36aa$var$il(a, 134217728);
    }
};
$af47be6906de36aa$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $af47be6906de36aa$var$yi(a), c = $af47be6906de36aa$var$ih(a, b);
        if (null !== c) {
            var d = $af47be6906de36aa$var$R();
            $af47be6906de36aa$var$gi(c, a, b, d);
        }
        $af47be6906de36aa$var$il(a, b);
    }
};
$af47be6906de36aa$var$Hc = function() {
    return $af47be6906de36aa$var$C;
};
$af47be6906de36aa$var$Ic = function(a, b) {
    var c = $af47be6906de36aa$var$C;
    try {
        return $af47be6906de36aa$var$C = a, b();
    } finally{
        $af47be6906de36aa$var$C = c;
    }
};
$af47be6906de36aa$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $af47be6906de36aa$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $af47be6906de36aa$var$Db(d);
                        if (!e) throw Error($af47be6906de36aa$var$p(90));
                        $af47be6906de36aa$var$Wa(d);
                        $af47be6906de36aa$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $af47be6906de36aa$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $af47be6906de36aa$var$fb(a, !!c.multiple, b, !1);
    }
};
$af47be6906de36aa$var$Gb = $af47be6906de36aa$var$Qk;
$af47be6906de36aa$var$Hb = $af47be6906de36aa$var$Rk;
var $af47be6906de36aa$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $af47be6906de36aa$var$Cb,
        $af47be6906de36aa$var$ue,
        $af47be6906de36aa$var$Db,
        $af47be6906de36aa$var$Eb,
        $af47be6906de36aa$var$Fb,
        $af47be6906de36aa$var$Qk
    ]
}, $af47be6906de36aa$var$tl = {
    findFiberByHostInstance: $af47be6906de36aa$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $af47be6906de36aa$var$ul = {
    bundleType: $af47be6906de36aa$var$tl.bundleType,
    version: $af47be6906de36aa$var$tl.version,
    rendererPackageName: $af47be6906de36aa$var$tl.rendererPackageName,
    rendererConfig: $af47be6906de36aa$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $af47be6906de36aa$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $af47be6906de36aa$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $af47be6906de36aa$var$tl.findFiberByHostInstance || $af47be6906de36aa$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $af47be6906de36aa$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$af47be6906de36aa$var$vl.isDisabled && $af47be6906de36aa$var$vl.supportsFiber) try {
        $af47be6906de36aa$var$kc = $af47be6906de36aa$var$vl.inject($af47be6906de36aa$var$ul), $af47be6906de36aa$var$lc = $af47be6906de36aa$var$vl;
    } catch (a) {}
}
$af47be6906de36aa$export$ae55be85d98224ed = $af47be6906de36aa$var$sl;
$af47be6906de36aa$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$af47be6906de36aa$var$nl(b)) throw Error($af47be6906de36aa$var$p(200));
    return $af47be6906de36aa$var$cl(a, b, null, c);
};
$af47be6906de36aa$export$882461b6382ed46c = function(a, b) {
    if (!$af47be6906de36aa$var$nl(a)) throw Error($af47be6906de36aa$var$p(299));
    var c = !1, d = "", e = $af47be6906de36aa$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $af47be6906de36aa$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$af47be6906de36aa$var$uf] = b.current;
    $af47be6906de36aa$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $af47be6906de36aa$var$ll(b);
};
$af47be6906de36aa$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($af47be6906de36aa$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($af47be6906de36aa$var$p(268, a));
    }
    a = $af47be6906de36aa$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$af47be6906de36aa$export$cd75ccfd720a3cd4 = function(a) {
    return $af47be6906de36aa$var$Rk(a);
};
$af47be6906de36aa$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$af47be6906de36aa$var$ol(b)) throw Error($af47be6906de36aa$var$p(200));
    return $af47be6906de36aa$var$rl(null, a, b, !0, c);
};
$af47be6906de36aa$export$757ceba2d55c277e = function(a, b, c) {
    if (!$af47be6906de36aa$var$nl(a)) throw Error($af47be6906de36aa$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $af47be6906de36aa$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $af47be6906de36aa$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$af47be6906de36aa$var$uf] = b.current;
    $af47be6906de36aa$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $af47be6906de36aa$var$ml(b);
};
$af47be6906de36aa$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$af47be6906de36aa$var$ol(b)) throw Error($af47be6906de36aa$var$p(200));
    return $af47be6906de36aa$var$rl(null, a, b, !1, c);
};
$af47be6906de36aa$export$502457920280e6be = function(a) {
    if (!$af47be6906de36aa$var$ol(a)) throw Error($af47be6906de36aa$var$p(40));
    return a._reactRootContainer ? ($af47be6906de36aa$var$Rk(function() {
        $af47be6906de36aa$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$af47be6906de36aa$var$uf] = null;
        });
    }), !0) : !1;
};
$af47be6906de36aa$export$c78a37762a8d58e1 = $af47be6906de36aa$var$Qk;
$af47be6906de36aa$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$af47be6906de36aa$var$ol(c)) throw Error($af47be6906de36aa$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($af47be6906de36aa$var$p(38));
    return $af47be6906de36aa$var$rl(a, b, c, !1, d);
};
$af47be6906de36aa$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("9LPgQ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jICNm"));

});
parcelRegister("jICNm", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $e5b038469f55a924$export$c4744153514ff05d; }, function (v) { return $e5b038469f55a924$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $e5b038469f55a924$export$3e506c1ccc9cc1a7; }, function (v) { return $e5b038469f55a924$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $e5b038469f55a924$export$e26fe2ed2fa76875; }, function (v) { return $e5b038469f55a924$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $e5b038469f55a924$export$502329bbf4b505b1; }, function (v) { return $e5b038469f55a924$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $e5b038469f55a924$export$6e3807111c4874c4; }, function (v) { return $e5b038469f55a924$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $e5b038469f55a924$export$c27134553091fb3a; }, function (v) { return $e5b038469f55a924$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $e5b038469f55a924$export$33ee1acdc04fd2a2; }, function (v) { return $e5b038469f55a924$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $e5b038469f55a924$export$b00a404bbd5edef2; }, function (v) { return $e5b038469f55a924$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $e5b038469f55a924$export$8352ce38b91d0c62; }, function (v) { return $e5b038469f55a924$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $e5b038469f55a924$export$d66a1c1c77bd778b; }, function (v) { return $e5b038469f55a924$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $e5b038469f55a924$export$d3dfb8e4810cb555; }, function (v) { return $e5b038469f55a924$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $e5b038469f55a924$export$839f9183b0465a69; }, function (v) { return $e5b038469f55a924$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $e5b038469f55a924$export$72fdf0e06517287b; }, function (v) { return $e5b038469f55a924$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $e5b038469f55a924$export$4b844e58a3e414b4; }, function (v) { return $e5b038469f55a924$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $e5b038469f55a924$export$816d2913ae6b83b1; }, function (v) { return $e5b038469f55a924$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $e5b038469f55a924$export$61bcfe829111a1d0; }, function (v) { return $e5b038469f55a924$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $e5b038469f55a924$export$7ee8c9beb337bc3f; }, function (v) { return $e5b038469f55a924$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $e5b038469f55a924$export$b5836b71941fa3ed; }, function (v) { return $e5b038469f55a924$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $e5b038469f55a924$export$cf845f2c119da08a; }, function (v) { return $e5b038469f55a924$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e5b038469f55a924$export$c4744153514ff05d;
var $e5b038469f55a924$export$3e506c1ccc9cc1a7;
var $e5b038469f55a924$export$e26fe2ed2fa76875;
var $e5b038469f55a924$export$502329bbf4b505b1;
var $e5b038469f55a924$export$6e3807111c4874c4;
var $e5b038469f55a924$export$c27134553091fb3a;
var $e5b038469f55a924$export$33ee1acdc04fd2a2;
var $e5b038469f55a924$export$b00a404bbd5edef2;
var $e5b038469f55a924$export$8352ce38b91d0c62;
var $e5b038469f55a924$export$d66a1c1c77bd778b;
var $e5b038469f55a924$export$d3dfb8e4810cb555;
var $e5b038469f55a924$export$839f9183b0465a69;
var $e5b038469f55a924$export$72fdf0e06517287b;
var $e5b038469f55a924$export$4b844e58a3e414b4;
var $e5b038469f55a924$export$816d2913ae6b83b1;
var $e5b038469f55a924$export$61bcfe829111a1d0;
var $e5b038469f55a924$export$7ee8c9beb337bc3f;
var $e5b038469f55a924$export$b5836b71941fa3ed;
var $e5b038469f55a924$export$cf845f2c119da08a;
'use strict';
function $e5b038469f55a924$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $e5b038469f55a924$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $e5b038469f55a924$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $e5b038469f55a924$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $e5b038469f55a924$var$g(C, c)) n < e && 0 > $e5b038469f55a924$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $e5b038469f55a924$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $e5b038469f55a924$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $e5b038469f55a924$var$l = performance;
    $e5b038469f55a924$export$c4744153514ff05d = function() {
        return $e5b038469f55a924$var$l.now();
    };
} else {
    var $e5b038469f55a924$var$p = Date, $e5b038469f55a924$var$q = $e5b038469f55a924$var$p.now();
    $e5b038469f55a924$export$c4744153514ff05d = function() {
        return $e5b038469f55a924$var$p.now() - $e5b038469f55a924$var$q;
    };
}
var $e5b038469f55a924$var$r = [], $e5b038469f55a924$var$t = [], $e5b038469f55a924$var$u = 1, $e5b038469f55a924$var$v = null, $e5b038469f55a924$var$y = 3, $e5b038469f55a924$var$z = !1, $e5b038469f55a924$var$A = !1, $e5b038469f55a924$var$B = !1, $e5b038469f55a924$var$D = "function" === typeof setTimeout ? setTimeout : null, $e5b038469f55a924$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $e5b038469f55a924$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $e5b038469f55a924$var$G(a) {
    for(var b = $e5b038469f55a924$var$h($e5b038469f55a924$var$t); null !== b;){
        if (null === b.callback) $e5b038469f55a924$var$k($e5b038469f55a924$var$t);
        else if (b.startTime <= a) $e5b038469f55a924$var$k($e5b038469f55a924$var$t), b.sortIndex = b.expirationTime, $e5b038469f55a924$var$f($e5b038469f55a924$var$r, b);
        else break;
        b = $e5b038469f55a924$var$h($e5b038469f55a924$var$t);
    }
}
function $e5b038469f55a924$var$H(a) {
    $e5b038469f55a924$var$B = !1;
    $e5b038469f55a924$var$G(a);
    if (!$e5b038469f55a924$var$A) {
        if (null !== $e5b038469f55a924$var$h($e5b038469f55a924$var$r)) $e5b038469f55a924$var$A = !0, $e5b038469f55a924$var$I($e5b038469f55a924$var$J);
        else {
            var b = $e5b038469f55a924$var$h($e5b038469f55a924$var$t);
            null !== b && $e5b038469f55a924$var$K($e5b038469f55a924$var$H, b.startTime - a);
        }
    }
}
function $e5b038469f55a924$var$J(a, b) {
    $e5b038469f55a924$var$A = !1;
    $e5b038469f55a924$var$B && ($e5b038469f55a924$var$B = !1, $e5b038469f55a924$var$E($e5b038469f55a924$var$L), $e5b038469f55a924$var$L = -1);
    $e5b038469f55a924$var$z = !0;
    var c = $e5b038469f55a924$var$y;
    try {
        $e5b038469f55a924$var$G(b);
        for($e5b038469f55a924$var$v = $e5b038469f55a924$var$h($e5b038469f55a924$var$r); null !== $e5b038469f55a924$var$v && (!($e5b038469f55a924$var$v.expirationTime > b) || a && !$e5b038469f55a924$var$M());){
            var d = $e5b038469f55a924$var$v.callback;
            if ("function" === typeof d) {
                $e5b038469f55a924$var$v.callback = null;
                $e5b038469f55a924$var$y = $e5b038469f55a924$var$v.priorityLevel;
                var e = d($e5b038469f55a924$var$v.expirationTime <= b);
                b = $e5b038469f55a924$export$c4744153514ff05d();
                "function" === typeof e ? $e5b038469f55a924$var$v.callback = e : $e5b038469f55a924$var$v === $e5b038469f55a924$var$h($e5b038469f55a924$var$r) && $e5b038469f55a924$var$k($e5b038469f55a924$var$r);
                $e5b038469f55a924$var$G(b);
            } else $e5b038469f55a924$var$k($e5b038469f55a924$var$r);
            $e5b038469f55a924$var$v = $e5b038469f55a924$var$h($e5b038469f55a924$var$r);
        }
        if (null !== $e5b038469f55a924$var$v) var w = !0;
        else {
            var m = $e5b038469f55a924$var$h($e5b038469f55a924$var$t);
            null !== m && $e5b038469f55a924$var$K($e5b038469f55a924$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $e5b038469f55a924$var$v = null, $e5b038469f55a924$var$y = c, $e5b038469f55a924$var$z = !1;
    }
}
var $e5b038469f55a924$var$N = !1, $e5b038469f55a924$var$O = null, $e5b038469f55a924$var$L = -1, $e5b038469f55a924$var$P = 5, $e5b038469f55a924$var$Q = -1;
function $e5b038469f55a924$var$M() {
    return $e5b038469f55a924$export$c4744153514ff05d() - $e5b038469f55a924$var$Q < $e5b038469f55a924$var$P ? !1 : !0;
}
function $e5b038469f55a924$var$R() {
    if (null !== $e5b038469f55a924$var$O) {
        var a = $e5b038469f55a924$export$c4744153514ff05d();
        $e5b038469f55a924$var$Q = a;
        var b = !0;
        try {
            b = $e5b038469f55a924$var$O(!0, a);
        } finally{
            b ? $e5b038469f55a924$var$S() : ($e5b038469f55a924$var$N = !1, $e5b038469f55a924$var$O = null);
        }
    } else $e5b038469f55a924$var$N = !1;
}
var $e5b038469f55a924$var$S;
if ("function" === typeof $e5b038469f55a924$var$F) $e5b038469f55a924$var$S = function() {
    $e5b038469f55a924$var$F($e5b038469f55a924$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $e5b038469f55a924$var$T = new MessageChannel, $e5b038469f55a924$var$U = $e5b038469f55a924$var$T.port2;
    $e5b038469f55a924$var$T.port1.onmessage = $e5b038469f55a924$var$R;
    $e5b038469f55a924$var$S = function() {
        $e5b038469f55a924$var$U.postMessage(null);
    };
} else $e5b038469f55a924$var$S = function() {
    $e5b038469f55a924$var$D($e5b038469f55a924$var$R, 0);
};
function $e5b038469f55a924$var$I(a) {
    $e5b038469f55a924$var$O = a;
    $e5b038469f55a924$var$N || ($e5b038469f55a924$var$N = !0, $e5b038469f55a924$var$S());
}
function $e5b038469f55a924$var$K(a, b) {
    $e5b038469f55a924$var$L = $e5b038469f55a924$var$D(function() {
        a($e5b038469f55a924$export$c4744153514ff05d());
    }, b);
}
$e5b038469f55a924$export$3e506c1ccc9cc1a7 = 5;
$e5b038469f55a924$export$e26fe2ed2fa76875 = 1;
$e5b038469f55a924$export$502329bbf4b505b1 = 4;
$e5b038469f55a924$export$6e3807111c4874c4 = 3;
$e5b038469f55a924$export$c27134553091fb3a = null;
$e5b038469f55a924$export$33ee1acdc04fd2a2 = 2;
$e5b038469f55a924$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$e5b038469f55a924$export$8352ce38b91d0c62 = function() {
    $e5b038469f55a924$var$A || $e5b038469f55a924$var$z || ($e5b038469f55a924$var$A = !0, $e5b038469f55a924$var$I($e5b038469f55a924$var$J));
};
$e5b038469f55a924$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $e5b038469f55a924$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$e5b038469f55a924$export$d3dfb8e4810cb555 = function() {
    return $e5b038469f55a924$var$y;
};
$e5b038469f55a924$export$839f9183b0465a69 = function() {
    return $e5b038469f55a924$var$h($e5b038469f55a924$var$r);
};
$e5b038469f55a924$export$72fdf0e06517287b = function(a) {
    switch($e5b038469f55a924$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $e5b038469f55a924$var$y;
    }
    var c = $e5b038469f55a924$var$y;
    $e5b038469f55a924$var$y = b;
    try {
        return a();
    } finally{
        $e5b038469f55a924$var$y = c;
    }
};
$e5b038469f55a924$export$4b844e58a3e414b4 = function() {};
$e5b038469f55a924$export$816d2913ae6b83b1 = function() {};
$e5b038469f55a924$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $e5b038469f55a924$var$y;
    $e5b038469f55a924$var$y = a;
    try {
        return b();
    } finally{
        $e5b038469f55a924$var$y = c;
    }
};
$e5b038469f55a924$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $e5b038469f55a924$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $e5b038469f55a924$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $e5b038469f55a924$var$f($e5b038469f55a924$var$t, a), null === $e5b038469f55a924$var$h($e5b038469f55a924$var$r) && a === $e5b038469f55a924$var$h($e5b038469f55a924$var$t) && ($e5b038469f55a924$var$B ? ($e5b038469f55a924$var$E($e5b038469f55a924$var$L), $e5b038469f55a924$var$L = -1) : $e5b038469f55a924$var$B = !0, $e5b038469f55a924$var$K($e5b038469f55a924$var$H, c - d))) : (a.sortIndex = e, $e5b038469f55a924$var$f($e5b038469f55a924$var$r, a), $e5b038469f55a924$var$A || $e5b038469f55a924$var$z || ($e5b038469f55a924$var$A = !0, $e5b038469f55a924$var$I($e5b038469f55a924$var$J)));
    return a;
};
$e5b038469f55a924$export$b5836b71941fa3ed = $e5b038469f55a924$var$M;
$e5b038469f55a924$export$cf845f2c119da08a = function(a) {
    var b = $e5b038469f55a924$var$y;
    return function() {
        var c = $e5b038469f55a924$var$y;
        $e5b038469f55a924$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $e5b038469f55a924$var$y = c;
        }
    };
};

});



parcelRegister("ajqgY", function(module, exports) {

$parcel$export(module.exports, "wpPages", function () { return $89dc62e75ae4350f$export$744a734ab77350cf; });
$parcel$export(module.exports, "default", function () { return $89dc62e75ae4350f$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $7X3oV = parcelRequire("7X3oV");
var $1a3a2 = parcelRequire("1a3a2");

var $huzw8 = parcelRequire("huzw8");
var $4NoTr = parcelRequire("4NoTr");

var $8FY87 = parcelRequire("8FY87");

var $jZedf = parcelRequire("jZedf");

var $gbHQM = parcelRequire("gbHQM");

var $1lSPe = parcelRequire("1lSPe");

var $2HzUL = parcelRequire("2HzUL");

var $a2oQf = parcelRequire("a2oQf");

var $7KXLb = parcelRequire("7KXLb");

var $e4coK = parcelRequire("e4coK");

var $eRN6V = parcelRequire("eRN6V");

var $lix2c = parcelRequire("lix2c");

var $khKSV = parcelRequire("khKSV");

var $akqLd = parcelRequire("akqLd");

var $5GeZI = parcelRequire("5GeZI");

var $c7Dnj = parcelRequire("c7Dnj");

var $eny4b = parcelRequire("eny4b");

var $7eH6V = parcelRequire("7eH6V");

var $2eDIc = parcelRequire("2eDIc");

var $dqm4D = parcelRequire("dqm4D");

var $1ZMj6 = parcelRequire("1ZMj6");

var $gUWYS = parcelRequire("gUWYS");

var $7YIgd = parcelRequire("7YIgd");

var $c5Qtu = parcelRequire("c5Qtu");

var $hJd3B = parcelRequire("hJd3B");

var $bW95k = parcelRequire("bW95k");

var $9tRLr = parcelRequire("9tRLr");

var $acaxR = parcelRequire("acaxR");

var $l9J5q = parcelRequire("l9J5q");

var $8RlLI = parcelRequire("8RlLI");

var $fsHI4 = parcelRequire("fsHI4");

var $dBwap = parcelRequire("dBwap");

const $89dc62e75ae4350f$var$Dashboard = /*#__PURE__*/ (0, $8FY87.lazy)(()=>(parcelRequire("jrLPj")));
const $89dc62e75ae4350f$var$queryClient = new (0, $7X3oV.QueryClient)({
    defaultOptions: {
        queries: {
            staleTime: 300000,
            gcTime: 1800000,
            retry: 2,
            refetchOnWindowFocus: false
        }
    }
});
const $89dc62e75ae4350f$export$744a734ab77350cf = [
    {
        slug: 'page',
        title: 'Wordpress Pages'
    },
    {
        slug: 'module',
        title: 'Wordpress Modules'
    }
];
const $89dc62e75ae4350f$var$CurrentPage = (props)=>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const queryPage = urlParams.get('page') ?? '';
    const currentPage = props.kiaPage || queryPage;
    const filteredProps = Object.entries(props).reduce((acc, [key, value])=>{
        if (value) acc[key] = value;
        return acc;
    }, {});
    const LoadingFallback = ()=>/*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            style: {
                minHeight: '700px',
                width: '100%'
            }
        });
    switch(currentPage){
        case 'privatleasing':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                fallback: /*#__PURE__*/ (0, $2PPWI.jsx)(LoadingFallback, {}),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c5Qtu.default), {
                    ...filteredProps
                })
            });
        case 'fleet':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                fallback: /*#__PURE__*/ (0, $2PPWI.jsx)(LoadingFallback, {}),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c7Dnj.default), {})
            });
        case 'story':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                fallback: /*#__PURE__*/ (0, $2PPWI.jsx)(LoadingFallback, {}),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $acaxR.default), {
                    ...filteredProps
                })
            });
        case 'carousel':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                fallback: /*#__PURE__*/ (0, $2PPWI.jsx)(LoadingFallback, {}),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eRN6V.default), {
                    ...filteredProps
                })
            });
        case 'are':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                fallback: /*#__PURE__*/ (0, $2PPWI.jsx)(LoadingFallback, {}),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a2oQf.default), {})
            });
        case 'newsletter':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                fallback: /*#__PURE__*/ (0, $2PPWI.jsx)(LoadingFallback, {}),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $dqm4D.default), {
                    ...filteredProps
                })
            });
        case 'pdf':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                fallback: /*#__PURE__*/ (0, $2PPWI.jsx)(LoadingFallback, {}),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $gUWYS.default), {
                    ...filteredProps
                })
            });
        case 'rent-app':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                fallback: /*#__PURE__*/ (0, $2PPWI.jsx)(LoadingFallback, {}),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $hJd3B.default), {
                    ...filteredProps
                })
            });
        case 'rent-landing':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                fallback: /*#__PURE__*/ (0, $2PPWI.jsx)(LoadingFallback, {}),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bW95k.default), {
                    ...filteredProps
                })
            });
        case 'rent-support':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                fallback: /*#__PURE__*/ (0, $2PPWI.jsx)(LoadingFallback, {}),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9tRLr.default), {
                    ...filteredProps
                })
            });
        case 'pricecard':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $7YIgd.default), {
                    ...filteredProps
                })
            });
        case 'cardgrid':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e4coK.default), {
                    ...filteredProps
                })
            });
        case 'disclaimers':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $akqLd.default), {
                    ...filteredProps
                })
            });
        case '100':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1ZMj6.default), {
                    ...filteredProps
                })
            });
        case 'behind-the-sceens':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $7KXLb.default), {
                    ...filteredProps
                })
            });
        case 'new-kia-ev6':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2eDIc.default), {
                    ...filteredProps
                })
            });
        case 'kia-ev5-campaign':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eny4b.default), {
                    ...filteredProps
                })
            });
        case 'kia-pv-five-card':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $7eH6V.default), {
                    ...filteredProps
                })
            });
        case 'climate-bounus-pv5':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $lix2c.default), {
                    ...filteredProps
                })
            });
        case 'adaptations-extensions':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2HzUL.default), {
                    ...filteredProps
                })
            });
        case 'summer':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $l9J5q.default), {
                    ...filteredProps
                })
            });
        case 'fleet-calculator':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5GeZI.default), {
                    ...filteredProps
                })
            });
        case 'data-card':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $khKSV.default), {
                    ...filteredProps
                })
            });
        case 'tavling-yrkes-sm':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8RlLI.default), {})
            });
        case 'page':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                fallback: /*#__PURE__*/ (0, $2PPWI.jsx)(LoadingFallback, {}),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $fsHI4.default), {
                    ...filteredProps
                })
            });
        case 'module':
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                fallback: /*#__PURE__*/ (0, $2PPWI.jsx)(LoadingFallback, {}),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $dBwap.default), {
                    ...filteredProps
                })
            });
        default:
            if (!(0, $1lSPe.locationIsKia)()) return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                fallback: /*#__PURE__*/ (0, $2PPWI.jsx)(LoadingFallback, {}),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)($89dc62e75ae4350f$var$Dashboard, {})
            });
            else {
                console.error('No page found');
                return null;
            }
    }
};
const $89dc62e75ae4350f$var$KiaPage = (props)=>{
    const [authStatus, setAuthStatus] = (0, $8FY87.useState)('pending');
    const [qr, setQr] = (0, $8FY87.useState)();
    const [code, setCode] = (0, $8FY87.useState)('');
    const [email, setEmail] = (0, $8FY87.useState)('');
    const deletePathParams = ()=>{
        window.location.href = '/';
    };
    (0, $8FY87.useEffect)(()=>{
        const validateToken = async ()=>{
            const token = (0, $gbHQM.getCookie)('x-kia-pages');
            if (token) try {
                // Vefiry the token the user has stored inside thier cookies.
                const { status: status } = await (0, $jZedf.fetchWithType)(`${(0, $1lSPe.getAdminUrl)()}/api/user/verify`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (status === 200) setAuthStatus('loggedIn');
                else {
                    (0, $gbHQM.removeCookie)('x-kia-pages');
                    setAuthStatus('loggedOut');
                }
            } catch (error) {
                (0, $gbHQM.removeCookie)('x-kia-pages');
                setAuthStatus('loggedOut');
            }
            else setAuthStatus('loggedOut');
        };
        validateToken();
    }, []);
    const handleLogin = async (e)=>{
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const email = formData.get('email');
        const password = formData.get('password');
        try {
            const { data: data, status: status } = await (0, $jZedf.fetchWithType)(`${(0, $1lSPe.getAdminUrl)()}/api/login`, {
                method: 'POST',
                body: JSON.stringify({
                    email: email,
                    password: password
                })
            });
            if (status === 200 && data?.qr) {
                setQr(data.qr);
                setEmail(email);
                setAuthStatus('needToken');
            } else if (status === 204) {
                setEmail(email);
                setAuthStatus('needToken');
            } else alert("Fel l\xf6senord");
        } catch (error) {
            alert("Fel l\xf6senord");
        }
    };
    const handleCode = async (e)=>{
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const codeValue = formData.get('code');
        try {
            const { data: data, status: status } = await (0, $jZedf.fetchWithType)(`${(0, $1lSPe.getAdminUrl)()}/api/2fa`, {
                method: 'POST',
                body: JSON.stringify({
                    email: email,
                    code: codeValue
                })
            });
            if (status === 200 && data.token) {
                (0, $gbHQM.setCookie)('x-kia-pages', data.token, 30);
                setAuthStatus('loggedIn');
            } else {
                alert('Fel kod');
                setCode('');
            }
        } catch (error) {
            setCode('');
            alert("Fel l\xf6senord");
        }
    };
    if (!(0, $1lSPe.locationIsKia)()) {
        if (authStatus === 'pending') return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            style: {
                minHeight: '100vh'
            }
        });
        if (authStatus === 'needToken') return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            className: "flex flex-col gap-4 items-center justify-center h-screen",
            children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "bg-kia-grey max-w-sm w-full p-4 rounded-xl border border-gray-100 shadow-lg",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h1", {
                        className: "text-4xl text-center mb-4",
                        children: "2FA"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("form", {
                        onSubmit: (e)=>handleCode(e),
                        className: "grid gap-2 w-full",
                        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: "grid gap-1",
                            children: [
                                qr && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                    className: "mx-auto",
                                    dangerouslySetInnerHTML: {
                                        __html: qr
                                    }
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                    htmlFor: "code",
                                    children: "Kod"
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                    type: "text",
                                    id: "code",
                                    value: code,
                                    onChange: (e)=>{
                                        const value = e.target.value;
                                        setCode(value);
                                        if (value.length === 6) e.currentTarget.form?.requestSubmit();
                                    },
                                    name: "code",
                                    className: "border p-2",
                                    placeholder: "Ange 2fa kod"
                                })
                            ]
                        })
                    }, 2)
                ]
            })
        });
        if (authStatus === 'loggedOut') return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            className: "flex flex-col gap-4 items-center justify-center h-screen",
            children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "bg-kia-grey max-w-sm w-full p-4 rounded-xl border border-gray-100 shadow-lg",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h1", {
                        className: "text-4xl text-center mb-4",
                        children: "Logga in"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("form", {
                        onSubmit: (e)=>handleLogin(e),
                        className: "grid gap-2 w-full",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: "grid gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                        htmlFor: "email",
                                        children: "E-mail"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                        type: "email",
                                        id: "email",
                                        name: "email",
                                        className: "border p-2",
                                        placeholder: "Ange e-mail"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: "grid gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                        htmlFor: "password",
                                        children: "Password"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                        id: "password",
                                        name: "password",
                                        className: "border p-2",
                                        placeholder: "Ange l\xf6senord",
                                        type: "password"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                type: "submit",
                                className: "p-2 mt-4 bg-black text-white rounded-md border border-black hover:bg-white hover:text-black transition-colors",
                                children: "Logga in"
                            })
                        ]
                    }, 1)
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $1a3a2.QueryClientProvider), {
            client: $89dc62e75ae4350f$var$queryClient,
            children: [
                (0, $1lSPe.locationIsKia)() ? null : /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: "flex items-center px-8 justify-center bg-white border-b border-gray-100 h-[111px]",
                    children: /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                        type: "button",
                        onClick: deletePathParams,
                        className: "text-left w-full grid place-content-center",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: "text-xs text-gray-400 mb-0.5",
                                children: "kia pages"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("h1", {
                                className: "text-2xl font-semibold text-gray-900 leading-tight",
                                children: "Sidor och moduler"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4NoTr.LazyMotion), {
                    features: (0, $huzw8.domAnimation),
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)($89dc62e75ae4350f$var$CurrentPage, {
                        ...props
                    })
                })
            ]
        })
    });
};
var $89dc62e75ae4350f$export$2e2bcd8739ae039 = $89dc62e75ae4350f$var$KiaPage;

});
parcelRegister("7X3oV", function(module, exports) {

$parcel$export(module.exports, "QueryClient", function () { return $5ca0ae740328bb5c$export$405d0624ed55a03f; });

var $3szIe = parcelRequire("3szIe");

var $6L2cD = parcelRequire("6L2cD");

var $fYclE = parcelRequire("fYclE");

var $hPIOx = parcelRequire("hPIOx");

var $hNxYl = parcelRequire("hNxYl");

var $jHZE2 = parcelRequire("jHZE2");

var $h2iHR = parcelRequire("h2iHR");
//#region src/queryClient.ts
var $5ca0ae740328bb5c$var$_queryCache = /* @__PURE__ */ new WeakMap();
var $5ca0ae740328bb5c$var$_mutationCache = /* @__PURE__ */ new WeakMap();
var $5ca0ae740328bb5c$var$_defaultOptions = /* @__PURE__ */ new WeakMap();
var $5ca0ae740328bb5c$var$_queryDefaults = /* @__PURE__ */ new WeakMap();
var $5ca0ae740328bb5c$var$_mutationDefaults = /* @__PURE__ */ new WeakMap();
var $5ca0ae740328bb5c$var$_mountCount = /* @__PURE__ */ new WeakMap();
var $5ca0ae740328bb5c$var$_unsubscribeFocus = /* @__PURE__ */ new WeakMap();
var $5ca0ae740328bb5c$var$_unsubscribeOnline = /* @__PURE__ */ new WeakMap();
var $5ca0ae740328bb5c$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $3szIe.i)(this, $5ca0ae740328bb5c$var$_queryCache, void 0);
        (0, $3szIe.i)(this, $5ca0ae740328bb5c$var$_mutationCache, void 0);
        (0, $3szIe.i)(this, $5ca0ae740328bb5c$var$_defaultOptions, void 0);
        (0, $3szIe.i)(this, $5ca0ae740328bb5c$var$_queryDefaults, void 0);
        (0, $3szIe.i)(this, $5ca0ae740328bb5c$var$_mutationDefaults, void 0);
        (0, $3szIe.i)(this, $5ca0ae740328bb5c$var$_mountCount, void 0);
        (0, $3szIe.i)(this, $5ca0ae740328bb5c$var$_unsubscribeFocus, void 0);
        (0, $3szIe.i)(this, $5ca0ae740328bb5c$var$_unsubscribeOnline, void 0);
        (0, $3szIe.t)($5ca0ae740328bb5c$var$_queryCache, this, config.queryCache || new (0, $h2iHR.QueryCache)());
        (0, $3szIe.t)($5ca0ae740328bb5c$var$_mutationCache, this, config.mutationCache || new (0, $jHZE2.MutationCache)());
        (0, $3szIe.t)($5ca0ae740328bb5c$var$_defaultOptions, this, config.defaultOptions || {});
        (0, $3szIe.t)($5ca0ae740328bb5c$var$_queryDefaults, this, /* @__PURE__ */ new Map());
        (0, $3szIe.t)($5ca0ae740328bb5c$var$_mutationDefaults, this, /* @__PURE__ */ new Map());
        (0, $3szIe.t)($5ca0ae740328bb5c$var$_mountCount, this, 0);
    }
    mount() {
        var _this$mountCount;
        (0, $3szIe.t)($5ca0ae740328bb5c$var$_mountCount, this, (_this$mountCount = (0, $3szIe.n)($5ca0ae740328bb5c$var$_mountCount, this), _this$mountCount++, _this$mountCount));
        if ((0, $3szIe.n)($5ca0ae740328bb5c$var$_mountCount, this) !== 1) return;
        (0, $3szIe.t)($5ca0ae740328bb5c$var$_unsubscribeFocus, this, (0, $fYclE.focusManager).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this).onFocus();
            }
        }));
        (0, $3szIe.t)($5ca0ae740328bb5c$var$_unsubscribeOnline, this, (0, $hNxYl.onlineManager).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this).onOnline();
            }
        }));
    }
    unmount() {
        var _this$mountCount3, _classPrivateFieldGet2$1, _classPrivateFieldGet3;
        (0, $3szIe.t)($5ca0ae740328bb5c$var$_mountCount, this, (_this$mountCount3 = (0, $3szIe.n)($5ca0ae740328bb5c$var$_mountCount, this), _this$mountCount3--, _this$mountCount3));
        if ((0, $3szIe.n)($5ca0ae740328bb5c$var$_mountCount, this) !== 0) return;
        (_classPrivateFieldGet2$1 = (0, $3szIe.n)($5ca0ae740328bb5c$var$_unsubscribeFocus, this)) === null || _classPrivateFieldGet2$1 === void 0 || _classPrivateFieldGet2$1.call(this);
        (0, $3szIe.t)($5ca0ae740328bb5c$var$_unsubscribeFocus, this, void 0);
        (_classPrivateFieldGet3 = (0, $3szIe.n)($5ca0ae740328bb5c$var$_unsubscribeOnline, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.call(this);
        (0, $3szIe.t)($5ca0ae740328bb5c$var$_unsubscribeOnline, this, void 0);
    }
    isFetching(filters) {
        return (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $3szIe.n)($5ca0ae740328bb5c$var$_mutationCache, this).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
	* Imperative (non-reactive) way to retrieve data for a QueryKey.
	* Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
	*
	* Hint: Do not use this function inside a component, because it won't receive updates.
	* Use `useQuery` to create a `QueryObserver` that subscribes to changes.
	*/ getQueryData(queryKey) {
        var _classPrivateFieldGet4;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_classPrivateFieldGet4 = (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this).get(options.queryHash)) === null || _classPrivateFieldGet4 === void 0 ? void 0 : _classPrivateFieldGet4.state.data;
    }
    /**
	* @deprecated Use queryClient.query({ ...options, staleTime: 'static' }) instead. This method will be removed in the next major version.
	*/ ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this).build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $6L2cD.resolveQueryValue)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            return [
                queryKey,
                state.data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this).get(defaultedOptions.queryHash);
        const prevData = query === null || query === void 0 ? void 0 : query.state.data;
        const data = (0, $6L2cD.functionalUpdate)(updater, prevData);
        if (data === void 0) return;
        return (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $hPIOx.notifyManager).batch(()=>(0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _classPrivateFieldGet5;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_classPrivateFieldGet5 = (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this).get(options.queryHash)) === null || _classPrivateFieldGet5 === void 0 ? void 0 : _classPrivateFieldGet5.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this);
        (0, $hPIOx.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this);
        return (0, $hPIOx.notifyManager).batch(()=>{
            const matched = queryCache.findAll(filters);
            const queriesToRefetch = new Set(matched);
            matched.forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                predicate: (query)=>queriesToRefetch.has(query)
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $hPIOx.notifyManager).batch(()=>(0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $6L2cD.noop)).catch((0, $6L2cD.noop));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $hPIOx.notifyManager).batch(()=>{
            (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if ((filters === null || filters === void 0 ? void 0 : filters.refetchType) === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: (filters === null || filters === void 0 ? void 0 : filters.refetchType) ?? (filters === null || filters === void 0 ? void 0 : filters.type) ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $hPIOx.notifyManager).batch(()=>(0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this).findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $6L2cD.noop));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $6L2cD.noop));
    }
    async query(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this).build(this, defaultedOptions);
        const queryData = query.isStaleByTime((0, $6L2cD.resolveQueryValue)(defaultedOptions.staleTime, query)) ? await query.fetch(defaultedOptions) : query.state.data;
        const select = defaultedOptions.select;
        if (select) return select(queryData);
        return queryData;
    }
    /**
	* @deprecated Use queryClient.query(options) instead. This method will be removed in the next major version.
	*/ fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this).build(this, defaultedOptions);
        return query.isStaleByTime((0, $6L2cD.resolveQueryValue)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    /**
	* @deprecated Use queryClient.query(options) instead. You can swallow errors with `.catch(noop)`. This method will be removed in the next major version.
	*/ prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $6L2cD.noop)).catch((0, $6L2cD.noop));
    }
    infiniteQuery(options) {
        options._type = "infinite";
        return this.query(options);
    }
    /**
	* @deprecated Use queryClient.infiniteQuery(options) instead. This method will be removed in the next major version.
	*/ fetchInfiniteQuery(options) {
        options._type = "infinite";
        return this.fetchQuery(options);
    }
    /**
	* @deprecated Use queryClient.infiniteQuery(options) instead. You can swallow errors with `.catch(noop)`. This method will be removed in the next major version.
	*/ prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $6L2cD.noop)).catch((0, $6L2cD.noop));
    }
    /**
	* @deprecated Use queryClient.infiniteQuery({ ...options, staleTime: 'static' }) instead. This method will be removed in the next major version.
	*/ ensureInfiniteQueryData(options) {
        options._type = "infinite";
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $hNxYl.onlineManager).isOnline()) return (0, $3szIe.n)($5ca0ae740328bb5c$var$_mutationCache, this).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this);
    }
    getMutationCache() {
        return (0, $3szIe.n)($5ca0ae740328bb5c$var$_mutationCache, this);
    }
    getDefaultOptions() {
        return (0, $3szIe.n)($5ca0ae740328bb5c$var$_defaultOptions, this);
    }
    setDefaultOptions(options) {
        (0, $3szIe.t)($5ca0ae740328bb5c$var$_defaultOptions, this, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryDefaults, this).set((0, $6L2cD.hashKey)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $3szIe.n)($5ca0ae740328bb5c$var$_queryDefaults, this).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $6L2cD.partialMatchKey)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $3szIe.n)($5ca0ae740328bb5c$var$_mutationDefaults, this).set((0, $6L2cD.hashKey)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $3szIe.n)($5ca0ae740328bb5c$var$_mutationDefaults, this).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $6L2cD.partialMatchKey)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $3szIe.n)($5ca0ae740328bb5c$var$_defaultOptions, this).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $6L2cD.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $6L2cD.skipToken)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options === null || options === void 0 ? void 0 : options._defaulted) return options;
        return {
            ...(0, $3szIe.n)($5ca0ae740328bb5c$var$_defaultOptions, this).mutations,
            ...(options === null || options === void 0 ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $3szIe.n)($5ca0ae740328bb5c$var$_queryCache, this).clear();
        (0, $3szIe.n)($5ca0ae740328bb5c$var$_mutationCache, this).clear();
    }
};

});
parcelRegister("3szIe", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $284fb05cd094bcce$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $284fb05cd094bcce$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "r", function () { return $284fb05cd094bcce$export$43caf9889c228507; });
$parcel$export(module.exports, "n", function () { return $284fb05cd094bcce$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "t", function () { return $284fb05cd094bcce$export$625550452a3fa3ec; });
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/checkPrivateRedeclaration.js
function $284fb05cd094bcce$export$407448d2b89b1813(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/classPrivateFieldInitSpec.js
function $284fb05cd094bcce$export$23f2a1d2818174ef(e, t, a) {
    $284fb05cd094bcce$export$407448d2b89b1813(e, t), t.set(e, a);
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/assertClassBrand.js
function $284fb05cd094bcce$export$43caf9889c228507(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/classPrivateFieldGet2.js
function $284fb05cd094bcce$export$7ccc53e8f1e7dfc5(s, a) {
    return s.get($284fb05cd094bcce$export$43caf9889c228507(s, a));
}
//#endregion
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/classPrivateFieldSet2.js
function $284fb05cd094bcce$export$625550452a3fa3ec(s, a, r) {
    return s.set($284fb05cd094bcce$export$43caf9889c228507(s, a), r), r;
}

});

parcelRegister("6L2cD", function(module, exports) {

$parcel$export(module.exports, "isServer", function () { return $4eb8d74eb21a268a$export$6acf61af03e62db; });
$parcel$export(module.exports, "noop", function () { return $4eb8d74eb21a268a$export$8793edee2d425525; });
$parcel$export(module.exports, "functionalUpdate", function () { return $4eb8d74eb21a268a$export$7f095f455ad5af3f; });
$parcel$export(module.exports, "isValidTimeout", function () { return $4eb8d74eb21a268a$export$e539f754e934e270; });
$parcel$export(module.exports, "timeUntilStale", function () { return $4eb8d74eb21a268a$export$811b83d62bcf47f0; });
$parcel$export(module.exports, "resolveQueryValue", function () { return $4eb8d74eb21a268a$export$e36731f6aa6a4362; });
$parcel$export(module.exports, "matchQuery", function () { return $4eb8d74eb21a268a$export$c5d1efe363797780; });
$parcel$export(module.exports, "hashQueryKeyByOptions", function () { return $4eb8d74eb21a268a$export$cc90ca97bc0d73fd; });
$parcel$export(module.exports, "partialMatchKey", function () { return $4eb8d74eb21a268a$export$2f07189bb9fa26a7; });
$parcel$export(module.exports, "matchMutation", function () { return $4eb8d74eb21a268a$export$a1ea5fb559f63ae3; });
$parcel$export(module.exports, "hashKey", function () { return $4eb8d74eb21a268a$export$1e87d19d4aab5805; });
$parcel$export(module.exports, "shallowEqualObjects", function () { return $4eb8d74eb21a268a$export$3e67810a3f0e9f1c; });
$parcel$export(module.exports, "sleep", function () { return $4eb8d74eb21a268a$export$e772c8ff12451969; });
$parcel$export(module.exports, "replaceData", function () { return $4eb8d74eb21a268a$export$17619bac5b909b23; });
$parcel$export(module.exports, "addToEnd", function () { return $4eb8d74eb21a268a$export$ccce65a22a26f2bc; });
$parcel$export(module.exports, "addToStart", function () { return $4eb8d74eb21a268a$export$8c6246b73dd61f4a; });
$parcel$export(module.exports, "skipToken", function () { return $4eb8d74eb21a268a$export$1aa5a89531b7670d; });
$parcel$export(module.exports, "ensureQueryFn", function () { return $4eb8d74eb21a268a$export$c71c44209368a3bc; });
$parcel$export(module.exports, "shouldThrowError", function () { return $4eb8d74eb21a268a$export$2072f68e6c3507cf; });
$parcel$export(module.exports, "addConsumeAwareSignal", function () { return $4eb8d74eb21a268a$export$83f813cd1f8a4973; });

var $6t06k = parcelRequire("6t06k");
//#region src/utils.ts
/** @deprecated
* use `environmentManager.isServer()` instead.
*/ const $4eb8d74eb21a268a$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $4eb8d74eb21a268a$export$8793edee2d425525() {}
function $4eb8d74eb21a268a$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $4eb8d74eb21a268a$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $4eb8d74eb21a268a$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $4eb8d74eb21a268a$export$e36731f6aa6a4362(value, query) {
    return typeof value === "function" ? value(query) : value;
}
function $4eb8d74eb21a268a$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $4eb8d74eb21a268a$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$4eb8d74eb21a268a$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $4eb8d74eb21a268a$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($4eb8d74eb21a268a$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $4eb8d74eb21a268a$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$4eb8d74eb21a268a$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $4eb8d74eb21a268a$export$cc90ca97bc0d73fd(queryKey, options) {
    return ((options === null || options === void 0 ? void 0 : options.queryKeyHashFn) || $4eb8d74eb21a268a$export$1e87d19d4aab5805)(queryKey);
}
/**
* Default query & mutation keys hash function.
* Hashes the value into a stable hash.
*/ function $4eb8d74eb21a268a$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$4eb8d74eb21a268a$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $4eb8d74eb21a268a$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (Array.isArray(a) && Array.isArray(b)) {
            for(let i = 0; i < b.length; i++)if (!$4eb8d74eb21a268a$export$2f07189bb9fa26a7(a[i], b[i])) return false;
            return true;
        }
        const bKeys = Object.keys(b);
        for (const key of bKeys)if (!$4eb8d74eb21a268a$export$2f07189bb9fa26a7(a[key], b[key])) return false;
        return true;
    }
    return false;
}
const $4eb8d74eb21a268a$var$hasOwn = Object.prototype.hasOwnProperty;
function $4eb8d74eb21a268a$export$77a71fc411098696(a, b, depth = 0) {
    if (a === b) return a;
    if (depth > 500) return b;
    const array = $4eb8d74eb21a268a$export$7a8558113332b71e(a) && $4eb8d74eb21a268a$export$7a8558113332b71e(b);
    if (!array && !($4eb8d74eb21a268a$export$53b83ca8eaab0383(a) && $4eb8d74eb21a268a$export$53b83ca8eaab0383(b))) return b;
    const aSize = (array ? a : Object.keys(a)).length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : $4eb8d74eb21a268a$var$hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = $4eb8d74eb21a268a$export$77a71fc411098696(aItem, bItem, depth + 1);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
/**
* Shallow compare objects.
*/ function $4eb8d74eb21a268a$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a)if (a[key] !== b[key]) return false;
    return true;
}
function $4eb8d74eb21a268a$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $4eb8d74eb21a268a$export$53b83ca8eaab0383(o) {
    if (!$4eb8d74eb21a268a$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$4eb8d74eb21a268a$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $4eb8d74eb21a268a$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $4eb8d74eb21a268a$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        (0, $6t06k.timeoutManager).setTimeout(resolve, timeout);
    });
}
function $4eb8d74eb21a268a$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $4eb8d74eb21a268a$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $4eb8d74eb21a268a$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $4eb8d74eb21a268a$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $4eb8d74eb21a268a$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
const $4eb8d74eb21a268a$export$1aa5a89531b7670d = Symbol();
function $4eb8d74eb21a268a$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $4eb8d74eb21a268a$export$1aa5a89531b7670d) return ()=>Promise.reject(/* @__PURE__ */ new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function $4eb8d74eb21a268a$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}
function $4eb8d74eb21a268a$export$83f813cd1f8a4973(object, getSignal, onCancelled) {
    let consumed = false;
    let signal;
    Object.defineProperty(object, "signal", {
        enumerable: true,
        get: ()=>{
            signal ?? (signal = getSignal());
            if (consumed) return signal;
            consumed = true;
            if (signal.aborted) onCancelled();
            else signal.addEventListener("abort", onCancelled, {
                once: true
            });
            return signal;
        }
    });
    return object;
}

});
parcelRegister("6t06k", function(module, exports) {

$parcel$export(module.exports, "timeoutManager", function () { return $4b5587914de611c0$export$94a2700736e69372; });
$parcel$export(module.exports, "systemSetTimeoutZero", function () { return $4b5587914de611c0$export$5086591e51e32a18; });

var $3szIe = parcelRequire("3szIe");
//#region src/timeoutManager.ts
const $4b5587914de611c0$export$d235812f9125bf47 = {
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
var $4b5587914de611c0$var$_provider = /* @__PURE__ */ new WeakMap();
var $4b5587914de611c0$var$_providerCalled = /* @__PURE__ */ new WeakMap();
/**
* Allows customization of how timeouts are created.
*
* @tanstack/query-core makes liberal use of timeouts to implement `staleTime`
* and `gcTime`. The default TimeoutManager provider uses the platform's global
* `setTimeout` implementation, which is known to have scalability issues with
* thousands of timeouts on the event loop.
*
* If you hit this limitation, consider providing a custom TimeoutProvider that
* coalesces timeouts.
*/ var $4b5587914de611c0$export$6336d90323f0ab52 = class {
    constructor(){
        (0, $3szIe.i)(this, $4b5587914de611c0$var$_provider, $4b5587914de611c0$export$d235812f9125bf47);
        (0, $3szIe.i)(this, $4b5587914de611c0$var$_providerCalled, false);
    }
    setTimeoutProvider(provider) {
        (0, $3szIe.t)($4b5587914de611c0$var$_provider, this, provider);
    }
    setTimeout(callback, delay) {
        return (0, $3szIe.n)($4b5587914de611c0$var$_provider, this).setTimeout(callback, delay);
    }
    clearTimeout(timeoutId) {
        (0, $3szIe.n)($4b5587914de611c0$var$_provider, this).clearTimeout(timeoutId);
    }
    setInterval(callback, delay) {
        return (0, $3szIe.n)($4b5587914de611c0$var$_provider, this).setInterval(callback, delay);
    }
    clearInterval(intervalId) {
        (0, $3szIe.n)($4b5587914de611c0$var$_provider, this).clearInterval(intervalId);
    }
};
const $4b5587914de611c0$export$94a2700736e69372 = new $4b5587914de611c0$export$6336d90323f0ab52();
/**
* In many cases code wants to delay to the next event loop tick; this is not
* mediated by {@link timeoutManager}.
*
* This function is provided to make auditing the `tanstack/query-core` for
* incorrect use of system `setTimeout` easier.
*/ function $4b5587914de611c0$export$5086591e51e32a18(callback) {
    setTimeout(callback, 0);
}

});


parcelRegister("fYclE", function(module, exports) {

$parcel$export(module.exports, "focusManager", function () { return $ba0609b466b3efb1$export$6bf54661be5b02cf; });

var $3szIe = parcelRequire("3szIe");

var $3G2zK = parcelRequire("3G2zK");
//#region src/focusManager.ts
var $ba0609b466b3efb1$var$_focused = /* @__PURE__ */ new WeakMap();
var $ba0609b466b3efb1$var$_cleanup = /* @__PURE__ */ new WeakMap();
var $ba0609b466b3efb1$var$_setup = /* @__PURE__ */ new WeakMap();
var $ba0609b466b3efb1$export$86f1af424b2ca4de = class extends (0, $3G2zK.Subscribable) {
    constructor(){
        super();
        (0, $3szIe.i)(this, $ba0609b466b3efb1$var$_focused, void 0);
        (0, $3szIe.i)(this, $ba0609b466b3efb1$var$_cleanup, void 0);
        (0, $3szIe.i)(this, $ba0609b466b3efb1$var$_setup, void 0);
        (0, $3szIe.t)($ba0609b466b3efb1$var$_setup, this, (onFocus)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
        });
    }
    onSubscribe() {
        if (!(0, $3szIe.n)($ba0609b466b3efb1$var$_cleanup, this)) this.setEventListener((0, $3szIe.n)($ba0609b466b3efb1$var$_setup, this));
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _classPrivateFieldGet2$1;
            (_classPrivateFieldGet2$1 = (0, $3szIe.n)($ba0609b466b3efb1$var$_cleanup, this)) === null || _classPrivateFieldGet2$1 === void 0 || _classPrivateFieldGet2$1.call(this);
            (0, $3szIe.t)($ba0609b466b3efb1$var$_cleanup, this, void 0);
        }
    }
    setEventListener(setup) {
        var _classPrivateFieldGet3;
        (0, $3szIe.t)($ba0609b466b3efb1$var$_setup, this, setup);
        (_classPrivateFieldGet3 = (0, $3szIe.n)($ba0609b466b3efb1$var$_cleanup, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.call(this);
        (0, $3szIe.t)($ba0609b466b3efb1$var$_cleanup, this, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        if ((0, $3szIe.n)($ba0609b466b3efb1$var$_focused, this) !== focused) {
            (0, $3szIe.t)($ba0609b466b3efb1$var$_focused, this, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _globalThis$document;
        if (typeof (0, $3szIe.n)($ba0609b466b3efb1$var$_focused, this) === "boolean") return (0, $3szIe.n)($ba0609b466b3efb1$var$_focused, this);
        return ((_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) !== "hidden";
    }
};
const $ba0609b466b3efb1$export$6bf54661be5b02cf = new $ba0609b466b3efb1$export$86f1af424b2ca4de();

});
parcelRegister("3G2zK", function(module, exports) {

$parcel$export(module.exports, "Subscribable", function () { return $2ad74acdef9e3bef$export$d26086b469ecdbcc; });
//#region src/subscribable.ts
var $2ad74acdef9e3bef$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};

});


parcelRegister("hPIOx", function(module, exports) {

$parcel$export(module.exports, "notifyManager", function () { return $cfb9f6399803c990$export$520687f44db6e1ab; });

var $6t06k = parcelRequire("6t06k");
//#region src/notifyManager.ts
const $cfb9f6399803c990$export$7c76da44185e6090 = (0, $6t06k.systemSetTimeoutZero);
function $cfb9f6399803c990$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $cfb9f6399803c990$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
		* All calls to the wrapped function will be batched.
		*/ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
		* Use this method to set a custom notify function.
		* This can be used to for example wrap notifications with `React.act` while running tests.
		*/ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
		* Use this method to set a custom function to batch notifications together into a single tick.
		* By default React Query will use the batch function provided by ReactDOM or React Native.
		*/ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
const $cfb9f6399803c990$export$520687f44db6e1ab = $cfb9f6399803c990$export$316a8efd03cd1458();

});

parcelRegister("hNxYl", function(module, exports) {

$parcel$export(module.exports, "onlineManager", function () { return $cf515d7607ea781e$export$b113e788b2dd3fdc; });

var $3szIe = parcelRequire("3szIe");

var $3G2zK = parcelRequire("3G2zK");
//#region src/onlineManager.ts
var $cf515d7607ea781e$var$_online = /* @__PURE__ */ new WeakMap();
var $cf515d7607ea781e$var$_cleanup = /* @__PURE__ */ new WeakMap();
var $cf515d7607ea781e$var$_setup = /* @__PURE__ */ new WeakMap();
var $cf515d7607ea781e$export$58774fb55d5ff7fc = class extends (0, $3G2zK.Subscribable) {
    constructor(){
        super();
        (0, $3szIe.i)(this, $cf515d7607ea781e$var$_online, true);
        (0, $3szIe.i)(this, $cf515d7607ea781e$var$_cleanup, void 0);
        (0, $3szIe.i)(this, $cf515d7607ea781e$var$_setup, void 0);
        (0, $3szIe.t)($cf515d7607ea781e$var$_setup, this, (onOnline)=>{
            if (typeof window !== "undefined" && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
        });
    }
    onSubscribe() {
        if (!(0, $3szIe.n)($cf515d7607ea781e$var$_cleanup, this)) this.setEventListener((0, $3szIe.n)($cf515d7607ea781e$var$_setup, this));
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _classPrivateFieldGet2$1;
            (_classPrivateFieldGet2$1 = (0, $3szIe.n)($cf515d7607ea781e$var$_cleanup, this)) === null || _classPrivateFieldGet2$1 === void 0 || _classPrivateFieldGet2$1.call(this);
            (0, $3szIe.t)($cf515d7607ea781e$var$_cleanup, this, void 0);
        }
    }
    setEventListener(setup) {
        var _classPrivateFieldGet3;
        (0, $3szIe.t)($cf515d7607ea781e$var$_setup, this, setup);
        (_classPrivateFieldGet3 = (0, $3szIe.n)($cf515d7607ea781e$var$_cleanup, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.call(this);
        (0, $3szIe.t)($cf515d7607ea781e$var$_cleanup, this, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        if ((0, $3szIe.n)($cf515d7607ea781e$var$_online, this) !== online) {
            (0, $3szIe.t)($cf515d7607ea781e$var$_online, this, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $3szIe.n)($cf515d7607ea781e$var$_online, this);
    }
};
const $cf515d7607ea781e$export$b113e788b2dd3fdc = new $cf515d7607ea781e$export$58774fb55d5ff7fc();

});

parcelRegister("jHZE2", function(module, exports) {

$parcel$export(module.exports, "MutationCache", function () { return $e591d9ddb9db9cba$export$1fcfd9a244434844; });

var $3szIe = parcelRequire("3szIe");

var $6L2cD = parcelRequire("6L2cD");

var $3G2zK = parcelRequire("3G2zK");

var $hPIOx = parcelRequire("hPIOx");

var $cDQLR = parcelRequire("cDQLR");
//#region src/mutationCache.ts
var $e591d9ddb9db9cba$var$_mutations = /* @__PURE__ */ new WeakMap();
var $e591d9ddb9db9cba$var$_scopes = /* @__PURE__ */ new WeakMap();
var $e591d9ddb9db9cba$var$_mutationId = /* @__PURE__ */ new WeakMap();
var $e591d9ddb9db9cba$export$1fcfd9a244434844 = class extends (0, $3G2zK.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $3szIe.i)(this, $e591d9ddb9db9cba$var$_mutations, void 0);
        (0, $3szIe.i)(this, $e591d9ddb9db9cba$var$_scopes, void 0);
        (0, $3szIe.i)(this, $e591d9ddb9db9cba$var$_mutationId, void 0);
        (0, $3szIe.t)($e591d9ddb9db9cba$var$_mutations, this, /* @__PURE__ */ new Set());
        (0, $3szIe.t)($e591d9ddb9db9cba$var$_scopes, this, /* @__PURE__ */ new Map());
        (0, $3szIe.t)($e591d9ddb9db9cba$var$_mutationId, this, 0);
    }
    build(client, options, state) {
        var _this$mutationId;
        const mutation = new (0, $cDQLR.Mutation)({
            client: client,
            mutationCache: this,
            mutationId: (0, $3szIe.t)($e591d9ddb9db9cba$var$_mutationId, this, (_this$mutationId = (0, $3szIe.n)($e591d9ddb9db9cba$var$_mutationId, this), ++_this$mutationId)),
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $3szIe.n)($e591d9ddb9db9cba$var$_mutations, this).add(mutation);
        const scope = $e591d9ddb9db9cba$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = (0, $3szIe.n)($e591d9ddb9db9cba$var$_scopes, this).get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else (0, $3szIe.n)($e591d9ddb9db9cba$var$_scopes, this).set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if ((0, $3szIe.n)($e591d9ddb9db9cba$var$_mutations, this).delete(mutation)) {
            const scope = $e591d9ddb9db9cba$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = (0, $3szIe.n)($e591d9ddb9db9cba$var$_scopes, this).get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) (0, $3szIe.n)($e591d9ddb9db9cba$var$_scopes, this).delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $e591d9ddb9db9cba$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = (0, $3szIe.n)($e591d9ddb9db9cba$var$_scopes, this).get(scope);
            const firstPendingMutation = mutationsWithSameScope === null || mutationsWithSameScope === void 0 ? void 0 : mutationsWithSameScope.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        const scope = $e591d9ddb9db9cba$var$scopeFor(mutation);
        if (typeof scope === "string") {
            var _classPrivateFieldGet2$1;
            const foundMutation = (_classPrivateFieldGet2$1 = (0, $3szIe.n)($e591d9ddb9db9cba$var$_scopes, this).get(scope)) === null || _classPrivateFieldGet2$1 === void 0 ? void 0 : _classPrivateFieldGet2$1.find((m)=>m !== mutation && m.state.isPaused);
            return (foundMutation === null || foundMutation === void 0 ? void 0 : foundMutation.continue()) ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $hPIOx.notifyManager).batch(()=>{
            (0, $3szIe.n)($e591d9ddb9db9cba$var$_mutations, this).forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            (0, $3szIe.n)($e591d9ddb9db9cba$var$_mutations, this).clear();
            (0, $3szIe.n)($e591d9ddb9db9cba$var$_scopes, this).clear();
        });
    }
    getAll() {
        return Array.from((0, $3szIe.n)($e591d9ddb9db9cba$var$_mutations, this));
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $6L2cD.matchMutation)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $6L2cD.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $hPIOx.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $hPIOx.notifyManager).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $6L2cD.noop)))));
    }
};
function $e591d9ddb9db9cba$var$scopeFor(mutation) {
    var _mutation$options$sco;
    return (_mutation$options$sco = mutation.options.scope) === null || _mutation$options$sco === void 0 ? void 0 : _mutation$options$sco.id;
}

});
parcelRegister("cDQLR", function(module, exports) {

$parcel$export(module.exports, "Mutation", function () { return $93420fc7e516fb30$export$17b8b19c814bcf56; });
$parcel$export(module.exports, "getDefaultState", function () { return $93420fc7e516fb30$export$a1659b54bac3252a; });

var $3szIe = parcelRequire("3szIe");

var $hPIOx = parcelRequire("hPIOx");

var $lYvhw = parcelRequire("lYvhw");

var $iGENh = parcelRequire("iGENh");

var $78xtY = parcelRequire("78xtY");
//#region src/mutation.ts
var $93420fc7e516fb30$var$_client = /* @__PURE__ */ new WeakMap();
var $93420fc7e516fb30$var$_observers = /* @__PURE__ */ new WeakMap();
var $93420fc7e516fb30$var$_mutationCache = /* @__PURE__ */ new WeakMap();
var $93420fc7e516fb30$var$_retryer = /* @__PURE__ */ new WeakMap();
var $93420fc7e516fb30$var$_Mutation_brand = /* @__PURE__ */ new WeakSet();
var $93420fc7e516fb30$export$17b8b19c814bcf56 = class extends (0, $iGENh.Removable) {
    constructor(config){
        super();
        (0, $78xtY.t)(this, $93420fc7e516fb30$var$_Mutation_brand);
        (0, $3szIe.i)(this, $93420fc7e516fb30$var$_client, void 0);
        (0, $3szIe.i)(this, $93420fc7e516fb30$var$_observers, void 0);
        (0, $3szIe.i)(this, $93420fc7e516fb30$var$_mutationCache, void 0);
        (0, $3szIe.i)(this, $93420fc7e516fb30$var$_retryer, void 0);
        (0, $3szIe.t)($93420fc7e516fb30$var$_client, this, config.client);
        this.mutationId = config.mutationId;
        (0, $3szIe.t)($93420fc7e516fb30$var$_mutationCache, this, config.mutationCache);
        (0, $3szIe.t)($93420fc7e516fb30$var$_observers, this, []);
        this.state = config.state || $93420fc7e516fb30$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $3szIe.n)($93420fc7e516fb30$var$_observers, this).includes(observer)) {
            (0, $3szIe.n)($93420fc7e516fb30$var$_observers, this).push(observer);
            this.clearGcTimeout();
            (0, $3szIe.n)($93420fc7e516fb30$var$_mutationCache, this).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $3szIe.t)($93420fc7e516fb30$var$_observers, this, (0, $3szIe.n)($93420fc7e516fb30$var$_observers, this).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $3szIe.n)($93420fc7e516fb30$var$_mutationCache, this).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $3szIe.n)($93420fc7e516fb30$var$_observers, this).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $3szIe.n)($93420fc7e516fb30$var$_mutationCache, this).remove(this);
        }
    }
    continue() {
        var _classPrivateFieldGet2$1;
        return ((_classPrivateFieldGet2$1 = (0, $3szIe.n)($93420fc7e516fb30$var$_retryer, this)) === null || _classPrivateFieldGet2$1 === void 0 ? void 0 : _classPrivateFieldGet2$1.continue()) ?? (this.state.status === "pending" ? this.execute(this.state.variables) : Promise.resolve());
    }
    async execute(variables) {
        const onContinue = ()=>{
            (0, $3szIe.r)($93420fc7e516fb30$var$_Mutation_brand, this, $93420fc7e516fb30$var$_dispatch).call(this, {
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: (0, $3szIe.n)($93420fc7e516fb30$var$_client, this),
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        const retryer = (0, $3szIe.t)($93420fc7e516fb30$var$_retryer, this, (0, $lYvhw.createRetryer)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(/* @__PURE__ */ new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                (0, $3szIe.r)($93420fc7e516fb30$var$_Mutation_brand, this, $93420fc7e516fb30$var$_dispatch).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $3szIe.r)($93420fc7e516fb30$var$_Mutation_brand, this, $93420fc7e516fb30$var$_dispatch).call(this, {
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $3szIe.n)($93420fc7e516fb30$var$_mutationCache, this).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !retryer.canStart();
        try {
            var _classPrivateFieldGet3, _classPrivateFieldGet4, _this$options$onSucce, _this$options2, _classPrivateFieldGet5, _classPrivateFieldGet6, _this$options$onSettl, _this$options3;
            if (restored) onContinue();
            else {
                var _this$options$onMutat, _this$options;
                (0, $3szIe.r)($93420fc7e516fb30$var$_Mutation_brand, this, $93420fc7e516fb30$var$_dispatch).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                if ((0, $3szIe.n)($93420fc7e516fb30$var$_mutationCache, this).config.onMutate) await (0, $3szIe.n)($93420fc7e516fb30$var$_mutationCache, this).config.onMutate(variables, this, mutationFnContext);
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) === null || _this$options$onMutat === void 0 ? void 0 : _this$options$onMutat.call(_this$options, variables, mutationFnContext));
                if (context !== this.state.context) (0, $3szIe.r)($93420fc7e516fb30$var$_Mutation_brand, this, $93420fc7e516fb30$var$_dispatch).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await retryer.start();
            await ((_classPrivateFieldGet3 = (_classPrivateFieldGet4 = (0, $3szIe.n)($93420fc7e516fb30$var$_mutationCache, this).config).onSuccess) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.call(_classPrivateFieldGet4, data, variables, this.state.context, this, mutationFnContext));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) === null || _this$options$onSucce === void 0 ? void 0 : _this$options$onSucce.call(_this$options2, data, variables, this.state.context, mutationFnContext));
            await ((_classPrivateFieldGet5 = (_classPrivateFieldGet6 = (0, $3szIe.n)($93420fc7e516fb30$var$_mutationCache, this).config).onSettled) === null || _classPrivateFieldGet5 === void 0 ? void 0 : _classPrivateFieldGet5.call(_classPrivateFieldGet6, data, null, this.state.variables, this.state.context, this, mutationFnContext));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) === null || _this$options$onSettl === void 0 ? void 0 : _this$options$onSettl.call(_this$options3, data, null, variables, this.state.context, mutationFnContext));
            (0, $3szIe.r)($93420fc7e516fb30$var$_Mutation_brand, this, $93420fc7e516fb30$var$_dispatch).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _classPrivateFieldGet7, _classPrivateFieldGet8;
                await ((_classPrivateFieldGet7 = (_classPrivateFieldGet8 = (0, $3szIe.n)($93420fc7e516fb30$var$_mutationCache, this).config).onError) === null || _classPrivateFieldGet7 === void 0 ? void 0 : _classPrivateFieldGet7.call(_classPrivateFieldGet8, error, variables, this.state.context, this, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                var _this$options$onError, _this$options4;
                await ((_this$options$onError = (_this$options4 = this.options).onError) === null || _this$options$onError === void 0 ? void 0 : _this$options$onError.call(_this$options4, error, variables, this.state.context, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                var _classPrivateFieldGet9, _classPrivateFieldGet10;
                await ((_classPrivateFieldGet9 = (_classPrivateFieldGet10 = (0, $3szIe.n)($93420fc7e516fb30$var$_mutationCache, this).config).onSettled) === null || _classPrivateFieldGet9 === void 0 ? void 0 : _classPrivateFieldGet9.call(_classPrivateFieldGet10, void 0, error, this.state.variables, this.state.context, this, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            try {
                var _this$options$onSettl2, _this$options5;
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) === null || _this$options$onSettl2 === void 0 ? void 0 : _this$options$onSettl2.call(_this$options5, void 0, error, variables, this.state.context, mutationFnContext));
            } catch (e) {
                Promise.reject(e);
            }
            (0, $3szIe.r)($93420fc7e516fb30$var$_Mutation_brand, this, $93420fc7e516fb30$var$_dispatch).call(this, {
                type: "error",
                error: error
            });
            throw error;
        } finally{
            if ((0, $3szIe.n)($93420fc7e516fb30$var$_retryer, this) === retryer) (0, $3szIe.t)($93420fc7e516fb30$var$_retryer, this, void 0);
            (0, $3szIe.n)($93420fc7e516fb30$var$_mutationCache, this).runNext(this);
        }
    }
};
function $93420fc7e516fb30$var$_dispatch(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $hPIOx.notifyManager).batch(()=>{
        (0, $3szIe.n)($93420fc7e516fb30$var$_observers, this).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $3szIe.n)($93420fc7e516fb30$var$_mutationCache, this).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
}
function $93420fc7e516fb30$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}

});
parcelRegister("lYvhw", function(module, exports) {

$parcel$export(module.exports, "canFetch", function () { return $fff77771a4748967$export$61b92f63f30245cf; });
$parcel$export(module.exports, "CancelledError", function () { return $fff77771a4748967$export$a8430ed4188f35a9; });
$parcel$export(module.exports, "createRetryer", function () { return $fff77771a4748967$export$2cbd00fe8a2c8d85; });

var $6L2cD = parcelRequire("6L2cD");

var $dMqmZ = parcelRequire("dMqmZ");

var $fYclE = parcelRequire("fYclE");

var $hNxYl = parcelRequire("hNxYl");
//#region src/retryer.ts
function $fff77771a4748967$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $fff77771a4748967$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $hNxYl.onlineManager).isOnline() : true;
}
var $fff77771a4748967$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options === null || options === void 0 ? void 0 : options.revert;
        this.silent = options === null || options === void 0 ? void 0 : options.silent;
    }
};
/**
* @deprecated Use instanceof `CancelledError` instead.
*/ function $fff77771a4748967$export$986cc6445c1d323(value) {
    return value instanceof $fff77771a4748967$export$a8430ed4188f35a9;
}
function $fff77771a4748967$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    let status = "pending";
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((resolve, reject)=>{
        promiseResolve = resolve;
        promiseReject = reject;
    });
    promise.catch((0, $6L2cD.noop));
    const isResolved = ()=>status !== "pending";
    const cancel = (cancelOptions)=>{
        if (!isResolved()) {
            var _config$onCancel;
            const error = new $fff77771a4748967$export$a8430ed4188f35a9(cancelOptions);
            reject(error);
            (_config$onCancel = config.onCancel) === null || _config$onCancel === void 0 || _config$onCancel.call(config, error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $fYclE.focusManager).isFocused() && (config.networkMode === "always" || (0, $hNxYl.onlineManager).isOnline()) && config.canRun();
    const canStart = ()=>$fff77771a4748967$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn === null || continueFn === void 0 || continueFn();
            status = "resolved";
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn === null || continueFn === void 0 || continueFn();
            status = "rejected";
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _config$onPause;
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            (_config$onPause = config.onPause) === null || _config$onPause === void 0 || _config$onPause.call(config);
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved()) {
                var _config$onContinue;
                (_config$onContinue = config.onContinue) === null || _config$onContinue === void 0 || _config$onContinue.call(config);
            }
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$onFail;
            if (isResolved()) return;
            const retry = config.retry ?? ((0, $dMqmZ.isServer)() ? 0 : 3);
            const retryDelay = config.retryDelay ?? $fff77771a4748967$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_config$onFail = config.onFail) === null || _config$onFail === void 0 || _config$onFail.call(config, failureCount, error);
            (0, $6L2cD.sleep)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: promise,
        status: ()=>status,
        cancel: cancel,
        continue: ()=>{
            continueFn === null || continueFn === void 0 || continueFn();
            return promise;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return promise;
        }
    };
}

});
parcelRegister("dMqmZ", function(module, exports) {

$parcel$export(module.exports, "isServer", function () { return $a084368a7cdb50bf$export$6acf61af03e62db; });

var $6L2cD = parcelRequire("6L2cD");
//#region src/environmentManager.ts
let $a084368a7cdb50bf$var$isServerFn = ()=>(0, $6L2cD.isServer);
/**
* Returns whether the current runtime should be treated as a server environment.
*/ const $a084368a7cdb50bf$export$6acf61af03e62db = ()=>$a084368a7cdb50bf$var$isServerFn();
/**
* Manages environment detection used by TanStack Query internals.
*/ const $a084368a7cdb50bf$export$2d935f1a9c9d3f3e = {
    isServer: $a084368a7cdb50bf$export$6acf61af03e62db,
    /**
	* Overrides the server check globally.
	*/ setIsServer (isServerValue) {
        $a084368a7cdb50bf$var$isServerFn = isServerValue;
    }
};

});


parcelRegister("iGENh", function(module, exports) {

$parcel$export(module.exports, "Removable", function () { return $d9abcb0559c798e8$export$e09608847fcc8c59; });

var $3szIe = parcelRequire("3szIe");

var $6t06k = parcelRequire("6t06k");

var $6L2cD = parcelRequire("6L2cD");

var $dMqmZ = parcelRequire("dMqmZ");
//#region src/removable.ts
var $d9abcb0559c798e8$var$_gcTimeout = /* @__PURE__ */ new WeakMap();
var $d9abcb0559c798e8$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $3szIe.i)(this, $d9abcb0559c798e8$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $6L2cD.isValidTimeout)(this.gcTime)) (0, $3szIe.t)($d9abcb0559c798e8$var$_gcTimeout, this, (0, $6t06k.timeoutManager).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $dMqmZ.isServer)() ? Infinity : 3e5));
    }
    clearGcTimeout() {
        if ((0, $3szIe.n)($d9abcb0559c798e8$var$_gcTimeout, this) !== void 0) {
            (0, $6t06k.timeoutManager).clearTimeout((0, $3szIe.n)($d9abcb0559c798e8$var$_gcTimeout, this));
            (0, $3szIe.t)($d9abcb0559c798e8$var$_gcTimeout, this, void 0);
        }
    }
};

});

parcelRegister("78xtY", function(module, exports) {

$parcel$export(module.exports, "t", function () { return $532340aaf17bbf5f$export$625550452a3fa3ec; });

var $3szIe = parcelRequire("3szIe");
//#region \0@oxc-project+runtime@0.144.0/helpers/esm/classPrivateMethodInitSpec.js
function $532340aaf17bbf5f$export$625550452a3fa3ec(e, a) {
    (0, $3szIe.a)(e, a), a.add(e);
}

});



parcelRegister("h2iHR", function(module, exports) {

$parcel$export(module.exports, "QueryCache", function () { return $c6712246f841d3a6$export$5dde0cd941da8468; });

var $3szIe = parcelRequire("3szIe");

var $6L2cD = parcelRequire("6L2cD");

var $3G2zK = parcelRequire("3G2zK");

var $hPIOx = parcelRequire("hPIOx");

var $iiqu4 = parcelRequire("iiqu4");
//#region src/queryCache.ts
var $c6712246f841d3a6$var$_queries = /* @__PURE__ */ new WeakMap();
var $c6712246f841d3a6$export$5dde0cd941da8468 = class extends (0, $3G2zK.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $3szIe.i)(this, $c6712246f841d3a6$var$_queries, void 0);
        (0, $3szIe.t)($c6712246f841d3a6$var$_queries, this, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $6L2cD.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $iiqu4.Query)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $3szIe.n)($c6712246f841d3a6$var$_queries, this).has(query.queryHash)) {
            (0, $3szIe.n)($c6712246f841d3a6$var$_queries, this).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $3szIe.n)($c6712246f841d3a6$var$_queries, this).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $3szIe.n)($c6712246f841d3a6$var$_queries, this).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $hPIOx.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $3szIe.n)($c6712246f841d3a6$var$_queries, this).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $3szIe.n)($c6712246f841d3a6$var$_queries, this).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $6L2cD.matchQuery)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $6L2cD.matchQuery)(filters, query)) : queries;
    }
    notify(event) {
        (0, $hPIOx.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $hPIOx.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $hPIOx.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};

});
parcelRegister("iiqu4", function(module, exports) {

$parcel$export(module.exports, "Query", function () { return $d51e739bda2a671a$export$62297b13309008b2; });
$parcel$export(module.exports, "fetchState", function () { return $d51e739bda2a671a$export$f3df9013f2b58bce; });

var $3szIe = parcelRequire("3szIe");

var $6L2cD = parcelRequire("6L2cD");

var $hPIOx = parcelRequire("hPIOx");

var $lYvhw = parcelRequire("lYvhw");

var $iGENh = parcelRequire("iGENh");

var $2EFjR = parcelRequire("2EFjR");

var $78xtY = parcelRequire("78xtY");
//#region src/query.ts
var $d51e739bda2a671a$var$_queryType = /* @__PURE__ */ new WeakMap();
var $d51e739bda2a671a$var$_initialState = /* @__PURE__ */ new WeakMap();
var $d51e739bda2a671a$var$_revertState = /* @__PURE__ */ new WeakMap();
var $d51e739bda2a671a$var$_cache = /* @__PURE__ */ new WeakMap();
var $d51e739bda2a671a$var$_client = /* @__PURE__ */ new WeakMap();
var $d51e739bda2a671a$var$_retryer = /* @__PURE__ */ new WeakMap();
var $d51e739bda2a671a$var$_defaultOptions = /* @__PURE__ */ new WeakMap();
var $d51e739bda2a671a$var$_abortSignalConsumed = /* @__PURE__ */ new WeakMap();
var $d51e739bda2a671a$var$_Query_brand = /* @__PURE__ */ new WeakSet();
var $d51e739bda2a671a$export$62297b13309008b2 = class extends (0, $iGENh.Removable) {
    constructor(config){
        super();
        (0, $78xtY.t)(this, $d51e739bda2a671a$var$_Query_brand);
        (0, $3szIe.i)(this, $d51e739bda2a671a$var$_queryType, void 0);
        (0, $3szIe.i)(this, $d51e739bda2a671a$var$_initialState, void 0);
        (0, $3szIe.i)(this, $d51e739bda2a671a$var$_revertState, void 0);
        (0, $3szIe.i)(this, $d51e739bda2a671a$var$_cache, void 0);
        (0, $3szIe.i)(this, $d51e739bda2a671a$var$_client, void 0);
        (0, $3szIe.i)(this, $d51e739bda2a671a$var$_retryer, void 0);
        (0, $3szIe.i)(this, $d51e739bda2a671a$var$_defaultOptions, void 0);
        (0, $3szIe.i)(this, $d51e739bda2a671a$var$_abortSignalConsumed, void 0);
        (0, $3szIe.t)($d51e739bda2a671a$var$_abortSignalConsumed, this, false);
        (0, $3szIe.t)($d51e739bda2a671a$var$_defaultOptions, this, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $3szIe.t)($d51e739bda2a671a$var$_client, this, config.client);
        (0, $3szIe.t)($d51e739bda2a671a$var$_cache, this, (0, $3szIe.n)($d51e739bda2a671a$var$_client, this).getQueryCache());
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $3szIe.t)($d51e739bda2a671a$var$_initialState, this, $d51e739bda2a671a$var$getDefaultState(this.options));
        this.state = config.state ?? (0, $3szIe.n)($d51e739bda2a671a$var$_initialState, this);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get queryType() {
        return (0, $3szIe.n)($d51e739bda2a671a$var$_queryType, this);
    }
    get promise() {
        var _classPrivateFieldGet2$1;
        return (_classPrivateFieldGet2$1 = (0, $3szIe.n)($d51e739bda2a671a$var$_retryer, this)) === null || _classPrivateFieldGet2$1 === void 0 ? void 0 : _classPrivateFieldGet2$1.promise;
    }
    setOptions(options) {
        this.options = {
            ...(0, $3szIe.n)($d51e739bda2a671a$var$_defaultOptions, this),
            ...options
        };
        if (options === null || options === void 0 ? void 0 : options._type) (0, $3szIe.t)($d51e739bda2a671a$var$_queryType, this, options._type);
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = $d51e739bda2a671a$var$getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setState($d51e739bda2a671a$var$successState(defaultState.data, defaultState.dataUpdatedAt));
                (0, $3szIe.t)($d51e739bda2a671a$var$_initialState, this, defaultState);
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $3szIe.n)($d51e739bda2a671a$var$_cache, this).remove(this);
    }
    setData(newData, options) {
        const data = (0, $6L2cD.replaceData)(this.state.data, newData, this.options);
        (0, $3szIe.r)($d51e739bda2a671a$var$_Query_brand, this, $d51e739bda2a671a$var$_dispatch).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options === null || options === void 0 ? void 0 : options.updatedAt,
            manual: options === null || options === void 0 ? void 0 : options.manual
        });
        return data;
    }
    setState(state) {
        (0, $3szIe.r)($d51e739bda2a671a$var$_Query_brand, this, $d51e739bda2a671a$var$_dispatch).call(this, {
            type: "setState",
            state: state
        });
    }
    cancel(options) {
        var _classPrivateFieldGet3, _classPrivateFieldGet4;
        const promise = (_classPrivateFieldGet3 = (0, $3szIe.n)($d51e739bda2a671a$var$_retryer, this)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.promise;
        (_classPrivateFieldGet4 = (0, $3szIe.n)($d51e739bda2a671a$var$_retryer, this)) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4.cancel(options);
        return promise ? promise.then((0, $6L2cD.noop)).catch((0, $6L2cD.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    get resetState() {
        return (0, $3szIe.n)($d51e739bda2a671a$var$_initialState, this);
    }
    reset() {
        this.destroy();
        this.setState(this.resetState);
    }
    isActive() {
        return this.observers.some((observer)=>(0, $6L2cD.resolveQueryValue)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $6L2cD.skipToken) || !this.isFetched();
    }
    isFetched() {
        return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $6L2cD.resolveQueryValue)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $6L2cD.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _classPrivateFieldGet5;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer === null || observer === void 0 || observer.refetch({
            cancelRefetch: false
        });
        (_classPrivateFieldGet5 = (0, $3szIe.n)($d51e739bda2a671a$var$_retryer, this)) === null || _classPrivateFieldGet5 === void 0 || _classPrivateFieldGet5.continue();
    }
    onOnline() {
        var _classPrivateFieldGet6;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer === null || observer === void 0 || observer.refetch({
            cancelRefetch: false
        });
        (_classPrivateFieldGet6 = (0, $3szIe.n)($d51e739bda2a671a$var$_retryer, this)) === null || _classPrivateFieldGet6 === void 0 || _classPrivateFieldGet6.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $3szIe.n)($d51e739bda2a671a$var$_cache, this).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.observers.splice(index, 1);
            if (!this.observers.length) {
                if ((0, $3szIe.n)($d51e739bda2a671a$var$_retryer, this)) {
                    if ((0, $3szIe.n)($d51e739bda2a671a$var$_abortSignalConsumed, this) || this.state.fetchStatus === "paused" && this.state.status === "pending") (0, $3szIe.n)($d51e739bda2a671a$var$_retryer, this).cancel({
                        revert: true
                    });
                    else (0, $3szIe.n)($d51e739bda2a671a$var$_retryer, this).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $3szIe.n)($d51e739bda2a671a$var$_cache, this).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $3szIe.r)($d51e739bda2a671a$var$_Query_brand, this, $d51e739bda2a671a$var$_dispatch).call(this, {
            type: "invalidate"
        });
    }
    async fetch(options, fetchOptions) {
        var _classPrivateFieldGet7, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle" && ((_classPrivateFieldGet7 = (0, $3szIe.n)($d51e739bda2a671a$var$_retryer, this)) === null || _classPrivateFieldGet7 === void 0 ? void 0 : _classPrivateFieldGet7.status()) !== "rejected") {
            if (this.state.data !== void 0 && (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $3szIe.n)($d51e739bda2a671a$var$_retryer, this)) {
                (0, $3szIe.n)($d51e739bda2a671a$var$_retryer, this).continueRetry();
                return (0, $3szIe.n)($d51e739bda2a671a$var$_retryer, this).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $3szIe.t)($d51e739bda2a671a$var$_abortSignalConsumed, this, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $6L2cD.ensureQueryFn)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext = {
                    client: (0, $3szIe.n)($d51e739bda2a671a$var$_client, this),
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext);
                return queryFnContext;
            };
            const queryFnContext = createQueryFnContext();
            (0, $3szIe.t)($d51e739bda2a671a$var$_abortSignalConsumed, this, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: (0, $3szIe.n)($d51e739bda2a671a$var$_client, this),
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context);
            return context;
        };
        const context = createFetchContext();
        const behavior = (0, $3szIe.n)($d51e739bda2a671a$var$_queryType, this) === "infinite" ? (0, $2EFjR.infiniteQueryBehavior)(this.options.pages) : this.options.behavior;
        behavior === null || behavior === void 0 || behavior.onFetch(context, this);
        (0, $3szIe.t)($d51e739bda2a671a$var$_revertState, this, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) === null || _context$fetchOptions === void 0 ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            (0, $3szIe.r)($d51e739bda2a671a$var$_Query_brand, this, $d51e739bda2a671a$var$_dispatch).call(this, {
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) === null || _context$fetchOptions2 === void 0 ? void 0 : _context$fetchOptions2.meta
            });
        }
        const retryer = (0, $3szIe.t)($d51e739bda2a671a$var$_retryer, this, (0, $lYvhw.createRetryer)({
            initialPromise: fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, $lYvhw.CancelledError) && error.revert) this.setState({
                    ...(0, $3szIe.n)($d51e739bda2a671a$var$_revertState, this),
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                (0, $3szIe.r)($d51e739bda2a671a$var$_Query_brand, this, $d51e739bda2a671a$var$_dispatch).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $3szIe.r)($d51e739bda2a671a$var$_Query_brand, this, $d51e739bda2a671a$var$_dispatch).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $3szIe.r)($d51e739bda2a671a$var$_Query_brand, this, $d51e739bda2a671a$var$_dispatch).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        try {
            var _classPrivateFieldGet8, _classPrivateFieldGet9, _classPrivateFieldGet10, _classPrivateFieldGet11;
            const data = await retryer.start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            (_classPrivateFieldGet8 = (_classPrivateFieldGet9 = (0, $3szIe.n)($d51e739bda2a671a$var$_cache, this).config).onSuccess) === null || _classPrivateFieldGet8 === void 0 || _classPrivateFieldGet8.call(_classPrivateFieldGet9, data, this);
            (_classPrivateFieldGet10 = (_classPrivateFieldGet11 = (0, $3szIe.n)($d51e739bda2a671a$var$_cache, this).config).onSettled) === null || _classPrivateFieldGet10 === void 0 || _classPrivateFieldGet10.call(_classPrivateFieldGet11, data, this.state.error, this);
            return data;
        } catch (error) {
            var _classPrivateFieldGet12, _classPrivateFieldGet13, _classPrivateFieldGet14, _classPrivateFieldGet15;
            if (error instanceof (0, $lYvhw.CancelledError)) {
                if (error.silent) return (0, $3szIe.n)($d51e739bda2a671a$var$_retryer, this).promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            (0, $3szIe.r)($d51e739bda2a671a$var$_Query_brand, this, $d51e739bda2a671a$var$_dispatch).call(this, {
                type: "error",
                error: error
            });
            (_classPrivateFieldGet12 = (_classPrivateFieldGet13 = (0, $3szIe.n)($d51e739bda2a671a$var$_cache, this).config).onError) === null || _classPrivateFieldGet12 === void 0 || _classPrivateFieldGet12.call(_classPrivateFieldGet13, error, this);
            (_classPrivateFieldGet14 = (_classPrivateFieldGet15 = (0, $3szIe.n)($d51e739bda2a671a$var$_cache, this).config).onSettled) === null || _classPrivateFieldGet14 === void 0 || _classPrivateFieldGet14.call(_classPrivateFieldGet15, this.state.data, error, this);
            throw error;
        } finally{
            if ((0, $3szIe.n)($d51e739bda2a671a$var$_retryer, this) === retryer) (0, $3szIe.t)($d51e739bda2a671a$var$_retryer, this, void 0);
            this.scheduleGc();
        }
    }
};
function $d51e739bda2a671a$var$_dispatch(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$d51e739bda2a671a$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                const newState = {
                    ...state,
                    ...$d51e739bda2a671a$var$successState(action.data, action.dataUpdatedAt),
                    dataUpdateCount: state.dataUpdateCount + 1,
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
                (0, $3szIe.t)($d51e739bda2a671a$var$_revertState, this, action.manual ? newState : void 0);
                return newState;
            case "error":
                const error = action.error;
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error",
                    isInvalidated: true
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $hPIOx.notifyManager).batch(()=>{
        this.observers.slice().forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $3szIe.n)($d51e739bda2a671a$var$_cache, this).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
}
function $d51e739bda2a671a$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $lYvhw.canFetch)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $d51e739bda2a671a$var$successState(data, dataUpdatedAt) {
    return {
        data: data,
        dataUpdatedAt: dataUpdatedAt ?? Date.now(),
        error: null,
        isInvalidated: false,
        status: "success"
    };
}
function $d51e739bda2a671a$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}

});
parcelRegister("2EFjR", function(module, exports) {

$parcel$export(module.exports, "infiniteQueryBehavior", function () { return $1eef5e58da26bac7$export$84470d1367601e8d; });

var $6L2cD = parcelRequire("6L2cD");
//#region src/infiniteQueryBehavior.ts
function $1eef5e58da26bac7$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            var _context$fetchOptions, _context$state$data, _context$state$data2;
            const options = context.options;
            const direction = (_context$fetchOptions = context.fetchOptions) === null || _context$fetchOptions === void 0 || (_context$fetchOptions = _context$fetchOptions.meta) === null || _context$fetchOptions === void 0 || (_context$fetchOptions = _context$fetchOptions.fetchMore) === null || _context$fetchOptions === void 0 ? void 0 : _context$fetchOptions.direction;
            const oldPages = ((_context$state$data = context.state.data) === null || _context$state$data === void 0 ? void 0 : _context$state$data.pages) || [];
            const oldPageParams = ((_context$state$data2 = context.state.data) === null || _context$state$data2 === void 0 ? void 0 : _context$state$data2.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    (0, $6L2cD.addConsumeAwareSignal)(object, ()=>context.signal, ()=>cancelled = true);
                };
                const queryFn = (0, $6L2cD.ensureQueryFn)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject(context.signal.reason);
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext);
                        return queryFnContext;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $6L2cD.addToStart) : (0, $6L2cD.addToEnd);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $1eef5e58da26bac7$var$getPreviousPageParam : $1eef5e58da26bac7$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    result = await fetchPage(oldData, pageParamFn(options, oldData), previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $1eef5e58da26bac7$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _context$options$pers, _context$options;
                return (_context$options$pers = (_context$options = context.options).persister) === null || _context$options$pers === void 0 ? void 0 : _context$options$pers.call(_context$options, fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $1eef5e58da26bac7$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $1eef5e58da26bac7$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _options$getPreviousP;
    return pages.length > 0 ? (_options$getPreviousP = options.getPreviousPageParam) === null || _options$getPreviousP === void 0 ? void 0 : _options$getPreviousP.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
/**
* Checks if there is a next page.
*/ function $1eef5e58da26bac7$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $1eef5e58da26bac7$var$getNextPageParam(options, data) != null;
}
/**
* Checks if there is a previous page.
*/ function $1eef5e58da26bac7$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $1eef5e58da26bac7$var$getPreviousPageParam(options, data) != null;
}

});




parcelRegister("1a3a2", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", function () { return $0d892d4f67bdc026$export$22e77b9572c4fded; });
$parcel$export(module.exports, "QueryClientProvider", function () { return $0d892d4f67bdc026$export$45604f0cc8ae667b; });

var $8FY87 = parcelRequire("8FY87");

var $2PPWI = parcelRequire("2PPWI");
"use client";
//#region src/QueryClientProvider.tsx
const $0d892d4f67bdc026$export$da112d31b0149f31 = $8FY87.createContext(void 0);
const $0d892d4f67bdc026$export$22e77b9572c4fded = (queryClient)=>{
    const client = $8FY87.useContext($0d892d4f67bdc026$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
const $0d892d4f67bdc026$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $8FY87.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $2PPWI.jsx)($0d892d4f67bdc026$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};

});

parcelRegister("huzw8", function(module, exports) {

$parcel$export(module.exports, "domAnimation", function () { return $f6a87cafe3897d6a$export$2cb19dbf990677e3; });

var $9KKIm = parcelRequire("9KKIm");

var $91h9m = parcelRequire("91h9m");

var $6pXP1 = parcelRequire("6pXP1");
/**
 * @public
 */ const $f6a87cafe3897d6a$export$2cb19dbf990677e3 = {
    renderer: (0, $6pXP1.createDomVisualElement),
    ...(0, $9KKIm.animations),
    ...(0, $91h9m.gestureAnimations)
};

});
parcelRegister("9KKIm", function(module, exports) {

$parcel$export(module.exports, "animations", function () { return $2ad88b2695ebe387$export$7f9953c70dacfd7f; });

var $9pRL1 = parcelRequire("9pRL1");

var $kks1S = parcelRequire("kks1S");
const $2ad88b2695ebe387$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $9pRL1.AnimationFeature)
    },
    exit: {
        Feature: (0, $kks1S.ExitAnimationFeature)
    }
};

});
parcelRegister("9pRL1", function(module, exports) {

$parcel$export(module.exports, "AnimationFeature", function () { return $97ddaf65819c6fbb$export$b45b3fe5caabdca; });

var $dHb9C = parcelRequire("dHb9C");

var $jQoAq = parcelRequire("jQoAq");

var $7Rn9r = parcelRequire("7Rn9r");
class $97ddaf65819c6fbb$export$b45b3fe5caabdca extends (0, $7Rn9r.Feature) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $jQoAq.createAnimationState)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $dHb9C.isAnimationControls)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}

});
parcelRegister("dHb9C", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", function () { return $8b261c7fe1a80608$export$aa71198ceeaf53ce; });
function $8b261c7fe1a80608$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}

});

parcelRegister("jQoAq", function(module, exports) {

$parcel$export(module.exports, "createAnimationState", function () { return $9a6a2df83fa40013$export$bb53502b7a672aa8; });

var $dHb9C = parcelRequire("dHb9C");

var $5EUnL = parcelRequire("5EUnL");

var $g5jiT = parcelRequire("g5jiT");

var $7upgv = parcelRequire("7upgv");

var $7U3mN = parcelRequire("7U3mN");

var $glANL = parcelRequire("glANL");

var $coA0Z = parcelRequire("coA0Z");

var $fR2RL = parcelRequire("fR2RL");
const $9a6a2df83fa40013$var$reversePriorityOrder = [
    ...(0, $glANL.variantPriorityOrder)
].reverse();
const $9a6a2df83fa40013$var$numAnimationTypes = (0, $glANL.variantPriorityOrder).length;
function $9a6a2df83fa40013$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $coA0Z.animateVisualElement)(visualElement, animation, options)));
}
function $9a6a2df83fa40013$export$bb53502b7a672aa8(visualElement) {
    let animate = $9a6a2df83fa40013$var$animateList(visualElement);
    let state = $9a6a2df83fa40013$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $7U3mN.resolveVariant)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $fR2RL.getVariantContext)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $9a6a2df83fa40013$var$numAnimationTypes; i++){
            const type = $9a6a2df83fa40013$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $7upgv.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $dHb9C.isAnimationControls)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $9a6a2df83fa40013$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $5EUnL.isKeyframesTarget)(next) && (0, $5EUnL.isKeyframesTarget)(prev)) valueHasChanged = !(0, $g5jiT.shallowCompare)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $9a6a2df83fa40013$var$createState();
            isInitialRender = true;
        }
    };
}
function $9a6a2df83fa40013$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $g5jiT.shallowCompare)(next, prev);
    return false;
}
function $9a6a2df83fa40013$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $9a6a2df83fa40013$var$createState() {
    return {
        animate: $9a6a2df83fa40013$var$createTypeState(true),
        whileInView: $9a6a2df83fa40013$var$createTypeState(),
        whileHover: $9a6a2df83fa40013$var$createTypeState(),
        whileTap: $9a6a2df83fa40013$var$createTypeState(),
        whileDrag: $9a6a2df83fa40013$var$createTypeState(),
        whileFocus: $9a6a2df83fa40013$var$createTypeState(),
        exit: $9a6a2df83fa40013$var$createTypeState()
    };
}

});
parcelRegister("5EUnL", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", function () { return $b7a6f70816698bb2$export$9153ad4c4999f4a0; });
const $b7a6f70816698bb2$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};

});

parcelRegister("g5jiT", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", function () { return $9c7538b7769b2698$export$90e866afbd6b9f1a; });
function $9c7538b7769b2698$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRegister("7upgv", function(module, exports) {

$parcel$export(module.exports, "isVariantLabel", function () { return $f514da049dd3413d$export$720b90e312cea233; });
/**
 * Decides if the supplied variable is variant label
 */ function $f514da049dd3413d$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}

});

parcelRegister("7U3mN", function(module, exports) {

$parcel$export(module.exports, "resolveVariant", function () { return $69504682a3c04510$export$7b1b1c981f4f0558; });

var $80nvV = parcelRequire("80nvV");
function $69504682a3c04510$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $80nvV.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

});
parcelRegister("80nvV", function(module, exports) {

$parcel$export(module.exports, "resolveVariantFromProps", function () { return $04042d68f1c55eab$export$d68f140c4d9b48bc; });
function $04042d68f1c55eab$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $04042d68f1c55eab$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $04042d68f1c55eab$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $04042d68f1c55eab$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}

});


parcelRegister("glANL", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", function () { return $e20ca620bfafef4f$export$16e45afcc206d3a8; });
$parcel$export(module.exports, "variantProps", function () { return $e20ca620bfafef4f$export$1405a65085f40b9; });
const $e20ca620bfafef4f$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $e20ca620bfafef4f$export$1405a65085f40b9 = [
    "initial",
    ...$e20ca620bfafef4f$export$16e45afcc206d3a8
];

});

parcelRegister("coA0Z", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", function () { return $f9f31dc3cb2b6b79$export$ff62cf473653f109; });

var $7U3mN = parcelRequire("7U3mN");

var $PbVbJ = parcelRequire("PbVbJ");

var $b9Wnj = parcelRequire("b9Wnj");
function $f9f31dc3cb2b6b79$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $b9Wnj.animateVariant)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $b9Wnj.animateVariant)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $7U3mN.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $PbVbJ.animateTarget)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}

});
parcelRegister("PbVbJ", function(module, exports) {

$parcel$export(module.exports, "animateTarget", function () { return $6076d4ba2f47d126$export$68cacfeee78d98d2; });


var $l38qt = parcelRequire("l38qt");

var $7t8KU = parcelRequire("7t8KU");

var $8KGmm = parcelRequire("8KGmm");

var $1dTsb = parcelRequire("1dTsb");

var $aoaXW = parcelRequire("aoaXW");

var $jgeNG = parcelRequire("jgeNG");

var $26AI3 = parcelRequire("26AI3");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $6076d4ba2f47d126$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $6076d4ba2f47d126$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $6076d4ba2f47d126$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $l38qt.getValueTransition)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $aoaXW.getOptimisedAppearId)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $26AI3.frame));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $1dTsb.addValueToWillChange)(visualElement, key);
        value.start((0, $jgeNG.animateMotionValue)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $7t8KU.positionalKeys).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $26AI3.frame).update(()=>{
            transitionEnd && (0, $8KGmm.setTarget)(visualElement, transitionEnd);
        });
    });
    return animations;
}

});
parcelRegister("l38qt", function(module, exports) {

$parcel$export(module.exports, "getValueTransition", function () { return $d48024d3bac76d08$export$7c1391340308742e; });
function $d48024d3bac76d08$export$7c1391340308742e(transition, key) {
    return transition ? transition[key] || transition["default"] || transition : undefined;
}

});

parcelRegister("7t8KU", function(module, exports) {

$parcel$export(module.exports, "positionalKeys", function () { return $938ef5dd7cbb57fb$export$c66c0d5db2a205d; });

var $301nj = parcelRequire("301nj");
const $938ef5dd7cbb57fb$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $301nj.transformPropOrder)
]);

});
parcelRegister("301nj", function(module, exports) {

$parcel$export(module.exports, "transformPropOrder", function () { return $f18128fa66309dbf$export$280dc01950909d86; });
$parcel$export(module.exports, "transformProps", function () { return $f18128fa66309dbf$export$7b42a0094fb00b6e; });
/**
 * Generate a list of every possible transform key.
 */ const $f18128fa66309dbf$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $f18128fa66309dbf$export$7b42a0094fb00b6e = new Set($f18128fa66309dbf$export$280dc01950909d86);

});


parcelRegister("8KGmm", function(module, exports) {

$parcel$export(module.exports, "setTarget", function () { return $f953de5edbfa9b10$export$1f61c53461aff4a5; });

var $e6m6D = parcelRequire("e6m6D");

var $cSjJD = parcelRequire("cSjJD");

var $7U3mN = parcelRequire("7U3mN");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $f953de5edbfa9b10$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $cSjJD.motionValue)(value));
}
function $f953de5edbfa9b10$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $7U3mN.resolveVariant)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $e6m6D.resolveFinalValueInKeyframes)(target[key]);
        $f953de5edbfa9b10$var$setMotionValue(visualElement, key, value);
    }
}

});
parcelRegister("e6m6D", function(module, exports) {

$parcel$export(module.exports, "isCustomValue", function () { return $c78459df3d3b6c3d$export$2f308ad9864b3ac9; });
$parcel$export(module.exports, "resolveFinalValueInKeyframes", function () { return $c78459df3d3b6c3d$export$5485128c47bd48bb; });

var $5EUnL = parcelRequire("5EUnL");
const $c78459df3d3b6c3d$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $c78459df3d3b6c3d$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $5EUnL.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
};

});

parcelRegister("cSjJD", function(module, exports) {

$parcel$export(module.exports, "motionValue", function () { return $4412cb69915997df$export$ce8bdc721e76545f; });

var $es6mb = parcelRequire("es6mb");

var $h6Yw9 = parcelRequire("h6Yw9");

var $3p9Mn = parcelRequire("3p9Mn");


var $26AI3 = parcelRequire("26AI3");
/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $4412cb69915997df$var$MAX_VELOCITY_DELTA = 30;
const $4412cb69915997df$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $4412cb69915997df$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $4412cb69915997df$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.18.2";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $es6mb.time).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $es6mb.time).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $4412cb69915997df$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $h6Yw9.SubscriptionManager)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $26AI3.frame).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($4412cb69915997df$export$67fcd818a264039d.current) $4412cb69915997df$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $es6mb.time).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $4412cb69915997df$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $4412cb69915997df$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $3p9Mn.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $4412cb69915997df$export$ce8bdc721e76545f(init, options) {
    return new $4412cb69915997df$export$8cea36d14ee64562(init, options);
}

});
parcelRegister("es6mb", function(module, exports) {

$parcel$export(module.exports, "time", function () { return $7828e30f67e33256$export$2da9be4cfdb689b1; });

var $2EmRR = parcelRequire("2EmRR");

var $26AI3 = parcelRequire("26AI3");
let $7828e30f67e33256$var$now;
function $7828e30f67e33256$var$clearTime() {
    $7828e30f67e33256$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $7828e30f67e33256$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($7828e30f67e33256$var$now === undefined) $7828e30f67e33256$export$2da9be4cfdb689b1.set((0, $26AI3.frameData).isProcessing || (0, $2EmRR.MotionGlobalConfig).useManualTiming ? (0, $26AI3.frameData).timestamp : performance.now());
        return $7828e30f67e33256$var$now;
    },
    set: (newTime)=>{
        $7828e30f67e33256$var$now = newTime;
        queueMicrotask($7828e30f67e33256$var$clearTime);
    }
};

});
parcelRegister("2EmRR", function(module, exports) {

$parcel$export(module.exports, "MotionGlobalConfig", function () { return $871fb5a20f3db8e7$export$dd826089e3c5e502; });
const $871fb5a20f3db8e7$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};

});

parcelRegister("26AI3", function(module, exports) {

$parcel$export(module.exports, "frame", function () { return $ff8e02f310922c06$export$2cef06c20297c17d; });
$parcel$export(module.exports, "cancelFrame", function () { return $ff8e02f310922c06$export$ec99c0ef4978dccb; });
$parcel$export(module.exports, "frameData", function () { return $ff8e02f310922c06$export$fff89137e9e818ce; });


var $i0SNZ = parcelRequire("i0SNZ");

var $7e1nO = parcelRequire("7e1nO");
const { schedule: $ff8e02f310922c06$export$2cef06c20297c17d, cancel: $ff8e02f310922c06$export$ec99c0ef4978dccb, state: $ff8e02f310922c06$export$fff89137e9e818ce, steps: $ff8e02f310922c06$export$1811c3a7e3af92f0 } = (0, $7e1nO.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $i0SNZ.noop), true);

});
parcelRegister("i0SNZ", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $f46685ae07709b03$export$8793edee2d425525; });
/*#__NO_SIDE_EFFECTS__*/ const $f46685ae07709b03$export$8793edee2d425525 = (any)=>any;

});

parcelRegister("7e1nO", function(module, exports) {

$parcel$export(module.exports, "createRenderBatcher", function () { return $1ff322cd0b90e1ac$export$510b0596a933801a; });

var $2EmRR = parcelRequire("2EmRR");

var $hex1v = parcelRequire("hex1v");
const $1ff322cd0b90e1ac$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $1ff322cd0b90e1ac$var$maxElapsed = 40;
function $1ff322cd0b90e1ac$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $1ff322cd0b90e1ac$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $hex1v.createRenderStep)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $2EmRR.MotionGlobalConfig).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $1ff322cd0b90e1ac$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $1ff322cd0b90e1ac$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $1ff322cd0b90e1ac$export$71ecace0a033b35a.length; i++)steps[$1ff322cd0b90e1ac$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}

});
parcelRegister("hex1v", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", function () { return $cd23b2871a1fa77a$export$b995e5e85f5c8289; });
function $cd23b2871a1fa77a$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

});




parcelRegister("h6Yw9", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", function () { return $41bbca194bba5619$export$e7dff9482a5fd23c; });

var $42WC3 = parcelRequire("42WC3");
class $41bbca194bba5619$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $42WC3.addUniqueItem)(this.subscriptions, handler);
        return ()=>(0, $42WC3.removeItem)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

});
parcelRegister("42WC3", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $4ef9127b7b15f95b$export$20e507e47fae79fd; });
$parcel$export(module.exports, "removeItem", function () { return $4ef9127b7b15f95b$export$fe2d9b4e03920b4c; });
function $4ef9127b7b15f95b$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $4ef9127b7b15f95b$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $4ef9127b7b15f95b$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});


parcelRegister("3p9Mn", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $98da9dffb019b589$export$eab0632f7ad4f9d7; });
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $98da9dffb019b589$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});



parcelRegister("1dTsb", function(module, exports) {

$parcel$export(module.exports, "addValueToWillChange", function () { return $a07cf9a1f95667f9$export$3ac5aed310be0bee; });

var $iIxyn = parcelRequire("iIxyn");
function $a07cf9a1f95667f9$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $iIxyn.isWillChangeMotionValue)(willChange)) return willChange.add(key);
}

});
parcelRegister("iIxyn", function(module, exports) {

$parcel$export(module.exports, "isWillChangeMotionValue", function () { return $9195887f156ab62a$export$98397f3adbf6259f; });

var $fCd14 = parcelRequire("fCd14");
function $9195887f156ab62a$export$98397f3adbf6259f(value) {
    return Boolean((0, $fCd14.isMotionValue)(value) && value.add);
}

});
parcelRegister("fCd14", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", function () { return $b20b9ad9e6e588d6$export$605d60a2578142d3; });
const $b20b9ad9e6e588d6$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);

});



parcelRegister("aoaXW", function(module, exports) {

$parcel$export(module.exports, "getOptimisedAppearId", function () { return $b477c137b5dd38af$export$5f8d21e84d1d84fc; });

var $dsanY = parcelRequire("dsanY");
function $b477c137b5dd38af$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $dsanY.optimizedAppearDataAttribute];
}

});
parcelRegister("dsanY", function(module, exports) {

$parcel$export(module.exports, "optimizedAppearDataAttribute", function () { return $98ef4f028eecfd04$export$8592e1c077c890a6; });

var $drayr = parcelRequire("drayr");
const $98ef4f028eecfd04$export$ed7b8fa9dbf0105d = "framerAppearId";
const $98ef4f028eecfd04$export$8592e1c077c890a6 = "data-" + (0, $drayr.camelToDash)($98ef4f028eecfd04$export$ed7b8fa9dbf0105d);

});
parcelRegister("drayr", function(module, exports) {

$parcel$export(module.exports, "camelToDash", function () { return $c71be1d1cff1c7ec$export$9fd24a634729c672; });
/**
 * Convert camelCase to dash-case properties.
 */ const $c71be1d1cff1c7ec$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();

});



parcelRegister("jgeNG", function(module, exports) {

$parcel$export(module.exports, "animateMotionValue", function () { return $dc77d35668cb9098$export$90b3dfc33ff3548; });

var $b9FzO = parcelRequire("b9FzO");

var $l38qt = parcelRequire("l38qt");


var $krTAM = parcelRequire("krTAM");

var $26AI3 = parcelRequire("26AI3");

var $2EmRR = parcelRequire("2EmRR");

var $fN1OV = parcelRequire("fN1OV");

var $1T9Sz = parcelRequire("1T9Sz");

var $kaADW = parcelRequire("kaADW");

var $2djcq = parcelRequire("2djcq");

var $bG443 = parcelRequire("bG443");

var $7MpWV = parcelRequire("7MpWV");
const $dc77d35668cb9098$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $l38qt.getValueTransition)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $krTAM.secondsToMilliseconds)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $7MpWV.isTransitionDefined)(valueTransition)) options = {
            ...options,
            ...(0, $bG443.getDefaultTransition)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $krTAM.secondsToMilliseconds)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $krTAM.secondsToMilliseconds)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $fN1OV.instantAnimationState).current || (0, $2EmRR.MotionGlobalConfig).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $2djcq.getFinalKeyframe)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $26AI3.frame).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $b9FzO.GroupPlaybackControls)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $1T9Sz.AcceleratedAnimation).supports(options)) return new (0, $1T9Sz.AcceleratedAnimation)(options);
        else return new (0, $kaADW.MainThreadAnimation)(options);
    };

});
parcelRegister("b9FzO", function(module, exports) {

$parcel$export(module.exports, "GroupPlaybackControls", function () { return $11c15d6675c6fe31$export$c1e41718f71efe41; });

var $bZoxb = parcelRequire("bZoxb");
/**
 * TODO: This is a temporary class to support the legacy
 * thennable API
 */ class $11c15d6675c6fe31$export$c1e41718f71efe41 extends (0, $bZoxb.BaseGroupPlaybackControls) {
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
}

});
parcelRegister("bZoxb", function(module, exports) {

$parcel$export(module.exports, "BaseGroupPlaybackControls", function () { return $3a5ecb392fa5cca1$export$4d0c371993b9283e; });

var $2X8qQ = parcelRequire("2X8qQ");
class $3a5ecb392fa5cca1$export$4d0c371993b9283e {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    get finished() {
        // Support for new finished Promise and legacy thennable API
        return Promise.all(this.animations.map((animation)=>"finished" in animation ? animation.finished : animation));
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline, fallback) {
        const subscriptions = this.animations.map((animation)=>{
            if ((0, $2X8qQ.supportsScrollTimeline)() && animation.attachTimeline) return animation.attachTimeline(timeline);
            else if (typeof fallback === "function") return fallback(animation);
        });
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    flatten() {
        this.runAll("flatten");
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}

});
parcelRegister("2X8qQ", function(module, exports) {

$parcel$export(module.exports, "supportsScrollTimeline", function () { return $5d2d2715152a822a$export$20d68f04f30763a5; });


var $2MbO2 = parcelRequire("2MbO2");
const $5d2d2715152a822a$export$20d68f04f30763a5 = (0, $2MbO2.memo)(()=>window.ScrollTimeline !== undefined);

});
parcelRegister("2MbO2", function(module, exports) {

$parcel$export(module.exports, "memo", function () { return $d9a3084764416db2$export$7c73462e0d25e514; });
/*#__NO_SIDE_EFFECTS__*/ function $d9a3084764416db2$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}

});




parcelRegister("krTAM", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $dec94fcd83b794a0$export$fc3e7e8557f8c8c7; });
$parcel$export(module.exports, "millisecondsToSeconds", function () { return $dec94fcd83b794a0$export$f64c3bfbc58eec0f; });
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $dec94fcd83b794a0$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $dec94fcd83b794a0$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

});

parcelRegister("fN1OV", function(module, exports) {

$parcel$export(module.exports, "instantAnimationState", function () { return $cf1931e9f2dc3c0a$export$888a3d84909f9e3d; });
const $cf1931e9f2dc3c0a$export$888a3d84909f9e3d = {
    current: false
};

});

parcelRegister("1T9Sz", function(module, exports) {

$parcel$export(module.exports, "AcceleratedAnimation", function () { return $065483771f4dfc47$export$2a45abb4e6513325; });


var $i0SNZ = parcelRequire("i0SNZ");

var $krTAM = parcelRequire("krTAM");

var $azOhQ = parcelRequire("azOhQ");

var $iAMvy = parcelRequire("iAMvy");

var $6aGcL = parcelRequire("6aGcL");

var $4Y8dy = parcelRequire("4Y8dy");

var $ipbmL = parcelRequire("ipbmL");

var $9cKFb = parcelRequire("9cKFb");

var $lY29q = parcelRequire("lY29q");

var $8bbgw = parcelRequire("8bbgw");

var $7wmH9 = parcelRequire("7wmH9");

var $kaADW = parcelRequire("kaADW");

var $cRfwW = parcelRequire("cRfwW");

var $5KHPh = parcelRequire("5KHPh");

var $2djcq = parcelRequire("2djcq");

var $dQsgv = parcelRequire("dQsgv");
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $065483771f4dfc47$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $065483771f4dfc47$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $065483771f4dfc47$var$requiresPregeneratedKeyframes(options) {
    return (0, $azOhQ.isGenerator)(options.type) || options.type === "spring" || !(0, $6aGcL.isWaapiSupportedEasing)(options.ease);
}
function $065483771f4dfc47$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $kaADW.MainThreadAnimation)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $065483771f4dfc47$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $065483771f4dfc47$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $065483771f4dfc47$var$sampleDelta,
        ease: "linear"
    };
}
const $065483771f4dfc47$var$unsupportedEasingFunctions = {
    anticipate: $ipbmL.anticipate,
    backInOut: $9cKFb.backInOut,
    circInOut: $lY29q.circInOut
};
function $065483771f4dfc47$var$isUnsupportedEase(key) {
    return key in $065483771f4dfc47$var$unsupportedEasingFunctions;
}
class $065483771f4dfc47$export$2a45abb4e6513325 extends (0, $7wmH9.BaseAnimation) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        this.resolver = new (0, $8bbgw.DOMKeyframesResolver)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name, startTime: startTime } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!motionValue.owner || !motionValue.owner.current) return false;
        /**
         * If the user has provided an easing function name that isn't supported
         * by WAAPI (like "anticipate"), we need to provide the corressponding
         * function. This will later get converted to a linear() easing function.
         */ if (typeof ease === "string" && (0, $4Y8dy.supportsLinearEasing)() && $065483771f4dfc47$var$isUnsupportedEase(ease)) ease = $065483771f4dfc47$var$unsupportedEasingFunctions[ease];
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($065483771f4dfc47$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, element: element, ...options } = this.options;
            const pregeneratedAnimation = $065483771f4dfc47$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $5KHPh.startWaapiAnimation)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            (0, $iAMvy.attachTimeline)(animation, this.pendingTimeline);
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $2djcq.getFinalKeyframe)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $krTAM.millisecondsToSeconds)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $krTAM.millisecondsToSeconds)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $krTAM.secondsToMilliseconds)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved: resolved } = this;
        if (!resolved) return null;
        const { animation: animation } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $i0SNZ.noop;
            const { animation: animation } = resolved;
            (0, $iAMvy.attachTimeline)(animation, timeline);
        }
        return 0, $i0SNZ.noop;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
            const sampleAnimation = new (0, $kaADW.MainThreadAnimation)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $krTAM.secondsToMilliseconds)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $065483771f4dfc47$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $065483771f4dfc47$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        if (!motionValue || !motionValue.owner || !(motionValue.owner.current instanceof HTMLElement)) return false;
        const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
        return (0, $dQsgv.supportsWaapi)() && name && (0, $cRfwW.acceleratedValues).has(name) && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !onUpdate && !transformTemplate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}

});
parcelRegister("azOhQ", function(module, exports) {

$parcel$export(module.exports, "isGenerator", function () { return $31177ffbf632497e$export$6ab7812f1bac68be; });
function $31177ffbf632497e$export$6ab7812f1bac68be(type) {
    return typeof type === "function";
}

});

parcelRegister("iAMvy", function(module, exports) {

$parcel$export(module.exports, "attachTimeline", function () { return $3bc093789279f23a$export$5bd0fcbc73622e13; });
function $3bc093789279f23a$export$5bd0fcbc73622e13(animation, timeline) {
    animation.timeline = timeline;
    animation.onfinish = null;
}

});

parcelRegister("6aGcL", function(module, exports) {

$parcel$export(module.exports, "isWaapiSupportedEasing", function () { return $254f3ca2cd1f7c06$export$fcdd8f3f2160beda; });
$parcel$export(module.exports, "mapEasingToNativeEasing", function () { return $254f3ca2cd1f7c06$export$916ea73bcd3a6030; });

var $2uane = parcelRequire("2uane");

var $4Y8dy = parcelRequire("4Y8dy");

var $5Uenq = parcelRequire("5Uenq");
function $254f3ca2cd1f7c06$export$fcdd8f3f2160beda(easing) {
    return Boolean(typeof easing === "function" && (0, $4Y8dy.supportsLinearEasing)() || !easing || typeof easing === "string" && (easing in $254f3ca2cd1f7c06$export$2cf569f5e2221176 || (0, $4Y8dy.supportsLinearEasing)()) || (0, $2uane.isBezierDefinition)(easing) || Array.isArray(easing) && easing.every($254f3ca2cd1f7c06$export$fcdd8f3f2160beda));
}
const $254f3ca2cd1f7c06$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $254f3ca2cd1f7c06$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ $254f3ca2cd1f7c06$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ $254f3ca2cd1f7c06$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ $254f3ca2cd1f7c06$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ $254f3ca2cd1f7c06$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $254f3ca2cd1f7c06$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function" && (0, $4Y8dy.supportsLinearEasing)()) return (0, $5Uenq.generateLinearEasing)(easing, duration);
    else if ((0, $2uane.isBezierDefinition)(easing)) return $254f3ca2cd1f7c06$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$254f3ca2cd1f7c06$export$916ea73bcd3a6030(segmentEasing, duration) || $254f3ca2cd1f7c06$export$2cf569f5e2221176.easeOut);
    else return $254f3ca2cd1f7c06$export$2cf569f5e2221176[easing];
}

});
parcelRegister("2uane", function(module, exports) {

$parcel$export(module.exports, "isBezierDefinition", function () { return $aa26939b491e05dd$export$ff43f99925d7366b; });
const $aa26939b491e05dd$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";

});

parcelRegister("4Y8dy", function(module, exports) {

$parcel$export(module.exports, "supportsLinearEasing", function () { return $76b08199ae5980ed$export$866c1d07a1ac2ab; });

var $kU60m = parcelRequire("kU60m");
const $76b08199ae5980ed$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $kU60m.memoSupports)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");

});
parcelRegister("kU60m", function(module, exports) {

$parcel$export(module.exports, "memoSupports", function () { return $4c179d3e99257598$export$1964673d5ec13c3a; });


var $2MbO2 = parcelRequire("2MbO2");

var $kOiql = parcelRequire("kOiql");
function $4c179d3e99257598$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $2MbO2.memo)(callback);
    return ()=>{
        var _a;
        return (_a = (0, $kOiql.supportsFlags)[supportsFlag]) !== null && _a !== void 0 ? _a : memoized();
    };
}

});
parcelRegister("kOiql", function(module, exports) {

$parcel$export(module.exports, "supportsFlags", function () { return $6193780219aeb469$export$e3ad02c335474dee; });
/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $6193780219aeb469$export$e3ad02c335474dee = {
    linearEasing: undefined
};

});



parcelRegister("5Uenq", function(module, exports) {

$parcel$export(module.exports, "generateLinearEasing", function () { return $cd638a1a66703fdb$export$66d3851e2b1ec912; });


var $93BDD = parcelRequire("93BDD");
const $cd638a1a66703fdb$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += easing((0, $93BDD.progress)(0, numPoints - 1, i)) + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};

});
parcelRegister("93BDD", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $986ff145134c60c1$export$504d7abb21fa8c9; });
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ const $986ff145134c60c1$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});



parcelRegister("ipbmL", function(module, exports) {

$parcel$export(module.exports, "anticipate", function () { return $8d4f2391d52c04ca$export$6b0af63b873d419e; });

var $9cKFb = parcelRequire("9cKFb");
const $8d4f2391d52c04ca$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $9cKFb.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

});
parcelRegister("9cKFb", function(module, exports) {

$parcel$export(module.exports, "backOut", function () { return $1454afc3e0576e32$export$77edfce482316a60; });
$parcel$export(module.exports, "backIn", function () { return $1454afc3e0576e32$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backInOut", function () { return $1454afc3e0576e32$export$ddc5fd596f6c71b2; });

var $huad4 = parcelRequire("huad4");

var $1UIQk = parcelRequire("1UIQk");

var $fLnWN = parcelRequire("fLnWN");
const $1454afc3e0576e32$export$77edfce482316a60 = /*@__PURE__*/ (0, $huad4.cubicBezier)(0.33, 1.53, 0.69, 0.99);
const $1454afc3e0576e32$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $fLnWN.reverseEasing)($1454afc3e0576e32$export$77edfce482316a60);
const $1454afc3e0576e32$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $1UIQk.mirrorEasing)($1454afc3e0576e32$export$b01116c84cdfe1a2);

});
parcelRegister("huad4", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $dfbc6ca797bee3c0$export$2c575fa1d20488bd; });


var $i0SNZ = parcelRequire("i0SNZ");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $dfbc6ca797bee3c0$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $dfbc6ca797bee3c0$var$subdivisionPrecision = 0.0000001;
const $dfbc6ca797bee3c0$var$subdivisionMaxIterations = 12;
function $dfbc6ca797bee3c0$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $dfbc6ca797bee3c0$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $dfbc6ca797bee3c0$var$subdivisionPrecision && ++i < $dfbc6ca797bee3c0$var$subdivisionMaxIterations);
    return currentT;
}
function $dfbc6ca797bee3c0$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $i0SNZ.noop;
    const getTForX = (aX)=>$dfbc6ca797bee3c0$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $dfbc6ca797bee3c0$var$calcBezier(getTForX(t), mY1, mY2);
}

});

parcelRegister("1UIQk", function(module, exports) {

$parcel$export(module.exports, "mirrorEasing", function () { return $e4d1bbf4d946f130$export$f946554fb8aeaf0d; });
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $e4d1bbf4d946f130$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

});

parcelRegister("fLnWN", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", function () { return $607e7b0bcb09b82a$export$2c07eeff45156d4d; });
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $607e7b0bcb09b82a$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);

});



parcelRegister("lY29q", function(module, exports) {

$parcel$export(module.exports, "circIn", function () { return $ac7ecf1eb1e084f5$export$e444123e42d03385; });
$parcel$export(module.exports, "circOut", function () { return $ac7ecf1eb1e084f5$export$c8d67a19199d1a50; });
$parcel$export(module.exports, "circInOut", function () { return $ac7ecf1eb1e084f5$export$30d3455eee55bed5; });

var $1UIQk = parcelRequire("1UIQk");

var $fLnWN = parcelRequire("fLnWN");
const $ac7ecf1eb1e084f5$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $ac7ecf1eb1e084f5$export$c8d67a19199d1a50 = (0, $fLnWN.reverseEasing)($ac7ecf1eb1e084f5$export$e444123e42d03385);
const $ac7ecf1eb1e084f5$export$30d3455eee55bed5 = (0, $1UIQk.mirrorEasing)($ac7ecf1eb1e084f5$export$e444123e42d03385);

});

parcelRegister("8bbgw", function(module, exports) {

$parcel$export(module.exports, "DOMKeyframesResolver", function () { return $fa4bcaa7aa1effc9$export$4983792d11b61017; });

var $iKkfC = parcelRequire("iKkfC");

var $7t8KU = parcelRequire("7t8KU");

var $hcsuo = parcelRequire("hcsuo");

var $8yAAg = parcelRequire("8yAAg");

var $7LaYD = parcelRequire("7LaYD");

var $8Xq7t = parcelRequire("8Xq7t");

var $bCqhd = parcelRequire("bCqhd");

var $2g4Ln = parcelRequire("2g4Ln");
class $fa4bcaa7aa1effc9$export$4983792d11b61017 extends (0, $8yAAg.KeyframeResolver) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $8Xq7t.isCSSVariableToken)(keyframe)) {
                    const resolved = (0, $7LaYD.getVariableValue)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $7t8KU.positionalKeys).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $2g4Ln.findDimensionValueType)(origin);
        const targetType = (0, $2g4Ln.findDimensionValueType)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $bCqhd.isNumOrPxType)(originType) && (0, $bCqhd.isNumOrPxType)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $iKkfC.isNone)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $hcsuo.makeNoneKeyframesAnimatable)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $bCqhd.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $bCqhd.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}

});
parcelRegister("iKkfC", function(module, exports) {

$parcel$export(module.exports, "isNone", function () { return $5f440e839d087162$export$e56af863d5645d5f; });

var $6GiZZ = parcelRequire("6GiZZ");
function $5f440e839d087162$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $6GiZZ.isZeroValueString)(value);
    else return true;
}

});
parcelRegister("6GiZZ", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", function () { return $f1c73865932b8c07$export$ade84c85e44a6cb1; });
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $f1c73865932b8c07$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);

});


parcelRegister("hcsuo", function(module, exports) {

$parcel$export(module.exports, "makeNoneKeyframesAnimatable", function () { return $94a60a238f72e9f5$export$8cc4958f8e540f37; });

var $btAzw = parcelRequire("btAzw");

var $cmmYl = parcelRequire("cmmYl");
/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $94a60a238f72e9f5$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $94a60a238f72e9f5$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$94a60a238f72e9f5$var$invalidTemplates.has(keyframe) && (0, $btAzw.analyseComplexValue)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $cmmYl.getAnimatableNone)(name, animatableTemplate);
}

});
parcelRegister("btAzw", function(module, exports) {

$parcel$export(module.exports, "analyseComplexValue", function () { return $56aca5a4ebce3976$export$b61fc7c44bf646d5; });
$parcel$export(module.exports, "complex", function () { return $56aca5a4ebce3976$export$83a0e34f1302825b; });

var $lQsem = parcelRequire("lQsem");

var $h4DlK = parcelRequire("h4DlK");

var $1K39z = parcelRequire("1K39z");

var $5mDUu = parcelRequire("5mDUu");
function $56aca5a4ebce3976$var$test(v) {
    var _a, _b;
    return isNaN(v) && typeof v === "string" && (((_a = v.match((0, $1K39z.floatRegex))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $h4DlK.colorRegex))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $56aca5a4ebce3976$var$NUMBER_TOKEN = "number";
const $56aca5a4ebce3976$var$COLOR_TOKEN = "color";
const $56aca5a4ebce3976$var$VAR_TOKEN = "var";
const $56aca5a4ebce3976$var$VAR_FUNCTION_TOKEN = "var(";
const $56aca5a4ebce3976$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $56aca5a4ebce3976$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $56aca5a4ebce3976$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($56aca5a4ebce3976$var$complexRegex, (parsedValue)=>{
        if ((0, $lQsem.color).test(parsedValue)) {
            indexes.color.push(i);
            types.push($56aca5a4ebce3976$var$COLOR_TOKEN);
            values.push((0, $lQsem.color).parse(parsedValue));
        } else if (parsedValue.startsWith($56aca5a4ebce3976$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($56aca5a4ebce3976$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($56aca5a4ebce3976$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $56aca5a4ebce3976$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($56aca5a4ebce3976$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $56aca5a4ebce3976$var$parseComplexValue(v) {
    return $56aca5a4ebce3976$export$b61fc7c44bf646d5(v).values;
}
function $56aca5a4ebce3976$var$createTransformer(source) {
    const { split: split, types: types } = $56aca5a4ebce3976$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $56aca5a4ebce3976$var$NUMBER_TOKEN) output += (0, $5mDUu.sanitize)(v[i]);
                else if (type === $56aca5a4ebce3976$var$COLOR_TOKEN) output += (0, $lQsem.color).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $56aca5a4ebce3976$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $56aca5a4ebce3976$var$getAnimatableNone(v) {
    const parsed = $56aca5a4ebce3976$var$parseComplexValue(v);
    const transformer = $56aca5a4ebce3976$var$createTransformer(v);
    return transformer(parsed.map($56aca5a4ebce3976$var$convertNumbersToZero));
}
const $56aca5a4ebce3976$export$83a0e34f1302825b = {
    test: $56aca5a4ebce3976$var$test,
    parse: $56aca5a4ebce3976$var$parseComplexValue,
    createTransformer: $56aca5a4ebce3976$var$createTransformer,
    getAnimatableNone: $56aca5a4ebce3976$var$getAnimatableNone
};

});
parcelRegister("lQsem", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $c751293d75f29209$export$35e9368ef982300f; });

var $hrCF0 = parcelRequire("hrCF0");

var $7faqX = parcelRequire("7faqX");

var $2G6DT = parcelRequire("2G6DT");
const $c751293d75f29209$export$35e9368ef982300f = {
    test: (v)=>(0, $2G6DT.rgba).test(v) || (0, $hrCF0.hex).test(v) || (0, $7faqX.hsla).test(v),
    parse: (v)=>{
        if ((0, $2G6DT.rgba).test(v)) return (0, $2G6DT.rgba).parse(v);
        else if ((0, $7faqX.hsla).test(v)) return (0, $7faqX.hsla).parse(v);
        else return (0, $hrCF0.hex).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $2G6DT.rgba).transform(v) : (0, $7faqX.hsla).transform(v);
    }
};

});
parcelRegister("hrCF0", function(module, exports) {

$parcel$export(module.exports, "hex", function () { return $6f3ab03499f418e5$export$834dfc94dde4b3d8; });

var $2G6DT = parcelRequire("2G6DT");

var $eQUtL = parcelRequire("eQUtL");
function $6f3ab03499f418e5$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $6f3ab03499f418e5$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $eQUtL.isColorString)("#"),
    parse: $6f3ab03499f418e5$var$parseHex,
    transform: (0, $2G6DT.rgba).transform
};

});
parcelRegister("2G6DT", function(module, exports) {

$parcel$export(module.exports, "rgba", function () { return $6b9a89fed46bd5b8$export$4e46ac54fc82cf3b; });

var $5Qfax = parcelRequire("5Qfax");

var $iM1hj = parcelRequire("iM1hj");

var $5mDUu = parcelRequire("5mDUu");

var $eQUtL = parcelRequire("eQUtL");
const $6b9a89fed46bd5b8$var$clampRgbUnit = (v)=>(0, $5Qfax.clamp)(0, 255, v);
const $6b9a89fed46bd5b8$export$7a99c86b5b1f4c9e = {
    ...(0, $iM1hj.number),
    transform: (v)=>Math.round($6b9a89fed46bd5b8$var$clampRgbUnit(v))
};
const $6b9a89fed46bd5b8$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $eQUtL.isColorString)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $eQUtL.splitColor)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $6b9a89fed46bd5b8$export$7a99c86b5b1f4c9e.transform(red) + ", " + $6b9a89fed46bd5b8$export$7a99c86b5b1f4c9e.transform(green) + ", " + $6b9a89fed46bd5b8$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $5mDUu.sanitize)((0, $iM1hj.alpha).transform(alpha$1)) + ")"
};

});
parcelRegister("5Qfax", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $362cd9e0fc75e062$export$7d15b64cf5a3a4c4; });
const $362cd9e0fc75e062$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

});

parcelRegister("iM1hj", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $52f40fb7e7508ed2$export$98e628dec113755e; });
$parcel$export(module.exports, "alpha", function () { return $52f40fb7e7508ed2$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "scale", function () { return $52f40fb7e7508ed2$export$dcdf75081b88279d; });

var $5Qfax = parcelRequire("5Qfax");
const $52f40fb7e7508ed2$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $52f40fb7e7508ed2$export$58f0f39f63f3cf42 = {
    ...$52f40fb7e7508ed2$export$98e628dec113755e,
    transform: (v)=>(0, $5Qfax.clamp)(0, 1, v)
};
const $52f40fb7e7508ed2$export$dcdf75081b88279d = {
    ...$52f40fb7e7508ed2$export$98e628dec113755e,
    default: 1
};

});

parcelRegister("5mDUu", function(module, exports) {

$parcel$export(module.exports, "sanitize", function () { return $331fd53a8aa63d7d$export$83d2e9e3e4ee39ed; });
// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $331fd53a8aa63d7d$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;

});

parcelRegister("eQUtL", function(module, exports) {

$parcel$export(module.exports, "isColorString", function () { return $2d0d8dca88c12694$export$2c8400d58aca05e; });
$parcel$export(module.exports, "splitColor", function () { return $2d0d8dca88c12694$export$73d6f35be992df24; });

var $1K39z = parcelRequire("1K39z");

var $hzSWP = parcelRequire("hzSWP");

var $dm1rX = parcelRequire("dm1rX");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $2d0d8dca88c12694$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $dm1rX.singleColorRegex).test(v) && v.startsWith(type) || testProp && !(0, $hzSWP.isNullish)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $2d0d8dca88c12694$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $1K39z.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

});
parcelRegister("1K39z", function(module, exports) {

$parcel$export(module.exports, "floatRegex", function () { return $665d6faf08cf6a67$export$2444ca58c08448e4; });
const $665d6faf08cf6a67$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;

});

parcelRegister("hzSWP", function(module, exports) {

$parcel$export(module.exports, "isNullish", function () { return $9807e960499a3d49$export$b931b78cbb3caf86; });
function $9807e960499a3d49$export$b931b78cbb3caf86(v) {
    return v == null;
}

});

parcelRegister("dm1rX", function(module, exports) {

$parcel$export(module.exports, "singleColorRegex", function () { return $f3001d1eee7fd4e4$export$ed808ff6ecd39e8d; });
const $f3001d1eee7fd4e4$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;

});




parcelRegister("7faqX", function(module, exports) {

$parcel$export(module.exports, "hsla", function () { return $fa857ced8a68c34a$export$810b04175080204c; });

var $iM1hj = parcelRequire("iM1hj");

var $ltGqL = parcelRequire("ltGqL");

var $5mDUu = parcelRequire("5mDUu");

var $eQUtL = parcelRequire("eQUtL");
const $fa857ced8a68c34a$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $eQUtL.isColorString)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $eQUtL.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $ltGqL.percent).transform((0, $5mDUu.sanitize)(saturation)) + ", " + (0, $ltGqL.percent).transform((0, $5mDUu.sanitize)(lightness)) + ", " + (0, $5mDUu.sanitize)((0, $iM1hj.alpha).transform(alpha$1)) + ")";
    }
};

});
parcelRegister("ltGqL", function(module, exports) {

$parcel$export(module.exports, "degrees", function () { return $ff0ac0cce254455b$export$41fc368e1a942b97; });
$parcel$export(module.exports, "percent", function () { return $ff0ac0cce254455b$export$626336c2cd4b14de; });
$parcel$export(module.exports, "px", function () { return $ff0ac0cce254455b$export$91c0eda1d06bf008; });
$parcel$export(module.exports, "vh", function () { return $ff0ac0cce254455b$export$f91e8c45a95a32f2; });
$parcel$export(module.exports, "vw", function () { return $ff0ac0cce254455b$export$aed3d7b7d206c196; });
$parcel$export(module.exports, "progressPercentage", function () { return $ff0ac0cce254455b$export$44e2e1705876d7ed; });
const $ff0ac0cce254455b$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $ff0ac0cce254455b$export$41fc368e1a942b97 = /*@__PURE__*/ $ff0ac0cce254455b$var$createUnitType("deg");
const $ff0ac0cce254455b$export$626336c2cd4b14de = /*@__PURE__*/ $ff0ac0cce254455b$var$createUnitType("%");
const $ff0ac0cce254455b$export$91c0eda1d06bf008 = /*@__PURE__*/ $ff0ac0cce254455b$var$createUnitType("px");
const $ff0ac0cce254455b$export$f91e8c45a95a32f2 = /*@__PURE__*/ $ff0ac0cce254455b$var$createUnitType("vh");
const $ff0ac0cce254455b$export$aed3d7b7d206c196 = /*@__PURE__*/ $ff0ac0cce254455b$var$createUnitType("vw");
const $ff0ac0cce254455b$export$44e2e1705876d7ed = {
    ...$ff0ac0cce254455b$export$626336c2cd4b14de,
    parse: (v)=>$ff0ac0cce254455b$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$ff0ac0cce254455b$export$626336c2cd4b14de.transform(v * 100)
};

});



parcelRegister("h4DlK", function(module, exports) {

$parcel$export(module.exports, "colorRegex", function () { return $4ae84fc987e06570$export$740b69c5fad25dba; });
const $4ae84fc987e06570$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;

});


parcelRegister("cmmYl", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", function () { return $7d9b45ae9f2aa606$export$cea0cedcb94873b5; });

var $btAzw = parcelRequire("btAzw");

var $bxJpI = parcelRequire("bxJpI");

var $PoyTG = parcelRequire("PoyTG");
function $7d9b45ae9f2aa606$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $PoyTG.getDefaultValueType)(key);
    if (defaultValueType !== (0, $bxJpI.filter)) defaultValueType = (0, $btAzw.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

});
parcelRegister("bxJpI", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $c05313358969d235$export$3dea766d36a8935f; });

var $btAzw = parcelRequire("btAzw");

var $1K39z = parcelRequire("1K39z");
/**
 * Properties that should default to 1 or 100%
 */ const $c05313358969d235$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $c05313358969d235$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $1K39z.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $c05313358969d235$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $c05313358969d235$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $c05313358969d235$export$3dea766d36a8935f = {
    ...(0, $btAzw.complex),
    getAnimatableNone: (v)=>{
        const functions = v.match($c05313358969d235$var$functionRegex);
        return functions ? functions.map($c05313358969d235$var$applyDefaultFilter).join(" ") : v;
    }
};

});

parcelRegister("PoyTG", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", function () { return $3b266737c01b9c19$export$67d1babe0338d23b; });

var $lQsem = parcelRequire("lQsem");

var $bxJpI = parcelRequire("bxJpI");

var $hhnjp = parcelRequire("hhnjp");
/**
 * A map of default value types for common values
 */ const $3b266737c01b9c19$export$98cd7c72c5a731fb = {
    ...(0, $hhnjp.numberValueTypes),
    color: // Color props
    $lQsem.color,
    backgroundColor: (0, $lQsem.color),
    outlineColor: (0, $lQsem.color),
    fill: (0, $lQsem.color),
    stroke: (0, $lQsem.color),
    // Border props
    borderColor: (0, $lQsem.color),
    borderTopColor: (0, $lQsem.color),
    borderRightColor: (0, $lQsem.color),
    borderBottomColor: (0, $lQsem.color),
    borderLeftColor: (0, $lQsem.color),
    filter: $bxJpI.filter,
    WebkitFilter: (0, $bxJpI.filter)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $3b266737c01b9c19$export$67d1babe0338d23b = (key)=>$3b266737c01b9c19$export$98cd7c72c5a731fb[key];

});
parcelRegister("hhnjp", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", function () { return $6f2dc8c6c9785a5d$export$eec14432cd1cb67b; });

var $iM1hj = parcelRequire("iM1hj");

var $ltGqL = parcelRequire("ltGqL");

var $lXYSV = parcelRequire("lXYSV");

var $gNYYx = parcelRequire("gNYYx");

var $aByol = parcelRequire("aByol");
const $6f2dc8c6c9785a5d$export$eec14432cd1cb67b = {
    ...(0, $lXYSV.browserNumberValueTypes),
    ...(0, $gNYYx.transformValueTypes),
    zIndex: (0, $aByol.int),
    size: (0, $ltGqL.px),
    // SVG
    fillOpacity: (0, $iM1hj.alpha),
    strokeOpacity: (0, $iM1hj.alpha),
    numOctaves: (0, $aByol.int)
};

});
parcelRegister("lXYSV", function(module, exports) {

$parcel$export(module.exports, "browserNumberValueTypes", function () { return $e8ef68e2ef797a81$export$2fb74b0a4e7d7c4a; });

var $ltGqL = parcelRequire("ltGqL");
const $e8ef68e2ef797a81$export$2fb74b0a4e7d7c4a = {
    // Border props
    borderWidth: (0, $ltGqL.px),
    borderTopWidth: (0, $ltGqL.px),
    borderRightWidth: (0, $ltGqL.px),
    borderBottomWidth: (0, $ltGqL.px),
    borderLeftWidth: (0, $ltGqL.px),
    borderRadius: (0, $ltGqL.px),
    radius: (0, $ltGqL.px),
    borderTopLeftRadius: (0, $ltGqL.px),
    borderTopRightRadius: (0, $ltGqL.px),
    borderBottomRightRadius: (0, $ltGqL.px),
    borderBottomLeftRadius: (0, $ltGqL.px),
    // Positioning props
    width: (0, $ltGqL.px),
    maxWidth: (0, $ltGqL.px),
    height: (0, $ltGqL.px),
    maxHeight: (0, $ltGqL.px),
    top: (0, $ltGqL.px),
    right: (0, $ltGqL.px),
    bottom: (0, $ltGqL.px),
    left: (0, $ltGqL.px),
    // Spacing props
    padding: (0, $ltGqL.px),
    paddingTop: (0, $ltGqL.px),
    paddingRight: (0, $ltGqL.px),
    paddingBottom: (0, $ltGqL.px),
    paddingLeft: (0, $ltGqL.px),
    margin: (0, $ltGqL.px),
    marginTop: (0, $ltGqL.px),
    marginRight: (0, $ltGqL.px),
    marginBottom: (0, $ltGqL.px),
    marginLeft: (0, $ltGqL.px),
    // Misc
    backgroundPositionX: (0, $ltGqL.px),
    backgroundPositionY: (0, $ltGqL.px)
};

});

parcelRegister("gNYYx", function(module, exports) {

$parcel$export(module.exports, "transformValueTypes", function () { return $0f4b4779e726004d$export$f2e4285fee37e26; });

var $iM1hj = parcelRequire("iM1hj");

var $ltGqL = parcelRequire("ltGqL");
const $0f4b4779e726004d$export$f2e4285fee37e26 = {
    rotate: (0, $ltGqL.degrees),
    rotateX: (0, $ltGqL.degrees),
    rotateY: (0, $ltGqL.degrees),
    rotateZ: (0, $ltGqL.degrees),
    scale: $iM1hj.scale,
    scaleX: (0, $iM1hj.scale),
    scaleY: (0, $iM1hj.scale),
    scaleZ: (0, $iM1hj.scale),
    skew: (0, $ltGqL.degrees),
    skewX: (0, $ltGqL.degrees),
    skewY: (0, $ltGqL.degrees),
    distance: (0, $ltGqL.px),
    translateX: (0, $ltGqL.px),
    translateY: (0, $ltGqL.px),
    translateZ: (0, $ltGqL.px),
    x: (0, $ltGqL.px),
    y: (0, $ltGqL.px),
    z: (0, $ltGqL.px),
    perspective: (0, $ltGqL.px),
    transformPerspective: (0, $ltGqL.px),
    opacity: (0, $iM1hj.alpha),
    originX: (0, $ltGqL.progressPercentage),
    originY: (0, $ltGqL.progressPercentage),
    originZ: (0, $ltGqL.px)
};

});

parcelRegister("aByol", function(module, exports) {

$parcel$export(module.exports, "int", function () { return $686376bc6f162787$export$7d260a2a5f8bc19e; });

var $iM1hj = parcelRequire("iM1hj");
const $686376bc6f162787$export$7d260a2a5f8bc19e = {
    ...(0, $iM1hj.number),
    transform: Math.round
};

});





parcelRegister("8yAAg", function(module, exports) {

$parcel$export(module.exports, "flushKeyframeResolvers", function () { return $ed6cbfb97bca2dc5$export$78b96d2a12593b05; });
$parcel$export(module.exports, "KeyframeResolver", function () { return $ed6cbfb97bca2dc5$export$74d34ca3182f1750; });

var $bCqhd = parcelRequire("bCqhd");

var $26AI3 = parcelRequire("26AI3");
const $ed6cbfb97bca2dc5$var$toResolve = new Set();
let $ed6cbfb97bca2dc5$var$isScheduled = false;
let $ed6cbfb97bca2dc5$var$anyNeedsMeasurement = false;
function $ed6cbfb97bca2dc5$var$measureAllKeyframes() {
    if ($ed6cbfb97bca2dc5$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($ed6cbfb97bca2dc5$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $bCqhd.removeNonTranslationalTransform)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $ed6cbfb97bca2dc5$var$anyNeedsMeasurement = false;
    $ed6cbfb97bca2dc5$var$isScheduled = false;
    $ed6cbfb97bca2dc5$var$toResolve.forEach((resolver)=>resolver.complete());
    $ed6cbfb97bca2dc5$var$toResolve.clear();
}
function $ed6cbfb97bca2dc5$var$readAllKeyframes() {
    $ed6cbfb97bca2dc5$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $ed6cbfb97bca2dc5$var$anyNeedsMeasurement = true;
    });
}
function $ed6cbfb97bca2dc5$export$78b96d2a12593b05() {
    $ed6cbfb97bca2dc5$var$readAllKeyframes();
    $ed6cbfb97bca2dc5$var$measureAllKeyframes();
}
class $ed6cbfb97bca2dc5$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $ed6cbfb97bca2dc5$var$toResolve.add(this);
            if (!$ed6cbfb97bca2dc5$var$isScheduled) {
                $ed6cbfb97bca2dc5$var$isScheduled = true;
                (0, $26AI3.frame).read($ed6cbfb97bca2dc5$var$readAllKeyframes);
                (0, $26AI3.frame).resolveKeyframes($ed6cbfb97bca2dc5$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $ed6cbfb97bca2dc5$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $ed6cbfb97bca2dc5$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}

});
parcelRegister("bCqhd", function(module, exports) {

$parcel$export(module.exports, "isNumOrPxType", function () { return $86b67e988c48fa09$export$8e5250d1aa9bf370; });
$parcel$export(module.exports, "removeNonTranslationalTransform", function () { return $86b67e988c48fa09$export$39d4bc9655f3f632; });
$parcel$export(module.exports, "positionalValues", function () { return $86b67e988c48fa09$export$781d46a8aa670d52; });

var $iM1hj = parcelRequire("iM1hj");

var $ltGqL = parcelRequire("ltGqL");

var $301nj = parcelRequire("301nj");
const $86b67e988c48fa09$export$8e5250d1aa9bf370 = (v)=>v === (0, $iM1hj.number) || v === (0, $ltGqL.px);
const $86b67e988c48fa09$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $86b67e988c48fa09$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $86b67e988c48fa09$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $86b67e988c48fa09$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $86b67e988c48fa09$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $86b67e988c48fa09$var$nonTranslationalTransformKeys = (0, $301nj.transformPropOrder).filter((key)=>!$86b67e988c48fa09$var$transformKeys.has(key));
function $86b67e988c48fa09$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $86b67e988c48fa09$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $86b67e988c48fa09$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $86b67e988c48fa09$var$getTranslateFromMatrix(4, 13),
    y: $86b67e988c48fa09$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$86b67e988c48fa09$export$781d46a8aa670d52.translateX = $86b67e988c48fa09$export$781d46a8aa670d52.x;
$86b67e988c48fa09$export$781d46a8aa670d52.translateY = $86b67e988c48fa09$export$781d46a8aa670d52.y;

});


parcelRegister("7LaYD", function(module, exports) {

$parcel$export(module.exports, "getVariableValue", function () { return $dcf2cdc18ba78db5$export$289398774300c991; });

var $k1o29 = parcelRequire("k1o29");

var $kqx13 = parcelRequire("kqx13");

var $8Xq7t = parcelRequire("8Xq7t");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $dcf2cdc18ba78db5$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $dcf2cdc18ba78db5$export$b9f0c1f373aee2b0(current) {
    const match = $dcf2cdc18ba78db5$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $dcf2cdc18ba78db5$var$maxDepth = 4;
function $dcf2cdc18ba78db5$export$289398774300c991(current, element, depth = 1) {
    (0, $k1o29.invariant)(depth <= $dcf2cdc18ba78db5$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $dcf2cdc18ba78db5$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $kqx13.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $8Xq7t.isCSSVariableToken)(fallback) ? $dcf2cdc18ba78db5$export$289398774300c991(fallback, element, depth + 1) : fallback;
}

});
parcelRegister("k1o29", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $6452fb21158a1e15$export$491112666e282270; });
$parcel$export(module.exports, "invariant", function () { return $6452fb21158a1e15$export$f5708dca728d7177; });

var $i0SNZ = parcelRequire("i0SNZ");
let $6452fb21158a1e15$export$491112666e282270 = (0, $i0SNZ.noop);
let $6452fb21158a1e15$export$f5708dca728d7177 = (0, $i0SNZ.noop);
var $6452fb21158a1e15$var$check, $6452fb21158a1e15$var$message, $6452fb21158a1e15$var$check1, $6452fb21158a1e15$var$message1;

});

parcelRegister("kqx13", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", function () { return $f1f45f4cd122868e$export$65583ed5a868f2d9; });
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $f1f45f4cd122868e$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

});

parcelRegister("8Xq7t", function(module, exports) {

$parcel$export(module.exports, "isCSSVariableName", function () { return $aca2eeb8f3b6c859$export$9de1236619d9e756; });
$parcel$export(module.exports, "isCSSVariableToken", function () { return $aca2eeb8f3b6c859$export$31f9caa2600b5723; });
const $aca2eeb8f3b6c859$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $aca2eeb8f3b6c859$export$9de1236619d9e756 = /*@__PURE__*/ $aca2eeb8f3b6c859$var$checkStringStartsWith("--");
const $aca2eeb8f3b6c859$var$startsAsVariableToken = /*@__PURE__*/ $aca2eeb8f3b6c859$var$checkStringStartsWith("var(--");
const $aca2eeb8f3b6c859$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $aca2eeb8f3b6c859$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $aca2eeb8f3b6c859$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $aca2eeb8f3b6c859$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

});


parcelRegister("2g4Ln", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", function () { return $5adefda27cefe8ff$export$d176691c1998a1f5; });
$parcel$export(module.exports, "findDimensionValueType", function () { return $5adefda27cefe8ff$export$eefdd52e3ccae428; });

var $iM1hj = parcelRequire("iM1hj");

var $ltGqL = parcelRequire("ltGqL");

var $4fktA = parcelRequire("4fktA");

var $dODwC = parcelRequire("dODwC");
/**
 * A list of value types commonly used for dimensions
 */ const $5adefda27cefe8ff$export$d176691c1998a1f5 = [
    (0, $iM1hj.number),
    (0, $ltGqL.px),
    (0, $ltGqL.percent),
    (0, $ltGqL.degrees),
    (0, $ltGqL.vw),
    (0, $ltGqL.vh),
    (0, $dODwC.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $5adefda27cefe8ff$export$eefdd52e3ccae428 = (v)=>$5adefda27cefe8ff$export$d176691c1998a1f5.find((0, $4fktA.testValueType)(v));

});
parcelRegister("4fktA", function(module, exports) {

$parcel$export(module.exports, "testValueType", function () { return $9aa06b0bc5203167$export$6eae4d0a6a7ca7cd; });
/**
 * Tests a provided value against a ValueType
 */ const $9aa06b0bc5203167$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);

});

parcelRegister("dODwC", function(module, exports) {

$parcel$export(module.exports, "auto", function () { return $53fcfc1129b29f76$export$dfb5619354ba860; });
/**
 * ValueType for "auto"
 */ const $53fcfc1129b29f76$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};

});



parcelRegister("7wmH9", function(module, exports) {

$parcel$export(module.exports, "BaseAnimation", function () { return $eaa9140e6ca7e147$export$d1e4f34b9c2550c1; });

var $es6mb = parcelRequire("es6mb");

var $8yAAg = parcelRequire("8yAAg");

var $fN1OV = parcelRequire("fN1OV");

var $Vs41j = parcelRequire("Vs41j");

var $2djcq = parcelRequire("2djcq");
/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $eaa9140e6ca7e147$var$MAX_RESOLVE_DELAY = 40;
class $eaa9140e6ca7e147$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, $es6mb.time).now();
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > $eaa9140e6ca7e147$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $8yAAg.flushKeyframeResolvers)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, $es6mb.time).now();
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $Vs41j.canAnimate)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $fN1OV.instantAnimationState).current || !delay) {
                onUpdate && onUpdate((0, $2djcq.getFinalKeyframe)(keyframes, this.options, finalKeyframe));
                onComplete && onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    flatten() {
        this.options.type = "keyframes";
        this.options.ease = "linear";
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}

});
parcelRegister("Vs41j", function(module, exports) {

$parcel$export(module.exports, "canAnimate", function () { return $01d32c0d50b1e637$export$1b109e6c9968df4f; });

var $k1o29 = parcelRequire("k1o29");

var $azOhQ = parcelRequire("azOhQ");

var $hDeGh = parcelRequire("hDeGh");
function $01d32c0d50b1e637$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $01d32c0d50b1e637$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $hDeGh.isAnimatable)(originKeyframe, name);
    const isTargetAnimatable = (0, $hDeGh.isAnimatable)(targetKeyframe, name);
    (0, $k1o29.warning)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $01d32c0d50b1e637$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $azOhQ.isGenerator)(type)) && velocity;
}

});
parcelRegister("hDeGh", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", function () { return $f0377d23d3bcfdb4$export$65676b58b122bc38; });

var $btAzw = parcelRequire("btAzw");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $f0377d23d3bcfdb4$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $btAzw.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});


parcelRegister("2djcq", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", function () { return $66173ac85b575cac$export$14de59408fad90b; });
const $66173ac85b575cac$var$isNotNull = (value)=>value !== null;
function $66173ac85b575cac$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($66173ac85b575cac$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

});


parcelRegister("kaADW", function(module, exports) {

$parcel$export(module.exports, "MainThreadAnimation", function () { return $4cb1c530b9c8b273$export$fd98d9cca67a58bc; });


var $krTAM = parcelRequire("krTAM");

var $9KQrz = parcelRequire("9KQrz");

var $azOhQ = parcelRequire("azOhQ");

var $8yAAg = parcelRequire("8yAAg");

var $5Qfax = parcelRequire("5Qfax");

var $hlH1P = parcelRequire("hlH1P");

var $jRjAc = parcelRequire("jRjAc");

var $atzVK = parcelRequire("atzVK");

var $7TfiH = parcelRequire("7TfiH");

var $kgh4p = parcelRequire("kgh4p");

var $7wmH9 = parcelRequire("7wmH9");

var $cQkPm = parcelRequire("cQkPm");

var $2djcq = parcelRequire("2djcq");
const $4cb1c530b9c8b273$var$generators = {
    decay: (0, $atzVK.inertia),
    inertia: $atzVK.inertia,
    tween: (0, $7TfiH.keyframes),
    keyframes: (0, $7TfiH.keyframes),
    spring: $kgh4p.spring
};
const $4cb1c530b9c8b273$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $4cb1c530b9c8b273$export$fd98d9cca67a58bc extends (0, $7wmH9.BaseAnimation) {
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $8yAAg.KeyframeResolver);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    flatten() {
        super.flatten();
        // If we've already resolved the animation, re-initialise it
        if (this._resolved) Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = (0, $azOhQ.isGenerator)(type) ? type : $4cb1c530b9c8b273$var$generators[type] || (0, $7TfiH.keyframes);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $7TfiH.keyframes) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $jRjAc.pipe)($4cb1c530b9c8b273$var$percentToProgress, (0, $hlH1P.mix)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $9KQrz.calcGeneratorDuration)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $5Qfax.clamp)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $2djcq.getFinalKeyframe)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $krTAM.millisecondsToSeconds)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $krTAM.millisecondsToSeconds)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $krTAM.secondsToMilliseconds)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $krTAM.millisecondsToSeconds)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $cQkPm.frameloopDriver), onPlay: onPlay, startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $4cb1c530b9c8b273$export$ee9b76de7353d815(options) {
    return new $4cb1c530b9c8b273$export$fd98d9cca67a58bc(options);
}

});
parcelRegister("9KQrz", function(module, exports) {

$parcel$export(module.exports, "maxGeneratorDuration", function () { return $8ba01a8aef5eba5d$export$f4ff70a5b4808fd8; });
$parcel$export(module.exports, "calcGeneratorDuration", function () { return $8ba01a8aef5eba5d$export$cbdd6b3d40ea54e2; });
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $8ba01a8aef5eba5d$export$f4ff70a5b4808fd8 = 20000;
function $8ba01a8aef5eba5d$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $8ba01a8aef5eba5d$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $8ba01a8aef5eba5d$export$f4ff70a5b4808fd8 ? Infinity : duration;
}

});

parcelRegister("hlH1P", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $85652a0f64c2c134$export$2c9e8a9632a706b2; });

var $hAJ1Y = parcelRequire("hAJ1Y");

var $7uAm4 = parcelRequire("7uAm4");
function $85652a0f64c2c134$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $7uAm4.mixNumber)(from, to, p);
    const mixer = (0, $hAJ1Y.getMixer)(from);
    return mixer(from, to);
}

});
parcelRegister("hAJ1Y", function(module, exports) {

$parcel$export(module.exports, "getMixer", function () { return $0e9352948c6c8506$export$36ec24672cd098e0; });

var $7uAm4 = parcelRequire("7uAm4");

var $8VsCu = parcelRequire("8VsCu");

var $jRjAc = parcelRequire("jRjAc");

var $k1o29 = parcelRequire("k1o29");

var $lQsem = parcelRequire("lQsem");

var $btAzw = parcelRequire("btAzw");

var $8Xq7t = parcelRequire("8Xq7t");

var $1vy2e = parcelRequire("1vy2e");

var $7xWse = parcelRequire("7xWse");
function $0e9352948c6c8506$var$mixNumber(a, b) {
    return (p)=>(0, $7uAm4.mixNumber)(a, b, p);
}
function $0e9352948c6c8506$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $0e9352948c6c8506$var$mixNumber;
    else if (typeof a === "string") return (0, $8Xq7t.isCSSVariableToken)(a) ? (0, $7xWse.mixImmediate) : (0, $lQsem.color).test(a) ? (0, $8VsCu.mixColor) : $0e9352948c6c8506$export$65516310a87d8205;
    else if (Array.isArray(a)) return $0e9352948c6c8506$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $lQsem.color).test(a) ? (0, $8VsCu.mixColor) : $0e9352948c6c8506$export$ebc23b6840c51ba1;
    return 0, $7xWse.mixImmediate;
}
function $0e9352948c6c8506$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$0e9352948c6c8506$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $0e9352948c6c8506$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $0e9352948c6c8506$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $0e9352948c6c8506$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $0e9352948c6c8506$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $btAzw.complex).createTransformer(target);
    const originStats = (0, $btAzw.analyseComplexValue)(origin);
    const targetStats = (0, $btAzw.analyseComplexValue)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $1vy2e.invisibleValues).has(origin) && !targetStats.values.length || (0, $1vy2e.invisibleValues).has(target) && !originStats.values.length) return (0, $1vy2e.mixVisibility)(origin, target);
        return (0, $jRjAc.pipe)($0e9352948c6c8506$export$3bbefa2f402845c4($0e9352948c6c8506$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $k1o29.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $7xWse.mixImmediate)(origin, target);
    }
};

});
parcelRegister("7uAm4", function(module, exports) {

$parcel$export(module.exports, "mixNumber", function () { return $858e31c528b77e2f$export$3bb0b4ff1037b8dd; });
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $858e31c528b77e2f$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};

});

parcelRegister("8VsCu", function(module, exports) {

$parcel$export(module.exports, "mixColor", function () { return $4bdf9f61c3656fdd$export$51e568cf5c039bac; });

var $7uAm4 = parcelRequire("7uAm4");

var $k1o29 = parcelRequire("k1o29");

var $Pnm7u = parcelRequire("Pnm7u");

var $hrCF0 = parcelRequire("hrCF0");

var $2G6DT = parcelRequire("2G6DT");

var $7faqX = parcelRequire("7faqX");

var $7xWse = parcelRequire("7xWse");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $4bdf9f61c3656fdd$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $4bdf9f61c3656fdd$var$colorTypes = [
    (0, $hrCF0.hex),
    (0, $2G6DT.rgba),
    (0, $7faqX.hsla)
];
const $4bdf9f61c3656fdd$var$getColorType = (v)=>$4bdf9f61c3656fdd$var$colorTypes.find((type)=>type.test(v));
function $4bdf9f61c3656fdd$var$asRGBA(color) {
    const type = $4bdf9f61c3656fdd$var$getColorType(color);
    (0, $k1o29.warning)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $7faqX.hsla)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $Pnm7u.hslaToRgba)(model);
    return model;
}
const $4bdf9f61c3656fdd$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $4bdf9f61c3656fdd$var$asRGBA(from);
    const toRGBA = $4bdf9f61c3656fdd$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $7xWse.mixImmediate)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $4bdf9f61c3656fdd$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $4bdf9f61c3656fdd$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $4bdf9f61c3656fdd$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $7uAm4.mixNumber)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $2G6DT.rgba).transform(blended);
    };
};

});
parcelRegister("Pnm7u", function(module, exports) {

$parcel$export(module.exports, "hslaToRgba", function () { return $15d1055a0296083f$export$6ae64dbcd6bfc33e; });
// Adapted from https://gist.github.com/mjackson/5311256
function $15d1055a0296083f$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $15d1055a0296083f$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $15d1055a0296083f$var$hueToRgb(p, q, hue + 1 / 3);
        green = $15d1055a0296083f$var$hueToRgb(p, q, hue);
        blue = $15d1055a0296083f$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

});

parcelRegister("7xWse", function(module, exports) {

$parcel$export(module.exports, "mixImmediate", function () { return $f34a132c4552c4ae$export$a6f92d4bae65c0f1; });
function $f34a132c4552c4ae$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}

});


parcelRegister("jRjAc", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $b516feddfc3a00a4$export$a4627e546088548d; });
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $b516feddfc3a00a4$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $b516feddfc3a00a4$export$a4627e546088548d = (...transformers)=>transformers.reduce($b516feddfc3a00a4$var$combineFunctions);

});

parcelRegister("1vy2e", function(module, exports) {

$parcel$export(module.exports, "invisibleValues", function () { return $98c400e1762a05e9$export$e5a55ae567dd4ac7; });
$parcel$export(module.exports, "mixVisibility", function () { return $98c400e1762a05e9$export$fed62ccc3fb1a568; });
const $98c400e1762a05e9$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $98c400e1762a05e9$export$fed62ccc3fb1a568(origin, target) {
    if ($98c400e1762a05e9$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}

});



parcelRegister("atzVK", function(module, exports) {

$parcel$export(module.exports, "inertia", function () { return $7b5816545a8a7786$export$ee3ff3a17106998; });

var $kgh4p = parcelRequire("kgh4p");

var $5bxJl = parcelRequire("5bxJl");
function $7b5816545a8a7786$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $kgh4p.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $5bxJl.calcGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

});
parcelRegister("kgh4p", function(module, exports) {

$parcel$export(module.exports, "spring", function () { return $fb8acf5102afbacc$export$b36281d89752ae66; });


var $krTAM = parcelRequire("krTAM");

var $9KQrz = parcelRequire("9KQrz");

var $5Uenq = parcelRequire("5Uenq");

var $5Qfax = parcelRequire("5Qfax");

var $5bxJl = parcelRequire("5bxJl");

var $6MEfv = parcelRequire("6MEfv");

var $1DbQN = parcelRequire("1DbQN");
const $fb8acf5102afbacc$var$durationKeys = [
    "duration",
    "bounce"
];
const $fb8acf5102afbacc$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $fb8acf5102afbacc$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $fb8acf5102afbacc$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $6MEfv.springDefaults).velocity,
        stiffness: (0, $6MEfv.springDefaults).stiffness,
        damping: (0, $6MEfv.springDefaults).damping,
        mass: (0, $6MEfv.springDefaults).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$fb8acf5102afbacc$var$isSpringType(options, $fb8acf5102afbacc$var$physicsKeys) && $fb8acf5102afbacc$var$isSpringType(options, $fb8acf5102afbacc$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $5Qfax.clamp)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $6MEfv.springDefaults).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $1DbQN.findSpring)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $6MEfv.springDefaults).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $fb8acf5102afbacc$export$b36281d89752ae66(optionsOrVisualDuration = (0, $6MEfv.springDefaults).visualDuration, bounce = (0, $6MEfv.springDefaults).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $fb8acf5102afbacc$var$getSpringOptions({
        ...options,
        velocity: -(0, $krTAM.millisecondsToSeconds)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $krTAM.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $6MEfv.springDefaults).restSpeed.granular : (0, $6MEfv.springDefaults).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $6MEfv.springDefaults).restDelta.granular : (0, $6MEfv.springDefaults).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $1DbQN.calcAngularFreq)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $krTAM.secondsToMilliseconds)(initialVelocity) : (0, $5bxJl.calcGeneratorVelocity)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $9KQrz.calcGeneratorDuration)(generator), (0, $9KQrz.maxGeneratorDuration));
            const easing = (0, $5Uenq.generateLinearEasing)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        }
    };
    return generator;
}

});
parcelRegister("5bxJl", function(module, exports) {

$parcel$export(module.exports, "calcGeneratorVelocity", function () { return $379248ac5d1f443b$export$854187271d233eb5; });

var $3p9Mn = parcelRequire("3p9Mn");
const $379248ac5d1f443b$var$velocitySampleDuration = 5; // ms
function $379248ac5d1f443b$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $379248ac5d1f443b$var$velocitySampleDuration, 0);
    return (0, $3p9Mn.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

});

parcelRegister("6MEfv", function(module, exports) {

$parcel$export(module.exports, "springDefaults", function () { return $34d757932af1335a$export$86436497e7b05d16; });
const $34d757932af1335a$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};

});

parcelRegister("1DbQN", function(module, exports) {

$parcel$export(module.exports, "findSpring", function () { return $427358b03c4c37f2$export$b15f158dc6d6f458; });
$parcel$export(module.exports, "calcAngularFreq", function () { return $427358b03c4c37f2$export$5f679887c3a78b15; });

var $k1o29 = parcelRequire("k1o29");

var $krTAM = parcelRequire("krTAM");

var $5Qfax = parcelRequire("5Qfax");

var $6MEfv = parcelRequire("6MEfv");
const $427358b03c4c37f2$var$safeMin = 0.001;
function $427358b03c4c37f2$export$b15f158dc6d6f458({ duration: duration = (0, $6MEfv.springDefaults).duration, bounce: bounce = (0, $6MEfv.springDefaults).bounce, velocity: velocity = (0, $6MEfv.springDefaults).velocity, mass: mass = (0, $6MEfv.springDefaults).mass }) {
    let envelope;
    let derivative;
    (0, $k1o29.warning)(duration <= (0, $krTAM.secondsToMilliseconds)((0, $6MEfv.springDefaults).maxDuration), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $5Qfax.clamp)((0, $6MEfv.springDefaults).minDamping, (0, $6MEfv.springDefaults).maxDamping, dampingRatio);
    duration = (0, $5Qfax.clamp)((0, $6MEfv.springDefaults).minDuration, (0, $6MEfv.springDefaults).maxDuration, (0, $krTAM.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $427358b03c4c37f2$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $427358b03c4c37f2$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $427358b03c4c37f2$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $427358b03c4c37f2$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$427358b03c4c37f2$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $427358b03c4c37f2$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $krTAM.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $6MEfv.springDefaults).stiffness,
        damping: (0, $6MEfv.springDefaults).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $427358b03c4c37f2$var$rootIterations = 12;
function $427358b03c4c37f2$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $427358b03c4c37f2$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $427358b03c4c37f2$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});



parcelRegister("7TfiH", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $fc1dc3d9776b5059$export$d25ddfdf17c3ad3e; });

var $7BCxW = parcelRequire("7BCxW");

var $5zixs = parcelRequire("5zixs");

var $hj8Pr = parcelRequire("hj8Pr");

var $31eCX = parcelRequire("31eCX");

var $er78O = parcelRequire("er78O");

var $cy2Ad = parcelRequire("cy2Ad");
function $fc1dc3d9776b5059$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $7BCxW.easeInOut)).splice(0, values.length - 1);
}
function $fc1dc3d9776b5059$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $5zixs.isEasingArray)(ease) ? ease.map((0, $hj8Pr.easingDefinitionToFunction)) : (0, $hj8Pr.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $cy2Ad.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $er78O.defaultOffset)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $31eCX.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $fc1dc3d9776b5059$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

});
parcelRegister("7BCxW", function(module, exports) {

$parcel$export(module.exports, "easeIn", function () { return $985c4a6f1c1ea5f9$export$929e5a82286172a6; });
$parcel$export(module.exports, "easeOut", function () { return $985c4a6f1c1ea5f9$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeInOut", function () { return $985c4a6f1c1ea5f9$export$c07234257a03d5e9; });

var $huad4 = parcelRequire("huad4");
const $985c4a6f1c1ea5f9$export$929e5a82286172a6 = /*@__PURE__*/ (0, $huad4.cubicBezier)(0.42, 0, 1, 1);
const $985c4a6f1c1ea5f9$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $huad4.cubicBezier)(0, 0, 0.58, 1);
const $985c4a6f1c1ea5f9$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $huad4.cubicBezier)(0.42, 0, 0.58, 1);

});

parcelRegister("5zixs", function(module, exports) {

$parcel$export(module.exports, "isEasingArray", function () { return $616dd61850878eff$export$216948827bbdc797; });
const $616dd61850878eff$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});

parcelRegister("hj8Pr", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", function () { return $510f124e1f2cb870$export$ef97fe084f156ca4; });

var $k1o29 = parcelRequire("k1o29");

var $i0SNZ = parcelRequire("i0SNZ");

var $2uane = parcelRequire("2uane");

var $ipbmL = parcelRequire("ipbmL");

var $9cKFb = parcelRequire("9cKFb");

var $lY29q = parcelRequire("lY29q");

var $huad4 = parcelRequire("huad4");

var $7BCxW = parcelRequire("7BCxW");
const $510f124e1f2cb870$var$easingLookup = {
    linear: (0, $i0SNZ.noop),
    easeIn: $7BCxW.easeIn,
    easeInOut: $7BCxW.easeInOut,
    easeOut: $7BCxW.easeOut,
    circIn: $lY29q.circIn,
    circInOut: $lY29q.circInOut,
    circOut: $lY29q.circOut,
    backIn: $9cKFb.backIn,
    backInOut: $9cKFb.backInOut,
    backOut: $9cKFb.backOut,
    anticipate: $ipbmL.anticipate
};
const $510f124e1f2cb870$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $2uane.isBezierDefinition)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $k1o29.invariant)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $huad4.cubicBezier)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $k1o29.invariant)($510f124e1f2cb870$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $510f124e1f2cb870$var$easingLookup[definition];
    }
    return definition;
};

});

parcelRegister("31eCX", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $0fc0d7fb6cb3cae2$export$89e29e4ab65e70a9; });

var $k1o29 = parcelRequire("k1o29");

var $i0SNZ = parcelRequire("i0SNZ");

var $93BDD = parcelRequire("93BDD");

var $5Qfax = parcelRequire("5Qfax");

var $hlH1P = parcelRequire("hlH1P");

var $jRjAc = parcelRequire("jRjAc");
function $0fc0d7fb6cb3cae2$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $hlH1P.mix);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $i0SNZ.noop) : ease;
            mixer = (0, $jRjAc.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $0fc0d7fb6cb3cae2$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $k1o29.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $0fc0d7fb6cb3cae2$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $93BDD.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $5Qfax.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

});

parcelRegister("er78O", function(module, exports) {

$parcel$export(module.exports, "defaultOffset", function () { return $81a940b5af37a2df$export$24dbcec0b26e6d9d; });

var $kEl7q = parcelRequire("kEl7q");
function $81a940b5af37a2df$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $kEl7q.fillOffset)(offset, arr.length - 1);
    return offset;
}

});
parcelRegister("kEl7q", function(module, exports) {

$parcel$export(module.exports, "fillOffset", function () { return $f64972bb3957713b$export$dafee61230cf05c6; });


var $93BDD = parcelRequire("93BDD");

var $7uAm4 = parcelRequire("7uAm4");
function $f64972bb3957713b$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $93BDD.progress)(0, remaining, i);
        offset.push((0, $7uAm4.mixNumber)(min, 1, offsetProgress));
    }
}

});


parcelRegister("cy2Ad", function(module, exports) {

$parcel$export(module.exports, "convertOffsetToTimes", function () { return $2d4327ab075d202c$export$2a91b4e3a4539316; });
function $2d4327ab075d202c$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}

});


parcelRegister("cQkPm", function(module, exports) {

$parcel$export(module.exports, "frameloopDriver", function () { return $2a8432ac97c1b272$export$c1033964b5ad7fef; });

var $es6mb = parcelRequire("es6mb");

var $26AI3 = parcelRequire("26AI3");
const $2a8432ac97c1b272$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $26AI3.frame).update(passTimestamp, true),
        stop: ()=>(0, $26AI3.cancelFrame)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $26AI3.frameData).isProcessing ? (0, $26AI3.frameData).timestamp : (0, $es6mb.time).now()
    };
};

});


parcelRegister("cRfwW", function(module, exports) {

$parcel$export(module.exports, "acceleratedValues", function () { return $4750b4f340b1c56c$export$a27eefbd8fb5e404; });
/**
 * A list of values that can be hardware-accelerated.
 */ const $4750b4f340b1c56c$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);

});

parcelRegister("5KHPh", function(module, exports) {

$parcel$export(module.exports, "startWaapiAnimation", function () { return $c9bccf3bfe816174$export$d896de52f97cb615; });


var $6aGcL = parcelRequire("6aGcL");
function $c9bccf3bfe816174$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeInOut", times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $6aGcL.mapEasingToNativeEasing)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}

});

parcelRegister("dQsgv", function(module, exports) {

$parcel$export(module.exports, "supportsWaapi", function () { return $fb32467af1ed20a8$export$51ea9b46fb7a8c5d; });


var $2MbO2 = parcelRequire("2MbO2");
const $fb32467af1ed20a8$export$51ea9b46fb7a8c5d = /*@__PURE__*/ (0, $2MbO2.memo)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));

});


parcelRegister("bG443", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", function () { return $ca4a9a2faa901160$export$262124b154b9f1c0; });

var $301nj = parcelRequire("301nj");
const $ca4a9a2faa901160$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $ca4a9a2faa901160$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $ca4a9a2faa901160$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $ca4a9a2faa901160$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $ca4a9a2faa901160$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $ca4a9a2faa901160$var$keyframesTransition;
    else if ((0, $301nj.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? $ca4a9a2faa901160$var$criticallyDampedSpring(keyframes[1]) : $ca4a9a2faa901160$var$underDampedSpring;
    return $ca4a9a2faa901160$var$ease;
};

});

parcelRegister("7MpWV", function(module, exports) {

$parcel$export(module.exports, "isTransitionDefined", function () { return $b803c18f5f0bf746$export$ca8e47dc8ed5a9d7; });
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $b803c18f5f0bf746$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}

});



parcelRegister("b9Wnj", function(module, exports) {

$parcel$export(module.exports, "animateVariant", function () { return $e73e9a7b4f9da30b$export$4709dc300705b2af; });

var $7U3mN = parcelRequire("7U3mN");

var $PbVbJ = parcelRequire("PbVbJ");
function $e73e9a7b4f9da30b$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $7U3mN.resolveVariant)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $PbVbJ.animateTarget)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $e73e9a7b4f9da30b$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $e73e9a7b4f9da30b$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($e73e9a7b4f9da30b$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($e73e9a7b4f9da30b$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $e73e9a7b4f9da30b$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}

});


parcelRegister("fR2RL", function(module, exports) {

$parcel$export(module.exports, "getVariantContext", function () { return $7311f3605a125f92$export$6669f52f7ffa343b; });

var $7upgv = parcelRequire("7upgv");

var $glANL = parcelRequire("glANL");
const $7311f3605a125f92$var$numVariantProps = (0, $glANL.variantProps).length;
function $7311f3605a125f92$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $7311f3605a125f92$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $7311f3605a125f92$var$numVariantProps; i++){
        const name = (0, $glANL.variantProps)[i];
        const prop = visualElement.props[name];
        if ((0, $7upgv.isVariantLabel)(prop) || prop === false) context[name] = prop;
    }
    return context;
}

});


parcelRegister("7Rn9r", function(module, exports) {

$parcel$export(module.exports, "Feature", function () { return $8336c9595b0f3225$export$6e91cf7616333d5; });
class $8336c9595b0f3225$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}

});


parcelRegister("kks1S", function(module, exports) {

$parcel$export(module.exports, "ExitAnimationFeature", function () { return $10460abecab6ba6c$export$4989d1eb6104cc6c; });

var $7Rn9r = parcelRequire("7Rn9r");
let $10460abecab6ba6c$var$id = 0;
class $10460abecab6ba6c$export$4989d1eb6104cc6c extends (0, $7Rn9r.Feature) {
    constructor(){
        super(...arguments);
        this.id = $10460abecab6ba6c$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}

});


parcelRegister("91h9m", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", function () { return $53be1f91c206a1b4$export$e5b72898e5a201f1; });

var $fprLd = parcelRequire("fprLd");

var $5r1iD = parcelRequire("5r1iD");

var $2BQ6M = parcelRequire("2BQ6M");

var $lbznl = parcelRequire("lbznl");
const $53be1f91c206a1b4$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $lbznl.InViewFeature)
    },
    tap: {
        Feature: (0, $2BQ6M.PressGesture)
    },
    focus: {
        Feature: (0, $5r1iD.FocusGesture)
    },
    hover: {
        Feature: (0, $fprLd.HoverGesture)
    }
};

});
parcelRegister("fprLd", function(module, exports) {

$parcel$export(module.exports, "HoverGesture", function () { return $2861dca5f68fca11$export$93a81ea037eac456; });

var $7Rn9r = parcelRequire("7Rn9r");


var $fKO3x = parcelRequire("fKO3x");

var $01rIG = parcelRequire("01rIG");

var $26AI3 = parcelRequire("26AI3");
function $2861dca5f68fca11$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $26AI3.frame).postRender(()=>callback(event, (0, $01rIG.extractEventInfo)(event)));
}
class $2861dca5f68fca11$export$93a81ea037eac456 extends (0, $7Rn9r.Feature) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $fKO3x.hover)(current, (startEvent)=>{
            $2861dca5f68fca11$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$2861dca5f68fca11$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}

});
parcelRegister("fKO3x", function(module, exports) {

$parcel$export(module.exports, "hover", function () { return $15fa0fc6aa96a10f$export$3f60957f5dbf3876; });

var $dFSMn = parcelRequire("dFSMn");

var $3B9m0 = parcelRequire("3B9m0");
/**
 * Filter out events that are not pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $15fa0fc6aa96a10f$var$filterEvents(callback) {
    return (event)=>{
        if (event.pointerType === "touch" || (0, $dFSMn.isDragActive)()) return;
        callback(event);
    };
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $15fa0fc6aa96a10f$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $3B9m0.setupGesture)(elementOrSelector, options);
    const onPointerEnter = $15fa0fc6aa96a10f$var$filterEvents((enterEvent)=>{
        const { target: target } = enterEvent;
        const onHoverEnd = onHoverStart(enterEvent);
        if (typeof onHoverEnd !== "function" || !target) return;
        const onPointerLeave = $15fa0fc6aa96a10f$var$filterEvents((leaveEvent)=>{
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        });
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    });
    elements.forEach((element)=>{
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}

});
parcelRegister("dFSMn", function(module, exports) {

$parcel$export(module.exports, "isDragActive", function () { return $eaeb624f18ba3381$export$1b3dd616664938e4; });
const $eaeb624f18ba3381$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $eaeb624f18ba3381$export$1b3dd616664938e4() {
    return $eaeb624f18ba3381$export$9e9bc3c487fccc00.x || $eaeb624f18ba3381$export$9e9bc3c487fccc00.y;
}

});

parcelRegister("3B9m0", function(module, exports) {

$parcel$export(module.exports, "setupGesture", function () { return $e28b6b0703176fcb$export$edc0ace9d5e7e842; });

var $7uNuW = parcelRequire("7uNuW");
function $e28b6b0703176fcb$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $7uNuW.resolveElements)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}

});
parcelRegister("7uNuW", function(module, exports) {

$parcel$export(module.exports, "resolveElements", function () { return $2a8a2627818b6e1f$export$90ceba2564a894f8; });
function $2a8a2627818b6e1f$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    var _a;
    if (elementOrSelector instanceof Element) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) // TODO: Refactor to utils package
        // invariant(
        //     Boolean(scope.current),
        //     "Scope provided, but no element detected."
        // )
        root = scope.current;
        const elements = (_a = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _a !== void 0 ? _a : root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}

});



parcelRegister("01rIG", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", function () { return $f3887b5dea69f3b4$export$12f84bb882d06e1a; });


var $2JzYh = parcelRequire("2JzYh");
function $f3887b5dea69f3b4$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $f3887b5dea69f3b4$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $2JzYh.isPrimaryPointer)(event) && handler(event, $f3887b5dea69f3b4$export$12f84bb882d06e1a(event));
};

});
parcelRegister("2JzYh", function(module, exports) {

$parcel$export(module.exports, "isPrimaryPointer", function () { return $eecbc72e8bb08801$export$a4cf9c8a4b063a6e; });
const $eecbc72e8bb08801$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};

});



parcelRegister("5r1iD", function(module, exports) {

$parcel$export(module.exports, "FocusGesture", function () { return $6635f9a7f19ecad8$export$d4826db40d47595b; });

var $5DYSG = parcelRequire("5DYSG");

var $7Rn9r = parcelRequire("7Rn9r");

var $jRjAc = parcelRequire("jRjAc");
class $6635f9a7f19ecad8$export$d4826db40d47595b extends (0, $7Rn9r.Feature) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $jRjAc.pipe)((0, $5DYSG.addDomEvent)(this.node.current, "focus", ()=>this.onFocus()), (0, $5DYSG.addDomEvent)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}

});
parcelRegister("5DYSG", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", function () { return $2ddbdca9b40ab76c$export$b1d829ddf82884aa; });
function $2ddbdca9b40ab76c$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}

});


parcelRegister("2BQ6M", function(module, exports) {

$parcel$export(module.exports, "PressGesture", function () { return $40f2910c43fd1774$export$f026abdbba7f0c9e; });

var $7Rn9r = parcelRequire("7Rn9r");


var $knagt = parcelRequire("knagt");

var $01rIG = parcelRequire("01rIG");

var $26AI3 = parcelRequire("26AI3");
function $40f2910c43fd1774$var$handlePressEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $26AI3.frame).postRender(()=>callback(event, (0, $01rIG.extractEventInfo)(event)));
}
class $40f2910c43fd1774$export$f026abdbba7f0c9e extends (0, $7Rn9r.Feature) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $knagt.press)(current, (startEvent)=>{
            $40f2910c43fd1774$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success })=>$40f2910c43fd1774$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: this.node.props.globalTapTarget
        });
    }
    unmount() {}
}

});
parcelRegister("knagt", function(module, exports) {

$parcel$export(module.exports, "press", function () { return $b11f323c9c9fe728$export$dbe9198142dace0c; });

var $dFSMn = parcelRequire("dFSMn");

var $5kAdW = parcelRequire("5kAdW");

var $2JzYh = parcelRequire("2JzYh");

var $3B9m0 = parcelRequire("3B9m0");

var $8u9bY = parcelRequire("8u9bY");

var $2HcQl = parcelRequire("2HcQl");

var $chy78 = parcelRequire("chy78");
/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $b11f323c9c9fe728$var$isValidPressEvent(event) {
    return (0, $2JzYh.isPrimaryPointer)(event) && !(0, $dFSMn.isDragActive)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $b11f323c9c9fe728$export$dbe9198142dace0c(elementOrSelector, onPressStart, options = {}) {
    const [elements, eventOptions, cancelEvents] = (0, $3B9m0.setupGesture)(elementOrSelector, options);
    const startPress = (startEvent)=>{
        const element = startEvent.currentTarget;
        if (!$b11f323c9c9fe728$var$isValidPressEvent(startEvent) || (0, $chy78.isPressing).has(element)) return;
        (0, $chy78.isPressing).add(element);
        const onPressEnd = onPressStart(startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if (!$b11f323c9c9fe728$var$isValidPressEvent(endEvent) || !(0, $chy78.isPressing).has(element)) return;
            (0, $chy78.isPressing).delete(element);
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, options.useGlobalTarget || (0, $5kAdW.isNodeOrChild)(element, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    elements.forEach((element)=>{
        if (!(0, $8u9bY.isElementKeyboardAccessible)(element) && element.getAttribute("tabindex") === null) element.tabIndex = 0;
        const target = options.useGlobalTarget ? window : element;
        target.addEventListener("pointerdown", startPress, eventOptions);
        element.addEventListener("focus", (event)=>(0, $2HcQl.enableKeyboardPress)(event, eventOptions), eventOptions);
    });
    return cancelEvents;
}

});
parcelRegister("5kAdW", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", function () { return $635f80ad52387555$export$e841ada32ff745b; });
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $635f80ad52387555$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $635f80ad52387555$export$e841ada32ff745b(parent, child.parentElement);
};

});

parcelRegister("8u9bY", function(module, exports) {

$parcel$export(module.exports, "isElementKeyboardAccessible", function () { return $d57299a5cbef4f66$export$5f6976e2f961e8b7; });
const $d57299a5cbef4f66$var$focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function $d57299a5cbef4f66$export$5f6976e2f961e8b7(element) {
    return $d57299a5cbef4f66$var$focusableElements.has(element.tagName) || element.tabIndex !== -1;
}

});

parcelRegister("2HcQl", function(module, exports) {

$parcel$export(module.exports, "enableKeyboardPress", function () { return $bcb8402b61c8f693$export$4b5790288fe12a79; });

var $chy78 = parcelRequire("chy78");
/**
 * Filter out events that are not "Enter" keys.
 */ function $bcb8402b61c8f693$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $bcb8402b61c8f693$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $bcb8402b61c8f693$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $bcb8402b61c8f693$var$filterEvents(()=>{
        if ((0, $chy78.isPressing).has(element)) return;
        $bcb8402b61c8f693$var$firePointerEvent(element, "down");
        const handleKeyup = $bcb8402b61c8f693$var$filterEvents(()=>{
            $bcb8402b61c8f693$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$bcb8402b61c8f693$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};

});
parcelRegister("chy78", function(module, exports) {

$parcel$export(module.exports, "isPressing", function () { return $49e2c50404bf3e08$export$7987404a4e35b84b; });
const $49e2c50404bf3e08$export$7987404a4e35b84b = new WeakSet();

});




parcelRegister("lbznl", function(module, exports) {

$parcel$export(module.exports, "InViewFeature", function () { return $68277ab4e71c3a65$export$150851c8cc2f0c72; });

var $7Rn9r = parcelRequire("7Rn9r");

var $bTFrh = parcelRequire("bTFrh");
const $68277ab4e71c3a65$var$thresholdNames = {
    some: 0,
    all: 1
};
class $68277ab4e71c3a65$export$150851c8cc2f0c72 extends (0, $7Rn9r.Feature) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $68277ab4e71c3a65$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $bTFrh.observeIntersection)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($68277ab4e71c3a65$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $68277ab4e71c3a65$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}

});
parcelRegister("bTFrh", function(module, exports) {

$parcel$export(module.exports, "observeIntersection", function () { return $84b5aa065bf2d45e$export$b2bcd62fb7925aa5; });
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $84b5aa065bf2d45e$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $84b5aa065bf2d45e$var$observers = new WeakMap();
const $84b5aa065bf2d45e$var$fireObserverCallback = (entry)=>{
    const callback = $84b5aa065bf2d45e$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $84b5aa065bf2d45e$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($84b5aa065bf2d45e$var$fireObserverCallback);
};
function $84b5aa065bf2d45e$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$84b5aa065bf2d45e$var$observers.has(lookupRoot)) $84b5aa065bf2d45e$var$observers.set(lookupRoot, {});
    const rootObservers = $84b5aa065bf2d45e$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($84b5aa065bf2d45e$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $84b5aa065bf2d45e$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $84b5aa065bf2d45e$var$initIntersectionObserver(options);
    $84b5aa065bf2d45e$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $84b5aa065bf2d45e$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

});



parcelRegister("6pXP1", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", function () { return $406db74168a9904c$export$56ba0183203348f5; });

var $8FY87 = parcelRequire("8FY87");

var $3ZVKo = parcelRequire("3ZVKo");

var $1NUND = parcelRequire("1NUND");

var $bK8RR = parcelRequire("bK8RR");
const $406db74168a9904c$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $bK8RR.isSVGComponent)(Component) ? new (0, $1NUND.SVGVisualElement)(options) : new (0, $3ZVKo.HTMLVisualElement)(options, {
        allowProjection: Component !== (0, $8FY87.Fragment)
    });
};

});
parcelRegister("3ZVKo", function(module, exports) {

$parcel$export(module.exports, "HTMLVisualElement", function () { return $acc0ffa19de9d84c$export$23fea75b03ac16b3; });

var $8ynSo = parcelRequire("8ynSo");

var $a2aQy = parcelRequire("a2aQy");

var $8Xq7t = parcelRequire("8Xq7t");

var $PoyTG = parcelRequire("PoyTG");

var $16Fu7 = parcelRequire("16Fu7");

var $301nj = parcelRequire("301nj");

var $1lX4q = parcelRequire("1lX4q");

var $5JR6Z = parcelRequire("5JR6Z");
function $acc0ffa19de9d84c$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $acc0ffa19de9d84c$export$23fea75b03ac16b3 extends (0, $a2aQy.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $1lX4q.renderHTML);
    }
    readValueFromInstance(instance, key) {
        if ((0, $301nj.transformProps).has(key)) {
            const defaultType = (0, $PoyTG.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $acc0ffa19de9d84c$export$3735103072e4a80(instance);
            const value = ((0, $8Xq7t.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $8ynSo.measureViewportBox)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $16Fu7.buildHTMLStyles)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $5JR6Z.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
}

});
parcelRegister("8ynSo", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", function () { return $3e232ae15108c4f1$export$d8718b6a7e5c624e; });

var $3ZB2d = parcelRequire("3ZB2d");

var $4G0xl = parcelRequire("4G0xl");
function $3e232ae15108c4f1$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $3ZB2d.convertBoundingBoxToBox)((0, $3ZB2d.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $3e232ae15108c4f1$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $3e232ae15108c4f1$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $4G0xl.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, $4G0xl.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

});
parcelRegister("3ZB2d", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", function () { return $bee0918ca74cfbc1$export$d3955c6a8f65a36b; });
$parcel$export(module.exports, "transformBoxPoints", function () { return $bee0918ca74cfbc1$export$21543fb75483a50; });
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $bee0918ca74cfbc1$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $bee0918ca74cfbc1$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $bee0918ca74cfbc1$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});

parcelRegister("4G0xl", function(module, exports) {

$parcel$export(module.exports, "translateAxis", function () { return $419540e7df4db082$export$a807a5ce5ebb3895; });

var $7uAm4 = parcelRequire("7uAm4");

var $dBsGE = parcelRequire("dBsGE");
/**
 * Scales a point based on a factor and an originPoint
 */ function $419540e7df4db082$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $419540e7df4db082$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $419540e7df4db082$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $419540e7df4db082$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $419540e7df4db082$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $419540e7df4db082$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $419540e7df4db082$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $419540e7df4db082$export$d80074982803af5c(box, { x: x, y: y }) {
    $419540e7df4db082$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $419540e7df4db082$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $419540e7df4db082$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $419540e7df4db082$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $419540e7df4db082$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $419540e7df4db082$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $419540e7df4db082$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $dBsGE.hasTransform)(node.latestValues)) $419540e7df4db082$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $419540e7df4db082$var$TREE_SCALE_SNAP_MAX && treeScale.x > $419540e7df4db082$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $419540e7df4db082$var$TREE_SCALE_SNAP_MAX && treeScale.y > $419540e7df4db082$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $419540e7df4db082$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $419540e7df4db082$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $7uAm4.mixNumber)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $419540e7df4db082$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $419540e7df4db082$export$58b16271041fbfb(box, transform) {
    $419540e7df4db082$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $419540e7df4db082$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}

});
parcelRegister("dBsGE", function(module, exports) {

$parcel$export(module.exports, "hasTransform", function () { return $dd19d0d4735bf6a9$export$a545127cf1fbb600; });
function $dd19d0d4735bf6a9$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $dd19d0d4735bf6a9$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$dd19d0d4735bf6a9$var$isIdentityScale(scale) || !$dd19d0d4735bf6a9$var$isIdentityScale(scaleX) || !$dd19d0d4735bf6a9$var$isIdentityScale(scaleY);
}
function $dd19d0d4735bf6a9$export$a545127cf1fbb600(values) {
    return $dd19d0d4735bf6a9$export$bdf30dca883ea463(values) || $dd19d0d4735bf6a9$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $dd19d0d4735bf6a9$export$bf80f5f8f4dc327f(values) {
    return $dd19d0d4735bf6a9$var$is2DTranslate(values.x) || $dd19d0d4735bf6a9$var$is2DTranslate(values.y);
}
function $dd19d0d4735bf6a9$var$is2DTranslate(value) {
    return value && value !== "0%";
}

});



parcelRegister("a2aQy", function(module, exports) {

$parcel$export(module.exports, "DOMVisualElement", function () { return $cce96f50414cf8c4$export$e49735c2a366bdc7; });

var $bKotx = parcelRequire("bKotx");

var $8bbgw = parcelRequire("8bbgw");

var $fCd14 = parcelRequire("fCd14");
class $cce96f50414cf8c4$export$e49735c2a366bdc7 extends (0, $bKotx.VisualElement) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $8bbgw.DOMKeyframesResolver);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $fCd14.isMotionValue)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}

});
parcelRegister("bKotx", function(module, exports) {

$parcel$export(module.exports, "VisualElement", function () { return $487d16cbf1b0a06b$export$fa8b653c0f3714e5; });

var $es6mb = parcelRequire("es6mb");

var $fz2io = parcelRequire("fz2io");

var $jbaLE = parcelRequire("jbaLE");

var $kqx13 = parcelRequire("kqx13");

var $6GiZZ = parcelRequire("6GiZZ");

var $b91kU = parcelRequire("b91kU");

var $epkKS = parcelRequire("epkKS");

var $h6Yw9 = parcelRequire("h6Yw9");


var $cSjJD = parcelRequire("cSjJD");

var $btAzw = parcelRequire("btAzw");

var $fCd14 = parcelRequire("fCd14");

var $cmmYl = parcelRequire("cmmYl");

var $5HeHr = parcelRequire("5HeHr");

var $301nj = parcelRequire("301nj");

var $1cBGI = parcelRequire("1cBGI");

var $5EVuK = parcelRequire("5EVuK");

var $8yAAg = parcelRequire("8yAAg");

var $3Z6fp = parcelRequire("3Z6fp");

var $80nvV = parcelRequire("80nvV");

var $26AI3 = parcelRequire("26AI3");
const $487d16cbf1b0a06b$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $487d16cbf1b0a06b$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $8yAAg.KeyframeResolver);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $es6mb.time).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $26AI3.frame).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState, onUpdate: onUpdate } = visualState;
        this.onUpdate = onUpdate;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $5EVuK.isControllingVariants)(props);
        this.isVariantNode = (0, $5EVuK.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $fCd14.isMotionValue)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $1cBGI.visualElementStore).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $epkKS.hasReducedMotionListener).current) (0, $b91kU.initPrefersReducedMotion)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $epkKS.prefersReducedMotion).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $1cBGI.visualElementStore).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $26AI3.cancelFrame)(this.notifyUpdate);
        (0, $26AI3.cancelFrame)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $301nj.transformProps).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $26AI3.frame).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $fz2io.featureDefinitions){
            const featureDefinition = (0, $fz2io.featureDefinitions)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $jbaLE.createBox)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $487d16cbf1b0a06b$var$propEventHandlers.length; i++){
            const key = $487d16cbf1b0a06b$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $3Z6fp.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
        this.onUpdate && this.onUpdate(this);
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $cSjJD.motionValue)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $kqx13.isNumericalString)(value) || (0, $6GiZZ.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $5HeHr.findValueType)(value) && (0, $btAzw.complex).test(target)) value = (0, $cmmYl.getAnimatableNone)(key, target);
            this.setBaseTarget(key, (0, $fCd14.isMotionValue)(value) ? value.get() : value);
        }
        return (0, $fCd14.isMotionValue)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $80nvV.resolveVariantFromProps)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $fCd14.isMotionValue)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $h6Yw9.SubscriptionManager)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}

});
parcelRegister("fz2io", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", function () { return $e56def868c552395$export$65570e08d843624d; });
const $e56def868c552395$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $e56def868c552395$export$65570e08d843624d = {};
for(const key in $e56def868c552395$var$featureProps)$e56def868c552395$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$e56def868c552395$var$featureProps[key].some((name)=>!!props[name])
};

});

parcelRegister("jbaLE", function(module, exports) {

$parcel$export(module.exports, "createBox", function () { return $5364cd39a87d101b$export$6459fc9e86be362e; });
const $5364cd39a87d101b$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $5364cd39a87d101b$export$3d227df54007d73a = ()=>({
        x: $5364cd39a87d101b$export$ff25708b37f72782(),
        y: $5364cd39a87d101b$export$ff25708b37f72782()
    });
const $5364cd39a87d101b$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $5364cd39a87d101b$export$6459fc9e86be362e = ()=>({
        x: $5364cd39a87d101b$export$6db76765312617ac(),
        y: $5364cd39a87d101b$export$6db76765312617ac()
    });

});

parcelRegister("b91kU", function(module, exports) {

$parcel$export(module.exports, "initPrefersReducedMotion", function () { return $fb2d799ef18717f5$export$ca9f41fb23dded3d; });

var $dZKvQ = parcelRequire("dZKvQ");

var $epkKS = parcelRequire("epkKS");
function $fb2d799ef18717f5$export$ca9f41fb23dded3d() {
    (0, $epkKS.hasReducedMotionListener).current = true;
    if (!(0, $dZKvQ.isBrowser)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $epkKS.prefersReducedMotion).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $epkKS.prefersReducedMotion).current = false;
}

});
parcelRegister("dZKvQ", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $fcb91b03cb35a16b$export$4e09c449d6c407f7; });
const $fcb91b03cb35a16b$export$4e09c449d6c407f7 = typeof window !== "undefined";

});

parcelRegister("epkKS", function(module, exports) {

$parcel$export(module.exports, "prefersReducedMotion", function () { return $e8f70df4837dcef7$export$ff7706047246b98b; });
$parcel$export(module.exports, "hasReducedMotionListener", function () { return $e8f70df4837dcef7$export$6476d16e2fd2d0db; });
// Does this device prefer reduced motion? Returns `null` server-side.
const $e8f70df4837dcef7$export$ff7706047246b98b = {
    current: null
};
const $e8f70df4837dcef7$export$6476d16e2fd2d0db = {
    current: false
};

});


parcelRegister("5HeHr", function(module, exports) {

$parcel$export(module.exports, "findValueType", function () { return $5d478fbd2e655e57$export$950e7e59ea1ffed7; });

var $lQsem = parcelRequire("lQsem");

var $btAzw = parcelRequire("btAzw");

var $2g4Ln = parcelRequire("2g4Ln");

var $4fktA = parcelRequire("4fktA");
/**
 * A list of all ValueTypes
 */ const $5d478fbd2e655e57$var$valueTypes = [
    ...(0, $2g4Ln.dimensionValueTypes),
    (0, $lQsem.color),
    (0, $btAzw.complex)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $5d478fbd2e655e57$export$950e7e59ea1ffed7 = (v)=>$5d478fbd2e655e57$var$valueTypes.find((0, $4fktA.testValueType)(v));

});

parcelRegister("1cBGI", function(module, exports) {

$parcel$export(module.exports, "visualElementStore", function () { return $39975809d2ea3499$export$bc2a978a17abfdde; });
const $39975809d2ea3499$export$bc2a978a17abfdde = new WeakMap();

});

parcelRegister("5EVuK", function(module, exports) {

$parcel$export(module.exports, "isControllingVariants", function () { return $dd7707fad2cadbc4$export$4b3c3bd8d910d78d; });
$parcel$export(module.exports, "isVariantNode", function () { return $dd7707fad2cadbc4$export$ce46fa4165cdec40; });

var $dHb9C = parcelRequire("dHb9C");

var $7upgv = parcelRequire("7upgv");

var $glANL = parcelRequire("glANL");
function $dd7707fad2cadbc4$export$4b3c3bd8d910d78d(props) {
    return (0, $dHb9C.isAnimationControls)(props.animate) || (0, $glANL.variantProps).some((name)=>(0, $7upgv.isVariantLabel)(props[name]));
}
function $dd7707fad2cadbc4$export$ce46fa4165cdec40(props) {
    return Boolean($dd7707fad2cadbc4$export$4b3c3bd8d910d78d(props) || props.variants);
}

});

parcelRegister("3Z6fp", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", function () { return $429fb157b463519a$export$9a552858d5197f6e; });


var $cSjJD = parcelRequire("cSjJD");

var $fCd14 = parcelRequire("fCd14");
function $429fb157b463519a$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $fCd14.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $fCd14.isMotionValue)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $cSjJD.motionValue)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $cSjJD.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});



parcelRegister("16Fu7", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", function () { return $eaffaeb4d02fcac8$export$bb517f8b40f8e99d; });

var $8Xq7t = parcelRequire("8Xq7t");

var $bDqpi = parcelRequire("bDqpi");

var $hhnjp = parcelRequire("hhnjp");

var $giKs8 = parcelRequire("giKs8");

var $301nj = parcelRequire("301nj");
function $eaffaeb4d02fcac8$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $301nj.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $8Xq7t.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $bDqpi.getValueAsType)(value, (0, $hhnjp.numberValueTypes)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $giKs8.buildTransform)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

});
parcelRegister("bDqpi", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", function () { return $3f93cd8beb18539e$export$453ef540a9a1bd6b; });
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $3f93cd8beb18539e$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};

});

parcelRegister("giKs8", function(module, exports) {

$parcel$export(module.exports, "buildTransform", function () { return $802b5f3016f9e12e$export$bdc96e0d5c8f914; });

var $bDqpi = parcelRequire("bDqpi");

var $hhnjp = parcelRequire("hhnjp");

var $301nj = parcelRequire("301nj");
const $802b5f3016f9e12e$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $802b5f3016f9e12e$var$numTransforms = (0, $301nj.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $802b5f3016f9e12e$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $802b5f3016f9e12e$var$numTransforms; i++){
        const key = (0, $301nj.transformPropOrder)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $bDqpi.getValueAsType)(value, (0, $hhnjp.numberValueTypes)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $802b5f3016f9e12e$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}

});


parcelRegister("1lX4q", function(module, exports) {

$parcel$export(module.exports, "renderHTML", function () { return $d3f10ab4b99a0dd8$export$1a32bf6229c258c0; });
function $d3f10ab4b99a0dd8$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}

});

parcelRegister("5JR6Z", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $b61e91c7bbde6691$export$16da615486abaa45; });

var $h5o7w = parcelRequire("h5o7w");

var $fCd14 = parcelRequire("fCd14");
function $b61e91c7bbde6691$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $fCd14.isMotionValue)(style[key]) || prevProps.style && (0, $fCd14.isMotionValue)(prevProps.style[key]) || (0, $h5o7w.isForcedMotionValue)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}

});
parcelRegister("h5o7w", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", function () { return $e3e99313b26e511e$export$6d27ce8e3de1c3cf; });

var $9wugv = parcelRequire("9wugv");

var $301nj = parcelRequire("301nj");
function $e3e99313b26e511e$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $301nj.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $9wugv.scaleCorrectors)[key] || key === "opacity");
}

});
parcelRegister("9wugv", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", function () { return $53b9013bb774c3c6$export$91ddd985b97788d1; });
const $53b9013bb774c3c6$export$91ddd985b97788d1 = {};
function $53b9013bb774c3c6$export$de9e7791c71225fd(correctors) {
    Object.assign($53b9013bb774c3c6$export$91ddd985b97788d1, correctors);
}

});




parcelRegister("1NUND", function(module, exports) {

$parcel$export(module.exports, "SVGVisualElement", function () { return $5d879407bce0bcee$export$86bcdffbaf733d84; });

var $jbaLE = parcelRequire("jbaLE");

var $a2aQy = parcelRequire("a2aQy");

var $drayr = parcelRequire("drayr");

var $PoyTG = parcelRequire("PoyTG");

var $301nj = parcelRequire("301nj");

var $iyj4g = parcelRequire("iyj4g");

var $2Zkr5 = parcelRequire("2Zkr5");

var $mzfai = parcelRequire("mzfai");

var $5VMyx = parcelRequire("5VMyx");

var $fxQ2n = parcelRequire("fxQ2n");
class $5d879407bce0bcee$export$86bcdffbaf733d84 extends (0, $a2aQy.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $jbaLE.createBox);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $301nj.transformProps).has(key)) {
            const defaultType = (0, $PoyTG.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $2Zkr5.camelCaseAttributes).has(key) ? (0, $drayr.camelToDash)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $fxQ2n.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $iyj4g.buildSVGAttrs)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $5VMyx.renderSVG)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $mzfai.isSVGTag)(instance.tagName);
        super.mount(instance);
    }
}

});
parcelRegister("iyj4g", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", function () { return $8e122739ba609a05$export$5475d24f125d7053; });

var $16Fu7 = parcelRequire("16Fu7");

var $dcBBm = parcelRequire("dcBBm");

var $3tEEx = parcelRequire("3tEEx");
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $8e122739ba609a05$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $16Fu7.buildHTMLStyles)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $3tEEx.calcSVGTransformOrigin)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $dcBBm.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("dcBBm", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", function () { return $cbd199a38c54331e$export$311b43f666da1d82; });

var $ltGqL = parcelRequire("ltGqL");
const $cbd199a38c54331e$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $cbd199a38c54331e$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $cbd199a38c54331e$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $cbd199a38c54331e$var$dashKeys : $cbd199a38c54331e$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $ltGqL.px).transform(-offset);
    // Build the dash array
    const pathLength = (0, $ltGqL.px).transform(length);
    const pathSpacing = (0, $ltGqL.px).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

});

parcelRegister("3tEEx", function(module, exports) {

$parcel$export(module.exports, "calcSVGTransformOrigin", function () { return $c8bda724e30a3338$export$d4fbcfc8e5472155; });

var $ltGqL = parcelRequire("ltGqL");
function $c8bda724e30a3338$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $ltGqL.px).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $c8bda724e30a3338$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $c8bda724e30a3338$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $c8bda724e30a3338$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}

});


parcelRegister("2Zkr5", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", function () { return $edf98f3b47d34444$export$28931db5d57958e5; });
/**
 * A set of attribute names that are always read/written as camel case.
 */ const $edf98f3b47d34444$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

});

parcelRegister("mzfai", function(module, exports) {

$parcel$export(module.exports, "isSVGTag", function () { return $5023c235fb5372e1$export$6328ce7565ea1049; });
const $5023c235fb5372e1$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";

});

parcelRegister("5VMyx", function(module, exports) {

$parcel$export(module.exports, "renderSVG", function () { return $3af76d931c5545eb$export$c5f8399d19a7394b; });

var $drayr = parcelRequire("drayr");

var $1lX4q = parcelRequire("1lX4q");

var $2Zkr5 = parcelRequire("2Zkr5");
function $3af76d931c5545eb$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $1lX4q.renderHTML)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $2Zkr5.camelCaseAttributes).has(key) ? (0, $drayr.camelToDash)(key) : key, renderState.attrs[key]);
}

});

parcelRegister("fxQ2n", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $e0cccd608e387eb6$export$16da615486abaa45; });

var $fCd14 = parcelRequire("fCd14");

var $301nj = parcelRequire("301nj");

var $5JR6Z = parcelRequire("5JR6Z");
function $e0cccd608e387eb6$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $5JR6Z.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    for(const key in props)if ((0, $fCd14.isMotionValue)(props[key]) || (0, $fCd14.isMotionValue)(prevProps[key])) {
        const targetKey = (0, $301nj.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});


parcelRegister("bK8RR", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", function () { return $f606e8063bdca857$export$88f3fc2fd3766989; });

var $iv3Cm = parcelRequire("iv3Cm");
function $f606e8063bdca857$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $iv3Cm.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}

});
parcelRegister("iv3Cm", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", function () { return $c22e369ae43b7a67$export$40209c4c512158e6; });
/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $c22e369ae43b7a67$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];

});




parcelRegister("4NoTr", function(module, exports) {

$parcel$export(module.exports, "LazyMotion", function () { return $2a4d925acc32bad4$export$23c340a7eb1b419; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $h0Eto = parcelRequire("h0Eto");

var $9ncNy = parcelRequire("9ncNy");
"use client";
/**
 * Used in conjunction with the `m` component to reduce bundle size.
 *
 * `m` is a version of the `motion` component that only loads functionality
 * critical for the initial render.
 *
 * `LazyMotion` can then be used to either synchronously or asynchronously
 * load animation and gesture support.
 *
 * ```jsx
 * // Synchronous loading
 * import { LazyMotion, m, domAnimation } from "framer-motion"
 *
 * function App() {
 *   return (
 *     <LazyMotion features={domAnimation}>
 *       <m.div animate={{ scale: 2 }} />
 *     </LazyMotion>
 *   )
 * }
 *
 * // Asynchronous loading
 * import { LazyMotion, m } from "framer-motion"
 *
 * function App() {
 *   return (
 *     <LazyMotion features={() => import('./path/to/domAnimation')}>
 *       <m.div animate={{ scale: 2 }} />
 *     </LazyMotion>
 *   )
 * }
 * ```
 *
 * @public
 */ function $2a4d925acc32bad4$export$23c340a7eb1b419({ children: children, features: features, strict: strict = false }) {
    const [, setIsLoaded] = (0, $8FY87.useState)(!$2a4d925acc32bad4$var$isLazyBundle(features));
    const loadedRenderer = (0, $8FY87.useRef)(undefined);
    /**
     * If this is a synchronous load, load features immediately
     */ if (!$2a4d925acc32bad4$var$isLazyBundle(features)) {
        const { renderer: renderer, ...loadedFeatures } = features;
        loadedRenderer.current = renderer;
        (0, $9ncNy.loadFeatures)(loadedFeatures);
    }
    (0, $8FY87.useEffect)(()=>{
        if ($2a4d925acc32bad4$var$isLazyBundle(features)) features().then(({ renderer: renderer, ...loadedFeatures })=>{
            (0, $9ncNy.loadFeatures)(loadedFeatures);
            loadedRenderer.current = renderer;
            setIsLoaded(true);
        });
    }, []);
    return (0, $2PPWI.jsx)((0, $h0Eto.LazyContext).Provider, {
        value: {
            renderer: loadedRenderer.current,
            strict: strict
        },
        children: children
    });
}
function $2a4d925acc32bad4$var$isLazyBundle(features) {
    return typeof features === "function";
}

});
parcelRegister("h0Eto", function(module, exports) {

$parcel$export(module.exports, "LazyContext", function () { return $117778d843f219b2$export$40f10139ecf1f171; });

var $8FY87 = parcelRequire("8FY87");
"use client";
const $117778d843f219b2$export$40f10139ecf1f171 = (0, $8FY87.createContext)({
    strict: false
});

});

parcelRegister("9ncNy", function(module, exports) {

$parcel$export(module.exports, "loadFeatures", function () { return $38a314202bd88aa1$export$449561ec5703cdc8; });

var $fz2io = parcelRequire("fz2io");
function $38a314202bd88aa1$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $fz2io.featureDefinitions)[key] = {
        ...(0, $fz2io.featureDefinitions)[key],
        ...features[key]
    };
}

});


parcelRegister("jZedf", function(module, exports) {

$parcel$export(module.exports, "fetchWithType", function () { return $71d5ed4cdc8a768e$export$4c04c73fd6987aab; });
$parcel$export(module.exports, "getTrim", function () { return $71d5ed4cdc8a768e$export$a78d66906c2c1938; });
$parcel$export(module.exports, "getModels", function () { return $71d5ed4cdc8a768e$export$b68ce1c40f5eb9e6; });

var $1lSPe = parcelRequire("1lSPe");
const $71d5ed4cdc8a768e$export$e9ddf1da8d18d6f = `${(0, $1lSPe.getAdminUrl)()}/api`;
async function $71d5ed4cdc8a768e$export$4c04c73fd6987aab(request, options) {
    try {
        const response = await fetch(request, {
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
        const contentType = response.headers.get('content-type') || '';
        const isJson = contentType.includes('application/json');
        const status = response.status;
        const data = isJson ? await response.json() : undefined;
        if (!response.ok) throw new Error(`${status} ${response.statusText}`);
        return {
            data: data,
            status: status
        };
    } catch (error) {
        if (error instanceof Error) throw new Error(`Failed to fetch data: ${error.message}`);
        else throw new Error(`Failed to fetch data: ${error}`);
    }
}
async function $71d5ed4cdc8a768e$export$a78d66906c2c1938(code) {
    return $71d5ed4cdc8a768e$export$4c04c73fd6987aab((0, $1lSPe.getAdminUrl)() + '/api/car/' + code, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${(0, $1lSPe.getApiToken)()}`
        }
    });
}
async function $71d5ed4cdc8a768e$export$b68ce1c40f5eb9e6() {
    return await $71d5ed4cdc8a768e$export$4c04c73fd6987aab((0, $1lSPe.getAdminUrl)() + '/api/calculator/models', {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${(0, $1lSPe.getApiToken)()}`
        }
    });
}

});
parcelRegister("1lSPe", function(module, exports) {

$parcel$export(module.exports, "locationIsKia", function () { return $b530ec3d3e16c5e6$export$d87e95f4cb506459; });
$parcel$export(module.exports, "getUniqId", function () { return $b530ec3d3e16c5e6$export$f0d40c8b1bd50ff0; });
$parcel$export(module.exports, "getAdminUrl", function () { return $b530ec3d3e16c5e6$export$4af8c31d839a7b83; });
$parcel$export(module.exports, "getApiToken", function () { return $b530ec3d3e16c5e6$export$3f3434baf5a5c9c; });
$parcel$export(module.exports, "formatNumber", function () { return $b530ec3d3e16c5e6$export$f5dd818bff069720; });
$parcel$export(module.exports, "validEmail", function () { return $b530ec3d3e16c5e6$export$9ab921aaffe56820; });
$parcel$export(module.exports, "fNumber", function () { return $b530ec3d3e16c5e6$export$5a1650786e4039b5; });
$parcel$export(module.exports, "getContainerClass", function () { return $b530ec3d3e16c5e6$export$6535aa9e360a25e0; });
$parcel$export(module.exports, "getYoutubeId", function () { return $b530ec3d3e16c5e6$export$57b1f5391d2ebf30; });
const $b530ec3d3e16c5e6$var$domains = [
    'kia.com',
    'landrinsbil.se',
    'www.bjorkmansbil.se',
    'www.smalandskabil.se',
    'svenskamotor.se',
    'moramotorcenter.se',
    'prod2admin-eu.kia.com',
    '127.0.0.1:3334',
    'www.bilkompaniet.com'
];
const $b530ec3d3e16c5e6$export$d87e95f4cb506459 = ()=>{
    if (typeof window === 'undefined') return false;
    const host = window.location.host.replace(/^www\./, '');
    return $b530ec3d3e16c5e6$var$domains.some((domain)=>domain.replace(/^www\./, '') === host);
};
const $b530ec3d3e16c5e6$export$f0d40c8b1bd50ff0 = ()=>Math.random().toString(36).substring(2, 8);
const $b530ec3d3e16c5e6$export$4af8c31d839a7b83 = ()=>{
    return $b530ec3d3e16c5e6$export$d87e95f4cb506459() ? 'https://kia.live.afonso.se' : "https://kia.live.afonso.se" ?? 'https://kia.dev.afonso.se';
};
const $b530ec3d3e16c5e6$export$3f3434baf5a5c9c = ()=>{
    return $b530ec3d3e16c5e6$export$d87e95f4cb506459() ? '3|EDPCQxV8mfDffJ02N9uLzAH3S6IjLap5f3ItxRZB99d561de' : "3|EDPCQxV8mfDffJ02N9uLzAH3S6IjLap5f3ItxRZB99d561de" ?? '4|RqQZzqaTK55e8oXVBD4iZ3CcRgRgdxbwSbz0ZwmI01141b46';
};
const $b530ec3d3e16c5e6$export$f5dd818bff069720 = (number)=>{
    if (!number || number === 0) return '-';
    return new Intl.NumberFormat('sv-SE').format(number);
};
const $b530ec3d3e16c5e6$export$4be65e66cfa2648a = (name)=>{
    const cookieArr = document.cookie.split(';');
    for(let i = 0; i < cookieArr.length; i++){
        const cookiePair = cookieArr[i].trim().split('=');
        if (cookiePair[0] === name) return decodeURIComponent(cookiePair[1]); // Decode cookie value
    }
    return null;
};
const $b530ec3d3e16c5e6$export$110700823644f4a6 = ({ name: name, value: value, expiry: expiry })=>{
    const date = new Date();
    date.setTime(date.getTime() + expiry * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${encodeURIComponent(value)};${expires};path=/`; // Encode value
};
const $b530ec3d3e16c5e6$export$9ab921aaffe56820 = (email)=>{
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
};
const $b530ec3d3e16c5e6$export$5a1650786e4039b5 = (num)=>{
    if (num === null || num === undefined || num < 0) return '-';
    const options = {
        style: 'currency',
        currency: 'SEK',
        maximumFractionDigits: 0
    };
    return num.toLocaleString('sv-SE', options);
};
const $b530ec3d3e16c5e6$export$6535aa9e360a25e0 = (width)=>{
    if (!width) return '';
    return width && width === 'lg' ? 'kia-w-lg' : width && width === 'md' ? 'kia-w-md' : width && width === 'sm' ? 'kia-w-sm' : width && width === 'full' ? 'w-full' : 'kia-w-xs';
};
const $b530ec3d3e16c5e6$export$57b1f5391d2ebf30 = (url)=>{
    if (!url) return null;
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|shorts\/)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
};

});


parcelRegister("gbHQM", function(module, exports) {

$parcel$export(module.exports, "setCookie", function () { return $f291105807749eff$export$110700823644f4a6; });
$parcel$export(module.exports, "getCookie", function () { return $f291105807749eff$export$4be65e66cfa2648a; });
$parcel$export(module.exports, "removeCookie", function () { return $f291105807749eff$export$6a874b7a74007875; });
const $f291105807749eff$export$110700823644f4a6 = (name, value, days)=>{
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 86400000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Strict; Secure";
};
const $f291105807749eff$export$4be65e66cfa2648a = (name)=>{
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) === " ")c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};
const $f291105807749eff$export$6a874b7a74007875 = (name)=>{
    document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

});

parcelRegister("2HzUL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e33b1eac751777c7$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $jeu8h = parcelRequire("jeu8h");

var $f0NwZ = parcelRequire("f0NwZ");

var $3eb7t = parcelRequire("3eb7t");

var $2FCIq = parcelRequire("2FCIq");

var $cMeiR = parcelRequire("cMeiR");

var $3m7pL = parcelRequire("3m7pL");
const $e33b1eac751777c7$var$AdaptationsExtensions = ()=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("main", {
        className: "relative max-w-screen-kia mx-auto",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $cMeiR.default), {
                ...(0, $3m7pL.heroAE)
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "w-full h-auto mx-auto",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                            initial: "hidden",
                            whileInView: "visible",
                            variants: (0, $51Ucj.containerVariants),
                            viewport: (0, $51Ucj.viewPort),
                            className: "mb-16 mx-auto max-w-screen-kia-sm",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                                variants: (0, $51Ucj.itemVariants),
                                className: " text-center font-light text-2xl px-2 mt-[28px]",
                                children: (0, $3m7pL.textAE001)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: " mx-auto px-6 w-full  max-w-7xl mb-7",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponentWidth: "col-span-4 lg:col-span-3",
                            secondComponentWidth: "col-span-4 lg:col-span-5",
                            mainBoxClassName: "mx-auto w-full max-w-7xl",
                            firstComponentClassName: "p-0 lg:p-10 lg:pt-5",
                            secondComponentClassName: "p-0",
                            mobilFirstComponentOnTop: false,
                            desktopFirstComponentFirst: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                    children: (0, $3m7pL.textAE002)
                                })
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                ...(0, $3m7pL.smallAEImg001)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: " mx-auto px-6 w-full  max-w-7xl mb-7",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponentWidth: "col-span-4 lg:col-span-5",
                            secondComponentWidth: "col-span-4 lg:col-span-3",
                            mainBoxClassName: "mx-auto w-full max-w-7xl",
                            firstComponentClassName: "p-0",
                            secondComponentClassName: "p-0 lg:p-10 lg:pt-5 lg:pb-0",
                            mobilFirstComponentOnTop: true,
                            desktopFirstComponentFirst: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                ...(0, $3m7pL.smallAEImg002)
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: "flex flex-col justify-between h-full",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        children: (0, $3m7pL.textAE003)
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                        ...(0, $3m7pL.linkAE01)
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                                initial: "hidden",
                                whileInView: "visible",
                                variants: (0, $51Ucj.containerVariants),
                                viewport: (0, $51Ucj.viewPort),
                                className: "mb-5 pt-6 mx-auto max-w-7xl border-t mt-20",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                                    variants: (0, $51Ucj.itemVariants),
                                    className: "text-start px-2 font-light text-2xl",
                                    children: (0, $3m7pL.textAE004)
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                                firstComponentWidth: "col-span-4",
                                secondComponentWidth: "col-span-4 ",
                                mainBoxClassName: "mx-auto w-full max-w-7xl border-b border-black/20 pb-6",
                                firstComponentClassName: "p-0",
                                secondComponentClassName: "p-0",
                                mobilFirstComponentOnTop: true,
                                desktopFirstComponentFirst: true,
                                firstComponent: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: "flex gap-2 h-full px-2 !text-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                            className: "!text-lg",
                                            children: (0, $3m7pL.textAE005)
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                            href: (0, $3m7pL.linkAE02).href,
                                            target: (0, $3m7pL.linkAE02).target,
                                            className: " underline decoration-current transition-all duration-200 ease-in-out hover:text-black/50 hover:decoration-transparent hover:underline-offset-4",
                                            children: (0, $3m7pL.linkAE02).label
                                        })
                                    ]
                                }),
                                secondComponent: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: "flex gap-2 h-full px-2 !text-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                            className: "!text-lg",
                                            children: (0, $3m7pL.textAE006)
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                            href: (0, $3m7pL.linkAE03).href,
                                            target: (0, $3m7pL.linkAE03).target,
                                            className: " underline decoration-current transition-all duration-200 ease-in-out hover:text-black/50 hover:decoration-transparent hover:underline-offset-4",
                                            children: (0, $3m7pL.linkAE03).label
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                        page: "adaptations-extensions"
                    })
                ]
            })
        ]
    });
};
var $e33b1eac751777c7$export$2e2bcd8739ae039 = $e33b1eac751777c7$var$AdaptationsExtensions;

});
parcelRegister("4Qpe2", function(module, exports) {

$parcel$export(module.exports, "m", function () { return $76f9914e06f68cfe$export$953cecd6e717a553; });

var $9Pg6w = parcelRequire("9Pg6w");

var $6DF7T = parcelRequire("6DF7T");
const $76f9914e06f68cfe$export$953cecd6e717a553 = /*@__PURE__*/ (0, $9Pg6w.createDOMMotionComponentProxy)((0, $6DF7T.createMinimalMotionComponent));

});
parcelRegister("9Pg6w", function(module, exports) {

$parcel$export(module.exports, "createDOMMotionComponentProxy", function () { return $28aff9aa6a9f13e6$export$3af29c0efb268f04; });

function $28aff9aa6a9f13e6$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}

});

parcelRegister("6DF7T", function(module, exports) {

$parcel$export(module.exports, "createMinimalMotionComponent", function () { return $19cbae3301e1af4e$export$93df5a9c3551758b; });

var $aQfJo = parcelRequire("aQfJo");
const $19cbae3301e1af4e$export$93df5a9c3551758b = /*@__PURE__*/ (0, $aQfJo.createMotionComponentFactory)();

});
parcelRegister("aQfJo", function(module, exports) {

$parcel$export(module.exports, "createMotionComponentFactory", function () { return $b0dd404c457c83b3$export$d86feac869a7f0d5; });

var $jde55 = parcelRequire("jde55");

var $bK8RR = parcelRequire("bK8RR");

var $iODdD = parcelRequire("iODdD");

var $fXpRm = parcelRequire("fXpRm");

var $j0l20 = parcelRequire("j0l20");
function $b0dd404c457c83b3$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $bK8RR.isSVGComponent)(Component) ? (0, $iODdD.svgMotionConfig) : (0, $fXpRm.htmlMotionConfig);
        const config = {
            ...baseConfig,
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $j0l20.createUseRender)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        };
        return (0, $jde55.createRendererMotionComponent)(config);
    };
}

});
parcelRegister("jde55", function(module, exports) {

$parcel$export(module.exports, "createRendererMotionComponent", function () { return $c1fb8b13d376ac41$export$c3ad4a902bccc2d8; });

var $2PPWI = parcelRequire("2PPWI");


var $8FY87 = parcelRequire("8FY87");

var $6y205 = parcelRequire("6y205");

var $h0Eto = parcelRequire("h0Eto");

var $i7M4t = parcelRequire("i7M4t");

var $cPSOv = parcelRequire("cPSOv");

var $eFlre = parcelRequire("eFlre");

var $dZKvQ = parcelRequire("dZKvQ");

var $fz2io = parcelRequire("fz2io");

var $9ncNy = parcelRequire("9ncNy");

var $cb3r2 = parcelRequire("cb3r2");

var $8442R = parcelRequire("8442R");

var $334Vg = parcelRequire("334Vg");
"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $c1fb8b13d376ac41$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    var _a, _b;
    preloadedFeatures && (0, $9ncNy.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $8FY87.useContext)((0, $i7M4t.MotionConfigContext)),
            ...props,
            layoutId: $c1fb8b13d376ac41$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $eFlre.useCreateMotionContext)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $dZKvQ.isBrowser)) {
            $c1fb8b13d376ac41$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $c1fb8b13d376ac41$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $334Vg.useVisualElement)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $2PPWI.jsxs)((0, $cPSOv.MotionContext).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $2PPWI.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $8442R.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    MotionComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${(_b = (_a = Component.displayName) !== null && _a !== void 0 ? _a : Component.name) !== null && _b !== void 0 ? _b : ""})`}`;
    const ForwardRefMotionComponent = (0, $8FY87.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $cb3r2.motionComponentSymbol] = Component;
    return ForwardRefMotionComponent;
}
function $c1fb8b13d376ac41$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $8FY87.useContext)((0, $6y205.LayoutGroupContext)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $c1fb8b13d376ac41$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $8FY87.useContext)((0, $h0Eto.LazyContext)).strict;
}
function $c1fb8b13d376ac41$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $fz2io.featureDefinitions);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}

});
parcelRegister("6y205", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", function () { return $13a2d52218ee3252$export$a3579ca508007a95; });

var $8FY87 = parcelRequire("8FY87");
"use client";
const $13a2d52218ee3252$export$a3579ca508007a95 = (0, $8FY87.createContext)({});

});

parcelRegister("i7M4t", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", function () { return $52d43d1d14d1038b$export$22a697fb29aac98d; });

var $8FY87 = parcelRequire("8FY87");
"use client";
/**
 * @public
 */ const $52d43d1d14d1038b$export$22a697fb29aac98d = (0, $8FY87.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});

});

parcelRegister("cPSOv", function(module, exports) {

$parcel$export(module.exports, "MotionContext", function () { return $852d31e93c74cc73$export$2285bbca2c666415; });

var $8FY87 = parcelRequire("8FY87");
"use client";
const $852d31e93c74cc73$export$2285bbca2c666415 = (0, $8FY87.createContext)({});

});

parcelRegister("eFlre", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", function () { return $1f6e06ed82671458$export$c5638d843b37a176; });

var $8FY87 = parcelRequire("8FY87");

var $cPSOv = parcelRequire("cPSOv");

var $JlRSf = parcelRequire("JlRSf");
function $1f6e06ed82671458$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $JlRSf.getCurrentTreeVariants)(props, (0, $8FY87.useContext)((0, $cPSOv.MotionContext)));
    return (0, $8FY87.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $1f6e06ed82671458$var$variantLabelsAsDependency(initial),
        $1f6e06ed82671458$var$variantLabelsAsDependency(animate)
    ]);
}
function $1f6e06ed82671458$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("JlRSf", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", function () { return $c11908b635a2632c$export$12fc32fc096a04a3; });

var $7upgv = parcelRequire("7upgv");

var $5EVuK = parcelRequire("5EVuK");
function $c11908b635a2632c$export$12fc32fc096a04a3(props, context) {
    if ((0, $5EVuK.isControllingVariants)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $7upgv.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $7upgv.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});


parcelRegister("cb3r2", function(module, exports) {

$parcel$export(module.exports, "motionComponentSymbol", function () { return $51fd590ebb86fe0b$export$28e2e4cce424ae23; });
const $51fd590ebb86fe0b$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");

});

parcelRegister("8442R", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", function () { return $212011c7c75ee146$export$c684914703d321fd; });

var $8FY87 = parcelRequire("8FY87");

var $8Fk65 = parcelRequire("8Fk65");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $212011c7c75ee146$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $8FY87.useCallback)((instance)=>{
        if (instance) visualState.onMount && visualState.onMount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $8Fk65.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

});
parcelRegister("8Fk65", function(module, exports) {

$parcel$export(module.exports, "isRefObject", function () { return $123a914f709f8eaa$export$dedd81df7bc1307; });
function $123a914f709f8eaa$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});


parcelRegister("334Vg", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", function () { return $349c83cb130bcafe$export$dc0335d73ab0b115; });

var $8FY87 = parcelRequire("8FY87");

var $5Hs9x = parcelRequire("5Hs9x");

var $cPSOv = parcelRequire("cPSOv");

var $1fuqy = parcelRequire("1fuqy");

var $h0Eto = parcelRequire("h0Eto");

var $i7M4t = parcelRequire("i7M4t");

var $dsanY = parcelRequire("dsanY");

var $dVBJw = parcelRequire("dVBJw");

var $8Fk65 = parcelRequire("8Fk65");

var $5DjGM = parcelRequire("5DjGM");
function $349c83cb130bcafe$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a, _b;
    const { visualElement: parent } = (0, $8FY87.useContext)((0, $cPSOv.MotionContext));
    const lazyContext = (0, $8FY87.useContext)((0, $h0Eto.LazyContext));
    const presenceContext = (0, $8FY87.useContext)((0, $5Hs9x.PresenceContext));
    const reducedMotionConfig = (0, $8FY87.useContext)((0, $i7M4t.MotionConfigContext)).reducedMotion;
    const visualElementRef = (0, $8FY87.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $8FY87.useContext)((0, $5DjGM.SwitchLayoutGroupContext));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $349c83cb130bcafe$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $8FY87.useRef)(false);
    (0, $8FY87.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $dsanY.optimizedAppearDataAttribute];
    const wantsHandoff = (0, $8FY87.useRef)(Boolean(optimisedAppearId) && !((_a = window.MotionHandoffIsComplete) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)) && ((_b = window.MotionHasOptimisedAnimation) === null || _b === void 0 ? void 0 : _b.call(window, optimisedAppearId)));
    (0, $1fuqy.useIsomorphicLayoutEffect)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        (0, $dVBJw.microtask).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $8FY87.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                var _a;
                (_a = window.MotionHandoffMarkAsComplete) === null || _a === void 0 || _a.call(window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
    });
    return visualElement;
}
function $349c83cb130bcafe$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $349c83cb130bcafe$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $8Fk65.isRefObject)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $349c83cb130bcafe$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $349c83cb130bcafe$var$getClosestProjectingNode(visualElement.parent);
}

});
parcelRegister("5Hs9x", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", function () { return $154ec1fe5c5db98c$export$f224e4635b6f8ce2; });

var $8FY87 = parcelRequire("8FY87");
"use client";
/**
 * @public
 */ const $154ec1fe5c5db98c$export$f224e4635b6f8ce2 = (0, $8FY87.createContext)(null);

});

parcelRegister("1fuqy", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $a5031065dccda2ee$export$700979bc83e7db82; });

var $8FY87 = parcelRequire("8FY87");

var $dZKvQ = parcelRequire("dZKvQ");
const $a5031065dccda2ee$export$700979bc83e7db82 = (0, $dZKvQ.isBrowser) ? (0, $8FY87.useLayoutEffect) : (0, $8FY87.useEffect);

});

parcelRegister("dVBJw", function(module, exports) {

$parcel$export(module.exports, "microtask", function () { return $e6d9e0c26e21e8be$export$bb76eed83315504c; });

var $7e1nO = parcelRequire("7e1nO");
const { schedule: $e6d9e0c26e21e8be$export$bb76eed83315504c, cancel: $e6d9e0c26e21e8be$export$3252729004b8456e } = (0, $7e1nO.createRenderBatcher)(queueMicrotask, false);

});

parcelRegister("5DjGM", function(module, exports) {

$parcel$export(module.exports, "SwitchLayoutGroupContext", function () { return $ba7ee85842fb07de$export$da5f7b802957459a; });

var $8FY87 = parcelRequire("8FY87");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $ba7ee85842fb07de$export$da5f7b802957459a = (0, $8FY87.createContext)({});

});



parcelRegister("iODdD", function(module, exports) {

$parcel$export(module.exports, "svgMotionConfig", function () { return $7af3f58c5f5ffa29$export$44dabd3fae512e85; });

var $26AI3 = parcelRequire("26AI3");

var $4ffba = parcelRequire("4ffba");

var $301nj = parcelRequire("301nj");

var $iyj4g = parcelRequire("iyj4g");

var $6FAyD = parcelRequire("6FAyD");

var $mzfai = parcelRequire("mzfai");

var $5VMyx = parcelRequire("5VMyx");

var $fxQ2n = parcelRequire("fxQ2n");
function $7af3f58c5f5ffa29$var$updateSVGDimensions(instance, renderState) {
    try {
        renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
    } catch (e) {
        // Most likely trying to measure an unrendered element under Firefox
        renderState.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}
const $7af3f58c5f5ffa29$var$layoutProps = [
    "x",
    "y",
    "width",
    "height",
    "cx",
    "cy",
    "r"
];
const $7af3f58c5f5ffa29$export$44dabd3fae512e85 = {
    useVisualState: (0, $4ffba.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $fxQ2n.scrapeMotionValuesFromProps),
        createRenderState: (0, $6FAyD.createSvgRenderState),
        onUpdate: ({ props: props, prevProps: prevProps, current: current, renderState: renderState, latestValues: latestValues })=>{
            if (!current) return;
            let hasTransform = !!props.drag;
            if (!hasTransform) {
                for(const key in latestValues)if ((0, $301nj.transformProps).has(key)) {
                    hasTransform = true;
                    break;
                }
            }
            if (!hasTransform) return;
            let needsMeasure = !prevProps;
            if (prevProps) /**
                 * Check the layout props for changes, if any are found we need to
                 * measure the element again.
                 */ for(let i = 0; i < $7af3f58c5f5ffa29$var$layoutProps.length; i++){
                const key = $7af3f58c5f5ffa29$var$layoutProps[i];
                if (props[key] !== prevProps[key]) needsMeasure = true;
            }
            if (!needsMeasure) return;
            (0, $26AI3.frame).read(()=>{
                $7af3f58c5f5ffa29$var$updateSVGDimensions(current, renderState);
                (0, $26AI3.frame).render(()=>{
                    (0, $iyj4g.buildSVGAttrs)(renderState, latestValues, (0, $mzfai.isSVGTag)(current.tagName), props.transformTemplate);
                    (0, $5VMyx.renderSVG)(current, renderState);
                });
            });
        }
    })
};

});
parcelRegister("4ffba", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", function () { return $901e9f09bbd547de$export$e91e107bc6d03a8e; });

var $8FY87 = parcelRequire("8FY87");

var $dHb9C = parcelRequire("dHb9C");

var $cPSOv = parcelRequire("cPSOv");

var $5Hs9x = parcelRequire("5Hs9x");

var $5EVuK = parcelRequire("5EVuK");

var $80nvV = parcelRequire("80nvV");

var $cYj8u = parcelRequire("cYj8u");

var $l8hBT = parcelRequire("l8hBT");
function $901e9f09bbd547de$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onUpdate: onUpdate }, props, context, presenceContext) {
    const state = {
        latestValues: $901e9f09bbd547de$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onUpdate) {
        /**
         * onMount works without the VisualElement because it could be
         * called before the VisualElement payload has been hydrated.
         * (e.g. if someone is using m components <m.circle />)
         */ state.onMount = (instance)=>onUpdate({
                props: props,
                current: instance,
                ...state
            });
        state.onUpdate = (visualElement)=>onUpdate(visualElement);
    }
    return state;
}
const $901e9f09bbd547de$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $8FY87.useContext)((0, $cPSOv.MotionContext));
        const presenceContext = (0, $8FY87.useContext)((0, $5Hs9x.PresenceContext));
        const make = ()=>$901e9f09bbd547de$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $cYj8u.useConstant)(make);
    };
function $901e9f09bbd547de$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $l8hBT.resolveMotionValue)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $5EVuK.isControllingVariants)(props);
    const isVariantNode$1 = (0, $5EVuK.isVariantNode)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $dHb9C.isAnimationControls)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $80nvV.resolveVariantFromProps)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}

});
parcelRegister("cYj8u", function(module, exports) {

$parcel$export(module.exports, "useConstant", function () { return $d490c9b2a1ca629f$export$fe4300aa8eebea86; });

var $8FY87 = parcelRequire("8FY87");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $d490c9b2a1ca629f$export$fe4300aa8eebea86(init) {
    const ref = (0, $8FY87.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});

parcelRegister("l8hBT", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", function () { return $cfa7e7df1a4b8bb4$export$fcc2206ecb6d74b; });

var $e6m6D = parcelRequire("e6m6D");

var $fCd14 = parcelRequire("fCd14");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $cfa7e7df1a4b8bb4$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $fCd14.isMotionValue)(value) ? value.get() : value;
    return (0, $e6m6D.isCustomValue)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

});


parcelRegister("6FAyD", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", function () { return $fd802be6165a3d32$export$41be8b43e1c4d4f9; });

var $kcUp4 = parcelRequire("kcUp4");
const $fd802be6165a3d32$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $kcUp4.createHtmlRenderState)(),
        attrs: {}
    });

});
parcelRegister("kcUp4", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", function () { return $c1805c601e89ece9$export$8940b483cf52eeda; });
const $c1805c601e89ece9$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });

});



parcelRegister("fXpRm", function(module, exports) {

$parcel$export(module.exports, "htmlMotionConfig", function () { return $348606bf1e84005f$export$e13ea21d87ea57c8; });

var $4ffba = parcelRequire("4ffba");

var $5JR6Z = parcelRequire("5JR6Z");

var $kcUp4 = parcelRequire("kcUp4");
const $348606bf1e84005f$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $4ffba.makeUseVisualState)({
        scrapeMotionValuesFromProps: $5JR6Z.scrapeMotionValuesFromProps,
        createRenderState: (0, $kcUp4.createHtmlRenderState)
    })
};

});

parcelRegister("j0l20", function(module, exports) {

$parcel$export(module.exports, "createUseRender", function () { return $1cab1e927dd2ba2a$export$5d29104eefd89cc8; });

var $8FY87 = parcelRequire("8FY87");

var $dqhnz = parcelRequire("dqhnz");

var $6CLrm = parcelRequire("6CLrm");

var $bK8RR = parcelRequire("bK8RR");

var $dCVL8 = parcelRequire("dCVL8");

var $fCd14 = parcelRequire("fCd14");
function $1cab1e927dd2ba2a$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $bK8RR.isSVGComponent)(Component) ? (0, $dCVL8.useSVGProps) : (0, $dqhnz.useHTMLProps);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $6CLrm.filterProps)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $8FY87.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $8FY87.useMemo)(()=>(0, $fCd14.isMotionValue)(children) ? children.get() : children, [
            children
        ]);
        return (0, $8FY87.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}

});
parcelRegister("dqhnz", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", function () { return $eb54cdd9048307cd$export$40dafdb8630c956b; });
$parcel$export(module.exports, "useHTMLProps", function () { return $eb54cdd9048307cd$export$57be0a314572d87d; });

var $8FY87 = parcelRequire("8FY87");

var $h5o7w = parcelRequire("h5o7w");

var $fCd14 = parcelRequire("fCd14");

var $16Fu7 = parcelRequire("16Fu7");

var $kcUp4 = parcelRequire("kcUp4");
function $eb54cdd9048307cd$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $fCd14.isMotionValue)(source[key]) && !(0, $h5o7w.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $eb54cdd9048307cd$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $8FY87.useMemo)(()=>{
        const state = (0, $kcUp4.createHtmlRenderState)();
        (0, $16Fu7.buildHTMLStyles)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $eb54cdd9048307cd$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $eb54cdd9048307cd$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $eb54cdd9048307cd$var$useInitialMotionValues(props, visualState));
    return style;
}
function $eb54cdd9048307cd$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $eb54cdd9048307cd$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}

});

parcelRegister("6CLrm", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $71827d03bc827c68$export$d697c39a2985a4c; });

var $gVVvs = parcelRequire("gVVvs");
let $71827d03bc827c68$var$shouldForward = (key)=>!(0, $gVVvs.isValidMotionProp)(key);
function $71827d03bc827c68$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $71827d03bc827c68$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $gVVvs.isValidMotionProp)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $71827d03bc827c68$export$59d6962c470509a5((parcelRequire("7fY6k")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $71827d03bc827c68$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($71827d03bc827c68$var$shouldForward(key) || forwardMotionProps === true && (0, $gVVvs.isValidMotionProp)(key) || !isDom && !(0, $gVVvs.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}

});
parcelRegister("gVVvs", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", function () { return $ff1022d94cbf33ca$export$2f9c46555243bf04; });
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $ff1022d94cbf33ca$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $ff1022d94cbf33ca$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $ff1022d94cbf33ca$var$validMotionProps.has(key);
}

});

parcelRegister("7fY6k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54888def81595797$export$2e2bcd8739ae039; });

var $chUI2 = parcelRequire("chUI2");
// eslint-disable-next-line no-undef
var $54888def81595797$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $54888def81595797$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $chUI2.default)(function(prop) {
    return $54888def81595797$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("chUI2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f230fd7415c39d6$export$2e2bcd8739ae039; });
function $8f230fd7415c39d6$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("dCVL8", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", function () { return $274fcba3eb655726$export$84309c4f53cb1bd5; });

var $8FY87 = parcelRequire("8FY87");

var $dqhnz = parcelRequire("dqhnz");

var $iyj4g = parcelRequire("iyj4g");

var $6FAyD = parcelRequire("6FAyD");

var $mzfai = parcelRequire("mzfai");
function $274fcba3eb655726$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $8FY87.useMemo)(()=>{
        const state = (0, $6FAyD.createSvgRenderState)();
        (0, $iyj4g.buildSVGAttrs)(state, visualState, (0, $mzfai.isSVGTag)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $dqhnz.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}

});





parcelRegister("51Ucj", function(module, exports) {

$parcel$export(module.exports, "containerVariants", function () { return $b0e9a74b4d290c37$export$6e1b7769725d9ca1; });
$parcel$export(module.exports, "itemVariants", function () { return $b0e9a74b4d290c37$export$e297faf3bc916948; });
$parcel$export(module.exports, "itemVariantsNoY", function () { return $b0e9a74b4d290c37$export$baba5b68ea182a83; });
$parcel$export(module.exports, "itemFadeIn", function () { return $b0e9a74b4d290c37$export$9d265f146869225a; });
$parcel$export(module.exports, "textVariants", function () { return $b0e9a74b4d290c37$export$47e553519a731635; });
$parcel$export(module.exports, "heroHeadingVariants", function () { return $b0e9a74b4d290c37$export$ff4551d7e29bf0b4; });
$parcel$export(module.exports, "lineTextVariants", function () { return $b0e9a74b4d290c37$export$16f0d1e44d75e8bc; });
$parcel$export(module.exports, "viewPort", function () { return $b0e9a74b4d290c37$export$fac710d19f78fea1; });
const $b0e9a74b4d290c37$export$6e1b7769725d9ca1 = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            duration: 0.5,
            when: 'beforeChildren',
            staggerChildren: 0.2
        }
    }
};
const $b0e9a74b4d290c37$export$e297faf3bc916948 = {
    hidden: {
        opacity: 0,
        y: 20
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.5
        }
    }
};
const $b0e9a74b4d290c37$export$baba5b68ea182a83 = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            duration: 0.5
        }
    }
};
const $b0e9a74b4d290c37$export$9d265f146869225a = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            duration: 0.3
        }
    }
};
const $b0e9a74b4d290c37$export$47e553519a731635 = {
    hidden: {
        opacity: 0,
        y: 50,
        transition: {
            duration: 0.6,
            ease: [
                0.6,
                0,
                0.4,
                1
            ],
            delay: 0
        }
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: [
                0.6,
                0,
                0.4,
                1
            ],
            delay: 0.2
        }
    }
};
const $b0e9a74b4d290c37$export$ff4551d7e29bf0b4 = {
    hidden: {
        opacity: 0,
        y: 50,
        transition: {
            duration: 0.8,
            ease: [
                0.6,
                0,
                0.4,
                1
            ],
            delay: 0
        }
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.8,
            ease: [
                0.6,
                0,
                0.4,
                1
            ],
            delay: 0
        }
    }
};
const $b0e9a74b4d290c37$export$16f0d1e44d75e8bc = {
    hidden: {
        width: 0,
        marginRight: 0,
        transition: {
            duration: 1.2,
            ease: [
                0.6,
                0,
                0.4,
                1
            ],
            delay: 0
        }
    },
    visible: {
        width: 65,
        marginRight: 16,
        transition: {
            width: {
                duration: 1.2,
                ease: [
                    0.6,
                    0,
                    0.4,
                    1
                ],
                delay: 0.8
            },
            marginRight: {
                duration: 1.2,
                ease: [
                    0.6,
                    0,
                    0.4,
                    1
                ],
                delay: 0.6
            }
        }
    }
};
const $b0e9a74b4d290c37$export$f6f3c43afe71d731 = {
    hidden: {
        opacity: 0,
        height: 0
    },
    visible: {
        opacity: 1,
        height: 'auto'
    }
};
const $b0e9a74b4d290c37$export$fac710d19f78fea1 = {
    once: true,
    margin: '-100px'
};

});

parcelRegister("jeu8h", function(module, exports) {

$parcel$export(module.exports, "TwoFlexibleComponentBox", function () { return $c3c2020f985d3b71$export$d075bf33ec1e6582; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");
const $c3c2020f985d3b71$export$d075bf33ec1e6582 = ({ firstComponent: firstComponent, secondComponent: secondComponent, mobilFirstComponentOnTop: mobilFirstComponentOnTop = true, desktopFirstComponentFirst: desktopFirstComponentFirst = true, firstComponentWidth: firstComponentWidth = 'col-span-4', secondComponentWidth: secondComponentWidth = 'col-span-4', mainBoxClassName: mainBoxClassName = '', firstComponentClassName: firstComponentClassName = '', secondComponentClassName: secondComponentClassName = '', noGap: noGap = false })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        variants: (0, $51Ucj.containerVariants),
        className: `grid lg:grid-cols-8 w-full ${mainBoxClassName} ${!noGap && 'gap-y-4'}`,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                variants: (0, $51Ucj.itemVariantsNoY),
                className: `${firstComponentWidth} ${firstComponentClassName} ${mobilFirstComponentOnTop ? 'order-1' : 'order-2'} ${desktopFirstComponentFirst ? 'lg:order-1' : 'lg:order-2'}`,
                children: firstComponent
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                variants: (0, $51Ucj.itemVariantsNoY),
                className: `${secondComponentWidth} ${secondComponentClassName} ${mobilFirstComponentOnTop ? 'order-2' : 'order-1'} ${desktopFirstComponentFirst ? 'lg:order-2' : 'lg:order-1'}`,
                children: secondComponent
            })
        ]
    });
};

});

parcelRegister("f0NwZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $397ae6cb54e0e19b$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $1lSPe = parcelRequire("1lSPe");

var $kM2Bn = parcelRequire("kM2Bn");

var $fMrFX = parcelRequire("fMrFX");
const $397ae6cb54e0e19b$var$Snippet = ({ page: page, props: props })=>{
    const [includeFont, setIncludeFont] = (0, $8FY87.useState)(false);
    const jsSnippet = `<script
  type="module"
  src="https://kia-pages-cdn.vercel.app/prod/load.js"
></script>`;
    const kebabize = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
    const makeIntoDataProp = (props = '')=>{
        if (!props) return '';
        return props.match(/([a-zA-ZäöåÄÖÅ-]+)="([^"]*)"/g) // Updated regex to capture everything within quotes
        .map((e)=>{
            const [key, value] = e.split(/=(.+)/); // Split only at the first equals sign
            return `data-${kebabize(key)}=${value}`;
        }).join(' ');
    };
    const htmlSnippet = `<div id="kia-page" data-kia-page="${page}" ${makeIntoDataProp(props) ?? ''} ${includeFont ? 'data-include-font' : ''} ></div>`;
    const copySnippet = ()=>{
        navigator.clipboard.writeText(`${jsSnippet}\n${htmlSnippet}`);
    };
    const [showSnippet, setShowSnippet] = (0, $8FY87.useState)(false);
    return (0, $1lSPe.locationIsKia)() ? null : /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            showSnippet ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kM2Bn.default), {
                clickOutside: ()=>setShowSnippet(false),
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "bg-white p-4",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                            className: "text-center text-2xl",
                            children: "Kodsnutt"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            className: "text-center",
                            children: "Kopiera koden nedan och klistra in i ett frikodsblock"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            className: "text-center",
                            children: "Scriptet ska endast laddas en g\xe5ng per sida"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: "flex items-center justify-between p-4 rounded-lg border mb-4",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                    className: "flex flex-col",
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                        htmlFor: "include-font",
                                        className: "text-sm font-medium cursor-pointer",
                                        children: "Inkludera Kia typsnitt"
                                    })
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("label", {
                                    className: "relative inline-flex items-center cursor-pointer",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                            type: "checkbox",
                                            id: "include-font",
                                            checked: includeFont,
                                            onChange: (e)=>setIncludeFont(e.target.checked),
                                            className: "sr-only peer"
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                            className: "w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-black/30 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-black"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: "bg-black p-4 text-white rounded-xl my-4",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("pre", {
                                className: "text-sm",
                                children: jsSnippet
                            })
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: "bg-black p-4 text-white rounded-xl my-4 max-w-lg overflow-auto",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("pre", {
                                className: "text-sm",
                                children: htmlSnippet
                            })
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: "flex justify-center gap-4",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                    onClick: copySnippet,
                                    className: "bg-black text-white p-2",
                                    children: "Kopiera"
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                    onClick: ()=>setShowSnippet(false),
                                    className: "bg-black text-white p-2",
                                    children: "St\xe4ng"
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                onClick: ()=>setShowSnippet(true),
                className: "z-10 fixed rounded-xl bg-black border-white border text-white p-2 bottom-2 right-2",
                children: "Visa kodsnutt"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $fMrFX.default), {
                page: page,
                props: props
            })
        ]
    });
};
var $397ae6cb54e0e19b$export$2e2bcd8739ae039 = $397ae6cb54e0e19b$var$Snippet;

});
parcelRegister("kM2Bn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef8ca3c2d735eb06$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");
const $ef8ca3c2d735eb06$var$Modal = ({ children: children, clickOutside: clickOutside })=>{
    (0, $8FY87.useEffect)(()=>{
        const onKey = (e)=>{
            if (e.key === 'Escape' && clickOutside) clickOutside();
        };
        document.addEventListener('keydown', onKey);
        return ()=>document.removeEventListener('keydown', onKey);
    }, [
        clickOutside
    ]);
    const handleClickOutside = (e)=>{
        if (e.target === e.currentTarget && clickOutside) clickOutside();
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        onClick: (e)=>handleClickOutside(e),
        className: "fixed top-0 right-0 left-0 w-dvh h-dvh flex justify-center items-center bg-black/90 z-30",
        children: children
    });
};
var $ef8ca3c2d735eb06$export$2e2bcd8739ae039 = $ef8ca3c2d735eb06$var$Modal;

});

parcelRegister("fMrFX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44a5561e2149edd1$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $kM2Bn = parcelRequire("kM2Bn");
function $44a5561e2149edd1$export$2e2bcd8739ae039({ page: page, props: props }) {
    const [isShowing, setIsShowing] = (0, $8FY87.useState)(false);
    const jsSnippet = `<script
  type="module"
  src="https://kia-pages-cdn.vercel.app/widget/widget.js"
></script>`;
    const kebabize = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
    const makeIntoDataProp = (props = '')=>{
        if (!props) return '';
        return props.match(/([a-zA-ZäöåÄÖÅ-]+)="([^"]*)"/g) // Updated regex to capture everything within quotes
        .map((e)=>{
            const [key, value] = e.split(/=(.+)/); // Split only at the first equals sign
            return `${kebabize(key)}=${value}`;
        }).join(' ');
    };
    const htmlSnippet = `<kia-widget kia-page="${page}" ${makeIntoDataProp(props) ?? ''}></kia-widget>`;
    const copySnippet = ()=>{
        navigator.clipboard.writeText(`${jsSnippet}\n${htmlSnippet}`);
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            isShowing ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kM2Bn.default), {
                clickOutside: ()=>setIsShowing(false),
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "bg-white p-4",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                            className: "text-center text-2xl",
                            children: "Kodsnutt"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            className: "text-center",
                            children: "Kopiera koden nedan och klistra in i ett frikodsblock"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            className: "text-center",
                            children: "Scriptet ska endast laddas en g\xe5ng per sida"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: "bg-black p-4 text-white rounded-xl my-4",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("pre", {
                                className: "text-sm",
                                children: jsSnippet
                            })
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: "bg-black p-4 text-white rounded-xl my-4 max-w-lg overflow-auto",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("pre", {
                                className: "text-sm",
                                children: htmlSnippet
                            })
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: "flex justify-center gap-4",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                    onClick: copySnippet,
                                    className: "bg-black text-white p-2",
                                    children: "Kopiera"
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                    onClick: ()=>setIsShowing(false),
                                    className: "bg-black text-white p-2",
                                    children: "St\xe4ng"
                                })
                            ]
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                onClick: ()=>setIsShowing(true),
                className: "z-10 fixed rounded-xl bg-black border-white border text-white p-2 bottom-2 left-2",
                children: "Visa webbkomponent kodsnutt"
            })
        ]
    });
}

});


parcelRegister("3eb7t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32a00675f3030559$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
parcelRequire("8FY87");
// const CDN_DOMAIN = 'https://kia-afonso.b-cdn.net';
//someting wrong with bunny so revering using kia.com for now
const $32a00675f3030559$var$CDN_DOMAIN = 'https://www.kia.com';
const $32a00675f3030559$var$ORIGINAL_DOMAIN = 'kia.com';
const $32a00675f3030559$var$KIAImage = ({ src: src, alt: alt, width: width = '100%', height: height = 0, quality: quality = 80, sizes: sizes, loading: loading = 'lazy', className: className, style: style })=>{
    const isKiaUrl = (url)=>url && url.includes($32a00675f3030559$var$ORIGINAL_DOMAIN);
    const generateSrcSet = (path)=>{
        const resolutions = [
            640,
            1080,
            1920,
            2560
        ];
        return resolutions.map((res)=>`${$32a00675f3030559$var$CDN_DOMAIN}/${path}?width=${res}&q=${quality} ${res}w`).join(', ');
    };
    let finalSrc = src;
    let srcSet;
    if (isKiaUrl(src)) {
        const urlParts = new URL(src);
        const path = urlParts.pathname + urlParts.search + urlParts.hash;
        finalSrc = `${$32a00675f3030559$var$CDN_DOMAIN}${path}?w=${width}&quality=${quality}`;
        srcSet = generateSrcSet(path);
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
        src: finalSrc,
        alt: alt,
        width: width,
        height: height,
        sizes: sizes,
        srcSet: srcSet,
        loading: loading,
        className: className,
        style: style
    });
};
var $32a00675f3030559$export$2e2bcd8739ae039 = $32a00675f3030559$var$KIAImage;

});

parcelRegister("2FCIq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $289bcdcc32675ffb$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $655D0 = parcelRequire("655D0");
const $289bcdcc32675ffb$var$LinkButton = ({ text: text, url: url, textSize: textSize = '16px', bgColor: bgColor = 'black', textColor: textColor = 'white', className: className = '', widthClass: widthClass = 'w-72', openInNewTab: openInNewTab = false })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
        href: url,
        target: openInNewTab ? '_blank' : '_self',
        rel: openInNewTab ? 'noopener noreferrer' : undefined,
        onClick: ()=>{
            if (url?.includes('sok-aterforsaljare-verkstad')) (0, $655D0.trackEvent)({
                event: 'find_a_dealer',
                model: undefined
            });
        },
        className: `${widthClass} bg-black hover:underline no-underline underline-offset-2 text-white  px-2 py-3 flex items-center justify-center ${className}`,
        style: {
            fontSize: textSize,
            backgroundColor: bgColor,
            color: textColor
        },
        children: text
    });
};
var $289bcdcc32675ffb$export$2e2bcd8739ae039 = $289bcdcc32675ffb$var$LinkButton;

});
parcelRegister("655D0", function(module, exports) {

$parcel$export(module.exports, "trackLinkClick", function () { return $60d64c2b3b4f0225$export$8ccbb8f33d016c10; });
$parcel$export(module.exports, "trackEvent", function () { return $60d64c2b3b4f0225$export$73d0a139caca1fee; });
// To see what to track: https://docs.google.com/document/d/1vqI8ffNHczh3FX_xYfUE-0AFbrcvz70uI74dk539w-I/edit?tab=t.0
const $60d64c2b3b4f0225$export$858a5fbee43159cd = (href, baseUrl)=>{
    if (!href.trim() || href.trim().startsWith('#')) return;
    try {
        const url = new URL(href, baseUrl);
        if ((url.protocol === 'https:' || url.protocol === 'http:') && (url.hostname === 'www.kia.com' || url.hostname === 'kia.com')) switch(url.pathname.replace(/\/$/, '')){
            case '/se/sok-aterforsaljare-verkstad':
                return {
                    event: 'find_a_dealer',
                    model: undefined
                };
            case '/se/provkor':
                return {
                    event: 'contact_dealer',
                    model: undefined
                };
        }
    } catch  {
    // Invalid CMS URLs should not break interaction with the page.
    }
};
const $60d64c2b3b4f0225$export$8ccbb8f33d016c10 = (event)=>{
    const input = $60d64c2b3b4f0225$export$858a5fbee43159cd(event.currentTarget.getAttribute('href') ?? '', document.baseURI);
    if (input) $60d64c2b3b4f0225$export$73d0a139caca1fee(input);
};
const $60d64c2b3b4f0225$export$73d0a139caca1fee = (input)=>{
    if (typeof window !== 'undefined') {
        const event = input.event === 'contact_dealer' ? {
            event: input.event,
            vehicle_nameplate: input.model?.name,
            vehicle_type: input.model?.type?.name
        } : input.event === 'find_a_dealer' ? {
            event: input.event,
            vehicle_nameplate: input.model?.name,
            vehicle_type: input.model?.type?.name,
            vehicle_year: undefined,
            vehicle_trim: input.trim?.name,
            form_step: input.form_step ?? 'contact dealer',
            zip_code: input.zip_code,
            dealer_id: input.dealer_id,
            dealer_name: input.dealer_name
        } : input;
        window.dataLayer = window.dataLayer || [];
        const payload = Object.fromEntries(Object.entries(event).map(([key, value])=>[
                key,
                value ?? undefined
            ]));
        window.dataLayer.push(payload);
    }
};

});


parcelRegister("cMeiR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7102d1b8095cf555$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $3eb7t = parcelRequire("3eb7t");
const $7102d1b8095cf555$var$TextOnImg = ({ image: image, altText: altText = '', title: title, subtitle: subtitle, position: position = 'bottom', hAlign: hAlign = 'center', titleClass: titleClass = 'text-3xl sm:text-4xl lg:text-5xl font-bold', subtitleClass: subtitleClass = 'text-base sm:text-lg lg:text-xl font-light', className: className = '' })=>{
    const posClass = position === 'top' ? 'top-4 sm:top-6 md:top-8 lg:top-12' : 'bottom-4 sm:bottom-6 md:bottom-8 lg:bottom-12';
    const hClass = hAlign === 'left' ? 'left-2 sm:left-4 md:left-8 lg:left-12 -translate-x-0 text-left' : 'left-1/2 -translate-x-1/2 text-center';
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: `relative w-full aspect-video overflow-hidden ${className}`,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                src: image,
                alt: altText,
                className: "absolute inset-0 w-full h-full object-cover",
                sizes: "100vw"
            }),
            (title || subtitle) && /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
                initial: "hidden",
                whileInView: "visible",
                variants: (0, $51Ucj.containerVariants),
                viewport: (0, $51Ucj.viewPort),
                className: `absolute ${hClass} ${posClass} px-0 md:px-4 space-y-2 text-white`,
                children: [
                    title && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                        variants: (0, $51Ucj.itemVariants),
                        className: `whitespace-pre-line break-normal hyphens-none leading-[1.1] ${titleClass}`,
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                        variants: (0, $51Ucj.itemVariants),
                        className: `whitespace-pre-line leading-[1] ${subtitleClass}`,
                        children: subtitle
                    })
                ]
            })
        ]
    });
};
var $7102d1b8095cf555$export$2e2bcd8739ae039 = $7102d1b8095cf555$var$TextOnImg;

});

parcelRegister("3m7pL", function(module, exports) {

$parcel$export(module.exports, "heroAE", function () { return $ca63e7c65e4eee27$export$346b6b0553daa59c; });
$parcel$export(module.exports, "textAE001", function () { return $ca63e7c65e4eee27$export$a634820eeb22b888; });
$parcel$export(module.exports, "smallAEImg001", function () { return $ca63e7c65e4eee27$export$d36fc7e34fb38b91; });
$parcel$export(module.exports, "smallAEImg002", function () { return $ca63e7c65e4eee27$export$bec4058ad1e364c9; });
$parcel$export(module.exports, "textAE002", function () { return $ca63e7c65e4eee27$export$a42775a589f54ab3; });
$parcel$export(module.exports, "textAE003", function () { return $ca63e7c65e4eee27$export$2cb211ea7aa70064; });
$parcel$export(module.exports, "linkAE01", function () { return $ca63e7c65e4eee27$export$36c3707cdaeb28df; });
$parcel$export(module.exports, "textAE004", function () { return $ca63e7c65e4eee27$export$7a124a8028c7ea2e; });
$parcel$export(module.exports, "textAE005", function () { return $ca63e7c65e4eee27$export$382cdfc882ba1fee; });
$parcel$export(module.exports, "linkAE02", function () { return $ca63e7c65e4eee27$export$e3c3d6e8ac257f08; });
$parcel$export(module.exports, "textAE006", function () { return $ca63e7c65e4eee27$export$5486098895605bde; });
$parcel$export(module.exports, "linkAE03", function () { return $ca63e7c65e4eee27$export$f5536f0ef24292f7; });
const $ca63e7c65e4eee27$export$346b6b0553daa59c = {
    image: 'https://kia-afonso-storage.b-cdn.net/Anpassningar/_smh9499.jpg',
    altText: "En vit och svart Kia PV5 Cargo-sk\xe5pbil med \xf6ppen sidod\xf6rr och lastutrymme med hyllor, parkerad p\xe5 grus framf\xf6r ett tr\xe4hus.",
    title: 'Nya Kia PV5 Cargo.',
    subtitle: "Byggd f\xf6r dig.",
    position: 'bottom',
    hAlign: 'left',
    titleClass: 'text-[clamp(38px,8vw,64px)] font-[400]',
    subtitleClass: 'text-[clamp(14px,5vw,24px)] font-[300]'
};
const $ca63e7c65e4eee27$export$a634820eeb22b888 = "Nya Kia PV5 Cargo har o\xe4ndliga m\xf6jligheter att anpassas efter era behov. Vi hj\xe4lper er att skr\xe4ddarsy transportbilen med de l\xf6sningar som kr\xe4vs f\xf6r er verksamhet och specifika krav. Det kan g\xe4lla allt ifr\xe5n dragkrok, varningsljus, specialbelysning, hyllsystem, s\xe4ker verktygsf\xf6rvaring till komplett inredning.";
const $ca63e7c65e4eee27$export$d36fc7e34fb38b91 = {
    src: 'https://kia-afonso-storage.b-cdn.net/Anpassningar/_SMH9231.jpg',
    alt: "En n\xe4rbild p\xe5 en person som b\xe4r arbetshandskar och drar ut en gr\xe5 metall\xe5da fr\xe5n ett modul\xe4rt hyllsystem monterat i en sk\xe5pbil.",
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto pt-0 w-full h-full object-cover'
};
const $ca63e7c65e4eee27$export$bec4058ad1e364c9 = {
    src: 'https://kia-afonso-storage.b-cdn.net/Anpassningar/_SMH9257.jpg',
    alt: 'En n\xe4rbild inuti en sk\xe5pbil som visar ett gr\xe5tt hyllsystem. En person drar ut en svart och gr\xf6n verktygsl\xe5da/sortimentsl\xe5da, m\xe4rkt med text som "SYSTEM EDSTR\xd6M", med sm\xe5 fack. Andra svarta f\xf6rvaringsl\xe5dor och gr\xf6na plastfack samt verktyg syns i hyllorna.',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto pt-0 w-full h-full object-cover'
};
const $ca63e7c65e4eee27$export$a42775a589f54ab3 = "En rullande verkstad och en arbetsplats som st\xe4ndigt \xe4r i r\xf6relse st\xe4ller krav p\xe5 utrustning och inredning. Det kr\xe4ver specialkunskap. V\xe5ra partners \xe4r experter p\xe5 inredning och specialanpassning av fordon. Det inneb\xe4r att ni t.ex kan lita p\xe5 att er transportbil har s\xe4kra hyllsystem, l\xe5dor och utrustning av h\xf6g kvalitet som klarar tuffa tag och \xe4r optimerade f\xf6r ett arbetsliv i r\xf6relse.";
const $ca63e7c65e4eee27$export$2cb211ea7aa70064 = "Kontakta din \xe5terf\xf6rs\xe4ljare s\xe5 optimerar ni tillsammans Kia PV5 Cargo efter just era behov. Vi ser sedan till att bilen levereras komplett och \xe4r redo att b\xf6rja jobba fr\xe5n dag ett.";
const $ca63e7c65e4eee27$export$36c3707cdaeb28df = {
    text: "Hitta din \xe5terf\xf6rs\xe4ljare",
    textSize: '16px',
    url: 'https://www.kia.com/se/sok-aterforsaljare-verkstad/#/',
    className: 'mt-6 mb-6 text-center ml-0 sm:ml-2 self-center sm:self-start md:self-end',
    widthClass: 'w-fit px-4 ',
    openInNewTab: false
};
const $ca63e7c65e4eee27$export$7a124a8028c7ea2e = "L\xe4s mer om v\xe5ra partners";
const $ca63e7c65e4eee27$export$382cdfc882ba1fee = 'Specialanpassning:';
const $ca63e7c65e4eee27$export$e3c3d6e8ac257f08 = {
    label: 'Bilbyggarna i Wallhamn',
    href: 'https://www.wallhamn.com/om-bilbyggarna',
    target: '_blank'
};
const $ca63e7c65e4eee27$export$5486098895605bde = 'Serviceinredning:';
const $ca63e7c65e4eee27$export$f5536f0ef24292f7 = {
    label: "System Edstr\xf6m",
    href: 'https://www.systemedstrom.com/sv/',
    target: '_blank'
};

});


parcelRegister("a2oQf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc1d2186e23d645c$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $f0NwZ = parcelRequire("f0NwZ");

var $ahfjd = parcelRequire("ahfjd");
const $fc1d2186e23d645c$var$Are = ()=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("center", {
                children: [
                    (0, $ahfjd.links).map((link, i)=>/*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                            style: {
                                backgroundColor: '#05141f',
                                border: 'none',
                                color: 'white',
                                padding: '15px 32px',
                                textAlign: 'center',
                                margin: '10px',
                                textDecoration: 'none',
                                display: 'block',
                                fontSize: '16px',
                                borderRadius: '2px',
                                width: '260px'
                            },
                            href: link.href,
                            target: link.href.includes('kia.com') ? '_self' : '_blank',
                            className: "btn btn--em btn--block-sm",
                            children: link.text
                        }, i)),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        style: {
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '5px'
                        },
                        children: (0, $ahfjd.socials).map((social, i)=>/*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                href: social.href,
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                                    style: {
                                        width: '100px',
                                        height: '100px'
                                    },
                                    src: social.icon,
                                    alt: social.alt
                                })
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        style: {
                            height: '100px'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                page: "are"
            })
        ]
    });
};
var $fc1d2186e23d645c$export$2e2bcd8739ae039 = $fc1d2186e23d645c$var$Are;

});
parcelRegister("ahfjd", function(module, exports) {

$parcel$export(module.exports, "socials", function () { return $e53164ef138ceaf5$export$8fdfb94761af3945; });
$parcel$export(module.exports, "links", function () { return $e53164ef138ceaf5$export$463d32b91de8b4d; });
const $e53164ef138ceaf5$export$8fdfb94761af3945 = [
    {
        href: 'https://www.facebook.com/KiaSweden/',
        icon: 'https://img.icons8.com/?size=100&id=13912&format=png&color=000000',
        alt: 'Facebook'
    },
    {
        href: 'https://www.linkedin.com/company/kia-sweden-ab/',
        icon: 'https://img.icons8.com/?size=100&id=13930&format=png&color=000000',
        alt: 'LinkedIn'
    },
    {
        href: 'https://www.instagram.com/kiasweden/',
        icon: 'https://img.icons8.com/?size=100&id=Xy10Jcu1L2Su&format=png&color=000000',
        alt: 'Email'
    }
];
const $e53164ef138ceaf5$export$463d32b91de8b4d = [
    {
        href: 'https://www.dropbox.com/scl/fi/u4mmz4gcpy3q1ve0h4w9l/Info-bro-FJM-2024-web.pdf?rlkey=7buvb541snkx1nwel90q454d3&dl=0',
        text: 'Schema 27/7 till 3/8'
    },
    {
        href: 'https://www.kia.com/se/nya-bilar/ev9/upptack/',
        text: 'Kia EV9'
    },
    {
        href: 'https://www.kia.com/se/nya-bilar/ev6/upptack/',
        text: 'Kia EV6'
    },
    {
        href: 'https://www.kia.com/se/nya-bilar/sorento-plug-in-hybrid/upptack/',
        text: 'Kia Sorento Plug-In Hybrid'
    },
    {
        href: 'https://www.kia.com/se/nya-bilar/sportage/upptack/',
        text: 'Kia Sportage Plug-In Hybrid'
    },
    {
        href: 'https://www.kia.com/se/broschyr/#/',
        text: 'Ladda ned faktablad'
    },
    {
        href: 'https://www.kia.com/se/tjanstebil/',
        text: "Kia som tj\xe4nstebil"
    },
    {
        href: 'https://www.kia.com/se/om-kia/upplev-kia/varumarke/sponsorskap/fjallmaraton/',
        text: "Kia Fj\xe4llmaraton"
    }
];

});


parcelRegister("7KXLb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2164ac76a379c572$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $crUoE = parcelRequire("crUoE");

var $9Pm4j = parcelRequire("9Pm4j");

var $lsG22 = parcelRequire("lsG22");

var $6z9m3 = parcelRequire("6z9m3");

var $jeu8h = parcelRequire("jeu8h");

var $f0NwZ = parcelRequire("f0NwZ");

var $3eb7t = parcelRequire("3eb7t");

var $2FCIq = parcelRequire("2FCIq");

var $c1M21 = parcelRequire("c1M21");
const $2164ac76a379c572$var$BehindTheSceens = ()=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("main", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $6z9m3.default), {
                ...(0, $c1M21.herobts)
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "w-full max-w-screen-kia mx-auto",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: " mx-auto px-6 w-full  max-w-7xl mb-8",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponentWidth: "col-span-4 lg:col-span-5",
                            secondComponentWidth: "col-span-4 lg:col-span-3",
                            mainBoxClassName: "mx-auto w-full max-w-7xl",
                            firstComponentClassName: "p-0",
                            secondComponentClassName: "p-0 lg:p-10 lg:pt-0",
                            mobilFirstComponentOnTop: false,
                            desktopFirstComponentFirst: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9Pm4j.default), {
                                videoId: "FLN6OG94SZc",
                                width: "100%",
                                height: "356px"
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: "mb-10 md:mb-0",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        className: "text-[23px] md:text-[32px] leading-[40px] mb-4",
                                        children: (0, $c1M21.twoComponentsTextbts01).title
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: "text-[16px] md:text[18px] leading-[24px] font-light",
                                        children: (0, $c1M21.twoComponentsTextbts01).text
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: " mx-auto px-6 w-full max-w-7xl mb-20 md:mb-28",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponentWidth: "col-span-4 lg:col-span-3",
                            secondComponentWidth: "col-span-4 lg:col-span-5",
                            mainBoxClassName: "mx-auto w-full max-w-7xl",
                            firstComponentClassName: "p-0 lg:p-10 lg:pt-0",
                            secondComponentClassName: "p-0 ",
                            mobilFirstComponentOnTop: true,
                            desktopFirstComponentFirst: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: "mb-10 md:mb-0",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        className: "text-[23px] md:text-[32px] leading-[40px] mb-4",
                                        children: (0, $c1M21.twoComponentsTextbts02).title
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: "text-[16px] md:text[18px] leading-[24px] font-light",
                                        children: (0, $c1M21.twoComponentsTextbts02).text
                                    })
                                ]
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9Pm4j.default), {
                                videoId: "b1XTh6x2yPA",
                                width: "100%",
                                height: "356px"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: " mx-auto px-6 w-full  max-w-7xl mb-8",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponentWidth: "col-span-4 lg:col-span-5",
                            secondComponentWidth: "col-span-4 lg:col-span-3",
                            mainBoxClassName: "mx-auto w-full max-w-7xl",
                            firstComponentClassName: "p-0",
                            secondComponentClassName: "p-0 lg:p-10 lg:pt-0",
                            mobilFirstComponentOnTop: false,
                            desktopFirstComponentFirst: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                ...(0, $c1M21.kiaImagebts03)
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        className: "text-[23px] md:text-[32px] leading-[40px] mb-4",
                                        children: (0, $c1M21.twoComponentsTextbts03).title
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: "text-[16px] md:text[18px] leading-[24px] font-light",
                                        children: (0, $c1M21.twoComponentsTextbts03).text
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "flex justify-center md:justify-start",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                            ...(0, $c1M21.linkbts03)
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: " mx-auto px-6 w-full  max-w-7xl mb-5",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponentWidth: "col-span-4 lg:col-span-3",
                            secondComponentWidth: "col-span-4 lg:col-span-5",
                            mainBoxClassName: "mx-auto w-full max-w-7xl",
                            firstComponentClassName: "p-0 lg:p-10 lg:pt-0",
                            secondComponentClassName: "p-0",
                            mobilFirstComponentOnTop: true,
                            desktopFirstComponentFirst: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        className: "text-[23px] md:text-[32px] leading-[40px] mb-4",
                                        children: (0, $c1M21.twoComponentsTextbts04).title
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: "text-[16px] md:text[18px] leading-[24px] font-light",
                                        children: (0, $c1M21.twoComponentsTextbts04).text
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "flex justify-center md:justify-start",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                            ...(0, $c1M21.linkbts04)
                                        })
                                    })
                                ]
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                ...(0, $c1M21.kiaImagebts04)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
                        className: " mx-auto px-6 w-full max-w-7xl mt-10 md:mt-28",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $lsG22.default), {
                                id: "subhedings",
                                className: "mb-1",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                                    className: "text-[23px] md:text-[32px] leading-[40px] mb-4",
                                    variants: (0, $51Ucj.itemVariants),
                                    children: (0, $c1M21.subheadingbts).heading
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $crUoE.default), {
                                images: (0, $c1M21.images)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                        page: "behind-the-sceens"
                    })
                ]
            })
        ]
    });
};
var $2164ac76a379c572$export$2e2bcd8739ae039 = $2164ac76a379c572$var$BehindTheSceens;

});
parcelRegister("crUoE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff8858bcc2f4bc06$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $3eb7t = parcelRequire("3eb7t");
const $ff8858bcc2f4bc06$var$ImgCarousel = ({ images: images, height: height = '', slideWidth: slideWidth = 500, gap: gap = 10 })=>{
    const containerRef = (0, $8FY87.useRef)(null);
    const [containerWidth, setContainerWidth] = (0, $8FY87.useState)(0);
    (0, $8FY87.useEffect)(()=>{
        const updateWidth = ()=>{
            if (containerRef.current) setContainerWidth(containerRef.current.offsetWidth);
        };
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return ()=>window.removeEventListener('resize', updateWidth);
    }, []);
    const CLONES = 4;
    const originalLength = images.length;
    const extendedImages = [
        ...images.slice(-CLONES),
        ...images,
        ...images.slice(0, CLONES)
    ];
    const [currentIndex, setCurrentIndex] = (0, $8FY87.useState)(CLONES);
    const [transitionEnabled, setTransitionEnabled] = (0, $8FY87.useState)(true);
    const moveDistance = slideWidth + gap;
    const centerOffset = (containerWidth - slideWidth) / 2;
    const totalOffset = currentIndex * moveDistance - centerOffset;
    const containerTransform = `translateX(-${totalOffset}px)`;
    const handleTransitionEnd = ()=>{
        if (currentIndex >= originalLength + CLONES) {
            setTransitionEnabled(false);
            setCurrentIndex(CLONES);
        } else if (currentIndex < CLONES) {
            setTransitionEnabled(false);
            setCurrentIndex(originalLength + CLONES - 1);
        }
    };
    (0, $8FY87.useEffect)(()=>{
        if (!transitionEnabled) {
            const timer = setTimeout(()=>setTransitionEnabled(true), 50);
            return ()=>clearTimeout(timer);
        }
    }, [
        transitionEnabled
    ]);
    const handlePrev = ()=>setCurrentIndex((i)=>i - 1);
    const handleNext = ()=>setCurrentIndex((i)=>i + 1);
    const touchStartX = (0, $8FY87.useRef)(null);
    const handleTouchStart = (e)=>{
        touchStartX.current = e.changedTouches[0].clientX;
    };
    const handleTouchMove = (e)=>{};
    const handleTouchEnd = (e)=>{
        if (touchStartX.current !== null) {
            const delta = touchStartX.current - e.changedTouches[0].clientX;
            const threshold = 50;
            if (delta > threshold) handleNext();
            if (delta < -threshold) handlePrev();
        }
        touchStartX.current = null;
    };
    const realIndex = (currentIndex - CLONES + originalLength) % originalLength;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        ref: containerRef,
        className: "relative w-full overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                onClick: handlePrev,
                className: "absolute left-4 top-1/2 -translate-y-1/2 z-10  bg-black bg-opacity-30 text-white rounded-full  p-2 hover:bg-opacity-50",
                "aria-label": "Previous slide",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 31 39",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                        d: "M29 37L4 17.4412L29 2",
                        stroke: "white",
                        strokeWidth: "4"
                    })
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                onClick: handleNext,
                className: "absolute right-4 top-1/2 -translate-y-1/2 z-10 bg-black bg-opacity-30 text-white rounded-full p-2 hover:bg-opacity-50",
                "aria-label": "Next slide",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 31 39",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                        d: "M2 37L27 17.4412L2 2",
                        stroke: "white",
                        strokeWidth: "4"
                    })
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "flex",
                style: {
                    transform: containerTransform,
                    transition: transitionEnabled ? 'transform 0.3s ease' : 'none',
                    gap: `${gap}px`
                },
                onTransitionEnd: handleTransitionEnd,
                onTouchStart: handleTouchStart,
                onTouchMove: handleTouchMove,
                onTouchEnd: handleTouchEnd,
                children: extendedImages.map((imgProps, idx)=>/*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "flex-shrink-0 relative",
                        style: {
                            minWidth: `${slideWidth}px`,
                            maxWidth: `${slideWidth}px`,
                            height: height
                        },
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                            ...imgProps,
                            height: height,
                            className: idx === currentIndex ? 'opacity-100' : 'opacity-50',
                            style: {
                                objectFit: 'cover',
                                width: '100%',
                                height: '100%'
                            }
                        })
                    }, idx))
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "flex justify-center mt-4",
                children: images.map((_, idx)=>/*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: `w-3 h-3 rounded-full mx-1 ${idx === realIndex ? 'bg-black' : 'bg-gray-300'}`
                    }, idx))
            })
        ]
    });
};
var $ff8858bcc2f4bc06$export$2e2bcd8739ae039 = $ff8858bcc2f4bc06$var$ImgCarousel;

});

parcelRegister("9Pm4j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81f5f2a9ceeb38ff$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
const $81f5f2a9ceeb38ff$var$YouTubeEmbed = ({ videoId: videoId, width: width = '100%', className: className = '' })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: `relative ${className}`,
        style: {
            width: width,
            paddingBottom: '56.25%',
            height: 0,
            overflow: 'hidden'
        },
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("iframe", {
            title: "YouTube Video",
            src: `https://www.youtube.com/embed/${videoId}?rel=0&loop=1&playlist=${videoId}`,
            style: {
                border: 0,
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
            },
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: true
        })
    });
};
var $81f5f2a9ceeb38ff$export$2e2bcd8739ae039 = $81f5f2a9ceeb38ff$var$YouTubeEmbed;

});

parcelRegister("lsG22", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2450ba61cc43470$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");
const $f2450ba61cc43470$var$AnimatedSection = ({ children: children, id: id, className: className, containerVariants: containerVariants = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.3
        }
    }
}, ...props })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).section, {
        id: id,
        className: className,
        variants: containerVariants,
        initial: "hidden",
        whileInView: "visible",
        viewport: {
            once: true
        },
        ...props,
        children: children
    });
};
var $f2450ba61cc43470$export$2e2bcd8739ae039 = $f2450ba61cc43470$var$AnimatedSection;

});

parcelRegister("6z9m3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c41960783010ebe6$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");
const $c41960783010ebe6$var$HeroPrivatLeasing = ({ image: image, title: title, subtitle: subtitle, mobileImage: mobileImage, position: position = 'center' })=>{
    const positionClass = {
        center: 'top-1/2 -translate-y-1/2',
        bottom: 'bottom-[86px]',
        top: 'top-[86px]'
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
        className: "relative flex w-full h-[80vh] max-h-[918] lg:max-h-[1018px] bg-cover bg-center lg:bg-[center_20%] text-white mb-14",
        style: {
            backgroundImage: `url(${image})`,
            backgroundColor: '#fafafa',
            ...mobileImage && {
                '--tw-bg-mobile': `url(${mobileImage})`
            }
        },
        children: (title || subtitle) && /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
            initial: "hidden",
            whileInView: "visible",
            variants: (0, $51Ucj.containerVariants),
            viewport: (0, $51Ucj.viewPort),
            className: `absolute text-center grid gap-1 text-white p-2 w-full left-1/2 -translate-x-1/2 ${positionClass[position]}`,
            children: [
                title && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h1, {
                    variants: (0, $51Ucj.itemVariants),
                    className: "font-medium leading-tight whitespace-pre-line",
                    style: {
                        fontSize: 'clamp(20px, 8vw, 72px)'
                    },
                    children: title
                }),
                subtitle && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                    variants: (0, $51Ucj.itemVariants),
                    className: "text-xl sm:text-2xl leading-tight whitespace-pre-line",
                    children: subtitle
                })
            ]
        })
    });
};
var $c41960783010ebe6$export$2e2bcd8739ae039 = $c41960783010ebe6$var$HeroPrivatLeasing;

});

parcelRegister("c1M21", function(module, exports) {

$parcel$export(module.exports, "herobts", function () { return $21f62ea50df2b892$export$c4effa4af90cc589; });
$parcel$export(module.exports, "twoComponentsTextbts01", function () { return $21f62ea50df2b892$export$b678b8d910080918; });
$parcel$export(module.exports, "twoComponentsTextbts02", function () { return $21f62ea50df2b892$export$d3120887a228af16; });
$parcel$export(module.exports, "kiaImagebts03", function () { return $21f62ea50df2b892$export$d89f8ccdbcd908a5; });
$parcel$export(module.exports, "twoComponentsTextbts03", function () { return $21f62ea50df2b892$export$413173f35308c0e7; });
$parcel$export(module.exports, "linkbts03", function () { return $21f62ea50df2b892$export$d57cea7b3ab1da25; });
$parcel$export(module.exports, "kiaImagebts04", function () { return $21f62ea50df2b892$export$fb9629f6fec28776; });
$parcel$export(module.exports, "twoComponentsTextbts04", function () { return $21f62ea50df2b892$export$2a0a568d25344598; });
$parcel$export(module.exports, "linkbts04", function () { return $21f62ea50df2b892$export$7fa711bafe3b4c78; });
$parcel$export(module.exports, "subheadingbts", function () { return $21f62ea50df2b892$export$37448c5a85848ff1; });
$parcel$export(module.exports, "images", function () { return $21f62ea50df2b892$export$6c746a5570b8b35c; });
const $21f62ea50df2b892$export$c4effa4af90cc589 = {
    title: 'Vidderna: live session.',
    subtitle: 'Driven av Kia EV6.',
    image: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-005.jpg',
    mobileImage: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-005.jpg'
};
const $21f62ea50df2b892$export$b678b8d910080918 = {
    title: 'Mot Vidderna',
    text: "En l\xe5t om svenskt vemod och det eviga s\xf6kandet efter ljuset. En toppmodern elbil med m\xf6jlighet att dela med sig av batteriets kapacitet via det som kallas f\xf6r Vehicle-to-Load. Tillsammans skapar de frihetsk\xe4nsla och l\xe4ngtan efter n\xe5got storslaget. Skruva upp volymen och lyssna p\xe5 en exklusiv livespelning av Vidderna, helt driven av el direkt fr\xe5n Kia EV6."
};
const $21f62ea50df2b892$export$d3120887a228af16 = {
    title: "En ov\xe4ntad v\xe4ndning",
    text: "Det bl\xe5ste och blev isande kallt l\xe4ngs den sk\xe5nska kusten. Tack vare en snabbt\xe4nkt manager och Kia EV6 som transportmedel kunde Bj\xf6rn Dixg\xe5rd och Patso Heikinpieti fr\xe5n Mando Diao styra om sina planer. Se v\xe4gen fram till spelningen h\xe4r."
};
const $21f62ea50df2b892$export$d89f8ccdbcd908a5 = {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-011.jpg',
    alt: 'Kia behind the scenes',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto pt-0 w-full '
};
const $21f62ea50df2b892$export$413173f35308c0e7 = {
    title: 'Laddad med Kia EV6',
    text: "Med Vehicle-to-Load kan EV6 dela med sig upp till 80 % av batteriets kapacitet via ett vanligt 230-voltsuttag, f\xf6r att f\xf6rse vad du \xe4n \xf6nskar med str\xf6m. Dessutom ger den oslagbar frihetsk\xe4nsla med upp till 582 km r\xe4ckvidd och ultrasnabb laddning, fr\xe5n 10\u201380 % p\xe5 ned till 18 minuter."
};
const $21f62ea50df2b892$export$d57cea7b3ab1da25 = {
    text: "Uppt\xe4ck EV6",
    textSize: '16px',
    url: ' https://www.kia.com/se/nya-bilar/ev6/upptack/',
    className: 'mt-6 mb-6 ',
    openInNewTab: false
};
const $21f62ea50df2b892$export$fb9629f6fec28776 = {
    src: 'https://kia-afonso-storage.b-cdn.net/kia/KIA-BD-EV6-HERO-B1.jpg',
    alt: 'KIA Bjorn',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto pt-0 w-full '
};
const $21f62ea50df2b892$export$2a0a568d25344598 = {
    title: "Bj\xf6rn Dixg\xe5rd om kreativitet",
    text: "Som frontman i Mando Diao har Bj\xf6rn Dixg\xe5rd r\xf6rt sig fr\xe5n sv\xe4ngig rock till svenskt vemod. Som egen artist kommer inspiration fr\xe5n countryscenen och den storslagna svenska naturen. M\xf6t mannen bakom musiken och h\xf6r hur en l\xe5t blir till."
};
const $21f62ea50df2b892$export$7fa711bafe3b4c78 = {
    text: "L\xe4s intervjun med Bj\xf6rn Dixg\xe5rd",
    textSize: '16px',
    url: 'https://story.kia.se/bjorn-dixgard-vidderna-ar-det-eviga-sokandet-efter-ljuset',
    className: 'mt-6 mb-6 ',
    openInNewTab: false
};
const $21f62ea50df2b892$export$37448c5a85848ff1 = {
    heading: "Fler bilder fr\xe5n spelningen"
};
const $21f62ea50df2b892$export$6c746a5570b8b35c = [
    {
        src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-023.jpg',
        alt: 'Kia behind the scenes',
        sizes: '(max-width: 768px) 100vw, 50vw'
    },
    {
        src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-007.jpg',
        alt: 'Kia behind the scenes',
        sizes: '(max-width: 768px) 100vw, 50vw'
    },
    {
        src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-009.jpg',
        alt: 'Kia behind the scenes',
        sizes: '(max-width: 768px) 100vw, 50vw'
    },
    {
        src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-016.jpg',
        alt: 'Kia behind the scenes',
        sizes: '(max-width: 768px) 100vw, 50vw'
    },
    {
        src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-024.jpg',
        alt: 'Kia behind the scenes',
        sizes: '(max-width: 768px) 100vw, 50vw'
    },
    {
        src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-030.jpg',
        alt: 'Kia behind the scenes',
        sizes: '(max-width: 768px) 100vw, 50vw'
    }
];

});


parcelRegister("e4coK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15ae5b1a31ce60a1$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $8mhoa = parcelRequire("8mhoa");

var $jZedf = parcelRequire("jZedf");

var $1lSPe = parcelRequire("1lSPe");

var $edALU = parcelRequire("edALU");

var $gjs5U = parcelRequire("gjs5U");

var $iH0Pu = parcelRequire("iH0Pu");

var $kM2Bn = parcelRequire("kM2Bn");

var $a3tFn = parcelRequire("a3tFn");

const $15ae5b1a31ce60a1$var$Snippet = /*#__PURE__*/ (0, $8FY87.lazy)(()=>Promise.resolve((parcelRequire("f0NwZ"))));

const $15ae5b1a31ce60a1$var$CarouselControls = /*#__PURE__*/ (0, $8FY87.lazy)(()=>(parcelRequire("hDVzU")));
const $15ae5b1a31ce60a1$var$maybeUniqId = (0, $1lSPe.getUniqId)();
const $15ae5b1a31ce60a1$var$PriceCardGrid = ({ fields: fields, imageType: imageType, trimCodes: trimCodes, modelCodes: modelCodes, hideControls: hideControls, uniqKey: uniqKey, onChangeTrims: onChangeTrims })=>{
    const uniqId = uniqKey || $15ae5b1a31ce60a1$var$maybeUniqId;
    const { dispatch: dispatch, options: options, direction: direction } = (0, $8mhoa.useStore)((0, $iH0Pu.getStoreByKey)(uniqId));
    const [cars, setCars] = (0, $8FY87.useState)([]);
    const [models, setModels] = (0, $8FY87.useState)([]);
    const [addTrim, setAddTrim] = (0, $8FY87.useState)(false);
    const [selectModel, setSelectModel] = (0, $8FY87.useState)(null);
    const [selectedTrimCode, setSelectedTrimCode] = (0, $8FY87.useState)(null);
    (0, $8FY87.useEffect)(()=>{
        if (onChangeTrims) onChangeTrims(cars);
    }, [
        cars
    ]);
    const setData = (models)=>{
        if (imageType) dispatch({
            type: 'IMAGE_TYPE',
            payload: imageType
        });
        if (fields) dispatch({
            type: 'CONTROLS',
            payload: fields.split(',')
        });
        dispatch({
            type: 'IS_LOADED',
            payload: true
        });
        // set the models and trim codes array
        if (modelCodes && trimCodes) setCars(modelCodes.split(',').map((modelCode, i)=>({
                model: models.find((m)=>m.code === modelCode),
                trimCode: trimCodes.split(',')[i]
            })));
    };
    const fetchModels = async ()=>{
        let models = JSON.parse(sessionStorage.getItem('kia-carousel-models')) ?? [];
        if (!models.length) try {
            const { data: data } = await (0, $jZedf.fetchWithType)((0, $1lSPe.getAdminUrl)() + '/api/models', {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${(0, $1lSPe.getApiToken)()}`
                }
            });
            if (data && data.length) {
                models = data;
                setModels(data);
            }
        } catch (error) {
            console.error('Error fetching trims:', error);
        }
        else setModels(models);
        setData(models);
    };
    (0, $8FY87.useEffect)(()=>{
        dispatch({
            type: 'DIRECTION',
            payload: 'vertical'
        });
        dispatch({
            type: 'SHOW_PRICELIST',
            payload: false
        });
        fetchModels();
    }, []);
    const getSnippetProps = ()=>{
        return `modelCodes="${cars.map((c)=>c.model.code).join(',')}" trimCodes="${cars.map((c)=>c.trimCode).join(',')}" ${!options ? 'pricelist="true"' : Object.entries(options).map(([key, value])=>value ? `${key}="${value}"` : '').filter(Boolean).join(' ')}`;
    };
    const gridCols = ()=>{
        switch(cars.length){
            case 2:
                return 'sm:grid-cols-2';
            case 3:
                return 'sm:grid-cols-3';
            default:
                return cars.length > 3 ? 'sm:grid-cols-4' : '';
        }
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: `pt-4 lg:px-4 pb-12 ${direction === 'vertical' ? 'max-w-screen-kia mx-auto' : ''}`,
        children: [
            !(0, $1lSPe.locationIsKia)() && !hideControls ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                children: [
                    addTrim ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kM2Bn.default), {
                        clickOutside: ()=>setAddTrim(false),
                        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: "bg-white p-8 grid gap-4",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                                    children: "V\xe4lj modell"
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("select", {
                                    className: "w-full p-2 border border-black",
                                    onChange: (e)=>{
                                        const model = models.find((m)=>m.code === e.target.value);
                                        setSelectModel(model);
                                        setSelectedTrimCode(model.first_car.code);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                            children: "V\xe4lj modell"
                                        }),
                                        models.map((model, i)=>/*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                                value: model.code,
                                                children: model.name
                                            }, i))
                                    ]
                                }),
                                selectModel ? /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                            children: selectModel.name
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("select", {
                                            onChange: (e)=>{
                                                setSelectedTrimCode(e.target.value);
                                            },
                                            className: "w-full p-2 border border-black",
                                            children: selectModel.visible_cars.map((t, i)=>/*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                                    value: t.code,
                                                    children: t.level ? `${selectModel.name} | ${t.level.name}` : t.name
                                                }, i))
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a3tFn.default), {
                                    onClick: ()=>{
                                        setCars((prev)=>[
                                                ...prev,
                                                {
                                                    model: selectModel,
                                                    trimCode: selectedTrimCode
                                                }
                                            ]);
                                        setSelectModel(null);
                                        setSelectedTrimCode(null);
                                        setAddTrim(false);
                                    },
                                    children: "L\xe4gg till trim"
                                })
                            ]
                        })
                    }) : null,
                    models?.length ? /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "max-w-screen-kia-sm m-auto flex flex-col justify-center items-center",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                                className: "text-center mb-2",
                                children: "Valda trims"
                            }),
                            cars.map((car, i)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: "flex gap-2 justify-center items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                            children: [
                                                car.model?.name,
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                            children: car.trimCode
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                            className: "text-red-500",
                                            onClick: ()=>{
                                                setCars((prevCars)=>prevCars.filter((c)=>c.trimCode !== car.trimCode));
                                            },
                                            children: "X"
                                        })
                                    ]
                                }, i)),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "max-w-40 mt-2",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a3tFn.default), {
                                    onClick: ()=>setAddTrim(true),
                                    children: "L\xe4gg till en trim"
                                })
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $2PPWI.jsx)($15ae5b1a31ce60a1$var$CarouselControls, {
                        uniqId: uniqId,
                        type: "grid"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)($15ae5b1a31ce60a1$var$Snippet, {
                        page: "cardgrid",
                        props: getSnippetProps()
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "max-w-screen-kia mx-auto relative",
                children: !options ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $gjs5U.default), {
                    uniqId: uniqId,
                    single: true
                }) : null
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: `px-4 lg:px-0 grid mx-auto gap-2 ${gridCols()}`,
                children: cars.map((car)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $edALU.default), {
                        uniqId: uniqId,
                        type: "grid",
                        model: car.model,
                        trimCode: car.trimCode
                    }, car.trimCode))
            })
        ]
    });
};
var $15ae5b1a31ce60a1$export$2e2bcd8739ae039 = $15ae5b1a31ce60a1$var$PriceCardGrid;

});
parcelRegister("8mhoa", function(module, exports) {
'use strict';

var $v5tUy = parcelRequire("v5tUy");

var $7nYS2 = parcelRequire("7nYS2");
Object.keys($v5tUy).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call(module.exports, k)) Object.defineProperty(module.exports, k, {
        enumerable: true,
        get: function() {
            return $v5tUy[k];
        }
    });
});
Object.keys($7nYS2).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call(module.exports, k)) Object.defineProperty(module.exports, k, {
        enumerable: true,
        get: function() {
            return $7nYS2[k];
        }
    });
});

});
parcelRegister("v5tUy", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $05d725dd421e05d3$export$f51a9068ac82ea43; }, function (v) { return $05d725dd421e05d3$export$f51a9068ac82ea43 = v; });
var $05d725dd421e05d3$export$f51a9068ac82ea43;
'use strict';
const $05d725dd421e05d3$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $05d725dd421e05d3$var$createStore = (createState)=>createState ? $05d725dd421e05d3$var$createStoreImpl(createState) : $05d725dd421e05d3$var$createStoreImpl;
$05d725dd421e05d3$export$f51a9068ac82ea43 = $05d725dd421e05d3$var$createStore;

});

parcelRegister("7nYS2", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $5609e601873f4479$export$185802fd694ee1f5; }, function (v) { return $5609e601873f4479$export$185802fd694ee1f5 = v; });
$parcel$export(module.exports, "useStore", function () { return $5609e601873f4479$export$6ccbb43953eebf8; }, function (v) { return $5609e601873f4479$export$6ccbb43953eebf8 = v; });
var $5609e601873f4479$export$185802fd694ee1f5;
var $5609e601873f4479$export$6ccbb43953eebf8;
'use strict';

var $8FY87 = parcelRequire("8FY87");

var $v5tUy = parcelRequire("v5tUy");
const $5609e601873f4479$var$identity = (arg)=>arg;
function $5609e601873f4479$var$useStore(api, selector = $5609e601873f4479$var$identity) {
    const slice = $8FY87.useSyncExternalStore(api.subscribe, $8FY87.useCallback(()=>selector(api.getState()), [
        api,
        selector
    ]), $8FY87.useCallback(()=>selector(api.getInitialState()), [
        api,
        selector
    ]));
    $8FY87.useDebugValue(slice);
    return slice;
}
const $5609e601873f4479$var$createImpl = (createState)=>{
    const api = $v5tUy.createStore(createState);
    const useBoundStore = (selector)=>$5609e601873f4479$var$useStore(api, selector);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $5609e601873f4479$var$create = (createState)=>createState ? $5609e601873f4479$var$createImpl(createState) : $5609e601873f4479$var$createImpl;
$5609e601873f4479$export$185802fd694ee1f5 = $5609e601873f4479$var$create;
$5609e601873f4479$export$6ccbb43953eebf8 = $5609e601873f4479$var$useStore;

});


parcelRegister("edALU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a641e1f69a49cc90$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $8mhoa = parcelRequire("8mhoa");

var $jZedf = parcelRequire("jZedf");

var $1lSPe = parcelRequire("1lSPe");

var $3eb7t = parcelRequire("3eb7t");

var $K8UMm = parcelRequire("K8UMm");

var $5AHc7 = parcelRequire("5AHc7");

var $4zO0F = parcelRequire("4zO0F");

var $39P5O = parcelRequire("39P5O");

var $iH0Pu = parcelRequire("iH0Pu");

var $5ANQT = parcelRequire("5ANQT");
const $a641e1f69a49cc90$var$CarouselCard = ({ model: model, trimCode: trimCode, type: type, uniqId: uniqId })=>{
    const { options: options, direction: direction, businessEditionFilter: businessEditionFilter } = (0, $8mhoa.useStore)((0, $iH0Pu.getStoreByKey)(uniqId));
    const getInitialTrim = ()=>{
        if (trimCode) return null;
        if (businessEditionFilter === 'only') return model.visible_cars?.find((c)=>c.business_edition) ?? model.first_car;
        if (businessEditionFilter === 'exclude') return model.visible_cars?.find((c)=>!c.business_edition) ?? model.first_car;
        return model.first_car;
    };
    const [trim, setTrim] = (0, $8FY87.useState)(getInitialTrim());
    const [isMobile, setIsMobile] = (0, $8FY87.useState)(true);
    (0, $8FY87.useEffect)(()=>{
        // Fetch trim if trimCode is provided
        if (trimCode) fetchTrim(trimCode);
        const handleResize = ()=>{
            setIsMobile(window.innerWidth < 700);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const getTrimImage = ()=>{
        switch(options?.imageType){
            case (0, $5ANQT.ImageTypeEnum).EXTERIOR:
                return trim.context_picture ?? model.context_picture ?? trim.image ?? '';
            default:
                return trim.image ?? model.context_picture ?? '';
        }
    };
    const fetchTrim = async (code)=>{
        try {
            const { data: data } = await (0, $jZedf.fetchWithType)((0, $1lSPe.getAdminUrl)() + '/api/car/' + code, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${(0, $1lSPe.getApiToken)()}`
                }
            });
            if (data && data.id) setTrim(data);
        } catch (error) {
            console.error(error);
        }
    };
    const handleChangeTrim = (e)=>{
        const selectedTrim = model.visible_cars.find((car)=>car.id === parseInt(e.target.value));
        if (selectedTrim) fetchTrim(selectedTrim.code);
    };
    const getModelName = ()=>{
        if (!options || options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).CHANGE_TRIM)) return model.name;
        else return trim.level ? `${model.name} | ${trim.level.name}` : trim.name;
    };
    return trim && model ? /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        style: {
            minWidth: type === 'grid' ? '' : options?.imageType !== (0, $5ANQT.ImageTypeEnum).EXTERIOR ? 'clamp(200px, 80vw, 378px)' : 'clamp(200px, 80vw, 456px)',
            maxWidth: type === 'grid' ? '940px' : direction === 'vertical' ? '100%' : options?.imageType === (0, $5ANQT.ImageTypeEnum).EXTERIOR ? '456px' : '378px'
        },
        className: "@container flex h-full mx-auto w-full",
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: `carousel-card  w-full min-h-[340px] group rounded-lg bg-kia-grey m-1 shadow snap-center grid grid-rows-subgrid row-span-12 @xlcard:row-span-1 @xlcard:grid-cols-2`,
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                    href: model.url,
                    "aria-label": `Utforska ${model.name}`,
                    className: "no-underline",
                    children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        style: {
                            '--color': model.background_color
                        },
                        className: "relative overflow-hidden h-full flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: `w-full ${direction === 'vertical' && options?.imageType === (0, $5ANQT.ImageTypeEnum).EXTERIOR ? 'sm:h-full' : ''} ${!options || options?.imageType !== (0, $5ANQT.ImageTypeEnum).EXTERIOR ? 'pt-6' : ''}`,
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                    className: `group-hover:scale-105 transition-transform w-full h-full relative z-[1] ${options?.imageType === (0, $5ANQT.ImageTypeEnum).EXTERIOR && (trim.context_picture || model.context_picture) ? 'object-cover aspect-[4/3]' : 'object-contain aspect-[2/1]'}`,
                                    width: 300,
                                    src: getTrimImage(),
                                    alt: model.name
                                })
                            }),
                            options?.imageType === (0, $5ANQT.ImageTypeEnum).STUDIO_BG && /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                                        className: `absolute top-0 left-0 hidden @xlcard:block h-[85%] w-full @xlcard:w-[85%] @xlcard:h-full`,
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 100 100",
                                        preserveAspectRatio: "none",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                                            d: "M0 100 L100 100 C90 50, 90 50, 100 0 L0 0 Z",
                                            fill: model.background_color
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                                        className: `absolute top-0 left-0 @xlcard:hidden h-[85%] w-full @xlcard:w-[85%] @xlcard:h-full `,
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 100 100",
                                        preserveAspectRatio: "none",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                                            d: "M100 0 L100 100 C50 90, 50 90, 0 100 L0 0 Z",
                                            fill: model.background_color
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: `absolute text-black z-10 bg-white py-1 px-4 shadow-sm text-[13px] rounded-full right-4 top-4 @xlcard:right-auto @xlcard:left-6 @xlcard:top-6`,
                                children: model.type.name
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: `py-4 px-4 grid grid-rows-subgrid row-span-12 @xlcard:row-span-1 @xlcard:flex @xlcard:flex-col @xlcard:my-auto ${(isMobile || direction === 'horizontal') && options?.imageType !== (0, $5ANQT.ImageTypeEnum).EXTERIOR ? 'pt-0' : ''} ${direction === 'vertical' && !isMobile ? !options ? '@xlcard:py-8' : '@xlcard:py-12' : ''} ${direction === 'vertical' && options?.imageType === (0, $5ANQT.ImageTypeEnum).EXTERIOR ? 'sm:!px-8' : ''}${direction === 'vertical' && options?.imageType !== (0, $5ANQT.ImageTypeEnum).EXTERIOR ? '@xlcard:pl-0' : ''}`,
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                            href: model.url,
                            "aria-label": `Utforska ${model.name}`,
                            className: "no-underline mb-4",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                className: `${direction === 'vertical' ? 'md:text-lg md:py-2' : ''} group-hover:underline text-lg`,
                                children: getModelName()
                            })
                        }),
                        options?.fields?.some((field)=>[
                                (0, $5ANQT.CarouselFieldsEnum).PRIVATE_DESCRIPTION,
                                (0, $5ANQT.CarouselFieldsEnum).COMPANY_DESCRIPTION,
                                (0, $5ANQT.CarouselFieldsEnum).TRIM_LEVEL_DESCRIPTION
                            ].includes(field)) && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            className: "mb-4",
                            children: options?.fields.includes((0, $5ANQT.CarouselFieldsEnum).PRIVATE_DESCRIPTION) ? trim.description : options.fields.includes((0, $5ANQT.CarouselFieldsEnum).COMPANY_DESCRIPTION) ? trim.description_business : options.fields.includes((0, $5ANQT.CarouselFieldsEnum).TRIM_LEVEL_DESCRIPTION) && trim.level?.description ? trim.level.description : null
                        }),
                        options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).FEATURES) && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            className: "mb-4",
                            children: trim.features
                        }),
                        !options || options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).CHANGE_TRIM) ? /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: "relative mb-4",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("select", {
                                    onChange: (e)=>handleChangeTrim(e),
                                    className: "w-full px-4 py-3 text-sm pr-10 bg-white rounded-full shadow-md",
                                    children: (businessEditionFilter === 'only' ? model.visible_cars.filter((c)=>c.business_edition) : businessEditionFilter === 'exclude' ? model.visible_cars.filter((c)=>!c.business_edition) : model.visible_cars).filter((c)=>!c.show).map((car)=>/*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                            value: car.id,
                                            children: car.level ? `${model.name} | ${car.level.name}` : car.name
                                        }, car.id))
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                                    className: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none",
                                    width: "12",
                                    height: "8",
                                    viewBox: "0 0 12 8",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                                        d: "M0.833496 1.5L5.8335 6.5L10.8335 1.5",
                                        stroke: "#05141F",
                                        strokeWidth: "2"
                                    })
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $39P5O.default), {
                            uniqId: uniqId,
                            trim: trim,
                            model: model
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5AHc7.default), {
                            uniqId: uniqId,
                            trim: trim,
                            model: model
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $K8UMm.default), {
                            uniqId: uniqId,
                            trim: trim
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4zO0F.default), {
                            uniqId: uniqId,
                            trim: trim,
                            model: model
                        }),
                        model.url && !options || options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).CTA_DISCOVER) ? /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                            className: "text-[14px] py-2 underline-offset-4 font-semibold flex gap-1 items-center",
                            href: model.url,
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                children: "Utforska bilen h\xe4r"
                            })
                        }) : null
                    ]
                })
            ]
        })
    }) : null;
};
var $a641e1f69a49cc90$export$2e2bcd8739ae039 = $a641e1f69a49cc90$var$CarouselCard;

});
parcelRegister("K8UMm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81691ae370998bc7$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8mhoa = parcelRequire("8mhoa");

var $dA2bf = parcelRequire("dA2bf");

var $1lSPe = parcelRequire("1lSPe");

var $78Kz0 = parcelRequire("78Kz0");

var $iH0Pu = parcelRequire("iH0Pu");

var $5ANQT = parcelRequire("5ANQT");
const $81691ae370998bc7$var$CarouselBusinessRows = ({ trim: trim, uniqId: uniqId })=>{
    const { options: options, selectedBusinessDistance: selectedBusinessDistance, selectedFinanceOption: selectedFinanceOption } = (0, $8mhoa.useStore)((0, $iH0Pu.getStoreByKey)(uniqId));
    const getPrice = ()=>{
        switch(selectedBusinessDistance){
            case (0, $dA2bf.BusinessDistance).Two:
                return trim.business_leasing[0].s_6000_inkl_forsakring;
            case (0, $dA2bf.BusinessDistance).Three:
                return trim.business_leasing[0].s_9000_inkl_forsakring;
            case (0, $dA2bf.BusinessDistance).Four:
                return trim.business_leasing[0].s_12000_inkl_forsakring;
            default:
                return trim.business_leasing[0].s_4500_inkl_forsakring;
        }
    };
    const shoundRenderInPriceList = Boolean(!options && (!selectedFinanceOption || selectedFinanceOption === (0, $dA2bf.FinanceOption).BUSINESS));
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            trim.business_leasing?.length ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
                children: shoundRenderInPriceList || options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).BUSINESS_LEASE) ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $78Kz0.default), {
                    uniqId: uniqId,
                    tooltip: "Inkl. serviceavtal, f\xf6rs\xe4kring, vinterhjul, 36 m\xe5n, ex.moms",
                    label: "Business Lease garanterat restv\xe4rde \u2075",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                            children: [
                                "Fr\xe5n ",
                                (0, $1lSPe.formatNumber)(getPrice()),
                                " kr/m\xe5n*"
                            ]
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                            children: [
                                "(F\xf6rsta f\xf6rh\xf6jd hyra",
                                ' ',
                                trim.business_leasing[0]?.andra_i_nedan_cell_1a_hyra_i,
                                "%)"
                            ]
                        })
                    ]
                }) : null
            }) : null,
            shoundRenderInPriceList || [
                (0, $5ANQT.CarouselFieldsEnum).BENEFICIAL_VALUE,
                (0, $5ANQT.CarouselFieldsEnum).TAX
            ].some((field)=>options?.fields?.includes(field)) ? /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "grid grid-cols-2",
                children: [
                    (shoundRenderInPriceList || options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).BENEFICIAL_VALUE)) && trim.beneficial_value != null ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $78Kz0.default), {
                        uniqId: uniqId,
                        className: options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).TAX) || !options ? 'border-r border-slate-200 px-1' : 'col-span-2',
                        tooltip: "Baserat p\xe5 en marginalskatt p\xe5 50%",
                        label: "F\xf6rm\xe5nsv\xe4rde fr. \u2077",
                        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                            children: [
                                (0, $1lSPe.formatNumber)(trim.beneficial_value),
                                " kr/m\xe5n"
                            ]
                        })
                    }) : null,
                    (shoundRenderInPriceList || options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).TAX)) && trim.vehicle_tax != null ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $78Kz0.default), {
                        uniqId: uniqId,
                        className: !options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).BENEFICIAL_VALUE) && options ? 'col-span-2' : 'px-1',
                        label: "Fordonsskatt",
                        children: [
                            (0, $1lSPe.formatNumber)(trim.vehicle_tax),
                            "kr/\xe5r"
                        ]
                    }) : null
                ]
            }) : null
        ]
    });
};
var $81691ae370998bc7$export$2e2bcd8739ae039 = $81691ae370998bc7$var$CarouselBusinessRows;

});
parcelRegister("dA2bf", function(module, exports) {

$parcel$export(module.exports, "FinanceOption", function () { return $cb184b45675bb6dc$export$a1f8e4f442f0f264; });
$parcel$export(module.exports, "BusinessDistance", function () { return $cb184b45675bb6dc$export$e5722972276c31e2; });
$parcel$export(module.exports, "PrivateDistance", function () { return $cb184b45675bb6dc$export$341d6f63d9c64848; });
$parcel$export(module.exports, "TypeOfLeasing", function () { return $cb184b45675bb6dc$export$c6e9ab6b3f34a577; });
var $cb184b45675bb6dc$export$a1f8e4f442f0f264 = /*#__PURE__*/ function(FinanceOption) {
    FinanceOption["PRIVATE"] = "Privatleasing";
    FinanceOption["LOAN"] = "Bill\xe5n";
    FinanceOption["BUSINESS"] = "Business lease";
    return FinanceOption;
}({});
var $cb184b45675bb6dc$export$e5722972276c31e2 = /*#__PURE__*/ function(BusinessDistance) {
    BusinessDistance["One"] = "1500 mil";
    BusinessDistance["Two"] = "2000 mil";
    BusinessDistance["Three"] = "3000 mil";
    BusinessDistance["Four"] = "4000 mil";
    return BusinessDistance;
}({});
var $cb184b45675bb6dc$export$341d6f63d9c64848 = /*#__PURE__*/ function(PrivateDistance) {
    PrivateDistance["One"] = "1000 mil";
    PrivateDistance["Two"] = "1500 mil";
    PrivateDistance["Three"] = "2000 mil";
    PrivateDistance["Four"] = "3000 mil";
    return PrivateDistance;
}({});
var $cb184b45675bb6dc$export$c6e9ab6b3f34a577 = /*#__PURE__*/ function(TypeOfLeasing) {
    TypeOfLeasing["BUSINESS"] = "Kia Business Lease\u2075\u207E";
    TypeOfLeasing["FINANCIAL"] = "Kia Finansiell Leasing\u2076\u207E";
    return TypeOfLeasing;
}({});

});

parcelRegister("78Kz0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $328e498267c1de3d$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $8mhoa = parcelRequire("8mhoa");

var $7hhPC = parcelRequire("7hhPC");

var $iH0Pu = parcelRequire("iH0Pu");
const $328e498267c1de3d$var$CarouselCardRow = ({ label: label, children: children, tooltip: tooltip, className: className = '', uniqId: uniqId })=>{
    const { options: options } = (0, $8mhoa.useStore)((0, $iH0Pu.getStoreByKey)(uniqId));
    const id = (0, $8FY87.useId)();
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: `flex flex-col gap-1 py-2 text-sm px-1 ${!options ? 'border-b' : ''} ${className}`,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("h5", {
                className: "flex gap-2 items-center text-[14px] font-semibold mb-0",
                children: [
                    label,
                    tooltip ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $7hhPC.default), {
                        describe: `tooltip-${id}`,
                        children: tooltip
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
                children: children
            })
        ]
    });
};
var $328e498267c1de3d$export$2e2bcd8739ae039 = $328e498267c1de3d$var$CarouselCardRow;

});
parcelRegister("7hhPC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f370d549a67369bf$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");
function $f370d549a67369bf$export$2e2bcd8739ae039({ describe: describe, children: children }) {
    const [isVisible, setIsVisible] = (0, $8FY87.useState)(false);
    const timeoutRef = (0, $8FY87.useRef)(null);
    (0, $8FY87.useEffect)(()=>{
        const handleEscape = (event)=>{
            if (event.key === 'Escape' && isVisible) setIsVisible(false);
        };
        document.addEventListener('keydown', handleEscape);
        return ()=>{
            document.removeEventListener('keydown', handleEscape);
        };
    }, [
        isVisible
    ]);
    const hideWithDelay = ()=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>setIsVisible(false), 3000);
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "relative inline-block",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-describedby": describe,
                className: "cursor-pointer",
                onMouseEnter: ()=>setIsVisible(true),
                onMouseLeave: ()=>setIsVisible(false),
                onBlur: ()=>setIsVisible(false),
                onFocus: ()=>setIsVisible(true),
                onClick: ()=>setIsVisible((prev)=>!prev),
                onTouchEnd: (e)=>{
                    e.preventDefault();
                    setIsVisible((prev)=>!prev);
                    hideWithDelay();
                },
                tabIndex: 0,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("g", {
                        clipPath: "url(#clip0_865_453)",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                                d: "M8.00016 14.6667C11.6821 14.6667 14.6668 11.6819 14.6668 8C14.6668 4.3181 11.6821 1.33333 8.00016 1.33333C4.31826 1.33333 1.3335 4.3181 1.3335 8C1.3335 11.6819 4.31826 14.6667 8.00016 14.6667Z",
                                stroke: "#05141F",
                                strokeWidth: "1.33333"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                                d: "M8 10.6667V8",
                                stroke: "#05141F",
                                strokeWidth: "1.33333",
                                strokeLinecap: "square"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("rect", {
                                x: "7.3335",
                                y: "4.66667",
                                width: "1.33333",
                                height: "1.33333",
                                fill: "#05141F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("clipPath", {
                            id: "clip0_865_453",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("rect", {
                                width: "16",
                                height: "16",
                                fill: "white"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: `absolute left-1/2 transform -translate-x-1/2 bottom-full font-light text-xs rounded-md p-2 ml-1 max-w-xs ${isVisible ? 'visible' : 'invisible'}`,
                role: "tooltip",
                id: describe,
                onMouseEnter: ()=>setIsVisible(true),
                onMouseLeave: ()=>setIsVisible(false),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: "p-2 bg-black text-white rounded-md min-w-[140px]",
                    children: children
                })
            })
        ]
    });
}

});

parcelRegister("iH0Pu", function(module, exports) {

$parcel$export(module.exports, "getStoreByKey", function () { return $cc91129f8042fd96$export$8b8f76c5bf80d396; });

var $8mhoa = parcelRequire("8mhoa");

var $dA2bf = parcelRequire("dA2bf");

var $5ANQT = parcelRequire("5ANQT");
const $cc91129f8042fd96$var$defaultOptions = {
    imageType: (0, $5ANQT.ImageTypeEnum).STUDIO_BG,
    fields: []
};
const $cc91129f8042fd96$var$getFilteredModels = (state)=>{
    let filtered;
    if (!state.selectedFinanceOption && !state.selectedFuels.length && !state.selectedCategories.length) filtered = [
        ...state.models
    ];
    else filtered = [
        ...state.models
    ].filter((model)=>{
        let shouldReturn = true;
        if (state.selectedFuels.length) {
            if (!state.selectedFuels.includes(model.type.id)) shouldReturn = false;
        }
        if (state.selectedCategories.length) {
            if (!state.selectedCategories.some((category)=>model.categories.map((c)=>c.id).includes(category))) shouldReturn = false;
        }
        if (state.selectedFinanceOption) switch(state.selectedFinanceOption){
            case (0, $dA2bf.FinanceOption).PRIVATE:
                if (!model.visible_cars[0]?.private_leasing?.length) shouldReturn = false;
                break;
            case (0, $dA2bf.FinanceOption).BUSINESS:
                if (!model.visible_cars[0].business_leasing?.length) shouldReturn = false;
                break;
            case (0, $dA2bf.FinanceOption).LOAN:
                if (!model.visible_cars[0].loan?.length) shouldReturn = false;
                break;
            default:
                break;
        }
        return shouldReturn;
    });
    if (state.businessEditionFilter === 'only') filtered = filtered.filter((m)=>m.visible_cars?.some((c)=>c.business_edition));
    else if (state.businessEditionFilter === 'exclude') filtered = filtered.filter((m)=>m.visible_cars?.some((c)=>!c.business_edition));
    return filtered;
};
const $cc91129f8042fd96$var$reducer = (state, action)=>{
    if (action.type === 'SHOW_PRIVATE_MILEAGES') return {
        ...state,
        showPrivateMileages: action.payload
    };
    if (action.type === 'SET_BUSINESS_EDITION_FILTER') return {
        ...state,
        businessEditionFilter: action.payload
    };
    if (action.type === 'SHOW_PRICELIST') return action.payload ? {
        ...state,
        options: undefined
    } : {
        ...state,
        options: $cc91129f8042fd96$var$defaultOptions
    };
    else if (action.type === 'HEADING') return {
        ...state,
        currentHeading: action.payload
    };
    else if (action.type === 'IMAGE_TYPE') return {
        ...state,
        options: {
            ...state.options,
            imageType: action.payload
        }
    };
    else if (action.type === 'CONTROLS') return {
        ...state,
        options: {
            ...state.options,
            fields: action.payload
        }
    };
    else if (action.type === 'DIRECTION') return {
        ...state,
        direction: action.payload
    };
    else if (action.type === 'MODELS') return {
        ...state,
        models: action.payload
    };
    else if (action.type === 'FILTERED_MODELS') return {
        ...state,
        filteredModels: action.payload
    };
    else if (action.type === 'FUEL') return {
        ...state,
        selectedFuels: action.payload
    };
    else if (action.type === 'FINANCE_OPTION') return {
        ...state,
        selectedFinanceOption: action.payload
    };
    else if (action.type === 'BUSINESS_DISTANCE') return {
        ...state,
        selectedBusinessDistance: action.payload
    };
    else if (action.type === 'PRIVATE_DISTANCE') return {
        ...state,
        selectedPrivateDistance: action.payload
    };
    else if (action.type === 'IS_LOADED') return {
        ...state,
        isLoaded: action.payload
    };
    else if (action.type === 'FILTER_MODELS') return {
        ...state,
        filteredModels: $cc91129f8042fd96$var$getFilteredModels(state)
    };
    else if (action.type === 'CATEGORY') return {
        ...state,
        selectedCategories: action.payload
    };
    else if (action.type === 'SORT_BY') return {
        ...state,
        sortField: action.payload,
        sortDirection: action.sortBy
    };
    return state;
};
const $cc91129f8042fd96$var$createCarouselStore = ()=>(0, $8mhoa.createStore)()((set)=>({
            models: [],
            filteredModels: [],
            selectedFuels: [],
            selectedCategories: [],
            currentHeading: '',
            selectedFinanceOption: undefined,
            direction: 'horizontal',
            options: undefined,
            isLoaded: false,
            showPrivateMileages: false,
            businessEditionFilter: 'exclude',
            selectedBusinessDistance: (0, $dA2bf.BusinessDistance).One,
            selectedPrivateDistance: (0, $dA2bf.PrivateDistance).One,
            sortField: null,
            sortDirection: 'asc',
            dispatch: (args)=>set((state)=>$cc91129f8042fd96$var$reducer(state, args))
        }));
const $cc91129f8042fd96$var$carouselStoresMap = new Map();
const $cc91129f8042fd96$var$createCarouselStoreFactory = (carouselStores)=>{
    return (carouselStoreKey)=>{
        if (!carouselStores.has(carouselStoreKey)) carouselStores.set(carouselStoreKey, $cc91129f8042fd96$var$createCarouselStore());
        return carouselStores.get(carouselStoreKey);
    };
};
const $cc91129f8042fd96$export$8b8f76c5bf80d396 = $cc91129f8042fd96$var$createCarouselStoreFactory($cc91129f8042fd96$var$carouselStoresMap);

});
parcelRegister("5ANQT", function(module, exports) {

$parcel$export(module.exports, "ImageTypeEnum", function () { return $da46ad23aab18a80$export$655f73007d63749a; });
$parcel$export(module.exports, "CarouselFieldsEnum", function () { return $da46ad23aab18a80$export$af55bc64aaca141; });
$parcel$export(module.exports, "sortableCarouselFields", function () { return $da46ad23aab18a80$export$9a6602d804a617bb; });
$parcel$export(module.exports, "buttonClasses", function () { return $da46ad23aab18a80$export$a2f13f7f8b2f493b; });
$parcel$export(module.exports, "activeButtonClasses", function () { return $da46ad23aab18a80$export$4dc4929bfe3623cb; });
var $da46ad23aab18a80$export$655f73007d63749a = /*#__PURE__*/ function(ImageTypeEnum) {
    ImageTypeEnum["STUDIO"] = "Studiobild";
    ImageTypeEnum["STUDIO_BG"] = "Studiobild med bakgrund";
    ImageTypeEnum["EXTERIOR"] = "Milj\xf6bild";
    return ImageTypeEnum;
}({});
var $da46ad23aab18a80$export$af55bc64aaca141 = /*#__PURE__*/ function(CarouselFieldsEnum) {
    CarouselFieldsEnum["FROM_PRICE"] = "Fr\xe5npris";
    CarouselFieldsEnum["PRIVATE_LEASING"] = "Privatleasingpris";
    CarouselFieldsEnum["LOAN"] = "Bill\xe5n";
    CarouselFieldsEnum["BUSINESS_LEASE"] = "Businesslease";
    CarouselFieldsEnum["BENEFICIAL_VALUE"] = "F\xf6rm\xe5nsv\xe4rde";
    CarouselFieldsEnum["TAX"] = "Fordonskatt";
    CarouselFieldsEnum["CTA_RETAILER"] = "Kontakta \xe5terf\xf6rs\xe4ljare";
    CarouselFieldsEnum["CTA_DISCOVER"] = "Uppt\xe4ck bilen";
    CarouselFieldsEnum["CHANGE_TRIM"] = "Byt trim";
    CarouselFieldsEnum["CHANGE_DIRECTION"] = "Byt riktning";
    CarouselFieldsEnum["PRIVATE_DESCRIPTION"] = "Privatbeskrivning";
    CarouselFieldsEnum["COMPANY_DESCRIPTION"] = "F\xf6retagsbeskrivning";
    CarouselFieldsEnum["TRIM_LEVEL_DESCRIPTION"] = "Utrustningsbeskrivning";
    CarouselFieldsEnum["FEATURES"] = "Trim-beskrivning";
    CarouselFieldsEnum["SHOW"] = "Visa Filter";
    CarouselFieldsEnum["ALLOW_SORTING"] = "Sortera";
    return CarouselFieldsEnum;
}({});
const $da46ad23aab18a80$export$9a6602d804a617bb = [
    "Fr\xe5npris",
    "Privatleasingpris",
    "Businesslease",
    "F\xf6rm\xe5nsv\xe4rde"
];
const $da46ad23aab18a80$export$a5b13e054f8b3b85 = Object.values($da46ad23aab18a80$export$af55bc64aaca141).filter((value)=>value.toLowerCase().includes('beskrivning'));
const $da46ad23aab18a80$export$72815f93679daed7 = Object.values($da46ad23aab18a80$export$af55bc64aaca141).filter((value)=>!$da46ad23aab18a80$export$a5b13e054f8b3b85.includes(value));
const $da46ad23aab18a80$export$a2f13f7f8b2f493b = 'bg-white shadow-sm border whitespace-nowrap rounded-full py-1 px-4 text-gray-500 text-xs border-b-2 border-gray-500';
const $da46ad23aab18a80$export$4dc4929bfe3623cb = '!text-black border-b-4 !border-black';

});




parcelRegister("5AHc7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d348eab58fb294c0$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8mhoa = parcelRequire("8mhoa");

var $dA2bf = parcelRequire("dA2bf");

var $1lSPe = parcelRequire("1lSPe");

var $78Kz0 = parcelRequire("78Kz0");

var $4wa1n = parcelRequire("4wa1n");

var $iH0Pu = parcelRequire("iH0Pu");

var $5ANQT = parcelRequire("5ANQT");
const $d348eab58fb294c0$var$CarouselLoanRows = ({ trim: trim, model: model, uniqId: uniqId })=>{
    const { options: options, selectedFinanceOption: selectedFinanceOption } = (0, $8mhoa.useStore)((0, $iH0Pu.getStoreByKey)(uniqId));
    const shouldRenderInPriceList = Boolean(!options && (!selectedFinanceOption || selectedFinanceOption === (0, $dA2bf.FinanceOption).LOAN)) || options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).LOAN);
    // console.log(trim.name, ' : ', trim.loan[0]?.incl_service_agreement);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: trim.loan?.length ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
            children: shouldRenderInPriceList || options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).LOAN) ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $78Kz0.default), {
                uniqId: uniqId,
                tooltip: "Bill\xe5n med kontantinsats 30%, 36 m\xe5n 4500 mil",
                label: "Bill\xe5n inkl. serviceavtal",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                        children: [
                            "Fr\xe5n ",
                            (0, $1lSPe.formatNumber)(trim.loan[0]?.incl_service_agreement),
                            " kr/m\xe5n"
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        className: "!text-xs",
                        children: trim.loan[0].disclaimer ?? 'Ingen information'
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4wa1n.default), {})
                ]
            }) : null
        }) : null
    });
};
var $d348eab58fb294c0$export$2e2bcd8739ae039 = $d348eab58fb294c0$var$CarouselLoanRows;

});
parcelRegister("4wa1n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee65379e77f6b245$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $80rvA = parcelRequire("80rvA");
const $ee65379e77f6b245$var$CarouselLoanDisclaimer = ()=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "grid grid-cols-[auto,1fr] items-start gap-4 p-[11px] mt-4 bg-white border rounded-lg",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "mt-5",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $80rvA.default), {})
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "!text-xs text-gray-900",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        className: "!text-xs  font-bold !leading-[14.4px] !tracking-[0]",
                        children: "Att l\xe5na kostar pengar!"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                        className: "!text-xs !leading-[15px]",
                        children: [
                            "Om du inte kan betala tillbaka skulden i tid riskerar du en betalningsanm\xe4rkning. Det kan leda till sv\xe5righeter att f\xe5 hyra bostad, teckna abonnemang och f\xe5 nya l\xe5n. F\xf6r st\xf6d, v\xe4nd dig till budget- och skuldr\xe5dgivningen i din kommun. Kontaktuppgifter finns p\xe5",
                            ' ',
                            /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                href: "https://www.konsumentverket.se",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "underline !text-xs",
                                children: "konsumentverket.se"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $ee65379e77f6b245$export$2e2bcd8739ae039 = $ee65379e77f6b245$var$CarouselLoanDisclaimer;

});
parcelRegister("80rvA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4115eb565ee0cd71$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
const $4115eb565ee0cd71$var$WarningIcon = ()=>/*#__PURE__*/ (0, $2PPWI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "45",
        height: "39",
        viewBox: "0 0 45 39",
        fill: "none",
        className: "self-start",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                d: "M44.1038 35.3325L24.4575 1.30126C24.0525 0.600012 23.3025 0.168762 22.4925 0.168762C21.6825 0.168762 20.9325 0.600012 20.5275 1.30126L0.881265 35.3325C0.476265 36.0338 0.476265 36.9 0.881265 37.6013C1.28626 38.3025 2.03626 38.7338 2.84626 38.7338H42.1425C42.9525 38.7338 43.7025 38.3025 44.1075 37.6013C44.5088 36.8963 44.5088 36.0338 44.1038 35.3325ZM6.77626 34.1963L22.4925 6.97126L38.2088 34.1963H6.77626Z",
                fill: "#AA1E1E"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                d: "M24.1013 28.3537C23.67 27.9712 23.1375 27.78 22.4925 27.78C21.8513 27.78 21.315 27.9712 20.8838 28.3537C20.4525 28.7362 20.2388 29.2237 20.2388 29.8162C20.2388 30.4087 20.4525 30.8962 20.8838 31.2787C21.3113 31.6612 21.8475 31.8525 22.4925 31.8525C23.1338 31.8525 23.67 31.6612 24.1013 31.2787C24.5288 30.8962 24.7463 30.4087 24.7463 29.8162C24.7425 29.22 24.5288 28.7325 24.1013 28.3537Z",
                fill: "#AA1E1E"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                d: "M20.88 26.085H24.165L24.6825 14.1038H20.3625L20.88 26.085Z",
                fill: "#AA1E1E"
            })
        ]
    });
var $4115eb565ee0cd71$export$2e2bcd8739ae039 = $4115eb565ee0cd71$var$WarningIcon;

});



parcelRegister("4zO0F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0389e170f8de5262$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8mhoa = parcelRequire("8mhoa");

var $1lSPe = parcelRequire("1lSPe");

var $655D0 = parcelRequire("655D0");

var $797BW = parcelRequire("797BW");

var $78Kz0 = parcelRequire("78Kz0");

var $iH0Pu = parcelRequire("iH0Pu");

var $5ANQT = parcelRequire("5ANQT");
const $0389e170f8de5262$var$CarouselOtherRows = ({ trim: trim, model: model, uniqId: uniqId })=>{
    const { options: options, direction: direction, selectedFinanceOption: selectedFinanceOption } = (0, $8mhoa.useStore)((0, $iH0Pu.getStoreByKey)(uniqId));
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            trim.price ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
                children: !options && !selectedFinanceOption || options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).FROM_PRICE) ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $78Kz0.default), {
                    uniqId: uniqId,
                    className: "border-none",
                    label: "Rek. ca pris",
                    tooltip: "inkl. moms",
                    children: /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                        children: [
                            "Fr\xe5n ",
                            (0, $1lSPe.formatNumber)(trim.price),
                            " kr"
                        ]
                    })
                }) : null
            }) : null,
            !options || options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).CTA_RETAILER) ? /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: `hidden py-2 ${direction === 'vertical' ? 'sm:flex' : ''} flex-col min-w-[175px] max-w-[220px] gap-2`,
                children: !options || options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).CTA_RETAILER) ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $797BW.default), {
                    href: "https://www.kia.com/se/provkor/#/",
                    onClick: ()=>(0, $655D0.trackEvent)({
                            event: 'contact_dealer',
                            model: model
                        }),
                    children: "Kontakta \xe5terf\xf6rs\xe4ljare"
                }) : null
            }) : null
        ]
    });
};
var $0389e170f8de5262$export$2e2bcd8739ae039 = $0389e170f8de5262$var$CarouselOtherRows;

});
parcelRegister("797BW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9be90db7c7919c2$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
const $c9be90db7c7919c2$var$KiaLink = ({ href: href, children: children, target: target = '_self', onClick: onClick })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("a", {
        className: "no-underline rounded-[100px] gap-2 text-white p-[.2rem] pl-3 inline-flex items-center cursor-pointer leading-[17px] bg-black justify-between",
        href: href,
        target: target,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                className: "text-xs font-semibold",
                children: children
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("svg", {
                width: "19",
                height: "19",
                viewBox: "0 0 19 19",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("rect", {
                        width: "19",
                        height: "19",
                        rx: "9.5",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                        d: "M8.1665 13.5L12.1665 9.5L8.1665 5.5",
                        stroke: "#05141F",
                        strokeWidth: "2"
                    })
                ]
            })
        ]
    });
};
var $c9be90db7c7919c2$export$2e2bcd8739ae039 = $c9be90db7c7919c2$var$KiaLink;

});


parcelRegister("39P5O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99d0767d30c65115$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $655D0 = parcelRequire("655D0");

var $8mhoa = parcelRequire("8mhoa");

var $dA2bf = parcelRequire("dA2bf");

var $1lSPe = parcelRequire("1lSPe");

var $78Kz0 = parcelRequire("78Kz0");

var $iH0Pu = parcelRequire("iH0Pu");

var $5ANQT = parcelRequire("5ANQT");
const $99d0767d30c65115$var$CarouselPrivateRows = ({ trim: trim, model: model, uniqId: uniqId })=>{
    const { options: options, showPrivateMileages: showPrivateMileages, selectedFinanceOption: selectedFinanceOption, selectedPrivateDistance: selectedPrivateDistance } = (0, $8mhoa.useStore)((0, $iH0Pu.getStoreByKey)(uniqId));
    const shouldRenderInPriceList = Boolean(!options && (!selectedFinanceOption || selectedFinanceOption === (0, $dA2bf.FinanceOption).PRIVATE));
    const getPrice = ()=>{
        switch(selectedPrivateDistance){
            case (0, $dA2bf.PrivateDistance).Two:
                return trim.private_leasing[0].manadshyra364500;
            case (0, $dA2bf.PrivateDistance).Three:
                return trim.private_leasing[0].manadshyra366000;
            case (0, $dA2bf.PrivateDistance).Four:
                return trim.private_leasing[0].manadshyra369000;
            default:
                return trim.private_leasing[0].manadshyra363000;
        }
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: trim.private_leasing?.length ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
            children: shouldRenderInPriceList || options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).PRIVATE_LEASING) ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $78Kz0.default), {
                uniqId: uniqId,
                tooltip: model.show_privatleasing ? showPrivateMileages ? "36 m\xe5nader. R\xf6rlig leasingavgift." : "36 m\xe5n 3000 mil" : null,
                label: "Privatleasing inkl. serviceavtal \xb2",
                children: model.show_privatleasing ? showPrivateMileages ? /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                    children: [
                        "Fr\xe5n ",
                        (0, $1lSPe.formatNumber)(getPrice()),
                        " kr/m\xe5n (r\xf6rlig leasingavgift)"
                    ]
                }) : /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                    children: [
                        "Fr\xe5n",
                        ' ',
                        (0, $1lSPe.formatNumber)(trim.private_leasing[0].manadshyra363000),
                        ' ',
                        "kr/m\xe5n"
                    ]
                }) : /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                            onClick: ()=>(0, $655D0.trackEvent)({
                                    event: 'find_a_dealer',
                                    model: model,
                                    trim: trim
                                }),
                            href: "https://www.kia.com/se/sok-aterforsaljare-verkstad",
                            className: "underline",
                            children: "Kontakta \xe5terf\xf6rs\xe4ljare"
                        }),
                        " f\xf6r prisuppgift"
                    ]
                })
            }) : null
        }) : null
    });
};
var $99d0767d30c65115$export$2e2bcd8739ae039 = $99d0767d30c65115$var$CarouselPrivateRows;

});


parcelRegister("gjs5U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19e1e8b6eb11d1eb$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8mhoa = parcelRequire("8mhoa");

var $dA2bf = parcelRequire("dA2bf");

var $78yL6 = parcelRequire("78yL6");

var $iH0Pu = parcelRequire("iH0Pu");

var $5ANQT = parcelRequire("5ANQT");
const $19e1e8b6eb11d1eb$var$CarouselFilters = ({ single: single, uniqId: uniqId })=>{
    const { dispatch: dispatch, selectedFinanceOption: selectedFinanceOption, selectedBusinessDistance: selectedBusinessDistance, selectedPrivateDistance: selectedPrivateDistance, showPrivateMileages: showPrivateMileages, businessEditionFilter: businessEditionFilter, options: options } = (0, $8mhoa.useStore)((0, $iH0Pu.getStoreByKey)(uniqId));
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "pb-10 flex flex-wrap gap-x-8 gap-y-4",
        children: [
            !single ? /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h5", {
                        className: "px-4 text-sm font-semibold mb-2",
                        children: "Drivlina"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "flex gap-2 overflow-x-auto max-w-[100dvw] px-4",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $78yL6.default), {
                            uniqId: uniqId
                        })
                    })
                ]
            }) : null,
            !options && businessEditionFilter !== 'only' && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h5", {
                        className: "px-4 text-sm font-semibold mb-2",
                        children: "Finansiering"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "flex gap-2 overflow-x-auto max-w-[100dvw] px-4",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                onClick: ()=>dispatch({
                                        type: 'FINANCE_OPTION',
                                        payload: undefined
                                    }),
                                className: `${(0, $5ANQT.buttonClasses)} ${!selectedFinanceOption ? (0, $5ANQT.activeButtonClasses) : null}`,
                                children: "Alla"
                            }),
                            Object.values((0, $dA2bf.FinanceOption)).map((option)=>/*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                    className: `${(0, $5ANQT.buttonClasses)} ${selectedFinanceOption === option ? (0, $5ANQT.activeButtonClasses) : null}`,
                                    onClick: ()=>dispatch({
                                            type: 'FINANCE_OPTION',
                                            payload: option
                                        }),
                                    children: option
                                }, option))
                        ]
                    })
                ]
            }),
            selectedFinanceOption === (0, $dA2bf.FinanceOption).BUSINESS && businessEditionFilter !== 'only' ? /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h5", {
                        className: "px-4 text-sm font-semibold mb-2",
                        children: "\xc5rlig k\xf6rstr\xe4cka"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "flex gap-2 overflow-x-auto max-w-[100dvw] px-4",
                        children: Object.values((0, $dA2bf.BusinessDistance)).map((distance)=>/*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                className: `${(0, $5ANQT.buttonClasses)} ${selectedBusinessDistance === distance ? (0, $5ANQT.activeButtonClasses) : null}`,
                                onClick: ()=>dispatch({
                                        type: 'BUSINESS_DISTANCE',
                                        payload: distance
                                    }),
                                children: distance
                            }, distance))
                    })
                ]
            }) : null,
            businessEditionFilter !== 'only' && (selectedFinanceOption === (0, $dA2bf.FinanceOption).PRIVATE || options?.fields.includes((0, $5ANQT.CarouselFieldsEnum).PRIVATE_DESCRIPTION)) && showPrivateMileages ? /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h5", {
                        className: "px-4 text-sm font-semibold mb-2",
                        children: "\xc5rlig k\xf6rstr\xe4cka"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "flex gap-2 overflow-x-auto max-w-[100dvw] px-4",
                        children: Object.values((0, $dA2bf.PrivateDistance)).map((distance)=>/*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                className: `${(0, $5ANQT.buttonClasses)} ${selectedPrivateDistance === distance ? (0, $5ANQT.activeButtonClasses) : null}`,
                                onClick: ()=>dispatch({
                                        type: 'PRIVATE_DISTANCE',
                                        payload: distance
                                    }),
                                children: distance
                            }, distance))
                    })
                ]
            }) : null
        ]
    });
};
var $19e1e8b6eb11d1eb$export$2e2bcd8739ae039 = $19e1e8b6eb11d1eb$var$CarouselFilters;

});
parcelRegister("78yL6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f624cd705b13bdfb$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $8mhoa = parcelRequire("8mhoa");

var $jZedf = parcelRequire("jZedf");

var $1lSPe = parcelRequire("1lSPe");

var $iH0Pu = parcelRequire("iH0Pu");

var $5ANQT = parcelRequire("5ANQT");
const $f624cd705b13bdfb$var$CarouselFuels = ({ uniqId: uniqId })=>{
    const [fuels, setFuels] = (0, $8FY87.useState)([]);
    const { dispatch: dispatch, selectedFuels: selectedFuels } = (0, $8mhoa.useStore)((0, $iH0Pu.getStoreByKey)(uniqId));
    const fetchFuelTypes = async ()=>{
        try {
            const { data: data } = await (0, $jZedf.fetchWithType)((0, $1lSPe.getAdminUrl)() + '/api/types', {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${(0, $1lSPe.getApiToken)()}`
                }
            });
            if (data && data.length) {
                setFuels(data);
                if (!(0, $1lSPe.locationIsKia)()) sessionStorage.setItem('kia-carousel-fuels', JSON.stringify(data));
            }
        } catch (error) {
            console.error('Error fetching fuel types:', error);
        }
    };
    (0, $8FY87.useEffect)(()=>{
        if (sessionStorage.getItem('kia-carousel-fuels')) setFuels(JSON.parse(sessionStorage.getItem('kia-carousel-fuels') || '[]'));
        else fetchFuelTypes();
    }, []);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                onClick: ()=>dispatch({
                        type: 'FUEL',
                        payload: []
                    }),
                className: `${(0, $5ANQT.buttonClasses)} ${!selectedFuels.length ? (0, $5ANQT.activeButtonClasses) : null}`,
                children: "Alla"
            }),
            fuels.map((fuel)=>/*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                    className: `${(0, $5ANQT.buttonClasses)} ${selectedFuels.includes(fuel.id) ? (0, $5ANQT.activeButtonClasses) : null}`,
                    onClick: ()=>dispatch({
                            type: 'FUEL',
                            payload: [
                                fuel.id
                            ]
                        }),
                    children: fuel.name
                }, fuel.id))
        ]
    });
};
var $f624cd705b13bdfb$export$2e2bcd8739ae039 = $f624cd705b13bdfb$var$CarouselFuels;

});


parcelRegister("a3tFn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a1194f97f83ed77$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
const $3a1194f97f83ed77$var$PrimaryButton = ({ children: children, onClick: onClick, className: className, type: type, mode: mode = 'light', state: state = 'idle' })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
        type: type || 'button',
        onClick: onClick,
        disabled: state === 'loading',
        className: `bg-black hover:underline underline-offset-2 text-white w-72 min-w-full max-w-full px-2 py-3 flex items-center justify-center ${state === 'loading' ? 'opacity-80' : ''} ${className} ${mode === 'dark' ? 'border border-white' : ''}`,
        children: [
            state === 'loading' ? /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "animate-spin rounded-full border-t-2 border-r-2 border-white h-5 w-5 mr-2"
            }) : null,
            children
        ]
    });
};
var $3a1194f97f83ed77$export$2e2bcd8739ae039 = $3a1194f97f83ed77$var$PrimaryButton;

});

parcelRegister("hDVzU", function(module, exports) {

module.exports = (parcelRequire("a0MnV"))($parcel$resolve("clzlU")).then(()=>parcelRequire('hU8fG'));

});
parcelRegister("a0MnV", function(module, exports) {
"use strict";

var $ixYzc = parcelRequire("ixYzc");
module.exports = $ixYzc(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("ixYzc", function(module, exports) {
"use strict";
var $d80a4a5444370561$var$cachedBundles = {};
var $d80a4a5444370561$var$cachedPreloads = {};
var $d80a4a5444370561$var$cachedPrefetches = {};
function $d80a4a5444370561$var$getCache(type) {
    switch(type){
        case 'preload':
            return $d80a4a5444370561$var$cachedPreloads;
        case 'prefetch':
            return $d80a4a5444370561$var$cachedPrefetches;
        default:
            return $d80a4a5444370561$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $d80a4a5444370561$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("eRN6V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf75d2302f2901d6$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $655D0 = parcelRequire("655D0");

var $8mhoa = parcelRequire("8mhoa");

var $jZedf = parcelRequire("jZedf");

var $1lSPe = parcelRequire("1lSPe");

var $7NDEC = parcelRequire("7NDEC");

var $gjs5U = parcelRequire("gjs5U");

var $dfZyB = parcelRequire("dfZyB");

var $f4yZE = parcelRequire("f4yZE");

var $iH0Pu = parcelRequire("iH0Pu");

var $5ANQT = parcelRequire("5ANQT");

var $j2mYw = parcelRequire("j2mYw");

const $cf75d2302f2901d6$var$Snippet = /*#__PURE__*/ (0, $8FY87.lazy)(()=>Promise.resolve((parcelRequire("f0NwZ"))));

const $cf75d2302f2901d6$var$CarouselControls = /*#__PURE__*/ (0, $8FY87.lazy)(()=>(parcelRequire("hDVzU")));
const $cf75d2302f2901d6$var$maybeUniqId = (0, $1lSPe.getUniqId)();
const $cf75d2302f2901d6$var$Carousel = ({ pricelist: pricelist, fields: fields, heading: heading, imageType: imageType, fuelId: fuelId, categoryIds: categoryIds, hideControls: hideControls, uniqKey: uniqKey, sort: sort, sortBy: sortBy, privateMileages: privateMileages, onlyBusinessEdition: onlyBusinessEdition, includeBusinessEdition: includeBusinessEdition })=>{
    const uniqId = uniqKey || $cf75d2302f2901d6$var$maybeUniqId;
    const { dispatch: dispatch, options: options, currentHeading: currentHeading, direction: direction, selectedFinanceOption: selectedFinanceOption, selectedFuels: selectedFuels, isLoaded: isLoaded, selectedCategories: selectedCategories, showPrivateMileages: showPrivateMileages, businessEditionFilter: businessEditionFilter, sortField: sortField, sortDirection: sortDirection } = (0, $8mhoa.useStore)((0, $iH0Pu.getStoreByKey)(uniqId));
    const [sliderKey, setSliderKey] = (0, $8FY87.useState)(0);
    const setData = (models)=>{
        sessionStorage.setItem('kia-carousel-models', JSON.stringify(models));
        dispatch({
            type: 'MODELS',
            payload: models
        });
        dispatch({
            type: 'FILTERED_MODELS',
            payload: models
        });
        dispatch({
            type: 'SHOW_PRIVATE_MILEAGES',
            payload: true
        });
        if (onlyBusinessEdition) dispatch({
            type: 'SET_BUSINESS_EDITION_FILTER',
            payload: 'only'
        });
        else if (includeBusinessEdition) dispatch({
            type: 'SET_BUSINESS_EDITION_FILTER',
            payload: 'include'
        });
        else dispatch({
            type: 'SET_BUSINESS_EDITION_FILTER',
            payload: 'exclude'
        });
        if (pricelist) dispatch({
            type: 'SHOW_PRICELIST',
            payload: true
        });
        else {
            if (heading) dispatch({
                type: 'HEADING',
                payload: heading
            });
            if (imageType) dispatch({
                type: 'IMAGE_TYPE',
                payload: imageType
            });
            if (fields) dispatch({
                type: 'CONTROLS',
                payload: fields.split(',')
            });
            if (fuelId) dispatch({
                type: 'FUEL',
                payload: fuelId.split(',').map((f)=>Number(f))
            });
            if (categoryIds) dispatch({
                type: 'CATEGORY',
                payload: categoryIds.split(',').map((c)=>Number(c))
            });
            if (sort) dispatch({
                type: 'SORT_BY',
                payload: sort,
                sortBy: sortBy
            });
        }
        dispatch({
            type: 'IS_LOADED',
            payload: true
        });
    };
    const fetchModels = async ()=>{
        let models = JSON.parse(sessionStorage.getItem('kia-carousel-models')) ?? [];
        if (!models.length) try {
            const { data: data } = await (0, $jZedf.fetchWithType)((0, $1lSPe.getAdminUrl)() + '/api/models', {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${(0, $1lSPe.getApiToken)()}`
                }
            });
            if (data && data.length) models = data;
        } catch (error) {
            console.error('Error fetching trims:', error);
        }
        setData(models);
    };
    (0, $8FY87.useEffect)(()=>{
        if (isLoaded) {
            dispatch({
                type: 'FILTER_MODELS'
            });
            setSliderKey((prev)=>prev + 1);
        }
    }, [
        selectedFuels,
        selectedFinanceOption,
        selectedCategories,
        businessEditionFilter
    ]);
    (0, $8FY87.useEffect)(()=>{
        fetchModels();
    }, []);
    const getSnippetProps = ()=>{
        const businessEditionAttr = businessEditionFilter === 'only' ? ` onlyBusinessEdition="true"` : businessEditionFilter === 'include' ? ` includeBusinessEdition="true"` : '';
        if (!options) return `pricelist="true" privateMileages="${showPrivateMileages}"${businessEditionAttr}`;
        return Object.entries(options).map(([key, value])=>value ? `${key}="${value}"` : '').filter(Boolean).join(' ') + ` ${selectedFuels ? `fuelId="${selectedFuels.join(',')}"` : ''} ${selectedCategories ? `categoryIds="${selectedCategories.join(',')}"` : ''} ${sortField ? `sort="${sortField}" sortBy="${sortDirection}"` : ''} ${heading ? ` heading="${heading}"` : ''} privateMileages="${showPrivateMileages}"${businessEditionAttr}`;
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: `pt-4 pb-12 ${direction === 'vertical' ? 'max-w-screen-kia-sm mx-auto' : ''}`,
        children: [
            !(0, $1lSPe.locationIsKia)() && !hideControls ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)($cf75d2302f2901d6$var$CarouselControls, {
                        uniqId: uniqId,
                        type: "carousel"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)($cf75d2302f2901d6$var$Snippet, {
                        page: "carousel",
                        props: getSnippetProps()
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "max-w-screen-kia-sm mx-auto relative",
                children: [
                    currentHeading ? /*#__PURE__*/ (0, $2PPWI.jsx)("h1", {
                        className: "pb-6 px-4",
                        children: currentHeading
                    }) : null,
                    !options ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $gjs5U.default), {
                        uniqId: uniqId
                    }) : businessEditionFilter !== 'only' && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $dfZyB.default), {
                        uniqId: uniqId
                    }),
                    !options || options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).CHANGE_DIRECTION) ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $7NDEC.default), {
                        uniqId: uniqId
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f4yZE.default), {
                uniqId: uniqId
            }, sliderKey),
            !options || options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).CTA_RETAILER) ? /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: `px-4 gap-4 pt-4 flex justify-center flex-col sm:flex-row ${direction === 'vertical' ? 'sm:hidden' : ''}`,
                children: !options || options.fields.includes((0, $5ANQT.CarouselFieldsEnum).CTA_RETAILER) ? /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                    onClick: ()=>(0, $655D0.trackEvent)({
                            event: 'contact_dealer',
                            model: undefined
                        }),
                    href: "https://www.kia.com/se/provkor/#/",
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $j2mYw.default), {
                        children: "Kontakta \xe5terf\xf6rs\xe4ljare"
                    })
                }) : null
            }) : null
        ]
    });
};
var $cf75d2302f2901d6$export$2e2bcd8739ae039 = $cf75d2302f2901d6$var$Carousel;

});
parcelRegister("7NDEC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49d24651fe191c8d$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8mhoa = parcelRequire("8mhoa");

var $iH0Pu = parcelRequire("iH0Pu");
const $49d24651fe191c8d$var$CarouselDirection = ({ uniqId: uniqId })=>{
    const { direction: direction, dispatch: dispatch } = (0, $8mhoa.useStore)((0, $iH0Pu.getStoreByKey)(uniqId));
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "absolute right-4 bottom-0 hidden sm:block",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                "aria-label": "Set vertical direction",
                className: "pr-2",
                onClick: ()=>dispatch({
                        type: 'DIRECTION',
                        payload: 'vertical'
                    }),
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("svg", {
                    width: "30",
                    height: "30",
                    viewBox: "0 0 30 30",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                            d: "M7.5 9H10.5V12H7.5V9Z",
                            fill: direction === 'vertical' ? '#05141F' : '#9BA1A5'
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                            d: "M12 14.25H22.5V15.75H12V14.25Z",
                            fill: direction === 'vertical' ? '#05141F' : '#9BA1A5'
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                            d: "M12 9.75H22.5V11.25H12V9.75Z",
                            fill: direction === 'vertical' ? '#05141F' : '#9BA1A5'
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                            d: "M12 18.75H22.5V20.25H12V18.75Z",
                            fill: direction === 'vertical' ? '#05141F' : '#9BA1A5'
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                            d: "M7.5 13.5H10.5V16.5H7.5V13.5Z",
                            fill: direction === 'vertical' ? '#05141F' : '#9BA1A5'
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                            d: "M7.5 18H10.5V21H7.5V18Z",
                            fill: direction === 'vertical' ? '#05141F' : '#9BA1A5'
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                "aria-label": "Set horizontal direction",
                onClick: ()=>dispatch({
                        type: 'DIRECTION',
                        payload: 'horizontal'
                    }),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                    width: "30",
                    height: "30",
                    viewBox: "0 0 30 30",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                        d: "M12.75 12.75H17.25V17.25H12.75V12.75ZM6.75 13.5H9.75V16.5H6.75V13.5ZM20.25 13.5H23.25V16.5H20.25V13.5Z",
                        stroke: direction === 'horizontal' ? '#05141F' : '#9BA1A5',
                        strokeWidth: "1.5"
                    })
                })
            })
        ]
    });
};
var $49d24651fe191c8d$export$2e2bcd8739ae039 = $49d24651fe191c8d$var$CarouselDirection;

});

parcelRegister("dfZyB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54b7cb7d4332e013$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8mhoa = parcelRequire("8mhoa");

var $dA2bf = parcelRequire("dA2bf");

var $iH0Pu = parcelRequire("iH0Pu");

var $5ANQT = parcelRequire("5ANQT");
function $54b7cb7d4332e013$export$2e2bcd8739ae039({ uniqId: uniqId }) {
    const { dispatch: dispatch, selectedBusinessDistance: selectedBusinessDistance, selectedPrivateDistance: selectedPrivateDistance, options: options } = (0, $8mhoa.useStore)((0, $iH0Pu.getStoreByKey)(uniqId));
    if (!options?.fields.includes((0, $5ANQT.CarouselFieldsEnum).SHOW)) return;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            options?.fields?.length && options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).BUSINESS_LEASE) ? /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "pb-5",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h5", {
                        className: "px-4 text-sm font-semibold mb-2",
                        children: "\xc5rlig k\xf6rstr\xe4cka"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "flex gap-2 overflow-x-auto max-w-[100dvw] px-4",
                        children: Object.values((0, $dA2bf.BusinessDistance)).map((distance)=>/*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                className: `${(0, $5ANQT.buttonClasses)} ${selectedBusinessDistance === distance ? (0, $5ANQT.activeButtonClasses) : null}`,
                                onClick: ()=>dispatch({
                                        type: 'BUSINESS_DISTANCE',
                                        payload: distance
                                    }),
                                children: distance
                            }, distance))
                    })
                ]
            }) : null,
            options?.fields?.length && options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).PRIVATE_LEASING) ? /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "pb-5",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h5", {
                        className: "px-4 text-sm font-semibold mb-2",
                        children: "\xc5rlig k\xf6rstr\xe4cka"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "flex gap-2 overflow-x-auto max-w-[100dvw] px-4",
                        children: Object.values((0, $dA2bf.PrivateDistance)).map((distance)=>/*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                className: `${(0, $5ANQT.buttonClasses)} ${selectedPrivateDistance === distance ? (0, $5ANQT.activeButtonClasses) : null}`,
                                onClick: ()=>dispatch({
                                        type: 'PRIVATE_DISTANCE',
                                        payload: distance
                                    }),
                                children: distance
                            }, distance))
                    })
                ]
            }) : null
        ]
    });
}

});

parcelRegister("f4yZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $beed81ddf5da3b92$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $8mhoa = parcelRequire("8mhoa");

var $edALU = parcelRequire("edALU");

var $iH0Pu = parcelRequire("iH0Pu");

var $5ANQT = parcelRequire("5ANQT");

var $ba1Bn = parcelRequire("ba1Bn");
const $beed81ddf5da3b92$var$CarouselSlider = ({ uniqId: uniqId })=>{
    const { direction: direction, options: options } = (0, $8mhoa.useStore)((0, $iH0Pu.getStoreByKey)(uniqId));
    const slider = (0, $8FY87.useRef)(null);
    const [control, setControls] = (0, $8FY87.useState)('right');
    const checkControls = ()=>{
        const container = slider.current;
        if (!container) return;
        setTimeout(()=>{
            if (container.scrollLeft < 40) setControls('right');
            else if (container.scrollLeft >= container.scrollWidth - (container.clientWidth + 40)) setControls('left');
            else setControls('both');
        }, 700);
    };
    const slideRight = ()=>{
        const container = slider.current;
        container.scrollLeft = container.scrollLeft + container.lastElementChild.clientWidth;
        checkControls();
    };
    const slideLeft = ()=>{
        const container = slider.current;
        container.scrollLeft = container.scrollLeft - container.lastElementChild.clientWidth;
        checkControls();
    };
    (0, $8FY87.useEffect)(()=>{
        document.addEventListener('touchend', ()=>checkControls());
        return ()=>{
            document.removeEventListener('touchend', ()=>checkControls());
        };
    }, []);
    const sortedModels = (0, $ba1Bn.useSortedModels)(uniqId);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                ref: slider,
                className: `gap-x-4 px-4 scrollbar-hide pb-4 overflow-x-auto overflow-y-hidden scroll-smooth snap-x box-border grid grid-flow-col ${direction === 'vertical' ? 'sm:flex sm:flex-col' : ''}`,
                children: sortedModels.map((model)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $edALU.default), {
                        uniqId: uniqId,
                        model: model
                    }, model.id))
            }),
            direction === 'horizontal' || window.innerWidth < 640 ? /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: `absolute z-50 transform -translate-y-1/2 w-[calc(100%-1rem)] left-2 justify-between flex gap-2 pointer-events-none md:right-12 ${!options || options?.fields.includes((0, $5ANQT.CarouselFieldsEnum).CHANGE_TRIM) ? 'top-48' : 'top-1/2'}`,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                        className: `pointer-events-auto bg-white rounded-full shadow-md ${[
                            'left',
                            'both'
                        ].includes(control) ? '' : 'opacity-0 pointer-events-none md:pointer-events-auto'}`,
                        "aria-label": "G\xe5 till v\xe4nster",
                        onClick: ()=>slideLeft(),
                        disabled: ![
                            'left',
                            'both'
                        ].includes(control),
                        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("svg", {
                            width: "37",
                            height: "37",
                            viewBox: "0 0 37 37",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("circle", {
                                    opacity: "0.2",
                                    cx: "18.5",
                                    cy: "18.5",
                                    r: "18",
                                    fill: "#fff"
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                                    d: "M20 23L15.5 18.5L20 14",
                                    stroke: "#000",
                                    strokeWidth: "1.5"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                        className: `pointer-events-auto bg-white rounded-full shadow-md ${[
                            'right',
                            'both'
                        ].includes(control) ? '' : 'opacity-0 pointer-events-none md:pointer-events-auto'}`,
                        "aria-label": "G\xe5 till h\xf6ger",
                        onClick: ()=>slideRight(),
                        disabled: ![
                            'right',
                            'both'
                        ].includes(control),
                        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("svg", {
                            width: "37",
                            height: "37",
                            viewBox: "0 0 37 37",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("circle", {
                                    opacity: "0.2",
                                    cx: "18.5",
                                    cy: "18.5",
                                    r: "18",
                                    fill: "none"
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                                    d: "M17 23L21.5 18.5L17 14",
                                    stroke: "#000",
                                    strokeWidth: "1.5"
                                })
                            ]
                        })
                    })
                ]
            }) : null
        ]
    });
};
var $beed81ddf5da3b92$export$2e2bcd8739ae039 = $beed81ddf5da3b92$var$CarouselSlider;

});
parcelRegister("ba1Bn", function(module, exports) {

$parcel$export(module.exports, "useSortedModels", function () { return $981f9f384003027a$export$8aede617f59bdcf1; });

var $8FY87 = parcelRequire("8FY87");

var $8mhoa = parcelRequire("8mhoa");

var $dA2bf = parcelRequire("dA2bf");

var $iH0Pu = parcelRequire("iH0Pu");

var $5ANQT = parcelRequire("5ANQT");
const $981f9f384003027a$export$8aede617f59bdcf1 = (uniqId)=>{
    const { filteredModels: filteredModels, options: options, sortField: sortField, sortDirection: sortDirection, showPrivateMileages: showPrivateMileages, selectedPrivateDistance: selectedPrivateDistance } = (0, $8mhoa.useStore)((0, $iH0Pu.getStoreByKey)(uniqId));
    const sortedModels = (0, $8FY87.useMemo)(()=>{
        const modelsToSort = [
            ...filteredModels
        ];
        const allowSorting = options?.fields?.includes((0, $5ANQT.CarouselFieldsEnum).ALLOW_SORTING);
        // if we dont sort fallback to default weight sort.
        if (!allowSorting || !sortField) return modelsToSort.sort((a, b)=>a.weight > b.weight ? 1 : -1);
        return modelsToSort.sort((a, b)=>{
            if (sortField === (0, $5ANQT.CarouselFieldsEnum).PRIVATE_LEASING) {
                const aShowsLeasing = a.show_privatleasing;
                const bShowsLeasing = b.show_privatleasing;
                if (aShowsLeasing && !bShowsLeasing) return -1;
                if (!aShowsLeasing && bShowsLeasing) return 1;
            }
            const sortModifier = sortDirection === 'asc' ? 1 : -1;
            let valA = 0;
            let valB = 0;
            const getPrivateLeasingPrice = (car)=>{
                const leasingData = car?.private_leasing?.[0];
                if (!leasingData) return 0;
                if (showPrivateMileages) switch(selectedPrivateDistance){
                    case (0, $dA2bf.PrivateDistance).Two:
                        return leasingData.manadshyra364500 ?? 0;
                    case (0, $dA2bf.PrivateDistance).Three:
                        return leasingData.manadshyra366000 ?? 0;
                    case (0, $dA2bf.PrivateDistance).Four:
                        return leasingData.manadshyra369000 ?? 0;
                    default:
                        return leasingData.manadshyra363000 ?? 0;
                }
                return leasingData.manadshyra363000 ?? 0;
            };
            switch(sortField){
                case (0, $5ANQT.CarouselFieldsEnum).FROM_PRICE:
                    valA = a.first_car?.price ?? 0;
                    valB = b.first_car?.price ?? 0;
                    break;
                case (0, $5ANQT.CarouselFieldsEnum).PRIVATE_LEASING:
                    valA = getPrivateLeasingPrice(a.first_car);
                    valB = getPrivateLeasingPrice(b.first_car);
                    break;
                case (0, $5ANQT.CarouselFieldsEnum).BUSINESS_LEASE:
                    valA = a.first_car?.business_leasing?.[0]?.s_6000_inkl_forsakring ?? 0;
                    valB = b.first_car?.business_leasing?.[0]?.s_6000_inkl_forsakring ?? 0;
                    break;
                case (0, $5ANQT.CarouselFieldsEnum).BENEFICIAL_VALUE:
                    valA = a.first_car?.beneficial_value ?? 0;
                    valB = b.first_car?.beneficial_value ?? 0;
                    break;
            }
            const aHasValue = valA !== 0;
            const bHasValue = valB !== 0;
            if (!aHasValue && bHasValue) return 1;
            if (aHasValue && !bHasValue) return -1;
            if (!aHasValue && !bHasValue) return 0;
            if (valA < valB) return -1 * sortModifier;
            if (valA > valB) return 1 * sortModifier;
            return 0;
        });
    }, [
        filteredModels,
        options,
        sortField,
        sortDirection,
        showPrivateMileages,
        selectedPrivateDistance
    ]);
    return sortedModels;
};

});


parcelRegister("j2mYw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecbbf8d6d632170b$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
const $ecbbf8d6d632170b$var$SecondaryButton = ({ children: children, onClick: onClick, className: className })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
        onClick: onClick,
        className: `border-black hover:underline underline-offset-2 border w-72 min-w-full max-w-full px-2 py-3 ${className}`,
        children: children
    });
};
var $ecbbf8d6d632170b$export$2e2bcd8739ae039 = $ecbbf8d6d632170b$var$SecondaryButton;

});


parcelRegister("lix2c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcb77ad13d421980$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $3f5pY = parcelRequire("3f5pY");

var $kZPx9 = parcelRequire("kZPx9");

var $jeu8h = parcelRequire("jeu8h");

var $f0NwZ = parcelRequire("f0NwZ");

var $2IJYm = parcelRequire("2IJYm");

var $3eb7t = parcelRequire("3eb7t");

var $2FCIq = parcelRequire("2FCIq");

var $cMeiR = parcelRequire("cMeiR");

var $eO5QR = parcelRequire("eO5QR");
const $bcb77ad13d421980$var$ClimateBounusPVFive = ()=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("main", {
        className: "relative max-w-screen-kia mx-auto",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $cMeiR.default), {
                ...(0, $eO5QR.heroCBPV5)
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "w-full mx-auto",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                            initial: "hidden",
                            whileInView: "visible",
                            variants: (0, $51Ucj.containerVariants),
                            viewport: (0, $51Ucj.viewPort),
                            className: "mb-16 mx-auto max-w-screen-kia-sm object-fill",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                                variants: (0, $51Ucj.itemVariants),
                                className: " text-center font-light text-[18px] px-2 mt-[28px]",
                                children: (0, $eO5QR.text001)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: " mx-auto px-6 w-full  max-w-7xl mb-7",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponentWidth: "col-span-4",
                            secondComponentWidth: "col-span-4 ",
                            mainBoxClassName: "mx-auto w-full max-w-7xl",
                            firstComponentClassName: "p-0 lg:p-10 lg:pt-0",
                            secondComponentClassName: "p-0",
                            mobilFirstComponentOnTop: false,
                            desktopFirstComponentFirst: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        className: (0, $eO5QR.climatePremiumIntro).titleClass,
                                        children: (0, $eO5QR.climatePremiumIntro).title
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: (0, $eO5QR.climatePremiumIntro).textClass,
                                        children: (0, $eO5QR.climatePremiumIntro).text
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                                        className: (0, $eO5QR.climatePremiumIntro).listClass,
                                        children: (0, $eO5QR.climatePremiumIntro).listItems.map((item, i)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                                                className: "flex items-start space-x-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2IJYm.default), {
                                                        className: "w-[6px] h-[6px] mt-[7px] flex-shrink-0"
                                                    }),
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                        className: "text-base font-[300] leading-[1.3]",
                                                        children: item
                                                    })
                                                ]
                                            }, i))
                                    })
                                ]
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                ...(0, $eO5QR.smallImg001)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: " mx-auto px-6 w-full  max-w-7xl mb-10",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponentWidth: "col-span-4",
                            secondComponentWidth: "col-span-4 ",
                            mainBoxClassName: "mx-auto w-full max-w-7xl",
                            firstComponentClassName: "p-0 ",
                            secondComponentClassName: "p-0 lg:p-10 lg:pt-0",
                            mobilFirstComponentOnTop: true,
                            desktopFirstComponentFirst: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                ...(0, $eO5QR.smallImg002)
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        className: (0, $eO5QR.applicationSection).titleClass,
                                        children: (0, $eO5QR.applicationSection).title
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "mb-6",
                                        children: (0, $eO5QR.applicationSection).paragraphs.map((p, i)=>/*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                className: "mb-1 text-base leading-[1.3] font-[300]",
                                                children: p
                                            }, i))
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        className: (0, $eO5QR.applicationSection).secondTitleClass,
                                        children: (0, $eO5QR.applicationSection).secondTitle
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("ol", {
                                        className: (0, $eO5QR.applicationSection).stepsListClass,
                                        children: (0, $eO5QR.applicationSection).steps.map((step, i)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                                className: "!list-item",
                                                dangerouslySetInnerHTML: {
                                                    __html: step
                                                }
                                            }, i))
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: (0, $eO5QR.applicationSection).footerTextClass,
                                        children: (0, $eO5QR.applicationSection).footerText
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $cMeiR.default), {
                        ...(0, $eO5QR.img001)
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                                initial: "hidden",
                                whileInView: "visible",
                                variants: (0, $51Ucj.containerVariants),
                                viewport: (0, $51Ucj.viewPort),
                                className: "mx-auto max-w-[700px] mt-[28px]",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                                    variants: (0, $51Ucj.itemVariants),
                                    className: "text-center font-light text-[20px] px-2  whitespace-pre-line break-normal hyphens-none  leading-[1.2]",
                                    children: (0, $eO5QR.text002)
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kZPx9.TextBox), {
                                ...(0, $eO5QR.textBoxCB),
                                mtClass: "mt-[33px]",
                                mbClass: "mb-1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("article", {
                        className: "bg-#fff max-w-screen-kia-sm mx-auto ",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3f5pY.default), {
                                ...(0, $eO5QR.faqBlockPL),
                                titleAlign: "left"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "flex justify-center sm:justify-start",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                    ...(0, $eO5QR.linkCB01)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                        page: "climate-bounus-pv5"
                    })
                ]
            })
        ]
    });
};
var $bcb77ad13d421980$export$2e2bcd8739ae039 = $bcb77ad13d421980$var$ClimateBounusPVFive;

});
parcelRegister("3f5pY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e70e0bf72ddc1b62$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $8FY87 = parcelRequire("8FY87");

var $51Ucj = parcelRequire("51Ucj");

var $655D0 = parcelRequire("655D0");
const $e70e0bf72ddc1b62$var$FaqBlock = ({ title: title, questions: questions, className: className, titleAlign: titleAlign = 'center' })=>{
    const [activeIndex, setActiveIndex] = (0, $8FY87.useState)(null);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
        variants: (0, $51Ucj.containerVariants),
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        className: `pt-8 pb-12 px-2 ${className ?? ''}`,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                variants: (0, $51Ucj.itemVariants),
                className: `
          px-4 mb-8 mt-6 pb-8
          ${titleAlign === 'left' ? 'text-left' : 'text-center'}
        `,
                children: title
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                variants: (0, $51Ucj.containerVariants),
                initial: "hidden",
                whileInView: "visible",
                viewport: (0, $51Ucj.viewPort),
                className: "mx-auto max-w-screen-kia-sm px-4",
                children: questions.map((faq, index)=>/*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
                        variants: (0, $51Ucj.itemVariants),
                        className: "border-t border-gray-200",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                                onClick: ()=>setActiveIndex(index === activeIndex ? null : index),
                                className: "flex w-full gap-4 py-4 justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        className: "text-lg text-left font-bold",
                                        children: faq.q
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                                        viewBox: "0 0 512 512",
                                        fill: "#fff",
                                        height: "1.5em",
                                        width: "1.5em",
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                                            fill: "none",
                                            stroke: "#000",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 48,
                                            d: "M112 184l144 144 144-144"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                dangerouslySetInnerHTML: {
                                    __html: faq.a
                                },
                                onClick: (e)=>{
                                    const target = e.target;
                                    const anchor = target.closest('a');
                                    if (anchor?.href.includes('sok-aterforsaljare-verkstad')) (0, $655D0.trackEvent)({
                                        event: 'find_a_dealer',
                                        model: undefined
                                    });
                                },
                                className: `pr-4 pb-4 ${index !== activeIndex ? 'hidden' : ''}`
                            })
                        ]
                    }, index))
            })
        ]
    });
};
var $e70e0bf72ddc1b62$export$2e2bcd8739ae039 = $e70e0bf72ddc1b62$var$FaqBlock;

});

parcelRegister("kZPx9", function(module, exports) {

$parcel$export(module.exports, "highlightText", function () { return $5b40da4123558cbb$export$8e93e90112ff7488; });
$parcel$export(module.exports, "TextBox", function () { return $5b40da4123558cbb$export$10e6f4f66014ee2d; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $a2EmR = parcelRequire("a2EmR");
const $5b40da4123558cbb$export$8e93e90112ff7488 = (text, boldParts)=>{
    if (!boldParts || boldParts.length === 0) return text;
    const regex = new RegExp(`(${boldParts.map((bp)=>bp.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'gi');
    return text.split(regex).map((part, idx)=>boldParts.includes(part) ? /*#__PURE__*/ (0, $2PPWI.jsx)("strong", {
            className: "font-bold",
            children: part
        }, idx) : part);
};
const $5b40da4123558cbb$export$10e6f4f66014ee2d = ({ title: title, backgroundColor: backgroundColor = 'bg-gray-100', numberOfFields: numberOfFields = 3, listItems: listItems = [], textSize: textSize = 'text-base leading-[24px]', titleStyle: titleStyle = 'mb-14 text-[40px] max-w-[717px] leading-[48px]', centerText: centerText = false, iconOnTop: iconOnTop = false, mtClass: mtClass = 'mt-14', mbClass: mbClass = 'mb-14', paddingClass: paddingClass = 'py-8 px-4', className: className = '' })=>{
    const limitedItems = listItems.slice(0, numberOfFields || 3);
    const containerVariants = {
        hidden: {
            opacity: 0
        },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    };
    const itemVariants = {
        hidden: {
            opacity: 0,
            y: 20
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.5
            }
        }
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: `flex flex-col items-center ${backgroundColor} ${paddingClass} ${mtClass} ${mbClass}
      ${className}`,
        children: [
            title && /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                className: `font-normal ${centerText ? 'text-center' : 'text-left'} ${titleStyle} px-3`,
                style: {
                    hyphens: 'none',
                    overflowWrap: 'normal'
                },
                children: title
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                initial: "hidden",
                whileInView: "visible",
                viewport: {
                    once: true,
                    amount: 0.5
                },
                variants: containerVariants,
                className: `grid grid-cols-1 lg:grid-cols-3 gap-8 w-full max-w-7xl ${iconOnTop ? 'lg:justify-start' : 'justify-items-start md:justify-items-center'}`,
                children: limitedItems.map((item, index)=>/*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
                        variants: itemVariants,
                        className: `flex flex-col ${centerText ? 'items-center text-center' : 'items-start text-left'} gap-y-3  w-full md:max-w-[460px] ${index === 1 ? 'self-center' : ''} ${iconOnTop ? 'mx-auto lg:mb-auto' : ''}`,
                        children: [
                            item.title && /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                                className: "text-xl font-bold leading-tight",
                                children: item.title
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: `flex gap-x-3 ${centerText ? 'justify-center' : 'items-start'} ${iconOnTop ? 'flex-col items-center' : ''}`,
                                children: [
                                    item.iconProps && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: `leading-none p-1 sm:p-0 flex-shrink-0 ${iconOnTop ? 'mb-3' : ''}`,
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a2EmR.CheckIcon), {
                                            ...item.iconProps
                                        })
                                    }),
                                    item.subtitle ? /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        className: `${textSize}`,
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                            className: "font-semibold",
                                            children: item.subtitle
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: `${textSize}`,
                                        children: $5b40da4123558cbb$export$8e93e90112ff7488(item.text, item.boldParts)
                                    })
                                ]
                            })
                        ]
                    }, index))
            })
        ]
    });
};

});
parcelRegister("a2EmR", function(module, exports) {

$parcel$export(module.exports, "CheckIcon", function () { return $5dfe7bfeb0e5b48c$export$7dd004358974b05d; });

var $2PPWI = parcelRequire("2PPWI");
const $5dfe7bfeb0e5b48c$export$7dd004358974b05d = ({ width: width = 50, height: height = 50, color: color = 'black', strokeWidth: strokeWidth = 2 })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 50 50",
        fill: color,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
            d: "M20 35 L10 25 L12.5 22.5 L20 30 L37.5 12.5 L40 15 L20 35 Z",
            fill: color,
            stroke: color,
            strokeWidth: strokeWidth,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

});


parcelRegister("2IJYm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1a96568280fd891$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
function $d1a96568280fd891$export$2e2bcd8739ae039({ className: className }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        className: className,
        width: "6",
        height: "6",
        viewBox: "0 0 6 6",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("circle", {
            cx: "3",
            cy: "3",
            r: "3"
        })
    });
}

});

parcelRegister("eO5QR", function(module, exports) {

$parcel$export(module.exports, "heroCBPV5", function () { return $4cb5a2c0203380bb$export$b40f146e7ef5bd78; });
$parcel$export(module.exports, "text001", function () { return $4cb5a2c0203380bb$export$86e19ba4e5ceb1b1; });
$parcel$export(module.exports, "smallImg001", function () { return $4cb5a2c0203380bb$export$68f154a253223e3c; });
$parcel$export(module.exports, "climatePremiumIntro", function () { return $4cb5a2c0203380bb$export$a4d933ddc8b713ea; });
$parcel$export(module.exports, "smallImg002", function () { return $4cb5a2c0203380bb$export$6b083b06802a346e; });
$parcel$export(module.exports, "applicationSection", function () { return $4cb5a2c0203380bb$export$8aff8ed3ec7ec302; });
$parcel$export(module.exports, "text002", function () { return $4cb5a2c0203380bb$export$4213bb3d2e7e1afc; });
$parcel$export(module.exports, "textBoxCB", function () { return $4cb5a2c0203380bb$export$c9ff1974163c4ef9; });
$parcel$export(module.exports, "img001", function () { return $4cb5a2c0203380bb$export$d3ae1c1538d19ed7; });
$parcel$export(module.exports, "faqBlockPL", function () { return $4cb5a2c0203380bb$export$1acb4d00a45d66c2; });
$parcel$export(module.exports, "linkCB01", function () { return $4cb5a2c0203380bb$export$c3c96a8e8098bb1a; });
const $4cb5a2c0203380bb$export$b40f146e7ef5bd78 = {
    image: 'https://kia-afonso-storage.b-cdn.net/PV5/KHQ_EV_Day_PV5_Cargo_KeyVisual_34SideFront.jpg',
    title: "Klimatpremie f\xf6r\n l\xe4tta ellastbilar.",
    subtitle: "Ans\xf6k om klimatpremie f\xf6r PV5 Cargo.",
    position: 'bottom',
    hAlign: 'left',
    titleClass: 'text-[clamp(38px,8vw,64px)] font-[400]',
    subtitleClass: 'text-[clamp(14px,5vw,24px)] font-[300]'
};
const $4cb5a2c0203380bb$export$86e19ba4e5ceb1b1 = "F\xf6retag, kommuner och regioner som ska investera i en eldriven l\xe4tt lastbil kan ans\xf6ka om en klimatpremie fr\xe5n Energimyndigheten. H\xe4r f\xe5r ni veta hur ans\xf6kan g\xe5r till.";
const $4cb5a2c0203380bb$export$68f154a253223e3c = {
    src: 'https://kia-afonso-storage.b-cdn.net/PV5/KHQ_EV_Day_PV5_Cargo_KeyVisual_Interior_FrontView.jpg',
    alt: 'inside car pv5',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto pt-0 w-full h-full object-cover'
};
const $4cb5a2c0203380bb$export$a4d933ddc8b713ea = {
    title: "Vad \xe4r klimatpremien?",
    titleClass: 'text-[24px] font-[400] mb-4',
    text: "2024 inf\xf6rde Energimyndigheten en klimatpremie f\xf6r l\xe4tta elbilar f\xf6r att fr\xe4mja introduktionen av en viss typ av milj\xf6fordon. Det inneb\xe4r:",
    textClass: 'mb-6 text-[18px] font-[300] leading-[1.3]',
    listClass: 'ml-4 space-y-1 text-base font-[300]',
    listItems: [
        "St\xf6det \xe4r upp till 30 % av den st\xf6dber\xe4ttigade kostnaden, men h\xf6gst 40 000 kr per l\xe4tt elbil till och med den 31 oktober 2027.",
        "Klimatpremien upph\xf6r Klimatpremien upph\xf6r 1 november 2027."
    ]
};
const $4cb5a2c0203380bb$export$6b083b06802a346e = {
    src: 'https://kia-afonso-storage.b-cdn.net/PV5/KHQ_EV_Day_PV5_Cargo_KeyVisual_Interior_CargoView.jpg',
    alt: 'inside car pv5',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto pt-0 w-full object-cover'
};
const $4cb5a2c0203380bb$export$8aff8ed3ec7ec302 = {
    title: "Vem kan ans\xf6ka?",
    titleClass: 'text-[20px] font-[400] mb-2',
    paragraphs: [
        "F\xf6retag, kommuner och regioner \xe4r ber\xe4ttigade st\xf6det. F\xf6r att st\xf6det ska kunna betalas ut m\xe5ste ni ha ett bankgiro eller plusgiro kopplat till organisationsnumret.",
        "Om ni leasar er l\xe4tta lastbil \xe4r det leasingbolaget som ans\xf6ker om st\xf6det."
    ],
    secondTitle: "Hur ans\xf6ker jag?",
    secondTitleClass: 'text-[20px] font-[400] mb-4',
    stepsListClass: 'space-y-1 text-base font-[300]',
    steps: [
        "1. <a href='https://minasidor.energimyndigheten.se/'>Logga in p\xe5 Mina sidor p\xe5 Energimyndigheten med personligt BankID.</a>",
        "2. Ans\xf6k om beh\xf6righet till e-tj\xe4nsten Klimatpremie.",
        "3. N\xe4r beh\xf6righeten \xe4r beviljad kan ni skicka in er ans\xf6kan.",
        "4. N\xe4r ans\xf6kan \xe4r inskickad till Energimyndigheten kan ni best\xe4lla fordonet."
    ],
    footerText: "Obs! F\xf6r att ans\xf6kan ska vara giltig m\xe5ste ni ans\xf6ka om st\xf6det innan ni best\xe4ller bilen.",
    footerTextClass: 'mt-4 text-base font-light'
};
const $4cb5a2c0203380bb$export$4213bb3d2e7e1afc = "F\xf6r att en l\xe4tt lastbil ska vara ber\xe4ttigad Energimyndighetens klimatpremie ska den m\xf6ta f\xf6ljande krav:";
const $4cb5a2c0203380bb$export$c9ff1974163c4ef9 = {
    title: '',
    backgroundColor: '',
    numberOfFields: 3,
    titleStyle: '',
    textSize: 'text-base md:text-lg font-light',
    listItems: [
        {
            text: "Den ska vara registrerad som lastbil i Transportstyrelsens v\xe4gtrafikregister.",
            boldParts: [
                ''
            ],
            iconProps: {
                color: '#000',
                width: 22,
                height: 22,
                strokeWidth: 3
            }
        },
        {
            text: "Den f\xe5r enbart drivas av el eller av el som producerats av v\xe4tgas via br\xe4nsleceller.",
            boldParts: [
                ''
            ],
            iconProps: {
                color: '#000',
                width: 22,
                height: 22,
                strokeWidth: 3
            }
        },
        {
            text: "Den har en totalvikt p\xe5 maximalt 3,5 ton.",
            boldParts: [
                ''
            ],
            iconProps: {
                color: '#000',
                width: 22,
                height: 22,
                strokeWidth: 3
            }
        }
    ]
};
const $4cb5a2c0203380bb$export$d3ae1c1538d19ed7 = {
    image: 'https://kia-afonso-storage.b-cdn.net/PV5/KHQ_EV_Day_PV5_Cargo_KeyVisual_TopViewRear.jpg',
    title: "Vilka l\xe4tta lastbilar \xe4r ber\xe4ttigade\n en klimatpremie?\xa0",
    position: 'top',
    hAlign: 'left',
    titleClass: 'text-[clamp(24px,6vw,48px)] font-[400] ',
    subtitleClass: 'hidden'
};
const $4cb5a2c0203380bb$export$1acb4d00a45d66c2 = {
    title: "Vanliga fr\xe5gor och svar om klimatpremien.",
    questions: [
        {
            q: "G\xe4ller st\xf6det vid leasing?",
            a: "Det \xe4r endast den som k\xf6pt fordonet och st\xe5r som \xe4gare f\xf6r fordonet som \xe4r st\xf6dber\xe4ttigad.</br></br>F\xf6r att utbetalning ska kunna g\xf6ras, m\xe5ste den som s\xf6kt st\xf6det, k\xf6pt och st\xe4llt p\xe5 fordonet ocks\xe5 vara registrerad som \xe4gare i Transportstyrelsens v\xe4gtrafikregister och fordonet ska vara registrerat i Sverige.</br></br>Vanligtvis \xe4r leasinggivaren \xe4gare av fordonet och leasingtagaren \xe4r brukare, i dessa fall inneb\xe4r det allts\xe5 att leasinggivaren ska s\xf6ka st\xf6det."
        },
        {
            q: "Ska ink\xf6pspriset anges inklusive eller exklusive moms?",
            a: "Om den s\xf6kande \xe4r momspliktig ska ink\xf6pspriset anges utan moms i ans\xf6kan om st\xf6d.</br></br>Om den s\xf6kande \xe4r momsbefriad ska ink\xf6pspriset anges inklusive moms.</br></br>Det g\xe4ller b\xe5de ink\xf6pspriset p\xe5 fordonet och priset f\xf6r n\xe4rmast j\xe4mf\xf6rbara fordon."
        },
        {
            q: "Vad g\xe4ller f\xf6r utbetalning av st\xf6det?",
            a: "Energimyndigheten ska betala ut det beviljade st\xf6dbeloppet tidigast sex m\xe5nader efter det att fordonet har st\xe4llts p\xe5 i Transportstyrelsens v\xe4gtrafikregister</br></br>Beloppet betalas ut om uppgifterna i v\xe4gtrafikregistret visar att</br></br><ol><li>1: den som k\xf6pt och st\xe4llt p\xe5 fordonet fortfarande \xe4r registrerad som \xe4gare och</li><li>2: att fordonet \xe4r registrerat i Sverige, samt att \xf6vriga f\xf6ruts\xe4ttningar f\xf6r utbetalning \xe4r uppfyllda.</li></ol>"
        }
    ]
};
const $4cb5a2c0203380bb$export$c3c96a8e8098bb1a = {
    text: "L\xe4s fler fr\xe5gor och svar hos Energimyndigheten.",
    textSize: '16px',
    url: 'https://www.energimyndigheten.se/klimat/transporter/transporteffektivt-samhalle/klimatpremie-for-latta-ellastbilar/',
    className: 'mt-6 mb-6 text-center ml-0 sm:ml-2',
    widthClass: 'w-[300px] sm:w-fit sm:px-7',
    openInNewTab: true
};

});


parcelRegister("khKSV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05685bf2998e778d$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $ZAgAN = parcelRequire("ZAgAN");

var $lAM5c = parcelRequire("lAM5c");

var $16gkH = parcelRequire("16gkH");

var $6B8Ld = parcelRequire("6B8Ld");

var $lIUfV = parcelRequire("lIUfV");
var $7hXNm = parcelRequire("7hXNm");

var $8FY87 = parcelRequire("8FY87");

var $1lSPe = parcelRequire("1lSPe");

var $655D0 = parcelRequire("655D0");

var $iI7zz = parcelRequire("iI7zz");

var $kAWPz = parcelRequire("kAWPz");

const $05685bf2998e778d$var$Snippet = /*#__PURE__*/ (0, $8FY87.lazy)(()=>Promise.resolve((parcelRequire("f0NwZ"))));
function $05685bf2998e778d$var$DataCardInternal({ modelCode: modelCode }) {
    const showSelect = !(0, $1lSPe.locationIsKia)() && !modelCode;
    const { models: models } = (0, $lAM5c.default)();
    const { model: fetchedModel } = (0, $ZAgAN.default)(modelCode);
    const selection = (0, $kAWPz.useDataCardStoreContext)((state)=>state.selectedModel);
    const setSelectedModel = (0, $kAWPz.useDataCardStoreContext)((state)=>state.setSelectedModel);
    const selectedModel = modelCode ? fetchedModel : selection ?? models[0];
    const { specs: specs, isLoading: isLoading } = (0, $16gkH.default)(selectedModel?.code);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        children: [
            showSelect ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "max-w-lg mb-6 mx-auto my-4",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                className: "block text-xs font-bold uppercase tracking-wide text-dark-blue/70 mb-1",
                                children: "V\xe4lj modell"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("select", {
                                value: selectedModel?.code ?? '',
                                onChange: (e)=>{
                                    const model = models.find((m)=>m.code === e.target.value);
                                    if (model) setSelectedModel(model);
                                },
                                className: "w-full h-11 px-3 rounded-md border border-dark-blue/10 bg-white text-sm font-medium text-dark-blue focus:outline-none focus:ring-2 focus:ring-dark-blue/20",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                        value: "",
                                        disabled: true,
                                        children: "V\xe4lj modell"
                                    }),
                                    models.map((model)=>/*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                            value: model.code,
                                            children: model.name
                                        }, model.id))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)($05685bf2998e778d$var$Snippet, {
                        page: "data-card",
                        props: `modelCode="${selectedModel?.code ?? ''}"`
                    })
                ]
            }) : null,
            selectedModel ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $iI7zz.default), {
                model: selectedModel,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)($05685bf2998e778d$var$UnifiedComparer, {
                    specs: specs,
                    model: selectedModel,
                    isLoading: isLoading
                })
            }) : null
        ]
    });
}
function $05685bf2998e778d$var$DataCard({ modelCode: modelCode }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kAWPz.DataCardStoreProvider), {
        children: /*#__PURE__*/ (0, $2PPWI.jsx)($05685bf2998e778d$var$DataCardInternal, {
            modelCode: modelCode
        })
    });
}
var $05685bf2998e778d$export$2e2bcd8739ae039 = $05685bf2998e778d$var$DataCard;
const $05685bf2998e778d$var$UnifiedComparer = ({ specs: specs, model: model, isLoading: isLoading })=>{
    const [openSections, setOpenSections] = (0, $8FY87.useState)({});
    const isSectionOpen = (key, defaultOpen)=>openSections[key] ?? defaultOpen;
    const toggleSection = (key, defaultOpen)=>{
        setOpenSections((prev)=>({
                ...prev,
                [key]: !isSectionOpen(key, defaultOpen)
            }));
    };
    const [prevBtnEnabled, setPrevBtnEnabled] = (0, $8FY87.useState)(false);
    const [nextBtnEnabled, setNextBtnEnabled] = (0, $8FY87.useState)(false);
    const [isOverflowing, setIsOverflowing] = (0, $8FY87.useState)(false);
    const [emblaRef, emblaApi] = (0, $6B8Ld.default)({
        align: 'center',
        dragFree: false,
        containScroll: 'trimSnaps',
        slidesToScroll: 'auto'
    });
    const scrollPrev = (0, $8FY87.useCallback)(()=>emblaApi && emblaApi.scrollPrev(), [
        emblaApi
    ]);
    const scrollNext = (0, $8FY87.useCallback)(()=>emblaApi && emblaApi.scrollNext(), [
        emblaApi
    ]);
    const onSelect = (0, $8FY87.useCallback)((api)=>{
        const canScrollPrev = api.canScrollPrev();
        const canScrollNext = api.canScrollNext();
        setPrevBtnEnabled(canScrollPrev);
        setNextBtnEnabled(canScrollNext);
        setIsOverflowing(canScrollPrev || canScrollNext);
    }, []);
    (0, $8FY87.useEffect)(()=>{
        if (!emblaApi) return;
        onSelect(emblaApi);
        emblaApi.on('reInit', onSelect);
        emblaApi.on('select', onSelect);
    }, [
        emblaApi,
        onSelect
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (!emblaApi) return;
        emblaApi.reInit({
            watchDrag: isOverflowing
        });
    }, [
        emblaApi,
        isOverflowing
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $2PPWI.jsx)($05685bf2998e778d$var$SpecsSkeleton, {});
    if (!specs.length) return null;
    const showGridAtLg = specs.length <= 3;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        "data-layout": showGridAtLg ? 'grid' : 'carousel',
        "data-scrollable": isOverflowing,
        "data-prev": prevBtnEnabled,
        "data-next": nextBtnEnabled,
        className: "group grid w-full mt-10 relative max-w-screen-2xl mx-auto data-[layout=carousel]:select-none",
        children: [
            prevBtnEnabled && /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                onClick: scrollPrev,
                className: "absolute left-0 lg:left-2 top-1/2 z-10 bg-white border border-dark-blue/10 grid place-content-center size-11 rounded-full hover:bg-slate-50 transition-all ",
                "aria-label": "F\xf6reg\xe5ende",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: "size-4 text-dark-blue",
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)($05685bf2998e778d$var$ChevronLeftIcon, {})
                })
            }),
            nextBtnEnabled && /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                onClick: scrollNext,
                className: "absolute right-0 lg:right-2 top-1/2 z-10 bg-white border border-dark-blue/10 grid place-content-center size-11 rounded-full hover:bg-slate-50 transition-all",
                "aria-label": "N\xe4sta",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: "size-4 text-dark-blue",
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)($05685bf2998e778d$var$ChevronRightIcon, {})
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "overflow-hidden transition-all group-data-[scrollable=true]:cursor-grab group-data-[scrollable=true]:active:cursor-grabbing group-data-[prev=true]:lg:[mask-image:linear-gradient(to_right,transparent,black_5%)] group-data-[next=true]:lg:[mask-image:linear-gradient(to_left,transparent,black_5%)]",
                ref: emblaRef,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: "flex touch-pan-y pb-12 group-data-[layout=grid]:lg:grid group-data-[layout=grid]:lg:grid-cols-3 group-data-[layout=grid]:lg:gap-4",
                    children: specs.map((trim)=>{
                        return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: "min-w-0 bg-white rounded-lg border border-dark-blue/10 flex flex-col flex-[0_0_85vw] md:flex-[0_0_calc(50%-1rem)] ml-4 group-data-[layout=grid]:lg:flex-none group-data-[layout=grid]:lg:ml-0 group-data-[layout=carousel]:lg:flex-[0_0_calc(30%-1rem)]",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                    className: "p-4 border-b border-dark-blue/10 min-h-[93px]",
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "flex justify-between items-start mb-1",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                            className: "text-lg font-extrabold uppercase text-dark-blue tracking-wide flex",
                                            children: trim.name
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: "px-4 py-4 pt-0 flex flex-col flex-grow",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)($05685bf2998e778d$var$AccordionSection, {
                                            title: "H\xf6jdpunkter",
                                            className: "border-b-0 border-t-0",
                                            isOpen: isSectionOpen('features', true),
                                            onToggle: ()=>toggleSection('features', true),
                                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                                                className: "flex flex-col gap-2",
                                                children: trim.highlights.map((feature, i)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                                                        className: "flex items-start gap-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                                                className: "shrink-0 mt-0.5 text-slate-900",
                                                                children: /*#__PURE__*/ (0, $2PPWI.jsx)($05685bf2998e778d$var$CheckIcon, {})
                                                            }),
                                                            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                                className: "text-sm font-medium text-slate-700 leading-snug",
                                                                children: feature
                                                            })
                                                        ]
                                                    }, i))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                            className: "mt-auto flex flex-col",
                                            children: trim.specifications.map((group, groupIndex)=>/*#__PURE__*/ (0, $2PPWI.jsx)($05685bf2998e778d$var$AccordionSection, {
                                                    title: group.label,
                                                    className: groupIndex === 0 ? 'border-t' : undefined,
                                                    isOpen: isSectionOpen(group.category, groupIndex === 0),
                                                    onToggle: ()=>toggleSection(group.category, groupIndex === 0),
                                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                                        className: "grid grid-cols-2 gap-2",
                                                        children: group.items.map((item)=>/*#__PURE__*/ (0, $2PPWI.jsx)($05685bf2998e778d$var$MiniStat, {
                                                                label: item.title,
                                                                value: item.unit ? `${item.value} ${item.unit}` : item.value
                                                            }, item.key))
                                                    })
                                                }, group.category))
                                        })
                                    ]
                                })
                            ]
                        }, trim.id);
                    })
                })
            }),
            model.fact_sheet && model.fact_sheet.length > 0 ? /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                href: model.fact_sheet,
                target: "_blank",
                rel: "noreferrer noopener",
                onClick: ()=>(0, $655D0.trackEvent)({
                        event: 'request_brochure',
                        form_step: 'download',
                        vehicle_nameplate: model.name,
                        vehicle_type: model.type?.name,
                        vehicle_year: undefined,
                        vehicle_trim: undefined,
                        document_type_list: 'fact sheet'
                    }),
                className: "flex items-center min-w-72 px-4 w-fit mx-auto justify-center gap-2 h-12 border bg-black text-white no-underline hover:underline",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                    children: "Ladda ner fullst\xe4ndigt faktablad"
                })
            }) : null
        ]
    });
};
function $05685bf2998e778d$var$SpecsSkeleton() {
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: "grid w-full mt-10 grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 max-w-screen-2xl mx-auto",
        children: Array.from({
            length: 3
        }).map((_, i)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "min-w-0 bg-white rounded-lg border border-dark-blue/10 flex flex-col animate-pulse",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "p-4 border-b border-dark-blue/10",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "h-6 w-2/3 bg-slate-200 rounded"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "mt-2 h-[34px] w-full"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "px-4 py-4 pt-0 flex flex-col flex-grow gap-4",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "flex flex-col gap-3 py-3",
                                children: Array.from({
                                    length: 10
                                }).map((_, j)=>/*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "h-4 w-11/12 bg-slate-100 rounded"
                                    }, j))
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "grid grid-cols-2 gap-2",
                                children: Array.from({
                                    length: 4
                                }).map((_, j)=>/*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "h-14 rounded-md bg-kia-grey border border-dark-blue/10"
                                    }, j))
                            })
                        ]
                    })
                ]
            }, i))
    });
}
function $05685bf2998e778d$var$MiniStat({ label: label, value: value }) {
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "flex flex-col p-3 rounded-md bg-kia-grey border border-dark-blue/10",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "flex items-center justify-between gap-2 mb-1",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                    className: "text-xs font-bold uppercase tracking-wide text-dark-blue/70 truncate",
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                className: "text-sm font-bold text-slate-900 tracking-tight",
                children: value
            })
        ]
    });
}
const $05685bf2998e778d$var$AccordionSection = ({ title: title, children: children, isOpen: isOpen, onToggle: onToggle, className: className })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: `border-b border-dark-blue/10 ${className ?? ''}`,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                onClick: onToggle,
                className: "flex items-center justify-between w-full py-3 text-left group",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        className: "text-xs font-bold uppercase tracking-widest text-dark-blue/70 group-hover:text-dark-blue transition-colors",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: `text-dark-blue/50 transition-transform duration-300 ${isOpen ? '-rotate-180' : ''}`,
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)($05685bf2998e778d$var$ChevronDownIcon, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $lIUfV.AnimatePresence), {
                initial: false,
                children: isOpen && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $7hXNm.motion).div, {
                    initial: {
                        height: 0,
                        opacity: 0
                    },
                    animate: {
                        height: 'auto',
                        opacity: 1
                    },
                    exit: {
                        height: 0,
                        opacity: 0
                    },
                    transition: {
                        duration: 0.3,
                        ease: [
                            0.04,
                            0.62,
                            0.23,
                            0.98
                        ]
                    },
                    className: "overflow-hidden",
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "pb-4 pt-1",
                        children: children
                    })
                })
            })
        ]
    });
};
const $05685bf2998e778d$var$ChevronDownIcon = ()=>/*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: "2.5",
        stroke: "currentColor",
        className: "size-4",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
        })
    });
const $05685bf2998e778d$var$ChevronLeftIcon = ()=>/*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: "2.5",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15.75 19.5L8.25 12l7.5-7.5"
        })
    });
const $05685bf2998e778d$var$ChevronRightIcon = ()=>/*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: "2.5",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M8.25 4.5l7.5 7.5-7.5 7.5"
        })
    });
const $05685bf2998e778d$var$CheckIcon = ()=>/*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "size-4",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
            d: "M20 6L9 17l-5-5"
        })
    });

});
parcelRegister("ZAgAN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f76ffbf5ca67b7a2$export$2e2bcd8739ae039; });

var $hgSaH = parcelRequire("hgSaH");

var $jZedf = parcelRequire("jZedf");

var $1lSPe = parcelRequire("1lSPe");
function $f76ffbf5ca67b7a2$var$useModel(code) {
    const { data: data, ...rest } = (0, $hgSaH.useQuery)({
        queryKey: [
            'model',
            code
        ],
        queryFn: async ()=>{
            return await (0, $jZedf.fetchWithType)((0, $1lSPe.getAdminUrl)() + '/api/model/' + code, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${(0, $1lSPe.getApiToken)()}`
                }
            });
        },
        enabled: !!code
    });
    return {
        model: data?.data,
        ...rest
    };
}
var $f76ffbf5ca67b7a2$export$2e2bcd8739ae039 = $f76ffbf5ca67b7a2$var$useModel;

});
parcelRegister("hgSaH", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $c92df3a380a73546$export$dd0a697e1782aedd; });

var $eEuVW = parcelRequire("eEuVW");

var $gp9ht = parcelRequire("gp9ht");
"use client";
//#region src/useQuery.ts
function $c92df3a380a73546$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $eEuVW.useBaseQuery)(options, (0, $gp9ht.QueryObserver), queryClient);
}

});
parcelRegister("eEuVW", function(module, exports) {

$parcel$export(module.exports, "useBaseQuery", function () { return $aaaccbe4133c3c13$export$fff0865807e996c5; });

var $1a3a2 = parcelRequire("1a3a2");

var $bxIcF = parcelRequire("bxIcF");

var $kkCTV = parcelRequire("kkCTV");

var $kVLmo = parcelRequire("kVLmo");

var $aJyjE = parcelRequire("aJyjE");

var $8FY87 = parcelRequire("8FY87");

var $6L2cD = parcelRequire("6L2cD");
var $hPIOx = parcelRequire("hPIOx");
"use client";
//#region src/useBaseQuery.ts
function $aaaccbe4133c3c13$export$fff0865807e996c5(options, Observer, queryClient) {
    const isRestoring = (0, $bxIcF.useIsRestoring)();
    const errorResetBoundary = (0, $kkCTV.useQueryErrorResetBoundary)();
    const client = (0, $1a3a2.useQueryClient)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    const query = client.getQueryCache().get(defaultedOptions.queryHash);
    const subscribed = options.subscribed !== false;
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : subscribed ? "optimistic" : void 0;
    (0, $aJyjE.ensureSuspenseTimers)(defaultedOptions);
    (0, $kVLmo.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary, query);
    (0, $kVLmo.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $8FY87.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && subscribed;
    $8FY87.useSyncExternalStore($8FY87.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $hPIOx.notifyManager).batchCalls(onStoreChange)) : (0, $6L2cD.noop);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $8FY87.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $aJyjE.shouldSuspend)(defaultedOptions, result)) throw (0, $aJyjE.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $kVLmo.getHasError)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: query,
        suspense: defaultedOptions.suspense
    })) throw result.error;
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

});
parcelRegister("bxIcF", function(module, exports) {

$parcel$export(module.exports, "useIsRestoring", function () { return $867510a84b74bb6b$export$4da0178d6b5f553; });

var $8FY87 = parcelRequire("8FY87");
"use client";
//#region src/IsRestoringProvider.ts
const $867510a84b74bb6b$var$IsRestoringContext = $8FY87.createContext(false);
const $867510a84b74bb6b$export$4da0178d6b5f553 = ()=>$8FY87.useContext($867510a84b74bb6b$var$IsRestoringContext);
const $867510a84b74bb6b$export$593807d4e94f9621 = $867510a84b74bb6b$var$IsRestoringContext.Provider;

});

parcelRegister("kkCTV", function(module, exports) {

$parcel$export(module.exports, "useQueryErrorResetBoundary", function () { return $ecd3d9d20c92eae8$export$50dfac555130cafd; });

var $8FY87 = parcelRequire("8FY87");

var $2PPWI = parcelRequire("2PPWI");
"use client";
//#region src/QueryErrorResetBoundary.tsx
function $ecd3d9d20c92eae8$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $ecd3d9d20c92eae8$var$QueryErrorResetBoundaryContext = $8FY87.createContext($ecd3d9d20c92eae8$var$createValue());
const $ecd3d9d20c92eae8$export$50dfac555130cafd = ()=>$8FY87.useContext($ecd3d9d20c92eae8$var$QueryErrorResetBoundaryContext);
const $ecd3d9d20c92eae8$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $8FY87.useState(()=>$ecd3d9d20c92eae8$var$createValue());
    return /* @__PURE__ */ (0, $2PPWI.jsx)($ecd3d9d20c92eae8$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};

});

parcelRegister("kVLmo", function(module, exports) {

$parcel$export(module.exports, "ensurePreventErrorBoundaryRetry", function () { return $f3cdde3dc199f4f2$export$ae8adb3de3d77633; });
$parcel$export(module.exports, "useClearResetErrorBoundary", function () { return $f3cdde3dc199f4f2$export$b2b17ca3a1fb0229; });
$parcel$export(module.exports, "getHasError", function () { return $f3cdde3dc199f4f2$export$1fbcf724762d607; });

var $8FY87 = parcelRequire("8FY87");

var $6L2cD = parcelRequire("6L2cD");
"use client";
//#region src/errorBoundaryUtils.ts
const $f3cdde3dc199f4f2$export$ae8adb3de3d77633 = (options, errorResetBoundary, query)=>{
    const throwOnError = (query === null || query === void 0 ? void 0 : query.state.error) && typeof options.throwOnError === "function" ? (0, $6L2cD.shouldThrowError)(options.throwOnError, [
        query.state.error,
        query
    ]) : options.throwOnError;
    if (options.suspense || throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $f3cdde3dc199f4f2$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $8FY87.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $f3cdde3dc199f4f2$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $6L2cD.shouldThrowError)(throwOnError, [
        result.error,
        query
    ]));
};

});

parcelRegister("aJyjE", function(module, exports) {

$parcel$export(module.exports, "ensureSuspenseTimers", function () { return $7d08b9c4be05addf$export$274d2a1db5a20c09; });
$parcel$export(module.exports, "shouldSuspend", function () { return $7d08b9c4be05addf$export$88d3586dfed64df9; });
$parcel$export(module.exports, "fetchOptimistic", function () { return $7d08b9c4be05addf$export$defdc11a9c9acfcf; });
//#region src/suspense.ts
const $7d08b9c4be05addf$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
const $7d08b9c4be05addf$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
const $7d08b9c4be05addf$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions === null || defaultedOptions === void 0 ? void 0 : defaultedOptions.suspense) && result.isPending;
const $7d08b9c4be05addf$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });

});


parcelRegister("gp9ht", function(module, exports) {

$parcel$export(module.exports, "QueryObserver", function () { return $bf162e208d2ac74e$export$a06cf8c0066f0d4c; });

var $3szIe = parcelRequire("3szIe");

var $6t06k = parcelRequire("6t06k");

var $6L2cD = parcelRequire("6L2cD");

var $dMqmZ = parcelRequire("dMqmZ");

var $3G2zK = parcelRequire("3G2zK");

var $fYclE = parcelRequire("fYclE");

var $hPIOx = parcelRequire("hPIOx");

var $78xtY = parcelRequire("78xtY");

var $iiqu4 = parcelRequire("iiqu4");
//#region src/queryObserver.ts
var $bf162e208d2ac74e$var$_client = /* @__PURE__ */ new WeakMap();
var $bf162e208d2ac74e$var$_currentQuery = /* @__PURE__ */ new WeakMap();
var $bf162e208d2ac74e$var$_currentQueryInitialState = /* @__PURE__ */ new WeakMap();
var $bf162e208d2ac74e$var$_currentResult = /* @__PURE__ */ new WeakMap();
var $bf162e208d2ac74e$var$_currentResultState = /* @__PURE__ */ new WeakMap();
var $bf162e208d2ac74e$var$_currentResultOptions = /* @__PURE__ */ new WeakMap();
var $bf162e208d2ac74e$var$_selectError = /* @__PURE__ */ new WeakMap();
var $bf162e208d2ac74e$var$_selectFn = /* @__PURE__ */ new WeakMap();
var $bf162e208d2ac74e$var$_selectResult = /* @__PURE__ */ new WeakMap();
var $bf162e208d2ac74e$var$_lastQueryWithDefinedData = /* @__PURE__ */ new WeakMap();
var $bf162e208d2ac74e$var$_staleTimeoutId = /* @__PURE__ */ new WeakMap();
var $bf162e208d2ac74e$var$_refetchIntervalId = /* @__PURE__ */ new WeakMap();
var $bf162e208d2ac74e$var$_currentRefetchInterval = /* @__PURE__ */ new WeakMap();
var $bf162e208d2ac74e$var$_trackedProps = /* @__PURE__ */ new WeakMap();
var $bf162e208d2ac74e$var$_QueryObserver_brand = /* @__PURE__ */ new WeakSet();
var $bf162e208d2ac74e$export$a06cf8c0066f0d4c = class extends (0, $3G2zK.Subscribable) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $78xtY.t)(this, $bf162e208d2ac74e$var$_QueryObserver_brand);
        (0, $3szIe.i)(this, $bf162e208d2ac74e$var$_client, void 0);
        (0, $3szIe.i)(this, $bf162e208d2ac74e$var$_currentQuery, void 0);
        (0, $3szIe.i)(this, $bf162e208d2ac74e$var$_currentQueryInitialState, void 0);
        (0, $3szIe.i)(this, $bf162e208d2ac74e$var$_currentResult, void 0);
        (0, $3szIe.i)(this, $bf162e208d2ac74e$var$_currentResultState, void 0);
        (0, $3szIe.i)(this, $bf162e208d2ac74e$var$_currentResultOptions, void 0);
        (0, $3szIe.i)(this, $bf162e208d2ac74e$var$_selectError, void 0);
        (0, $3szIe.i)(this, $bf162e208d2ac74e$var$_selectFn, void 0);
        (0, $3szIe.i)(this, $bf162e208d2ac74e$var$_selectResult, void 0);
        (0, $3szIe.i)(this, $bf162e208d2ac74e$var$_lastQueryWithDefinedData, void 0);
        (0, $3szIe.i)(this, $bf162e208d2ac74e$var$_staleTimeoutId, void 0);
        (0, $3szIe.i)(this, $bf162e208d2ac74e$var$_refetchIntervalId, void 0);
        (0, $3szIe.i)(this, $bf162e208d2ac74e$var$_currentRefetchInterval, void 0);
        (0, $3szIe.i)(this, $bf162e208d2ac74e$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $3szIe.t)($bf162e208d2ac74e$var$_client, this, client);
        (0, $3szIe.t)($bf162e208d2ac74e$var$_selectError, this, null);
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this).addObserver(this);
            if ($bf162e208d2ac74e$var$shouldFetchOnMount((0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this), this.options)) (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_executeFetch).call(this);
            else this.updateResult();
            (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_updateTimers).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $bf162e208d2ac74e$var$shouldFetchOn((0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $bf162e208d2ac74e$var$shouldFetchOn((0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_clearStaleTimeout).call(this);
        (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_clearRefetchInterval).call(this);
        (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this).removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this);
        this.options = (0, $3szIe.n)($bf162e208d2ac74e$var$_client, this).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $6L2cD.resolveQueryValue)(this.options.enabled, (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_updateQuery).call(this);
        (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $6L2cD.shallowEqualObjects)(this.options, prevOptions)) (0, $3szIe.n)($bf162e208d2ac74e$var$_client, this).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $bf162e208d2ac74e$var$shouldFetchOptionally((0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this), prevQuery, this.options, prevOptions)) (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_executeFetch).call(this);
        this.updateResult();
        if (mounted && ((0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this) !== prevQuery || (0, $6L2cD.resolveQueryValue)(this.options.enabled, (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this)) !== (0, $6L2cD.resolveQueryValue)(prevOptions.enabled, (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this)) || (0, $6L2cD.resolveQueryValue)(this.options.staleTime, (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this)) !== (0, $6L2cD.resolveQueryValue)(prevOptions.staleTime, (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this)))) (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_updateStaleTimeout).call(this);
        const nextRefetchInterval = (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_computeRefetchInterval).call(this);
        if (mounted && ((0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this) !== prevQuery || (0, $6L2cD.resolveQueryValue)(this.options.enabled, (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this)) !== (0, $6L2cD.resolveQueryValue)(prevOptions.enabled, (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this)) || nextRefetchInterval !== (0, $3szIe.n)($bf162e208d2ac74e$var$_currentRefetchInterval, this))) (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_updateRefetchInterval).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $3szIe.n)($bf162e208d2ac74e$var$_client, this).getQueryCache().build((0, $3szIe.n)($bf162e208d2ac74e$var$_client, this), options);
        const result = this.createResult(query, options);
        if (!(0, $6L2cD.shallowEqualObjects)(this.getCurrentResult(), result)) {
            (0, $3szIe.t)($bf162e208d2ac74e$var$_currentResult, this, result);
            (0, $3szIe.t)($bf162e208d2ac74e$var$_currentResultOptions, this, this.options);
            (0, $3szIe.t)($bf162e208d2ac74e$var$_currentResultState, this, (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $3szIe.n)($bf162e208d2ac74e$var$_currentResult, this);
    }
    trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked === null || onPropTracked === void 0 || onPropTracked(key);
                return Reflect.get(target, key);
            }
        });
    }
    trackProp(key) {
        (0, $3szIe.n)($bf162e208d2ac74e$var$_trackedProps, this).add(key);
    }
    getCurrentQuery() {
        return (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $3szIe.n)($bf162e208d2ac74e$var$_client, this).defaultQueryOptions(options);
        const query = (0, $3szIe.n)($bf162e208d2ac74e$var$_client, this).getQueryCache().build((0, $3szIe.n)($bf162e208d2ac74e$var$_client, this), defaultedOptions);
        let unsubscribe = ()=>{};
        let resolveEarly;
        const cachePromise = new Promise((resolve)=>{
            resolveEarly = resolve;
            unsubscribe = (0, $3szIe.n)($bf162e208d2ac74e$var$_client, this).getQueryCache().subscribe((event)=>{
                if (event.type === "updated" && event.query.queryHash === query.queryHash && query.state.data !== void 0) {
                    unsubscribe();
                    resolve(this.createResult(query, defaultedOptions));
                }
            });
        });
        return Promise.race([
            query.fetch().then(()=>{
                const result = this.createResult(query, defaultedOptions);
                resolveEarly === null || resolveEarly === void 0 || resolveEarly(result);
                return result;
            }).finally(()=>{
                unsubscribe();
            }),
            cachePromise
        ]);
    }
    fetch(fetchOptions) {
        return (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_executeFetch).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $3szIe.n)($bf162e208d2ac74e$var$_currentResult, this);
        });
    }
    createResult(query, options) {
        const prevQuery = (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this);
        const prevOptions = this.options;
        const prevResult = (0, $3szIe.n)($bf162e208d2ac74e$var$_currentResult, this);
        const prevResultState = (0, $3szIe.n)($bf162e208d2ac74e$var$_currentResultState, this);
        const prevResultOptions = (0, $3szIe.n)($bf162e208d2ac74e$var$_currentResultOptions, this);
        const queryInitialState = query !== prevQuery ? query.state : (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQueryInitialState, this);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $bf162e208d2ac74e$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $bf162e208d2ac74e$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $iiqu4.fetchState)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult === null || prevResult === void 0 ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions === null || prevResultOptions === void 0 ? void 0 : prevResultOptions.placeholderData)) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else {
                var _classPrivateFieldGet2$1;
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_classPrivateFieldGet2$1 = (0, $3szIe.n)($bf162e208d2ac74e$var$_lastQueryWithDefinedData, this)) === null || _classPrivateFieldGet2$1 === void 0 ? void 0 : _classPrivateFieldGet2$1.state.data, (0, $3szIe.n)($bf162e208d2ac74e$var$_lastQueryWithDefinedData, this)) : options.placeholderData;
            }
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $6L2cD.replaceData)(prevResult === null || prevResult === void 0 ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === (prevResultState === null || prevResultState === void 0 ? void 0 : prevResultState.data) && options.select === (0, $3szIe.n)($bf162e208d2ac74e$var$_selectFn, this)) data = (0, $3szIe.n)($bf162e208d2ac74e$var$_selectResult, this);
            else try {
                (0, $3szIe.t)($bf162e208d2ac74e$var$_selectFn, this, options.select);
                data = options.select(data);
                data = (0, $6L2cD.replaceData)(prevResult === null || prevResult === void 0 ? void 0 : prevResult.data, data, options);
                (0, $3szIe.t)($bf162e208d2ac74e$var$_selectResult, this, data);
                (0, $3szIe.t)($bf162e208d2ac74e$var$_selectError, this, null);
            } catch (selectError) {
                (0, $3szIe.t)($bf162e208d2ac74e$var$_selectError, this, selectError);
            }
        } else if (data === void 0) (0, $3szIe.t)($bf162e208d2ac74e$var$_selectError, this, null);
        if ((0, $3szIe.n)($bf162e208d2ac74e$var$_selectError, this)) {
            error = (0, $3szIe.n)($bf162e208d2ac74e$var$_selectError, this);
            data = (0, $3szIe.n)($bf162e208d2ac74e$var$_selectResult, this);
            errorUpdatedAt = Date.now();
            status = "error";
            isPlaceholderData = false;
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        return {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: query.isFetched(),
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $bf162e208d2ac74e$var$isStale(query, options),
            refetch: this.refetch,
            isEnabled: (0, $6L2cD.resolveQueryValue)(options.enabled, query) !== false
        };
    }
    updateResult() {
        const prevResult = (0, $3szIe.n)($bf162e208d2ac74e$var$_currentResult, this);
        const nextResult = this.createResult((0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this), this.options);
        (0, $3szIe.t)($bf162e208d2ac74e$var$_currentResultState, this, (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this).state);
        (0, $3szIe.t)($bf162e208d2ac74e$var$_currentResultOptions, this, this.options);
        if ((0, $3szIe.n)($bf162e208d2ac74e$var$_currentResultState, this).data !== void 0) (0, $3szIe.t)($bf162e208d2ac74e$var$_lastQueryWithDefinedData, this, (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this));
        if ((0, $6L2cD.shallowEqualObjects)(nextResult, prevResult)) return;
        (0, $3szIe.t)($bf162e208d2ac74e$var$_currentResult, this, nextResult);
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $3szIe.n)($bf162e208d2ac74e$var$_trackedProps, this).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $3szIe.n)($bf162e208d2ac74e$var$_trackedProps, this));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $3szIe.n)($bf162e208d2ac74e$var$_currentResult, this)).some((key)=>{
                const typedKey = key;
                return (0, $3szIe.n)($bf162e208d2ac74e$var$_currentResult, this)[typedKey] !== prevResult[typedKey] && includedProps.has(typedKey);
            });
        };
        const notifyListeners = shouldNotifyListeners();
        (0, $hPIOx.notifyManager).batch(()=>{
            if (notifyListeners) this.listeners.forEach((listener)=>{
                listener((0, $3szIe.n)($bf162e208d2ac74e$var$_currentResult, this));
            });
            (0, $3szIe.n)($bf162e208d2ac74e$var$_client, this).getQueryCache().notify({
                query: (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this),
                type: "observerResultsUpdated"
            });
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_updateTimers).call(this);
    }
};
function $bf162e208d2ac74e$var$_executeFetch(fetchOptions) {
    (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_updateQuery).call(this);
    let promise = (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this).fetch(this.options, fetchOptions);
    if (!(fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $6L2cD.noop));
    return promise;
}
function $bf162e208d2ac74e$var$_shouldScheduleTimer(timeout) {
    return !(0, $dMqmZ.isServer)() && (0, $6L2cD.resolveQueryValue)(this.options.enabled, (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this)) !== false && (0, $6L2cD.isValidTimeout)(timeout);
}
function $bf162e208d2ac74e$var$_updateStaleTimeout() {
    (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_clearStaleTimeout).call(this);
    const staleTime = (0, $6L2cD.resolveQueryValue)(this.options.staleTime, (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this));
    if ((0, $3szIe.n)($bf162e208d2ac74e$var$_currentResult, this).isStale || !(0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_shouldScheduleTimer).call(this, staleTime)) return;
    const timeout = (0, $6L2cD.timeUntilStale)((0, $3szIe.n)($bf162e208d2ac74e$var$_currentResult, this).dataUpdatedAt, staleTime) + 1;
    (0, $3szIe.t)($bf162e208d2ac74e$var$_staleTimeoutId, this, (0, $6t06k.timeoutManager).setTimeout(()=>{
        if (!(0, $3szIe.n)($bf162e208d2ac74e$var$_currentResult, this).isStale) this.updateResult();
    }, timeout));
}
function $bf162e208d2ac74e$var$_computeRefetchInterval() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this)) : this.options.refetchInterval) ?? false;
}
function $bf162e208d2ac74e$var$_updateRefetchInterval(nextInterval) {
    (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_clearRefetchInterval).call(this);
    (0, $3szIe.t)($bf162e208d2ac74e$var$_currentRefetchInterval, this, nextInterval);
    if ((0, $3szIe.n)($bf162e208d2ac74e$var$_currentRefetchInterval, this) === 0 || !(0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_shouldScheduleTimer).call(this, (0, $3szIe.n)($bf162e208d2ac74e$var$_currentRefetchInterval, this))) return;
    (0, $3szIe.t)($bf162e208d2ac74e$var$_refetchIntervalId, this, (0, $6t06k.timeoutManager).setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $fYclE.focusManager).isFocused()) (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_executeFetch).call(this);
    }, (0, $3szIe.n)($bf162e208d2ac74e$var$_currentRefetchInterval, this)));
}
function $bf162e208d2ac74e$var$_updateTimers() {
    (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_updateStaleTimeout).call(this);
    (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_updateRefetchInterval).call(this, (0, $3szIe.r)($bf162e208d2ac74e$var$_QueryObserver_brand, this, $bf162e208d2ac74e$var$_computeRefetchInterval).call(this));
}
function $bf162e208d2ac74e$var$_clearStaleTimeout() {
    if ((0, $3szIe.n)($bf162e208d2ac74e$var$_staleTimeoutId, this) !== void 0) {
        (0, $6t06k.timeoutManager).clearTimeout((0, $3szIe.n)($bf162e208d2ac74e$var$_staleTimeoutId, this));
        (0, $3szIe.t)($bf162e208d2ac74e$var$_staleTimeoutId, this, void 0);
    }
}
function $bf162e208d2ac74e$var$_clearRefetchInterval() {
    if ((0, $3szIe.n)($bf162e208d2ac74e$var$_refetchIntervalId, this) !== void 0) {
        (0, $6t06k.timeoutManager).clearInterval((0, $3szIe.n)($bf162e208d2ac74e$var$_refetchIntervalId, this));
        (0, $3szIe.t)($bf162e208d2ac74e$var$_refetchIntervalId, this, void 0);
    }
}
function $bf162e208d2ac74e$var$_updateQuery() {
    const query = (0, $3szIe.n)($bf162e208d2ac74e$var$_client, this).getQueryCache().build((0, $3szIe.n)($bf162e208d2ac74e$var$_client, this), this.options);
    if (query === (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this)) return;
    const prevQuery = (0, $3szIe.n)($bf162e208d2ac74e$var$_currentQuery, this);
    (0, $3szIe.t)($bf162e208d2ac74e$var$_currentQuery, this, query);
    (0, $3szIe.t)($bf162e208d2ac74e$var$_currentQueryInitialState, this, query.state);
    if (this.hasListeners()) {
        prevQuery === null || prevQuery === void 0 || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
}
function $bf162e208d2ac74e$var$shouldLoadOnMount(query, options) {
    return (0, $6L2cD.resolveQueryValue)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && (0, $6L2cD.resolveQueryValue)(options.retryOnMount, query) === false);
}
function $bf162e208d2ac74e$var$shouldFetchOnMount(query, options) {
    return $bf162e208d2ac74e$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $bf162e208d2ac74e$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $bf162e208d2ac74e$var$shouldFetchOn(query, options, field) {
    if ((0, $6L2cD.resolveQueryValue)(options.enabled, query) !== false && (0, $6L2cD.resolveQueryValue)(options.staleTime, query) !== "static") {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $bf162e208d2ac74e$var$isStale(query, options);
    }
    return false;
}
function $bf162e208d2ac74e$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $6L2cD.resolveQueryValue)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $bf162e208d2ac74e$var$isStale(query, options);
}
function $bf162e208d2ac74e$var$isStale(query, options) {
    return (0, $6L2cD.resolveQueryValue)(options.enabled, query) !== false && query.isStaleByTime((0, $6L2cD.resolveQueryValue)(options.staleTime, query));
}

});



parcelRegister("lAM5c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $596e5342589d2a41$export$2e2bcd8739ae039; });

var $hgSaH = parcelRequire("hgSaH");

var $jZedf = parcelRequire("jZedf");

var $1lSPe = parcelRequire("1lSPe");
function $596e5342589d2a41$var$useModels() {
    const { data: data, ...rest } = (0, $hgSaH.useQuery)({
        queryKey: [
            'models'
        ],
        queryFn: async ()=>{
            return await (0, $jZedf.fetchWithType)((0, $1lSPe.getAdminUrl)() + '/api/models', {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${(0, $1lSPe.getApiToken)()}`
                }
            });
        }
    });
    return {
        models: data?.data ?? [],
        ...rest
    };
}
var $596e5342589d2a41$export$2e2bcd8739ae039 = $596e5342589d2a41$var$useModels;

});

parcelRegister("16gkH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56e3544f30ddcf01$export$2e2bcd8739ae039; });

var $hgSaH = parcelRequire("hgSaH");

var $jZedf = parcelRequire("jZedf");

var $1lSPe = parcelRequire("1lSPe");
function $56e3544f30ddcf01$var$useSpecs(code) {
    const { data: data, ...rest } = (0, $hgSaH.useQuery)({
        queryKey: [
            'specs',
            code
        ],
        queryFn: async ()=>{
            return await (0, $jZedf.fetchWithType)((0, $1lSPe.getAdminUrl)() + '/api/model/' + code + '/specifications', {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${(0, $1lSPe.getApiToken)()}`
                }
            });
        },
        enabled: !!code
    });
    return {
        specs: data?.data ?? [],
        ...rest
    };
}
var $56e3544f30ddcf01$export$2e2bcd8739ae039 = $56e3544f30ddcf01$var$useSpecs;

});

parcelRegister("6B8Ld", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cdcfe757ce37baf$export$2e2bcd8739ae039; });

var $8FY87 = parcelRequire("8FY87");

var $893HA = parcelRequire("893HA");

var $4ZHzC = parcelRequire("4ZHzC");
function $4cdcfe757ce37baf$export$2e2bcd8739ae039(options = {}, plugins = []) {
    const storedOptions = (0, $8FY87.useRef)(options);
    const storedPlugins = (0, $8FY87.useRef)(plugins);
    const [emblaApi, setEmblaApi] = (0, $8FY87.useState)();
    const [viewport, setViewport] = (0, $8FY87.useState)();
    const reInit = (0, $8FY87.useCallback)(()=>{
        if (emblaApi) emblaApi.reInit(storedOptions.current, storedPlugins.current);
    }, [
        emblaApi
    ]);
    (0, $8FY87.useEffect)(()=>{
        if ((0, $893HA.areOptionsEqual)(storedOptions.current, options)) return;
        storedOptions.current = options;
        reInit();
    }, [
        options,
        reInit
    ]);
    (0, $8FY87.useEffect)(()=>{
        if ((0, $893HA.arePluginsEqual)(storedPlugins.current, plugins)) return;
        storedPlugins.current = plugins;
        reInit();
    }, [
        plugins,
        reInit
    ]);
    (0, $8FY87.useEffect)(()=>{
        if ((0, $893HA.canUseDOM)() && viewport) {
            (0, $4ZHzC.default).globalOptions = $4cdcfe757ce37baf$export$2e2bcd8739ae039.globalOptions;
            const newEmblaApi = (0, $4ZHzC.default)(viewport, storedOptions.current, storedPlugins.current);
            setEmblaApi(newEmblaApi);
            return ()=>newEmblaApi.destroy();
        } else setEmblaApi(undefined);
    }, [
        viewport,
        setEmblaApi
    ]);
    return [
        setViewport,
        emblaApi
    ];
}
$4cdcfe757ce37baf$export$2e2bcd8739ae039.globalOptions = undefined;

});
parcelRegister("893HA", function(module, exports) {

$parcel$export(module.exports, "canUseDOM", function () { return $5ee209245bed9f01$export$71594e8a50f746f4; });
$parcel$export(module.exports, "areOptionsEqual", function () { return $5ee209245bed9f01$export$1ace03bbcd701468; });
$parcel$export(module.exports, "arePluginsEqual", function () { return $5ee209245bed9f01$export$8a8daedc629f7568; });
function $5ee209245bed9f01$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === '[object Object]';
}
function $5ee209245bed9f01$var$isRecord(subject) {
    return $5ee209245bed9f01$var$isObject(subject) || Array.isArray(subject);
}
function $5ee209245bed9f01$export$71594e8a50f746f4() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
function $5ee209245bed9f01$export$1ace03bbcd701468(optionsA, optionsB) {
    const optionsAKeys = Object.keys(optionsA);
    const optionsBKeys = Object.keys(optionsB);
    if (optionsAKeys.length !== optionsBKeys.length) return false;
    const breakpointsA = JSON.stringify(Object.keys(optionsA.breakpoints || {}));
    const breakpointsB = JSON.stringify(Object.keys(optionsB.breakpoints || {}));
    if (breakpointsA !== breakpointsB) return false;
    return optionsAKeys.every((key)=>{
        const valueA = optionsA[key];
        const valueB = optionsB[key];
        if (typeof valueA === 'function') return `${valueA}` === `${valueB}`;
        if (!$5ee209245bed9f01$var$isRecord(valueA) || !$5ee209245bed9f01$var$isRecord(valueB)) return valueA === valueB;
        return $5ee209245bed9f01$export$1ace03bbcd701468(valueA, valueB);
    });
}
function $5ee209245bed9f01$export$919604828c9466f3(plugins) {
    return plugins.concat().sort((a, b)=>a.name > b.name ? 1 : -1).map((plugin)=>plugin.options);
}
function $5ee209245bed9f01$export$8a8daedc629f7568(pluginsA, pluginsB) {
    if (pluginsA.length !== pluginsB.length) return false;
    const optionsA = $5ee209245bed9f01$export$919604828c9466f3(pluginsA);
    const optionsB = $5ee209245bed9f01$export$919604828c9466f3(pluginsB);
    return optionsA.every((optionA, index)=>{
        const optionB = optionsB[index];
        return $5ee209245bed9f01$export$1ace03bbcd701468(optionA, optionB);
    });
}

});

parcelRegister("4ZHzC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a2ea8b3deea05cd$export$2e2bcd8739ae039; });
function $3a2ea8b3deea05cd$var$isNumber(subject) {
    return typeof subject === 'number';
}
function $3a2ea8b3deea05cd$var$isString(subject) {
    return typeof subject === 'string';
}
function $3a2ea8b3deea05cd$var$isBoolean(subject) {
    return typeof subject === 'boolean';
}
function $3a2ea8b3deea05cd$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === '[object Object]';
}
function $3a2ea8b3deea05cd$var$mathAbs(n) {
    return Math.abs(n);
}
function $3a2ea8b3deea05cd$var$mathSign(n) {
    return Math.sign(n);
}
function $3a2ea8b3deea05cd$var$deltaAbs(valueB, valueA) {
    return $3a2ea8b3deea05cd$var$mathAbs(valueB - valueA);
}
function $3a2ea8b3deea05cd$var$factorAbs(valueB, valueA) {
    if (valueB === 0 || valueA === 0) return 0;
    if ($3a2ea8b3deea05cd$var$mathAbs(valueB) <= $3a2ea8b3deea05cd$var$mathAbs(valueA)) return 0;
    const diff = $3a2ea8b3deea05cd$var$deltaAbs($3a2ea8b3deea05cd$var$mathAbs(valueB), $3a2ea8b3deea05cd$var$mathAbs(valueA));
    return $3a2ea8b3deea05cd$var$mathAbs(diff / valueB);
}
function $3a2ea8b3deea05cd$var$roundToTwoDecimals(num) {
    return Math.round(num * 100) / 100;
}
function $3a2ea8b3deea05cd$var$arrayKeys(array) {
    return $3a2ea8b3deea05cd$var$objectKeys(array).map(Number);
}
function $3a2ea8b3deea05cd$var$arrayLast(array) {
    return array[$3a2ea8b3deea05cd$var$arrayLastIndex(array)];
}
function $3a2ea8b3deea05cd$var$arrayLastIndex(array) {
    return Math.max(0, array.length - 1);
}
function $3a2ea8b3deea05cd$var$arrayIsLastIndex(array, index) {
    return index === $3a2ea8b3deea05cd$var$arrayLastIndex(array);
}
function $3a2ea8b3deea05cd$var$arrayFromNumber(n, startAt = 0) {
    return Array.from(Array(n), (_, i)=>startAt + i);
}
function $3a2ea8b3deea05cd$var$objectKeys(object) {
    return Object.keys(object);
}
function $3a2ea8b3deea05cd$var$objectsMergeDeep(objectA, objectB) {
    return [
        objectA,
        objectB
    ].reduce((mergedObjects, currentObject)=>{
        $3a2ea8b3deea05cd$var$objectKeys(currentObject).forEach((key)=>{
            const valueA = mergedObjects[key];
            const valueB = currentObject[key];
            const areObjects = $3a2ea8b3deea05cd$var$isObject(valueA) && $3a2ea8b3deea05cd$var$isObject(valueB);
            mergedObjects[key] = areObjects ? $3a2ea8b3deea05cd$var$objectsMergeDeep(valueA, valueB) : valueB;
        });
        return mergedObjects;
    }, {});
}
function $3a2ea8b3deea05cd$var$isMouseEvent(evt, ownerWindow) {
    return typeof ownerWindow.MouseEvent !== 'undefined' && evt instanceof ownerWindow.MouseEvent;
}
function $3a2ea8b3deea05cd$var$Alignment(align, viewSize) {
    const predefined = {
        start: start,
        center: center,
        end: end
    };
    function start() {
        return 0;
    }
    function center(n) {
        return end(n) / 2;
    }
    function end(n) {
        return viewSize - n;
    }
    function measure(n, index) {
        if ($3a2ea8b3deea05cd$var$isString(align)) return predefined[align](n);
        return align(viewSize, n, index);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $3a2ea8b3deea05cd$var$EventStore() {
    let listeners = [];
    function add(node, type, handler, options = {
        passive: true
    }) {
        let removeListener;
        if ('addEventListener' in node) {
            node.addEventListener(type, handler, options);
            removeListener = ()=>node.removeEventListener(type, handler, options);
        } else {
            const legacyMediaQueryList = node;
            legacyMediaQueryList.addListener(handler);
            removeListener = ()=>legacyMediaQueryList.removeListener(handler);
        }
        listeners.push(removeListener);
        return self;
    }
    function clear() {
        listeners = listeners.filter((remove)=>remove());
    }
    const self = {
        add: add,
        clear: clear
    };
    return self;
}
function $3a2ea8b3deea05cd$var$Animations(ownerDocument, ownerWindow, update, render) {
    const documentVisibleHandler = $3a2ea8b3deea05cd$var$EventStore();
    const fixedTimeStep = 1000 / 60;
    let lastTimeStamp = null;
    let accumulatedTime = 0;
    let animationId = 0;
    function init() {
        documentVisibleHandler.add(ownerDocument, 'visibilitychange', ()=>{
            if (ownerDocument.hidden) reset();
        });
    }
    function destroy() {
        stop();
        documentVisibleHandler.clear();
    }
    function animate(timeStamp) {
        if (!animationId) return;
        if (!lastTimeStamp) {
            lastTimeStamp = timeStamp;
            update();
            update();
        }
        const timeElapsed = timeStamp - lastTimeStamp;
        lastTimeStamp = timeStamp;
        accumulatedTime += timeElapsed;
        while(accumulatedTime >= fixedTimeStep){
            update();
            accumulatedTime -= fixedTimeStep;
        }
        const alpha = accumulatedTime / fixedTimeStep;
        render(alpha);
        if (animationId) animationId = ownerWindow.requestAnimationFrame(animate);
    }
    function start() {
        if (animationId) return;
        animationId = ownerWindow.requestAnimationFrame(animate);
    }
    function stop() {
        ownerWindow.cancelAnimationFrame(animationId);
        lastTimeStamp = null;
        accumulatedTime = 0;
        animationId = 0;
    }
    function reset() {
        lastTimeStamp = null;
        accumulatedTime = 0;
    }
    const self = {
        init: init,
        destroy: destroy,
        start: start,
        stop: stop,
        update: update,
        render: render
    };
    return self;
}
function $3a2ea8b3deea05cd$var$Axis(axis, contentDirection) {
    const isRightToLeft = contentDirection === 'rtl';
    const isVertical = axis === 'y';
    const scroll = isVertical ? 'y' : 'x';
    const cross = isVertical ? 'x' : 'y';
    const sign = !isVertical && isRightToLeft ? -1 : 1;
    const startEdge = getStartEdge();
    const endEdge = getEndEdge();
    function measureSize(nodeRect) {
        const { height: height, width: width } = nodeRect;
        return isVertical ? height : width;
    }
    function getStartEdge() {
        if (isVertical) return 'top';
        return isRightToLeft ? 'right' : 'left';
    }
    function getEndEdge() {
        if (isVertical) return 'bottom';
        return isRightToLeft ? 'left' : 'right';
    }
    function direction(n) {
        return n * sign;
    }
    const self = {
        scroll: scroll,
        cross: cross,
        startEdge: startEdge,
        endEdge: endEdge,
        measureSize: measureSize,
        direction: direction
    };
    return self;
}
function $3a2ea8b3deea05cd$var$Limit(min = 0, max = 0) {
    const length = $3a2ea8b3deea05cd$var$mathAbs(min - max);
    function reachedMin(n) {
        return n < min;
    }
    function reachedMax(n) {
        return n > max;
    }
    function reachedAny(n) {
        return reachedMin(n) || reachedMax(n);
    }
    function constrain(n) {
        if (!reachedAny(n)) return n;
        return reachedMin(n) ? min : max;
    }
    function removeOffset(n) {
        if (!length) return n;
        return n - length * Math.ceil((n - max) / length);
    }
    const self = {
        length: length,
        max: max,
        min: min,
        constrain: constrain,
        reachedAny: reachedAny,
        reachedMax: reachedMax,
        reachedMin: reachedMin,
        removeOffset: removeOffset
    };
    return self;
}
function $3a2ea8b3deea05cd$var$Counter(max, start, loop) {
    const { constrain: constrain } = $3a2ea8b3deea05cd$var$Limit(0, max);
    const loopEnd = max + 1;
    let counter = withinLimit(start);
    function withinLimit(n) {
        return !loop ? constrain(n) : $3a2ea8b3deea05cd$var$mathAbs((loopEnd + n) % loopEnd);
    }
    function get() {
        return counter;
    }
    function set(n) {
        counter = withinLimit(n);
        return self;
    }
    function add(n) {
        return clone().set(get() + n);
    }
    function clone() {
        return $3a2ea8b3deea05cd$var$Counter(max, get(), loop);
    }
    const self = {
        get: get,
        set: set,
        add: add,
        clone: clone
    };
    return self;
}
function $3a2ea8b3deea05cd$var$DragHandler(axis, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
    const { cross: crossAxis, direction: direction } = axis;
    const focusNodes = [
        'INPUT',
        'SELECT',
        'TEXTAREA'
    ];
    const nonPassiveEvent = {
        passive: false
    };
    const initEvents = $3a2ea8b3deea05cd$var$EventStore();
    const dragEvents = $3a2ea8b3deea05cd$var$EventStore();
    const goToNextThreshold = $3a2ea8b3deea05cd$var$Limit(50, 225).constrain(percentOfView.measure(20));
    const snapForceBoost = {
        mouse: 300,
        touch: 400
    };
    const freeForceBoost = {
        mouse: 500,
        touch: 600
    };
    const baseSpeed = dragFree ? 43 : 25;
    let isMoving = false;
    let startScroll = 0;
    let startCross = 0;
    let pointerIsDown = false;
    let preventScroll = false;
    let preventClick = false;
    let isMouse = false;
    function init(emblaApi) {
        if (!watchDrag) return;
        function downIfAllowed(evt) {
            if ($3a2ea8b3deea05cd$var$isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
        }
        const node = rootNode;
        initEvents.add(node, 'dragstart', (evt)=>evt.preventDefault(), nonPassiveEvent).add(node, 'touchmove', ()=>undefined, nonPassiveEvent).add(node, 'touchend', ()=>undefined).add(node, 'touchstart', downIfAllowed).add(node, 'mousedown', downIfAllowed).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click, true);
    }
    function destroy() {
        initEvents.clear();
        dragEvents.clear();
    }
    function addDragEvents() {
        const node = isMouse ? ownerDocument : rootNode;
        dragEvents.add(node, 'touchmove', move, nonPassiveEvent).add(node, 'touchend', up).add(node, 'mousemove', move, nonPassiveEvent).add(node, 'mouseup', up);
    }
    function isFocusNode(node) {
        const nodeName = node.nodeName || '';
        return focusNodes.includes(nodeName);
    }
    function forceBoost() {
        const boost = dragFree ? freeForceBoost : snapForceBoost;
        const type = isMouse ? 'mouse' : 'touch';
        return boost[type];
    }
    function allowedForce(force, targetChanged) {
        const next = index.add($3a2ea8b3deea05cd$var$mathSign(force) * -1);
        const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
        if (dragFree || $3a2ea8b3deea05cd$var$mathAbs(force) < goToNextThreshold) return baseForce;
        if (skipSnaps && targetChanged) return baseForce * 0.5;
        return scrollTarget.byIndex(next.get(), 0).distance;
    }
    function down(evt) {
        const isMouseEvt = $3a2ea8b3deea05cd$var$isMouseEvent(evt, ownerWindow);
        isMouse = isMouseEvt;
        preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
        isMoving = $3a2ea8b3deea05cd$var$deltaAbs(target.get(), location.get()) >= 2;
        if (isMouseEvt && evt.button !== 0) return;
        if (isFocusNode(evt.target)) return;
        pointerIsDown = true;
        dragTracker.pointerDown(evt);
        scrollBody.useFriction(0).useDuration(0);
        target.set(location);
        addDragEvents();
        startScroll = dragTracker.readPoint(evt);
        startCross = dragTracker.readPoint(evt, crossAxis);
        eventHandler.emit('pointerDown');
    }
    function move(evt) {
        const isTouchEvt = !$3a2ea8b3deea05cd$var$isMouseEvent(evt, ownerWindow);
        if (isTouchEvt && evt.touches.length >= 2) return up(evt);
        const lastScroll = dragTracker.readPoint(evt);
        const lastCross = dragTracker.readPoint(evt, crossAxis);
        const diffScroll = $3a2ea8b3deea05cd$var$deltaAbs(lastScroll, startScroll);
        const diffCross = $3a2ea8b3deea05cd$var$deltaAbs(lastCross, startCross);
        if (!preventScroll && !isMouse) {
            if (!evt.cancelable) return up(evt);
            preventScroll = diffScroll > diffCross;
            if (!preventScroll) return up(evt);
        }
        const diff = dragTracker.pointerMove(evt);
        if (diffScroll > dragThreshold) preventClick = true;
        scrollBody.useFriction(0.3).useDuration(0.75);
        animation.start();
        target.add(direction(diff));
        evt.preventDefault();
    }
    function up(evt) {
        const currentLocation = scrollTarget.byDistance(0, false);
        const targetChanged = currentLocation.index !== index.get();
        const rawForce = dragTracker.pointerUp(evt) * forceBoost();
        const force = allowedForce(direction(rawForce), targetChanged);
        const forceFactor = $3a2ea8b3deea05cd$var$factorAbs(rawForce, force);
        const speed = baseSpeed - 10 * forceFactor;
        const friction = baseFriction + forceFactor / 50;
        preventScroll = false;
        pointerIsDown = false;
        dragEvents.clear();
        scrollBody.useDuration(speed).useFriction(friction);
        scrollTo.distance(force, !dragFree);
        isMouse = false;
        eventHandler.emit('pointerUp');
    }
    function click(evt) {
        if (preventClick) {
            evt.stopPropagation();
            evt.preventDefault();
            preventClick = false;
        }
    }
    function pointerDown() {
        return pointerIsDown;
    }
    const self = {
        init: init,
        destroy: destroy,
        pointerDown: pointerDown
    };
    return self;
}
function $3a2ea8b3deea05cd$var$DragTracker(axis, ownerWindow) {
    const logInterval = 170;
    let startEvent;
    let lastEvent;
    function readTime(evt) {
        return evt.timeStamp;
    }
    function readPoint(evt, evtAxis) {
        const property = evtAxis || axis.scroll;
        const coord = `client${property === 'x' ? 'X' : 'Y'}`;
        return ($3a2ea8b3deea05cd$var$isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
    }
    function pointerDown(evt) {
        startEvent = evt;
        lastEvent = evt;
        return readPoint(evt);
    }
    function pointerMove(evt) {
        const diff = readPoint(evt) - readPoint(lastEvent);
        const expired = readTime(evt) - readTime(startEvent) > logInterval;
        lastEvent = evt;
        if (expired) startEvent = evt;
        return diff;
    }
    function pointerUp(evt) {
        if (!startEvent || !lastEvent) return 0;
        const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
        const diffTime = readTime(evt) - readTime(startEvent);
        const expired = readTime(evt) - readTime(lastEvent) > logInterval;
        const force = diffDrag / diffTime;
        const isFlick = diffTime && !expired && $3a2ea8b3deea05cd$var$mathAbs(force) > 0.1;
        return isFlick ? force : 0;
    }
    const self = {
        pointerDown: pointerDown,
        pointerMove: pointerMove,
        pointerUp: pointerUp,
        readPoint: readPoint
    };
    return self;
}
function $3a2ea8b3deea05cd$var$NodeRects() {
    function measure(node) {
        const { offsetTop: offsetTop, offsetLeft: offsetLeft, offsetWidth: offsetWidth, offsetHeight: offsetHeight } = node;
        const offset = {
            top: offsetTop,
            right: offsetLeft + offsetWidth,
            bottom: offsetTop + offsetHeight,
            left: offsetLeft,
            width: offsetWidth,
            height: offsetHeight
        };
        return offset;
    }
    const self = {
        measure: measure
    };
    return self;
}
function $3a2ea8b3deea05cd$var$PercentOfView(viewSize) {
    function measure(n) {
        return viewSize * (n / 100);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $3a2ea8b3deea05cd$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
    const observeNodes = [
        container
    ].concat(slides);
    let resizeObserver;
    let containerSize;
    let slideSizes = [];
    let destroyed = false;
    function readSize(node) {
        return axis.measureSize(nodeRects.measure(node));
    }
    function init(emblaApi) {
        if (!watchResize) return;
        containerSize = readSize(container);
        slideSizes = slides.map(readSize);
        function defaultCallback(entries) {
            for (const entry of entries){
                if (destroyed) return;
                const isContainer = entry.target === container;
                const slideIndex = slides.indexOf(entry.target);
                const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
                const newSize = readSize(isContainer ? container : slides[slideIndex]);
                const diffSize = $3a2ea8b3deea05cd$var$mathAbs(newSize - lastSize);
                if (diffSize >= 0.5) {
                    emblaApi.reInit();
                    eventHandler.emit('resize');
                    break;
                }
            }
        }
        resizeObserver = new ResizeObserver((entries)=>{
            if ($3a2ea8b3deea05cd$var$isBoolean(watchResize) || watchResize(emblaApi, entries)) defaultCallback(entries);
        });
        ownerWindow.requestAnimationFrame(()=>{
            observeNodes.forEach((node)=>resizeObserver.observe(node));
        });
    }
    function destroy() {
        destroyed = true;
        if (resizeObserver) resizeObserver.disconnect();
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $3a2ea8b3deea05cd$var$ScrollBody(location, offsetLocation, previousLocation, target, baseDuration, baseFriction) {
    let scrollVelocity = 0;
    let scrollDirection = 0;
    let scrollDuration = baseDuration;
    let scrollFriction = baseFriction;
    let rawLocation = location.get();
    let rawLocationPrevious = 0;
    function seek() {
        const displacement = target.get() - location.get();
        const isInstant = !scrollDuration;
        let scrollDistance = 0;
        if (isInstant) {
            scrollVelocity = 0;
            previousLocation.set(target);
            location.set(target);
            scrollDistance = displacement;
        } else {
            previousLocation.set(location);
            scrollVelocity += displacement / scrollDuration;
            scrollVelocity *= scrollFriction;
            rawLocation += scrollVelocity;
            location.add(scrollVelocity);
            scrollDistance = rawLocation - rawLocationPrevious;
        }
        scrollDirection = $3a2ea8b3deea05cd$var$mathSign(scrollDistance);
        rawLocationPrevious = rawLocation;
        return self;
    }
    function settled() {
        const diff = target.get() - offsetLocation.get();
        return $3a2ea8b3deea05cd$var$mathAbs(diff) < 0.001;
    }
    function duration() {
        return scrollDuration;
    }
    function direction() {
        return scrollDirection;
    }
    function velocity() {
        return scrollVelocity;
    }
    function useBaseDuration() {
        return useDuration(baseDuration);
    }
    function useBaseFriction() {
        return useFriction(baseFriction);
    }
    function useDuration(n) {
        scrollDuration = n;
        return self;
    }
    function useFriction(n) {
        scrollFriction = n;
        return self;
    }
    const self = {
        direction: direction,
        duration: duration,
        velocity: velocity,
        seek: seek,
        settled: settled,
        useBaseFriction: useBaseFriction,
        useBaseDuration: useBaseDuration,
        useFriction: useFriction,
        useDuration: useDuration
    };
    return self;
}
function $3a2ea8b3deea05cd$var$ScrollBounds(limit, location, target, scrollBody, percentOfView) {
    const pullBackThreshold = percentOfView.measure(10);
    const edgeOffsetTolerance = percentOfView.measure(50);
    const frictionLimit = $3a2ea8b3deea05cd$var$Limit(0.1, 0.99);
    let disabled = false;
    function shouldConstrain() {
        if (disabled) return false;
        if (!limit.reachedAny(target.get())) return false;
        if (!limit.reachedAny(location.get())) return false;
        return true;
    }
    function constrain(pointerDown) {
        if (!shouldConstrain()) return;
        const edge = limit.reachedMin(location.get()) ? 'min' : 'max';
        const diffToEdge = $3a2ea8b3deea05cd$var$mathAbs(limit[edge] - location.get());
        const diffToTarget = target.get() - location.get();
        const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
        target.subtract(diffToTarget * friction);
        if (!pointerDown && $3a2ea8b3deea05cd$var$mathAbs(diffToTarget) < pullBackThreshold) {
            target.set(limit.constrain(target.get()));
            scrollBody.useDuration(25).useBaseFriction();
        }
    }
    function toggleActive(active) {
        disabled = !active;
    }
    const self = {
        shouldConstrain: shouldConstrain,
        constrain: constrain,
        toggleActive: toggleActive
    };
    return self;
}
function $3a2ea8b3deea05cd$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
    const scrollBounds = $3a2ea8b3deea05cd$var$Limit(-contentSize + viewSize, 0);
    const snapsBounded = measureBounded();
    const scrollContainLimit = findScrollContainLimit();
    const snapsContained = measureContained();
    function usePixelTolerance(bound, snap) {
        return $3a2ea8b3deea05cd$var$deltaAbs(bound, snap) <= 1;
    }
    function findScrollContainLimit() {
        const startSnap = snapsBounded[0];
        const endSnap = $3a2ea8b3deea05cd$var$arrayLast(snapsBounded);
        const min = snapsBounded.lastIndexOf(startSnap);
        const max = snapsBounded.indexOf(endSnap) + 1;
        return $3a2ea8b3deea05cd$var$Limit(min, max);
    }
    function measureBounded() {
        return snapsAligned.map((snapAligned, index)=>{
            const { min: min, max: max } = scrollBounds;
            const snap = scrollBounds.constrain(snapAligned);
            const isFirst = !index;
            const isLast = $3a2ea8b3deea05cd$var$arrayIsLastIndex(snapsAligned, index);
            if (isFirst) return max;
            if (isLast) return min;
            if (usePixelTolerance(min, snap)) return min;
            if (usePixelTolerance(max, snap)) return max;
            return snap;
        }).map((scrollBound)=>parseFloat(scrollBound.toFixed(3)));
    }
    function measureContained() {
        if (contentSize <= viewSize + pixelTolerance) return [
            scrollBounds.max
        ];
        if (containScroll === 'keepSnaps') return snapsBounded;
        const { min: min, max: max } = scrollContainLimit;
        return snapsBounded.slice(min, max);
    }
    const self = {
        snapsContained: snapsContained,
        scrollContainLimit: scrollContainLimit
    };
    return self;
}
function $3a2ea8b3deea05cd$var$ScrollLimit(contentSize, scrollSnaps, loop) {
    const max = scrollSnaps[0];
    const min = loop ? max - contentSize : $3a2ea8b3deea05cd$var$arrayLast(scrollSnaps);
    const limit = $3a2ea8b3deea05cd$var$Limit(min, max);
    const self = {
        limit: limit
    };
    return self;
}
function $3a2ea8b3deea05cd$var$ScrollLooper(contentSize, limit, location, vectors) {
    const jointSafety = 0.1;
    const min = limit.min + jointSafety;
    const max = limit.max + jointSafety;
    const { reachedMin: reachedMin, reachedMax: reachedMax } = $3a2ea8b3deea05cd$var$Limit(min, max);
    function shouldLoop(direction) {
        if (direction === 1) return reachedMax(location.get());
        if (direction === -1) return reachedMin(location.get());
        return false;
    }
    function loop(direction) {
        if (!shouldLoop(direction)) return;
        const loopDistance = contentSize * (direction * -1);
        vectors.forEach((v)=>v.add(loopDistance));
    }
    const self = {
        loop: loop
    };
    return self;
}
function $3a2ea8b3deea05cd$var$ScrollProgress(limit) {
    const { max: max, length: length } = limit;
    function get(n) {
        const currentLocation = n - max;
        return length ? currentLocation / -length : 0;
    }
    const self = {
        get: get
    };
    return self;
}
function $3a2ea8b3deea05cd$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
    const { startEdge: startEdge, endEdge: endEdge } = axis;
    const { groupSlides: groupSlides } = slidesToScroll;
    const alignments = measureSizes().map(alignment.measure);
    const snaps = measureUnaligned();
    const snapsAligned = measureAligned();
    function measureSizes() {
        return groupSlides(slideRects).map((rects)=>$3a2ea8b3deea05cd$var$arrayLast(rects)[endEdge] - rects[0][startEdge]).map($3a2ea8b3deea05cd$var$mathAbs);
    }
    function measureUnaligned() {
        return slideRects.map((rect)=>containerRect[startEdge] - rect[startEdge]).map((snap)=>-$3a2ea8b3deea05cd$var$mathAbs(snap));
    }
    function measureAligned() {
        return groupSlides(snaps).map((g)=>g[0]).map((snap, index)=>snap + alignments[index]);
    }
    const self = {
        snaps: snaps,
        snapsAligned: snapsAligned
    };
    return self;
}
function $3a2ea8b3deea05cd$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
    const { groupSlides: groupSlides } = slidesToScroll;
    const { min: min, max: max } = scrollContainLimit;
    const slideRegistry = createSlideRegistry();
    function createSlideRegistry() {
        const groupedSlideIndexes = groupSlides(slideIndexes);
        const doNotContain = !containSnaps || containScroll === 'keepSnaps';
        if (scrollSnaps.length === 1) return [
            slideIndexes
        ];
        if (doNotContain) return groupedSlideIndexes;
        return groupedSlideIndexes.slice(min, max).map((group, index, groups)=>{
            const isFirst = !index;
            const isLast = $3a2ea8b3deea05cd$var$arrayIsLastIndex(groups, index);
            if (isFirst) {
                const range = $3a2ea8b3deea05cd$var$arrayLast(groups[0]) + 1;
                return $3a2ea8b3deea05cd$var$arrayFromNumber(range);
            }
            if (isLast) {
                const range = $3a2ea8b3deea05cd$var$arrayLastIndex(slideIndexes) - $3a2ea8b3deea05cd$var$arrayLast(groups)[0] + 1;
                return $3a2ea8b3deea05cd$var$arrayFromNumber(range, $3a2ea8b3deea05cd$var$arrayLast(groups)[0]);
            }
            return group;
        });
    }
    const self = {
        slideRegistry: slideRegistry
    };
    return self;
}
function $3a2ea8b3deea05cd$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
    const { reachedAny: reachedAny, removeOffset: removeOffset, constrain: constrain } = limit;
    function minDistance(distances) {
        return distances.concat().sort((a, b)=>$3a2ea8b3deea05cd$var$mathAbs(a) - $3a2ea8b3deea05cd$var$mathAbs(b))[0];
    }
    function findTargetSnap(target) {
        const distance = loop ? removeOffset(target) : constrain(target);
        const ascDiffsToSnaps = scrollSnaps.map((snap, index)=>({
                diff: shortcut(snap - distance, 0),
                index: index
            })).sort((d1, d2)=>$3a2ea8b3deea05cd$var$mathAbs(d1.diff) - $3a2ea8b3deea05cd$var$mathAbs(d2.diff));
        const { index: index } = ascDiffsToSnaps[0];
        return {
            index: index,
            distance: distance
        };
    }
    function shortcut(target, direction) {
        const targets = [
            target,
            target + contentSize,
            target - contentSize
        ];
        if (!loop) return target;
        if (!direction) return minDistance(targets);
        const matchingTargets = targets.filter((t)=>$3a2ea8b3deea05cd$var$mathSign(t) === direction);
        if (matchingTargets.length) return minDistance(matchingTargets);
        return $3a2ea8b3deea05cd$var$arrayLast(targets) - contentSize;
    }
    function byIndex(index, direction) {
        const diffToSnap = scrollSnaps[index] - targetVector.get();
        const distance = shortcut(diffToSnap, direction);
        return {
            index: index,
            distance: distance
        };
    }
    function byDistance(distance, snap) {
        const target = targetVector.get() + distance;
        const { index: index, distance: targetSnapDistance } = findTargetSnap(target);
        const reachedBound = !loop && reachedAny(target);
        if (!snap || reachedBound) return {
            index: index,
            distance: distance
        };
        const diffToSnap = scrollSnaps[index] - targetSnapDistance;
        const snapDistance = distance + shortcut(diffToSnap, 0);
        return {
            index: index,
            distance: snapDistance
        };
    }
    const self = {
        byDistance: byDistance,
        byIndex: byIndex,
        shortcut: shortcut
    };
    return self;
}
function $3a2ea8b3deea05cd$var$ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
    function scrollTo(target) {
        const distanceDiff = target.distance;
        const indexDiff = target.index !== indexCurrent.get();
        targetVector.add(distanceDiff);
        if (distanceDiff) {
            if (scrollBody.duration()) animation.start();
            else {
                animation.update();
                animation.render(1);
                animation.update();
            }
        }
        if (indexDiff) {
            indexPrevious.set(indexCurrent.get());
            indexCurrent.set(target.index);
            eventHandler.emit('select');
        }
    }
    function distance(n, snap) {
        const target = scrollTarget.byDistance(n, snap);
        scrollTo(target);
    }
    function index(n, direction) {
        const targetIndex = indexCurrent.clone().set(n);
        const target = scrollTarget.byIndex(targetIndex.get(), direction);
        scrollTo(target);
    }
    const self = {
        distance: distance,
        index: index
    };
    return self;
}
function $3a2ea8b3deea05cd$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus) {
    const focusListenerOptions = {
        passive: true,
        capture: true
    };
    let lastTabPressTime = 0;
    function init(emblaApi) {
        if (!watchFocus) return;
        function defaultCallback(index) {
            const nowTime = new Date().getTime();
            const diffTime = nowTime - lastTabPressTime;
            if (diffTime > 10) return;
            eventHandler.emit('slideFocusStart');
            root.scrollLeft = 0;
            const group = slideRegistry.findIndex((group)=>group.includes(index));
            if (!$3a2ea8b3deea05cd$var$isNumber(group)) return;
            scrollBody.useDuration(0);
            scrollTo.index(group, 0);
            eventHandler.emit('slideFocus');
        }
        eventStore.add(document, 'keydown', registerTabPress, false);
        slides.forEach((slide, slideIndex)=>{
            eventStore.add(slide, 'focus', (evt)=>{
                if ($3a2ea8b3deea05cd$var$isBoolean(watchFocus) || watchFocus(emblaApi, evt)) defaultCallback(slideIndex);
            }, focusListenerOptions);
        });
    }
    function registerTabPress(event) {
        if (event.code === 'Tab') lastTabPressTime = new Date().getTime();
    }
    const self = {
        init: init
    };
    return self;
}
function $3a2ea8b3deea05cd$var$Vector1D(initialValue) {
    let value = initialValue;
    function get() {
        return value;
    }
    function set(n) {
        value = normalizeInput(n);
    }
    function add(n) {
        value += normalizeInput(n);
    }
    function subtract(n) {
        value -= normalizeInput(n);
    }
    function normalizeInput(n) {
        return $3a2ea8b3deea05cd$var$isNumber(n) ? n : n.get();
    }
    const self = {
        get: get,
        set: set,
        add: add,
        subtract: subtract
    };
    return self;
}
function $3a2ea8b3deea05cd$var$Translate(axis, container) {
    const translate = axis.scroll === 'x' ? x : y;
    const containerStyle = container.style;
    let previousTarget = null;
    let disabled = false;
    function x(n) {
        return `translate3d(${n}px,0px,0px)`;
    }
    function y(n) {
        return `translate3d(0px,${n}px,0px)`;
    }
    function to(target) {
        if (disabled) return;
        const newTarget = $3a2ea8b3deea05cd$var$roundToTwoDecimals(axis.direction(target));
        if (newTarget === previousTarget) return;
        containerStyle.transform = translate(newTarget);
        previousTarget = newTarget;
    }
    function toggleActive(active) {
        disabled = !active;
    }
    function clear() {
        if (disabled) return;
        containerStyle.transform = '';
        if (!container.getAttribute('style')) container.removeAttribute('style');
    }
    const self = {
        clear: clear,
        to: to,
        toggleActive: toggleActive
    };
    return self;
}
function $3a2ea8b3deea05cd$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, location, slides) {
    const roundingSafety = 0.5;
    const ascItems = $3a2ea8b3deea05cd$var$arrayKeys(slideSizesWithGaps);
    const descItems = $3a2ea8b3deea05cd$var$arrayKeys(slideSizesWithGaps).reverse();
    const loopPoints = startPoints().concat(endPoints());
    function removeSlideSizes(indexes, from) {
        return indexes.reduce((a, i)=>{
            return a - slideSizesWithGaps[i];
        }, from);
    }
    function slidesInGap(indexes, gap) {
        return indexes.reduce((a, i)=>{
            const remainingGap = removeSlideSizes(a, gap);
            return remainingGap > 0 ? a.concat([
                i
            ]) : a;
        }, []);
    }
    function findSlideBounds(offset) {
        return snaps.map((snap, index)=>({
                start: snap - slideSizes[index] + roundingSafety + offset,
                end: snap + viewSize - roundingSafety + offset
            }));
    }
    function findLoopPoints(indexes, offset, isEndEdge) {
        const slideBounds = findSlideBounds(offset);
        return indexes.map((index)=>{
            const initial = isEndEdge ? 0 : -contentSize;
            const altered = isEndEdge ? contentSize : 0;
            const boundEdge = isEndEdge ? 'end' : 'start';
            const loopPoint = slideBounds[index][boundEdge];
            return {
                index: index,
                loopPoint: loopPoint,
                slideLocation: $3a2ea8b3deea05cd$var$Vector1D(-1),
                translate: $3a2ea8b3deea05cd$var$Translate(axis, slides[index]),
                target: ()=>location.get() > loopPoint ? initial : altered
            };
        });
    }
    function startPoints() {
        const gap = scrollSnaps[0];
        const indexes = slidesInGap(descItems, gap);
        return findLoopPoints(indexes, contentSize, false);
    }
    function endPoints() {
        const gap = viewSize - scrollSnaps[0] - 1;
        const indexes = slidesInGap(ascItems, gap);
        return findLoopPoints(indexes, -contentSize, true);
    }
    function canLoop() {
        return loopPoints.every(({ index: index })=>{
            const otherIndexes = ascItems.filter((i)=>i !== index);
            return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
        });
    }
    function loop() {
        loopPoints.forEach((loopPoint)=>{
            const { target: target, translate: translate, slideLocation: slideLocation } = loopPoint;
            const shiftLocation = target();
            if (shiftLocation === slideLocation.get()) return;
            translate.to(shiftLocation);
            slideLocation.set(shiftLocation);
        });
    }
    function clear() {
        loopPoints.forEach((loopPoint)=>loopPoint.translate.clear());
    }
    const self = {
        canLoop: canLoop,
        clear: clear,
        loop: loop,
        loopPoints: loopPoints
    };
    return self;
}
function $3a2ea8b3deea05cd$var$SlidesHandler(container, eventHandler, watchSlides) {
    let mutationObserver;
    let destroyed = false;
    function init(emblaApi) {
        if (!watchSlides) return;
        function defaultCallback(mutations) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                emblaApi.reInit();
                eventHandler.emit('slidesChanged');
                break;
            }
        }
        mutationObserver = new MutationObserver((mutations)=>{
            if (destroyed) return;
            if ($3a2ea8b3deea05cd$var$isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) defaultCallback(mutations);
        });
        mutationObserver.observe(container, {
            childList: true
        });
    }
    function destroy() {
        if (mutationObserver) mutationObserver.disconnect();
        destroyed = true;
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $3a2ea8b3deea05cd$var$SlidesInView(container, slides, eventHandler, threshold) {
    const intersectionEntryMap = {};
    let inViewCache = null;
    let notInViewCache = null;
    let intersectionObserver;
    let destroyed = false;
    function init() {
        intersectionObserver = new IntersectionObserver((entries)=>{
            if (destroyed) return;
            entries.forEach((entry)=>{
                const index = slides.indexOf(entry.target);
                intersectionEntryMap[index] = entry;
            });
            inViewCache = null;
            notInViewCache = null;
            eventHandler.emit('slidesInView');
        }, {
            root: container.parentElement,
            threshold: threshold
        });
        slides.forEach((slide)=>intersectionObserver.observe(slide));
    }
    function destroy() {
        if (intersectionObserver) intersectionObserver.disconnect();
        destroyed = true;
    }
    function createInViewList(inView) {
        return $3a2ea8b3deea05cd$var$objectKeys(intersectionEntryMap).reduce((list, slideIndex)=>{
            const index = parseInt(slideIndex);
            const { isIntersecting: isIntersecting } = intersectionEntryMap[index];
            const inViewMatch = inView && isIntersecting;
            const notInViewMatch = !inView && !isIntersecting;
            if (inViewMatch || notInViewMatch) list.push(index);
            return list;
        }, []);
    }
    function get(inView = true) {
        if (inView && inViewCache) return inViewCache;
        if (!inView && notInViewCache) return notInViewCache;
        const slideIndexes = createInViewList(inView);
        if (inView) inViewCache = slideIndexes;
        if (!inView) notInViewCache = slideIndexes;
        return slideIndexes;
    }
    const self = {
        init: init,
        destroy: destroy,
        get: get
    };
    return self;
}
function $3a2ea8b3deea05cd$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
    const { measureSize: measureSize, startEdge: startEdge, endEdge: endEdge } = axis;
    const withEdgeGap = slideRects[0] && readEdgeGap;
    const startGap = measureStartGap();
    const endGap = measureEndGap();
    const slideSizes = slideRects.map(measureSize);
    const slideSizesWithGaps = measureWithGaps();
    function measureStartGap() {
        if (!withEdgeGap) return 0;
        const slideRect = slideRects[0];
        return $3a2ea8b3deea05cd$var$mathAbs(containerRect[startEdge] - slideRect[startEdge]);
    }
    function measureEndGap() {
        if (!withEdgeGap) return 0;
        const style = ownerWindow.getComputedStyle($3a2ea8b3deea05cd$var$arrayLast(slides));
        return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
    }
    function measureWithGaps() {
        return slideRects.map((rect, index, rects)=>{
            const isFirst = !index;
            const isLast = $3a2ea8b3deea05cd$var$arrayIsLastIndex(rects, index);
            if (isFirst) return slideSizes[index] + startGap;
            if (isLast) return slideSizes[index] + endGap;
            return rects[index + 1][startEdge] - rect[startEdge];
        }).map($3a2ea8b3deea05cd$var$mathAbs);
    }
    const self = {
        slideSizes: slideSizes,
        slideSizesWithGaps: slideSizesWithGaps,
        startGap: startGap,
        endGap: endGap
    };
    return self;
}
function $3a2ea8b3deea05cd$var$SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
    const { startEdge: startEdge, endEdge: endEdge, direction: direction } = axis;
    const groupByNumber = $3a2ea8b3deea05cd$var$isNumber(slidesToScroll);
    function byNumber(array, groupSize) {
        return $3a2ea8b3deea05cd$var$arrayKeys(array).filter((i)=>i % groupSize === 0).map((i)=>array.slice(i, i + groupSize));
    }
    function bySize(array) {
        if (!array.length) return [];
        return $3a2ea8b3deea05cd$var$arrayKeys(array).reduce((groups, rectB, index)=>{
            const rectA = $3a2ea8b3deea05cd$var$arrayLast(groups) || 0;
            const isFirst = rectA === 0;
            const isLast = rectB === $3a2ea8b3deea05cd$var$arrayLastIndex(array);
            const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
            const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
            const gapA = !loop && isFirst ? direction(startGap) : 0;
            const gapB = !loop && isLast ? direction(endGap) : 0;
            const chunkSize = $3a2ea8b3deea05cd$var$mathAbs(edgeB - gapB - (edgeA + gapA));
            if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
            if (isLast) groups.push(array.length);
            return groups;
        }, []).map((currentSize, index, groups)=>{
            const previousSize = Math.max(groups[index - 1] || 0);
            return array.slice(previousSize, currentSize);
        });
    }
    function groupSlides(array) {
        return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
    }
    const self = {
        groupSlides: groupSlides
    };
    return self;
}
function $3a2ea8b3deea05cd$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
    // Options
    const { align: align, axis: scrollAxis, direction: direction, startIndex: startIndex, loop: loop, duration: duration, dragFree: dragFree, dragThreshold: dragThreshold, inViewThreshold: inViewThreshold, slidesToScroll: groupSlides, skipSnaps: skipSnaps, containScroll: containScroll, watchResize: watchResize, watchSlides: watchSlides, watchDrag: watchDrag, watchFocus: watchFocus } = options;
    // Measurements
    const pixelTolerance = 2;
    const nodeRects = $3a2ea8b3deea05cd$var$NodeRects();
    const containerRect = nodeRects.measure(container);
    const slideRects = slides.map(nodeRects.measure);
    const axis = $3a2ea8b3deea05cd$var$Axis(scrollAxis, direction);
    const viewSize = axis.measureSize(containerRect);
    const percentOfView = $3a2ea8b3deea05cd$var$PercentOfView(viewSize);
    const alignment = $3a2ea8b3deea05cd$var$Alignment(align, viewSize);
    const containSnaps = !loop && !!containScroll;
    const readEdgeGap = loop || !!containScroll;
    const { slideSizes: slideSizes, slideSizesWithGaps: slideSizesWithGaps, startGap: startGap, endGap: endGap } = $3a2ea8b3deea05cd$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
    const slidesToScroll = $3a2ea8b3deea05cd$var$SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
    const { snaps: snaps, snapsAligned: snapsAligned } = $3a2ea8b3deea05cd$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
    const contentSize = -$3a2ea8b3deea05cd$var$arrayLast(snaps) + $3a2ea8b3deea05cd$var$arrayLast(slideSizesWithGaps);
    const { snapsContained: snapsContained, scrollContainLimit: scrollContainLimit } = $3a2ea8b3deea05cd$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
    const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
    const { limit: limit } = $3a2ea8b3deea05cd$var$ScrollLimit(contentSize, scrollSnaps, loop);
    // Indexes
    const index = $3a2ea8b3deea05cd$var$Counter($3a2ea8b3deea05cd$var$arrayLastIndex(scrollSnaps), startIndex, loop);
    const indexPrevious = index.clone();
    const slideIndexes = $3a2ea8b3deea05cd$var$arrayKeys(slides);
    // Animation
    const update = ({ dragHandler: dragHandler, scrollBody: scrollBody, scrollBounds: scrollBounds, options: { loop: loop } })=>{
        if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
        scrollBody.seek();
    };
    const render = ({ scrollBody: scrollBody, translate: translate, location: location, offsetLocation: offsetLocation, previousLocation: previousLocation, scrollLooper: scrollLooper, slideLooper: slideLooper, dragHandler: dragHandler, animation: animation, eventHandler: eventHandler, scrollBounds: scrollBounds, options: { loop: loop } }, alpha)=>{
        const shouldSettle = scrollBody.settled();
        const withinBounds = !scrollBounds.shouldConstrain();
        const hasSettled = loop ? shouldSettle : shouldSettle && withinBounds;
        const hasSettledAndIdle = hasSettled && !dragHandler.pointerDown();
        if (hasSettledAndIdle) animation.stop();
        const interpolatedLocation = location.get() * alpha + previousLocation.get() * (1 - alpha);
        offsetLocation.set(interpolatedLocation);
        if (loop) {
            scrollLooper.loop(scrollBody.direction());
            slideLooper.loop();
        }
        translate.to(offsetLocation.get());
        if (hasSettledAndIdle) eventHandler.emit('settle');
        if (!hasSettled) eventHandler.emit('scroll');
    };
    const animation = $3a2ea8b3deea05cd$var$Animations(ownerDocument, ownerWindow, ()=>update(engine), (alpha)=>render(engine, alpha));
    // Shared
    const friction = 0.68;
    const startLocation = scrollSnaps[index.get()];
    const location = $3a2ea8b3deea05cd$var$Vector1D(startLocation);
    const previousLocation = $3a2ea8b3deea05cd$var$Vector1D(startLocation);
    const offsetLocation = $3a2ea8b3deea05cd$var$Vector1D(startLocation);
    const target = $3a2ea8b3deea05cd$var$Vector1D(startLocation);
    const scrollBody = $3a2ea8b3deea05cd$var$ScrollBody(location, offsetLocation, previousLocation, target, duration, friction);
    const scrollTarget = $3a2ea8b3deea05cd$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
    const scrollTo = $3a2ea8b3deea05cd$var$ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
    const scrollProgress = $3a2ea8b3deea05cd$var$ScrollProgress(limit);
    const eventStore = $3a2ea8b3deea05cd$var$EventStore();
    const slidesInView = $3a2ea8b3deea05cd$var$SlidesInView(container, slides, eventHandler, inViewThreshold);
    const { slideRegistry: slideRegistry } = $3a2ea8b3deea05cd$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
    const slideFocus = $3a2ea8b3deea05cd$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus);
    // Engine
    const engine = {
        ownerDocument: ownerDocument,
        ownerWindow: ownerWindow,
        eventHandler: eventHandler,
        containerRect: containerRect,
        slideRects: slideRects,
        animation: animation,
        axis: axis,
        dragHandler: $3a2ea8b3deea05cd$var$DragHandler(axis, root, ownerDocument, ownerWindow, target, $3a2ea8b3deea05cd$var$DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
        eventStore: eventStore,
        percentOfView: percentOfView,
        index: index,
        indexPrevious: indexPrevious,
        limit: limit,
        location: location,
        offsetLocation: offsetLocation,
        previousLocation: previousLocation,
        options: options,
        resizeHandler: $3a2ea8b3deea05cd$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
        scrollBody: scrollBody,
        scrollBounds: $3a2ea8b3deea05cd$var$ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
        scrollLooper: $3a2ea8b3deea05cd$var$ScrollLooper(contentSize, limit, offsetLocation, [
            location,
            offsetLocation,
            previousLocation,
            target
        ]),
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnaps.map(scrollProgress.get),
        scrollSnaps: scrollSnaps,
        scrollTarget: scrollTarget,
        scrollTo: scrollTo,
        slideLooper: $3a2ea8b3deea05cd$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
        slideFocus: slideFocus,
        slidesHandler: $3a2ea8b3deea05cd$var$SlidesHandler(container, eventHandler, watchSlides),
        slidesInView: slidesInView,
        slideIndexes: slideIndexes,
        slideRegistry: slideRegistry,
        slidesToScroll: slidesToScroll,
        target: target,
        translate: $3a2ea8b3deea05cd$var$Translate(axis, container)
    };
    return engine;
}
function $3a2ea8b3deea05cd$var$EventHandler() {
    let listeners = {};
    let api;
    function init(emblaApi) {
        api = emblaApi;
    }
    function getListeners(evt) {
        return listeners[evt] || [];
    }
    function emit(evt) {
        getListeners(evt).forEach((e)=>e(api, evt));
        return self;
    }
    function on(evt, cb) {
        listeners[evt] = getListeners(evt).concat([
            cb
        ]);
        return self;
    }
    function off(evt, cb) {
        listeners[evt] = getListeners(evt).filter((e)=>e !== cb);
        return self;
    }
    function clear() {
        listeners = {};
    }
    const self = {
        init: init,
        emit: emit,
        off: off,
        on: on,
        clear: clear
    };
    return self;
}
const $3a2ea8b3deea05cd$var$defaultOptions = {
    align: 'center',
    axis: 'x',
    container: null,
    slides: null,
    containScroll: 'trimSnaps',
    direction: 'ltr',
    slidesToScroll: 1,
    inViewThreshold: 0,
    breakpoints: {},
    dragFree: false,
    dragThreshold: 10,
    loop: false,
    skipSnaps: false,
    duration: 25,
    startIndex: 0,
    active: true,
    watchDrag: true,
    watchResize: true,
    watchSlides: true,
    watchFocus: true
};
function $3a2ea8b3deea05cd$var$OptionsHandler(ownerWindow) {
    function mergeOptions(optionsA, optionsB) {
        return $3a2ea8b3deea05cd$var$objectsMergeDeep(optionsA, optionsB || {});
    }
    function optionsAtMedia(options) {
        const optionsAtMedia = options.breakpoints || {};
        const matchedMediaOptions = $3a2ea8b3deea05cd$var$objectKeys(optionsAtMedia).filter((media)=>ownerWindow.matchMedia(media).matches).map((media)=>optionsAtMedia[media]).reduce((a, mediaOption)=>mergeOptions(a, mediaOption), {});
        return mergeOptions(options, matchedMediaOptions);
    }
    function optionsMediaQueries(optionsList) {
        return optionsList.map((options)=>$3a2ea8b3deea05cd$var$objectKeys(options.breakpoints || {})).reduce((acc, mediaQueries)=>acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
    }
    const self = {
        mergeOptions: mergeOptions,
        optionsAtMedia: optionsAtMedia,
        optionsMediaQueries: optionsMediaQueries
    };
    return self;
}
function $3a2ea8b3deea05cd$var$PluginsHandler(optionsHandler) {
    let activePlugins = [];
    function init(emblaApi, plugins) {
        activePlugins = plugins.filter(({ options: options })=>optionsHandler.optionsAtMedia(options).active !== false);
        activePlugins.forEach((plugin)=>plugin.init(emblaApi, optionsHandler));
        return plugins.reduce((map, plugin)=>Object.assign(map, {
                [plugin.name]: plugin
            }), {});
    }
    function destroy() {
        activePlugins = activePlugins.filter((plugin)=>plugin.destroy());
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $3a2ea8b3deea05cd$export$2e2bcd8739ae039(root, userOptions, userPlugins) {
    const ownerDocument = root.ownerDocument;
    const ownerWindow = ownerDocument.defaultView;
    const optionsHandler = $3a2ea8b3deea05cd$var$OptionsHandler(ownerWindow);
    const pluginsHandler = $3a2ea8b3deea05cd$var$PluginsHandler(optionsHandler);
    const mediaHandlers = $3a2ea8b3deea05cd$var$EventStore();
    const eventHandler = $3a2ea8b3deea05cd$var$EventHandler();
    const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia, optionsMediaQueries: optionsMediaQueries } = optionsHandler;
    const { on: on, off: off, emit: emit } = eventHandler;
    const reInit = reActivate;
    let destroyed = false;
    let engine;
    let optionsBase = mergeOptions($3a2ea8b3deea05cd$var$defaultOptions, $3a2ea8b3deea05cd$export$2e2bcd8739ae039.globalOptions);
    let options = mergeOptions(optionsBase);
    let pluginList = [];
    let pluginApis;
    let container;
    let slides;
    function storeElements() {
        const { container: userContainer, slides: userSlides } = options;
        const customContainer = $3a2ea8b3deea05cd$var$isString(userContainer) ? root.querySelector(userContainer) : userContainer;
        container = customContainer || root.children[0];
        const customSlides = $3a2ea8b3deea05cd$var$isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
        slides = [].slice.call(customSlides || container.children);
    }
    function createEngine(options) {
        const engine = $3a2ea8b3deea05cd$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
        if (options.loop && !engine.slideLooper.canLoop()) {
            const optionsWithoutLoop = Object.assign({}, options, {
                loop: false
            });
            return createEngine(optionsWithoutLoop);
        }
        return engine;
    }
    function activate(withOptions, withPlugins) {
        if (destroyed) return;
        optionsBase = mergeOptions(optionsBase, withOptions);
        options = optionsAtMedia(optionsBase);
        pluginList = withPlugins || pluginList;
        storeElements();
        engine = createEngine(options);
        optionsMediaQueries([
            optionsBase,
            ...pluginList.map(({ options: options })=>options)
        ]).forEach((query)=>mediaHandlers.add(query, 'change', reActivate));
        if (!options.active) return;
        engine.translate.to(engine.location.get());
        engine.animation.init();
        engine.slidesInView.init();
        engine.slideFocus.init(self);
        engine.eventHandler.init(self);
        engine.resizeHandler.init(self);
        engine.slidesHandler.init(self);
        if (engine.options.loop) engine.slideLooper.loop();
        if (container.offsetParent && slides.length) engine.dragHandler.init(self);
        pluginApis = pluginsHandler.init(self, pluginList);
    }
    function reActivate(withOptions, withPlugins) {
        const startIndex = selectedScrollSnap();
        deActivate();
        activate(mergeOptions({
            startIndex: startIndex
        }, withOptions), withPlugins);
        eventHandler.emit('reInit');
    }
    function deActivate() {
        engine.dragHandler.destroy();
        engine.eventStore.clear();
        engine.translate.clear();
        engine.slideLooper.clear();
        engine.resizeHandler.destroy();
        engine.slidesHandler.destroy();
        engine.slidesInView.destroy();
        engine.animation.destroy();
        pluginsHandler.destroy();
        mediaHandlers.clear();
    }
    function destroy() {
        if (destroyed) return;
        destroyed = true;
        mediaHandlers.clear();
        deActivate();
        eventHandler.emit('destroy');
        eventHandler.clear();
    }
    function scrollTo(index, jump, direction) {
        if (!options.active || destroyed) return;
        engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
        engine.scrollTo.index(index, direction || 0);
    }
    function scrollNext(jump) {
        const next = engine.index.add(1).get();
        scrollTo(next, jump, -1);
    }
    function scrollPrev(jump) {
        const prev = engine.index.add(-1).get();
        scrollTo(prev, jump, 1);
    }
    function canScrollNext() {
        const next = engine.index.add(1).get();
        return next !== selectedScrollSnap();
    }
    function canScrollPrev() {
        const prev = engine.index.add(-1).get();
        return prev !== selectedScrollSnap();
    }
    function scrollSnapList() {
        return engine.scrollSnapList;
    }
    function scrollProgress() {
        return engine.scrollProgress.get(engine.offsetLocation.get());
    }
    function selectedScrollSnap() {
        return engine.index.get();
    }
    function previousScrollSnap() {
        return engine.indexPrevious.get();
    }
    function slidesInView() {
        return engine.slidesInView.get();
    }
    function slidesNotInView() {
        return engine.slidesInView.get(false);
    }
    function plugins() {
        return pluginApis;
    }
    function internalEngine() {
        return engine;
    }
    function rootNode() {
        return root;
    }
    function containerNode() {
        return container;
    }
    function slideNodes() {
        return slides;
    }
    const self = {
        canScrollNext: canScrollNext,
        canScrollPrev: canScrollPrev,
        containerNode: containerNode,
        internalEngine: internalEngine,
        destroy: destroy,
        off: off,
        on: on,
        emit: emit,
        plugins: plugins,
        previousScrollSnap: previousScrollSnap,
        reInit: reInit,
        rootNode: rootNode,
        scrollNext: scrollNext,
        scrollPrev: scrollPrev,
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnapList,
        scrollTo: scrollTo,
        selectedScrollSnap: selectedScrollSnap,
        slideNodes: slideNodes,
        slidesInView: slidesInView,
        slidesNotInView: slidesNotInView
    };
    activate(userOptions, userPlugins);
    setTimeout(()=>eventHandler.emit('init'), 0);
    return self;
}
$3a2ea8b3deea05cd$export$2e2bcd8739ae039.globalOptions = undefined;

});


parcelRegister("lIUfV", function(module, exports) {

$parcel$export(module.exports, "AnimatePresence", function () { return $b699fa25a6fca869$export$3ae376d12526dd6f; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $b2HTw = parcelRequire("b2HTw");

var $3TpDH = parcelRequire("3TpDH");

var $dqFLN = parcelRequire("dqFLN");

var $4wB90 = parcelRequire("4wB90");

var $4pn0p = parcelRequire("4pn0p");

var $foA0a = parcelRequire("foA0a");
"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $b699fa25a6fca869$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync", propagate: propagate = false })=>{
    const [isParentPresent, safeToRemove] = (0, $4wB90.usePresence)(propagate);
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $8FY87.useMemo)(()=>(0, $4pn0p.onlyElements)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = propagate && !isParentPresent ? [] : presentChildren.map((0, $4pn0p.getChildKey));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $8FY87.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $8FY87.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $3TpDH.useConstant)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $8FY87.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $8FY87.useState)(presentChildren);
    (0, $foA0a.useIsomorphicLayoutEffect)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $4pn0p.getChildKey)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $4pn0p.getChildKey)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $4pn0p.onlyElements)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $8FY87.useContext)((0, $b2HTw.LayoutGroupContext));
    return (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $4pn0p.getChildKey)(child);
            const isPresent = propagate && !isParentPresent ? false : presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 || forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    propagate && (safeToRemove === null || safeToRemove === void 0 || safeToRemove());
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $2PPWI.jsx)((0, $dqFLN.PresenceChild), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: isPresent ? undefined : custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                children: child
            }, key);
        })
    });
};

});
parcelRegister("b2HTw", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", function () { return $40528390a3864be6$export$a3579ca508007a95; });

var $8FY87 = parcelRequire("8FY87");
"use client";
const $40528390a3864be6$export$a3579ca508007a95 = (0, $8FY87.createContext)({});

});

parcelRegister("3TpDH", function(module, exports) {

$parcel$export(module.exports, "useConstant", function () { return $dc23b480bc2763d6$export$fe4300aa8eebea86; });

var $8FY87 = parcelRequire("8FY87");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $dc23b480bc2763d6$export$fe4300aa8eebea86(init) {
    const ref = (0, $8FY87.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});

parcelRegister("dqFLN", function(module, exports) {

$parcel$export(module.exports, "PresenceChild", function () { return $a39e32b687f3b6d0$export$979daf65881a382a; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $kL7gn = parcelRequire("kL7gn");

var $3TpDH = parcelRequire("3TpDH");

var $iUCdJ = parcelRequire("iUCdJ");
"use client";
const $a39e32b687f3b6d0$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $3TpDH.useConstant)($a39e32b687f3b6d0$var$newChildrenMap);
    const id = (0, $8FY87.useId)();
    const memoizedOnExitComplete = (0, $8FY87.useCallback)((childId)=>{
        presenceChildren.set(childId, true);
        for (const isComplete of presenceChildren.values()){
            if (!isComplete) return; // can stop searching when any is incomplete
        }
        onExitComplete && onExitComplete();
    }, [
        presenceChildren,
        onExitComplete
    ]);
    const context = (0, $8FY87.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: memoizedOnExitComplete,
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random(),
        memoizedOnExitComplete
    ] : [
        isPresent,
        memoizedOnExitComplete
    ]);
    (0, $8FY87.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $8FY87.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $2PPWI.jsx)((0, $iUCdJ.PopChild), {
        isPresent: isPresent,
        children: children
    });
    return (0, $2PPWI.jsx)((0, $kL7gn.PresenceContext).Provider, {
        value: context,
        children: children
    });
};
function $a39e32b687f3b6d0$var$newChildrenMap() {
    return new Map();
}

});
parcelRegister("kL7gn", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", function () { return $5286f0a10bef04b8$export$f224e4635b6f8ce2; });

var $8FY87 = parcelRequire("8FY87");
"use client";
/**
 * @public
 */ const $5286f0a10bef04b8$export$f224e4635b6f8ce2 = (0, $8FY87.createContext)(null);

});

parcelRegister("iUCdJ", function(module, exports) {

$parcel$export(module.exports, "PopChild", function () { return $c3560737a65788c9$export$1d6cdde0c6816c6d; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $2WRim = parcelRequire("2WRim");
"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $c3560737a65788c9$var$PopChildMeasure extends $8FY87.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $c3560737a65788c9$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $8FY87.useId)();
    const ref = (0, $8FY87.useRef)(null);
    const size = (0, $8FY87.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const { nonce: nonce } = (0, $8FY87.useContext)((0, $2WRim.MotionConfigContext));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $8FY87.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $2PPWI.jsx)($c3560737a65788c9$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $8FY87.cloneElement(children, {
            ref: ref
        })
    });
}

});
parcelRegister("2WRim", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", function () { return $ecd2edf7f22dc2ca$export$22a697fb29aac98d; });

var $8FY87 = parcelRequire("8FY87");
"use client";
/**
 * @public
 */ const $ecd2edf7f22dc2ca$export$22a697fb29aac98d = (0, $8FY87.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});

});



parcelRegister("4wB90", function(module, exports) {

$parcel$export(module.exports, "usePresence", function () { return $1745d42e44e400d4$export$2a8c16d82a0a0e26; });

var $8FY87 = parcelRequire("8FY87");

var $kL7gn = parcelRequire("kL7gn");
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $1745d42e44e400d4$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $8FY87.useContext)((0, $kL7gn.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $8FY87.useId)();
    (0, $8FY87.useEffect)(()=>{
        if (subscribe) register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $8FY87.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $1745d42e44e400d4$export$8249053f690ea39a() {
    return $1745d42e44e400d4$export$ee27c052bca048fb((0, $8FY87.useContext)((0, $kL7gn.PresenceContext)));
}
function $1745d42e44e400d4$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}

});

parcelRegister("4pn0p", function(module, exports) {

$parcel$export(module.exports, "getChildKey", function () { return $fe3e67b9ca5b6ef2$export$10e61aed958678dd; });
$parcel$export(module.exports, "onlyElements", function () { return $fe3e67b9ca5b6ef2$export$872a3a1281f4b357; });

var $8FY87 = parcelRequire("8FY87");
const $fe3e67b9ca5b6ef2$export$10e61aed958678dd = (child)=>child.key || "";
function $fe3e67b9ca5b6ef2$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $8FY87.Children).forEach(children, (child)=>{
        if ((0, $8FY87.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}

});

parcelRegister("foA0a", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $3684dd6020d83a42$export$700979bc83e7db82; });

var $8FY87 = parcelRequire("8FY87");

var $4N4vL = parcelRequire("4N4vL");
const $3684dd6020d83a42$export$700979bc83e7db82 = (0, $4N4vL.isBrowser) ? (0, $8FY87.useLayoutEffect) : (0, $8FY87.useEffect);

});
parcelRegister("4N4vL", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $fa4fba8311273859$export$4e09c449d6c407f7; });
const $fa4fba8311273859$export$4e09c449d6c407f7 = typeof window !== "undefined";

});



parcelRegister("7hXNm", function(module, exports) {

$parcel$export(module.exports, "motion", function () { return $deea4480a0f0a36f$export$e25e478948902b8b; });

var $5HOFw = parcelRequire("5HOFw");

var $3f8cY = parcelRequire("3f8cY");
const $deea4480a0f0a36f$export$e25e478948902b8b = /*@__PURE__*/ (0, $5HOFw.createDOMMotionComponentProxy)((0, $3f8cY.createMotionComponent));

});
parcelRegister("5HOFw", function(module, exports) {

$parcel$export(module.exports, "createDOMMotionComponentProxy", function () { return $7a742a4ea663e837$export$3af29c0efb268f04; });

function $7a742a4ea663e837$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}

});

parcelRegister("3f8cY", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", function () { return $2b1e9c0144a225b4$export$46b7e4b9dc6110c3; });

var $1ltng = parcelRequire("1ltng");

var $9LKwx = parcelRequire("9LKwx");

var $hBQm6 = parcelRequire("hBQm6");

var $jk1q1 = parcelRequire("jk1q1");

var $ggmR6 = parcelRequire("ggmR6");

var $gG7Ih = parcelRequire("gG7Ih");
const $2b1e9c0144a225b4$export$46b7e4b9dc6110c3 = /*@__PURE__*/ (0, $ggmR6.createMotionComponentFactory)({
    ...(0, $1ltng.animations),
    ...(0, $hBQm6.gestureAnimations),
    ...(0, $9LKwx.drag),
    ...(0, $jk1q1.layout)
}, (0, $gG7Ih.createDomVisualElement));

});
parcelRegister("1ltng", function(module, exports) {

$parcel$export(module.exports, "animations", function () { return $88cd57db6732ad5e$export$7f9953c70dacfd7f; });

var $4crwF = parcelRequire("4crwF");

var $4yGWr = parcelRequire("4yGWr");
const $88cd57db6732ad5e$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $4crwF.AnimationFeature)
    },
    exit: {
        Feature: (0, $4yGWr.ExitAnimationFeature)
    }
};

});
parcelRegister("4crwF", function(module, exports) {

$parcel$export(module.exports, "AnimationFeature", function () { return $500e3801067a80c1$export$b45b3fe5caabdca; });

var $4hf94 = parcelRequire("4hf94");

var $l8QLP = parcelRequire("l8QLP");

var $d72GF = parcelRequire("d72GF");
class $500e3801067a80c1$export$b45b3fe5caabdca extends (0, $d72GF.Feature) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $l8QLP.createAnimationState)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $4hf94.isAnimationControls)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}

});
parcelRegister("4hf94", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", function () { return $82ec1f8807d45bd4$export$aa71198ceeaf53ce; });
function $82ec1f8807d45bd4$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}

});

parcelRegister("l8QLP", function(module, exports) {

$parcel$export(module.exports, "createAnimationState", function () { return $bbf2b0f224cadf08$export$bb53502b7a672aa8; });

var $4hf94 = parcelRequire("4hf94");

var $95jQo = parcelRequire("95jQo");

var $4DtBH = parcelRequire("4DtBH");

var $ipk3v = parcelRequire("ipk3v");

var $hTtrb = parcelRequire("hTtrb");

var $cV5Fz = parcelRequire("cV5Fz");

var $aWFGB = parcelRequire("aWFGB");

var $7xNZg = parcelRequire("7xNZg");
const $bbf2b0f224cadf08$var$reversePriorityOrder = [
    ...(0, $cV5Fz.variantPriorityOrder)
].reverse();
const $bbf2b0f224cadf08$var$numAnimationTypes = (0, $cV5Fz.variantPriorityOrder).length;
function $bbf2b0f224cadf08$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $aWFGB.animateVisualElement)(visualElement, animation, options)));
}
function $bbf2b0f224cadf08$export$bb53502b7a672aa8(visualElement) {
    let animate = $bbf2b0f224cadf08$var$animateList(visualElement);
    let state = $bbf2b0f224cadf08$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $hTtrb.resolveVariant)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $7xNZg.getVariantContext)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $bbf2b0f224cadf08$var$numAnimationTypes; i++){
            const type = $bbf2b0f224cadf08$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $ipk3v.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $4hf94.isAnimationControls)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $bbf2b0f224cadf08$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $95jQo.isKeyframesTarget)(next) && (0, $95jQo.isKeyframesTarget)(prev)) valueHasChanged = !(0, $4DtBH.shallowCompare)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $bbf2b0f224cadf08$var$createState();
            isInitialRender = true;
        }
    };
}
function $bbf2b0f224cadf08$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $4DtBH.shallowCompare)(next, prev);
    return false;
}
function $bbf2b0f224cadf08$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $bbf2b0f224cadf08$var$createState() {
    return {
        animate: $bbf2b0f224cadf08$var$createTypeState(true),
        whileInView: $bbf2b0f224cadf08$var$createTypeState(),
        whileHover: $bbf2b0f224cadf08$var$createTypeState(),
        whileTap: $bbf2b0f224cadf08$var$createTypeState(),
        whileDrag: $bbf2b0f224cadf08$var$createTypeState(),
        whileFocus: $bbf2b0f224cadf08$var$createTypeState(),
        exit: $bbf2b0f224cadf08$var$createTypeState()
    };
}

});
parcelRegister("95jQo", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", function () { return $428de5f5f14e7dca$export$9153ad4c4999f4a0; });
const $428de5f5f14e7dca$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};

});

parcelRegister("4DtBH", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", function () { return $bc7affb50709dfaa$export$90e866afbd6b9f1a; });
function $bc7affb50709dfaa$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRegister("ipk3v", function(module, exports) {

$parcel$export(module.exports, "isVariantLabel", function () { return $ae7aa8bdd0f59521$export$720b90e312cea233; });
/**
 * Decides if the supplied variable is variant label
 */ function $ae7aa8bdd0f59521$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}

});

parcelRegister("hTtrb", function(module, exports) {

$parcel$export(module.exports, "resolveVariant", function () { return $962876016c401a14$export$7b1b1c981f4f0558; });

var $avJMO = parcelRequire("avJMO");
function $962876016c401a14$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $avJMO.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

});
parcelRegister("avJMO", function(module, exports) {

$parcel$export(module.exports, "resolveVariantFromProps", function () { return $9a3e6a003c9bff9f$export$d68f140c4d9b48bc; });
function $9a3e6a003c9bff9f$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $9a3e6a003c9bff9f$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $9a3e6a003c9bff9f$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $9a3e6a003c9bff9f$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}

});


parcelRegister("cV5Fz", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", function () { return $caa984ddc1915abc$export$16e45afcc206d3a8; });
$parcel$export(module.exports, "variantProps", function () { return $caa984ddc1915abc$export$1405a65085f40b9; });
const $caa984ddc1915abc$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $caa984ddc1915abc$export$1405a65085f40b9 = [
    "initial",
    ...$caa984ddc1915abc$export$16e45afcc206d3a8
];

});

parcelRegister("aWFGB", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", function () { return $b075e976515b64ac$export$ff62cf473653f109; });

var $hTtrb = parcelRequire("hTtrb");

var $7qcxu = parcelRequire("7qcxu");

var $adguu = parcelRequire("adguu");
function $b075e976515b64ac$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $adguu.animateVariant)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $adguu.animateVariant)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $hTtrb.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $7qcxu.animateTarget)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}

});
parcelRegister("7qcxu", function(module, exports) {

$parcel$export(module.exports, "animateTarget", function () { return $f90cab5c0d21710b$export$68cacfeee78d98d2; });
parcelRequire("7Ow0h");
var $aPjDR = parcelRequire("aPjDR");

var $2TFvH = parcelRequire("2TFvH");

var $e4w0T = parcelRequire("e4w0T");

var $28eMC = parcelRequire("28eMC");

var $cBNAe = parcelRequire("cBNAe");

var $6LTw8 = parcelRequire("6LTw8");

var $5Orka = parcelRequire("5Orka");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $f90cab5c0d21710b$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $f90cab5c0d21710b$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $f90cab5c0d21710b$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $aPjDR.getValueTransition)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $cBNAe.getOptimisedAppearId)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $5Orka.frame));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $28eMC.addValueToWillChange)(visualElement, key);
        value.start((0, $6LTw8.animateMotionValue)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $2TFvH.positionalKeys).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $5Orka.frame).update(()=>{
            transitionEnd && (0, $e4w0T.setTarget)(visualElement, transitionEnd);
        });
    });
    return animations;
}

});
parcelRegister("7Ow0h", function(module, exports) {

$parcel$export(module.exports, "GroupPlaybackControls", function () { return (parcelRequire("35dO7")).GroupPlaybackControls; });
$parcel$export(module.exports, "getValueTransition", function () { return (parcelRequire("aPjDR")).getValueTransition; });
$parcel$export(module.exports, "calcGeneratorDuration", function () { return (parcelRequire("fXjmT")).calcGeneratorDuration; });
$parcel$export(module.exports, "maxGeneratorDuration", function () { return (parcelRequire("fXjmT")).maxGeneratorDuration; });
$parcel$export(module.exports, "isGenerator", function () { return (parcelRequire("ezUzd")).isGenerator; });
$parcel$export(module.exports, "attachTimeline", function () { return (parcelRequire("1wGNu")).attachTimeline; });
$parcel$export(module.exports, "isWaapiSupportedEasing", function () { return (parcelRequire("5OhEy")).isWaapiSupportedEasing; });
$parcel$export(module.exports, "mapEasingToNativeEasing", function () { return (parcelRequire("5OhEy")).mapEasingToNativeEasing; });
$parcel$export(module.exports, "generateLinearEasing", function () { return (parcelRequire("2bfsp")).generateLinearEasing; });
$parcel$export(module.exports, "hover", function () { return (parcelRequire("jicDV")).hover; });
$parcel$export(module.exports, "press", function () { return (parcelRequire("aMjVo")).press; });
$parcel$export(module.exports, "isBezierDefinition", function () { return (parcelRequire("j8D8r")).isBezierDefinition; });
$parcel$export(module.exports, "supportsLinearEasing", function () { return (parcelRequire("2GgX8")).supportsLinearEasing; });
$parcel$export(module.exports, "setDragLock", function () { return (parcelRequire("5pan6")).setDragLock; });
$parcel$export(module.exports, "isPrimaryPointer", function () { return (parcelRequire("hclYu")).isPrimaryPointer; });

var $35dO7 = parcelRequire("35dO7");

var $aPjDR = parcelRequire("aPjDR");

var $fXjmT = parcelRequire("fXjmT");

var $h7DmV = parcelRequire("h7DmV");

var $ezUzd = parcelRequire("ezUzd");

var $2WRYS = parcelRequire("2WRYS");

var $1wGNu = parcelRequire("1wGNu");

var $5OhEy = parcelRequire("5OhEy");

var $2bfsp = parcelRequire("2bfsp");

var $jicDV = parcelRequire("jicDV");

var $aMjVo = parcelRequire("aMjVo");

var $j8D8r = parcelRequire("j8D8r");

var $caYDN = parcelRequire("caYDN");

var $f4iSK = parcelRequire("f4iSK");

var $2GgX8 = parcelRequire("2GgX8");

var $hTZFh = parcelRequire("hTZFh");

var $dgksD = parcelRequire("dgksD");

var $3IIHs = parcelRequire("3IIHs");

var $5pan6 = parcelRequire("5pan6");

var $5bq44 = parcelRequire("5bq44");

var $hclYu = parcelRequire("hclYu");

});
parcelRegister("35dO7", function(module, exports) {

$parcel$export(module.exports, "GroupPlaybackControls", function () { return $bf8197c9504b1a59$export$c1e41718f71efe41; });

var $hTtg7 = parcelRequire("hTtg7");
/**
 * TODO: This is a temporary class to support the legacy
 * thennable API
 */ class $bf8197c9504b1a59$export$c1e41718f71efe41 extends (0, $hTtg7.BaseGroupPlaybackControls) {
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
}

});
parcelRegister("hTtg7", function(module, exports) {

$parcel$export(module.exports, "BaseGroupPlaybackControls", function () { return $c8ca1c95fd0828ff$export$4d0c371993b9283e; });

var $hTZFh = parcelRequire("hTZFh");
class $c8ca1c95fd0828ff$export$4d0c371993b9283e {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    get finished() {
        // Support for new finished Promise and legacy thennable API
        return Promise.all(this.animations.map((animation)=>"finished" in animation ? animation.finished : animation));
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline, fallback) {
        const subscriptions = this.animations.map((animation)=>{
            if ((0, $hTZFh.supportsScrollTimeline)() && animation.attachTimeline) return animation.attachTimeline(timeline);
            else if (typeof fallback === "function") return fallback(animation);
        });
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    flatten() {
        this.runAll("flatten");
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}

});
parcelRegister("hTZFh", function(module, exports) {

$parcel$export(module.exports, "supportsScrollTimeline", function () { return $b622f222f9ede0c1$export$20d68f04f30763a5; });
parcelRequire("gxAX4");
var $9IjQW = parcelRequire("9IjQW");
const $b622f222f9ede0c1$export$20d68f04f30763a5 = (0, $9IjQW.memo)(()=>window.ScrollTimeline !== undefined);

});
parcelRegister("gxAX4", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return (parcelRequire("jQRuG")).invariant; });
$parcel$export(module.exports, "warning", function () { return (parcelRequire("jQRuG")).warning; });
$parcel$export(module.exports, "memo", function () { return (parcelRequire("9IjQW")).memo; });
$parcel$export(module.exports, "noop", function () { return (parcelRequire("j5fqa")).noop; });
$parcel$export(module.exports, "progress", function () { return (parcelRequire("2UGlP")).progress; });
$parcel$export(module.exports, "millisecondsToSeconds", function () { return (parcelRequire("eJ1nu")).millisecondsToSeconds; });
$parcel$export(module.exports, "secondsToMilliseconds", function () { return (parcelRequire("eJ1nu")).secondsToMilliseconds; });

var $jQRuG = parcelRequire("jQRuG");

var $9IjQW = parcelRequire("9IjQW");

var $j5fqa = parcelRequire("j5fqa");

var $2UGlP = parcelRequire("2UGlP");

var $eJ1nu = parcelRequire("eJ1nu");

});
parcelRegister("jQRuG", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $9054022d79f84234$export$491112666e282270; });
$parcel$export(module.exports, "invariant", function () { return $9054022d79f84234$export$f5708dca728d7177; });

var $j5fqa = parcelRequire("j5fqa");
let $9054022d79f84234$export$491112666e282270 = (0, $j5fqa.noop);
let $9054022d79f84234$export$f5708dca728d7177 = (0, $j5fqa.noop);
var $9054022d79f84234$var$check, $9054022d79f84234$var$message, $9054022d79f84234$var$check1, $9054022d79f84234$var$message1;

});
parcelRegister("j5fqa", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $f793445da91b0fb1$export$8793edee2d425525; });
/*#__NO_SIDE_EFFECTS__*/ const $f793445da91b0fb1$export$8793edee2d425525 = (any)=>any;

});


parcelRegister("9IjQW", function(module, exports) {

$parcel$export(module.exports, "memo", function () { return $57bf9765b71a2272$export$7c73462e0d25e514; });
/*#__NO_SIDE_EFFECTS__*/ function $57bf9765b71a2272$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}

});

parcelRegister("2UGlP", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $6cbbe4fa2c6b1b8d$export$504d7abb21fa8c9; });
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ const $6cbbe4fa2c6b1b8d$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});

parcelRegister("eJ1nu", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $7e3a2d75b5c7ae9f$export$fc3e7e8557f8c8c7; });
$parcel$export(module.exports, "millisecondsToSeconds", function () { return $7e3a2d75b5c7ae9f$export$f64c3bfbc58eec0f; });
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $7e3a2d75b5c7ae9f$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $7e3a2d75b5c7ae9f$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

});





parcelRegister("aPjDR", function(module, exports) {

$parcel$export(module.exports, "getValueTransition", function () { return $79bcc9d72f7a8380$export$7c1391340308742e; });
function $79bcc9d72f7a8380$export$7c1391340308742e(transition, key) {
    return transition ? transition[key] || transition["default"] || transition : undefined;
}

});

parcelRegister("fXjmT", function(module, exports) {

$parcel$export(module.exports, "maxGeneratorDuration", function () { return $3e0b62525d978887$export$f4ff70a5b4808fd8; });
$parcel$export(module.exports, "calcGeneratorDuration", function () { return $3e0b62525d978887$export$cbdd6b3d40ea54e2; });
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $3e0b62525d978887$export$f4ff70a5b4808fd8 = 20000;
function $3e0b62525d978887$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $3e0b62525d978887$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $3e0b62525d978887$export$f4ff70a5b4808fd8 ? Infinity : duration;
}

});

parcelRegister("h7DmV", function(module, exports) {

$parcel$export(module.exports, "createGeneratorEasing", function () { return $23917d6f7987cc32$export$7f1511d09ee75a99; });
parcelRequire("gxAX4");
var $eJ1nu = parcelRequire("eJ1nu");

var $fXjmT = parcelRequire("fXjmT");
/**
 * Create a progress => progress easing function from a generator.
 */ function $23917d6f7987cc32$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $fXjmT.calcGeneratorDuration)(generator), (0, $fXjmT.maxGeneratorDuration));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $eJ1nu.millisecondsToSeconds)(duration)
    };
}

});

parcelRegister("ezUzd", function(module, exports) {

$parcel$export(module.exports, "isGenerator", function () { return $234882abe29e2c6f$export$6ab7812f1bac68be; });
function $234882abe29e2c6f$export$6ab7812f1bac68be(type) {
    return typeof type === "function";
}

});

parcelRegister("2WRYS", function(module, exports) {

$parcel$export(module.exports, "NativeAnimationControls", function () { return $952f951970834096$export$a361fbe706f8c9b; });
parcelRequire("gxAX4");
var $eJ1nu = parcelRequire("eJ1nu");
var $j5fqa = parcelRequire("j5fqa");

var $1wGNu = parcelRequire("1wGNu");
class $952f951970834096$export$a361fbe706f8c9b {
    constructor(animation){
        this.animation = animation;
    }
    get duration() {
        var _a, _b, _c;
        const durationInMs = ((_b = (_a = this.animation) === null || _a === void 0 ? void 0 : _a.effect) === null || _b === void 0 ? void 0 : _b.getComputedTiming().duration) || ((_c = this.options) === null || _c === void 0 ? void 0 : _c.duration) || 300;
        return (0, $eJ1nu.millisecondsToSeconds)(Number(durationInMs));
    }
    get time() {
        var _a;
        if (this.animation) return (0, $eJ1nu.millisecondsToSeconds)(((_a = this.animation) === null || _a === void 0 ? void 0 : _a.currentTime) || 0);
        return 0;
    }
    set time(newTime) {
        if (this.animation) this.animation.currentTime = (0, $eJ1nu.secondsToMilliseconds)(newTime);
    }
    get speed() {
        return this.animation ? this.animation.playbackRate : 1;
    }
    set speed(newSpeed) {
        if (this.animation) this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.animation ? this.animation.playState : "finished";
    }
    get startTime() {
        return this.animation ? this.animation.startTime : null;
    }
    get finished() {
        return this.animation ? this.animation.finished : Promise.resolve();
    }
    play() {
        this.animation && this.animation.play();
    }
    pause() {
        this.animation && this.animation.pause();
    }
    stop() {
        if (!this.animation || this.state === "idle" || this.state === "finished") return;
        if (this.animation.commitStyles) this.animation.commitStyles();
        this.cancel();
    }
    flatten() {
        var _a;
        if (!this.animation) return;
        (_a = this.animation.effect) === null || _a === void 0 || _a.updateTiming({
            easing: "linear"
        });
    }
    attachTimeline(timeline) {
        if (this.animation) (0, $1wGNu.attachTimeline)(this.animation, timeline);
        return 0, $j5fqa.noop;
    }
    complete() {
        this.animation && this.animation.finish();
    }
    cancel() {
        try {
            this.animation && this.animation.cancel();
        } catch (e) {}
    }
}

});
parcelRegister("1wGNu", function(module, exports) {

$parcel$export(module.exports, "attachTimeline", function () { return $5c23d8f5fe27319d$export$5bd0fcbc73622e13; });
function $5c23d8f5fe27319d$export$5bd0fcbc73622e13(animation, timeline) {
    animation.timeline = timeline;
    animation.onfinish = null;
}

});


parcelRegister("5OhEy", function(module, exports) {

$parcel$export(module.exports, "isWaapiSupportedEasing", function () { return $16307950a9dbbe43$export$fcdd8f3f2160beda; });
$parcel$export(module.exports, "mapEasingToNativeEasing", function () { return $16307950a9dbbe43$export$916ea73bcd3a6030; });

var $j8D8r = parcelRequire("j8D8r");

var $2GgX8 = parcelRequire("2GgX8");

var $2bfsp = parcelRequire("2bfsp");
function $16307950a9dbbe43$export$fcdd8f3f2160beda(easing) {
    return Boolean(typeof easing === "function" && (0, $2GgX8.supportsLinearEasing)() || !easing || typeof easing === "string" && (easing in $16307950a9dbbe43$export$2cf569f5e2221176 || (0, $2GgX8.supportsLinearEasing)()) || (0, $j8D8r.isBezierDefinition)(easing) || Array.isArray(easing) && easing.every($16307950a9dbbe43$export$fcdd8f3f2160beda));
}
const $16307950a9dbbe43$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $16307950a9dbbe43$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ $16307950a9dbbe43$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ $16307950a9dbbe43$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ $16307950a9dbbe43$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ $16307950a9dbbe43$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $16307950a9dbbe43$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function" && (0, $2GgX8.supportsLinearEasing)()) return (0, $2bfsp.generateLinearEasing)(easing, duration);
    else if ((0, $j8D8r.isBezierDefinition)(easing)) return $16307950a9dbbe43$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$16307950a9dbbe43$export$916ea73bcd3a6030(segmentEasing, duration) || $16307950a9dbbe43$export$2cf569f5e2221176.easeOut);
    else return $16307950a9dbbe43$export$2cf569f5e2221176[easing];
}

});
parcelRegister("j8D8r", function(module, exports) {

$parcel$export(module.exports, "isBezierDefinition", function () { return $79c5216bf2face1b$export$ff43f99925d7366b; });
const $79c5216bf2face1b$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";

});

parcelRegister("2GgX8", function(module, exports) {

$parcel$export(module.exports, "supportsLinearEasing", function () { return $be7f8131649485a5$export$866c1d07a1ac2ab; });

var $8wU8B = parcelRequire("8wU8B");
const $be7f8131649485a5$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $8wU8B.memoSupports)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");

});
parcelRegister("8wU8B", function(module, exports) {

$parcel$export(module.exports, "memoSupports", function () { return $43d80f07c5319551$export$1964673d5ec13c3a; });
parcelRequire("gxAX4");
var $9IjQW = parcelRequire("9IjQW");

var $f4iSK = parcelRequire("f4iSK");
function $43d80f07c5319551$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $9IjQW.memo)(callback);
    return ()=>{
        var _a;
        return (_a = (0, $f4iSK.supportsFlags)[supportsFlag]) !== null && _a !== void 0 ? _a : memoized();
    };
}

});
parcelRegister("f4iSK", function(module, exports) {

$parcel$export(module.exports, "supportsFlags", function () { return $f56b95a1974d136b$export$e3ad02c335474dee; });
/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $f56b95a1974d136b$export$e3ad02c335474dee = {
    linearEasing: undefined
};

});



parcelRegister("2bfsp", function(module, exports) {

$parcel$export(module.exports, "generateLinearEasing", function () { return $a62670fc9cfdd28a$export$66d3851e2b1ec912; });
parcelRequire("gxAX4");
var $2UGlP = parcelRequire("2UGlP");
const $a62670fc9cfdd28a$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += easing((0, $2UGlP.progress)(0, numPoints - 1, i)) + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};

});


parcelRegister("jicDV", function(module, exports) {

$parcel$export(module.exports, "hover", function () { return $47ca448b7925137b$export$3f60957f5dbf3876; });

var $3IIHs = parcelRequire("3IIHs");

var $cp2AG = parcelRequire("cp2AG");
/**
 * Filter out events that are not pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $47ca448b7925137b$var$filterEvents(callback) {
    return (event)=>{
        if (event.pointerType === "touch" || (0, $3IIHs.isDragActive)()) return;
        callback(event);
    };
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $47ca448b7925137b$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $cp2AG.setupGesture)(elementOrSelector, options);
    const onPointerEnter = $47ca448b7925137b$var$filterEvents((enterEvent)=>{
        const { target: target } = enterEvent;
        const onHoverEnd = onHoverStart(enterEvent);
        if (typeof onHoverEnd !== "function" || !target) return;
        const onPointerLeave = $47ca448b7925137b$var$filterEvents((leaveEvent)=>{
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        });
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    });
    elements.forEach((element)=>{
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}

});
parcelRegister("3IIHs", function(module, exports) {

$parcel$export(module.exports, "isDragging", function () { return $0619c6f3d80bbc2a$export$9e9bc3c487fccc00; });
$parcel$export(module.exports, "isDragActive", function () { return $0619c6f3d80bbc2a$export$1b3dd616664938e4; });
const $0619c6f3d80bbc2a$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $0619c6f3d80bbc2a$export$1b3dd616664938e4() {
    return $0619c6f3d80bbc2a$export$9e9bc3c487fccc00.x || $0619c6f3d80bbc2a$export$9e9bc3c487fccc00.y;
}

});

parcelRegister("cp2AG", function(module, exports) {

$parcel$export(module.exports, "setupGesture", function () { return $6724612b355cbea4$export$edc0ace9d5e7e842; });

var $caYDN = parcelRequire("caYDN");
function $6724612b355cbea4$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $caYDN.resolveElements)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}

});
parcelRegister("caYDN", function(module, exports) {

$parcel$export(module.exports, "resolveElements", function () { return $cf525f7a752dba92$export$90ceba2564a894f8; });
function $cf525f7a752dba92$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    var _a;
    if (elementOrSelector instanceof Element) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) // TODO: Refactor to utils package
        // invariant(
        //     Boolean(scope.current),
        //     "Scope provided, but no element detected."
        // )
        root = scope.current;
        const elements = (_a = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _a !== void 0 ? _a : root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}

});



parcelRegister("aMjVo", function(module, exports) {

$parcel$export(module.exports, "press", function () { return $6517aace6ba045ac$export$dbe9198142dace0c; });

var $3IIHs = parcelRequire("3IIHs");

var $5bq44 = parcelRequire("5bq44");

var $hclYu = parcelRequire("hclYu");

var $cp2AG = parcelRequire("cp2AG");

var $jKGN9 = parcelRequire("jKGN9");

var $64RLV = parcelRequire("64RLV");

var $jyiP2 = parcelRequire("jyiP2");
/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $6517aace6ba045ac$var$isValidPressEvent(event) {
    return (0, $hclYu.isPrimaryPointer)(event) && !(0, $3IIHs.isDragActive)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $6517aace6ba045ac$export$dbe9198142dace0c(elementOrSelector, onPressStart, options = {}) {
    const [elements, eventOptions, cancelEvents] = (0, $cp2AG.setupGesture)(elementOrSelector, options);
    const startPress = (startEvent)=>{
        const element = startEvent.currentTarget;
        if (!$6517aace6ba045ac$var$isValidPressEvent(startEvent) || (0, $jyiP2.isPressing).has(element)) return;
        (0, $jyiP2.isPressing).add(element);
        const onPressEnd = onPressStart(startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if (!$6517aace6ba045ac$var$isValidPressEvent(endEvent) || !(0, $jyiP2.isPressing).has(element)) return;
            (0, $jyiP2.isPressing).delete(element);
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, options.useGlobalTarget || (0, $5bq44.isNodeOrChild)(element, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    elements.forEach((element)=>{
        if (!(0, $jKGN9.isElementKeyboardAccessible)(element) && element.getAttribute("tabindex") === null) element.tabIndex = 0;
        const target = options.useGlobalTarget ? window : element;
        target.addEventListener("pointerdown", startPress, eventOptions);
        element.addEventListener("focus", (event)=>(0, $64RLV.enableKeyboardPress)(event, eventOptions), eventOptions);
    });
    return cancelEvents;
}

});
parcelRegister("5bq44", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", function () { return $ad66739ad3f890ac$export$e841ada32ff745b; });
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $ad66739ad3f890ac$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $ad66739ad3f890ac$export$e841ada32ff745b(parent, child.parentElement);
};

});

parcelRegister("hclYu", function(module, exports) {

$parcel$export(module.exports, "isPrimaryPointer", function () { return $f42f1e44495328ec$export$a4cf9c8a4b063a6e; });
const $f42f1e44495328ec$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};

});

parcelRegister("jKGN9", function(module, exports) {

$parcel$export(module.exports, "isElementKeyboardAccessible", function () { return $d55244428652f234$export$5f6976e2f961e8b7; });
const $d55244428652f234$var$focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function $d55244428652f234$export$5f6976e2f961e8b7(element) {
    return $d55244428652f234$var$focusableElements.has(element.tagName) || element.tabIndex !== -1;
}

});

parcelRegister("64RLV", function(module, exports) {

$parcel$export(module.exports, "enableKeyboardPress", function () { return $0732ced746dfa70f$export$4b5790288fe12a79; });

var $jyiP2 = parcelRequire("jyiP2");
/**
 * Filter out events that are not "Enter" keys.
 */ function $0732ced746dfa70f$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $0732ced746dfa70f$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $0732ced746dfa70f$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $0732ced746dfa70f$var$filterEvents(()=>{
        if ((0, $jyiP2.isPressing).has(element)) return;
        $0732ced746dfa70f$var$firePointerEvent(element, "down");
        const handleKeyup = $0732ced746dfa70f$var$filterEvents(()=>{
            $0732ced746dfa70f$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$0732ced746dfa70f$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};

});
parcelRegister("jyiP2", function(module, exports) {

$parcel$export(module.exports, "isPressing", function () { return $09d3f0db758634dc$export$7987404a4e35b84b; });
const $09d3f0db758634dc$export$7987404a4e35b84b = new WeakSet();

});



parcelRegister("dgksD", function(module, exports) {
parcelRequire("gxAX4");
var $j5fqa = parcelRequire("j5fqa");

var $fRa7p = parcelRequire("fRa7p");
/**
 * TODO:
 * - Create view transition on next tick
 * - Replace animations with Motion animations
 * - Return GroupAnimation on next tick
 */ class $b1503feffc89868c$export$a25c8c3ef5e625d7 {
    constructor(update, options = {}){
        this.currentTarget = "root";
        this.targets = new Map();
        this.notifyReady = (0, $j5fqa.noop);
        this.readyPromise = new Promise((resolve)=>{
            this.notifyReady = resolve;
        });
        queueMicrotask(()=>{
            (0, $fRa7p.startViewAnimation)(update, options, this.targets).then((animation)=>this.notifyReady(animation));
        });
    }
    get(selector) {
        this.currentTarget = selector;
        return this;
    }
    layout(keyframes, options) {
        this.updateTarget("layout", keyframes, options);
        return this;
    }
    new(keyframes, options) {
        this.updateTarget("new", keyframes, options);
        return this;
    }
    old(keyframes, options) {
        this.updateTarget("old", keyframes, options);
        return this;
    }
    enter(keyframes, options) {
        this.updateTarget("enter", keyframes, options);
        return this;
    }
    exit(keyframes, options) {
        this.updateTarget("exit", keyframes, options);
        return this;
    }
    crossfade(options) {
        this.updateTarget("enter", {
            opacity: 1
        }, options);
        this.updateTarget("exit", {
            opacity: 0
        }, options);
        return this;
    }
    updateTarget(target, keyframes, options = {}) {
        const { currentTarget: currentTarget, targets: targets } = this;
        if (!targets.has(currentTarget)) targets.set(currentTarget, {});
        const targetData = targets.get(currentTarget);
        targetData[target] = {
            keyframes: keyframes,
            options: options
        };
    }
    then(resolve, reject) {
        return this.readyPromise.then(resolve, reject);
    }
}
function $b1503feffc89868c$export$c4ddc81c7b2c8d7a(update, defaultOptions = {}) {
    return new $b1503feffc89868c$export$a25c8c3ef5e625d7(update, defaultOptions);
}

});
parcelRegister("fRa7p", function(module, exports) {

$parcel$export(module.exports, "startViewAnimation", function () { return $23a9f59f99e2bcd6$export$43cd2edcbb51216c; });
parcelRequire("gxAX4");
var $eJ1nu = parcelRequire("eJ1nu");

var $hTtg7 = parcelRequire("hTtg7");

var $aPjDR = parcelRequire("aPjDR");

var $2WRYS = parcelRequire("2WRYS");

var $1xm05 = parcelRequire("1xm05");

var $a6V7B = parcelRequire("a6V7B");

var $5OhEy = parcelRequire("5OhEy");

var $cioUM = parcelRequire("cioUM");

var $7WRGc = parcelRequire("7WRGc");

var $cAoAA = parcelRequire("cAoAA");

var $8zDYv = parcelRequire("8zDYv");

var $fVPjM = parcelRequire("fVPjM");
const $23a9f59f99e2bcd6$var$definitionNames = [
    "layout",
    "enter",
    "exit",
    "new",
    "old"
];
function $23a9f59f99e2bcd6$export$43cd2edcbb51216c(update, defaultOptions, targets) {
    if (!document.startViewTransition) return new Promise(async (resolve)=>{
        await update();
        resolve(new (0, $hTtg7.BaseGroupPlaybackControls)([]));
    });
    // TODO: Go over existing targets and ensure they all have ids
    /**
     * If we don't have any animations defined for the root target,
     * remove it from being captured.
     */ if (!(0, $fVPjM.hasTarget)("root", targets)) (0, $7WRGc.css).set(":root", {
        "view-transition-name": "none"
    });
    /**
     * Set the timing curve to linear for all view transition layers.
     * This gets baked into the keyframes, which can't be changed
     * without breaking the generated animation.
     *
     * This allows us to set easing via updateTiming - which can be changed.
     */ (0, $7WRGc.css).set("::view-transition-group(*), ::view-transition-old(*), ::view-transition-new(*)", {
        "animation-timing-function": "linear !important"
    });
    (0, $7WRGc.css).commit(); // Write
    const transition = document.startViewTransition(async ()=>{
        await update();
    // TODO: Go over new targets and ensure they all have ids
    });
    transition.finished.finally(()=>{
        (0, $7WRGc.css).remove(); // Write
    });
    return new Promise((resolve)=>{
        transition.ready.then(()=>{
            var _a;
            const generatedViewAnimations = (0, $8zDYv.getViewAnimations)();
            const animations = [];
            /**
             * Create animations for our definitions
             */ targets.forEach((definition, target)=>{
                // TODO: If target is not "root", resolve elements
                // and iterate over each
                for (const key of $23a9f59f99e2bcd6$var$definitionNames){
                    if (!definition[key]) continue;
                    const { keyframes: keyframes, options: options } = definition[key];
                    for (let [valueName, valueKeyframes] of Object.entries(keyframes)){
                        if (!valueKeyframes) continue;
                        const valueOptions = {
                            ...(0, $aPjDR.getValueTransition)(defaultOptions, valueName),
                            ...(0, $aPjDR.getValueTransition)(options, valueName)
                        };
                        const type = (0, $cioUM.chooseLayerType)(key);
                        /**
                         * If this is an opacity animation, and keyframes are not an array,
                         * we need to convert them into an array and set an initial value.
                         */ if (valueName === "opacity" && !Array.isArray(valueKeyframes)) {
                            const initialValue = type === "new" ? 0 : 1;
                            valueKeyframes = [
                                initialValue,
                                valueKeyframes
                            ];
                        }
                        /**
                         * Resolve stagger function if provided.
                         */ if (typeof valueOptions.delay === "function") valueOptions.delay = valueOptions.delay(0, 1);
                        const animation = new (0, $1xm05.PseudoAnimation)(document.documentElement, `::view-transition-${type}(${target})`, valueName, valueKeyframes, valueOptions);
                        animations.push(animation);
                    }
                }
            });
            /**
             * Handle browser generated animations
             */ for (const animation of generatedViewAnimations){
                if (animation.playState === "finished") continue;
                const { effect: effect } = animation;
                if (!effect || !(effect instanceof KeyframeEffect)) continue;
                const { pseudoElement: pseudoElement } = effect;
                if (!pseudoElement) continue;
                const name = (0, $cAoAA.getLayerName)(pseudoElement);
                if (!name) continue;
                const targetDefinition = targets.get(name.layer);
                if (!targetDefinition) {
                    /**
                     * If transition name is group then update the timing of the animation
                     * whereas if it's old or new then we could possibly replace it using
                     * the above method.
                     */ const transitionName = name.type === "group" ? "layout" : "";
                    const animationTransition = {
                        ...(0, $aPjDR.getValueTransition)(defaultOptions, transitionName)
                    };
                    (0, $a6V7B.applyGeneratorOptions)(animationTransition);
                    const easing = (0, $5OhEy.mapEasingToNativeEasing)(animationTransition.ease, animationTransition.duration);
                    effect.updateTiming({
                        delay: (0, $eJ1nu.secondsToMilliseconds)((_a = animationTransition.delay) !== null && _a !== void 0 ? _a : 0),
                        duration: animationTransition.duration,
                        easing: easing
                    });
                    animations.push(new (0, $2WRYS.NativeAnimationControls)(animation));
                } else if ($23a9f59f99e2bcd6$var$hasOpacity(targetDefinition, "enter") && $23a9f59f99e2bcd6$var$hasOpacity(targetDefinition, "exit") && effect.getKeyframes().some((keyframe)=>keyframe.mixBlendMode)) animations.push(new (0, $2WRYS.NativeAnimationControls)(animation));
                else animation.cancel();
            }
            resolve(new (0, $hTtg7.BaseGroupPlaybackControls)(animations));
        });
    });
}
function $23a9f59f99e2bcd6$var$hasOpacity(target, key) {
    var _a;
    return (_a = target === null || target === void 0 ? void 0 : target[key]) === null || _a === void 0 ? void 0 : _a.keyframes.opacity;
}

});
parcelRegister("1xm05", function(module, exports) {

$parcel$export(module.exports, "PseudoAnimation", function () { return $d5c0bbbef22d30e5$export$bd39eb4d1b05262c; });

var $2WRYS = parcelRequire("2WRYS");

var $a6V7B = parcelRequire("a6V7B");
class $d5c0bbbef22d30e5$export$bd39eb4d1b05262c extends (0, $2WRYS.NativeAnimationControls) {
    constructor(target, pseudoElement, valueName, keyframes, options){
        const animationOptions = (0, $a6V7B.convertMotionOptionsToNative)(valueName, keyframes, options);
        const animation = target.animate(animationOptions.keyframes, {
            pseudoElement: pseudoElement,
            ...animationOptions.options
        });
        super(animation);
    }
}

});
parcelRegister("a6V7B", function(module, exports) {

$parcel$export(module.exports, "applyGeneratorOptions", function () { return $3e26b0e5f05c03ca$export$a31269144d66b4a; });
$parcel$export(module.exports, "convertMotionOptionsToNative", function () { return $3e26b0e5f05c03ca$export$f837a3b7321adfa5; });
parcelRequire("gxAX4");
var $eJ1nu = parcelRequire("eJ1nu");

var $2GgX8 = parcelRequire("2GgX8");

var $h7DmV = parcelRequire("h7DmV");

var $ezUzd = parcelRequire("ezUzd");

var $5OhEy = parcelRequire("5OhEy");
const $3e26b0e5f05c03ca$var$defaultEasing = "easeOut";
function $3e26b0e5f05c03ca$export$a31269144d66b4a(options) {
    var _a;
    if ((0, $ezUzd.isGenerator)(options.type)) {
        const generatorOptions = (0, $h7DmV.createGeneratorEasing)(options, 100, options.type);
        options.ease = (0, $2GgX8.supportsLinearEasing)() ? generatorOptions.ease : $3e26b0e5f05c03ca$var$defaultEasing;
        options.duration = (0, $eJ1nu.secondsToMilliseconds)(generatorOptions.duration);
        options.type = "keyframes";
    } else {
        options.duration = (0, $eJ1nu.secondsToMilliseconds)((_a = options.duration) !== null && _a !== void 0 ? _a : 0.3);
        options.ease = options.ease || $3e26b0e5f05c03ca$var$defaultEasing;
    }
}
// TODO: Reuse for NativeAnimation
function $3e26b0e5f05c03ca$export$f837a3b7321adfa5(valueName, keyframes, options) {
    var _a;
    const nativeKeyframes = {};
    const nativeOptions = {
        fill: "both",
        easing: "linear",
        composite: "replace"
    };
    nativeOptions.delay = (0, $eJ1nu.secondsToMilliseconds)((_a = options.delay) !== null && _a !== void 0 ? _a : 0);
    $3e26b0e5f05c03ca$export$a31269144d66b4a(options);
    nativeOptions.duration = options.duration;
    const { ease: ease, times: times } = options;
    if (times) nativeKeyframes.offset = times;
    nativeKeyframes[valueName] = keyframes;
    const easing = (0, $5OhEy.mapEasingToNativeEasing)(ease, options.duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) nativeKeyframes.easing = easing;
    else nativeOptions.easing = easing;
    return {
        keyframes: nativeKeyframes,
        options: nativeOptions
    };
}

});


parcelRegister("cioUM", function(module, exports) {

$parcel$export(module.exports, "chooseLayerType", function () { return $defb4452b0e76bff$export$f156731db478ee9e; });
function $defb4452b0e76bff$export$f156731db478ee9e(valueName) {
    if (valueName === "layout") return "group";
    if (valueName === "enter" || valueName === "new") return "new";
    if (valueName === "exit" || valueName === "old") return "old";
    return "group";
}

});

parcelRegister("7WRGc", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $1138ed992c713573$export$dbf350e5966cf602; });
let $1138ed992c713573$var$pendingRules = {};
let $1138ed992c713573$var$style = null;
const $1138ed992c713573$export$dbf350e5966cf602 = {
    set: (selector, values)=>{
        $1138ed992c713573$var$pendingRules[selector] = values;
    },
    commit: ()=>{
        if (!$1138ed992c713573$var$style) {
            $1138ed992c713573$var$style = document.createElement("style");
            $1138ed992c713573$var$style.id = "motion-view";
        }
        let cssText = "";
        for(const selector in $1138ed992c713573$var$pendingRules){
            const rule = $1138ed992c713573$var$pendingRules[selector];
            cssText += `${selector} {\n`;
            for (const [property, value] of Object.entries(rule))cssText += `  ${property}: ${value};\n`;
            cssText += "}\n";
        }
        $1138ed992c713573$var$style.textContent = cssText;
        document.head.appendChild($1138ed992c713573$var$style);
        $1138ed992c713573$var$pendingRules = {};
    },
    remove: ()=>{
        if ($1138ed992c713573$var$style && $1138ed992c713573$var$style.parentElement) $1138ed992c713573$var$style.parentElement.removeChild($1138ed992c713573$var$style);
    }
};

});

parcelRegister("cAoAA", function(module, exports) {

$parcel$export(module.exports, "getLayerName", function () { return $6aad56e09a072d35$export$318a4a45ce9f2d6a; });
function $6aad56e09a072d35$export$318a4a45ce9f2d6a(pseudoElement) {
    const match = pseudoElement.match(/::view-transition-(old|new|group|image-pair)\((.*?)\)/);
    if (!match) return null;
    return {
        layer: match[2],
        type: match[1]
    };
}

});

parcelRegister("8zDYv", function(module, exports) {

$parcel$export(module.exports, "getViewAnimations", function () { return $67dfd05a21787f69$export$8d6316dd934b3f3b; });
function $67dfd05a21787f69$var$filterViewAnimations(animation) {
    var _a;
    const { effect: effect } = animation;
    if (!effect) return false;
    return effect.target === document.documentElement && ((_a = effect.pseudoElement) === null || _a === void 0 ? void 0 : _a.startsWith("::view-transition"));
}
function $67dfd05a21787f69$export$8d6316dd934b3f3b() {
    return document.getAnimations().filter($67dfd05a21787f69$var$filterViewAnimations);
}

});

parcelRegister("fVPjM", function(module, exports) {

$parcel$export(module.exports, "hasTarget", function () { return $b45f4c17e852f368$export$cb29cf2b8e0a8ae1; });
function $b45f4c17e852f368$export$cb29cf2b8e0a8ae1(target, targets) {
    return targets.has(target) && Object.keys(targets.get(target)).length > 0;
}

});



parcelRegister("5pan6", function(module, exports) {

$parcel$export(module.exports, "setDragLock", function () { return $5c67173fe1cdda9b$export$64d8a3fd7eb621d5; });

var $3IIHs = parcelRequire("3IIHs");
function $5c67173fe1cdda9b$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $3IIHs.isDragging)[axis]) return null;
        else {
            (0, $3IIHs.isDragging)[axis] = true;
            return ()=>{
                (0, $3IIHs.isDragging)[axis] = false;
            };
        }
    } else {
        if ((0, $3IIHs.isDragging).x || (0, $3IIHs.isDragging).y) return null;
        else {
            (0, $3IIHs.isDragging).x = (0, $3IIHs.isDragging).y = true;
            return ()=>{
                (0, $3IIHs.isDragging).x = (0, $3IIHs.isDragging).y = false;
            };
        }
    }
}

});


parcelRegister("2TFvH", function(module, exports) {

$parcel$export(module.exports, "positionalKeys", function () { return $e1b0147582df701c$export$c66c0d5db2a205d; });

var $e3WlB = parcelRequire("e3WlB");
const $e1b0147582df701c$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $e3WlB.transformPropOrder)
]);

});
parcelRegister("e3WlB", function(module, exports) {

$parcel$export(module.exports, "transformPropOrder", function () { return $549390a2365d82ad$export$280dc01950909d86; });
$parcel$export(module.exports, "transformProps", function () { return $549390a2365d82ad$export$7b42a0094fb00b6e; });
/**
 * Generate a list of every possible transform key.
 */ const $549390a2365d82ad$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $549390a2365d82ad$export$7b42a0094fb00b6e = new Set($549390a2365d82ad$export$280dc01950909d86);

});


parcelRegister("e4w0T", function(module, exports) {

$parcel$export(module.exports, "setTarget", function () { return $1c788cb4c4e62dae$export$1f61c53461aff4a5; });

var $95tho = parcelRequire("95tho");

var $apeLX = parcelRequire("apeLX");

var $hTtrb = parcelRequire("hTtrb");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $1c788cb4c4e62dae$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $apeLX.motionValue)(value));
}
function $1c788cb4c4e62dae$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $hTtrb.resolveVariant)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $95tho.resolveFinalValueInKeyframes)(target[key]);
        $1c788cb4c4e62dae$var$setMotionValue(visualElement, key, value);
    }
}

});
parcelRegister("95tho", function(module, exports) {

$parcel$export(module.exports, "isCustomValue", function () { return $a4efeb98ebb59f63$export$2f308ad9864b3ac9; });
$parcel$export(module.exports, "resolveFinalValueInKeyframes", function () { return $a4efeb98ebb59f63$export$5485128c47bd48bb; });

var $95jQo = parcelRequire("95jQo");
const $a4efeb98ebb59f63$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $a4efeb98ebb59f63$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $95jQo.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
};

});

parcelRegister("apeLX", function(module, exports) {

$parcel$export(module.exports, "motionValue", function () { return $1f35b6d91a55df00$export$ce8bdc721e76545f; });

var $k83cl = parcelRequire("k83cl");

var $aQwlE = parcelRequire("aQwlE");

var $3LwX1 = parcelRequire("3LwX1");


var $5Orka = parcelRequire("5Orka");
/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $1f35b6d91a55df00$var$MAX_VELOCITY_DELTA = 30;
const $1f35b6d91a55df00$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $1f35b6d91a55df00$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $1f35b6d91a55df00$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.18.2";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $k83cl.time).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $k83cl.time).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $1f35b6d91a55df00$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $aQwlE.SubscriptionManager)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $5Orka.frame).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($1f35b6d91a55df00$export$67fcd818a264039d.current) $1f35b6d91a55df00$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $k83cl.time).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $1f35b6d91a55df00$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $1f35b6d91a55df00$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $3LwX1.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $1f35b6d91a55df00$export$ce8bdc721e76545f(init, options) {
    return new $1f35b6d91a55df00$export$8cea36d14ee64562(init, options);
}

});
parcelRegister("k83cl", function(module, exports) {

$parcel$export(module.exports, "time", function () { return $7b82e39241203fea$export$2da9be4cfdb689b1; });

var $ir9N4 = parcelRequire("ir9N4");

var $5Orka = parcelRequire("5Orka");
let $7b82e39241203fea$var$now;
function $7b82e39241203fea$var$clearTime() {
    $7b82e39241203fea$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $7b82e39241203fea$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($7b82e39241203fea$var$now === undefined) $7b82e39241203fea$export$2da9be4cfdb689b1.set((0, $5Orka.frameData).isProcessing || (0, $ir9N4.MotionGlobalConfig).useManualTiming ? (0, $5Orka.frameData).timestamp : performance.now());
        return $7b82e39241203fea$var$now;
    },
    set: (newTime)=>{
        $7b82e39241203fea$var$now = newTime;
        queueMicrotask($7b82e39241203fea$var$clearTime);
    }
};

});
parcelRegister("ir9N4", function(module, exports) {

$parcel$export(module.exports, "MotionGlobalConfig", function () { return $6c97fb08e8bf80da$export$dd826089e3c5e502; });
const $6c97fb08e8bf80da$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};

});

parcelRegister("5Orka", function(module, exports) {

$parcel$export(module.exports, "frame", function () { return $603e93f092b6b621$export$2cef06c20297c17d; });
$parcel$export(module.exports, "cancelFrame", function () { return $603e93f092b6b621$export$ec99c0ef4978dccb; });
$parcel$export(module.exports, "frameData", function () { return $603e93f092b6b621$export$fff89137e9e818ce; });
$parcel$export(module.exports, "frameSteps", function () { return $603e93f092b6b621$export$1811c3a7e3af92f0; });
parcelRequire("gxAX4");
var $j5fqa = parcelRequire("j5fqa");

var $bPjUa = parcelRequire("bPjUa");
const { schedule: $603e93f092b6b621$export$2cef06c20297c17d, cancel: $603e93f092b6b621$export$ec99c0ef4978dccb, state: $603e93f092b6b621$export$fff89137e9e818ce, steps: $603e93f092b6b621$export$1811c3a7e3af92f0 } = (0, $bPjUa.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $j5fqa.noop), true);

});
parcelRegister("bPjUa", function(module, exports) {

$parcel$export(module.exports, "createRenderBatcher", function () { return $f30a9b88da17ff88$export$510b0596a933801a; });

var $ir9N4 = parcelRequire("ir9N4");

var $isOzU = parcelRequire("isOzU");
const $f30a9b88da17ff88$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $f30a9b88da17ff88$var$maxElapsed = 40;
function $f30a9b88da17ff88$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $f30a9b88da17ff88$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $isOzU.createRenderStep)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $ir9N4.MotionGlobalConfig).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $f30a9b88da17ff88$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $f30a9b88da17ff88$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $f30a9b88da17ff88$export$71ecace0a033b35a.length; i++)steps[$f30a9b88da17ff88$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}

});
parcelRegister("isOzU", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", function () { return $3fd8a3058bf86887$export$b995e5e85f5c8289; });
function $3fd8a3058bf86887$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

});




parcelRegister("aQwlE", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", function () { return $b7794e5fa33ba27b$export$e7dff9482a5fd23c; });

var $8jGnO = parcelRequire("8jGnO");
class $b7794e5fa33ba27b$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $8jGnO.addUniqueItem)(this.subscriptions, handler);
        return ()=>(0, $8jGnO.removeItem)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

});
parcelRegister("8jGnO", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $3aec299667308c9d$export$20e507e47fae79fd; });
$parcel$export(module.exports, "removeItem", function () { return $3aec299667308c9d$export$fe2d9b4e03920b4c; });
function $3aec299667308c9d$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $3aec299667308c9d$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $3aec299667308c9d$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});


parcelRegister("3LwX1", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $7fe7ca71b081b98c$export$eab0632f7ad4f9d7; });
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $7fe7ca71b081b98c$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});



parcelRegister("28eMC", function(module, exports) {

$parcel$export(module.exports, "addValueToWillChange", function () { return $5b4bb665133ecfe1$export$3ac5aed310be0bee; });

var $1r6ag = parcelRequire("1r6ag");
function $5b4bb665133ecfe1$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $1r6ag.isWillChangeMotionValue)(willChange)) return willChange.add(key);
}

});
parcelRegister("1r6ag", function(module, exports) {

$parcel$export(module.exports, "isWillChangeMotionValue", function () { return $e3411dec1a22d65f$export$98397f3adbf6259f; });

var $dOcpx = parcelRequire("dOcpx");
function $e3411dec1a22d65f$export$98397f3adbf6259f(value) {
    return Boolean((0, $dOcpx.isMotionValue)(value) && value.add);
}

});
parcelRegister("dOcpx", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", function () { return $f01cb32a23599d00$export$605d60a2578142d3; });
const $f01cb32a23599d00$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);

});



parcelRegister("cBNAe", function(module, exports) {

$parcel$export(module.exports, "getOptimisedAppearId", function () { return $2d1ad83aae5a8487$export$5f8d21e84d1d84fc; });

var $3eWnz = parcelRequire("3eWnz");
function $2d1ad83aae5a8487$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $3eWnz.optimizedAppearDataAttribute];
}

});
parcelRegister("3eWnz", function(module, exports) {

$parcel$export(module.exports, "optimizedAppearDataAttribute", function () { return $ae6c1892adb6618d$export$8592e1c077c890a6; });

var $dn8nQ = parcelRequire("dn8nQ");
const $ae6c1892adb6618d$export$ed7b8fa9dbf0105d = "framerAppearId";
const $ae6c1892adb6618d$export$8592e1c077c890a6 = "data-" + (0, $dn8nQ.camelToDash)($ae6c1892adb6618d$export$ed7b8fa9dbf0105d);

});
parcelRegister("dn8nQ", function(module, exports) {

$parcel$export(module.exports, "camelToDash", function () { return $6bfb26310d25ca13$export$9fd24a634729c672; });
/**
 * Convert camelCase to dash-case properties.
 */ const $6bfb26310d25ca13$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();

});



parcelRegister("6LTw8", function(module, exports) {

$parcel$export(module.exports, "animateMotionValue", function () { return $d62f370bf70a1cea$export$90b3dfc33ff3548; });
parcelRequire("7Ow0h");
var $aPjDR = parcelRequire("aPjDR");
var $35dO7 = parcelRequire("35dO7");
parcelRequire("gxAX4");
var $eJ1nu = parcelRequire("eJ1nu");

var $5Orka = parcelRequire("5Orka");

var $ir9N4 = parcelRequire("ir9N4");

var $bqq26 = parcelRequire("bqq26");

var $hH1jR = parcelRequire("hH1jR");

var $kifNe = parcelRequire("kifNe");

var $jVNB3 = parcelRequire("jVNB3");

var $h42YW = parcelRequire("h42YW");

var $a0cfS = parcelRequire("a0cfS");
const $d62f370bf70a1cea$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $aPjDR.getValueTransition)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $eJ1nu.secondsToMilliseconds)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $a0cfS.isTransitionDefined)(valueTransition)) options = {
            ...options,
            ...(0, $h42YW.getDefaultTransition)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $eJ1nu.secondsToMilliseconds)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $eJ1nu.secondsToMilliseconds)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $bqq26.instantAnimationState).current || (0, $ir9N4.MotionGlobalConfig).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $jVNB3.getFinalKeyframe)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $5Orka.frame).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $35dO7.GroupPlaybackControls)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $hH1jR.AcceleratedAnimation).supports(options)) return new (0, $hH1jR.AcceleratedAnimation)(options);
        else return new (0, $kifNe.MainThreadAnimation)(options);
    };

});
parcelRegister("bqq26", function(module, exports) {

$parcel$export(module.exports, "instantAnimationState", function () { return $4e2518a3f6e5dadc$export$888a3d84909f9e3d; });
const $4e2518a3f6e5dadc$export$888a3d84909f9e3d = {
    current: false
};

});

parcelRegister("hH1jR", function(module, exports) {

$parcel$export(module.exports, "AcceleratedAnimation", function () { return $cb523a15991912d4$export$2a45abb4e6513325; });
parcelRequire("7Ow0h");
var $1wGNu = parcelRequire("1wGNu");
var $ezUzd = parcelRequire("ezUzd");
var $5OhEy = parcelRequire("5OhEy");
var $2GgX8 = parcelRequire("2GgX8");
parcelRequire("gxAX4");
var $eJ1nu = parcelRequire("eJ1nu");
var $j5fqa = parcelRequire("j5fqa");

var $iQDT2 = parcelRequire("iQDT2");

var $iWs3r = parcelRequire("iWs3r");

var $fYI2h = parcelRequire("fYI2h");

var $9KxvK = parcelRequire("9KxvK");

var $35Ltl = parcelRequire("35Ltl");

var $kifNe = parcelRequire("kifNe");

var $et7p6 = parcelRequire("et7p6");

var $iL4tV = parcelRequire("iL4tV");

var $jVNB3 = parcelRequire("jVNB3");

var $alOff = parcelRequire("alOff");
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $cb523a15991912d4$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $cb523a15991912d4$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $cb523a15991912d4$var$requiresPregeneratedKeyframes(options) {
    return (0, $ezUzd.isGenerator)(options.type) || options.type === "spring" || !(0, $5OhEy.isWaapiSupportedEasing)(options.ease);
}
function $cb523a15991912d4$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $kifNe.MainThreadAnimation)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $cb523a15991912d4$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $cb523a15991912d4$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $cb523a15991912d4$var$sampleDelta,
        ease: "linear"
    };
}
const $cb523a15991912d4$var$unsupportedEasingFunctions = {
    anticipate: $iQDT2.anticipate,
    backInOut: $iWs3r.backInOut,
    circInOut: $fYI2h.circInOut
};
function $cb523a15991912d4$var$isUnsupportedEase(key) {
    return key in $cb523a15991912d4$var$unsupportedEasingFunctions;
}
class $cb523a15991912d4$export$2a45abb4e6513325 extends (0, $35Ltl.BaseAnimation) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        this.resolver = new (0, $9KxvK.DOMKeyframesResolver)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name, startTime: startTime } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!motionValue.owner || !motionValue.owner.current) return false;
        /**
         * If the user has provided an easing function name that isn't supported
         * by WAAPI (like "anticipate"), we need to provide the corressponding
         * function. This will later get converted to a linear() easing function.
         */ if (typeof ease === "string" && (0, $2GgX8.supportsLinearEasing)() && $cb523a15991912d4$var$isUnsupportedEase(ease)) ease = $cb523a15991912d4$var$unsupportedEasingFunctions[ease];
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($cb523a15991912d4$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, element: element, ...options } = this.options;
            const pregeneratedAnimation = $cb523a15991912d4$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $iL4tV.startWaapiAnimation)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            (0, $1wGNu.attachTimeline)(animation, this.pendingTimeline);
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $jVNB3.getFinalKeyframe)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $eJ1nu.millisecondsToSeconds)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $eJ1nu.millisecondsToSeconds)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $eJ1nu.secondsToMilliseconds)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved: resolved } = this;
        if (!resolved) return null;
        const { animation: animation } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $j5fqa.noop;
            const { animation: animation } = resolved;
            (0, $1wGNu.attachTimeline)(animation, timeline);
        }
        return 0, $j5fqa.noop;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
            const sampleAnimation = new (0, $kifNe.MainThreadAnimation)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $eJ1nu.secondsToMilliseconds)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $cb523a15991912d4$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $cb523a15991912d4$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        if (!motionValue || !motionValue.owner || !(motionValue.owner.current instanceof HTMLElement)) return false;
        const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
        return (0, $alOff.supportsWaapi)() && name && (0, $et7p6.acceleratedValues).has(name) && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !onUpdate && !transformTemplate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}

});
parcelRegister("iQDT2", function(module, exports) {

$parcel$export(module.exports, "anticipate", function () { return $ac645e0ee4c59f09$export$6b0af63b873d419e; });

var $iWs3r = parcelRequire("iWs3r");
const $ac645e0ee4c59f09$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $iWs3r.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

});
parcelRegister("iWs3r", function(module, exports) {

$parcel$export(module.exports, "backOut", function () { return $e05fec5d88f71a3f$export$77edfce482316a60; });
$parcel$export(module.exports, "backIn", function () { return $e05fec5d88f71a3f$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backInOut", function () { return $e05fec5d88f71a3f$export$ddc5fd596f6c71b2; });

var $5LCCJ = parcelRequire("5LCCJ");

var $1WdAU = parcelRequire("1WdAU");

var $h2Bzn = parcelRequire("h2Bzn");
const $e05fec5d88f71a3f$export$77edfce482316a60 = /*@__PURE__*/ (0, $5LCCJ.cubicBezier)(0.33, 1.53, 0.69, 0.99);
const $e05fec5d88f71a3f$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $h2Bzn.reverseEasing)($e05fec5d88f71a3f$export$77edfce482316a60);
const $e05fec5d88f71a3f$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $1WdAU.mirrorEasing)($e05fec5d88f71a3f$export$b01116c84cdfe1a2);

});
parcelRegister("5LCCJ", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $d8166a071178712e$export$2c575fa1d20488bd; });
parcelRequire("gxAX4");
var $j5fqa = parcelRequire("j5fqa");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $d8166a071178712e$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $d8166a071178712e$var$subdivisionPrecision = 0.0000001;
const $d8166a071178712e$var$subdivisionMaxIterations = 12;
function $d8166a071178712e$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $d8166a071178712e$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $d8166a071178712e$var$subdivisionPrecision && ++i < $d8166a071178712e$var$subdivisionMaxIterations);
    return currentT;
}
function $d8166a071178712e$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $j5fqa.noop;
    const getTForX = (aX)=>$d8166a071178712e$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $d8166a071178712e$var$calcBezier(getTForX(t), mY1, mY2);
}

});

parcelRegister("1WdAU", function(module, exports) {

$parcel$export(module.exports, "mirrorEasing", function () { return $8177912303a94fe1$export$f946554fb8aeaf0d; });
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $8177912303a94fe1$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

});

parcelRegister("h2Bzn", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", function () { return $ab43bbe451fd3b84$export$2c07eeff45156d4d; });
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $ab43bbe451fd3b84$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);

});



parcelRegister("fYI2h", function(module, exports) {

$parcel$export(module.exports, "circIn", function () { return $8dd803f74b943778$export$e444123e42d03385; });
$parcel$export(module.exports, "circOut", function () { return $8dd803f74b943778$export$c8d67a19199d1a50; });
$parcel$export(module.exports, "circInOut", function () { return $8dd803f74b943778$export$30d3455eee55bed5; });

var $1WdAU = parcelRequire("1WdAU");

var $h2Bzn = parcelRequire("h2Bzn");
const $8dd803f74b943778$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $8dd803f74b943778$export$c8d67a19199d1a50 = (0, $h2Bzn.reverseEasing)($8dd803f74b943778$export$e444123e42d03385);
const $8dd803f74b943778$export$30d3455eee55bed5 = (0, $1WdAU.mirrorEasing)($8dd803f74b943778$export$e444123e42d03385);

});

parcelRegister("9KxvK", function(module, exports) {

$parcel$export(module.exports, "DOMKeyframesResolver", function () { return $ed06db9e234ccaaa$export$4983792d11b61017; });

var $9AVUX = parcelRequire("9AVUX");

var $2TFvH = parcelRequire("2TFvH");

var $aIkhT = parcelRequire("aIkhT");

var $l82xw = parcelRequire("l82xw");

var $lDm6I = parcelRequire("lDm6I");

var $iaXVW = parcelRequire("iaXVW");

var $gOhQZ = parcelRequire("gOhQZ");

var $eoRpa = parcelRequire("eoRpa");
class $ed06db9e234ccaaa$export$4983792d11b61017 extends (0, $l82xw.KeyframeResolver) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $iaXVW.isCSSVariableToken)(keyframe)) {
                    const resolved = (0, $lDm6I.getVariableValue)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $2TFvH.positionalKeys).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $eoRpa.findDimensionValueType)(origin);
        const targetType = (0, $eoRpa.findDimensionValueType)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $gOhQZ.isNumOrPxType)(originType) && (0, $gOhQZ.isNumOrPxType)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $9AVUX.isNone)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $aIkhT.makeNoneKeyframesAnimatable)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $gOhQZ.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $gOhQZ.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}

});
parcelRegister("9AVUX", function(module, exports) {

$parcel$export(module.exports, "isNone", function () { return $bd03e93ec5ce8a9d$export$e56af863d5645d5f; });

var $jLJum = parcelRequire("jLJum");
function $bd03e93ec5ce8a9d$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $jLJum.isZeroValueString)(value);
    else return true;
}

});
parcelRegister("jLJum", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", function () { return $7b5b940cba14f85a$export$ade84c85e44a6cb1; });
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $7b5b940cba14f85a$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);

});


parcelRegister("aIkhT", function(module, exports) {

$parcel$export(module.exports, "makeNoneKeyframesAnimatable", function () { return $7231fd65f227ee7e$export$8cc4958f8e540f37; });

var $3aPzZ = parcelRequire("3aPzZ");

var $2zwmu = parcelRequire("2zwmu");
/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $7231fd65f227ee7e$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $7231fd65f227ee7e$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$7231fd65f227ee7e$var$invalidTemplates.has(keyframe) && (0, $3aPzZ.analyseComplexValue)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $2zwmu.getAnimatableNone)(name, animatableTemplate);
}

});
parcelRegister("3aPzZ", function(module, exports) {

$parcel$export(module.exports, "analyseComplexValue", function () { return $36fd25abd5552359$export$b61fc7c44bf646d5; });
$parcel$export(module.exports, "complex", function () { return $36fd25abd5552359$export$83a0e34f1302825b; });

var $kew5R = parcelRequire("kew5R");

var $83urV = parcelRequire("83urV");

var $gRkXo = parcelRequire("gRkXo");

var $2xlhT = parcelRequire("2xlhT");
function $36fd25abd5552359$var$test(v) {
    var _a, _b;
    return isNaN(v) && typeof v === "string" && (((_a = v.match((0, $gRkXo.floatRegex))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $83urV.colorRegex))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $36fd25abd5552359$var$NUMBER_TOKEN = "number";
const $36fd25abd5552359$var$COLOR_TOKEN = "color";
const $36fd25abd5552359$var$VAR_TOKEN = "var";
const $36fd25abd5552359$var$VAR_FUNCTION_TOKEN = "var(";
const $36fd25abd5552359$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $36fd25abd5552359$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $36fd25abd5552359$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($36fd25abd5552359$var$complexRegex, (parsedValue)=>{
        if ((0, $kew5R.color).test(parsedValue)) {
            indexes.color.push(i);
            types.push($36fd25abd5552359$var$COLOR_TOKEN);
            values.push((0, $kew5R.color).parse(parsedValue));
        } else if (parsedValue.startsWith($36fd25abd5552359$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($36fd25abd5552359$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($36fd25abd5552359$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $36fd25abd5552359$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($36fd25abd5552359$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $36fd25abd5552359$var$parseComplexValue(v) {
    return $36fd25abd5552359$export$b61fc7c44bf646d5(v).values;
}
function $36fd25abd5552359$var$createTransformer(source) {
    const { split: split, types: types } = $36fd25abd5552359$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $36fd25abd5552359$var$NUMBER_TOKEN) output += (0, $2xlhT.sanitize)(v[i]);
                else if (type === $36fd25abd5552359$var$COLOR_TOKEN) output += (0, $kew5R.color).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $36fd25abd5552359$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $36fd25abd5552359$var$getAnimatableNone(v) {
    const parsed = $36fd25abd5552359$var$parseComplexValue(v);
    const transformer = $36fd25abd5552359$var$createTransformer(v);
    return transformer(parsed.map($36fd25abd5552359$var$convertNumbersToZero));
}
const $36fd25abd5552359$export$83a0e34f1302825b = {
    test: $36fd25abd5552359$var$test,
    parse: $36fd25abd5552359$var$parseComplexValue,
    createTransformer: $36fd25abd5552359$var$createTransformer,
    getAnimatableNone: $36fd25abd5552359$var$getAnimatableNone
};

});
parcelRegister("kew5R", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $05f7e56bffc5c51a$export$35e9368ef982300f; });

var $gsOWO = parcelRequire("gsOWO");

var $kTDRk = parcelRequire("kTDRk");

var $1fJUI = parcelRequire("1fJUI");
const $05f7e56bffc5c51a$export$35e9368ef982300f = {
    test: (v)=>(0, $1fJUI.rgba).test(v) || (0, $gsOWO.hex).test(v) || (0, $kTDRk.hsla).test(v),
    parse: (v)=>{
        if ((0, $1fJUI.rgba).test(v)) return (0, $1fJUI.rgba).parse(v);
        else if ((0, $kTDRk.hsla).test(v)) return (0, $kTDRk.hsla).parse(v);
        else return (0, $gsOWO.hex).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $1fJUI.rgba).transform(v) : (0, $kTDRk.hsla).transform(v);
    }
};

});
parcelRegister("gsOWO", function(module, exports) {

$parcel$export(module.exports, "hex", function () { return $875a90539a1f4fad$export$834dfc94dde4b3d8; });

var $1fJUI = parcelRequire("1fJUI");

var $30hKj = parcelRequire("30hKj");
function $875a90539a1f4fad$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $875a90539a1f4fad$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $30hKj.isColorString)("#"),
    parse: $875a90539a1f4fad$var$parseHex,
    transform: (0, $1fJUI.rgba).transform
};

});
parcelRegister("1fJUI", function(module, exports) {

$parcel$export(module.exports, "rgba", function () { return $79ae3d4c2a1c3bfe$export$4e46ac54fc82cf3b; });

var $j1IcX = parcelRequire("j1IcX");

var $79XDc = parcelRequire("79XDc");

var $2xlhT = parcelRequire("2xlhT");

var $30hKj = parcelRequire("30hKj");
const $79ae3d4c2a1c3bfe$var$clampRgbUnit = (v)=>(0, $j1IcX.clamp)(0, 255, v);
const $79ae3d4c2a1c3bfe$export$7a99c86b5b1f4c9e = {
    ...(0, $79XDc.number),
    transform: (v)=>Math.round($79ae3d4c2a1c3bfe$var$clampRgbUnit(v))
};
const $79ae3d4c2a1c3bfe$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $30hKj.isColorString)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $30hKj.splitColor)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $79ae3d4c2a1c3bfe$export$7a99c86b5b1f4c9e.transform(red) + ", " + $79ae3d4c2a1c3bfe$export$7a99c86b5b1f4c9e.transform(green) + ", " + $79ae3d4c2a1c3bfe$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $2xlhT.sanitize)((0, $79XDc.alpha).transform(alpha$1)) + ")"
};

});
parcelRegister("j1IcX", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $9eb4184c0f8960c6$export$7d15b64cf5a3a4c4; });
const $9eb4184c0f8960c6$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

});

parcelRegister("79XDc", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $cab3e38f9b708702$export$98e628dec113755e; });
$parcel$export(module.exports, "alpha", function () { return $cab3e38f9b708702$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "scale", function () { return $cab3e38f9b708702$export$dcdf75081b88279d; });

var $j1IcX = parcelRequire("j1IcX");
const $cab3e38f9b708702$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $cab3e38f9b708702$export$58f0f39f63f3cf42 = {
    ...$cab3e38f9b708702$export$98e628dec113755e,
    transform: (v)=>(0, $j1IcX.clamp)(0, 1, v)
};
const $cab3e38f9b708702$export$dcdf75081b88279d = {
    ...$cab3e38f9b708702$export$98e628dec113755e,
    default: 1
};

});

parcelRegister("2xlhT", function(module, exports) {

$parcel$export(module.exports, "sanitize", function () { return $055459bf92e5c164$export$83d2e9e3e4ee39ed; });
// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $055459bf92e5c164$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;

});

parcelRegister("30hKj", function(module, exports) {

$parcel$export(module.exports, "isColorString", function () { return $9f2a1c6f449d8924$export$2c8400d58aca05e; });
$parcel$export(module.exports, "splitColor", function () { return $9f2a1c6f449d8924$export$73d6f35be992df24; });

var $gRkXo = parcelRequire("gRkXo");

var $hCnRn = parcelRequire("hCnRn");

var $em9cj = parcelRequire("em9cj");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $9f2a1c6f449d8924$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $em9cj.singleColorRegex).test(v) && v.startsWith(type) || testProp && !(0, $hCnRn.isNullish)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $9f2a1c6f449d8924$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $gRkXo.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

});
parcelRegister("gRkXo", function(module, exports) {

$parcel$export(module.exports, "floatRegex", function () { return $afe003cd043f58f0$export$2444ca58c08448e4; });
const $afe003cd043f58f0$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;

});

parcelRegister("hCnRn", function(module, exports) {

$parcel$export(module.exports, "isNullish", function () { return $7998572ae94de1d8$export$b931b78cbb3caf86; });
function $7998572ae94de1d8$export$b931b78cbb3caf86(v) {
    return v == null;
}

});

parcelRegister("em9cj", function(module, exports) {

$parcel$export(module.exports, "singleColorRegex", function () { return $1704e13d709bd2be$export$ed808ff6ecd39e8d; });
const $1704e13d709bd2be$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;

});




parcelRegister("kTDRk", function(module, exports) {

$parcel$export(module.exports, "hsla", function () { return $e5636c16ec9e60a5$export$810b04175080204c; });

var $79XDc = parcelRequire("79XDc");

var $5arE3 = parcelRequire("5arE3");

var $2xlhT = parcelRequire("2xlhT");

var $30hKj = parcelRequire("30hKj");
const $e5636c16ec9e60a5$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $30hKj.isColorString)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $30hKj.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $5arE3.percent).transform((0, $2xlhT.sanitize)(saturation)) + ", " + (0, $5arE3.percent).transform((0, $2xlhT.sanitize)(lightness)) + ", " + (0, $2xlhT.sanitize)((0, $79XDc.alpha).transform(alpha$1)) + ")";
    }
};

});
parcelRegister("5arE3", function(module, exports) {

$parcel$export(module.exports, "degrees", function () { return $9ded5e443ee04e10$export$41fc368e1a942b97; });
$parcel$export(module.exports, "percent", function () { return $9ded5e443ee04e10$export$626336c2cd4b14de; });
$parcel$export(module.exports, "px", function () { return $9ded5e443ee04e10$export$91c0eda1d06bf008; });
$parcel$export(module.exports, "vh", function () { return $9ded5e443ee04e10$export$f91e8c45a95a32f2; });
$parcel$export(module.exports, "vw", function () { return $9ded5e443ee04e10$export$aed3d7b7d206c196; });
$parcel$export(module.exports, "progressPercentage", function () { return $9ded5e443ee04e10$export$44e2e1705876d7ed; });
const $9ded5e443ee04e10$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $9ded5e443ee04e10$export$41fc368e1a942b97 = /*@__PURE__*/ $9ded5e443ee04e10$var$createUnitType("deg");
const $9ded5e443ee04e10$export$626336c2cd4b14de = /*@__PURE__*/ $9ded5e443ee04e10$var$createUnitType("%");
const $9ded5e443ee04e10$export$91c0eda1d06bf008 = /*@__PURE__*/ $9ded5e443ee04e10$var$createUnitType("px");
const $9ded5e443ee04e10$export$f91e8c45a95a32f2 = /*@__PURE__*/ $9ded5e443ee04e10$var$createUnitType("vh");
const $9ded5e443ee04e10$export$aed3d7b7d206c196 = /*@__PURE__*/ $9ded5e443ee04e10$var$createUnitType("vw");
const $9ded5e443ee04e10$export$44e2e1705876d7ed = {
    ...$9ded5e443ee04e10$export$626336c2cd4b14de,
    parse: (v)=>$9ded5e443ee04e10$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$9ded5e443ee04e10$export$626336c2cd4b14de.transform(v * 100)
};

});



parcelRegister("83urV", function(module, exports) {

$parcel$export(module.exports, "colorRegex", function () { return $043e67c012798bfd$export$740b69c5fad25dba; });
const $043e67c012798bfd$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;

});


parcelRegister("2zwmu", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", function () { return $c697966517183b9e$export$cea0cedcb94873b5; });

var $3aPzZ = parcelRequire("3aPzZ");

var $hsPzP = parcelRequire("hsPzP");

var $dzOZ3 = parcelRequire("dzOZ3");
function $c697966517183b9e$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $dzOZ3.getDefaultValueType)(key);
    if (defaultValueType !== (0, $hsPzP.filter)) defaultValueType = (0, $3aPzZ.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

});
parcelRegister("hsPzP", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $6289fc2b047dca9d$export$3dea766d36a8935f; });

var $3aPzZ = parcelRequire("3aPzZ");

var $gRkXo = parcelRequire("gRkXo");
/**
 * Properties that should default to 1 or 100%
 */ const $6289fc2b047dca9d$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $6289fc2b047dca9d$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $gRkXo.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $6289fc2b047dca9d$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $6289fc2b047dca9d$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $6289fc2b047dca9d$export$3dea766d36a8935f = {
    ...(0, $3aPzZ.complex),
    getAnimatableNone: (v)=>{
        const functions = v.match($6289fc2b047dca9d$var$functionRegex);
        return functions ? functions.map($6289fc2b047dca9d$var$applyDefaultFilter).join(" ") : v;
    }
};

});

parcelRegister("dzOZ3", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", function () { return $35ed75aa2253175e$export$67d1babe0338d23b; });

var $kew5R = parcelRequire("kew5R");

var $hsPzP = parcelRequire("hsPzP");

var $g4KZe = parcelRequire("g4KZe");
/**
 * A map of default value types for common values
 */ const $35ed75aa2253175e$export$98cd7c72c5a731fb = {
    ...(0, $g4KZe.numberValueTypes),
    color: // Color props
    $kew5R.color,
    backgroundColor: (0, $kew5R.color),
    outlineColor: (0, $kew5R.color),
    fill: (0, $kew5R.color),
    stroke: (0, $kew5R.color),
    // Border props
    borderColor: (0, $kew5R.color),
    borderTopColor: (0, $kew5R.color),
    borderRightColor: (0, $kew5R.color),
    borderBottomColor: (0, $kew5R.color),
    borderLeftColor: (0, $kew5R.color),
    filter: $hsPzP.filter,
    WebkitFilter: (0, $hsPzP.filter)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $35ed75aa2253175e$export$67d1babe0338d23b = (key)=>$35ed75aa2253175e$export$98cd7c72c5a731fb[key];

});
parcelRegister("g4KZe", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", function () { return $2e3cf987305dcae0$export$eec14432cd1cb67b; });

var $79XDc = parcelRequire("79XDc");

var $5arE3 = parcelRequire("5arE3");

var $lTX2l = parcelRequire("lTX2l");

var $e5yK7 = parcelRequire("e5yK7");

var $d2SZB = parcelRequire("d2SZB");
const $2e3cf987305dcae0$export$eec14432cd1cb67b = {
    ...(0, $lTX2l.browserNumberValueTypes),
    ...(0, $e5yK7.transformValueTypes),
    zIndex: (0, $d2SZB.int),
    size: (0, $5arE3.px),
    // SVG
    fillOpacity: (0, $79XDc.alpha),
    strokeOpacity: (0, $79XDc.alpha),
    numOctaves: (0, $d2SZB.int)
};

});
parcelRegister("lTX2l", function(module, exports) {

$parcel$export(module.exports, "browserNumberValueTypes", function () { return $e50e8251d031c382$export$2fb74b0a4e7d7c4a; });

var $5arE3 = parcelRequire("5arE3");
const $e50e8251d031c382$export$2fb74b0a4e7d7c4a = {
    // Border props
    borderWidth: (0, $5arE3.px),
    borderTopWidth: (0, $5arE3.px),
    borderRightWidth: (0, $5arE3.px),
    borderBottomWidth: (0, $5arE3.px),
    borderLeftWidth: (0, $5arE3.px),
    borderRadius: (0, $5arE3.px),
    radius: (0, $5arE3.px),
    borderTopLeftRadius: (0, $5arE3.px),
    borderTopRightRadius: (0, $5arE3.px),
    borderBottomRightRadius: (0, $5arE3.px),
    borderBottomLeftRadius: (0, $5arE3.px),
    // Positioning props
    width: (0, $5arE3.px),
    maxWidth: (0, $5arE3.px),
    height: (0, $5arE3.px),
    maxHeight: (0, $5arE3.px),
    top: (0, $5arE3.px),
    right: (0, $5arE3.px),
    bottom: (0, $5arE3.px),
    left: (0, $5arE3.px),
    // Spacing props
    padding: (0, $5arE3.px),
    paddingTop: (0, $5arE3.px),
    paddingRight: (0, $5arE3.px),
    paddingBottom: (0, $5arE3.px),
    paddingLeft: (0, $5arE3.px),
    margin: (0, $5arE3.px),
    marginTop: (0, $5arE3.px),
    marginRight: (0, $5arE3.px),
    marginBottom: (0, $5arE3.px),
    marginLeft: (0, $5arE3.px),
    // Misc
    backgroundPositionX: (0, $5arE3.px),
    backgroundPositionY: (0, $5arE3.px)
};

});

parcelRegister("e5yK7", function(module, exports) {

$parcel$export(module.exports, "transformValueTypes", function () { return $f18418e2f2e6593b$export$f2e4285fee37e26; });

var $79XDc = parcelRequire("79XDc");

var $5arE3 = parcelRequire("5arE3");
const $f18418e2f2e6593b$export$f2e4285fee37e26 = {
    rotate: (0, $5arE3.degrees),
    rotateX: (0, $5arE3.degrees),
    rotateY: (0, $5arE3.degrees),
    rotateZ: (0, $5arE3.degrees),
    scale: $79XDc.scale,
    scaleX: (0, $79XDc.scale),
    scaleY: (0, $79XDc.scale),
    scaleZ: (0, $79XDc.scale),
    skew: (0, $5arE3.degrees),
    skewX: (0, $5arE3.degrees),
    skewY: (0, $5arE3.degrees),
    distance: (0, $5arE3.px),
    translateX: (0, $5arE3.px),
    translateY: (0, $5arE3.px),
    translateZ: (0, $5arE3.px),
    x: (0, $5arE3.px),
    y: (0, $5arE3.px),
    z: (0, $5arE3.px),
    perspective: (0, $5arE3.px),
    transformPerspective: (0, $5arE3.px),
    opacity: (0, $79XDc.alpha),
    originX: (0, $5arE3.progressPercentage),
    originY: (0, $5arE3.progressPercentage),
    originZ: (0, $5arE3.px)
};

});

parcelRegister("d2SZB", function(module, exports) {

$parcel$export(module.exports, "int", function () { return $35124d56630e77b1$export$7d260a2a5f8bc19e; });

var $79XDc = parcelRequire("79XDc");
const $35124d56630e77b1$export$7d260a2a5f8bc19e = {
    ...(0, $79XDc.number),
    transform: Math.round
};

});





parcelRegister("l82xw", function(module, exports) {

$parcel$export(module.exports, "flushKeyframeResolvers", function () { return $7624544714439428$export$78b96d2a12593b05; });
$parcel$export(module.exports, "KeyframeResolver", function () { return $7624544714439428$export$74d34ca3182f1750; });

var $gOhQZ = parcelRequire("gOhQZ");

var $5Orka = parcelRequire("5Orka");
const $7624544714439428$var$toResolve = new Set();
let $7624544714439428$var$isScheduled = false;
let $7624544714439428$var$anyNeedsMeasurement = false;
function $7624544714439428$var$measureAllKeyframes() {
    if ($7624544714439428$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($7624544714439428$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $gOhQZ.removeNonTranslationalTransform)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $7624544714439428$var$anyNeedsMeasurement = false;
    $7624544714439428$var$isScheduled = false;
    $7624544714439428$var$toResolve.forEach((resolver)=>resolver.complete());
    $7624544714439428$var$toResolve.clear();
}
function $7624544714439428$var$readAllKeyframes() {
    $7624544714439428$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $7624544714439428$var$anyNeedsMeasurement = true;
    });
}
function $7624544714439428$export$78b96d2a12593b05() {
    $7624544714439428$var$readAllKeyframes();
    $7624544714439428$var$measureAllKeyframes();
}
class $7624544714439428$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $7624544714439428$var$toResolve.add(this);
            if (!$7624544714439428$var$isScheduled) {
                $7624544714439428$var$isScheduled = true;
                (0, $5Orka.frame).read($7624544714439428$var$readAllKeyframes);
                (0, $5Orka.frame).resolveKeyframes($7624544714439428$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $7624544714439428$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $7624544714439428$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}

});
parcelRegister("gOhQZ", function(module, exports) {

$parcel$export(module.exports, "isNumOrPxType", function () { return $19014d3adac7ea04$export$8e5250d1aa9bf370; });
$parcel$export(module.exports, "removeNonTranslationalTransform", function () { return $19014d3adac7ea04$export$39d4bc9655f3f632; });
$parcel$export(module.exports, "positionalValues", function () { return $19014d3adac7ea04$export$781d46a8aa670d52; });

var $79XDc = parcelRequire("79XDc");

var $5arE3 = parcelRequire("5arE3");

var $e3WlB = parcelRequire("e3WlB");
const $19014d3adac7ea04$export$8e5250d1aa9bf370 = (v)=>v === (0, $79XDc.number) || v === (0, $5arE3.px);
const $19014d3adac7ea04$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $19014d3adac7ea04$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $19014d3adac7ea04$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $19014d3adac7ea04$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $19014d3adac7ea04$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $19014d3adac7ea04$var$nonTranslationalTransformKeys = (0, $e3WlB.transformPropOrder).filter((key)=>!$19014d3adac7ea04$var$transformKeys.has(key));
function $19014d3adac7ea04$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $19014d3adac7ea04$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $19014d3adac7ea04$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $19014d3adac7ea04$var$getTranslateFromMatrix(4, 13),
    y: $19014d3adac7ea04$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$19014d3adac7ea04$export$781d46a8aa670d52.translateX = $19014d3adac7ea04$export$781d46a8aa670d52.x;
$19014d3adac7ea04$export$781d46a8aa670d52.translateY = $19014d3adac7ea04$export$781d46a8aa670d52.y;

});


parcelRegister("lDm6I", function(module, exports) {

$parcel$export(module.exports, "getVariableValue", function () { return $42b80769b9c9e9ea$export$289398774300c991; });
parcelRequire("gxAX4");
var $jQRuG = parcelRequire("jQRuG");

var $jhoKN = parcelRequire("jhoKN");

var $iaXVW = parcelRequire("iaXVW");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $42b80769b9c9e9ea$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $42b80769b9c9e9ea$export$b9f0c1f373aee2b0(current) {
    const match = $42b80769b9c9e9ea$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $42b80769b9c9e9ea$var$maxDepth = 4;
function $42b80769b9c9e9ea$export$289398774300c991(current, element, depth = 1) {
    (0, $jQRuG.invariant)(depth <= $42b80769b9c9e9ea$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $42b80769b9c9e9ea$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $jhoKN.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $iaXVW.isCSSVariableToken)(fallback) ? $42b80769b9c9e9ea$export$289398774300c991(fallback, element, depth + 1) : fallback;
}

});
parcelRegister("jhoKN", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", function () { return $4e2ad079f273c20d$export$65583ed5a868f2d9; });
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $4e2ad079f273c20d$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

});

parcelRegister("iaXVW", function(module, exports) {

$parcel$export(module.exports, "isCSSVariableName", function () { return $5e4d1ac876ecf9de$export$9de1236619d9e756; });
$parcel$export(module.exports, "isCSSVariableToken", function () { return $5e4d1ac876ecf9de$export$31f9caa2600b5723; });
const $5e4d1ac876ecf9de$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $5e4d1ac876ecf9de$export$9de1236619d9e756 = /*@__PURE__*/ $5e4d1ac876ecf9de$var$checkStringStartsWith("--");
const $5e4d1ac876ecf9de$var$startsAsVariableToken = /*@__PURE__*/ $5e4d1ac876ecf9de$var$checkStringStartsWith("var(--");
const $5e4d1ac876ecf9de$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $5e4d1ac876ecf9de$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $5e4d1ac876ecf9de$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $5e4d1ac876ecf9de$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

});


parcelRegister("eoRpa", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", function () { return $b86567a3f56c511f$export$d176691c1998a1f5; });
$parcel$export(module.exports, "findDimensionValueType", function () { return $b86567a3f56c511f$export$eefdd52e3ccae428; });

var $79XDc = parcelRequire("79XDc");

var $5arE3 = parcelRequire("5arE3");

var $cf1oE = parcelRequire("cf1oE");

var $iLEPt = parcelRequire("iLEPt");
/**
 * A list of value types commonly used for dimensions
 */ const $b86567a3f56c511f$export$d176691c1998a1f5 = [
    (0, $79XDc.number),
    (0, $5arE3.px),
    (0, $5arE3.percent),
    (0, $5arE3.degrees),
    (0, $5arE3.vw),
    (0, $5arE3.vh),
    (0, $iLEPt.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $b86567a3f56c511f$export$eefdd52e3ccae428 = (v)=>$b86567a3f56c511f$export$d176691c1998a1f5.find((0, $cf1oE.testValueType)(v));

});
parcelRegister("cf1oE", function(module, exports) {

$parcel$export(module.exports, "testValueType", function () { return $c6f9156202f453f4$export$6eae4d0a6a7ca7cd; });
/**
 * Tests a provided value against a ValueType
 */ const $c6f9156202f453f4$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);

});

parcelRegister("iLEPt", function(module, exports) {

$parcel$export(module.exports, "auto", function () { return $a274bdae185c6f16$export$dfb5619354ba860; });
/**
 * ValueType for "auto"
 */ const $a274bdae185c6f16$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};

});



parcelRegister("35Ltl", function(module, exports) {

$parcel$export(module.exports, "BaseAnimation", function () { return $fdf223305eb73cab$export$d1e4f34b9c2550c1; });

var $k83cl = parcelRequire("k83cl");

var $l82xw = parcelRequire("l82xw");

var $bqq26 = parcelRequire("bqq26");

var $fHKGQ = parcelRequire("fHKGQ");

var $jVNB3 = parcelRequire("jVNB3");
/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $fdf223305eb73cab$var$MAX_RESOLVE_DELAY = 40;
class $fdf223305eb73cab$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, $k83cl.time).now();
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > $fdf223305eb73cab$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $l82xw.flushKeyframeResolvers)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, $k83cl.time).now();
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $fHKGQ.canAnimate)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $bqq26.instantAnimationState).current || !delay) {
                onUpdate && onUpdate((0, $jVNB3.getFinalKeyframe)(keyframes, this.options, finalKeyframe));
                onComplete && onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    flatten() {
        this.options.type = "keyframes";
        this.options.ease = "linear";
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}

});
parcelRegister("fHKGQ", function(module, exports) {

$parcel$export(module.exports, "canAnimate", function () { return $da3417a422372560$export$1b109e6c9968df4f; });
parcelRequire("7Ow0h");
var $ezUzd = parcelRequire("ezUzd");
parcelRequire("gxAX4");
var $jQRuG = parcelRequire("jQRuG");

var $2vKqF = parcelRequire("2vKqF");
function $da3417a422372560$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $da3417a422372560$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $2vKqF.isAnimatable)(originKeyframe, name);
    const isTargetAnimatable = (0, $2vKqF.isAnimatable)(targetKeyframe, name);
    (0, $jQRuG.warning)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $da3417a422372560$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $ezUzd.isGenerator)(type)) && velocity;
}

});
parcelRegister("2vKqF", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", function () { return $7aeb45214bb1f789$export$65676b58b122bc38; });

var $3aPzZ = parcelRequire("3aPzZ");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $7aeb45214bb1f789$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $3aPzZ.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});


parcelRegister("jVNB3", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", function () { return $d5c1063e478112cf$export$14de59408fad90b; });
const $d5c1063e478112cf$var$isNotNull = (value)=>value !== null;
function $d5c1063e478112cf$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($d5c1063e478112cf$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

});


parcelRegister("kifNe", function(module, exports) {

$parcel$export(module.exports, "MainThreadAnimation", function () { return $3d4a57fc07426f39$export$fd98d9cca67a58bc; });
parcelRequire("7Ow0h");
var $fXjmT = parcelRequire("fXjmT");
var $ezUzd = parcelRequire("ezUzd");
parcelRequire("gxAX4");
var $eJ1nu = parcelRequire("eJ1nu");

var $l82xw = parcelRequire("l82xw");

var $j1IcX = parcelRequire("j1IcX");

var $dkITH = parcelRequire("dkITH");

var $1bJJj = parcelRequire("1bJJj");

var $9L7gc = parcelRequire("9L7gc");

var $bGhTr = parcelRequire("bGhTr");

var $640gE = parcelRequire("640gE");

var $35Ltl = parcelRequire("35Ltl");

var $ewDAc = parcelRequire("ewDAc");

var $jVNB3 = parcelRequire("jVNB3");
const $3d4a57fc07426f39$var$generators = {
    decay: (0, $9L7gc.inertia),
    inertia: $9L7gc.inertia,
    tween: (0, $bGhTr.keyframes),
    keyframes: (0, $bGhTr.keyframes),
    spring: $640gE.spring
};
const $3d4a57fc07426f39$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $3d4a57fc07426f39$export$fd98d9cca67a58bc extends (0, $35Ltl.BaseAnimation) {
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $l82xw.KeyframeResolver);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    flatten() {
        super.flatten();
        // If we've already resolved the animation, re-initialise it
        if (this._resolved) Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = (0, $ezUzd.isGenerator)(type) ? type : $3d4a57fc07426f39$var$generators[type] || (0, $bGhTr.keyframes);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $bGhTr.keyframes) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $1bJJj.pipe)($3d4a57fc07426f39$var$percentToProgress, (0, $dkITH.mix)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $fXjmT.calcGeneratorDuration)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $j1IcX.clamp)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $jVNB3.getFinalKeyframe)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $eJ1nu.millisecondsToSeconds)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $eJ1nu.millisecondsToSeconds)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $eJ1nu.secondsToMilliseconds)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $eJ1nu.millisecondsToSeconds)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $ewDAc.frameloopDriver), onPlay: onPlay, startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $3d4a57fc07426f39$export$ee9b76de7353d815(options) {
    return new $3d4a57fc07426f39$export$fd98d9cca67a58bc(options);
}

});
parcelRegister("dkITH", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $8fa6f0b5805e669c$export$2c9e8a9632a706b2; });

var $9JRcG = parcelRequire("9JRcG");

var $aCww2 = parcelRequire("aCww2");
function $8fa6f0b5805e669c$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $aCww2.mixNumber)(from, to, p);
    const mixer = (0, $9JRcG.getMixer)(from);
    return mixer(from, to);
}

});
parcelRegister("9JRcG", function(module, exports) {

$parcel$export(module.exports, "getMixer", function () { return $a3bc6940b02d3a68$export$36ec24672cd098e0; });

var $aCww2 = parcelRequire("aCww2");

var $7IKuH = parcelRequire("7IKuH");

var $1bJJj = parcelRequire("1bJJj");
parcelRequire("gxAX4");
var $jQRuG = parcelRequire("jQRuG");

var $kew5R = parcelRequire("kew5R");

var $3aPzZ = parcelRequire("3aPzZ");

var $iaXVW = parcelRequire("iaXVW");

var $ccQ9x = parcelRequire("ccQ9x");

var $fubq3 = parcelRequire("fubq3");
function $a3bc6940b02d3a68$var$mixNumber(a, b) {
    return (p)=>(0, $aCww2.mixNumber)(a, b, p);
}
function $a3bc6940b02d3a68$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $a3bc6940b02d3a68$var$mixNumber;
    else if (typeof a === "string") return (0, $iaXVW.isCSSVariableToken)(a) ? (0, $fubq3.mixImmediate) : (0, $kew5R.color).test(a) ? (0, $7IKuH.mixColor) : $a3bc6940b02d3a68$export$65516310a87d8205;
    else if (Array.isArray(a)) return $a3bc6940b02d3a68$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $kew5R.color).test(a) ? (0, $7IKuH.mixColor) : $a3bc6940b02d3a68$export$ebc23b6840c51ba1;
    return 0, $fubq3.mixImmediate;
}
function $a3bc6940b02d3a68$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$a3bc6940b02d3a68$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $a3bc6940b02d3a68$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $a3bc6940b02d3a68$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $a3bc6940b02d3a68$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $a3bc6940b02d3a68$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $3aPzZ.complex).createTransformer(target);
    const originStats = (0, $3aPzZ.analyseComplexValue)(origin);
    const targetStats = (0, $3aPzZ.analyseComplexValue)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $ccQ9x.invisibleValues).has(origin) && !targetStats.values.length || (0, $ccQ9x.invisibleValues).has(target) && !originStats.values.length) return (0, $ccQ9x.mixVisibility)(origin, target);
        return (0, $1bJJj.pipe)($a3bc6940b02d3a68$export$3bbefa2f402845c4($a3bc6940b02d3a68$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $jQRuG.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $fubq3.mixImmediate)(origin, target);
    }
};

});
parcelRegister("aCww2", function(module, exports) {

$parcel$export(module.exports, "mixNumber", function () { return $cb9d92ed7d244136$export$3bb0b4ff1037b8dd; });
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $cb9d92ed7d244136$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};

});

parcelRegister("7IKuH", function(module, exports) {

$parcel$export(module.exports, "mixColor", function () { return $da43e5449ecfa05c$export$51e568cf5c039bac; });

var $aCww2 = parcelRequire("aCww2");
parcelRequire("gxAX4");
var $jQRuG = parcelRequire("jQRuG");

var $cb19I = parcelRequire("cb19I");

var $gsOWO = parcelRequire("gsOWO");

var $1fJUI = parcelRequire("1fJUI");

var $kTDRk = parcelRequire("kTDRk");

var $fubq3 = parcelRequire("fubq3");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $da43e5449ecfa05c$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $da43e5449ecfa05c$var$colorTypes = [
    (0, $gsOWO.hex),
    (0, $1fJUI.rgba),
    (0, $kTDRk.hsla)
];
const $da43e5449ecfa05c$var$getColorType = (v)=>$da43e5449ecfa05c$var$colorTypes.find((type)=>type.test(v));
function $da43e5449ecfa05c$var$asRGBA(color) {
    const type = $da43e5449ecfa05c$var$getColorType(color);
    (0, $jQRuG.warning)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $kTDRk.hsla)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $cb19I.hslaToRgba)(model);
    return model;
}
const $da43e5449ecfa05c$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $da43e5449ecfa05c$var$asRGBA(from);
    const toRGBA = $da43e5449ecfa05c$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $fubq3.mixImmediate)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $da43e5449ecfa05c$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $da43e5449ecfa05c$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $da43e5449ecfa05c$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $aCww2.mixNumber)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $1fJUI.rgba).transform(blended);
    };
};

});
parcelRegister("cb19I", function(module, exports) {

$parcel$export(module.exports, "hslaToRgba", function () { return $8260ef9ff0029f05$export$6ae64dbcd6bfc33e; });
// Adapted from https://gist.github.com/mjackson/5311256
function $8260ef9ff0029f05$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $8260ef9ff0029f05$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $8260ef9ff0029f05$var$hueToRgb(p, q, hue + 1 / 3);
        green = $8260ef9ff0029f05$var$hueToRgb(p, q, hue);
        blue = $8260ef9ff0029f05$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

});

parcelRegister("fubq3", function(module, exports) {

$parcel$export(module.exports, "mixImmediate", function () { return $e21f1951465e5026$export$a6f92d4bae65c0f1; });
function $e21f1951465e5026$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}

});


parcelRegister("1bJJj", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $3c67aef0233ae7f2$export$a4627e546088548d; });
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $3c67aef0233ae7f2$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $3c67aef0233ae7f2$export$a4627e546088548d = (...transformers)=>transformers.reduce($3c67aef0233ae7f2$var$combineFunctions);

});

parcelRegister("ccQ9x", function(module, exports) {

$parcel$export(module.exports, "invisibleValues", function () { return $6f3e22f9d62669ab$export$e5a55ae567dd4ac7; });
$parcel$export(module.exports, "mixVisibility", function () { return $6f3e22f9d62669ab$export$fed62ccc3fb1a568; });
const $6f3e22f9d62669ab$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $6f3e22f9d62669ab$export$fed62ccc3fb1a568(origin, target) {
    if ($6f3e22f9d62669ab$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}

});



parcelRegister("9L7gc", function(module, exports) {

$parcel$export(module.exports, "inertia", function () { return $b47edb1df79026f8$export$ee3ff3a17106998; });

var $640gE = parcelRequire("640gE");

var $eJlxG = parcelRequire("eJlxG");
function $b47edb1df79026f8$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $640gE.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $eJlxG.calcGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

});
parcelRegister("640gE", function(module, exports) {

$parcel$export(module.exports, "spring", function () { return $24c6b1ffbf932841$export$b36281d89752ae66; });
parcelRequire("7Ow0h");
var $fXjmT = parcelRequire("fXjmT");
var $2bfsp = parcelRequire("2bfsp");
parcelRequire("gxAX4");
var $eJ1nu = parcelRequire("eJ1nu");

var $j1IcX = parcelRequire("j1IcX");

var $eJlxG = parcelRequire("eJlxG");

var $jMBSN = parcelRequire("jMBSN");

var $iFG86 = parcelRequire("iFG86");
const $24c6b1ffbf932841$var$durationKeys = [
    "duration",
    "bounce"
];
const $24c6b1ffbf932841$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $24c6b1ffbf932841$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $24c6b1ffbf932841$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $jMBSN.springDefaults).velocity,
        stiffness: (0, $jMBSN.springDefaults).stiffness,
        damping: (0, $jMBSN.springDefaults).damping,
        mass: (0, $jMBSN.springDefaults).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$24c6b1ffbf932841$var$isSpringType(options, $24c6b1ffbf932841$var$physicsKeys) && $24c6b1ffbf932841$var$isSpringType(options, $24c6b1ffbf932841$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $j1IcX.clamp)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $jMBSN.springDefaults).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $iFG86.findSpring)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $jMBSN.springDefaults).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $24c6b1ffbf932841$export$b36281d89752ae66(optionsOrVisualDuration = (0, $jMBSN.springDefaults).visualDuration, bounce = (0, $jMBSN.springDefaults).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $24c6b1ffbf932841$var$getSpringOptions({
        ...options,
        velocity: -(0, $eJ1nu.millisecondsToSeconds)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $eJ1nu.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $jMBSN.springDefaults).restSpeed.granular : (0, $jMBSN.springDefaults).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $jMBSN.springDefaults).restDelta.granular : (0, $jMBSN.springDefaults).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $iFG86.calcAngularFreq)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $eJ1nu.secondsToMilliseconds)(initialVelocity) : (0, $eJlxG.calcGeneratorVelocity)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $fXjmT.calcGeneratorDuration)(generator), (0, $fXjmT.maxGeneratorDuration));
            const easing = (0, $2bfsp.generateLinearEasing)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        }
    };
    return generator;
}

});
parcelRegister("eJlxG", function(module, exports) {

$parcel$export(module.exports, "calcGeneratorVelocity", function () { return $2818e6636217687f$export$854187271d233eb5; });

var $3LwX1 = parcelRequire("3LwX1");
const $2818e6636217687f$var$velocitySampleDuration = 5; // ms
function $2818e6636217687f$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $2818e6636217687f$var$velocitySampleDuration, 0);
    return (0, $3LwX1.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

});

parcelRegister("jMBSN", function(module, exports) {

$parcel$export(module.exports, "springDefaults", function () { return $a77ba7a1cc46dc78$export$86436497e7b05d16; });
const $a77ba7a1cc46dc78$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};

});

parcelRegister("iFG86", function(module, exports) {

$parcel$export(module.exports, "findSpring", function () { return $fe1c9b88896057d2$export$b15f158dc6d6f458; });
$parcel$export(module.exports, "calcAngularFreq", function () { return $fe1c9b88896057d2$export$5f679887c3a78b15; });
parcelRequire("gxAX4");
var $eJ1nu = parcelRequire("eJ1nu");
var $jQRuG = parcelRequire("jQRuG");

var $j1IcX = parcelRequire("j1IcX");

var $jMBSN = parcelRequire("jMBSN");
const $fe1c9b88896057d2$var$safeMin = 0.001;
function $fe1c9b88896057d2$export$b15f158dc6d6f458({ duration: duration = (0, $jMBSN.springDefaults).duration, bounce: bounce = (0, $jMBSN.springDefaults).bounce, velocity: velocity = (0, $jMBSN.springDefaults).velocity, mass: mass = (0, $jMBSN.springDefaults).mass }) {
    let envelope;
    let derivative;
    (0, $jQRuG.warning)(duration <= (0, $eJ1nu.secondsToMilliseconds)((0, $jMBSN.springDefaults).maxDuration), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $j1IcX.clamp)((0, $jMBSN.springDefaults).minDamping, (0, $jMBSN.springDefaults).maxDamping, dampingRatio);
    duration = (0, $j1IcX.clamp)((0, $jMBSN.springDefaults).minDuration, (0, $jMBSN.springDefaults).maxDuration, (0, $eJ1nu.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $fe1c9b88896057d2$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $fe1c9b88896057d2$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $fe1c9b88896057d2$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $fe1c9b88896057d2$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$fe1c9b88896057d2$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $fe1c9b88896057d2$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $eJ1nu.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $jMBSN.springDefaults).stiffness,
        damping: (0, $jMBSN.springDefaults).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $fe1c9b88896057d2$var$rootIterations = 12;
function $fe1c9b88896057d2$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $fe1c9b88896057d2$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $fe1c9b88896057d2$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});



parcelRegister("bGhTr", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $6ab386cfc7b875e1$export$d25ddfdf17c3ad3e; });

var $3zR4V = parcelRequire("3zR4V");

var $jBkAc = parcelRequire("jBkAc");

var $3oKGP = parcelRequire("3oKGP");

var $8iiSK = parcelRequire("8iiSK");

var $eHrJD = parcelRequire("eHrJD");

var $foZ6g = parcelRequire("foZ6g");
function $6ab386cfc7b875e1$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $3zR4V.easeInOut)).splice(0, values.length - 1);
}
function $6ab386cfc7b875e1$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $jBkAc.isEasingArray)(ease) ? ease.map((0, $3oKGP.easingDefinitionToFunction)) : (0, $3oKGP.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $foZ6g.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $eHrJD.defaultOffset)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $8iiSK.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $6ab386cfc7b875e1$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

});
parcelRegister("3zR4V", function(module, exports) {

$parcel$export(module.exports, "easeIn", function () { return $ba2b220d96580d66$export$929e5a82286172a6; });
$parcel$export(module.exports, "easeOut", function () { return $ba2b220d96580d66$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeInOut", function () { return $ba2b220d96580d66$export$c07234257a03d5e9; });

var $5LCCJ = parcelRequire("5LCCJ");
const $ba2b220d96580d66$export$929e5a82286172a6 = /*@__PURE__*/ (0, $5LCCJ.cubicBezier)(0.42, 0, 1, 1);
const $ba2b220d96580d66$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $5LCCJ.cubicBezier)(0, 0, 0.58, 1);
const $ba2b220d96580d66$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $5LCCJ.cubicBezier)(0.42, 0, 0.58, 1);

});

parcelRegister("jBkAc", function(module, exports) {

$parcel$export(module.exports, "isEasingArray", function () { return $5a0d1367f684bae9$export$216948827bbdc797; });
const $5a0d1367f684bae9$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});

parcelRegister("3oKGP", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", function () { return $59a613b80ac99226$export$ef97fe084f156ca4; });
parcelRequire("7Ow0h");
var $j8D8r = parcelRequire("j8D8r");
parcelRequire("gxAX4");
var $jQRuG = parcelRequire("jQRuG");
var $j5fqa = parcelRequire("j5fqa");

var $iQDT2 = parcelRequire("iQDT2");

var $iWs3r = parcelRequire("iWs3r");

var $fYI2h = parcelRequire("fYI2h");

var $5LCCJ = parcelRequire("5LCCJ");

var $3zR4V = parcelRequire("3zR4V");
const $59a613b80ac99226$var$easingLookup = {
    linear: (0, $j5fqa.noop),
    easeIn: $3zR4V.easeIn,
    easeInOut: $3zR4V.easeInOut,
    easeOut: $3zR4V.easeOut,
    circIn: $fYI2h.circIn,
    circInOut: $fYI2h.circInOut,
    circOut: $fYI2h.circOut,
    backIn: $iWs3r.backIn,
    backInOut: $iWs3r.backInOut,
    backOut: $iWs3r.backOut,
    anticipate: $iQDT2.anticipate
};
const $59a613b80ac99226$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $j8D8r.isBezierDefinition)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $jQRuG.invariant)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $5LCCJ.cubicBezier)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $jQRuG.invariant)($59a613b80ac99226$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $59a613b80ac99226$var$easingLookup[definition];
    }
    return definition;
};

});

parcelRegister("8iiSK", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $60d5f4e1106b47ad$export$89e29e4ab65e70a9; });
parcelRequire("gxAX4");
var $jQRuG = parcelRequire("jQRuG");
var $j5fqa = parcelRequire("j5fqa");
var $2UGlP = parcelRequire("2UGlP");

var $j1IcX = parcelRequire("j1IcX");

var $dkITH = parcelRequire("dkITH");

var $1bJJj = parcelRequire("1bJJj");
function $60d5f4e1106b47ad$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $dkITH.mix);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $j5fqa.noop) : ease;
            mixer = (0, $1bJJj.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $60d5f4e1106b47ad$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $jQRuG.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $60d5f4e1106b47ad$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $2UGlP.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $j1IcX.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

});

parcelRegister("eHrJD", function(module, exports) {

$parcel$export(module.exports, "defaultOffset", function () { return $231ca04eed5b42ea$export$24dbcec0b26e6d9d; });

var $fld9E = parcelRequire("fld9E");
function $231ca04eed5b42ea$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $fld9E.fillOffset)(offset, arr.length - 1);
    return offset;
}

});
parcelRegister("fld9E", function(module, exports) {

$parcel$export(module.exports, "fillOffset", function () { return $8ef14f7e53afcde3$export$dafee61230cf05c6; });
parcelRequire("gxAX4");
var $2UGlP = parcelRequire("2UGlP");

var $aCww2 = parcelRequire("aCww2");
function $8ef14f7e53afcde3$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $2UGlP.progress)(0, remaining, i);
        offset.push((0, $aCww2.mixNumber)(min, 1, offsetProgress));
    }
}

});


parcelRegister("foZ6g", function(module, exports) {

$parcel$export(module.exports, "convertOffsetToTimes", function () { return $c7a85f3b4a07ee88$export$2a91b4e3a4539316; });
function $c7a85f3b4a07ee88$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}

});


parcelRegister("ewDAc", function(module, exports) {

$parcel$export(module.exports, "frameloopDriver", function () { return $65d07f74462e0d1b$export$c1033964b5ad7fef; });

var $k83cl = parcelRequire("k83cl");

var $5Orka = parcelRequire("5Orka");
const $65d07f74462e0d1b$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $5Orka.frame).update(passTimestamp, true),
        stop: ()=>(0, $5Orka.cancelFrame)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $5Orka.frameData).isProcessing ? (0, $5Orka.frameData).timestamp : (0, $k83cl.time).now()
    };
};

});


parcelRegister("et7p6", function(module, exports) {

$parcel$export(module.exports, "acceleratedValues", function () { return $e6f6f3df0e5f6064$export$a27eefbd8fb5e404; });
/**
 * A list of values that can be hardware-accelerated.
 */ const $e6f6f3df0e5f6064$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);

});

parcelRegister("iL4tV", function(module, exports) {

$parcel$export(module.exports, "startWaapiAnimation", function () { return $cd4280e81767e5a7$export$d896de52f97cb615; });
parcelRequire("7Ow0h");
var $5OhEy = parcelRequire("5OhEy");
function $cd4280e81767e5a7$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeInOut", times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $5OhEy.mapEasingToNativeEasing)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}

});

parcelRegister("alOff", function(module, exports) {

$parcel$export(module.exports, "supportsWaapi", function () { return $0fc2b7a4aa23672d$export$51ea9b46fb7a8c5d; });
parcelRequire("gxAX4");
var $9IjQW = parcelRequire("9IjQW");
const $0fc2b7a4aa23672d$export$51ea9b46fb7a8c5d = /*@__PURE__*/ (0, $9IjQW.memo)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));

});


parcelRegister("h42YW", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", function () { return $6d40e17948c8b57d$export$262124b154b9f1c0; });

var $e3WlB = parcelRequire("e3WlB");
const $6d40e17948c8b57d$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $6d40e17948c8b57d$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $6d40e17948c8b57d$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $6d40e17948c8b57d$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $6d40e17948c8b57d$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $6d40e17948c8b57d$var$keyframesTransition;
    else if ((0, $e3WlB.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? $6d40e17948c8b57d$var$criticallyDampedSpring(keyframes[1]) : $6d40e17948c8b57d$var$underDampedSpring;
    return $6d40e17948c8b57d$var$ease;
};

});

parcelRegister("a0cfS", function(module, exports) {

$parcel$export(module.exports, "isTransitionDefined", function () { return $3c51806c7aff0b86$export$ca8e47dc8ed5a9d7; });
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $3c51806c7aff0b86$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}

});



parcelRegister("adguu", function(module, exports) {

$parcel$export(module.exports, "animateVariant", function () { return $88a824a5bd2a67a4$export$4709dc300705b2af; });

var $hTtrb = parcelRequire("hTtrb");

var $7qcxu = parcelRequire("7qcxu");
function $88a824a5bd2a67a4$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $hTtrb.resolveVariant)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $7qcxu.animateTarget)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $88a824a5bd2a67a4$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $88a824a5bd2a67a4$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($88a824a5bd2a67a4$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($88a824a5bd2a67a4$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $88a824a5bd2a67a4$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}

});


parcelRegister("7xNZg", function(module, exports) {

$parcel$export(module.exports, "getVariantContext", function () { return $9326fda471d2b5f6$export$6669f52f7ffa343b; });

var $ipk3v = parcelRequire("ipk3v");

var $cV5Fz = parcelRequire("cV5Fz");
const $9326fda471d2b5f6$var$numVariantProps = (0, $cV5Fz.variantProps).length;
function $9326fda471d2b5f6$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $9326fda471d2b5f6$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $9326fda471d2b5f6$var$numVariantProps; i++){
        const name = (0, $cV5Fz.variantProps)[i];
        const prop = visualElement.props[name];
        if ((0, $ipk3v.isVariantLabel)(prop) || prop === false) context[name] = prop;
    }
    return context;
}

});


parcelRegister("d72GF", function(module, exports) {

$parcel$export(module.exports, "Feature", function () { return $fd435b7f1020cfc8$export$6e91cf7616333d5; });
class $fd435b7f1020cfc8$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}

});


parcelRegister("4yGWr", function(module, exports) {

$parcel$export(module.exports, "ExitAnimationFeature", function () { return $5529cd460489ff68$export$4989d1eb6104cc6c; });

var $d72GF = parcelRequire("d72GF");
let $5529cd460489ff68$var$id = 0;
class $5529cd460489ff68$export$4989d1eb6104cc6c extends (0, $d72GF.Feature) {
    constructor(){
        super(...arguments);
        this.id = $5529cd460489ff68$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}

});


parcelRegister("9LKwx", function(module, exports) {

$parcel$export(module.exports, "drag", function () { return $ad95615eeb9ab845$export$d7d5d435647ed5a0; });

var $fuRi3 = parcelRequire("fuRi3");

var $8edVu = parcelRequire("8edVu");

var $ijW4B = parcelRequire("ijW4B");

var $6xkeI = parcelRequire("6xkeI");
const $ad95615eeb9ab845$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $8edVu.PanGesture)
    },
    drag: {
        Feature: (0, $fuRi3.DragGesture),
        ProjectionNode: (0, $6xkeI.HTMLProjectionNode),
        MeasureLayout: $ijW4B.MeasureLayout
    }
};

});
parcelRegister("fuRi3", function(module, exports) {

$parcel$export(module.exports, "DragGesture", function () { return $df89ffde2ef9093f$export$5d97dc2872682820; });

var $d72GF = parcelRequire("d72GF");
parcelRequire("gxAX4");
var $j5fqa = parcelRequire("j5fqa");

var $eVGz0 = parcelRequire("eVGz0");
class $df89ffde2ef9093f$export$5d97dc2872682820 extends (0, $d72GF.Feature) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $j5fqa.noop);
        this.removeListeners = (0, $j5fqa.noop);
        this.controls = new (0, $eVGz0.VisualElementDragControls)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $j5fqa.noop);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}

});
parcelRegister("eVGz0", function(module, exports) {

$parcel$export(module.exports, "VisualElementDragControls", function () { return $1657ea445f4f3bf4$export$86bff71f18910307; });
parcelRequire("gxAX4");
var $jQRuG = parcelRequire("jQRuG");
parcelRequire("7Ow0h");
var $5pan6 = parcelRequire("5pan6");

var $eA7AD = parcelRequire("eA7AD");

var $98dna = parcelRequire("98dna");

var $grqSe = parcelRequire("grqSe");

var $fmKVe = parcelRequire("fmKVe");

var $6lXUx = parcelRequire("6lXUx");

var $ej3WU = parcelRequire("ej3WU");

var $7jXA1 = parcelRequire("7jXA1");

var $TUqSB = parcelRequire("TUqSB");

var $iQsxp = parcelRequire("iQsxp");

var $bnFL7 = parcelRequire("bnFL7");

var $1Bv54 = parcelRequire("1Bv54");

var $aCww2 = parcelRequire("aCww2");

var $5arE3 = parcelRequire("5arE3");

var $6LTw8 = parcelRequire("6LTw8");

var $kqnNR = parcelRequire("kqnNR");

var $28eMC = parcelRequire("28eMC");

var $5Orka = parcelRequire("5Orka");
const $1657ea445f4f3bf4$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $1657ea445f4f3bf4$export$86bff71f18910307 {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $6lXUx.createBox)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $TUqSB.extractEventInfo)(event).point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $5pan6.setDragLock)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $ej3WU.eachAxis)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $5arE3.percent).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $1Bv54.calcLength)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $5Orka.frame).postRender(()=>onDragStart(event, info));
            (0, $28eMC.addValueToWillChange)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $1657ea445f4f3bf4$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $ej3WU.eachAxis)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $eA7AD.PanSession)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $kqnNR.getContextWindow)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $5Orka.frame).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$1657ea445f4f3bf4$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $fmKVe.applyConstraints)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $98dna.isRefObject)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $fmKVe.calcRelativeConstraints)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $fmKVe.resolveDragElastic)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $ej3WU.eachAxis)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $fmKVe.rebaseAxisConstraints)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $98dna.isRefObject)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $jQRuG.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $7jXA1.measurePageBox)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $fmKVe.calcViewportConstraints)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $iQsxp.convertBoxToBoundingBox)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $iQsxp.convertBoundingBoxToBox)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $ej3WU.eachAxis)((axis)=>{
            if (!$1657ea445f4f3bf4$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $28eMC.addValueToWillChange)(this.visualElement, axis);
        return axisValue.start((0, $6LTw8.animateMotionValue)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $ej3WU.eachAxis)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $ej3WU.eachAxis)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $ej3WU.eachAxis)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$1657ea445f4f3bf4$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $aCww2.mixNumber)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $98dna.isRefObject)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $ej3WU.eachAxis)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $fmKVe.calcOrigin)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $ej3WU.eachAxis)((axis)=>{
            if (!$1657ea445f4f3bf4$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $aCww2.mixNumber)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $1657ea445f4f3bf4$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $grqSe.addPointerEvent)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $98dna.isRefObject)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $5Orka.frame).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $bnFL7.addDomEvent)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $ej3WU.eachAxis)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $fmKVe.defaultElastic), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $1657ea445f4f3bf4$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $1657ea445f4f3bf4$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

});
parcelRegister("eA7AD", function(module, exports) {

$parcel$export(module.exports, "PanSession", function () { return $7943f2f4544886c0$export$d9c66232c9c4689c; });
parcelRequire("7Ow0h");
var $hclYu = parcelRequire("hclYu");
parcelRequire("gxAX4");
var $eJ1nu = parcelRequire("eJ1nu");

var $grqSe = parcelRequire("grqSe");

var $TUqSB = parcelRequire("TUqSB");

var $iYUWS = parcelRequire("iYUWS");

var $1bJJj = parcelRequire("1bJJj");

var $5Orka = parcelRequire("5Orka");
/**
 * @internal
 */ class $7943f2f4544886c0$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $7943f2f4544886c0$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $iYUWS.distance2D)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $5Orka.frameData);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $7943f2f4544886c0$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $5Orka.frame).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $7943f2f4544886c0$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $7943f2f4544886c0$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $hclYu.isPrimaryPointer)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $TUqSB.extractEventInfo)(event);
        const initialInfo = $7943f2f4544886c0$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $5Orka.frameData);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $7943f2f4544886c0$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $1bJJj.pipe)((0, $grqSe.addPointerEvent)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $grqSe.addPointerEvent)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $grqSe.addPointerEvent)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $5Orka.cancelFrame)(this.updatePoint);
    }
}
function $7943f2f4544886c0$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $7943f2f4544886c0$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $7943f2f4544886c0$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $7943f2f4544886c0$var$subtractPoint(point, $7943f2f4544886c0$var$lastDevicePoint(history)),
        offset: $7943f2f4544886c0$var$subtractPoint(point, $7943f2f4544886c0$var$startDevicePoint(history)),
        velocity: $7943f2f4544886c0$var$getVelocity(history, 0.1)
    };
}
function $7943f2f4544886c0$var$startDevicePoint(history) {
    return history[0];
}
function $7943f2f4544886c0$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $7943f2f4544886c0$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $7943f2f4544886c0$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $eJ1nu.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $eJ1nu.millisecondsToSeconds)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

});
parcelRegister("grqSe", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", function () { return $92cdeda714df9cb9$export$fcff2e64e6676b81; });

var $bnFL7 = parcelRequire("bnFL7");

var $TUqSB = parcelRequire("TUqSB");
function $92cdeda714df9cb9$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $bnFL7.addDomEvent)(target, eventName, (0, $TUqSB.addPointerInfo)(handler), options);
}

});
parcelRegister("bnFL7", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", function () { return $ed53eb80d596c118$export$b1d829ddf82884aa; });
function $ed53eb80d596c118$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}

});

parcelRegister("TUqSB", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", function () { return $99f4206b3adf30ea$export$12f84bb882d06e1a; });
$parcel$export(module.exports, "addPointerInfo", function () { return $99f4206b3adf30ea$export$c404e80f92c98d29; });
parcelRequire("7Ow0h");
var $hclYu = parcelRequire("hclYu");
function $99f4206b3adf30ea$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $99f4206b3adf30ea$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $hclYu.isPrimaryPointer)(event) && handler(event, $99f4206b3adf30ea$export$12f84bb882d06e1a(event));
};

});


parcelRegister("iYUWS", function(module, exports) {

$parcel$export(module.exports, "distance2D", function () { return $7ea7c17895cfdad3$export$503a1d513f12e38b; });
const $7ea7c17895cfdad3$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $7ea7c17895cfdad3$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $7ea7c17895cfdad3$export$9f17032d917177de(a.x, b.x);
    const yDelta = $7ea7c17895cfdad3$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

});


parcelRegister("98dna", function(module, exports) {

$parcel$export(module.exports, "isRefObject", function () { return $36a6e05bf470cdb3$export$dedd81df7bc1307; });
function $36a6e05bf470cdb3$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});

parcelRegister("fmKVe", function(module, exports) {

$parcel$export(module.exports, "applyConstraints", function () { return $5a4e2ae37435143f$export$b3c764d3fca3ffe3; });
$parcel$export(module.exports, "calcRelativeConstraints", function () { return $5a4e2ae37435143f$export$4e9195bf7793bc78; });
$parcel$export(module.exports, "calcViewportConstraints", function () { return $5a4e2ae37435143f$export$4228500f19d4cdf7; });
$parcel$export(module.exports, "calcOrigin", function () { return $5a4e2ae37435143f$export$13abbfca044ca46d; });
$parcel$export(module.exports, "rebaseAxisConstraints", function () { return $5a4e2ae37435143f$export$e9672cc4c36a8b87; });
$parcel$export(module.exports, "defaultElastic", function () { return $5a4e2ae37435143f$export$a3366d3bac43a742; });
$parcel$export(module.exports, "resolveDragElastic", function () { return $5a4e2ae37435143f$export$7c5eaef8f4723d22; });
parcelRequire("gxAX4");
var $2UGlP = parcelRequire("2UGlP");

var $1Bv54 = parcelRequire("1Bv54");

var $j1IcX = parcelRequire("j1IcX");

var $aCww2 = parcelRequire("aCww2");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $5a4e2ae37435143f$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $aCww2.mixNumber)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $aCww2.mixNumber)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $5a4e2ae37435143f$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $5a4e2ae37435143f$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $5a4e2ae37435143f$export$690c180aa5775042(layoutBox.x, left, right),
        y: $5a4e2ae37435143f$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $5a4e2ae37435143f$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $5a4e2ae37435143f$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $5a4e2ae37435143f$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $5a4e2ae37435143f$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $5a4e2ae37435143f$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $1Bv54.calcLength)(source);
    const targetLength = (0, $1Bv54.calcLength)(target);
    if (targetLength > sourceLength) origin = (0, $2UGlP.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $2UGlP.progress)(source.min, source.max - targetLength, target.min);
    return (0, $j1IcX.clamp)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $5a4e2ae37435143f$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $5a4e2ae37435143f$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $5a4e2ae37435143f$export$7c5eaef8f4723d22(dragElastic = $5a4e2ae37435143f$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $5a4e2ae37435143f$export$a3366d3bac43a742;
    return {
        x: $5a4e2ae37435143f$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $5a4e2ae37435143f$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $5a4e2ae37435143f$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $5a4e2ae37435143f$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $5a4e2ae37435143f$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $5a4e2ae37435143f$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

});
parcelRegister("1Bv54", function(module, exports) {

$parcel$export(module.exports, "calcLength", function () { return $5ef24737b805c78f$export$c1c127004b72a37; });
$parcel$export(module.exports, "isNear", function () { return $5ef24737b805c78f$export$28d0384c4b79bde2; });
$parcel$export(module.exports, "calcBoxDelta", function () { return $5ef24737b805c78f$export$c0d25e96fc67d310; });
$parcel$export(module.exports, "calcRelativeBox", function () { return $5ef24737b805c78f$export$426154f9d100f99; });
$parcel$export(module.exports, "calcRelativePosition", function () { return $5ef24737b805c78f$export$2785bfcc929c5650; });

var $aCww2 = parcelRequire("aCww2");
const $5ef24737b805c78f$var$SCALE_PRECISION = 0.0001;
const $5ef24737b805c78f$var$SCALE_MIN = 1 - $5ef24737b805c78f$var$SCALE_PRECISION;
const $5ef24737b805c78f$var$SCALE_MAX = 1 + $5ef24737b805c78f$var$SCALE_PRECISION;
const $5ef24737b805c78f$var$TRANSLATE_PRECISION = 0.01;
const $5ef24737b805c78f$var$TRANSLATE_MIN = 0 - $5ef24737b805c78f$var$TRANSLATE_PRECISION;
const $5ef24737b805c78f$var$TRANSLATE_MAX = 0 + $5ef24737b805c78f$var$TRANSLATE_PRECISION;
function $5ef24737b805c78f$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $5ef24737b805c78f$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $5ef24737b805c78f$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $aCww2.mixNumber)(source.min, source.max, delta.origin);
    delta.scale = $5ef24737b805c78f$export$c1c127004b72a37(target) / $5ef24737b805c78f$export$c1c127004b72a37(source);
    delta.translate = (0, $aCww2.mixNumber)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $5ef24737b805c78f$var$SCALE_MIN && delta.scale <= $5ef24737b805c78f$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $5ef24737b805c78f$var$TRANSLATE_MIN && delta.translate <= $5ef24737b805c78f$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $5ef24737b805c78f$export$c0d25e96fc67d310(delta, source, target, origin) {
    $5ef24737b805c78f$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $5ef24737b805c78f$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $5ef24737b805c78f$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $5ef24737b805c78f$export$c1c127004b72a37(relative);
}
function $5ef24737b805c78f$export$426154f9d100f99(target, relative, parent) {
    $5ef24737b805c78f$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $5ef24737b805c78f$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $5ef24737b805c78f$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $5ef24737b805c78f$export$c1c127004b72a37(layout);
}
function $5ef24737b805c78f$export$2785bfcc929c5650(target, layout, parent) {
    $5ef24737b805c78f$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $5ef24737b805c78f$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}

});


parcelRegister("6lXUx", function(module, exports) {

$parcel$export(module.exports, "createDelta", function () { return $0350c49398fe6c2f$export$3d227df54007d73a; });
$parcel$export(module.exports, "createBox", function () { return $0350c49398fe6c2f$export$6459fc9e86be362e; });
const $0350c49398fe6c2f$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $0350c49398fe6c2f$export$3d227df54007d73a = ()=>({
        x: $0350c49398fe6c2f$export$ff25708b37f72782(),
        y: $0350c49398fe6c2f$export$ff25708b37f72782()
    });
const $0350c49398fe6c2f$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $0350c49398fe6c2f$export$6459fc9e86be362e = ()=>({
        x: $0350c49398fe6c2f$export$6db76765312617ac(),
        y: $0350c49398fe6c2f$export$6db76765312617ac()
    });

});

parcelRegister("ej3WU", function(module, exports) {

$parcel$export(module.exports, "eachAxis", function () { return $4fe94351240f5a3f$export$b789de563eb43b1; });
function $4fe94351240f5a3f$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

});

parcelRegister("7jXA1", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", function () { return $f66a24e7cca65496$export$d8718b6a7e5c624e; });
$parcel$export(module.exports, "measurePageBox", function () { return $f66a24e7cca65496$export$6a597be7a7940a96; });

var $iQsxp = parcelRequire("iQsxp");

var $ePypE = parcelRequire("ePypE");
function $f66a24e7cca65496$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $iQsxp.convertBoundingBoxToBox)((0, $iQsxp.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $f66a24e7cca65496$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $f66a24e7cca65496$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $ePypE.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, $ePypE.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

});
parcelRegister("iQsxp", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", function () { return $51b4bc3254276e41$export$d3955c6a8f65a36b; });
$parcel$export(module.exports, "convertBoxToBoundingBox", function () { return $51b4bc3254276e41$export$b6b9cd4198191a47; });
$parcel$export(module.exports, "transformBoxPoints", function () { return $51b4bc3254276e41$export$21543fb75483a50; });
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $51b4bc3254276e41$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $51b4bc3254276e41$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $51b4bc3254276e41$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});

parcelRegister("ePypE", function(module, exports) {

$parcel$export(module.exports, "scalePoint", function () { return $a99e8a83984745c9$export$2290ec7febe36dd6; });
$parcel$export(module.exports, "applyBoxDelta", function () { return $a99e8a83984745c9$export$d80074982803af5c; });
$parcel$export(module.exports, "applyTreeDeltas", function () { return $a99e8a83984745c9$export$e2a980535c55eabb; });
$parcel$export(module.exports, "transformBox", function () { return $a99e8a83984745c9$export$58b16271041fbfb; });
$parcel$export(module.exports, "translateAxis", function () { return $a99e8a83984745c9$export$a807a5ce5ebb3895; });

var $aCww2 = parcelRequire("aCww2");

var $9G49G = parcelRequire("9G49G");
/**
 * Scales a point based on a factor and an originPoint
 */ function $a99e8a83984745c9$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $a99e8a83984745c9$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $a99e8a83984745c9$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $a99e8a83984745c9$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $a99e8a83984745c9$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $a99e8a83984745c9$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $a99e8a83984745c9$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $a99e8a83984745c9$export$d80074982803af5c(box, { x: x, y: y }) {
    $a99e8a83984745c9$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $a99e8a83984745c9$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $a99e8a83984745c9$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $a99e8a83984745c9$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $a99e8a83984745c9$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $a99e8a83984745c9$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $a99e8a83984745c9$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $9G49G.hasTransform)(node.latestValues)) $a99e8a83984745c9$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $a99e8a83984745c9$var$TREE_SCALE_SNAP_MAX && treeScale.x > $a99e8a83984745c9$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $a99e8a83984745c9$var$TREE_SCALE_SNAP_MAX && treeScale.y > $a99e8a83984745c9$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $a99e8a83984745c9$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $a99e8a83984745c9$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $aCww2.mixNumber)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $a99e8a83984745c9$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $a99e8a83984745c9$export$58b16271041fbfb(box, transform) {
    $a99e8a83984745c9$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $a99e8a83984745c9$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}

});
parcelRegister("9G49G", function(module, exports) {

$parcel$export(module.exports, "hasScale", function () { return $e9f1cdc21a39107d$export$bdf30dca883ea463; });
$parcel$export(module.exports, "hasTransform", function () { return $e9f1cdc21a39107d$export$a545127cf1fbb600; });
$parcel$export(module.exports, "has2DTranslate", function () { return $e9f1cdc21a39107d$export$bf80f5f8f4dc327f; });
function $e9f1cdc21a39107d$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $e9f1cdc21a39107d$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$e9f1cdc21a39107d$var$isIdentityScale(scale) || !$e9f1cdc21a39107d$var$isIdentityScale(scaleX) || !$e9f1cdc21a39107d$var$isIdentityScale(scaleY);
}
function $e9f1cdc21a39107d$export$a545127cf1fbb600(values) {
    return $e9f1cdc21a39107d$export$bdf30dca883ea463(values) || $e9f1cdc21a39107d$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $e9f1cdc21a39107d$export$bf80f5f8f4dc327f(values) {
    return $e9f1cdc21a39107d$var$is2DTranslate(values.x) || $e9f1cdc21a39107d$var$is2DTranslate(values.y);
}
function $e9f1cdc21a39107d$var$is2DTranslate(value) {
    return value && value !== "0%";
}

});



parcelRegister("kqnNR", function(module, exports) {

$parcel$export(module.exports, "getContextWindow", function () { return $8e8d9a3e263a5739$export$d533d84f9871c879; });
// Fixes https://github.com/motiondivision/motion/issues/2270
const $8e8d9a3e263a5739$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};

});



parcelRegister("8edVu", function(module, exports) {

$parcel$export(module.exports, "PanGesture", function () { return $326dc8b32e346a7b$export$b4f8f1ee75ce5859; });

var $eA7AD = parcelRequire("eA7AD");

var $grqSe = parcelRequire("grqSe");

var $d72GF = parcelRequire("d72GF");
parcelRequire("gxAX4");
var $j5fqa = parcelRequire("j5fqa");

var $kqnNR = parcelRequire("kqnNR");

var $5Orka = parcelRequire("5Orka");
const $326dc8b32e346a7b$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $5Orka.frame).postRender(()=>handler(event, info));
    };
class $326dc8b32e346a7b$export$b4f8f1ee75ce5859 extends (0, $d72GF.Feature) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $j5fqa.noop);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $eA7AD.PanSession)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $kqnNR.getContextWindow)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $326dc8b32e346a7b$var$asyncHandler(onPanSessionStart),
            onStart: $326dc8b32e346a7b$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $5Orka.frame).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $grqSe.addPointerEvent)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}

});

parcelRegister("ijW4B", function(module, exports) {

$parcel$export(module.exports, "MeasureLayout", function () { return $9c38174f780984e5$export$779f5fb01ad751cd; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $4wB90 = parcelRequire("4wB90");

var $b2HTw = parcelRequire("b2HTw");

var $84YNP = parcelRequire("84YNP");

var $5KynG = parcelRequire("5KynG");

var $7oK8C = parcelRequire("7oK8C");

var $9Xn5l = parcelRequire("9Xn5l");

var $bdHsB = parcelRequire("bdHsB");

var $4go82 = parcelRequire("4go82");

var $5Orka = parcelRequire("5Orka");
"use client";
class $9c38174f780984e5$var$MeasureLayoutWithContext extends (0, $8FY87.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $bdHsB.addScaleCorrector)($9c38174f780984e5$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $5KynG.globalProjectionState).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $5Orka.frame).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $4go82.microtask).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $9c38174f780984e5$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $4wB90.usePresence)();
    const layoutGroup = (0, $8FY87.useContext)((0, $b2HTw.LayoutGroupContext));
    return (0, $2PPWI.jsx)($9c38174f780984e5$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $8FY87.useContext)((0, $84YNP.SwitchLayoutGroupContext)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $9c38174f780984e5$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $7oK8C.correctBorderRadius),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $7oK8C.correctBorderRadius),
    borderTopRightRadius: (0, $7oK8C.correctBorderRadius),
    borderBottomLeftRadius: (0, $7oK8C.correctBorderRadius),
    borderBottomRightRadius: (0, $7oK8C.correctBorderRadius),
    boxShadow: (0, $9Xn5l.correctBoxShadow)
};

});
parcelRegister("84YNP", function(module, exports) {

$parcel$export(module.exports, "SwitchLayoutGroupContext", function () { return $7548e7a476453da9$export$da5f7b802957459a; });

var $8FY87 = parcelRequire("8FY87");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $7548e7a476453da9$export$da5f7b802957459a = (0, $8FY87.createContext)({});

});

parcelRegister("5KynG", function(module, exports) {

$parcel$export(module.exports, "globalProjectionState", function () { return $b9add32a87acd26b$export$97db156a3ed1593b; });
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $b9add32a87acd26b$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};

});

parcelRegister("7oK8C", function(module, exports) {

$parcel$export(module.exports, "correctBorderRadius", function () { return $c6ded5eea9d7baf5$export$5eafb6257a5844c; });

var $5arE3 = parcelRequire("5arE3");
function $c6ded5eea9d7baf5$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $c6ded5eea9d7baf5$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $5arE3.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $c6ded5eea9d7baf5$export$fafff692be55225d(latest, node.target.x);
        const y = $c6ded5eea9d7baf5$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};

});

parcelRegister("9Xn5l", function(module, exports) {

$parcel$export(module.exports, "correctBoxShadow", function () { return $8163cadceda63692$export$eb0bc629e74dcf8; });

var $aCww2 = parcelRequire("aCww2");

var $3aPzZ = parcelRequire("3aPzZ");
const $8163cadceda63692$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $3aPzZ.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $3aPzZ.complex).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $aCww2.mixNumber)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};

});

parcelRegister("bdHsB", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", function () { return $eb15ba4f29b864fa$export$91ddd985b97788d1; });
$parcel$export(module.exports, "addScaleCorrector", function () { return $eb15ba4f29b864fa$export$de9e7791c71225fd; });
const $eb15ba4f29b864fa$export$91ddd985b97788d1 = {};
function $eb15ba4f29b864fa$export$de9e7791c71225fd(correctors) {
    Object.assign($eb15ba4f29b864fa$export$91ddd985b97788d1, correctors);
}

});

parcelRegister("4go82", function(module, exports) {

$parcel$export(module.exports, "microtask", function () { return $d97463e29623f3b3$export$bb76eed83315504c; });

var $bPjUa = parcelRequire("bPjUa");
const { schedule: $d97463e29623f3b3$export$bb76eed83315504c, cancel: $d97463e29623f3b3$export$3252729004b8456e } = (0, $bPjUa.createRenderBatcher)(queueMicrotask, false);

});


parcelRegister("6xkeI", function(module, exports) {

$parcel$export(module.exports, "HTMLProjectionNode", function () { return $a107225e636a6dbd$export$b61a9eb3dbde8858; });

var $2DcIR = parcelRequire("2DcIR");

var $lrrFy = parcelRequire("lrrFy");
const $a107225e636a6dbd$export$b91509fcf893b648 = {
    current: undefined
};
const $a107225e636a6dbd$export$b61a9eb3dbde8858 = (0, $2DcIR.createProjectionNode)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$a107225e636a6dbd$export$b91509fcf893b648.current) {
            const documentNode = new (0, $lrrFy.DocumentProjectionNode)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $a107225e636a6dbd$export$b91509fcf893b648.current = documentNode;
        }
        return $a107225e636a6dbd$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});

});
parcelRegister("2DcIR", function(module, exports) {

$parcel$export(module.exports, "createProjectionNode", function () { return $4f9c83c3c7fa7d7f$export$a84b61f69daa9da0; });
parcelRequire("7Ow0h");
var $aPjDR = parcelRequire("aPjDR");
parcelRequire("gxAX4");
var $j5fqa = parcelRequire("j5fqa");

var $gcYfB = parcelRequire("gcYfB");

var $cBNAe = parcelRequire("cBNAe");

var $5Orka = parcelRequire("5Orka");

var $4go82 = parcelRequire("4go82");

var $k83cl = parcelRequire("k83cl");

var $ArOHJ = parcelRequire("ArOHJ");

var $3ne85 = parcelRequire("3ne85");

var $j1IcX = parcelRequire("j1IcX");

var $laRzS = parcelRequire("laRzS");

var $aCww2 = parcelRequire("aCww2");

var $aQwlE = parcelRequire("aQwlE");

var $ghoe6 = parcelRequire("ghoe6");

var $ihbCv = parcelRequire("ihbCv");

var $heq6H = parcelRequire("heq6H");

var $ePypE = parcelRequire("ePypE");

var $1Bv54 = parcelRequire("1Bv54");

var $eaj70 = parcelRequire("eaj70");

var $6lXUx = parcelRequire("6lXUx");

var $dEVqe = parcelRequire("dEVqe");

var $gFnwd = parcelRequire("gFnwd");

var $bdHsB = parcelRequire("bdHsB");

var $eGZeP = parcelRequire("eGZeP");

var $ej3WU = parcelRequire("ej3WU");

var $9G49G = parcelRequire("9G49G");

var $5KynG = parcelRequire("5KynG");
const $4f9c83c3c7fa7d7f$var$metrics = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
const $4f9c83c3c7fa7d7f$var$isDebug = typeof window !== "undefined" && window.MotionDebug !== undefined;
const $4f9c83c3c7fa7d7f$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $4f9c83c3c7fa7d7f$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $4f9c83c3c7fa7d7f$var$animationTarget = 1000;
let $4f9c83c3c7fa7d7f$var$id = 0;
function $4f9c83c3c7fa7d7f$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $4f9c83c3c7fa7d7f$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $cBNAe.getOptimisedAppearId)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $5Orka.frame), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $4f9c83c3c7fa7d7f$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $4f9c83c3c7fa7d7f$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $4f9c83c3c7fa7d7f$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ($4f9c83c3c7fa7d7f$var$isDebug) $4f9c83c3c7fa7d7f$var$metrics.totalNodes = $4f9c83c3c7fa7d7f$var$metrics.resolvedTargetDeltas = $4f9c83c3c7fa7d7f$var$metrics.recalculatedProjection = 0;
                this.nodes.forEach($4f9c83c3c7fa7d7f$export$131f2f0cc5fe9609);
                this.nodes.forEach($4f9c83c3c7fa7d7f$var$resolveTargetDelta);
                this.nodes.forEach($4f9c83c3c7fa7d7f$var$calcProjection);
                this.nodes.forEach($4f9c83c3c7fa7d7f$export$c2664f37bc951031);
                if ($4f9c83c3c7fa7d7f$var$isDebug) window.MotionDebug.record($4f9c83c3c7fa7d7f$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $3ne85.FlatTree)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $aQwlE.SubscriptionManager)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $ArOHJ.isSVGElement)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $laRzS.delay)(resizeUnblockUpdate, 250);
                    if ((0, $5KynG.globalProjectionState).hasAnimatedSinceResize) {
                        (0, $5KynG.globalProjectionState).hasAnimatedSinceResize = false;
                        this.nodes.forEach($4f9c83c3c7fa7d7f$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $4f9c83c3c7fa7d7f$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $dEVqe.boxEqualsRounded)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $aPjDR.getValueTransition)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $4f9c83c3c7fa7d7f$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $5Orka.cancelFrame)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($4f9c83c3c7fa7d7f$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $4f9c83c3c7fa7d7f$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($4f9c83c3c7fa7d7f$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($4f9c83c3c7fa7d7f$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($4f9c83c3c7fa7d7f$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($4f9c83c3c7fa7d7f$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($4f9c83c3c7fa7d7f$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $k83cl.time).now();
            (0, $5Orka.frameData).delta = (0, $j1IcX.clamp)(0, 1000 / 60, now - (0, $5Orka.frameData).timestamp);
            (0, $5Orka.frameData).timestamp = now;
            (0, $5Orka.frameData).isProcessing = true;
            (0, $5Orka.frameSteps).update.process((0, $5Orka.frameData));
            (0, $5Orka.frameSteps).preRender.process((0, $5Orka.frameData));
            (0, $5Orka.frameSteps).render.process((0, $5Orka.frameData));
            (0, $5Orka.frameData).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $4go82.microtask).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($4f9c83c3c7fa7d7f$var$clearSnapshot);
            this.sharedNodes.forEach($4f9c83c3c7fa7d7f$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $5Orka.frame).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $5Orka.frame).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $6lXUx.createBox)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $dEVqe.isDeltaZero)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $9G49G.hasTransform)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $4f9c83c3c7fa7d7f$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $6lXUx.createBox)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some($4f9c83c3c7fa7d7f$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $ePypE.translateAxis)(box.x, scroll.offset.x);
                    (0, $ePypE.translateAxis)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = (0, $6lXUx.createBox)();
            (0, $heq6H.copyBoxInto)(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $heq6H.copyBoxInto)(boxWithoutScroll, box);
                    (0, $ePypE.translateAxis)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $ePypE.translateAxis)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $6lXUx.createBox)();
            (0, $heq6H.copyBoxInto)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $ePypE.transformBox)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $9G49G.hasTransform)(node.latestValues)) continue;
                (0, $ePypE.transformBox)(withTransforms, node.latestValues);
            }
            if ((0, $9G49G.hasTransform)(this.latestValues)) (0, $ePypE.transformBox)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $6lXUx.createBox)();
            (0, $heq6H.copyBoxInto)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $9G49G.hasTransform)(node.latestValues)) continue;
                (0, $9G49G.hasScale)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $6lXUx.createBox)();
                const nodeBox = node.measurePageBox();
                (0, $heq6H.copyBoxInto)(sourceBox, nodeBox);
                (0, $eaj70.removeBoxTransforms)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $9G49G.hasTransform)(this.latestValues)) (0, $eaj70.removeBoxTransforms)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $5Orka.frameData).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $5Orka.frameData).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $6lXUx.createBox)();
                    this.relativeTargetOrigin = (0, $6lXUx.createBox)();
                    (0, $1Bv54.calcRelativePosition)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $heq6H.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $6lXUx.createBox)();
                this.targetWithTransforms = (0, $6lXUx.createBox)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $1Bv54.calcRelativeBox)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $heq6H.copyBoxInto)(this.target, this.layout.layoutBox);
                (0, $ePypE.applyBoxDelta)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $heq6H.copyBoxInto)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $6lXUx.createBox)();
                    this.relativeTargetOrigin = (0, $6lXUx.createBox)();
                    (0, $1Bv54.calcRelativePosition)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $heq6H.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ($4f9c83c3c7fa7d7f$var$isDebug) $4f9c83c3c7fa7d7f$var$metrics.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $9G49G.hasScale)(this.parent.latestValues) || (0, $9G49G.has2DTranslate)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $5Orka.frameData).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $heq6H.copyBoxInto)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $ePypE.applyTreeDeltas)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $6lXUx.createBox)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $heq6H.copyAxisDeltaInto)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $heq6H.copyAxisDeltaInto)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $1Bv54.calcBoxDelta)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $dEVqe.axisDeltaEquals)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $dEVqe.axisDeltaEquals)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ($4f9c83c3c7fa7d7f$var$isDebug) $4f9c83c3c7fa7d7f$var$metrics.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 || _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $6lXUx.createDelta)();
            this.projectionDelta = (0, $6lXUx.createDelta)();
            this.projectionDeltaWithTransform = (0, $6lXUx.createDelta)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $6lXUx.createDelta)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $6lXUx.createBox)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($4f9c83c3c7fa7d7f$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $4f9c83c3c7fa7d7f$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $4f9c83c3c7fa7d7f$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $1Bv54.calcRelativePosition)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $4f9c83c3c7fa7d7f$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $dEVqe.boxEquals)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $6lXUx.createBox)();
                    (0, $heq6H.copyBoxInto)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $ihbCv.mixValues)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $5Orka.cancelFrame)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $5Orka.frame).update(()=>{
                (0, $5KynG.globalProjectionState).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $gcYfB.animateSingleValue)(0, $4f9c83c3c7fa7d7f$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($4f9c83c3c7fa7d7f$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $4f9c83c3c7fa7d7f$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $6lXUx.createBox)();
                const xLength = (0, $1Bv54.calcLength)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $1Bv54.calcLength)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $heq6H.copyBoxInto)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $ePypE.transformBox)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $1Bv54.calcBoxDelta)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $gFnwd.NodeStack)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $4f9c83c3c7fa7d7f$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $4f9c83c3c7fa7d7f$var$transformAxes.length; i++){
                $4f9c83c3c7fa7d7f$var$resetDistortingTransform(`rotate${$4f9c83c3c7fa7d7f$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $4f9c83c3c7fa7d7f$var$resetDistortingTransform(`skew${$4f9c83c3c7fa7d7f$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $4f9c83c3c7fa7d7f$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $ghoe6.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $ghoe6.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $9G49G.hasTransform)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $eGZeP.buildProjectionTransform)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $bdHsB.scaleCorrectors){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $bdHsB.scaleCorrectors)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $ghoe6.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($4f9c83c3c7fa7d7f$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $4f9c83c3c7fa7d7f$var$updateLayout(node) {
    node.updateLayout();
}
function $4f9c83c3c7fa7d7f$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $ej3WU.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $1Bv54.calcLength)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($4f9c83c3c7fa7d7f$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $ej3WU.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $1Bv54.calcLength)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $6lXUx.createDelta)();
        (0, $1Bv54.calcBoxDelta)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $6lXUx.createDelta)();
        if (isShared) (0, $1Bv54.calcBoxDelta)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $1Bv54.calcBoxDelta)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $dEVqe.isDeltaZero)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $6lXUx.createBox)();
                    (0, $1Bv54.calcRelativePosition)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $6lXUx.createBox)();
                    (0, $1Bv54.calcRelativePosition)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $dEVqe.boxEqualsRounded)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $4f9c83c3c7fa7d7f$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ($4f9c83c3c7fa7d7f$var$isDebug) $4f9c83c3c7fa7d7f$var$metrics.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $4f9c83c3c7fa7d7f$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $4f9c83c3c7fa7d7f$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $4f9c83c3c7fa7d7f$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $4f9c83c3c7fa7d7f$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $4f9c83c3c7fa7d7f$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $4f9c83c3c7fa7d7f$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $4f9c83c3c7fa7d7f$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $4f9c83c3c7fa7d7f$var$calcProjection(node) {
    node.calcProjection();
}
function $4f9c83c3c7fa7d7f$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $4f9c83c3c7fa7d7f$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $4f9c83c3c7fa7d7f$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $aCww2.mixNumber)(delta.translate, 0, p);
    output.scale = (0, $aCww2.mixNumber)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $4f9c83c3c7fa7d7f$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $aCww2.mixNumber)(from.min, to.min, p);
    output.max = (0, $aCww2.mixNumber)(from.max, to.max, p);
}
function $4f9c83c3c7fa7d7f$export$6ffd3e6ae339a132(output, from, to, p) {
    $4f9c83c3c7fa7d7f$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $4f9c83c3c7fa7d7f$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $4f9c83c3c7fa7d7f$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $4f9c83c3c7fa7d7f$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $4f9c83c3c7fa7d7f$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $4f9c83c3c7fa7d7f$var$roundPoint = $4f9c83c3c7fa7d7f$var$userAgentContains("applewebkit/") && !$4f9c83c3c7fa7d7f$var$userAgentContains("chrome/") ? Math.round : (0, $j5fqa.noop);
function $4f9c83c3c7fa7d7f$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $4f9c83c3c7fa7d7f$var$roundPoint(axis.min);
    axis.max = $4f9c83c3c7fa7d7f$var$roundPoint(axis.max);
}
function $4f9c83c3c7fa7d7f$var$roundBox(box) {
    $4f9c83c3c7fa7d7f$var$roundAxis(box.x);
    $4f9c83c3c7fa7d7f$var$roundAxis(box.y);
}
function $4f9c83c3c7fa7d7f$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $1Bv54.isNear)((0, $dEVqe.aspectRatio)(snapshot), (0, $dEVqe.aspectRatio)(layout), 0.2);
}
function $4f9c83c3c7fa7d7f$var$checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}

});
parcelRegister("gcYfB", function(module, exports) {

$parcel$export(module.exports, "animateSingleValue", function () { return $03f715f6438015f9$export$335a17c977067b99; });

var $apeLX = parcelRequire("apeLX");

var $dOcpx = parcelRequire("dOcpx");

var $6LTw8 = parcelRequire("6LTw8");
function $03f715f6438015f9$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $dOcpx.isMotionValue)(value) ? value : (0, $apeLX.motionValue)(value);
    motionValue$1.start((0, $6LTw8.animateMotionValue)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

});

parcelRegister("ArOHJ", function(module, exports) {

$parcel$export(module.exports, "isSVGElement", function () { return $a33ab7cf24f30bc1$export$17eda790a720ec57; });
function $a33ab7cf24f30bc1$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}

});

parcelRegister("3ne85", function(module, exports) {

$parcel$export(module.exports, "FlatTree", function () { return $107a415b7c05da39$export$1465d17e3de78a96; });

var $8jGnO = parcelRequire("8jGnO");

var $k6ItP = parcelRequire("k6ItP");
class $107a415b7c05da39$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $8jGnO.addUniqueItem)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $8jGnO.removeItem)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $k6ItP.compareByDepth));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}

});
parcelRegister("k6ItP", function(module, exports) {

$parcel$export(module.exports, "compareByDepth", function () { return $d6ad9a5aec3d5cf1$export$d689d9dec5ad338; });
const $d6ad9a5aec3d5cf1$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;

});


parcelRegister("laRzS", function(module, exports) {

$parcel$export(module.exports, "delay", function () { return $a8609c0b7141f36b$export$1391212d75b2ee65; });
parcelRequire("gxAX4");
var $eJ1nu = parcelRequire("eJ1nu");

var $k83cl = parcelRequire("k83cl");

var $5Orka = parcelRequire("5Orka");
/**
 * Timeout defined in ms
 */ function $a8609c0b7141f36b$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $k83cl.time).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $5Orka.cancelFrame)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $5Orka.frame).read(checkElapsed, true);
    return ()=>(0, $5Orka.cancelFrame)(checkElapsed);
}
function $a8609c0b7141f36b$export$fcd451ca460f8a2a(callback, timeout) {
    return $a8609c0b7141f36b$export$1391212d75b2ee65(callback, (0, $eJ1nu.secondsToMilliseconds)(timeout));
}

});

parcelRegister("ghoe6", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", function () { return $dac10fa8bebe74ab$export$fcc2206ecb6d74b; });

var $95tho = parcelRequire("95tho");

var $dOcpx = parcelRequire("dOcpx");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $dac10fa8bebe74ab$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $dOcpx.isMotionValue)(value) ? value.get() : value;
    return (0, $95tho.isCustomValue)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

});

parcelRegister("ihbCv", function(module, exports) {

$parcel$export(module.exports, "mixValues", function () { return $7ebe9a8042beec85$export$739e279c17d51c3d; });
parcelRequire("gxAX4");
var $j5fqa = parcelRequire("j5fqa");
var $2UGlP = parcelRequire("2UGlP");

var $fYI2h = parcelRequire("fYI2h");

var $aCww2 = parcelRequire("aCww2");

var $5arE3 = parcelRequire("5arE3");
const $7ebe9a8042beec85$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $7ebe9a8042beec85$var$numBorders = $7ebe9a8042beec85$var$borders.length;
const $7ebe9a8042beec85$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $7ebe9a8042beec85$var$isPx = (value)=>typeof value === "number" || (0, $5arE3.px).test(value);
function $7ebe9a8042beec85$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $aCww2.mixNumber)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $7ebe9a8042beec85$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $aCww2.mixNumber)(follow.opacity !== undefined ? follow.opacity : 1, 0, $7ebe9a8042beec85$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $aCww2.mixNumber)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $7ebe9a8042beec85$var$numBorders; i++){
        const borderLabel = `border${$7ebe9a8042beec85$var$borders[i]}Radius`;
        let followRadius = $7ebe9a8042beec85$var$getRadius(follow, borderLabel);
        let leadRadius = $7ebe9a8042beec85$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $7ebe9a8042beec85$var$isPx(followRadius) === $7ebe9a8042beec85$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $aCww2.mixNumber)($7ebe9a8042beec85$var$asNumber(followRadius), $7ebe9a8042beec85$var$asNumber(leadRadius), progress), 0);
            if ((0, $5arE3.percent).test(leadRadius) || (0, $5arE3.percent).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $aCww2.mixNumber)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $7ebe9a8042beec85$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $7ebe9a8042beec85$var$easeCrossfadeIn = /*@__PURE__*/ $7ebe9a8042beec85$var$compress(0, 0.5, (0, $fYI2h.circOut));
const $7ebe9a8042beec85$var$easeCrossfadeOut = /*@__PURE__*/ $7ebe9a8042beec85$var$compress(0.5, 0.95, (0, $j5fqa.noop));
function $7ebe9a8042beec85$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $2UGlP.progress)(min, max, p));
    };
}

});

parcelRegister("heq6H", function(module, exports) {

$parcel$export(module.exports, "copyBoxInto", function () { return $cc9af628393a665a$export$c53fd88f45d77e4b; });
$parcel$export(module.exports, "copyAxisDeltaInto", function () { return $cc9af628393a665a$export$8ead6a7d6b225ef; });
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $cc9af628393a665a$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $cc9af628393a665a$export$c53fd88f45d77e4b(box, originBox) {
    $cc9af628393a665a$export$a0230ae482601ae8(box.x, originBox.x);
    $cc9af628393a665a$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $cc9af628393a665a$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}

});

parcelRegister("eaj70", function(module, exports) {

$parcel$export(module.exports, "removeBoxTransforms", function () { return $8078103c5d4a0a7d$export$73e1ad0a9694e25c; });

var $aCww2 = parcelRequire("aCww2");

var $5arE3 = parcelRequire("5arE3");

var $ePypE = parcelRequire("ePypE");
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $8078103c5d4a0a7d$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $ePypE.scalePoint)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $ePypE.scalePoint)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $8078103c5d4a0a7d$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $5arE3.percent).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $aCww2.mixNumber)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $aCww2.mixNumber)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $8078103c5d4a0a7d$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $8078103c5d4a0a7d$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $8078103c5d4a0a7d$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $8078103c5d4a0a7d$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $8078103c5d4a0a7d$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $8078103c5d4a0a7d$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $8078103c5d4a0a7d$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $8078103c5d4a0a7d$export$42b76f1d0d16d5b(box.x, transforms, $8078103c5d4a0a7d$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $8078103c5d4a0a7d$export$42b76f1d0d16d5b(box.y, transforms, $8078103c5d4a0a7d$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

});

parcelRegister("dEVqe", function(module, exports) {

$parcel$export(module.exports, "isDeltaZero", function () { return $87c13487f9d16e0c$export$a7ec7642fe550fb6; });
$parcel$export(module.exports, "boxEquals", function () { return $87c13487f9d16e0c$export$8d5cf76bb7daff09; });
$parcel$export(module.exports, "boxEqualsRounded", function () { return $87c13487f9d16e0c$export$ef641b782d85522; });
$parcel$export(module.exports, "aspectRatio", function () { return $87c13487f9d16e0c$export$c5706146bc63213; });
$parcel$export(module.exports, "axisDeltaEquals", function () { return $87c13487f9d16e0c$export$444620505e28fe92; });

var $1Bv54 = parcelRequire("1Bv54");
function $87c13487f9d16e0c$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $87c13487f9d16e0c$export$a7ec7642fe550fb6(delta) {
    return $87c13487f9d16e0c$var$isAxisDeltaZero(delta.x) && $87c13487f9d16e0c$var$isAxisDeltaZero(delta.y);
}
function $87c13487f9d16e0c$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $87c13487f9d16e0c$export$8d5cf76bb7daff09(a, b) {
    return $87c13487f9d16e0c$export$7a9a6f114ddd0fdb(a.x, b.x) && $87c13487f9d16e0c$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $87c13487f9d16e0c$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $87c13487f9d16e0c$export$ef641b782d85522(a, b) {
    return $87c13487f9d16e0c$export$22adf28bfca1c186(a.x, b.x) && $87c13487f9d16e0c$export$22adf28bfca1c186(a.y, b.y);
}
function $87c13487f9d16e0c$export$c5706146bc63213(box) {
    return (0, $1Bv54.calcLength)(box.x) / (0, $1Bv54.calcLength)(box.y);
}
function $87c13487f9d16e0c$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}

});

parcelRegister("gFnwd", function(module, exports) {

$parcel$export(module.exports, "NodeStack", function () { return $e27abd77bb0789bc$export$39be5b2d82fc9dc7; });

var $8jGnO = parcelRequire("8jGnO");
class $e27abd77bb0789bc$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $8jGnO.addUniqueItem)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $8jGnO.removeItem)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}

});

parcelRegister("eGZeP", function(module, exports) {

$parcel$export(module.exports, "buildProjectionTransform", function () { return $ca6c6bcebb81d543$export$d33653b270fe725c; });
function $ca6c6bcebb81d543$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}

});


parcelRegister("lrrFy", function(module, exports) {

$parcel$export(module.exports, "DocumentProjectionNode", function () { return $2aacce69df227839$export$2d029a49a09b6177; });

var $2DcIR = parcelRequire("2DcIR");

var $bnFL7 = parcelRequire("bnFL7");
const $2aacce69df227839$export$2d029a49a09b6177 = (0, $2DcIR.createProjectionNode)({
    attachResizeListener: (ref, notify)=>(0, $bnFL7.addDomEvent)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});

});



parcelRegister("hBQm6", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", function () { return $e0b72b7d91d47761$export$e5b72898e5a201f1; });

var $hSogH = parcelRequire("hSogH");

var $61007 = parcelRequire("61007");

var $9hujZ = parcelRequire("9hujZ");

var $gOr5N = parcelRequire("gOr5N");
const $e0b72b7d91d47761$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $gOr5N.InViewFeature)
    },
    tap: {
        Feature: (0, $9hujZ.PressGesture)
    },
    focus: {
        Feature: (0, $61007.FocusGesture)
    },
    hover: {
        Feature: (0, $hSogH.HoverGesture)
    }
};

});
parcelRegister("hSogH", function(module, exports) {

$parcel$export(module.exports, "HoverGesture", function () { return $24f4dfc6049c26b0$export$93a81ea037eac456; });

var $d72GF = parcelRequire("d72GF");
parcelRequire("7Ow0h");
var $jicDV = parcelRequire("jicDV");

var $TUqSB = parcelRequire("TUqSB");

var $5Orka = parcelRequire("5Orka");
function $24f4dfc6049c26b0$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $5Orka.frame).postRender(()=>callback(event, (0, $TUqSB.extractEventInfo)(event)));
}
class $24f4dfc6049c26b0$export$93a81ea037eac456 extends (0, $d72GF.Feature) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $jicDV.hover)(current, (startEvent)=>{
            $24f4dfc6049c26b0$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$24f4dfc6049c26b0$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}

});

parcelRegister("61007", function(module, exports) {

$parcel$export(module.exports, "FocusGesture", function () { return $d9817c94f0bb1283$export$d4826db40d47595b; });

var $bnFL7 = parcelRequire("bnFL7");

var $d72GF = parcelRequire("d72GF");

var $1bJJj = parcelRequire("1bJJj");
class $d9817c94f0bb1283$export$d4826db40d47595b extends (0, $d72GF.Feature) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $1bJJj.pipe)((0, $bnFL7.addDomEvent)(this.node.current, "focus", ()=>this.onFocus()), (0, $bnFL7.addDomEvent)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}

});

parcelRegister("9hujZ", function(module, exports) {

$parcel$export(module.exports, "PressGesture", function () { return $f8cc4ef4e17254f8$export$f026abdbba7f0c9e; });

var $d72GF = parcelRequire("d72GF");
parcelRequire("7Ow0h");
var $aMjVo = parcelRequire("aMjVo");

var $TUqSB = parcelRequire("TUqSB");

var $5Orka = parcelRequire("5Orka");
function $f8cc4ef4e17254f8$var$handlePressEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $5Orka.frame).postRender(()=>callback(event, (0, $TUqSB.extractEventInfo)(event)));
}
class $f8cc4ef4e17254f8$export$f026abdbba7f0c9e extends (0, $d72GF.Feature) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $aMjVo.press)(current, (startEvent)=>{
            $f8cc4ef4e17254f8$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success })=>$f8cc4ef4e17254f8$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: this.node.props.globalTapTarget
        });
    }
    unmount() {}
}

});

parcelRegister("gOr5N", function(module, exports) {

$parcel$export(module.exports, "InViewFeature", function () { return $b968952f84795565$export$150851c8cc2f0c72; });

var $d72GF = parcelRequire("d72GF");

var $anqGh = parcelRequire("anqGh");
const $b968952f84795565$var$thresholdNames = {
    some: 0,
    all: 1
};
class $b968952f84795565$export$150851c8cc2f0c72 extends (0, $d72GF.Feature) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $b968952f84795565$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $anqGh.observeIntersection)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($b968952f84795565$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $b968952f84795565$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}

});
parcelRegister("anqGh", function(module, exports) {

$parcel$export(module.exports, "observeIntersection", function () { return $1dd9f5eb8e2be645$export$b2bcd62fb7925aa5; });
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $1dd9f5eb8e2be645$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $1dd9f5eb8e2be645$var$observers = new WeakMap();
const $1dd9f5eb8e2be645$var$fireObserverCallback = (entry)=>{
    const callback = $1dd9f5eb8e2be645$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $1dd9f5eb8e2be645$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($1dd9f5eb8e2be645$var$fireObserverCallback);
};
function $1dd9f5eb8e2be645$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$1dd9f5eb8e2be645$var$observers.has(lookupRoot)) $1dd9f5eb8e2be645$var$observers.set(lookupRoot, {});
    const rootObservers = $1dd9f5eb8e2be645$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($1dd9f5eb8e2be645$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $1dd9f5eb8e2be645$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $1dd9f5eb8e2be645$var$initIntersectionObserver(options);
    $1dd9f5eb8e2be645$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $1dd9f5eb8e2be645$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

});



parcelRegister("jk1q1", function(module, exports) {

$parcel$export(module.exports, "layout", function () { return $e94bac147d39cdaf$export$b3219800bda33a1f; });

var $6xkeI = parcelRequire("6xkeI");

var $ijW4B = parcelRequire("ijW4B");
const $e94bac147d39cdaf$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $6xkeI.HTMLProjectionNode),
        MeasureLayout: $ijW4B.MeasureLayout
    }
};

});

parcelRegister("ggmR6", function(module, exports) {

$parcel$export(module.exports, "createMotionComponentFactory", function () { return $1a2bbd40621639cc$export$d86feac869a7f0d5; });

var $9OLZt = parcelRequire("9OLZt");

var $77evI = parcelRequire("77evI");

var $a9TPC = parcelRequire("a9TPC");

var $6fpjr = parcelRequire("6fpjr");

var $5jOOJ = parcelRequire("5jOOJ");
function $1a2bbd40621639cc$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $77evI.isSVGComponent)(Component) ? (0, $a9TPC.svgMotionConfig) : (0, $6fpjr.htmlMotionConfig);
        const config = {
            ...baseConfig,
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $5jOOJ.createUseRender)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        };
        return (0, $9OLZt.createRendererMotionComponent)(config);
    };
}

});
parcelRegister("9OLZt", function(module, exports) {

$parcel$export(module.exports, "createRendererMotionComponent", function () { return $a36eb0ac151be800$export$c3ad4a902bccc2d8; });

var $2PPWI = parcelRequire("2PPWI");
parcelRequire("gxAX4");

var $8FY87 = parcelRequire("8FY87");

var $b2HTw = parcelRequire("b2HTw");

var $jFo3K = parcelRequire("jFo3K");

var $2WRim = parcelRequire("2WRim");

var $aZ8da = parcelRequire("aZ8da");

var $dXuDq = parcelRequire("dXuDq");

var $4N4vL = parcelRequire("4N4vL");

var $huw9a = parcelRequire("huw9a");

var $idIju = parcelRequire("idIju");

var $1ofBB = parcelRequire("1ofBB");

var $ao4L1 = parcelRequire("ao4L1");

var $koHnp = parcelRequire("koHnp");
"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $a36eb0ac151be800$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    var _a, _b;
    preloadedFeatures && (0, $idIju.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $8FY87.useContext)((0, $2WRim.MotionConfigContext)),
            ...props,
            layoutId: $a36eb0ac151be800$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $dXuDq.useCreateMotionContext)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $4N4vL.isBrowser)) {
            $a36eb0ac151be800$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $a36eb0ac151be800$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $koHnp.useVisualElement)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $2PPWI.jsxs)((0, $aZ8da.MotionContext).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $2PPWI.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $ao4L1.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    MotionComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${(_b = (_a = Component.displayName) !== null && _a !== void 0 ? _a : Component.name) !== null && _b !== void 0 ? _b : ""})`}`;
    const ForwardRefMotionComponent = (0, $8FY87.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $1ofBB.motionComponentSymbol] = Component;
    return ForwardRefMotionComponent;
}
function $a36eb0ac151be800$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $8FY87.useContext)((0, $b2HTw.LayoutGroupContext)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $a36eb0ac151be800$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $8FY87.useContext)((0, $jFo3K.LazyContext)).strict;
}
function $a36eb0ac151be800$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $huw9a.featureDefinitions);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}

});
parcelRegister("jFo3K", function(module, exports) {

$parcel$export(module.exports, "LazyContext", function () { return $72adf3fe06125ed3$export$40f10139ecf1f171; });

var $8FY87 = parcelRequire("8FY87");
"use client";
const $72adf3fe06125ed3$export$40f10139ecf1f171 = (0, $8FY87.createContext)({
    strict: false
});

});

parcelRegister("aZ8da", function(module, exports) {

$parcel$export(module.exports, "MotionContext", function () { return $5e942ad6283d4871$export$2285bbca2c666415; });

var $8FY87 = parcelRequire("8FY87");
"use client";
const $5e942ad6283d4871$export$2285bbca2c666415 = (0, $8FY87.createContext)({});

});

parcelRegister("dXuDq", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", function () { return $a931e2694f66365d$export$c5638d843b37a176; });

var $8FY87 = parcelRequire("8FY87");

var $aZ8da = parcelRequire("aZ8da");

var $2H1cl = parcelRequire("2H1cl");
function $a931e2694f66365d$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $2H1cl.getCurrentTreeVariants)(props, (0, $8FY87.useContext)((0, $aZ8da.MotionContext)));
    return (0, $8FY87.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $a931e2694f66365d$var$variantLabelsAsDependency(initial),
        $a931e2694f66365d$var$variantLabelsAsDependency(animate)
    ]);
}
function $a931e2694f66365d$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("2H1cl", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", function () { return $192ec766db434201$export$12fc32fc096a04a3; });

var $ipk3v = parcelRequire("ipk3v");

var $ckGM8 = parcelRequire("ckGM8");
function $192ec766db434201$export$12fc32fc096a04a3(props, context) {
    if ((0, $ckGM8.isControllingVariants)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $ipk3v.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $ipk3v.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});
parcelRegister("ckGM8", function(module, exports) {

$parcel$export(module.exports, "isControllingVariants", function () { return $f4c0cb1ca851316c$export$4b3c3bd8d910d78d; });
$parcel$export(module.exports, "isVariantNode", function () { return $f4c0cb1ca851316c$export$ce46fa4165cdec40; });

var $4hf94 = parcelRequire("4hf94");

var $ipk3v = parcelRequire("ipk3v");

var $cV5Fz = parcelRequire("cV5Fz");
function $f4c0cb1ca851316c$export$4b3c3bd8d910d78d(props) {
    return (0, $4hf94.isAnimationControls)(props.animate) || (0, $cV5Fz.variantProps).some((name)=>(0, $ipk3v.isVariantLabel)(props[name]));
}
function $f4c0cb1ca851316c$export$ce46fa4165cdec40(props) {
    return Boolean($f4c0cb1ca851316c$export$4b3c3bd8d910d78d(props) || props.variants);
}

});



parcelRegister("huw9a", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", function () { return $a2d396c79201195a$export$65570e08d843624d; });
const $a2d396c79201195a$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $a2d396c79201195a$export$65570e08d843624d = {};
for(const key in $a2d396c79201195a$var$featureProps)$a2d396c79201195a$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$a2d396c79201195a$var$featureProps[key].some((name)=>!!props[name])
};

});

parcelRegister("idIju", function(module, exports) {

$parcel$export(module.exports, "loadFeatures", function () { return $cde47b58e3aed51d$export$449561ec5703cdc8; });

var $huw9a = parcelRequire("huw9a");
function $cde47b58e3aed51d$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $huw9a.featureDefinitions)[key] = {
        ...(0, $huw9a.featureDefinitions)[key],
        ...features[key]
    };
}

});

parcelRegister("1ofBB", function(module, exports) {

$parcel$export(module.exports, "motionComponentSymbol", function () { return $f2c85e92b449b541$export$28e2e4cce424ae23; });
const $f2c85e92b449b541$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");

});

parcelRegister("ao4L1", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", function () { return $020abefc68ddb528$export$c684914703d321fd; });

var $8FY87 = parcelRequire("8FY87");

var $98dna = parcelRequire("98dna");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $020abefc68ddb528$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $8FY87.useCallback)((instance)=>{
        if (instance) visualState.onMount && visualState.onMount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $98dna.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

});

parcelRegister("koHnp", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", function () { return $7b1baa912746ca03$export$dc0335d73ab0b115; });

var $8FY87 = parcelRequire("8FY87");

var $kL7gn = parcelRequire("kL7gn");

var $aZ8da = parcelRequire("aZ8da");

var $foA0a = parcelRequire("foA0a");

var $jFo3K = parcelRequire("jFo3K");

var $2WRim = parcelRequire("2WRim");

var $3eWnz = parcelRequire("3eWnz");

var $4go82 = parcelRequire("4go82");

var $98dna = parcelRequire("98dna");

var $84YNP = parcelRequire("84YNP");
function $7b1baa912746ca03$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a, _b;
    const { visualElement: parent } = (0, $8FY87.useContext)((0, $aZ8da.MotionContext));
    const lazyContext = (0, $8FY87.useContext)((0, $jFo3K.LazyContext));
    const presenceContext = (0, $8FY87.useContext)((0, $kL7gn.PresenceContext));
    const reducedMotionConfig = (0, $8FY87.useContext)((0, $2WRim.MotionConfigContext)).reducedMotion;
    const visualElementRef = (0, $8FY87.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $8FY87.useContext)((0, $84YNP.SwitchLayoutGroupContext));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $7b1baa912746ca03$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $8FY87.useRef)(false);
    (0, $8FY87.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $3eWnz.optimizedAppearDataAttribute];
    const wantsHandoff = (0, $8FY87.useRef)(Boolean(optimisedAppearId) && !((_a = window.MotionHandoffIsComplete) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)) && ((_b = window.MotionHasOptimisedAnimation) === null || _b === void 0 ? void 0 : _b.call(window, optimisedAppearId)));
    (0, $foA0a.useIsomorphicLayoutEffect)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        (0, $4go82.microtask).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $8FY87.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                var _a;
                (_a = window.MotionHandoffMarkAsComplete) === null || _a === void 0 || _a.call(window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
    });
    return visualElement;
}
function $7b1baa912746ca03$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $7b1baa912746ca03$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $98dna.isRefObject)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $7b1baa912746ca03$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $7b1baa912746ca03$var$getClosestProjectingNode(visualElement.parent);
}

});


parcelRegister("77evI", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", function () { return $dadd5176b64c9635$export$88f3fc2fd3766989; });

var $22VTS = parcelRequire("22VTS");
function $dadd5176b64c9635$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $22VTS.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}

});
parcelRegister("22VTS", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", function () { return $75009b6d9e306a51$export$40209c4c512158e6; });
/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $75009b6d9e306a51$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];

});


parcelRegister("a9TPC", function(module, exports) {

$parcel$export(module.exports, "svgMotionConfig", function () { return $db8a7e4b10e2e355$export$44dabd3fae512e85; });

var $5Orka = parcelRequire("5Orka");

var $bN1Az = parcelRequire("bN1Az");

var $e3WlB = parcelRequire("e3WlB");

var $ilbNQ = parcelRequire("ilbNQ");

var $3TImI = parcelRequire("3TImI");

var $i9CT4 = parcelRequire("i9CT4");

var $cYGcE = parcelRequire("cYGcE");

var $cvw68 = parcelRequire("cvw68");
function $db8a7e4b10e2e355$var$updateSVGDimensions(instance, renderState) {
    try {
        renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
    } catch (e) {
        // Most likely trying to measure an unrendered element under Firefox
        renderState.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}
const $db8a7e4b10e2e355$var$layoutProps = [
    "x",
    "y",
    "width",
    "height",
    "cx",
    "cy",
    "r"
];
const $db8a7e4b10e2e355$export$44dabd3fae512e85 = {
    useVisualState: (0, $bN1Az.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $cvw68.scrapeMotionValuesFromProps),
        createRenderState: (0, $3TImI.createSvgRenderState),
        onUpdate: ({ props: props, prevProps: prevProps, current: current, renderState: renderState, latestValues: latestValues })=>{
            if (!current) return;
            let hasTransform = !!props.drag;
            if (!hasTransform) {
                for(const key in latestValues)if ((0, $e3WlB.transformProps).has(key)) {
                    hasTransform = true;
                    break;
                }
            }
            if (!hasTransform) return;
            let needsMeasure = !prevProps;
            if (prevProps) /**
                 * Check the layout props for changes, if any are found we need to
                 * measure the element again.
                 */ for(let i = 0; i < $db8a7e4b10e2e355$var$layoutProps.length; i++){
                const key = $db8a7e4b10e2e355$var$layoutProps[i];
                if (props[key] !== prevProps[key]) needsMeasure = true;
            }
            if (!needsMeasure) return;
            (0, $5Orka.frame).read(()=>{
                $db8a7e4b10e2e355$var$updateSVGDimensions(current, renderState);
                (0, $5Orka.frame).render(()=>{
                    (0, $ilbNQ.buildSVGAttrs)(renderState, latestValues, (0, $i9CT4.isSVGTag)(current.tagName), props.transformTemplate);
                    (0, $cYGcE.renderSVG)(current, renderState);
                });
            });
        }
    })
};

});
parcelRegister("bN1Az", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", function () { return $532c1da023c12ce0$export$e91e107bc6d03a8e; });

var $8FY87 = parcelRequire("8FY87");

var $4hf94 = parcelRequire("4hf94");

var $aZ8da = parcelRequire("aZ8da");

var $kL7gn = parcelRequire("kL7gn");

var $ckGM8 = parcelRequire("ckGM8");

var $avJMO = parcelRequire("avJMO");

var $3TpDH = parcelRequire("3TpDH");

var $ghoe6 = parcelRequire("ghoe6");
function $532c1da023c12ce0$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onUpdate: onUpdate }, props, context, presenceContext) {
    const state = {
        latestValues: $532c1da023c12ce0$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onUpdate) {
        /**
         * onMount works without the VisualElement because it could be
         * called before the VisualElement payload has been hydrated.
         * (e.g. if someone is using m components <m.circle />)
         */ state.onMount = (instance)=>onUpdate({
                props: props,
                current: instance,
                ...state
            });
        state.onUpdate = (visualElement)=>onUpdate(visualElement);
    }
    return state;
}
const $532c1da023c12ce0$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $8FY87.useContext)((0, $aZ8da.MotionContext));
        const presenceContext = (0, $8FY87.useContext)((0, $kL7gn.PresenceContext));
        const make = ()=>$532c1da023c12ce0$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $3TpDH.useConstant)(make);
    };
function $532c1da023c12ce0$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $ghoe6.resolveMotionValue)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $ckGM8.isControllingVariants)(props);
    const isVariantNode$1 = (0, $ckGM8.isVariantNode)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $4hf94.isAnimationControls)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $avJMO.resolveVariantFromProps)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}

});

parcelRegister("ilbNQ", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", function () { return $23f96fa9f5b352b2$export$5475d24f125d7053; });

var $lMdGX = parcelRequire("lMdGX");

var $7BVsZ = parcelRequire("7BVsZ");

var $6ziLS = parcelRequire("6ziLS");
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $23f96fa9f5b352b2$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $lMdGX.buildHTMLStyles)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $6ziLS.calcSVGTransformOrigin)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $7BVsZ.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("lMdGX", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", function () { return $e179c39cf9cca9fc$export$bb517f8b40f8e99d; });

var $iaXVW = parcelRequire("iaXVW");

var $cjO48 = parcelRequire("cjO48");

var $g4KZe = parcelRequire("g4KZe");

var $8h1Iz = parcelRequire("8h1Iz");

var $e3WlB = parcelRequire("e3WlB");
function $e179c39cf9cca9fc$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $e3WlB.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $iaXVW.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $cjO48.getValueAsType)(value, (0, $g4KZe.numberValueTypes)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $8h1Iz.buildTransform)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

});
parcelRegister("cjO48", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", function () { return $bc103766e9015f02$export$453ef540a9a1bd6b; });
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $bc103766e9015f02$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};

});

parcelRegister("8h1Iz", function(module, exports) {

$parcel$export(module.exports, "buildTransform", function () { return $bface07cd22e9309$export$bdc96e0d5c8f914; });

var $cjO48 = parcelRequire("cjO48");

var $g4KZe = parcelRequire("g4KZe");

var $e3WlB = parcelRequire("e3WlB");
const $bface07cd22e9309$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $bface07cd22e9309$var$numTransforms = (0, $e3WlB.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $bface07cd22e9309$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $bface07cd22e9309$var$numTransforms; i++){
        const key = (0, $e3WlB.transformPropOrder)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $cjO48.getValueAsType)(value, (0, $g4KZe.numberValueTypes)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $bface07cd22e9309$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}

});


parcelRegister("7BVsZ", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", function () { return $c6873d84f9acefb2$export$311b43f666da1d82; });

var $5arE3 = parcelRequire("5arE3");
const $c6873d84f9acefb2$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $c6873d84f9acefb2$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $c6873d84f9acefb2$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $c6873d84f9acefb2$var$dashKeys : $c6873d84f9acefb2$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $5arE3.px).transform(-offset);
    // Build the dash array
    const pathLength = (0, $5arE3.px).transform(length);
    const pathSpacing = (0, $5arE3.px).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

});

parcelRegister("6ziLS", function(module, exports) {

$parcel$export(module.exports, "calcSVGTransformOrigin", function () { return $5e6c74a9c683e842$export$d4fbcfc8e5472155; });

var $5arE3 = parcelRequire("5arE3");
function $5e6c74a9c683e842$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $5arE3.px).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $5e6c74a9c683e842$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $5e6c74a9c683e842$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $5e6c74a9c683e842$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}

});


parcelRegister("3TImI", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", function () { return $6d8a44ef175265b4$export$41be8b43e1c4d4f9; });

var $cHfvJ = parcelRequire("cHfvJ");
const $6d8a44ef175265b4$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $cHfvJ.createHtmlRenderState)(),
        attrs: {}
    });

});
parcelRegister("cHfvJ", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", function () { return $f41e5377ac116d0b$export$8940b483cf52eeda; });
const $f41e5377ac116d0b$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });

});


parcelRegister("i9CT4", function(module, exports) {

$parcel$export(module.exports, "isSVGTag", function () { return $2fa6dd9fa00b5601$export$6328ce7565ea1049; });
const $2fa6dd9fa00b5601$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";

});

parcelRegister("cYGcE", function(module, exports) {

$parcel$export(module.exports, "renderSVG", function () { return $d6175b05aeedcb6d$export$c5f8399d19a7394b; });

var $dn8nQ = parcelRequire("dn8nQ");

var $2vF5W = parcelRequire("2vF5W");

var $hvaXj = parcelRequire("hvaXj");
function $d6175b05aeedcb6d$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $2vF5W.renderHTML)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $hvaXj.camelCaseAttributes).has(key) ? (0, $dn8nQ.camelToDash)(key) : key, renderState.attrs[key]);
}

});
parcelRegister("2vF5W", function(module, exports) {

$parcel$export(module.exports, "renderHTML", function () { return $0e945ff12c08954e$export$1a32bf6229c258c0; });
function $0e945ff12c08954e$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}

});

parcelRegister("hvaXj", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", function () { return $c367e31942aefc66$export$28931db5d57958e5; });
/**
 * A set of attribute names that are always read/written as camel case.
 */ const $c367e31942aefc66$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

});


parcelRegister("cvw68", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $cc669155653ce357$export$16da615486abaa45; });

var $dOcpx = parcelRequire("dOcpx");

var $e3WlB = parcelRequire("e3WlB");

var $kJiF4 = parcelRequire("kJiF4");
function $cc669155653ce357$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $kJiF4.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    for(const key in props)if ((0, $dOcpx.isMotionValue)(props[key]) || (0, $dOcpx.isMotionValue)(prevProps[key])) {
        const targetKey = (0, $e3WlB.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});
parcelRegister("kJiF4", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $3757622bf3212c9f$export$16da615486abaa45; });

var $2NBSS = parcelRequire("2NBSS");

var $dOcpx = parcelRequire("dOcpx");
function $3757622bf3212c9f$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $dOcpx.isMotionValue)(style[key]) || prevProps.style && (0, $dOcpx.isMotionValue)(prevProps.style[key]) || (0, $2NBSS.isForcedMotionValue)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}

});
parcelRegister("2NBSS", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", function () { return $eb30c20c3fb5548c$export$6d27ce8e3de1c3cf; });

var $bdHsB = parcelRequire("bdHsB");

var $e3WlB = parcelRequire("e3WlB");
function $eb30c20c3fb5548c$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $e3WlB.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $bdHsB.scaleCorrectors)[key] || key === "opacity");
}

});




parcelRegister("6fpjr", function(module, exports) {

$parcel$export(module.exports, "htmlMotionConfig", function () { return $5bfe1e12b344b7d6$export$e13ea21d87ea57c8; });

var $bN1Az = parcelRequire("bN1Az");

var $kJiF4 = parcelRequire("kJiF4");

var $cHfvJ = parcelRequire("cHfvJ");
const $5bfe1e12b344b7d6$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $bN1Az.makeUseVisualState)({
        scrapeMotionValuesFromProps: $kJiF4.scrapeMotionValuesFromProps,
        createRenderState: (0, $cHfvJ.createHtmlRenderState)
    })
};

});

parcelRegister("5jOOJ", function(module, exports) {

$parcel$export(module.exports, "createUseRender", function () { return $87c3fa48a3e731ce$export$5d29104eefd89cc8; });

var $8FY87 = parcelRequire("8FY87");

var $5dqin = parcelRequire("5dqin");

var $cai6M = parcelRequire("cai6M");

var $77evI = parcelRequire("77evI");

var $j4mvU = parcelRequire("j4mvU");

var $dOcpx = parcelRequire("dOcpx");
function $87c3fa48a3e731ce$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $77evI.isSVGComponent)(Component) ? (0, $j4mvU.useSVGProps) : (0, $5dqin.useHTMLProps);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $cai6M.filterProps)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $8FY87.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $8FY87.useMemo)(()=>(0, $dOcpx.isMotionValue)(children) ? children.get() : children, [
            children
        ]);
        return (0, $8FY87.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}

});
parcelRegister("5dqin", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", function () { return $678e429e79f82435$export$40dafdb8630c956b; });
$parcel$export(module.exports, "useHTMLProps", function () { return $678e429e79f82435$export$57be0a314572d87d; });

var $8FY87 = parcelRequire("8FY87");

var $2NBSS = parcelRequire("2NBSS");

var $dOcpx = parcelRequire("dOcpx");

var $lMdGX = parcelRequire("lMdGX");

var $cHfvJ = parcelRequire("cHfvJ");
function $678e429e79f82435$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $dOcpx.isMotionValue)(source[key]) && !(0, $2NBSS.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $678e429e79f82435$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $8FY87.useMemo)(()=>{
        const state = (0, $cHfvJ.createHtmlRenderState)();
        (0, $lMdGX.buildHTMLStyles)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $678e429e79f82435$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $678e429e79f82435$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $678e429e79f82435$var$useInitialMotionValues(props, visualState));
    return style;
}
function $678e429e79f82435$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $678e429e79f82435$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}

});

parcelRegister("cai6M", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $b9165942ed8c13f6$export$d697c39a2985a4c; });

var $hY8UY = parcelRequire("hY8UY");
let $b9165942ed8c13f6$var$shouldForward = (key)=>!(0, $hY8UY.isValidMotionProp)(key);
function $b9165942ed8c13f6$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $b9165942ed8c13f6$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $hY8UY.isValidMotionProp)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $b9165942ed8c13f6$export$59d6962c470509a5((parcelRequire("7fY6k")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $b9165942ed8c13f6$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($b9165942ed8c13f6$var$shouldForward(key) || forwardMotionProps === true && (0, $hY8UY.isValidMotionProp)(key) || !isDom && !(0, $hY8UY.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}

});
parcelRegister("hY8UY", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", function () { return $fbbad56d0620f37f$export$2f9c46555243bf04; });
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $fbbad56d0620f37f$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $fbbad56d0620f37f$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $fbbad56d0620f37f$var$validMotionProps.has(key);
}

});


parcelRegister("j4mvU", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", function () { return $b739822fa7627364$export$84309c4f53cb1bd5; });

var $8FY87 = parcelRequire("8FY87");

var $5dqin = parcelRequire("5dqin");

var $ilbNQ = parcelRequire("ilbNQ");

var $3TImI = parcelRequire("3TImI");

var $i9CT4 = parcelRequire("i9CT4");
function $b739822fa7627364$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $8FY87.useMemo)(()=>{
        const state = (0, $3TImI.createSvgRenderState)();
        (0, $ilbNQ.buildSVGAttrs)(state, visualState, (0, $i9CT4.isSVGTag)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $5dqin.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}

});



parcelRegister("gG7Ih", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", function () { return $2745a2051a1291a7$export$56ba0183203348f5; });

var $8FY87 = parcelRequire("8FY87");

var $jeYKv = parcelRequire("jeYKv");

var $2CqLe = parcelRequire("2CqLe");

var $77evI = parcelRequire("77evI");
const $2745a2051a1291a7$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $77evI.isSVGComponent)(Component) ? new (0, $2CqLe.SVGVisualElement)(options) : new (0, $jeYKv.HTMLVisualElement)(options, {
        allowProjection: Component !== (0, $8FY87.Fragment)
    });
};

});
parcelRegister("jeYKv", function(module, exports) {

$parcel$export(module.exports, "HTMLVisualElement", function () { return $ef912543382c3b96$export$23fea75b03ac16b3; });

var $7jXA1 = parcelRequire("7jXA1");

var $bsnYG = parcelRequire("bsnYG");

var $iaXVW = parcelRequire("iaXVW");

var $dzOZ3 = parcelRequire("dzOZ3");

var $lMdGX = parcelRequire("lMdGX");

var $e3WlB = parcelRequire("e3WlB");

var $2vF5W = parcelRequire("2vF5W");

var $kJiF4 = parcelRequire("kJiF4");
function $ef912543382c3b96$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $ef912543382c3b96$export$23fea75b03ac16b3 extends (0, $bsnYG.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $2vF5W.renderHTML);
    }
    readValueFromInstance(instance, key) {
        if ((0, $e3WlB.transformProps).has(key)) {
            const defaultType = (0, $dzOZ3.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $ef912543382c3b96$export$3735103072e4a80(instance);
            const value = ((0, $iaXVW.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $7jXA1.measureViewportBox)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $lMdGX.buildHTMLStyles)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $kJiF4.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
}

});
parcelRegister("bsnYG", function(module, exports) {

$parcel$export(module.exports, "DOMVisualElement", function () { return $1d0a5e7e0f5ebee5$export$e49735c2a366bdc7; });

var $liXOk = parcelRequire("liXOk");

var $9KxvK = parcelRequire("9KxvK");

var $dOcpx = parcelRequire("dOcpx");
class $1d0a5e7e0f5ebee5$export$e49735c2a366bdc7 extends (0, $liXOk.VisualElement) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $9KxvK.DOMKeyframesResolver);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $dOcpx.isMotionValue)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}

});
parcelRegister("liXOk", function(module, exports) {

$parcel$export(module.exports, "VisualElement", function () { return $dd6ce5d32fcd1f65$export$fa8b653c0f3714e5; });

var $k83cl = parcelRequire("k83cl");

var $huw9a = parcelRequire("huw9a");

var $6lXUx = parcelRequire("6lXUx");

var $jhoKN = parcelRequire("jhoKN");

var $jLJum = parcelRequire("jLJum");

var $jt7rq = parcelRequire("jt7rq");

var $eqZtg = parcelRequire("eqZtg");

var $aQwlE = parcelRequire("aQwlE");


var $apeLX = parcelRequire("apeLX");

var $3aPzZ = parcelRequire("3aPzZ");

var $dOcpx = parcelRequire("dOcpx");

var $2zwmu = parcelRequire("2zwmu");

var $jqGeL = parcelRequire("jqGeL");

var $e3WlB = parcelRequire("e3WlB");

var $3gNtv = parcelRequire("3gNtv");

var $ckGM8 = parcelRequire("ckGM8");

var $l82xw = parcelRequire("l82xw");

var $l7cKm = parcelRequire("l7cKm");

var $avJMO = parcelRequire("avJMO");

var $5Orka = parcelRequire("5Orka");
const $dd6ce5d32fcd1f65$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $dd6ce5d32fcd1f65$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $l82xw.KeyframeResolver);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $k83cl.time).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $5Orka.frame).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState, onUpdate: onUpdate } = visualState;
        this.onUpdate = onUpdate;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $ckGM8.isControllingVariants)(props);
        this.isVariantNode = (0, $ckGM8.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $dOcpx.isMotionValue)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $3gNtv.visualElementStore).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $eqZtg.hasReducedMotionListener).current) (0, $jt7rq.initPrefersReducedMotion)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $eqZtg.prefersReducedMotion).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $3gNtv.visualElementStore).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $5Orka.cancelFrame)(this.notifyUpdate);
        (0, $5Orka.cancelFrame)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $e3WlB.transformProps).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $5Orka.frame).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $huw9a.featureDefinitions){
            const featureDefinition = (0, $huw9a.featureDefinitions)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $6lXUx.createBox)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $dd6ce5d32fcd1f65$var$propEventHandlers.length; i++){
            const key = $dd6ce5d32fcd1f65$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $l7cKm.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
        this.onUpdate && this.onUpdate(this);
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $apeLX.motionValue)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $jhoKN.isNumericalString)(value) || (0, $jLJum.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $jqGeL.findValueType)(value) && (0, $3aPzZ.complex).test(target)) value = (0, $2zwmu.getAnimatableNone)(key, target);
            this.setBaseTarget(key, (0, $dOcpx.isMotionValue)(value) ? value.get() : value);
        }
        return (0, $dOcpx.isMotionValue)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $avJMO.resolveVariantFromProps)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $dOcpx.isMotionValue)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $aQwlE.SubscriptionManager)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}

});
parcelRegister("jt7rq", function(module, exports) {

$parcel$export(module.exports, "initPrefersReducedMotion", function () { return $db9c62c51153561d$export$ca9f41fb23dded3d; });

var $4N4vL = parcelRequire("4N4vL");

var $eqZtg = parcelRequire("eqZtg");
function $db9c62c51153561d$export$ca9f41fb23dded3d() {
    (0, $eqZtg.hasReducedMotionListener).current = true;
    if (!(0, $4N4vL.isBrowser)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $eqZtg.prefersReducedMotion).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $eqZtg.prefersReducedMotion).current = false;
}

});
parcelRegister("eqZtg", function(module, exports) {

$parcel$export(module.exports, "prefersReducedMotion", function () { return $a8d92ad10003cbde$export$ff7706047246b98b; });
$parcel$export(module.exports, "hasReducedMotionListener", function () { return $a8d92ad10003cbde$export$6476d16e2fd2d0db; });
// Does this device prefer reduced motion? Returns `null` server-side.
const $a8d92ad10003cbde$export$ff7706047246b98b = {
    current: null
};
const $a8d92ad10003cbde$export$6476d16e2fd2d0db = {
    current: false
};

});


parcelRegister("jqGeL", function(module, exports) {

$parcel$export(module.exports, "findValueType", function () { return $7521544c5ca4cb84$export$950e7e59ea1ffed7; });

var $kew5R = parcelRequire("kew5R");

var $3aPzZ = parcelRequire("3aPzZ");

var $eoRpa = parcelRequire("eoRpa");

var $cf1oE = parcelRequire("cf1oE");
/**
 * A list of all ValueTypes
 */ const $7521544c5ca4cb84$var$valueTypes = [
    ...(0, $eoRpa.dimensionValueTypes),
    (0, $kew5R.color),
    (0, $3aPzZ.complex)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $7521544c5ca4cb84$export$950e7e59ea1ffed7 = (v)=>$7521544c5ca4cb84$var$valueTypes.find((0, $cf1oE.testValueType)(v));

});

parcelRegister("3gNtv", function(module, exports) {

$parcel$export(module.exports, "visualElementStore", function () { return $6760b25b990f46c2$export$bc2a978a17abfdde; });
const $6760b25b990f46c2$export$bc2a978a17abfdde = new WeakMap();

});

parcelRegister("l7cKm", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", function () { return $c520e6200bd348b1$export$9a552858d5197f6e; });


var $apeLX = parcelRequire("apeLX");

var $dOcpx = parcelRequire("dOcpx");
function $c520e6200bd348b1$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $dOcpx.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $dOcpx.isMotionValue)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $apeLX.motionValue)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $apeLX.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});




parcelRegister("2CqLe", function(module, exports) {

$parcel$export(module.exports, "SVGVisualElement", function () { return $b6b9af77539e97af$export$86bcdffbaf733d84; });

var $6lXUx = parcelRequire("6lXUx");

var $bsnYG = parcelRequire("bsnYG");

var $dn8nQ = parcelRequire("dn8nQ");

var $dzOZ3 = parcelRequire("dzOZ3");

var $e3WlB = parcelRequire("e3WlB");

var $ilbNQ = parcelRequire("ilbNQ");

var $hvaXj = parcelRequire("hvaXj");

var $i9CT4 = parcelRequire("i9CT4");

var $cYGcE = parcelRequire("cYGcE");

var $cvw68 = parcelRequire("cvw68");
class $b6b9af77539e97af$export$86bcdffbaf733d84 extends (0, $bsnYG.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $6lXUx.createBox);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $e3WlB.transformProps).has(key)) {
            const defaultType = (0, $dzOZ3.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $hvaXj.camelCaseAttributes).has(key) ? (0, $dn8nQ.camelToDash)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $cvw68.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $ilbNQ.buildSVGAttrs)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $cYGcE.renderSVG)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $i9CT4.isSVGTag)(instance.tagName);
        super.mount(instance);
    }
}

});




parcelRegister("iI7zz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4d24157bc0d3637$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $3eb7t = parcelRequire("3eb7t");
function $e4d24157bc0d3637$var$CardContainer({ children: children, model: model }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: "grid",
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("article", {
            className: "grid",
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "grid relative lg:grid-cols-[1fr_1.5fr] items-center gap-6 lg:gap-12 max-w-screen-2xl w-full mx-auto px-4 py-10 lg:py-16 rounded-t-lg overflow-hidden",
                    children: [
                        model.first_car.image ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                            className: "w-full h-auto max-w-md lg:max-w-none object-contain mx-auto drop-shadow-xl",
                            width: 600,
                            src: model.first_car.image,
                            alt: model.name
                        }) : null,
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: "text-center lg:text-left max-w-lg mx-auto",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                    className: "inline-flex items-center gap-2 bg-white border border-dark-blue/10 px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide text-dark-blue shadow-sm mb-3",
                                    children: "Snabbfakta"
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                    className: "text-3xl lg:text-5xl font-extrabold text-dark-blue tracking-tight text-balance",
                                    children: model.name
                                }),
                                model.description && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                    className: "mt-3 text-base lg:text-lg text-slate-600",
                                    children: model.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                            className: "absolute inset-0 w-full h-full -z-10",
                            width: "100%",
                            height: "100%",
                            viewBox: "0 0 1440 560",
                            preserveAspectRatio: "none",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                                d: "M0 0 L1440 0 L1440 560 Q720 450 0 560 Z",
                                fill: "#f7f7f7"
                            })
                        })
                    ]
                }),
                children
            ]
        })
    });
}
var $e4d24157bc0d3637$export$2e2bcd8739ae039 = $e4d24157bc0d3637$var$CardContainer;

});

parcelRegister("kAWPz", function(module, exports) {

$parcel$export(module.exports, "DataCardStoreProvider", function () { return $ebb38f8e7b8e6a7f$export$b2ff850043c25df3; });
$parcel$export(module.exports, "useDataCardStoreContext", function () { return $ebb38f8e7b8e6a7f$export$d35a9268bef8e6b3; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $8mhoa = parcelRequire("8mhoa");

var $ekqaz = parcelRequire("ekqaz");
const $ebb38f8e7b8e6a7f$export$554ccc96b126a426 = /*#__PURE__*/ (0, $8FY87.createContext)(null);
const $ebb38f8e7b8e6a7f$export$b2ff850043c25df3 = ({ children: children })=>{
    const storeRef = (0, $8FY87.useRef)();
    if (!storeRef.current) storeRef.current = (0, $ekqaz.createDataCardStore)();
    return /*#__PURE__*/ (0, $2PPWI.jsx)($ebb38f8e7b8e6a7f$export$554ccc96b126a426.Provider, {
        value: storeRef.current,
        children: children
    });
};
const $ebb38f8e7b8e6a7f$export$d35a9268bef8e6b3 = (selector)=>{
    const store = (0, $8FY87.useContext)($ebb38f8e7b8e6a7f$export$554ccc96b126a426);
    if (!store) throw new Error('useDataCardStoreContext must be used within a DataCardStoreProvider');
    return (0, $8mhoa.useStore)(store, selector);
};

});
parcelRegister("ekqaz", function(module, exports) {

$parcel$export(module.exports, "createDataCardStore", function () { return $23fd5dd0708a132a$export$a36b11b5ef6c80da; });

var $v5tUy = parcelRequire("v5tUy");
const $23fd5dd0708a132a$export$a36b11b5ef6c80da = (initialState = {})=>{
    return (0, $v5tUy.createStore)()((set)=>({
            selectedModel: null,
            ...initialState,
            setSelectedModel: (selectedModel)=>set({
                    selectedModel: selectedModel
                })
        }));
};

});



parcelRegister("akqLd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfc74e853baeaf20$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $jZedf = parcelRequire("jZedf");

var $1lSPe = parcelRequire("1lSPe");

var $f0NwZ = parcelRequire("f0NwZ");

const $bfc74e853baeaf20$var$DisclaimersControls = /*#__PURE__*/ (0, $8FY87.lazy)(()=>(parcelRequire("bmHFK")));
const $bfc74e853baeaf20$var$Disclaimers = ({ ids: ids, hideControls: hideControls = false })=>{
    const [options, setOptions] = (0, $8FY87.useState)({
        ids: ids ? ids.replace(/&quot;|&#34;|&#x22;|["'“”‘’„]/gi, '').split(',').map((e)=>Number(e.trim())).filter((n)=>!Number.isNaN(n) && n > 0) : []
    });
    const [disclaimers, setDisclaimers] = (0, $8FY87.useState)([]);
    const fetchDisclaimers = async ()=>{
        const { data: data } = await (0, $jZedf.fetchWithType)((0, $1lSPe.getAdminUrl)() + '/api/disclaimers', {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${(0, $1lSPe.getApiToken)()}`
            }
        });
        setDisclaimers(data);
    };
    const getSnippetProps = ()=>{
        return `ids="${options.ids.join(',')}"`;
    };
    (0, $8FY87.useEffect)(()=>{
        fetchDisclaimers();
    }, []);
    const getById = (id)=>disclaimers.find((d)=>d.id === id);
    return disclaimers?.length ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            !(0, $1lSPe.locationIsKia)() && !hideControls ? /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "pt-4 pb-4",
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)($bfc74e853baeaf20$var$DisclaimersControls, {
                            setOptions: setOptions,
                            disclaimers: disclaimers
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                            page: "disclaimers",
                            props: getSnippetProps()
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "my-10 max-w-screen-kia-sm mx-auto px-4",
                children: options.ids.map((d)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: `py-4 ${getById(d)?.background ? 'rounded-2xl bg-kia-grey px-2' : ''}`,
                        children: [
                            !getById(d)?.vroom && /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                children: `${getById(d)?.key}. ${getById(d)?.title}`
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                dangerouslySetInnerHTML: {
                                    __html: getById(d)?.text
                                }
                            })
                        ]
                    }, d))
            })
        ]
    }) : null;
};
var $bfc74e853baeaf20$export$2e2bcd8739ae039 = $bfc74e853baeaf20$var$Disclaimers;

});
parcelRegister("bmHFK", function(module, exports) {

module.exports = (parcelRequire("a0MnV"))($parcel$resolve("clEYe")).then(()=>parcelRequire('kLOuP'));

});


parcelRegister("5GeZI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3279306596ae1cab$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $1lSPe = parcelRequire("1lSPe");

var $4AtAC = parcelRequire("4AtAC");

var $d0LqK = parcelRequire("d0LqK");

var $2Khqg = parcelRequire("2Khqg");

var $carWB = parcelRequire("carWB");

var $f0NwZ = parcelRequire("f0NwZ");

var $kM2Bn = parcelRequire("kM2Bn");

var $a3tFn = parcelRequire("a3tFn");

var $j2mYw = parcelRequire("j2mYw");

var $kg9We = parcelRequire("kg9We");

var $2kX7d = parcelRequire("2kX7d");

var $4TYXv = parcelRequire("4TYXv");

var $cfLoc = parcelRequire("cfLoc");

var $dYQug = parcelRequire("dYQug");
function $3279306596ae1cab$var$FleetCalculatorInternal({ hideControls: hideControls, activeTrims: activeTrims, availableTrims: availableTrims, compact: compact }) {
    const activeCarPair = (0, $4AtAC.useCarStoreContext)((state)=>state.activeCarPair);
    const selectableTrimCodes = (0, $4AtAC.useCarStoreContext)((state)=>state.selectableTrimCodes);
    const activeTrimCodes = (0, $4AtAC.useCarStoreContext)((state)=>state.activeTrimCodes);
    const initializeTrims = (0, $4AtAC.useCarStoreContext)((state)=>state.initializeTrims);
    const isFilterModalOpen = (0, $4AtAC.useCarStoreContext)((state)=>state.isFilterModalOpen);
    const isCompactLayout = (0, $4AtAC.useCarStoreContext)((state)=>state.isCompactLayout);
    const updateState = (0, $4AtAC.useCarStoreContext)((state)=>state.updateState);
    (0, $8FY87.useEffect)(()=>{
        const active = activeTrims ? activeTrims.split(',') : [];
        const available = availableTrims ? availableTrims.split(',') : [];
        if (compact) updateState({
            isCompactLayout: compact
        });
        initializeTrims(active, available);
    }, [
        activeTrims,
        availableTrims,
        initializeTrims,
        compact,
        updateState
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        children: [
            !(0, $1lSPe.locationIsKia)() && !hideControls ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $dYQug.default), {}) : null,
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $carWB.default), {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d0LqK.default), {}),
            isFilterModalOpen && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kM2Bn.default), {
                clickOutside: ()=>updateState({
                        isFilterModalOpen: false
                    }),
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "relative max-w-xl bg-white max-h-[90dvh] lg:max-h-[70dvh] p-4 mx-2 flex flex-col gap-4 overflow-auto",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2kX7d.default), {}),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $j2mYw.default), {
                            className: "sticky bottom-0 bg-white shadow-sm",
                            onClick: ()=>updateState({
                                    isFilterModalOpen: false
                                }),
                            children: "Spara"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
                className: `lg:grid ${!isCompactLayout && 'lg:grid-cols-3'}`,
                children: [
                    !isCompactLayout && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "hidden pl-12 pr-6 py-10 lg:grid bg-gray-100 col-span-1",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2kX7d.default), {})
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: `${isCompactLayout ? 'col-span-3' : 'lg:col-span-2'} grid gap-4 px-4 lg:px-8 py-10`,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kg9We.default), {}),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: "grid grid-cols-2 gap-4 lg:gap-8",
                                children: [
                                    activeCarPair && activeCarPair.length > 0 ? activeCarPair.map((car, index)=>car?.car ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2Khqg.default), {
                                            car: car,
                                            index: index
                                        }, car.car.code + index) : null) : null,
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a3tFn.default), {
                                        onClick: ()=>updateState({
                                                isFilterModalOpen: true
                                            }),
                                        className: `${!isCompactLayout && 'lg:hidden'} col-span-2`,
                                        children: "\xc4ndra generalla uppgifter"
                                    }),
                                    activeCarPair && activeCarPair.length > 0 ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $cfLoc.default), {}) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4TYXv.default), {})
                        ]
                    })
                ]
            }),
            activeTrimCodes.length > 0 ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                page: "fleet-calculator",
                props: `activeTrims="${activeTrimCodes.join(',')}" availableTrims="${selectableTrimCodes.join(',')}" ${isCompactLayout ? 'compact="true"' : ''}`
            }) : null
        ]
    });
}
function $3279306596ae1cab$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4AtAC.CarStoreProvider), {
        children: /*#__PURE__*/ (0, $2PPWI.jsx)($3279306596ae1cab$var$FleetCalculatorInternal, {
            ...props
        })
    });
}

});
parcelRegister("4AtAC", function(module, exports) {

$parcel$export(module.exports, "CarStoreProvider", function () { return $b76fbf249de4496e$export$2cea40d87f185acf; });
$parcel$export(module.exports, "useCarStoreContext", function () { return $b76fbf249de4496e$export$decc0cd15951494f; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $8mhoa = parcelRequire("8mhoa");

var $jZedf = parcelRequire("jZedf");

var $bkgA4 = parcelRequire("bkgA4");

var $hjGcb = parcelRequire("hjGcb");

var $9Fpjc = parcelRequire("9Fpjc");
const $b76fbf249de4496e$export$554ccc96b126a426 = /*#__PURE__*/ (0, $8FY87.createContext)(null);
const $b76fbf249de4496e$export$2cea40d87f185acf = ({ children: children })=>{
    const storeRef = (0, $8FY87.useRef)();
    if (!storeRef.current) storeRef.current = (0, $hjGcb.createFleetCalculatorStore)();
    const settings = (0, $9Fpjc.default)();
    const store = storeRef.current;
    const activeTrimCodes = (0, $8mhoa.useStore)(store, (state)=>state.activeTrimCodes);
    const updateState = (0, $8mhoa.useStore)(store, (state)=>state.updateState);
    const isAnyModalOpen = (0, $8mhoa.useStore)(store, (state)=>state.isSwitchCarModalOpen || !!state.detailedCarViewData || state.isFilterModalOpen);
    const activeCarPair = (0, $8mhoa.useStore)(store, (state)=>state.activeCarPair);
    const prevTrimCodesRef = (0, $8FY87.useRef)([]);
    (0, $8FY87.useEffect)(()=>{
        const getCarModelsAction = async ()=>{
            let models = JSON.parse(sessionStorage.getItem('kia-fleet-models')) ?? [];
            if (models.length) return updateState({
                allCarModels: models
            });
            try {
                const { data: data } = await (0, $jZedf.getModels)();
                if (data) updateState({
                    allCarModels: data
                });
                sessionStorage.setItem('kia-fleet-models', JSON.stringify(data));
                return data;
            } catch (error) {
                console.error('Failed to fetch car models:', error);
            }
        };
        getCarModelsAction();
    }, [
        updateState
    ]);
    (0, $8FY87.useEffect)(()=>{
        const getTrimAndCalculateAction = async (code, index)=>{
            try {
                const { data: car } = await (0, $jZedf.getTrim)(code);
                if (car) {
                    const currentState = storeRef.current.getState();
                    const newActiveCarPair = [
                        ...currentState.activeCarPair
                    ];
                    newActiveCarPair[index] = {
                        car: car,
                        calc: new (0, $bkgA4.default)(car, settings)
                    };
                    updateState({
                        activeCarPair: newActiveCarPair
                    });
                }
            } catch (error) {
                console.error(`Failed to fetch trim data for code ${code}:`, error);
            }
        };
        const prevTrimCodes = prevTrimCodesRef.current;
        if (activeTrimCodes?.[0] && activeTrimCodes[0] !== prevTrimCodes[0]) getTrimAndCalculateAction(activeTrimCodes[0], 0);
        if (activeTrimCodes?.[1] && activeTrimCodes[1] !== prevTrimCodes[1]) getTrimAndCalculateAction(activeTrimCodes[1], 1);
        prevTrimCodesRef.current = activeTrimCodes || [];
    }, [
        activeTrimCodes,
        settings,
        updateState
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (activeCarPair.length > 0 && activeCarPair.every((c)=>c.car)) {
            const newActiveCarPair = activeCarPair.map((carData)=>({
                    car: carData.car,
                    calc: new (0, $bkgA4.default)(carData.car, settings)
                }));
            updateState({
                activeCarPair: newActiveCarPair
            });
        }
    }, [
        settings
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (isAnyModalOpen) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'auto';
        return ()=>{
            document.body.style.overflow = 'auto';
        };
    }, [
        isAnyModalOpen
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($b76fbf249de4496e$export$554ccc96b126a426.Provider, {
        value: storeRef.current,
        children: children
    });
};
const $b76fbf249de4496e$export$decc0cd15951494f = (selector)=>{
    const store = (0, $8FY87.useContext)($b76fbf249de4496e$export$554ccc96b126a426);
    if (!store) throw new Error('useCarStoreContext must be used within a CarStoreProvider');
    return (0, $8mhoa.useStore)(store, selector);
};

});
parcelRegister("bkgA4", function(module, exports) {

$parcel$export(module.exports, "getElForbrukningPrice", function () { return $3053dc3b1cb23e29$export$f942c716d7b71dba; });
$parcel$export(module.exports, "getBensinForbrukningPrice", function () { return $3053dc3b1cb23e29$export$f405d28480ae8e56; });
$parcel$export(module.exports, "default", function () { return $3053dc3b1cb23e29$export$2e2bcd8739ae039; });

var $dA2bf = parcelRequire("dA2bf");

var $jcPqj = parcelRequire("jcPqj");

var $1572F = parcelRequire("1572F");

var $b225W = parcelRequire("b225W");
// Hämta från kpms
const $3053dc3b1cb23e29$var$defaultForbrukningBensinLitreperMile = 0.8;
const $3053dc3b1cb23e29$var$defaultForbrukningElkwhper100km = 15;
const $3053dc3b1cb23e29$export$f942c716d7b71dba = (price)=>{
    if (price) return price > 100 ? price / 10 : price;
    else return $3053dc3b1cb23e29$var$defaultForbrukningElkwhper100km;
};
const $3053dc3b1cb23e29$export$f405d28480ae8e56 = (price)=>{
    return price ? price : $3053dc3b1cb23e29$var$defaultForbrukningBensinLitreperMile;
};
class $3053dc3b1cb23e29$export$2e2bcd8739ae039 {
    settings;
    businessLeasing;
    financialLeasing;
    car;
    constructor(trim, settings){
        this.businessLeasing = trim.business_leasing ? trim.business_leasing[0] : undefined;
        this.financialLeasing = trim.financial_leasing ? trim.financial_leasing[0] : undefined;
        this.settings = settings;
        this.car = trim;
    }
    restValue() {
        if (this.settings.typeOfLeasing === (0, $dA2bf.TypeOfLeasing).BUSINESS) return (0, $1572F.getBusinessRest)(this.settings.mileage, this.businessLeasing);
        else return (0, $1572F.getFinancialRest)(this.settings.mileage, this.financialLeasing);
    }
    // include service and insurance?
    calculateFinancialLease() {
        if (!this.financialLeasing) return 0;
        return (0, $jcPqj.pmt)({
            rate: (0, $jcPqj.percentToDecimal)(this.businessLeasing.ranta ?? this.settings.interestRate) / 12,
            nper: 36,
            pv: -(this.financialLeasing.kalkylpris_exkl_moms - (this.settings.firstRent ? this.financialLeasing['1a_forhojd_hyra_20_ex_moms'] : 0)),
            fv: this.restValue(),
            type: 1
        });
    }
    calculateBusinessLease() {
        if (!this.businessLeasing) return 0;
        return (0, $jcPqj.pmt)({
            rate: (0, $jcPqj.percentToDecimal)(this.businessLeasing.ranta ?? this.settings.interestRate) / 12,
            nper: 36,
            pv: -(this.businessLeasing.ex_moms - (this.settings.firstRent ? this.businessLeasing.andra_inte_1a_hyra_ex_moms : 0)),
            fv: this.restValue(),
            type: 1
        }) + (0, $1572F.getBusinessService)(this.settings.mileage, this.businessLeasing) + this.businessLeasing.vinterhjul_ex_moms + (0, $1572F.getBusinessForsakring)(this.settings.mileage, this.businessLeasing);
    }
    formansvardeGrundPris(price, type = 'el') {
        switch(type.toLowerCase()){
            case 'el':
                return price / 2 < price - (0, $b225W.default).schablonAvdragEl ? price - (0, $b225W.default).schablonAvdragEl : price / 2;
            case 'laddhybrid':
                return price / 2 < price - (0, $b225W.default).schablonAvdragLaddHybrid ? price - (0, $b225W.default).schablonAvdragLaddHybrid : price / 2;
            default:
                return price;
        }
    }
    calculateFormansvardeBransle() {
        const korstracka_privat = this.settings.mileage - this.settings.workMileage;
        let branslekostnad = this.fuelCost / 1.25;
        const formansvarde = this.settings.fuelBenefit ? branslekostnad * (korstracka_privat / this.settings.mileage) * 1.2 : 0;
        return Math.round(formansvarde);
    }
    calculateFuelCost(mileage) {
        switch(this.car.type?.name.toLowerCase()){
            case 'el':
                return $3053dc3b1cb23e29$export$f942c716d7b71dba(this.car.electric_consumption) / 10 * mileage * this.settings.electricityPricePerKwh;
            case 'bensin':
            case 'hybrid':
                return $3053dc3b1cb23e29$export$f405d28480ae8e56(this.car.fuel_consumption) * mileage * this.settings.gasPricePerLiter;
            case 'laddhybrid':
                const bensinkostnad = $3053dc3b1cb23e29$export$f405d28480ae8e56(this.car.fuel_consumption) * mileage * this.settings.gasPricePerLiter * (1 - this.settings.percentOnElectricity);
                const elkostnad = $3053dc3b1cb23e29$export$f942c716d7b71dba(this.car.electric_consumption) / 10 * mileage * this.settings.electricityPricePerKwh * this.settings.percentOnElectricity;
                return Math.floor(bensinkostnad + elkostnad);
            default:
                return 0;
        }
    }
    get taxMonthly() {
        return (0, $jcPqj.yearlyToMonthlyCost)(this.car.vehicle_tax);
    }
    // integrera mot api? https://www.skatteverket.se/privat/skatter/arbeteochinkomst/formaner/bilforman/bilformansberakning.4.3f4496fd14864cc5ac9539d.html
    get formansVarde() {
        const basbeloppsdel = (0, $b225W.default).prisbasBelopp * (0, $b225W.default).prisBasBeloppProcentsats;
        const formansGrundPris = this.formansvardeGrundPris(this.car.price, this.car.type ? this.car.type.name : 'el');
        const rantedelen = Math.floor(formansGrundPris * (0, $b225W.default).ranteProcent);
        const prisdelen = Math.floor(formansGrundPris * (0, $b225W.default).prisDelProcent);
        const multiplier = this.settings.workMileage >= 3000 ? 0.75 : 1;
        const formansvarde = (basbeloppsdel + rantedelen + prisdelen + (0, $b225W.default).fordonsSkatt) * multiplier;
        return {
            formansvarde: formansvarde,
            formansvardeMonthly: (0, $jcPqj.yearlyToMonthlyCost)(formansvarde)
        };
    }
    // caclulate monthly cost depending on type of leasing
    get monthlyCost() {
        return this.settings.typeOfLeasing === (0, $dA2bf.TypeOfLeasing).BUSINESS ? this.calculateBusinessLease() : this.calculateFinancialLease();
    }
    get fuelCost() {
        return this.calculateFuelCost(this.settings.mileage);
    }
    get fuelCostMonthly() {
        return (0, $jcPqj.yearlyToMonthlyCost)(this.fuelCost);
    }
    get fuelCostMonthlyDriver() {
        return this.settings.fuelBenefit ? 0 : this.fuelCostMonthly;
    }
    get fuelCostMonthlyBusiness() {
        return this.settings.fuelBenefit ? (0, $jcPqj.inclMomsToExMoms)(this.fuelCostMonthly) : 0;
    }
    get socialCostMonthly() {
        return Math.round((0, $jcPqj.yearlyToMonthlyCost)(this.formansVarde.formansvarde * (0, $b225W.default).arbetsgivaravgiftProcent));
    }
    get socialCostFuelMonthly() {
        const price = this.settings.fuelBenefit ? (0, $jcPqj.yearlyToMonthlyCost)((0, $jcPqj.inclMomsToExMoms)(this.calculateFuelCost(this.settings.mileage - this.settings.workMileage)) * (0, $b225W.default).arbetsgivaravgiftProcent) : 0;
        return Math.round(price);
    }
    get totalCostPersonal() {
        return this.nettoFormansVarde.formansvarde_netto_monthly + this.fuelCostMonthlyDriver + this.nettoFormansVarde.formansvarde_bransle_netto_monthly;
    }
    get insuranceCost() {
        return this.settings.typeOfLeasing === (0, $dA2bf.TypeOfLeasing).BUSINESS ? 0 : (0, $1572F.getFinancialForsakring)(this.settings.mileage, this.financialLeasing);
    }
    get serviceCost() {
        return this.settings.typeOfLeasing === (0, $dA2bf.TypeOfLeasing).BUSINESS ? 0 : (0, $1572F.getFinancialService)(this.settings.mileage, this.financialLeasing);
    }
    get totalCostBusiness() {
        return this.monthlyCost + this.taxMonthly + this.fuelCostMonthlyBusiness + this.socialCostMonthly + this.socialCostFuelMonthly + this.insuranceCost + this.serviceCost;
    }
    get nettoFormansVarde() {
        const formansvarde_netto = this.formansVarde.formansvarde * (1 - this.settings.percentTaxRate);
        const formansvarde_bransle_netto = this.calculateFormansvardeBransle() * (1 - this.settings.percentTaxRate);
        return {
            formansvarde_netto: formansvarde_netto,
            formansvarde_bransle_netto: formansvarde_bransle_netto,
            formansvarde_netto_monthly: formansvarde_netto / 12,
            formansvarde_bransle_netto_monthly: formansvarde_bransle_netto / 12
        };
    }
}

});
parcelRegister("jcPqj", function(module, exports) {

$parcel$export(module.exports, "pmt", function () { return $475cd5d41f3125da$export$17c292b36100698a; });
$parcel$export(module.exports, "percentToDecimal", function () { return $475cd5d41f3125da$export$b42b098160e6f2f7; });
$parcel$export(module.exports, "yearlyToMonthlyCost", function () { return $475cd5d41f3125da$export$5f2f4dccde26c1f0; });
$parcel$export(module.exports, "inclMomsToExMoms", function () { return $475cd5d41f3125da$export$71e4738ff76dfec3; });
const $475cd5d41f3125da$export$17c292b36100698a = ({ rate: rate, nper: nper, pv: pv, fv: fv = 0, type: type = 0 })=>{
    /*
   * rate   - interest rate per month
   * nper   - number of periods (months)
   * pv   - present value
   * fv   - future value
   * type - when the payments are due:
   *        0: end of the period, e.g. end of month (default)
   *        1: beginning of period
   *
   * https://stackoverflow.com/questions/5294074/pmt-function-in-javascript
   * Ps. maybe calc rabatt as advance payments?
   */ let pmt, pvif;
    if (rate === 0) return -(pv + fv) / nper;
    pvif = Math.pow(1 + rate, nper);
    pmt = -rate * (pv * pvif + fv) / (pvif - 1);
    if (type === 1) pmt /= 1 + rate;
    return Math.round(pmt);
};
const $475cd5d41f3125da$export$b42b098160e6f2f7 = (t)=>{
    return t / 100;
};
const $475cd5d41f3125da$export$5f2f4dccde26c1f0 = (cost)=>{
    return cost / 12;
};
const $475cd5d41f3125da$export$71e4738ff76dfec3 = (price)=>{
    return price / 1.25;
};

});

parcelRegister("1572F", function(module, exports) {

$parcel$export(module.exports, "getBusinessRest", function () { return $b242b04771db7a4a$export$727dfea12715d87b; });
$parcel$export(module.exports, "getBusinessService", function () { return $b242b04771db7a4a$export$3c457bdd15128dde; });
$parcel$export(module.exports, "getBusinessForsakring", function () { return $b242b04771db7a4a$export$e3bbe86a75a19ba; });
$parcel$export(module.exports, "getFinancialRest", function () { return $b242b04771db7a4a$export$92d9cbf76ebb6958; });
$parcel$export(module.exports, "getFinancialService", function () { return $b242b04771db7a4a$export$229173b464971f3e; });
$parcel$export(module.exports, "getFinancialForsakring", function () { return $b242b04771db7a4a$export$237baaa5dce1e7aa; });
const $b242b04771db7a4a$export$727dfea12715d87b = (mileage, businessLeasing)=>{
    switch(mileage){
        case 1500:
            return businessLeasing.restvarde1;
        case 2000:
            return businessLeasing.restvarde2;
        case 3000:
            return businessLeasing.restvarde3;
        default:
            return businessLeasing.restvarde4;
    }
};
const $b242b04771db7a4a$export$3c457bdd15128dde = (mileage, businessLeasing)=>{
    switch(mileage){
        case 1500:
            return businessLeasing.serviceniva1;
        case 2000:
            return businessLeasing.serviceniva2;
        case 3000:
            return businessLeasing.serviceniva3;
        default:
            return businessLeasing.serviceniva4;
    }
};
const $b242b04771db7a4a$export$e3bbe86a75a19ba = (milage, businessLeasing)=>{
    switch(milage){
        case 1500:
            return businessLeasing.forsakring_4500_ingen_moms;
        case 2000:
            return businessLeasing.forsakring_6000_ingen_moms;
        case 3000:
            return businessLeasing.forsakring_9000_ingen_moms;
        default:
            return businessLeasing.forsakring_12000_ingen_moms;
    }
};
const $b242b04771db7a4a$export$92d9cbf76ebb6958 = (mileage, financialLeasing)=>{
    switch(mileage){
        case 1500:
            return financialLeasing.restvarde4500_ex_moms;
        case 2000:
            return financialLeasing.restvarde6000_ex_moms;
        case 3000:
            return financialLeasing.restvarde6000_ex_moms;
        default:
            return financialLeasing.restvarde9000_ex_moms;
    }
};
const $b242b04771db7a4a$export$229173b464971f3e = (mileage, financialLeasing)=>{
    switch(mileage){
        case 1500:
            return financialLeasing.service4500_ex_moms;
        case 2000:
            return financialLeasing.service6000_exmoms;
        case 3000:
            return financialLeasing.service9000_ex_moms;
        default:
            return financialLeasing.service12000_ex_moms;
    }
};
const $b242b04771db7a4a$export$237baaa5dce1e7aa = (mileage, financialLeasing)=>{
    switch(mileage){
        case 1500:
            return financialLeasing.forsakring4500;
        case 2000:
            return financialLeasing.forsakring6000;
        case 3000:
            return financialLeasing.forsakring9000;
        default:
            return financialLeasing.forsakring12000;
    }
};

});

parcelRegister("b225W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $761e7a73ea0fdfbc$export$2e2bcd8739ae039; });
var $761e7a73ea0fdfbc$export$2e2bcd8739ae039 = {
    prisbasBelopp: 57300,
    prisBasBeloppProcentsats: 0.29,
    ranteProcent: parseFloat((0.7 * 2.62 + 1).toFixed(3)) / 100,
    fordonsSkatt: 360,
    prisDelProcent: 0.13,
    schablonAvdragEl: 350000,
    schablonAvdragLaddHybrid: 140000,
    brytpunkt: 615300,
    arbetsgivaravgiftProcent: 0.3142
};

});


parcelRegister("hjGcb", function(module, exports) {

$parcel$export(module.exports, "createFleetCalculatorStore", function () { return $a8a2fe6e9de3ea5b$export$75c6a7300553b0; });

var $v5tUy = parcelRequire("v5tUy");
const $a8a2fe6e9de3ea5b$export$75c6a7300553b0 = (initialState = {})=>{
    return (0, $v5tUy.createStore)()((set)=>({
            allCarModels: [],
            activeCarPair: [],
            activeTrimCodes: [],
            selectableTrimCodes: [],
            isCompactLayout: false,
            isSwitchCarModalOpen: false,
            carIndexToReplace: null,
            isFilterModalOpen: false,
            detailedCarViewData: null,
            ...initialState,
            updateState: (state)=>set(state),
            initializeTrims: (activeTrims, availableTrims)=>set({
                    activeTrimCodes: activeTrims,
                    selectableTrimCodes: availableTrims
                }),
            replaceActiveCar: (index, newTrimCode)=>set((state)=>{
                    if (index < 0 || index >= state.activeTrimCodes.length) return {};
                    const newActiveTrimCodes = [
                        ...state.activeTrimCodes
                    ];
                    newActiveTrimCodes[index] = newTrimCode;
                    return {
                        activeTrimCodes: newActiveTrimCodes
                    };
                }),
            openSwitchCarModal: (index)=>set({
                    carIndexToReplace: index,
                    isSwitchCarModalOpen: true
                }),
            closeSwitchCarModal: ()=>set({
                    carIndexToReplace: null,
                    isSwitchCarModalOpen: false
                }),
            openCarDetailsModal: (car)=>set({
                    detailedCarViewData: car
                }),
            closeCarDetailsModal: ()=>set({
                    detailedCarViewData: null
                })
        }));
};

});

parcelRegister("9Fpjc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c81ffe94dee5122b$export$2e2bcd8739ae039; });

var $8mhoa = parcelRequire("8mhoa");

var $bEVCz = parcelRequire("bEVCz");
const $c81ffe94dee5122b$var$useSettingsStore = (0, $8mhoa.create)()((set)=>({
        typeOfLeasing: (0, $bEVCz.TypeOfLeasing).BUSINESS,
        mileage: 1500,
        workMileage: 100,
        firstRent: true,
        interestRate: 7.95,
        fuelBenefit: false,
        gasPricePerLiter: 18,
        electricityPricePerKwh: 3,
        percentOnElectricity: 0.7,
        percentTaxRate: 0.5,
        updateSettingsStore: (state)=>set(state)
    }));
var $c81ffe94dee5122b$export$2e2bcd8739ae039 = $c81ffe94dee5122b$var$useSettingsStore;

});
parcelRegister("bEVCz", function(module, exports) {

$parcel$export(module.exports, "TypeOfLeasing", function () { return $c33619f6192d0ffc$export$c6e9ab6b3f34a577; });
var $c33619f6192d0ffc$export$c6e9ab6b3f34a577 = /*#__PURE__*/ function(TypeOfLeasing) {
    TypeOfLeasing["BUSINESS"] = "Kia Business Lease\u2075\u207E";
    TypeOfLeasing["FINANCIAL"] = "Kia Finansiell Leasing\u2076\u207E";
    return TypeOfLeasing;
}({});

});



parcelRegister("d0LqK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5a958941722fae1$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $1lSPe = parcelRequire("1lSPe");

var $lRXuw = parcelRequire("lRXuw");

var $kM2Bn = parcelRequire("kM2Bn");

var $j2mYw = parcelRequire("j2mYw");

var $4AtAC = parcelRequire("4AtAC");

var $9Fpjc = parcelRequire("9Fpjc");

var $jcPqj = parcelRequire("jcPqj");

var $bkgA4 = parcelRequire("bkgA4");
function $b5a958941722fae1$export$2e2bcd8739ae039() {
    const detailedCarViewData = (0, $4AtAC.useCarStoreContext)((state)=>state.detailedCarViewData);
    const closeCarDetailsModal = (0, $4AtAC.useCarStoreContext)((state)=>state.closeCarDetailsModal);
    const { percentOnElectricity: percentOnElectricity } = (0, $9Fpjc.default)();
    const [electricPercent, setElectricPercent] = (0, $8FY87.useState)(percentOnElectricity * 100);
    if (!detailedCarViewData) return;
    const { car: car, calc: calc } = detailedCarViewData;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kM2Bn.default), {
        clickOutside: ()=>closeCarDetailsModal(),
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: "bg-white shadow-lg max-w-[90dvw] w-[600px] p-6 flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsxs)("h3", {
                    className: "text-2xl font-semibold mb-4 max-w-[90%]",
                    children: [
                        (0, $lRXuw.carDetails).title,
                        " ",
                        car.name
                    ]
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "grid md:grid-cols-2 text-sm gap-4",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                    children: (0, $lRXuw.carDetails).price
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                    children: (0, $1lSPe.fNumber)(car.price)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: "flex flex-col gap-2",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                    className: "text-lg font-semibold",
                                    children: [
                                        (0, $lRXuw.carDetails).usageTitle,
                                        "\xb9\u2077\u207E"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                            children: (0, $lRXuw.carDetails).usageFuel
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                            children: [
                                                car.type?.name.toLowerCase() !== 'el' ? (0, $bkgA4.getBensinForbrukningPrice)(car.fuel_consumption) : 0,
                                                ' ',
                                                "liter/mil"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                            children: "CO2-utsl\xe4pp"
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                            children: [
                                                car.emissions ?? 0,
                                                " g/km"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                            children: (0, $lRXuw.carDetails).usageElectric
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                            children: [
                                                car.electric_consumption ? (0, $bkgA4.getElForbrukningPrice)(car.electric_consumption) : 0,
                                                ' ',
                                                "kWh/100km"
                                            ]
                                        })
                                    ]
                                }),
                                car.type?.name.toLowerCase() === 'laddhybrid' ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("label", {
                                            htmlFor: "electricDrive",
                                            className: "flex justify-between mt-2",
                                            children: [
                                                /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                    children: (0, $lRXuw.carDetails).totalElectic
                                                }),
                                                /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                                    children: [
                                                        electricPercent,
                                                        " procent"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                            name: "electricDrive",
                                            id: "electricDrive",
                                            type: "range",
                                            value: electricPercent,
                                            min: 0,
                                            max: 100,
                                            onChange: (e)=>setElectricPercent(Number(e.target.value))
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                            children: (0, $lRXuw.carDetails).costFuel
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                            children: [
                                                (0, $1lSPe.fNumber)((0, $jcPqj.yearlyToMonthlyCost)(calc.fuelCost)),
                                                "/m\xe5n"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $j2mYw.default), {
                    className: "mt-2",
                    onClick: ()=>closeCarDetailsModal(),
                    children: (0, $lRXuw.general).close
                })
            ]
        })
    });
}

});
parcelRegister("lRXuw", function(module, exports) {

$parcel$export(module.exports, "excerpt", function () { return $736c570e6fea0ae7$export$f8e8f85027c88e59; });
$parcel$export(module.exports, "businessExcerpt", function () { return $736c570e6fea0ae7$export$49ef7530627d3d03; });
$parcel$export(module.exports, "financialExcerpt", function () { return $736c570e6fea0ae7$export$15ebb0bbe0cfe2e8; });
$parcel$export(module.exports, "includedBusinessLeasing", function () { return $736c570e6fea0ae7$export$707dee57b1030518; });
$parcel$export(module.exports, "filter", function () { return $736c570e6fea0ae7$export$3dea766d36a8935f; });
$parcel$export(module.exports, "priceTable", function () { return $736c570e6fea0ae7$export$abc33a8eddbd29b0; });
$parcel$export(module.exports, "general", function () { return $736c570e6fea0ae7$export$78b80bc2f5d4953a; });
$parcel$export(module.exports, "carDetails", function () { return $736c570e6fea0ae7$export$66886284f80f5ad1; });
$parcel$export(module.exports, "legal", function () { return $736c570e6fea0ae7$export$29c248a685096bf5; });
const $736c570e6fea0ae7$export$124049a9e3d0d4c3 = {
    title: "Tj\xe4nstebils&shy;kalkylatorn",
    backgroundImage: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/contents/new-car/ev9/Kia_EV9_1920x1080px.jpg'
};
const $736c570e6fea0ae7$export$f8e8f85027c88e59 = [
    {
        heading: "H\xe4r kan du enkelt r\xe4kna ut vad det kostar att k\xf6ra en laddbar tj\xe4nstebil fr\xe5n Kia.",
        paragraph: "L\xe5g elf\xf6rbrukning, l\xe4gre sociala avgifter och minskade koldioxidutsl\xe4pp - att k\xf6ra en elbil eller laddhybrid som tj\xe4nstebil \xe4r ett smart val. I v\xe5r tj\xe4nstebilskalkylator kan du enkelt j\xe4mf\xf6ra v\xe5ra tj\xe4nstebilsmodeller och se vad det kommer att kosta att k\xf6ra laddbart med Kia. I matrisen nedan kan du v\xe4lja mellan 8 laddbara bilmodeller fr\xe5n Kia och tv\xe5 finansieringsl\xf6sningar, Kia Finansiell leasing\u2076\u207E och Kia Business Lease.\u2075\u207E"
    }
];
const $736c570e6fea0ae7$export$49ef7530627d3d03 = {
    heading: "Kia Business Lease\u2075\u207E"
};
const $736c570e6fea0ae7$export$15ebb0bbe0cfe2e8 = {
    heading: "Kia Finansiell Leasing\u2076\u207E"
};
const $736c570e6fea0ae7$export$6400a49649897c19 = {
    heading: "L\xe4gg till j\xe4mf\xf6relse",
    subHeading: "V\xe4lj bil",
    subHeadingModel: "V\xe4lj modell"
};
const $736c570e6fea0ae7$export$707dee57b1030518 = [
    {
        label: "Garanterat restv\xe4rde",
        value: 'Ja'
    },
    {
        label: "Kia Serviceavtal\xb9\u2075\u207E",
        value: "Ing\xe5r"
    },
    {
        label: "Kia Bilf\xf6rs\xe4kring\xb9\u2076\u207E",
        value: "Ing\xe5r"
    },
    {
        label: 'Kia Original Vinterhjul',
        value: "Ing\xe5r"
    }
];
const $736c570e6fea0ae7$export$3dea766d36a8935f = {
    heading: 'Generella uppgifter',
    subHeading: "Reglera k\xf6rstr\xe4cka och \xe4ndra globala v\xe4rden som p\xe5verkar kostnaderna f\xf6r alla bilar i j\xe4mf\xf6relsen.",
    typeOfLeasing: 'Typ av leasing',
    mileageLabel: "Total k\xf6rstr\xe4cka",
    mileageServiceLabel: "Varav i tj\xe4nsten",
    elevatedFirstMonthRent: {
        label: "F\xf6rsta f\xf6rh\xf6jd hyra",
        subLabel: "20% f\xf6rsta f\xf6rh\xf6jd leasinghyra"
    },
    fuelBenefit: {
        label: "Har du drivmedelsf\xf6rm\xe5n?",
        subLabel: "V\xe4lj om du har drivmedelsf\xf6rm\xe5n fr\xe5n f\xf6retaget"
    },
    fuelCost: "Br\xe4nslekostnad bensin",
    fuelCostElectric: 'Elkostnad',
    marginalTax: 'Marginalskatt'
};
const $736c570e6fea0ae7$export$abc33a8eddbd29b0 = {
    formansVardeNetto: "F\xf6rm\xe5nsv\xe4rde bil netto/m\xe5nad\u2077\u207E",
    totalUser: "Totalkostnad f\xf6r f\xf6raren/m\xe5nad",
    totalCompany: "Totalkostnad f\xf6r f\xf6retaget/m\xe5nad",
    inclFuel: 'Inkl. drivmedel',
    formansVarde: "F\xf6rm\xe5nsv\xe4rde bil\u2077\u207E",
    formansVardeFuel: "F\xf6rm\xe5nsv\xe4rde br\xe4nsle",
    fuel: 'Drivmedel',
    finance: 'Finansiering',
    serviceDeal: "Kia Serviceavtal\xb9\u2075\u207E",
    insurance: "F\xf6rs\xe4kring\xb9\u2076\u207E",
    included: "Ing\xe5r",
    carTax: 'Fordonskatt',
    fuelCost: 'Kostnad drivmedel',
    socialCost: 'Sociala avgifter',
    socialCostFuel: "Sociala avgifter br\xe4nsle"
};
const $736c570e6fea0ae7$export$78b80bc2f5d4953a = {
    changeModel: 'Byt modell',
    showDetails: "Detaljerade v\xe4rden",
    update: 'Uppdatera',
    close: "St\xe4ng"
};
const $736c570e6fea0ae7$export$66886284f80f5ad1 = {
    title: "Detaljerade v\xe4rden f\xf6r",
    price: 'Pris',
    usageTitle: "F\xf6rbrukning",
    usageFuel: "Br\xe4nslef\xf6rbrukning",
    usageElectric: "Elf\xf6rbrukning",
    totalElectic: "Total k\xf6rning p\xe5 el",
    costFuel: 'Kostnad drivmedel'
};
const $736c570e6fea0ae7$export$29c248a685096bf5 = [
    'Kalkylen \xe4r framtagen i samarbete med Kia Finans och inneb\xe4r ett estimat p\xe5 totalkostnadskalkyl och \xe4r ej underlag f\xf6r offert.<br><br> V\xe4nligen se <a href="https://skatteverket.se/" target="_blank">https://skatteverket.se/</a> f\xf6r aktuella v\xe4rden samt ber\xe4kningar.'
];

});


parcelRegister("2Khqg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ba659dd5479ca32$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $1lSPe = parcelRequire("1lSPe");

var $lRXuw = parcelRequire("lRXuw");

var $a3tFn = parcelRequire("a3tFn");

var $4AtAC = parcelRequire("4AtAC");

var $9Fpjc = parcelRequire("9Fpjc");

var $bEVCz = parcelRequire("bEVCz");
function $8ba659dd5479ca32$export$2e2bcd8739ae039({ car: car, index: index }) {
    const { typeOfLeasing: typeOfLeasing } = (0, $9Fpjc.default)();
    const openCarDetailsModal = (0, $4AtAC.useCarStoreContext)((state)=>state.openCarDetailsModal);
    const openSwitchCarModal = (0, $4AtAC.useCarStoreContext)((state)=>state.openSwitchCarModal);
    const selectableTrimCodes = (0, $4AtAC.useCarStoreContext)((state)=>state.selectableTrimCodes);
    if (!car || !car.car) return /*#__PURE__*/ (0, $2PPWI.jsx)("article", {
        className: "flex flex-col justify-between gap-4 p-4 border rounded-md min-h-[400px] animate-pulse bg-gray-200"
    });
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("article", {
        className: "flex flex-col justify-between gap-4",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                src: car.car.image,
                alt: car.car.name,
                className: "w-full h-auto"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "flex flex-col md:flex-row justify-between gap-1",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "min-h-14 grow",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                children: car.car.name
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                children: car.car.type.name
                            })
                        ]
                    }),
                    selectableTrimCodes.length > 2 ? /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                            type: "button",
                            className: "bg-black w-full whitespace-nowrap rounded-3xl text-white px-4 py-1",
                            onClick: ()=>openSwitchCarModal(index),
                            children: "Byt modell"
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("ul", {
                className: "flex flex-col gap-2",
                children: [
                    typeOfLeasing === (0, $bEVCz.TypeOfLeasing).BUSINESS ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
                        children: (0, $lRXuw.includedBusinessLeasing).map((item, index)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                                className: "flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        children: item.label
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        children: item.value
                                    })
                                ]
                            }, index))
                    }) : null,
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                children: typeOfLeasing === (0, $bEVCz.TypeOfLeasing).BUSINESS ? "Business Lease\u2075\u207E" : "Leasinghyra Finansiell Leasing\u2076\u207E (exkl moms)"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                children: [
                                    (0, $1lSPe.fNumber)(car.calc.monthlyCost),
                                    "/m\xe5n"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a3tFn.default), {
                onClick: ()=>openCarDetailsModal(car),
                children: (0, $lRXuw.general).showDetails
            })
        ]
    });
}

});

parcelRegister("carWB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73aba6c8925e6d28$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $kM2Bn = parcelRequire("kM2Bn");

var $j2mYw = parcelRequire("j2mYw");

var $4AtAC = parcelRequire("4AtAC");
function $73aba6c8925e6d28$export$2e2bcd8739ae039() {
    const allCarModels = (0, $4AtAC.useCarStoreContext)((state)=>state.allCarModels);
    const selectableTrimCodes = (0, $4AtAC.useCarStoreContext)((state)=>state.selectableTrimCodes);
    const replaceActiveCar = (0, $4AtAC.useCarStoreContext)((state)=>state.replaceActiveCar);
    const activeTrimCodes = (0, $4AtAC.useCarStoreContext)((state)=>state.activeTrimCodes);
    const isSwitchCarModalOpen = (0, $4AtAC.useCarStoreContext)((state)=>state.isSwitchCarModalOpen);
    const closeSwitchCarModal = (0, $4AtAC.useCarStoreContext)((state)=>state.closeSwitchCarModal);
    const carIndexToReplace = (0, $4AtAC.useCarStoreContext)((state)=>state.carIndexToReplace);
    const [selectedModel, setSelectedModel] = (0, $8FY87.useState)(null);
    const otherActiveCarCodes = (0, $8FY87.useMemo)(()=>{
        if (carIndexToReplace === null) return [];
        return activeTrimCodes.filter((_, index)=>index !== carIndexToReplace);
    }, [
        activeTrimCodes,
        carIndexToReplace
    ]);
    const filteredCarModels = (0, $8FY87.useMemo)(()=>{
        if (!selectableTrimCodes.length || !allCarModels) return [];
        return allCarModels.filter((model)=>model.calculator_cars.some((car)=>selectableTrimCodes.includes(car.code)));
    }, [
        allCarModels,
        selectableTrimCodes
    ]);
    const handleSelectCar = (newTrimCode)=>{
        if (carIndexToReplace !== null) replaceActiveCar(carIndexToReplace, newTrimCode);
        handleCloseModal();
    };
    const handleCloseModal = ()=>{
        closeSwitchCarModal();
        setSelectedModel(null);
    };
    if (!isSwitchCarModalOpen) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kM2Bn.default), {
        clickOutside: handleCloseModal,
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: "relative max-w-xl bg-white max-h-[90dvh] lg:max-h-[70dvh] p-8 flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: "flex justify-between items-center",
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("h1", {
                        className: "text-2xl font-bold",
                        children: selectedModel ? `V\xe4lj en ${selectedModel.name}` : 'Byt modell'
                    })
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: "overflow-y-auto flex flex-col min-w-96 gap-4",
                    children: !selectedModel ? /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                        className: "grid gap-2",
                        children: filteredCarModels.map((model)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                className: "grid",
                                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                                    onClick: ()=>setSelectedModel(model),
                                    className: "flex shadow m-1 px-3 py-4 rounded items-center gap-2 justify-between hover:underline hover:bg-kia-grey/50 transition-colors",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                                            className: "w-28",
                                            src: model.calculator_cars[0]?.image,
                                            alt: model.name
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                            children: model.name
                                        })
                                    ]
                                })
                            }, model.id))
                    }) : /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                        className: "grid gap-2",
                        children: selectedModel.calculator_cars.filter((car)=>selectableTrimCodes.includes(car.code)).filter((car)=>!otherActiveCarCodes.includes(car.code)).map((car)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                className: "grid",
                                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                                    onClick: ()=>handleSelectCar(car.code),
                                    className: "flex shadow m-1 px-3 py-4 rounded items-center gap-2 justify-between hover:underline hover:bg-kia-grey/50 transition-colors",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                                            className: "w-28",
                                            src: car.image,
                                            alt: car.name
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                            children: car.name
                                        })
                                    ]
                                })
                            }, car.code))
                    })
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "grid gap-4",
                    children: [
                        selectedModel && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $j2mYw.default), {
                            onClick: ()=>setSelectedModel(null),
                            className: "w-full",
                            children: "Tillbaka"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $j2mYw.default), {
                            onClick: handleCloseModal,
                            className: "w-full",
                            children: "Avbryt"
                        })
                    ]
                })
            ]
        })
    });
}

});

parcelRegister("kg9We", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b83a485a50615697$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $dA2bf = parcelRequire("dA2bf");

var $9Fpjc = parcelRequire("9Fpjc");

var $lRXuw = parcelRequire("lRXuw");
const $b83a485a50615697$var$CarExcerpt = ()=>{
    const { typeOfLeasing: typeOfLeasing } = (0, $9Fpjc.default)();
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "grid gap-2 mb-4",
        children: [
            (0, $lRXuw.excerpt).map((item)=>{
                return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                    children: [
                        item.heading ? /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                            className: "text-xl font-semibold",
                            children: item.heading
                        }) : null,
                        item.paragraph ? /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            className: "pb-2",
                            children: item.paragraph
                        }) : null
                    ]
                }, item.heading);
            }),
            typeOfLeasing === (0, $dA2bf.TypeOfLeasing).BUSINESS ? /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                className: "text-xl font-semibold",
                children: (0, $lRXuw.businessExcerpt).heading
            }) : /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                className: "text-xl font-semibold",
                children: (0, $lRXuw.financialExcerpt).heading
            })
        ]
    });
};
var $b83a485a50615697$export$2e2bcd8739ae039 = $b83a485a50615697$var$CarExcerpt;

});

parcelRegister("2kX7d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2081805c6f42d656$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $dA2bf = parcelRequire("dA2bf");

var $9Fpjc = parcelRequire("9Fpjc");

var $jiCSz = parcelRequire("jiCSz");

var $8xY5P = parcelRequire("8xY5P");

var $bYbWH = parcelRequire("bYbWH");

var $lRXuw = parcelRequire("lRXuw");
function $2081805c6f42d656$export$2e2bcd8739ae039() {
    const { updateSettingsStore: updateSettingsStore, firstRent: firstRent, fuelBenefit: fuelBenefit, typeOfLeasing: typeOfLeasing } = (0, $9Fpjc.default)();
    const handleFuelBenefitChange = (e)=>{
        const newFuelBenefitValue = e.target.value === 'true';
        updateSettingsStore({
            fuelBenefit: newFuelBenefitValue
        });
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("aside", {
        className: "flex flex-col gap-6",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                        className: "lg:border-t-2 text-xl pt-4 pb-2 border-black",
                        children: (0, $lRXuw.filter).heading
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        className: "text-sm",
                        children: (0, $lRXuw.filter).subHeading
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                        htmlFor: "type-of-leasing",
                        children: (0, $lRXuw.filter).typeOfLeasing
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("select", {
                        onChange: (e)=>{
                            updateSettingsStore({
                                typeOfLeasing: e.target.value
                            });
                        },
                        id: "type-of-leasing",
                        className: "p-4 bg-white rounded-[2px] border border-black ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow focus-visible:outline-none w-full",
                        defaultValue: typeOfLeasing,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                value: (0, $dA2bf.TypeOfLeasing).BUSINESS,
                                children: (0, $dA2bf.TypeOfLeasing).BUSINESS
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                value: (0, $dA2bf.TypeOfLeasing).FINANCIAL,
                                children: (0, $dA2bf.TypeOfLeasing).FINANCIAL
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bYbWH.default), {}),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                        children: (0, $lRXuw.filter).elevatedFirstMonthRent.label
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("label", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                type: "checkbox",
                                className: "ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow focus-within:outline-none",
                                id: "increased-rent",
                                defaultChecked: firstRent,
                                onChange: (e)=>updateSettingsStore({
                                        firstRent: e.target.checked
                                    })
                            }),
                            (0, $lRXuw.filter).elevatedFirstMonthRent.subLabel
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                        children: (0, $lRXuw.filter).fuelBenefit.label
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        className: "text-sm mb-4",
                        children: (0, $lRXuw.filter).fuelBenefit.subLabel
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("label", {
                                htmlFor: "fuel_benefit_yes",
                                className: "flex gap-2 items-center",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                        type: "radio",
                                        id: "fuel_benefit_yes",
                                        name: "fuel_benefit",
                                        value: "true",
                                        defaultChecked: fuelBenefit === true,
                                        className: "ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow focus-within:outline-none",
                                        onChange: handleFuelBenefitChange
                                    }),
                                    "Ja"
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("label", {
                                htmlFor: "fuel_benefit_no",
                                className: "flex gap-2 items-center",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                        type: "radio",
                                        id: "fuel_benefit_no",
                                        name: "fuel_benefit",
                                        value: "false",
                                        defaultChecked: fuelBenefit === false,
                                        className: "ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow focus-within:outline-none",
                                        onChange: handleFuelBenefitChange
                                    }),
                                    "Nej"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jiCSz.default), {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8xY5P.default), {})
        ]
    });
}

});
parcelRegister("jiCSz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afc5179ac3888bac$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $lRXuw = parcelRequire("lRXuw");

var $9Fpjc = parcelRequire("9Fpjc");
const $afc5179ac3888bac$var$Fuel = ()=>{
    const { updateSettingsStore: updateSettingsStore, electricityPricePerKwh: electricityPricePerKwh, gasPricePerLiter: gasPricePerLiter } = (0, $9Fpjc.default)();
    const [electricFuelCost, setElectricFuelCost] = (0, $8FY87.useState)(String(electricityPricePerKwh));
    const [gasFuelCost, setGasFuelCost] = (0, $8FY87.useState)(String(gasPricePerLiter));
    (0, $8FY87.useEffect)(()=>{
        updateSettingsStore({
            electricityPricePerKwh: Number(electricFuelCost)
        });
    }, [
        electricFuelCost
    ]);
    (0, $8FY87.useEffect)(()=>{
        updateSettingsStore({
            gasPricePerLiter: Number(gasFuelCost)
        });
    }, [
        gasFuelCost
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "flex flex-col gap-2 relative",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                        htmlFor: "electric-fuel-cost",
                        children: (0, $lRXuw.filter).fuelCostElectric
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                id: "electric-fuel-cost",
                                value: electricFuelCost,
                                type: "number",
                                className: "py-4 pl-4 pr-10 w-full rounded-[2px] border border-black ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow focus-visible:outline-none",
                                onChange: (e)=>{
                                    setElectricFuelCost(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                className: "absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none",
                                children: "kr/kWh"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "flex flex-col gap-2 relative",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                        htmlFor: "fuel-cost",
                        children: (0, $lRXuw.filter).fuelCost
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                id: "fuel-cost",
                                value: gasFuelCost,
                                type: "number",
                                className: "py-4 pl-4 pr-10 w-full rounded-[2px] border border-black ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow focus-visible:outline-none",
                                onChange: (e)=>{
                                    setGasFuelCost(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                className: "absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none",
                                children: "kr/liter"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $afc5179ac3888bac$export$2e2bcd8739ae039 = $afc5179ac3888bac$var$Fuel;

});

parcelRegister("8xY5P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95d43ee3daf6391d$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $geEW9 = parcelRequire("geEW9");

var $lRXuw = parcelRequire("lRXuw");

var $9Fpjc = parcelRequire("9Fpjc");

var $jcPqj = parcelRequire("jcPqj");
const $95d43ee3daf6391d$var$MarginalTax = ()=>{
    const { updateSettingsStore: updateSettingsStore, percentTaxRate: percentTaxRate } = (0, $9Fpjc.default)();
    const [tax, setTax] = (0, $8FY87.useState)(percentTaxRate * 100);
    const [taxDebouncedValue, setTaxDebouncedValue] = (0, $geEW9.useDebounceValue)(percentTaxRate * 100, 200);
    (0, $8FY87.useEffect)(()=>{
        updateSettingsStore({
            percentTaxRate: (0, $jcPqj.percentToDecimal)(taxDebouncedValue)
        });
    }, [
        taxDebouncedValue
    ]);
    (0, $8FY87.useEffect)(()=>{
        setTaxDebouncedValue(tax);
    }, [
        tax
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "flex gap-2 justify-between",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                            htmlFor: "marnigal-tax",
                            children: (0, $lRXuw.filter).marginalTax
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                            children: [
                                tax,
                                " %"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                    onChange: (e)=>setTax(Number(e.target.value)),
                    type: "range",
                    id: "marnigal-tax",
                    className: "ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow",
                    defaultValue: tax,
                    min: 30,
                    max: 55
                })
            ]
        })
    });
};
var $95d43ee3daf6391d$export$2e2bcd8739ae039 = $95d43ee3daf6391d$var$MarginalTax;

});
parcelRegister("geEW9", function(module, exports) {

$parcel$export(module.exports, "useCopyToClipboard", function () { return $bd1db55df8ecf8fc$export$b2199c37e85de4a7; });
$parcel$export(module.exports, "useDebounceValue", function () { return $bd1db55df8ecf8fc$export$52bae15610182273; });

var $8FY87 = parcelRequire("8FY87");

var $61omv = parcelRequire("61omv");
// src/useBoolean/useBoolean.ts
function $bd1db55df8ecf8fc$export$c32275ecbd12948f(defaultValue = false) {
    if (typeof defaultValue !== "boolean") throw new Error("defaultValue must be `true` or `false`");
    const [value, setValue] = (0, $8FY87.useState)(defaultValue);
    const setTrue = (0, $8FY87.useCallback)(()=>{
        setValue(true);
    }, []);
    const setFalse = (0, $8FY87.useCallback)(()=>{
        setValue(false);
    }, []);
    const toggle = (0, $8FY87.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return {
        value: value,
        setValue: setValue,
        setTrue: setTrue,
        setFalse: setFalse,
        toggle: toggle
    };
}
var $bd1db55df8ecf8fc$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $8FY87.useLayoutEffect) : (0, $8FY87.useEffect);
// src/useEventListener/useEventListener.ts
function $bd1db55df8ecf8fc$export$7080b3e976bc91ab(eventName, handler, element, options) {
    const savedHandler = (0, $8FY87.useRef)(handler);
    $bd1db55df8ecf8fc$export$700979bc83e7db82(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $8FY87.useEffect)(()=>{
        const targetElement = (element == null ? void 0 : element.current) ?? window;
        if (!(targetElement && targetElement.addEventListener)) return;
        const listener = (event)=>{
            savedHandler.current(event);
        };
        targetElement.addEventListener(eventName, listener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
}
// src/useClickAnyWhere/useClickAnyWhere.ts
function $bd1db55df8ecf8fc$export$5139c081cbc6c8bb(handler) {
    $bd1db55df8ecf8fc$export$7080b3e976bc91ab("click", (event)=>{
        handler(event);
    });
}
function $bd1db55df8ecf8fc$export$b2199c37e85de4a7() {
    const [copiedText, setCopiedText] = (0, $8FY87.useState)(null);
    const copy = (0, $8FY87.useCallback)(async (text)=>{
        if (!(navigator == null ? void 0 : navigator.clipboard)) {
            console.warn("Clipboard not supported");
            return false;
        }
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        } catch (error) {
            console.warn("Copy failed", error);
            setCopiedText(null);
            return false;
        }
    }, []);
    return [
        copiedText,
        copy
    ];
}
function $bd1db55df8ecf8fc$export$70c4067197c60e2d(initialValue) {
    const [count, setCount] = (0, $8FY87.useState)(initialValue ?? 0);
    const increment = (0, $8FY87.useCallback)(()=>{
        setCount((x)=>x + 1);
    }, []);
    const decrement = (0, $8FY87.useCallback)(()=>{
        setCount((x)=>x - 1);
    }, []);
    const reset = (0, $8FY87.useCallback)(()=>{
        setCount(initialValue ?? 0);
    }, [
        initialValue
    ]);
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset,
        setCount: setCount
    };
}
function $bd1db55df8ecf8fc$export$f4b266cd2aae9cb1(callback, delay) {
    const savedCallback = (0, $8FY87.useRef)(callback);
    $bd1db55df8ecf8fc$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (delay === null) return;
        const id = setInterval(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearInterval(id);
        };
    }, [
        delay
    ]);
}
// src/useCountdown/useCountdown.ts
function $bd1db55df8ecf8fc$export$8103f7eb37e19f7b({ countStart: countStart, countStop: countStop = 0, intervalMs: intervalMs = 1e3, isIncrement: isIncrement = false }) {
    const { count: count, increment: increment, decrement: decrement, reset: resetCounter } = $bd1db55df8ecf8fc$export$70c4067197c60e2d(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown } = $bd1db55df8ecf8fc$export$c32275ecbd12948f(false);
    const resetCountdown = (0, $8FY87.useCallback)(()=>{
        stopCountdown();
        resetCounter();
    }, [
        stopCountdown,
        resetCounter
    ]);
    const countdownCallback = (0, $8FY87.useCallback)(()=>{
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) increment();
        else decrement();
    }, [
        count,
        countStop,
        decrement,
        increment,
        isIncrement,
        stopCountdown
    ]);
    $bd1db55df8ecf8fc$export$f4b266cd2aae9cb1(countdownCallback, isCountdownRunning ? intervalMs : null);
    return [
        count,
        {
            startCountdown: startCountdown,
            stopCountdown: stopCountdown,
            resetCountdown: resetCountdown
        }
    ];
}
function $bd1db55df8ecf8fc$export$ee5b5d04074a389e(fn) {
    const ref = (0, $8FY87.useRef)(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    $bd1db55df8ecf8fc$export$700979bc83e7db82(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    return (0, $8FY87.useCallback)((...args)=>{
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.call(ref, ...args);
    }, [
        ref
    ]);
}
// src/useLocalStorage/useLocalStorage.ts
var $bd1db55df8ecf8fc$var$IS_SERVER = typeof window === "undefined";
function $bd1db55df8ecf8fc$export$86e2cef2561044ac(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $8FY87.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $8FY87.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $8FY87.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($bd1db55df8ecf8fc$var$IS_SERVER) return initialValueToUse;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $8FY87.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $bd1db55df8ecf8fc$export$ee5b5d04074a389e((value)=>{
        if ($bd1db55df8ecf8fc$var$IS_SERVER) console.warn(`Tried setting localStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.localStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("local-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting localStorage key \u201C${key}\u201D:`, error);
        }
    });
    const removeValue = $bd1db55df8ecf8fc$export$ee5b5d04074a389e(()=>{
        if ($bd1db55df8ecf8fc$var$IS_SERVER) console.warn(`Tried removing localStorage key \u201C${key}\u201D even though environment is not a client`);
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        window.localStorage.removeItem(key);
        setStoredValue(defaultValue);
        window.dispatchEvent(new StorageEvent("local-storage", {
            key: key
        }));
    });
    (0, $8FY87.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $8FY87.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $bd1db55df8ecf8fc$export$7080b3e976bc91ab("storage", handleStorageChange);
    $bd1db55df8ecf8fc$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return [
        storedValue,
        setValue,
        removeValue
    ];
}
var $bd1db55df8ecf8fc$var$IS_SERVER2 = typeof window === "undefined";
function $bd1db55df8ecf8fc$export$32d5543ab307c01(query, { defaultValue: defaultValue = false, initializeWithValue: initializeWithValue = true } = {}) {
    const getMatches = (query2)=>{
        if ($bd1db55df8ecf8fc$var$IS_SERVER2) return defaultValue;
        return window.matchMedia(query2).matches;
    };
    const [matches, setMatches] = (0, $8FY87.useState)(()=>{
        if (initializeWithValue) return getMatches(query);
        return defaultValue;
    });
    function handleChange() {
        setMatches(getMatches(query));
    }
    $bd1db55df8ecf8fc$export$700979bc83e7db82(()=>{
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) matchMedia.addListener(handleChange);
        else matchMedia.addEventListener("change", handleChange);
        return ()=>{
            if (matchMedia.removeListener) matchMedia.removeListener(handleChange);
            else matchMedia.removeEventListener("change", handleChange);
        };
    }, [
        query
    ]);
    return matches;
}
// src/useDarkMode/useDarkMode.ts
var $bd1db55df8ecf8fc$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
var $bd1db55df8ecf8fc$var$LOCAL_STORAGE_KEY = "usehooks-ts-dark-mode";
function $bd1db55df8ecf8fc$export$4673cbff94e146e2(options = {}) {
    const { defaultValue: defaultValue, localStorageKey: localStorageKey = $bd1db55df8ecf8fc$var$LOCAL_STORAGE_KEY, initializeWithValue: initializeWithValue = true } = options;
    const isDarkOS = $bd1db55df8ecf8fc$export$32d5543ab307c01($bd1db55df8ecf8fc$var$COLOR_SCHEME_QUERY, {
        initializeWithValue: initializeWithValue,
        defaultValue: defaultValue
    });
    const [isDarkMode, setDarkMode] = $bd1db55df8ecf8fc$export$86e2cef2561044ac(localStorageKey, defaultValue ?? isDarkOS ?? false, {
        initializeWithValue: initializeWithValue
    });
    $bd1db55df8ecf8fc$export$700979bc83e7db82(()=>{
        if (isDarkOS !== isDarkMode) setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    return {
        isDarkMode: isDarkMode,
        toggle: ()=>{
            setDarkMode((prev)=>!prev);
        },
        enable: ()=>{
            setDarkMode(true);
        },
        disable: ()=>{
            setDarkMode(false);
        },
        set: (value)=>{
            setDarkMode(value);
        }
    };
}
function $bd1db55df8ecf8fc$export$89e33b3d84d8c331(func) {
    const funcRef = (0, $8FY87.useRef)(func);
    funcRef.current = func;
    (0, $8FY87.useEffect)(()=>()=>{
            funcRef.current();
        }, []);
}
// src/useDebounceCallback/useDebounceCallback.ts
function $bd1db55df8ecf8fc$export$40ae01be0011c1e6(func, delay = 500, options) {
    const debouncedFunc = (0, $8FY87.useRef)();
    $bd1db55df8ecf8fc$export$89e33b3d84d8c331(()=>{
        if (debouncedFunc.current) debouncedFunc.current.cancel();
    });
    const debounced = (0, $8FY87.useMemo)(()=>{
        const debouncedFuncInstance = (0, (/*@__PURE__*/$parcel$interopDefault($61omv)))(func, delay, options);
        const wrappedFunc = (...args)=>{
            return debouncedFuncInstance(...args);
        };
        wrappedFunc.cancel = ()=>{
            debouncedFuncInstance.cancel();
        };
        wrappedFunc.isPending = ()=>{
            return !!debouncedFunc.current;
        };
        wrappedFunc.flush = ()=>{
            return debouncedFuncInstance.flush();
        };
        return wrappedFunc;
    }, [
        func,
        delay,
        options
    ]);
    (0, $8FY87.useEffect)(()=>{
        debouncedFunc.current = (0, (/*@__PURE__*/$parcel$interopDefault($61omv)))(func, delay, options);
    }, [
        func,
        delay,
        options
    ]);
    return debounced;
}
function $bd1db55df8ecf8fc$export$52bae15610182273(initialValue, delay, options) {
    const eq = (options == null ? void 0 : options.equalityFn) ?? ((left, right)=>left === right);
    const unwrappedInitialValue = initialValue instanceof Function ? initialValue() : initialValue;
    const [debouncedValue, setDebouncedValue] = (0, $8FY87.useState)(unwrappedInitialValue);
    const previousValueRef = (0, $8FY87.useRef)(unwrappedInitialValue);
    const updateDebouncedValue = $bd1db55df8ecf8fc$export$40ae01be0011c1e6(setDebouncedValue, delay, options);
    if (!eq(previousValueRef.current, unwrappedInitialValue)) {
        updateDebouncedValue(unwrappedInitialValue);
        previousValueRef.current = unwrappedInitialValue;
    }
    return [
        debouncedValue,
        updateDebouncedValue
    ];
}
function $bd1db55df8ecf8fc$export$4b208edda918084f(title, options = {}) {
    const { preserveTitleOnUnmount: preserveTitleOnUnmount = true } = options;
    const defaultTitle = (0, $8FY87.useRef)(null);
    $bd1db55df8ecf8fc$export$700979bc83e7db82(()=>{
        defaultTitle.current = window.document.title;
    }, []);
    $bd1db55df8ecf8fc$export$700979bc83e7db82(()=>{
        window.document.title = title;
    }, [
        title
    ]);
    $bd1db55df8ecf8fc$export$89e33b3d84d8c331(()=>{
        if (!preserveTitleOnUnmount && defaultTitle.current) window.document.title = defaultTitle.current;
    });
}
function $bd1db55df8ecf8fc$export$ae780daf29e6d456(elementRef) {
    const [value, setValue] = (0, $8FY87.useState)(false);
    const handleMouseEnter = ()=>{
        setValue(true);
    };
    const handleMouseLeave = ()=>{
        setValue(false);
    };
    $bd1db55df8ecf8fc$export$7080b3e976bc91ab("mouseenter", handleMouseEnter, elementRef);
    $bd1db55df8ecf8fc$export$7080b3e976bc91ab("mouseleave", handleMouseLeave, elementRef);
    return value;
}
function $bd1db55df8ecf8fc$export$a7395f9832c00176({ threshold: threshold = 0, root: root = null, rootMargin: rootMargin = "0%", freezeOnceVisible: freezeOnceVisible = false, initialIsIntersecting: initialIsIntersecting = false, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = (0, $8FY87.useState)(null);
    const [state, setState] = (0, $8FY87.useState)(()=>({
            isIntersecting: initialIsIntersecting,
            entry: void 0
        }));
    const callbackRef = (0, $8FY87.useRef)();
    callbackRef.current = onChange;
    const frozen = ((_a = state.entry) == null ? void 0 : _a.isIntersecting) && freezeOnceVisible;
    (0, $8FY87.useEffect)(()=>{
        if (!ref) return;
        if (!("IntersectionObserver" in window)) return;
        if (frozen) return;
        let unobserve;
        const observer = new IntersectionObserver((entries)=>{
            const thresholds = Array.isArray(observer.thresholds) ? observer.thresholds : [
                observer.thresholds
            ];
            entries.forEach((entry)=>{
                const isIntersecting = entry.isIntersecting && thresholds.some((threshold2)=>entry.intersectionRatio >= threshold2);
                setState({
                    isIntersecting: isIntersecting,
                    entry: entry
                });
                if (callbackRef.current) callbackRef.current(isIntersecting, entry);
                if (isIntersecting && freezeOnceVisible && unobserve) {
                    unobserve();
                    unobserve = void 0;
                }
            });
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(threshold),
        root,
        rootMargin,
        frozen,
        freezeOnceVisible
    ]);
    const prevRef = (0, $8FY87.useRef)(null);
    (0, $8FY87.useEffect)(()=>{
        var _a2;
        if (!ref && ((_a2 = state.entry) == null ? void 0 : _a2.target) && !freezeOnceVisible && !frozen && prevRef.current !== state.entry.target) {
            prevRef.current = state.entry.target;
            setState({
                isIntersecting: initialIsIntersecting,
                entry: void 0
            });
        }
    }, [
        ref,
        state.entry,
        freezeOnceVisible,
        frozen,
        initialIsIntersecting
    ]);
    const result = [
        setRef,
        !!state.isIntersecting,
        state.entry
    ];
    result.ref = result[0];
    result.isIntersecting = result[1];
    result.entry = result[2];
    return result;
}
function $bd1db55df8ecf8fc$export$7c8949515a63d2a1() {
    const [isClient, setClient] = (0, $8FY87.useState)(false);
    (0, $8FY87.useEffect)(()=>{
        setClient(true);
    }, []);
    return isClient;
}
function $bd1db55df8ecf8fc$export$80c2a3957bcb42ea() {
    const isMounted = (0, $8FY87.useRef)(false);
    (0, $8FY87.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $8FY87.useCallback)(()=>isMounted.current, []);
}
function $bd1db55df8ecf8fc$export$86f8f9f08863e403(initialState = /* @__PURE__ */ new Map()) {
    const [map, setMap] = (0, $8FY87.useState)(new Map(initialState));
    const actions = {
        set: (0, $8FY87.useCallback)((key, value)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0, $8FY87.useCallback)((entries)=>{
            setMap(()=>new Map(entries));
        }, []),
        remove: (0, $8FY87.useCallback)((key)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0, $8FY87.useCallback)(()=>{
            setMap(()=>/* @__PURE__ */ new Map());
        }, [])
    };
    return [
        map,
        actions
    ];
}
// src/useOnClickOutside/useOnClickOutside.ts
function $bd1db55df8ecf8fc$export$9afc64c180e82dc4(ref, handler, eventType = "mousedown", eventListenerOptions = {}) {
    $bd1db55df8ecf8fc$export$7080b3e976bc91ab(eventType, (event)=>{
        const target = event.target;
        if (!target || !target.isConnected) return;
        const isOutside = Array.isArray(ref) ? ref.filter((r)=>Boolean(r.current)).every((r)=>r.current && !r.current.contains(target)) : ref.current && !ref.current.contains(target);
        if (isOutside) handler(event);
    }, void 0, eventListenerOptions);
}
var $bd1db55df8ecf8fc$var$IS_SERVER3 = typeof window === "undefined";
function $bd1db55df8ecf8fc$export$558ff211cfc1c1fe(key, options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($bd1db55df8ecf8fc$var$IS_SERVER3) initializeWithValue = false;
    const deserializer = (0, $8FY87.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return null;
        }
        return parsed;
    }, [
        options
    ]);
    const readValue = (0, $8FY87.useCallback)(()=>{
        if ($bd1db55df8ecf8fc$var$IS_SERVER3) return null;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : null;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return null;
        }
    }, [
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $8FY87.useState)(()=>{
        if (initializeWithValue) return readValue();
        return void 0;
    });
    (0, $8FY87.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $8FY87.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $bd1db55df8ecf8fc$export$7080b3e976bc91ab("storage", handleStorageChange);
    $bd1db55df8ecf8fc$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return storedValue;
}
var $bd1db55df8ecf8fc$var$initialSize = {
    width: void 0,
    height: void 0
};
function $bd1db55df8ecf8fc$export$683480f191c0e3ea(options) {
    const { ref: ref, box: box = "content-box" } = options;
    const [{ width: width, height: height }, setSize] = (0, $8FY87.useState)($bd1db55df8ecf8fc$var$initialSize);
    const isMounted = $bd1db55df8ecf8fc$export$80c2a3957bcb42ea();
    const previousSize = (0, $8FY87.useRef)({
        ...$bd1db55df8ecf8fc$var$initialSize
    });
    const onResize = (0, $8FY87.useRef)(void 0);
    onResize.current = options.onResize;
    (0, $8FY87.useEffect)(()=>{
        if (!ref.current) return;
        if (typeof window === "undefined" || !("ResizeObserver" in window)) return;
        const observer = new ResizeObserver(([entry])=>{
            const boxProp = box === "border-box" ? "borderBoxSize" : box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
            const newWidth = $bd1db55df8ecf8fc$var$extractSize(entry, boxProp, "inlineSize");
            const newHeight = $bd1db55df8ecf8fc$var$extractSize(entry, boxProp, "blockSize");
            const hasChanged = previousSize.current.width !== newWidth || previousSize.current.height !== newHeight;
            if (hasChanged) {
                const newSize = {
                    width: newWidth,
                    height: newHeight
                };
                previousSize.current.width = newWidth;
                previousSize.current.height = newHeight;
                if (onResize.current) onResize.current(newSize);
                else if (isMounted()) setSize(newSize);
            }
        });
        observer.observe(ref.current, {
            box: box
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        box,
        ref,
        isMounted
    ]);
    return {
        width: width,
        height: height
    };
}
function $bd1db55df8ecf8fc$var$extractSize(entry, box, sizeType) {
    if (!entry[box]) {
        if (box === "contentBoxSize") return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
        return void 0;
    }
    return Array.isArray(entry[box]) ? entry[box][0][sizeType] : // @ts-ignore Support Firefox's non-standard behavior
    entry[box][sizeType];
}
var $bd1db55df8ecf8fc$var$IS_SERVER4 = typeof window === "undefined";
function $bd1db55df8ecf8fc$export$654d3fb7a8fef387(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($bd1db55df8ecf8fc$var$IS_SERVER4) initializeWithValue = false;
    const readScreen = ()=>{
        if ($bd1db55df8ecf8fc$var$IS_SERVER4) return void 0;
        return window.screen;
    };
    const [screen, setScreen] = (0, $8FY87.useState)(()=>{
        if (initializeWithValue) return readScreen();
        return void 0;
    });
    const debouncedSetScreen = $bd1db55df8ecf8fc$export$40ae01be0011c1e6(setScreen, options.debounceDelay);
    function handleSize() {
        const newScreen = readScreen();
        const setSize = options.debounceDelay ? debouncedSetScreen : setScreen;
        if (newScreen) {
            const { width: width, height: height, availHeight: availHeight, availWidth: availWidth, colorDepth: colorDepth, orientation: orientation, pixelDepth: pixelDepth } = newScreen;
            setSize({
                width: width,
                height: height,
                availHeight: availHeight,
                availWidth: availWidth,
                colorDepth: colorDepth,
                orientation: orientation,
                pixelDepth: pixelDepth
            });
        }
    }
    $bd1db55df8ecf8fc$export$7080b3e976bc91ab("resize", handleSize);
    $bd1db55df8ecf8fc$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return screen;
}
var $bd1db55df8ecf8fc$var$cachedScriptStatuses = /* @__PURE__ */ new Map();
function $bd1db55df8ecf8fc$var$getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node == null ? void 0 : node.getAttribute("data-status");
    return {
        node: node,
        status: status
    };
}
function $bd1db55df8ecf8fc$export$1d3955b0b5cace9c(src, options) {
    const [status, setStatus] = (0, $8FY87.useState)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return "idle";
        if (typeof window === "undefined") return "loading";
        return $bd1db55df8ecf8fc$var$cachedScriptStatuses.get(src) ?? "loading";
    });
    (0, $8FY87.useEffect)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return;
        const cachedScriptStatus = $bd1db55df8ecf8fc$var$cachedScriptStatuses.get(src);
        if (cachedScriptStatus === "ready" || cachedScriptStatus === "error") {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = $bd1db55df8ecf8fc$var$getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement("script");
            scriptNode.src = src;
            scriptNode.async = true;
            if (options == null ? void 0 : options.id) scriptNode.id = options.id;
            scriptNode.setAttribute("data-status", "loading");
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event)=>{
                const scriptStatus = event.type === "load" ? "ready" : "error";
                scriptNode == null || scriptNode.setAttribute("data-status", scriptStatus);
            };
            scriptNode.addEventListener("load", setAttributeFromEvent);
            scriptNode.addEventListener("error", setAttributeFromEvent);
        } else setStatus(script.status ?? cachedScriptStatus ?? "loading");
        const setStateFromEvent = (event)=>{
            const newStatus = event.type === "load" ? "ready" : "error";
            setStatus(newStatus);
            $bd1db55df8ecf8fc$var$cachedScriptStatuses.set(src, newStatus);
        };
        scriptNode.addEventListener("load", setStateFromEvent);
        scriptNode.addEventListener("error", setStateFromEvent);
        return ()=>{
            if (scriptNode) {
                scriptNode.removeEventListener("load", setStateFromEvent);
                scriptNode.removeEventListener("error", setStateFromEvent);
            }
            if (scriptNode && (options == null ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
                $bd1db55df8ecf8fc$var$cachedScriptStatuses.delete(src);
            }
        };
    }, [
        src,
        options == null ? void 0 : options.shouldPreventLoad,
        options == null ? void 0 : options.removeOnUnmount,
        options == null ? void 0 : options.id
    ]);
    return status;
}
var $bd1db55df8ecf8fc$var$IS_SERVER5 = typeof window === "undefined";
function $bd1db55df8ecf8fc$export$e47ba1b900da5d3b(options = {}) {
    const { autoLock: autoLock = true, lockTarget: lockTarget, widthReflow: widthReflow = true } = options;
    const [isLocked, setIsLocked] = (0, $8FY87.useState)(false);
    const target = (0, $8FY87.useRef)(null);
    const originalStyle = (0, $8FY87.useRef)(null);
    const lock = ()=>{
        if (target.current) {
            const { overflow: overflow, paddingRight: paddingRight } = target.current.style;
            originalStyle.current = {
                overflow: overflow,
                paddingRight: paddingRight
            };
            if (widthReflow) {
                const offsetWidth = target.current === document.body ? window.innerWidth : target.current.offsetWidth;
                const currentPaddingRight = parseInt(window.getComputedStyle(target.current).paddingRight, 10) || 0;
                const scrollbarWidth = offsetWidth - target.current.scrollWidth;
                target.current.style.paddingRight = `${scrollbarWidth + currentPaddingRight}px`;
            }
            target.current.style.overflow = "hidden";
            setIsLocked(true);
        }
    };
    const unlock = ()=>{
        if (target.current && originalStyle.current) {
            target.current.style.overflow = originalStyle.current.overflow;
            if (widthReflow) target.current.style.paddingRight = originalStyle.current.paddingRight;
        }
        setIsLocked(false);
    };
    $bd1db55df8ecf8fc$export$700979bc83e7db82(()=>{
        if ($bd1db55df8ecf8fc$var$IS_SERVER5) return;
        if (lockTarget) target.current = typeof lockTarget === "string" ? document.querySelector(lockTarget) : lockTarget;
        if (!target.current) target.current = document.body;
        if (autoLock) lock();
        return ()=>{
            unlock();
        };
    }, [
        autoLock,
        lockTarget,
        widthReflow
    ]);
    return {
        isLocked: isLocked,
        lock: lock,
        unlock: unlock
    };
}
var $bd1db55df8ecf8fc$var$IS_SERVER6 = typeof window === "undefined";
function $bd1db55df8ecf8fc$export$864b6828bd07eda6(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $8FY87.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $8FY87.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $8FY87.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($bd1db55df8ecf8fc$var$IS_SERVER6) return initialValueToUse;
        try {
            const raw = window.sessionStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading sessionStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $8FY87.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $bd1db55df8ecf8fc$export$ee5b5d04074a389e((value)=>{
        if ($bd1db55df8ecf8fc$var$IS_SERVER6) console.warn(`Tried setting sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.sessionStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("session-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting sessionStorage key \u201C${key}\u201D:`, error);
        }
    });
    const removeValue = $bd1db55df8ecf8fc$export$ee5b5d04074a389e(()=>{
        if ($bd1db55df8ecf8fc$var$IS_SERVER6) console.warn(`Tried removing sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        window.sessionStorage.removeItem(key);
        setStoredValue(defaultValue);
        window.dispatchEvent(new StorageEvent("session-storage", {
            key: key
        }));
    });
    (0, $8FY87.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $8FY87.useCallback)((event)=>{
        if (event.key && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $bd1db55df8ecf8fc$export$7080b3e976bc91ab("storage", handleStorageChange);
    $bd1db55df8ecf8fc$export$7080b3e976bc91ab("session-storage", handleStorageChange);
    return [
        storedValue,
        setValue,
        removeValue
    ];
}
function $bd1db55df8ecf8fc$export$7896576cb7635832(maxStep) {
    const [currentStep, setCurrentStep] = (0, $8FY87.useState)(1);
    const canGoToNextStep = currentStep + 1 <= maxStep;
    const canGoToPrevStep = currentStep - 1 > 0;
    const setStep = (0, $8FY87.useCallback)((step)=>{
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error("Step not valid");
    }, [
        maxStep,
        currentStep
    ]);
    const goToNextStep = (0, $8FY87.useCallback)(()=>{
        if (canGoToNextStep) setCurrentStep((step)=>step + 1);
    }, [
        canGoToNextStep
    ]);
    const goToPrevStep = (0, $8FY87.useCallback)(()=>{
        if (canGoToPrevStep) setCurrentStep((step)=>step - 1);
    }, [
        canGoToPrevStep
    ]);
    const reset = (0, $8FY87.useCallback)(()=>{
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep: goToNextStep,
            goToPrevStep: goToPrevStep,
            canGoToNextStep: canGoToNextStep,
            canGoToPrevStep: canGoToPrevStep,
            setStep: setStep,
            reset: reset
        }
    ];
}
// src/useTernaryDarkMode/useTernaryDarkMode.ts
var $bd1db55df8ecf8fc$var$COLOR_SCHEME_QUERY2 = "(prefers-color-scheme: dark)";
var $bd1db55df8ecf8fc$var$LOCAL_STORAGE_KEY2 = "usehooks-ts-ternary-dark-mode";
function $bd1db55df8ecf8fc$export$ec561688e440eda6({ defaultValue: defaultValue = "system", localStorageKey: localStorageKey = $bd1db55df8ecf8fc$var$LOCAL_STORAGE_KEY2, initializeWithValue: initializeWithValue = true } = {}) {
    const isDarkOS = $bd1db55df8ecf8fc$export$32d5543ab307c01($bd1db55df8ecf8fc$var$COLOR_SCHEME_QUERY2, {
        initializeWithValue: initializeWithValue
    });
    const [mode, setMode] = $bd1db55df8ecf8fc$export$86e2cef2561044ac(localStorageKey, defaultValue, {
        initializeWithValue: initializeWithValue
    });
    const isDarkMode = mode === "dark" || mode === "system" && isDarkOS;
    const toggleTernaryDarkMode = ()=>{
        const modes = [
            "light",
            "system",
            "dark"
        ];
        setMode((prevMode)=>{
            const nextIndex = (modes.indexOf(prevMode) + 1) % modes.length;
            return modes[nextIndex];
        });
    };
    return {
        isDarkMode: isDarkMode,
        ternaryDarkMode: mode,
        setTernaryDarkMode: setMode,
        toggleTernaryDarkMode: toggleTernaryDarkMode
    };
}
function $bd1db55df8ecf8fc$export$d8e6abf214c9ec0f(callback, delay) {
    const savedCallback = (0, $8FY87.useRef)(callback);
    $bd1db55df8ecf8fc$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setTimeout(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearTimeout(id);
        };
    }, [
        delay
    ]);
}
function $bd1db55df8ecf8fc$export$cbe85ee05b554577(defaultValue) {
    const [value, setValue] = (0, $8FY87.useState)(!!defaultValue);
    const toggle = (0, $8FY87.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return [
        value,
        toggle,
        setValue
    ];
}
var $bd1db55df8ecf8fc$var$IS_SERVER7 = typeof window === "undefined";
function $bd1db55df8ecf8fc$export$42c02f33970a2afa(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($bd1db55df8ecf8fc$var$IS_SERVER7) initializeWithValue = false;
    const [windowSize, setWindowSize] = (0, $8FY87.useState)(()=>{
        if (initializeWithValue) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        return {
            width: void 0,
            height: void 0
        };
    });
    const debouncedSetWindowSize = $bd1db55df8ecf8fc$export$40ae01be0011c1e6(setWindowSize, options.debounceDelay);
    function handleSize() {
        const setSize = options.debounceDelay ? debouncedSetWindowSize : setWindowSize;
        setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }
    $bd1db55df8ecf8fc$export$7080b3e976bc91ab("resize", handleSize);
    $bd1db55df8ecf8fc$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return windowSize;
}

});
parcelRegister("61omv", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $4625bbdce08b3b1a$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $4625bbdce08b3b1a$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $4625bbdce08b3b1a$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $4625bbdce08b3b1a$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $4625bbdce08b3b1a$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $4625bbdce08b3b1a$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $4625bbdce08b3b1a$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $4625bbdce08b3b1a$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $4625bbdce08b3b1a$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $4625bbdce08b3b1a$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $4625bbdce08b3b1a$var$root = $4625bbdce08b3b1a$var$freeGlobal || $4625bbdce08b3b1a$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $4625bbdce08b3b1a$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4625bbdce08b3b1a$var$objectToString = $4625bbdce08b3b1a$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4625bbdce08b3b1a$var$nativeMax = Math.max, $4625bbdce08b3b1a$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $4625bbdce08b3b1a$var$now = function() {
    return $4625bbdce08b3b1a$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $4625bbdce08b3b1a$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($4625bbdce08b3b1a$var$FUNC_ERROR_TEXT);
    wait = $4625bbdce08b3b1a$var$toNumber(wait) || 0;
    if ($4625bbdce08b3b1a$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $4625bbdce08b3b1a$var$nativeMax($4625bbdce08b3b1a$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $4625bbdce08b3b1a$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $4625bbdce08b3b1a$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($4625bbdce08b3b1a$var$now());
    }
    function debounced() {
        var time = $4625bbdce08b3b1a$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $4625bbdce08b3b1a$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $4625bbdce08b3b1a$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $4625bbdce08b3b1a$var$isSymbol(value) {
    return typeof value == 'symbol' || $4625bbdce08b3b1a$var$isObjectLike(value) && $4625bbdce08b3b1a$var$objectToString.call(value) == $4625bbdce08b3b1a$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $4625bbdce08b3b1a$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($4625bbdce08b3b1a$var$isSymbol(value)) return $4625bbdce08b3b1a$var$NAN;
    if ($4625bbdce08b3b1a$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $4625bbdce08b3b1a$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($4625bbdce08b3b1a$var$reTrim, '');
    var isBinary = $4625bbdce08b3b1a$var$reIsBinary.test(value);
    return isBinary || $4625bbdce08b3b1a$var$reIsOctal.test(value) ? $4625bbdce08b3b1a$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $4625bbdce08b3b1a$var$reIsBadHex.test(value) ? $4625bbdce08b3b1a$var$NAN : +value;
}
module.exports = $4625bbdce08b3b1a$var$debounce;

});



parcelRegister("bYbWH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e22c2fb377e96bb$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $lRXuw = parcelRequire("lRXuw");

var $9Fpjc = parcelRequire("9Fpjc");
const $5e22c2fb377e96bb$var$MILEAGE_STEPS = [
    1500,
    2000,
    3000,
    4000
];
const $5e22c2fb377e96bb$var$MileageFilter = ()=>{
    const { mileage: mileage, workMileage: workMileage, updateSettingsStore: updateSettingsStore } = (0, $9Fpjc.default)();
    const handleUpdateMileage = (e)=>{
        const index = parseInt(e.target.value);
        const mileageValue = $5e22c2fb377e96bb$var$MILEAGE_STEPS[index];
        if (mileageValue < workMileage) updateSettingsStore({
            workMileage: mileageValue
        });
        updateSettingsStore({
            mileage: mileageValue
        });
    };
    const handleUpdateWorkMileage = (e)=>{
        updateSettingsStore({
            workMileage: parseInt(e.target.value)
        });
    };
    const currentMileageIndex = $5e22c2fb377e96bb$var$MILEAGE_STEPS.indexOf(mileage);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "flex gap-2 justify-between",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                htmlFor: "mileage",
                                children: (0, $lRXuw.filter).mileageLabel
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                children: [
                                    mileage,
                                    " mil/\xe5r"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                        onChange: handleUpdateMileage,
                        type: "range",
                        id: "mileage",
                        className: "ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow",
                        value: currentMileageIndex > -1 ? currentMileageIndex : 0,
                        min: 0,
                        max: $5e22c2fb377e96bb$var$MILEAGE_STEPS.length - 1,
                        step: 1
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "flex gap-2 justify-between",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                htmlFor: "business-mileage",
                                children: (0, $lRXuw.filter).mileageServiceLabel
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                children: [
                                    workMileage,
                                    " mil/\xe5r"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                        onChange: handleUpdateWorkMileage,
                        type: "range",
                        id: "business-mileage",
                        className: "ring-dark-blue ring-offset-1 focus-visible:ring-2 transition-shadow",
                        value: workMileage,
                        min: 100,
                        max: mileage,
                        step: 100
                    })
                ]
            })
        ]
    });
};
var $5e22c2fb377e96bb$export$2e2bcd8739ae039 = $5e22c2fb377e96bb$var$MileageFilter;

});


parcelRegister("4TYXv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81ca6d1c6d0affc8$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $lRXuw = parcelRequire("lRXuw");
const $81ca6d1c6d0affc8$var$Legal = ()=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: "grid gap-3 mt-8",
        children: (0, $lRXuw.legal).map((item, i)=>/*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                className: "text-sm text-gray-400",
                dangerouslySetInnerHTML: {
                    __html: item
                }
            }, i))
    });
};
var $81ca6d1c6d0affc8$export$2e2bcd8739ae039 = $81ca6d1c6d0affc8$var$Legal;

});

parcelRegister("cfLoc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14cef518cd7b4acc$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $1lSPe = parcelRequire("1lSPe");

var $4AtAC = parcelRequire("4AtAC");

var $9Fpjc = parcelRequire("9Fpjc");

var $bEVCz = parcelRequire("bEVCz");

var $lRXuw = parcelRequire("lRXuw");
const $14cef518cd7b4acc$var$PriceTable = ()=>{
    const activeCarPair = (0, $4AtAC.useCarStoreContext)((state)=>state.activeCarPair);
    const { typeOfLeasing: typeOfLeasing } = (0, $9Fpjc.default)();
    const reducer = (state, action)=>{
        switch(action.type){
            case 'firstToggle':
                return {
                    ...state,
                    firstOpen: !state.firstOpen
                };
            case 'secondToggle':
                return {
                    ...state,
                    secondOpen: !state.secondOpen
                };
            default:
                return state;
        }
    };
    const [tables, dispatch] = (0, $8FY87.useReducer)(reducer, {
        firstOpen: false,
        secondOpen: false
    });
    if (!activeCarPair || activeCarPair.length === 0) return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: "price-table"
    });
    const driverCostRows = [
        {
            label: (0, $lRXuw.priceTable).formansVarde,
            value: (calc)=>calc.nettoFormansVarde.formansvarde_netto_monthly
        },
        {
            label: (0, $lRXuw.priceTable).formansVardeFuel,
            value: (calc)=>calc.nettoFormansVarde.formansvarde_bransle_netto_monthly
        },
        {
            label: (0, $lRXuw.priceTable).fuel,
            value: (calc)=>calc.fuelCostMonthlyDriver
        }
    ];
    const companyCostRows = [
        {
            label: (0, $lRXuw.priceTable).finance,
            value: (calc)=>calc.monthlyCost
        },
        {
            label: (0, $lRXuw.priceTable).serviceDeal,
            value: (calc)=>calc.serviceCost,
            businessOnly: true
        },
        {
            label: (0, $lRXuw.priceTable).insurance,
            value: (calc)=>calc.insuranceCost,
            businessOnly: true
        },
        {
            label: (0, $lRXuw.priceTable).carTax,
            value: (calc)=>calc.taxMonthly
        },
        {
            label: (0, $lRXuw.priceTable).fuelCost,
            value: (calc)=>calc.fuelCostMonthlyBusiness
        },
        {
            label: (0, $lRXuw.priceTable).socialCost,
            value: (calc)=>calc.socialCostMonthly
        },
        {
            label: (0, $lRXuw.priceTable).socialCostFuel,
            value: (calc)=>calc.socialCostFuelMonthly
        }
    ];
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "w-full col-span-2 min-w-0 font-sans space-y-6 text-gray-900",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "grid",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: "text-sm text-dark-blue font-semibold",
                                children: (0, $lRXuw.priceTable).formansVardeNetto
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: "text-xs text-dark-blue",
                                children: "Fr\xe5n ca"
                            }),
                            activeCarPair.slice(1).map((car)=>/*#__PURE__*/ (0, $2PPWI.jsx)("div", {}, car.car.id))
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "grid mt-2 grid-cols-2 gap-4 lg:gap-8",
                        children: activeCarPair.map((carData)=>/*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: "text-2xl tracking-tight",
                                children: (0, $1lSPe.fNumber)(carData.calc.nettoFormansVarde.formansvarde_netto_monthly)
                            }, carData.car.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "border-t border-kia-grey pt-4",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "grid items-start grid-cols-2 gap-x-4 lg:gap-x-8",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: "text-sm font-semibold",
                                        children: (0, $lRXuw.priceTable).totalUser
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: "text-xs text-dark-blue",
                                        children: (0, $lRXuw.priceTable).inclFuel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                onClick: ()=>dispatch({
                                        type: 'firstToggle'
                                    }),
                                className: "text-2xl justify-self-end text-gray-400 size-8 hover:bg-gray-100 rounded-full flex items-center justify-center",
                                children: tables.firstOpen ? "\u2212" : "\uFF0B"
                            }),
                            activeCarPair.map((carData)=>/*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                    className: "text-2xl tracking-tight mt-2",
                                    children: (0, $1lSPe.fNumber)(carData.calc.totalCostPersonal)
                                }, carData.car.id))
                        ]
                    }),
                    tables.firstOpen && /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                        className: "mt-4 divide-y divide-kia-grey",
                        children: driverCostRows.map((row)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                className: "grid text-sm grid-cols-2 gap-x-4 lg:gap-x-8 py-2",
                                children: activeCarPair.map((carData)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                className: "text-dark-blue text-sm",
                                                children: row.label
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                className: "tabular-nums",
                                                children: (0, $1lSPe.fNumber)(row.value(carData.calc))
                                            })
                                        ]
                                    }, carData.car.id))
                            }, row.label))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "border-t border-kia-grey pt-4",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "grid items-start grid-cols-2 gap-x-4 lg:gap-x-8",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: "text-sm font-semibold",
                                        children: (0, $lRXuw.priceTable).totalCompany
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: "text-xs text-dark-blue",
                                        children: "Exkl. moms"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                onClick: ()=>dispatch({
                                        type: 'secondToggle'
                                    }),
                                className: "text-2xl justify-self-end text-gray-400 size-8 hover:bg-gray-100 rounded-full grid place-content-center",
                                children: tables.secondOpen ? "\u2212" : "\uFF0B"
                            }),
                            activeCarPair.map((carData)=>/*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                    className: "text-2xl tracking-tight mt-2",
                                    children: (0, $1lSPe.fNumber)(carData.calc.totalCostBusiness)
                                }, carData.car.id)),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "flex justify-end"
                            })
                        ]
                    }),
                    tables.secondOpen && /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                        className: "mt-4 border-gray-200 divide-y divide-kia-grey",
                        children: companyCostRows.map((row)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                className: "grid text-sm grid-cols-2 gap-x-4 lg:gap-x-8 py-2",
                                children: activeCarPair.map((carData)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                className: "text-dark-blue text-sm",
                                                children: row.label
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                className: "tabular-nums",
                                                children: row.businessOnly && typeOfLeasing === (0, $bEVCz.TypeOfLeasing).BUSINESS ? (0, $lRXuw.priceTable).included : `${(0, $1lSPe.fNumber)(row.value(carData.calc))}`
                                            })
                                        ]
                                    }, carData.car.id))
                            }, row.label))
                    })
                ]
            })
        ]
    });
};
var $14cef518cd7b4acc$export$2e2bcd8739ae039 = $14cef518cd7b4acc$var$PriceTable;

});

parcelRegister("dYQug", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d640537c89ca58fe$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4AtAC = parcelRequire("4AtAC");
function $d640537c89ca58fe$export$2e2bcd8739ae039() {
    const allCarModels = (0, $4AtAC.useCarStoreContext)((state)=>state.allCarModels);
    const updateState = (0, $4AtAC.useCarStoreContext)((state)=>state.updateState);
    const activeTrimCodes = (0, $4AtAC.useCarStoreContext)((state)=>state.activeTrimCodes);
    const selectableTrimCodes = (0, $4AtAC.useCarStoreContext)((state)=>state.selectableTrimCodes);
    const isCompactLayout = (0, $4AtAC.useCarStoreContext)((state)=>state.isCompactLayout);
    const hasSelectedTrim = selectableTrimCodes.length > 0;
    const handleModelCheckboxChange = (model, isChecked)=>{
        const modelTrimCodes = model.calculator_cars.map((trim)=>trim.code);
        let newSelectableTrimCodes;
        if (isChecked) newSelectableTrimCodes = [
            ...new Set([
                ...selectableTrimCodes,
                ...modelTrimCodes
            ])
        ];
        else newSelectableTrimCodes = selectableTrimCodes.filter((code)=>!modelTrimCodes.includes(code));
        updateState({
            selectableTrimCodes: newSelectableTrimCodes
        });
    };
    const handleTrimCheckboxChange = (trimCode, isChecked)=>{
        let newSelectableTrimCodes;
        if (isChecked) newSelectableTrimCodes = [
            ...new Set([
                ...selectableTrimCodes,
                trimCode
            ])
        ];
        else newSelectableTrimCodes = selectableTrimCodes.filter((code)=>code !== trimCode);
        updateState({
            selectableTrimCodes: newSelectableTrimCodes
        });
    };
    const handleSelectAll = ()=>{
        if (!allCarModels) return;
        const allTrimCodes = allCarModels.flatMap((model)=>model.calculator_cars.map((trim)=>trim.code));
        updateState({
            selectableTrimCodes: allTrimCodes
        });
    };
    const handleDeselectAll = ()=>{
        updateState({
            selectableTrimCodes: []
        });
    };
    const handleSetTrim = (code, pos)=>{
        const newTrimCodes = [
            ...activeTrimCodes || []
        ];
        const index = pos === 'left' ? 0 : 1;
        newTrimCodes[index] = code;
        updateState({
            activeTrimCodes: newTrimCodes
        });
    };
    const getModelSelectionState = (model)=>{
        const modelTrimCodes = model.calculator_cars.map((t)=>t.code);
        const selectedCount = modelTrimCodes.filter((code)=>selectableTrimCodes.includes(code)).length;
        if (selectedCount === 0) return 'none';
        if (selectedCount === modelTrimCodes.length) return 'all';
        return 'some';
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "max-w-3xl mx-auto p-4 font-sans bg-white rounded-lg",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "space-y-2",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "grid grid-cols-2 min-h-11 border border-black",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                "data-active": isCompactLayout === false,
                                onClick: ()=>updateState({
                                        isCompactLayout: false
                                    }),
                                className: "data-[active='true']:bg-black data-[active='true']:text-white transition-colors",
                                children: "Full view"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                "data-active": isCompactLayout === true,
                                onClick: ()=>updateState({
                                        isCompactLayout: true
                                    }),
                                className: "data-[active='true']:bg-black data-[active='true']:text-white transition-colors",
                                children: "Compact view"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "flex justify-between text-gray-800 border-b pb-2",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("h1", {
                                className: "text-2xl font-bold ",
                                children: "Configure Snippet"
                            }),
                            !hasSelectedTrim ? /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                onClick: handleSelectAll,
                                className: "bg-black text-white cursor-pointer px-6",
                                children: "Select all"
                            }) : /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                onClick: handleDeselectAll,
                                className: "bg-black text-white cursor-pointer px-6 ",
                                children: "Deselect All"
                            })
                        ]
                    }),
                    allCarModels.map((model)=>{
                        const selectionState = getModelSelectionState(model);
                        const selectionCount = model.calculator_cars.filter((c)=>selectableTrimCodes.includes(c.code)).length;
                        return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: "model-accordion border rounded-md overflow-hidden",
                            children: /*#__PURE__*/ (0, $2PPWI.jsxs)("details", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsxs)("summary", {
                                        className: "flex items-center p-3 cursor-pointer gap-2 hover:bg-gray-100 transition-colors duration-150 list-none",
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                type: "checkbox",
                                                title: "check",
                                                className: "mr-3 size-5 rounded",
                                                checked: selectionState === 'all',
                                                ref: (el)=>el && (el.indeterminate = selectionState === 'some'),
                                                onChange: (e)=>handleModelCheckboxChange(model, e.target.checked),
                                                onClick: (e)=>e.stopPropagation()
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                className: "flex-grow text-lg font-semibold text-gray-700",
                                                children: model.name
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                                                className: "text-sm text-gray-500 mr-2",
                                                children: [
                                                    "(",
                                                    selectionCount,
                                                    " / ",
                                                    model.calculator_cars.length,
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "trims-list bg-gray-50 border-t border-gray-200 py-2",
                                        children: model.calculator_cars.map((trim)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                className: "trim-item flex items-center px-4 py-2 hover:bg-gray-100 gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                                        className: "w-8"
                                                    }),
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                        type: "checkbox",
                                                        id: `trim-${trim.id}`,
                                                        className: "mr-3 h-4 w-4 rounded text-blue-600 focus:ring-blue-500",
                                                        checked: selectableTrimCodes.includes(trim.code),
                                                        onChange: (e)=>handleTrimCheckboxChange(trim.code, e.target.checked)
                                                    }),
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                        htmlFor: `trim-${trim.id}`,
                                                        className: "flex-grow text-gray-700 cursor-pointer",
                                                        children: trim.name
                                                    })
                                                ]
                                            }, trim.id))
                                    })
                                ]
                            })
                        }, model.id);
                    })
                ]
            }),
            hasSelectedTrim && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "grid gap-4 p-2 rounded-md border mt-4",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "grid ",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                className: "font-bold",
                                htmlFor: "first-trim",
                                children: "Left trim"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("select", {
                                className: "p-3 cursor-pointer hover:bg-gray-100 transition-colors duration-150 border rounded-md",
                                id: "first-trim",
                                name: "first-trim",
                                value: activeTrimCodes?.[0] || '',
                                onChange: (e)=>{
                                    const selectedCode = e.target.value;
                                    if (!selectedCode) return;
                                    const selectedCar = allCarModels?.flatMap((model)=>model.calculator_cars).find((car)=>car.code === selectedCode);
                                    if (selectedCar) handleSetTrim(selectedCar.code, 'left');
                                },
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                        value: "",
                                        children: "Select left trim"
                                    }),
                                    allCarModels?.flatMap((model)=>model.calculator_cars.filter((car)=>selectableTrimCodes.includes(car.code))).filter((car)=>car.code !== activeTrimCodes?.[1]).map((car)=>/*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                            value: car.code,
                                            children: car.name
                                        }, car.id))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "grid ",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                className: "font-bold",
                                htmlFor: "second-trim",
                                children: "Right trim"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("select", {
                                className: "p-3 cursor-pointer hover:bg-gray-100 transition-colors duration-150 border rounded-md",
                                id: "second-trim",
                                name: "second-trim",
                                value: activeTrimCodes?.[1] || '',
                                onChange: (e)=>{
                                    const selectedCode = e.target.value;
                                    if (!selectedCode) return;
                                    const selectedCar = allCarModels?.flatMap((model)=>model.calculator_cars).find((car)=>car.code === selectedCode);
                                    if (selectedCar) handleSetTrim(selectedCar.code, 'right');
                                },
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                        value: "",
                                        children: "Select right trim"
                                    }),
                                    allCarModels?.flatMap((model)=>model.calculator_cars.filter((car)=>selectableTrimCodes.includes(car.code))).filter((car)=>car.code !== activeTrimCodes?.[0]).map((car)=>/*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                            value: car.code,
                                            children: car.name
                                        }, car.id))
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

});


parcelRegister("c7Dnj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f99186253a49186$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $jXrsw = parcelRequire("jXrsw");

var $f0NwZ = parcelRequire("f0NwZ");

var $k1xco = parcelRequire("k1xco");

var $e1qbH = parcelRequire("e1qbH");

var $gY3S2 = parcelRequire("gY3S2");

var $dUhH1 = parcelRequire("dUhH1");

var $gJOH1 = parcelRequire("gJOH1");

var $1LX1E = parcelRequire("1LX1E");

var $1swI9 = parcelRequire("1swI9");

var $je5iV = parcelRequire("je5iV");

var $5HYoR = parcelRequire("5HYoR");

const $7f99186253a49186$var$FleetContainer = (0, $jXrsw.default).div`
  display: flex;
  flex-direction: column;
  gap: 96px;
  margin-bottom: 96px;

  @media (max-width: 768px) {
    gap: 40px;
  }

  & > div.container {
    width: 100%;
    max-width: 940px !important;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 96px;

    @media (max-width: 940px) {
      gap: 40px;
      padding: 0 32px;
    }
    & > div.offset_text {
      max-width: 530px;
      margin-top: 96px;

      @media only screen and (min-width: 940px) {
        max-width: 100%;
        margin-bottom: 96px;
      }
    }
    & > p.legal-text {
      font-weight: 400;
      font-size: 9px;
      line-height: 18px;
      color: #5f5f5f;
    }
  }
`;
/*#__PURE__*/ (0, $2PPWI.jsx)("script", {
    type: "module",
    src: "https://cdn.jsdelivr.net/npm/@afonso-digital/kia-web-components@latest/dist/kia-web-components/kia-web-components.esm.js"
});
const $7f99186253a49186$var$FleetSite = ()=>{
    const [persona, setPersona] = (0, $8FY87.useState)('driver');
    (0, $8FY87.useEffect)(()=>{
        const script = document.createElement('script');
        script.type = 'module';
        script.src = 'https://cdn.jsdelivr.net/npm/@afonso-digital/kia-web-components@latest/dist/kia-web-components/kia-web-components.esm.js';
        document.body.appendChild(script);
        return ()=>{
            document.body.removeChild(script);
        };
    }, []);
    const personaNews = persona === 'driver' ? (0, $5HYoR.driverNews) : persona === 'company' ? (0, $5HYoR.companyNews) : (0, $5HYoR.buyerNews);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($7f99186253a49186$var$FleetContainer, {
        id: "fleet",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $dUhH1.default), {
                ...(0, $5HYoR.hero)
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $je5iV.default), {
                ...(0, $5HYoR.companyOffer)
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $k1xco.default), {
                ...(0, $5HYoR.collage)
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("kia-prislista-business", {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1LX1E.default), {
                    ...(0, $5HYoR.rentAndShareImageAndLink)
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $k1xco.default), {
                ...(0, $5HYoR.collage2)
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1LX1E.default), {
                        ...(0, $5HYoR.imageAndLink)
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $gY3S2.default), {
                        ...(0, $5HYoR.fleetPuff)
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1swI9.default), {
                        ...(0, $5HYoR.table)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $dUhH1.default), {
                ...(0, $5HYoR.hero2)
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $gJOH1.default), {
                        ...(0, $5HYoR.news2)
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e1qbH.default), {
                        ...(0, $5HYoR.faq)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                page: "fleet"
            })
        ]
    });
};
var $7f99186253a49186$export$2e2bcd8739ae039 = $7f99186253a49186$var$FleetSite;

});
parcelRegister("jXrsw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e878d3d36e70201f$export$2e2bcd8739ae039; });
parcelRequire("7fY6k");

var $8FY87 = parcelRequire("8FY87");

var $bmQuu = parcelRequire("bmQuu");
var $e878d3d36e70201f$var$r, $e878d3d36e70201f$var$i;
const $e878d3d36e70201f$var$c = "data-styled", $e878d3d36e70201f$var$a = "active", $e878d3d36e70201f$var$l = "data-styled-version", $e878d3d36e70201f$export$83d89fbfd8236492 = "6.5.3", $e878d3d36e70201f$var$h = "/*!sc*/\n", $e878d3d36e70201f$var$d = "undefined" != typeof window && "undefined" != typeof document;
function $e878d3d36e70201f$var$p(e) {}
const $e878d3d36e70201f$var$f = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : null !== ($e878d3d36e70201f$var$i = null !== ($e878d3d36e70201f$var$r = $e878d3d36e70201f$var$p("REACT_APP_SC_DISABLE_SPEEDY")) && void 0 !== $e878d3d36e70201f$var$r ? $e878d3d36e70201f$var$r : $e878d3d36e70201f$var$p("SC_DISABLE_SPEEDY")) && void 0 !== $e878d3d36e70201f$var$i ? $e878d3d36e70201f$var$i : false), $e878d3d36e70201f$var$m = "sc-keyframes-", $e878d3d36e70201f$var$y = {}, $e878d3d36e70201f$var$g = {};
function $e878d3d36e70201f$var$v(e, ...t) {
    return new Error(`An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#${e} for more information.${t.length > 0 ? ` Args: ${t.join(", ")}` : ""}`);
}
const $e878d3d36e70201f$var$S = 1073741824;
let $e878d3d36e70201f$var$b = new Map, $e878d3d36e70201f$var$w = new Map, $e878d3d36e70201f$var$N = 1;
const $e878d3d36e70201f$var$C = (e)=>{
    if ($e878d3d36e70201f$var$b.has(e)) return $e878d3d36e70201f$var$b.get(e);
    for(; $e878d3d36e70201f$var$w.has($e878d3d36e70201f$var$N);)$e878d3d36e70201f$var$N++;
    const t = $e878d3d36e70201f$var$N++;
    return $e878d3d36e70201f$var$b.set(e, t), $e878d3d36e70201f$var$w.set(t, e), t;
}, $e878d3d36e70201f$var$O = (e)=>$e878d3d36e70201f$var$w.get(e), $e878d3d36e70201f$var$E = (e, t)=>{
    $e878d3d36e70201f$var$N = t + 1, $e878d3d36e70201f$var$b.set(e, t), $e878d3d36e70201f$var$w.set(t, e);
}, $e878d3d36e70201f$var$A = /invalid hook call/i, $e878d3d36e70201f$var$P = new Set, $e878d3d36e70201f$var$_ = (e, n)=>{
    var t, n1, e1;
}, $e878d3d36e70201f$var$I = Object.freeze([]), $e878d3d36e70201f$var$$ = Object.freeze({});
function $e878d3d36e70201f$var$R(e, t, n = $e878d3d36e70201f$var$$) {
    return e.theme !== n.theme && e.theme || t || n.theme;
}
const $e878d3d36e70201f$var$j = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $e878d3d36e70201f$var$x = /(^-|-$)/g;
function $e878d3d36e70201f$var$T(e) {
    return e.replace($e878d3d36e70201f$var$j, "-").replace($e878d3d36e70201f$var$x, "");
}
const $e878d3d36e70201f$var$k = /(a)(d)/gi, $e878d3d36e70201f$var$D = (e)=>String.fromCharCode(e + (e > 25 ? 39 : 97));
function $e878d3d36e70201f$var$V(e) {
    let t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $e878d3d36e70201f$var$D(t % 52) + n;
    return ($e878d3d36e70201f$var$D(t % 52) + n).replace($e878d3d36e70201f$var$k, "$1-$2");
}
const $e878d3d36e70201f$var$M = 5381, $e878d3d36e70201f$var$G = (e, t)=>{
    let n = t.length;
    for(; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $e878d3d36e70201f$var$F = (e)=>$e878d3d36e70201f$var$G($e878d3d36e70201f$var$M, e);
function $e878d3d36e70201f$var$z(e) {
    return $e878d3d36e70201f$var$V($e878d3d36e70201f$var$F(e) >>> 0);
}
function $e878d3d36e70201f$var$W(e) {
    return e.displayName || e.name || "Component";
}
function $e878d3d36e70201f$var$L(e) {
    return "string" == typeof e && true;
}
function $e878d3d36e70201f$var$B(e) {
    return $e878d3d36e70201f$var$L(e) ? `styled.${e}` : `Styled(${$e878d3d36e70201f$var$W(e)})`;
}
const $e878d3d36e70201f$var$q = Symbol.for("react.memo"), $e878d3d36e70201f$var$H = Symbol.for("react.forward_ref"), $e878d3d36e70201f$var$Y = {
    contextType: !0,
    defaultProps: !0,
    displayName: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    propTypes: !0,
    type: !0
}, $e878d3d36e70201f$var$U = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $e878d3d36e70201f$var$J = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $e878d3d36e70201f$var$X = {
    [$e878d3d36e70201f$var$H]: {
        $$typeof: !0,
        render: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0
    },
    [$e878d3d36e70201f$var$q]: $e878d3d36e70201f$var$J
};
function $e878d3d36e70201f$var$K(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $e878d3d36e70201f$var$q ? $e878d3d36e70201f$var$J : "$$typeof" in e ? $e878d3d36e70201f$var$X[e.$$typeof] : $e878d3d36e70201f$var$Y;
}
const $e878d3d36e70201f$var$Q = Object.defineProperty, $e878d3d36e70201f$var$Z = Object.getOwnPropertyNames, $e878d3d36e70201f$var$ee = Object.getOwnPropertySymbols, $e878d3d36e70201f$var$te = Object.getOwnPropertyDescriptor, $e878d3d36e70201f$var$ne = Object.getPrototypeOf, $e878d3d36e70201f$var$oe = Object.prototype;
function $e878d3d36e70201f$var$se(e, t, n) {
    if ("string" != typeof t) {
        const o = $e878d3d36e70201f$var$ne(t);
        o && o !== $e878d3d36e70201f$var$oe && $e878d3d36e70201f$var$se(e, o, n);
        const s = $e878d3d36e70201f$var$Z(t).concat($e878d3d36e70201f$var$ee(t)), r = $e878d3d36e70201f$var$K(e), i = $e878d3d36e70201f$var$K(t);
        for(let o = 0; o < s.length; ++o){
            const c = s[o];
            if (!(c in $e878d3d36e70201f$var$U || n && n[c] || i && c in i || r && c in r)) {
                const n = $e878d3d36e70201f$var$te(t, c);
                try {
                    $e878d3d36e70201f$var$Q(e, c, n);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $e878d3d36e70201f$var$re(e) {
    return "function" == typeof e;
}
const $e878d3d36e70201f$var$ie = Symbol.for("react.forward_ref");
function $e878d3d36e70201f$export$7ba318d8d2f06c76(e) {
    return null != e && ("object" == typeof e || "function" == typeof e) && e.$$typeof === $e878d3d36e70201f$var$ie && "styledComponentId" in e;
}
function $e878d3d36e70201f$var$ae(e, t) {
    return e && t ? e + " " + t : e || t || "";
}
function $e878d3d36e70201f$var$le(e, t) {
    return e.join(t || "");
}
function $e878d3d36e70201f$var$ue(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $e878d3d36e70201f$var$he(e, t, n = !1) {
    if (!n && !$e878d3d36e70201f$var$ue(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(let n = 0; n < t.length; n++)e[n] = $e878d3d36e70201f$var$he(e[n], t[n]);
    else if ($e878d3d36e70201f$var$ue(t)) for(const n in t)e[n] = $e878d3d36e70201f$var$he(e[n], t[n]);
    return e;
}
function $e878d3d36e70201f$var$de(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
const $e878d3d36e70201f$var$pe = class {
    constructor(e){
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e, this._cGroup = 0, this._cIndex = 0;
    }
    indexOfGroup(e) {
        if (e === this._cGroup) return this._cIndex;
        let t = this._cIndex;
        if (e > this._cGroup) for(let n = this._cGroup; n < e; n++)t += this.groupSizes[n];
        else for(let n = this._cGroup - 1; n >= e; n--)t -= this.groupSizes[n];
        return this._cGroup = e, this._cIndex = t, t;
    }
    insertRules(e, t) {
        if (e >= this.groupSizes.length) {
            const t = this.groupSizes, n = t.length;
            let o = n;
            for(; e >= o;)if (o <<= 1, o < 0) throw $e878d3d36e70201f$var$v(16, `${e}`);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(t), this.length = o;
            for(let e = n; e < o; e++)this.groupSizes[e] = 0;
        }
        let n = this.indexOfGroup(e + 1), o = 0;
        for(let s = 0, r = t.length; s < r; s++)this.tag.insertRule(n, t[s]) && (this.groupSizes[e]++, n++, o++);
        o > 0 && this._cGroup > e && (this._cIndex += o);
    }
    clearGroup(e) {
        if (e < this.length) {
            const t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(let e = n; e < o; e++)this.tag.deleteRule(n);
            t > 0 && this._cGroup > e && (this._cIndex -= t);
        }
    }
    getGroup(e) {
        let t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        const n = this.groupSizes[e], o = this.indexOfGroup(e), s = o + n;
        for(let e = o; e < s; e++)t += this.tag.getRule(e) + $e878d3d36e70201f$var$h;
        return t;
    }
}, $e878d3d36e70201f$var$fe = `style[${$e878d3d36e70201f$var$c}][${$e878d3d36e70201f$var$l}="${$e878d3d36e70201f$export$83d89fbfd8236492}"]`, $e878d3d36e70201f$var$me = new RegExp(`^${$e878d3d36e70201f$var$c}\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)`), $e878d3d36e70201f$var$ye = (e)=>"undefined" != typeof ShadowRoot && e instanceof ShadowRoot || "host" in e && 11 === e.nodeType, $e878d3d36e70201f$var$ge = (e)=>{
    if (!e) return document;
    if ($e878d3d36e70201f$var$ye(e)) return e;
    if ("getRootNode" in e) {
        const t = e.getRootNode();
        if ($e878d3d36e70201f$var$ye(t)) return t;
    }
    return document;
}, $e878d3d36e70201f$var$ve = (e, t, n)=>{
    const o = n.split(",");
    let s;
    for(let n = 0, r = o.length; n < r; n++)(s = o[n]) && e.registerName(t, s);
}, $e878d3d36e70201f$var$Se = (e, t)=>{
    var n;
    const o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($e878d3d36e70201f$var$h), s = [];
    for(let t = 0, n = o.length; t < n; t++){
        const n = o[t].trim();
        if (!n) continue;
        const r = n.match($e878d3d36e70201f$var$me);
        if (r) {
            const t = 0 | parseInt(r[1], 10), n = r[2];
            0 !== t && ($e878d3d36e70201f$var$E(n, t), $e878d3d36e70201f$var$ve(e, n, r[3]), e.getTag().insertRules(t, s)), s.length = 0;
        } else s.push(n);
    }
}, $e878d3d36e70201f$var$be = (e)=>{
    const t = $e878d3d36e70201f$var$ge(e.options.target).querySelectorAll($e878d3d36e70201f$var$fe);
    for(let n = 0, o = t.length; n < o; n++){
        const o = t[n];
        o && o.getAttribute($e878d3d36e70201f$var$c) !== $e878d3d36e70201f$var$a && ($e878d3d36e70201f$var$Se(e, o), o.parentNode && o.parentNode.removeChild(o));
    }
};
let $e878d3d36e70201f$var$we = !1;
function $e878d3d36e70201f$var$Ne() {
    if (!1 !== $e878d3d36e70201f$var$we) return $e878d3d36e70201f$var$we;
    if ("undefined" != typeof document) {
        const e = document.head.querySelector('meta[property="csp-nonce"]');
        if (e) return $e878d3d36e70201f$var$we = e.nonce || e.getAttribute("content") || void 0;
        const t = document.head.querySelector('meta[name="sc-nonce"]');
        if (t) return $e878d3d36e70201f$var$we = t.getAttribute("content") || void 0;
    }
    return $e878d3d36e70201f$var$we = "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : void 0;
}
const $e878d3d36e70201f$var$Ce = (e, t)=>{
    const n = document.head, o = e || n, s = document.createElement("style"), r = ((e)=>{
        const t = Array.from(e.querySelectorAll(`style[${$e878d3d36e70201f$var$c}]`));
        return t[t.length - 1];
    })(o), i = void 0 !== r ? r.nextSibling : null;
    s.setAttribute($e878d3d36e70201f$var$c, $e878d3d36e70201f$var$a), s.setAttribute($e878d3d36e70201f$var$l, $e878d3d36e70201f$export$83d89fbfd8236492);
    const h = t || $e878d3d36e70201f$var$Ne();
    return h && s.setAttribute("nonce", h), o.insertBefore(s, i), s;
}, $e878d3d36e70201f$var$Oe = class {
    constructor(e, t){
        this.element = $e878d3d36e70201f$var$Ce(e, t), this.element.appendChild(document.createTextNode("")), this.sheet = ((e)=>{
            var t;
            if (e.sheet) return e.sheet;
            const n = null !== (t = e.getRootNode().styleSheets) && void 0 !== t ? t : document.styleSheets;
            for(let t = 0, o = n.length; t < o; t++){
                const o = n[t];
                if (o.ownerNode === e) return o;
            }
            throw $e878d3d36e70201f$var$v(17);
        })(this.element), this.length = 0;
    }
    insertRule(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }
    deleteRule(e) {
        this.sheet.deleteRule(e), this.length--;
    }
    getRule(e) {
        const t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }
}, $e878d3d36e70201f$var$Ee = class {
    constructor(e, t){
        this.element = $e878d3d36e70201f$var$Ce(e, t), this.nodes = this.element.childNodes, this.length = 0;
    }
    insertRule(e, t) {
        if (e <= this.length && e >= 0) {
            const n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }
    deleteRule(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }
    getRule(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }
};
let $e878d3d36e70201f$var$Ae = $e878d3d36e70201f$var$d;
const $e878d3d36e70201f$var$Pe = {
    isServer: !$e878d3d36e70201f$var$d,
    useCSSOMInjection: !$e878d3d36e70201f$var$f
};
class $e878d3d36e70201f$var$_e {
    static registerId(e) {
        return $e878d3d36e70201f$var$C(e);
    }
    constructor(e = $e878d3d36e70201f$var$$, t = {}, n){
        this.options = Object.assign(Object.assign({}, $e878d3d36e70201f$var$Pe), e), this.gs = t, this.keyframeIds = new Set, this.names = new Map(n), this.server = !!e.isServer, !this.server && $e878d3d36e70201f$var$d && $e878d3d36e70201f$var$Ae && ($e878d3d36e70201f$var$Ae = !1, $e878d3d36e70201f$var$be(this)), $e878d3d36e70201f$var$de(this, ()=>((e)=>{
                const t = e.getTag(), { length: n } = t;
                let o = "";
                for(let s = 0; s < n; s++){
                    const n = $e878d3d36e70201f$var$O(s);
                    if (void 0 === n) continue;
                    const r = e.names.get(n);
                    if (void 0 === r || !r.size) continue;
                    const i = t.getGroup(s);
                    if (0 === i.length) continue;
                    const a = $e878d3d36e70201f$var$c + ".g" + s + '[id="' + n + '"]';
                    let l = "";
                    for (const e of r)e.length > 0 && (l += e + ",");
                    o += i + a + '{content:"' + l + '"}' + $e878d3d36e70201f$var$h;
                }
                return o;
            })(this));
    }
    rehydrate() {
        !this.server && $e878d3d36e70201f$var$d && $e878d3d36e70201f$var$be(this);
    }
    reconstructWithOptions(e, t = !0) {
        const n = new $e878d3d36e70201f$var$_e(Object.assign(Object.assign({}, this.options), e), this.gs, t && this.names || void 0);
        return n.keyframeIds = new Set(this.keyframeIds), !this.server && $e878d3d36e70201f$var$d && e.target !== this.options.target && $e878d3d36e70201f$var$ge(this.options.target) !== $e878d3d36e70201f$var$ge(e.target) && $e878d3d36e70201f$var$be(n), n;
    }
    allocateGSInstance(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }
    getTag() {
        var e;
        return this.tag || (this.tag = (e = (({ useCSSOMInjection: e, target: t, nonce: n })=>e ? new $e878d3d36e70201f$var$Oe(t, n) : new $e878d3d36e70201f$var$Ee(t, n))(this.options), new $e878d3d36e70201f$var$pe(e)));
    }
    hasNameForId(e, t) {
        var n, o;
        return null !== (o = null === (n = this.names.get(e)) || void 0 === n ? void 0 : n.has(t)) && void 0 !== o && o;
    }
    registerName(e, t) {
        $e878d3d36e70201f$var$C(e), e.startsWith($e878d3d36e70201f$var$m) && this.keyframeIds.add(e);
        const n = this.names.get(e);
        n ? n.add(t) : this.names.set(e, new Set([
            t
        ]));
    }
    insertRules(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($e878d3d36e70201f$var$C(e), n);
    }
    clearNames(e) {
        this.names.has(e) && this.names.get(e).clear();
    }
    clearRules(e) {
        this.getTag().clearGroup($e878d3d36e70201f$var$C(e)), this.clearNames(e);
    }
    clearTag() {
        this.tag = void 0;
    }
}
const $e878d3d36e70201f$var$Ie = new WeakSet, $e878d3d36e70201f$var$$e = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexShrink: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
function $e878d3d36e70201f$var$Re(e, t) {
    return null == t || "boolean" == typeof t || "" === t ? "" : "number" != typeof t || 0 === t || e in $e878d3d36e70201f$var$$e || e.startsWith("--") ? String(t).trim() : t + "px";
}
const $e878d3d36e70201f$var$je = 47;
function $e878d3d36e70201f$var$xe(e) {
    if (45 === e.charCodeAt(0) && 45 === e.charCodeAt(1)) return e;
    let t = "";
    for(let n = 0; n < e.length; n++){
        const o = e.charCodeAt(n);
        t += o >= 65 && o <= 90 ? "-" + String.fromCharCode(o + 32) : e[n];
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
const $e878d3d36e70201f$var$Te = Symbol.for("sc-keyframes");
function $e878d3d36e70201f$var$ke(e) {
    return "object" == typeof e && null !== e && $e878d3d36e70201f$var$Te in e;
}
function $e878d3d36e70201f$var$De(e) {
    return $e878d3d36e70201f$var$re(e) && !(e.prototype && e.prototype.isReactComponent);
}
const $e878d3d36e70201f$var$Ve = (e)=>null == e || !1 === e || "" === e, $e878d3d36e70201f$var$Me = Symbol.for("react.client.reference");
function $e878d3d36e70201f$var$Ge(e) {
    return e.$$typeof === $e878d3d36e70201f$var$Me;
}
function $e878d3d36e70201f$var$Fe(e) {
    const t = e.$$id, n = (t && t.includes("#") ? t.split("#").pop() : t) || e.name || "unknown";
    console.warn(`Interpolating a client component (${n}) as a selector is not supported in server components. The component selector pattern requires access to the component's internal class name, which is not available across the server/client boundary. Use a plain CSS class selector instead.`);
}
function $e878d3d36e70201f$var$ze(e, t) {
    for(const n in e){
        const o = e[n];
        e.hasOwnProperty(n) && !$e878d3d36e70201f$var$Ve(o) && (Array.isArray(o) && $e878d3d36e70201f$var$Ie.has(o) || $e878d3d36e70201f$var$re(o) ? t.push($e878d3d36e70201f$var$xe(n) + ":", o, ";") : $e878d3d36e70201f$var$ue(o) ? (t.push(n + " {"), $e878d3d36e70201f$var$ze(o, t), t.push("}")) : t.push($e878d3d36e70201f$var$xe(n) + ": " + $e878d3d36e70201f$var$Re(n, o) + ";"));
    }
}
function $e878d3d36e70201f$var$We(e, t, n, o, s = []) {
    if ($e878d3d36e70201f$var$Ve(e)) return s;
    const r = typeof e;
    if ("string" === r) return s.push(e), s;
    if ("function" === r) {
        if ($e878d3d36e70201f$var$Ge(e)) return s;
        if ($e878d3d36e70201f$var$De(e) && t) {
            const r = e(t);
            return $e878d3d36e70201f$var$We(r, t, n, o, s);
        }
        return s.push(e), s;
    }
    if (Array.isArray(e)) {
        for(let r = 0; r < e.length; r++)$e878d3d36e70201f$var$We(e[r], t, n, o, s);
        return s;
    }
    return $e878d3d36e70201f$export$7ba318d8d2f06c76(e) ? (s.push(`.${e.styledComponentId}`), s) : $e878d3d36e70201f$var$ke(e) ? (n ? (e.inject(n, o), s.push(e.getName(o))) : s.push(e), s) : $e878d3d36e70201f$var$Ge(e) ? s : $e878d3d36e70201f$var$ue(e) ? e.toString !== Object.prototype.toString ? (s.push(e.toString()), s) : ($e878d3d36e70201f$var$ze(e, s), s) : (s.push(e.toString()), s);
}
const $e878d3d36e70201f$var$Le = $e878d3d36e70201f$var$F($e878d3d36e70201f$export$83d89fbfd8236492);
class $e878d3d36e70201f$var$Be {
    constructor(e, t, n){
        this.rules = e, this.componentId = t, this.baseHash = $e878d3d36e70201f$var$G($e878d3d36e70201f$var$Le, t), this.baseStyle = n, $e878d3d36e70201f$var$_e.registerId(t);
    }
    generateAndInjectStyles(e, t, n) {
        let o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        {
            let s = "";
            for(let o = 0; o < this.rules.length; o++){
                const r = this.rules[o];
                if ("string" == typeof r) s += r;
                else if (r) {
                    if ($e878d3d36e70201f$var$De(r)) {
                        const o = r(e);
                        "string" == typeof o ? s += o : null != o && !1 !== o && (s += $e878d3d36e70201f$var$le($e878d3d36e70201f$var$We(o, e, t, n)));
                    } else s += $e878d3d36e70201f$var$le($e878d3d36e70201f$var$We(r, e, t, n));
                }
            }
            if (s) {
                this.dynamicNameCache || (this.dynamicNameCache = new Map);
                const e = n.hash ? n.hash + s : s;
                let r = this.dynamicNameCache.get(e);
                if (!r) {
                    if (r = $e878d3d36e70201f$var$V($e878d3d36e70201f$var$G($e878d3d36e70201f$var$G(this.baseHash, n.hash), s) >>> 0), this.dynamicNameCache.size >= 200) {
                        const e = this.dynamicNameCache.keys().next().value;
                        void 0 !== e && this.dynamicNameCache.delete(e);
                    }
                    this.dynamicNameCache.set(e, r);
                }
                if (!t.hasNameForId(this.componentId, r)) {
                    const e = n(s, "." + r, void 0, this.componentId);
                    t.insertRules(this.componentId, r, e);
                }
                o = $e878d3d36e70201f$var$ae(o, r);
            }
        }
        return o;
    }
}
const $e878d3d36e70201f$var$qe = /&/g;
function $e878d3d36e70201f$var$He(e, t) {
    let n = 0;
    for(; --t >= 0 && 92 === e.charCodeAt(t);)n++;
    return !(1 & ~n);
}
function $e878d3d36e70201f$var$Ye(e) {
    const t = e.length;
    let n = "", o = 0, s = 0, r = 0, i = !1, c = !1;
    for(let a = 0; a < t; a++){
        const l = e.charCodeAt(a);
        if (0 !== r || i || l !== $e878d3d36e70201f$var$je || 42 !== e.charCodeAt(a + 1)) {
            if (i) 42 === l && e.charCodeAt(a + 1) === $e878d3d36e70201f$var$je && (i = !1, a++);
            else if (34 !== l && 39 !== l || $e878d3d36e70201f$var$He(e, a)) {
                if (0 === r) {
                    if (123 === l) s++;
                    else if (125 === l) {
                        if (s--, s < 0) {
                            c = !0;
                            let n = a + 1;
                            for(; n < t;){
                                const t = e.charCodeAt(n);
                                if (59 === t || 10 === t) break;
                                n++;
                            }
                            n < t && 59 === e.charCodeAt(n) && n++, s = 0, a = n - 1, o = n;
                            continue;
                        }
                        0 === s && (n += e.substring(o, a + 1), o = a + 1);
                    } else 59 === l && 0 === s && (n += e.substring(o, a + 1), o = a + 1);
                }
            } else 0 === r ? r = l : r === l && (r = 0);
        } else i = !0, a++;
    }
    return c || 0 !== s || 0 !== r ? (o < t && 0 === s && 0 === r && (n += e.substring(o)), n) : e;
}
function $e878d3d36e70201f$var$Ue(e, t) {
    const n = t + " ", o = "," + n;
    for(let s = 0; s < e.length; s++){
        const r = e[s];
        if ("rule" === r.type) {
            r.value = (n + r.value).replaceAll(",", o);
            const e = r.props, t = [];
            for(let o = 0; o < e.length; o++)t[o] = n + e[o];
            r.props = t;
        }
        Array.isArray(r.children) && "@keyframes" !== r.type && $e878d3d36e70201f$var$Ue(r.children, t);
    }
    return e;
}
function $e878d3d36e70201f$var$Je({ options: e = $e878d3d36e70201f$var$$, plugins: t = $e878d3d36e70201f$var$I } = $e878d3d36e70201f$var$$) {
    let n, s, r;
    const i = (e, t, o)=>o.startsWith(s) && o.endsWith(s) && o.replaceAll(s, "").length > 0 ? `.${n}` : e, c = t.slice();
    c.push((e)=>{
        e.type === $bmQuu.RULESET && e.value.includes("&") && (r || (r = new RegExp(`\\${s}\\b`, "g")), e.props[0] = e.props[0].replace($e878d3d36e70201f$var$qe, s).replace(r, i));
    }), e.prefix && c.push($bmQuu.prefixer), c.push($bmQuu.stringify);
    let a = [];
    const l = $bmQuu.middleware(c.concat($bmQuu.rulesheet((e)=>a.push(e)))), u = (t, i = "", c = "", u = "&")=>{
        n = u, s = i, r = void 0;
        const h = function(e) {
            const t = -1 !== e.indexOf("//"), n = -1 !== e.indexOf("}");
            if (!t && !n) return e;
            if (!t) return $e878d3d36e70201f$var$Ye(e);
            const o = e.length;
            let s = "", r = 0, i = 0, c = 0, a = 0, l = 0, u = !1;
            for(; i < o;){
                const t = e.charCodeAt(i);
                if (34 !== t && 39 !== t || $e878d3d36e70201f$var$He(e, i)) {
                    if (0 === c) {
                        if (t === $e878d3d36e70201f$var$je && i + 1 < o && 42 === e.charCodeAt(i + 1)) {
                            for(i += 2; i + 1 < o && (42 !== e.charCodeAt(i) || e.charCodeAt(i + 1) !== $e878d3d36e70201f$var$je);)i++;
                            i += 2;
                        } else if (40 !== t) {
                            if (41 !== t) {
                                if (a > 0) i++;
                                else if (42 === t && i + 1 < o && e.charCodeAt(i + 1) === $e878d3d36e70201f$var$je) s += e.substring(r, i), i += 2, r = i, u = !0;
                                else if (t === $e878d3d36e70201f$var$je && i + 1 < o && e.charCodeAt(i + 1) === $e878d3d36e70201f$var$je) {
                                    for(s += e.substring(r, i); i < o && 10 !== e.charCodeAt(i);)i++;
                                    r = i, u = !0;
                                } else 123 === t ? l++ : 125 === t && l--, i++;
                            } else a > 0 && a--, i++;
                        } else a++, i++;
                    } else i++;
                } else 0 === c ? c = t : c === t && (c = 0), i++;
            }
            return u ? (r < o && (s += e.substring(r)), 0 === l ? s : $e878d3d36e70201f$var$Ye(s)) : 0 === l ? e : $e878d3d36e70201f$var$Ye(e);
        }(t);
        let d = $bmQuu.compile(c || i ? c + " " + i + " { " + h + " }" : h);
        return e.namespace && (d = $e878d3d36e70201f$var$Ue(d, e.namespace)), a = [], $bmQuu.serialize(d, l), a;
    }, h = e;
    let d = $e878d3d36e70201f$var$M;
    for(let e = 0; e < t.length; e++)t[e].name || $e878d3d36e70201f$var$v(15), d = $e878d3d36e70201f$var$G(d, t[e].name);
    return (null == h ? void 0 : h.namespace) && (d = $e878d3d36e70201f$var$G(d, h.namespace)), (null == h ? void 0 : h.prefix) && (d = $e878d3d36e70201f$var$G(d, "p")), u.hash = d !== $e878d3d36e70201f$var$M ? d.toString() : "", u;
}
const $e878d3d36e70201f$var$Xe = new $e878d3d36e70201f$var$_e, $e878d3d36e70201f$var$Ke = $e878d3d36e70201f$var$Je(), $e878d3d36e70201f$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $e878d3d36e70201f$var$Xe,
    stylis: $e878d3d36e70201f$var$Ke,
    stylisPlugins: void 0
}), $e878d3d36e70201f$export$91317688fc694efa = $e878d3d36e70201f$export$8c190ef828af4c86.Consumer;
function $e878d3d36e70201f$var$et() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useContext($e878d3d36e70201f$export$8c190ef828af4c86);
}
function $e878d3d36e70201f$export$a473771da2f0ff7c(e) {
    var n;
    const o = $e878d3d36e70201f$var$et(), { styleSheet: s } = o, r = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useMemo(()=>{
        let t = s;
        return e.sheet ? t = e.sheet : e.target ? t = t.reconstructWithOptions(void 0 !== e.nonce ? {
            target: e.target,
            nonce: e.nonce
        } : {
            target: e.target
        }, !1) : void 0 !== e.nonce && (t = t.reconstructWithOptions({
            nonce: e.nonce
        })), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.nonce,
        e.sheet,
        e.target,
        s
    ]), i = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useMemo(()=>{
        var t;
        return void 0 === e.stylisPlugins && void 0 === e.namespace && void 0 === e.enableVendorPrefixes ? o.stylis : $e878d3d36e70201f$var$Je({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: null !== (t = e.stylisPlugins) && void 0 !== t ? t : o.stylisPlugins
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        e.stylisPlugins,
        o.stylis,
        o.stylisPlugins
    ]), c = "shouldForwardProp" in e ? e.shouldForwardProp : o.shouldForwardProp, a = null !== (n = e.stylisPlugins) && void 0 !== n ? n : o.stylisPlugins, l = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useMemo(()=>({
            shouldForwardProp: c,
            styleSheet: r,
            stylis: i,
            stylisPlugins: a
        }), [
        c,
        r,
        i,
        a
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($e878d3d36e70201f$export$8c190ef828af4c86.Provider, {
        value: l
    }, e.children);
}
const $e878d3d36e70201f$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createContext(void 0), $e878d3d36e70201f$export$b631efc24e9d5e2f = $e878d3d36e70201f$export$2c657da244d00bd6.Consumer;
function $e878d3d36e70201f$export$93d4e7f90805808f() {
    const e = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useContext($e878d3d36e70201f$export$2c657da244d00bd6);
    if (!e) throw $e878d3d36e70201f$var$v(18);
    return e;
}
function $e878d3d36e70201f$export$d8964aec282183a3(e) {
    const n = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useContext($e878d3d36e70201f$export$2c657da244d00bd6), o = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useMemo(()=>(function(e, t) {
            if (!e) throw $e878d3d36e70201f$var$v(14);
            if ($e878d3d36e70201f$var$re(e)) {
                const n = e(t);
                return n;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $e878d3d36e70201f$var$v(8);
            return t ? Object.assign(Object.assign({}, t), e) : e;
        })(e.theme, n), [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($e878d3d36e70201f$export$2c657da244d00bd6.Provider, {
        value: o
    }, e.children) : null;
}
const $e878d3d36e70201f$var$it = Object.prototype.hasOwnProperty, $e878d3d36e70201f$var$ct = {};
function $e878d3d36e70201f$var$at(e, t) {
    const n = "string" != typeof e ? "sc" : $e878d3d36e70201f$var$T(e);
    $e878d3d36e70201f$var$ct[n] = ($e878d3d36e70201f$var$ct[n] || 0) + 1;
    const o = n + "-" + $e878d3d36e70201f$var$z($e878d3d36e70201f$export$83d89fbfd8236492 + n + $e878d3d36e70201f$var$ct[n]);
    return t ? t + "-" + o : o;
}
let $e878d3d36e70201f$var$lt;
function $e878d3d36e70201f$var$ut(o, s, r) {
    const i = $e878d3d36e70201f$export$7ba318d8d2f06c76(o), c = o, a = !$e878d3d36e70201f$var$L(o), { attrs: l = $e878d3d36e70201f$var$I, componentId: u = $e878d3d36e70201f$var$at(s.displayName, s.parentComponentId), displayName: h = $e878d3d36e70201f$var$B(o) } = s, d = s.displayName && s.componentId ? $e878d3d36e70201f$var$T(s.displayName) + "-" + s.componentId : s.componentId || u, p = i && c.attrs ? c.attrs.concat(l).filter(Boolean) : l;
    let { shouldForwardProp: f } = s;
    if (i && c.shouldForwardProp) {
        const e = c.shouldForwardProp;
        if (s.shouldForwardProp) {
            const t = s.shouldForwardProp;
            f = (n, o)=>e(n, o) && t(n, o);
        } else f = e;
    }
    const m = new $e878d3d36e70201f$var$Be(r, d, i ? c.componentStyle : void 0);
    function y(o, s) {
        return function(o, s, r) {
            const { attrs: i, componentStyle: c, defaultProps: a, foldedComponentIds: l, styledComponentId: u, target: h } = o, d = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useContext($e878d3d36e70201f$export$2c657da244d00bd6), p = $e878d3d36e70201f$var$et(), f = o.shouldForwardProp || p.shouldForwardProp;
            const m = $e878d3d36e70201f$var$R(s, d, a) || $e878d3d36e70201f$var$$;
            let y, g;
            {
                const e = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useRef(null), n = e.current;
                if (null !== n && n[1] === m && n[2] === p.styleSheet && n[3] === p.stylis && n[7] === c && function(e, t, n) {
                    const o = e, s = t;
                    let r = 0;
                    for(const e in s)if ($e878d3d36e70201f$var$it.call(s, e) && (r++, o[e] !== s[e])) return !1;
                    return r === n;
                }(n[0], s, n[4])) y = n[5], g = n[6];
                else {
                    y = function(e, t, n) {
                        const o = Object.assign(Object.assign({}, t), {
                            className: void 0,
                            theme: n
                        }), s = e.length > 1;
                        for(let n = 0; n < e.length; n++){
                            const r = e[n], i = $e878d3d36e70201f$var$re(r) ? r(s ? Object.assign({}, o) : o) : r;
                            for(const e in i)"className" === e ? o.className = $e878d3d36e70201f$var$ae(o.className, i[e]) : "style" === e ? o.style = Object.assign(Object.assign({}, o.style), i[e]) : e in t && void 0 === t[e] || (o[e] = i[e]);
                        }
                        return "className" in t && "string" == typeof t.className && (o.className = $e878d3d36e70201f$var$ae(o.className, t.className)), o;
                    }(i, s, m), g = c.generateAndInjectStyles(y, p.styleSheet, p.stylis);
                    let t = 0;
                    for(const e in s)$e878d3d36e70201f$var$it.call(s, e) && t++;
                    e.current = [
                        s,
                        m,
                        p.styleSheet,
                        p.stylis,
                        t,
                        y,
                        g,
                        c
                    ];
                }
            }
            const v = y.as || h, S = function(t, n, o, s) {
                const r = {};
                for(const i in t)void 0 === t[i] || "$" === i[0] || "as" === i || "theme" === i && t.theme === o || ("forwardedAs" === i ? r.as = t.forwardedAs : s && !s(i, n) || (r[i] = t[i], s));
                return r;
            }(y, v, m, f);
            let b = $e878d3d36e70201f$var$ae(l, u);
            return g && (b += " " + g), y.className && (b += " " + y.className), S[$e878d3d36e70201f$var$L(v) && v.includes("-") ? "class" : "className"] = b, r && (S.ref = r), (0, $8FY87.createElement)(v, S);
        }(g, o, s);
    }
    y.displayName = h;
    let g = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).forwardRef(y);
    return g.attrs = p, g.componentStyle = m, g.displayName = h, g.shouldForwardProp = f, g.foldedComponentIds = i ? $e878d3d36e70201f$var$ae(c.foldedComponentIds, c.styledComponentId) : "", g.styledComponentId = d, g.target = i ? c.target : o, Object.defineProperty(g, "defaultProps", {
        get () {
            return this._foldedDefaultProps;
        },
        set (e) {
            this._foldedDefaultProps = i ? function(e, ...t) {
                for (const n of t)$e878d3d36e70201f$var$he(e, n, !0);
                return e;
            }({}, c.defaultProps, e) : e;
        }
    }), $e878d3d36e70201f$var$de(g, ()=>`.${g.styledComponentId}`), a && $e878d3d36e70201f$var$se(g, o, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), g;
}
var $e878d3d36e70201f$var$ht = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "button",
    "br",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "map",
    "mark",
    "menu",
    "meter",
    "nav",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "search",
    "section",
    "select",
    "slot",
    "small",
    "span",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tspan",
    "use"
]);
function $e878d3d36e70201f$var$dt(e, t) {
    const n = [
        e[0]
    ];
    for(let o = 0, s = t.length; o < s; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
const $e878d3d36e70201f$var$pt = (e)=>($e878d3d36e70201f$var$Ie.add(e), e);
function $e878d3d36e70201f$export$dbf350e5966cf602(e, ...t) {
    if ($e878d3d36e70201f$var$re(e) || $e878d3d36e70201f$var$ue(e)) return $e878d3d36e70201f$var$pt($e878d3d36e70201f$var$We($e878d3d36e70201f$var$dt($e878d3d36e70201f$var$I, [
        e,
        ...t
    ])));
    const n = e;
    return 0 === t.length && 1 === n.length && "string" == typeof n[0] ? $e878d3d36e70201f$var$We(n) : $e878d3d36e70201f$var$pt($e878d3d36e70201f$var$We($e878d3d36e70201f$var$dt(n, t)));
}
function $e878d3d36e70201f$var$mt(e, t, n = $e878d3d36e70201f$var$$) {
    if (!t) throw $e878d3d36e70201f$var$v(1, t);
    const o = (o, ...s)=>e(t, n, $e878d3d36e70201f$export$dbf350e5966cf602(o, ...s));
    return o.attrs = (o)=>$e878d3d36e70201f$var$mt(e, t, Object.assign(Object.assign({}, n), {
            attrs: Array.prototype.concat(n.attrs, o).filter(Boolean)
        })), o.withConfig = (o)=>$e878d3d36e70201f$var$mt(e, t, Object.assign(Object.assign({}, n), o)), o;
}
const $e878d3d36e70201f$var$yt = (e)=>$e878d3d36e70201f$var$mt($e878d3d36e70201f$var$ut, e), $e878d3d36e70201f$export$2e2bcd8739ae039 = $e878d3d36e70201f$var$yt;
$e878d3d36e70201f$var$ht.forEach((e)=>{
    $e878d3d36e70201f$export$2e2bcd8739ae039[e] = $e878d3d36e70201f$var$yt(e);
});
class $e878d3d36e70201f$var$vt {
    constructor(e, t){
        this.instanceRules = new Map, this.rules = e, this.componentId = t, this.isStatic = function(e) {
            for(let t = 0; t < e.length; t += 1){
                const n = e[t];
                if ($e878d3d36e70201f$var$re(n) && !$e878d3d36e70201f$export$7ba318d8d2f06c76(n)) return !1;
            }
            return !0;
        }(e), $e878d3d36e70201f$var$_e.registerId(this.componentId);
    }
    removeStyles(e, t) {
        this.instanceRules.delete(e), this.rebuildGroup(t);
    }
    renderStyles(e, t, n, o) {
        const s = this.componentId;
        if (this.isStatic) {
            if (n.hasNameForId(s, s + e)) this.instanceRules.has(e) || this.computeRules(e, t, n, o);
            else {
                const r = this.computeRules(e, t, n, o);
                n.insertRules(s, r.name, r.rules);
            }
            return;
        }
        const r = this.instanceRules.get(e);
        if (this.computeRules(e, t, n, o), !n.server && r) {
            const t = r.rules, n = this.instanceRules.get(e).rules;
            if (t.length === n.length) {
                let e = !0;
                for(let o = 0; o < t.length; o++)if (t[o] !== n[o]) {
                    e = !1;
                    break;
                }
                if (e) return;
            }
        }
        this.rebuildGroup(n);
    }
    computeRules(e, t, n, o) {
        const s = $e878d3d36e70201f$var$le($e878d3d36e70201f$var$We(this.rules, t, n, o)), r = {
            name: this.componentId + e,
            rules: o(s, "")
        };
        return this.instanceRules.set(e, r), r;
    }
    rebuildGroup(e) {
        const t = this.componentId;
        e.clearRules(t);
        for (const n of this.instanceRules.values())e.insertRules(t, n.name, n.rules);
    }
}
function $e878d3d36e70201f$export$f0f03736edb61697(e, ...n) {
    const o = $e878d3d36e70201f$export$dbf350e5966cf602(e, ...n), s = `sc-global-${$e878d3d36e70201f$var$z(JSON.stringify(o))}`, r = new $e878d3d36e70201f$var$vt(o, s);
    const i = (e)=>{
        const n = $e878d3d36e70201f$var$et(), i = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useContext($e878d3d36e70201f$export$2c657da244d00bd6);
        let a;
        {
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useRef(null);
            null === e.current && (e.current = n.styleSheet.allocateGSInstance(s)), a = e.current;
        }
        n.styleSheet.server && c(a, e, n.styleSheet, i, n.stylis);
        {
            const o = r.isStatic ? [
                a,
                n.styleSheet,
                r
            ] : [
                a,
                e,
                n.styleSheet,
                i,
                n.stylis,
                r
            ], l = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useRef(r);
            (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useLayoutEffect(()=>{
                n.styleSheet.server || (l.current !== r && (n.styleSheet.clearRules(s), l.current = r), c(a, e, n.styleSheet, i, n.stylis));
            }, o), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useLayoutEffect(()=>()=>{
                    n.styleSheet.server || r.removeStyles(a, n.styleSheet);
                }, [
                a,
                n.styleSheet,
                r
            ]);
        }
        return n.styleSheet.server && r.instanceRules.delete(a), null;
    };
    function c(e, t, n, o, s) {
        if (r.isStatic) r.renderStyles(e, $e878d3d36e70201f$var$y, n, s);
        else {
            const c = Object.assign(Object.assign({}, t), {
                theme: $e878d3d36e70201f$var$R(t, o, i.defaultProps)
            });
            r.renderStyles(e, c, n, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).memo(i);
}
function $e878d3d36e70201f$var$bt(e, t, n, o, s) {
    for(const r in e){
        const i = e[r], c = s ? s + "-" + r : r;
        if ("object" == typeof i && null !== i) {
            const e = {};
            $e878d3d36e70201f$var$bt(i, t, e, o, c), n[r] = e;
        } else n[r] = o(c, i, r);
    }
}
function $e878d3d36e70201f$var$wt(e, t, n, o) {
    let s = "";
    for(const r in e){
        const i = e[r], c = t[r], a = o ? o + "-" + r : r;
        "object" == typeof i && null !== i ? "object" == typeof c && null !== c && (s += $e878d3d36e70201f$var$wt(i, c, n, a)) : void 0 !== c && "function" != typeof c && (s += "--" + n + a + ":" + c + ";");
    }
    return s;
}
function $e878d3d36e70201f$export$25d302a5b900a763(e, t) {
    var n, o;
    const s = (null !== (n = null == t ? void 0 : t.prefix) && void 0 !== n ? n : "sc") + "-", r = null !== (o = null == t ? void 0 : t.selector) && void 0 !== o ? o : ":root", i = function(e, t) {
        const n = {};
        return $e878d3d36e70201f$var$bt(e, t, n, (e)=>"--" + t + e), n;
    }(e, s), c = function(e, t) {
        const n = {};
        return $e878d3d36e70201f$var$bt(e, t, n, (e, n)=>{
            return "var(--" + t + e + ", " + n + ")";
        }), n;
    }(e, s), a = $e878d3d36e70201f$export$f0f03736edb61697`
    ${r} {
      ${(t)=>$e878d3d36e70201f$var$wt(e, t.theme, s)}
    }
  `;
    return Object.assign(c, {
        GlobalStyle: a,
        raw: e,
        vars: i,
        resolve (t) {
            if (!$e878d3d36e70201f$var$d) throw new Error("createTheme.resolve() is client-only");
            const n = null != t ? t : document.documentElement;
            return function(e, t, n) {
                const o = {};
                return $e878d3d36e70201f$var$bt(e, t, o, (e, o)=>n.getPropertyValue("--" + t + e).trim() || o), o;
            }(e, s, getComputedStyle(n));
        }
    });
}
var $e878d3d36e70201f$var$Ct;
class $e878d3d36e70201f$var$Ot {
    constructor(e, t){
        this[$e878d3d36e70201f$var$Ct] = !0, this.inject = (e, t = $e878d3d36e70201f$var$Ke)=>{
            const n = this.getName(t);
            if (!e.hasNameForId(this.id, n)) {
                const o = t(this.rules, n, "@keyframes");
                e.insertRules(this.id, n, o);
            }
        }, this.name = e, this.id = $e878d3d36e70201f$var$m + e, this.rules = t, $e878d3d36e70201f$var$C(this.id), $e878d3d36e70201f$var$de(this, ()=>{
            throw $e878d3d36e70201f$var$v(12, String(this.name));
        });
    }
    getName(e = $e878d3d36e70201f$var$Ke) {
        return e.hash ? this.name + $e878d3d36e70201f$var$V(+e.hash >>> 0) : this.name;
    }
}
function $e878d3d36e70201f$export$d25ddfdf17c3ad3e(e, ...t) {
    const n = $e878d3d36e70201f$var$le($e878d3d36e70201f$export$dbf350e5966cf602(e, ...t)), o = $e878d3d36e70201f$var$z(n);
    return new $e878d3d36e70201f$var$Ot(o, n);
}
function $e878d3d36e70201f$export$e8748c6a27b910dc(e) {
    const n = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).forwardRef((n, o)=>{
        const s = $e878d3d36e70201f$var$R(n, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useContext($e878d3d36e70201f$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement(e, Object.assign(Object.assign({}, n), {
            theme: s,
            ref: o
        }));
    });
    return n.displayName = `WithTheme(${$e878d3d36e70201f$var$W(e)})`, $e878d3d36e70201f$var$se(n, e);
}
$e878d3d36e70201f$var$Ct = $e878d3d36e70201f$var$Te;
class $e878d3d36e70201f$export$ae8c7d15c8b89a20 {
    constructor({ nonce: e } = {}){
        this._emitSheetCSS = ()=>{
            const e = this.instance.toString();
            if (!e) return "";
            const t = this.instance.options.nonce || $e878d3d36e70201f$var$Ne();
            return `<style ${$e878d3d36e70201f$var$le([
                t && `nonce="${t}"`,
                `${$e878d3d36e70201f$var$c}="true"`,
                `${$e878d3d36e70201f$var$l}="${$e878d3d36e70201f$export$83d89fbfd8236492}"`
            ].filter(Boolean), " ")}>${e}</style>`;
        }, this.getStyleTags = ()=>{
            if (this.sealed) throw $e878d3d36e70201f$var$v(2);
            return this._emitSheetCSS();
        }, this.getStyleElement = ()=>{
            if (this.sealed) throw $e878d3d36e70201f$var$v(2);
            const e = this.instance.toString();
            if (!e) return [];
            const n = {
                [$e878d3d36e70201f$var$c]: "",
                [$e878d3d36e70201f$var$l]: $e878d3d36e70201f$export$83d89fbfd8236492,
                dangerouslySetInnerHTML: {
                    __html: e
                }
            }, o = this.instance.options.nonce || $e878d3d36e70201f$var$Ne();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("style", Object.assign({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = ()=>{
            this.sealed = !0;
        }, this.instance = new $e878d3d36e70201f$var$_e({
            isServer: !0,
            nonce: e
        }), this.sealed = !1;
    }
    collectStyles(e) {
        if (this.sealed) throw $e878d3d36e70201f$var$v(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($e878d3d36e70201f$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }
    interleaveWithNodeStream(e) {
        throw $e878d3d36e70201f$var$v(3);
    }
}
const $e878d3d36e70201f$export$5c87cfe6c475f500 = {
    StyleSheet: $e878d3d36e70201f$var$_e,
    mainSheet: $e878d3d36e70201f$var$Xe
};
const $e878d3d36e70201f$var$It = `__sc-${$e878d3d36e70201f$var$c}__`;
const $e878d3d36e70201f$var$$t = /:(?:(first)-child|(last)-child|(only)-child|(nth-child)\(([^()]+)\)|(nth-last-child)\(([^()]+)\))/g, $e878d3d36e70201f$var$Rt = `:not(style[${$e878d3d36e70201f$var$c}])`, $e878d3d36e70201f$var$jt = `style[${$e878d3d36e70201f$var$c}]`;
function $e878d3d36e70201f$var$xt(e) {
    return -1 === e.indexOf("-child") ? e : ($e878d3d36e70201f$var$$t.lastIndex = 0, e.replace($e878d3d36e70201f$var$$t, (e, t, n, o, s, r, i, c)=>t ? `:nth-child(1 of ${$e878d3d36e70201f$var$Rt})` : n ? `:nth-last-child(1 of ${$e878d3d36e70201f$var$Rt})` : o ? `:nth-child(1 of ${$e878d3d36e70201f$var$Rt}):nth-last-child(1 of ${$e878d3d36e70201f$var$Rt})` : s ? -1 !== r.indexOf(" of ") ? e : `:nth-child(${r} of ${$e878d3d36e70201f$var$Rt})` : -1 !== c.indexOf(" of ") ? e : `:nth-last-child(${c} of ${$e878d3d36e70201f$var$Rt})`));
}
function $e878d3d36e70201f$var$Tt(e, t) {
    if (-1 === e.indexOf("+")) return;
    let n = 0, o = 0;
    for(let s = 0; s < e.length; s++){
        const r = e.charCodeAt(s);
        if (40 === r) n++;
        else if (41 === r) n--;
        else if (91 === r) o++;
        else if (93 === r) o--;
        else if (43 === r && 0 === n && 0 === o && !$e878d3d36e70201f$var$He(e, s)) {
            const n = e.substring(0, s), o = e.substring(s + 1);
            t.push(n + "+" + $e878d3d36e70201f$var$jt + "+" + o), t.push(n + "+" + $e878d3d36e70201f$var$jt + "+" + $e878d3d36e70201f$var$jt + "+" + o);
        }
    }
}
function $e878d3d36e70201f$export$337461d98bd2ad54(e) {
    if (e.type === (0, $bmQuu.RULESET)) {
        const t = e.props, n = [];
        for(let e = 0; e < t.length; e++){
            const o = $e878d3d36e70201f$var$xt(t[e]);
            n.push(o), $e878d3d36e70201f$var$Tt(o, n);
        }
        e.props = n;
    }
}

});
parcelRegister("bmQuu", function(module, exports) {

$parcel$export(module.exports, "RULESET", function () { return $f212c67d2aff02bb$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "compile", function () { return $f212c67d2aff02bb$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $f212c67d2aff02bb$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $f212c67d2aff02bb$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $f212c67d2aff02bb$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $f212c67d2aff02bb$export$38bcb760f1d4871c; });
$parcel$export(module.exports, "prefixer", function () { return $f212c67d2aff02bb$export$e08c7d021b829b7a; });
var $f212c67d2aff02bb$export$71ad59f2e432cfe8 = "-ms-";
var $f212c67d2aff02bb$export$2c0f367103c8d01c = "-moz-";
var $f212c67d2aff02bb$export$39dfd62a25e0fe93 = "-webkit-";
var $f212c67d2aff02bb$export$a29989082612d0d9 = "comm";
var $f212c67d2aff02bb$export$aa3a2e812ca8570d = "rule";
var $f212c67d2aff02bb$export$527d108ccf083c2b = "decl";
var $f212c67d2aff02bb$export$d3d35020fa5b54f0 = "@page";
var $f212c67d2aff02bb$export$500415a86c544f73 = "@media";
var $f212c67d2aff02bb$export$a763edbf796b780a = "@import";
var $f212c67d2aff02bb$export$2790aeb8b4e5c826 = "@charset";
var $f212c67d2aff02bb$export$1cc683e23b84b133 = "@viewport";
var $f212c67d2aff02bb$export$9447a5efea57e862 = "@supports";
var $f212c67d2aff02bb$export$ef011b4e114b1fba = "@document";
var $f212c67d2aff02bb$export$6aad947bda0f3f46 = "@namespace";
var $f212c67d2aff02bb$export$b44a8529a35fcb60 = "@keyframes";
var $f212c67d2aff02bb$export$2c16de31893252e6 = "@font-face";
var $f212c67d2aff02bb$export$3d846dd52e150c6f = "@counter-style";
var $f212c67d2aff02bb$export$22314bfbb57653fe = "@font-feature-values";
var $f212c67d2aff02bb$export$d773506282b3cfe6 = "@layer";
var $f212c67d2aff02bb$export$1c5a554c78c0cd12 = "@scope";
var $f212c67d2aff02bb$export$2335f513bbd82c6d = Math.abs;
var $f212c67d2aff02bb$export$6788812c4e6611e6 = String.fromCharCode;
var $f212c67d2aff02bb$export$e6e34fd1f2686227 = Object.assign;
function $f212c67d2aff02bb$export$d6af199866bfb566(e, r) {
    return $f212c67d2aff02bb$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $f212c67d2aff02bb$export$a9db5e087081082d(e, 0)) << 2 ^ $f212c67d2aff02bb$export$a9db5e087081082d(e, 1)) << 2 ^ $f212c67d2aff02bb$export$a9db5e087081082d(e, 2)) << 2 ^ $f212c67d2aff02bb$export$a9db5e087081082d(e, 3) : 0;
}
function $f212c67d2aff02bb$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $f212c67d2aff02bb$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $f212c67d2aff02bb$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $f212c67d2aff02bb$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $f212c67d2aff02bb$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $f212c67d2aff02bb$export$36776f635604f274(e) {
    return e.length;
}
function $f212c67d2aff02bb$export$f9084667e487ed46(e) {
    return e.length;
}
function $f212c67d2aff02bb$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $f212c67d2aff02bb$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $f212c67d2aff02bb$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$f212c67d2aff02bb$export$4659b591c19bdf3d(e, r);
    });
}
var $f212c67d2aff02bb$export$53f1d5ea8de3d7c = 1;
var $f212c67d2aff02bb$export$4e0c71f277ca26b3 = 1;
var $f212c67d2aff02bb$export$f24224f1c91d8156 = 0;
var $f212c67d2aff02bb$export$5880b8b5730aff45 = 0;
var $f212c67d2aff02bb$export$c0306caf338ac095 = 0;
var $f212c67d2aff02bb$export$30a86d91af8ff6e6 = "";
function $f212c67d2aff02bb$export$35059013cd4a06db(e, r, a, c, n, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: c,
        props: n,
        children: s,
        line: $f212c67d2aff02bb$export$53f1d5ea8de3d7c,
        column: $f212c67d2aff02bb$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $f212c67d2aff02bb$export$784d13d8ee351f07(e, r) {
    return $f212c67d2aff02bb$export$e6e34fd1f2686227($f212c67d2aff02bb$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $f212c67d2aff02bb$export$590e8b2c435046d9(e) {
    while(e.root)e = $f212c67d2aff02bb$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $f212c67d2aff02bb$export$10d8903dec122b9d(e, e.siblings);
}
function $f212c67d2aff02bb$export$eba6f6f03b0a92e7() {
    return $f212c67d2aff02bb$export$c0306caf338ac095;
}
function $f212c67d2aff02bb$export$232faf9add678146() {
    $f212c67d2aff02bb$export$c0306caf338ac095 = $f212c67d2aff02bb$export$5880b8b5730aff45 > 0 ? $f212c67d2aff02bb$export$a9db5e087081082d($f212c67d2aff02bb$export$30a86d91af8ff6e6, --$f212c67d2aff02bb$export$5880b8b5730aff45) : 0;
    if ($f212c67d2aff02bb$export$4e0c71f277ca26b3--, $f212c67d2aff02bb$export$c0306caf338ac095 === 10) $f212c67d2aff02bb$export$4e0c71f277ca26b3 = 1, $f212c67d2aff02bb$export$53f1d5ea8de3d7c--;
    return $f212c67d2aff02bb$export$c0306caf338ac095;
}
function $f212c67d2aff02bb$export$48cfd1e771a65c4f() {
    $f212c67d2aff02bb$export$c0306caf338ac095 = $f212c67d2aff02bb$export$5880b8b5730aff45 < $f212c67d2aff02bb$export$f24224f1c91d8156 ? $f212c67d2aff02bb$export$a9db5e087081082d($f212c67d2aff02bb$export$30a86d91af8ff6e6, $f212c67d2aff02bb$export$5880b8b5730aff45++) : 0;
    if ($f212c67d2aff02bb$export$4e0c71f277ca26b3++, $f212c67d2aff02bb$export$c0306caf338ac095 === 10) $f212c67d2aff02bb$export$4e0c71f277ca26b3 = 1, $f212c67d2aff02bb$export$53f1d5ea8de3d7c++;
    return $f212c67d2aff02bb$export$c0306caf338ac095;
}
function $f212c67d2aff02bb$export$4d3fb11e950abb9e() {
    return $f212c67d2aff02bb$export$a9db5e087081082d($f212c67d2aff02bb$export$30a86d91af8ff6e6, $f212c67d2aff02bb$export$5880b8b5730aff45);
}
function $f212c67d2aff02bb$export$e88cb2efb12ae807() {
    return $f212c67d2aff02bb$export$5880b8b5730aff45;
}
function $f212c67d2aff02bb$export$58adb3bec8346d0f(e, r) {
    return $f212c67d2aff02bb$export$2f35ab04d2335697($f212c67d2aff02bb$export$30a86d91af8ff6e6, e, r);
}
function $f212c67d2aff02bb$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f212c67d2aff02bb$export$2de70f21292aac9e(e) {
    return $f212c67d2aff02bb$export$53f1d5ea8de3d7c = $f212c67d2aff02bb$export$4e0c71f277ca26b3 = 1, $f212c67d2aff02bb$export$f24224f1c91d8156 = $f212c67d2aff02bb$export$36776f635604f274($f212c67d2aff02bb$export$30a86d91af8ff6e6 = e), $f212c67d2aff02bb$export$5880b8b5730aff45 = 0, [];
}
function $f212c67d2aff02bb$export$45918ac1574455b1(e) {
    return $f212c67d2aff02bb$export$30a86d91af8ff6e6 = "", e;
}
function $f212c67d2aff02bb$export$410ac95b9ec204b8(e) {
    return $f212c67d2aff02bb$export$87c2784dc9fc4ab($f212c67d2aff02bb$export$58adb3bec8346d0f($f212c67d2aff02bb$export$5880b8b5730aff45 - 1, $f212c67d2aff02bb$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $f212c67d2aff02bb$export$660b2ee2d4fb4eff(e) {
    return $f212c67d2aff02bb$export$45918ac1574455b1($f212c67d2aff02bb$export$5f8c09e3ae6f64e1($f212c67d2aff02bb$export$2de70f21292aac9e(e)));
}
function $f212c67d2aff02bb$export$7af1228ff777d175(e) {
    while($f212c67d2aff02bb$export$c0306caf338ac095 = $f212c67d2aff02bb$export$4d3fb11e950abb9e())if ($f212c67d2aff02bb$export$c0306caf338ac095 < 33) $f212c67d2aff02bb$export$48cfd1e771a65c4f();
    else break;
    return $f212c67d2aff02bb$export$9e1725a4cfeada27(e) > 2 || $f212c67d2aff02bb$export$9e1725a4cfeada27($f212c67d2aff02bb$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $f212c67d2aff02bb$export$5f8c09e3ae6f64e1(e) {
    while($f212c67d2aff02bb$export$48cfd1e771a65c4f())switch($f212c67d2aff02bb$export$9e1725a4cfeada27($f212c67d2aff02bb$export$c0306caf338ac095)){
        case 0:
            $f212c67d2aff02bb$export$10d8903dec122b9d($f212c67d2aff02bb$export$c2ab62c7bf24634($f212c67d2aff02bb$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $f212c67d2aff02bb$export$10d8903dec122b9d($f212c67d2aff02bb$export$410ac95b9ec204b8($f212c67d2aff02bb$export$c0306caf338ac095), e);
            break;
        default:
            $f212c67d2aff02bb$export$10d8903dec122b9d($f212c67d2aff02bb$export$6788812c4e6611e6($f212c67d2aff02bb$export$c0306caf338ac095), e);
    }
    return e;
}
function $f212c67d2aff02bb$export$955ba06d119e085e(e, r) {
    while(--r && $f212c67d2aff02bb$export$48cfd1e771a65c4f())if ($f212c67d2aff02bb$export$c0306caf338ac095 < 48 || $f212c67d2aff02bb$export$c0306caf338ac095 > 102 || $f212c67d2aff02bb$export$c0306caf338ac095 > 57 && $f212c67d2aff02bb$export$c0306caf338ac095 < 65 || $f212c67d2aff02bb$export$c0306caf338ac095 > 70 && $f212c67d2aff02bb$export$c0306caf338ac095 < 97) break;
    return $f212c67d2aff02bb$export$58adb3bec8346d0f(e, $f212c67d2aff02bb$export$e88cb2efb12ae807() + (r < 6 && $f212c67d2aff02bb$export$4d3fb11e950abb9e() == 32 && $f212c67d2aff02bb$export$48cfd1e771a65c4f() == 32));
}
function $f212c67d2aff02bb$export$c889f2fcc19dbf12(e) {
    while($f212c67d2aff02bb$export$48cfd1e771a65c4f())switch($f212c67d2aff02bb$export$c0306caf338ac095){
        case e:
            return $f212c67d2aff02bb$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $f212c67d2aff02bb$export$c889f2fcc19dbf12($f212c67d2aff02bb$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $f212c67d2aff02bb$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $f212c67d2aff02bb$export$48cfd1e771a65c4f();
            break;
    }
    return $f212c67d2aff02bb$export$5880b8b5730aff45;
}
function $f212c67d2aff02bb$export$4254d4e2b3745c4c(e, r) {
    while($f212c67d2aff02bb$export$48cfd1e771a65c4f())if (e + $f212c67d2aff02bb$export$c0306caf338ac095 === 57) break;
    else if (e + $f212c67d2aff02bb$export$c0306caf338ac095 === 84 && $f212c67d2aff02bb$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $f212c67d2aff02bb$export$58adb3bec8346d0f(r, $f212c67d2aff02bb$export$5880b8b5730aff45 - 1) + "*" + $f212c67d2aff02bb$export$6788812c4e6611e6(e === 47 ? e : $f212c67d2aff02bb$export$48cfd1e771a65c4f());
}
function $f212c67d2aff02bb$export$c2ab62c7bf24634(e) {
    while(!$f212c67d2aff02bb$export$9e1725a4cfeada27($f212c67d2aff02bb$export$4d3fb11e950abb9e()))$f212c67d2aff02bb$export$48cfd1e771a65c4f();
    return $f212c67d2aff02bb$export$58adb3bec8346d0f(e, $f212c67d2aff02bb$export$5880b8b5730aff45);
}
function $f212c67d2aff02bb$export$ef7acd7185315e22(e) {
    return $f212c67d2aff02bb$export$45918ac1574455b1($f212c67d2aff02bb$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $f212c67d2aff02bb$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $f212c67d2aff02bb$export$98e6a39c04603d36(e, r, a, c, n, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var p = 0;
    var v = 0;
    var b = 0;
    var h = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = n;
    var y = s;
    var j = c;
    var z = k;
    while(w)switch(b = g, g = $f212c67d2aff02bb$export$48cfd1e771a65c4f()){
        case 40:
            if (b != 108 && $f212c67d2aff02bb$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($f212c67d2aff02bb$export$f8e21b1e77979a08(z += $f212c67d2aff02bb$export$77ad94ebf1c2b9ed($f212c67d2aff02bb$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $f212c67d2aff02bb$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $f212c67d2aff02bb$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $f212c67d2aff02bb$export$7af1228ff777d175(b);
            break;
        case 92:
            z += $f212c67d2aff02bb$export$955ba06d119e085e($f212c67d2aff02bb$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($f212c67d2aff02bb$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $f212c67d2aff02bb$export$10d8903dec122b9d($f212c67d2aff02bb$export$4a34f930e789283c($f212c67d2aff02bb$export$4254d4e2b3745c4c($f212c67d2aff02bb$export$48cfd1e771a65c4f(), $f212c67d2aff02bb$export$e88cb2efb12ae807()), r, a, i), i);
                    if (($f212c67d2aff02bb$export$9e1725a4cfeada27(b || 1) == 5 || $f212c67d2aff02bb$export$9e1725a4cfeada27($f212c67d2aff02bb$export$4d3fb11e950abb9e() || 1) == 5) && $f212c67d2aff02bb$export$36776f635604f274(z) && $f212c67d2aff02bb$export$2f35ab04d2335697(z, -1, void 0) !== " ") z += " ";
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * h:
            u[f++] = $f212c67d2aff02bb$export$36776f635604f274(z) * d;
        case 125 * h:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (v > 0 && ($f212c67d2aff02bb$export$36776f635604f274(z) - l || h === 0 && b === 47)) $f212c67d2aff02bb$export$10d8903dec122b9d(v > 32 ? $f212c67d2aff02bb$export$f8483753829ec8f3(z + ";", c, a, l - 1, i) : $f212c67d2aff02bb$export$f8483753829ec8f3($f212c67d2aff02bb$export$77ad94ebf1c2b9ed(z, " ", "") + ";", c, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $f212c67d2aff02bb$export$10d8903dec122b9d(j = $f212c67d2aff02bb$export$3307ffa7023ede1e(z, r, a, f, o, n, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $f212c67d2aff02bb$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else {
                            switch(p){
                                case 99:
                                    if ($f212c67d2aff02bb$export$a9db5e087081082d(z, 3) === 110) break;
                                case 108:
                                    if ($f212c67d2aff02bb$export$a9db5e087081082d(z, 2) === 97) break;
                                default:
                                    o = 0;
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (o) $f212c67d2aff02bb$export$98e6a39c04603d36(e, j, j, c && $f212c67d2aff02bb$export$10d8903dec122b9d($f212c67d2aff02bb$export$3307ffa7023ede1e(e, j, j, 0, 0, n, u, k, n, x = [], l, y), y), n, y, l, u, c ? x : y);
                            else $f212c67d2aff02bb$export$98e6a39c04603d36(z, j, j, j, [
                                ""
                            ], y, 0, u, y);
                        }
                    }
            }
            f = o = v = 0, h = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $f212c67d2aff02bb$export$36776f635604f274(z), v = b;
        default:
            if (h < 1) {
                if (g == 123) --h;
                else if (g == 125 && h++ == 0 && $f212c67d2aff02bb$export$232faf9add678146() == 125) continue;
            }
            switch(z += $f212c67d2aff02bb$export$6788812c4e6611e6(g), g * h){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($f212c67d2aff02bb$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($f212c67d2aff02bb$export$4d3fb11e950abb9e() === 45) z += $f212c67d2aff02bb$export$410ac95b9ec204b8($f212c67d2aff02bb$export$48cfd1e771a65c4f());
                    p = $f212c67d2aff02bb$export$4d3fb11e950abb9e(), o = l = $f212c67d2aff02bb$export$36776f635604f274(k = z += $f212c67d2aff02bb$export$c2ab62c7bf24634($f212c67d2aff02bb$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (b === 45 && $f212c67d2aff02bb$export$36776f635604f274(z) == 2) h = 0;
            }
    }
    return s;
}
function $f212c67d2aff02bb$export$3307ffa7023ede1e(e, r, a, c, s, t, u, i, f, o, l, p) {
    var v = s - 1;
    var b = s === 0 ? t : [
        ""
    ];
    var h = $f212c67d2aff02bb$export$f9084667e487ed46(b);
    for(var w = 0, d = 0, g = 0; w < c; ++w)for(var k = 0, m = $f212c67d2aff02bb$export$2f35ab04d2335697(e, v + 1, v = $f212c67d2aff02bb$export$2335f513bbd82c6d(d = u[w])), x = e; k < h; ++k)if (x = $f212c67d2aff02bb$export$87c2784dc9fc4ab(d > 0 ? b[k] + " " + m : $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(m, /&\f/g, b[k]))) f[g++] = x;
    return $f212c67d2aff02bb$export$35059013cd4a06db(e, r, a, s === 0 ? $f212c67d2aff02bb$export$aa3a2e812ca8570d : i, f, o, l, p);
}
function $f212c67d2aff02bb$export$4a34f930e789283c(e, r, a, n) {
    return $f212c67d2aff02bb$export$35059013cd4a06db(e, r, a, $f212c67d2aff02bb$export$a29989082612d0d9, $f212c67d2aff02bb$export$6788812c4e6611e6($f212c67d2aff02bb$export$eba6f6f03b0a92e7()), $f212c67d2aff02bb$export$2f35ab04d2335697(e, 2, -2), 0, n);
}
function $f212c67d2aff02bb$export$f8483753829ec8f3(e, r, a, c, n) {
    return $f212c67d2aff02bb$export$35059013cd4a06db(e, r, a, $f212c67d2aff02bb$export$527d108ccf083c2b, $f212c67d2aff02bb$export$2f35ab04d2335697(e, 0, c), $f212c67d2aff02bb$export$2f35ab04d2335697(e, c + 1, -1), c, n);
}
function $f212c67d2aff02bb$export$82e9f45cca5ba907(c, n, s) {
    switch($f212c67d2aff02bb$export$d6af199866bfb566(c, n)){
        case 5103:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "print-" + c + c;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + c + c;
        case 4855:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + c.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + c;
        case 4789:
            return $f212c67d2aff02bb$export$2c0f367103c8d01c + c + c;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + c + $f212c67d2aff02bb$export$2c0f367103c8d01c + c + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + c + c;
        case 5936:
            switch($f212c67d2aff02bb$export$a9db5e087081082d(c, n + 11)){
                case 114:
                    return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + c + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb") + c;
                case 108:
                    return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + c + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;
                case 45:
                    return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + c + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
            }
        case 6828:
        case 4268:
        case 2903:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + c + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + c + c;
        case 6165:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + c + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "flex-" + c + c;
        case 5187:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + c + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /(\w+).+(:[^]+)/, $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "box-$1$2" + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "flex-$1$2") + c;
        case 5443:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + c + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "flex-item-" + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") + (!$f212c67d2aff02bb$export$4659b591c19bdf3d(c, /flex-|baseline/) ? $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "grid-row-" + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") : "") + c;
        case 4675:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + c + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "flex-line-pack" + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /align-content|flex-|-self/g, "") + c;
        case 5548:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + c + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, "shrink", "negative") + c;
        case 5292:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + c + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, "basis", "preferred-size") + c;
        case 6060:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "box-" + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, "-grow", "") + $f212c67d2aff02bb$export$39dfd62a25e0fe93 + c + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, "grow", "positive") + c;
        case 4554:
            return $f212c67d2aff02bb$export$39dfd62a25e0fe93 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /([^-])(transform)/g, "$1" + $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "$2") + c;
        case 6187:
            return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed($f212c67d2aff02bb$export$77ad94ebf1c2b9ed($f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /(zoom-|grab)/, $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "$1"), c, "") + c;
        case 5495:
        case 3959:
            return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /(image-set\([^]*)/, $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed($f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /(.+:)(flex-)?(.*)/, $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "box-pack:$3" + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "flex-pack:$3"), /space-between/, "justify") + $f212c67d2aff02bb$export$39dfd62a25e0fe93 + c + c;
        case 4200:
            if (!$f212c67d2aff02bb$export$4659b591c19bdf3d(c, /flex-|baseline/)) return $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "grid-column-align" + $f212c67d2aff02bb$export$2f35ab04d2335697(c, n) + c;
            break;
        case 2592:
        case 3360:
            return $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, "template-", "") + c;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return n = r, $f212c67d2aff02bb$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$f212c67d2aff02bb$export$f8e21b1e77979a08(c + (s = s[n].value), "span", 0) ? c : $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, "-start", "") + c + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$f212c67d2aff02bb$export$f8e21b1e77979a08(s, "span", 0) ? $f212c67d2aff02bb$export$4659b591c19bdf3d(s, /\d+/) : +$f212c67d2aff02bb$export$4659b591c19bdf3d(s, /\d+/) - +$f212c67d2aff02bb$export$4659b591c19bdf3d(c, /\d+/)) + ";";
            return $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, "-start", "") + c;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $f212c67d2aff02bb$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? c : $f212c67d2aff02bb$export$71ad59f2e432cfe8 + $f212c67d2aff02bb$export$77ad94ebf1c2b9ed($f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, "-end", "-span"), "span ", "") + c;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /(.+)-inline(.+)/, $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "$1$2") + c;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($f212c67d2aff02bb$export$36776f635604f274(c) - 1 - n > 6) switch($f212c67d2aff02bb$export$a9db5e087081082d(c, n + 1)){
                case 109:
                    if ($f212c67d2aff02bb$export$a9db5e087081082d(c, n + 4) !== 45) break;
                case 102:
                    return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /(.+:)(.+)-([^]+)/, "$1" + $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $f212c67d2aff02bb$export$2c0f367103c8d01c + ($f212c67d2aff02bb$export$a9db5e087081082d(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;
                case 115:
                    return ~$f212c67d2aff02bb$export$f8e21b1e77979a08(c, "stretch", 0) ? $f212c67d2aff02bb$export$82e9f45cca5ba907($f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, "stretch", "fill-available"), n, s) + c : c;
            }
            break;
        case 5152:
        case 5920:
            return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, n, s, t, u, i) {
                return $f212c67d2aff02bb$export$71ad59f2e432cfe8 + a + ":" + n + i + (s ? $f212c67d2aff02bb$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +n) + i : "") + c;
            });
        case 4949:
            if ($f212c67d2aff02bb$export$a9db5e087081082d(c, n + 6) === 121) return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, ":", ":" + $f212c67d2aff02bb$export$39dfd62a25e0fe93) + c;
            break;
        case 6444:
            switch($f212c67d2aff02bb$export$a9db5e087081082d(c, $f212c67d2aff02bb$export$a9db5e087081082d(c, 14) === 45 ? 18 : 11)){
                case 120:
                    return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $f212c67d2aff02bb$export$39dfd62a25e0fe93 + ($f212c67d2aff02bb$export$a9db5e087081082d(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "$2box$3") + c;
                case 100:
                    return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, ":", ":" + $f212c67d2aff02bb$export$71ad59f2e432cfe8) + c;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c, "scroll-", "scroll-snap-") + c;
    }
    return c;
}
function $f212c67d2aff02bb$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var c = 0; c < e.length; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $f212c67d2aff02bb$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $f212c67d2aff02bb$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $f212c67d2aff02bb$export$a763edbf796b780a:
        case $f212c67d2aff02bb$export$6aad947bda0f3f46:
        case $f212c67d2aff02bb$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $f212c67d2aff02bb$export$a29989082612d0d9:
            return "";
        case $f212c67d2aff02bb$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $f212c67d2aff02bb$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $f212c67d2aff02bb$export$aa3a2e812ca8570d:
            if (!$f212c67d2aff02bb$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $f212c67d2aff02bb$export$36776f635604f274(a = $f212c67d2aff02bb$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $f212c67d2aff02bb$export$5a7767152ae0305f(e) {
    var r = $f212c67d2aff02bb$export$f9084667e487ed46(e);
    return function(a, c, n, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, c, n, s) || "";
        return t;
    };
}
function $f212c67d2aff02bb$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $f212c67d2aff02bb$export$e08c7d021b829b7a(c, t, u, i) {
    if (c.length > -1) {
        if (!c.return) switch(c.type){
            case $f212c67d2aff02bb$export$527d108ccf083c2b:
                c.return = $f212c67d2aff02bb$export$82e9f45cca5ba907(c.value, c.length, u);
                return;
            case $f212c67d2aff02bb$export$b44a8529a35fcb60:
                return $f212c67d2aff02bb$export$dfdc1655ccc5b9cb([
                    $f212c67d2aff02bb$export$784d13d8ee351f07(c, {
                        value: $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(c.value, "@", "@" + $f212c67d2aff02bb$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $f212c67d2aff02bb$export$aa3a2e812ca8570d:
                if (c.length) return $f212c67d2aff02bb$export$1be1fc439b849fdf(u = c.props, function(n) {
                    switch($f212c67d2aff02bb$export$4659b591c19bdf3d(n, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $f212c67d2aff02bb$export$590e8b2c435046d9($f212c67d2aff02bb$export$784d13d8ee351f07(c, {
                                props: [
                                    $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /:(read-\w+)/, ":" + $f212c67d2aff02bb$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $f212c67d2aff02bb$export$590e8b2c435046d9($f212c67d2aff02bb$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $f212c67d2aff02bb$export$e6e34fd1f2686227(c, {
                                props: $f212c67d2aff02bb$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $f212c67d2aff02bb$export$590e8b2c435046d9($f212c67d2aff02bb$export$784d13d8ee351f07(c, {
                                props: [
                                    $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $f212c67d2aff02bb$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $f212c67d2aff02bb$export$590e8b2c435046d9($f212c67d2aff02bb$export$784d13d8ee351f07(c, {
                                props: [
                                    $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $f212c67d2aff02bb$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $f212c67d2aff02bb$export$590e8b2c435046d9($f212c67d2aff02bb$export$784d13d8ee351f07(c, {
                                props: [
                                    $f212c67d2aff02bb$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, $f212c67d2aff02bb$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $f212c67d2aff02bb$export$590e8b2c435046d9($f212c67d2aff02bb$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $f212c67d2aff02bb$export$e6e34fd1f2686227(c, {
                                props: $f212c67d2aff02bb$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $f212c67d2aff02bb$export$76a88f7de6507443(e) {
    switch(e.type){
        case $f212c67d2aff02bb$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $f212c67d2aff02bb$export$1be1fc439b849fdf($f212c67d2aff02bb$export$660b2ee2d4fb4eff(r), function(r, a, c) {
                    switch($f212c67d2aff02bb$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $f212c67d2aff02bb$export$2f35ab04d2335697(r, 1, $f212c67d2aff02bb$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (c[++a] === "global") c[a] = "", c[++a] = "\f" + $f212c67d2aff02bb$export$2f35ab04d2335697(c[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $f212c67d2aff02bb$export$f9084667e487ed46(c) > 1 ? "" : r;
                                case a = $f212c67d2aff02bb$export$f9084667e487ed46(c) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});


parcelRegister("k1xco", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2101507ecaa3afb$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $3eb7t = parcelRequire("3eb7t");
function $e2101507ecaa3afb$export$2e2bcd8739ae039({ title: title, text: text, images: images }) {
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "gap-0 mx-auto px-4 max-w-7xl",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "max-w-[840px] m-auto",
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "mb-12 md:mb-0 max-w-[530px] w-full",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                            className: "text-2xl font-normal mb-3",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            className: "text-base leading-relaxed",
                            children: text
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10",
                children: images.map((image, index)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: `${index === 0 ? 'md:mt-32 hidden md:block' : index === 1 ? 'md:mt-32' : ''} mb-8 md:mb-0`,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "mb-6",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                    src: image.src,
                                    alt: image.alt,
                                    height: 600,
                                    width: 500,
                                    sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 400px",
                                    className: "w-full h-auto"
                                })
                            }),
                            image.title && /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                className: "text-xl font-normal mb-2",
                                children: image.title
                            }),
                            image.text && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: "text-sm leading-relaxed mb-2",
                                children: image.text
                            }),
                            image.link && /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                href: image.link,
                                className: "link-text",
                                children: "L\xe4s mer"
                            })
                        ]
                    }, index))
            })
        ]
    });
}

});

parcelRegister("e1qbH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccfa830f151b858f$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $jXrsw = parcelRequire("jXrsw");
// import faq from '../../data/faq.js';
// import BoxButton from '../BoxButton';
const $ccfa830f151b858f$var$Container = (0, $jXrsw.default).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 30px;

  & > h1 {
    font-weight: 400;
    font-size: 40px;
    line-height: 48px;
  }

  & > div.faq__item {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-self: stretch;
    gap: 16px;
    border-bottom: 1px solid #cdd0d2 !important;
    padding: 0 0 30px 0;
    cursor: pointer;

    & > p {
      margin: 0;
      font-size: 14px;
      line-height: 20px;
    }

    & > div.faq__item__header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      & > h5 {
        margin: 0 !important;
        font-weight: 400 !important;
        font-size: 18px !important;
        line-height: 23px !important;
      }

      .gg-chevron-down {
        box-sizing: border-box;
        position: relative;
        display: block;
        transform: scale(var(--ggs, 1));
        width: 22px;
        height: 22px;
        border: 2px solid transparent !important;
        border-radius: 100px;
      }
      .gg-chevron-down::after {
        content: '';
        display: block;
        box-sizing: border-box;
        position: absolute;
        width: 10px;
        height: 10px;
        border-bottom: 2px solid !important;
        border-right: 2px solid !important;
        transform: rotate(45deg);
        left: 4px;
        top: 2px;
      }
    }
  }
`;
const $ccfa830f151b858f$var$FAQItem = ({ item: item })=>{
    const [open, setOpen] = (0, $8FY87.useState)(false);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "faq__item",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "faq__item__header",
                onClick: ()=>{
                    setOpen(!open);
                },
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h5", {
                        children: item.q
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("i", {
                        className: "gg-chevron-down"
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                dangerouslySetInnerHTML: {
                    __html: item.a
                }
            })
        ]
    });
};
const $ccfa830f151b858f$var$FAQ = ({ questions: questions, title: title })=>{
    const [showMore, setShowMore] = (0, $8FY87.useState)(false);
    const questionsFiltered = showMore ? questions : questions.slice(0, 5);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($ccfa830f151b858f$var$Container, {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("h1", {
                children: title
            }),
            questionsFiltered.map((question, index)=>{
                return /*#__PURE__*/ (0, $2PPWI.jsx)($ccfa830f151b858f$var$FAQItem, {
                    item: question
                }, index);
            })
        ]
    });
};
var $ccfa830f151b858f$export$2e2bcd8739ae039 = $ccfa830f151b858f$var$FAQ;

});

parcelRegister("gY3S2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e6a03544e3fe994$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $jXrsw = parcelRequire("jXrsw");

var $3eb7t = parcelRequire("3eb7t");
const $4e6a03544e3fe994$var$FleetCalcPuffStyled = (0, $jXrsw.default).section`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 40px;

  .cta span {
    font-family: 'kiab', sans-serif;
  }

  .cta a {
    color: #fff !important;
    background-color: #000;
    margin-top: 34px;
    padding: 19px 24px;
    line-height: 18px;
    text-decoration: none !important;
  }

  .cta {
    margin-top: 34px;
  }

  .cta .rounded-full {
    position: relative;
  }

  .cta span.rounded-full::after {
    content: ' ';
    float: none;
    width: 6px;
    height: 9px;
    background: url(https://www.kia.com/etc.clientlibs/settings/wcm/designs/eut/clientlib/resources/rbr/icons/spr-button.png) -28px -71px
      no-repeat;
    margin: -5px -4px 0 0;
    display: block;
    position: absolute;
    top: 50%;
    right: 12px;
    overflow: hidden;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }

  & > img {
    height: auto;

    @media (max-width: 768px) {
      width: 100%;
      height: 290px;
      object-fit: cover;
    }
  }

  & > .fleet_calc_puff__content {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;
const $4e6a03544e3fe994$var$FleetCalcPuff = ({ title: title, subTitle: subTitle, text: text, link: link, linkText: linkText, image: image })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($4e6a03544e3fe994$var$FleetCalcPuffStyled, {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                sizes: "(max-width: 768px) 100vw, 290px",
                alt: "R\xe4kna p\xe5 tj\xe4nstebil",
                src: image
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "fleet_calc_puff__content",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                        className: "pre_header",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                        children: subTitle
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        children: text
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        className: "cta",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                            className: "link-button",
                            href: link,
                            children: linkText
                        })
                    })
                ]
            })
        ]
    });
};
var $4e6a03544e3fe994$export$2e2bcd8739ae039 = $4e6a03544e3fe994$var$FleetCalcPuff;

});

parcelRegister("dUhH1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6bd0d654005585b$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $jXrsw = parcelRequire("jXrsw");

var $51Ucj = parcelRequire("51Ucj");
const $c6bd0d654005585b$var$HeroContainer = (0, $jXrsw.default).section`
  background-image: ${({ $image: $image })=>`url(${$image})`};
  @media (max-width: 768px) {
    background-image: ${({ $mobileImage: $mobileImage })=>`url(${$mobileImage})`};
  }
  background-color: #fafafa;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  color: #fff;
  display: flex;
  width: 100%;
  height: 45vw;
  max-height: 600px;

  @media (max-width: 768px) {
    height: auto;
  }

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 1rem;
    padding-bottom: 60px;
    max-width: 940px;
    margin: 0 auto;

    @media (max-width: 940px) {
      padding: 300px 32px 48px 32px;
    }
  }
`;
const $c6bd0d654005585b$var$Hero = ({ image: image, subtitle: subtitle, title: title, source: source, mobileImage: mobileImage = '' })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)($c6bd0d654005585b$var$HeroContainer, {
        className: "hero",
        $image: image,
        $mobileImage: mobileImage ?? image,
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
            initial: "hidden",
            whileInView: "visible",
            viewport: (0, $51Ucj.viewPort),
            variants: (0, $51Ucj.containerVariants),
            className: "hero-content",
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h1, {
                    variants: (0, $51Ucj.itemVariants),
                    className: "billboard dynamic",
                    children: title
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).p, {
                    variants: (0, $51Ucj.itemVariants),
                    children: [
                        subtitle,
                        /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
                        source ? /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                            children: source
                        }) : null
                    ]
                })
            ]
        })
    });
};
var $c6bd0d654005585b$export$2e2bcd8739ae039 = $c6bd0d654005585b$var$Hero;

});

parcelRegister("gJOH1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8725859054b78d0a$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $3eb7t = parcelRequire("3eb7t");
const $8725859054b78d0a$var$NewsAgent = ({ title: title, image: image, link_style: link_style, description: description, articles: articles, cta: cta })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
        className: "news_agent_container",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "news_agent_header",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                        className: "dynamic",
                        children: title
                    }),
                    image && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                        sizes: "(max-width: 840px) 100vw, 840px",
                        alt: title,
                        src: image
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        children: description
                    }),
                    cta && /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        className: "cta",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                            href: cta.url,
                            className: "link-button",
                            children: cta.text
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "news_agent_content",
                children: articles.map((article, i)=>{
                    return /*#__PURE__*/ (0, $2PPWI.jsxs)("article", {
                        className: "news_agent_article",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: "news_agent_article_header",
                                children: [
                                    article.image && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                        sizes: "(max-width: 840px) 100vw, 400px",
                                        alt: article.title,
                                        src: article.image
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        children: article.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "news_agent_article_content",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                    children: article.text
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "news_agent_article_footer",
                                children: article.link && /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                    className: `link-${link_style}`,
                                    href: article.link,
                                    children: article.linkText ? article.linkText : "L\xe4s mer"
                                })
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
};
var $8725859054b78d0a$export$2e2bcd8739ae039 = $8725859054b78d0a$var$NewsAgent;

});

parcelRegister("1LX1E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eea4814286cb9791$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $jXrsw = parcelRequire("jXrsw");

var $3eb7t = parcelRequire("3eb7t");
const $eea4814286cb9791$var$SBSStyled = (0, $jXrsw.default).section`
  display: grid;
  grid-template-columns: 1.7fr 1fr;
  gap: 40px;
  > img {
    width: 100%;
  }
  > .content > h3 {
    font-size: 18px;
    line-height: 23px;
    font-weight: 400;
    margin: 0 0 8px 0;
  }
  > .content > p {
    font-size: 14px;
    line-height: 20px;
  }

  @media screen and (max-width: 940px) {
    grid-template-areas: 'image' 'text';
    grid-template-columns: 1fr;
    gap: 0;
    > .content {
      margin-top: 32px;
      max-width: 100%;
      margin: 40px 32px 0 32px;
      grid-area: text;
    }
    > img {
      grid-area: image;
    }
  }
`;
const $eea4814286cb9791$var$SBS = ({ image: image, text: text, link: link, title: title })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($eea4814286cb9791$var$SBSStyled, {
        className: "side_side_img_text container",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                sizes: "(max-width: 768px) 100vw, 290px",
                alt: "Kia car image",
                src: image
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "content",
                children: [
                    title && /*#__PURE__*/ (0, $2PPWI.jsx)("h4", {
                        style: {
                            marginBottom: '.5rem'
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        children: text
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                        className: "link-button",
                        href: link,
                        children: "L\xe4s mer"
                    })
                ]
            })
        ]
    });
};
var $eea4814286cb9791$export$2e2bcd8739ae039 = $eea4814286cb9791$var$SBS;

});

parcelRegister("1swI9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26451d17d3cbab48$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $jXrsw = parcelRequire("jXrsw");
const $26451d17d3cbab48$var$TableContainer = (0, $jXrsw.default).div`
  width: 100%;
  max-width: 940px;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  gap: 96px;
  padding: 0;
  .comparisonTableContainer {
    width: 100%;
    font-family: inherit;
    margin: auto;
    position: relative;
    overflow-anchor: none;
  }
  .comp-table__tableHead.stickyHeader {
    position: fixed;
    z-index: 999;
    overflow-x: scroll;
    top: 0px;
  }
  .comp-table__tableHead.stickyHeader.atBottom {
    position: absolute;
    z-index: 999;
    bottom: 0px;
    left: 0px !important;
    top: initial;
    width: initial !important;
    overflow-x: clip;
  }
  th {
    vertical-align: top;
  }
  .comparisonTableContainer use:nth-child(2) {
    transform: translate(20px);
  }
  .comparisonTableContainer use:nth-child(3) {
    transform: translate(40px);
  }
  .comparisonTableContainer use:nth-child(4) {
    transform: translate(60px);
  }
  .comparisonTableContainer use:nth-child(5) {
    transform: translate(80px);
  }
  .comparisonTableContainer .rating {
    height: 20px;
    width: 100px;
  }
  .comparisonTableContainer #stars-empty-star {
    fill: #f1e8ca;
  }
  .comparisonTableContainer #stars-full-star,
  .comparisonTableContainer #stars-half-star {
    fill: #fdcc0d;
  }
  @media (max-width: 769px) {
    .comp-table__columnGroup .comp-table__tableData,
    .comp-table__columnGroupSection .comp-table__tableData,
    .comp-table__columnHeader:nth-child(2),
    .comp-table__tableBodyRow .comp-table__tableData:nth-child(2) {
      border-left: 1px solid #bdbdbd !important;
    }
    .comp-table__emptyCell,
    .comp-table__rowheader {
      display: none;
    }
    .comp-table__productImage {
      height: auto;
      max-width: 100%;
    }
    .comp-table__columnGroupSection .comp-table__tableData {
      text-align: left;
    }
    .comparisonTableContainer
      .comp-table
      .comp-table__tableData:not([scope='colgroup']) {
      min-width: 80px;
      max-width: 80px;
    }
    .comparisonTableContainer.moreThan4
      .comp-table
      .comp-table__tableData:not([scope='colgroup']) {
      min-width: 90px;
      max-width: 90px;
    }
    .comparisonTableContainer.moreThan4
      .comp-table__tableData[scope='colgroup'] {
      text-align: left;
    }
    .comp-table__productImageContainer {
      width: 80px;
      height: 80px;
    }
    .comparisonTableContainer use:nth-child(2) {
      transform: translate(15px);
    }
    .comparisonTableContainer use:nth-child(3) {
      transform: translate(30px);
    }
    .comparisonTableContainer use:nth-child(4) {
      transform: translate(45px);
    }
    .comparisonTableContainer use:nth-child(5) {
      transform: translate(60px);
    }
    .comparisonTableContainer .rating {
      height: 13px;
    }
  }
  .comparisonTableContainer.moreThan4
    .comp-table__tableData[scope='colgroup']
    span {
    padding-left: 10px;
  }
  .comparisonTableContainer.moreThan4 .comp-table__tableData[scope='colgroup'] {
    padding-left: 0;
  }
  .comp-table {
    width: 100%;
    margin: auto;
    border-bottom: 1px solid #bdbdbd !important;
    table-layout: auto;
    border-collapse: separate;
    border-spacing: 0;
  }
  .comparisonTableContainer {
    overflow: auto;
  }
  .comparisonTableContainer .comp-table__tableData:not([scope='colgroup']) {
    min-width: 150px;
    max-width: 150px;
  }
  .comparisonTableContainer .comp-table__rowheader {
    width: 200px !important;
    min-width: 200px !important;
    max-width: 200px !important;
    border-left: 1px solid #bdbdbd !important;
  }
  .comparisonTableContainer .checkmark {
    fill: #4ac263;
  }
  .comparisonTableContainer .xmark {
    fill: #808080;
  }
  .comp-table__tableData {
    border-right: 1px solid #bdbdbd !important;
    border-top: 1px solid #bdbdbd !important;
  }
  .comp-table caption {
    position: absolute;
    opacity: 0;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }
  .comp-table__rowheader {
    /*width:20%;*/
    text-align: left;
    padding: 10px;
    left: 0;
    position: sticky;
    position: -webkit-sticky;
  }
  .comp-table__tableData {
    padding: 12px 5px;
    background: #ffffff;
    border-color: #bdbdbd;
    line-height: 1.4;
  }
  [scope='colgroup'] span {
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    left: 0;
  }
  .comp-table__columnGroup,
  .comp-table__tableDataCell {
    text-align: center;
    background-clip: padding-box !important;
  }
  .comp-table__columnHeader {
    text-align: left;
  }
  .comp-table__columnHeader p {
    font-weight: normal;
    font-size: 14px;
    margin: 0;
  }
  .comp-table__columnHeader {
    background: #f8f8f8;
    padding: 1rem;
    padding-bottom:;
    position: relative;
    min-width: 50% !important;
  }
  .comp-table__emptyCell {
    border-top: 1px solid #bdbdbd !important;
    border-left: 1px solid #bdbdbd !important;
    background: #f8f8f8;
    position: sticky;
    left: 0;
    z-index: 99;
    padding-left: 20px;
  }
  .comp-table__tableDataCell {
    padding: 12px 5px;
  }
  .comp-table__tableDataCell svg {
    margin: auto;
    display: block;
  }
  .comp-table__tableDataCell > * {
    min-height: 28px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .comp-table__columnHeader:not(.comp-table__recommended)
    .comp-table__recommendedText {
    display: none;
  }
  .comp-table__recommendedText {
    color: #ffffff;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    margin: 0;
    padding: 4px 0;
  }
  @media (min-width: 769px) {
    padding: 0 32px;
    .comp-table__tableBodyRow:nth-child(2n),
    .comp-table__tableBodyRow:nth-child(2n) .comp-table__tableData {
      background: #ffffff;
    }
    .comp-table__tableBodyRow:nth-child(4n),
    .comp-table__tableBodyRow:nth-child(4n) .comp-table__tableData {
      background: #f8f8f8;
    }
    .comp-table__columnGroup {
      display: none;
    }
    .comp-table__productImage {
      max-width: 120px !important;
      height: auto;
    }
    .comp-table__rowheader {
      padding-left: 20px !important;
    }
    .comp-table__columnGroupSection .comp-table__tableData {
      text-align: left;
    }
    .comp-table__productImageContainer {
      width: 140px;
      height: 140px;
    }
  }
  .comp-table__columnGroup .comp-table__tableData {
    background: #f0f0f0;
    border-top: 4px solid #bdbdbd !important;
  }
  .comp-table__type {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: auto;
    position: relative;
  }
  .comp-table__productLink:hover {
    filter: brightness(0.9);
  }
  .comp-table__productLink {
    background: #ffffff;
    padding: 12px 2px;
    border-radius: 5px;
    width: 95%;
    line-height: 1.2;
    pointer-events: all !important;
  }
  .comp-table__recommended .comp-table__productLink {
    border: 2px solid transparent;
    background: #f27e3d;
    color: #ffffff;
  }
  .comp-table__price {
    margin-top: 10px;
    margin-bottom: 10px;
    word-break: break-word;
    line-height: 1.2;
  }
  .comp-table__title {
    font-size: 18px !important;
    font-style: normal;
    font-weight: 400 !important;
    line-height: 23px !important;
  }
  .comp-table__recurrence {
    margin-top: -10px;
    margin-bottom: 20px;
    line-height: 1rem;
  }
  .comp-table__columnGroupSection .comp-table__tableData {
    text-transform: uppercase;
    background: #9fd0d1;
    padding: 15px 5px;
    border-left: 1px solid #bdbdbd !important;
  }
  .comp-table__recommended {
    background: #eafbed !important;
  }
  .comp-table__productImageContainer {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    margin-bottom: 10px;
  }
  .comp-table__tableHead::-webkit-scrollbar {
    height: 0px;
  }
`;
const $26451d17d3cbab48$var$Table = ({ businessTitle: businessTitle, financialTitle: financialTitle, businessText: businessText, financialText: financialText, rows: rows })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)($26451d17d3cbab48$var$TableContainer, {
        className: "comparison_container",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            className: "comparisonTableContainer",
            children: /*#__PURE__*/ (0, $2PPWI.jsxs)("table", {
                className: "comp-table",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("thead", {
                        className: "comp-table__tableHead",
                        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("tr", {
                            className: "comp-table__columnHeaders comp-table__tableRow",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("th", {
                                    title: "Empty placeholder cell",
                                    className: "comp-table__emptyCell comp-table__tableData comp-table__columnHeader"
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("th", {
                                    scope: "col",
                                    className: " comp-table__tableData comp-table__columnHeader",
                                    children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                        className: "comp-table__type",
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                                className: "comp-table__title",
                                                children: businessTitle
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                children: businessText
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("th", {
                                    scope: "col",
                                    className: " comp-table__tableData comp-table__columnHeader",
                                    children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                        className: "comp-table__type",
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                                className: "comp-table__title",
                                                children: financialTitle
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                children: financialText
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("tbody", {
                        className: "comp-table__tableBody",
                        children: rows.map((row)=>/*#__PURE__*/ (0, $2PPWI.jsxs)((0, $8FY87.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("tr", {
                                        className: "comp-table__columnGroup comp-table__tableRow",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("th", {
                                            scope: "colgroup",
                                            className: "comp-table__tableData",
                                            colSpan: 2,
                                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                children: row.title
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsxs)("tr", {
                                        className: "comp-table__tableRow comp-table__tableBodyRow",
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("th", {
                                                className: "comp-table__tableData comp-table__rowheader",
                                                scope: "row",
                                                children: row.title
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("td", {
                                                className: "comp-table__tableData comp-table__tableDataCell ",
                                                children: row.business
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("td", {
                                                className: "comp-table__tableData comp-table__tableDataCell ",
                                                children: row.financial
                                            })
                                        ]
                                    })
                                ]
                            }, row.title))
                    })
                ]
            })
        })
    });
};
var $26451d17d3cbab48$export$2e2bcd8739ae039 = $26451d17d3cbab48$var$Table;

});

parcelRegister("je5iV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $593cd5c3c9aa6783$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $jXrsw = parcelRequire("jXrsw");

var $2IJYm = parcelRequire("2IJYm");

var $3eb7t = parcelRequire("3eb7t");
const $593cd5c3c9aa6783$var$CompanyOfferStyled = (0, $jXrsw.default).section`
  display: flex;
  flex-direction: row;
  gap: 0;

  > img {
    width: 31%;
    height: auto;
    object-fit: cover;
  }

  > .content {
    display: flex;
    flex-direction: column;
    background-color: #f4f4f4;
    width: 100%;
    padding: 26px 16px 0 32px;
  }

  > .content > h2 {
    max-width: 700px;
    letter-spacing: -1.56px;
  }

  /* paragraph version */
  > .content > p {
    font-size: 14px;
    line-height: 20px;
    max-width: 690px;
  }

  /* list version */
  > .content > ul {
    list-style: none; /* we insert our own bullets */
    padding: 0;
    margin: 0;
  }

  > .content > ul li {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 14px;
    line-height: 20px;
    max-width: 690px;
    margin-bottom: 6px;
  }

  > .content > span.legal-text {
    font-size: 9px;
    line-height: 18px;
    color: #5f5f5f;
    margin-top: 4px;
  }

  @media screen and (max-width: 940px) {
    flex-direction: column;

    > .content {
      padding: 14px 16px 0 16px;
    }

    > .content > h2 {
      max-width: 85%;
      letter-spacing: 0.5px;
    }

    > .content > p,
    > .content > ul li {
      line-height: 22px !important;
    }

    > img {
      width: 100%;
    }
  }

  .link-button {
    background-color: #000;
    color: #fff;
    line-height: 24px;
    font-size: 20px;
    padding: 16px 58px;
    margin: auto 4px 17px auto;

    @media screen and (max-width: 940px) {
      margin: 34px auto 40px auto;
      padding: 14px 50px;
    }
  }
`;
const $593cd5c3c9aa6783$var$CompanyOffer = ({ image: image, title: title, subTitle: subTitle, text: text, listItems: listItems, legalText: legalText, link: link, linkText: linkText })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($593cd5c3c9aa6783$var$CompanyOfferStyled, {
        className: "px-4 mx-auto max-w-7xl",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                sizes: "(max-width: 768px) 100vw, 290px",
                alt: title || 'Company offer',
                src: image,
                className: "aspect-video object-[50%_60%]"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "content",
                children: [
                    title && /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                        children: title
                    }),
                    subTitle && /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                        className: "mb-2",
                        children: subTitle
                    }),
                    text && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        className: "mb-2 text-lg ",
                        children: text
                    }),
                    listItems && listItems.length > 0 && /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                        children: listItems.map((item, i)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                                className: "flex items-start space-x-2",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2IJYm.default), {
                                        className: "w-[6px] h-[6px] mt-[7px] flex-shrink-0"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                        children: item
                                    })
                                ]
                            }, i))
                    }),
                    legalText && /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        className: "legal-text",
                        children: legalText
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                        className: "no-underline link-button text-white",
                        href: link,
                        children: linkText
                    })
                ]
            })
        ]
    });
};
var $593cd5c3c9aa6783$export$2e2bcd8739ae039 = $593cd5c3c9aa6783$var$CompanyOffer;

});

parcelRegister("5HYoR", function(module, exports) {

$parcel$export(module.exports, "hero", function () { return $50fa9e0493288401$export$124049a9e3d0d4c3; });
$parcel$export(module.exports, "companyOffer", function () { return $50fa9e0493288401$export$a1bd427253f3af33; });
$parcel$export(module.exports, "collage", function () { return $50fa9e0493288401$export$a0dd4abd963baeb5; });
$parcel$export(module.exports, "collage2", function () { return $50fa9e0493288401$export$c0f78d748eeb5aea; });
$parcel$export(module.exports, "table", function () { return $50fa9e0493288401$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "imageAndLink", function () { return $50fa9e0493288401$export$9736a23d9ab65287; });
$parcel$export(module.exports, "rentAndShareImageAndLink", function () { return $50fa9e0493288401$export$8c2eb1f9158bd9d3; });
$parcel$export(module.exports, "driverNews", function () { return $50fa9e0493288401$export$60ee8771cb796c23; });
$parcel$export(module.exports, "companyNews", function () { return $50fa9e0493288401$export$5d2ae464d6e875ce; });
$parcel$export(module.exports, "buyerNews", function () { return $50fa9e0493288401$export$a194a21a6c0e6a0b; });
$parcel$export(module.exports, "fleetPuff", function () { return $50fa9e0493288401$export$6af2cedc2fa01596; });
$parcel$export(module.exports, "hero2", function () { return $50fa9e0493288401$export$3efe54bdd210966d; });
$parcel$export(module.exports, "news2", function () { return $50fa9e0493288401$export$ae083610243dff7e; });
$parcel$export(module.exports, "faq", function () { return $50fa9e0493288401$export$bcbb932733b48eed; });
const $50fa9e0493288401$export$124049a9e3d0d4c3 = {
    title: "Kia Tj\xe4nstebil",
    subtitle: "Bli en del av den laddbara friheten med en tj\xe4nstebil fr\xe5n Kia. Innovativ teknik och gener\xf6sa utrustningsniv\xe5er som standard.",
    image: 'https://kia-afonso-storage.b-cdn.net/EV5_Friheten-Vantar_2.jpg',
    mobileImage: 'https://kia-afonso-storage.b-cdn.net/EV5_Friheten-Vantar_2.jpg'
};
const $50fa9e0493288401$export$a1bd427253f3af33 = {
    image: 'https://kia-afonso-storage.b-cdn.net/Kia-Range_7bilar_Business_Edition.jpg',
    title: 'Kia Business Edition.',
    subTitle: "Fullutrustade bilar, attraktiva f\xf6rm\xe5nsv\xe4rden.",
    text: "Med Business Edition f\xe5r du v\xe5ra popul\xe4ra elbilar Kia EV3, EV4, EV5, EV6 och EV9 i fullutrustade GT Line-utf\xf6randen, med attraktiva f\xf6rm\xe5nsv\xe4rden. Dessutom finns nu Kia Sportage Plug-In Hybrid och Kia Sorento Plug-In Hybrid som Business Edition. Uppt\xe4ck den laddbara friheten.",
    link: 'https://www.kia.com/se/tjanstebil/business-edition/',
    linkText: "L\xe4s om Business Edition"
};
const $50fa9e0493288401$export$a0dd4abd963baeb5 = {
    title: 'Den laddbara friheten',
    text: "Med en Kia som tj\xe4nstebil f\xe5r du innovativ teknik, h\xf6g komfort och de senaste s\xe4kerhets- och infotainment-systemen med uppkopplade tj\xe4nster \u2013 samt flexibla finansieringsl\xf6sningar. Vill du dessutom k\xf6ra en tj\xe4nstebil med fyrhjulsdrift finns det flera laddbara modeller att v\xe4lja bland. Laddbar frihet n\xe4r den \xe4r som b\xe4st.",
    images: [
        {
            src: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/logo.jpg',
            alt: 'Kia logo'
        },
        {
            src: 'https://kia-afonso-storage.b-cdn.net/EV9-2024.jpg',
            alt: 'Livet med fyrhjulsdrift',
            title: 'Livet med fyrhjulsdrift',
            text: "Kia EV9, Kia EV6, Kia Sportage Plug-In Hybrid och Kia Sorento Plug-In Hybrid \xe4r fyra popul\xe4ra tj\xe4nstebilar med fyrhjulsdrift. Alla med gener\xf6sa utrymmen och fulla av innovativ teknik. "
        },
        {
            src: 'https://kia-afonso-storage.b-cdn.net/Ev6-FL-2024-Dec.jpg',
            alt: 'Ultrasnabb laddning',
            title: 'Ultrasnabb laddning',
            text: "Kia EV6 och Kia EV9 har b\xe5da 800-voltsteknik som m\xf6jligg\xf6r laddning av batteriet fr\xe5n 10-80% p\xe5 ned till 18 respektive 24 minuter med en >250 kW snabbladdare."
        }
    ]
};
const $50fa9e0493288401$export$c0f78d748eeb5aea = {
    title: 'Den laddbara friheten',
    text: "Med en Kia som tj\xe4nstebil f\xe5r du innovativ teknik, h\xf6g komfort och de senaste s\xe4kerhets- och infotainment-systemen med uppkopplade tj\xe4nster \u2013 samt flexibla finansieringsl\xf6sningar. Vill du dessutom k\xf6ra en tj\xe4nstebil med fyrhjulsdrift finns det flera laddbara modeller att v\xe4lja bland. Laddbar frihet n\xe4r den \xe4r som b\xe4st.",
    images: [
        {
            src: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/Kia-Tjanstebil-1.jpg',
            alt: 'Kia logo'
        },
        {
            src: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/Kia-Tjanstebil-2.jpg',
            alt: "Tj\xe4nstebilen som powerbank?",
            title: "Tj\xe4nstebilen som powerbank?",
            text: "V\xe5ra elbilar har funktionen Vehicle-to-Load (V2L) som inneb\xe4r att du kan anv\xe4nda din elbil f\xf6r att driva eller ladda till exempel en kaffekokare, elcykel eller annan utrustning du har med dig p\xe5 resan.",
            link: 'https://www.kia.com/se/om-kia/upplev-kia/teknik/'
        },
        {
            src: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/Kia-Tjanstebil-3.jpg',
            alt: 'Plug & Charge',
            title: 'Plug & Charge',
            text: "Med Plug & Charge blir laddstoppen otroligt smidiga. Laddning och betalning startar automatiskt n\xe4r du ansluter kabeln. Det inneb\xe4r att du beh\xf6ver varken app eller betalkort n\xe4r du ska ladda.",
            link: 'https://kiacharge.com/web/sv/kia-se/service'
        }
    ]
};
const $50fa9e0493288401$export$9852986a3ec5f6a0 = {
    businessTitle: 'Kia Business Lease',
    businessText: "Kia Business Lease \xe4r en paketl\xf6sning d\xe4r finansiering, f\xf6rs\xe4kring, service och vinterd\xe4ck ing\xe5r. Allt samlat p\xe5 en m\xe5nadsfaktura. Du beh\xf6ver inte bekymra dig \xf6ver restv\xe4rdet, det \xe4r garanterat, och f\xf6rsta f\xf6rh\xf6jd hyra \xe4r valfritt.",
    financialTitle: 'Kia Finansiell Leasing',
    financialText: "Med Kia Finansiell Leasing v\xe4ljer du sj\xe4lv till de tj\xe4nster du beh\xf6ver samt s\xe4tter bilens restv\xe4rde. Kia Finans hyr ut bilen mot en m\xe5nadskostnad. Leasingavgiften best\xe4ms av bilens nettopris, kapitalkostnaden och fordonets restv\xe4rde.",
    rows: [
        {
            title: "Garanterat restv\xe4rde",
            business: 'Ja',
            financial: 'Nej'
        },
        {
            title: 'Kia serviceavtal',
            business: "Ing\xe5r",
            financial: 'Tillval'
        },
        {
            title: "Kia bilf\xf6rs\xe4kring",
            business: "Ing\xe5r",
            financial: 'Tillval'
        },
        {
            title: 'Kia Original Vinterhjul',
            business: "Ing\xe5r",
            financial: 'Tillval'
        }
    ]
};
const $50fa9e0493288401$export$9736a23d9ab65287 = {
    image: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/KiaSorento.jpg',
    text: "Vi hj\xe4lper dig att hitta den finansieringsl\xf6sning som passar b\xe4st - p\xe5 l\xe4nken nedan hittar du mer information om v\xe5ra olika modeller och finansieringsl\xf6sningar.",
    link: 'https://www.kia.com/se/tjanstebil/foretagsleasing/'
};
const $50fa9e0493288401$export$8c2eb1f9158bd9d3 = {
    image: 'https://kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/hyr-och-dela/Appsida-bild-man.jpg',
    title: 'Kia Drive, Hyr & Dela.',
    text: "Med bildelningstj\xe4nsten Kia Drive, hyr ni bilar m\xe5nadsvis och kan enkelt anpassa er flotta efter behov. Bilarna anv\xe4nds som f\xf6retagsbil i tj\xe4nsten men kan \xe4ven hyras av medarbetare eller kunder. Allt som kr\xe4vs \xe4r v\xe5r app Kia Drive.",
    link: 'https://www.kia.com/se/kopa/hyr-och-dela/'
};
const $50fa9e0493288401$export$60ee8771cb796c23 = {
    title: "Bra att veta f\xf6r dig som k\xf6r tj\xe4nstebil",
    link_style: 'text',
    description: "Hur fungerar drivmedelsers\xe4ttningen? Hur ber\xe4knas egentligen f\xf6rm\xe5nsv\xe4rdet? Och vilka tj\xe4nstebilsmodeller kan du v\xe4lja mellan? H\xe4r hittar du information om vanliga begrepp och fr\xe5gor som r\xf6r tj\xe4nstebilsaff\xe4ren - s\xe5 att det blir \xe4nnu enklare f\xf6r dig att v\xe4lja en Kia som tj\xe4nstebil.",
    articles: [
        {
            title: "F\xf6rm\xe5nsv\xe4rde",
            text: "Om du som anst\xe4lld har en tj\xe4nstebil som du anv\xe4nder privat, beh\xf6ver du utg\xe5 ifr\xe5n att den f\xf6rm\xe5nen ska f\xf6rm\xe5nsbeskattas. Varje bilmodell f\xf6rses med ett f\xf6rm\xe5nsv\xe4rde baserat p\xe5 dess pris och CO2-utsl\xe4pp, och som l\xe4ggs ovanp\xe5 din bruttol\xf6n.",
            link: 'https://www.kia.com/se/tjanstebil/priser/'
        },
        {
            title: "Vad \xe4r skillnaden mellan olika typer av tj\xe4nstebilar?",
            text: "En f\xf6rm\xe5nsbil \xe4r en tj\xe4nstebil som din arbetsgivare l\xe5ter dig anv\xe4nda privat. Det klassas som en l\xf6nef\xf6rm\xe5n som du betalar skatt f\xf6r. En personalbil \xe4r en bil som hyrs genom arbetsgivaren och disponeras av medarbetaren som en privat bil. Medarbetaren betalar f\xf6r hela kostnaden som arbetsgivaren har f\xf6r bilen genom bruttol\xf6neavdrag. En renodlad tj\xe4nstebil f\xe5r endast anv\xe4ndas i tj\xe4nsten och f\xf6r denna betalar man inget f\xf6rm\xe5nsv\xe4rde."
        },
        {
            title: 'Bonus Malus',
            text: "F\xf6r att minska koldioxidutsl\xe4ppen inf\xf6rdes 2018 skattesystemet Bonus Malus. Bilar med h\xf6ga CO2-utsl\xe4pp bestraffas med malus-skatt, och fordon med l\xe5ga C02-utsl\xe4pp premierades med en klimatbonus. Regeringen beslutade att avskaffa klimatbonusen den 8 november 2022."
        },
        {
            title: "Drivmedelsers\xe4ttning",
            text: "Drivmedelsers\xe4ttning kan ber\xe4knas p\xe5 tv\xe5 olika s\xe4tt, kallat huvudregeln och komplementregeln. Huvudregeln inneb\xe4r att den anst\xe4llde betalar br\xe4nslet sj\xe4lv och sedan tar ut milers\xe4ttning f\xf6r de tj\xe4nstemil som k\xf6rs. Komplementregeln inneb\xe4r att f\xf6retaget st\xe5r f\xf6r hela br\xe4nslekostnaden och att f\xf6raren f\xf6rm\xe5nsbeskattas f\xf6r privatmilen. L\xe4s mer om drivmedelsers\xe4ttning under \u201DVanliga fr\xe5gor och svar om tj\xe4nstebilar\u201D."
        },
        {
            title: 'Vill du veta mer?',
            text: "\xc4r du ansvarig f\xf6r ditt f\xf6retags tj\xe4nstebilar och vill veta mer om Kias tj\xe4nstebilserbjudande? D\xe5 \xe4r du v\xe4lkommen att kontakta din Kia-\xe5terf\xf6rs\xe4ljare som hj\xe4lper dig med r\xe5dgivning.",
            link: 'https://www.kia.com/se/tjanstebil/kia-fleet-team/'
        },
        {
            title: "Brett utbud av tj\xe4nstebilar",
            text: "Vi vet vad som kr\xe4vs av en tj\xe4nstebil och utvecklar hela tiden v\xe5ra modeller s\xe5 att de lever upp till v\xe5ra h\xf6gt st\xe4llda krav p\xe5 innovation, kvalitet och design. H\xe4r kan du se hela v\xe5rt utbud av innovativa tj\xe4nstebilar med mycket k\xf6rgl\xe4dje.",
            link: 'https://www.kia.com/se/nya-bilar/bilmodeller/'
        }
    ]
};
const $50fa9e0493288401$export$5d2ae464d6e875ce = {
    title: "Bra att veta f\xf6r dig som erbjuder tj\xe4nstebil till dina anst\xe4llda",
    image_src: 'https://www.fillmurray.com/840/450',
    link_style: 'text',
    description: "Vilka finansiella l\xf6sningar kan ditt f\xf6retag anv\xe4nda sig av n\xe4r det g\xe4ller tj\xe4nstebilar? Hur ber\xe4knas restv\xe4rdet? Och vilka tj\xe4nstebilsmodeller kan du v\xe4lja mellan? H\xe4r hittar du information om vanliga begrepp och fr\xe5gor som r\xf6r tj\xe4nstebilsaff\xe4ren - s\xe5 att det blir \xe4nnu enklare f\xf6r dig att v\xe4lja en Kia som tj\xe4nstebil.",
    articles: [
        {
            title: 'TCO',
            text: "TCO st\xe5r f\xf6r Total Cost of Ownership. Det \xe4r den totala \xe4gandekostnaden som avg\xf6r hur mycket en bil kommer att kosta i slut\xe4nden. F\xf6r att r\xe4kna ut TCO ska alla kostnader inkluderas, som till exempel leasingavgift, extrautrustning, service, f\xf6rs\xe4kringar, skatter osv. Du kan l\xe4sa mer om TCO under \u201DVanliga fr\xe5gor och svar om tj\xe4nstebilar.\u201D"
        },
        {
            title: 'Finansiell och operationell leasing',
            text: "Om du v\xe4ljer finansiell leasing f\xe5r du en flexibel l\xf6sning med m\xe5nga valm\xf6jligheter. Kunden \xe4ger bilen och ansvarar f\xf6r dess restv\xe4rde. Leasingavgiften best\xe4ms av bilens nettopris, kapitalkostnaden och fordonets restv\xe4rde som s\xe4tts baserat p\xe5 k\xf6rprofil. Om \xf6vriga bilkostnader uppst\xe5r hanteras de av kunden. Vid operationell leasing \xe4gs bilen av leasingbolaget som ocks\xe5 ansvarar f\xf6r restv\xe4rdet och bilen hyrs ut till kunden till en fast avgift d\xe4r alla omkostnader \xe4r inkluderade.",
            link: 'https://www.kia.com/se/tjanstebil/inkopare-farre-an-50-bilar/finansiering/'
        },
        {
            title: 'Bilpolicy',
            text: "F\xf6retag tar ofta fram en bilpolicy f\xf6r att definiera regler kring ink\xf6p och anv\xe4ndning av tj\xe4nste- och f\xf6rm\xe5nsbilar. Beh\xf6ver du som ink\xf6pare r\xe5d och hj\xe4lp kring utformandet av en bilpolicy kan en Certifierad F\xf6retagsr\xe5dgivare hos en Kia- \xe5terf\xf6rs\xe4ljare hj\xe4lpa till. L\xe4s mer under \u201DVanliga fr\xe5gor och svar om tj\xe4nstebilar.\u201D"
        },
        {
            title: 'Vill du veta mer?',
            text: "\xc4r du ansvarig f\xf6r ditt f\xf6retags tj\xe4nstebilar och vill veta mer om Kias tj\xe4nstebilserbjudande? D\xe5 \xe4r du v\xe4lkommen att kontakta din Kia-\xe5terf\xf6rs\xe4ljare som hj\xe4lper dig med r\xe5dgivning.",
            link: ' https://www.kia.com/se/tjanstebil/kia-fleet-team/'
        },
        {
            title: "Brett utbud av tj\xe4nstebilar",
            text: "Vi vet vad som kr\xe4vs av en tj\xe4nstebil och utvecklar hela tiden v\xe5ra modeller s\xe5 att de lever upp till v\xe5ra h\xf6gt st\xe4llda krav p\xe5 innovation, kvalitet och design. H\xe4r kan du se hela v\xe5rt utbud av innovativa tj\xe4nstebilar med mycket k\xf6rgl\xe4dje.",
            link: 'https://www.kia.com/se/nya-bilar/bilmodeller/'
        }
    ]
};
const $50fa9e0493288401$export$a194a21a6c0e6a0b = {
    title: "Bra att veta f\xf6r dig som \xe4r ink\xf6pare",
    image_src: 'https://www.fillmurray.com/840/450',
    link_style: 'text',
    description: "Vad g\xe4ller f\xf6r ramavtal? Hur ber\xe4knas restv\xe4rdet? Och vilka tj\xe4nstebilsmodeller kan du v\xe4lja mellan? H\xe4r hittar du information om vanliga begrepp och fr\xe5gor som r\xf6r tj\xe4nstebilsaff\xe4ren - s\xe5 att det blir \xe4nnu enklare f\xf6r dig att v\xe4lja en Kia som tj\xe4nstebil.",
    articles: [
        {
            title: 'TCO',
            text: "TCO st\xe5r f\xf6r Total Cost of Ownership. Det \xe4r den totala \xe4gandekostnaden som avg\xf6r hur mycket en bil kommer att kosta i slut\xe4nden. F\xf6r att r\xe4kna ut TCO ska alla kostnader, tillexempel leasingavgift, extrautrustning, service, f\xf6rs\xe4kringar, skatter osv inkluderas. Du kan l\xe4sa mer om TCO under \u201DVanliga fr\xe5gor och svar om tj\xe4nstebilar.\u201D"
        },
        {
            title: "Restv\xe4rde",
            text: "Restv\xe4rdet \xe4r det v\xe4rde som bilen uppskattas ha vid leasingperiodens slut och som till stor del best\xe4mmer hur h\xf6g leasingavgiften ska vara. I en finansiell leasing b\xf6r det faktiska restv\xe4rdet vid leasingperiodens slut l\xe4ggas n\xe5got l\xe4gre \xe4n det f\xf6rv\xe4ntade marknadsv\xe4rdet f\xf6r att vara p\xe5 den s\xe4kra sidan."
        },
        {
            title: 'Ramavtal',
            text: "F\xf6r att f\xe5 b\xe4sta m\xf6jliga villkor vid k\xf6p av Kia-bilar kan f\xf6retag med minst 10 personbilar i vagnparken teckna ett ramavtal med Kia Sweden AB. Det finns \xe4ven andra f\xf6rm\xe5nliga erbjudanden f\xf6r f\xf6retag med mindre vagnparker. Kontakta din Kia-\xe5terf\xf6rs\xe4ljare f\xf6r mer information."
        },
        {
            title: 'Vill du veta mer?',
            text: "\xc4r du ansvarig f\xf6r ditt f\xf6retags tj\xe4nstebilar och vill veta mer om Kias tj\xe4nstebilserbjudande? D\xe5 \xe4r du v\xe4lkommen att kontakta din Kia-\xe5terf\xf6rs\xe4ljare som hj\xe4lper dig med r\xe5dgivning.",
            link: 'https://www.kia.com/se/tjanstebil/kia-fleet-team/'
        },
        {
            title: "Brett utbud av tj\xe4nstebilar",
            text: "Vi vet vad som kr\xe4vs av en tj\xe4nstebil och utvecklar hela tiden v\xe5ra modeller s\xe5 att de lever upp till v\xe5ra h\xf6gt st\xe4llda krav p\xe5 innovation, kvalitet och design. H\xe4r kan du se hela v\xe5rt utbud av innovativa tj\xe4nstebilar med mycket k\xf6rgl\xe4dje.",
            link: 'https://www.kia.com/se/nya-bilar/bilmodeller/'
        }
    ]
};
const $50fa9e0493288401$export$6af2cedc2fa01596 = {
    title: "Tj\xe4nstebilskalkylatorn",
    subTitle: "R\xe4kna p\xe5 din tj\xe4nstebil",
    text: "Ta reda p\xe5 vad tj\xe4nstebilen kommer kosta. Du kan r\xe4kna ut kostnaden f\xf6r f\xf6retaget och f\xf6r f\xf6raren. Det g\xf6r det enkelt att j\xe4mf\xf6ra vad olika laddbara modeller och avtal g\xf6r f\xf6r skillnad i praktiken.",
    link: 'https://www.kia.com/se/tjanstebil/kalkyl-laddhybrid/',
    linkText: "Tj\xe4nstebilskalkylatorn",
    image: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/tjanstebil.jpg'
};
const $50fa9e0493288401$export$3efe54bdd210966d = {
    title: "Teknologi som tar dig fram\xe5t",
    subtitle: "Kia EV9 och EV6 \xe4r utvecklade f\xf6r att ta dig ut p\xe5 l\xe4ngre resor och med mer utrymme vilket ger dig balanserade k\xf6rupplevelser. Den l\xe5nga hjulbasen hos E-GMP-plattformen ger dig en rymlig kup\xe9 med h\xf6g komfort f\xf6r alla i bilen. Den banbrytande plattformen bidrar ocks\xe5 till inspirerande k\xf6regenskaper, en stabil och tyst upplevelse \xe4ven i h\xf6gre hastigheter och imponerande r\xe4ckvidder.  Med sin banbrytande 800-voltsteknik kan EV9 och EV6 laddas ultrasnabbt fr\xe5n 10\u201380 % p\xe5 ned till 24 minuter. Upplev en ny standard f\xf6r elektrisk komfort och prestanda.",
    image: 'https://kia-afonso.b-cdn.net/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/LaddbarRorelse.jpg?quality=80'
};
const $50fa9e0493288401$export$ae083610243dff7e = {
    title: "Hundratusentals laddningsm\xf6jligheter med Kia Charge",
    image: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/contents/purchase-guide/kampanjer/ceed-vi-lever-nu/freecoding/assets/images/kia-ceed-laddkontakt.jpg',
    image_src: 'https://www.kia.com/se/aga/support/kia-charge/',
    description: "N\xe4r du inte kan ladda hemma \xe4r Kia Charge en enkel och l\xe4ttanv\xe4nd laddningstj\xe4nst l\xe4ngs v\xe4garna. Allt du beh\xf6ver \xe4r ett kort, eller Kia Charge-appen, f\xf6r att f\xe5 tillg\xe5ng till hundratusentals laddstationer \xf6ver hela Europa med klimatneutral el. I appen kan du enkelt planera resans laddstopp och Kia Charge \xe4r nyckeln till det b\xe4sta laddningsn\xe4tverket Ionity.",
    cta: {
        url: 'https://www.kia.com/se/aga/support/kia-charge/',
        text: "L\xe4s mer om Kia Charge"
    },
    link_style: 'button',
    articles: [
        {
            title: 'Kia Serviceavtal',
            text: "N\xe4r du k\xf6per en tj\xe4nstebil fr\xe5n Kia kan du v\xe4lja Kia Serviceavtal. Det inneb\xe4r att du f\xe5r Kia Originalservice till en fast m\xe5nadskostnad, reservdelar som \xe4r speciellt framtagna och utvalda f\xf6r just din tj\xe4nstebil, samt fri assistans till n\xe4rmaste servicest\xe4lle om det h\xe4nder n\xe5got p\xe5 v\xe4gen.",
            link: 'https://www.kia.com/se/aga/originalservice/serviceavtal/',
            linkText: "L\xe4s mer",
            image: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/Serviceavtal.jpg'
        },
        {
            title: "Kia Originaltillbeh\xf6r",
            text: "Beh\xf6ver du dragkrok, lastgaller eller takbox till din tj\xe4nstebil? Med Kia Originaltillbeh\xf6r kan du komplettera din tj\xe4nstebil med tillbeh\xf6r som \xe4r konstruerade, tillverkade och testade f\xf6r att passa din Kia Tj\xe4nstebil perfekt.",
            link: 'https://www.kia.com/se/aga/tillbehor/?gclid=CjwKCAjw6dmSBhBkEiwA_W-EoC20t_0weX72SRN76gORj69_ssgHE5-kDanlQywk7ozL2lXP_zzLmRoCikMQAvD_BwE',
            linkText: "L\xe4s mer",
            image: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/Tillbehor.jpg'
        },
        {
            title: "Uppkopplade tj\xe4nster",
            text: "G\xf6r k\xf6rupplevelsen med din tj\xe4nstebil \xe4nnu b\xe4ttre med tj\xe4nster anpassade f\xf6r en uppkopplad vardag. Kia Connect-appen ger dig information i realtid och assisterar dig i varje situation. Med Apple CarPlay och Android Auto kan du lyssna p\xe5 din favoritpodd eller p\xe5 din spellista.",
            link: 'https://www.kia.com/se/om-kia/upplev-kia/teknik/kia-connect/',
            linkText: "L\xe4s mer",
            image: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/KIA-Connect.jpg'
        },
        {
            title: "7 \xe5rs nybilsgaranti",
            text: "Med en produktkvalitet som \xe4r utvecklad och testad under extrema f\xf6rh\xe5llanden erbjuder vi p\xe5 Kia ett bekymmersfritt bil\xe4gande med b\xe5de f\xf6ruts\xe4gbarhet och kostnadskontroll f\xf6r dig som f\xf6retagskund. Tack vare den l\xe5nga garantin har Kia-bilar ett mycket gott andrahandsv\xe4rde. Det inneb\xe4r mindre v\xe4rdeminskning och d\xe4rmed en l\xe5g total \xe4gandekostnad, vilket ger dig och ditt f\xf6retag resurser \xf6ver till annat.",
            link: 'https://www.kia.com/se/aga/kias-servicelofte/7-ars-nybilsgaranti/',
            linkText: "L\xe4s mer",
            image: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/7ar.jpg'
        },
        {
            title: 'Kia Sweden',
            text: "Sedan 2017 \xe4r Kia det tredje st\xf6rsta bilm\xe4rket i Sverige och redan 2013 lanserade vi v\xe5r f\xf6rsta elbil. V\xe5rt m\xe5l \xe4r 100% laddbar f\xf6rs\xe4ljning. Kias modellprogram pr\xe4glas av design, kvalitet och s\xe4kerhet och vi \xe4r stolta \xf6ver att sedan 2020 vara det mest popul\xe4ra bilm\xe4rket bland privatpersoner. Och vi v\xe4xer stadigt p\xe5 f\xf6retagsmarknaden.",
            link: 'https://www.kia.com/se/elbil/100-procent-laddbart-2024/',
            linkText: "L\xe4s mer om Kia Sweden",
            image: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/KIA-Sweden.jpg'
        },
        {
            title: "H\xe5llbarhetsrapport",
            text: "Visionen f\xf6r Kia Corporation \xe4r att bli en h\xe5llbar, ansvarstagande och innovativ tillverkare av mobilitetsl\xf6sningar. Vi st\xf6der principerna i FN:s Global Compact och har som m\xe5ls\xe4ttning att vi, tillsammans med \xf6vriga bilindustrin, ska ha en nyckelroll i \xf6verg\xe5ngen till en fossilfri fordonsflotta. H\xe5llbarhetsarbetet handlar ocks\xe5 om personal- och sociala f\xf6rh\xe5llanden, att bek\xe4mpa korruption och mutor, samt att skydda utsatta barn.",
            link: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/Hallbarhetsredovisning_2025-Spread-050525 1.pdf',
            linkText: "Ladda ner h\xe5llbarhetsrapporten",
            image: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/stockholm/freecoding/fleet-site/Hallbarhet.jpg'
        }
    ]
};
const $50fa9e0493288401$export$bcbb932733b48eed = {
    title: "Vanliga fr\xe5gor och svar om tj\xe4nstebilar",
    questions: [
        {
            q: "Hur fungerar drivmedelsers\xe4ttning om jag k\xf6r en tj\xe4nstebil?",
            a: `
        Det finns tv\xe5 olika s\xe4tt att ber\xe4kna drivmedelsers\xe4ttning f\xf6r tj\xe4nstebilsf\xf6rare: 
        <br>1) Huvudregeln inneb\xe4r att den anst\xe4llde betalar allt br\xe4nsle sj\xe4lv och sedan tar ut milers\xe4ttning f\xf6r de tj\xe4nstemil som k\xf6rs. Denna \xe4r f\xf6r n\xe4rvarande p\xe5 9 kr f\xf6r diesel och 12 kr f\xf6r \xf6vriga drivmedel.
        <br><br>
        2) Komplementregeln inneb\xe4r att f\xf6retaget st\xe5r f\xf6r hela br\xe4nslekostnaden och och f\xf6raren f\xf6rm\xe5nsbeskattas f\xf6r privatmilen med 120% av br\xe4nslekostnaden. (vid 50% marginalskatt betalar man 60% skatt p\xe5 privata mil)
        Du m\xe5ste kunna visa hur mycket som k\xf6rts i tj\xe4nsten genom att f\xf6ra k\xf6rjournal, annars betraktas bilens totala k\xf6rstr\xe4cka som privat k\xf6rning.`
        },
        {
            q: "Vilken drivmedelsers\xe4ttning \xe4r att f\xf6redra om jag k\xf6r en elbil som tj\xe4nstebil?",
            a: `
        I fallet med elbil \xe4r det att f\xf6redra att anv\xe4nda sig av Huvudregeln med milers\xe4ttning p\xe5 12 kr d\xe5 denna inneb\xe4r en ekonomiskt mer f\xf6rdelaktig l\xf6sning i de allra flesta fall om merparten av laddningen sker hemma.
        <br /><br />
        Kompletteringsregeln fungerar ej i de fall som f\xf6raren laddar hemma, p\xe5 jobbet, och l\xe4ngs v\xe4gen d\xe5 egna utl\xe4gg och f\xf6retagsbetalt br\xe4nsle inte kan kombineras.
       `
        },
        {
            q: "Hur ber\xe4knar jag f\xf6rm\xe5nsv\xe4rdet?",
            a: `
        Om du som anst\xe4lld har en tj\xe4nstebil som du anv\xe4nder privat, beh\xf6ver du utg\xe5 ifr\xe5n att den f\xf6rm\xe5nen ska f\xf6rm\xe5nsbeskattas. Skatten dras p\xe5 din l\xf6n och baseras p\xe5 den valda bilens f\xf6rm\xe5nsv\xe4rde.
        `
        },
        {
            q: "R\xe4knas tj\xe4nstebil som l\xf6n?",
            a: `Om du f\xe5r anv\xe4nda bilen privat \xe4r den att betrakta som en del av din l\xf6n, och ben\xe4mns d\xe5 ocks\xe5 som f\xf6rm\xe5nsbil. F\xf6rm\xe5nsv\xe4rdet l\xe4ggs till p\xe5 din bruttol\xf6n och du f\xe5r betala skatt p\xe5 totalbeloppet.`
        },
        {
            q: "P\xe5verkar min l\xf6n hur mycket jag betalar f\xf6r tj\xe4nstebilen?",
            a: `Generellt kan man s\xe4ga att ju h\xf6gre l\xf6n du har desto mer f\xf6rm\xe5nligt \xe4r det att ha f\xf6rm\xe5nsbil, eftersom den som \xe4ven betalar statlig skatt kommer att f\xe5 ett f\xf6rh\xe5llandevis st\xf6rre skatteavdrag \xe4n den som inte g\xf6r det.`
        },
        {
            q: "Vad h\xe4nder om jag inte fyller i k\xf6rjournal?",
            a: `Det \xe4r inget lagkrav p\xe5 k\xf6rjournal men Skatteverket kan beg\xe4ra att du bevisar hur du anv\xe4nder din tj\xe4nstebil privat. Speciellt viktigt \xe4r det f\xf6r dig som har en f\xf6retagsbil d\xe4r antalet privata mil \xe4r begr\xe4nsade till max 10 mil, vid max 10 tillf\xe4llen per \xe5r.
        <br /><br />
        Om det blir skatterevision kan utg\xe5ngen bero p\xe5 om du har f\xf6rt k\xf6rjournal och hur noggrant du har f\xf6rt den. Om du inte kan redovisa det ordentligt riskerar du att f\xe5 betala f\xf6rm\xe5nsskatt retroaktivt, \xe4ven f\xf6r de mil som du har k\xf6rt i tj\xe4nsten.`
        },
        {
            q: "Vad \xe4r TCO?",
            a: `TCO st\xe5r f\xf6r Total Cost of Ownership och \xe4r den den totala \xe4gandekostnaden och som avg\xf6r hur mycket en bil kommer att kosta i slut\xe4nden, inte prislappen i bilhallen. F\xf6r att r\xe4kna ut den totala summan ska du ta med alla t\xe4nkbara kostnader, som leasingavgift, extrautrustning, service, f\xf6rs\xe4kringar, skatter och sociala avgifter f\xf6r b\xe5de bil och br\xe4nsle. T\xe4nk p\xe5 att en dyr bil som k\xf6rs f\xf6rh\xe5llandevis s\xe4llan blir en mycket d\xe5lig ekonomisk aff\xe4r eftersom kostnaden f\xf6r varje k\xf6rd mil blir relativt sett h\xf6gre.`
        },
        {
            q: "Kan jag f\xe5 s\xe4nkt f\xf6rm\xe5nsskatt om jag k\xf6r mycket i tj\xe4nsten?",
            a: `Ja, om du k\xf6r \xf6ver 3 000 mil i tj\xe4nsten/\xe5r kan du f\xe5 din bilf\xf6rm\xe5n s\xe4nkt med 25%.
        <br /><br />
        Det \xe4r Skatteverket som beslutar om du ska f\xe5 nedsatt f\xf6rm\xe5nsv\xe4rde. Ans\xf6kan ska l\xe4mnas in varje \xe5r. Blanketten som ska anv\xe4ndas f\xf6r att ans\xf6ka om nedsatt f\xf6rm\xe5nsv\xe4rde heter <a href="https://www.skatteverket.se/foretagorganisationer/sjalvservice/blanketterbroschyrer/blanketter/info/4893.4.39f16f103821c58f680006780.html">SKV 4893</a>.
        `
        },
        {
            q: "M\xe5ste jag som arbetsgivare bokf\xf6ra en \u201Df\xf6rsta f\xf6rh\xf6jd hyra\u201D?",
            a: `Det vanligaste \xe4r att f\xf6retaget betalar en f\xf6rsta f\xf6rh\xf6jd hyra. Hur mycket som ska betalas \xe4r ofta val- eller f\xf6rhandlingsbart. F\xf6rdelen med att betala mer i b\xf6rjan \xe4r att hyran sedan blir l\xe4gre under de resterande m\xe5naderna. Bokf\xf6ringsm\xe4ssigt ska den f\xf6rsta f\xf6rh\xf6jda hyran sedan f\xf6rdelas \xf6ver hela leasingkontraktets l\xf6ptid.`
        },
        {
            q: "Vad \xe4r f\xf6rdelarna f\xf6r f\xf6retaget att leasa en bil ist\xe4llet f\xf6r att k\xf6pa den?",
            a: `Det st\xf6rsta f\xf6rdelarna \xe4r att halva momsen p\xe5 leasinghyran \xe4r avdragsgill, och att hela momsen p\xe5 \xf6vriga kostnader (d\xe4ck, service, reparation). Leasinghyran \xe4r dessutom avdragsgill mot f\xf6retagets resultat och kapital slipper bindas i bilen. De pengarna kan ist\xe4llet anv\xe4ndas i f\xf6retagets verksamhet.`
        },
        {
            q: "Tj\xe4nstebil eller f\xf6rm\xe5nsbil, vad \xe4r skillnaden?",
            a: `Tj\xe4nstebil \xe4r ett samlingsbegrepp f\xf6r alla bilar som erbjuds anst\xe4llda i jobbet. I dagligt tal anv\xe4nds tj\xe4nstebil lika ofta f\xf6r en bil som enbart f\xe5r k\xf6ras i jobbet som f\xf6r en bil som \xe4ven f\xe5r anv\xe4ndas privat. Det \xe4r dock viktigt att k\xe4nna till skillnaderna.
        <br /><br />
        En tj\xe4nstebil/servicebil \xe4r avsedd att enbart anv\xe4ndas i tj\xe4nsten, och den privata k\xf6rningen \xe4r d\xe5 begr\xe4nsad till max 10 mil vid h\xf6gst 10 tillf\xe4llen per \xe5r. Om du k\xf6r mer \xe4n s\xe5 kan du bli straffbeskattad. Skatteverket kan be dig bevisa att du bara anv\xe4nder bilen i jobbet. D\xe4rf\xf6r \xe4r det viktigt att f\xf6ra noggrann k\xf6rjournal.
        <br /><br />
        En tj\xe4nstebil/f\xf6rm\xe5nsbil f\xe5r \xe4ven anv\xe4ndas privat, men d\xe5 ska den anst\xe4llde betala f\xf6rm\xe5nsskatt. Hur h\xf6g skatten blir beror p\xe5 bilens f\xf6rm\xe5nsv\xe4rde, som Skatteverket best\xe4mmer \xe5rligen f\xf6r varje bilmodell. Tillval som dragkrok och ljudanl\xe4ggning h\xf6jer f\xf6rm\xe5nsv\xe4rdet. Vem som betalar br\xe4nslet \u{2013} du eller din arbetsgivare \u{2013} spelar ocks\xe5 in. Betalar f\xf6retaget br\xe4nsle r\xe4knas det som en l\xf6nef\xf6rm\xe5n och du f\xe5r betala skatt.
        `
        },
        {
            q: "Kan jag som \xe4r egenf\xf6retagare ha en tj\xe4nstebil utan att f\xf6rm\xe5nsbeskattas?",
            a: `Om din enskilda firma \xe4ger en personbil kan du undvika ett f\xf6rm\xe5nsv\xe4rde genom att endast k\xf6ra den privat h\xf6gst tio g\xe5nger per \xe5r och h\xf6gst hundra mil per \xe5r. K\xf6r du mer \xe4n s\xe5 \xe4r det inte ringa omfattning, och d\xe5 m\xe5ste du betala f\xf6rm\xe5nsv\xe4rde.
        <br /><br />
        Det \xe4r upp till dig som f\xf6retagare att kunna visa upp f\xf6r Skatteverket att du inte har anv\xe4nt bilen privat. Det g\xf6r du genom att f\xf6ra en k\xf6rjournal, d\xe4r du antecknar varje k\xf6rning. 
Detta \xe4r vad en k\xf6rjournal b\xf6r inneh\xe5lla: 
<br />
<ul>
<li>datum och m\xe4tarst\xe4llning vid resans start samt varifr\xe5n resan startade</li>
<li>\xe4rende samt vilka platser/f\xf6retag/kontaktpersoner du har bes\xf6kt (beh\xf6vs inte vid privata resor)</li>
<li>hur m\xe5nga kilometer du har k\xf6rt</li>
<li>datum och m\xe4tarst\xe4llning vid resans slut, samt var resan avslutades.</li>
<br /><br />
T\xe4nk p\xe5 att du ska f\xf6ra k\xf6rjournal l\xf6pande under hela \xe5ret, s\xe5 t\xe4nk p\xe5 att g\xf6ra en anteckning i k\xf6rjournalen f\xf6r m\xe4tarst\xe4llningen vid \xe5rets b\xf6rjan och slut.
        `
        },
        {
            q: "Vad h\xe4nder med min tj\xe4nstebil n\xe4r jag g\xe5r p\xe5 f\xf6r\xe4ldraledighet?",
            a: `Om du har en f\xf6rm\xe5nsbil s\xe5 kommer du att beskattas f\xf6r den \xe4ven om du \xe4r f\xf6r\xe4ldraledig. Men eftersom din arbetsgivare inte betalar ut n\xe5gon l\xf6n till dig under f\xf6r\xe4ldraledigheten finns det ingen ers\xe4ttning att g\xf6ra skatteavdrag ifr\xe5n. D\xe4rf\xf6r f\xe5r du betala skatt p\xe5 f\xf6rm\xe5nen i samband med deklarationen. Du kan l\xe4sa mer om vad som g\xe4ller p\xe5 skatteverket.se.`
        },
        {
            q: "Vad g\xe4ller n\xe4r jag anv\xe4nder min tj\xe4nstebil utomlands?",
            a: `Om du ska k\xf6ra din tj\xe4nstebil utomlands \xe4r det viktigt att du alltid f\xf6rvarar registreringsbeviset i bilen. Det kan ocks\xe5 vara bra att skriva ut en skadeanm\xe4lan och f\xf6rvara i bilen om n\xe5got skulle h\xe4nda. Se till att prata med din arbetsgivare om vad som g\xe4ller f\xf6r just dig och det f\xf6retag d\xe4r du \xe4r anst\xe4lld.`
        },
        {
            q: "Vad h\xe4nder om jag vill k\xf6pa min tj\xe4nstebil?",
            a: `Om du och det f\xf6retag som du jobbar p\xe5 kommer \xf6verens om att du ska k\xf6pa den tj\xe4nstebil som du har k\xf6rt m\xe5ste du betala minst ett marknadsm\xe4ssigt pris, annars kommer inte Skatteverket att godk\xe4nna transaktionen.`
        }
    ]
};

});


parcelRegister("eny4b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ce70eee2ec5b35d$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $9AwRV = parcelRequire("9AwRV");

var $jKEzv = parcelRequire("jKEzv");

var $6sz0l = parcelRequire("6sz0l");

var $4hFDS = parcelRequire("4hFDS");

var $8hzsK = parcelRequire("8hzsK");

var $22OL8 = parcelRequire("22OL8");

var $lsG22 = parcelRequire("lsG22");

var $kZPx9 = parcelRequire("kZPx9");

var $arp00 = parcelRequire("arp00");

var $3eb7t = parcelRequire("3eb7t");

var $2FCIq = parcelRequire("2FCIq");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $datmG = parcelRequire("datmG");
const $4ce70eee2ec5b35d$var$KiaEv5Campaign = ()=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("main", {
        className: "relative w-full",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $arp00.default), {
                ...(0, $datmG.heroEV5),
                className: "h-[85svh]"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $lsG22.default), {
                id: "ev-5-heading",
                className: "wrapper-kia-sm my-14",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                        variants: (0, $51Ucj.itemVariants),
                        className: "mb-2 text-center font-bold text-[32px] md:text-[40px] leading-[1.2]",
                        children: (0, $datmG.introEV5).heading
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                        variants: (0, $51Ucj.itemVariants),
                        className: "text-center font-semibold",
                        children: (0, $datmG.introEV5).headingSub
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                        variants: (0, $51Ucj.itemVariants),
                        className: "mt-8 text-center",
                        children: (0, $datmG.introEV5).text
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $lsG22.default), {
                id: "ev5-intro",
                className: "wrapper-kia-sm",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                        variants: (0, $51Ucj.itemVariants),
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                            ...(0, $datmG.introEV5).image,
                            className: `${(0, $datmG.introEV5).image.className || ''}`
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kZPx9.TextBox), {
                        iconOnTop: true,
                        centerText: true,
                        mtClass: "mt-8",
                        paddingClass: "p-0",
                        ...(0, $datmG.textBoxicon01)
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                        variants: (0, $51Ucj.itemVariants),
                        className: "flex justify-center my-14",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                            url: (0, $datmG.introEV5).link.url,
                            text: (0, $datmG.introEV5).link.text
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $arp00.default), {
                src: (0, $datmG.hero2EV5).src,
                controls: true,
                className: "aspect-video"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $lsG22.default), {
                id: "ev5-features",
                className: "wrapper-kia-md mx-auto my-10 lg:my-24",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $6sz0l.default), {
                    items: (0, $datmG.featuresEV5)
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $lsG22.default), {
                id: "ev5-content-blockss",
                className: "wrapper-kia-md mx-auto my-10 lg:my-24",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9AwRV.default), {
                    blocks: (0, $datmG.contentBlocksEV5),
                    firstBlockReversed: true
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $lsG22.default), {
                id: "ev5-hero-image",
                className: "my-10 lg:my-24",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4hFDS.default), {
                    slides: (0, $datmG.CarouselEV5)
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $lsG22.default), {
                id: "ev5-infobox",
                className: "wrapper-kia-md mx-auto my-14 lg:my-24",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                    variants: (0, $51Ucj.itemVariants),
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $22OL8.default), {
                        titleFontSize: "text-4xl",
                        ...(0, $datmG.infoBoxEV5)
                    })
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $lsG22.default), {
                id: "ev5-infocolumns",
                className: "wrapper-kia-lg mx-auto my-14 lg:my-24",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jKEzv.default), {
                    columns: (0, $datmG.infoColumnsEV5)
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $lsG22.default), {
                id: "ev5-greylist",
                className: "wrapper-kia-md mx-auto my-10 lg:my-24",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8hzsK.default), {
                    className: "[&_div:has(svg)]:self-center",
                    ...(0, $datmG.greyListEV5)
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $lsG22.default), {
                id: "ev5-infocolumns2",
                className: "wrapper-kia-lg mx-auto my-14 lg:my-24",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jKEzv.default), {
                    columns: (0, $datmG.infoColumns2EV5)
                })
            })
        ]
    });
};
var $4ce70eee2ec5b35d$export$2e2bcd8739ae039 = $4ce70eee2ec5b35d$var$KiaEv5Campaign;

});
parcelRegister("9AwRV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05f079d5ddc6075f$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $3eb7t = parcelRequire("3eb7t");

var $gGGAE = parcelRequire("gGGAE");

var $2FCIq = parcelRequire("2FCIq");
const $05f079d5ddc6075f$var$ContentBlock = ({ blocks: blocks, firstBlockReversed: firstBlockReversed })=>{
    if (!blocks || blocks.length < 1) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).ul, {
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        variants: (0, $51Ucj.containerVariants),
        className: "flex flex-col gap-14 md:gap-10 lg:gap-24",
        children: blocks.map((block, index)=>{
            const isOdd = firstBlockReversed ? (index + 1) % 2 === 0 : (index + 1) % 2 != 0;
            return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).li, {
                initial: "hidden",
                whileInView: "visible",
                viewport: (0, $51Ucj.viewPort),
                variants: (0, $51Ucj.containerVariants),
                className: `grid grid-cols-1 lg:grid-cols-2 lg:items-center gap-4 lg:gap-8`,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: `w-full ${isOdd ? 'order-1' : 'order-1 lg:order-2'}`,
                        children: block.image.src === 'placeholder' ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $gGGAE.default), {
                            className: "aspect-[3/2]"
                        }) : /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                            ...block.image,
                            className: `aspect-[3/2] object-cover ${block.image.className || ''}`
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: `flex flex-col gap-3 lg:gap-4 w-full px-4 lg:px-10 ${isOdd ? 'order-2' : 'order-2 lg:order-1'}`,
                        children: [
                            block.title ? /*#__PURE__*/ (0, $2PPWI.jsxs)("h2", {
                                className: "font-semibold antialiased",
                                children: [
                                    " ",
                                    block.title
                                ]
                            }) : null,
                            block.text ? /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: "font-light",
                                dangerouslySetInnerHTML: {
                                    __html: block.text
                                }
                            }) : null,
                            block.list ? /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                                className: "ml-4 grid gap-2",
                                children: block.list.map((item, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                        className: "list-disc",
                                        children: item
                                    }, index))
                            }) : null,
                            block.link.url ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                className: "mt-2",
                                url: block.link.url,
                                text: block.link.text
                            }) : null
                        ]
                    })
                ]
            }, index);
        })
    });
};
var $05f079d5ddc6075f$export$2e2bcd8739ae039 = $05f079d5ddc6075f$var$ContentBlock;

});
parcelRegister("gGGAE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f67329a2de9fb257$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
let $f67329a2de9fb257$var$placeholderCount = 0;
function $f67329a2de9fb257$export$2e2bcd8739ae039({ className: className }) {
    $f67329a2de9fb257$var$placeholderCount++;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: `bg-slate-200/50 grid place-content-center ${className || 'aspect-square border border-black'}`,
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
            children: [
                "Placeholder ",
                $f67329a2de9fb257$var$placeholderCount
            ]
        })
    });
}

});


parcelRegister("jKEzv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bc08676f604a22c$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $3eb7t = parcelRequire("3eb7t");

var $gGGAE = parcelRequire("gGGAE");

var $2FCIq = parcelRequire("2FCIq");
const $5bc08676f604a22c$var$gridColsMap = {
    1: 'lg:grid-cols-1',
    2: 'lg:grid-cols-2',
    3: 'lg:grid-cols-3',
    4: 'lg:grid-cols-4'
};
const $5bc08676f604a22c$var$ContentColumnsBlock = ({ columns: columns })=>{
    if (!columns || columns.length < 1) return null;
    const gridColsClass = $5bc08676f604a22c$var$gridColsMap[columns.length] || 'lg:grid-cols-3';
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).ul, {
        initial: "hidden",
        whileInView: "visible",
        viewport: {
            once: true,
            margin: '-100px'
        },
        variants: (0, $51Ucj.containerVariants),
        className: `grid grid-cols-1 ${gridColsClass} gap-14 md:gap-6 w-full`,
        children: columns.map((column, index)=>{
            return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).li, {
                variants: (0, $51Ucj.itemVariantsNoY),
                className: "flex flex-col gap-4 lg:gap-8",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "w-full",
                        children: column.image.src === 'placeholder' ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $gGGAE.default), {
                            className: "max-w-full max-h-full aspect-[4/3]"
                        }) : /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                            ...column.image,
                            className: `aspect-[4/3] object-cover ${column.image.className || ''}`
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: `flex flex-col gap-3 lg:gap-4 w-full h-full ${column.textContainerClasses || ''}`,
                        children: [
                            column.title ? /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                className: `font-semibold antialiased ${column.titleClasses || ''}`,
                                children: column.title
                            }) : null,
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: `${column.textClasses || ''}`,
                                dangerouslySetInnerHTML: {
                                    __html: column.text
                                }
                            }),
                            column.link.url ? /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                    className: "mt-4 mx-auto",
                                    url: column.link.url,
                                    text: column.link.text
                                })
                            }) : null
                        ]
                    })
                ]
            }, `${index}-${column.title || 'col'}`);
        })
    }, `${columns[0].text}`);
};
var $5bc08676f604a22c$export$2e2bcd8739ae039 = $5bc08676f604a22c$var$ContentColumnsBlock;

});

parcelRegister("6sz0l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98cb2e1ba9b3cfa1$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $8FY87 = parcelRequire("8FY87");

var $51Ucj = parcelRequire("51Ucj");

var $kZPx9 = parcelRequire("kZPx9");

var $bRf1s = parcelRequire("bRf1s");

var $96iav = parcelRequire("96iav");

var $2FCIq = parcelRequire("2FCIq");

var $kM2Bn = parcelRequire("kM2Bn");

var $b2c0V = parcelRequire("b2c0V");

var $3eb7t = parcelRequire("3eb7t");
'use client';
const $98cb2e1ba9b3cfa1$var$ContentMediaList = ({ items: items })=>{
    const [currentVideoPlaying, setCurrentVideoPlaying] = (0, $8FY87.useState)(null);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).ul, {
                initial: "hidden",
                whileInView: "visible",
                viewport: (0, $51Ucj.viewPort),
                variants: (0, $51Ucj.containerVariants),
                className: "grid lg:grid-cols-2 gap-y-14 lg:gap-y-12 gap-12",
                children: items.map((item, index)=>{
                    const hasMobileVideo = item.videoMobile && item.videoMobile.src || item.videoMobile && item.videoMobile.srcWebm;
                    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).li, {
                        "data-layout": item.layout,
                        viewport: (0, $51Ucj.viewPort),
                        variants: (0, $51Ucj.itemVariants),
                        className: "grid grid-cols-1 lg:grid-cols-2 gap-x-12 data-[layout='row']:lg:col-span-2 data-[layout='col']:lg:grid-cols-1 data-[layout='col']:lg:self-start group",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "flex w-full aspect-video relative ",
                                onClick: ()=>hasMobileVideo ? setCurrentVideoPlaying({
                                        video: item.video,
                                        videoMobile: item.videoMobile
                                    }) : setCurrentVideoPlaying({
                                        video: item.video
                                    }),
                                children: item.thumbnail ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $b2c0V.default), {
                                            className: "w-16 h-16 text-white absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                            className: "w-full h-full object-cover",
                                            src: item.thumbnail.src,
                                            alt: item.thumbnail.alt
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $b2c0V.default), {
                                            className: "w-16 h-16 text-white absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("video", {
                                            className: `w-full h-full object-cover ${item.videoMobile && (item.videoMobile.src || item.videoMobile.srcWebm) ? 'max-lg:hidden' : ''}`,
                                            muted: true,
                                            playsInline: true,
                                            preload: "metadata",
                                            children: [
                                                item.video.srcWebm && /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                                                    src: `${item.video.srcWebm}#t=0.001`,
                                                    type: "video/webm"
                                                }),
                                                /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                                                    src: `${item.video.src}#t=0.001`,
                                                    type: "video/mp4"
                                                })
                                            ]
                                        }),
                                        item.videoMobile && (item.videoMobile.src || item.videoMobile.srcWebm) ? /*#__PURE__*/ (0, $2PPWI.jsxs)("video", {
                                            className: "w-full h-full object-cover lg:hidden",
                                            muted: true,
                                            playsInline: true,
                                            preload: "metadata",
                                            children: [
                                                item.videoMobile.srcWebm && /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                                                    src: `${item.videoMobile.srcWebm}#t=0.001`,
                                                    type: "video/webm"
                                                }),
                                                /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                                                    src: `${item.videoMobile.src}#t=0.001`,
                                                    type: "video/mp4"
                                                })
                                            ]
                                        }) : null
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: "flex flex-col gap-1 lg:gap-4 mt-4 lg:mt-0 px-4 lg:px-0 group-data-[layout='col']:lg:pt-4 group-data-[layout='row']:lg:self-center",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        className: "text-[28px] lg:text-[36px] leading-[40px] font-semibold ",
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: "font-light",
                                        children: (0, $kZPx9.highlightText)(item.text, item.boldText)
                                    }),
                                    item.link ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                        url: item.link.url,
                                        text: item.link.text,
                                        className: "mt-4 lg:mt-2"
                                    }) : null
                                ]
                            })
                        ]
                    }, index);
                })
            }),
            currentVideoPlaying ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kM2Bn.default), {
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "flex justify-center items-center w-full h-full",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                            "aria-label": "Close window",
                            className: "absolute top-6 right-6 flex items-center justify-center w-10 h-10 hover:bg-black/10 opacity-60 hover:opacity-100 rounded-full transition-all z-10",
                            onClick: ()=>setCurrentVideoPlaying(null),
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $96iav.default), {
                                className: "w-6 h-6 text-white"
                            })
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bRf1s.VideoClip), {
                            controls: true,
                            autoplay: true,
                            cropMobile: false,
                            videoClasses: "w-full max-h-[90vh] lg:aspect-video h-full",
                            wrapperClasses: currentVideoPlaying.videoMobile ? 'max-lg:hidden' : '',
                            ...currentVideoPlaying.video
                        }),
                        currentVideoPlaying.videoMobile && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bRf1s.VideoClip), {
                            controls: true,
                            autoplay: true,
                            cropMobile: false,
                            videoClasses: "w-full h-full",
                            wrapperClasses: "lg:hidden",
                            ...currentVideoPlaying.videoMobile
                        })
                    ]
                })
            }) : null
        ]
    });
};
var $98cb2e1ba9b3cfa1$export$2e2bcd8739ae039 = $98cb2e1ba9b3cfa1$var$ContentMediaList;

});
parcelRegister("bRf1s", function(module, exports) {

$parcel$export(module.exports, "VideoClip", function () { return $546e3bf90431c492$export$549c3bd210462fa5; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $8FY87 = parcelRequire("8FY87");

var $51Ucj = parcelRequire("51Ucj");
const $546e3bf90431c492$export$549c3bd210462fa5 = ({ src: src, srcWebm: srcWebm, poster: poster, autoplay: autoplay = false, controls: controls = false, loop: loop = true, muted: muted = true, width: width = '100%', height: height = 'auto', title: title, subTitle: subTitle, titleClasses: titleClasses, titleLocation: titleLocation = 'center', cropMobile: cropMobile = true, customIcon: customIcon = null, videoClasses: videoClasses, wrapperClasses: wrapperClasses })=>{
    const videoRef = (0, $8FY87.useRef)(null);
    const [isPlaying, setIsPlaying] = (0, $8FY87.useState)(autoplay && muted);
    const handleOnClick = ()=>{
        if (!controls && !autoplay) setIsPlaying((prev)=>!prev);
    };
    (0, $8FY87.useEffect)(()=>{
        if (!videoRef.current) return;
        if (isPlaying) videoRef.current.play();
        else videoRef.current.pause();
    }, [
        isPlaying
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        variants: (0, $51Ucj.containerVariants),
        onClick: ()=>handleOnClick(),
        className: `relative overflow-hidden ${cropMobile ? 'max-sm:pt-[100%]' : 'w-full h-full'} ${wrapperClasses || ''}`,
        children: [
            !controls && !isPlaying ? /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "w-full h-full absolute flex justify-center items-center bg-black bg-opacity-20 z-30 top-0",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                    "aria-label": "Play video",
                    className: "cursor-pointer",
                    children: customIcon ? customIcon : /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                        viewBox: "0 0 512 512",
                        fill: "#fff",
                        height: "8em",
                        width: "8em",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                            d: "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-56 296V168l144 88z"
                        })
                    })
                })
            }) : null,
            /*#__PURE__*/ (0, $2PPWI.jsxs)("video", {
                ref: videoRef,
                poster: poster,
                autoPlay: autoplay,
                controls: controls,
                loop: loop,
                muted: muted,
                width: width,
                height: height,
                playsInline: true,
                className: `${videoClasses ? videoClasses : cropMobile ? 'max-sm:absolute min-h-screen max-sm:top-1/2 max-sm:left-1/2 max-sm:-translate-x-1/2 max-sm:-translate-y-1/2 max-sm:w-auto max-sm:max-w-none max-sm:h-full' : ''}`,
                children: [
                    srcWebm && /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                        src: `${srcWebm}#t=0.001`,
                        type: "video/webm"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                        src: `${src}#t=0.001`,
                        type: "video/mp4"
                    })
                ]
            }),
            title ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
                initial: "hidden",
                whileInView: "visible",
                variants: (0, $51Ucj.containerVariants),
                viewport: (0, $51Ucj.viewPort),
                className: `absolute p-2 text-center text-white ${titleLocation === 'bottom-left' ? 'left-24 bottom-20' : 'grid gap-4 w-full left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2'}`,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h1, {
                        className: `${titleClasses || ''}`,
                        variants: (0, $51Ucj.itemVariants),
                        children: title
                    }),
                    subTitle ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                        variants: (0, $51Ucj.itemVariants),
                        className: "text-xl sm:text-2xl",
                        children: subTitle
                    }) : null
                ]
            }) : null
        ]
    });
};

});

parcelRegister("96iav", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9be1775c63344e2$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
const $b9be1775c63344e2$var$CloseIcon = (props)=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        fill: "currentColor",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
            d: "M10.586 12 2.793 4.207l1.414-1.414L12 10.586l7.793-7.793 1.414 1.414L13.414 12l7.793 7.793-1.414 1.414L12 13.414l-7.793 7.793-1.414-1.414z"
        })
    });
};
var $b9be1775c63344e2$export$2e2bcd8739ae039 = $b9be1775c63344e2$var$CloseIcon;

});

parcelRegister("b2c0V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42062787a787cd36$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
const $42062787a787cd36$var$PlayVideoIcon = (props)=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        width: 36,
        height: 36,
        viewBox: "0 0 36 36",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
            fill: "currentColor",
            d: "M32.16 16.08 8.94 4.47A2.07 2.07 0 0 0 6 6.32v23.21a2.06 2.06 0 0 0 3 1.85l23.16-11.61a2.07 2.07 0 0 0 0-3.7Z"
        })
    });
};
var $42062787a787cd36$export$2e2bcd8739ae039 = $42062787a787cd36$var$PlayVideoIcon;

});


parcelRegister("4hFDS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2df08ef0b8ca564$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $6B8Ld = parcelRequire("6B8Ld");

var $4Qpe2 = parcelRequire("4Qpe2");

var $8FY87 = parcelRequire("8FY87");

var $51Ucj = parcelRequire("51Ucj");

var $3eb7t = parcelRequire("3eb7t");
function $e2df08ef0b8ca564$var$KiaHeroSlider({ slides: slides }) {
    const [emblaRef, emblaApi] = (0, $6B8Ld.default)({
        loop: true
    });
    const [selectedIndex, setSelectedIndex] = (0, $8FY87.useState)(0);
    const [scrollSnaps, setScrollSnaps] = (0, $8FY87.useState)([]);
    const onInit = (0, $8FY87.useCallback)((emblaApi)=>{
        setScrollSnaps(emblaApi.scrollSnapList());
    }, []);
    const onSelect = (0, $8FY87.useCallback)((api)=>{
        setSelectedIndex(api.selectedScrollSnap());
    }, []);
    (0, $8FY87.useEffect)(()=>{
        if (!emblaApi) return;
        onInit(emblaApi);
        onSelect(emblaApi);
        emblaApi.on('reInit', onInit).on('reInit', onSelect).on('select', onSelect);
        return ()=>{
            emblaApi.off('reInit', onInit).off('reInit', onSelect).off('select', onSelect);
        };
    }, [
        emblaApi,
        onInit,
        onSelect
    ]);
    const scrollPrev = (0, $8FY87.useCallback)(()=>{
        if (emblaApi) emblaApi.scrollPrev();
    }, [
        emblaApi
    ]);
    const scrollNext = (0, $8FY87.useCallback)(()=>{
        if (emblaApi) emblaApi.scrollNext();
    }, [
        emblaApi
    ]);
    const scrollTo = (0, $8FY87.useCallback)((index)=>{
        if (emblaApi) emblaApi.scrollTo(index);
    }, [
        emblaApi
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        variants: (0, $51Ucj.containerVariants),
        className: "relative group overflow-hidden aspect-[478/319] max-w-screen-kia-lg mx-auto",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "overflow-hidden",
                ref: emblaRef,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: "flex touch-pan-y will-change-transform",
                    children: slides.map((slide, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: "relative flex-[0_0_100%]",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                loading: "eager",
                                src: slide.image.src,
                                alt: slide.image.alt,
                                className: "w-full object-contain"
                            })
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                onClick: scrollPrev,
                className: "absolute left-4 top-1/2 -translate-y-1/2 z-20 p-2 bg-kia-grey/50 size-10 lg:size-12 grid place-content-center rounded-full hover:bg-kia-grey lg:opacity-0 lg:group-hover:opacity-100 transition-all",
                "aria-label": "F\xf6reg\xe5ende slide",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        className: "sr-only",
                        children: "F\xf6reg\xe5ende slide"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                        className: "rotate-180",
                        width: "37",
                        height: "37",
                        viewBox: "0 0 37 37",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                            d: "M17 23L21.5 18.5L17 14",
                            stroke: "#000",
                            strokeWidth: "1.5"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                onClick: scrollNext,
                className: "absolute right-4 top-1/2 -translate-y-1/2 z-20 p-2 bg-kia-grey/50 size-10 lg:size-12 grid place-content-center rounded-full  hover:bg-kia-grey lg:opacity-0 lg:group-hover:opacity-100 transition-all",
                "aria-label": "N\xe4sta slide",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        className: "sr-only",
                        children: "N\xe4sta slide"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                        width: "37",
                        height: "37",
                        viewBox: "0 0 37 37",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                            d: "M17 23L21.5 18.5L17 14",
                            stroke: "#000",
                            strokeWidth: "1.5"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "absolute bottom-4 lg:bottom-10 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2 lg:gap-4",
                children: scrollSnaps.map((_, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                        onClick: ()=>scrollTo(index),
                        className: `relative h-1 overflow-hidden transition-all duration-300 ${index === selectedIndex ? 'w-8 md:w-16 bg-kia-grey' : 'w-4 md:w-8 bg-gray-500/50 hover:bg-gray-400'}`,
                        "aria-label": `G\xe5 till slide ${index + 1}`
                    }, index))
            })
        ]
    });
}
var $e2df08ef0b8ca564$export$2e2bcd8739ae039 = $e2df08ef0b8ca564$var$KiaHeroSlider;

});

parcelRegister("8hzsK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2ab20ea300ebbce$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $a2EmR = parcelRequire("a2EmR");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");
const $d2ab20ea300ebbce$var$GreyListbox = ({ title: title, underTitle: underTitle, items: items, backgroundColor: backgroundColor = 'bg-gray-100', className: className = '' })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).section, {
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        variants: (0, $51Ucj.containerVariants),
        className: `${backgroundColor} ${className} p-4`,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                variants: (0, $51Ucj.itemVariants),
                className: "font-semibold text-lg mb-0",
                children: title
            }),
            underTitle && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                variants: (0, $51Ucj.itemVariants),
                className: "mb-4",
                children: underTitle
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "ml-5",
                children: items.map((item, idx)=>/*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
                        variants: (0, $51Ucj.itemVariants),
                        className: "flex items-baseline mb-2",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "relative flex-shrink-0",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a2EmR.CheckIcon), {
                                    width: 24,
                                    height: 24,
                                    color: "black",
                                    strokeWidth: 3
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: "ml-2",
                                children: item.text
                            })
                        ]
                    }, idx))
            })
        ]
    });
};
var $d2ab20ea300ebbce$export$2e2bcd8739ae039 = $d2ab20ea300ebbce$var$GreyListbox;

});

parcelRegister("22OL8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65b14c4017121890$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $3eb7t = parcelRequire("3eb7t");

var $2FCIq = parcelRequire("2FCIq");
const $65b14c4017121890$var$InfoBoxImgTextLinks = ({ title: title, image: image, text: text, links: links, gap: gap = '16', titleFontSize: titleFontSize = 'text-[30px] md:text-[40px] leading-[48px]', textFontSize: textFontSize = 'text-[12px] md:text-lg', headingPosition: headingPosition = 'above' })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).section, {
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        variants: (0, $51Ucj.containerVariants),
        className: "flex flex-col items-center text-center mx-auto px-0 py-0",
        children: [
            headingPosition === 'above' && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                variants: (0, $51Ucj.itemVariants),
                className: `${titleFontSize} font-medium mb-10`,
                children: title
            }),
            image && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                variants: (0, $51Ucj.itemVariants),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                    ...image,
                    className: `mb-6 ${image.className || ''}`
                })
            }),
            headingPosition === 'below' && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                variants: (0, $51Ucj.itemVariants),
                className: `${titleFontSize} font-medium`,
                children: title
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                variants: (0, $51Ucj.itemVariants),
                className: `${textFontSize} p-4 mb-6 font-light`,
                children: text
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                variants: (0, $51Ucj.itemVariants),
                className: `flex flex-wrap justify-center gap-8 md:gap-${gap}`,
                children: links.map((link, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                        variants: (0, $51Ucj.itemVariants),
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                            ...link
                        })
                    }, index))
            })
        ]
    });
};
var $65b14c4017121890$export$2e2bcd8739ae039 = $65b14c4017121890$var$InfoBoxImgTextLinks;

});

parcelRegister("arp00", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81644e1e40c91329$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");
function $81644e1e40c91329$var$VideoHero({ src: src, srcWebm: srcWebm, mobileSrc: mobileSrc, title: title, subTitle: subTitle, children: children, className: className, ...props }) {
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).section, {
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        variants: (0, $51Ucj.containerVariants),
        className: "grid *:col-start-1 *:row-start-1",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("video", {
                autoPlay: true,
                muted: true,
                playsInline: true,
                controls: props.controls || false,
                loop: true,
                className: `w-full lg:max-h-[900px] object-cover ${className}`,
                ...props,
                children: [
                    srcWebm && /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                        src: `${srcWebm}#t=0.001`,
                        type: "video/webm"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                        src: `${mobileSrc}#t=0.001`,
                        type: "video/mp4",
                        media: "(max-width:768px)"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                        src: `${src}#t=0.001`,
                        type: "video/mp4"
                    })
                ]
            }),
            title ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
                className: "mt-9 lg:mt-0 lg:place-self-center text-center text-white px-4 z-10",
                initial: "hidden",
                whileInView: "visible",
                variants: (0, $51Ucj.containerVariants),
                viewport: (0, $51Ucj.viewPort),
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h1, {
                        className: "text-[clamp(35px,_4vw,_72px)] mb-2",
                        variants: (0, $51Ucj.itemVariants),
                        children: title
                    }),
                    subTitle ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                        variants: (0, $51Ucj.itemVariants),
                        className: "text-xl sm:text-2xl font-thin",
                        children: subTitle
                    }) : null
                ]
            }) : null,
            children
        ]
    });
}
var $81644e1e40c91329$export$2e2bcd8739ae039 = $81644e1e40c91329$var$VideoHero;

});

parcelRegister("datmG", function(module, exports) {

$parcel$export(module.exports, "heroEV5", function () { return $b99e287077d50ed8$export$49a8e3d5110cf3f3; });
$parcel$export(module.exports, "introEV5", function () { return $b99e287077d50ed8$export$c9014c27f405aa3c; });
$parcel$export(module.exports, "textBoxicon01", function () { return $b99e287077d50ed8$export$42c2e441a1a0fc02; });
$parcel$export(module.exports, "featuresEV5", function () { return $b99e287077d50ed8$export$4a4139900deb916e; });
$parcel$export(module.exports, "hero2EV5", function () { return $b99e287077d50ed8$export$8a377f6ae957839b; });
$parcel$export(module.exports, "CarouselEV5", function () { return $b99e287077d50ed8$export$fd091bab1bbe3859; });
$parcel$export(module.exports, "contentBlocksEV5", function () { return $b99e287077d50ed8$export$c115f8b97b2f30a; });
$parcel$export(module.exports, "infoBoxEV5", function () { return $b99e287077d50ed8$export$83d1f506e30f4d6b; });
$parcel$export(module.exports, "infoColumnsEV5", function () { return $b99e287077d50ed8$export$3cba7d38b7b41e9e; });
$parcel$export(module.exports, "greyListEV5", function () { return $b99e287077d50ed8$export$e4033a5a32765150; });
$parcel$export(module.exports, "infoColumns2EV5", function () { return $b99e287077d50ed8$export$b68904de1089a39f; });
const $b99e287077d50ed8$export$49a8e3d5110cf3f3 = {
    title: "Kia EV5. Med Pausl\xe4ge.",
    subTitle: "Friheten v\xe4ntar.",
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/Clean%20EV5_topp_kia-com.mp4',
    mobileSrc: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/videos/CLEAN_OLV_10s_EV5_hero_feb_GENERELL_9_16_reel_MASTER_V1_260120.mp4',
    srcWebm: ''
};
const $b99e287077d50ed8$export$c9014c27f405aa3c = {
    heading: "Kia EV5. Friheten v\xe4ntar.",
    headingSub: "Rek. ca pris fr\xe5n 553 900kr.",
    text: "Uppt\xe4ck Kia EV5 \u2014 en helt ny el-SUV som kombinerar innovativ teknik med imponerande utrymmen och f\xf6rstklassig komfort. Med det smarta pausl\xe4get h\xe5ller bilen r\xe4tt temperatur hela natten \u2014 perfekt f\xf6r \xe4ventyret p\xe5 fj\xe4llet eller en spontan \xf6vernattning var du \xe4n \xe4r.\xa0V\xe4lkommen in och upplev Kia EV5.",
    image: {
        src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-890x240px-x2.jpg',
        alt: "En silverf\xe4rgad Kia EV5 med takbox parkerad i ett storslaget, sn\xf6t\xe4ckt fj\xe4llandskap. Bredvid bilen sitter en person och en hund vid en snowboard och blickar ut \xf6ver de vintriga bergen i solnedg\xe5ngen.",
        sizes: '(max-width: 768px) 100vw, 50vw',
        className: 'w-full min-h-[200px] object-cover'
    },
    link: {
        url: 'https://www.kia.com/se/nya-bilar/ev5/upptack/',
        text: "L\xe4s mer om Kia EV5"
    }
};
const $b99e287077d50ed8$export$42c2e441a1a0fc02 = {
    title: '',
    backgroundColor: '',
    numberOfFields: 3,
    titleStyle: 'mb-6 text-[32px] max-w-[627px]',
    textSize: 'text-center leading-[24px] text-[16px] md:text[18px] font-light md:font-normal',
    listItems: [
        {
            subtitle: 'Klassledande utrymme och komfort',
            text: 'Stort bagageutrymme, relaxationstolar fram och gott om benutrymme bak.',
            boldParts: [
                ''
            ],
            iconProps: {
                color: '#000',
                width: 24,
                height: 24,
                strokeWidth: 5
            }
        },
        {
            subtitle: 'Modern teknik',
            text: "Aktivera pausl\xe4get och anv\xe4nd allt fr\xe5n Vehicle-to-Load, infotainment och klimatanl\xe4ggning n\xe4r bilen st\xe5r parkerad.",
            boldParts: [
                ''
            ],
            iconProps: {
                color: '#000',
                width: 24,
                height: 24,
                strokeWidth: 5
            }
        },
        {
            subtitle: "Tryggt och s\xe4kert",
            text: "De senaste f\xf6rarassistanssystemen, inklusive autobromsfunktioner, adaptiv farth\xe5llare och parkeringsassistans.",
            boldParts: [
                ''
            ],
            iconProps: {
                color: '#000',
                width: 24,
                height: 24,
                strokeWidth: 5
            }
        }
    ]
};
const $b99e287077d50ed8$export$4a4139900deb916e = [
    {
        title: "Bilen som basl\xe4ger.",
        layout: 'row',
        text: "Tack vare pausl\xe4get kan du anv\xe4nda Kia EV5 i stillast\xe5ende l\xe4ge. I pausl\xe4get anv\xe4nder bilen h\xf6gvoltsbatteriet f\xf6r att h\xe5lla funktioner i g\xe5ng. Bilen kan inte k\xf6ras men alla elektriska enheter kan anv\xe4ndas, som klimatanl\xe4ggning, infotainmentsystem, USB-uttag, innerbelysning, fram- och bakljus och Vehicle-to-Load (V2L). Under filminspelningen i Storulv\xe5n anv\xe4ndes stillast\xe5ende l\xe4ge i 8 timmar i minus 10 grader och d\xe5 anv\xe4ndes 6% av h\xf6gvoltsbatteriet. (Siffran \xe4r bara en indikation vid detta tillf\xe4lle. Faktisk f\xf6rbrukning beror bl.a. p\xe5 yttertemperaturen.)",
        video: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/videos/Kia%20EV5%20A%CC%8Are%2060s%2016x9.mp4'
        },
        videoMobile: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/videos/Kia_EV5_A%CC%8Are_60s_9X16_CLEAN.mp4'
        },
        thumbnail: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5_baslager_1400.png',
            alt: "En person p\xe5 turstegel skidar uppf\xf6r en sn\xf6t\xe4ckt fj\xe4llsida tillsammans med en hund i ett gyllene kv\xe4llsljus."
        }
    },
    {
        title: "Plats f\xf6r \xe4ventyr.",
        layout: 'col',
        text: "Med h\xf6g komfort och stora utrymmen \xe4r Kia EV5 ett perfekt val f\xf6r alla resor, oavsett l\xe4ngd. Njut av relaxationstolar fram, klassledande benutrymme bak och m\xf6jlighet att f\xe4lla den bakre s\xe4tesraden helt plant f\xf6r att ge plats \xe5t mer packning eller en madrass att sova p\xe5.",
        video: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/videos/Kia%20EV5%20A%CC%8Are%20A%CC%88ventyret%2016X9.mp4'
        },
        videoMobile: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/videos/Kia_EV5_A%CC%8Are_A%CC%88ventyret_9X16_CLEAN.mp4'
        },
        thumbnail: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/Kia_EV5_swe_dec_2025__CJ__MG_8713_v2_1200.jpg',
            alt: "Mysig st\xe4mning med en hund som vilar p\xe5 ett mjukt t\xe4cke i bagageutrymmet p\xe5 en Kia EV5 under en bilutflykt eller campingtur i vintermilj\xf6."
        }
    },
    {
        title: "Med hj\xe4rtat i J\xe4mtland.",
        layout: 'col',
        text: '\u201CJ\xe4mtland \xe4r min lekplats och bakg\xe5rden d\xe4r jag v\xe4xte upp. Men \xe4nd\xe5 hann jag utforska resten av v\xe4rlden innan jag p\xe5 allvar uppt\xe4ckte J\xe4mtland. Den svenska fj\xe4llv\xe4rlden kr\xe4ver ganska mycket av \xe5karna, det \xe4r tjorvigt och stundtals otillg\xe4ngligt \u2014 men kan som ingen annanstans ge mig aha-upplevelser och storslagna \xf6gonblick" Tom-Oliver Hedvall',
        boldText: [
            'Tom-Oliver Hedvall'
        ],
        link: {
            url: 'https://story.kia.se/tom-oliver-hedvall-med-hjartat-i-jamtland',
            text: "L\xe4s mer om Tom-Oliver Hedvall "
        },
        thumbnail: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_6725.jpg',
            alt: "En person och en hund sitter bredvid en silverf\xe4rgad Kia EV5 med snowboard och ett vintrigt fj\xe4ll i bakgrunden."
        },
        video: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/videos/Kia%20EV5%20x%20Tom-Oliver%20Hedvall.%20Livet%20med%20bilen.mp4'
        },
        videoMobile: {
            src: ''
        }
    }
];
const $b99e287077d50ed8$export$8a377f6ae957839b = {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/videos/kia-ev5-directors-cut.mp4'
};
const $b99e287077d50ed8$export$fd091bab1bbe3859 = [
    {
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_6725.jpg',
            alt: "En person och en hund sitter bredvid en silverf\xe4rgad Kia EV5 med snowboard och ett vintrigt fj\xe4ll i bakgrunden."
        }
    },
    {
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_7062.jpg',
            alt: "N\xe4rbild i profil p\xe5 en person och en engelsk setter som blickar ut \xf6ver ett sn\xf6t\xe4ckt landskap."
        }
    },
    {
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_7311.jpg',
            alt: "En person och en hund sover tillsammans i det b\xe4ddade bagageutrymmet p\xe5 en Kia EV5, upplyst av en lykta."
        }
    },
    {
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_7696.jpg',
            alt: "Vy uppifr\xe5n genom bilens panoramatak som visar en person och en hund som vilar i det varma skenet inuti kup\xe9n."
        }
    },
    {
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_8367.jpg',
            alt: "En person f\xf6rbereder s\xe4ngplatsen i bakluckan p\xe5 en Kia EV5 under en vintercamping."
        }
    },
    {
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_8398.jpg',
            alt: "En person t\xe4nder en fotogenlykta i baks\xe4tet p\xe5 en Kia EV5 f\xf6r att skapa en mysig st\xe4mning inf\xf6r natten."
        }
    },
    {
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_8673.jpg',
            alt: "N\xe4rbild p\xe5 en person som anv\xe4nder ett v\xe5ffelj\xe4rn i bagageutrymmet p\xe5 en Kia EV5, med hunden vilande i bakgrunden."
        }
    },
    {
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_8713_v2.jpg',
            alt: "En engelsk setter vilar p\xe5 ett mjukt t\xe4cke i det \xf6ppna bagageutrymmet p\xe5 en Kia EV5 i vintermilj\xf6."
        }
    },
    {
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_8785.jpg',
            alt: "En person sitter i bakluckan p\xe5 en Kia EV5 och \xe4ter en sm\xf6rg\xe5s tillsammans med sin hund i ett sn\xf6igt landskap."
        }
    },
    {
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/_MG_9044.jpg',
            alt: "En person och en hund ligger nedb\xe4ddade i bakluckan p\xe5 en Kia EV5 och tittar ut genom rutan mot vinterkv\xe4llen."
        }
    },
    {
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/KIA_EV5_FRONT_FINAL_CAR.jpg?v=2',
            alt: " En silverf\xe4rgad Kia EV5 parkerad framf\xf6r ett sn\xf6t\xe4ckt fj\xe4ll under en klarbl\xe5 vinterhimmel."
        }
    },
    {
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/KIA_EV5_REAR_FINAL_TAKBOX%2BTOM.jpg?v=2',
            alt: "En person och en hund st\xe5r bredvid en Kia EV5 utrustad med takbox och snowboard i ett vidstr\xe4ckt fj\xe4llandskap."
        }
    },
    {
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/carousel/KIA_EV5_SIDE_DAY_FINAL_TAKBOX%2BTOM.jpg?v=2',
            alt: "Kia EV5 med takbox parkerad p\xe5 en isig v\xe4g i fj\xe4llen med en person, en hund och en snowboard i f\xf6rgrunden."
        }
    }
];
const $b99e287077d50ed8$export$c115f8b97b2f30a = [
    {
        title: "Snabbladdning och utrustningsniv\xe5er.",
        text: "Kia EV5 kommer med en r\xe4ckvidd p\xe5 upp till 530 km. Tack vare 400V-tekniken och m\xf6jlighet att f\xf6rv\xe4rma h\xf6gvoltsbatteriet p\xe5 81,4 kWh kan bilen snabbladdas 10\u201380 % p\xe5 ner till 30 minuter. Kia EV5 erbjuds i tre utrustningsniv\xe5er: Kia EV5, Kia EV5 Plus och Kia EV5 GT Line, de tv\xe5 senare kan f\xe5s med fyrhjulsdrift (AWD).",
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-2-590x400-x2.jpg',
            alt: "En person och en hund sitter tillsammans i den \xf6ppna bakluckan p\xe5 en Kia EV5 och blickar ut \xf6ver ett vidstr\xe4ckt, vintrigt fj\xe4llandskap under en paus p\xe5 bilresan.",
            sizes: '(max-width: 768px) 100vw, 50vw',
            className: ''
        },
        link: {
            url: 'https://www.kia.com/se/nya-bilar/ev5/upptack/#charging-range',
            text: "L\xe4s mer om laddning"
        }
    },
    {
        title: "S\xe5 aktiverar du pausl\xe4get.",
        list: [
            'Tryck p\xe5 "elfordon\u201D p\xe5 hemsk\xe4rmen (syns inte denna knapp vid kartan/mediaspelaren p\xe5 hemsk\xe4rmen, svajpa \xe5t v\xe4nster).',
            "Tryck p\xe5 EV-inst\xe4llningar (det lilla kugghjulet nere till h\xf6ger).",
            "V\xe4lj \u201DStillast\xe5ende l\xe4ge\u201D."
        ],
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-2-590x400-x3.jpg',
            alt: "En person och en hund sitter inne i en bil p\xe5 kv\xe4llen framf\xf6r en t\xe4nd laptopsk\xe4rm med vintermilj\xf6 i bakgrunden.",
            sizes: '(max-width: 768px) 100vw, 50vw',
            className: ''
        },
        link: {
            url: 'https://story.kia.se/pauslage-i-kia-ev5-anvand-bilen-nar-den-star-still',
            text: "L\xe4s mer om hur pausl\xe4get fungerar"
        }
    },
    {
        title: 'Pet mode: nu i Kia EV5.',
        text: "Med Pet mode i Kia EV5 blir det enklare att ta med dina fyrfota v\xe4nner i bilen. L\xe4mna ditt djur i bilen med l\xe5sta d\xf6rrar och klimatanl\xe4ggningen p\xe5 i \xf6nskad temperatur. Infotainmentsystemet visar f\xf6rbipasserande att djuret har det bra. Som en extra garant kan \xe4ven du f\xf6lja bilens temperatur direkt i telefonen, via Kia App.",
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-interior.jpg',
            alt: 'Interi\xf6ren i en Kia EV5 d\xe4r den digitala instrumentpanelen visar "Husdjursl\xe4ge" aktiverat. P\xe5 sk\xe4rmen syns en s\xf6t animation och texten "Jag v\xe4ntar p\xe5 min husse/matte" samt en inst\xe4lld temperatur p\xe5 20 grader, med ett sn\xf6igt landskap utanf\xf6r vindrutan.',
            sizes: '(max-width: 768px) 100vw, 50vw',
            className: ''
        },
        link: {
            url: 'https://story.kia.se/husdjurslage-och-3-andra-tips-till-dig-med-djur-i-bil',
            text: "L\xe4s mer om Pet mode"
        }
    },
    {
        title: 'Kia EV5 Business Edition.',
        text: "Med Kia Business Edition f\xe5r du Kia EV5 i fullutrustat GT Line-utf\xf6rande, till attraktivt f\xf6rm\xe5nsv\xe4rde. Uppt\xe4ck alla f\xf6rdelar med Kia Business Edition.<br><br>Rek. ca pris fr\xe5n 569 900 kr.<br>F\xf6rm\xe5nsv\xe4rde fr\xe5n 2 604 kr/m\xe5n.",
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-2-590x400-x4.jpg',
            alt: "N\xe4rbild p\xe5 den karakteristiska LED-str\xe5lkastaren och fronten p\xe5 en silverf\xe4rgad Kia EV5, med ett suddigt vintrigt fj\xe4llandskap i bakgrunden som framh\xe4ver bilens moderna desi",
            sizes: '(max-width: 768px) 100vw, 50vw',
            className: ''
        },
        link: {
            url: 'https://www.kia.com/se/tjanstebil/business-edition/',
            text: "L\xe4s mer om Kia Business Edition"
        }
    }
];
const $b99e287077d50ed8$export$2d7060329fc95880 = {
    image: {
        src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-Hero2.jpg',
        alt: 'KIA Car',
        sizes: '(max-width: 768px) 100vw, 50vw',
        className: ''
    }
};
const $b99e287077d50ed8$export$83d1f506e30f4d6b = {
    title: 'Enkel finansiering.',
    text: "Att k\xf6pa och finansiera sin bil ska vara enkelt, f\xf6rm\xe5nligt och tryggt. D\xe4rf\xf6r erbjuder vi flexibla och skr\xe4ddarsydda finansl\xf6sningar som kan g\xf6ra ditt bil\xe4gande \xe4nnu smidigare.",
    links: [
        {
            text: "Hitta n\xe4rmaste \xe5terf\xf6rs\xe4ljare",
            url: 'https://www.kia.com/se/sok-aterforsaljare-verkstad/#/',
            className: 'border-2 border-black',
            openInNewTab: true,
            textColor: 'black',
            bgColor: 'white'
        },
        {
            text: 'Prislista',
            url: 'https://www.kia.com/se/kopa/prislista/',
            className: 'w-[298px]',
            openInNewTab: true
        }
    ]
};
const $b99e287077d50ed8$export$3cba7d38b7b41e9e = [
    // {
    //   title: 'Finansiera din tjänstebil',
    //   text: 'Kia Business Lease är en helhetslösning som innebär ett garanterat restvärde. Med Kia Finansiell leasing väljer du själv till de tjänster du behöver.',
    //   titleClasses: 'font-medium text-2xl',
    //   textClasses: 'font-light',
    //   textContainerClasses: 'text-center',
    //   image: {
    //     src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-300x400-1.jpg',
    //     alt: 'KIA Elbilar',
    //     sizes: '(max-width: 768px) 100vw, 50vw',
    //   },
    //   link: {
    //     text: 'Våra finansieringslösningar',
    //     url: 'https://www.kia.com/se/tjanstebil/foretagsleasing/',
    //     openInNewTab: false,
    //   },
    // },
    {
        title: "Kia som tj\xe4nstebil.",
        text: "Med en Kia som tj\xe4nstebil f\xe5r du innovativ teknik, uppkopplade tj\xe4nster, h\xf6g komfort och de senaste s\xe4kerhetssystemen. Alltid med flexibla finansieringsl\xf6sningar.",
        titleClasses: 'font-medium text-2xl',
        textClasses: 'font-light',
        textContainerClasses: 'text-center',
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/KIA_EV5_SIDE_kamp_tjanstebil_1200.jpg',
            alt: "En silverf\xe4rgad Kia EV5 sedd snett bakifr\xe5n, parkerad p\xe5 en isig v\xe4g i ett dramatiskt fj\xe4llandskap. Bilen \xe4r utrustad med en takbox och dess karakteristiska bakljus \xe4r t\xe4nda mot de sn\xf6kl\xe4dda bergen i bakgrunden.",
            sizes: '(max-width: 768px) 100vw, 50vw'
        },
        link: {
            text: "L\xe4s mer om Kia som tj\xe4nstebil",
            url: 'https://www.kia.com/se/tjanstebil/',
            openInNewTab: false
        }
    },
    {
        title: "R\xe4kna p\xe5 din n\xe4sta tj\xe4nstebil.",
        text: "I v\xe5r tj\xe4nstebilskalkylator kan du j\xe4mf\xf6ra v\xe5ra laddbara modeller och r\xe4kna p\xe5 vad din n\xe4sta tj\xe4nstebil fr\xe5n Kia kommer att kosta.",
        titleClasses: 'font-medium text-2xl',
        textClasses: 'font-light',
        textContainerClasses: 'text-center',
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/KIA_EV5_REAR_kalkylator.jpg',
            alt: "En silverf\xe4rgad Kia EV5 parkerad p\xe5 en vidstr\xe4ckt, isbelagd yta i ett sn\xf6kl\xe4tt fj\xe4llandskap under en bl\xe5 skymningshimmel.",
            sizes: '(max-width: 768px) 100vw, 50vw'
        },
        link: {
            text: "R\xe4kna p\xe5 din n\xe4sta tj\xe4nstebil",
            url: 'https://www.kia.com/se/tjanstebil/kalkyl-laddhybrid/',
            openInNewTab: false
        }
    }
];
const $b99e287077d50ed8$export$e4033a5a32765150 = {
    title: 'Alltid i en Kia.',
    underTitle: "F\xf6ljande ing\xe5r som standard i alla nya personbilar fr\xe5n Kia:\xa0",
    items: [
        {
            text: "Rattv\xe4rme"
        },
        {
            text: 'Backkamera'
        },
        {
            text: 'Metallic/pearl-lack'
        },
        {
            text: "V\xe4rmepump och f\xf6rv\xe4rmning av batteri och kup\xe9 (i elbilar)"
        },
        {
            text: "Kia Assistans i samband med Kia Originalservice\xb9\u2074"
        },
        {
            text: "7 \xe5rs nybilsgaranti fr\xe5n fabrik\xb9\xb9"
        },
        {
            text: "7 \xe5rs app-styrning (Kia App\xb9\xb3)"
        },
        {
            text: "7 \xe5rs garanti p\xe5 Kia Original vinterhjul (tillval)"
        },
        {
            text: "7 \xe5rs uppkopplad navigation med live-tj\xe4nster (Kia Live)"
        }
    ]
};
const $b99e287077d50ed8$export$b68904de1089a39f = [
    {
        title: 'Bilmodeller.',
        text: "Uppt\xe4ck v\xe5rt breda modellprogram med laddbara bilar som passar alla.",
        titleClasses: 'font-medium text-2xl',
        textClasses: 'font-light',
        textContainerClasses: 'text-center',
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/Kia_Fullrange_Final_4x3.jpg',
            alt: 'KIA Elbilar',
            sizes: '(max-width: 768px) 100vw, 50vw'
        },
        link: {
            text: "L\xe4s mer om v\xe5ra bilmodeller",
            url: 'https://www.kia.com/se/nya-bilar/bilmodeller/',
            openInNewTab: false
        }
    },
    {
        title: "Uppkopplade tj\xe4nster.",
        text: "I Kia App kan du hantera allt som r\xf6r din bil - fr\xe5n att ruttplanera resor och fj\xe4rrstyra funktioner, till att boka service och hitta laddstationer. ",
        titleClasses: 'font-medium text-2xl',
        textClasses: 'font-light',
        textContainerClasses: 'text-center',
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-mobile-guy.jpg',
            alt: '',
            sizes: '(max-width: 768px) 100vw, 50vw'
        },
        link: {
            text: "L\xe4s mer om Kia App",
            url: 'https://www.kia.com/se/om-kia/upplev-kia/teknik/kia-app/',
            openInNewTab: false
        }
    },
    {
        title: "Kia Originaltillbeh\xf6r.",
        text: "Oavsett om du beh\xf6ver en h\xf6gkvalitativ dragkrok, lasth\xe5llare eller takbox erbjuder Kia tillbeh\xf6r som \xe4r speciellt tillverkade och anpassade f\xf6r din Kia.",
        titleClasses: 'font-medium text-2xl',
        textClasses: 'font-light',
        textContainerClasses: 'text-center',
        image: {
            src: 'https://kia-afonso-storage.b-cdn.net/Kia-Ev5/EV5-300x400-6_NY.jpg',
            alt: 'KIA Elbilar',
            sizes: '(max-width: 768px) 100vw, 50vw'
        },
        link: {
            text: "L\xe4s mer om Kia Originaltillbeh\xf6r",
            url: 'https://www.kia.com/se/aga/originaldelar-oversikt/originaltillbehor/',
            openInNewTab: false
        }
    }
];

});


parcelRegister("7eH6V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17afda03bae1ca6e$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4hvlL = parcelRequire("4hvlL");

var $f0NwZ = parcelRequire("f0NwZ");
const $17afda03bae1ca6e$var$KiaPVFiveCard = ()=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4hvlL.default), {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                page: "kia-pv-five-card"
            })
        ]
    });
};
var $17afda03bae1ca6e$export$2e2bcd8739ae039 = $17afda03bae1ca6e$var$KiaPVFiveCard;

});
parcelRegister("4hvlL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a625ccc697c5ad37$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $655D0 = parcelRequire("655D0");

var $3eb7t = parcelRequire("3eb7t");

var $7hhPC = parcelRequire("7hhPC");

var $6MHW3 = parcelRequire("6MHW3");
const $a625ccc697c5ad37$var$Divider = ()=>/*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: "h-px bg-dark-blue/50 my-4"
    });
const $a625ccc697c5ad37$var$InfoCard = ()=>{
    const [customerType, setCustomerType] = (0, $8FY87.useState)('business');
    const info = (0, $6MHW3.default)[customerType];
    const { title: title, subtitle: subtitle, tag: tag, image: image, leases: leases, tax: tax, pricing: pricing, links: links, footer: footer, detailText: detailText, priceText: priceText, extraLink: extraLink } = info;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: "max-w-screen-kia-sm mx-auto px-4 lg:px-0",
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: "relative group bg-kia-grey p-6 rounded-lg shadow-lg overflow-visible",
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                    className: "absolute top-4 right-4 md:left-4 md:right-auto inline-block bg-white text-black text-[13px] px-3 py-1 rounded-full shadow-sm z-10",
                    children: tag
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 gap-6 mt-7",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: "relative group flex justify-center items-start mt-0 md:mt-5",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                href: image.href,
                                className: "block group-hover:scale-105 transition-transform",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                    src: image.src,
                                    alt: image.alt,
                                    width: 500,
                                    className: "object-cover"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                    href: image.href,
                                    className: "no-underline group-hover:underline",
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        className: "text-lg font-bold mb-2 text-black",
                                        children: title
                                    })
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                    className: "mb-4 inline-block px-4 py-2 bg-white rounded-full shadow-md text-sm text-black",
                                    children: subtitle
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: "mb-4 flex rounded-full p-1 bg-white shadow-md",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                            onClick: ()=>setCustomerType('business'),
                                            className: `px-4 py-2 flex-1 rounded-full text-sm ${customerType === 'business' ? 'bg-black text-white' : 'bg-white text-black hover:bg-white/90'}`,
                                            children: "F\xf6retag"
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                            onClick: ()=>setCustomerType('private'),
                                            className: `px-4 py-2 flex-1 rounded-full text-sm ${customerType === 'private' ? 'bg-black text-white' : 'bg-white text-black hover:bg-white/90'}`,
                                            children: "Privat"
                                        })
                                    ]
                                }),
                                leases.length > 0 && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                    className: "",
                                    children: leases.map((lease, idx)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                            className: "font-semibold text-sm flex items-center",
                                            children: [
                                                lease.headline,
                                                " ",
                                                lease.subline,
                                                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                    className: "ml-1 self-start relative -top-1",
                                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $7hhPC.default), {
                                                        describe: lease.tooltip,
                                                        children: lease.tooltip
                                                    })
                                                })
                                            ]
                                        }, idx))
                                }),
                                priceText && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                    className: "text-sm mb-4",
                                    children: priceText
                                }),
                                detailText && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                    className: "text-xs text-gray-700 mb-4 whitespace-pre-line",
                                    children: detailText
                                }),
                                customerType === 'private' ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                            className: "grid sm:grid-cols-2 gap-1 sm:gap-4 text-sm text-gray-800 mb-4",
                                            children: [
                                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                            className: "font-semibold text-sm",
                                                            children: pricing.list[0]?.label
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                            className: "text-sm",
                                                            children: pricing.list[0]?.value
                                                        })
                                                    ]
                                                }),
                                                extraLink && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                                    className: "flex items-start",
                                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                                        href: extraLink.href,
                                                        className: "text-xs underline decoration-current transition-all duration-200 ease-in-out hover:text-black/50 hover:decoration-transparent hover:underline-offset-4",
                                                        children: extraLink.label
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                            className: "grid sm:grid-cols-2 gap-4 text-sm text-gray-800",
                                            children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                        className: "font-semibold text-sm",
                                                        children: tax.label
                                                    }),
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                        className: "text-sm",
                                                        children: tax.value
                                                    })
                                                ]
                                            })
                                        }),
                                        links[0] && /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                            href: links[0].href,
                                            className: "mt-4 bg-black underline-offset-2 no-underline text-white py-3 text-center rounded-sm border border-black hover:bg-transparent hover:underline hover:text-black transition-colors",
                                            children: links[0].label
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                            className: "grid sm:grid-cols-2 gap-4 text-sm text-gray-800 mb-4",
                                            children: [
                                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                            className: "font-semibold text-sm",
                                                            children: pricing.list[0]?.label
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                            className: "text-sm mb-2",
                                                            children: pricing.list[0]?.value
                                                        }),
                                                        extraLink && /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                                            href: extraLink.href,
                                                            className: "text-xs underline decoration-current transition-all duration-200 ease-in-out hover:text-black/50 hover:decoration-transparent hover:underline-offset-4",
                                                            children: extraLink.label
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                            className: "font-semibold text-sm",
                                                            children: pricing.list[1]?.label
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                            className: "text-sm mb-2",
                                                            children: pricing.list[1]?.value
                                                        }),
                                                        links[1] && /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                                            href: links[1].href,
                                                            className: "text-xs underline decoration-current transition-all duration-200 ease-in-out hover:text-black/50 hover:decoration-transparent hover:underline-offset-4",
                                                            children: links[1].label
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                            className: "grid sm:grid-cols-2 gap-4 text-sm text-gray-800",
                                            children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                        className: "font-semibold text-sm",
                                                        children: tax.label
                                                    }),
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                        className: "text-sm",
                                                        children: tax.value
                                                    })
                                                ]
                                            })
                                        }),
                                        links[0] && /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                            href: links[0].href,
                                            className: "mt-4 bg-black underline-offset-2 no-underline text-white py-3 text-center rounded-sm border border-black hover:bg-transparent hover:underline hover:text-black transition-colors",
                                            children: links[0].label
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)($a625ccc697c5ad37$var$Divider, {})
                                    ]
                                }),
                                footer.map((line, i)=>{
                                    if (line.includes("Kia-\xe5terf\xf6rs\xe4ljare")) {
                                        const [before, after] = line.split("Kia-\xe5terf\xf6rs\xe4ljare");
                                        return /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                            className: "text-xs mt-2",
                                            children: [
                                                before,
                                                /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                                    href: "https://www.kia.com/se/sok-aterforsaljare-verkstad",
                                                    onClick: ()=>(0, $655D0.trackEvent)({
                                                            event: 'find_a_dealer',
                                                            model: undefined
                                                        }),
                                                    className: "text-xs underline decoration-current transition-all duration-200 ease-in-out hover:text-black/50 hover:decoration-transparent hover:underline-offset-4",
                                                    children: "Kia-\xe5terf\xf6rs\xe4ljare"
                                                }),
                                                after
                                            ]
                                        }, i);
                                    }
                                    return /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: "text-xs",
                                        children: line
                                    }, i);
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $a625ccc697c5ad37$export$2e2bcd8739ae039 = $a625ccc697c5ad37$var$InfoCard;

});
parcelRegister("6MHW3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3485f430a9d168b$export$2e2bcd8739ae039; });
const $b3485f430a9d168b$var$sharedInfo = {
    title: 'Kia PV5 Cargo',
    subtitle: 'Kia PV5 Cargo L2H1 4dr Long Range',
    tag: 'El',
    image: {
        src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/kia-pb5-cargo-my26-v1-520x260.png',
        alt: 'Kia PV5',
        href: 'https://www.kia.com/se/pbv/modellutbud/pv5-cargo/'
    },
    tax: {
        label: 'Fordonsskatt',
        value: "360 kr/\xe5r"
    },
    links: [
        {
            label: "Utforska PV5 Cargo h\xe4r",
            href: 'https://www.kia.com/se/pbv/modellutbud/pv5-cargo/'
        }
    ],
    extraLink: {
        label: 'Prislista PBV: modellversioner och priser',
        href: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/contents/utility/prislista/kia-sweden-pricelist-pbv.pdf'
    }
};
const $b3485f430a9d168b$var$pvfiveInfo = {
    business: {
        ...$b3485f430a9d168b$var$sharedInfo,
        leases: [
            {
                headline: 'Finansiell leasing',
                tooltip: "Med finansiell leasing f\xe5r du en flexibel l\xf6sning med m\xe5nga valm\xf6jligheter. Kunden \xe4ger bilen och ansvarar f\xf6r dess restv\xe4rde. Leasingavgiften best\xe4ms av bilens nettopris, kapitalkostnaden och fordonets restv\xe4rde som s\xe4tts baserat p\xe5 k\xf6rprofil. Om \xf6vriga bilkostnader uppst\xe5r hanteras de direkt av kunden.",
                subline: 'inkl. serviceavtal'
            }
        ],
        priceText: "3 165 kr/m\xe5n*",
        detailText: `*F\xf6retagsleasing via Kia Finans: Ber\xe4kningen baseras p\xe5 att leasegivaren Santander Consumer Bank AS Norge, Sverige Filial (Santander) erh\xe5ller st\xf6d fr\xe5n Energimyndigheten i enlighet med f\xf6rordningen (2020:750) om statligt st\xf6d till vissa milj\xf6fordon. I ber\xe4kningen g\xf6rs antagandet att Santander erh\xe5ller ett st\xf6d om 40 000 kr sju m\xe5nader efter att leasingkontraktet startats. M\xe5nad 1-7 \xe4r leasinghyran 4 365 kr och m\xe5nad 8-36 \xe4r leasinghyran 2 876 kr. Genomsnittlig m\xe5nadshyra uppg\xe5r till 3 165 kr. Observera att ber\xe4kningen f\xf6r\xe4ndras beroende p\xe5 storleken p\xe5 det st\xf6d som beviljas av Energimyndigheten samt den tidpunkt d\xe5 Santander erh\xe5ller st\xf6det fr\xe5n Energimyndigheten. Avtalstid: 36 m\xe5nader och restv\xe4rde: 204 750 kr. Vid leverans utg\xe5r en s\xe4rskild leasingavgift om 76 440 kr. Uppl\xe4ggnings- och administrationsavgift tillkommer. Serviceavtal ing\xe5r med 236 kr/m\xe5n. Samtliga belopp \xe4r angivna exklusive moms. Leasingavgiften \xe4r r\xf6rlig (april 2026) och kan t.ex. \xe4ndras p.g.a. f\xf6r\xe4ndringar i det allm\xe4nna r\xe4ntel\xe4get. Sedvanlig kreditpr\xf6vning sker.`,
        pricing: {
            list: [
                {
                    label: 'Rek. ca pris exkl. moms',
                    value: "fr\xe5n 455.000 kr"
                },
                {
                    label: 'Klimatpremie upp till**',
                    value: "-40.000 kr (ej avr\xe4knad i rek.pris)"
                }
            ]
        },
        links: [
            ...$b3485f430a9d168b$var$sharedInfo.links,
            {
                label: "**L\xe4s mer om klimatpremien",
                href: 'https://www.kia.com/se/pbv/plattform-beyond-vehicle/klimatpremie/'
            }
        ],
        footer: [
            "Individuella f\xf6retagsrabatter och finansieringsuppl\xe4gg kan p\xe5verka exempelpriserna visade ovan.",
            "Kontakta din Kia-\xe5terf\xf6rs\xe4ljare f\xf6r ett skr\xe4ddarsytt aff\xe4rsf\xf6rslag och ev. anpassning av ditt fordon."
        ]
    },
    private: {
        ...$b3485f430a9d168b$var$sharedInfo,
        leases: [],
        priceText: '',
        detailText: '',
        pricing: {
            list: [
                {
                    label: 'Rek. ca pris inkl. moms',
                    value: "fr\xe5n 568 750 kr"
                }
            ]
        },
        footer: []
    }
};
var $b3485f430a9d168b$export$2e2bcd8739ae039 = $b3485f430a9d168b$var$pvfiveInfo;

});



parcelRegister("2eDIc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec82061f02bd1260$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $8FY87 = parcelRequire("8FY87");

var $51Ucj = parcelRequire("51Ucj");

var $f0NwZ = parcelRequire("f0NwZ");

var $8hzsK = parcelRequire("8hzsK");

var $22OL8 = parcelRequire("22OL8");

var $eKy2z = parcelRequire("eKy2z");

var $lsG22 = parcelRequire("lsG22");

var $kZPx9 = parcelRequire("kZPx9");

var $jeu8h = parcelRequire("jeu8h");

var $bRf1s = parcelRequire("bRf1s");

var $2FCIq = parcelRequire("2FCIq");

var $3eb7t = parcelRequire("3eb7t");

var $e4coK = parcelRequire("e4coK");

var $3NV5M = parcelRequire("3NV5M");
const $ec82061f02bd1260$var$NewKiaEV6 = ()=>{
    const [hideControls] = (0, $8FY87.useState)(true);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("main", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bRf1s.VideoClip), {
                autoplay: true,
                ...(0, $3NV5M.heroev6)
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "w-full max-w-screen-kia mx-auto",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $lsG22.default), {
                        id: "hedings",
                        className: "mt-9 p-6",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                                className: "text-center font-medium text-[30px]  md:text-[40px] leading-[48px] mb-1 ",
                                variants: (0, $51Ucj.itemVariants),
                                children: (0, $3NV5M.headingEV6).heading
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                                variants: (0, $51Ucj.itemVariants),
                                className: "text-center font-normal text-[17px]  ",
                                children: (0, $3NV5M.headingEV6).headingSub
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
                        className: "w-full max-w-screen-kia-sm mx-auto",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kZPx9.TextBox), {
                                    ...(0, $3NV5M.textBoxicon01)
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e4coK.default), {
                                hideControls: hideControls,
                                modelCodes: "ASW5",
                                trimCodes: "ASW5YCZ7ZKK0JP",
                                imageType: 'Studiobild',
                                fields: "Byt trim,Businesslease,F\xf6rm\xe5nsv\xe4rde,Fr\xe5npris,Uppt\xe4ck bilen,Kontakta \xe5terf\xf6rs\xe4ljare"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: " mx-auto px-6 w-full max-w-7xl  mb-5",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponentWidth: "col-span-4 lg:col-span-5",
                            secondComponentWidth: "col-span-4 lg:col-span-3",
                            mainBoxClassName: "mx-auto w-full max-w-7xl",
                            firstComponentClassName: "p-0",
                            secondComponentClassName: "p-0 lg:p-10 lg:pt-0",
                            mobilFirstComponentOnTop: false,
                            desktopFirstComponentFirst: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                ...(0, $3NV5M.kiaImageEV601)
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        className: "text-[23px] md:text-[32px] leading-[40px] mb-4",
                                        children: (0, $3NV5M.twoComponentsTextEV601).title
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: "text-[16px] md:text[18px] leading-[24px] font-light",
                                        children: (0, $3NV5M.twoComponentsTextEV601).text
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "flex justify-center md:justify-start",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                            ...(0, $3NV5M.linkEV601)
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: " mx-auto px-6 w-full max-w-7xl  mb-5",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponentWidth: "col-span-4 lg:col-span-3",
                            secondComponentWidth: "col-span-4 lg:col-span-5",
                            mainBoxClassName: "mx-auto w-full max-w-7xl",
                            firstComponentClassName: "p-0 lg:p-10 lg:pt-0",
                            secondComponentClassName: "p-0",
                            mobilFirstComponentOnTop: true,
                            desktopFirstComponentFirst: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        className: "text-[23px] md:text-[32px] leading-[40px] mb-4",
                                        children: (0, $3NV5M.twoComponentsTextEV602).title
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: "text-[16px] md:text[18px] leading-[24px] font-light",
                                        children: (0, $3NV5M.twoComponentsTextEV602).text
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "flex justify-center md:justify-start",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                            ...(0, $3NV5M.linkEV602)
                                        })
                                    })
                                ]
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                ...(0, $3NV5M.kiaImageEV602)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kZPx9.TextBox), {
                            ...(0, $3NV5M.textBox2)
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: " mx-auto px-6 w-full max-w-7xl  mb-5",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponentWidth: "col-span-4 lg:col-span-5",
                            secondComponentWidth: "col-span-4 lg:col-span-3",
                            mainBoxClassName: "mx-auto w-full max-w-7xl",
                            firstComponentClassName: "p-0",
                            secondComponentClassName: "p-0 lg:p-10 lg:pt-0",
                            mobilFirstComponentOnTop: true,
                            desktopFirstComponentFirst: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                ...(0, $3NV5M.kiaImageEV605)
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        className: "text-[23px] md:text-[32px] leading-[40px] mb-4",
                                        children: (0, $3NV5M.twoComponentsTextEV604).title
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: "text-[16px] md:text[18px] leading-[24px] font-light",
                                        children: (0, $3NV5M.twoComponentsTextEV604).text
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "flex justify-center md:justify-start",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                            ...(0, $3NV5M.linkEV604)
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: " mx-auto px-6 w-full max-w-7xl  mb-16",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $22OL8.default), {
                            ...(0, $3NV5M.infobox01)
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: "max-w-screen-kia mb-20",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $lsG22.default), {
                            id: "kia-img",
                            className: "mt-0",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                                variants: (0, $51Ucj.itemVariants),
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                    ...(0, $3NV5M.kiaImageEV603)
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: " mx-auto px-6 w-full max-w-7xl  mb-16",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $22OL8.default), {
                            ...(0, $3NV5M.infobox02)
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: " mx-auto px-6 w-full max-w-7xl  mb-16",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eKy2z.default), {
                            boxes: [
                                (0, $3NV5M.infobox03),
                                (0, $3NV5M.infobox04),
                                (0, $3NV5M.infobox05)
                            ],
                            columns: 3,
                            containerClassName: "px-0"
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: " mx-auto px-6 w-full max-w-7xl  mb-16",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8hzsK.default), {
                            ...(0, $3NV5M.greyListData)
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: " mx-auto px-6 w-full max-w-7xl mb-10 md:mb-20",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eKy2z.default), {
                            boxes: [
                                (0, $3NV5M.infobox06),
                                (0, $3NV5M.infobox07),
                                (0, $3NV5M.infobox09)
                            ],
                            columns: 3,
                            containerClassName: "px-0 "
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                        page: "new-kia-ev6"
                    })
                ]
            })
        ]
    });
};
var $ec82061f02bd1260$export$2e2bcd8739ae039 = $ec82061f02bd1260$var$NewKiaEV6;

});
parcelRegister("eKy2z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fb6a5b626a3ff23$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
parcelRequire("8FY87");

var $22OL8 = parcelRequire("22OL8");
const $9fb6a5b626a3ff23$var$InfoBoxesSection = ({ boxes: boxes, columns: columns = 3, containerClassName: containerClassName = '' })=>{
    const gridClass = columns === 2 ? 'grid gap-y-10 md:gap-5 grid-cols-1 md:grid-cols-2' : columns === 3 ? 'grid gap-y-10 xl:gap-5 grid-cols-1 xl:grid-cols-3' : columns === 4 ? 'grid gap-y-10 md:gap-0 grid-cols-1 md:grid-cols-4' : 'grid gap-y-10 grid-cols-1';
    return /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
        className: `w-full ${containerClassName}`,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            className: gridClass,
            children: boxes.map((box, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $22OL8.default), {
                    ...box
                }, index))
        })
    });
};
var $9fb6a5b626a3ff23$export$2e2bcd8739ae039 = $9fb6a5b626a3ff23$var$InfoBoxesSection;

});

parcelRegister("3NV5M", function(module, exports) {

$parcel$export(module.exports, "heroev6", function () { return $e94f4eb2b4b70f4e$export$b27bd2a7cf70f59f; });
$parcel$export(module.exports, "headingEV6", function () { return $e94f4eb2b4b70f4e$export$2dffc7fe7a9f3509; });
$parcel$export(module.exports, "textBoxicon01", function () { return $e94f4eb2b4b70f4e$export$42c2e441a1a0fc02; });
$parcel$export(module.exports, "kiaImageEV601", function () { return $e94f4eb2b4b70f4e$export$d45b871c44a88e85; });
$parcel$export(module.exports, "twoComponentsTextEV601", function () { return $e94f4eb2b4b70f4e$export$286da52d5f49828d; });
$parcel$export(module.exports, "linkEV601", function () { return $e94f4eb2b4b70f4e$export$89d7f87a3a88cc00; });
$parcel$export(module.exports, "kiaImageEV602", function () { return $e94f4eb2b4b70f4e$export$f5eb25f1788d9a0e; });
$parcel$export(module.exports, "twoComponentsTextEV602", function () { return $e94f4eb2b4b70f4e$export$3e8e5935e31ad1b8; });
$parcel$export(module.exports, "linkEV602", function () { return $e94f4eb2b4b70f4e$export$ead72aaf5f8ac053; });
$parcel$export(module.exports, "textBox2", function () { return $e94f4eb2b4b70f4e$export$3b25dfdda0032e88; });
$parcel$export(module.exports, "infobox01", function () { return $e94f4eb2b4b70f4e$export$21b786e360350a31; });
$parcel$export(module.exports, "kiaImageEV603", function () { return $e94f4eb2b4b70f4e$export$b58a9f907818d01a; });
$parcel$export(module.exports, "infobox02", function () { return $e94f4eb2b4b70f4e$export$12cc0caed90f9a52; });
$parcel$export(module.exports, "infobox03", function () { return $e94f4eb2b4b70f4e$export$e617572ac37a3191; });
$parcel$export(module.exports, "infobox04", function () { return $e94f4eb2b4b70f4e$export$9fef7162c4921709; });
$parcel$export(module.exports, "infobox05", function () { return $e94f4eb2b4b70f4e$export$f0f67c933eb67fbf; });
$parcel$export(module.exports, "infobox06", function () { return $e94f4eb2b4b70f4e$export$9f1965f6845783c3; });
$parcel$export(module.exports, "infobox07", function () { return $e94f4eb2b4b70f4e$export$d4c450b619ce7028; });
$parcel$export(module.exports, "infobox09", function () { return $e94f4eb2b4b70f4e$export$dc9654189b6d24c0; });
$parcel$export(module.exports, "greyListData", function () { return $e94f4eb2b4b70f4e$export$b8246066969ef720; });
$parcel$export(module.exports, "kiaImageEV605", function () { return $e94f4eb2b4b70f4e$export$ee6fa5cf870bdadb; });
$parcel$export(module.exports, "twoComponentsTextEV604", function () { return $e94f4eb2b4b70f4e$export$e5ed6d90743c5cbe; });
$parcel$export(module.exports, "linkEV604", function () { return $e94f4eb2b4b70f4e$export$504adf9f4f4e1bc; });
const $e94f4eb2b4b70f4e$export$b27bd2a7cf70f59f = {
    title: 'Kia EV6',
    subTitle: '',
    src: 'https://kia-afonso-storage.b-cdn.net/kia/Vidderna_landningssida-2.mp4',
    srcWebm: 'https://kia-afonso-storage.b-cdn.net/kia/Vidderna_landningssida_1920x800-2.webm'
};
const $e94f4eb2b4b70f4e$export$2dffc7fe7a9f3509 = {
    heading: 'Vidden av frihet',
    headingSub: "Kia Business Lease med garanterat restv\xe4rde fr. 4 272 kr/m\xe5n"
};
const $e94f4eb2b4b70f4e$export$42c2e441a1a0fc02 = {
    title: '',
    backgroundColor: '',
    numberOfFields: 3,
    titleStyle: 'mb-6 text-[32px] max-w-[627px]',
    textSize: 'text-center leading-[24px] text-[16px] md:text[18px] font-light md:font-normal',
    listItems: [
        {
            text: "R\xe4ckvidd upp till 582 km tack vare batteriets h\xf6ga kapacitet.",
            boldParts: [
                ''
            ],
            iconProps: {
                color: '#000',
                width: 24,
                height: 24,
                strokeWidth: 5
            }
        },
        {
            text: "Ultrasnabb laddning 10\u201380 % p\xe5 ner till 18 minuter med f\xf6rfinad 800-voltsteknik.",
            boldParts: [
                ''
            ],
            iconProps: {
                color: '#000',
                width: 24,
                height: 24,
                strokeWidth: 5
            }
        },
        {
            text: "Smidigare laddstopp med Plug & Charge \u2013 anslut via Kia Charge.",
            boldParts: [
                ''
            ],
            iconProps: {
                color: '#000',
                width: 24,
                height: 24,
                strokeWidth: 5
            }
        }
    ]
};
const $e94f4eb2b4b70f4e$export$d45b871c44a88e85 = {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-007.jpg',
    alt: 'KIA Car',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto pt-0 w-full '
};
const $e94f4eb2b4b70f4e$export$286da52d5f49828d = {
    title: 'Kia EV6 och Mando Diao',
    text: "Med upp till 582 km r\xe4ckvidd, ultrasnabb laddning och Vehicle-to-Load ger Kia EV6 samma uttryck f\xf6r frihet som musiken fr\xe5n Mando Diao som den ackompanjeras av. "
};
const $e94f4eb2b4b70f4e$export$89d7f87a3a88cc00 = {
    text: "L\xe4s mer om EV6",
    textSize: '16px',
    url: 'https://www.kia.com/se/nya-bilar/ev6/upptack/',
    className: 'mt-6 mb-6 ',
    openInNewTab: false
};
const $e94f4eb2b4b70f4e$export$f5eb25f1788d9a0e = {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-011.jpg',
    alt: 'Kia behind the scenes',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto pt-0 w-full '
};
const $e94f4eb2b4b70f4e$export$3e8e5935e31ad1b8 = {
    title: 'Laddad med Kia EV6',
    text: "Utnyttja elbilens m\xf6jligheter till fullo. Med Vehicle-to-Load som enda str\xf6mk\xe4lla driver Kia EV6 en hemlig spelning med Mando Diao.\xa0F\xf6lj med bakom kulisserna och upp p\xe5 scenen med ett av Sveriges fr\xe4msta rockband och h\xf6r l\xe5ten Vidderna, specialskriven f\xf6r Kia."
};
const $e94f4eb2b4b70f4e$export$ead72aaf5f8ac053 = {
    text: "Se spelningen med Mando Diao\xa0",
    textSize: '16x',
    url: 'https://www.kia.com/se/kopa/erbjudanden/ev6/vidderna',
    className: 'mt-6 mb-6 ',
    openInNewTab: false
};
const $e94f4eb2b4b70f4e$export$3b25dfdda0032e88 = {
    title: "Tekniken som tar Kia EV6 i m\xe5l",
    backgroundColor: '#000',
    numberOfFields: 3,
    textSize: 'text-center leading-[24px] text-[16px] md:text[18px] font-light md:font-normal',
    titleStyle: 'mb-14 text-[40px] max-w-[717px] leading-[48px]',
    centerText: true,
    listItems: [
        {
            title: "R\xe4ckvidd",
            text: "Tack vare batteriets kapacitet p\xe5 84 kWh: r\xe4ckvidd p\xe5 upp till 546 km i EV6 AWD och upp till 582 km i EV6 RWD."
        },
        {
            title: "S\xf6ml\xf6s laddning",
            text: "Via Kia Charge kan du som k\xf6r EV6 ansluta till Plug & Charge och ladda smidigt utan betalkort eller appar vid Ionitys stationer. Allt du beh\xf6ver g\xf6ra \xe4r att ansluta laddkabeln."
        },
        {
            title: "Sist in, f\xf6rst ut",
            text: "Kia EV6 laddar 10 till 80 procent p\xe5 ner till 18 minuter. Allt tack vare den f\xf6rfinade 800-voltstekniken. Det robusta batteriet \xe4r byggt f\xf6r att t\xe5la upprepade snabbladdningar.\xa0"
        }
    ]
};
const $e94f4eb2b4b70f4e$export$21b786e360350a31 = {
    title: "Laddbar frihet, f\xf6r fler.",
    image: {
        src: 'https://kia-afonso-storage.b-cdn.net/kia/EV_Range.jpg',
        alt: 'KIA Elbilar',
        sizes: '(max-width: 768px) 100vw, 50vw',
        className: 'mx-auto pt-0 w-full '
    },
    text: "Nu finns fler anledningar att v\xe4lja en Kia som elbil. Kia EV6 kommer med en r\xe4ckvidd p\xe5 upp till 582 km och dessutom upp till 1 800 kg dragvikt. Kia EV3 \xe4r en rymlig kompakt SUV med en r\xe4ckvidd p\xe5 upp till 605 km och design inspirerad av EV9. St\xf6rst av v\xe5ra elbilar \xe4r prisvinnande Kia EV9 med en r\xe4ckvidd p\xe5 upp till 512 km, plats f\xf6r upp till sju och maximal dragvikt p\xe5 upp till 2500 kg. B\xe5de Kia EV9 och Kia EV6 kommer med 800V-teknik som m\xf6jligg\xf6r ultrasnabb laddning.",
    links: [
        {
            text: "L\xe4s mer om Kia EV6",
            url: ' https://www.kia.com/se/nya-bilar/ev6/upptack/',
            className: 'w-[298px]',
            openInNewTab: false
        },
        {
            text: "L\xe4s mer om Kia EV3",
            url: 'https://www.kia.com/se/nya-bilar/ev3/upptack/',
            className: 'w-[298px]',
            openInNewTab: false
        },
        {
            text: "L\xe4s mer om Kia EV9",
            url: 'https://www.kia.com/se/nya-bilar/ev9/upptack/',
            className: 'w-[298px]',
            openInNewTab: false
        }
    ],
    titleFontSize: 'text-[32px] md:text-[32px]',
    textFontSize: 'text-[16px] md:text[18px] font-light'
};
const $e94f4eb2b4b70f4e$export$b58a9f907818d01a = {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/KIA-BD-EV6-Side.jpg',
    alt: 'Kia EV6',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto pt-0 w-full '
};
const $e94f4eb2b4b70f4e$export$12cc0caed90f9a52 = {
    title: 'Enkel finansiering ',
    text: "Uppt\xe4ck din n\xe4sta tj\xe4nstebil fr\xe5n Kia. Med Kia Business Lease kan du uppleva laddbar frihet i form av en v\xe4lutrustad laddbar Kia inklusive f\xf6rs\xe4kring, service, vinterhjul och med garanterat restv\xe4rde.",
    links: [
        {
            text: "Hitta n\xe4rmaste \xe5terf\xf6rs\xe4ljare",
            url: 'https://www.kia.com/se/sok-aterforsaljare-verkstad/#/',
            className: 'border-2 border-black',
            openInNewTab: true,
            textColor: 'black',
            bgColor: 'white'
        },
        {
            text: 'Prislista',
            url: 'https://www.kia.com/se/kopa/prislista/',
            className: 'w-[298px]',
            openInNewTab: true
        }
    ],
    gap: '5',
    titleFontSize: 'text-[32px] md:text-[32px]',
    textFontSize: 'text-[16px] md:text[18px] font-light'
};
const $e94f4eb2b4b70f4e$export$e617572ac37a3191 = {
    title: "Finansiera din n\xe4sta tj\xe4nstebil\xa0",
    image: {
        src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/KIA-BD-EV6-HERO-Car.jpg',
        alt: 'KIA Elbilar',
        sizes: '(max-width: 768px) 100vw, 50vw',
        className: 'min-h-[290px] max-h-[290px] min-w-[330px] md:min-w-[380px] md:max-w[380px] object-cover object-center'
    },
    text: "Kia Business Lease \xe4r en helhetsl\xf6sning som inneb\xe4r ett garanterat restv\xe4rde och inkluderar f\xf6rs\xe4kring, service och Kia Original vinterhjul. Med Kia Finansiell leasing v\xe4ljer du sj\xe4lv till de tj\xe4nster du beh\xf6ver.\xa0",
    links: [
        {
            text: "V\xe5ra finansl\xf6sningar",
            url: 'https://www.kia.com/se/tjanstebil/foretagsleasing/',
            className: 'w-[298px]',
            openInNewTab: false
        }
    ],
    headingPosition: 'below',
    titleFontSize: 'text-[22px]',
    textFontSize: 'text-[16px] font-light'
};
const $e94f4eb2b4b70f4e$export$9fef7162c4921709 = {
    title: "Kia som tj\xe4nstebil",
    image: {
        src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/EV6_GTL_MY25_Exterior_Headlamps_CMYK.jpg',
        alt: 'KIA Elbilar',
        sizes: '(max-width: 768px) 100vw, 50vw',
        className: 'min-h-[290px] max-h-[290px] min-w-[330px] md:min-w-[380px] md:max-w[380px] object-cover object-center'
    },
    text: "Med en Kia som tj\xe4nstebil f\xe5r du innovativ teknik, h\xf6g komfort och de senaste s\xe4kerhets- och infotainment-systemen med uppkopplade tj\xe4nster \u2013 samt flexibla finansieringsl\xf6sningar.",
    links: [
        {
            text: "L\xe4s mer om Kia som tj\xe4nstebil",
            url: 'https://www.kia.com/se/tjanstebil/',
            openInNewTab: false
        }
    ],
    headingPosition: 'below',
    titleFontSize: 'text-[22px]',
    textFontSize: 'text-[16px] font-light'
};
const $e94f4eb2b4b70f4e$export$f0f67c933eb67fbf = {
    title: "R\xe4kna p\xe5 din n\xe4sta tj\xe4nstebil",
    image: {
        src: 'https://kia-afonso-storage.b-cdn.net/kia/tjanstebil.webp',
        alt: 'KIA Elbilar',
        sizes: '(max-width: 768px) 100vw, 50vw',
        className: 'min-h-[290px] max-h-[290px] min-w-[330px] md:min-w-[380px] md:max-w[380px] object-cover object-center'
    },
    text: "J\xe4mf\xf6r v\xe5ra laddbara modeller och r\xe4kna p\xe5 vad din n\xe4sta tj\xe4nstebil fr\xe5n Kia kommer att kosta.",
    links: [
        {
            text: "Till tj\xe4nstebilskalkylatorn",
            url: 'https://www.kia.com/se/tjanstebil/kalkyl-laddhybrid/',
            className: 'w-[298px]',
            openInNewTab: false
        }
    ],
    headingPosition: 'below',
    titleFontSize: 'text-[22px]',
    textFontSize: 'text-[16px] font-light'
};
const $e94f4eb2b4b70f4e$export$9f1965f6845783c3 = {
    title: 'Bilmodeller',
    image: {
        src: 'https://kia-afonso-storage.b-cdn.net/100procent/Elbil-Laddbar-KIa.jpg',
        alt: 'KIA Elbilar',
        sizes: '(max-width: 768px) 100vw, 50vw',
        className: 'min-h-[290px] max-h-[300px] min-w-[330px] object-cover object-center'
    },
    text: "Uppt\xe4ck v\xe5rt breda modellprogram med laddbara bilar som passar alla.\xa0",
    links: [
        {
            text: "L\xe4s mer om v\xe5ra bilmodeller",
            url: 'https://www.kia.com/se/nya-bilar/bilmodeller/',
            className: 'w-[298px]',
            openInNewTab: true
        }
    ],
    headingPosition: 'below',
    titleFontSize: 'text-[22px]',
    textFontSize: 'text-[16px] font-light'
};
const $e94f4eb2b4b70f4e$export$d4c450b619ce7028 = {
    title: "Uppkopplade tj\xe4nster",
    image: {
        src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/EV6_GTL_MY25_LifstyleInterior_PhoneNavi_with_Talent_CMYK.jpg',
        alt: 'KIA Elbilar',
        sizes: '(max-width: 768px) 100vw, 50vw',
        className: 'min-h-[290px] max-h-[300px] min-w-[330px] object-cover object-center'
    },
    text: "Beh\xe5ll kontakten med din bil, var du \xe4n \xe4r. Med appen Kia Connect f\xe5r du k\xf6rstatistik och status.",
    links: [
        {
            text: "L\xe4s mer om Kia Connect",
            url: 'https://www.kia.com/se/om-kia/upplev-kia/teknik/kia-connect/',
            className: 'w-[298px]',
            openInNewTab: true
        }
    ],
    headingPosition: 'below',
    titleFontSize: 'text-[22px]',
    textFontSize: 'text-[16px] font-light'
};
const $e94f4eb2b4b70f4e$export$dc9654189b6d24c0 = {
    title: "Kia Originaltillbeh\xf6r",
    image: {
        src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/KIA_MG_1409.jpg',
        alt: 'KIA Elbilar',
        sizes: '(max-width: 768px) 100vw, 50vw',
        className: 'min-h-[290px] max-h-[300px] min-w-[330px] object-cover object-center'
    },
    text: "Oavsett om du beh\xf6ver en h\xf6gkvalitativ dragkrok, lasth\xe5llare eller takbox erbjuder Kia tillbeh\xf6r som \xe4r speciellt tillverkade och anpassade f\xf6r din Kia.\xa0",
    links: [
        {
            text: "Till Kia Originaltillbeh\xf6r",
            url: 'https://www.kia.com/se/aga/originaldelar-oversikt/originaltillbehor/',
            className: 'w-[298px]',
            openInNewTab: true
        }
    ],
    headingPosition: 'below',
    titleFontSize: 'text-[22px]',
    textFontSize: 'text-[16px] font-light'
};
const $e94f4eb2b4b70f4e$export$b8246066969ef720 = {
    title: 'Alltid i en Kia',
    underTitle: "F\xf6ljande ing\xe5r som standard i alla nya personbilar fr\xe5n Kia:\xa0",
    items: [
        {
            text: "Rattv\xe4rme"
        },
        {
            text: 'Backkamera'
        },
        {
            text: 'Metallic/pearl-lack'
        },
        {
            text: "V\xe4rmepump och f\xf6rv\xe4rmning av batteri och kup\xe9 (i elbilar)"
        },
        {
            text: "Kia Assistans i samband med Kia Originalservice\xb9\u2074"
        },
        {
            text: "7 \xe5rs nybilsgaranti fr\xe5n fabrik\xb9\xb9"
        },
        {
            text: "7 \xe5rs app-styrning (Kia App\xb9\xb3)"
        },
        {
            text: "7 \xe5rs garanti p\xe5 Kia Original vinterhjul (tillval)"
        },
        {
            text: "7 \xe5rs uppkopplad navigation med live-tj\xe4nster (Kia Live)"
        }
    ]
};
const $e94f4eb2b4b70f4e$export$ee6fa5cf870bdadb = {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/Range_Bjorkvik_2411212.jpg',
    alt: 'KIA Car',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto pt-0 w-full '
};
const $e94f4eb2b4b70f4e$export$e5ed6d90743c5cbe = {
    title: "Erbjudande fr\xe5n Kia.",
    text: "Just nu har vi f\xf6rst\xe4rkta erbjudanden p\xe5 flera popul\xe4ra elbilar och laddhybrider med privatleasing. Se \xe4ven v\xe5ra \xf6vriga erbjudanden f\xf6r privatpersoner och f\xf6retag. V\xe4lkommen in och uppt\xe4ck den laddbara friheten med Kia."
};
const $e94f4eb2b4b70f4e$export$504adf9f4f4e1bc = {
    text: "L\xe4s mer om erbjudandena.",
    textSize: '16px',
    url: 'https://www.kia.com/se/kopa/erbjudanden/',
    className: 'mt-6 mb-6 ',
    openInNewTab: false
};

});


parcelRegister("dqm4D", function(module, exports) {

$parcel$export(module.exports, "ThemeEnum", function () { return $999ec13d6e2dab25$export$b001bf2df04bbbf1; });
$parcel$export(module.exports, "defaultOptions", function () { return $999ec13d6e2dab25$export$ba43bf67f3d48107; });
$parcel$export(module.exports, "default", function () { return $999ec13d6e2dab25$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $655D0 = parcelRequire("655D0");

var $8uZ4e = parcelRequire("8uZ4e");

var $1lSPe = parcelRequire("1lSPe");

var $f0NwZ = parcelRequire("f0NwZ");

var $a3tFn = parcelRequire("a3tFn");

const $999ec13d6e2dab25$var$NewsLetterControls = /*#__PURE__*/ (0, $8FY87.lazy)(()=>(parcelRequire("aCwBf")));
var $999ec13d6e2dab25$export$b001bf2df04bbbf1 = /*#__PURE__*/ function(ThemeEnum) {
    ThemeEnum["GREY"] = "Grey";
    ThemeEnum["LIGHT"] = "Light";
    ThemeEnum["DARK"] = "Dark";
    return ThemeEnum;
}({});
const $999ec13d6e2dab25$export$ba43bf67f3d48107 = {
    theme: "Grey",
    heading: 'Nyhetsbrev',
    description: "F\xe5 de senaste nyheterna kring lanseringar av nya bilar, kampanjer, event och andra sp\xe4nnande reportage genom att g\xe5 med i nyhetsbrevet.",
    buttonLabel: "G\xe5 med i nyhetsbrev",
    checkboxLabel: "Nyhetsbrev. Jag samtycker till att Kia Sverige AB behandlar mina personuppgifter och f\xf6rser mig med information fr\xe5n Kia Sverige. Jag kan n\xe4r som helst s\xe4ga upp prenumerationen p\xe5 ett visst e-postnyhetsbrev eller liknande kommunikation genom att f\xf6lja anvisningarna i respektive kommunikation.",
    emailPlaceholder: 'Ange din e-postadress',
    thankYouMessage: "Tack f\xf6r att du prenumererar p\xe5 v\xe5rt nyhetsbrev!"
};
const $999ec13d6e2dab25$var$NewsLetter = ({ hideControls: hideControls, onSettingsChange: onSettingsChange, ...optionProps })=>{
    const [email, setEmail] = (0, $8FY87.useState)('');
    const [acceptedTerms, setAcceptedTerms] = (0, $8FY87.useState)(false);
    const [options, setOptions] = (0, $8FY87.useState)($999ec13d6e2dab25$export$ba43bf67f3d48107);
    const [error, setError] = (0, $8FY87.useState)(null);
    const [termsOpen, setTermsOpen] = (0, $8FY87.useState)(false);
    const [formState, setFormState] = (0, $8FY87.useState)('idle');
    (0, $8FY87.useEffect)(()=>{
        if (onSettingsChange) onSettingsChange(options);
    }, [
        options
    ]);
    (0, $8FY87.useEffect)(()=>{
        setOptions((prevOptions)=>{
            if (Object.keys(optionProps).every((key)=>prevOptions[key] === optionProps[key])) return prevOptions;
            return {
                ...prevOptions,
                ...optionProps
            };
        });
    }, [
        optionProps
    ]);
    const handleFormError = ()=>{
        setError(null);
        if (!email) {
            setError("V\xe4nligen ange din e-postadress");
            return false;
        } else if (!acceptedTerms) {
            setError("V\xe4nligen acceptera villkoren");
            return false;
        } else if (!(0, $1lSPe.validEmail)(email)) {
            setError("V\xe4nligen ange en giltig e-postadress");
            return false;
        }
        return true;
    };
    const handleSubmit = async ()=>{
        setFormState('loading');
        const valid = handleFormError();
        if (!valid) {
            setFormState('idle');
            return;
        }
        const { status: status } = await (0, $8uZ4e.subscribeToApsisNewsletter)({
            email: email,
            url: window.location.href
        });
        if (status !== 200) {
            setError("N\xe5got gick fel, v\xe4nligen f\xf6rs\xf6k igen senare");
            setFormState('idle');
            return;
        }
        (0, $655D0.trackEvent)({
            event: 'newsletter_signup'
        });
        setFormState('success');
    };
    const themeClasses = ()=>{
        switch(options.theme){
            case "Light":
                return 'bg-white border border-black border-opacity-10';
            case "Dark":
                return 'bg-black !text-white';
            default:
                return 'bg-kia-grey';
        }
    };
    const getSnippetProps = ()=>{
        return Object.entries(options).map(([key, value])=>{
            return value ? `${key}="${value.replaceAll('"', "'")}"` : '';
        }).join(' ');
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "max-w-screen-kia-sm mx-auto relative px-4",
        children: [
            !(0, $1lSPe.locationIsKia)() && !hideControls ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)($999ec13d6e2dab25$var$NewsLetterControls, {
                        setOptions: setOptions
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                        page: "newsletter",
                        props: getSnippetProps()
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: `p-7 text-center grid sm:grid-cols-2 gap-6 my-4 ${themeClasses()}`,
                children: formState === 'success' ? /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: "col-span-2 px-10 py-20",
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                        className: "large",
                        children: options.thankYouMessage
                    })
                }) : /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: "flex flex-col gap-5",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                                    className: "large sm:text-left",
                                    children: options.heading
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                    className: "text-left",
                                    children: options.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("form", {
                            onSubmit: (e)=>{
                                e.preventDefault();
                                handleSubmit();
                            },
                            className: "grid gap-4",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: "w-full flex flex-col gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                            htmlFor: "newsletterEmail",
                                            className: "sr-only",
                                            children: options.emailPlaceholder
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                            type: "email",
                                            name: "newsletterEmail",
                                            autoComplete: "email",
                                            id: "newsletterEmail",
                                            placeholder: options.emailPlaceholder,
                                            className: "border-black border p-4 w-full h-auto placeholder:text-black !text-black focus-visible:outline-black",
                                            value: email,
                                            onChange: (e)=>setEmail(e.target.value)
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("label", {
                                            htmlFor: "acceptTerms",
                                            className: "flex gap-2 w-full",
                                            children: [
                                                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                        onChange: (e)=>{
                                                            setAcceptedTerms(e.target.checked);
                                                        },
                                                        id: "acceptTerms",
                                                        checked: acceptedTerms,
                                                        type: "checkbox",
                                                        className: "self-start",
                                                        title: options.checkboxLabel
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                    className: "relative text-left",
                                                    children: [
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                            className: `underline text-left text-sm pr-4 ${termsOpen ? '' : 'line-clamp-1'}`,
                                                            dangerouslySetInnerHTML: {
                                                                __html: options.checkboxLabel
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                            onClick: (e)=>{
                                                                e.preventDefault();
                                                                setTermsOpen(!termsOpen);
                                                            },
                                                            className: `absolute right-0 top-0 ${termsOpen ? 'rotate-180' : ''}`,
                                                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                                                                width: "18",
                                                                height: "18",
                                                                viewBox: "0 0 18 18",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                                                                    d: "M4.5 6.75L9 11.25L13.5 6.75",
                                                                    stroke: "Dark" === options.theme ? 'white' : 'black',
                                                                    strokeWidth: "2",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: "flex flex-col gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a3tFn.default), {
                                            state: formState === 'loading' ? 'loading' : 'idle',
                                            mode: "dark",
                                            type: "submit",
                                            children: options.buttonLabel
                                        }),
                                        error ? /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                            className: "text-red-500",
                                            children: error
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $999ec13d6e2dab25$export$2e2bcd8739ae039 = $999ec13d6e2dab25$var$NewsLetter;

});
parcelRegister("8uZ4e", function(module, exports) {

$parcel$export(module.exports, "subscribeToApsisNewsletter", function () { return $362192585d4b7220$export$ec7cb178cf36adc5; });

var $jZedf = parcelRequire("jZedf");

var $1lSPe = parcelRequire("1lSPe");
const $362192585d4b7220$export$ec7cb178cf36adc5 = async ({ email: email, url: url })=>{
    return await (0, $jZedf.fetchWithType)(`${(0, $1lSPe.getAdminUrl)()}/api/subscribe`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${(0, $1lSPe.getApiToken)()}`
        },
        body: JSON.stringify({
            email: email,
            url: url
        })
    });
};

});

parcelRegister("aCwBf", function(module, exports) {

module.exports = (parcelRequire("a0MnV"))($parcel$resolve("a1AD2")).then(()=>parcelRequire('5wNWv'));

});


parcelRegister("1ZMj6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $585a87c974a9a05a$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $8FY87 = parcelRequire("8FY87");

var $51Ucj = parcelRequire("51Ucj");

var $6w4kh = parcelRequire("6w4kh");

var $89E8A = parcelRequire("89E8A");

var $5ANQT = parcelRequire("5ANQT");

var $lsG22 = parcelRequire("lsG22");

var $6z9m3 = parcelRequire("6z9m3");

var $8fOnD = parcelRequire("8fOnD");

var $kZPx9 = parcelRequire("kZPx9");

var $jeu8h = parcelRequire("jeu8h");

var $f0NwZ = parcelRequire("f0NwZ");

var $3eb7t = parcelRequire("3eb7t");

var $2FCIq = parcelRequire("2FCIq");

var $eRN6V = parcelRequire("eRN6V");

var $cw9vq = parcelRequire("cw9vq");
const $585a87c974a9a05a$var$Page100 = ()=>{
    const [hideControls] = (0, $8FY87.useState)(true);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("main", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $6z9m3.default), {
                    ...(0, $cw9vq.hero100Page)
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "w-full max-w-screen-kia mx-auto",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "max-w-7xl mx-auto",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            className: "font-light text-[18px] px-2 mt-[28px]",
                            children: (0, $cw9vq.text100page001)
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kZPx9.TextBox), {
                            ...(0, $cw9vq.textBox100Page)
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8fOnD.default), {
                            ...(0, $cw9vq.imgAndTextCarCard100Page)
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $lsG22.default), {
                        id: "car-models",
                        className: "my-6",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                                className: "text-center p-2 font-medium text-[32px] md:text-[40px] leading-[48px] mb-3 whitespace-pre-line break-normal",
                                style: {
                                    hyphens: 'none',
                                    overflowWrap: 'normal'
                                },
                                variants: (0, $51Ucj.itemVariants),
                                children: (0, $cw9vq.subHeadingOne100Page).text
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                                variants: (0, $51Ucj.itemVariants),
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eRN6V.default), {
                                    hideControls: hideControls,
                                    pricelist: false,
                                    fields: "Uppt\xe4ck bilen",
                                    heading: "",
                                    imageType: (0, $5ANQT.ImageTypeEnum).STUDIO,
                                    fuelId: "1,2",
                                    categoryIds: ""
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $lsG22.default), {
                        id: "sub-hedings",
                        className: "mb-12",
                        children: /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).h2, {
                            className: "text-center p-2 font-medium text-[30px] md:text-[40px] leading-[48px] mb-3 whitespace-pre-line break-normal",
                            style: {
                                hyphens: 'none',
                                overflowWrap: 'normal'
                            },
                            variants: (0, $51Ucj.itemVariants),
                            children: [
                                "Framtidens ",
                                /*#__PURE__*/ (0, $2PPWI.jsx)("br", {
                                    className: "block md:hidden"
                                }),
                                " energil\xf6sningar i din Kia."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "mx-auto px-6",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "max-w-screen-sm mx-auto",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                    ...(0, $cw9vq.kiaImageOne100Page)
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                                className: "border-b pb-24 border-black/20 mx-auto px-6 w-full max-w-7xl",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                                    firstComponentWidth: "col-span-4 ",
                                    secondComponentWidth: "col-span-4",
                                    mainBoxClassName: "mx-auto w-full max-w-7xl",
                                    firstComponentClassName: "p-0 lg:p-10 lg:pt-0",
                                    secondComponentClassName: "p-0 lg:p-10 lg:pt-0",
                                    firstComponent: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                                className: "text-[20px]  md:text-[22px] leading-[28px] font-semibold mt-10 mb-6 ",
                                                children: (0, $cw9vq.twoComponentsText100Page).firstComponent.title
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                className: "text-base md:text-[18px] font-light",
                                                children: (0, $cw9vq.twoComponentsText100Page).firstComponent.text
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                className: "mt-2 text-xs font-light text-gray-700",
                                                children: (0, $cw9vq.twoComponentsText100Page).firstComponent.disclaimer
                                            })
                                        ]
                                    }),
                                    secondComponent: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                                className: "text-[20px]  md:text-[22px] leading-[28px] font-semibold mt-10 mb-6 ",
                                                children: (0, $cw9vq.twoComponentsText100Page).secondComponent.title
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                className: "text-base md:text-[18px] font-light",
                                                children: (0, $cw9vq.twoComponentsText100Page).secondComponent.text
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                                className: "h-12 mt-4",
                                                ...(0, $cw9vq.twoComponentsText100Page).secondComponent.link
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: "border-b border-black/20 md:border-none p-4 mt-12 mx-auto w-full max-w-7xl",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponentWidth: "col-span-4",
                            secondComponentWidth: "col-span-4",
                            mainBoxClassName: "mx-auto w-full max-w-7xl",
                            firstComponentClassName: "p-3 lg:p-10 lg:pt-0",
                            secondComponentClassName: "p-0",
                            mobilFirstComponentOnTop: true,
                            desktopFirstComponentFirst: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $89E8A.default), {
                                title: (0, $cw9vq.twoComponentsTextandImg100Page01).title,
                                text: (0, $cw9vq.twoComponentsTextandImg100Page01).text,
                                links: (0, $cw9vq.twoComponentsTextandImg100Page01).links,
                                titleClassName: "text-[28px]  lg:text-[36px] leading-[40px] font-semibold mb-6 ",
                                textClassName: "text-[16px] md:text-[18px] leading-[24px] font-light"
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                ...(0, $cw9vq.kiaImage100Page01)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: "border-b border-black/20 md:border-none p-4 mx-auto w-full max-w-7xl",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponentWidth: "col-span-4",
                            secondComponentWidth: "col-span-4",
                            mainBoxClassName: "mx-auto w-full max-w-7xl",
                            firstComponentClassName: " pt-0",
                            secondComponentClassName: "p-3 lg:p-10 lg:pt-0",
                            mobilFirstComponentOnTop: false,
                            desktopFirstComponentFirst: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                ...(0, $cw9vq.kiaImage100Page02)
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $89E8A.default), {
                                title: (0, $cw9vq.twoComponentsTextandImg100Page02).title,
                                text: (0, $cw9vq.twoComponentsTextandImg100Page02).text,
                                links: (0, $cw9vq.twoComponentsTextandImg100Page02).links,
                                titleClassName: "text-[28px]  lg:text-[36px] leading-[40px] font-semibold mb-6 ",
                                textClassName: "text-[16px] md:text-[18px] leading-[24px] font-light"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: "border-b border-black/20 md:border-none p-4 mx-auto w-full max-w-7xl",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponentWidth: "col-span-4",
                            secondComponentWidth: "col-span-4",
                            mainBoxClassName: "mx-auto w-full max-w-7xl",
                            firstComponentClassName: "p-3 lg:p-10 lg:pt-0",
                            secondComponentClassName: "p-0",
                            mobilFirstComponentOnTop: true,
                            desktopFirstComponentFirst: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $89E8A.default), {
                                title: (0, $cw9vq.twoComponentsTextandImg100Page03).title,
                                text: (0, $cw9vq.twoComponentsTextandImg100Page03).text,
                                links: (0, $cw9vq.twoComponentsTextandImg100Page03).links,
                                titleClassName: "text-[28px]  lg:text-[36px] leading-[40px] font-semibold mb-6 ",
                                textClassName: "text-[16px] md:text-[18px] leading-[24px] font-light"
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                ...(0, $cw9vq.kiaImage100Page03)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: "border-b border-black/20 md:border-none p-4 mx-auto w-full max-w-7xl",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponentWidth: "col-span-4",
                            secondComponentWidth: "col-span-4",
                            mainBoxClassName: "mx-auto w-full max-w-7xl",
                            firstComponentClassName: " pt-0",
                            secondComponentClassName: "p-3 lg:p-10 lg:pt-0",
                            mobilFirstComponentOnTop: false,
                            desktopFirstComponentFirst: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                ...(0, $cw9vq.kiaImage100Page04)
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $89E8A.default), {
                                title: (0, $cw9vq.twoComponentsTextandImg100Page04).title,
                                text: (0, $cw9vq.twoComponentsTextandImg100Page04).text,
                                links: (0, $cw9vq.twoComponentsTextandImg100Page04).links,
                                titleClassName: "text-[28px]  lg:text-[36px] leading-[40px] font-semibold mb-6 ",
                                textClassName: "text-[16px] md:text-[18px] lg:text-[20px] leading-[24px] font-light "
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $6w4kh.default), {
                            image: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                ...(0, $cw9vq.kiaImage100Page05)
                            }),
                            title: (0, $cw9vq.centerText).title,
                            text: (0, $cw9vq.centerText).text,
                            link: (0, $cw9vq.centerText).link,
                            linkClassName: "font-medium"
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                        page: "100"
                    })
                ]
            })
        ]
    });
};
var $585a87c974a9a05a$export$2e2bcd8739ae039 = $585a87c974a9a05a$var$Page100;

});
parcelRegister("6w4kh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b18195cc7004d7b$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $2FCIq = parcelRequire("2FCIq");
const $5b18195cc7004d7b$var$CenteredImageTextLink = ({ image: image, title: title, text: text, link: link, containerClassName: containerClassName = '', imageClassName: imageClassName = '', linkClassName: linkClassName = '' })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).section, {
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        variants: (0, $51Ucj.containerVariants),
        className: `mx-auto w-full max-w-screen-kia mt-14 flex flex-col items-center text-center px-2 sm:px-4 ${containerClassName}`,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: imageClassName,
                children: image
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "mx-auto w-full max-w-screen-sm",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                        variants: (0, $51Ucj.itemVariants),
                        className: "text-[32px] md:text-[32px] font-semibold mb-8 mt-4",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                        variants: (0, $51Ucj.itemVariants),
                        className: "!text-[16px] md:text-[18px] mb-4",
                        children: text
                    })
                ]
            }),
            link && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                url: link.url,
                text: link.label,
                openInNewTab: link.openInNewTab,
                className: `mt-2 ${linkClassName}`
            })
        ]
    });
};
var $5b18195cc7004d7b$export$2e2bcd8739ae039 = $5b18195cc7004d7b$var$CenteredImageTextLink;

});

parcelRegister("89E8A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd9fec92bfb37df1$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $2FCIq = parcelRequire("2FCIq");
const $dd9fec92bfb37df1$var$TextBlock = ({ title: title, text: text, links: links, className: className = '', titleClassName: titleClassName = '', textClassName: textClassName = '', headingLevel: headingLevel = 3 })=>{
    const renderHeading = ()=>{
        switch(headingLevel){
            case 2:
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                    className: titleClassName,
                    variants: (0, $51Ucj.itemVariants),
                    children: title
                });
            case 3:
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h3, {
                    className: titleClassName,
                    variants: (0, $51Ucj.itemVariants),
                    children: title
                });
            default:
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h3, {
                    className: titleClassName,
                    variants: (0, $51Ucj.itemVariants),
                    children: title
                });
        }
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
        className: className,
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        children: [
            renderHeading(),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                className: textClassName,
                variants: (0, $51Ucj.itemVariants),
                children: text
            }),
            links && links.length > 0 && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                className: "mt-7 flex flex-col space-y-6",
                variants: (0, $51Ucj.itemVariants),
                children: links.map((link, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "flex justify-center md:justify-start",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                            url: link.url,
                            text: link.label,
                            openInNewTab: link.openInNewTab,
                            widthClass: link.widthClass
                        })
                    }, link.url ?? index))
            })
        ]
    });
};
var $dd9fec92bfb37df1$export$2e2bcd8739ae039 = $dd9fec92bfb37df1$var$TextBlock;

});

parcelRegister("8fOnD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95c4e52cb2b25772$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $fu5YU = parcelRequire("fu5YU");

var $2FCIq = parcelRequire("2FCIq");
const $95c4e52cb2b25772$var$ImgAndTextCarCard = ({ title: title, cards: cards })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
        className: "px-6 mt-7 mb-20",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                initial: "hidden",
                whileInView: "visible",
                viewport: (0, $51Ucj.viewPort),
                variants: (0, $51Ucj.itemVariants),
                className: "text-center p-2 font-medium text-[32px] md:text-[40px] leading-[48px] mb-3 whitespace-pre-line break-normal",
                children: title
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                initial: "hidden",
                whileInView: "visible",
                viewport: (0, $51Ucj.viewPort),
                variants: (0, $51Ucj.containerVariants),
                className: "grid grid-cols-1 md:grid-cols-3 gap-4 max-w-7xl mx-auto",
                children: cards.map((card, index)=>/*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
                        variants: (0, $51Ucj.itemVariants),
                        className: "flex flex-col text-left",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "flex items-end w-full md:h-96",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).img, {
                                    src: card.image,
                                    alt: card.alt,
                                    className: `object-cover w-full ${index === 1 ? 'md:h-96' : 'md:h-72'}`,
                                    variants: (0, $51Ucj.itemVariants)
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h3, {
                                variants: (0, $51Ucj.itemVariants),
                                className: "text-[20px] md:text-[24px] leading-[28px] mt-9 mb-3",
                                children: card.title
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                                variants: (0, $51Ucj.itemVariants),
                                className: "text-base leading-[24px]",
                                children: card.description
                            }),
                            card.link && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "flex justify-center md:justify-start",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                    url: card.link,
                                    text: card.linkText || "L\xe4s mer",
                                    openInNewTab: card.openInNewTab,
                                    className: "mt-2",
                                    widthClass: card.widthClass
                                })
                            }),
                            card.appLinks && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "flex gap-4 mt-4",
                                children: card.appLinks.map((appLink, idx)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $fu5YU.LinkApp), {
                                        text: appLink.text,
                                        Icon: appLink.Icon,
                                        href: appLink.href,
                                        target: appLink.target || '_blank'
                                    }, idx))
                            })
                        ]
                    }, index))
            })
        ]
    });
};
var $95c4e52cb2b25772$export$2e2bcd8739ae039 = $95c4e52cb2b25772$var$ImgAndTextCarCard;

});
parcelRegister("fu5YU", function(module, exports) {

$parcel$export(module.exports, "LinkApp", function () { return $23ca3523386962d8$export$60d97d7db8055070; });

var $2PPWI = parcelRequire("2PPWI");
const $23ca3523386962d8$export$60d97d7db8055070 = ({ text: text, Icon: Icon, href: href, target: target = '_blank' })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("a", {
        href: href,
        className: "w-32 text-sm font-semibold no-underline flex items-center justify-start gap-1 bg-white border-2 border-slate-600 rounded-lg py-1.5 px-0.5",
        target: target,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)(Icon, {}),
            text
        ]
    });
};

});


parcelRegister("cw9vq", function(module, exports) {

$parcel$export(module.exports, "hero100Page", function () { return $50cdc9247fc5ffd9$export$cdbca872710fd282; });
$parcel$export(module.exports, "text100page001", function () { return $50cdc9247fc5ffd9$export$46757be3e8284053; });
$parcel$export(module.exports, "textBox100Page", function () { return $50cdc9247fc5ffd9$export$5881f341f5ac1314; });
$parcel$export(module.exports, "imgAndTextCarCard100Page", function () { return $50cdc9247fc5ffd9$export$25fa977f8101953c; });
$parcel$export(module.exports, "subHeadingOne100Page", function () { return $50cdc9247fc5ffd9$export$f94758cb2695237a; });
$parcel$export(module.exports, "kiaImageOne100Page", function () { return $50cdc9247fc5ffd9$export$6272320460a0a268; });
$parcel$export(module.exports, "twoComponentsText100Page", function () { return $50cdc9247fc5ffd9$export$ea46f155ce60c47; });
$parcel$export(module.exports, "twoComponentsTextandImg100Page01", function () { return $50cdc9247fc5ffd9$export$3a0ce1f49af9560; });
$parcel$export(module.exports, "kiaImage100Page01", function () { return $50cdc9247fc5ffd9$export$b1a476032e4eb4cd; });
$parcel$export(module.exports, "twoComponentsTextandImg100Page02", function () { return $50cdc9247fc5ffd9$export$47889f342d14aac; });
$parcel$export(module.exports, "kiaImage100Page02", function () { return $50cdc9247fc5ffd9$export$c6d0192164050148; });
$parcel$export(module.exports, "twoComponentsTextandImg100Page03", function () { return $50cdc9247fc5ffd9$export$1331fedf3eeb3d2; });
$parcel$export(module.exports, "kiaImage100Page03", function () { return $50cdc9247fc5ffd9$export$4dd95b36e6d28a74; });
$parcel$export(module.exports, "twoComponentsTextandImg100Page04", function () { return $50cdc9247fc5ffd9$export$6b49540c4ac4a3f2; });
$parcel$export(module.exports, "kiaImage100Page04", function () { return $50cdc9247fc5ffd9$export$93b316a498d196b6; });
$parcel$export(module.exports, "centerText", function () { return $50cdc9247fc5ffd9$export$7fbfc7da7d3c2e5e; });
$parcel$export(module.exports, "kiaImage100Page05", function () { return $50cdc9247fc5ffd9$export$68d615f29d73d5c9; });

var $e2YZi = parcelRequire("e2YZi");

var $zuoP0 = parcelRequire("zuoP0");
const $50cdc9247fc5ffd9$export$cdbca872710fd282 = {
    title: '100 % laddbart',
    image: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/KIA-Elbilar-Range.jpg',
    mobileImage: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/KIA-Elbilar-Range_mobile.jpg',
    position: 'top'
};
const $50cdc9247fc5ffd9$export$46757be3e8284053 = "F\xf6r oss p\xe5 Kia har m\xe5let alltid varit att g\xf6ra det m\xf6jligt f\xf6r fler att v\xe4lja elbil eller laddhybrid och vi str\xe4var efter att 100 % av v\xe5r f\xf6rs\xe4ljning i Sverige ska vara laddbar. Redan 2014 var vi en tidig uppstickare p\xe5 elbilsmarknaden n\xe4r vi lanserade v\xe5r f\xf6rsta elbil i Sverige, Kia Soul EV, och sedan dess har vi introducerat flera omtyckta elbilar och laddhybrider p\xe5 den svenska marknaden. Genom att kontinuerligt ut\xf6ka v\xe5rt modellprogram kommer vi kunna erbjuda en elbil f\xf6r alla, i alla segment \u2013 och det kommer vara avg\xf6rande f\xf6r att vi ska n\xe5 v\xe5rt m\xe5l. Tack f\xf6r att du \xe4r med oss p\xe5 resan.";
const $50cdc9247fc5ffd9$export$5881f341f5ac1314 = {
    title: '',
    backgroundColor: '',
    numberOfFields: 3,
    titleStyle: 'mb-6 text-[32px] max-w-[627px]',
    textSize: 'text-lg leading-[24px]',
    listItems: [
        {
            text: "2024 var 85 % av v\xe5r f\xf6rs\xe4ljning i Sverige laddbar. M\xe5let \xe4r 100 % laddbart.",
            boldParts: [
                ''
            ],
            iconProps: {
                color: '#000',
                width: 24,
                height: 24,
                strokeWidth: 5
            }
        },
        {
            text: "Vi erbjuder elbilar och laddhybrider med h\xf6g teknik- och utrustningsniv\xe5 samt innovativa s\xe4kerhetssystem som standard.",
            boldParts: [
                ''
            ],
            iconProps: {
                color: '#000',
                width: 24,
                height: 24,
                strokeWidth: 5
            }
        },
        {
            text: "Med ett brett modellprogram som st\xe4ndigt ut\xf6kas g\xf6r vi det m\xf6jligt f\xf6r fler att k\xf6ra laddbart fr\xe5n Kia.",
            boldParts: [
                ''
            ],
            iconProps: {
                color: '#000',
                width: 24,
                height: 24,
                strokeWidth: 5
            }
        }
    ]
};
const $50cdc9247fc5ffd9$export$25fa977f8101953c = {
    title: "Tekniken som tar oss i m\xe5l.",
    cards: [
        {
            image: 'https://kia-afonso-storage.b-cdn.net/100procent/EV3-ladda-ultrasnabbt.jpg',
            alt: 'kia car',
            title: 'Ladda snabbt och ultrasnabbt.',
            description: "Kia EV3 laddar snabbt och s\xf6ml\xf6st fr\xe5n 10 till 80 procent p\xe5 ner till 31 minuter.\u202FTack vare 800-voltsteknik laddar Kia EV6 10 till 80 procent p\xe5 ner till 18 minuter. \xc4ven Kia EV9 \xe4r utrustad med 800-voltsteknik, och den ultrasnabba laddningen g\xe5r fr\xe5n 10 till 80 procent p\xe5 ner till 24 minuter.",
            // link: 'https://www.kia.com/se/elbil/elbil/',
            linkText: "Uppt\xe4ck v\xe5ra elbilar",
            openInNewTab: false,
            widthClass: 'w-full max-w-[300px]'
        },
        {
            image: 'https://kia-afonso-storage.b-cdn.net/100procent/Kia-plattformen-gor-det.jpg',
            alt: 'kia car',
            title: "Plattformen g\xf6r det m\xf6jligt.",
            description: "2027 kommer Kia att erbjuda 15 helt elektriska bilmodeller, som alla bygger p\xe5 plattformen E-GMP. Plattformen omfattar elbilens alla viktiga komponenter som batteri, motor och drivlina. Eftersom hjulbasen \xe4r justerbar g\xe5r plattformen att applicera p\xe5 alla typer av bilmodeller, oavsett storlek \u2013 allt fr\xe5n crossovers till suvar och transportbilar.",
            // link: 'https://www.kia.com/se/om-kia/upplev-kia/teknik/e-gmp',
            linkText: "L\xe4s mer om E-GMP",
            openInNewTab: false,
            widthClass: 'w-full max-w-[300px]'
        },
        {
            image: 'https://kia-afonso-storage.b-cdn.net/100procent/EV6_GTL_MY25_LifstyleInterior_PhoneNavi_with_Talent.png',
            alt: 'kia car',
            title: "En app f\xf6r allt som r\xf6r din Kia.",
            description: "Aktivera ditt Kia Charge-kontrakt, fj\xe4rrstyr funktioner, f\xe5 insikter kring k\xf6rdata och fordonsstatus, navigera och boka verkstadsbes\xf6k. Kia App \xe4r nyckeln till ett enkelt bil\xe4gande, d\xe4r allt \xe4r samlat p\xe5 en och samma plats.",
            appLinks: [
                {
                    text: 'Google Play',
                    Icon: (0, $zuoP0.GooglePlayIcon),
                    href: 'https://play.google.com/store/apps/details?id=com.kia.oneapp.kr&hl=en '
                },
                {
                    text: 'App Store',
                    Icon: (0, $e2YZi.AppStoreIcon),
                    href: 'https://apps.apple.com/se/app/kia-app/id6740517042'
                }
            ]
        }
    ]
};
const $50cdc9247fc5ffd9$export$f94758cb2695237a = {
    text: "Uppt\xe4ck alla v\xe5ra laddbara\n modeller."
};
const $50cdc9247fc5ffd9$export$1e974f46276454d8 = {
    text: "Framtidens energil\xf6sningar i din Kia."
};
const $50cdc9247fc5ffd9$export$6272320460a0a268 = {
    src: 'https://kia-afonso-storage.b-cdn.net/100procent/Framtidens-Energilosningar.jpg',
    alt: 'KIA Car',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto py-4 w-full max-w-7xl object-cover object-center h-auto'
};
const $50cdc9247fc5ffd9$export$ea46f155ce60c47 = {
    firstComponent: {
        title: "J\xe4mna ut effekttoppar med Vehicle-to-Grid.",
        text: "Kia EV9, Kia EV6, Kia EV5, Kia EV4 och Kia EV3 har dubbelriktad laddning och \xe4r d\xe4rmed f\xf6rberedda f\xf6r bland annat Vehicle-to-Grid (V2G)*. Det inneb\xe4r att bilen kan anv\xe4ndas f\xf6r att lagra energi som sedan kan matas in i eln\xe4tet. P\xe5 s\xe5 s\xe4tt kan  elbilen spela en viktig roll f\xf6r att j\xe4mna ut och stabilisera effekttoppar.",
        disclaimer: "* Beroende p\xe5 modellversion."
    },
    secondComponent: {
        title: "Anv\xe4nd bilen som powerbank\n med Vehicle-to-Load.",
        text: "Kia EV3, EV4, EV5, EV6 och EV9 har Vehicle-to-Load. Det inneb\xe4r att du kan anv\xe4nda bilen som mobil powerbank och p\xe5 s\xe5 s\xe4tt utnyttja elbilens kapacitet till fullo. Bilen delar med sig av upp till 80 procent av batteriets kapacitet f\xf6r att f\xf6rse vad du \xe4n \xf6nskar med str\xf6m.",
        link: {
            url: 'https://www.kia.com/se/om-kia/upplev-kia/teknik/vehicle-to-load/',
            text: "L\xe4s mer om V2L"
        }
    }
};
const $50cdc9247fc5ffd9$export$3a0ce1f49af9560 = {
    title: "N\xe4sta generations transportbilar.",
    text: "Under samlingsnamnet PBV \u2013 platform beyond vehicle \u2013 lanserar Kia eldrivna transportbilar med start 2025. Tack vare integrerad, avancerad mjukvara, modul\xe4r konstruktion och exceptionell flexibilitet kan bilarna varieras och anpassas till olika branschers och kunders specifika krav inom betydligt vidare gr\xe4nser \xe4n vad som tidigare varit m\xf6jligt. F\xf6rst att lanseras \xe4r Kia PV5 Cargo L2H1, som har upp till 416 km r\xe4ckvidd och kan snabbladdas fr\xe5n 10\u201380 % p\xe5 ner till 30 minuter.",
    links: [
        {
            url: 'https://www.kia.com/se/pbv/modellutbud/pv5-cargo/',
            label: "L\xe4s mer om PV5 Cargo",
            openInNewTab: false
        }
    ]
};
const $50cdc9247fc5ffd9$export$b1a476032e4eb4cd = {
    src: 'https://kia-afonso-storage.b-cdn.net/100procent/pv5-cargo-hero-vit.jpg',
    alt: 'KIA Car',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto pt-0 py-4 w-full '
};
const $50cdc9247fc5ffd9$export$47889f342d14aac = {
    title: "Ladda 100 % f\xf6rnybart hemma.",
    text: "N\xe4r du k\xf6per eller leasar en laddbar Kia erbjuder vi dig att teckna ett rabatterat elavtal med v\xe5r samarbetspartner Boo Energi. Du f\xe5r 100 kr rabatt i m\xe5nanden i tre \xe5r, och ett elavtal med 100 % f\xf6rnybar el fr\xe5n sol, vind och vatten.",
    links: [
        {
            url: 'https://www.kia.com/se/elbil/booenergi/',
            label: "L\xe4s mer om v\xe5rt samarbete med Boo Energi",
            openInNewTab: false,
            widthClass: 'w-full max-w-[380px]'
        }
    ]
};
const $50cdc9247fc5ffd9$export$c6d0192164050148 = {
    src: 'https://kia-afonso-storage.b-cdn.net/100procent/Ladda-100-procent.jpg',
    alt: 'KIA Car',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto pt-0 py-4 w-full '
};
const $50cdc9247fc5ffd9$export$1331fedf3eeb3d2 = {
    title: "Ladda p\xe5 v\xe4g med Kia Charge.",
    text: "Med Kia Charge f\xe5r du tillg\xe5ng till hundratusentals laddstationer \xf6ver hela Europa och kan uppleva bekv\xe4m och smidig laddning oavsett var du \xe4r. Du laddar via appen Kia Charge eller Kia Charge-kortet och kostnaden f\xf6r alla laddsessioner samlas p\xe5 en faktura. I appen ser du pris, tillg\xe4nglighet och effekt. Kia sammanst\xe4llar all el som laddas via Kia Charge och k\xf6per motsvarande m\xe4ngd f\xf6rnybar el i form av ursprungsintyg (Guarantee of Origin), n\xe5got som kontrolleras och s\xe4kerst\xe4lls av en oberoende tredjeparts-organisation.\xa0",
    links: [
        {
            url: 'https://kiacharge.com/web/sv/kia-se/service',
            label: 'Anslut till Kia Charge nu',
            openInNewTab: false
        }
    ]
};
const $50cdc9247fc5ffd9$export$4dd95b36e6d28a74 = {
    src: 'https://kia-afonso-storage.b-cdn.net/100procent/Kia%20Charge.jpg',
    alt: 'KIA Car',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto pt-0 py-4 w-full '
};
const $50cdc9247fc5ffd9$export$6b49540c4ac4a3f2 = {
    title: "V\xe5ra h\xe5llbarhetsrapporter.",
    text: "Varje \xe5r publicerar vi h\xe5llbarhetsrapporter d\xe4r vi sammanst\xe4ller det g\xe5ngna \xe5rets insatser. I den globala rapporten kan du l\xe4sa om de globala satsningarna och i Kia Sveriges h\xe5llbarhetsrapport lyfter vi de aspekter som har en direkt koppling till v\xe5r aff\xe4r, v\xe5ra k\xe4rnv\xe4rden och v\xe5r verksamhet i Sverige.",
    links: [
        {
            url: 'https://worldwide.kia.com/int/company/sustainability/sustainability-report',
            label: "Ladda ner Kias globala h\xe5llbarhetsrapport.",
            openInNewTab: false,
            widthClass: 'w-full max-w-[380px]'
        }
    ]
};
const $50cdc9247fc5ffd9$export$93b316a498d196b6 = {
    src: 'https://kia-afonso-storage.b-cdn.net/100procent/Hallbarhetsrapport-Kia.jpg',
    alt: 'KIA Car',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto pt-0 py-4 w-full '
};
const $50cdc9247fc5ffd9$export$7fbfc7da7d3c2e5e = {
    title: "Ut\xf6kad elbilsstrategi och fler modeller.",
    text: "Kia ut\xf6kar sin elbilsstrategi och breddar sitt modellprogram. Det inneb\xe4r att det snart kommer att finnas en laddbar Kia f\xf6r alla, i alla segment. Alla kommande och nuvarande elbilar fr\xe5n Kia bygger p\xe5 plattformen E-GMP, som inneb\xe4r att nya modeller kan utvecklas modul\xe4rt p\xe5 samma grund oavsett vilket segment de tillh\xf6r. F\xf6rdelarna \xe4r flera, bland annat \xe4r plattformen utformad med l\xe5ng hjulbas och plant golv vilket bidrar till rymlig interi\xf6r. Andra f\xf6rdelar \xe4r att den helelektriska drivlinan ocks\xe5 har l\xe5ng r\xe4ckvidd och snabbladdning som sitt signum. Samma plattformsprincip ligger till grund f\xf6r utvecklingen av transportbilssegmentet PBV. Plattformen kallas d\xe5 f\xf6r E-GMP.S.",
    link: {
        url: 'https://www.kia.com/se/om-kia/inspiredbykia/2025-ev-day/',
        label: "L\xe4s mer om kommande bilmodeller",
        openInNewTab: false
    }
};
const $50cdc9247fc5ffd9$export$68d615f29d73d5c9 = {
    src: 'https://kia-afonso-storage.b-cdn.net/100procent/Elbilsstrategi.jpg',
    alt: 'KIA Car',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto pt-0 py-4 w-11/12 lg:w-full'
};

});
parcelRegister("e2YZi", function(module, exports) {

$parcel$export(module.exports, "AppStoreIcon", function () { return $0febbc61c1bb721d$export$471fc58157231e0e; });

var $2PPWI = parcelRequire("2PPWI");
parcelRequire("8FY87");
const $0febbc61c1bb721d$export$471fc58157231e0e = ()=>/*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        fill: "#000000",
        width: "30px",
        height: "30px",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
            d: "M17.564 13.862c-.413.916-.612 1.325-1.144 2.135-.742 1.13-1.79 2.538-3.087 2.55-1.152.01-1.448-.75-3.013-.741-1.564.008-1.89.755-3.043.744-1.297-.012-2.29-1.283-3.033-2.414-2.077-3.16-2.294-6.87-1.013-8.843.91-1.401 2.347-2.221 3.697-2.221 1.375 0 2.24.754 3.376.754 1.103 0 1.775-.756 3.365-.756 1.2 0 2.474.655 3.381 1.785-2.972 1.629-2.49 5.873.514 7.007zM12.463 3.808c.577-.742 1.016-1.788.857-2.858-.944.065-2.047.665-2.692 1.448-.584.71-1.067 1.763-.88 2.787 1.03.031 2.096-.584 2.715-1.377z"
        })
    });

});

parcelRegister("zuoP0", function(module, exports) {

$parcel$export(module.exports, "GooglePlayIcon", function () { return $09eda55a27791184$export$c550f7146e4ffb94; });

var $2PPWI = parcelRequire("2PPWI");
const $09eda55a27791184$export$c550f7146e4ffb94 = ()=>/*#__PURE__*/ (0, $2PPWI.jsxs)("svg", {
        width: "30px",
        height: "30px",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("mask", {
                id: "mask0_87_8320",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "3",
                width: "24",
                height: "26",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M30.0484 14.4004C31.3172 15.0986 31.3172 16.9014 30.0484 17.5996L9.75627 28.7659C8.52052 29.4459 7 28.5634 7 27.1663L7 4.83374C7 3.43657 8.52052 2.55415 9.75627 3.23415L30.0484 14.4004Z",
                    fill: "#C4C4C4"
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("g", {
                mask: "url(#mask0_87_8320)",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                        d: "M7.63473 28.5466L20.2923 15.8179L7.84319 3.29883C7.34653 3.61721 7 4.1669 7 4.8339V27.1664C7 27.7355 7.25223 28.2191 7.63473 28.5466Z",
                        fill: "url(#paint0_linear_87_8320)"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                        d: "M30.048 14.4003C31.3169 15.0985 31.3169 16.9012 30.048 17.5994L24.9287 20.4165L20.292 15.8175L24.6923 11.4531L30.048 14.4003Z",
                        fill: "url(#paint1_linear_87_8320)"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                        d: "M24.9292 20.4168L20.2924 15.8179L7.63477 28.5466C8.19139 29.0232 9.02389 29.1691 9.75635 28.766L24.9292 20.4168Z",
                        fill: "url(#paint2_linear_87_8320)"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                        d: "M7.84277 3.29865L20.2919 15.8177L24.6922 11.4533L9.75583 3.23415C9.11003 2.87878 8.38646 2.95013 7.84277 3.29865Z",
                        fill: "url(#paint3_linear_87_8320)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("linearGradient", {
                        id: "paint0_linear_87_8320",
                        x1: "15.6769",
                        y1: "10.874",
                        x2: "7.07106",
                        y2: "19.5506",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("stop", {
                                stopColor: "#00C3FF"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1BE2FA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("linearGradient", {
                        id: "paint1_linear_87_8320",
                        x1: "20.292",
                        y1: "15.8176",
                        x2: "31.7381",
                        y2: "15.8176",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("stop", {
                                stopColor: "#FFCE00"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFEA00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("linearGradient", {
                        id: "paint2_linear_87_8320",
                        x1: "7.36932",
                        y1: "30.1004",
                        x2: "22.595",
                        y2: "17.8937",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("stop", {
                                stopColor: "#DE2453"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FE3944"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("linearGradient", {
                        id: "paint3_linear_87_8320",
                        x1: "8.10725",
                        y1: "1.90137",
                        x2: "22.5971",
                        y2: "13.7365",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("stop", {
                                stopColor: "#11D574"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("stop", {
                                offset: "1",
                                stopColor: "#01F176"
                            })
                        ]
                    })
                ]
            })
        ]
    });

});



parcelRegister("gUWYS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae198bc2f70fc0aa$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $1lSPe = parcelRequire("1lSPe");

var $5JLKp = parcelRequire("5JLKp");

var $7WjIR = parcelRequire("7WjIR");

var $6ranG = parcelRequire("6ranG");

var $9N3d6 = parcelRequire("9N3d6");

var $gTvaa = parcelRequire("gTvaa");

var $l34aq = parcelRequire("l34aq");

var $fe54Q = parcelRequire("fe54Q");

var $9UIBy = parcelRequire("9UIBy");

var $hfcW7 = parcelRequire("hfcW7");

var $jGzhv = parcelRequire("jGzhv");

var $aBQcF = parcelRequire("aBQcF");

const $ae198bc2f70fc0aa$var$Pdf = ({ pdfName: pdfName })=>{
    const [pdf, setPdf] = (0, $8FY87.useState)(null);
    const [lead, setLead] = (0, $8FY87.useState)(null);
    const containerRef = (0, $8FY87.useRef)(null);
    const pdfRef = (0, $8FY87.useRef)(null);
    const [key, setKey] = (0, $8FY87.useState)(0);
    const [menuTitle, setMenuTitle] = (0, $8FY87.useState)('');
    const [subject, setSubject] = (0, $8FY87.useState)('');
    const [scrolledPast, setScrolledPast] = (0, $8FY87.useState)(false);
    const loadPdfData = async (slug)=>{
        const modulesMap = {
            'matt-lack': ()=>(parcelRequire("c7bfI"))
        };
        try {
            if (modulesMap[slug]) {
                const pdfData = await modulesMap[slug]();
                setPdf(pdfData.pdf);
                setLead(pdfData.lead);
                setSubject(pdfData.tableOfContents.subject);
                setMenuTitle(pdfData.tableOfContents.menuTitle);
                setKey((prevKey)=>prevKey + 1);
            } else console.error('Module not found for slug:', slug);
        } catch (error) {
            console.error('Error loading pdf data', error);
        }
    };
    const handlePdfSelect = (0, $8FY87.useCallback)((slug)=>{
        loadPdfData(slug);
    }, []);
    (0, $8FY87.useEffect)(()=>{
        if (pdfName) loadPdfData(pdfName);
    }, [
        pdfName
    ]);
    (0, $8FY87.useEffect)(()=>{
        const handleScroll = ()=>{
            if (!pdfRef.current) return;
            const { top: top } = pdfRef.current.getBoundingClientRect();
            setScrolledPast(top < 0);
        };
        window.addEventListener('scroll', handleScroll);
        return ()=>window.removeEventListener('scroll', handleScroll);
    });
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        children: [
            !(0, $1lSPe.locationIsKia)() ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9UIBy.PdfSelector), {
                        onPdfSelect: handlePdfSelect
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "snb-parent sticky top-0 w-full h-20 sm:h-32 bg-blue-500",
                        children: "Mocked kia sticky header"
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                ref: pdfRef,
                className: "w-full max-w-screen-kia-sm mx-auto ",
                children: [
                    pdf && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $7WjIR.PdfDropdown), {
                        scrolledPast: scrolledPast,
                        menuTitle: menuTitle,
                        subject: subject,
                        children: (closeDropdown)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $5JLKp.PdfContentMenuDropdown), {
                                containerRef: containerRef,
                                closeDropdown: closeDropdown
                            }, key)
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "flex flex-col justify-center",
                        children: [
                            lead && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $gTvaa.PdfLead), {
                                data: {
                                    leadTitle: lead.leadTitle,
                                    content: lead.content
                                }
                            }, "lead"),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                ref: containerRef,
                                className: "flex flex-col gap-5 mt-8 mb-4 w-full",
                                children: pdf ? pdf.map((item, index)=>{
                                    switch(item.type){
                                        case 'heading':
                                            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $6ranG.PdfHeading), {
                                                data: item.data
                                            }, index);
                                        case 'sub-heading':
                                            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $hfcW7.PdfSubHeading), {
                                                data: item.data
                                            }, index);
                                        case 'paragraph':
                                            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $fe54Q.PdfParagraph), {
                                                data: item.data
                                            }, index);
                                        case 'tip':
                                            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jGzhv.PdfTip), {
                                                data: item.data
                                            }, index);
                                        case 'ul':
                                            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $aBQcF.PdfUnorderedList), {
                                                data: item.data
                                            }, index);
                                        case 'ol':
                                            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $l34aq.PdfOrderedList), {
                                                data: item.data
                                            }, index);
                                        case 'img':
                                            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9N3d6.PdfImage), {
                                                data: item.data
                                            }, index);
                                        default:
                                            return null;
                                    }
                                }) : null
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $ae198bc2f70fc0aa$export$2e2bcd8739ae039 = $ae198bc2f70fc0aa$var$Pdf;

});
parcelRegister("5JLKp", function(module, exports) {

$parcel$export(module.exports, "PdfContentMenuDropdown", function () { return $7bb1e54c5eff0e91$export$bf45a76aa82d5a95; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $dMcco = parcelRequire("dMcco");
const $7bb1e54c5eff0e91$export$bf45a76aa82d5a95 = ({ containerRef: containerRef, closeDropdown: closeDropdown })=>{
    const { menuItems: menuItems, handleScroll: handleScroll } = (0, $dMcco.useGeneratesMenu)(containerRef);
    const dropdownRef = (0, $8FY87.useRef)(null);
    const handleClick = (id)=>{
        handleScroll(id);
        if (closeDropdown) closeDropdown();
    };
    const handleClickOutside = (e)=>{
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) closeDropdown();
    };
    (0, $8FY87.useEffect)(()=>{
        if (window.innerWidth < 768) document.body.classList.add('overflow-hidden');
        document.addEventListener('click', handleClickOutside);
        return ()=>{
            document.body.classList.remove('overflow-hidden');
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        ref: dropdownRef,
        className: "dropdown-content max-h-60 overflow-auto",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
            className: " absolute flex flex-col gap-3 pb-4 pt-2 w-full overflow-auto shadow-lg bg-white md:w-fit max-h-screen",
            children: menuItems.map((item)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                            href: `#${item.id}`,
                            className: " ml-2 text-lg px-2 font-semibold no-underline hover:underline  ",
                            onClick: (e)=>{
                                e.preventDefault();
                                handleClick(item.id);
                            },
                            children: item.title
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: "border-b-2 pb-4 mb-2 w-full"
                        }),
                        item.children && item.children.length > 0 && /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                            children: item.children.map((child)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                    className: "pb-2 px-8 space-y-1",
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                        href: `#${child.id}`,
                                        className: "no-underline hover:underline",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            handleClick(child.id);
                                        },
                                        children: child.title
                                    })
                                }, child.id))
                        })
                    ]
                }, item.id))
        })
    });
};

});
parcelRegister("dMcco", function(module, exports) {

$parcel$export(module.exports, "useGeneratesMenu", function () { return $ff250b82eb8d0d1d$export$cad1f4f66c972567; });

var $8FY87 = parcelRequire("8FY87");

var $8RPww = parcelRequire("8RPww");
const $ff250b82eb8d0d1d$export$cad1f4f66c972567 = (containerRef)=>{
    const [menuItems, setMenuItems] = (0, $8FY87.useState)([]);
    (0, $8FY87.useEffect)(()=>{
        if (!containerRef.current) return;
        const newMenuItems = [];
        const headings = containerRef.current.querySelectorAll('h2, h3');
        headings.forEach((heading)=>{
            const headingText = heading.textContent;
            const uniqueId = (0, $8RPww.default)();
            heading.setAttribute('id', uniqueId);
            if (heading.tagName.toLowerCase() === 'h2') newMenuItems.push({
                title: headingText,
                id: uniqueId,
                children: []
            });
            else if (heading.tagName.toLowerCase() === 'h3') {
                const currentH2 = newMenuItems[newMenuItems.length - 1];
                if (currentH2) currentH2.children?.push({
                    title: headingText,
                    id: uniqueId
                });
            }
        });
        setMenuItems(newMenuItems);
    }, [
        containerRef
    ]);
    const handleScroll = (id)=>{
        const target = document.getElementById(id);
        if (!target) return;
        const yOffset = window.innerWidth < 768 ? -150 : -200;
        const yPosition = target.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({
            top: yPosition,
            behavior: 'smooth'
        });
    };
    return {
        menuItems: menuItems,
        handleScroll: handleScroll
    };
};

});
parcelRegister("8RPww", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $674b3d77ec11b4a3$export$2e2bcd8739ae039; });

var $5eIiC = parcelRequire("5eIiC");

var $gegXr = parcelRequire("gegXr");

var $j8hyO = parcelRequire("j8hyO");
function $674b3d77ec11b4a3$var$v4(options, buf, offset) {
    if ((0, $5eIiC.default).randomUUID && !buf && !options) return (0, $5eIiC.default).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, $gegXr.default))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $j8hyO.unsafeStringify)(rnds);
}
var $674b3d77ec11b4a3$export$2e2bcd8739ae039 = $674b3d77ec11b4a3$var$v4;

});
parcelRegister("5eIiC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d009f73c3d55c65$export$2e2bcd8739ae039; });
var $3d009f73c3d55c65$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $3d009f73c3d55c65$export$2e2bcd8739ae039 = {
    randomUUID: $3d009f73c3d55c65$var$randomUUID
};

});

parcelRegister("gegXr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd0b1b99a1c4101f$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $bd0b1b99a1c4101f$var$getRandomValues;
var $bd0b1b99a1c4101f$var$rnds8 = new Uint8Array(16);
function $bd0b1b99a1c4101f$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$bd0b1b99a1c4101f$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $bd0b1b99a1c4101f$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$bd0b1b99a1c4101f$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $bd0b1b99a1c4101f$var$getRandomValues($bd0b1b99a1c4101f$var$rnds8);
}

});

parcelRegister("j8hyO", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", function () { return $dedc62d279de0424$export$8fb373d660548968; });

var $b0bqy = parcelRequire("b0bqy");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $dedc62d279de0424$var$byteToHex = [];
for(var $dedc62d279de0424$var$i = 0; $dedc62d279de0424$var$i < 256; ++$dedc62d279de0424$var$i)$dedc62d279de0424$var$byteToHex.push(($dedc62d279de0424$var$i + 0x100).toString(16).slice(1));
function $dedc62d279de0424$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return ($dedc62d279de0424$var$byteToHex[arr[offset + 0]] + $dedc62d279de0424$var$byteToHex[arr[offset + 1]] + $dedc62d279de0424$var$byteToHex[arr[offset + 2]] + $dedc62d279de0424$var$byteToHex[arr[offset + 3]] + '-' + $dedc62d279de0424$var$byteToHex[arr[offset + 4]] + $dedc62d279de0424$var$byteToHex[arr[offset + 5]] + '-' + $dedc62d279de0424$var$byteToHex[arr[offset + 6]] + $dedc62d279de0424$var$byteToHex[arr[offset + 7]] + '-' + $dedc62d279de0424$var$byteToHex[arr[offset + 8]] + $dedc62d279de0424$var$byteToHex[arr[offset + 9]] + '-' + $dedc62d279de0424$var$byteToHex[arr[offset + 10]] + $dedc62d279de0424$var$byteToHex[arr[offset + 11]] + $dedc62d279de0424$var$byteToHex[arr[offset + 12]] + $dedc62d279de0424$var$byteToHex[arr[offset + 13]] + $dedc62d279de0424$var$byteToHex[arr[offset + 14]] + $dedc62d279de0424$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $dedc62d279de0424$var$stringify(arr, offset = 0) {
    var uuid = $dedc62d279de0424$export$8fb373d660548968(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $b0bqy.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $dedc62d279de0424$export$2e2bcd8739ae039 = $dedc62d279de0424$var$stringify;

});
parcelRegister("b0bqy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80288f08856c03d1$export$2e2bcd8739ae039; });

var $dVJHO = parcelRequire("dVJHO");
function $80288f08856c03d1$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $dVJHO.default).test(uuid);
}
var $80288f08856c03d1$export$2e2bcd8739ae039 = $80288f08856c03d1$var$validate;

});
parcelRegister("dVJHO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2440d684776c94a$export$2e2bcd8739ae039; });
var $a2440d684776c94a$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});






parcelRegister("7WjIR", function(module, exports) {

$parcel$export(module.exports, "PdfDropdown", function () { return $1317e4d3abdd003f$export$4ea209154d03f79; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $8qMcq = parcelRequire("8qMcq");
const $1317e4d3abdd003f$export$4ea209154d03f79 = ({ menuTitle: menuTitle = "Inneh\xe5llsf\xf6rteckning", scrolledPast: scrolledPast, children: children })=>{
    const [isOpen, setIsOpen] = (0, $8FY87.useState)(false);
    const menuRef = (0, $8FY87.useRef)(null);
    const [dropdownPosition, setDropdownPosition] = (0, $8FY87.useState)(0);
    const toggleDropdown = (e)=>{
        e.stopPropagation();
        if (!isOpen && menuRef.current) menuRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
        setIsOpen(!isOpen);
    };
    const closeDropdown = ()=>setIsOpen(false);
    (0, $8FY87.useEffect)(()=>{
        const stickyHeader = document.querySelector('.snb-parent');
        if (!stickyHeader) return;
        setDropdownPosition(stickyHeader.clientHeight);
        const handleResize = ()=>{
            setDropdownPosition(stickyHeader.clientHeight);
        };
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                ref: menuRef,
                className: "w-full max-w-screen-kia-sm",
                style: {
                    top: `${scrolledPast ? dropdownPosition : 0}px`,
                    position: scrolledPast ? 'fixed' : 'relative'
                },
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: "flex p-2 flex-row gap-2 bg-white items-center border-gray-200 border-b-2",
                            children: /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                                onClick: (e)=>toggleDropdown(e),
                                className: "z-20 text-lg font-semibold flex items-center gap-2 bg-dark-blue text-white py-2 px-2",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8qMcq.HamburgerIcon), {
                                        isOpen: isOpen,
                                        strokeColor: "#000000"
                                    }),
                                    menuTitle
                                ]
                            })
                        }),
                        isOpen && children(closeDropdown)
                    ]
                })
            }),
            scrolledPast ? /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                style: {
                    height: '60px'
                }
            }) : null
        ]
    });
};

});
parcelRegister("8qMcq", function(module, exports) {

$parcel$export(module.exports, "HamburgerIcon", function () { return $00b3ab035328c737$export$e369611dc3dfbf44; });

var $2PPWI = parcelRequire("2PPWI");
const $00b3ab035328c737$export$e369611dc3dfbf44 = ({ isOpen: isOpen, strokeColor: strokeColor = "black" })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        className: "absolut z-20 cursor-pointer w-6 h-6",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: isOpen ? /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
            d: "M6 6L18 18M6 18L18 6",
            stroke: strokeColor,
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }) : /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M3 12H21",
                    stroke: strokeColor,
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M3 6H21",
                    stroke: strokeColor,
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M3 18H21",
                    stroke: strokeColor,
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};

});


parcelRegister("6ranG", function(module, exports) {

$parcel$export(module.exports, "PdfHeading", function () { return $fca5ffc9dd312534$export$20fdd5ac58f5b12d; });

var $2PPWI = parcelRequire("2PPWI");
const $fca5ffc9dd312534$export$20fdd5ac58f5b12d = ({ data: data })=>{
    const { content: content } = data;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
        className: "text-xl scroll-mt-16 px-2 ",
        children: content
    });
};

});

parcelRegister("9N3d6", function(module, exports) {

$parcel$export(module.exports, "PdfImage", function () { return $69a9efe24503ed00$export$ee8313b7edf5feab; });

var $2PPWI = parcelRequire("2PPWI");
const $69a9efe24503ed00$export$ee8313b7edf5feab = ({ data: data })=>{
    const { src: src } = data;
    const { alt: alt } = data;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
        src: src,
        alt: alt,
        className: "w-max"
    });
};

});

parcelRegister("gTvaa", function(module, exports) {

$parcel$export(module.exports, "PdfLead", function () { return $0a17aa4fc576e088$export$cdd7ba01ccbff49a; });

var $2PPWI = parcelRequire("2PPWI");
const $0a17aa4fc576e088$export$cdd7ba01ccbff49a = ({ data: data })=>{
    const { leadTitle: leadTitle } = data;
    const { content: content } = data;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                className: "mt-4 mb-2 px-2 text-3xl",
                children: leadTitle
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                className: "px-2",
                children: content
            })
        ]
    });
};

});

parcelRegister("l34aq", function(module, exports) {

$parcel$export(module.exports, "PdfOrderedList", function () { return $74a81c82a6b2c683$export$e9e318a9a88ed259; });

var $2PPWI = parcelRequire("2PPWI");
const $74a81c82a6b2c683$export$e9e318a9a88ed259 = ({ data: data })=>{
    const { item: item } = data;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("ol", {
            className: "px-2",
            children: item.map((item, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                    className: "my-1",
                    children: item
                }, index))
        })
    });
};

});

parcelRegister("fe54Q", function(module, exports) {

$parcel$export(module.exports, "PdfParagraph", function () { return $f31a7daa9bbdf5e1$export$d8b0bfb75e19c27f; });

var $2PPWI = parcelRequire("2PPWI");
const $f31a7daa9bbdf5e1$export$d8b0bfb75e19c27f = ({ data: data })=>{
    const { content: content } = data;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
        className: "px-2",
        children: content
    });
};

});

parcelRegister("9UIBy", function(module, exports) {

$parcel$export(module.exports, "PdfSelector", function () { return $245e099ef51177f5$export$945ec1b12d4a4546; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $f0NwZ = parcelRequire("f0NwZ");
const $245e099ef51177f5$export$945ec1b12d4a4546 = ({ onPdfSelect: onPdfSelect })=>{
    const pdfButtonClass = 'no-underline p-2 bg-black text-white rounded-md text-center';
    const [slug, setSlug] = (0, $8FY87.useState)('matt-lack');
    (0, $8FY87.useEffect)(()=>{
        onPdfSelect(slug);
    }, [
        slug,
        onPdfSelect
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                page: "pdf",
                props: `pdfName="${slug}"`
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "flex flex-col gap-5 border-b-2 border-black pb-3 pl-4 mb-2",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                        children: "V\xe4lj en manual:"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "flex flex-row gap-5 pl-2",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                            onClick: ()=>setSlug('matt-lack'),
                            className: pdfButtonClass,
                            children: "Mattlack"
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("hfcW7", function(module, exports) {

$parcel$export(module.exports, "PdfSubHeading", function () { return $dce6e60cc1d6a4c4$export$869d9676a0e75a56; });

var $2PPWI = parcelRequire("2PPWI");
const $dce6e60cc1d6a4c4$export$869d9676a0e75a56 = ({ data: data })=>{
    const { content: content } = data;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
        className: "scroll-mt-16 px-2",
        children: content
    });
};

});

parcelRegister("jGzhv", function(module, exports) {

$parcel$export(module.exports, "PdfTip", function () { return $3e1ffaaefa5b2b3c$export$98f03dbfae90a5ca; });

var $2PPWI = parcelRequire("2PPWI");
const $3e1ffaaefa5b2b3c$export$98f03dbfae90a5ca = ({ data: data })=>{
    const { content: content } = data;
    const { title: title } = data;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "px-2",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("h4", {
                className: "bg-dark-blue p-2 text-white ",
                children: title
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                className: "pt-2",
                children: content
            })
        ]
    });
};

});

parcelRegister("aBQcF", function(module, exports) {

$parcel$export(module.exports, "PdfUnorderedList", function () { return $2a53ffb6d5431f02$export$291d21266be6639d; });

var $2PPWI = parcelRequire("2PPWI");
const $2a53ffb6d5431f02$export$291d21266be6639d = ({ data: data })=>{
    const { label: label } = data;
    const { item: item } = data;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                className: "scroll-mt-16 px-2",
                children: label
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                className: "list-disc pl-4 ml-4",
                children: item.map((item, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                        className: "mb-3",
                        children: item
                    }, index))
            })
        ]
    });
};

});

parcelRegister("c7bfI", function(module, exports) {

module.exports = (parcelRequire("a0MnV"))($parcel$resolve("5YhI4")).then(()=>parcelRequire('dLUJN'));

});


parcelRegister("7YIgd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7840dc76a385c608$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $8mhoa = parcelRequire("8mhoa");

var $jZedf = parcelRequire("jZedf");

var $1lSPe = parcelRequire("1lSPe");

var $edALU = parcelRequire("edALU");

var $gjs5U = parcelRequire("gjs5U");

var $iH0Pu = parcelRequire("iH0Pu");

var $5ANQT = parcelRequire("5ANQT");

const $7840dc76a385c608$var$Snippet = /*#__PURE__*/ (0, $8FY87.lazy)(()=>Promise.resolve((parcelRequire("f0NwZ"))));

const $7840dc76a385c608$var$CarouselControls = /*#__PURE__*/ (0, $8FY87.lazy)(()=>(parcelRequire("hDVzU")));
const $7840dc76a385c608$var$maybeUniqId = (0, $1lSPe.getUniqId)();
const $7840dc76a385c608$var$PriceCard = ({ pricelist: pricelist, privateMileages: privateMileages, fields: fields, imageType: imageType, modelCode: modelCode, hideControls: hideControls, uniqKey: uniqKey })=>{
    const uniqId = uniqKey || $7840dc76a385c608$var$maybeUniqId;
    const { dispatch: dispatch, options: options, direction: direction, showPrivateMileages: showPrivateMileages } = (0, $8mhoa.useStore)((0, $iH0Pu.getStoreByKey)(uniqId));
    const [model, setModel] = (0, $8FY87.useState)();
    const [models, setModels] = (0, $8FY87.useState)([]);
    const setData = ()=>{
        dispatch({
            type: 'SHOW_PRICELIST',
            payload: Boolean(pricelist)
        });
        dispatch({
            type: 'SHOW_PRIVATE_MILEAGES',
            payload: privateMileages === 'true'
        });
        if (imageType) dispatch({
            type: 'IMAGE_TYPE',
            payload: imageType
        });
        if (fields) dispatch({
            type: 'CONTROLS',
            payload: fields.split(',')
        });
        dispatch({
            type: 'IS_LOADED',
            payload: true
        });
    };
    const fetchModels = async ()=>{
        if (!(0, $1lSPe.locationIsKia)()) {
            let models = JSON.parse(sessionStorage.getItem('kia-carousel-models')) ?? [];
            if (!models.length) try {
                const { data: data } = await (0, $jZedf.fetchWithType)((0, $1lSPe.getAdminUrl)() + '/api/models', {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${(0, $1lSPe.getApiToken)()}`
                    }
                });
                if (data && data.length) setModels(data);
            } catch (error) {
                console.error('Error fetching trims:', error);
            }
            else setModels(models);
        }
        if (modelCode) try {
            const { data: data } = await (0, $jZedf.fetchWithType)((0, $1lSPe.getAdminUrl)() + '/api/model/' + modelCode, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${(0, $1lSPe.getApiToken)()}`
                }
            });
            if (data && data.id) setModel(data);
            setData();
        } catch (error) {
            console.warn('Error fetching model:', modelCode);
        }
        else setModel(models[0]);
    };
    (0, $8FY87.useEffect)(()=>{
        fetchModels();
        dispatch({
            type: 'DIRECTION',
            payload: 'vertical'
        });
    }, []);
    const getSnippetProps = ()=>{
        return `modelCode="${model?.code}" ${!options ? `pricelist="true" privateMileages="${showPrivateMileages}"` : Object.entries(options).map(([key, value])=>value ? `${key}="${value}"` : '').filter(Boolean).join(' ')}`;
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: `pt-4 pb-12 ${direction === 'vertical' ? 'max-w-screen-kia-sm mx-auto' : ''}`,
        children: [
            !(0, $1lSPe.locationIsKia)() && !hideControls ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                children: [
                    models?.length ? /*#__PURE__*/ (0, $2PPWI.jsxs)("select", {
                        onChange: (e)=>{
                            const model = models.find((m)=>m.code === e.target.value);
                            if (model) setModel(model);
                        },
                        className: "border border-black p-1 w-full",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                value: "",
                                children: "V\xe4lj modell"
                            }),
                            models.map((model)=>/*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                    value: model.code,
                                    children: model.name
                                }, model.id))
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $2PPWI.jsx)($7840dc76a385c608$var$CarouselControls, {
                        uniqId: uniqId,
                        type: "single"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)($7840dc76a385c608$var$Snippet, {
                        page: "pricecard",
                        props: getSnippetProps()
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "max-w-screen-kia-sm mx-auto relative",
                children: !options || options?.fields.includes((0, $5ANQT.CarouselFieldsEnum).PRIVATE_LEASING || (0, $5ANQT.CarouselFieldsEnum).BUSINESS_LEASE) ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $gjs5U.default), {
                        uniqId: uniqId,
                        single: true
                    })
                }) : null
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "px-4 lg:px-0",
                children: model ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $edALU.default), {
                    uniqId: uniqId,
                    model: model
                }, model.code) : null
            })
        ]
    });
};
var $7840dc76a385c608$export$2e2bcd8739ae039 = $7840dc76a385c608$var$PriceCard;

});

parcelRegister("c5Qtu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87e76819fb2463ea$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $5ANQT = parcelRequire("5ANQT");

var $3f5pY = parcelRequire("3f5pY");

var $jYoa1 = parcelRequire("jYoa1");

var $417Ek = parcelRequire("417Ek");

var $kZPx9 = parcelRequire("kZPx9");

var $jeu8h = parcelRequire("jeu8h");

var $f0NwZ = parcelRequire("f0NwZ");

var $3eb7t = parcelRequire("3eb7t");

var $e4coK = parcelRequire("e4coK");

var $eRN6V = parcelRequire("eRN6V");

var $89E8A = parcelRequire("89E8A");

var $9VHYD = parcelRequire("9VHYD");

var $22OL8 = parcelRequire("22OL8");

var $lsG22 = parcelRequire("lsG22");

var $4NMKm = parcelRequire("4NMKm");

var $2FCIq = parcelRequire("2FCIq");

var $dqm4D = parcelRequire("dqm4D");

var $18QKF = parcelRequire("18QKF");
const $87e76819fb2463ea$var$PrivatLeasing = ()=>{
    const hideControls = true;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("main", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                id: "top",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4NMKm.default), {
                    ...(0, $18QKF.heroPrivatLeasing)
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "w-full max-w-screen-kia mx-auto",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
                        className: "flex flex-col justify-center items-center mx-auto mb-10 max-w-[110ch] text-center",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("h1", {
                                className: "text-center font-medium my-4 text-[32px] md:text-[40px] leading-[1.2] px-3",
                                children: (0, $18QKF.textBox).title
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: "font-light text-[18px] px-2",
                                children: (0, $18QKF.textBox).body
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $417Ek.default), {
                        links: (0, $18QKF.navLinksPL).links
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: "mb-10 lg:mb-20",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            noGap: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jYoa1.ContentTextBoxAndIcons), {
                                ...(0, $18QKF.contentTextBoxAndIcons)
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                ...(0, $18QKF.kiaImageOne)
                            }),
                            mobilFirstComponentOnTop: true,
                            desktopFirstComponentFirst: true
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $lsG22.default), {
                        id: "leasing-offer",
                        className: "my-6",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                                className: "text-center p-2 font-medium text-[32px] md:text-[40px] leading-[48px] mb-3",
                                variants: (0, $51Ucj.itemVariants),
                                children: (0, $18QKF.subHeadingOne).text
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                                variants: (0, $51Ucj.itemVariants),
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e4coK.default), {
                                    hideControls: hideControls,
                                    modelCodes: "JYW5EV2,9VW5,0TW5",
                                    trimCodes: "JYW5D5G1GEV2GG0VD,9VW5ZHZ7ZKK728,0TW5K9A1TEV2KK914",
                                    imageType: (0, $5ANQT.ImageTypeEnum).EXTERIOR,
                                    fields: "Privatbeskrivning,Privatleasingpris"
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kZPx9.TextBox), {
                                ...(0, $18QKF.popularLeasing)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $lsG22.default), {
                        id: "popular-models",
                        className: "my-6",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                                className: "text-center p-2 font-medium text-[32px] md:text-[40px] leading-[48px] mb-3",
                                variants: (0, $51Ucj.itemVariants),
                                children: (0, $18QKF.subHeadingTwo).text
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                                variants: (0, $51Ucj.itemVariants),
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eRN6V.default), {
                                    hideControls: hideControls,
                                    pricelist: false,
                                    fields: "Privatleasingpris,Fordonskatt,Uppt\xe4ck bilen,Kontakta \xe5terf\xf6rs\xe4ljare,Byt trim,Privatbeskrivning,Sortera,Visa Filter",
                                    imageType: (0, $5ANQT.ImageTypeEnum).STUDIO,
                                    privateMileages: "true",
                                    sort: (0, $5ANQT.CarouselFieldsEnum).PRIVATE_LEASING,
                                    sortBy: "asc"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $lsG22.default), {
                        id: "how-it-works",
                        className: "px-4 my-14 mx-auto w-full max-w-7xl",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                                variants: (0, $51Ucj.itemVariants),
                                className: "text-center p-2 font-medium text-[32px] md:text-[40px] leading-[48px] mb-14",
                                children: (0, $18QKF.getStarted).title
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                                firstComponentWidth: "col-span-4",
                                secondComponentWidth: "col-span-4",
                                mainBoxClassName: "mx-auto w-full max-w-7xl",
                                firstComponentClassName: "p-0 lg:p-10 lg:pt-0",
                                secondComponentClassName: "p-0",
                                mobilFirstComponentOnTop: true,
                                desktopFirstComponentFirst: true,
                                firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                    ...(0, $18QKF.gettingStarted).image
                                }),
                                secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9VHYD.default), {
                                    content: (0, $18QKF.gettingStarted).content
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $lsG22.default), {
                        id: "leasing",
                        className: "px-4 my-14 mb-20 mx-auto w-full max-w-7xl",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: "max-w-5xl mx-auto mb-14 text-center",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                                        className: "text-center p-2 font-medium text-[32px] md:text-[40px] leading-[48px]",
                                        variants: (0, $51Ucj.itemVariants),
                                        children: (0, $18QKF.electricCarLeasing).title
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                                        className: "text-base md:text-[18px] font-light mb-6",
                                        variants: (0, $51Ucj.itemVariants),
                                        children: (0, $18QKF.electricCarLeasing).text
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
                                        variants: (0, $51Ucj.itemVariants),
                                        className: "flex flex-wrap justify-center gap-8 md:gap-5",
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                                bgColor: "white",
                                                textColor: "black",
                                                className: "border-2 border-black h-12",
                                                ...(0, $18QKF.electricCarLeasing).links[0]
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                                className: "h-12",
                                                ...(0, $18QKF.electricCarLeasing).links[1]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                                firstComponentWidth: "col-span-4",
                                secondComponentWidth: "col-span-4",
                                mainBoxClassName: "mx-auto w-full max-w-7xl my-16",
                                mobilFirstComponentOnTop: false,
                                firstComponentClassName: "p-0 lg:p-10 lg:pt-0",
                                secondComponentClassName: "p-0 lg:p-10 lg:pt-0",
                                firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $89E8A.default), {
                                    title: (0, $18QKF.leasingGettingStarted).title,
                                    headingLevel: 2,
                                    text: (0, $18QKF.leasingGettingStarted).text,
                                    titleClassName: "text-[28px] lg:text-[36px] leading-[40px] font-semibold mb-2 lg:mb-6 ",
                                    textClassName: "text-[16px] md:text-[18px] leading-[24px] font-light"
                                }),
                                secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                    ...(0, $18QKF.leasingGettingStarted).image
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                                firstComponentWidth: "col-span-4 ",
                                secondComponentWidth: "col-span-4",
                                mainBoxClassName: "mx-auto w-full max-w-7xl mt-16 mb-8",
                                firstComponentClassName: "p-0 lg:p-10 lg:pt-0",
                                secondComponentClassName: "p-0 lg:p-10 lg:pt-0 mb-6 lg:mb-0",
                                firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                    ...(0, $18QKF.kiaPrivatleasingskyddBlock).image
                                }),
                                secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9VHYD.default), {
                                    content: (0, $18QKF.kiaPrivatleasingskyddBlock).content
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $22OL8.default), {
                                headingPosition: "below",
                                ...(0, $18QKF.leasingAltenative)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: "px-4 my-14 mx-auto w-full max-w-7xl",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponentWidth: "col-span-4",
                            secondComponentWidth: "col-span-4",
                            mainBoxClassName: "mx-auto w-full max-w-7xl",
                            firstComponentClassName: " lg:p-10 lg:pt-0",
                            secondComponentClassName: "p-0",
                            mobilFirstComponentOnTop: false,
                            desktopFirstComponentFirst: true,
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9VHYD.default), {
                                content: (0, $18QKF.companyLeasing).content
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                ...(0, $18QKF.companyLeasing).image
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("article", {
                        id: "faq",
                        className: "bg-slate-50 mb-20",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3f5pY.default), {
                            ...(0, $18QKF.faqBlockPL)
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $lsG22.default), {
                        id: "newsletter-section",
                        className: "mb-[90px]",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                            variants: (0, $51Ucj.itemVariants),
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $dqm4D.default), {
                                hideControls: hideControls,
                                theme: (0, $dqm4D.ThemeEnum).GREY,
                                heading: "Nyhetsbrev",
                                description: "F\xe5 de senaste nyheterna kring lanseringar av nya bilar, kampanjer, event och andra sp\xe4nnande reportage genom att g\xe5 med i nyhetsbrevet.",
                                buttonLabel: "G\xe5 med i nyhetsbrev",
                                checkboxLabel: "Nyhetsbrev. Jag samtycker till att Kia Sverige AB behandlar mina personuppgifter och f\xf6rser mig med information fr\xe5n Kia Sverige. Jag kan n\xe4r som helst s\xe4ga upp prenumerationen p\xe5 ett visst e-postnyhetsbrev eller liknande kommunikation genom att f\xf6lja anvisningarna i respektive kommunikation.",
                                emailPlaceholder: "Ange din e-postadress",
                                thankYouMessage: "Tack f\xf6r att du prenumererar p\xe5 v\xe5rt nyhetsbrev!"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                        page: "privatleasing"
                    })
                ]
            })
        ]
    });
};
var $87e76819fb2463ea$export$2e2bcd8739ae039 = $87e76819fb2463ea$var$PrivatLeasing;

});
parcelRegister("jYoa1", function(module, exports) {

$parcel$export(module.exports, "ContentTextBoxAndIcons", function () { return $c6be8dbe91cfcd11$export$308cada30c845fd9; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $a2EmR = parcelRequire("a2EmR");
const $c6be8dbe91cfcd11$export$308cada30c845fd9 = ({ titleLine1: titleLine1, titleLine2: titleLine2, backgroundColor: backgroundColor = '#ffffff', titleColor: titleColor = '#000000', textColor: textColor = '#000000', listItems: listItems })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        variants: (0, $51Ucj.containerVariants),
        style: {
            backgroundColor: backgroundColor
        },
        className: "w-full h-full xl:pl-44 flex flex-col justify-center items-start gap-4 md:gap-4 p-8 md:py-16",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "text-start",
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).h2, {
                    variants: (0, $51Ucj.itemVariants),
                    style: {
                        color: titleColor
                    },
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                            className: "text-2xl  block",
                            children: titleLine1
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                            className: "text-5xl leading-[72px] block",
                            children: titleLine2
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).ul, {
                initial: "hidden",
                whileInView: "visible",
                viewport: (0, $51Ucj.viewPort),
                variants: (0, $51Ucj.containerVariants),
                className: "list-none flex flex-col gap-6 ",
                children: listItems.map((item, index)=>/*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).li, {
                        variants: (0, $51Ucj.itemVariants),
                        className: "flex items-center gap-3",
                        children: [
                            item.iconProps && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "flex-shrink-0",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a2EmR.CheckIcon), {
                                    ...item.iconProps
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                style: {
                                    color: textColor
                                },
                                className: "text-xl md:text-2xl font-normal leading-[24px]  ",
                                children: item.text
                            })
                        ]
                    }, index))
            })
        ]
    });
};

});

parcelRegister("417Ek", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06dcb07649a16a46$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $655D0 = parcelRequire("655D0");

var $8qMcq = parcelRequire("8qMcq");
const $06dcb07649a16a46$var$PrivatLeasingNavBar = ({ links: links })=>{
    const [activeLink, setActiveLink] = (0, $8FY87.useState)('');
    const [isMenuOpen, setIsMenuOpen] = (0, $8FY87.useState)(false);
    const [isFixed, setIsFixed] = (0, $8FY87.useState)(false);
    const [navHeight, setNavHeight] = (0, $8FY87.useState)(0);
    const navRef = (0, $8FY87.useRef)(null);
    (0, $8FY87.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        setNavHeight(nav.offsetHeight);
        const sentinel = document.createElement('div');
        sentinel.style.height = '1px';
        navRef.current?.before(sentinel);
        const observer = new IntersectionObserver(([entry])=>{
            setIsFixed(entry.boundingClientRect.top < 0);
        }, {
            root: null,
            threshold: 0
        });
        observer.observe(sentinel);
        return ()=>{
            observer.disconnect();
            sentinel.remove();
        };
    }, []);
    (0, $8FY87.useEffect)(()=>{
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) setActiveLink(`#${entry.target.id}`);
            });
        }, {
            rootMargin: '-70px 0px -100% 0px'
        });
        const observedSections = [];
        links.forEach((link)=>{
            if (link.link.startsWith('#')) {
                const section = document.querySelector(link.link);
                if (section) {
                    observer.observe(section);
                    observedSections.push(section);
                }
            }
        });
        return ()=>{
            observedSections.forEach((section)=>observer.unobserve(section));
            observer.disconnect();
        };
    }, [
        links
    ]);
    const handleScroll = (e, target)=>{
        if (target.includes('sok-aterforsaljare-verkstad')) (0, $655D0.trackEvent)({
            event: 'find_a_dealer',
            model: undefined
        });
        if (target.startsWith('#')) {
            e.preventDefault();
            const element = document.querySelector(target);
            if (element) {
                const offset = 68;
                const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - offset;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }
        setIsMenuOpen(false);
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("nav", {
                "aria-label": "Hoppa till avsnitt",
                ref: navRef,
                className: `w-full bg-white z-[51] mb-5 transition-all duration-300 ${isFixed ? 'fixed top-0 left-0 shadow' : 'relative'}`,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "hidden xl:flex justify-center items-center h-[59px] ",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                            className: "flex gap-16 xl:gap-20 ",
                            children: links.map((link, index)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                            href: link.link,
                                            onClick: (e)=>handleScroll(e, link.link),
                                            className: `text-base font-bold no-underline ${activeLink === link.link ? 'text-gray-500' : 'text-black'} hover:text-gray-500 transition`,
                                            children: link.text
                                        }),
                                        activeLink === link.link && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                            className: "absolute bottom-[-1px] left-0 w-full h-[2px] bg-black"
                                        })
                                    ]
                                }, index))
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "flex xl:hidden  items-center gap-2 p-4 h-16 justify-between",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: "text-sm",
                                children: "Inneh\xe5llsf\xf6rteckning privatleasing"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                className: "relative z-30 grid place-content-center size-12",
                                onClick: ()=>setIsMenuOpen(!isMenuOpen),
                                "aria-label": isMenuOpen ? "\xd6ppna Inneh\xe5llsf\xf6rteckning privatleasing" : "St\xe4ng Inneh\xe5llsf\xf6rteckning privatleasing",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8qMcq.HamburgerIcon), {
                                    isOpen: isMenuOpen,
                                    strokeColor: "black"
                                })
                            })
                        ]
                    }),
                    isMenuOpen && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "absolute top-16 left-0 w-full bg-white shadow-lg z-40",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                            className: "flex flex-col gap-4 p-4",
                            children: links.map((link, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                    className: "relative",
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                        href: link.link,
                                        onClick: (e)=>handleScroll(e, link.link),
                                        className: `block text-base font-medium no-underline ${activeLink === link.link ? 'text-gray-500' : 'text-black'} hover:text-gray-500 transition`,
                                        children: link.text
                                    })
                                }, index))
                        })
                    })
                ]
            }),
            isFixed && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "mb-5",
                style: {
                    height: navHeight
                }
            })
        ]
    });
};
var $06dcb07649a16a46$export$2e2bcd8739ae039 = $06dcb07649a16a46$var$PrivatLeasingNavBar;

});

parcelRegister("9VHYD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f3eeb03de3e5edf$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $2FCIq = parcelRequire("2FCIq");
const $3f3eeb03de3e5edf$var$FlexibleTextBlock = ({ content: content, className: className = '' })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
        className: className,
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        children: content.map((block, i)=>{
            switch(block.__type){
                case 'heading':
                    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                        className: `text-[28px] lg:text-[36px] leading-[40px] font-semibold mb-2 lg:mb-6 ${block.className}`,
                        variants: (0, $51Ucj.itemVariants),
                        children: block.content
                    }, i);
                case 'text':
                    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                        className: `text-[16px] md:text-[18px] leading-[24px] font-light ${block.className}`,
                        variants: (0, $51Ucj.itemVariants),
                        children: block.content
                    }, i);
                case 'link':
                    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                        className: `mt-7 flex flex-col space-y-6 ${block.className ?? ''}`,
                        variants: (0, $51Ucj.itemVariants),
                        children: block.links?.map((link, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "flex justify-center md:justify-start",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                    url: link.url,
                                    text: link.label,
                                    openInNewTab: link.openInNewTab,
                                    widthClass: link.widthClass
                                })
                            }, link.url ?? index))
                    }, i);
                case 'list':
                    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).ul, {
                        className: `list-outside space-y-2 my-3 pl-5 ${block.className}`,
                        variants: (0, $51Ucj.itemVariants),
                        children: block.items?.map((item, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                className: "text-[16px] list-disc md:text-[18px] leading-[24px] font-light",
                                children: item
                            }, index))
                    }, i);
                default:
                    return null;
            }
        })
    });
};
var $3f3eeb03de3e5edf$export$2e2bcd8739ae039 = $3f3eeb03de3e5edf$var$FlexibleTextBlock;

});

parcelRegister("4NMKm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5de46420f0569836$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $3eb7t = parcelRequire("3eb7t");
const $5de46420f0569836$var$PrivateLeasingHero = ({ image: image, mobileImage: mobileImage })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
        className: "relative w-full h-[52vh] lg:h-[60vh] max-h-[918px] lg:max-h-[900px] text-white mb-4 lg:mb-10",
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("picture", {
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                    media: "(max-width: 1023px)",
                    srcSet: mobileImage
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                    src: image,
                    alt: "En rad Kia-bilar parkerade vid vattnet i solnedg\xe5ngen.",
                    className: "w-full h-full object-cover object-[center_60%] lg:object-[center_bottom]"
                })
            ]
        })
    });
};
var $5de46420f0569836$export$2e2bcd8739ae039 = $5de46420f0569836$var$PrivateLeasingHero;

});

parcelRegister("18QKF", function(module, exports) {

$parcel$export(module.exports, "heroPrivatLeasing", function () { return $6f0fca904b672096$export$930bf9671af613ac; });
$parcel$export(module.exports, "subHeadingOne", function () { return $6f0fca904b672096$export$3cf7f10ba26805e3; });
$parcel$export(module.exports, "subHeadingTwo", function () { return $6f0fca904b672096$export$8b675f415d6a0d2; });
$parcel$export(module.exports, "textBox", function () { return $6f0fca904b672096$export$1fba60a20f17ac3e; });
$parcel$export(module.exports, "contentTextBoxAndIcons", function () { return $6f0fca904b672096$export$16a7b616097f1ebe; });
$parcel$export(module.exports, "popularLeasing", function () { return $6f0fca904b672096$export$8c69c00c282806e1; });
$parcel$export(module.exports, "electricCarLeasing", function () { return $6f0fca904b672096$export$5f64c1b422829ef6; });
$parcel$export(module.exports, "leasingGettingStarted", function () { return $6f0fca904b672096$export$58817a319c20e0fd; });
$parcel$export(module.exports, "kiaPrivatleasingskyddBlock", function () { return $6f0fca904b672096$export$aa847a64983b1354; });
$parcel$export(module.exports, "getStarted", function () { return $6f0fca904b672096$export$4e7c2edc266bb521; });
$parcel$export(module.exports, "gettingStarted", function () { return $6f0fca904b672096$export$a2c030203ab23d22; });
$parcel$export(module.exports, "leasingAltenative", function () { return $6f0fca904b672096$export$3d415a0e1c437448; });
$parcel$export(module.exports, "companyLeasing", function () { return $6f0fca904b672096$export$ed0e64d0317bde15; });
$parcel$export(module.exports, "faqBlockPL", function () { return $6f0fca904b672096$export$1acb4d00a45d66c2; });
$parcel$export(module.exports, "navLinksPL", function () { return $6f0fca904b672096$export$8eb85d646d74c0c0; });
$parcel$export(module.exports, "kiaImageOne", function () { return $6f0fca904b672096$export$2caa8c4ac35a8a92; });
const $6f0fca904b672096$export$930bf9671af613ac = {
    image: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/KIA-Elbilar-Range.jpg',
    mobileImage: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/KIA-Elbilar-Range_mobile.jpg'
};
const $6f0fca904b672096$export$3cf7f10ba26805e3 = {
    text: "Popul\xe4ra leasingerbjudanden"
};
const $6f0fca904b672096$export$8b675f415d6a0d2 = {
    text: 'Bilmodeller att leasa'
};
const $6f0fca904b672096$export$1fba60a20f17ac3e = {
    title: "Privatleasa en laddbar bil fr\xe5n Kia med 0 kr i kontantinsats.",
    body: "Kia Privatleasing \xe4r ett enkelt och bekv\xe4mt s\xe4tt att finansiera din Kia. Privatleasa en laddbar Kia med 0 kr i kontantinsats och kostnadsfritt Kia Privatleasingskydd i tre m\xe5nader. Dessutom ing\xe5r alltid v\xe4gassistans, 7 \xe5rs nybilsgaranti fr\xe5n fabrik och Kia Serviceavtal.",
    backgroundColor: '',
    numberOfFields: 3,
    titleStyle: 'text-center p-2 font-medium text-[32px] md:text-[40px] leading-[48px] mb-6 max-w-[627px]',
    textSize: 'text-lg leading-[24px]'
};
const $6f0fca904b672096$export$16a7b616097f1ebe = {
    titleLine1: 'Privatleasing',
    titleLine2: "Det h\xe4r ing\xe5r n\xe4r du leasar bil:",
    backgroundColor: '#37434C',
    titleColor: '#FFFFFF',
    textColor: '#FFFFFF',
    listItems: [
        {
            text: '0 kr i kontantinsats',
            iconProps: {
                color: '#FFFFFF',
                width: 25,
                height: 25,
                strokeWidth: 4
            }
        },
        {
            text: 'Kia Serviceavtal',
            iconProps: {
                color: '#FFFFFF',
                width: 25,
                height: 25,
                strokeWidth: 4
            }
        },
        {
            text: "7 \xe5rs nybilsgaranti",
            iconProps: {
                color: '#FFFFFF',
                width: 25,
                height: 25,
                strokeWidth: 4
            }
        },
        {
            text: "V\xe4gassistans",
            iconProps: {
                color: '#FFFFFF',
                width: 25,
                height: 25,
                strokeWidth: 4
            }
        },
        {
            text: "Kia Privatleasingskydd i 3 m\xe5nader",
            iconProps: {
                color: '#FFFFFF',
                width: 25,
                height: 25,
                strokeWidth: 4
            }
        }
    ]
};
const $6f0fca904b672096$export$8c69c00c282806e1 = {
    backgroundColor: '',
    numberOfFields: 3,
    mtClass: 'mt-4',
    mbClass: 'mb-9',
    titleStyle: 'text-center text-black p-2 font-medium text-[32px] md:text-[40px] leading-[48px] mb-6 max-w-[627px]',
    textSize: 'text-lg leading-[24px]',
    listItems: [
        {
            text: "Kia Privatleasing \xe4r ett enkelt och bekv\xe4mt s\xe4tt att finansiera din Kia.",
            boldParts: [
                'finansiera din Kia'
            ],
            iconProps: {
                color: '#000',
                width: 24,
                height: 24,
                strokeWidth: 5
            }
        },
        {
            text: "Privatleasa en elbil eller laddbar Kia med 0 kr i kontantinsats och kostnadsfritt Kia Privatleasingskydd i tre m\xe5nader.",
            boldParts: [
                'kostnadsfritt Kia Privateleasingskydd'
            ],
            iconProps: {
                color: '#000',
                width: 24,
                height: 24,
                strokeWidth: 5
            }
        },
        {
            text: "Dessutom ing\xe5r alltid v\xe4gassistans, 7\xe5rs nybilsgaranti fr\xe5n fabrik och Kia serviceavtal.",
            boldParts: [
                "Dessutom ing\xe5r alltid v\xe4gassistans,"
            ],
            iconProps: {
                color: '#000',
                width: 24,
                height: 24,
                strokeWidth: 5
            }
        }
    ]
};
const $6f0fca904b672096$export$5f64c1b422829ef6 = {
    title: 'Leasa elbil',
    text: "Kia erbjuder flera elbilsmodeller f\xf6r privatleasing: bland annat den stora el-SUV:en Kia EV9, den sportiga el-crossovern Kia EV6, prestandaelbilen Kia EV6 GT och den kompakta el-SUV:en Kia EV3.",
    links: [
        {
            url: 'https://www.kia.com/se/elbil/elbil/',
            text: "L\xe4s mer om v\xe5ra elbilar."
        },
        {
            url: 'https://www.kia.com/se/elbil/laddhybrid/',
            text: "Se \xe4ven v\xe5ra laddhybrider."
        }
    ],
    image: {
        src: 'https://kia-afonso-storage.b-cdn.net/Ev6-FL-2024-Dec.jpg',
        alt: "En gr\xe5 Kia EV6 k\xf6r p\xe5 en bro i skymningen."
    }
};
const $6f0fca904b672096$export$58817a319c20e0fd = {
    title: "Vad \xe4r privatleasing?",
    text: "Kia Privatleasing \xe4r ett enkelt och bekymmersfritt finansieringsalternativ som kan beskrivas som l\xe5ngtidshyra av en bil. Allt fler tycker att det \xe4r viktigare att k\xf6ra en ny bil \xe4n att \xe4ga den och v\xe4ljer d\xe4rf\xf6r privatleasing som finansieringsalternativ.",
    image: {
        src: 'https://kia-afonso-storage.b-cdn.net/kia/placeholder2.png',
        alt: "Man med surfbr\xe4da vid en Kia parkerad p\xe5 en grusv\xe4g i en barrskog."
    }
};
const $6f0fca904b672096$export$aa847a64983b1354 = {
    content: [
        {
            __type: 'heading',
            content: 'Kia Privatleasingskydd'
        },
        {
            __type: 'text',
            content: "Kia Privatleasingskydd \xe4r en f\xf6rs\xe4kring som betalar kundens privatleasingavtal i upp till ett \xe5r om han eller hon blir sjuk eller arbetsl\xf6s:"
        },
        {
            __type: 'list',
            items: [
                "Sjukskrivning i mer \xe4n 30 dagar - skydd f\xf6r kunden som \xe4r anst\xe4lld eller egenf\xf6retagare.",
                "Ofrivillig arbetsl\xf6shet i mer \xe4n 30 dagar \u2013 skydd f\xf6r kunden som \xe4r anst\xe4lld eller egenf\xf6retagare.",
                "D\xf6dsfall \u2013 vid d\xf6dsfall ers\xe4tts kundens utest\xe5ende m\xe5nadsbetalningar f\xf6r privatleasingavtalet."
            ]
        },
        {
            __type: 'text',
            content: "Premien \xe4r 6,5% och ber\xe4knas p\xe5 m\xe5nadshyran exkl. service, f\xf6rs\xe4kring och avgifter. F\xf6rs\xe4kringspremien redovisas separat p\xe5 fakturan."
        },
        {
            __type: 'link',
            links: [
                {
                    url: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/contents/purchase-guide/privatleasing/Privatleasingsskydd_A4.pdf',
                    label: 'Ladda ner informationsblad'
                }
            ]
        }
    ],
    image: {
        src: 'https://kia-afonso-storage.b-cdn.net/kia/placeholder3.png',
        alt: "Ett ungt par sitter och \xe4ter framf\xf6r ett upplyst t\xe4lt p\xe5 en strand i skymningen, med en campinglampa mellan sig."
    }
};
const $6f0fca904b672096$export$4e7c2edc266bb521 = {
    title: "S\xe5 fungerar privatleasing"
};
const $6f0fca904b672096$export$a2c030203ab23d22 = {
    content: [
        {
            __type: 'heading',
            content: "1. V\xe4lj bil att leasea."
        },
        {
            __type: 'text',
            content: "V\xe4lj en bil som passar dina behov. Idag har vi 10 olika laddbara modeller att v\xe4lja mellan. Med en laddbar Kia kan du alltid r\xe4kna med integrerad telematik, adaptiv farth\xe5llare, eluppv\xe4rmd ratt och uttrycksfulla metallic-f\xe4rger.",
            className: 'mb-6'
        },
        {
            __type: 'heading',
            content: "2. Bes\xf6k din \xe5terf\xf6rs\xe4ljare"
        },
        {
            __type: 'text',
            content: "N\xe4r du har best\xe4mt dig f\xf6r en bilmodell eller om du vill provk\xf6ra en Kia, kontakta din n\xe4rmaste Kia-\xe5terf\xf6rs\xe4ljare."
        },
        {
            __type: 'link',
            links: [
                {
                    url: 'https://www.kia.com/se/sok-aterforsaljare-verkstad/#/',
                    label: "Hitta \xe5terf\xf6rs\xe4ljare"
                }
            ]
        }
    ],
    image: {
        src: 'https://kia-afonso-storage.b-cdn.net/kia/placeholder1.png',
        alt: "En modern, ljust inredd utst\xe4llningsmonter f\xf6r Kia, med tr\xe4paneler, ett vitt bord och tr\xe4stolar, samt en sk\xe4rm som visar en bil.r"
    }
};
const $6f0fca904b672096$export$3d415a0e1c437448 = {
    title: 'Alternativ till leasing',
    text: "Vill du ist\xe4llet \xe4ga din bil erbjuder Kia flexibla och skr\xe4ddarsydda bill\xe5n inklusive Kia serviceavtal. L\xe4s mer om v\xe5ra \xf6vriga finanseringsalternativ.",
    links: [
        {
            text: "L\xe4s om Kia Bill\xe5n",
            url: 'https://www.kia.com/se/kopa/billan/#/',
            className: 'border-2 border-black h-12',
            openInNewTab: false,
            textColor: 'black',
            bgColor: 'white'
        },
        {
            text: 'Se prislista',
            url: 'https://www.kia.com/se/kopa/prislista/',
            className: 'w-[298px] h-12',
            openInNewTab: false
        }
    ],
    gap: '5',
    titleFontSize: 'text-[32px] md:text-[32px]',
    textFontSize: 'text-[16px] md:text[18px] font-light'
};
const $6f0fca904b672096$export$ed0e64d0317bde15 = {
    content: [
        {
            __type: 'heading',
            content: "F\xf6retagsleasing"
        },
        {
            __type: 'text',
            content: "Med Kia Business Lease f\xf6r ert f\xf6retag kan ni uppleva laddbar frihet i form av en v\xe4lutrustad laddbar Kia inklusive f\xf6rs\xe4kring, service, vinterhjul och med garanterat restv\xe4rde.\u2075"
        },
        {
            __type: 'link',
            links: [
                {
                    url: 'https://www.kia.com/se/tjanstebil/foretagsleasing/',
                    label: "L\xe4s mer om Business lease"
                }
            ]
        }
    ],
    image: {
        src: 'https://kia-afonso-storage.b-cdn.net/kia/placeholder4.png',
        alt: "Tre Kia elbilar \u2013 en ljus SUV (v\xe4nster), en gr\xe5 crossover (mitten) och en bl\xe5 SUV (h\xf6ger) \u2013 st\xe5r parkerade utomhus p\xe5 en asfalterad yta under klarbl\xe5 himmel."
    }
};
const $6f0fca904b672096$export$1acb4d00a45d66c2 = {
    title: "Vanliga fr\xe5gor om privatleasing",
    questions: [
        {
            q: "Beh\xf6ver jag betala kontantinsats vid privatleasing?",
            a: "Nej, vid privatleasing finns inget krav p\xe5 kontantinsats."
        },
        {
            q: "Vad kr\xe4vs f\xf6r att bli godk\xe4nd f\xf6r Kia Privatleasing?",
            a: "V\xe5ra krav \xe4r att leasingtagaren har giltigt k\xf6rkort (vid utl\xe4ndskt k\xf6rkort kr\xe4vs komplettering med svensk ID handling) och blir godk\xe4nd vid sedvanlig kreditpr\xf6vning."
        },
        {
            q: "\xc4r m\xe5nadskostnaden fast?",
            a: "Nej, m\xe5nadskostnaden baseras p\xe5 en r\xf6rlig r\xe4nta och kan \xe4ndras beroende p\xe5 r\xe4nteutvecklingen."
        },
        {
            q: "Om jag k\xf6r mer \xe4n avtalad k\xf6rstr\xe4cka?",
            a: "F\xf6r dig som privatleasingkund g\xf6rs det vid \xe5terl\xe4mnandet en kontroll av bilens skick. D\xe5 kontrolleras \xe4ven att service har utf\xf6rts enl. service- och garantihandboken. Det sker en avr\xe4kning och \xf6vermilen debiteras enligt avtal."
        },
        {
            q: "Kan jag \xe4ndra avtalade mil p\xe5 mitt leasingavtal?",
            a: "Det g\xe5r endast att \xe4ndra miltal innan leverans av bil, du kan inte \xe4ndra miltal n\xe4r avtalet p\xe5b\xf6rjats."
        },
        {
            q: "Om jag \xf6nskar k\xf6pa tillbeh\xf6r till min bil?",
            a: "Om du \xf6nskar k\xf6pa tillbeh\xf6r tala med din Kia-\xe5terf\xf6rs\xe4ljare s\xe5 hj\xe4lper de g\xe4rna dig."
        },
        {
            q: "Ing\xe5r bilf\xf6rs\xe4kring?",
            a: "I m\xe5nadsbetalningen ing\xe5r inte bilf\xf6rs\xe4kring. Du kan enkelt v\xe4lja till en Kia Bilf\xf6rs\xe4kring till en f\xf6rm\xe5nlig m\xe5nadskostnad. Din \xe5terf\xf6rs\xe4ljare hj\xe4lper dig g\xe4rna med att l\xe4gga upp detta vid leverans."
        },
        {
            q: "Beh\xf6ver jag ha en f\xf6rs\xe4kring p\xe5 min privatleasade bil?",
            a: 'Ja, ett fordon som finansieras via Kia Finans m\xe5ste alltid vara helf\xf6rs\xe4krat. S\xe5 l\xe4nge bilen har vagnskadegaranti r\xe4cker det med en halvf\xf6rs\xe4kring. Du v\xe4ljer sj\xe4lv om du \xf6nskar ha en Kia Bilf\xf6rs\xe4kring som samfaktureras via Kia Finans eller ett annat f\xf6rs\xe4kringsbolag. L\xe4s mer om <a href="https://www.kiabilforsakring.com/" target="_blank">Kia Bilf\xf6rs\xe4kring.</a>'
        },
        {
            q: "Om jag f\xe5r skador p\xe5 bilen vad h\xe4nder d\xe5?",
            a: 'Det \xe4r viktigt att du tar hand om din privatleasade Kia under hela avtalsperioden f\xf6r att inte r\xe5ka ut f\xf6r on\xf6diga kostnader n\xe4r du ska l\xe4mna tillbaka ditt fordon. Det f\xf6rsta som g\xf6rs n\xe4r du l\xe4mnar tillbaka din bil \xe4r en skadebesiktning av en auktoriserad Kia-\xe5terf\xf6rs\xe4ljare. Slitage som anses vara normalt debiteras inte. Slitage som d\xe4remot anses vara onormalt p\xe5verkar bilens v\xe4rde och kommer d\xe4rf\xf6r att debiteras enligt det testprotokoll som uppr\xe4ttats. F\xf6r att l\xe4sa mer om vad som anses som onormalt slitage l\xe4s <a href="https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/contents/purchase-guide/finance-a-purchase/privatleasing/kia_underhall_och_aterlamningsguide.pdf" target="_blank">Kias \xe5terl\xe4mningsguide.</a>'
        },
        {
            q: "Vad ing\xe5r i ett serviceavtal?",
            a: "Vi p\xe5 Kia tycker det \xe4r viktigt att serva bilen s\xe5 att du som kund ska k\xe4nna dig s\xe4ker och trygg med din nya privatleasade Kia. Det \xe4r \xe4ven viktigt f\xf6r att bibeh\xe5lla nybilsgarantin att service g\xf6rs enligt bilens serviceintervall. Serviceavtalet ing\xe5r i priset p\xe5 din privatleasing och innefattar alla de punkter som v\xe5ra fabriker/ ingenj\xf6rer har konstaterat att man beh\xf6ver kontrollera f\xf6r att bilen ska m\xe5 bra samt bibeh\xe5lla den goda kvalitet som Kia st\xe5r f\xf6r. Det ing\xe5r \xe4ven f\xf6rl\xe4ngd assistans n\xe4r du servar din privatleasade bil hos en auktoriserad Kia-verkstad. V\xe4rdet f\xf6r servicen specificeras separat i ditt avtal och p\xe5 dina kommande fakturor och g\xe4ller endast hos auktoriserad Kia-verkstad."
        },
        {
            q: "N\xe4r ska jag serva bilen?",
            a: "Bilen ska servas i enlighet med bilens serviceplan. Det \xe4r viktigt att samtliga servicar har utf\xf6rts p\xe5 fordonet enligt service- och garantiboken. Om service inte \xe4r gjord i enlighet med detta kommer en v\xe4rdeminskningskostnad debiteras vid \xe5terl\xe4mnandet p\xe5 20.000 sek inkl. moms. Vid \xe5terl\xe4mnandet sker en kontroll av bilens skick och att service har utf\xf6rts enligt service- och garantihandboken. Dessutom g\xf6rs en avr\xe4kning och eventuella \xf6vermil debiteras enligt avtal."
        },
        {
            q: 'Hur bokar jag service?',
            a: 'All bokning av service sker via auktoriserade Kia-verkst\xe4der. Hitta din n\xe4rmaste auktoriserade verkstad <a href="https://www.kia.com/se/sok-aterforsaljare-verkstad" target="_blank">h\xe4r</a>. Eller boka direkt online via <a href="https://www.kia.com/se/guestbooking/new-appointment/" target="_blank">denna l\xe4nk.</a>'
        },
        {
            q: "Kan jag \xf6verl\xe5ta mitt privatleasingavtal?",
            a: "Nej, det \xe4r inte m\xf6jligt att \xf6verl\xe5ta ditt privatleasingavtal."
        },
        {
            q: "Kan jag f\xf6rl\xe4nga mitt privatleasingavtal?",
            a: "Nej, du kan inte f\xf6rl\xe4nga ditt avtal utan ska \xe5terl\xe4mna bilen vid kontraktstidens slut."
        },
        {
            q: "Mitt privatleasingavtal p\xe5 v\xe4g att l\xf6pa ut, vad g\xf6r jag?",
            a: 'Vi ber dig kontakta den Kia-\xe5terf\xf6rs\xe4ljare som levererade bilen f\xf6r planering av genomg\xe5ng och \xe5terl\xe4mnande av fordonet. Om du trivs med uppl\xe4gget kan du h\xe4mta ut en helt ny Kia och p\xe5b\xf6rja en ny tre\xe5rig leasingperiod. L\xe4s <a href="https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/contents/purchase-guide/finance-a-purchase/privatleasing/kia_underhall_och_aterlamningsguide.pdf" target="_blank">Kias \xe5terl\xe4mningsguide h\xe4r.</a>'
        }
    ]
};
const $6f0fca904b672096$export$8eb85d646d74c0c0 = {
    links: [
        {
            text: 'Leasingerbjudanden',
            link: '#leasing-offer'
        },
        {
            text: 'Bilmodeller att leasa',
            link: '#popular-models'
        },
        {
            text: "S\xe5 fungerar leasing",
            link: '#how-it-works'
        },
        {
            text: 'Leasa elbil',
            link: '#leasing'
        },
        {
            text: "Fr\xe5gor & Svar",
            link: '#faq'
        },
        {
            text: "Kontakta \xc5terf\xf6rs\xe4ljare",
            link: 'https://www.kia.com/se/sok-aterforsaljare-verkstad/#/'
        },
        {
            text: "Provk\xf6r Kia",
            link: 'https://www.kia.com/se/provkor/#/'
        }
    ]
};
const $6f0fca904b672096$export$2caa8c4ac35a8a92 = {
    src: 'https://kia-afonso-storage.b-cdn.net/Appsida-bild-ev3.jpg',
    alt: "En kvinna i ljusa kl\xe4der sitter och vilar i solskenet mot en betongv\xe4gg, bredvid bakdelen p\xe5 en parkerad ljusgr\xf6n Kia EV3 SUV med klippor i bakgrunden.",
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'lg:min-h-[550px] max-h-[600px] object-cover object-center'
};

});


parcelRegister("hJd3B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2e6f056ebf6caa4$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $3f5pY = parcelRequire("3f5pY");

var $e2YZi = parcelRequire("e2YZi");

var $1CznZ = parcelRequire("1CznZ");

var $zuoP0 = parcelRequire("zuoP0");

var $fu5YU = parcelRequire("fu5YU");

var $jeu8h = parcelRequire("jeu8h");

var $bRf1s = parcelRequire("bRf1s");

var $f0NwZ = parcelRequire("f0NwZ");

var $3eb7t = parcelRequire("3eb7t");
const $b2e6f056ebf6caa4$var$RentAndShareApp = ()=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bRf1s.VideoClip), {
                title: "Kia Drive",
                subTitle: "Hyr & Dela",
                autoplay: true,
                src: "https://kia-afonso-storage.b-cdn.net/filmer/HyrDela-Hero-Clean-EV3-appsida.mp4"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "w-full max-w-screen-kia mx-auto",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                        firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1CznZ.ContentTextBox), {
                            className: "max-w-[650px]",
                            title: "Kia Drive",
                            description: "Har du blivit inbjuden att anv\xe4nda v\xe5r mobilitetstj\xe4nst Kia Drive? Grattis! Det \xe4r en enkel och smart tj\xe4nst d\xe4r flera anv\xe4ndare kan dela p\xe5 en eller flera bilar. Du bokar, l\xe5ser upp och betalar f\xf6r ditt anv\xe4ndande direkt i v\xe5r app. S\xe5 h\xe4r kommer du i g\xe5ng.",
                            children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: "flex gap-4 mt-auto",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $fu5YU.LinkApp), {
                                        text: "Google Play",
                                        Icon: (0, $zuoP0.GooglePlayIcon),
                                        href: "https://play.google.com/store/apps/details?id=com.ridecell.massiv.kangaroo.prod&hl=en",
                                        target: "_blank"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $fu5YU.LinkApp), {
                                        text: "App Store",
                                        Icon: (0, $e2YZi.AppStoreIcon),
                                        href: "https://apps.apple.com/se/app/hyr-dela/id1658798260",
                                        target: "_blank"
                                    })
                                ]
                            })
                        }),
                        secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                            src: "https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/hyr-och-dela/Appsida-bild-man.jpg",
                            alt: "KIA Car",
                            sizes: "(max-width: 768px) 100vw, 50vw",
                            className: "max-h-[450px] object-cover object-center"
                        }),
                        mobilFirstComponentOnTop: true,
                        desktopFirstComponentFirst: false
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                        firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1CznZ.ContentTextBox), {
                            title: "S\xe5 fungerar appen Kia Drive",
                            listItems: [
                                {
                                    title: 'Ladda ner appen Kia Drive.',
                                    text: "Den finns f\xf6r b\xe5de Apple och Android."
                                },
                                {
                                    title: 'Skapa ett konto.',
                                    text: "L\xe4gg till betalningsinformation och v\xe4lj upph\xe4mtningsst\xe4lle. Upph\xe4mtningsst\xe4llet \xe4r oftast adressen till f\xf6retaget som du ansluter till."
                                },
                                {
                                    title: 'Hitta alla bokningsbara bilar.',
                                    text: "Boka fr\xe5n en timme och upp\xe5t."
                                },
                                {
                                    title: "Anv\xe4nd appen f\xf6r att l\xe5sa upp och starta bilen.",
                                    text: "Vill du korta eller f\xf6rl\xe4nga din hyrestid g\xf6r du det direkt i appen."
                                },
                                {
                                    title: "L\xe4mna tillbaka bilen d\xe4r du h\xe4mtade den.",
                                    text: 'Avsluta och betala via appen!'
                                }
                            ]
                        }),
                        secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                            src: "https://kia-afonso-storage.b-cdn.net/Appsida-bild-ev3.jpg",
                            alt: "KIA Car",
                            sizes: "(max-width: 768px) 100vw, 50vw",
                            className: "lg:min-h-[550px] max-h-[600px] object-cover object-center"
                        }),
                        mobilFirstComponentOnTop: true,
                        desktopFirstComponentFirst: true
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3f5pY.default), {
                        className: "bg-dark-blue",
                        questions: [
                            {
                                q: 'Hur laddar jag bilen?',
                                a: "Har ni inte laddstationer p\xe5 plats hj\xe4lper Kia-\xe5terf\xf6rs\xe4ljaren er med en l\xf6sning som passar era behov."
                            },
                            {
                                q: "Hur f\xe5r jag tillg\xe5ng till bilen?",
                                a: "Din mobil \xe4r nyckeln till bilen. N\xe5gra minuter innan din hyresperiod b\xf6rjar s\xe5 skickas ett sms till det mobilnummer du uppgett, och din bil aktiveras samtidigt i Kia Drive-appen. Du \xf6ppnar bilen genom att trycka p\xe5 'L\xe5s upp & starta' i appen, och du har sedan tv\xe5 minuter p\xe5 dig att starta bilen. Hinner du inte starta bilen trycker du p\xe5 knappen 'Starta och l\xe5s upp' i appen igen, och f\xe5r d\xe5 tv\xe5 nya minuter p\xe5 dig att starta bilen."
                            },
                            {
                                q: "Vad h\xe4nder om jag krockar?",
                                a: "Bilen \xe4r fullt f\xf6rs\xe4krad. Om olyckan skulle vara framme g\xe4ller sj\xe4lvrisk enligt hyresavtalet. <a href='https://www.kia.com/se/kopa/hyr-och-dela/support/forsakring'>L\xe4s mer</a>"
                            },
                            {
                                q: 'Vem tar hand om bilen?',
                                a: "Ni kan v\xe4lja om ni som f\xf6retag tar ansvar f\xf6r allt som r\xf6r bilen, precis som en traditionell tj\xe4nstebil, eller om ni \xf6nskar en fullservicel\xf6sning. Prata med er <a href='https://www.kia.com/se/sok-aterforsaljare-verkstad/#/'>Kia-\xe5terf\xf6rs\xe4ljare</a> f\xf6r att hitta en passande l\xf6sning f\xf6r era behov."
                            }
                        ],
                        title: "Vanliga fr\xe5gor och svar"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bRf1s.VideoClip), {
                        autoplay: true,
                        cropMobile: false,
                        src: "https://kia-afonso-storage.b-cdn.net/filmer/Hyrdela-Appfilm-v2.mp4"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                        page: "rent-app"
                    })
                ]
            })
        ]
    });
};
var $b2e6f056ebf6caa4$export$2e2bcd8739ae039 = $b2e6f056ebf6caa4$var$RentAndShareApp;

});
parcelRegister("1CznZ", function(module, exports) {

$parcel$export(module.exports, "ContentTextBox", function () { return $6aa8e2061bec5d59$export$f497ee19653b40d9; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");
const $6aa8e2061bec5d59$export$f497ee19653b40d9 = ({ title: title, description: description, listItems: listItems, children: children, backgroundColor: backgroundColor = 'bg-white', titleColor: titleColor = 'text-black', textColor: textColor = 'text-gray-600', className: className = '' })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        variants: (0, $51Ucj.containerVariants),
        className: `flex flex-col justify-center gap-8 h-full px-6 py-8 lg:p-8 xl:px-12 ${className} ${backgroundColor}`,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h2, {
                variants: (0, $51Ucj.itemVariants),
                className: titleColor,
                children: title
            }),
            description && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                variants: (0, $51Ucj.itemVariants),
                className: `${textColor}`,
                children: description
            }),
            listItems ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).ol, {
                initial: "hidden",
                whileInView: "visible",
                viewport: (0, $51Ucj.viewPort),
                variants: (0, $51Ucj.containerVariants),
                className: "list-decimal ml-4",
                children: listItems.map((item, index)=>/*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).li, {
                        variants: (0, $51Ucj.itemVariants),
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: "font-bold text-xl",
                                children: item.title
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: "text-gray-600 mb-2 md:mb-4",
                                children: item.text
                            })
                        ]
                    }, index))
            }) : /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                variants: (0, $51Ucj.itemVariants),
                children: children
            })
        ]
    });
};

});


parcelRegister("bW95k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37305321746b3e4d$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $3f5pY = parcelRequire("3f5pY");

var $e2YZi = parcelRequire("e2YZi");

var $avtAN = parcelRequire("avtAN");

var $1CznZ = parcelRequire("1CznZ");

var $zuoP0 = parcelRequire("zuoP0");

var $3V4x6 = parcelRequire("3V4x6");

var $3buP0 = parcelRequire("3buP0");

var $fu5YU = parcelRequire("fu5YU");

var $8Hi9x = parcelRequire("8Hi9x");

var $jeu8h = parcelRequire("jeu8h");

var $bRf1s = parcelRequire("bRf1s");

var $f0NwZ = parcelRequire("f0NwZ");

var $3eb7t = parcelRequire("3eb7t");
const $37305321746b3e4d$var$RentAndShareLanding = ()=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bRf1s.VideoClip), {
                title: "Kia Drive",
                subTitle: "Hyr & Dela",
                autoplay: true,
                src: "https://kia-afonso-storage.b-cdn.net/filmer/HyrDela-Hero-Clean-EV3-appsida.mp4"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "max-w-screen-xl mx-auto",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $avtAN.default), {
                        boxes: [
                            {
                                title: 'HYR',
                                text: "Hyr er n\xe4sta f\xf6retagsbil m\xe5nadsvis.",
                                boxColor: 'bg-gray-100'
                            },
                            {
                                title: 'DELA',
                                text: "Anslut till tj\xe4nsten Kia Drive och g\xf6r bilen bokningsbar per timme.",
                                boxColor: 'bg-gray-100'
                            },
                            {
                                title: "ANV\xc4ND",
                                text: "All administration och anv\xe4ndning sk\xf6ts via appen.",
                                boxColor: 'bg-gray-100'
                            }
                        ],
                        lineColor: "bg-gray-100"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                            firstComponent: /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $1CznZ.ContentTextBox), {
                                title: "S\xe5 fungerar Kia Drive",
                                description: "Hyr en f\xf6retagsbil som alla tj\xe4nar p\xe5. Med v\xe5r bildelningsapp Kia Drive kan ni dela er f\xf6retagsbil med anst\xe4llda eller g\xe4ster under dygnets alla timmar. Ni slipper manuell nyckelhantering och fakturering, och era anv\xe4ndare kan enkelt boka och l\xe5sa upp bilen via appen. Anslut via er \xe5terf\xf6rs\xe4ljare och kom i g\xe5ng redan idag.",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3buP0.InternalLink), {
                                        text: "L\xe4s mer om appen",
                                        href: "https://www.kia.com/se/kopa/hyr-och-dela/hyr-och-dela-app"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                        className: "flex gap-4 mt-10",
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $fu5YU.LinkApp), {
                                                text: "Google Play",
                                                Icon: (0, $zuoP0.GooglePlayIcon),
                                                href: "https://play.google.com/store/apps/details?id=com.ridecell.massiv.kangaroo.prod&hl=en",
                                                target: "_blank"
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $fu5YU.LinkApp), {
                                                text: "App Store",
                                                Icon: (0, $e2YZi.AppStoreIcon),
                                                href: "https://apps.apple.com/se/app/hyr-dela/id1658798260",
                                                target: "_blank"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                src: "https://kia-afonso-storage.b-cdn.net/Handbild-Iphone-HyrDela.png",
                                alt: "KIA Car",
                                sizes: "(max-width: 768px) 50vw, 100vw",
                                className: "object-cover object-center w-[50%] h-auto mx-auto lg:w-full"
                            }),
                            mobilFirstComponentOnTop: false,
                            desktopFirstComponentFirst: false,
                            firstComponentWidth: "lg:col-span-5",
                            secondComponentWidth: "lg:col-span-3"
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3V4x6.GreyBox), {
                            boxes: [
                                {
                                    title: "Uppt\xe4ck v\xe5r laddbara frihet",
                                    text: "Njut av den senaste tekniken och oslagbar frihetsk\xe4nsla med v\xe5ra laddbara bilar."
                                },
                                {
                                    title: 'Enkel administration',
                                    text: "S\xe4g hejd\xe5 till manuell nyckelhantering och bokning."
                                },
                                {
                                    title: 'All inclusive - om ni vill',
                                    text: "Ta del av v\xe5ra fullservicel\xf6sningar f\xf6r service och underh\xe5ll."
                                },
                                {
                                    title: 'Frihet direkt i fickan',
                                    text: "Boka, \xf6ppna, starta, k\xf6r - direkt via appen."
                                },
                                {
                                    title: 'Smart oavsett verksamhet',
                                    text: "Fr\xe5n camping till kontor och verkstad. Kia Drive g\xe5r att anv\xe4nda i alla slags verksamheter."
                                },
                                {
                                    title: 'Kundsupport dygnet runt',
                                    text: "V\xe5r f\xf6rarsupport \xe4r tillg\xe4nglig dygnet runt p\xe5 0770-11 70 00."
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).section, {
                        initial: "hidden",
                        whileInView: "visible",
                        viewport: (0, $51Ucj.viewPort),
                        variants: (0, $51Ucj.containerVariants),
                        className: "w-full lg:grid-cols-2 grid",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8Hi9x.Testimony), {
                                imageSrc: "https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/hyr-och-dela/Bylunds-logo.png",
                                altText: "Hanna Bylund",
                                name: "Hanna Bylund",
                                title: "Bylunds Bil",
                                testimony: "\u201DVi anv\xe4nder Kia Drive f\xf6r v\xe5ra verkstadsbilar. De kunder som redan k\xf6r elbil och \xe4r mer digitala, tycker att det \xe4r kul att ladda ner en app f\xf6r att v\xe4lja l\xe5nebil. Men det \xe4r n\xe4stan \xe4nnu roligare n\xe4r vi n\xe5r de kunder som inte \xe4r lika digitala, utan till och med lite r\xe4dda f\xf6r att testa elbil. N\xe4r l\xe5netiden \xe4r slut och de ska byta tillbaka till sin vanliga bil s\xe4ger n\xe4stan alla att de hellre beh\xe5ller l\xe5nebilen.\u201D"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8Hi9x.Testimony), {
                                imageSrc: "https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/hyr-och-dela/skill-logo.png",
                                altText: "Marie Karlsson",
                                name: "Marie Karlsson",
                                title: "Kontorskoordinator Skill",
                                testimony: "\u201DF\xf6r oss som rekryterings- och bemanningsf\xf6retag \xe4r en egen bilflotta n\xf6dv\xe4ndig och att kunna optimera den efter behov och kostnad \xe4r ov\xe4rderligt. Med Kia Drive f\xe5r vi den flexibiliteten samtidigt som vi kan erbjuda v\xe5ra medarbetare ett cirkul\xe4rt alternativ till att \xe4ga bil. V\xe5rt n\xe4sta steg \xe4r att se \xf6ver v\xe5r nuvarande bilfotta och kanske knacka p\xe5 hos v\xe5ra kontorsgrannar och fr\xe5ga om de vill vara med och dela p\xe5 v\xe5r n\xe4sta bil.\u201D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3f5pY.default), {
                        title: "Vanliga fr\xe5gor och svar om Kia Drive",
                        questions: [
                            {
                                q: 'Hur ser betalningsmodellen ut?',
                                a: "Som f\xf6retag kan ni hyra en eller flera bilar m\xe5nadsvis och har sedan m\xf6jlighet att dela bilen/bilarna med anst\xe4llda eller g\xe4ster under dygnets alla timmar. Ni betalar f\xf6r bilen per m\xe5nad och de som anv\xe4nder bilen betalar f\xf6r sin anv\xe4ndning direkt i appen Kia Drive."
                            },
                            {
                                q: "Vad h\xe4nder om det sker en olycka?",
                                a: "Bilarna \xe4r fullt f\xf6rs\xe4krade. Om olyckan skulle vara framme g\xe4ller sj\xe4lvrisk enligt hyresavtalet."
                            },
                            {
                                q: "Hur f\xe5r anv\xe4ndarna tillg\xe5ng till bilen?",
                                a: "Appen fungerar som en nyckel till bilen. N\xe5gra minuter innan hyresperioden b\xf6rjar skickas ett sms till det mobilnummer som anv\xe4ndaren uppgett, och bilen aktiveras samtidigt i appen Kia Drive. Genom att trycka p\xe5 'L\xe5s upp och starta' i appen l\xe5ser anv\xe4ndaren enkelt upp bilen och har sedan tv\xe5 minuter p\xe5 sig att starta bilen. Om f\xf6raren inte hinner starta bilen under den tiden kan hen alltid trycka p\xe5 'L\xe5s upp och starta' i appen igen."
                            },
                            {
                                q: 'Vem tar hand om bilen?',
                                a: "Ni kan v\xe4lja om ni som f\xf6retag tar ansvar f\xf6r allt som r\xf6r bilen, precis som en traditionell tj\xe4nstebil, eller om ni \xf6nskar en fullservicel\xf6sning. Prata med er <a href='https://www.kia.com/se/sok-aterforsaljare-verkstad/#/' target='_blank'>Kia-\xe5terf\xf6rs\xe4ljare</a> f\xf6r att hitta en l\xf6sning skr\xe4ddarsydd f\xf6r just era behov."
                            }
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                page: "rent-landing"
            })
        ]
    });
};
var $37305321746b3e4d$export$2e2bcd8739ae039 = $37305321746b3e4d$var$RentAndShareLanding;

});
parcelRegister("avtAN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0aaec622a0d956a0$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");
const $0aaec622a0d956a0$var$BoxesWithLines = ({ boxes: boxes, lineColor: lineColor })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        variants: (0, $51Ucj.containerVariants),
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                variants: (0, $51Ucj.itemVariantsNoY),
                className: `absolute md:hidden top-12 left-1/2 ${lineColor} `,
                style: {
                    width: '4px',
                    height: 'calc(100% - 55px)',
                    zIndex: 0
                }
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                variants: (0, $51Ucj.itemVariantsNoY),
                className: `hidden md:block absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${lineColor}`,
                style: {
                    width: 'calc(80% - 85px)',
                    height: '4px',
                    zIndex: 0
                }
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                initial: "hidden",
                whileInView: "visible",
                viewport: (0, $51Ucj.viewPort),
                variants: (0, $51Ucj.containerVariants),
                className: "relative md:place-items-center mx-auto flex flex-col md:grid items-center justify-around space-y-12 md:space-y-0 md:grid-cols-3 my-12 md:mb-20",
                children: boxes.map((box, index)=>/*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
                        variants: (0, $51Ucj.itemVariants),
                        className: `max-w-[440px] w-[85%] flex flex-col gap-2 h-full px-4 py-6 text-center ${box.boxColor}`,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                                className: "font-bold text-lg tracking-[4px]",
                                children: box.title
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                children: box.text
                            })
                        ]
                    }, index))
            })
        ]
    });
};
var $0aaec622a0d956a0$export$2e2bcd8739ae039 = $0aaec622a0d956a0$var$BoxesWithLines;

});

parcelRegister("3V4x6", function(module, exports) {

$parcel$export(module.exports, "GreyBox", function () { return $ac9c19ac796d6e19$export$fb35ff28d91f4230; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");
const $ac9c19ac796d6e19$export$fb35ff28d91f4230 = ({ boxes: boxes })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: "flex flex-col mb-2 bg-gray-100 pt-2 pb-8 pl-2  ",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
            initial: "hidden",
            whileInView: "visible",
            viewport: (0, $51Ucj.viewPort),
            variants: (0, $51Ucj.containerVariants),
            className: "flex p-8 gap-x-4 gap-y-8 flex-wrap justify-around w-full h-fit",
            children: boxes.map((box, index)=>/*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
                    variants: (0, $51Ucj.itemVariants),
                    className: "flex flex-col pt-5 gap-2 w-96  md:h-32",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                            children: box.title
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            children: box.text
                        }),
                        index !== boxes.length - 1 && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: " bg-gray-200 w-full h-0.5 mt-5 md:mt-0 md:h-0 md:w-0"
                        })
                    ]
                }, index))
        })
    });
};

});

parcelRegister("3buP0", function(module, exports) {

$parcel$export(module.exports, "InternalLink", function () { return $f80ee436b9f675ee$export$f35822977cb6df33; });

var $2PPWI = parcelRequire("2PPWI");
const $f80ee436b9f675ee$export$f35822977cb6df33 = ({ text: text, href: href, backgroundColor: backgroundColor = 'bg-dark-blue', textColor: textColor = 'text-white', target: target = '_self' })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
        href: href,
        className: `mt-8 mb-4 font-semibold no-underline inline-block ${backgroundColor} ${textColor} py-6 px-8`,
        target: target,
        children: text
    });
};

});

parcelRegister("8Hi9x", function(module, exports) {

$parcel$export(module.exports, "Testimony", function () { return $d23118a801970d56$export$161bb2463de9d5ec; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");
parcelRequire("8FY87");

var $51Ucj = parcelRequire("51Ucj");

var $3eb7t = parcelRequire("3eb7t");
const $d23118a801970d56$export$161bb2463de9d5ec = ({ imageSrc: imageSrc, altText: altText, name: name, title: title, testimony: testimony })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
        variants: (0, $51Ucj.itemVariants),
        className: "w-full p-4 flex flex-col md:flex-row md:p-6 md:px-10 md:mb-10 md:mt-10 items-center bg-white md:rounded-lg",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "flex w-full md:justify-end md:w-1/3",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "h-28 ml-4 mr-4 md:ml-0 md:h-44",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                            src: imageSrc,
                            alt: altText,
                            className: "object-contain object-center w-full h-full"
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "md:hidden self-end",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: "font-bold text-sm",
                                children: name
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: "text-gray-600",
                                children: title
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "w-full md:w-2/3 p-4 md:p-2 flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        className: "md:text-sm text-gray-800 italic",
                        children: testimony
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "hidden md:block",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: "font-bold text-base",
                                children: name
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: "text-gray-600",
                                children: title
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("9tRLr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3bd12ce2d1f628e$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $3f5pY = parcelRequire("3f5pY");

var $dUhH1 = parcelRequire("dUhH1");

var $1CznZ = parcelRequire("1CznZ");

var $jeu8h = parcelRequire("jeu8h");

var $f0NwZ = parcelRequire("f0NwZ");

var $3eb7t = parcelRequire("3eb7t");
const $d3bd12ce2d1f628e$var$RentAndShareLanding = ()=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $dUhH1.default), {
                title: "Kia Drive",
                subtitle: "Hyr & Dela",
                image: "https://kia-afonso-storage.b-cdn.net/Kia-Hyr-och-dela-bilar.jpg",
                mobileImage: "https://kia-afonso-storage.b-cdn.net/Kia-Hyr-och-dela-bilar-mobile-2.jpg"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "w-full max-w-screen-kia mx-auto",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jeu8h.TwoFlexibleComponentBox), {
                        firstComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1CznZ.ContentTextBox), {
                            className: "max-w-[650px]",
                            title: "Kontakta oss",
                            children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: "flex gap-4 flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                        children: [
                                            "\xc4r ditt f\xf6retag intresserade av Kia Drive eller \xe4r ni redan kund och har fr\xe5gor kring avtal och uppl\xe4gg? Mejla oss p\xe5",
                                            ' ',
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                                href: "mailto:mobilitet@kia.se",
                                                children: "mobilitet@kia.se"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                        children: [
                                            "Har du fr\xe5gor kring daglig drift och anv\xe4ndning? Kontakta oss p\xe5 ",
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                                href: "mailto:info@kia.se",
                                                children: "info@kia.se"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                        children: [
                                            "Beh\xf6ver du akut hj\xe4lp och f\xf6rarsupport? Till exempel om hyran inte p\xe5b\xf6rjas Ring ",
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                                href: "tel:0770-117000",
                                                children: "0770-117000"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        secondComponent: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                            src: "https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/hyr-och-dela/RHD_EV6_GTL_MY25_LifstyleExterior_Side_with_Talent_CMYK-2.png",
                            alt: "KIA Car",
                            sizes: "(max-width: 768px) 100vw, 50vw",
                            className: "max-h-[450px] object-cover object-center"
                        }),
                        mobilFirstComponentOnTop: true,
                        desktopFirstComponentFirst: false
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3f5pY.default), {
                        className: "bg-dark-blue",
                        questions: [
                            {
                                q: "Appen fungerar inte. Vad ska jag g\xf6ra?",
                                a: "Testa att starta om telefonen och appen. Dubbelkolla att du har bra mobilt\xe4ckning. Fungerar det fortfarande inte? Kontakta oss p\xe5 <a href='tel:0770117000'>0770-11 70 00</a>."
                            },
                            {
                                q: 'Hur raderar jag mitt konto?',
                                a: "Mejla oss p\xe5 <a href='mailto:mobilitet@kia.se'>mobilitet@kia.se</a> s\xe5 hj\xe4lper vi dig att radera din profil och all kunddata fr\xe5n plattformen."
                            },
                            {
                                q: 'Jag har laddat ned appen men det finns inga bilar att boka.',
                                a: "Kia Drive \xe4r en bildelningstj\xe4nst f\xf6r slutna grupper. F\xf6r att kunna boka bilar beh\xf6ver du vara del av en grupp. \xc4r du inbjuden till Kia Drive kan du kontakta den som bj\xf6d in dig f\xf6r att f\xe5 hj\xe4lp. Du kan ocks\xe5 v\xe4nda dig till <a href='mailto:mobilitet@kia.se'>mobilitet@kia.se</a>. Kom ih\xe5g att ber\xe4tta vilken grupp du tillh\xf6r, s\xe5 att vi kan bjuda in dig p\xe5 nytt. Du kommer d\xe5 att f\xe5 en kod som du anger under Inst\xe4llningar i appen Kia Drive."
                            },
                            {
                                q: "Hur ska jag p\xe5b\xf6rja min hyrperiod?",
                                a: "N\xe4r startpunkten f\xf6r din hyra n\xe4rmar sig f\xe5r du ett sms d\xe4r det st\xe5r vilket registreringsnummer din bil har. Bilen blir tillg\xe4nglig i appen tio minuter innan din angivna tidsbokning. N\xe4r du kan b\xf6rja anv\xe4nda bilen dyker den upp i appen under Mina resor."
                            },
                            {
                                q: "Min bil dyker inte upp i appen trots att min bokning b\xf6rjar.",
                                a: "Kontakta f\xf6rararsupport p\xe5 nummer <a href='tel:0770117000'>0770-11 70 00</a>. De hj\xe4lper dig med hyror som inte startar eller beh\xf6ver f\xf6rl\xe4ngas, samt andra akuta problem som kan uppst\xe5 inf\xf6r och under hyrperioden."
                            },
                            {
                                q: 'Jag kan inte starta bilen.',
                                a: "Fr\xe5n det att du klickar p\xe5 L\xe5s upp & starta \xe4r bilen aktiv i tv\xe5 minuter. Under den tiden kan du starta bilen. Om du inte hinner starta bilen inom tv\xe5 minuter beh\xf6ver du klicka p\xe5 L\xe5s upp & starta p\xe5 nytt f\xf6r att bilen ska starta."
                            },
                            {
                                q: "Jag kan inte l\xe5sa eller l\xe5sa upp bilen.",
                                a: "Appen och bilen kommunicerar via mobildata och Bluetooth. Om signalerna \xe4r svaga eller om det finns st\xf6rningar kan det ta upp till tv\xe5 minuter innan bilen svarar. Ring f\xf6rararsupport om det inte funkar efter ett par f\xf6rs\xf6k."
                            },
                            {
                                q: 'Jag hittar inte bilen.',
                                a: "Klicka p\xe5 stationen i appen s\xe5 kan Google guida dig r\xe4tt. Om du redan \xe4r p\xe5 r\xe4tt plats men inte hittar bilen, kontakta v\xe5r f\xf6rararsupport."
                            },
                            {
                                q: "Hur f\xe5r jag upp tanklocket?",
                                a: "F\xf6r att \xf6ppna tanklocket trycker du p\xe5 en knapp som sitter till v\xe4nster om ratten. I laddhybrider kan det dr\xf6ja en stund innan luckan \xf6ppnar sig eftersom br\xe4nsletanken beh\xf6ver tryckregleras innan den g\xe5r att \xf6ppna."
                            },
                            {
                                q: 'Hur laddar jag bilen?',
                                a: "N\xe4r bilen \xe4r ol\xe5st g\xe5r det oftast att \xf6ppna laddluckan med ett l\xe4tt tryck. I vissa bilar finns \xe4ven en knapp till v\xe4nster om ratten. Det finns n\xe5gra olika sorters laddningskontakter. Du kan inte g\xf6ra fel om kabeln passar i bilen. Vid en privat laddare r\xe4cker det vanligtvis med att stoppa in kabeln i bilen f\xf6r att laddningen ska starta. Vid publika laddare beh\xf6ver du oftast starta laddningen via en app eller med en RFID-bricka. Vill du ha en smidig laddningsapp som fungerar hos n\xe4stan alla laddoperat\xf6rer i Europa? Kolla in <a href='https://www.kia.com/se/aga/support/kia-charge/'>Kia Charge</a>."
                            },
                            {
                                q: 'Laddsladden har fastnat i bilen.',
                                a: "Om laddsladden fastnar i bilen kan du testa att l\xe5sa upp bilen fr\xe5n l\xe5sknappen som finns inuti bilen. Knappen sitter oftast kring v\xe4xelspaken eller p\xe5 mittkonsolen. Laddar du p\xe5 en publik laddstation ska du f\xf6rst avsluta laddningen p\xe5 samma s\xe4tt som du p\xe5b\xf6rjade laddningen. Funkar det inte kan du trycka p\xe5 n\xf6dstoppknappen som sitter p\xe5 laddstationen och sedan f\xf6rs\xf6ka ta loss kabeln fr\xe5n bilen. Om du fortfarande inte kan koppla bort sladden kan du kontakta laddoperat\xf6ren eller v\xe5r f\xf6rarsupport."
                            },
                            {
                                q: "Jag r\xe5kade starta bilen med laddkabeln i och nu vill den inte starta?",
                                a: "St\xe4ng f\xf6rst av bilen genom att trycka p\xe5 startknappen utan att ha foten p\xe5 bromsen. Instrumentbelysningen ska d\xe5 slockna. L\xe5s sedan upp bilen med l\xe5sknappen som finns inne i bilen och dra sedan ur laddkabeln. D\xe4refter ska bilen g\xe5 att starta som vanligt."
                            }
                        ],
                        title: "Vanliga fr\xe5gor och svar"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                        page: "rent-support"
                    })
                ]
            })
        ]
    });
};
var $d3bd12ce2d1f628e$export$2e2bcd8739ae039 = $d3bd12ce2d1f628e$var$RentAndShareLanding;

});

parcelRegister("acaxR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed3599aea0dba494$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $jZedf = parcelRequire("jZedf");

var $1lSPe = parcelRequire("1lSPe");

var $h5X6g = parcelRequire("h5X6g");

var $3eb7t = parcelRequire("3eb7t");
const $ed3599aea0dba494$var$Story = ({ heading: heading, tag: tag, category: category, centerTitle: centerTitle, hideTitle: hideTitle })=>{
    const [posts, setPosts] = (0, $8FY87.useState)([]);
    const [testTag, setTestTag] = (0, $8FY87.useState)(null);
    const [testCategory, setTestCategory] = (0, $8FY87.useState)(null);
    const [testHeading, setTestHeading] = (0, $8FY87.useState)(null);
    const [categoryOrTagName, setCategoryOrTagName] = (0, $8FY87.useState)(null);
    const [blockOptions, setBlockOptions] = (0, $8FY87.useState)({
        centerTitle: centerTitle || false,
        hideTitle: hideTitle || false
    });
    const postsFragment = `
    posts(first: 3) {
      nodes {
        link
        title
        excerpt
        categories {
          nodes {
            name
          }
        }
        featuredImage {
          node {
            sourceUrl(size: MEDIUM_LARGE)
            altText
          }
        }
      }
    }
  `;
    const postsQuery = `
    query getPosts {
      ${postsFragment}
    }
  `;
    const tagQuery = `
    query getPostsByTag {
      tag(id: "${testTag ?? tag}", idType: ID) {
        ${postsFragment}
        name
      }
    }
  `;
    const categoryQuery = `
    query getPostsByCategory {
      category(id: "${testCategory ?? category}", idType: ID) {
        ${postsFragment}
        name
      }
    }
  `;
    const options = {
        method: 'POST',
        body: JSON.stringify({
            query: category || testCategory ? categoryQuery : tag || testTag ? tagQuery : postsQuery,
            variables: {}
        })
    };
    const fetchPosts = async ()=>{
        const { data: data, status: status } = await (0, $jZedf.fetchWithType)('https://kia-blog.live.afonso.se/graphql', options);
        if (data?.data && !('errors' in data) && status === 200) {
            if ('posts' in data.data) setPosts(data.data.posts.nodes);
            else if ('tag' in data.data) {
                setCategoryOrTagName(data.data.tag.name);
                if (data.data.tag.posts?.nodes) setPosts(data.data.tag.posts.nodes);
            } else if ('category' in data.data) {
                setCategoryOrTagName(data.data.category.name);
                if (data.data.category.posts?.nodes) setPosts(data.data.category.posts.nodes);
            }
        }
    };
    (0, $8FY87.useEffect)(()=>{
        fetchPosts();
    }, []);
    (0, $8FY87.useEffect)(()=>{
        if (testTag) fetchPosts();
        else if (testCategory) fetchPosts();
    }, [
        testTag,
        testCategory
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            !(0, $1lSPe.locationIsKia)() ? /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "my-10 max-w-screen-kia-sm mx-auto grid gap-2 px-4",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("h1", {
                                className: "pb-4 text-3xl font-bold",
                                children: "Detta \xe4r ett block f\xf6r att h\xe4mta blogginl\xe4gg fr\xe5n Kia Story"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                className: "grid",
                                children: [
                                    'Justera f\xf6ljande filter och klicka sedan p\xe5 "Visa kodsnutt" l\xe4ngst ned till h\xf6ger',
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                        className: "font-bold",
                                        children: "Om ingen tag eller kategori anv\xe4nds s\xe5 h\xe4mtas de tre senaste inl\xe4ggen"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $h5X6g.default), {
                        setTestCategory: setTestCategory,
                        setTestTag: setTestTag,
                        setTestHeading: setTestHeading,
                        testTag: testTag,
                        testCategory: testCategory,
                        testHeading: testHeading,
                        blockOptions: blockOptions,
                        setBlockOptions: setBlockOptions
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
                className: "my-10 max-w-screen-kia-sm mx-auto",
                children: [
                    blockOptions.hideTitle ? null : /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                        "data-center": blockOptions.centerTitle || false,
                        className: "mb-8 text-2xl font-bold px-4 md:px-1 data-[center='true']:text-center",
                        children: testHeading ?? heading ?? 'Kia Story'
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                        className: "grid grid-flow-col auto-cols-[80vw] md:auto-cols-fr snap-x snap-mandatory overflow-x-auto md:px-1 md:gap-4 pb-4 md:pb-8 h-full",
                        children: posts.map((post, i)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                className: `${i === 0 ? 'snap-start' : i === 1 ? 'snap-center' : 'snap-end'} no-underline relative group px-2 md:px-0 `,
                                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: "post w-full shadow-md shadow-black/6 h-full rounded overflow-hidden grid grid-rows-[auto_1fr]",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                            className: "px-5 md:px-6 pt-5 pb-6 md:pb-8 h-full",
                                            children: [
                                                /*#__PURE__*/ (0, $2PPWI.jsx)("h4", {
                                                    className: "flex items-center group-hover:underline text-2xl font-bold mb-3",
                                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                        children: post.title
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                                    className: "text-base font-light line-clamp-6",
                                                    dangerouslySetInnerHTML: {
                                                        __html: post.excerpt
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                                    href: post.link,
                                                    target: "_blank",
                                                    className: "absolute inset-0",
                                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                        className: "sr-only",
                                                        children: post.title
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                            className: "overflow-hidden aspect-[4/3] -order-1",
                                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
                                                loading: "lazy",
                                                width: "300",
                                                height: "300",
                                                className: "w-full h-full object-cover group-hover:scale-[1.025] transition-all duration-500",
                                                src: post.featuredImage?.node?.sourceUrl,
                                                alt: post.featuredImage?.node?.altText ?? post.title
                                            })
                                        })
                                    ]
                                })
                            }, i))
                    })
                ]
            })
        ]
    });
};
var $ed3599aea0dba494$export$2e2bcd8739ae039 = $ed3599aea0dba494$var$Story;

});
parcelRegister("h5X6g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6bab9002e13b008$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $jZedf = parcelRequire("jZedf");

var $f0NwZ = parcelRequire("f0NwZ");
const $e6bab9002e13b008$var$StoryFilters = ({ setTestCategory: setTestCategory, setTestTag: setTestTag, setTestHeading: setTestHeading, setBlockOptions: setBlockOptions, testTag: testTag, testCategory: testCategory, testHeading: testHeading, blockOptions: blockOptions })=>{
    const [categories, setCategories] = (0, $8FY87.useState)([]);
    const [tags, setTags] = (0, $8FY87.useState)([]);
    const fetchCategoriesAndTags = async ()=>{
        const { data: data, status: status } = await (0, $jZedf.fetchWithType)('https://kia-blog.live.afonso.se/graphql', {
            method: 'POST',
            body: JSON.stringify({
                query: `
          query getCategoriesAndTags {
            categories(first: 1000, where: {hideEmpty: true}) {
              nodes {
                name
                id
              }
            }
            tags(first: 1000, where: {hideEmpty: true}) {
              nodes {
                name
                id
              }
            }
          }
        `,
                variables: {}
            })
        });
        if (data?.data && status === 200) {
            setCategories(data.data.categories.nodes);
            setTags(data.data.tags.nodes);
        }
    };
    (0, $8FY87.useEffect)(()=>{
        fetchCategoriesAndTags();
    }, []);
    const handleSetTestTag = (id)=>{
        setTestCategory(null);
        setTestTag(id);
    };
    const handleSetTestCategory = (id)=>{
        setTestTag(null);
        setTestCategory(id);
    };
    const getSnippetProps = ()=>{
        const props = [];
        if (testHeading) props.push(`heading="${testHeading}"`);
        if (testCategory) props.push(`category="${testCategory}"`);
        else if (testTag) props.push(`tag="${testTag}"`);
        if (blockOptions?.centerTitle) props.push(`centerTitle="true"`);
        if (blockOptions?.hideTitle) props.push(`hideTitle="true"`);
        return props.join(' ');
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "pt-2 grid gap-2",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("label", {
                className: "grid gap-1 items-center",
                children: [
                    "Rubrik",
                    /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                        type: "text",
                        placeholder: "Ange en rubrik",
                        className: "border-black border p-2 w-full rounded-sm",
                        onChange: (e)=>setTestHeading(e.currentTarget.value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "grid grid-cols-2 gap-2",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("label", {
                        className: "grid gap-1 items-center",
                        children: [
                            "Kategori",
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("select", {
                                className: "border-black border p-2 w-full rounded-sm",
                                onChange: (e)=>handleSetTestCategory(e.currentTarget.value),
                                value: testCategory || '',
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                        value: "",
                                        children: "V\xe4lj kategori"
                                    }),
                                    categories.map((category)=>/*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                            value: category.id,
                                            children: category.name
                                        }, category.id))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("label", {
                        className: "grid gap-1 items-center",
                        children: [
                            "Tag",
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("select", {
                                className: "border-black border p-2 w-full rounded-sm",
                                onChange: (e)=>handleSetTestTag(e.currentTarget.value),
                                value: testTag || '',
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                        value: "",
                                        children: "V\xe4lj tag"
                                    }),
                                    tags.map((tag)=>/*#__PURE__*/ (0, $2PPWI.jsx)("option", {
                                            value: tag.id,
                                            children: tag.name
                                        }, tag.id))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "flex gap-8",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "flex gap-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                type: "checkbox",
                                name: "center-title",
                                id: "center-title",
                                checked: blockOptions?.centerTitle || false,
                                onChange: ()=>setBlockOptions((prev)=>({
                                            ...prev,
                                            centerTitle: !prev.centerTitle
                                        }))
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                htmlFor: "center-title",
                                children: "Centrera titeln"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "flex gap-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                type: "checkbox",
                                name: "hide-title",
                                id: "hide-title",
                                checked: blockOptions?.hideTitle || false,
                                onChange: ()=>setBlockOptions((prev)=>({
                                            ...prev,
                                            hideTitle: !prev.hideTitle
                                        }))
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                htmlFor: "hide-title",
                                children: "D\xf6lja titeln"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                page: "story",
                props: getSnippetProps()
            })
        ]
    });
};
var $e6bab9002e13b008$export$2e2bcd8739ae039 = $e6bab9002e13b008$var$StoryFilters;

});


parcelRegister("l9J5q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6e16b8dbbe89767$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $f0NwZ = parcelRequire("f0NwZ");

var $79vA2 = parcelRequire("79vA2");

var $2FCIq = parcelRequire("2FCIq");

var $hrXpK = parcelRequire("hrXpK");
const $f6e16b8dbbe89767$var$Summer = ()=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("main", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $79vA2.default), {
                    ...(0, $hrXpK.hero_Summer)
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "w-full max-w-screen-kia mx-auto pl-2 pr-2",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "max-w-7xl mx-auto mb-4",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            className: "text-center font-light text-[18px] sm:text-[20px] px-2 mt-[30px]",
                            children: (0, $hrXpK.lead)
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "flex flex-col items-center gap-1  sm:gap-10 sm:flex-row sm:justify-center",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                ...(0, $hrXpK.link_private)
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2FCIq.default), {
                                ...(0, $hrXpK.link_company)
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0NwZ.default), {
                                page: "summer"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $f6e16b8dbbe89767$export$2e2bcd8739ae039 = $f6e16b8dbbe89767$var$Summer;

});
parcelRegister("79vA2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76964b38346d971c$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");
const $76964b38346d971c$var$HeroImgDeskAndMobil = ({ image: image, mobileImage: mobileImage, title: title, subtitle: subtitle, position: position = 'center', textColor: textColor = 'text-white' })=>{
    const textPositionClass = position === 'top' ? 'top-10 left-1/2 -translate-x-1/2' : position === 'bottom' ? 'bottom-5 left-1/2 -translate-x-1/2' : 'left-1/2 -translate-x-1/2 top-[65%] -translate-y-1/2 sm:top-1/2';
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
        className: "relative flex w-full h-[80vh] max-h-[918px] lg:max-h-[1018px]",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("picture", {
                className: "absolute inset-0 z-0",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                        media: "(min-width:1024px)",
                        srcSet: image
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                        src: mobileImage ?? image,
                        alt: title ?? '',
                        className: "w-full h-full object-cover object-[center_20%] select-none",
                        loading: "eager",
                        decoding: "async"
                    })
                ]
            }),
            (title || subtitle) && /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
                variants: (0, $51Ucj.containerVariants),
                viewport: (0, $51Ucj.viewPort),
                initial: "hidden",
                whileInView: "visible",
                className: `absolute z-10 ${textPositionClass} w-full text-center grid gap-1 ${textColor} px-4`,
                children: [
                    title && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h1, {
                        variants: (0, $51Ucj.itemVariants),
                        className: "font-medium leading-tight whitespace-pre-line",
                        style: {
                            fontSize: 'clamp(20px, 8vw, 72px)'
                        },
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                        variants: (0, $51Ucj.itemVariants),
                        className: "text-xl sm:text-2xl leading-tight whitespace-pre-line",
                        children: subtitle
                    })
                ]
            })
        ]
    });
};
var $76964b38346d971c$export$2e2bcd8739ae039 = $76964b38346d971c$var$HeroImgDeskAndMobil;

});

parcelRegister("hrXpK", function(module, exports) {

$parcel$export(module.exports, "hero_Summer", function () { return $3805dbf4fb58a5fc$export$793ace73a25edcab; });
$parcel$export(module.exports, "lead", function () { return $3805dbf4fb58a5fc$export$3f2a8c4c78c0ce1c; });
$parcel$export(module.exports, "link_company", function () { return $3805dbf4fb58a5fc$export$87238a804e47eaac; });
$parcel$export(module.exports, "link_private", function () { return $3805dbf4fb58a5fc$export$8a3fe1730cd51ed2; });
const $3805dbf4fb58a5fc$export$793ace73a25edcab = {
    title: "Sommarerbjudanden fr\xe5n Kia.",
    image: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/laddbar-frihet/rangebild_hoga_kusten_1920x671px.jpg',
    mobileImage: 'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/laddbar-frihet/rangebild_hoga_kusten_1024x768px.jpg',
    position: 'bottom'
};
const $3805dbf4fb58a5fc$export$46e4a324ac90507f = "Sommarerbjudanden fr\xe5n Kia.";
const $3805dbf4fb58a5fc$export$3f2a8c4c78c0ce1c = "Lagom till v\xe4rme och ledighet h\xf6jer vi temperaturen p\xe5 v\xe5ra erbjudanden. Just nu har vi kampanjer p\xe5 flera popul\xe4ra elbilar och laddhybrider. V\xe4lkommen in och uppt\xe4ck den laddbara friheten med Kia.";
const $3805dbf4fb58a5fc$export$87238a804e47eaac = {
    text: "F\xf6retagserbjudanden",
    textSize: '16px',
    url: 'https://www.kia.com/se/kopa/kampanjer/elbilserbjudanden/',
    className: 'mt-6 ',
    openInNewTab: false
};
const $3805dbf4fb58a5fc$export$8a3fe1730cd51ed2 = {
    text: 'Privaterbjudanden',
    textSize: '16px',
    url: 'https://www.kia.com/se/kopa/erbjudanden/',
    className: 'mt-6',
    openInNewTab: false
};

});


parcelRegister("8RlLI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64bcd253197a65c9$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $k7h0Y = parcelRequire("k7h0Y");

var $jAgEx = parcelRequire("jAgEx");
var $huzw8 = parcelRequire("huzw8");
var $4NoTr = parcelRequire("4NoTr");
var $4Qpe2 = parcelRequire("4Qpe2");

var $8FY87 = parcelRequire("8FY87");

var $elAir = parcelRequire("elAir");

const $64bcd253197a65c9$var$Snippet = /*#__PURE__*/ (0, $8FY87.lazy)(()=>Promise.resolve((parcelRequire("f0NwZ"))));
const $64bcd253197a65c9$var$questions = [
    {
        name: 'answer1',
        question: "Hur m\xe5nga v\xe4rldsrekord har Kia inskrivna i Guiness rekordbok?",
        options: [
            {
                label: '1',
                value: '1',
                text: '2'
            },
            {
                label: 'X',
                value: 'X',
                text: '4'
            },
            {
                label: '2',
                value: '2',
                text: '6'
            }
        ]
    },
    {
        name: 'answer2',
        question: "Hur m\xe5nga nya fordonstekniker beh\xf6vs i Sverige inom tre \xe5r?",
        options: [
            {
                label: '1',
                value: '1',
                text: '6 500 st'
            },
            {
                label: 'X',
                value: 'X',
                text: '650 st'
            },
            {
                label: '2',
                value: '2',
                text: '65 000 st'
            }
        ]
    },
    {
        name: 'answer3',
        question: "Kia kommer fr\xe5n Sydkorea. Vilken popul\xe4r Netflix-serie kommer fr\xe5n samma land?",
        options: [
            {
                label: '1',
                value: '1',
                text: 'Love is blind'
            },
            {
                label: 'X',
                value: 'X',
                text: 'Squid Game'
            },
            {
                label: '2',
                value: '2',
                text: 'Bridgerton'
            }
        ]
    }
];
const $64bcd253197a65c9$var$schema = (0, $elAir.object)({
    answer1: (0, $elAir.string)().min(1, "V\xe4lj ett svar"),
    answer2: (0, $elAir.string)().min(1, "V\xe4lj ett svar"),
    answer3: (0, $elAir.string)().min(1, "V\xe4lj ett svar"),
    motivation: (0, $elAir.string)().min(1, "Motivering kr\xe4vs").max(255, 'Max 255 tecken'),
    name: (0, $elAir.string)().min(1, "Namn kr\xe4vs"),
    phone: (0, $elAir.string)().regex(/^(\+46|0)7[0-9\s\-]{7,9}$/, 'Ange ett giltigt mobilnummer'),
    email: (0, $elAir.string)().optional(),
    acceptTerms: (0, $elAir.boolean)().refine((v)=>v === true, {
        message: "Du m\xe5ste godk\xe4nna t\xe4vlingsvillkoren"
    })
});
const $64bcd253197a65c9$var$termsText = `Genom att delta i t\xe4vlingen godk\xe4nner du f\xf6ljande villkor. T\xe4vlingen arrangeras av Kia Sweden AB och f\xf6r att delta ska du besvara t\xe4vlingsfr\xe5gorna samt l\xe4mna en motivering enligt anvisningarna. Anst\xe4llda hos Kia Sweden AB, samt deras n\xe4rst\xe5ende, f\xe5r inte delta i t\xe4vlingen. Vinnaren utses av en jury baserat p\xe5 korrekta svar och b\xe4sta motivering, och juryns beslut kan inte \xf6verklagas. Eventuell vinst kan inte bytas mot kontanter eller \xf6verl\xe5tas till annan person. Vinnaren dras i samband med yrkes-SM och kontaktas via de kontaktuppgifter som angivits i samband med t\xe4vlingsbidraget, och om vinnaren inte svarar f\xf6rbeh\xe5ller vi oss r\xe4tten att utse en ny vinnare. Eventuell vinstskatt eller andra kostnader som kan uppst\xe5 i samband med vinsten betalas av vinnaren. Genom att delta godk\xe4nner du att dina personuppgifter behandlas i syfte att administrera t\xe4vlingen i enlighet med g\xe4llande dataskyddslagstiftning.`;
function $64bcd253197a65c9$var$FieldError({ errors: errors }) {
    if (!errors.length) return null;
    const message = errors[0]?.message ?? String(errors[0]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
        role: "alert",
        "aria-live": "polite",
        className: "text-red-500 text-sm mt-2",
        children: message
    });
}
const $64bcd253197a65c9$var$TavlingYrkesSM = ()=>{
    const [submitted, setSubmitted] = (0, $8FY87.useState)(false);
    const scrollToSubmitted = (0, $8FY87.useCallback)((node)=>{
        node?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }, []);
    const form = (0, $k7h0Y.useForm)({
        defaultValues: {
            answer1: '',
            answer2: '',
            answer3: '',
            motivation: '',
            name: '',
            phone: '',
            email: '',
            acceptTerms: false
        },
        onSubmit: async ({ value: value })=>{
            if (value.email && value.email.length > 0) {
                //honeypot field
                setSubmitted(true);
                return;
            }
            const res = await fetch('https://kia-nodemailer.vercel.app/api/contest', {
                method: 'POST',
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    values: value
                })
            });
            if (!res.ok) throw new Error("N\xe5got gick fel, v\xe4nligen f\xf6rs\xf6k igen senare.");
            setSubmitted(true);
        },
        validators: {
            onSubmit: $64bcd253197a65c9$var$schema
        }
    });
    if (submitted) return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4NoTr.LazyMotion), {
        features: (0, $huzw8.domAnimation),
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
            ref: scrollToSubmitted,
            initial: {
                opacity: 0,
                y: 24
            },
            animate: {
                opacity: 1,
                y: 0
            },
            transition: {
                duration: 0.6,
                ease: [
                    0.16,
                    1,
                    0.3,
                    1
                ]
            },
            className: "max-w-screen-kia-sm mx-auto px-4 py-24 text-center",
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: "inline-block border border-black px-3 py-1 text-sm mb-6",
                    children: "Skickat"
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                    className: "text-4xl md:text-5xl font-medium mb-6 leading-tight",
                    children: "Tack!"
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                    className: "max-w-prose mx-auto text-base font-light leading-relaxed text-gray-600",
                    children: "H\xe5ll koll p\xe5 din mobil. Vi kommer meddela vinnarna under dagen f\xf6r att de ska kunna h\xe4mta upp priset."
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                    type: "reset",
                    onClick: ()=>{
                        setSubmitted(false);
                        form.reset();
                    },
                    className: "mt-8 border border-[#05141F] text-[#05141F] px-8 py-3 text-base font-medium hover:bg-[#05141F] hover:text-white transition-colors",
                    children: "Skicka in nytt bidrag"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4NoTr.LazyMotion), {
        features: (0, $huzw8.domAnimation),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "bg-[#05141F] text-white px-4 py-14 md:py-20",
                        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: "max-w-screen-kia-sm mx-auto",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                                    initial: {
                                        opacity: 0,
                                        y: 16
                                    },
                                    animate: {
                                        opacity: 1,
                                        y: 0
                                    },
                                    transition: {
                                        duration: 0.5,
                                        ease: [
                                            0.16,
                                            1,
                                            0.3,
                                            1
                                        ]
                                    },
                                    className: "inline-block border border-white/30 px-3 py-1 text-sm mb-6",
                                    children: "T\xe4vling"
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h1, {
                                    initial: {
                                        opacity: 0,
                                        y: 20
                                    },
                                    animate: {
                                        opacity: 1,
                                        y: 0
                                    },
                                    transition: {
                                        duration: 0.6,
                                        delay: 0.1,
                                        ease: [
                                            0.16,
                                            1,
                                            0.3,
                                            1
                                        ]
                                    },
                                    className: "text-4xl md:text-6xl font-medium leading-tight mb-5",
                                    children: "T\xe4vla med Kia"
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                                    initial: {
                                        opacity: 0,
                                        y: 16
                                    },
                                    animate: {
                                        opacity: 1,
                                        y: 0
                                    },
                                    transition: {
                                        duration: 0.6,
                                        delay: 0.2,
                                        ease: [
                                            0.16,
                                            1,
                                            0.3,
                                            1
                                        ]
                                    },
                                    className: "text-base font-light text-white/70 max-w-prose leading-relaxed",
                                    children: "Svara r\xe4tt p\xe5 tre fr\xe5gor och t\xe4vla om fina priser (v\xe4rde upp till 400 kr/st) fr\xe5n Kia."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                        className: "max-w-screen-kia-sm mx-auto px-4 py-14",
                        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("form", {
                            onSubmit: (e)=>{
                                e.preventDefault();
                                e.stopPropagation();
                                form.handleSubmit();
                            },
                            className: "flex flex-col gap-14",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                    className: "flex flex-col gap-12",
                                    children: $64bcd253197a65c9$var$questions.map((q, qi)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                                            initial: {
                                                opacity: 0,
                                                y: 20
                                            },
                                            animate: {
                                                opacity: 1,
                                                y: 0
                                            },
                                            transition: {
                                                duration: 0.5,
                                                delay: 0.15 + qi * 0.1,
                                                ease: [
                                                    0.16,
                                                    1,
                                                    0.3,
                                                    1
                                                ]
                                            },
                                            children: /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                                name: q.name,
                                                children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("fieldset", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $2PPWI.jsxs)("legend", {
                                                                className: "mb-5",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                                                                        className: "block text-sm font-light text-gray-400 mb-1",
                                                                        children: [
                                                                            "Fr\xe5ga ",
                                                                            qi + 1
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                                        className: "block text-lg md:text-xl font-medium leading-snug",
                                                                        children: q.question
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                                                className: "grid md:grid-cols-3 gap-3",
                                                                children: q.options.map((opt)=>{
                                                                    const isSelected = field.state.value === opt.value;
                                                                    const hasError = field.state.meta.errors.length > 0;
                                                                    return /*#__PURE__*/ (0, $2PPWI.jsxs)("label", {
                                                                        className: `
                                  relative flex flex-col items-center justify-between
                                  gap-4 p-4 md:p-5 cursor-pointer select-none
                                  border transition-all duration-200
                                  rounded-sm
                                  ${isSelected ? 'border-[#05141F] bg-[#05141F] text-white' : hasError ? 'border-red-300 bg-red-50/40 hover:border-red-400' : 'border-gray-200 bg-[#F7F7F7] hover:border-gray-400 hover:bg-white'}
                                `,
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                                                className: `text-base md:text-lg font-medium text-center leading-snug ${isSelected ? 'text-white' : 'text-[#05141F]'}`,
                                                                                children: opt.text
                                                                            }),
                                                                            /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                                                type: "radio",
                                                                                className: "sr-only",
                                                                                name: field.name,
                                                                                value: opt.value,
                                                                                checked: isSelected,
                                                                                onBlur: field.handleBlur,
                                                                                onChange: ()=>field.handleChange(opt.value)
                                                                            })
                                                                        ]
                                                                    }, opt.value);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2PPWI.jsx)($64bcd253197a65c9$var$FieldError, {
                                                                errors: field.state.meta.errors
                                                            })
                                                        ]
                                                    })
                                            })
                                        }, q.name))
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
                                    initial: {
                                        opacity: 0,
                                        y: 16
                                    },
                                    animate: {
                                        opacity: 1,
                                        y: 0
                                    },
                                    transition: {
                                        duration: 0.5,
                                        delay: 0.45,
                                        ease: [
                                            0.16,
                                            1,
                                            0.3,
                                            1
                                        ]
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                            name: "motivation",
                                            children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                            className: "block text-base font-medium mb-2",
                                                            htmlFor: field.name,
                                                            children: "Motivera med max tv\xe5 meningar varf\xf6r just du ska vinna"
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("textarea", {
                                                            id: field.name,
                                                            rows: 4,
                                                            className: `w-full border resize-none border-kia-gray rounded px-4 py-3 text-base focus:outline-none focus:border-black focus:ring-1 focus:ring-black transition-colors ${field.state.meta.errors.length ? 'border-red-400 focus:border-red-600' : 'border-gray-200 focus:border-[#05141F] focus:ring-1 focus:ring-[#05141F]'}`,
                                                            value: field.state.value,
                                                            onBlur: field.handleBlur,
                                                            onChange: (e)=>field.handleChange(e.target.value)
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)($64bcd253197a65c9$var$FieldError, {
                                                            errors: field.state.meta.errors
                                                        })
                                                    ]
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                            className: "mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                                    name: "name",
                                                    children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                                    className: "block text-base font-medium mb-2",
                                                                    htmlFor: field.name,
                                                                    children: "Namn"
                                                                }),
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                                    type: "text",
                                                                    id: field.name,
                                                                    autoComplete: "name",
                                                                    className: `w-full border border-kia-gray h-12 rounded px-4 py-3 text-base focus:outline-none focus:border-black focus:ring-1 focus:ring-black transition-colors ${field.state.meta.errors.length ? 'border-red-400 focus:border-red-600' : 'border-gray-200 focus:border-[#05141F] focus:ring-1 focus:ring-[#05141F]'}`,
                                                                    value: field.state.value,
                                                                    onBlur: field.handleBlur,
                                                                    onChange: (e)=>field.handleChange(e.target.value)
                                                                }),
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)($64bcd253197a65c9$var$FieldError, {
                                                                    errors: field.state.meta.errors
                                                                })
                                                            ]
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                                    name: "phone",
                                                    children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                                    className: "block text-base font-medium mb-2",
                                                                    htmlFor: field.name,
                                                                    children: "Mobiltelefon"
                                                                }),
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                                    type: "tel",
                                                                    id: field.name,
                                                                    autoComplete: "tel",
                                                                    className: `w-full border border-kia-gray h-12 rounded px-4 py-3 text-base focus:outline-none focus:border-black focus:ring-1 focus:ring-black transition-colors ${field.state.meta.errors.length ? 'border-red-400 focus:border-red-600' : 'border-gray-200 focus:border-[#05141F] focus:ring-1 focus:ring-[#05141F]'}`,
                                                                    value: field.state.value,
                                                                    onBlur: field.handleBlur,
                                                                    onChange: (e)=>field.handleChange(e.target.value)
                                                                }),
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)($64bcd253197a65c9$var$FieldError, {
                                                                    errors: field.state.meta.errors
                                                                })
                                                            ]
                                                        })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                    name: "email",
                                    children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                            "aria-hidden": "true",
                                            className: "absolute -left-[9999px] w-px h-px overflow-hidden opacity-0 pointer-events-none",
                                            children: [
                                                /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                    htmlFor: field.name,
                                                    children: "Email"
                                                }),
                                                /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                    type: "text",
                                                    id: field.name,
                                                    autoComplete: "off",
                                                    tabIndex: -1,
                                                    value: field.state.value,
                                                    onChange: (e)=>field.handleChange(e.target.value)
                                                })
                                            ]
                                        })
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
                                    initial: {
                                        opacity: 0,
                                        y: 16
                                    },
                                    animate: {
                                        opacity: 1,
                                        y: 0
                                    },
                                    transition: {
                                        duration: 0.5,
                                        delay: 0.55,
                                        ease: [
                                            0.16,
                                            1,
                                            0.3,
                                            1
                                        ]
                                    },
                                    className: "border border-gray-200 p-6",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                            className: "text-base font-semibold mb-4",
                                            children: "T\xe4vlingsvillkor"
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                            className: "text-sm font-light text-gray-600 leading-relaxed mb-5",
                                            children: $64bcd253197a65c9$var$termsText
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                            name: "acceptTerms",
                                            children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("label", {
                                                            className: "flex items-center gap-3 cursor-pointer",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                                    type: "checkbox",
                                                                    className: "mt-0.5 flex-shrink-0",
                                                                    checked: field.state.value,
                                                                    onBlur: field.handleBlur,
                                                                    onChange: (e)=>field.handleChange(e.target.checked)
                                                                }),
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                                    className: "text-base font-light",
                                                                    children: "Jag godk\xe4nner t\xe4vlingsvillkoren"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)($64bcd253197a65c9$var$FieldError, {
                                                            errors: field.state.meta.errors
                                                        })
                                                    ]
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
                                    initial: {
                                        opacity: 0,
                                        y: 12
                                    },
                                    animate: {
                                        opacity: 1,
                                        y: 0
                                    },
                                    transition: {
                                        duration: 0.5,
                                        delay: 0.6,
                                        ease: [
                                            0.16,
                                            1,
                                            0.3,
                                            1
                                        ]
                                    },
                                    className: "flex flex-col gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)(form.Subscribe, {
                                            selector: (state)=>[
                                                    state.errors
                                                ],
                                            children: ([errors])=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $jAgEx.AnimatePresence), {
                                                    children: errors.length > 0 && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                                                        initial: {
                                                            opacity: 0,
                                                            height: 0
                                                        },
                                                        animate: {
                                                            opacity: 1,
                                                            height: 'auto'
                                                        },
                                                        exit: {
                                                            opacity: 0,
                                                            height: 0
                                                        },
                                                        role: "alert",
                                                        "aria-live": "polite",
                                                        className: "text-red-500 text-sm",
                                                        children: "V\xe4nligen kontrollera att alla f\xe4lt \xe4r korrekt ifyllda."
                                                    })
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)(form.Subscribe, {
                                            selector: (state)=>[
                                                    state.canSubmit,
                                                    state.isSubmitting
                                                ],
                                            children: ([canSubmit, isSubmitting])=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
                                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                                        type: "submit",
                                                        disabled: !canSubmit,
                                                        className: "bg-[#05141F] text-white px-8 py-4 text-base font-medium hover:bg-black transition-colors disabled:opacity-50 disabled:cursor-not-allowed self-start",
                                                        children: isSubmitting ? "Skickar\u2026" : "Skicka in t\xe4vlingsbidrag"
                                                    })
                                                })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)($64bcd253197a65c9$var$Snippet, {
                page: "tavling-yrkes-sm"
            })
        ]
    });
};
var $64bcd253197a65c9$export$2e2bcd8739ae039 = $64bcd253197a65c9$var$TavlingYrkesSM;

});
parcelRegister("k7h0Y", function(module, exports) {

$parcel$export(module.exports, "useForm", function () { return $ea51a8dda09c7b43$export$87c0cf8eb5a167e0; });

var $2PPWI = parcelRequire("2PPWI");

var $jDKuH = parcelRequire("jDKuH");
var $5D8ug = parcelRequire("5D8ug");
var $cAd5g = parcelRequire("cAd5g");

var $97PWA = parcelRequire("97PWA");

var $8FY87 = parcelRequire("8FY87");

var $lSHgR = parcelRequire("lSHgR");

var $9r8W0 = parcelRequire("9r8W0");

var $aCiHk = parcelRequire("aCiHk");

var $iaJCr = parcelRequire("iaJCr");
"use client";
function $ea51a8dda09c7b43$var$LocalSubscribe({ form: form, selector: selector = (state)=>state, children: children }) {
    const data = (0, $97PWA.useSelector)(form.store, selector);
    return /* @__PURE__ */ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: (0, $5D8ug.functionalUpdate)(children, data)
    });
}
function $ea51a8dda09c7b43$export$87c0cf8eb5a167e0(opts) {
    const fallbackFormId = (0, $aCiHk.useFormId)();
    const [prevFormId, setPrevFormId] = (0, $8FY87.useState)(opts?.formId);
    const [formApi, setFormApi] = (0, $8FY87.useState)(()=>{
        return new (0, $jDKuH.FormApi)({
            ...opts,
            formId: opts?.formId ?? fallbackFormId
        });
    });
    if (prevFormId !== opts?.formId) {
        const formId = opts?.formId ?? fallbackFormId;
        setFormApi(new (0, $jDKuH.FormApi)({
            ...opts,
            formId: formId
        }));
        setPrevFormId(formId);
    }
    const extendedFormApi = (0, $8FY87.useMemo)(()=>{
        const extendedApi = {
            ...formApi,
            handleSubmit: (...props)=>{
                return formApi._handleSubmit(...props);
            },
            // We must add all `get`ters from `core`'s `FormApi` here, as otherwise the spread operator won't catch those
            get formId () {
                return formApi._formId;
            },
            get state () {
                return formApi.store.state;
            }
        };
        extendedApi.Field = function APIField(props) {
            return /* @__PURE__ */ (0, $2PPWI.jsx)((0, $lSHgR.Field), {
                ...props,
                form: formApi
            });
        };
        extendedApi.FormGroup = function APIFormGroup(props) {
            return /* @__PURE__ */ (0, $2PPWI.jsx)((0, $iaJCr.FormGroup), {
                ...props,
                form: formApi
            });
        };
        extendedApi.Subscribe = function Subscribe(props) {
            return /* @__PURE__ */ (0, $2PPWI.jsx)($ea51a8dda09c7b43$var$LocalSubscribe, {
                form: formApi,
                selector: props.selector,
                children: props.children
            });
        };
        return extendedApi;
    }, [
        formApi
    ]);
    (0, $9r8W0.useIsomorphicLayoutEffect)(formApi.mount, []);
    (0, $9r8W0.useIsomorphicLayoutEffect)(()=>{
        formApi.update(opts);
    });
    const hasRan = (0, $8FY87.useRef)(false);
    (0, $9r8W0.useIsomorphicLayoutEffect)(()=>{
        if (!hasRan.current) return;
        if (!opts?.transform) return;
        (0, $cAd5g.mergeAndUpdate)(formApi, opts.transform);
    }, [
        formApi,
        opts?.transform
    ]);
    (0, $9r8W0.useIsomorphicLayoutEffect)(()=>{
        hasRan.current = true;
    });
    return extendedFormApi;
}

});
parcelRegister("jDKuH", function(module, exports) {

$parcel$export(module.exports, "FormApi", function () { return $e4c5b9997feed6f4$export$6f21fafcb383efb1; });

var $dgHzL = parcelRequire("dgHzL");
var $kKYCu = parcelRequire("kKYCu");

var $5D8ug = parcelRequire("5D8ug");

var $8TrCb = parcelRequire("8TrCb");

var $8DIXq = parcelRequire("8DIXq");

var $d7Y8n = parcelRequire("d7Y8n");

var $7lYn9 = parcelRequire("7lYn9");
function $e4c5b9997feed6f4$var$getDefaultFormState(defaultState) {
    return {
        values: defaultState.values ?? {},
        errorMap: defaultState.errorMap ?? {},
        fieldMetaBase: defaultState.fieldMetaBase ?? {},
        formGroupStateBase: defaultState.formGroupStateBase ?? {},
        isSubmitted: defaultState.isSubmitted ?? false,
        isSubmitting: defaultState.isSubmitting ?? false,
        isValidating: defaultState.isValidating ?? false,
        submissionAttempts: defaultState.submissionAttempts ?? 0,
        isSubmitSuccessful: defaultState.isSubmitSuccessful ?? false,
        validationMetaMap: defaultState.validationMetaMap ?? {
            onChange: void 0,
            onBlur: void 0,
            onSubmit: void 0,
            onMount: void 0,
            onServer: void 0,
            onDynamic: void 0
        }
    };
}
class $e4c5b9997feed6f4$export$6f21fafcb383efb1 {
    /**
   * Constructs a new `FormApi` instance with the given form options.
   */ constructor(opts){
        this.options = {};
        this.fieldInfo = {};
        this.formGroupApis = /* @__PURE__ */ new Set();
        this.mount = ()=>{
            const cleanupDevtoolBroadcast = this.store.subscribe(()=>{
                (0, $5D8ug.throttleFormState)(this);
            });
            const cleanupFormStateListener = (0, $7lYn9.formEventClient).on("request-form-state", (e)=>{
                if (e.payload.id === this._formId) (0, $7lYn9.formEventClient).emit("form-api", {
                    id: this._formId,
                    state: this.store.state,
                    options: this.options
                });
            });
            const cleanupFormResetListener = (0, $7lYn9.formEventClient).on("request-form-reset", (e)=>{
                if (e.payload.id === this._formId) this.reset();
            });
            const cleanupFormForceSubmitListener = (0, $7lYn9.formEventClient).on("request-form-force-submit", (e)=>{
                if (e.payload.id === this._formId) {
                    this._devtoolsSubmissionOverride = true;
                    this.handleSubmit();
                    this._devtoolsSubmissionOverride = false;
                }
            });
            const cleanup = ()=>{
                cleanupFormForceSubmitListener();
                cleanupFormResetListener();
                cleanupFormStateListener();
                cleanupDevtoolBroadcast.unsubscribe();
                (0, $7lYn9.formEventClient).emit("form-unmounted", {
                    id: this._formId
                });
            };
            this.options.listeners?.onMount?.({
                formApi: this
            });
            const { onMount: onMount } = this.options.validators || {};
            (0, $7lYn9.formEventClient).emit("form-api", {
                id: this._formId,
                state: this.store.state,
                options: this.options
            });
            if (!onMount) return cleanup;
            this.validateSync("mount");
            return cleanup;
        };
        this.update = (options)=>{
            if (!options) return;
            const oldOptions = this.options;
            this.options = options;
            const shouldUpdateValues = options.defaultValues && !(0, $5D8ug.evaluate)(options.defaultValues, oldOptions.defaultValues) && !this.state.isTouched;
            const shouldUpdateState = !(0, $5D8ug.evaluate)(options.defaultState, oldOptions.defaultState) && !this.state.isTouched;
            if (!shouldUpdateValues && !shouldUpdateState) return;
            (0, $dgHzL.batch)(()=>{
                this.baseStore.setState(()=>$e4c5b9997feed6f4$var$getDefaultFormState(Object.assign({}, this.state, shouldUpdateState ? options.defaultState : {}, shouldUpdateValues ? {
                        values: options.defaultValues
                    } : {})));
            });
            if (shouldUpdateValues) {
                const helper = (0, $d7Y8n.metaHelper)(this);
                for (const fieldKey of Object.keys(this.fieldInfo))if (Array.isArray(this.getFieldValue(fieldKey))) helper.bumpArrayVersion(fieldKey);
            }
            (0, $7lYn9.formEventClient).emit("form-api", {
                id: this._formId,
                state: this.store.state,
                options: this.options
            });
        };
        this.reset = (values, opts2)=>{
            const { fieldMeta: currentFieldMeta } = this.state;
            const fieldMetaBase = this.resetFieldMeta(currentFieldMeta);
            if (values && !opts2?.keepDefaultValues) this.options = {
                ...this.options,
                defaultValues: values
            };
            this.baseStore.setState(()=>{
                let nextValues = values ?? this.options.defaultValues ?? this.options.defaultState?.values;
                if (!values) Object.values(this.fieldInfo).forEach((fieldInfo)=>{
                    if (fieldInfo.instance && fieldInfo.instance.options.defaultValue !== void 0) nextValues = (0, $5D8ug.setBy)(nextValues, fieldInfo.instance.name, fieldInfo.instance.options.defaultValue);
                });
                return $e4c5b9997feed6f4$var$getDefaultFormState({
                    ...this.options.defaultState,
                    values: nextValues,
                    fieldMetaBase: fieldMetaBase
                });
            });
        };
        this.validateAllFields = async (cause)=>{
            const fieldValidationPromises = [];
            (0, $dgHzL.batch)(()=>{
                Object.values(this.fieldInfo).forEach((field)=>{
                    if (!field.instance) return;
                    const fieldInstance = field.instance;
                    fieldValidationPromises.push(// Remember, `validate` is either a sync operation or a promise
                    Promise.resolve().then(()=>fieldInstance.validate(cause, {
                            skipFormValidation: true,
                            skipGroupValidation: true
                        })));
                    if (!field.instance.store.state.meta.isTouched) field.instance.setMeta((prev)=>({
                            ...prev,
                            isTouched: true
                        }));
                });
            });
            const fieldErrorMapMap = await Promise.all(fieldValidationPromises);
            return fieldErrorMapMap.flat();
        };
        this.validateArrayFieldsStartingFrom = async (field, index, cause)=>{
            const currentValue = this.getFieldValue(field);
            const lastIndex = Array.isArray(currentValue) ? Math.max(currentValue.length - 1, 0) : null;
            const fieldKeysToValidate = [
                `${field}[${index}]`
            ];
            for(let i = index + 1; i <= (lastIndex ?? 0); i++)fieldKeysToValidate.push(`${field}[${i}]`);
            const fieldsToValidate = Object.keys(this.fieldInfo).filter((fieldKey)=>fieldKeysToValidate.some((key)=>fieldKey.startsWith(key)));
            const fieldValidationPromises = [];
            (0, $dgHzL.batch)(()=>{
                fieldsToValidate.forEach((nestedField)=>{
                    fieldValidationPromises.push(Promise.resolve().then(()=>this.validateField(nestedField, cause)));
                });
            });
            const fieldErrorMapMap = await Promise.all(fieldValidationPromises);
            return fieldErrorMapMap.flat();
        };
        this.validateField = (field, cause)=>{
            const fieldInstance = this.fieldInfo[field]?.instance;
            if (!fieldInstance) {
                const { hasErrored: hasErrored } = this.validateSync(cause);
                if (hasErrored && !this.options.asyncAlways) return this.getFieldMeta(field)?.errors ?? [];
                return this.validateAsync(cause).then(()=>{
                    return this.getFieldMeta(field)?.errors ?? [];
                });
            }
            if (!fieldInstance.store.state.meta.isTouched) fieldInstance.setMeta((prev)=>({
                    ...prev,
                    isTouched: true
                }));
            return fieldInstance.validate(cause);
        };
        this.validateSync = (cause, validateOpts)=>{
            const validates = (0, $5D8ug.getSyncValidatorArray)(cause, {
                ...this.options,
                form: this,
                group: validateOpts?.group,
                validationLogic: this.options.validationLogic || (0, $8TrCb.defaultValidationLogic)
            });
            let hasErrored = false;
            const currentValidationErrorMap = {};
            (0, $dgHzL.batch)(()=>{
                for (const validateObj of validates){
                    if (!validateObj.validate) continue;
                    const rawError = this.runValidator({
                        validate: validateObj.validate,
                        value: {
                            value: this.state.values,
                            formApi: this,
                            validationSource: "form"
                        },
                        type: "validate"
                    });
                    const { formError: formError, fieldErrors: fieldErrors } = $e4c5b9997feed6f4$var$normalizeError(rawError);
                    const errorMapKey = $e4c5b9997feed6f4$var$getErrorMapKey(validateObj.cause);
                    let allFieldsToProcess = /* @__PURE__ */ new Set([
                        ...Object.keys(this.state.fieldMeta),
                        ...Object.keys(fieldErrors || {})
                    ]);
                    if (validateOpts?.filterFieldNames) allFieldsToProcess = new Set([
                        ...allFieldsToProcess
                    ].filter(validateOpts.filterFieldNames));
                    for (const field of allFieldsToProcess){
                        if (this.baseStore.state.fieldMetaBase[field] === void 0 && !fieldErrors?.[field]) continue;
                        const fieldMeta = this.getFieldMeta(field) ?? (0, $d7Y8n.defaultFieldMeta);
                        const { errorMap: currentErrorMap, errorSourceMap: currentErrorMapSource } = fieldMeta;
                        const newFormValidatorError = fieldErrors?.[field];
                        const { newErrorValue: newErrorValue, newSource: newSource } = (0, $5D8ug.determineFormLevelErrorSourceAndValue)({
                            newFormValidatorError: newFormValidatorError,
                            isPreviousErrorFromFormValidator: // These conditional checks are required, otherwise we get runtime errors.
                            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                            currentErrorMapSource?.[errorMapKey] === "form",
                            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                            previousErrorValue: currentErrorMap?.[errorMapKey]
                        });
                        if (newSource === "form") currentValidationErrorMap[field] = {
                            ...currentValidationErrorMap[field],
                            [errorMapKey]: newFormValidatorError
                        };
                        if (currentErrorMap?.[errorMapKey] !== newErrorValue) this.setFieldMeta(field, (prev = (0, $d7Y8n.defaultFieldMeta))=>({
                                ...prev,
                                errorMap: {
                                    ...prev.errorMap,
                                    [errorMapKey]: newErrorValue
                                },
                                errorSourceMap: {
                                    ...prev.errorSourceMap,
                                    [errorMapKey]: newSource
                                }
                            }));
                    }
                    if (!validateOpts?.dontUpdateFormErrorMap) {
                        if (this.state.errorMap?.[errorMapKey] !== formError) this.baseStore.setState((prev)=>({
                                ...prev,
                                errorMap: {
                                    ...prev.errorMap,
                                    [errorMapKey]: formError
                                }
                            }));
                    }
                    if (formError || fieldErrors) hasErrored = true;
                }
                if (validateOpts?.dontUpdateFormErrorMap) return;
                const submitErrKey = $e4c5b9997feed6f4$var$getErrorMapKey("submit");
                if (// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                this.state.errorMap?.[submitErrKey] && cause !== "submit" && !hasErrored) this.baseStore.setState((prev)=>({
                        ...prev,
                        errorMap: {
                            ...prev.errorMap,
                            [submitErrKey]: void 0
                        }
                    }));
                const serverErrKey = $e4c5b9997feed6f4$var$getErrorMapKey("server");
                if (// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                this.state.errorMap?.[serverErrKey] && cause !== "server" && !hasErrored) this.baseStore.setState((prev)=>({
                        ...prev,
                        errorMap: {
                            ...prev.errorMap,
                            [serverErrKey]: void 0
                        }
                    }));
            });
            return {
                hasErrored: hasErrored,
                fieldsErrorMap: currentValidationErrorMap
            };
        };
        this.validateAsync = async (cause, validateOpts)=>{
            const validates = (0, $5D8ug.getAsyncValidatorArray)(cause, {
                ...this.options,
                form: this,
                group: validateOpts?.group,
                validationLogic: this.options.validationLogic || (0, $8TrCb.defaultValidationLogic)
            });
            if (!this.state.isFormValidating) this.baseStore.setState((prev)=>({
                    ...prev,
                    isFormValidating: true
                }));
            const promises = [];
            let fieldErrorsFromFormValidators;
            for (const validateObj of validates){
                if (!validateObj.validate) continue;
                const key = $e4c5b9997feed6f4$var$getErrorMapKey(validateObj.cause);
                const fieldValidatorMeta = this.state.validationMetaMap[key];
                fieldValidatorMeta?.lastAbortController.abort();
                const controller = new AbortController();
                this.state.validationMetaMap[key] = {
                    lastAbortController: controller
                };
                promises.push(new Promise(async (resolve)=>{
                    let rawError;
                    try {
                        rawError = await new Promise((rawResolve, rawReject)=>{
                            setTimeout(async ()=>{
                                if (controller.signal.aborted) return rawResolve(void 0);
                                try {
                                    rawResolve(await this.runValidator({
                                        validate: validateObj.validate,
                                        value: {
                                            value: this.state.values,
                                            formApi: this,
                                            validationSource: "form",
                                            signal: controller.signal
                                        },
                                        type: "validateAsync"
                                    }));
                                } catch (e) {
                                    rawReject(e);
                                }
                            }, validateObj.debounceMs);
                        });
                    } catch (e) {
                        rawError = e;
                    }
                    const { formError: formError, fieldErrors: fieldErrorsFromNormalizeError } = $e4c5b9997feed6f4$var$normalizeError(rawError);
                    if (fieldErrorsFromNormalizeError) fieldErrorsFromFormValidators = fieldErrorsFromFormValidators ? {
                        ...fieldErrorsFromFormValidators,
                        ...fieldErrorsFromNormalizeError
                    } : fieldErrorsFromNormalizeError;
                    const errorMapKey = $e4c5b9997feed6f4$var$getErrorMapKey(validateObj.cause);
                    const allFieldsToProcess = /* @__PURE__ */ new Set([
                        ...Object.keys(this.state.fieldMeta),
                        ...Object.keys(fieldErrorsFromFormValidators || {})
                    ]);
                    let fields = Array.from(allFieldsToProcess);
                    if (validateOpts?.filterFieldNames) fields = fields.filter(validateOpts.filterFieldNames);
                    for (const field of fields){
                        if (this.baseStore.state.fieldMetaBase[field] === void 0 && !fieldErrorsFromFormValidators?.[field]) continue;
                        const fieldMeta = this.getFieldMeta(field) ?? (0, $d7Y8n.defaultFieldMeta);
                        const { errorMap: currentErrorMap, errorSourceMap: currentErrorMapSource } = fieldMeta;
                        const newFormValidatorError = fieldErrorsFromFormValidators?.[field];
                        const { newErrorValue: newErrorValue, newSource: newSource } = (0, $5D8ug.determineFormLevelErrorSourceAndValue)({
                            newFormValidatorError: newFormValidatorError,
                            isPreviousErrorFromFormValidator: // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                            currentErrorMapSource?.[errorMapKey] === "form",
                            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                            previousErrorValue: currentErrorMap?.[errorMapKey]
                        });
                        if (currentErrorMap?.[errorMapKey] !== newErrorValue) this.setFieldMeta(field, (prev = (0, $d7Y8n.defaultFieldMeta))=>({
                                ...prev,
                                errorMap: {
                                    ...prev.errorMap,
                                    [errorMapKey]: newErrorValue
                                },
                                errorSourceMap: {
                                    ...prev.errorSourceMap,
                                    [errorMapKey]: newSource
                                }
                            }));
                    }
                    if (!validateOpts?.dontUpdateFormErrorMap) this.baseStore.setState((prev)=>({
                            ...prev,
                            errorMap: {
                                ...prev.errorMap,
                                [errorMapKey]: formError
                            }
                        }));
                    resolve(fieldErrorsFromFormValidators ? {
                        fieldErrors: fieldErrorsFromFormValidators,
                        errorMapKey: errorMapKey
                    } : void 0);
                }));
            }
            let results = [];
            const fieldsErrorMap = {};
            if (promises.length) {
                results = await Promise.all(promises);
                for (const fieldValidationResult of results)if (fieldValidationResult?.fieldErrors) {
                    const { errorMapKey: errorMapKey } = fieldValidationResult;
                    for (const [field, fieldError] of Object.entries(fieldValidationResult.fieldErrors)){
                        const oldErrorMap = fieldsErrorMap[field] || {};
                        const newErrorMap = {
                            ...oldErrorMap,
                            [errorMapKey]: fieldError
                        };
                        fieldsErrorMap[field] = newErrorMap;
                    }
                }
            }
            this.baseStore.setState((prev)=>({
                    ...prev,
                    isFormValidating: false
                }));
            return fieldsErrorMap;
        };
        this.validate = (cause, validateOpts)=>{
            const { hasErrored: hasErrored, fieldsErrorMap: fieldsErrorMap } = this.validateSync(cause, validateOpts);
            if (hasErrored && !this.options.asyncAlways) return fieldsErrorMap;
            return this.validateAsync(cause, validateOpts);
        };
        this._handleSubmit = async (submitMeta)=>{
            this.baseStore.setState((old)=>({
                    ...old,
                    // Submission attempts mark the form as not submitted
                    isSubmitted: false,
                    // Count submission attempts
                    submissionAttempts: old.submissionAttempts + 1,
                    isSubmitSuccessful: false
                }));
            (0, $dgHzL.batch)(()=>{
                Object.values(this.fieldInfo).forEach((field)=>{
                    if (!field.instance) return;
                    if (!field.instance.store.state.meta.isTouched) field.instance.setMeta((prev)=>({
                            ...prev,
                            isTouched: true
                        }));
                });
            });
            const submitMetaArg = submitMeta ?? this.options.onSubmitMeta;
            if (!this.state.canSubmit && !this._devtoolsSubmissionOverride) {
                if (this.baseStore.state.submissionAttempts <= 1) {
                    this.options.onSubmitInvalid?.({
                        value: this.state.values,
                        formApi: this,
                        meta: submitMetaArg
                    });
                    return;
                }
            }
            this.baseStore.setState((d)=>({
                    ...d,
                    isSubmitting: true
                }));
            const done = ()=>{
                this.baseStore.setState((prev)=>({
                        ...prev,
                        isSubmitting: false
                    }));
            };
            await this.validateAllFields("submit");
            if (!this.state.isFieldsValid) {
                done();
                this.options.onSubmitInvalid?.({
                    value: this.state.values,
                    formApi: this,
                    meta: submitMetaArg
                });
                (0, $7lYn9.formEventClient).emit("form-submission", {
                    id: this._formId,
                    submissionAttempt: this.state.submissionAttempts,
                    successful: false,
                    stage: "validateAllFields",
                    errors: Object.values(this.state.fieldMeta).map((meta)=>meta.errors).flat()
                });
                return;
            }
            await this.validate("submit");
            if (!this.state.isValid) {
                done();
                this.options.onSubmitInvalid?.({
                    value: this.state.values,
                    formApi: this,
                    meta: submitMetaArg
                });
                (0, $7lYn9.formEventClient).emit("form-submission", {
                    id: this._formId,
                    submissionAttempt: this.state.submissionAttempts,
                    successful: false,
                    stage: "validate",
                    errors: this.state.errors
                });
                return;
            }
            (0, $dgHzL.batch)(()=>{
                Object.values(this.fieldInfo).forEach((field)=>{
                    field.instance?.triggerOnSubmitListener();
                });
            });
            this.options.listeners?.onSubmit?.({
                formApi: this,
                meta: submitMetaArg
            });
            try {
                await this.options.onSubmit?.({
                    value: this.state.values,
                    formApi: this,
                    meta: submitMetaArg
                });
                (0, $dgHzL.batch)(()=>{
                    this.baseStore.setState((prev)=>({
                            ...prev,
                            isSubmitted: true,
                            isSubmitSuccessful: true
                        }));
                    (0, $7lYn9.formEventClient).emit("form-submission", {
                        id: this._formId,
                        submissionAttempt: this.state.submissionAttempts,
                        successful: true
                    });
                    done();
                });
            } catch (err) {
                this.baseStore.setState((prev)=>({
                        ...prev,
                        isSubmitSuccessful: false
                    }));
                (0, $7lYn9.formEventClient).emit("form-submission", {
                    id: this._formId,
                    submissionAttempt: this.state.submissionAttempts,
                    successful: false,
                    stage: "inflight",
                    onError: err
                });
                done();
                throw err;
            }
        };
        this.getFieldValue = (field)=>(0, $5D8ug.getBy)(this.state.values, field);
        this.getFieldMeta = (field)=>{
            return this.state.fieldMeta[field];
        };
        this.getFormGroupMeta = (name)=>{
            return this.formGroupMetaDerived.state[name];
        };
        this.getFieldInfo = (field)=>{
            return this.fieldInfo[field] ||= {
                instance: null,
                validationMetaMap: {
                    onChange: void 0,
                    onBlur: void 0,
                    onSubmit: void 0,
                    onMount: void 0,
                    onServer: void 0,
                    onDynamic: void 0
                }
            };
        };
        this.setFieldMeta = (field, updater)=>{
            this.baseStore.setState((prev)=>{
                return {
                    ...prev,
                    fieldMetaBase: {
                        ...prev.fieldMetaBase,
                        [field]: (0, $5D8ug.functionalUpdate)(updater, prev.fieldMetaBase[field])
                    }
                };
            });
        };
        this.resetFieldMeta = (fieldMeta)=>{
            return Object.keys(fieldMeta).reduce((acc, key)=>{
                const fieldKey = key;
                acc[fieldKey] = (0, $d7Y8n.defaultFieldMeta);
                return acc;
            }, {});
        };
        this.setFieldValue = (field, updater, opts2)=>{
            const dontUpdateMeta = opts2?.dontUpdateMeta ?? false;
            const dontRunListeners = opts2?.dontRunListeners ?? false;
            const dontValidate = opts2?.dontValidate ?? false;
            (0, $dgHzL.batch)(()=>{
                if (!dontUpdateMeta) this.setFieldMeta(field, (prev)=>({
                        ...prev,
                        isTouched: true,
                        isDirty: true,
                        errorMap: {
                            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                            ...prev?.errorMap,
                            onMount: void 0
                        }
                    }));
                this.baseStore.setState((prev)=>{
                    return {
                        ...prev,
                        values: (0, $5D8ug.setBy)(prev.values, field, updater)
                    };
                });
            });
            if (!dontRunListeners) this.getFieldInfo(field).instance?.triggerOnChangeListener();
            if (!dontValidate) this.validateField(field, "change");
        };
        this.deleteField = (field)=>{
            const subFieldsToDelete = Object.keys(this.fieldInfo).filter((f)=>{
                const fieldStr = field.toString();
                return f.startsWith(`${fieldStr}.`) || f.startsWith(`${fieldStr}[`);
            });
            const fieldsToDelete = [
                ...subFieldsToDelete,
                field
            ];
            this.baseStore.setState((prev)=>{
                const newState = {
                    ...prev
                };
                fieldsToDelete.forEach((f)=>{
                    newState.values = (0, $5D8ug.deleteBy)(newState.values, f);
                    delete this.fieldInfo[f];
                    delete newState.fieldMetaBase[f];
                });
                return newState;
            });
        };
        this.pushFieldValue = (field, value, options)=>{
            this.setFieldValue(field, (prev)=>[
                    ...Array.isArray(prev) ? prev : [],
                    value
                ], options);
            (0, $d7Y8n.metaHelper)(this).bumpArrayVersion(field);
        };
        this.insertFieldValue = async (field, index, value, options)=>{
            this.setFieldValue(field, (prev)=>{
                return [
                    ...prev.slice(0, index),
                    value,
                    ...prev.slice(index)
                ];
            }, (0, $5D8ug.mergeOpts)(options, {
                dontValidate: true
            }));
            const dontValidate = options?.dontValidate ?? false;
            if (!dontValidate) await this.validateField(field, "change");
            (0, $d7Y8n.metaHelper)(this).handleArrayInsert(field, index);
            if (!dontValidate) await this.validateArrayFieldsStartingFrom(field, index, "change");
        };
        this.replaceFieldValue = async (field, index, value, options)=>{
            this.setFieldValue(field, (prev)=>{
                return prev.map((d, i)=>i === index ? value : d);
            }, (0, $5D8ug.mergeOpts)(options, {
                dontValidate: true
            }));
            (0, $d7Y8n.metaHelper)(this).bumpArrayVersion(field);
            const dontValidate = options?.dontValidate ?? false;
            if (!dontValidate) {
                await this.validateField(field, "change");
                await this.validateArrayFieldsStartingFrom(field, index, "change");
            }
        };
        this.removeFieldValue = async (field, index, options)=>{
            const fieldValue = this.getFieldValue(field);
            const lastIndex = Array.isArray(fieldValue) ? Math.max(fieldValue.length - 1, 0) : null;
            this.setFieldValue(field, (prev)=>{
                return prev.filter((_d, i)=>i !== index);
            }, (0, $5D8ug.mergeOpts)(options, {
                dontValidate: true
            }));
            (0, $d7Y8n.metaHelper)(this).handleArrayRemove(field, index);
            if (lastIndex !== null) {
                const start = `${field}[${lastIndex}]`;
                this.deleteField(start);
            }
            const dontValidate = options?.dontValidate ?? false;
            if (!dontValidate) {
                await this.validateField(field, "change");
                await this.validateArrayFieldsStartingFrom(field, index, "change");
            }
        };
        this.swapFieldValues = (field, index1, index2, options)=>{
            this.setFieldValue(field, (prev)=>{
                const prev1 = prev[index1];
                const prev2 = prev[index2];
                return (0, $5D8ug.setBy)((0, $5D8ug.setBy)(prev, `${index1}`, prev2), `${index2}`, prev1);
            }, (0, $5D8ug.mergeOpts)(options, {
                dontValidate: true
            }));
            (0, $d7Y8n.metaHelper)(this).handleArraySwap(field, index1, index2);
            const dontValidate = options?.dontValidate ?? false;
            if (!dontValidate) {
                this.validateField(field, "change");
                this.validateField(`${field}[${index1}]`, "change");
                this.validateField(`${field}[${index2}]`, "change");
            }
        };
        this.moveFieldValues = (field, index1, index2, options)=>{
            this.setFieldValue(field, (prev)=>{
                const next = [
                    ...prev
                ];
                next.splice(index2, 0, next.splice(index1, 1)[0]);
                return next;
            }, (0, $5D8ug.mergeOpts)(options, {
                dontValidate: true
            }));
            (0, $d7Y8n.metaHelper)(this).handleArrayMove(field, index1, index2);
            const dontValidate = options?.dontValidate ?? false;
            if (!dontValidate) {
                this.validateField(field, "change");
                this.validateField(`${field}[${index1}]`, "change");
                this.validateField(`${field}[${index2}]`, "change");
            }
        };
        this.clearFieldValues = (field, options)=>{
            const fieldValue = this.getFieldValue(field);
            const lastIndex = Array.isArray(fieldValue) ? Math.max(fieldValue.length - 1, 0) : null;
            this.setFieldValue(field, [], (0, $5D8ug.mergeOpts)(options, {
                dontValidate: true
            }));
            (0, $d7Y8n.metaHelper)(this).bumpArrayVersion(field);
            if (lastIndex !== null) for(let i = 0; i <= lastIndex; i++){
                const fieldKey = `${field}[${i}]`;
                this.deleteField(fieldKey);
            }
            const dontValidate = options?.dontValidate ?? false;
            if (!dontValidate) this.validateField(field, "change");
        };
        this.resetField = (field)=>{
            this.baseStore.setState((prev)=>{
                const fieldDefault = this.getFieldInfo(field).instance?.options.defaultValue;
                const formDefault = (0, $5D8ug.getBy)(this.options.defaultValues, field);
                const targetValue = fieldDefault ?? formDefault;
                return {
                    ...prev,
                    fieldMetaBase: {
                        ...prev.fieldMetaBase,
                        [field]: (0, $d7Y8n.defaultFieldMeta)
                    },
                    values: targetValue !== void 0 ? (0, $5D8ug.setBy)(prev.values, field, targetValue) : prev.values
                };
            });
        };
        this.setErrorMap = (errorMap)=>{
            (0, $dgHzL.batch)(()=>{
                Object.entries(errorMap).forEach(([key, value])=>{
                    const errorMapKey = key;
                    if ((0, $5D8ug.isGlobalFormValidationError)(value)) {
                        const { formError: formError, fieldErrors: fieldErrors } = $e4c5b9997feed6f4$var$normalizeError(value);
                        for (const fieldName of Object.keys(this.fieldInfo)){
                            const fieldMeta = this.getFieldMeta(fieldName);
                            if (!fieldMeta) continue;
                            this.setFieldMeta(fieldName, (prev)=>({
                                    ...prev,
                                    errorMap: {
                                        ...prev.errorMap,
                                        [errorMapKey]: fieldErrors?.[fieldName]
                                    },
                                    errorSourceMap: {
                                        ...prev.errorSourceMap,
                                        [errorMapKey]: "form"
                                    }
                                }));
                        }
                        this.baseStore.setState((prev)=>({
                                ...prev,
                                errorMap: {
                                    ...prev.errorMap,
                                    [errorMapKey]: formError
                                }
                            }));
                    } else this.baseStore.setState((prev)=>({
                            ...prev,
                            errorMap: {
                                ...prev.errorMap,
                                [errorMapKey]: value
                            }
                        }));
                });
            });
        };
        this.getAllErrors = ()=>{
            return {
                form: {
                    errors: this.state.errors,
                    errorMap: this.state.errorMap
                },
                fields: Object.entries(this.state.fieldMeta).reduce((acc, [fieldName, fieldMeta])=>{
                    if (Object.keys(fieldMeta).length && fieldMeta.errors.length) acc[fieldName] = {
                        errors: fieldMeta.errors,
                        errorMap: fieldMeta.errorMap
                    };
                    return acc;
                }, {})
            };
        };
        this.parseValuesWithSchema = (schema)=>{
            return (0, $8DIXq.standardSchemaValidators).validate({
                value: this.state.values,
                validationSource: "form"
            }, schema);
        };
        this.parseValuesWithSchemaAsync = (schema)=>{
            return (0, $8DIXq.standardSchemaValidators).validateAsync({
                value: this.state.values,
                validationSource: "form"
            }, schema);
        };
        this.timeoutIds = {
            validations: {},
            listeners: {},
            formListeners: {}
        };
        this._formId = opts?.formId ?? (0, $5D8ug.uuid)();
        this._devtoolsSubmissionOverride = false;
        let baseStoreVal = $e4c5b9997feed6f4$var$getDefaultFormState({
            ...opts?.defaultState,
            values: opts?.defaultValues ?? opts?.defaultState?.values
        });
        if (opts?.transform) {
            baseStoreVal = opts.transform({
                state: baseStoreVal
            }).state;
            for (const errKey of Object.keys(baseStoreVal.errorMap)){
                const errKeyMap = baseStoreVal.errorMap[errKey];
                if (errKeyMap === void 0 || !(0, $5D8ug.isGlobalFormValidationError)(errKeyMap)) continue;
                for (const fieldName of Object.keys(errKeyMap.fields)){
                    const fieldErr = errKeyMap.fields[fieldName];
                    if (fieldErr === void 0) continue;
                    const existingFieldMeta = baseStoreVal.fieldMetaBase[fieldName];
                    baseStoreVal.fieldMetaBase[fieldName] = {
                        isTouched: false,
                        isValidating: false,
                        isBlurred: false,
                        isDirty: false,
                        _arrayVersion: 0,
                        _pendingValidationsCount: 0,
                        ...existingFieldMeta ?? {},
                        errorSourceMap: {
                            ...existingFieldMeta?.["errorSourceMap"] ?? {},
                            onChange: "form"
                        },
                        errorMap: {
                            ...existingFieldMeta?.["errorMap"] ?? {},
                            [errKey]: fieldErr
                        }
                    };
                }
            }
        }
        this.baseStore = (0, $kKYCu.createStore)(baseStoreVal);
        let prevBaseStore = void 0;
        this.fieldMetaDerived = (0, $kKYCu.createStore)((prevVal)=>{
            const currBaseStore = this.baseStore.get();
            let originalMetaCount = 0;
            const fieldMeta = {};
            for (const fieldName of Object.keys(currBaseStore.fieldMetaBase)){
                const currBaseMeta = currBaseStore.fieldMetaBase[fieldName];
                const prevBaseMeta = prevBaseStore?.fieldMetaBase[fieldName];
                const prevFieldInfo = prevVal?.[fieldName];
                const curFieldVal = (0, $5D8ug.getBy)(currBaseStore.values, fieldName);
                let fieldErrors = prevFieldInfo?.errors;
                if (!prevBaseMeta || currBaseMeta.errorMap !== prevBaseMeta.errorMap) {
                    fieldErrors = Object.values(currBaseMeta.errorMap ?? {}).filter((val)=>val !== void 0);
                    const fieldInstance = this.getFieldInfo(fieldName)?.instance;
                    if (!fieldInstance || !fieldInstance.options.disableErrorFlat) fieldErrors = fieldErrors.flat(1);
                }
                const isFieldValid = !(0, $5D8ug.isNonEmptyArray)(fieldErrors);
                const isFieldPristine = !currBaseMeta.isDirty;
                const isDefaultValue = (0, $5D8ug.evaluate)(curFieldVal, // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                this.getFieldInfo(fieldName)?.instance?.options.defaultValue ?? (0, $5D8ug.getBy)(this.options.defaultValues, fieldName));
                if (prevFieldInfo && prevFieldInfo.isPristine === isFieldPristine && prevFieldInfo.isValid === isFieldValid && prevFieldInfo.isDefaultValue === isDefaultValue && prevFieldInfo.errors === fieldErrors && currBaseMeta === prevBaseMeta) {
                    fieldMeta[fieldName] = prevFieldInfo;
                    originalMetaCount++;
                    continue;
                }
                fieldMeta[fieldName] = {
                    ...currBaseMeta,
                    errors: fieldErrors ?? [],
                    isPristine: isFieldPristine,
                    isValid: isFieldValid,
                    isDefaultValue: isDefaultValue
                };
            }
            if (!Object.keys(currBaseStore.fieldMetaBase).length) return fieldMeta;
            if (prevVal && originalMetaCount === Object.keys(currBaseStore.fieldMetaBase).length) return prevVal;
            prevBaseStore = this.baseStore.get();
            return fieldMeta;
        });
        this.formGroupMetaDerived = (0, $kKYCu.createStore)((prevVal)=>{
            const currBaseStore = this.baseStore.get();
            const currFieldMeta = this.fieldMetaDerived.get();
            const result = {};
            for (const group of this.formGroupApis){
                const groupName = group.name;
                const lifecycle = currBaseStore.formGroupStateBase[groupName] ?? {
                    isSubmitted: false,
                    isSubmitting: false,
                    isValidating: false,
                    submissionAttempts: 0,
                    isSubmitSuccessful: false
                };
                const ownFieldMeta = currFieldMeta[groupName];
                let isFieldsValidating = false;
                let isFieldsValid = true;
                let aggIsTouched = false;
                let aggIsBlurred = false;
                let aggIsDefaultValue = true;
                let aggIsDirty = false;
                for(const fieldName in currFieldMeta){
                    if (fieldName === groupName) continue;
                    if (!(0, $5D8ug.isFieldInGroup)(groupName, fieldName)) continue;
                    const m = currFieldMeta[fieldName];
                    if (!m) continue;
                    if (m.isValidating) isFieldsValidating = true;
                    if (!m.isValid) isFieldsValid = false;
                    if (m.isTouched) aggIsTouched = true;
                    if (m.isBlurred) aggIsBlurred = true;
                    if (!m.isDefaultValue) aggIsDefaultValue = false;
                    if (m.isDirty) aggIsDirty = true;
                }
                const isPristine = !aggIsDirty;
                const isValidating = !!isFieldsValidating || lifecycle.isValidating;
                const errorMap = ownFieldMeta?.errorMap ?? {};
                const errorSourceMap = ownFieldMeta?.errorSourceMap ?? {};
                const hasOnMountError = Boolean(errorMap.onMount || Object.entries(currFieldMeta).some(([fieldName, field])=>field && fieldName !== groupName && (0, $5D8ug.isFieldInGroup)(groupName, fieldName) && field.errorMap.onMount));
                const prevGroupMeta = prevVal?.[groupName];
                let errors = prevGroupMeta?.errors ?? [];
                if (!prevGroupMeta || prevGroupMeta.__srcErrorMap !== errorMap) errors = Object.values(errorMap).reduce((acc, curr)=>{
                    if (curr === void 0) return acc;
                    if (curr && typeof curr === "object" && "fields" in curr) {
                        const groupErr = curr.group;
                        if (groupErr !== void 0) acc.push(groupErr);
                        return acc;
                    }
                    acc.push(curr);
                    return acc;
                }, []);
                const isGroupValid = errors.length === 0;
                const isValid = isFieldsValid && isGroupValid;
                const submitInvalid = group.options.canSubmitWhenInvalid ?? false;
                const canSubmit = lifecycle.submissionAttempts === 0 && !aggIsTouched && !hasOnMountError || !isValidating && !lifecycle.isSubmitting && isValid || submitInvalid;
                if (prevGroupMeta && prevGroupMeta.errorMap === errorMap && prevGroupMeta.errorSourceMap === errorSourceMap && prevGroupMeta.errors === errors && prevGroupMeta.isFieldsValidating === isFieldsValidating && prevGroupMeta.isFieldsValid === isFieldsValid && prevGroupMeta.isGroupValid === isGroupValid && prevGroupMeta.isValid === isValid && prevGroupMeta.canSubmit === canSubmit && prevGroupMeta.isTouched === aggIsTouched && prevGroupMeta.isBlurred === aggIsBlurred && prevGroupMeta.isPristine === isPristine && prevGroupMeta.isDefaultValue === aggIsDefaultValue && prevGroupMeta.isDirty === aggIsDirty && prevGroupMeta.isValidating === isValidating && prevGroupMeta.isSubmitting === lifecycle.isSubmitting && prevGroupMeta.isSubmitted === lifecycle.isSubmitted && prevGroupMeta.submissionAttempts === lifecycle.submissionAttempts && prevGroupMeta.isSubmitSuccessful === lifecycle.isSubmitSuccessful) {
                    result[groupName] = prevGroupMeta;
                    continue;
                }
                const meta = {
                    // Submission lifecycle (spread first; `isValidating` below
                    // intentionally overrides `lifecycle.isValidating` with the
                    // OR of group-level + descendant-field validating).
                    ...lifecycle,
                    errorMap: // Field-meta-base fields (so `setMeta` updates can roundtrip
                    // through `state.meta`).
                    errorMap,
                    errorSourceMap: errorSourceMap,
                    _arrayVersion: ownFieldMeta?._arrayVersion ?? 0,
                    // Aggregated descendant booleans (override field-level meaning
                    // for groups — a group's "field" itself never receives input).
                    isTouched: aggIsTouched,
                    isBlurred: aggIsBlurred,
                    isDirty: aggIsDirty,
                    isPristine: isPristine,
                    isDefaultValue: aggIsDefaultValue,
                    isValid: // Aggregated validity
                    isValid,
                    errors: errors,
                    isValidating: isValidating,
                    isFieldsValidating: // Group-only flags
                    isFieldsValidating,
                    isFieldsValid: isFieldsValid,
                    isGroupValid: isGroupValid,
                    canSubmit: canSubmit
                };
                Object.defineProperty(meta, "__srcErrorMap", {
                    value: errorMap,
                    enumerable: false,
                    configurable: true
                });
                result[groupName] = meta;
            }
            return result;
        });
        let prevBaseStoreForStore = void 0;
        this.store = (0, $kKYCu.createStore)((prevVal)=>{
            const currBaseStore = this.baseStore.get();
            const currFieldMeta = this.fieldMetaDerived.get();
            const fieldMetaValues = Object.values(currFieldMeta).filter(Boolean);
            const isFieldsValidating = fieldMetaValues.some((field)=>field.isValidating);
            const isFieldsValid = fieldMetaValues.every((field)=>field.isValid);
            const isTouched = fieldMetaValues.some((field)=>field.isTouched);
            const isBlurred = fieldMetaValues.some((field)=>field.isBlurred);
            const isDefaultValue = fieldMetaValues.every((field)=>field.isDefaultValue);
            const shouldInvalidateOnMount = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            isTouched && currBaseStore.errorMap?.onMount;
            const isDirty = fieldMetaValues.some((field)=>field.isDirty);
            const isPristine = !isDirty;
            const hasOnMountError = Boolean(// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            currBaseStore.errorMap?.onMount || // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            fieldMetaValues.some((f)=>f?.errorMap?.onMount));
            const isValidating = !!isFieldsValidating;
            let errors = prevVal?.errors ?? [];
            if (!prevBaseStoreForStore || currBaseStore.errorMap !== prevBaseStoreForStore.errorMap) errors = Object.values(currBaseStore.errorMap).reduce((prev, curr)=>{
                if (curr === void 0) return prev;
                if (curr && (0, $5D8ug.isGlobalFormValidationError)(curr)) {
                    prev.push(curr.form);
                    return prev;
                }
                prev.push(curr);
                return prev;
            }, []);
            const isFormValid = errors.length === 0;
            const isValid = isFieldsValid && isFormValid;
            const submitInvalid = this.options.canSubmitWhenInvalid ?? false;
            const canSubmit = currBaseStore.submissionAttempts === 0 && !isTouched && !hasOnMountError || !isValidating && !currBaseStore.isSubmitting && isValid || submitInvalid;
            let errorMap = currBaseStore.errorMap;
            if (shouldInvalidateOnMount) {
                errors = errors.filter((err)=>err !== currBaseStore.errorMap.onMount);
                errorMap = Object.assign(errorMap, {
                    onMount: void 0
                });
            }
            if (prevVal && prevBaseStoreForStore && prevVal.errorMap === errorMap && prevVal.fieldMeta === this.fieldMetaDerived.state && prevVal.errors === errors && prevVal.isFieldsValidating === isFieldsValidating && prevVal.isFieldsValid === isFieldsValid && prevVal.isFormValid === isFormValid && prevVal.isValid === isValid && prevVal.canSubmit === canSubmit && prevVal.isTouched === isTouched && prevVal.isBlurred === isBlurred && prevVal.isPristine === isPristine && prevVal.isDefaultValue === isDefaultValue && prevVal.isDirty === isDirty && (0, $5D8ug.evaluate)(prevBaseStoreForStore, currBaseStore)) return prevVal;
            const state = {
                ...currBaseStore,
                errorMap: errorMap,
                fieldMeta: this.fieldMetaDerived.state,
                errors: errors,
                isFieldsValidating: isFieldsValidating,
                isFieldsValid: isFieldsValid,
                isFormValid: isFormValid,
                isValid: isValid,
                canSubmit: canSubmit,
                isTouched: isTouched,
                isBlurred: isBlurred,
                isPristine: isPristine,
                isDefaultValue: isDefaultValue,
                isDirty: isDirty
            };
            prevBaseStoreForStore = this.baseStore.get();
            return state;
        });
        this.handleSubmit = this.handleSubmit.bind(this);
        this.update(opts || {});
    }
    get state() {
        return this.store.state;
    }
    get formId() {
        return this._formId;
    }
    /**
   * @private
   */ runValidator(props) {
        if ((0, $8DIXq.isStandardSchemaValidator)(props.validate)) return (0, $8DIXq.standardSchemaValidators)[props.type](props.value, props.validate);
        return props.validate(props.value);
    }
    handleSubmit(submitMeta) {
        return this._handleSubmit(submitMeta);
    }
}
function $e4c5b9997feed6f4$var$normalizeError(rawError) {
    if (rawError) {
        if ((0, $5D8ug.isGlobalFormValidationError)(rawError)) {
            const formError = $e4c5b9997feed6f4$var$normalizeError(rawError.form).formError;
            const fieldErrors = rawError.fields;
            return {
                formError: formError,
                fieldErrors: fieldErrors
            };
        }
        return {
            formError: rawError
        };
    }
    return {
        formError: void 0
    };
}
function $e4c5b9997feed6f4$var$getErrorMapKey(cause) {
    switch(cause){
        case "submit":
            return "onSubmit";
        case "blur":
            return "onBlur";
        case "mount":
            return "onMount";
        case "server":
            return "onServer";
        case "dynamic":
            return "onDynamic";
        case "change":
        default:
            return "onChange";
    }
}

});
parcelRegister("dgHzL", function(module, exports) {

$parcel$export(module.exports, "toObserver", function () { return $9a8e92434f151c25$export$75b67481063f2f98; });
$parcel$export(module.exports, "batch", function () { return $9a8e92434f151c25$export$712ea50be43a7858; });
$parcel$export(module.exports, "createAtom", function () { return $9a8e92434f151c25$export$2e17fe64ec9a826e; });

var $8lKYl = parcelRequire("8lKYl");
//#region src/atom.ts
function $9a8e92434f151c25$export$75b67481063f2f98(nextHandler, errorHandler, completionHandler) {
    const isObserver = typeof nextHandler === "object";
    const self = isObserver ? nextHandler : void 0;
    return {
        next: (isObserver ? nextHandler.next : nextHandler)?.bind(self),
        error: (isObserver ? nextHandler.error : errorHandler)?.bind(self),
        complete: (isObserver ? nextHandler.complete : completionHandler)?.bind(self)
    };
}
const $9a8e92434f151c25$var$queuedEffects = [];
let $9a8e92434f151c25$var$cycle = 0;
const { link: $9a8e92434f151c25$var$link, unlink: $9a8e92434f151c25$var$unlink, propagate: $9a8e92434f151c25$var$propagate, checkDirty: $9a8e92434f151c25$var$checkDirty, shallowPropagate: $9a8e92434f151c25$var$shallowPropagate } = /* @__PURE__ */ (0, $8lKYl.createReactiveSystem)({
    update (atom) {
        return atom._update();
    },
    notify (effect) {
        $9a8e92434f151c25$var$queuedEffects[$9a8e92434f151c25$var$queuedEffectsLength++] = effect;
        effect.flags &= -3;
    },
    unwatched (atom) {
        if (atom.depsTail !== void 0) {
            atom.depsTail = void 0;
            atom.flags = 17;
            $9a8e92434f151c25$var$purgeDeps(atom);
        }
    }
});
let $9a8e92434f151c25$var$notifyIndex = 0;
let $9a8e92434f151c25$var$queuedEffectsLength = 0;
let $9a8e92434f151c25$var$activeSub;
let $9a8e92434f151c25$var$batchDepth = 0;
function $9a8e92434f151c25$export$712ea50be43a7858(fn) {
    try {
        ++$9a8e92434f151c25$var$batchDepth;
        fn();
    } finally{
        if (!--$9a8e92434f151c25$var$batchDepth) $9a8e92434f151c25$export$4909b86c8034bf73();
    }
}
function $9a8e92434f151c25$var$purgeDeps(sub) {
    const depsTail = sub.depsTail;
    let dep = depsTail !== void 0 ? depsTail.nextDep : sub.deps;
    while(dep !== void 0)dep = $9a8e92434f151c25$var$unlink(dep, sub);
}
function $9a8e92434f151c25$export$4909b86c8034bf73() {
    if ($9a8e92434f151c25$var$batchDepth > 0) return;
    while($9a8e92434f151c25$var$notifyIndex < $9a8e92434f151c25$var$queuedEffectsLength){
        const effect = $9a8e92434f151c25$var$queuedEffects[$9a8e92434f151c25$var$notifyIndex];
        $9a8e92434f151c25$var$queuedEffects[$9a8e92434f151c25$var$notifyIndex++] = void 0;
        effect.notify();
    }
    $9a8e92434f151c25$var$notifyIndex = 0;
    $9a8e92434f151c25$var$queuedEffectsLength = 0;
}
function $9a8e92434f151c25$export$9b74abc112e7de28(getValue, options) {
    const ref = {};
    const atom = $9a8e92434f151c25$export$2e17fe64ec9a826e(()=>{
        getValue().then((data)=>{
            const internalAtom = ref.current;
            if (internalAtom._update({
                status: "done",
                data: data
            })) {
                const subs = internalAtom.subs;
                if (subs !== void 0) {
                    $9a8e92434f151c25$var$propagate(subs);
                    $9a8e92434f151c25$var$shallowPropagate(subs);
                    $9a8e92434f151c25$export$4909b86c8034bf73();
                }
            }
        }, (error)=>{
            const internalAtom = ref.current;
            if (internalAtom._update({
                status: "error",
                error: error
            })) {
                const subs = internalAtom.subs;
                if (subs !== void 0) {
                    $9a8e92434f151c25$var$propagate(subs);
                    $9a8e92434f151c25$var$shallowPropagate(subs);
                    $9a8e92434f151c25$export$4909b86c8034bf73();
                }
            }
        });
        return {
            status: "pending"
        };
    }, options);
    ref.current = atom;
    return atom;
}
function $9a8e92434f151c25$export$2e17fe64ec9a826e(valueOrFn, options) {
    const isComputed = typeof valueOrFn === "function";
    const getter = valueOrFn;
    const atom = {
        _snapshot: isComputed ? void 0 : valueOrFn,
        subs: void 0,
        subsTail: void 0,
        deps: void 0,
        depsTail: void 0,
        flags: isComputed ? 0 : 1,
        get () {
            if ($9a8e92434f151c25$var$activeSub !== void 0) $9a8e92434f151c25$var$link(atom, $9a8e92434f151c25$var$activeSub, $9a8e92434f151c25$var$cycle);
            return atom._snapshot;
        },
        subscribe (observerOrFn) {
            const obs = $9a8e92434f151c25$export$75b67481063f2f98(observerOrFn);
            const observed = {
                current: false
            };
            const e = $9a8e92434f151c25$var$effect(()=>{
                atom.get();
                if (!observed.current) observed.current = true;
                else obs.next?.(atom._snapshot);
            });
            return {
                unsubscribe: ()=>{
                    e.stop();
                }
            };
        },
        _update (getValue) {
            const prevSub = $9a8e92434f151c25$var$activeSub;
            const compare = options?.compare ?? Object.is;
            if (isComputed) {
                $9a8e92434f151c25$var$activeSub = atom;
                ++$9a8e92434f151c25$var$cycle;
                atom.depsTail = void 0;
            } else if (getValue === void 0) return false;
            if (isComputed) atom.flags = 5;
            try {
                const oldValue = atom._snapshot;
                const newValue = typeof getValue === "function" ? getValue(oldValue) : getValue === void 0 && isComputed ? getter(oldValue) : getValue;
                if (oldValue === void 0 || !compare(oldValue, newValue)) {
                    atom._snapshot = newValue;
                    return true;
                }
                return false;
            } finally{
                $9a8e92434f151c25$var$activeSub = prevSub;
                if (isComputed) atom.flags &= -5;
                $9a8e92434f151c25$var$purgeDeps(atom);
            }
        }
    };
    if (isComputed) {
        atom.flags = 17;
        atom.get = function() {
            const flags = atom.flags;
            if (flags & 16 || flags & 32 && $9a8e92434f151c25$var$checkDirty(atom.deps, atom)) {
                if (atom._update()) {
                    const subs = atom.subs;
                    if (subs !== void 0) $9a8e92434f151c25$var$shallowPropagate(subs);
                }
            } else if (flags & 32) atom.flags = flags & -33;
            if ($9a8e92434f151c25$var$activeSub !== void 0) $9a8e92434f151c25$var$link(atom, $9a8e92434f151c25$var$activeSub, $9a8e92434f151c25$var$cycle);
            return atom._snapshot;
        };
    } else atom.set = function(valueOrFn) {
        if (atom._update(valueOrFn)) {
            const subs = atom.subs;
            if (subs !== void 0) {
                $9a8e92434f151c25$var$propagate(subs);
                $9a8e92434f151c25$var$shallowPropagate(subs);
                $9a8e92434f151c25$export$4909b86c8034bf73();
            }
        }
    };
    return atom;
}
function $9a8e92434f151c25$var$effect(fn) {
    const run = ()=>{
        const prevSub = $9a8e92434f151c25$var$activeSub;
        $9a8e92434f151c25$var$activeSub = effectObj;
        ++$9a8e92434f151c25$var$cycle;
        effectObj.depsTail = void 0;
        effectObj.flags = 6;
        try {
            return fn();
        } finally{
            $9a8e92434f151c25$var$activeSub = prevSub;
            effectObj.flags &= -5;
            $9a8e92434f151c25$var$purgeDeps(effectObj);
        }
    };
    const effectObj = {
        deps: void 0,
        depsTail: void 0,
        subs: void 0,
        subsTail: void 0,
        flags: 6,
        notify () {
            const flags = this.flags;
            if (flags & 16 || flags & 32 && $9a8e92434f151c25$var$checkDirty(this.deps, this)) run();
            else this.flags = 2;
        },
        stop () {
            this.flags = 0;
            this.depsTail = void 0;
            $9a8e92434f151c25$var$purgeDeps(this);
        }
    };
    run();
    return effectObj;
}

});
parcelRegister("8lKYl", function(module, exports) {

$parcel$export(module.exports, "createReactiveSystem", function () { return $6144b8a13cedec51$export$952cb7b9893d64c4; });
//#region src/alien.ts
const $6144b8a13cedec51$var$NONE = 0;
const $6144b8a13cedec51$var$MUTABLE = 1;
const $6144b8a13cedec51$var$WATCHING = 2;
const $6144b8a13cedec51$var$RECURSED_CHECK = 4;
const $6144b8a13cedec51$var$RECURSED = 8;
const $6144b8a13cedec51$var$DIRTY = 16;
const $6144b8a13cedec51$var$PENDING = 32;
/* @__NO_SIDE_EFFECTS__ */ function $6144b8a13cedec51$export$952cb7b9893d64c4({ update: update, notify: notify, unwatched: unwatched }) {
    return {
        link: link,
        unlink: unlink,
        propagate: propagate,
        checkDirty: checkDirty,
        shallowPropagate: shallowPropagate
    };
    function link(dep, sub, version) {
        const prevDep = sub.depsTail;
        if (prevDep !== void 0 && prevDep.dep === dep) return;
        const nextDep = prevDep !== void 0 ? prevDep.nextDep : sub.deps;
        if (nextDep !== void 0 && nextDep.dep === dep) {
            nextDep.version = version;
            sub.depsTail = nextDep;
            return;
        }
        const prevSub = dep.subsTail;
        if (prevSub !== void 0 && prevSub.version === version && prevSub.sub === sub) return;
        const newLink = sub.depsTail = dep.subsTail = {
            version: version,
            dep: dep,
            sub: sub,
            prevDep: prevDep,
            nextDep: nextDep,
            prevSub: prevSub,
            nextSub: void 0
        };
        if (nextDep !== void 0) nextDep.prevDep = newLink;
        if (prevDep !== void 0) prevDep.nextDep = newLink;
        else sub.deps = newLink;
        if (prevSub !== void 0) prevSub.nextSub = newLink;
        else dep.subs = newLink;
    }
    function unlink(link, sub = link.sub) {
        const dep = link.dep;
        const prevDep = link.prevDep;
        const nextDep = link.nextDep;
        const nextSub = link.nextSub;
        const prevSub = link.prevSub;
        if (nextDep !== void 0) nextDep.prevDep = prevDep;
        else sub.depsTail = prevDep;
        if (prevDep !== void 0) prevDep.nextDep = nextDep;
        else sub.deps = nextDep;
        if (nextSub !== void 0) nextSub.prevSub = prevSub;
        else dep.subsTail = prevSub;
        if (prevSub !== void 0) prevSub.nextSub = nextSub;
        else if ((dep.subs = nextSub) === void 0) unwatched(dep);
        return nextDep;
    }
    function propagate(link) {
        let next = link.nextSub;
        let stack;
        top: do {
            const sub = link.sub;
            let flags = sub.flags;
            if (!(flags & 60)) sub.flags = flags | 32;
            else if (!(flags & 12)) flags = 0;
            else if (!(flags & 4)) sub.flags = flags & -9 | 32;
            else if (!(flags & 48) && isValidLink(link, sub)) {
                sub.flags = flags | 40;
                flags &= 1;
            } else flags = 0;
            if (flags & 2) notify(sub);
            if (flags & 1) {
                const subSubs = sub.subs;
                if (subSubs !== void 0) {
                    const nextSub = (link = subSubs).nextSub;
                    if (nextSub !== void 0) {
                        stack = {
                            value: next,
                            prev: stack
                        };
                        next = nextSub;
                    }
                    continue;
                }
            }
            if ((link = next) !== void 0) {
                next = link.nextSub;
                continue;
            }
            while(stack !== void 0){
                link = stack.value;
                stack = stack.prev;
                if (link !== void 0) {
                    next = link.nextSub;
                    continue top;
                }
            }
            break;
        }while (true);
    }
    function checkDirty(link, sub) {
        let stack;
        let checkDepth = 0;
        let dirty = false;
        top: do {
            const dep = link.dep;
            const flags = dep.flags;
            if (sub.flags & 16) dirty = true;
            else if ((flags & 17) === 17) {
                if (update(dep)) {
                    const subs = dep.subs;
                    if (subs.nextSub !== void 0) shallowPropagate(subs);
                    dirty = true;
                }
            } else if ((flags & 33) === 33) {
                if (link.nextSub !== void 0 || link.prevSub !== void 0) stack = {
                    value: link,
                    prev: stack
                };
                link = dep.deps;
                sub = dep;
                ++checkDepth;
                continue;
            }
            if (!dirty) {
                const nextDep = link.nextDep;
                if (nextDep !== void 0) {
                    link = nextDep;
                    continue;
                }
            }
            while(checkDepth--){
                const firstSub = sub.subs;
                const hasMultipleSubs = firstSub.nextSub !== void 0;
                if (hasMultipleSubs) {
                    link = stack.value;
                    stack = stack.prev;
                } else link = firstSub;
                if (dirty) {
                    if (update(sub)) {
                        if (hasMultipleSubs) shallowPropagate(firstSub);
                        sub = link.sub;
                        continue;
                    }
                    dirty = false;
                } else sub.flags &= -33;
                sub = link.sub;
                const nextDep = link.nextDep;
                if (nextDep !== void 0) {
                    link = nextDep;
                    continue top;
                }
            }
            return dirty;
        }while (true);
    }
    function shallowPropagate(link) {
        do {
            const sub = link.sub;
            const flags = sub.flags;
            if ((flags & 48) === 32) {
                sub.flags = flags | 16;
                if ((flags & 6) === 2) notify(sub);
            }
        }while ((link = link.nextSub) !== void 0);
    }
    function isValidLink(checkLink, sub) {
        let link = sub.depsTail;
        while(link !== void 0){
            if (link === checkLink) return true;
            link = link.prevDep;
        }
        return false;
    }
}

});


parcelRegister("kKYCu", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $f1c7205dcf5e39a4$export$f51a9068ac82ea43; });

var $dgHzL = parcelRequire("dgHzL");
//#region src/store.ts
var $f1c7205dcf5e39a4$export$390f32400eaf98c9 = class {
    constructor(valueOrFn, actionsFactory){
        this.atom = (0, $dgHzL.createAtom)(valueOrFn);
        this.get = this.get.bind(this);
        this.setState = this.setState.bind(this);
        this.subscribe = this.subscribe.bind(this);
        if (actionsFactory) this.actions = actionsFactory(this);
    }
    setState(updater) {
        this.atom.set(updater);
    }
    get state() {
        return this.atom.get();
    }
    get() {
        return this.state;
    }
    subscribe(observerOrFn) {
        return this.atom.subscribe((0, $dgHzL.toObserver)(observerOrFn));
    }
};
var $f1c7205dcf5e39a4$export$655824c42fbbeca = class {
    constructor(valueOrFn){
        this.atom = (0, $dgHzL.createAtom)(valueOrFn);
    }
    get state() {
        return this.atom.get();
    }
    get() {
        return this.state;
    }
    subscribe(observerOrFn) {
        return this.atom.subscribe((0, $dgHzL.toObserver)(observerOrFn));
    }
};
function $f1c7205dcf5e39a4$export$f51a9068ac82ea43(valueOrFn, actions) {
    if (typeof valueOrFn === "function") return new $f1c7205dcf5e39a4$export$655824c42fbbeca(valueOrFn);
    if (actions) return new $f1c7205dcf5e39a4$export$390f32400eaf98c9(valueOrFn, actions);
    return new $f1c7205dcf5e39a4$export$390f32400eaf98c9(valueOrFn);
}

});

parcelRegister("5D8ug", function(module, exports) {

$parcel$export(module.exports, "functionalUpdate", function () { return $41972da8896fa072$export$7f095f455ad5af3f; });
$parcel$export(module.exports, "getBy", function () { return $41972da8896fa072$export$d42617c71165e4fc; });
$parcel$export(module.exports, "setBy", function () { return $41972da8896fa072$export$33f1188edec767af; });
$parcel$export(module.exports, "deleteBy", function () { return $41972da8896fa072$export$9ea2b6c3fae093d8; });
$parcel$export(module.exports, "isNonEmptyArray", function () { return $41972da8896fa072$export$d307f5934e447d0e; });
$parcel$export(module.exports, "getSyncValidatorArray", function () { return $41972da8896fa072$export$da43ebe26011838e; });
$parcel$export(module.exports, "getAsyncValidatorArray", function () { return $41972da8896fa072$export$703137be220bac88; });
$parcel$export(module.exports, "isGlobalFormValidationError", function () { return $41972da8896fa072$export$f2014ca2e5c932e; });
$parcel$export(module.exports, "evaluate", function () { return $41972da8896fa072$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "determineFormLevelErrorSourceAndValue", function () { return $41972da8896fa072$export$b23644be2fcc54e8; });
$parcel$export(module.exports, "determineFieldLevelErrorSourceAndValue", function () { return $41972da8896fa072$export$6583ad9917450771; });
$parcel$export(module.exports, "mergeOpts", function () { return $41972da8896fa072$export$1682c9e62cb16f41; });
$parcel$export(module.exports, "uuid", function () { return $41972da8896fa072$export$31b40729666a4ae0; });
$parcel$export(module.exports, "throttleFormState", function () { return $41972da8896fa072$export$9503cb153fe3109; });
$parcel$export(module.exports, "deepCopy", function () { return $41972da8896fa072$export$6c40052bed430212; });
$parcel$export(module.exports, "isFieldInGroup", function () { return $41972da8896fa072$export$8c92194a19f357b7; });

var $7DOjy = parcelRequire("7DOjy");

var $7lYn9 = parcelRequire("7lYn9");
function $41972da8896fa072$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $41972da8896fa072$export$d42617c71165e4fc(obj, path) {
    const pathObj = $41972da8896fa072$export$ca6b1b7fbf097d6d(path);
    return pathObj.reduce((current, pathPart)=>{
        if (current === null) return null;
        if (typeof current !== "undefined") return current[pathPart];
        return void 0;
    }, obj);
}
function $41972da8896fa072$export$33f1188edec767af(obj, _path, updater) {
    const path = $41972da8896fa072$export$ca6b1b7fbf097d6d(_path);
    function doSet(parent) {
        if (!path.length) return $41972da8896fa072$export$7f095f455ad5af3f(updater, parent);
        const key = path.shift();
        if (typeof key === "string" || typeof key === "number" && !Array.isArray(parent)) {
            if (typeof parent === "object") {
                if (parent === null) parent = {};
                return {
                    ...parent,
                    [key]: doSet(parent[key])
                };
            }
            return {
                [key]: doSet()
            };
        }
        if (Array.isArray(parent) && typeof key === "number") {
            const prefix = parent.slice(0, key);
            return [
                ...prefix.length ? prefix : new Array(key),
                doSet(parent[key]),
                ...parent.slice(key + 1)
            ];
        }
        return [
            ...new Array(key),
            doSet()
        ];
    }
    return doSet(obj);
}
function $41972da8896fa072$export$9ea2b6c3fae093d8(obj, _path) {
    const path = $41972da8896fa072$export$ca6b1b7fbf097d6d(_path);
    function doDelete(parent) {
        if (!parent) return;
        if (path.length === 1) {
            const finalPath = path[0];
            if (Array.isArray(parent) && typeof finalPath === "number") return parent.filter((_, i)=>i !== finalPath);
            const { [finalPath]: remove, ...rest } = parent;
            return rest;
        }
        const key = path.shift();
        if (typeof key === "string" || typeof key === "number" && !Array.isArray(parent)) {
            if (typeof parent === "object") return {
                ...parent,
                [key]: doDelete(parent[key])
            };
        }
        if (typeof key === "number") {
            if (Array.isArray(parent)) {
                if (key >= parent.length) return parent;
                const prefix = parent.slice(0, key);
                return [
                    ...prefix.length ? prefix : new Array(key),
                    doDelete(parent[key]),
                    ...parent.slice(key + 1)
                ];
            }
        }
        throw new Error("It seems we have created an infinite loop in deleteBy. ");
    }
    return doDelete(obj);
}
const $41972da8896fa072$var$CC_DOT = 46;
const $41972da8896fa072$var$CC_OPEN = 91;
const $41972da8896fa072$var$CC_CLOSE = 93;
const $41972da8896fa072$var$CC_ZERO = 48;
const $41972da8896fa072$var$CC_NINE = 57;
function $41972da8896fa072$export$ca6b1b7fbf097d6d(str) {
    if (Array.isArray(str)) return [
        ...str
    ];
    if (typeof str !== "string") throw new Error("Path must be a string.");
    const len = str.length;
    const result = [];
    let segStart = len > 0 && str.charCodeAt(0) === $41972da8896fa072$var$CC_OPEN ? 1 : 0;
    let allDigits = true;
    let prev = -1;
    for(let i = segStart; i <= len; i++){
        const char = i < len ? str.charCodeAt(i) : -1;
        if (i === len || char === $41972da8896fa072$var$CC_DOT || char === $41972da8896fa072$var$CC_OPEN || char === $41972da8896fa072$var$CC_CLOSE) {
            const segLen = i - segStart;
            if (segLen > 0) {
                const treatAsNumber = // ...it must contain only digits...
                allDigits && // ...and either be a single '0' or not start with '0'.
                (segLen === 1 || str.charCodeAt(segStart) !== $41972da8896fa072$var$CC_ZERO);
                const seg = str.slice(segStart, i);
                if (treatAsNumber) {
                    const num = parseInt(seg, 10);
                    if (segLen <= 15 || String(num) === seg) result.push(num);
                    else result.push(seg);
                } else result.push(seg);
            } else if (// This branch, which handles empty segments, only exists to preserve
            // the old behavior for malformed input.
            // Push the empty segment unless this is a "phantom boundary" the
            // old regex impl would have absorbed:
            //   1. `]` was always stripped — `prev === ']'` means the real
            //      boundary already happened on the previous iteration.
            //   2. A leading `]` was stripped too (the leading `[` strip
            //      above handles its counterpart for `[`).
            //   3. `..` and `[[` collapse to a single boundary.
            prev !== $41972da8896fa072$var$CC_CLOSE && !(prev === -1 && char === $41972da8896fa072$var$CC_CLOSE) && !(prev === char && (char === $41972da8896fa072$var$CC_DOT || char === $41972da8896fa072$var$CC_OPEN))) result.push("");
            segStart = i + 1;
            allDigits = true;
        } else if (char < $41972da8896fa072$var$CC_ZERO || char > $41972da8896fa072$var$CC_NINE) allDigits = false;
        prev = char;
    }
    if (!result.length) result.push("");
    return result;
}
function $41972da8896fa072$export$f53892b9fb95d73(path1, path2) {
    if (path1.length === 0) return path2;
    if (path2.length === 0) return path1;
    if (path2.startsWith("[")) return path1 + path2;
    if (path2.startsWith(".")) return path1 + path2;
    return `${path1}.${path2}`;
}
function $41972da8896fa072$export$d307f5934e447d0e(obj) {
    return !(Array.isArray(obj) && obj.length === 0);
}
function $41972da8896fa072$export$da43ebe26011838e(cause, options) {
    const runValidation = (props)=>{
        return props.validators.filter(Boolean).map((validator)=>{
            return {
                cause: validator.cause,
                validate: validator.fn
            };
        });
    };
    return options.validationLogic({
        form: options.form,
        group: options.group,
        validators: options.validators,
        event: {
            type: cause,
            fieldName: options.fieldName,
            async: false
        },
        runValidation: runValidation
    });
}
function $41972da8896fa072$export$703137be220bac88(cause, options) {
    const { asyncDebounceMs: asyncDebounceMs } = options;
    const { onBlurAsyncDebounceMs: onBlurAsyncDebounceMs, onChangeAsyncDebounceMs: onChangeAsyncDebounceMs, onDynamicAsyncDebounceMs: onDynamicAsyncDebounceMs } = options.validators || {};
    const defaultDebounceMs = asyncDebounceMs ?? 0;
    const runValidation = (props)=>{
        return props.validators.filter(Boolean).map((validator)=>{
            const validatorCause = validator?.cause || cause;
            let debounceMs = defaultDebounceMs;
            switch(validatorCause){
                case "change":
                    debounceMs = onChangeAsyncDebounceMs ?? defaultDebounceMs;
                    break;
                case "blur":
                    debounceMs = onBlurAsyncDebounceMs ?? defaultDebounceMs;
                    break;
                case "dynamic":
                    debounceMs = onDynamicAsyncDebounceMs ?? defaultDebounceMs;
                    break;
                case "submit":
                    debounceMs = 0;
                    break;
            }
            if (cause === "submit") debounceMs = 0;
            return {
                cause: validatorCause,
                validate: validator.fn,
                debounceMs: debounceMs
            };
        });
    };
    return options.validationLogic({
        form: options.form,
        group: options.group,
        validators: options.validators,
        event: {
            type: cause,
            fieldName: options.fieldName,
            async: true
        },
        runValidation: runValidation
    });
}
const $41972da8896fa072$export$f2014ca2e5c932e = (error)=>{
    return !!error && typeof error === "object" && "fields" in error;
};
function $41972da8896fa072$export$fef61f332f2c0afc(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    if (objA instanceof Date && objB instanceof Date) return objA.getTime() === objB.getTime();
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for (const [k, v] of objA){
            if (!objB.has(k) || !Object.is(v, objB.get(k))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for (const v of objA){
            if (!objB.has(v)) return false;
        }
        return true;
    }
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    if (keysA.length === 0 && !Array.isArray(objA) && !Array.isArray(objB) && (Object.getPrototypeOf(objA) !== Object.prototype || Object.getPrototypeOf(objB) !== Object.prototype)) return false;
    for (const key of keysA){
        if (!keysB.includes(key) || !$41972da8896fa072$export$fef61f332f2c0afc(objA[key], objB[key])) return false;
    }
    return true;
}
const $41972da8896fa072$export$b23644be2fcc54e8 = ({ newFormValidatorError: newFormValidatorError, isPreviousErrorFromFormValidator: isPreviousErrorFromFormValidator, previousErrorValue: previousErrorValue })=>{
    if (newFormValidatorError) return {
        newErrorValue: newFormValidatorError,
        newSource: "form"
    };
    if (isPreviousErrorFromFormValidator) return {
        newErrorValue: void 0,
        newSource: void 0
    };
    if (previousErrorValue) return {
        newErrorValue: previousErrorValue,
        newSource: "field"
    };
    return {
        newErrorValue: void 0,
        newSource: void 0
    };
};
const $41972da8896fa072$export$6583ad9917450771 = ({ formLevelError: formLevelError, fieldLevelError: fieldLevelError })=>{
    if (fieldLevelError) return {
        newErrorValue: fieldLevelError,
        newSource: "field"
    };
    if (formLevelError) return {
        newErrorValue: formLevelError,
        newSource: "form"
    };
    return {
        newErrorValue: void 0,
        newSource: void 0
    };
};
function $41972da8896fa072$export$e9d84dc4e5980b3f(values) {
    const output = {};
    for(const key in values)output[key] = key;
    return output;
}
function $41972da8896fa072$export$1682c9e62cb16f41(originalOpts, overrides) {
    if (originalOpts === void 0 || originalOpts === null) return overrides;
    return {
        ...originalOpts,
        ...overrides
    };
}
let $41972da8896fa072$var$IDX = 256;
const $41972da8896fa072$var$HEX = [];
let $41972da8896fa072$var$BUFFER;
while($41972da8896fa072$var$IDX--)$41972da8896fa072$var$HEX[$41972da8896fa072$var$IDX] = ($41972da8896fa072$var$IDX + 256).toString(16).substring(1);
function $41972da8896fa072$export$31b40729666a4ae0() {
    let i = 0;
    let num;
    let out = "";
    if (!$41972da8896fa072$var$BUFFER || $41972da8896fa072$var$IDX + 16 > 256) {
        $41972da8896fa072$var$BUFFER = new Array(256);
        i = 256;
        while(i--)$41972da8896fa072$var$BUFFER[i] = 256 * Math.random() | 0;
        i = 0;
        $41972da8896fa072$var$IDX = 0;
    }
    for(; i < 16; i++){
        num = $41972da8896fa072$var$BUFFER[$41972da8896fa072$var$IDX + i];
        if (i === 6) out += $41972da8896fa072$var$HEX[num & 15 | 64];
        else if (i === 8) out += $41972da8896fa072$var$HEX[num & 63 | 128];
        else out += $41972da8896fa072$var$HEX[num];
        if (i & 1 && i > 1 && i < 11) out += "-";
    }
    $41972da8896fa072$var$IDX++;
    return out;
}
const $41972da8896fa072$export$9503cb153fe3109 = (0, $7DOjy.liteThrottle)((form)=>(0, $7lYn9.formEventClient).emit("form-state", {
        id: form.formId,
        state: form.store.state
    }), {
    wait: 300
});
function $41972da8896fa072$export$6c40052bed430212(obj) {
    if (obj === null || typeof obj !== "object") return obj;
    if (obj instanceof Date) return new Date(obj.getTime());
    if (Array.isArray(obj)) {
        const arrCopy = [];
        for(let i = 0; i < obj.length; i++)arrCopy[i] = $41972da8896fa072$export$6c40052bed430212(obj[i]);
        return arrCopy;
    }
    if (obj instanceof Map) {
        const mapCopy = /* @__PURE__ */ new Map();
        obj.forEach((value, key)=>{
            mapCopy.set(key, $41972da8896fa072$export$6c40052bed430212(value));
        });
        return mapCopy;
    }
    if (obj instanceof Set) {
        const setCopy = /* @__PURE__ */ new Set();
        obj.forEach((value)=>{
            setCopy.add($41972da8896fa072$export$6c40052bed430212(value));
        });
        return setCopy;
    }
    const copy = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) copy[key] = $41972da8896fa072$export$6c40052bed430212(obj[key]);
    return copy;
}
function $41972da8896fa072$export$8c92194a19f357b7(groupName, fieldName) {
    return fieldName === groupName || fieldName.startsWith(`${groupName}.`) || fieldName.startsWith(`${groupName}[`);
}

});
parcelRegister("7DOjy", function(module, exports) {

$parcel$export(module.exports, "liteThrottle", function () { return $590334557f44bdf9$export$24b8a9977fbfb979; });
//#region src/lite-throttler.ts
/**
* A lightweight class that creates a throttled function.
*
* This is an alternative to the Throttler in the core @tanstack/pacer package, but is more
* suitable for libraries and npm packages that need minimal overhead. Unlike the core Throttler,
* this version does not use TanStack Store for state management, has no devtools integration,
* and provides only essential throttling functionality.
*
* Throttling ensures a function is called at most once within a specified time window.
* Unlike debouncing which waits for a pause in calls, throttling guarantees consistent
* execution timing regardless of call frequency.
*
* Supports both leading and trailing edge execution:
* - Leading: Execute immediately on first call (default: true)
* - Trailing: Execute after wait period if called during throttle (default: true)
*
* Features:
* - Zero dependencies - no external libraries required
* - Minimal API surface - only essential methods (maybeExecute, flush, cancel)
* - Simple state management - uses basic private properties instead of reactive stores
* - Callback support for monitoring execution events
* - Lightweight - designed for use in npm packages where bundle size matters
*
* @example
* ```ts
* const throttler = new LiteThrottler((scrollY: number) => {
*   updateScrollPosition(scrollY);
* }, {
*   wait: 100,
*   onExecute: (args, throttler) => {
*     console.log('Updated scroll position:', args[0]);
*   }
* });
*
* // Will execute at most once per 100ms
* window.addEventListener('scroll', () => {
*   throttler.maybeExecute(window.scrollY);
* });
* ```
*/ var $590334557f44bdf9$export$15dbce0e0a6dd3df = class {
    constructor(fn, options){
        this.fn = fn;
        this.options = options;
        this.lastExecutionTime = 0;
        this.isPending = false;
        this.maybeExecute = (...args)=>{
            const timeSinceLastExecution = Date.now() - this.lastExecutionTime;
            if (this.options.leading && timeSinceLastExecution >= this.options.wait) this.execute(...args);
            else {
                this.lastArgs = args;
                if (!this.timeoutId && this.options.trailing) {
                    const timeoutDuration = this.options.wait - timeSinceLastExecution;
                    this.isPending = true;
                    this.timeoutId = setTimeout(()=>{
                        if (this.lastArgs !== void 0) this.execute(...this.lastArgs);
                    }, timeoutDuration);
                }
            }
        };
        this.execute = (...args)=>{
            this.fn(...args);
            this.options.onExecute?.(args, this);
            this.lastExecutionTime = Date.now();
            this.clearTimeout();
            this.lastArgs = void 0;
            this.isPending = false;
        };
        this.flush = ()=>{
            if (this.isPending && this.lastArgs) this.execute(...this.lastArgs);
        };
        this.cancel = ()=>{
            this.clearTimeout();
            this.lastArgs = void 0;
            this.isPending = false;
        };
        this.clearTimeout = ()=>{
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
                this.timeoutId = void 0;
            }
        };
        if (this.options.leading === void 0 && this.options.trailing === void 0) {
            this.options.leading = true;
            this.options.trailing = true;
        }
    }
};
/**
* Creates a lightweight throttled function that limits how often the provided function can execute.
*
* This is an alternative to the throttle function in the core @tanstack/pacer package, but is more
* suitable for libraries and npm packages that need minimal overhead. Unlike the core version,
* this function creates a throttler with no external dependencies, devtools integration, or reactive state.
*
* Throttling ensures a function executes at most once within a specified time window,
* regardless of how many times it is called. This is useful for rate-limiting
* expensive operations or UI updates.
*
* @example
* ```ts
* const throttledScroll = liteThrottle(() => {
*   updateScrollIndicator();
* }, { wait: 100 });
*
* // Will execute at most once per 100ms
* window.addEventListener('scroll', throttledScroll);
* ```
*
* @example
* ```ts
* // Leading edge execution - fires immediately then throttles
* const throttledResize = liteThrottle(() => {
*   recalculateLayout();
* }, { wait: 250, leading: true, trailing: false });
* ```
*/ function $590334557f44bdf9$export$24b8a9977fbfb979(fn, options) {
    return new $590334557f44bdf9$export$15dbce0e0a6dd3df(fn, options).maybeExecute;
}

});

parcelRegister("7lYn9", function(module, exports) {

$parcel$export(module.exports, "formEventClient", function () { return $55a953435e2f7277$export$ac6919c7ec46a615; });

var $1vWHq = parcelRequire("1vWHq");
class $55a953435e2f7277$var$FormEventClient extends (0, $1vWHq.EventClient) {
    constructor(){
        super({
            pluginId: "form-devtools",
            reconnectEveryMs: 1e3
        });
    }
}
const $55a953435e2f7277$export$ac6919c7ec46a615 = new $55a953435e2f7277$var$FormEventClient();

});
parcelRegister("1vWHq", function(module, exports) {

$parcel$export(module.exports, "EventClient", function () { return $11a6382b057dfac7$export$f4a30e909fe70796; });
//#region src/plugin.ts
var $11a6382b057dfac7$export$f4a30e909fe70796 = class {
    #enabled = true;
    #pluginId;
    #eventTarget;
    #debug;
    #queuedEvents;
    #connected;
    #connectIntervalId;
    #connectEveryMs;
    #retryCount = 0;
    #maxRetries = 5;
    #connecting = false;
    #failedToConnect = false;
    #internalEventTarget = null;
    #onConnected = ()=>{
        this.debugLog("Connected to event bus");
        this.#connected = true;
        this.#connecting = false;
        this.debugLog("Emitting queued events", this.#queuedEvents);
        this.#queuedEvents.forEach((event)=>this.emitEventToBus(event));
        this.#queuedEvents = [];
        this.stopConnectLoop();
        this.#eventTarget().removeEventListener("tanstack-connect-success", this.#onConnected);
    };
    #retryConnection = ()=>{
        if (this.#retryCount < this.#maxRetries) {
            this.#retryCount++;
            this.dispatchCustomEvent("tanstack-connect", {});
            return;
        }
        this.#eventTarget().removeEventListener("tanstack-connect", this.#retryConnection);
        this.#failedToConnect = true;
        this.debugLog("Max retries reached, giving up on connection");
        this.stopConnectLoop();
    };
    #connectFunction = ()=>{
        if (this.#connecting) return;
        this.#connecting = true;
        this.#eventTarget().addEventListener("tanstack-connect-success", this.#onConnected);
        this.#retryConnection();
    };
    constructor({ pluginId: pluginId, debug: debug = false, enabled: enabled = true, reconnectEveryMs: reconnectEveryMs = 300 }){
        this.#pluginId = pluginId;
        this.#enabled = enabled;
        this.#eventTarget = this.getGlobalTarget;
        this.#debug = debug;
        this.debugLog(" Initializing event subscription for plugin", this.#pluginId);
        this.#queuedEvents = [];
        this.#connected = false;
        this.#failedToConnect = false;
        this.#connectIntervalId = null;
        this.#connectEveryMs = reconnectEveryMs;
    }
    startConnectLoop() {
        if (this.#connectIntervalId !== null || this.#connected) return;
        this.debugLog(`Starting connect loop (every ${this.#connectEveryMs}ms)`);
        this.#connectIntervalId = setInterval(this.#retryConnection, this.#connectEveryMs);
    }
    stopConnectLoop() {
        this.#connecting = false;
        if (this.#connectIntervalId === null) return;
        clearInterval(this.#connectIntervalId);
        this.#connectIntervalId = null;
        this.#queuedEvents = [];
        this.debugLog("Stopped connect loop");
    }
    debugLog(...args) {
        if (this.#debug) console.log(`\u{1F334} [tanstack-devtools:${this.#pluginId}-plugin]`, ...args);
    }
    getGlobalTarget() {
        if (typeof globalThis !== "undefined" && globalThis.__TANSTACK_EVENT_TARGET__) {
            this.debugLog("Using global event target");
            return globalThis.__TANSTACK_EVENT_TARGET__;
        }
        if (typeof window !== "undefined" && typeof window.addEventListener !== "undefined") {
            this.debugLog("Using window as event target");
            return window;
        }
        const eventTarget = typeof EventTarget !== "undefined" ? new EventTarget() : void 0;
        if (typeof eventTarget === "undefined" || typeof eventTarget.addEventListener === "undefined") {
            this.debugLog("No event mechanism available, running in non-web environment");
            return {
                addEventListener: ()=>{},
                removeEventListener: ()=>{},
                dispatchEvent: ()=>false
            };
        }
        this.debugLog("Using new EventTarget as fallback");
        return eventTarget;
    }
    getPluginId() {
        return this.#pluginId;
    }
    dispatchCustomEventShim(eventName, detail) {
        try {
            const event = new Event(eventName, {
                detail: detail
            });
            this.#eventTarget().dispatchEvent(event);
        } catch (e) {
            this.debugLog("Failed to dispatch shim event");
        }
    }
    dispatchCustomEvent(eventName, detail) {
        try {
            this.#eventTarget().dispatchEvent(new CustomEvent(eventName, {
                detail: detail
            }));
        } catch (e) {
            this.dispatchCustomEventShim(eventName, detail);
        }
    }
    emitEventToBus(event) {
        this.debugLog("Emitting event to client bus", event);
        this.dispatchCustomEvent("tanstack-dispatch-event", event);
    }
    createEventPayload(eventSuffix, payload) {
        return {
            type: `${this.#pluginId}:${eventSuffix}`,
            payload: payload,
            pluginId: this.#pluginId
        };
    }
    emit(eventSuffix, payload) {
        if (!this.#enabled) {
            this.debugLog("Event bus client is disabled, not emitting event", eventSuffix, payload);
            return;
        }
        if (this.#internalEventTarget) {
            this.debugLog("Emitting event to internal event target", eventSuffix, payload);
            this.#internalEventTarget.dispatchEvent(new CustomEvent(`${this.#pluginId}:${eventSuffix}`, {
                detail: this.createEventPayload(eventSuffix, payload)
            }));
        }
        if (this.#failedToConnect) {
            this.debugLog("Previously failed to connect, not emitting to bus");
            return;
        }
        if (!this.#connected) {
            this.debugLog("Bus not available, will be pushed as soon as connected");
            this.#queuedEvents.push(this.createEventPayload(eventSuffix, payload));
            if (typeof CustomEvent !== "undefined" && !this.#connecting) {
                this.#connectFunction();
                this.startConnectLoop();
            }
            return;
        }
        return this.emitEventToBus(this.createEventPayload(eventSuffix, payload));
    }
    on(eventSuffix, cb, options) {
        const withEventTarget = options?.withEventTarget ?? false;
        const eventName = `${this.#pluginId}:${eventSuffix}`;
        if (withEventTarget) {
            if (!this.#internalEventTarget) this.#internalEventTarget = new EventTarget();
            this.#internalEventTarget.addEventListener(eventName, (e)=>{
                cb(e.detail);
            });
        }
        if (!this.#enabled) {
            this.debugLog("Event bus client is disabled, not registering event", eventName);
            return ()=>{};
        }
        const handler = (e)=>{
            this.debugLog("Received event from bus", e.detail);
            cb(e.detail);
        };
        this.#eventTarget().addEventListener(eventName, handler);
        this.debugLog("Registered event to bus", eventName);
        return ()=>{
            if (withEventTarget) this.#internalEventTarget?.removeEventListener(eventName, handler);
            this.#eventTarget().removeEventListener(eventName, handler);
        };
    }
    onAll(cb) {
        if (!this.#enabled) {
            this.debugLog("Event bus client is disabled, not registering event");
            return ()=>{};
        }
        const handler = (e)=>{
            const event = e.detail;
            cb(event);
        };
        this.#eventTarget().addEventListener("tanstack-devtools-global", handler);
        return ()=>this.#eventTarget().removeEventListener("tanstack-devtools-global", handler);
    }
    onAllPluginEvents(cb) {
        if (!this.#enabled) {
            this.debugLog("Event bus client is disabled, not registering event");
            return ()=>{};
        }
        const handler = (e)=>{
            const event = e.detail;
            if (this.#pluginId && event.pluginId !== this.#pluginId) return;
            cb(event);
        };
        this.#eventTarget().addEventListener("tanstack-devtools-global", handler);
        return ()=>this.#eventTarget().removeEventListener("tanstack-devtools-global", handler);
    }
};

});



parcelRegister("8TrCb", function(module, exports) {

$parcel$export(module.exports, "revalidateLogic", function () { return $6798e182eb7e6b0d$export$f7ab95d63be2dc09; });
$parcel$export(module.exports, "defaultValidationLogic", function () { return $6798e182eb7e6b0d$export$10851d056fe11b6a; });
const $6798e182eb7e6b0d$export$f7ab95d63be2dc09 = ({ mode: mode = "submit", modeAfterSubmission: modeAfterSubmission = "change" } = {})=>(props)=>{
        const validatorNames = Object.keys(props.validators ?? {});
        if (validatorNames.length === 0) return props.runValidation({
            validators: [],
            form: props.form
        });
        const dynamicValidator = {
            fn: props.event.async ? props.validators["onDynamicAsync"] : props.validators["onDynamic"],
            cause: "dynamic"
        };
        const validatorsToAdd = [];
        const submissionAttempts = props.group ? props.group.state.meta.submissionAttempts : props.form.state.submissionAttempts;
        const modeToWatch = submissionAttempts === 0 ? mode : modeAfterSubmission;
        if ([
            modeToWatch,
            "submit"
        ].includes(props.event.type)) validatorsToAdd.push(dynamicValidator);
        let defaultValidators = [];
        $6798e182eb7e6b0d$export$10851d056fe11b6a({
            ...props,
            runValidation: (vProps)=>{
                defaultValidators = vProps.validators;
            }
        });
        if (validatorsToAdd.length === 0) return props.runValidation({
            validators: defaultValidators,
            form: props.form
        });
        return props.runValidation({
            validators: [
                ...defaultValidators,
                ...validatorsToAdd
            ],
            form: props.form
        });
    };
const $6798e182eb7e6b0d$export$10851d056fe11b6a = (props)=>{
    if (!props.validators) return props.runValidation({
        validators: [],
        form: props.form
    });
    const isAsync = props.event.async;
    const onMountValidator = isAsync ? void 0 : {
        fn: props.validators.onMount,
        cause: "mount"
    };
    const onChangeValidator = {
        fn: isAsync ? props.validators.onChangeAsync : props.validators.onChange,
        cause: "change"
    };
    const onBlurValidator = {
        fn: isAsync ? props.validators.onBlurAsync : props.validators.onBlur,
        cause: "blur"
    };
    const onSubmitValidator = {
        fn: isAsync ? props.validators.onSubmitAsync : props.validators.onSubmit,
        cause: "submit"
    };
    const onServerValidator = isAsync ? void 0 : {
        fn: ()=>void 0,
        cause: "server"
    };
    switch(props.event.type){
        case "mount":
            return props.runValidation({
                validators: [
                    onMountValidator
                ],
                form: props.form
            });
        case "submit":
            return props.runValidation({
                validators: [
                    onChangeValidator,
                    onBlurValidator,
                    onSubmitValidator,
                    onServerValidator
                ],
                form: props.form
            });
        case "server":
            return props.runValidation({
                validators: [],
                form: props.form
            });
        case "blur":
            return props.runValidation({
                validators: [
                    onBlurValidator,
                    onServerValidator
                ],
                form: props.form
            });
        case "change":
            return props.runValidation({
                validators: [
                    onChangeValidator,
                    onServerValidator
                ],
                form: props.form
            });
        default:
            throw new Error(`Unknown validation event type: ${props.event.type}`);
    }
};

});

parcelRegister("8DIXq", function(module, exports) {

$parcel$export(module.exports, "standardSchemaValidators", function () { return $64a4d6d87994da9e$export$c95e1c323383105e; });
$parcel$export(module.exports, "isStandardSchemaValidator", function () { return $64a4d6d87994da9e$export$56aa5344d2a73e86; });
function $64a4d6d87994da9e$var$prefixSchemaToErrors(issues, formValue) {
    const schema = /* @__PURE__ */ new Map();
    for (const issue of issues){
        const issuePath = issue.path ?? [];
        let currentFormValue = formValue;
        let path = "";
        for(let i = 0; i < issuePath.length; i++){
            const pathSegment = issuePath[i];
            if (pathSegment === void 0) continue;
            const segment = typeof pathSegment === "object" ? pathSegment.key : pathSegment;
            const segmentAsNumber = Number(segment);
            if (Array.isArray(currentFormValue) && !Number.isNaN(segmentAsNumber)) path += `[${segmentAsNumber}]`;
            else path += (i > 0 ? "." : "") + String(segment);
            if (typeof currentFormValue === "object" && currentFormValue !== null) currentFormValue = currentFormValue[segment];
            else currentFormValue = void 0;
        }
        schema.set(path, (schema.get(path) ?? []).concat(issue));
    }
    return Object.fromEntries(schema);
}
const $64a4d6d87994da9e$var$transformFormIssues = (issues, formValue)=>{
    const schemaErrors = $64a4d6d87994da9e$var$prefixSchemaToErrors(issues, formValue);
    return {
        form: schemaErrors,
        fields: schemaErrors
    };
};
const $64a4d6d87994da9e$export$c95e1c323383105e = {
    validate ({ value: value, validationSource: validationSource }, schema) {
        const result = schema["~standard"].validate(value);
        if (result instanceof Promise) throw new Error("async function passed to sync validator");
        if (!result.issues) return;
        if (validationSource === "field") return result.issues;
        return $64a4d6d87994da9e$var$transformFormIssues(result.issues, value);
    },
    async validateAsync ({ value: value, validationSource: validationSource }, schema) {
        const result = await schema["~standard"].validate(value);
        if (!result.issues) return;
        if (validationSource === "field") return result.issues;
        return $64a4d6d87994da9e$var$transformFormIssues(result.issues, value);
    }
};
const $64a4d6d87994da9e$export$56aa5344d2a73e86 = (validator)=>!!validator && "~standard" in validator;

});

parcelRegister("d7Y8n", function(module, exports) {

$parcel$export(module.exports, "defaultFieldMeta", function () { return $98ea932c18ad285e$export$15d3e75c9fa17583; });
$parcel$export(module.exports, "metaHelper", function () { return $98ea932c18ad285e$export$a758eacc0dd44285; });
const $98ea932c18ad285e$export$15d3e75c9fa17583 = {
    isValidating: false,
    isTouched: false,
    isBlurred: false,
    isDirty: false,
    isPristine: true,
    isValid: true,
    isDefaultValue: true,
    errors: [],
    errorMap: {},
    errorSourceMap: {},
    _arrayVersion: 0,
    _pendingValidationsCount: 0
};
function $98ea932c18ad285e$export$a758eacc0dd44285(formApi) {
    function bumpArrayVersion(field) {
        const currentMeta = formApi.getFieldMeta(field) ?? $98ea932c18ad285e$export$15d3e75c9fa17583;
        formApi.setFieldMeta(field, {
            ...currentMeta,
            _arrayVersion: (currentMeta._arrayVersion || 0) + 1
        });
    }
    function handleArrayMove(field, fromIndex, toIndex) {
        bumpArrayVersion(field);
        const affectedFields = getAffectedFields(field, fromIndex, "move", toIndex);
        const startIndex = Math.min(fromIndex, toIndex);
        const endIndex = Math.max(fromIndex, toIndex);
        for(let i = startIndex; i <= endIndex; i++)affectedFields.push(getFieldPath(field, i));
        const fromFields = Object.keys(formApi.fieldInfo).reduce((fieldMap, fieldKey)=>{
            if (fieldKey.startsWith(getFieldPath(field, fromIndex))) fieldMap.set(fieldKey, formApi.getFieldMeta(fieldKey));
            return fieldMap;
        }, /* @__PURE__ */ new Map());
        shiftMeta(affectedFields, fromIndex < toIndex ? "up" : "down");
        Object.keys(formApi.fieldInfo).filter((fieldKey)=>fieldKey.startsWith(getFieldPath(field, toIndex))).forEach((fieldKey)=>{
            const fromKey = fieldKey.replace(getFieldPath(field, toIndex), getFieldPath(field, fromIndex));
            const fromMeta = fromFields.get(fromKey);
            if (fromMeta) formApi.setFieldMeta(fieldKey, fromMeta);
        });
    }
    function handleArrayRemove(field, index) {
        bumpArrayVersion(field);
        const affectedFields = getAffectedFields(field, index, "remove");
        shiftMeta(affectedFields, "up");
    }
    function handleArraySwap(field, index, secondIndex) {
        bumpArrayVersion(field);
        const affectedFields = getAffectedFields(field, index, "swap", secondIndex);
        affectedFields.forEach((fieldKey)=>{
            if (!fieldKey.toString().startsWith(getFieldPath(field, index))) return;
            const swappedKey = fieldKey.toString().replace(getFieldPath(field, index), getFieldPath(field, secondIndex));
            const [meta1, meta2] = [
                formApi.getFieldMeta(fieldKey),
                formApi.getFieldMeta(swappedKey)
            ];
            if (meta1) formApi.setFieldMeta(swappedKey, meta1);
            if (meta2) formApi.setFieldMeta(fieldKey, meta2);
        });
    }
    function handleArrayInsert(field, insertIndex) {
        bumpArrayVersion(field);
        const affectedFields = getAffectedFields(field, insertIndex, "insert");
        shiftMeta(affectedFields, "down");
        affectedFields.forEach((fieldKey)=>{
            if (fieldKey.toString().startsWith(getFieldPath(field, insertIndex))) formApi.setFieldMeta(fieldKey, getEmptyFieldMeta());
        });
    }
    function getFieldPath(field, index) {
        return `${field}[${index}]`;
    }
    function getAffectedFields(field, index, mode, secondIndex) {
        const affectedFieldKeys = [
            getFieldPath(field, index)
        ];
        switch(mode){
            case "swap":
                affectedFieldKeys.push(getFieldPath(field, secondIndex));
                break;
            case "move":
                {
                    const [startIndex, endIndex] = [
                        Math.min(index, secondIndex),
                        Math.max(index, secondIndex)
                    ];
                    for(let i = startIndex; i <= endIndex; i++)affectedFieldKeys.push(getFieldPath(field, i));
                    break;
                }
            default:
                {
                    const currentValue = formApi.getFieldValue(field);
                    const fieldItems = Array.isArray(currentValue) ? currentValue.length : 0;
                    for(let i = index + 1; i < fieldItems; i++)affectedFieldKeys.push(getFieldPath(field, i));
                    break;
                }
        }
        return Object.keys(formApi.fieldInfo).filter((fieldKey)=>affectedFieldKeys.some((key)=>fieldKey.startsWith(key)));
    }
    function updateIndex(fieldKey, direction) {
        return fieldKey.replace(/\[(\d+)\]/, (_, num)=>{
            const currIndex = parseInt(num, 10);
            const newIndex = direction === "up" ? currIndex + 1 : Math.max(0, currIndex - 1);
            return `[${newIndex}]`;
        });
    }
    function shiftMeta(fields, direction) {
        const sortedFields = direction === "up" ? fields : [
            ...fields
        ].reverse();
        sortedFields.forEach((fieldKey)=>{
            const nextFieldKey = updateIndex(fieldKey.toString(), direction);
            const nextFieldMeta = formApi.getFieldMeta(nextFieldKey);
            if (nextFieldMeta) formApi.setFieldMeta(fieldKey, nextFieldMeta);
            else formApi.setFieldMeta(fieldKey, getEmptyFieldMeta());
        });
    }
    const getEmptyFieldMeta = ()=>$98ea932c18ad285e$export$15d3e75c9fa17583;
    return {
        bumpArrayVersion: bumpArrayVersion,
        handleArrayMove: handleArrayMove,
        handleArrayRemove: handleArrayRemove,
        handleArraySwap: handleArraySwap,
        handleArrayInsert: handleArrayInsert
    };
}

});


parcelRegister("cAd5g", function(module, exports) {

$parcel$export(module.exports, "mergeAndUpdate", function () { return $9292ff09f77ae415$export$146cf9cdd3915fb1; });

var $dgHzL = parcelRequire("dgHzL");

var $5D8ug = parcelRequire("5D8ug");
function $9292ff09f77ae415$export$146cf9cdd3915fb1(form, fn) {
    if (!fn) return;
    const newObj = Object.assign({}, form, {
        state: (0, $5D8ug.deepCopy)(form.state)
    });
    fn(newObj);
    if (newObj.fieldInfo !== form.fieldInfo) form.fieldInfo = newObj.fieldInfo;
    if (newObj.options !== form.options) form.options = newObj.options;
    const baseFormKeys = Object.keys({
        values: null,
        validationMetaMap: null,
        fieldMetaBase: null,
        formGroupStateBase: null,
        isSubmitting: null,
        isSubmitted: null,
        isValidating: null,
        submissionAttempts: null,
        isSubmitSuccessful: null,
        _force_re_eval: null
    });
    const diffedObject = baseFormKeys.reduce((prev, key)=>{
        if (form.state[key] !== newObj.state[key]) prev[key] = newObj.state[key];
        return prev;
    }, {});
    (0, $dgHzL.batch)(()=>{
        if (Object.keys(diffedObject).length) form.baseStore.setState((prev)=>({
                ...prev,
                ...diffedObject
            }));
        if (newObj.state.errorMap !== form.state.errorMap) form.setErrorMap(newObj.state.errorMap);
    });
    return newObj;
}

});

parcelRegister("97PWA", function(module, exports) {

$parcel$export(module.exports, "useSelector", function () { return $6a4d0f7c717cb599$export$2105062e25df4afe; });

var $8FY87 = parcelRequire("8FY87");

var $l80b5 = parcelRequire("l80b5");
//#region src/useSelector.ts
function $6a4d0f7c717cb599$var$defaultCompare(a, b) {
    return a === b;
}
/**
* Selects a slice of state from an atom or store and subscribes the component
* to that selection.
*
* This is the primary React read hook for TanStack Store. It works with any
* source that exposes `get()` and `subscribe()`, including atoms, readonly
* atoms, stores, and readonly stores.
*
* Omit the selector to subscribe to the whole value.
*
* @example
* ```tsx
* const count = useSelector(counterStore, (state) => state.count)
* ```
*
* @example
* ```tsx
* const value = useSelector(countAtom)
* ```
*/ function $6a4d0f7c717cb599$export$2105062e25df4afe(source, selector = (s)=>s, options) {
    const compare = options?.compare ?? $6a4d0f7c717cb599$var$defaultCompare;
    const subscribe = (0, $8FY87.useCallback)((handleStoreChange)=>{
        const { unsubscribe: unsubscribe } = source.subscribe(handleStoreChange);
        return unsubscribe;
    }, [
        source
    ]);
    const getSnapshot = (0, $8FY87.useCallback)(()=>source.get(), [
        source
    ]);
    return (0, $l80b5.useSyncExternalStoreWithSelector)(subscribe, getSnapshot, getSnapshot, selector, compare);
}

});
parcelRegister("l80b5", function(module, exports) {
'use strict';

module.exports = (parcelRequire("krxcj"));

});
parcelRegister("krxcj", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $ee201498a056cebf$export$bf730a2d8bf68b42; }, function (v) { return $ee201498a056cebf$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ee201498a056cebf$export$bf730a2d8bf68b42;
"use strict";

var $8FY87 = parcelRequire("8FY87");

var $arzaR = parcelRequire("arzaR");
function $ee201498a056cebf$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $ee201498a056cebf$var$objectIs = "function" === typeof Object.is ? Object.is : $ee201498a056cebf$var$is, $ee201498a056cebf$var$useSyncExternalStore = $arzaR.useSyncExternalStore, $ee201498a056cebf$var$useRef = $8FY87.useRef, $ee201498a056cebf$var$useEffect = $8FY87.useEffect, $ee201498a056cebf$var$useMemo = $8FY87.useMemo, $ee201498a056cebf$var$useDebugValue = $8FY87.useDebugValue;
$ee201498a056cebf$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $ee201498a056cebf$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $ee201498a056cebf$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($ee201498a056cebf$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $ee201498a056cebf$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $ee201498a056cebf$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $ee201498a056cebf$var$useDebugValue(value);
    return value;
};

});
parcelRegister("arzaR", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9oiBY"));

});
parcelRegister("9oiBY", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $6d64cad06b21f189$export$306c0aa65ff9ec16; }, function (v) { return $6d64cad06b21f189$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6d64cad06b21f189$export$306c0aa65ff9ec16;
"use strict";

var $8FY87 = parcelRequire("8FY87");
function $6d64cad06b21f189$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $6d64cad06b21f189$var$objectIs = "function" === typeof Object.is ? Object.is : $6d64cad06b21f189$var$is, $6d64cad06b21f189$var$useState = $8FY87.useState, $6d64cad06b21f189$var$useEffect = $8FY87.useEffect, $6d64cad06b21f189$var$useLayoutEffect = $8FY87.useLayoutEffect, $6d64cad06b21f189$var$useDebugValue = $8FY87.useDebugValue;
function $6d64cad06b21f189$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $6d64cad06b21f189$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $6d64cad06b21f189$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $6d64cad06b21f189$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $6d64cad06b21f189$var$useEffect(function() {
        $6d64cad06b21f189$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $6d64cad06b21f189$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $6d64cad06b21f189$var$useDebugValue(value);
    return value;
}
function $6d64cad06b21f189$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$6d64cad06b21f189$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $6d64cad06b21f189$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $6d64cad06b21f189$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $6d64cad06b21f189$var$useSyncExternalStore$1 : $6d64cad06b21f189$var$useSyncExternalStore$2;
$6d64cad06b21f189$export$306c0aa65ff9ec16 = void 0 !== $8FY87.useSyncExternalStore ? $8FY87.useSyncExternalStore : $6d64cad06b21f189$var$shim;

});





parcelRegister("lSHgR", function(module, exports) {

$parcel$export(module.exports, "Field", function () { return $fee034d76235bb8d$export$a455218a85c89869; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $97PWA = parcelRequire("97PWA");

var $kq1Ta = parcelRequire("kq1Ta");
var $5D8ug = parcelRequire("5D8ug");

var $9r8W0 = parcelRequire("9r8W0");
"use client";
function $fee034d76235bb8d$export$294aa081a6c6f55d(opts) {
    const [prevOptions, setPrevOptions] = (0, $8FY87.useState)(()=>({
            form: opts.form,
            name: opts.name
        }));
    const [fieldApiState, setFieldApi] = (0, $8FY87.useState)(()=>{
        return new (0, $kq1Ta.FieldApi)({
            ...opts
        });
    });
    let fieldApi = fieldApiState;
    if (prevOptions.form !== opts.form || prevOptions.name !== opts.name) {
        fieldApi = new (0, $kq1Ta.FieldApi)({
            ...opts
        });
        setFieldApi(fieldApi);
        setPrevOptions({
            form: opts.form,
            name: opts.name
        });
    }
    const reactiveStateValue = (0, $97PWA.useSelector)(fieldApi.store, opts.mode === "array" ? (state)=>state.meta._arrayVersion || 0 : (state)=>state.value);
    const reactiveMetaIsTouched = (0, $97PWA.useSelector)(fieldApi.store, (state)=>state.meta.isTouched);
    const reactiveMetaIsBlurred = (0, $97PWA.useSelector)(fieldApi.store, (state)=>state.meta.isBlurred);
    const reactiveMetaIsDirty = (0, $97PWA.useSelector)(fieldApi.store, (state)=>state.meta.isDirty);
    const reactiveMetaErrorMap = (0, $97PWA.useSelector)(fieldApi.store, (state)=>state.meta.errorMap);
    const reactiveMetaErrorSourceMap = (0, $97PWA.useSelector)(fieldApi.store, (state)=>state.meta.errorSourceMap);
    const reactiveMetaIsValidating = (0, $97PWA.useSelector)(fieldApi.store, (state)=>state.meta.isValidating);
    const extendedFieldApi = (0, $8FY87.useMemo)(()=>{
        const reactiveFieldApi = {
            ...fieldApi,
            get state () {
                return {
                    // For array mode, reactiveStateValue is the length (for reactivity tracking),
                    // so we need to get the actual value from fieldApi
                    value: opts.mode === "array" ? fieldApi.state.value : reactiveStateValue,
                    get meta () {
                        return {
                            ...fieldApi.state.meta,
                            isTouched: reactiveMetaIsTouched,
                            isBlurred: reactiveMetaIsBlurred,
                            isDirty: reactiveMetaIsDirty,
                            errorMap: reactiveMetaErrorMap,
                            errorSourceMap: reactiveMetaErrorSourceMap,
                            isValidating: reactiveMetaIsValidating
                        };
                    }
                };
            }
        };
        const extendedApi = reactiveFieldApi;
        return extendedApi;
    }, [
        fieldApi,
        opts.mode,
        reactiveStateValue,
        reactiveMetaIsTouched,
        reactiveMetaIsBlurred,
        reactiveMetaIsDirty,
        reactiveMetaErrorMap,
        reactiveMetaErrorSourceMap,
        reactiveMetaIsValidating
    ]);
    (0, $9r8W0.useIsomorphicLayoutEffect)(fieldApi.mount, [
        fieldApi
    ]);
    (0, $9r8W0.useIsomorphicLayoutEffect)(()=>{
        fieldApi.update(opts);
    });
    return extendedFieldApi;
}
const $fee034d76235bb8d$export$a455218a85c89869 = ({ children: children, ...fieldOptions })=>{
    const fieldApi = $fee034d76235bb8d$export$294aa081a6c6f55d(fieldOptions);
    const jsxToDisplay = (0, $8FY87.useMemo)(()=>(0, $5D8ug.functionalUpdate)(children, fieldApi), [
        children,
        fieldApi
    ]);
    return /* @__PURE__ */ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: jsxToDisplay
    });
};

});
parcelRegister("kq1Ta", function(module, exports) {

$parcel$export(module.exports, "FieldApi", function () { return $edd7b36dcd654887$export$8506bfe5f1bd84e1; });

var $dgHzL = parcelRequire("dgHzL");
var $kKYCu = parcelRequire("kKYCu");

var $8DIXq = parcelRequire("8DIXq");

var $d7Y8n = parcelRequire("d7Y8n");

var $5D8ug = parcelRequire("5D8ug");

var $8TrCb = parcelRequire("8TrCb");
class $edd7b36dcd654887$export$8506bfe5f1bd84e1 {
    /**
   * Initializes a new `FieldApi` instance.
   */ constructor(opts){
        this.options = {};
        this.mount = ()=>{
            if (this.options.defaultValue !== void 0 && !this.getMeta().isTouched) this.form.setFieldValue(this.name, this.options.defaultValue, {
                dontUpdateMeta: true
            });
            const info = this.getInfo();
            info.instance = this;
            this.update(this.options);
            const { onMount: onMount } = this.options.validators || {};
            if (onMount) {
                const error = this.runValidator({
                    validate: onMount,
                    value: {
                        value: this.state.value,
                        fieldApi: this,
                        validationSource: "field"
                    },
                    type: "validate"
                });
                if (error) this.setMeta((prev)=>({
                        ...prev,
                        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                        errorMap: {
                            ...prev?.errorMap,
                            onMount: error
                        },
                        errorSourceMap: {
                            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                            ...prev?.errorSourceMap,
                            onMount: "field"
                        }
                    }));
            }
            this.options.listeners?.onMount?.({
                value: this.state.value,
                fieldApi: this
            });
            return ()=>{
                for (const [key, timeout] of Object.entries(this.timeoutIds.validations))if (timeout) {
                    clearTimeout(timeout);
                    this.timeoutIds.validations[key] = null;
                }
                for (const [key, timeout] of Object.entries(this.timeoutIds.listeners))if (timeout) {
                    clearTimeout(timeout);
                    this.timeoutIds.listeners[key] = null;
                }
                for (const [key, timeout] of Object.entries(this.timeoutIds.formListeners))if (timeout) {
                    clearTimeout(timeout);
                    this.timeoutIds.formListeners[key] = null;
                }
                const fieldInfo = this.form.fieldInfo[this.name];
                if (!fieldInfo) return;
                if (fieldInfo.instance !== this) return;
                for (const [key, validationMeta] of Object.entries(fieldInfo.validationMetaMap)){
                    validationMeta?.lastAbortController.abort();
                    fieldInfo.validationMetaMap[key] = void 0;
                }
                this.form.baseStore.setState((prev)=>({
                        // Preserve interaction flags so field-level defaultValue does not
                        // reseed user-entered values on remount.
                        ...prev,
                        fieldMetaBase: {
                            ...prev.fieldMetaBase,
                            [this.name]: {
                                ...(0, $d7Y8n.defaultFieldMeta),
                                isTouched: prev.fieldMetaBase[this.name]?.isTouched ?? (0, $d7Y8n.defaultFieldMeta).isTouched,
                                isBlurred: prev.fieldMetaBase[this.name]?.isBlurred ?? (0, $d7Y8n.defaultFieldMeta).isBlurred,
                                isDirty: prev.fieldMetaBase[this.name]?.isDirty ?? (0, $d7Y8n.defaultFieldMeta).isDirty
                            }
                        }
                    }));
                fieldInfo.instance = null;
                this.options.listeners?.onUnmount?.({
                    value: this.state.value,
                    fieldApi: this
                });
                this.form.options.listeners?.onFieldUnmount?.({
                    formApi: this.form,
                    fieldApi: this
                });
            };
        };
        this.update = (opts2)=>{
            this.options = opts2;
            this.name = opts2.name;
            if (!this.state.meta.isTouched && this.options.defaultValue !== void 0) {
                const formField = this.form.getFieldValue(this.name);
                if (!(0, $5D8ug.evaluate)(formField, opts2.defaultValue)) this.form.setFieldValue(this.name, opts2.defaultValue, {
                    dontUpdateMeta: true,
                    dontValidate: true,
                    dontRunListeners: true
                });
            }
            if (!this.form.getFieldMeta(this.name)) this.form.setFieldMeta(this.name, this.state.meta);
        };
        this.getValue = ()=>{
            return this.form.getFieldValue(this.name);
        };
        this.setValue = (updater, options)=>{
            this.form.setFieldValue(this.name, updater, (0, $5D8ug.mergeOpts)(options, {
                dontRunListeners: true,
                dontValidate: true
            }));
            if (!options?.dontRunListeners) this.triggerOnChangeListener();
            if (!options?.dontValidate) this.validate("change");
        };
        this.getMeta = ()=>this.store.state.meta;
        this.setMeta = (updater)=>this.form.setFieldMeta(this.name, updater);
        this.getInfo = ()=>this.form.getFieldInfo(this.name);
        this.pushValue = (value, options)=>{
            this.form.pushFieldValue(this.name, value, (0, $5D8ug.mergeOpts)(options, {
                dontRunListeners: true
            }));
            if (!options?.dontRunListeners) this.triggerOnChangeListener();
        };
        this.insertValue = (index, value, options)=>{
            this.form.insertFieldValue(this.name, index, value, (0, $5D8ug.mergeOpts)(options, {
                dontRunListeners: true
            }));
            if (!options?.dontRunListeners) this.triggerOnChangeListener();
        };
        this.replaceValue = (index, value, options)=>{
            this.form.replaceFieldValue(this.name, index, value, (0, $5D8ug.mergeOpts)(options, {
                dontRunListeners: true
            }));
            if (!options?.dontRunListeners) this.triggerOnChangeListener();
        };
        this.removeValue = (index, options)=>{
            this.form.removeFieldValue(this.name, index, (0, $5D8ug.mergeOpts)(options, {
                dontRunListeners: true
            }));
            if (!options?.dontRunListeners) this.triggerOnChangeListener();
        };
        this.swapValues = (aIndex, bIndex, options)=>{
            this.form.swapFieldValues(this.name, aIndex, bIndex, (0, $5D8ug.mergeOpts)(options, {
                dontRunListeners: true
            }));
            if (!options?.dontRunListeners) this.triggerOnChangeListener();
        };
        this.moveValue = (aIndex, bIndex, options)=>{
            this.form.moveFieldValues(this.name, aIndex, bIndex, (0, $5D8ug.mergeOpts)(options, {
                dontRunListeners: true
            }));
            if (!options?.dontRunListeners) this.triggerOnChangeListener();
        };
        this.clearValues = (options)=>{
            this.form.clearFieldValues(this.name, (0, $5D8ug.mergeOpts)(options, {
                dontRunListeners: true
            }));
            if (!options?.dontRunListeners) this.triggerOnChangeListener();
        };
        this.getLinkedFields = (cause)=>{
            const fields = Object.values(this.form.fieldInfo);
            const linkedFields = [];
            for (const field of fields){
                if (!field.instance) continue;
                if (!(field.instance instanceof $edd7b36dcd654887$export$8506bfe5f1bd84e1)) continue;
                const { onChangeListenTo: onChangeListenTo, onBlurListenTo: onBlurListenTo } = field.instance.options.validators || {};
                if (cause === "change" && onChangeListenTo?.includes(this.name)) linkedFields.push(field.instance);
                if (cause === "blur" && onBlurListenTo?.includes(this.name)) linkedFields.push(field.instance);
            }
            return linkedFields;
        };
        this.validateSync = (cause, errorFromForm)=>{
            const validates = (0, $5D8ug.getSyncValidatorArray)(cause, {
                ...this.options,
                form: this.form,
                fieldName: this.name,
                validationLogic: this.form.options.validationLogic || (0, $8TrCb.defaultValidationLogic)
            });
            const linkedFields = this.getLinkedFields(cause);
            const linkedFieldValidates = linkedFields.reduce((acc, field)=>{
                const fieldValidates = (0, $5D8ug.getSyncValidatorArray)(cause, {
                    ...field.options,
                    form: field.form,
                    fieldName: field.name,
                    validationLogic: field.form.options.validationLogic || (0, $8TrCb.defaultValidationLogic)
                });
                fieldValidates.forEach((validate)=>{
                    validate.field = field;
                });
                return acc.concat(fieldValidates);
            }, []);
            let hasErrored = false;
            (0, $dgHzL.batch)(()=>{
                const validateFieldFn = (field, validateObj)=>{
                    const errorMapKey = $edd7b36dcd654887$var$getErrorMapKey(validateObj.cause);
                    const fieldLevelError = validateObj.validate ? $edd7b36dcd654887$var$normalizeError(field.runValidator({
                        validate: validateObj.validate,
                        value: {
                            value: field.store.state.value,
                            validationSource: "field",
                            fieldApi: field
                        },
                        type: "validate"
                    })) : void 0;
                    const formLevelError = errorFromForm[errorMapKey];
                    const { newErrorValue: newErrorValue, newSource: newSource } = (0, $5D8ug.determineFieldLevelErrorSourceAndValue)({
                        formLevelError: formLevelError,
                        fieldLevelError: fieldLevelError
                    });
                    if (field.state.meta.errorMap?.[errorMapKey] !== newErrorValue) field.setMeta((prev)=>({
                            ...prev,
                            errorMap: {
                                ...prev.errorMap,
                                [errorMapKey]: newErrorValue
                            },
                            errorSourceMap: {
                                ...prev.errorSourceMap,
                                [errorMapKey]: newSource
                            }
                        }));
                    if (newErrorValue) hasErrored = true;
                };
                for (const validateObj of validates)validateFieldFn(this, validateObj);
                for (const fieldValitateObj of linkedFieldValidates){
                    if (!fieldValitateObj.validate) continue;
                    validateFieldFn(fieldValitateObj.field, fieldValitateObj);
                }
            });
            const submitErrKey = $edd7b36dcd654887$var$getErrorMapKey("submit");
            if (// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            this.state.meta.errorMap?.[submitErrKey] && cause !== "submit" && !hasErrored) this.setMeta((prev)=>({
                    ...prev,
                    errorMap: {
                        ...prev.errorMap,
                        [submitErrKey]: void 0
                    },
                    errorSourceMap: {
                        ...prev.errorSourceMap,
                        [submitErrKey]: void 0
                    }
                }));
            return {
                hasErrored: hasErrored
            };
        };
        this.validateAsync = async (cause, formValidationResultPromise)=>{
            const validates = (0, $5D8ug.getAsyncValidatorArray)(cause, {
                ...this.options,
                form: this.form,
                fieldName: this.name,
                validationLogic: this.form.options.validationLogic || (0, $8TrCb.defaultValidationLogic)
            });
            const asyncFormValidationResults = await formValidationResultPromise;
            const linkedFields = this.getLinkedFields(cause);
            const linkedFieldValidates = linkedFields.reduce((acc, field)=>{
                const fieldValidates = (0, $5D8ug.getAsyncValidatorArray)(cause, {
                    ...field.options,
                    form: field.form,
                    fieldName: field.name,
                    validationLogic: field.form.options.validationLogic || (0, $8TrCb.defaultValidationLogic)
                });
                fieldValidates.forEach((validate)=>{
                    validate.field = field;
                });
                return acc.concat(fieldValidates);
            }, []);
            const validatesPromises = [];
            const linkedPromises = [];
            const hasAsyncValidators = validates.some((v)=>v.validate);
            const linkedFieldsWithAsyncValidators = Array.from(new Set(linkedFieldValidates.filter((v)=>v.validate).map((v)=>v.field)));
            (0, $dgHzL.batch)(()=>{
                if (hasAsyncValidators) this.startValidation();
                for (const linkedField of linkedFieldsWithAsyncValidators)linkedField.startValidation();
            });
            const validateFieldAsyncFn = (field, validateObj, promises)=>{
                const errorMapKey = $edd7b36dcd654887$var$getErrorMapKey(validateObj.cause);
                const fieldInfo = field.getInfo();
                const fieldValidatorMeta = fieldInfo.validationMetaMap[errorMapKey];
                fieldValidatorMeta?.lastAbortController.abort();
                const controller = new AbortController();
                fieldInfo.validationMetaMap[errorMapKey] = {
                    lastAbortController: controller
                };
                promises.push(new Promise(async (resolve)=>{
                    let rawError;
                    try {
                        rawError = await new Promise((rawResolve, rawReject)=>{
                            if (field.timeoutIds.validations[validateObj.cause]) {
                                clearTimeout(field.timeoutIds.validations[validateObj.cause]);
                                field.endValidation();
                            }
                            field.timeoutIds.validations[validateObj.cause] = setTimeout(async ()=>{
                                if (controller.signal.aborted) return rawResolve(void 0);
                                try {
                                    rawResolve(await this.runValidator({
                                        validate: validateObj.validate,
                                        value: {
                                            value: field.store.state.value,
                                            fieldApi: field,
                                            signal: controller.signal,
                                            validationSource: "field"
                                        },
                                        type: "validateAsync"
                                    }));
                                } catch (e) {
                                    rawReject(e);
                                }
                            }, validateObj.debounceMs);
                        });
                    } catch (e) {
                        rawError = e;
                    }
                    if (controller.signal.aborted) return resolve(void 0);
                    const fieldLevelError = $edd7b36dcd654887$var$normalizeError(rawError);
                    const formLevelError = asyncFormValidationResults[field.name]?.[errorMapKey];
                    const { newErrorValue: newErrorValue, newSource: newSource } = (0, $5D8ug.determineFieldLevelErrorSourceAndValue)({
                        formLevelError: formLevelError,
                        fieldLevelError: fieldLevelError
                    });
                    if (field.getInfo().instance !== field) return resolve(void 0);
                    field.setMeta((prev)=>{
                        return {
                            ...prev,
                            errorMap: {
                                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                                ...prev?.errorMap,
                                [errorMapKey]: newErrorValue
                            },
                            errorSourceMap: {
                                ...prev.errorSourceMap,
                                [errorMapKey]: newSource
                            }
                        };
                    });
                    resolve(newErrorValue);
                }));
            };
            for (const validateObj of validates){
                if (!validateObj.validate) continue;
                validateFieldAsyncFn(this, validateObj, validatesPromises);
            }
            for (const fieldValitateObj of linkedFieldValidates){
                if (!fieldValitateObj.validate) continue;
                validateFieldAsyncFn(fieldValitateObj.field, fieldValitateObj, linkedPromises);
            }
            let results = [];
            if (validatesPromises.length || linkedPromises.length) {
                results = await Promise.all(validatesPromises);
                await Promise.all(linkedPromises);
            }
            (0, $dgHzL.batch)(()=>{
                if (hasAsyncValidators) this.endValidation();
                for (const linkedField of linkedFieldsWithAsyncValidators)linkedField.endValidation();
            });
            return results.filter(Boolean);
        };
        this.validate = (cause, opts2)=>{
            if (!this.state.meta.isTouched) return [];
            const encompassingGroups = opts2?.skipGroupValidation ? [] : Array.from(this.form.formGroupApis).filter((group)=>this.name.startsWith(group.name));
            const formSyncResult = opts2?.skipFormValidation ? {
                fieldsErrorMap: {}
            } : this.form.validateSync(cause);
            let fieldsErrorMap = formSyncResult.fieldsErrorMap[this.name] ?? {};
            if (!opts2?.skipFormValidation) for (const group of encompassingGroups){
                if (group.state.meta.submissionAttempts === 0) continue;
                const { fieldsErrorMap: groupFormErrors } = this.form.validateSync(cause, {
                    group: group,
                    dontUpdateFormErrorMap: true,
                    filterFieldNames: (fieldName)=>(0, $5D8ug.isFieldInGroup)(group.name, fieldName)
                });
                fieldsErrorMap = {
                    ...fieldsErrorMap,
                    ...groupFormErrors[this.name] ?? {}
                };
            }
            const { hasErrored: hasErrored } = this.validateSync(cause, fieldsErrorMap);
            const groupHasErroredWeakMap = /* @__PURE__ */ new WeakMap();
            for (const group of encompassingGroups){
                const { hasErrored: groupHasErrored } = group.validateSync(cause, {}, {
                    skipRelatedFieldValidation: true
                });
                groupHasErroredWeakMap.set(group, groupHasErrored);
            }
            if (hasErrored && !this.options.asyncAlways) {
                this.getInfo().validationMetaMap[$edd7b36dcd654887$var$getErrorMapKey(cause)]?.lastAbortController.abort();
                const groupErrors = [];
                for (const group of encompassingGroups){
                    group.getInfo().validationMetaMap[$edd7b36dcd654887$var$getErrorMapKey(cause)]?.lastAbortController.abort();
                    groupErrors.push(group.state.meta.errors);
                }
                return [
                    ...this.state.meta.errors,
                    ...groupErrors.flat()
                ];
            }
            const formValidationResultPromise = opts2?.skipFormValidation ? Promise.resolve({}) : this.form.validateAsync(cause);
            const fieldAsyncResults = this.validateAsync(cause, formValidationResultPromise);
            const groupAsyncResults = [];
            for (const group of encompassingGroups){
                if (groupHasErroredWeakMap.get(group) && !group.options.asyncAlways) continue;
                groupAsyncResults.push(group.validateAsync(cause, formValidationResultPromise, {
                    skipRelatedFieldValidation: true
                }));
            }
            if (groupAsyncResults.length === 0) return fieldAsyncResults;
            return Promise.all([
                fieldAsyncResults,
                ...groupAsyncResults
            ]).then((results)=>results.flat());
        };
        this.handleChange = (updater)=>{
            this.setValue(updater);
        };
        this.handleBlur = ()=>{
            const prevTouched = this.state.meta.isTouched;
            if (!prevTouched) this.setMeta((prev)=>({
                    ...prev,
                    isTouched: true
                }));
            if (!this.state.meta.isBlurred) this.setMeta((prev)=>({
                    ...prev,
                    isBlurred: true
                }));
            this.validate("blur");
            this.triggerOnBlurListener();
        };
        this.setErrorMap = (errorMap)=>{
            this.setMeta((prev)=>({
                    ...prev,
                    errorMap: {
                        ...prev.errorMap,
                        ...errorMap
                    }
                }));
        };
        this.parseValueWithSchema = (schema)=>{
            return (0, $8DIXq.standardSchemaValidators).validate({
                value: this.state.value,
                validationSource: "field"
            }, schema);
        };
        this.parseValueWithSchemaAsync = (schema)=>{
            return (0, $8DIXq.standardSchemaValidators).validateAsync({
                value: this.state.value,
                validationSource: "field"
            }, schema);
        };
        this.triggerOnBlurListener = ()=>{
            const formDebounceMs = this.form.options.listeners?.onBlurDebounceMs;
            if (formDebounceMs && formDebounceMs > 0) {
                if (this.timeoutIds.formListeners.blur) clearTimeout(this.timeoutIds.formListeners.blur);
                this.timeoutIds.formListeners.blur = setTimeout(()=>{
                    this.form.options.listeners?.onBlur?.({
                        formApi: this.form,
                        fieldApi: this
                    });
                }, formDebounceMs);
            } else this.form.options.listeners?.onBlur?.({
                formApi: this.form,
                fieldApi: this
            });
            const fieldDebounceMs = this.options.listeners?.onBlurDebounceMs;
            if (fieldDebounceMs && fieldDebounceMs > 0) {
                if (this.timeoutIds.listeners.blur) clearTimeout(this.timeoutIds.listeners.blur);
                this.timeoutIds.listeners.blur = setTimeout(()=>{
                    this.options.listeners?.onBlur?.({
                        value: this.state.value,
                        fieldApi: this
                    });
                }, fieldDebounceMs);
            } else this.options.listeners?.onBlur?.({
                value: this.state.value,
                fieldApi: this
            });
        };
        this.triggerOnChangeListener = ()=>{
            const formDebounceMs = this.form.options.listeners?.onChangeDebounceMs;
            if (formDebounceMs && formDebounceMs > 0) {
                if (this.timeoutIds.formListeners.change) clearTimeout(this.timeoutIds.formListeners.change);
                this.timeoutIds.formListeners.change = setTimeout(()=>{
                    this.form.options.listeners?.onChange?.({
                        formApi: this.form,
                        fieldApi: this
                    });
                }, formDebounceMs);
            } else this.form.options.listeners?.onChange?.({
                formApi: this.form,
                fieldApi: this
            });
            const fieldDebounceMs = this.options.listeners?.onChangeDebounceMs;
            if (fieldDebounceMs && fieldDebounceMs > 0) {
                if (this.timeoutIds.listeners.change) clearTimeout(this.timeoutIds.listeners.change);
                this.timeoutIds.listeners.change = setTimeout(()=>{
                    this.options.listeners?.onChange?.({
                        value: this.state.value,
                        fieldApi: this
                    });
                }, fieldDebounceMs);
            } else this.options.listeners?.onChange?.({
                value: this.state.value,
                fieldApi: this
            });
            for (const group of this.form.formGroupApis)if ((0, $5D8ug.isFieldInGroup)(group.name, this.name)) group.triggerOnChangeListener();
        };
        this.triggerOnSubmitListener = ()=>{
            this.options.listeners?.onSubmit?.({
                value: this.state.value,
                fieldApi: this
            });
        };
        this.form = opts.form;
        this.name = opts.name;
        this.options = opts;
        this.timeoutIds = {
            validations: {},
            listeners: {},
            formListeners: {}
        };
        this.store = (0, $kKYCu.createStore)((prevVal)=>{
            this.form.store.get();
            const meta = this.form.getFieldMeta(this.name) ?? {
                ...(0, $d7Y8n.defaultFieldMeta),
                ...opts.defaultMeta
            };
            let value = this.form.getFieldValue(this.name);
            if (!meta.isTouched && value === void 0 && this.options.defaultValue !== void 0 && !(0, $5D8ug.evaluate)(value, this.options.defaultValue)) value = this.options.defaultValue;
            if (prevVal && prevVal.value === value && prevVal.meta === meta) return prevVal;
            return {
                value: value,
                meta: meta
            };
        });
    }
    /**
   * The current field state.
   */ get state() {
        return this.store.state;
    }
    /**
   * @private
   */ runValidator(props) {
        if ((0, $8DIXq.isStandardSchemaValidator)(props.validate)) return (0, $8DIXq.standardSchemaValidators)[props.type](props.value, props.validate);
        return props.validate(props.value);
    }
    /**
   * `@private`
   * Starts tracking an async validation, incrementing the counter and setting isValidating if needed.
   */ startValidation() {
        this.setMeta((prev)=>{
            const newCount = prev._pendingValidationsCount + 1;
            return {
                ...prev,
                _pendingValidationsCount: newCount,
                isValidating: newCount > 0 && !prev.isValidating ? true : prev.isValidating
            };
        });
    }
    /**
   * `@private`
   * Ends tracking an async validation, decrementing the counter and clearing isValidating if no validations remain.
   */ endValidation() {
        this.setMeta((prev)=>{
            const newCount = Math.max(0, prev._pendingValidationsCount - 1);
            return {
                ...prev,
                _pendingValidationsCount: newCount,
                isValidating: newCount === 0 && prev.isValidating ? false : prev.isValidating
            };
        });
    }
}
function $edd7b36dcd654887$var$normalizeError(rawError) {
    if (rawError) return rawError;
    return void 0;
}
function $edd7b36dcd654887$var$getErrorMapKey(cause) {
    switch(cause){
        case "submit":
            return "onSubmit";
        case "blur":
            return "onBlur";
        case "mount":
            return "onMount";
        case "server":
            return "onServer";
        case "dynamic":
            return "onDynamic";
        case "change":
        default:
            return "onChange";
    }
}

});

parcelRegister("9r8W0", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $6ded90e28d3029c1$export$700979bc83e7db82; });

var $8FY87 = parcelRequire("8FY87");
const $6ded90e28d3029c1$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $8FY87.useLayoutEffect) : (0, $8FY87.useEffect);

});


parcelRegister("aCiHk", function(module, exports) {

$parcel$export(module.exports, "useFormId", function () { return $7babf4fd4a9396a1$export$900b9a43fd4d5ea2; });

var $8FY87 = parcelRequire("8FY87");

var $5EX3y = parcelRequire("5EX3y");
const $7babf4fd4a9396a1$var$_React = $8FY87;
const $7babf4fd4a9396a1$export$900b9a43fd4d5ea2 = $8FY87.version.split(".")[0] === "17" ? (0, $5EX3y.useUUID) : $7babf4fd4a9396a1$var$_React.useId;

});
parcelRegister("5EX3y", function(module, exports) {

$parcel$export(module.exports, "useUUID", function () { return $41ee7f8415d69d81$export$b53193151b894db6; });

var $8FY87 = parcelRequire("8FY87");

var $5D8ug = parcelRequire("5D8ug");
function $41ee7f8415d69d81$export$b53193151b894db6() {
    return (0, $8FY87.useState)(()=>(0, $5D8ug.uuid)())[0];
}

});


parcelRegister("iaJCr", function(module, exports) {

$parcel$export(module.exports, "FormGroup", function () { return $d3ac8c2846a62ed6$export$2d00230e1e6f7fbc; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $97PWA = parcelRequire("97PWA");

var $d0V05 = parcelRequire("d0V05");
var $5D8ug = parcelRequire("5D8ug");

var $9r8W0 = parcelRequire("9r8W0");
"use client";
function $d3ac8c2846a62ed6$export$f60f091fde508dd2(opts) {
    const [prevOptions, setPrevOptions] = (0, $8FY87.useState)(()=>({
            form: opts.form,
            name: opts.name
        }));
    const [formGroupApi, setFormGroupApi] = (0, $8FY87.useState)(()=>{
        return new (0, $d0V05.FormGroupApi)({
            ...opts
        });
    });
    if (prevOptions.form !== opts.form || prevOptions.name !== opts.name) {
        setFormGroupApi(new (0, $d0V05.FormGroupApi)({
            ...opts
        }));
        setPrevOptions({
            form: opts.form,
            name: opts.name
        });
    }
    const reactiveStateValue = (0, $97PWA.useSelector)(formGroupApi.store, (state)=>state.value);
    const reactiveMetaIsTouched = (0, $97PWA.useSelector)(formGroupApi.store, (state)=>state.meta.isTouched);
    const reactiveMetaIsBlurred = (0, $97PWA.useSelector)(formGroupApi.store, (state)=>state.meta.isBlurred);
    const reactiveMetaIsDirty = (0, $97PWA.useSelector)(formGroupApi.store, (state)=>state.meta.isDirty);
    const reactiveMetaErrorMap = (0, $97PWA.useSelector)(formGroupApi.store, (state)=>state.meta.errorMap);
    const reactiveMetaErrorSourceMap = (0, $97PWA.useSelector)(formGroupApi.store, (state)=>state.meta.errorSourceMap);
    const reactiveMetaIsValidating = (0, $97PWA.useSelector)(formGroupApi.store, (state)=>state.meta.isValidating);
    const reactiveMetaIsSubmitting = (0, $97PWA.useSelector)(formGroupApi.store, (state)=>state.meta.isSubmitting);
    const reactiveMetaIsSubmitted = (0, $97PWA.useSelector)(formGroupApi.store, (state)=>state.meta.isSubmitted);
    const reactiveMetaSubmissionAttempts = (0, $97PWA.useSelector)(formGroupApi.store, (state)=>state.meta.submissionAttempts);
    const reactiveMetaIsSubmitSuccessful = (0, $97PWA.useSelector)(formGroupApi.store, (state)=>state.meta.isSubmitSuccessful);
    const reactiveMetaCanSubmit = (0, $97PWA.useSelector)(formGroupApi.store, (state)=>state.meta.canSubmit);
    const reactiveMetaIsValid = (0, $97PWA.useSelector)(formGroupApi.store, (state)=>state.meta.isValid);
    const reactiveMetaIsFieldsValid = (0, $97PWA.useSelector)(formGroupApi.store, (state)=>state.meta.isFieldsValid);
    const reactiveMetaIsFieldsValidating = (0, $97PWA.useSelector)(formGroupApi.store, (state)=>state.meta.isFieldsValidating);
    const reactiveMetaIsGroupValid = (0, $97PWA.useSelector)(formGroupApi.store, (state)=>state.meta.isGroupValid);
    const extendedFieldApi = (0, $8FY87.useMemo)(()=>{
        const reactiveFieldApi = {
            ...formGroupApi,
            handleSubmit: (...props)=>{
                return formGroupApi._handleSubmit(...props);
            },
            get state () {
                return {
                    ...formGroupApi.state,
                    value: reactiveStateValue,
                    get meta () {
                        return {
                            ...formGroupApi.state.meta,
                            isTouched: reactiveMetaIsTouched,
                            isBlurred: reactiveMetaIsBlurred,
                            isDirty: reactiveMetaIsDirty,
                            errorMap: reactiveMetaErrorMap,
                            errorSourceMap: reactiveMetaErrorSourceMap,
                            isValidating: reactiveMetaIsValidating,
                            isSubmitting: reactiveMetaIsSubmitting,
                            isSubmitted: reactiveMetaIsSubmitted,
                            submissionAttempts: reactiveMetaSubmissionAttempts,
                            isSubmitSuccessful: reactiveMetaIsSubmitSuccessful,
                            canSubmit: reactiveMetaCanSubmit,
                            isValid: reactiveMetaIsValid,
                            isFieldsValid: reactiveMetaIsFieldsValid,
                            isFieldsValidating: reactiveMetaIsFieldsValidating,
                            isGroupValid: reactiveMetaIsGroupValid
                        };
                    }
                };
            }
        };
        const extendedApi = reactiveFieldApi;
        return extendedApi;
    }, [
        formGroupApi,
        reactiveStateValue,
        reactiveMetaIsTouched,
        reactiveMetaIsBlurred,
        reactiveMetaIsDirty,
        reactiveMetaErrorMap,
        reactiveMetaErrorSourceMap,
        reactiveMetaIsValidating,
        reactiveMetaIsSubmitting,
        reactiveMetaIsSubmitted,
        reactiveMetaSubmissionAttempts,
        reactiveMetaIsSubmitSuccessful,
        reactiveMetaCanSubmit,
        reactiveMetaIsValid,
        reactiveMetaIsFieldsValid,
        reactiveMetaIsFieldsValidating,
        reactiveMetaIsGroupValid
    ]);
    (0, $9r8W0.useIsomorphicLayoutEffect)(formGroupApi.mount, [
        formGroupApi
    ]);
    (0, $9r8W0.useIsomorphicLayoutEffect)(()=>{
        formGroupApi.update(opts);
    });
    return extendedFieldApi;
}
const $d3ac8c2846a62ed6$export$2d00230e1e6f7fbc = ({ children: children, ...formGroupOptions })=>{
    const formGroupApi = $d3ac8c2846a62ed6$export$f60f091fde508dd2(formGroupOptions);
    const jsxToDisplay = (0, $8FY87.useMemo)(()=>(0, $5D8ug.functionalUpdate)(children, formGroupApi), [
        children,
        formGroupApi
    ]);
    return /* @__PURE__ */ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: jsxToDisplay
    });
};

});
parcelRegister("d0V05", function(module, exports) {

$parcel$export(module.exports, "FormGroupApi", function () { return $97977d866b6010ce$export$3f64748c3c0187ed; });

var $dgHzL = parcelRequire("dgHzL");
var $kKYCu = parcelRequire("kKYCu");

var $5D8ug = parcelRequire("5D8ug");

var $8TrCb = parcelRequire("8TrCb");

var $8DIXq = parcelRequire("8DIXq");

var $d7Y8n = parcelRequire("d7Y8n");

var $kq1Ta = parcelRequire("kq1Ta");
function $97977d866b6010ce$var$getDefaultFormGroupState(defaultState) {
    return {
        isSubmitted: defaultState.isSubmitted ?? false,
        isSubmitting: defaultState.isSubmitting ?? false,
        isValidating: defaultState.isValidating ?? false,
        submissionAttempts: defaultState.submissionAttempts ?? 0,
        isSubmitSuccessful: defaultState.isSubmitSuccessful ?? false
    };
}
function $97977d866b6010ce$export$68e3c7fb549fd7b8(defaultMeta) {
    return {
        ...(0, $d7Y8n.defaultFieldMeta),
        ...defaultMeta,
        errors: [],
        isPristine: true,
        isValid: true,
        isDefaultValue: true,
        isFieldsValidating: false,
        isFieldsValid: true,
        isGroupValid: true,
        canSubmit: true,
        isSubmitting: false,
        isSubmitted: false,
        isValidating: false,
        submissionAttempts: 0,
        isSubmitSuccessful: false
    };
}
class $97977d866b6010ce$export$3f64748c3c0187ed {
    constructor(opts){
        this.options = {};
        this.setFormGroupState = (updater)=>{
            this.form.baseStore.setState((prev)=>{
                const prevGroupState = prev.formGroupStateBase[this.name] ?? $97977d866b6010ce$var$getDefaultFormGroupState({});
                return {
                    ...prev,
                    formGroupStateBase: {
                        ...prev.formGroupStateBase,
                        [this.name]: updater(prevGroupState)
                    }
                };
            });
        };
        this._lastDistributedFieldNames = {};
        this.update = (opts2)=>{
            this.options = opts2;
            this.name = opts2.name;
            if (!this.state.meta.isTouched && this.options.defaultValue !== void 0) {
                const formField = this.form.getFieldValue(this.name);
                if (!(0, $5D8ug.evaluate)(formField, opts2.defaultValue)) this.form.setFieldValue(this.name, opts2.defaultValue, {
                    dontUpdateMeta: true,
                    dontValidate: true,
                    dontRunListeners: true
                });
            }
            if (!this.form.getFieldMeta(this.name)) this.form.setFieldMeta(this.name, {
                ...(0, $d7Y8n.defaultFieldMeta),
                ...this.options.defaultMeta
            });
        };
        this.mount = ()=>{
            this.update(this.options);
            this.form.formGroupApis.add(this);
            this.fieldInfo.instance = this;
            this.form.baseStore.setState((prev)=>({
                    ...prev,
                    formGroupStateBase: {
                        ...prev.formGroupStateBase,
                        [this.name]: prev.formGroupStateBase[this.name] ?? $97977d866b6010ce$var$getDefaultFormGroupState({
                            ...this.options.defaultState
                        })
                    }
                }));
            const { onMount: onMount } = this.options.validators || {};
            if (onMount) {
                const rawError = this.runValidator({
                    validate: onMount,
                    value: {
                        value: this.state.value,
                        groupApi: this,
                        validationSource: "form"
                    },
                    type: "validate"
                });
                let groupOwnRawError = rawError;
                let groupFieldErrors = void 0;
                if ($97977d866b6010ce$var$isGlobalGroupValidationError(rawError)) {
                    groupOwnRawError = rawError.group;
                    groupFieldErrors = rawError.fields;
                }
                const error = $97977d866b6010ce$var$normalizeError(groupOwnRawError);
                if (error) this.setMeta((prev)=>({
                        ...prev,
                        errorMap: {
                            ...prev.errorMap,
                            onMount: error
                        },
                        errorSourceMap: {
                            ...prev.errorSourceMap,
                            onMount: "field"
                        }
                    }));
                this.distributeFieldErrors("onMount", groupFieldErrors);
            }
            this.options.listeners?.onMount?.({
                value: this.state.value,
                groupApi: this
            });
            return ()=>{
                for (const [key, timeout] of Object.entries(this.timeoutIds.validations))if (timeout) {
                    clearTimeout(timeout);
                    this.timeoutIds.validations[key] = null;
                }
                for (const [key, timeout] of Object.entries(this.timeoutIds.listeners))if (timeout) {
                    clearTimeout(timeout);
                    this.timeoutIds.listeners[key] = null;
                }
                for (const [key, timeout] of Object.entries(this.timeoutIds.formListeners))if (timeout) {
                    clearTimeout(timeout);
                    this.timeoutIds.formListeners[key] = null;
                }
                if (this.fieldInfo.instance !== this) return;
                for (const [key, validationMeta] of Object.entries(this.fieldInfo.validationMetaMap)){
                    validationMeta?.lastAbortController.abort();
                    this.fieldInfo.validationMetaMap[key] = void 0;
                }
                this.form.formGroupApis.delete(this);
                this.form.baseStore.setState((prev)=>({
                        ...prev,
                        formGroupStateBase: {
                            ...prev.formGroupStateBase,
                            [this.name]: $97977d866b6010ce$var$getDefaultFormGroupState({})
                        }
                    }));
                this.fieldInfo.instance = null;
                this.options.listeners?.onUnmount?.({
                    value: this.state.value,
                    groupApi: this
                });
            };
        };
        this.setValue = (updater, options)=>{
            this.form.setFieldValue(this.name, updater, (0, $5D8ug.mergeOpts)(options, {
                dontRunListeners: true,
                dontValidate: true
            }));
            if (!options?.dontRunListeners) this.triggerOnChangeListener();
            if (!options?.dontValidate) this.validate("change");
        };
        this.getMeta = ()=>this.store.state.meta;
        this.setMeta = (updater)=>this.form.setFieldMeta(this.name, updater);
        this.getInfo = ()=>this.fieldInfo;
        this.getRelatedFields = ()=>{
            const fields = Object.values(this.form.fieldInfo);
            const relatedFields = [];
            for (const field of fields){
                if (!field.instance) continue;
                if (!(field.instance instanceof (0, $kq1Ta.FieldApi))) continue;
                if (field.instance.name.startsWith(this.name)) relatedFields.push(field.instance);
            }
            return relatedFields;
        };
        this.getRelatedFieldMetasDerived = ()=>{
            const fields = Object.entries(this.form.fieldMetaDerived.state);
            const relatedFieldMetas = [];
            for (const [fieldName, fieldMeta] of fields){
                if (fieldName === this.name) continue;
                if ((0, $5D8ug.isFieldInGroup)(this.name, fieldName)) relatedFieldMetas.push({
                    ...fieldMeta,
                    name: fieldName
                });
            }
            return relatedFieldMetas;
        };
        this.buildChildFieldName = (relativeName)=>{
            if (relativeName === "") return this.name;
            if (relativeName.startsWith("[")) return `${this.name}${relativeName}`;
            return `${this.name}.${relativeName}`;
        };
        this.distributeFieldErrors = (errorMapKey, fieldErrors)=>{
            const previousNames = this._lastDistributedFieldNames[errorMapKey] ?? /* @__PURE__ */ new Set();
            const currentNames = /* @__PURE__ */ new Set();
            if (fieldErrors) for (const [relativeName, err] of Object.entries(fieldErrors)){
                if (err === void 0 || err === null || err === false) continue;
                currentNames.add(this.buildChildFieldName(relativeName));
            }
            const allNames = /* @__PURE__ */ new Set([
                ...previousNames,
                ...currentNames
            ]);
            let hasErrored = false;
            for (const fullName of allNames){
                const relativeName = fullName.startsWith(this.name + "[") ? fullName.slice(this.name.length) : fullName.slice(this.name.length + 1);
                const newFormValidatorError = fieldErrors?.[relativeName];
                const fieldMeta = this.form.getFieldMeta(fullName);
                if (!fieldMeta && !newFormValidatorError) continue;
                const previousErrorValue = fieldMeta?.errorMap[errorMapKey];
                const isPreviousErrorFromFormValidator = fieldMeta?.errorSourceMap[errorMapKey] === "form";
                const { newErrorValue: newErrorValue, newSource: newSource } = (0, $5D8ug.determineFormLevelErrorSourceAndValue)({
                    newFormValidatorError: newFormValidatorError,
                    isPreviousErrorFromFormValidator: isPreviousErrorFromFormValidator,
                    previousErrorValue: previousErrorValue
                });
                if (newErrorValue) hasErrored = true;
                if (previousErrorValue === newErrorValue && fieldMeta?.errorSourceMap[errorMapKey] === newSource) continue;
                this.form.setFieldMeta(fullName, (prev = (0, $d7Y8n.defaultFieldMeta))=>({
                        ...prev,
                        errorMap: {
                            ...prev.errorMap,
                            [errorMapKey]: newErrorValue
                        },
                        errorSourceMap: {
                            ...prev.errorSourceMap,
                            [errorMapKey]: newSource
                        }
                    }));
            }
            this._lastDistributedFieldNames[errorMapKey] = currentNames;
            return hasErrored;
        };
        this.validateSync = (cause, errorFromForm, opts2 = {})=>{
            const validates = (0, $5D8ug.getSyncValidatorArray)(cause, {
                ...this.options,
                form: this.form,
                group: this,
                validationLogic: this.options.validationLogic || this.form.options.validationLogic || (0, $8TrCb.defaultValidationLogic)
            });
            const relatedFields = opts2.skipRelatedFieldValidation ? [] : this.getRelatedFields();
            const relatedFieldValidates = relatedFields.reduce((acc, field)=>{
                const fieldValidates = (0, $5D8ug.getSyncValidatorArray)(cause, {
                    ...field.options,
                    form: field.form,
                    validationLogic: field.form.options.validationLogic || (0, $8TrCb.defaultValidationLogic)
                });
                fieldValidates.forEach((validate)=>{
                    validate.field = field;
                });
                return acc.concat(fieldValidates);
            }, []);
            let hasErrored = false;
            (0, $dgHzL.batch)(()=>{
                const validateFieldOrGroupFn = (fieldOrGroup, validateObj)=>{
                    const errorMapKey = $97977d866b6010ce$var$getErrorMapKey(validateObj.cause);
                    const isGroup = fieldOrGroup === this;
                    let rawError = void 0;
                    if (validateObj.validate) rawError = fieldOrGroup.runValidator({
                        validate: validateObj.validate,
                        value: {
                            value: fieldOrGroup.store.state.value,
                            // For the group's own validators we want standard schemas to
                            // produce a `{ form, fields }` shape (with relative keys) so
                            // we can fan errors out to children. Field-level validators on
                            // related fields keep the regular field source.
                            validationSource: isGroup ? "form" : "field",
                            ...fieldOrGroup instanceof $97977d866b6010ce$export$3f64748c3c0187ed ? {
                                groupApi: fieldOrGroup
                            } : {
                                fieldApi: fieldOrGroup
                            }
                        },
                        type: "validate"
                    });
                    let groupOwnRawError = rawError;
                    let groupFieldErrors = void 0;
                    if (isGroup && $97977d866b6010ce$var$isGlobalGroupValidationError(rawError)) {
                        groupOwnRawError = rawError.group;
                        groupFieldErrors = rawError.fields;
                    }
                    const fieldLevelError = $97977d866b6010ce$var$normalizeError(groupOwnRawError);
                    const formLevelError = errorFromForm[errorMapKey];
                    const { newErrorValue: newErrorValue, newSource: newSource } = (0, $5D8ug.determineFieldLevelErrorSourceAndValue)({
                        formLevelError: formLevelError,
                        fieldLevelError: fieldLevelError
                    });
                    if (fieldOrGroup.state.meta.errorMap?.[errorMapKey] !== newErrorValue) fieldOrGroup.setMeta((prev)=>({
                            ...prev,
                            errorMap: {
                                ...prev.errorMap,
                                [errorMapKey]: newErrorValue
                            },
                            errorSourceMap: {
                                ...prev.errorSourceMap,
                                [errorMapKey]: newSource
                            }
                        }));
                    if (newErrorValue) hasErrored = true;
                    if (isGroup) {
                        const distributedHasErrored = this.distributeFieldErrors(errorMapKey, groupFieldErrors);
                        if (distributedHasErrored) hasErrored = true;
                    }
                };
                for (const validateObj of validates)validateFieldOrGroupFn(this, validateObj);
                for (const fieldValidateObj of relatedFieldValidates){
                    if (!fieldValidateObj.validate) continue;
                    validateFieldOrGroupFn(fieldValidateObj.field, fieldValidateObj);
                }
            });
            const submitErrKey = $97977d866b6010ce$var$getErrorMapKey("submit");
            if (// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            this.state.meta.errorMap?.[submitErrKey] && cause !== "submit" && !hasErrored) this.setMeta((prev)=>({
                    ...prev,
                    errorMap: {
                        ...prev.errorMap,
                        [submitErrKey]: void 0
                    },
                    errorSourceMap: {
                        ...prev.errorSourceMap,
                        [submitErrKey]: void 0
                    }
                }));
            return {
                hasErrored: hasErrored
            };
        };
        this.validateAsync = async (cause, formValidationResultPromise, opts2 = {})=>{
            const validates = (0, $5D8ug.getAsyncValidatorArray)(cause, {
                ...this.options,
                form: this.form,
                group: this,
                validationLogic: this.options.validationLogic || this.form.options.validationLogic || (0, $8TrCb.defaultValidationLogic)
            });
            const asyncFormValidationResults = await formValidationResultPromise;
            const relatedFields = opts2.skipRelatedFieldValidation ? [] : this.getRelatedFields();
            const relatedFieldValidates = relatedFields.reduce((acc, field)=>{
                const fieldValidates = (0, $5D8ug.getAsyncValidatorArray)(cause, {
                    ...field.options,
                    form: field.form,
                    validationLogic: field.form.options.validationLogic || (0, $8TrCb.defaultValidationLogic)
                });
                fieldValidates.forEach((validate)=>{
                    validate.field = field;
                });
                return acc.concat(fieldValidates);
            }, []);
            const validatesPromises = [];
            const linkedPromises = [];
            const hasAsyncValidators = validates.some((v)=>v.validate) || relatedFieldValidates.some((v)=>v.validate);
            if (hasAsyncValidators) {
                if (!this.state.meta.isValidating) this.setMeta((prev)=>({
                        ...prev,
                        isValidating: true
                    }));
                for (const linkedField of relatedFields)linkedField.setMeta((prev)=>({
                        ...prev,
                        isValidating: true
                    }));
            }
            const validateFieldOrGroupAsyncFn = (fieldOrGroup, validateObj, promises)=>{
                const errorMapKey = $97977d866b6010ce$var$getErrorMapKey(validateObj.cause);
                const fieldInfo = fieldOrGroup.getInfo();
                const fieldValidatorMeta = fieldInfo.validationMetaMap[errorMapKey];
                fieldValidatorMeta?.lastAbortController.abort();
                const controller = new AbortController();
                fieldInfo.validationMetaMap[errorMapKey] = {
                    lastAbortController: controller
                };
                const isGroup = fieldOrGroup === this;
                promises.push(new Promise(async (resolve)=>{
                    let rawError;
                    try {
                        rawError = await new Promise((rawResolve, rawReject)=>{
                            if (fieldOrGroup.timeoutIds.validations[validateObj.cause]) clearTimeout(fieldOrGroup.timeoutIds.validations[validateObj.cause]);
                            fieldOrGroup.timeoutIds.validations[validateObj.cause] = setTimeout(async ()=>{
                                if (controller.signal.aborted) return rawResolve(void 0);
                                try {
                                    rawResolve(await this.runValidator({
                                        validate: validateObj.validate,
                                        value: {
                                            value: fieldOrGroup.store.state.value,
                                            signal: controller.signal,
                                            // See sync counterpart: produce `{ form, fields }`
                                            // from standard schemas attached to the group so we
                                            // can fan errors out to children.
                                            validationSource: isGroup ? "form" : "field",
                                            ...fieldOrGroup instanceof $97977d866b6010ce$export$3f64748c3c0187ed ? {
                                                groupApi: fieldOrGroup
                                            } : {
                                                fieldApi: fieldOrGroup
                                            }
                                        },
                                        type: "validateAsync"
                                    }));
                                } catch (e) {
                                    rawReject(e);
                                }
                            }, validateObj.debounceMs);
                        });
                    } catch (e) {
                        rawError = e;
                    }
                    if (controller.signal.aborted) return resolve(void 0);
                    let groupOwnRawError = rawError;
                    let groupFieldErrors = void 0;
                    if (isGroup && $97977d866b6010ce$var$isGlobalGroupValidationError(rawError)) {
                        groupOwnRawError = rawError.group;
                        groupFieldErrors = rawError.fields;
                    }
                    const fieldLevelError = $97977d866b6010ce$var$normalizeError(groupOwnRawError);
                    const formLevelError = asyncFormValidationResults[fieldOrGroup.name]?.[errorMapKey];
                    const { newErrorValue: newErrorValue, newSource: newSource } = (0, $5D8ug.determineFieldLevelErrorSourceAndValue)({
                        formLevelError: formLevelError,
                        fieldLevelError: fieldLevelError
                    });
                    if (fieldOrGroup.getInfo().instance !== fieldOrGroup) return resolve(void 0);
                    fieldOrGroup.setMeta((prev)=>{
                        return {
                            ...prev,
                            errorMap: {
                                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                                ...prev?.errorMap,
                                [errorMapKey]: newErrorValue
                            },
                            errorSourceMap: {
                                ...prev.errorSourceMap,
                                [errorMapKey]: newSource
                            }
                        };
                    });
                    if (isGroup) this.distributeFieldErrors(errorMapKey, groupFieldErrors);
                    resolve(newErrorValue);
                }));
            };
            for (const validateObj of validates){
                if (!validateObj.validate) continue;
                validateFieldOrGroupAsyncFn(this, validateObj, validatesPromises);
            }
            for (const fieldValitateObj of relatedFieldValidates){
                if (!fieldValitateObj.validate) continue;
                validateFieldOrGroupAsyncFn(fieldValitateObj.field, fieldValitateObj, linkedPromises);
            }
            let results = [];
            if (validatesPromises.length || linkedPromises.length) {
                results = await Promise.all(validatesPromises);
                await Promise.all(linkedPromises);
            }
            if (hasAsyncValidators) {
                this.setMeta((prev)=>({
                        ...prev,
                        isValidating: false
                    }));
                for (const linkedField of relatedFields)linkedField.setMeta((prev)=>({
                        ...prev,
                        isValidating: false
                    }));
            }
            return results.filter(Boolean);
        };
        this.validateAllFields = async (cause)=>{
            const fieldValidationPromises = [];
            (0, $dgHzL.batch)(()=>{
                Object.values(this.getRelatedFields()).forEach((fieldInstance)=>{
                    fieldValidationPromises.push(// Remember, `validate` is either a sync operation or a promise
                    Promise.resolve().then(()=>fieldInstance.validate(cause, {
                            skipFormValidation: true,
                            skipGroupValidation: true
                        })));
                    if (!fieldInstance.store.state.meta.isTouched) fieldInstance.setMeta((prev)=>({
                            ...prev,
                            isTouched: true
                        }));
                });
            });
            const fieldErrorMapMap = await Promise.all(fieldValidationPromises);
            return fieldErrorMapMap.flat();
        };
        this.validateArrayFieldsStartingFrom = (field, index, cause)=>{
            return this.form.validateArrayFieldsStartingFrom(field, index, cause);
        };
        this.validateField = (field, cause)=>{
            return this.form.validateField(field, cause);
        };
        this.getFieldValue = (field)=>{
            return this.form.getFieldValue(field);
        };
        this.getFieldMeta = (field)=>{
            return this.form.getFieldMeta(field);
        };
        this.setFieldMeta = (field, updater)=>{
            return this.form.setFieldMeta(field, updater);
        };
        this.setFieldValue = (field, value)=>{
            return this.form.setFieldValue(field, value);
        };
        this.deleteField = (field)=>{
            return this.form.deleteField(field);
        };
        this.pushFieldValue = (field, value)=>{
            return this.form.pushFieldValue(field, value);
        };
        this.insertFieldValue = (field, index, value)=>{
            return this.form.insertFieldValue(field, index, value);
        };
        this.replaceFieldValue = (field, index, value)=>{
            return this.form.replaceFieldValue(field, index, value);
        };
        this.swapFieldValues = (field, index1, index2)=>{
            return this.form.swapFieldValues(field, index1, index2);
        };
        this.moveFieldValues = (field, fromIndex, toIndex)=>{
            return this.form.moveFieldValues(field, fromIndex, toIndex);
        };
        this.clearFieldValues = (field)=>{
            return this.form.clearFieldValues(field);
        };
        this.resetField = (field)=>{
            return this.form.resetField(field);
        };
        this.removeFieldValue = (field, index)=>{
            return this.form.removeFieldValue(field, index);
        };
        this.areRelatedFieldsValid = ()=>{
            return Object.values(this.getRelatedFields()).every((field)=>field.state.meta.isValid);
        };
        this.validate = (cause, opts2)=>{
            const { fieldsErrorMap: fieldsErrorMap } = opts2?.skipFormValidation ? {
                fieldsErrorMap: {}
            } : this.form.validateSync(cause, {
                dontUpdateFormErrorMap: true,
                filterFieldNames: (fieldName)=>(0, $5D8ug.isFieldInGroup)(this.name, fieldName)
            });
            const { hasErrored: hasErrored } = this.validateSync(cause, fieldsErrorMap[this.name] ?? {}, {
                skipRelatedFieldValidation: opts2?.skipRelatedFieldValidation
            });
            if (hasErrored && !this.options.asyncAlways) {
                this.getInfo().validationMetaMap[$97977d866b6010ce$var$getErrorMapKey(cause)]?.lastAbortController.abort();
                return this.state.meta.errors;
            }
            const formValidationResultPromise = opts2?.skipFormValidation ? Promise.resolve({}) : this.form.validateAsync(cause, {
                dontUpdateFormErrorMap: true,
                filterFieldNames: (fieldName)=>(0, $5D8ug.isFieldInGroup)(this.name, fieldName)
            });
            return this.validateAsync(cause, formValidationResultPromise, {
                skipRelatedFieldValidation: opts2?.skipRelatedFieldValidation
            });
        };
        this.triggerOnChangeListener = ()=>{
            const formDebounceMs = this.form.options.listeners?.onChangeGroupDebounceMs;
            if (formDebounceMs && formDebounceMs > 0) {
                if (this.timeoutIds.formListeners.change) clearTimeout(this.timeoutIds.formListeners.change);
                this.timeoutIds.formListeners.change = setTimeout(()=>{
                    this.form.options.listeners?.onChangeGroup?.({
                        formApi: this.form,
                        groupApi: this
                    });
                }, formDebounceMs);
            } else this.form.options.listeners?.onChangeGroup?.({
                formApi: this.form,
                groupApi: this
            });
            const fieldDebounceMs = this.options.listeners?.onChangeDebounceMs;
            if (fieldDebounceMs && fieldDebounceMs > 0) {
                if (this.timeoutIds.listeners.change) clearTimeout(this.timeoutIds.listeners.change);
                this.timeoutIds.listeners.change = setTimeout(()=>{
                    this.options.listeners?.onChange?.({
                        value: this.state.value,
                        groupApi: this
                    });
                }, fieldDebounceMs);
            } else this.options.listeners?.onChange?.({
                value: this.state.value,
                groupApi: this
            });
        };
        this.triggerOnSubmitListener = ()=>{
            this.options.listeners?.onSubmit?.({
                value: this.state.value,
                groupApi: this
            });
        };
        this._handleSubmit = async (submitMeta)=>{
            this.setFormGroupState((old)=>({
                    ...old,
                    // Submission attempts mark the form as not submitted
                    isSubmitted: false,
                    // Count submission attempts
                    submissionAttempts: old.submissionAttempts + 1,
                    isSubmitSuccessful: false
                }));
            (0, $dgHzL.batch)(()=>{
                Object.values(this.getRelatedFields()).forEach((field)=>{
                    if (!field.state.meta.isTouched) field.setMeta((prev)=>({
                            ...prev,
                            isTouched: true
                        }));
                });
            });
            const submitMetaArg = submitMeta ?? this.options.onSubmitMeta;
            this.setFormGroupState((d)=>({
                    ...d,
                    isSubmitting: true
                }));
            const done = ()=>{
                this.setFormGroupState((prev)=>({
                        ...prev,
                        isSubmitting: false
                    }));
            };
            await this.validateAllFields("submit");
            if (!this.areRelatedFieldsValid()) {
                done();
                this.options.onGroupSubmitInvalid?.({
                    value: this.state.value,
                    groupApi: this,
                    meta: submitMetaArg
                });
                return;
            }
            await this.validate("submit", {
                // This has already happened in the previous step
                skipRelatedFieldValidation: true
            });
            if (!this.areRelatedFieldsValid() || !this.state.meta.isValid) {
                done();
                this.options.onGroupSubmitInvalid?.({
                    value: this.state.value,
                    groupApi: this,
                    meta: submitMetaArg
                });
                return;
            }
            (0, $dgHzL.batch)(()=>{
                Object.values(this.getRelatedFields()).forEach((field)=>{
                    field.options.listeners?.onGroupSubmit?.({
                        value: field.state.value,
                        fieldApi: field
                    });
                });
            });
            this.options.listeners?.onSubmit?.({
                groupApi: this,
                value: this.state.value
            });
            try {
                await this.options.onGroupSubmit?.({
                    value: this.state.value,
                    groupApi: this,
                    meta: submitMetaArg
                });
                (0, $dgHzL.batch)(()=>{
                    this.setFormGroupState((prev)=>({
                            ...prev,
                            isSubmitted: true,
                            isSubmitSuccessful: true
                        }));
                    done();
                });
            } catch (err) {
                this.setFormGroupState((prev)=>({
                        ...prev,
                        isSubmitSuccessful: false
                    }));
                done();
                throw err;
            }
        };
        this.form = opts.form;
        this.name = opts.name;
        this.options = opts;
        this.timeoutIds = {
            validations: {},
            listeners: {},
            formListeners: {}
        };
        this.fieldInfo = {
            instance: null,
            validationMetaMap: {
                onChange: void 0,
                onBlur: void 0,
                onSubmit: void 0,
                onMount: void 0,
                onServer: void 0,
                onDynamic: void 0
            }
        };
        this.store = (0, $kKYCu.createStore)((prevVal)=>{
            this.form.formGroupMetaDerived.get();
            this.form.baseStore.get();
            const meta = this.form.getFormGroupMeta(this.name) ?? $97977d866b6010ce$export$68e3c7fb549fd7b8(opts.defaultMeta);
            let value = this.form.getFieldValue(this.name);
            if (!meta.isTouched && value === void 0 && this.options.defaultValue !== void 0 && !(0, $5D8ug.evaluate)(value, this.options.defaultValue)) value = this.options.defaultValue;
            if (prevVal && prevVal.value === value && prevVal.meta === meta) return prevVal;
            return {
                value: value,
                meta: meta
            };
        });
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    /**
   * The current field state.
   */ get state() {
        return this.store.state;
    }
    /**
   * @private
   */ runValidator(props) {
        if ((0, $8DIXq.isStandardSchemaValidator)(props.validate)) {
            const result = (0, $8DIXq.standardSchemaValidators)[props.type](props.value, props.validate);
            if (props.type === "validate") return $97977d866b6010ce$var$remapStandardSchemaResultForGroup(result);
            return result.then($97977d866b6010ce$var$remapStandardSchemaResultForGroup);
        }
        return props.validate(props.value);
    }
    handleSubmit(submitMeta) {
        return this._handleSubmit(submitMeta);
    }
}
function $97977d866b6010ce$var$normalizeError(rawError) {
    if (rawError) return rawError;
    return void 0;
}
function $97977d866b6010ce$var$isGlobalGroupValidationError(error) {
    return !!error && typeof error === "object" && "fields" in error;
}
function $97977d866b6010ce$var$remapStandardSchemaResultForGroup(result) {
    if (!result || typeof result !== "object") return result;
    if (!("form" in result) && !("fields" in result)) return result;
    const { form: form, fields: fields, ...rest } = result;
    return {
        ...rest,
        group: form,
        fields: fields
    };
}
function $97977d866b6010ce$var$getErrorMapKey(cause) {
    switch(cause){
        case "submit":
            return "onSubmit";
        case "blur":
            return "onBlur";
        case "mount":
            return "onMount";
        case "server":
            return "onServer";
        case "dynamic":
            return "onDynamic";
        case "change":
        default:
            return "onChange";
    }
}

});



parcelRegister("jAgEx", function(module, exports) {

$parcel$export(module.exports, "AnimatePresence", function () { return $b694f20f6c2567ba$export$3ae376d12526dd6f; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $6y205 = parcelRequire("6y205");

var $cYj8u = parcelRequire("cYj8u");

var $SQ4XF = parcelRequire("SQ4XF");

var $52yRq = parcelRequire("52yRq");

var $i8Wha = parcelRequire("i8Wha");

var $1fuqy = parcelRequire("1fuqy");
"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $b694f20f6c2567ba$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync", propagate: propagate = false })=>{
    const [isParentPresent, safeToRemove] = (0, $52yRq.usePresence)(propagate);
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $8FY87.useMemo)(()=>(0, $i8Wha.onlyElements)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = propagate && !isParentPresent ? [] : presentChildren.map((0, $i8Wha.getChildKey));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $8FY87.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $8FY87.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $cYj8u.useConstant)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $8FY87.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $8FY87.useState)(presentChildren);
    (0, $1fuqy.useIsomorphicLayoutEffect)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $i8Wha.getChildKey)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $i8Wha.getChildKey)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $i8Wha.onlyElements)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $8FY87.useContext)((0, $6y205.LayoutGroupContext));
    return (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $i8Wha.getChildKey)(child);
            const isPresent = propagate && !isParentPresent ? false : presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 || forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    propagate && (safeToRemove === null || safeToRemove === void 0 || safeToRemove());
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $2PPWI.jsx)((0, $SQ4XF.PresenceChild), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: isPresent ? undefined : custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                children: child
            }, key);
        })
    });
};

});
parcelRegister("SQ4XF", function(module, exports) {

$parcel$export(module.exports, "PresenceChild", function () { return $f2f6cb4a3435301d$export$979daf65881a382a; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $5Hs9x = parcelRequire("5Hs9x");

var $cYj8u = parcelRequire("cYj8u");

var $8oGoD = parcelRequire("8oGoD");
"use client";
const $f2f6cb4a3435301d$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $cYj8u.useConstant)($f2f6cb4a3435301d$var$newChildrenMap);
    const id = (0, $8FY87.useId)();
    const memoizedOnExitComplete = (0, $8FY87.useCallback)((childId)=>{
        presenceChildren.set(childId, true);
        for (const isComplete of presenceChildren.values()){
            if (!isComplete) return; // can stop searching when any is incomplete
        }
        onExitComplete && onExitComplete();
    }, [
        presenceChildren,
        onExitComplete
    ]);
    const context = (0, $8FY87.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: memoizedOnExitComplete,
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random(),
        memoizedOnExitComplete
    ] : [
        isPresent,
        memoizedOnExitComplete
    ]);
    (0, $8FY87.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $8FY87.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $2PPWI.jsx)((0, $8oGoD.PopChild), {
        isPresent: isPresent,
        children: children
    });
    return (0, $2PPWI.jsx)((0, $5Hs9x.PresenceContext).Provider, {
        value: context,
        children: children
    });
};
function $f2f6cb4a3435301d$var$newChildrenMap() {
    return new Map();
}

});
parcelRegister("8oGoD", function(module, exports) {

$parcel$export(module.exports, "PopChild", function () { return $c57c73e5d52eaf65$export$1d6cdde0c6816c6d; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $i7M4t = parcelRequire("i7M4t");
"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $c57c73e5d52eaf65$var$PopChildMeasure extends $8FY87.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $c57c73e5d52eaf65$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $8FY87.useId)();
    const ref = (0, $8FY87.useRef)(null);
    const size = (0, $8FY87.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const { nonce: nonce } = (0, $8FY87.useContext)((0, $i7M4t.MotionConfigContext));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $8FY87.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $2PPWI.jsx)($c57c73e5d52eaf65$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $8FY87.cloneElement(children, {
            ref: ref
        })
    });
}

});


parcelRegister("52yRq", function(module, exports) {

$parcel$export(module.exports, "usePresence", function () { return $c4341d089b587859$export$2a8c16d82a0a0e26; });

var $8FY87 = parcelRequire("8FY87");

var $5Hs9x = parcelRequire("5Hs9x");
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $c4341d089b587859$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $8FY87.useContext)((0, $5Hs9x.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $8FY87.useId)();
    (0, $8FY87.useEffect)(()=>{
        if (subscribe) register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $8FY87.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $c4341d089b587859$export$8249053f690ea39a() {
    return $c4341d089b587859$export$ee27c052bca048fb((0, $8FY87.useContext)((0, $5Hs9x.PresenceContext)));
}
function $c4341d089b587859$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}

});

parcelRegister("i8Wha", function(module, exports) {

$parcel$export(module.exports, "getChildKey", function () { return $8420e60cb48d1c5f$export$10e61aed958678dd; });
$parcel$export(module.exports, "onlyElements", function () { return $8420e60cb48d1c5f$export$872a3a1281f4b357; });

var $8FY87 = parcelRequire("8FY87");
const $8420e60cb48d1c5f$export$10e61aed958678dd = (child)=>child.key || "";
function $8420e60cb48d1c5f$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $8FY87.Children).forEach(children, (child)=>{
        if ((0, $8FY87.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}

});


parcelRegister("elAir", function(module, exports) {

$parcel$export(module.exports, "string", function () { return string; });
$parcel$export(module.exports, "email", function () { return email; });
$parcel$export(module.exports, "number", function () { return number; });
$parcel$export(module.exports, "boolean", function () { return boolean; });
$parcel$export(module.exports, "enum", function () { return _enum; });
$parcel$export(module.exports, "object", function () { return object; });
$parcel$export(module.exports, "file", function () { return file; });

var $8tIUC = parcelRequire("8tIUC");
var $59TZW = parcelRequire("59TZW");
var $MHJtW = parcelRequire("MHJtW");
var $9iCDw = parcelRequire("9iCDw");
var $c0663 = parcelRequire("c0663");
var $eTOwy = parcelRequire("eTOwy");
var $cxlmR = parcelRequire("cxlmR");
var $6iLpq = parcelRequire("6iLpq");

var $6iVFp = parcelRequire("6iVFp");

var $itk2T = parcelRequire("itk2T");

var $dsEDN = parcelRequire("dsEDN");

var $8tIUC = parcelRequire("8tIUC");

var $eeCax = parcelRequire("eeCax");
// Register English as the default locale on first ZodType construction. Hooked into the `ZodType` `$constructor` (rather than a top-level `config(en())` in `external.ts`) so bundlers honoring `sideEffects: false` can't tree-shake it out — see #5953, #5725. An explicit `z.config(z.locales.xx())` call wins regardless of order, since this only sets the default when none is present.
function _ensureDefaultLocale() {
    if (!$59TZW.globalConfig.localeError) $59TZW.config((0, $dsEDN.default)());
}
// the default memoizer is read by the core container init, which runs before `ZodType.init`, so each container calls this first
function _ensureDefaultMemoizer() {
    if (!$59TZW.globalConfig.memoizer) $59TZW.config({
        memoizer: $cxlmR.memoizer()
    });
}
const ZodType = /*@__PURE__*/ $59TZW.$constructor("ZodType", (inst, def)=>{
    _ensureDefaultLocale();
    $MHJtW.$ZodType.init(inst, def);
    inst.def = def;
    inst.type = def.type;
    return inst;
}, {
    check (...chks) {
        const def = this.def;
        return this.clone((0, $c0663).mergeDefs(def, {
            checks: [
                ...def.checks ?? [],
                ...chks.map((ch)=>typeof ch === "function" ? {
                        _zod: {
                            check: ch,
                            def: {
                                check: "custom"
                            },
                            onattach: []
                        }
                    } : ch)
            ]
        }), {
            parent: true
        });
    },
    with (...chks) {
        return this.check(...chks);
    },
    clone (def, params) {
        return $c0663.clone(this, def, params);
    },
    brand () {
        return this;
    },
    register (reg, meta) {
        reg.add(this, meta);
        return this;
    },
    refine (check, params) {
        return this.check(refine(check, params));
    },
    superRefine (refinement, params) {
        return this.check(superRefine(refinement, params));
    },
    overwrite (fn) {
        return this.check($8tIUC._overwrite(fn));
    },
    optional () {
        return optional(this);
    },
    exactOptional () {
        return exactOptional(this);
    },
    nullable () {
        return nullable(this);
    },
    nullish () {
        return optional(nullable(this));
    },
    nonoptional (params) {
        return nonoptional(this, params);
    },
    array () {
        return array(this);
    },
    or (arg) {
        return union([
            this,
            arg
        ]);
    },
    and (arg) {
        return intersection(this, arg);
    },
    transform (tx) {
        return pipe(this, transform(tx));
    },
    default (d) {
        return _default(this, d);
    },
    prefault (d) {
        return prefault(this, d);
    },
    catch (params) {
        return _catch(this, params);
    },
    pipe (target) {
        return pipe(this, target);
    },
    readonly () {
        return readonly(this);
    },
    describe (description) {
        const cl = this.clone();
        $eTOwy.globalRegistry.add(cl, {
            description: description
        });
        return cl;
    },
    meta (...args) {
        // overloaded: meta() returns the registered metadata, meta(data) returns a clone with `data` registered. The mapped type picks up the second overload, so we accept variadic any-args and return `any` to satisfy both at runtime.
        if (args.length === 0) return $eTOwy.globalRegistry.get(this);
        const cl = this.clone();
        $eTOwy.globalRegistry.add(cl, args[0]);
        return cl;
    },
    isOptional () {
        return this.safeParse(undefined).success;
    },
    isNullable () {
        return this.safeParse(null).success;
    },
    apply (fn, ...args) {
        return args.length === 0 ? fn(this) : fn(this, ...args);
    },
    // Overrides core's `~standard` to add `jsonSchema`. Must stay a prototype entry: redefining it per instance demotes instances to dictionary mode.
    get "~standard" () {
        return (0, $c0663).hide(this, "~standard", {
            ...$MHJtW.standardProps(this),
            jsonSchema: {
                input: (0, $itk2T.createStandardJSONSchemaMethod)(this, "input"),
                output: (0, $itk2T.createStandardJSONSchemaMethod)(this, "output")
            }
        });
    },
    set "~standard" (value){
        (0, $c0663).own(this, "~standard", value);
    },
    parse: function _parse(data, params) {
        return $eeCax.parse(this, data, params, {
            callee: _parse
        });
    },
    parseAsync: async function _parseAsync(data, params) {
        return await $eeCax.parseAsync(this, data, params, {
            callee: _parseAsync
        });
    },
    safeParse (data, params) {
        return $eeCax.safeParse(this, data, params);
    },
    async safeParseAsync (data, params) {
        return $eeCax.safeParseAsync(this, data, params);
    },
    // `spa` is an alias: same function object as `safeParseAsync`, as before.
    get spa () {
        return this?.safeParseAsync;
    },
    set spa (value){
        (0, $c0663).own(this, "spa", value);
    },
    encode: function _encode(data, params) {
        return $eeCax.encode(this, data, params, {
            callee: _encode
        });
    },
    decode: function _decode(data, params) {
        return $eeCax.decode(this, data, params, {
            callee: _decode
        });
    },
    encodeAsync: async function _encodeAsync(data, params) {
        return await $eeCax.encodeAsync(this, data, params, {
            callee: _encodeAsync
        });
    },
    decodeAsync: async function _decodeAsync(data, params) {
        return await $eeCax.decodeAsync(this, data, params, {
            callee: _decodeAsync
        });
    },
    safeEncode (data, params) {
        return $eeCax.safeEncode(this, data, params);
    },
    safeDecode (data, params) {
        return $eeCax.safeDecode(this, data, params);
    },
    async safeEncodeAsync (data, params) {
        return $eeCax.safeEncodeAsync(this, data, params);
    },
    async safeDecodeAsync (data, params) {
        return $eeCax.safeDecodeAsync(this, data, params);
    },
    toJSONSchema (params) {
        return (0, $itk2T.createToJSONSchemaMethod)(this, {})(params);
    },
    // Reads through to the registry on every access, so it must not cache.
    get description () {
        return $eTOwy.globalRegistry.get(this)?.description;
    },
    // No setter: `schema._def = x` throws, as it did when `_def` was a non-writable own property.
    get _def () {
        return this._zod.def;
    }
});
const _ZodString = /*@__PURE__*/ $59TZW.$constructor("_ZodString", (inst, def)=>{
    $MHJtW.$ZodString.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.stringProcessor(inst, ctx, json, params);
    const bag = inst._zod.bag;
    inst.format = bag.format ?? null;
    inst.minLength = bag.minimum ?? null;
    inst.maxLength = bag.maximum ?? null;
}, {
    regex (...args) {
        return this.check($8tIUC._regex(...args));
    },
    includes (...args) {
        return this.check($8tIUC._includes(...args));
    },
    startsWith (...args) {
        return this.check($8tIUC._startsWith(...args));
    },
    endsWith (...args) {
        return this.check($8tIUC._endsWith(...args));
    },
    min (...args) {
        return this.check($8tIUC._minLength(...args));
    },
    max (...args) {
        return this.check($8tIUC._maxLength(...args));
    },
    length (...args) {
        return this.check($8tIUC._length(...args));
    },
    nonempty (...args) {
        return this.check($8tIUC._minLength(1, ...args));
    },
    lowercase (params) {
        return this.check($8tIUC._lowercase(params));
    },
    uppercase (params) {
        return this.check($8tIUC._uppercase(params));
    },
    trim () {
        return this.check($8tIUC._trim());
    },
    normalize (...args) {
        return this.check($8tIUC._normalize(...args));
    },
    toLowerCase () {
        return this.check($8tIUC._toLowerCase());
    },
    toUpperCase () {
        return this.check($8tIUC._toUpperCase());
    },
    slugify () {
        return this.check($8tIUC._slugify());
    }
});
const ZodString = /*@__PURE__*/ $59TZW.$constructor("ZodString", (inst, def)=>{
    $MHJtW.$ZodString.init(inst, def);
    _ZodString.init(inst, def);
}, {
    email (params) {
        return this.check($8tIUC._email(ZodEmail, params));
    },
    url (params) {
        return this.check($8tIUC._url(ZodURL, params));
    },
    jwt (params) {
        return this.check($8tIUC._jwt(ZodJWT, params));
    },
    emoji (params) {
        return this.check($8tIUC._emoji(ZodEmoji, params));
    },
    guid (params) {
        return this.check($8tIUC._guid(ZodGUID, params));
    },
    uuid (params) {
        return this.check($8tIUC._uuid(ZodUUID, params));
    },
    uuidv4 (params) {
        return this.check($8tIUC._uuidv4(ZodUUID, params));
    },
    uuidv6 (params) {
        return this.check($8tIUC._uuidv6(ZodUUID, params));
    },
    uuidv7 (params) {
        return this.check($8tIUC._uuidv7(ZodUUID, params));
    },
    nanoid (params) {
        return this.check($8tIUC._nanoid(ZodNanoID, params));
    },
    cuid (params) {
        return this.check($8tIUC._cuid(ZodCUID, params));
    },
    cuid2 (params) {
        return this.check($8tIUC._cuid2(ZodCUID2, params));
    },
    ulid (params) {
        return this.check($8tIUC._ulid(ZodULID, params));
    },
    base64 (params) {
        return this.check($8tIUC._base64(ZodBase64, params));
    },
    base64url (params) {
        return this.check($8tIUC._base64url(ZodBase64URL, params));
    },
    xid (params) {
        return this.check($8tIUC._xid(ZodXID, params));
    },
    ksuid (params) {
        return this.check($8tIUC._ksuid(ZodKSUID, params));
    },
    ipv4 (params) {
        return this.check($8tIUC._ipv4(ZodIPv4, params));
    },
    ipv6 (params) {
        return this.check($8tIUC._ipv6(ZodIPv6, params));
    },
    cidrv4 (params) {
        return this.check($8tIUC._cidrv4(ZodCIDRv4, params));
    },
    cidrv6 (params) {
        return this.check($8tIUC._cidrv6(ZodCIDRv6, params));
    },
    e164 (params) {
        return this.check($8tIUC._e164(ZodE164, params));
    },
    datetime (params) {
        return this.check($8tIUC._isoDateTime(ZodISODateTime, params));
    },
    date (params) {
        return this.check($8tIUC._isoDate(ZodISODate, params));
    },
    time (params) {
        return this.check($8tIUC._isoTime(ZodISOTime, params));
    },
    duration (params) {
        return this.check($8tIUC._isoDuration(ZodISODuration, params));
    }
});
function string(params) {
    return $8tIUC._string(ZodString, params);
}
const ZodStringFormat = /*@__PURE__*/ $59TZW.$constructor("ZodStringFormat", (inst, def)=>{
    $MHJtW.$ZodStringFormat.init(inst, def);
    _ZodString.init(inst, def);
});
const ZodISODateTime = /*@__PURE__*/ $59TZW.$constructor("ZodISODateTime", (inst, def)=>{
    $MHJtW.$ZodISODateTime.init(inst, def);
    ZodStringFormat.init(inst, def);
});
const ZodISODate = /*@__PURE__*/ $59TZW.$constructor("ZodISODate", (inst, def)=>{
    $MHJtW.$ZodISODate.init(inst, def);
    ZodStringFormat.init(inst, def);
});
const ZodISOTime = /*@__PURE__*/ $59TZW.$constructor("ZodISOTime", (inst, def)=>{
    $MHJtW.$ZodISOTime.init(inst, def);
    ZodStringFormat.init(inst, def);
});
const ZodISODuration = /*@__PURE__*/ $59TZW.$constructor("ZodISODuration", (inst, def)=>{
    $MHJtW.$ZodISODuration.init(inst, def);
    ZodStringFormat.init(inst, def);
});
const ZodEmail = /*@__PURE__*/ $59TZW.$constructor("ZodEmail", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodEmail.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function email(params) {
    return $8tIUC._email(ZodEmail, params);
}
const ZodGUID = /*@__PURE__*/ $59TZW.$constructor("ZodGUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodGUID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function guid(params) {
    return $8tIUC._guid(ZodGUID, params);
}
const ZodUUID = /*@__PURE__*/ $59TZW.$constructor("ZodUUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodUUID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function uuid(params) {
    return $8tIUC._uuid(ZodUUID, params);
}
function uuidv4(params) {
    return $8tIUC._uuidv4(ZodUUID, params);
}
function uuidv6(params) {
    return $8tIUC._uuidv6(ZodUUID, params);
}
function uuidv7(params) {
    return $8tIUC._uuidv7(ZodUUID, params);
}
const ZodURL = /*@__PURE__*/ $59TZW.$constructor("ZodURL", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodURL.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function url(params) {
    return $8tIUC._url(ZodURL, params);
}
function httpUrl(params) {
    return $8tIUC._url(ZodURL, {
        protocol: $6iLpq.httpProtocol,
        hostname: $6iLpq.domain,
        ...(0, $c0663).normalizeParams(params)
    });
}
const ZodEmoji = /*@__PURE__*/ $59TZW.$constructor("ZodEmoji", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodEmoji.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function emoji(params) {
    return $8tIUC._emoji(ZodEmoji, params);
}
const ZodNanoID = /*@__PURE__*/ $59TZW.$constructor("ZodNanoID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodNanoID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function nanoid(params) {
    return $8tIUC._nanoid(ZodNanoID, params);
}
const ZodCUID = /*@__PURE__*/ $59TZW.$constructor("ZodCUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodCUID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function cuid(params) {
    return $8tIUC._cuid(ZodCUID, params);
}
const ZodCUID2 = /*@__PURE__*/ $59TZW.$constructor("ZodCUID2", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodCUID2.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function cuid2(params) {
    return $8tIUC._cuid2(ZodCUID2, params);
}
const ZodULID = /*@__PURE__*/ $59TZW.$constructor("ZodULID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodULID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function ulid(params) {
    return $8tIUC._ulid(ZodULID, params);
}
const ZodXID = /*@__PURE__*/ $59TZW.$constructor("ZodXID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodXID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function xid(params) {
    return $8tIUC._xid(ZodXID, params);
}
const ZodKSUID = /*@__PURE__*/ $59TZW.$constructor("ZodKSUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodKSUID.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function ksuid(params) {
    return $8tIUC._ksuid(ZodKSUID, params);
}
const ZodIPv4 = /*@__PURE__*/ $59TZW.$constructor("ZodIPv4", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodIPv4.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function ipv4(params) {
    return $8tIUC._ipv4(ZodIPv4, params);
}
const ZodMAC = /*@__PURE__*/ $59TZW.$constructor("ZodMAC", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodMAC.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function mac(params) {
    return $8tIUC._mac(ZodMAC, params);
}
const ZodIPv6 = /*@__PURE__*/ $59TZW.$constructor("ZodIPv6", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodIPv6.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function ipv6(params) {
    return $8tIUC._ipv6(ZodIPv6, params);
}
const ZodCIDRv4 = /*@__PURE__*/ $59TZW.$constructor("ZodCIDRv4", (inst, def)=>{
    $MHJtW.$ZodCIDRv4.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function cidrv4(params) {
    return $8tIUC._cidrv4(ZodCIDRv4, params);
}
const ZodCIDRv6 = /*@__PURE__*/ $59TZW.$constructor("ZodCIDRv6", (inst, def)=>{
    $MHJtW.$ZodCIDRv6.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function cidrv6(params) {
    return $8tIUC._cidrv6(ZodCIDRv6, params);
}
const ZodBase64 = /*@__PURE__*/ $59TZW.$constructor("ZodBase64", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodBase64.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function base64(params) {
    return $8tIUC._base64(ZodBase64, params);
}
const ZodBase64URL = /*@__PURE__*/ $59TZW.$constructor("ZodBase64URL", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodBase64URL.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function base64url(params) {
    return $8tIUC._base64url(ZodBase64URL, params);
}
const ZodE164 = /*@__PURE__*/ $59TZW.$constructor("ZodE164", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodE164.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function e164(params) {
    return $8tIUC._e164(ZodE164, params);
}
const ZodCreditCard = /*@__PURE__*/ $59TZW.$constructor("ZodCreditCard", (inst, def)=>{
    $MHJtW.$ZodCreditCard.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function creditCard(params) {
    return $8tIUC._creditCard(ZodCreditCard, params);
}
const ZodJWT = /*@__PURE__*/ $59TZW.$constructor("ZodJWT", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodJWT.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function jwt(params) {
    return $8tIUC._jwt(ZodJWT, params);
}
const ZodCustomStringFormat = /*@__PURE__*/ $59TZW.$constructor("ZodCustomStringFormat", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $MHJtW.$ZodCustomStringFormat.init(inst, def);
    ZodStringFormat.init(inst, def);
});
function stringFormat(format, fnOrRegex, _params = {}) {
    return $8tIUC._stringFormat(ZodCustomStringFormat, format, fnOrRegex, _params);
}
function hostname(_params) {
    return $8tIUC._stringFormat(ZodCustomStringFormat, "hostname", $6iLpq.hostname, _params);
}
function hex(_params) {
    return $8tIUC._stringFormat(ZodCustomStringFormat, "hex", $6iLpq.hex, _params);
}
function hash(alg, params) {
    const enc = params?.enc ?? "hex";
    const format = `${alg}_${enc}`;
    const regex = $6iLpq[format];
    if (!regex) throw new Error(`Unrecognized hash format: ${format}`);
    return $8tIUC._stringFormat(ZodCustomStringFormat, format, regex, params);
}
const ZodNumber = /*@__PURE__*/ $59TZW.$constructor("ZodNumber", (inst, def)=>{
    $MHJtW.$ZodNumber.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.numberProcessor(inst, ctx, json, params);
    const bag = inst._zod.bag;
    inst.minValue = Math.max(bag.minimum ?? Number.NEGATIVE_INFINITY, bag.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null;
    inst.maxValue = Math.min(bag.maximum ?? Number.POSITIVE_INFINITY, bag.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null;
    inst.isInt = (bag.format ?? "").includes("int") || Number.isSafeInteger(bag.multipleOf ?? 0.5);
    inst.isFinite = true;
    inst.format = bag.format ?? null;
}, {
    gt (value1, params) {
        return this.check($8tIUC._gt(value1, params));
    },
    gte (value1, params) {
        return this.check($8tIUC._gte(value1, params));
    },
    min (value1, params) {
        return this.check($8tIUC._gte(value1, params));
    },
    lt (value1, params) {
        return this.check($8tIUC._lt(value1, params));
    },
    lte (value1, params) {
        return this.check($8tIUC._lte(value1, params));
    },
    max (value1, params) {
        return this.check($8tIUC._lte(value1, params));
    },
    int (params) {
        return this.check(int(params));
    },
    safe (params) {
        return this.check(int(params));
    },
    positive (params) {
        return this.check($8tIUC._gt(0, params));
    },
    nonnegative (params) {
        return this.check($8tIUC._gte(0, params));
    },
    negative (params) {
        return this.check($8tIUC._lt(0, params));
    },
    nonpositive (params) {
        return this.check($8tIUC._lte(0, params));
    },
    multipleOf (value1, params) {
        return this.check($8tIUC._multipleOf(value1, params));
    },
    step (value1, params) {
        return this.check($8tIUC._multipleOf(value1, params));
    },
    finite () {
        return this;
    }
});
function number(params) {
    return $8tIUC._number(ZodNumber, params);
}
const ZodNumberFormat = /*@__PURE__*/ $59TZW.$constructor("ZodNumberFormat", (inst, def)=>{
    $MHJtW.$ZodNumberFormat.init(inst, def);
    ZodNumber.init(inst, def);
});
function int(params) {
    return $8tIUC._int(ZodNumberFormat, params);
}
function float32(params) {
    return $8tIUC._float32(ZodNumberFormat, params);
}
function float64(params) {
    return $8tIUC._float64(ZodNumberFormat, params);
}
function int32(params) {
    return $8tIUC._int32(ZodNumberFormat, params);
}
function uint32(params) {
    return $8tIUC._uint32(ZodNumberFormat, params);
}
const ZodBoolean = /*@__PURE__*/ $59TZW.$constructor("ZodBoolean", (inst, def)=>{
    $MHJtW.$ZodBoolean.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.booleanProcessor(inst, ctx, json, params);
});
function boolean(params) {
    return $8tIUC._boolean(ZodBoolean, params);
}
const ZodBigInt = /*@__PURE__*/ $59TZW.$constructor("ZodBigInt", (inst, def)=>{
    $MHJtW.$ZodBigInt.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.bigintProcessor(inst, ctx, json, params);
    const bag = inst._zod.bag;
    inst.minValue = bag.minimum ?? null;
    inst.maxValue = bag.maximum ?? null;
    inst.format = bag.format ?? null;
}, {
    gte (value1, params) {
        return this.check($8tIUC._gte(value1, params));
    },
    min (value1, params) {
        return this.check($8tIUC._gte(value1, params));
    },
    gt (value1, params) {
        return this.check($8tIUC._gt(value1, params));
    },
    lt (value1, params) {
        return this.check($8tIUC._lt(value1, params));
    },
    lte (value1, params) {
        return this.check($8tIUC._lte(value1, params));
    },
    max (value1, params) {
        return this.check($8tIUC._lte(value1, params));
    },
    positive (params) {
        return this.check($8tIUC._gt(BigInt(0), params));
    },
    negative (params) {
        return this.check($8tIUC._lt(BigInt(0), params));
    },
    nonpositive (params) {
        return this.check($8tIUC._lte(BigInt(0), params));
    },
    nonnegative (params) {
        return this.check($8tIUC._gte(BigInt(0), params));
    },
    multipleOf (value1, params) {
        return this.check($8tIUC._multipleOf(value1, params));
    }
});
function bigint(params) {
    return $8tIUC._bigint(ZodBigInt, params);
}
const ZodBigIntFormat = /*@__PURE__*/ $59TZW.$constructor("ZodBigIntFormat", (inst, def)=>{
    $MHJtW.$ZodBigIntFormat.init(inst, def);
    ZodBigInt.init(inst, def);
});
function int64(params) {
    return $8tIUC._int64(ZodBigIntFormat, params);
}
function uint64(params) {
    return $8tIUC._uint64(ZodBigIntFormat, params);
}
const ZodSymbol = /*@__PURE__*/ $59TZW.$constructor("ZodSymbol", (inst, def)=>{
    $MHJtW.$ZodSymbol.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.symbolProcessor(inst, ctx, json, params);
});
function symbol(params) {
    return $8tIUC._symbol(ZodSymbol, params);
}
const ZodUndefined = /*@__PURE__*/ $59TZW.$constructor("ZodUndefined", (inst, def)=>{
    $MHJtW.$ZodUndefined.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.undefinedProcessor(inst, ctx, json, params);
});
function _undefined(params) {
    return $8tIUC._undefined(ZodUndefined, params);
}
const ZodNull = /*@__PURE__*/ $59TZW.$constructor("ZodNull", (inst, def)=>{
    $MHJtW.$ZodNull.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.nullProcessor(inst, ctx, json, params);
});
function _null(params) {
    return $8tIUC._null(ZodNull, params);
}
const ZodAny = /*@__PURE__*/ $59TZW.$constructor("ZodAny", (inst, def)=>{
    $MHJtW.$ZodAny.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.anyProcessor(inst, ctx, json, params);
});
function any() {
    return $8tIUC._any(ZodAny);
}
const ZodUnknown = /*@__PURE__*/ $59TZW.$constructor("ZodUnknown", (inst, def)=>{
    $MHJtW.$ZodUnknown.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.unknownProcessor(inst, ctx, json, params);
});
function unknown() {
    return $8tIUC._unknown(ZodUnknown);
}
const ZodNever = /*@__PURE__*/ $59TZW.$constructor("ZodNever", (inst, def)=>{
    $MHJtW.$ZodNever.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.neverProcessor(inst, ctx, json, params);
});
function never(params) {
    return $8tIUC._never(ZodNever, params);
}
const ZodVoid = /*@__PURE__*/ $59TZW.$constructor("ZodVoid", (inst, def)=>{
    $MHJtW.$ZodVoid.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.voidProcessor(inst, ctx, json, params);
});
function _void(params) {
    return $8tIUC._void(ZodVoid, params);
}
const ZodDate = /*@__PURE__*/ $59TZW.$constructor("ZodDate", (inst, def)=>{
    $MHJtW.$ZodDate.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.dateProcessor(inst, ctx, json, params);
    inst.min = (value1, params)=>inst.check($8tIUC._gte(value1, params));
    inst.max = (value1, params)=>inst.check($8tIUC._lte(value1, params));
    const c = inst._zod.bag;
    inst.minDate = c.minimum ? new Date(c.minimum) : null;
    inst.maxDate = c.maximum ? new Date(c.maximum) : null;
});
function date(params) {
    return $8tIUC._date(ZodDate, params);
}
const ZodArray = /*@__PURE__*/ $59TZW.$constructor("ZodArray", (inst, def)=>{
    _ensureDefaultMemoizer();
    $MHJtW.$ZodArray.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.arrayProcessor(inst, ctx, json, params);
    inst.element = def.element;
}, {
    min (n, params) {
        return this.check($8tIUC._minLength(n, params));
    },
    nonempty (params) {
        return this.check($8tIUC._minLength(1, params));
    },
    max (n, params) {
        return this.check($8tIUC._maxLength(n, params));
    },
    length (n, params) {
        return this.check($8tIUC._length(n, params));
    },
    unwrap () {
        return this.element;
    }
});
function array(element, params) {
    return $8tIUC._array(ZodArray, element, params);
}
function keyof(schema) {
    const shape = schema._zod.def.shape;
    return _enum(Object.keys(shape));
}
const ZodObject = /*@__PURE__*/ $59TZW.$constructor("ZodObject", (inst, def)=>{
    _ensureDefaultMemoizer();
    $MHJtW.$ZodObjectJIT.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.objectProcessor(inst, ctx, json, params);
    (0, $c0663).installLazyProp(inst, "shape", (self)=>self._zod.def.shape, false);
}, {
    keyof () {
        return _enum(Object.keys(this._zod.def.shape));
    },
    catchall (catchall) {
        return this.clone({
            ...this._zod.def,
            catchall: catchall
        });
    },
    passthrough () {
        return this.clone({
            ...this._zod.def,
            catchall: unknown()
        });
    },
    loose () {
        return this.clone({
            ...this._zod.def,
            catchall: unknown()
        });
    },
    strict () {
        return this.clone({
            ...this._zod.def,
            catchall: never()
        });
    },
    strip () {
        return this.clone({
            ...this._zod.def,
            catchall: undefined
        });
    },
    extend (incoming) {
        return (0, $c0663).extend(this, incoming);
    },
    safeExtend (incoming) {
        return (0, $c0663).safeExtend(this, incoming);
    },
    merge (other) {
        return (0, $c0663).merge(this, other);
    },
    pick (mask) {
        return (0, $c0663).pick(this, mask);
    },
    omit (mask) {
        return (0, $c0663).omit(this, mask);
    },
    partial (...args) {
        return (0, $c0663).partial(ZodOptional, this, args[0]);
    },
    exactPartial (...args) {
        return (0, $c0663).partial(ZodExactOptional, this, args[0], "exactPartial");
    },
    required (...args) {
        return (0, $c0663).required(ZodNonOptional, this, args[0]);
    }
});
function object(shape, params) {
    const def = {
        type: "object",
        shape: shape ?? {},
        ...(0, $c0663).normalizeParams(params)
    };
    return new ZodObject(def);
}
function strictObject(shape, params) {
    return new ZodObject({
        type: "object",
        shape: shape,
        catchall: never(),
        ...(0, $c0663).normalizeParams(params)
    });
}
function looseObject(shape, params) {
    return new ZodObject({
        type: "object",
        shape: shape,
        catchall: unknown(),
        ...(0, $c0663).normalizeParams(params)
    });
}
const ZodUnion = /*@__PURE__*/ $59TZW.$constructor("ZodUnion", (inst, def)=>{
    $MHJtW.$ZodUnion.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.unionProcessor(inst, ctx, json, params);
    inst.options = def.options;
});
function union(options, params) {
    return new ZodUnion({
        type: "union",
        options: options,
        ...(0, $c0663).normalizeParams(params)
    });
}
const ZodXor = /*@__PURE__*/ $59TZW.$constructor("ZodXor", (inst, def)=>{
    ZodUnion.init(inst, def);
    $MHJtW.$ZodXor.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.unionProcessor(inst, ctx, json, params);
    inst.options = def.options;
});
function xor(options, params) {
    return new ZodXor({
        type: "union",
        options: options,
        inclusive: false,
        ...(0, $c0663).normalizeParams(params)
    });
}
const ZodDiscriminatedUnion = /*@__PURE__*/ $59TZW.$constructor("ZodDiscriminatedUnion", (inst, def)=>{
    ZodUnion.init(inst, def);
    $MHJtW.$ZodDiscriminatedUnion.init(inst, def);
});
function discriminatedUnion(discriminator, options, params) {
    // const [options, params] = args;
    return new ZodDiscriminatedUnion({
        type: "union",
        options: options,
        discriminator: discriminator,
        ...(0, $c0663).normalizeParams(params)
    });
}
const ZodIntersection = /*@__PURE__*/ $59TZW.$constructor("ZodIntersection", (inst, def)=>{
    $MHJtW.$ZodIntersection.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.intersectionProcessor(inst, ctx, json, params);
});
function intersection(left, right) {
    return new ZodIntersection({
        type: "intersection",
        left: left,
        right: right
    });
}
const ZodTuple = /*@__PURE__*/ $59TZW.$constructor("ZodTuple", (inst, def)=>{
    _ensureDefaultMemoizer();
    $MHJtW.$ZodTuple.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.tupleProcessor(inst, ctx, json, params);
}, {
    rest (rest) {
        return this.clone({
            ...this._zod.def,
            rest: rest
        });
    },
    partial () {
        const def = this._zod.def;
        // a refinement was authored against the full arity; partialing would run it on a shorter array
        if (def.checks?.length) throw new Error(".partial() cannot be used on tuple schemas containing refinements");
        return this.clone({
            ...def,
            items: def.items.map((item)=>new ZodOptional({
                    type: "optional",
                    innerType: item
                }))
        });
    }
});
function tuple(items, _paramsOrRest, _params) {
    const hasRest = _paramsOrRest instanceof $MHJtW.$ZodType;
    const params = hasRest ? _params : _paramsOrRest;
    const rest = hasRest ? _paramsOrRest : null;
    return new ZodTuple({
        type: "tuple",
        items: items,
        rest: rest,
        ...(0, $c0663).normalizeParams(params)
    });
}
const ZodRecord = /*@__PURE__*/ $59TZW.$constructor("ZodRecord", (inst, def)=>{
    _ensureDefaultMemoizer();
    $MHJtW.$ZodRecord.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.recordProcessor(inst, ctx, json, params);
    inst.keyType = def.keyType;
    inst.valueType = def.valueType;
});
function record(keyType, valueType, params) {
    // v3-compat: z.record(valueType, params?) — defaults keyType to z.string()
    if (!valueType || !valueType._zod) return new ZodRecord({
        type: "record",
        keyType: string(),
        valueType: keyType,
        ...(0, $c0663).normalizeParams(valueType)
    });
    return new ZodRecord({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        ...(0, $c0663).normalizeParams(params)
    });
}
function partialRecord(keyType, valueType, params) {
    return new ZodRecord({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        ...(0, $c0663).normalizeParams(params),
        partial: true
    });
}
function looseRecord(keyType, valueType, params) {
    return new ZodRecord({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        mode: "loose",
        ...(0, $c0663).normalizeParams(params)
    });
}
const ZodMap = /*@__PURE__*/ $59TZW.$constructor("ZodMap", (inst, def)=>{
    _ensureDefaultMemoizer();
    $MHJtW.$ZodMap.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.mapProcessor(inst, ctx, json, params);
    inst.keyType = def.keyType;
    inst.valueType = def.valueType;
    inst.min = (...args)=>inst.check($8tIUC._minSize(...args));
    inst.nonempty = (params)=>inst.check($8tIUC._minSize(1, params));
    inst.max = (...args)=>inst.check($8tIUC._maxSize(...args));
    inst.size = (...args)=>inst.check($8tIUC._size(...args));
});
function map(keyType, valueType, params) {
    return new ZodMap({
        type: "map",
        keyType: keyType,
        valueType: valueType,
        ...(0, $c0663).normalizeParams(params)
    });
}
const ZodSet = /*@__PURE__*/ $59TZW.$constructor("ZodSet", (inst, def)=>{
    _ensureDefaultMemoizer();
    $MHJtW.$ZodSet.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.setProcessor(inst, ctx, json, params);
    inst.min = (...args)=>inst.check($8tIUC._minSize(...args));
    inst.nonempty = (params)=>inst.check($8tIUC._minSize(1, params));
    inst.max = (...args)=>inst.check($8tIUC._maxSize(...args));
    inst.size = (...args)=>inst.check($8tIUC._size(...args));
});
function set(valueType, params) {
    return new ZodSet({
        type: "set",
        valueType: valueType,
        ...(0, $c0663).normalizeParams(params)
    });
}
const ZodEnum = /*@__PURE__*/ $59TZW.$constructor("ZodEnum", (inst, def)=>{
    $MHJtW.$ZodEnum.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.enumProcessor(inst, ctx, json, params);
    inst.enum = def.entries;
    inst.options = Object.values(def.entries);
    const keys = new Set(Object.keys(def.entries));
    inst.extract = (values, params)=>{
        const newEntries = {};
        for (const value1 of values){
            if (keys.has(value1)) newEntries[value1] = def.entries[value1];
            else throw new Error(`Key ${value1} not found in enum`);
        }
        return new ZodEnum({
            ...def,
            checks: [],
            ...(0, $c0663).normalizeParams(params),
            entries: newEntries
        });
    };
    inst.exclude = (values, params)=>{
        const newEntries = {
            ...def.entries
        };
        for (const value1 of values){
            if (keys.has(value1)) delete newEntries[value1];
            else throw new Error(`Key ${value1} not found in enum`);
        }
        return new ZodEnum({
            ...def,
            checks: [],
            ...(0, $c0663).normalizeParams(params),
            entries: newEntries
        });
    };
});
function _enum(values, params) {
    const entries = Array.isArray(values) ? Object.fromEntries(values.map((v)=>[
            v,
            v
        ])) : values;
    return new ZodEnum({
        type: "enum",
        entries: entries,
        ...(0, $c0663).normalizeParams(params)
    });
}
function nativeEnum(entries, params) {
    return new ZodEnum({
        type: "enum",
        entries: entries,
        ...(0, $c0663).normalizeParams(params)
    });
}
const ZodLiteral = /*@__PURE__*/ $59TZW.$constructor("ZodLiteral", (inst, def)=>{
    $MHJtW.$ZodLiteral.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.literalProcessor(inst, ctx, json, params);
    inst.values = new Set(def.values);
    Object.defineProperty(inst, "value", {
        get () {
            if (def.values.length > 1) throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
            return def.values[0];
        }
    });
});
function literal(value1, params) {
    return new ZodLiteral({
        type: "literal",
        values: Array.isArray(value1) ? value1 : [
            value1
        ],
        ...(0, $c0663).normalizeParams(params)
    });
}
const ZodFile = /*@__PURE__*/ $59TZW.$constructor("ZodFile", (inst, def)=>{
    $MHJtW.$ZodFile.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.fileProcessor(inst, ctx, json, params);
    inst.min = (size, params)=>inst.check($8tIUC._minSize(size, params));
    inst.max = (size, params)=>inst.check($8tIUC._maxSize(size, params));
    inst.mime = (types, params)=>inst.check($8tIUC._mime(Array.isArray(types) ? types : [
            types
        ], params));
});
function file(params) {
    return $8tIUC._file(ZodFile, params);
}
const ZodTransform = /*@__PURE__*/ $59TZW.$constructor("ZodTransform", (inst, def)=>{
    _ensureDefaultMemoizer();
    $MHJtW.$ZodTransform.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.transformProcessor(inst, ctx, json, params);
    inst._zod.parse = (payload, _ctx)=>{
        if (_ctx.direction === "backward") throw new $59TZW.$ZodEncodeError(inst.constructor.name);
        payload.addIssue = (issue)=>{
            if (typeof issue === "string") payload.issues.push((0, $c0663).issue(issue, payload.value, def));
            else {
                // for Zod 3 backwards compatibility
                const _issue = issue;
                if (_issue.fatal) _issue.continue = false;
                _issue.code ?? (_issue.code = "custom");
                if (!("input" in _issue)) _issue.input = payload.value;
                _issue.inst ?? (_issue.inst = inst);
                // _issue.continue ??= true;
                payload.issues.push((0, $c0663).issue(_issue));
            }
        };
        const output = def.transform(payload.value, payload);
        if (output instanceof Promise) return output.then((output)=>{
            payload.value = output;
            return payload;
        });
        payload.value = output;
        return payload;
    };
});
function transform(fn) {
    return new ZodTransform({
        type: "transform",
        transform: fn
    });
}
const ZodOptional = /*@__PURE__*/ $59TZW.$constructor("ZodOptional", (inst, def)=>{
    $MHJtW.$ZodOptional.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.optionalProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function optional(innerType) {
    return new ZodOptional({
        type: "optional",
        innerType: innerType
    });
}
const ZodExactOptional = /*@__PURE__*/ $59TZW.$constructor("ZodExactOptional", (inst, def)=>{
    $MHJtW.$ZodExactOptional.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.optionalProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function exactOptional(innerType) {
    return new ZodExactOptional({
        type: "optional",
        innerType: innerType
    });
}
const ZodNullable = /*@__PURE__*/ $59TZW.$constructor("ZodNullable", (inst, def)=>{
    $MHJtW.$ZodNullable.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.nullableProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function nullable(innerType) {
    return new ZodNullable({
        type: "nullable",
        innerType: innerType
    });
}
function nullish(innerType) {
    return optional(nullable(innerType));
}
const ZodDefault = /*@__PURE__*/ $59TZW.$constructor("ZodDefault", (inst, def)=>{
    $MHJtW.$ZodDefault.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.defaultProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
    inst.removeDefault = inst.unwrap;
});
function _default(innerType, defaultValue) {
    return new ZodDefault({
        type: "default",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : (0, $c0663).shallowClone(defaultValue);
        }
    });
}
const ZodPrefault = /*@__PURE__*/ $59TZW.$constructor("ZodPrefault", (inst, def)=>{
    $MHJtW.$ZodPrefault.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.prefaultProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function prefault(innerType, defaultValue) {
    return new ZodPrefault({
        type: "prefault",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : (0, $c0663).shallowClone(defaultValue);
        }
    });
}
const ZodNonOptional = /*@__PURE__*/ $59TZW.$constructor("ZodNonOptional", (inst, def)=>{
    $MHJtW.$ZodNonOptional.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.nonoptionalProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function nonoptional(innerType, params) {
    return new ZodNonOptional({
        type: "nonoptional",
        innerType: innerType,
        ...(0, $c0663).normalizeParams(params)
    });
}
const ZodSuccess = /*@__PURE__*/ $59TZW.$constructor("ZodSuccess", (inst, def)=>{
    $MHJtW.$ZodSuccess.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.successProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function success(innerType) {
    return new ZodSuccess({
        type: "success",
        innerType: innerType
    });
}
const ZodCatch = /*@__PURE__*/ $59TZW.$constructor("ZodCatch", (inst, def)=>{
    $MHJtW.$ZodCatch.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.catchProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
    inst.removeCatch = inst.unwrap;
});
function _catch(innerType, catchValue) {
    return new ZodCatch({
        type: "catch",
        innerType: innerType,
        catchValue: typeof catchValue === "function" ? catchValue : $c0663.constantCatch(catchValue)
    });
}
const ZodNaN = /*@__PURE__*/ $59TZW.$constructor("ZodNaN", (inst, def)=>{
    $MHJtW.$ZodNaN.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.nanProcessor(inst, ctx, json, params);
});
function nan(params) {
    return $8tIUC._nan(ZodNaN, params);
}
const ZodPipe = /*@__PURE__*/ $59TZW.$constructor("ZodPipe", (inst, def)=>{
    $MHJtW.$ZodPipe.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.pipeProcessor(inst, ctx, json, params);
    inst.in = def.in;
    inst.out = def.out;
});
function pipe(in_, out) {
    return new ZodPipe({
        type: "pipe",
        in: in_,
        out: out
    });
}
const ZodCodec = /*@__PURE__*/ $59TZW.$constructor("ZodCodec", (inst, def)=>{
    ZodPipe.init(inst, def);
    $MHJtW.$ZodCodec.init(inst, def);
});
function codec(in_, out, params) {
    return new ZodCodec({
        type: "pipe",
        in: in_,
        out: out,
        transform: params.decode,
        reverseTransform: params.encode
    });
}
function invertCodec(codec) {
    const def = codec._zod.def;
    return new ZodCodec({
        type: "pipe",
        in: def.out,
        out: def.in,
        transform: def.reverseTransform,
        reverseTransform: def.transform
    });
}
const ZodPreprocess = /*@__PURE__*/ $59TZW.$constructor("ZodPreprocess", (inst, def)=>{
    ZodPipe.init(inst, def);
    $MHJtW.$ZodPreprocess.init(inst, def);
});
const ZodReadonly = /*@__PURE__*/ $59TZW.$constructor("ZodReadonly", (inst, def)=>{
    $MHJtW.$ZodReadonly.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.readonlyProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function readonly(innerType) {
    return new ZodReadonly({
        type: "readonly",
        innerType: innerType
    });
}
const ZodTemplateLiteral = /*@__PURE__*/ $59TZW.$constructor("ZodTemplateLiteral", (inst, def)=>{
    $MHJtW.$ZodTemplateLiteral.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.templateLiteralProcessor(inst, ctx, json, params);
});
function templateLiteral(parts, params) {
    return new ZodTemplateLiteral({
        type: "template_literal",
        parts: parts,
        ...(0, $c0663).normalizeParams(params)
    });
}
const ZodLazy = /*@__PURE__*/ $59TZW.$constructor("ZodLazy", (inst, def)=>{
    $MHJtW.$ZodLazy.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.lazyProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.getter();
});
function lazy(getter) {
    return new ZodLazy({
        type: "lazy",
        getter: getter
    });
}
const ZodPromise = /*@__PURE__*/ $59TZW.$constructor("ZodPromise", (inst, def)=>{
    $MHJtW.$ZodPromise.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.promiseProcessor(inst, ctx, json, params);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function promise(innerType) {
    return new ZodPromise({
        type: "promise",
        innerType: innerType
    });
}
const ZodFunction = /*@__PURE__*/ $59TZW.$constructor("ZodFunction", (inst, def)=>{
    $MHJtW.$ZodFunction.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.functionProcessor(inst, ctx, json, params);
});
function _function(params) {
    return new ZodFunction({
        type: "function",
        input: Array.isArray(params?.input) ? tuple(params?.input) : params?.input ?? array(unknown()),
        output: params?.output ?? unknown()
    });
}
const ZodCustom = /*@__PURE__*/ $59TZW.$constructor("ZodCustom", (inst, def)=>{
    $MHJtW.$ZodCustom.init(inst, def);
    ZodType.init(inst, def);
    inst._zod.processJSONSchema = (ctx, json, params)=>$6iVFp.customProcessor(inst, ctx, json, params);
});
function check(fn) {
    const ch = new $9iCDw.$ZodCheck({
        check: "custom"
    });
    ch._zod.check = fn;
    return ch;
}
function custom(fn, _params) {
    return $8tIUC._custom(ZodCustom, fn ?? (()=>true), _params);
}
function refine(fn, _params = {}) {
    return $8tIUC._refine(ZodCustom, fn, _params);
}
function superRefine(fn, params) {
    return $8tIUC._superRefine(fn, params);
}
const describe = $8tIUC.describe;
const meta = $8tIUC.meta;
function _instanceof(cls, params = {}) {
    const inst = new ZodCustom({
        type: "custom",
        check: "custom",
        fn: (data)=>data instanceof cls,
        abort: true,
        ...(0, $c0663).normalizeParams(params)
    });
    inst._zod.bag.Class = cls;
    // Override check to emit invalid_type instead of custom
    inst._zod.check = (payload)=>{
        if (!(payload.value instanceof cls)) payload.issues.push({
            code: "invalid_type",
            expected: cls.name,
            input: payload.value,
            inst: inst,
            path: [
                ...inst._zod.def.path ?? []
            ]
        });
    };
    return inst;
}
const stringbool = (...args)=>$8tIUC._stringbool({
        Codec: ZodCodec,
        Boolean: ZodBoolean,
        String: ZodString
    }, ...args);
function json(params) {
    const jsonSchema = lazy(()=>{
        return union([
            string(params),
            number(),
            boolean(),
            _null(),
            array(jsonSchema),
            record(string(), jsonSchema)
        ]);
    });
    return jsonSchema;
}
function preprocess(fn, schema) {
    return new ZodPreprocess({
        type: "pipe",
        in: transform(fn),
        out: schema
    });
}

});
parcelRegister("8tIUC", function(module, exports) {

$parcel$export(module.exports, "_string", function () { return $62c3dec5fa9ab363$export$25986a84359f8f7f; });
$parcel$export(module.exports, "_email", function () { return $62c3dec5fa9ab363$export$471b39521bec3299; });
$parcel$export(module.exports, "_guid", function () { return $62c3dec5fa9ab363$export$129b5399d64cccb0; });
$parcel$export(module.exports, "_uuid", function () { return $62c3dec5fa9ab363$export$f2f3139038bea52c; });
$parcel$export(module.exports, "_uuidv4", function () { return $62c3dec5fa9ab363$export$a5559d7da37a112f; });
$parcel$export(module.exports, "_uuidv6", function () { return $62c3dec5fa9ab363$export$53b427a8173231a; });
$parcel$export(module.exports, "_uuidv7", function () { return $62c3dec5fa9ab363$export$588d23d6e9ec2ed5; });
$parcel$export(module.exports, "_url", function () { return $62c3dec5fa9ab363$export$e3f203373341d39; });
$parcel$export(module.exports, "_emoji", function () { return $62c3dec5fa9ab363$export$936e26d261396f46; });
$parcel$export(module.exports, "_nanoid", function () { return $62c3dec5fa9ab363$export$a030949b19390ea0; });
$parcel$export(module.exports, "_cuid", function () { return $62c3dec5fa9ab363$export$639125837b796148; });
$parcel$export(module.exports, "_cuid2", function () { return $62c3dec5fa9ab363$export$36b63ef9af7972c2; });
$parcel$export(module.exports, "_ulid", function () { return $62c3dec5fa9ab363$export$95acf3b3fa11bdc9; });
$parcel$export(module.exports, "_xid", function () { return $62c3dec5fa9ab363$export$bbb0a2cfb079fa90; });
$parcel$export(module.exports, "_ksuid", function () { return $62c3dec5fa9ab363$export$1306ede2f9ea153f; });
$parcel$export(module.exports, "_ipv4", function () { return $62c3dec5fa9ab363$export$c77a1c80cebc2aad; });
$parcel$export(module.exports, "_ipv6", function () { return $62c3dec5fa9ab363$export$964dfe0e2e4e8895; });
$parcel$export(module.exports, "_mac", function () { return $62c3dec5fa9ab363$export$84f8b3e041d8e7d9; });
$parcel$export(module.exports, "_cidrv4", function () { return $62c3dec5fa9ab363$export$feaac4e27a421ddc; });
$parcel$export(module.exports, "_cidrv6", function () { return $62c3dec5fa9ab363$export$a0518ffc5273ec92; });
$parcel$export(module.exports, "_base64", function () { return $62c3dec5fa9ab363$export$9fdb09384fbc4988; });
$parcel$export(module.exports, "_base64url", function () { return $62c3dec5fa9ab363$export$178c70fb89c949fa; });
$parcel$export(module.exports, "_e164", function () { return $62c3dec5fa9ab363$export$b8bf0b70d4bc7855; });
$parcel$export(module.exports, "_creditCard", function () { return $62c3dec5fa9ab363$export$86d44988408f3a7f; });
$parcel$export(module.exports, "_jwt", function () { return $62c3dec5fa9ab363$export$4a9318e6b46f1aa1; });
$parcel$export(module.exports, "_isoDateTime", function () { return $62c3dec5fa9ab363$export$a62adeb27809351b; });
$parcel$export(module.exports, "_isoDate", function () { return $62c3dec5fa9ab363$export$e4f19dd0a54e7a59; });
$parcel$export(module.exports, "_isoTime", function () { return $62c3dec5fa9ab363$export$36f9f051d5e817c; });
$parcel$export(module.exports, "_isoDuration", function () { return $62c3dec5fa9ab363$export$7d70539c76fbff4; });
$parcel$export(module.exports, "_number", function () { return $62c3dec5fa9ab363$export$9249bb0b45639623; });
$parcel$export(module.exports, "_int", function () { return $62c3dec5fa9ab363$export$3d5b343b1f51efdd; });
$parcel$export(module.exports, "_float32", function () { return $62c3dec5fa9ab363$export$656ad65d6cf64174; });
$parcel$export(module.exports, "_float64", function () { return $62c3dec5fa9ab363$export$9ddff8176107cc11; });
$parcel$export(module.exports, "_int32", function () { return $62c3dec5fa9ab363$export$5ec965fd114a2f9f; });
$parcel$export(module.exports, "_uint32", function () { return $62c3dec5fa9ab363$export$a43c28c6e86e066e; });
$parcel$export(module.exports, "_boolean", function () { return $62c3dec5fa9ab363$export$e23c41ce5ce2db39; });
$parcel$export(module.exports, "_bigint", function () { return $62c3dec5fa9ab363$export$c96ff33878177e4c; });
$parcel$export(module.exports, "_int64", function () { return $62c3dec5fa9ab363$export$cb7d3ec922804f3f; });
$parcel$export(module.exports, "_uint64", function () { return $62c3dec5fa9ab363$export$c51606f0dfa0f5a1; });
$parcel$export(module.exports, "_symbol", function () { return $62c3dec5fa9ab363$export$a8f93f5b7c030e84; });
$parcel$export(module.exports, "_undefined", function () { return $62c3dec5fa9ab363$export$60e4c9fe67803d40; });
$parcel$export(module.exports, "_null", function () { return $62c3dec5fa9ab363$export$a2cbb38cda512d16; });
$parcel$export(module.exports, "_any", function () { return $62c3dec5fa9ab363$export$4678886173313220; });
$parcel$export(module.exports, "_unknown", function () { return $62c3dec5fa9ab363$export$e0ed508a47e00801; });
$parcel$export(module.exports, "_never", function () { return $62c3dec5fa9ab363$export$887f43204ffc2a69; });
$parcel$export(module.exports, "_void", function () { return $62c3dec5fa9ab363$export$9480825d3c8e9ad6; });
$parcel$export(module.exports, "_date", function () { return $62c3dec5fa9ab363$export$da799735c76175a; });
$parcel$export(module.exports, "_nan", function () { return $62c3dec5fa9ab363$export$a5e7e1f8491a5e50; });
$parcel$export(module.exports, "_lt", function () { return $62c3dec5fa9ab363$export$2a42c74e76a068a; });
$parcel$export(module.exports, "_lte", function () { return $62c3dec5fa9ab363$export$7a060cf3d60b84a6; });
$parcel$export(module.exports, "_gt", function () { return $62c3dec5fa9ab363$export$7582466e3ab4d25b; });
$parcel$export(module.exports, "_gte", function () { return $62c3dec5fa9ab363$export$a1c6d8834a3b19c9; });
$parcel$export(module.exports, "_multipleOf", function () { return $62c3dec5fa9ab363$export$c41e40f80e978ab1; });
$parcel$export(module.exports, "_maxSize", function () { return $62c3dec5fa9ab363$export$3eed6ccb98bc18db; });
$parcel$export(module.exports, "_minSize", function () { return $62c3dec5fa9ab363$export$e379713268c2c18a; });
$parcel$export(module.exports, "_size", function () { return $62c3dec5fa9ab363$export$2621565b966a8d23; });
$parcel$export(module.exports, "_maxLength", function () { return $62c3dec5fa9ab363$export$ec76627108655a22; });
$parcel$export(module.exports, "_minLength", function () { return $62c3dec5fa9ab363$export$21f6711a906c1450; });
$parcel$export(module.exports, "_length", function () { return $62c3dec5fa9ab363$export$620b9f7ab17ff8a9; });
$parcel$export(module.exports, "_regex", function () { return $62c3dec5fa9ab363$export$c4768a1bd8f8393; });
$parcel$export(module.exports, "_lowercase", function () { return $62c3dec5fa9ab363$export$ea67c3edeec85c63; });
$parcel$export(module.exports, "_uppercase", function () { return $62c3dec5fa9ab363$export$2998381b41c6902a; });
$parcel$export(module.exports, "_includes", function () { return $62c3dec5fa9ab363$export$fccf016a6caa651d; });
$parcel$export(module.exports, "_startsWith", function () { return $62c3dec5fa9ab363$export$2f37aaf99060de76; });
$parcel$export(module.exports, "_endsWith", function () { return $62c3dec5fa9ab363$export$eaeaa2fcd833167e; });
$parcel$export(module.exports, "_mime", function () { return $62c3dec5fa9ab363$export$267177285a1a8b37; });
$parcel$export(module.exports, "_overwrite", function () { return $62c3dec5fa9ab363$export$aeea8f004f34f8c2; });
$parcel$export(module.exports, "_normalize", function () { return $62c3dec5fa9ab363$export$2b99bb23a814f78e; });
$parcel$export(module.exports, "_trim", function () { return $62c3dec5fa9ab363$export$8be2de0b60774d1e; });
$parcel$export(module.exports, "_toLowerCase", function () { return $62c3dec5fa9ab363$export$d9cfe939403a2525; });
$parcel$export(module.exports, "_toUpperCase", function () { return $62c3dec5fa9ab363$export$cf76ef1ae9e9944e; });
$parcel$export(module.exports, "_slugify", function () { return $62c3dec5fa9ab363$export$2801993b93f3c232; });
$parcel$export(module.exports, "_array", function () { return $62c3dec5fa9ab363$export$4ea446333e3db634; });
$parcel$export(module.exports, "_file", function () { return $62c3dec5fa9ab363$export$e335cd0b9f8bab1e; });
$parcel$export(module.exports, "_custom", function () { return $62c3dec5fa9ab363$export$8bfc2ce1398e3071; });
$parcel$export(module.exports, "_refine", function () { return $62c3dec5fa9ab363$export$ac822e05051812e1; });
$parcel$export(module.exports, "_superRefine", function () { return $62c3dec5fa9ab363$export$f2b01ecb843d7ab9; });
$parcel$export(module.exports, "describe", function () { return $62c3dec5fa9ab363$export$cd5450f3a47e3789; });
$parcel$export(module.exports, "meta", function () { return $62c3dec5fa9ab363$export$6990040ee07315; });
$parcel$export(module.exports, "_stringbool", function () { return $62c3dec5fa9ab363$export$a75528509e3a7006; });
$parcel$export(module.exports, "_stringFormat", function () { return $62c3dec5fa9ab363$export$e25dde89ba546b88; });

var $9iCDw = parcelRequire("9iCDw");

var $eTOwy = parcelRequire("eTOwy");

var $MHJtW = parcelRequire("MHJtW");

var $c0663 = parcelRequire("c0663");
function $62c3dec5fa9ab363$export$25986a84359f8f7f(Class, params) {
    return new Class({
        type: "string",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$614049477c642ce0(Class, params) {
    return new Class({
        type: "string",
        coerce: true,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$471b39521bec3299(Class, params) {
    return new Class({
        type: "string",
        format: "email",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$129b5399d64cccb0(Class, params) {
    return new Class({
        type: "string",
        format: "guid",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$f2f3139038bea52c(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$a5559d7da37a112f(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v4",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$53b427a8173231a(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v6",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$588d23d6e9ec2ed5(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v7",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$e3f203373341d39(Class, params) {
    return new Class({
        type: "string",
        format: "url",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$936e26d261396f46(Class, params) {
    return new Class({
        type: "string",
        format: "emoji",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$a030949b19390ea0(Class, params) {
    return new Class({
        type: "string",
        format: "nanoid",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$639125837b796148(Class, params) {
    return new Class({
        type: "string",
        format: "cuid",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$36b63ef9af7972c2(Class, params) {
    return new Class({
        type: "string",
        format: "cuid2",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$95acf3b3fa11bdc9(Class, params) {
    return new Class({
        type: "string",
        format: "ulid",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$bbb0a2cfb079fa90(Class, params) {
    return new Class({
        type: "string",
        format: "xid",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$1306ede2f9ea153f(Class, params) {
    return new Class({
        type: "string",
        format: "ksuid",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$c77a1c80cebc2aad(Class, params) {
    return new Class({
        type: "string",
        format: "ipv4",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$964dfe0e2e4e8895(Class, params) {
    return new Class({
        type: "string",
        format: "ipv6",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$84f8b3e041d8e7d9(Class, params) {
    return new Class({
        type: "string",
        format: "mac",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$feaac4e27a421ddc(Class, params) {
    return new Class({
        type: "string",
        format: "cidrv4",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$a0518ffc5273ec92(Class, params) {
    return new Class({
        type: "string",
        format: "cidrv6",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$9fdb09384fbc4988(Class, params) {
    return new Class({
        type: "string",
        format: "base64",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$178c70fb89c949fa(Class, params) {
    return new Class({
        type: "string",
        format: "base64url",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$b8bf0b70d4bc7855(Class, params) {
    return new Class({
        type: "string",
        format: "e164",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$86d44988408f3a7f(Class, params) {
    return new Class({
        type: "string",
        format: "credit_card",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$4a9318e6b46f1aa1(Class, params) {
    return new Class({
        type: "string",
        format: "jwt",
        check: "string_format",
        abort: false,
        ...$c0663.normalizeParams(params)
    });
}
const $62c3dec5fa9ab363$export$3a3ade082c590099 = {
    Any: null,
    Minute: -1,
    Second: 0,
    Millisecond: 3,
    Microsecond: 6
};
function $62c3dec5fa9ab363$export$a62adeb27809351b(Class, params) {
    return new Class({
        type: "string",
        format: "datetime",
        check: "string_format",
        offset: false,
        local: false,
        precision: null,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$e4f19dd0a54e7a59(Class, params) {
    return new Class({
        type: "string",
        format: "date",
        check: "string_format",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$36f9f051d5e817c(Class, params) {
    return new Class({
        type: "string",
        format: "time",
        check: "string_format",
        precision: null,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$7d70539c76fbff4(Class, params) {
    return new Class({
        type: "string",
        format: "duration",
        check: "string_format",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$9249bb0b45639623(Class, params) {
    return new Class({
        type: "number",
        checks: [],
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$272511620e4661dd(Class, params) {
    return new Class({
        type: "number",
        coerce: true,
        checks: [],
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$3d5b343b1f51efdd(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "safeint",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$656ad65d6cf64174(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "float32",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$9ddff8176107cc11(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "float64",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$5ec965fd114a2f9f(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "int32",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$a43c28c6e86e066e(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "uint32",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$e23c41ce5ce2db39(Class, params) {
    return new Class({
        type: "boolean",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$c3eb0e1c7c887e5c(Class, params) {
    return new Class({
        type: "boolean",
        coerce: true,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$c96ff33878177e4c(Class, params) {
    return new Class({
        type: "bigint",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$8ff745acc355d077(Class, params) {
    return new Class({
        type: "bigint",
        coerce: true,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$cb7d3ec922804f3f(Class, params) {
    return new Class({
        type: "bigint",
        check: "bigint_format",
        abort: false,
        format: "int64",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$c51606f0dfa0f5a1(Class, params) {
    return new Class({
        type: "bigint",
        check: "bigint_format",
        abort: false,
        format: "uint64",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$a8f93f5b7c030e84(Class, params) {
    return new Class({
        type: "symbol",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$60e4c9fe67803d40(Class, params) {
    return new Class({
        type: "undefined",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$a2cbb38cda512d16(Class, params) {
    return new Class({
        type: "null",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$4678886173313220(Class) {
    return new Class({
        type: "any"
    });
}
function $62c3dec5fa9ab363$export$e0ed508a47e00801(Class) {
    return new Class({
        type: "unknown"
    });
}
function $62c3dec5fa9ab363$export$887f43204ffc2a69(Class, params) {
    return new Class({
        type: "never",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$9480825d3c8e9ad6(Class, params) {
    return new Class({
        type: "void",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$da799735c76175a(Class, params) {
    return new Class({
        type: "date",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$2efeac445ea43f33(Class, params) {
    return new Class({
        type: "date",
        coerce: true,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$a5e7e1f8491a5e50(Class, params) {
    return new Class({
        type: "nan",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$2a42c74e76a068a(value, params) {
    return new $9iCDw.$ZodCheckLessThan({
        check: "less_than",
        ...$c0663.normalizeParams(params),
        value: value,
        inclusive: false
    });
}
function $62c3dec5fa9ab363$export$7a060cf3d60b84a6(value, params) {
    return new $9iCDw.$ZodCheckLessThan({
        check: "less_than",
        ...$c0663.normalizeParams(params),
        value: value,
        inclusive: true
    });
}
function $62c3dec5fa9ab363$export$7582466e3ab4d25b(value, params) {
    return new $9iCDw.$ZodCheckGreaterThan({
        check: "greater_than",
        ...$c0663.normalizeParams(params),
        value: value,
        inclusive: false
    });
}
function $62c3dec5fa9ab363$export$a1c6d8834a3b19c9(value, params) {
    return new $9iCDw.$ZodCheckGreaterThan({
        check: "greater_than",
        ...$c0663.normalizeParams(params),
        value: value,
        inclusive: true
    });
}
function $62c3dec5fa9ab363$export$ddfc6f0a2e49a568(params) {
    return $62c3dec5fa9ab363$export$7582466e3ab4d25b(0, params);
}
function $62c3dec5fa9ab363$export$d30568dda7134ca5(params) {
    return $62c3dec5fa9ab363$export$2a42c74e76a068a(0, params);
}
function $62c3dec5fa9ab363$export$c3e51eea33419c94(params) {
    return $62c3dec5fa9ab363$export$7a060cf3d60b84a6(0, params);
}
function $62c3dec5fa9ab363$export$93ec5f75848b1928(params) {
    return $62c3dec5fa9ab363$export$a1c6d8834a3b19c9(0, params);
}
function $62c3dec5fa9ab363$export$c41e40f80e978ab1(value, params) {
    return new $9iCDw.$ZodCheckMultipleOf({
        check: "multiple_of",
        ...$c0663.normalizeParams(params),
        value: value
    });
}
function $62c3dec5fa9ab363$export$3eed6ccb98bc18db(maximum, params) {
    return new $9iCDw.$ZodCheckMaxSize({
        check: "max_size",
        ...$c0663.normalizeParams(params),
        maximum: maximum
    });
}
function $62c3dec5fa9ab363$export$e379713268c2c18a(minimum, params) {
    return new $9iCDw.$ZodCheckMinSize({
        check: "min_size",
        ...$c0663.normalizeParams(params),
        minimum: minimum
    });
}
function $62c3dec5fa9ab363$export$2621565b966a8d23(size, params) {
    return new $9iCDw.$ZodCheckSizeEquals({
        check: "size_equals",
        ...$c0663.normalizeParams(params),
        size: size
    });
}
function $62c3dec5fa9ab363$export$ec76627108655a22(maximum, params) {
    const ch = new $9iCDw.$ZodCheckMaxLength({
        check: "max_length",
        ...$c0663.normalizeParams(params),
        maximum: maximum
    });
    return ch;
}
function $62c3dec5fa9ab363$export$21f6711a906c1450(minimum, params) {
    return new $9iCDw.$ZodCheckMinLength({
        check: "min_length",
        ...$c0663.normalizeParams(params),
        minimum: minimum
    });
}
function $62c3dec5fa9ab363$export$620b9f7ab17ff8a9(length, params) {
    return new $9iCDw.$ZodCheckLengthEquals({
        check: "length_equals",
        ...$c0663.normalizeParams(params),
        length: length
    });
}
function $62c3dec5fa9ab363$export$c4768a1bd8f8393(pattern, params) {
    return new $9iCDw.$ZodCheckRegex({
        check: "string_format",
        format: "regex",
        ...$c0663.normalizeParams(params),
        pattern: pattern
    });
}
function $62c3dec5fa9ab363$export$ea67c3edeec85c63(params) {
    return new $9iCDw.$ZodCheckLowerCase({
        check: "string_format",
        format: "lowercase",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$2998381b41c6902a(params) {
    return new $9iCDw.$ZodCheckUpperCase({
        check: "string_format",
        format: "uppercase",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$fccf016a6caa651d(includes, params) {
    return new $9iCDw.$ZodCheckIncludes({
        check: "string_format",
        format: "includes",
        ...$c0663.normalizeParams(params),
        includes: includes
    });
}
function $62c3dec5fa9ab363$export$2f37aaf99060de76(prefix, params) {
    return new $9iCDw.$ZodCheckStartsWith({
        check: "string_format",
        format: "starts_with",
        ...$c0663.normalizeParams(params),
        prefix: prefix
    });
}
function $62c3dec5fa9ab363$export$eaeaa2fcd833167e(suffix, params) {
    return new $9iCDw.$ZodCheckEndsWith({
        check: "string_format",
        format: "ends_with",
        ...$c0663.normalizeParams(params),
        suffix: suffix
    });
}
function $62c3dec5fa9ab363$export$537db06738ee7f1b(property, schema, params) {
    return new $9iCDw.$ZodCheckProperty({
        check: "property",
        property: property,
        schema: schema,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$a72788ae987f5bef(shape) {
    return Object.entries(shape).map(([property, schema])=>new $9iCDw.$ZodCheckProperty({
            check: "property",
            property: property,
            schema: schema
        }));
}
function $62c3dec5fa9ab363$export$267177285a1a8b37(types, params) {
    return new $9iCDw.$ZodCheckMimeType({
        check: "mime_type",
        mime: types,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$aeea8f004f34f8c2(tx) {
    return new $9iCDw.$ZodCheckOverwrite({
        check: "overwrite",
        tx: tx
    });
}
function $62c3dec5fa9ab363$export$2b99bb23a814f78e(form) {
    return $62c3dec5fa9ab363$export$aeea8f004f34f8c2((input)=>input.normalize(form));
}
function $62c3dec5fa9ab363$export$8be2de0b60774d1e() {
    return $62c3dec5fa9ab363$export$aeea8f004f34f8c2((input)=>input.trim());
}
function $62c3dec5fa9ab363$export$d9cfe939403a2525() {
    return $62c3dec5fa9ab363$export$aeea8f004f34f8c2((input)=>input.toLowerCase());
}
function $62c3dec5fa9ab363$export$cf76ef1ae9e9944e() {
    return $62c3dec5fa9ab363$export$aeea8f004f34f8c2((input)=>input.toUpperCase());
}
function $62c3dec5fa9ab363$export$2801993b93f3c232() {
    return $62c3dec5fa9ab363$export$aeea8f004f34f8c2((input)=>$c0663.slugify(input));
}
function $62c3dec5fa9ab363$export$4ea446333e3db634(Class, element, params) {
    return new Class({
        type: "array",
        element: element,
        // get element() {
        //   return element;
        // },
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$48eec03fd15d025b(Class, options, params) {
    return new Class({
        type: "union",
        options: options,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$d941708f3b69bf5a(Class, options, params) {
    return new Class({
        type: "union",
        options: options,
        inclusive: false,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$ffbf51421b0acee1(Class, discriminator, options, params) {
    return new Class({
        type: "union",
        options: options,
        discriminator: discriminator,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$3d0d84e16c5ea809(Class, left, right) {
    return new Class({
        type: "intersection",
        left: left,
        right: right
    });
}
function $62c3dec5fa9ab363$export$a13693bfb304605a(Class, items, _paramsOrRest, _params) {
    const hasRest = _paramsOrRest instanceof $MHJtW.$ZodType;
    const params = hasRest ? _params : _paramsOrRest;
    const rest = hasRest ? _paramsOrRest : null;
    return new Class({
        type: "tuple",
        items: items,
        rest: rest,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$64440e3f2e29d7bc(Class, keyType, valueType, params) {
    return new Class({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$a0135aecf4a782ab(Class, keyType, valueType, params) {
    return new Class({
        type: "map",
        keyType: keyType,
        valueType: valueType,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$c37fd9e9b598996d(Class, valueType, params) {
    return new Class({
        type: "set",
        valueType: valueType,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$3290a9b46bcfecc1(Class, values, params) {
    const entries = Array.isArray(values) ? Object.fromEntries(values.map((v)=>[
            v,
            v
        ])) : values;
    // if (Array.isArray(values)) {
    //   for (const value of values) {
    //     entries[value] = value;
    //   }
    // } else {
    //   Object.assign(entries, values);
    // }
    // const entries: util.EnumLike = {};
    // for (const val of values) {
    //   entries[val] = val;
    // }
    return new Class({
        type: "enum",
        entries: entries,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$6b94bba2375b9e3d(Class, entries, params) {
    return new Class({
        type: "enum",
        entries: entries,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$a03e276eec27de8b(Class, value, params) {
    return new Class({
        type: "literal",
        values: Array.isArray(value) ? value : [
            value
        ],
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$e335cd0b9f8bab1e(Class, params) {
    return new Class({
        type: "file",
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$fa4a3df4db7f3166(Class, fn) {
    return new Class({
        type: "transform",
        transform: fn
    });
}
function $62c3dec5fa9ab363$export$6d07c57dda792495(Class, innerType) {
    return new Class({
        type: "optional",
        innerType: innerType
    });
}
function $62c3dec5fa9ab363$export$4e46ee4534ff341d(Class, innerType) {
    return new Class({
        type: "nullable",
        innerType: innerType
    });
}
function $62c3dec5fa9ab363$export$d4b0f68d0d916971(Class, innerType, defaultValue) {
    return new Class({
        type: "default",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : $c0663.shallowClone(defaultValue);
        }
    });
}
function $62c3dec5fa9ab363$export$24cb0533b28b009b(Class, innerType, params) {
    return new Class({
        type: "nonoptional",
        innerType: innerType,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$6f570707f72cba02(Class, innerType) {
    return new Class({
        type: "success",
        innerType: innerType
    });
}
function $62c3dec5fa9ab363$export$7f43fa37c3d8a0b3(Class, innerType, catchValue) {
    return new Class({
        type: "catch",
        innerType: innerType,
        catchValue: typeof catchValue === "function" ? catchValue : $c0663.constantCatch(catchValue)
    });
}
function $62c3dec5fa9ab363$export$fc24e256ce7b145(Class, in_, out) {
    return new Class({
        type: "pipe",
        in: in_,
        out: out
    });
}
function $62c3dec5fa9ab363$export$4fe7ff2cfb7a6dd7(Class, innerType) {
    return new Class({
        type: "readonly",
        innerType: innerType
    });
}
function $62c3dec5fa9ab363$export$f30d99994777b6d(Class, parts, params) {
    return new Class({
        type: "template_literal",
        parts: parts,
        ...$c0663.normalizeParams(params)
    });
}
function $62c3dec5fa9ab363$export$137d76f65e4bcae1(Class, getter) {
    return new Class({
        type: "lazy",
        getter: getter
    });
}
function $62c3dec5fa9ab363$export$d91bbb815217feb6(Class, innerType) {
    return new Class({
        type: "promise",
        innerType: innerType
    });
}
function $62c3dec5fa9ab363$export$8bfc2ce1398e3071(Class, fn, _params) {
    const norm = $c0663.normalizeParams(_params);
    norm.abort ?? (norm.abort = true); // default to abort:false
    const schema = new Class({
        type: "custom",
        check: "custom",
        fn: fn,
        ...norm
    });
    return schema;
}
function $62c3dec5fa9ab363$export$ac822e05051812e1(Class, fn, _params) {
    const schema = new Class({
        type: "custom",
        check: "custom",
        fn: fn,
        ...$c0663.normalizeParams(_params)
    });
    return schema;
}
function $62c3dec5fa9ab363$export$f2b01ecb843d7ab9(fn, params) {
    const ch = $62c3dec5fa9ab363$export$d37145829e4ff88e((payload)=>{
        payload.addIssue = (issue)=>{
            if (typeof issue === "string") payload.issues.push($c0663.issue(issue, payload.value, ch._zod.def));
            else {
                // for Zod 3 backwards compatibility
                const _issue = issue;
                if (_issue.fatal) _issue.continue = false;
                _issue.code ?? (_issue.code = "custom");
                if (!("input" in _issue)) _issue.input = payload.value;
                _issue.inst ?? (_issue.inst = ch);
                _issue.continue ?? (_issue.continue = !ch._zod.def.abort); // abort is always undefined, so this is always true...
                payload.issues.push($c0663.issue(_issue));
            }
        };
        return fn(payload.value, payload);
    }, params);
    return ch;
}
function $62c3dec5fa9ab363$export$d37145829e4ff88e(fn, params) {
    const ch = new $9iCDw.$ZodCheck({
        check: "custom",
        ...$c0663.normalizeParams(params)
    });
    ch._zod.check = fn;
    return ch;
}
function $62c3dec5fa9ab363$export$cd5450f3a47e3789(description) {
    const ch = new $9iCDw.$ZodCheck({
        check: "describe"
    });
    ch._zod.onattach = [
        (inst)=>{
            const existing = $eTOwy.globalRegistry.get(inst) ?? {};
            $eTOwy.globalRegistry.add(inst, {
                ...existing,
                description: description
            });
        }
    ];
    ch._zod.check = ()=>{}; // no-op check
    return ch;
}
function $62c3dec5fa9ab363$export$6990040ee07315(metadata) {
    const ch = new $9iCDw.$ZodCheck({
        check: "meta"
    });
    ch._zod.onattach = [
        (inst)=>{
            const existing = $eTOwy.globalRegistry.get(inst) ?? {};
            $eTOwy.globalRegistry.add(inst, {
                ...existing,
                ...metadata
            });
        }
    ];
    ch._zod.check = ()=>{}; // no-op check
    return ch;
}
function $62c3dec5fa9ab363$export$a75528509e3a7006(Classes, _params) {
    const params = $c0663.normalizeParams(_params);
    let truthyArray = params.truthy ?? [
        "true",
        "1",
        "yes",
        "on",
        "y",
        "enabled"
    ];
    let falsyArray = params.falsy ?? [
        "false",
        "0",
        "no",
        "off",
        "n",
        "disabled"
    ];
    if (params.case !== "sensitive") {
        truthyArray = truthyArray.map((v)=>typeof v === "string" ? v.toLowerCase() : v);
        falsyArray = falsyArray.map((v)=>typeof v === "string" ? v.toLowerCase() : v);
    }
    const truthySet = new Set(truthyArray);
    const falsySet = new Set(falsyArray);
    const _Codec = Classes.Codec ?? $MHJtW.$ZodCodec;
    const _Boolean = Classes.Boolean ?? $MHJtW.$ZodBoolean;
    const _String = Classes.String ?? $MHJtW.$ZodString;
    const stringSchema = new _String({
        type: "string",
        error: params.error
    });
    const booleanSchema = new _Boolean({
        type: "boolean",
        error: params.error
    });
    const codec = new _Codec({
        type: "pipe",
        in: stringSchema,
        out: booleanSchema,
        transform: (input, payload)=>{
            let data = input;
            if (params.case !== "sensitive") data = data.toLowerCase();
            if (truthySet.has(data)) return true;
            else if (falsySet.has(data)) return false;
            else {
                payload.issues.push({
                    code: "invalid_value",
                    expected: "stringbool",
                    values: [
                        ...truthySet,
                        ...falsySet
                    ],
                    input: payload.value,
                    inst: codec,
                    continue: false
                });
                return {};
            }
        },
        reverseTransform: (input, _payload)=>{
            if (input === true) return truthyArray[0] || "true";
            else return falsyArray[0] || "false";
        },
        error: params.error
    });
    codec._zod.bag.truthy = truthyArray;
    codec._zod.bag.falsy = falsyArray;
    codec._zod.bag.case = params.case ?? "insensitive";
    return codec;
}
function $62c3dec5fa9ab363$export$e25dde89ba546b88(Class, format, fnOrRegex, _params = {}) {
    const params = $c0663.normalizeParams(_params);
    const def = {
        check: "string_format",
        type: "string",
        format: format,
        fn: typeof fnOrRegex === "function" ? fnOrRegex : (val)=>fnOrRegex.test(val),
        ...params
    };
    if (fnOrRegex instanceof RegExp) def.pattern = fnOrRegex;
    const inst = new Class(def);
    return inst;
}

});
parcelRegister("9iCDw", function(module, exports) {

$parcel$export(module.exports, "$ZodCheck", function () { return $6c53c3e6ac94ab84$export$c05d9110ef20bb2c; });
$parcel$export(module.exports, "$ZodCheckLessThan", function () { return $6c53c3e6ac94ab84$export$294415ecbdd02022; });
$parcel$export(module.exports, "$ZodCheckGreaterThan", function () { return $6c53c3e6ac94ab84$export$8b670f58decbca18; });
$parcel$export(module.exports, "$ZodCheckMultipleOf", function () { return $6c53c3e6ac94ab84$export$ae602e11c1dd0628; });
$parcel$export(module.exports, "$ZodCheckNumberFormat", function () { return $6c53c3e6ac94ab84$export$5c26c85ad6aed3e8; });
$parcel$export(module.exports, "$ZodCheckBigIntFormat", function () { return $6c53c3e6ac94ab84$export$a0a6d75ce7dc4d36; });
$parcel$export(module.exports, "$ZodCheckMaxSize", function () { return $6c53c3e6ac94ab84$export$b3cec505675cf50c; });
$parcel$export(module.exports, "$ZodCheckMinSize", function () { return $6c53c3e6ac94ab84$export$59fb0a2e7217c42b; });
$parcel$export(module.exports, "$ZodCheckSizeEquals", function () { return $6c53c3e6ac94ab84$export$af532c490f33cd47; });
$parcel$export(module.exports, "$ZodCheckMaxLength", function () { return $6c53c3e6ac94ab84$export$b07b097887f4c15a; });
$parcel$export(module.exports, "$ZodCheckMinLength", function () { return $6c53c3e6ac94ab84$export$cd5336aa96b8417c; });
$parcel$export(module.exports, "$ZodCheckLengthEquals", function () { return $6c53c3e6ac94ab84$export$ccdb9b9d477068fb; });
$parcel$export(module.exports, "$ZodCheckStringFormat", function () { return $6c53c3e6ac94ab84$export$e0c7f6847ab1b629; });
$parcel$export(module.exports, "$ZodCheckRegex", function () { return $6c53c3e6ac94ab84$export$6faea86ff718d6df; });
$parcel$export(module.exports, "$ZodCheckLowerCase", function () { return $6c53c3e6ac94ab84$export$e18e268bd5c9f27a; });
$parcel$export(module.exports, "$ZodCheckUpperCase", function () { return $6c53c3e6ac94ab84$export$6d0944a5127e820a; });
$parcel$export(module.exports, "$ZodCheckIncludes", function () { return $6c53c3e6ac94ab84$export$600021c28f0498dc; });
$parcel$export(module.exports, "$ZodCheckStartsWith", function () { return $6c53c3e6ac94ab84$export$8e83a74b4b83cc62; });
$parcel$export(module.exports, "$ZodCheckEndsWith", function () { return $6c53c3e6ac94ab84$export$4a10f85c6af4e92; });
$parcel$export(module.exports, "$ZodCheckProperty", function () { return $6c53c3e6ac94ab84$export$d36a4eecd766dbc0; });
$parcel$export(module.exports, "$ZodCheckMimeType", function () { return $6c53c3e6ac94ab84$export$5546147f1877f806; });
$parcel$export(module.exports, "$ZodCheckOverwrite", function () { return $6c53c3e6ac94ab84$export$1bda1934456013d3; });
// import { $ZodType } from "./schemas.js";

var $59TZW = parcelRequire("59TZW");

var $6iLpq = parcelRequire("6iLpq");

var $c0663 = parcelRequire("c0663");
const $6c53c3e6ac94ab84$export$c05d9110ef20bb2c = /*@__PURE__*/ $59TZW.$constructor("$ZodCheck", (inst, def)=>{
    var _a;
    inst._zod ?? (inst._zod = {});
    inst._zod.def = def;
    (_a = inst._zod).onattach ?? (_a.onattach = []);
});
/** Default `when` for size-based checks: run only on non-nullish values with a `size`. */ const $6c53c3e6ac94ab84$var$_whenHasSize = (payload)=>{
    const val = payload.value;
    return !$c0663.nullish(val) && val.size !== undefined;
};
/** Default `when` for length-based checks: run only on non-nullish values with a `length`. */ const $6c53c3e6ac94ab84$var$_whenHasLength = (payload)=>{
    const val = payload.value;
    return !$c0663.nullish(val) && val.length !== undefined;
};
const $6c53c3e6ac94ab84$var$numericOriginMap = {
    number: "number",
    bigint: "bigint",
    object: "date"
};
const $6c53c3e6ac94ab84$export$294415ecbdd02022 = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckLessThan", (inst, def)=>{
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def);
    const origin = $6c53c3e6ac94ab84$var$numericOriginMap[typeof def.value];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        const curr = (def.inclusive ? bag.maximum : bag.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
        if (def.value < curr) {
            if (def.inclusive) bag.maximum = def.value;
            else bag.exclusiveMaximum = def.value;
        }
    });
    inst._zod.check = (payload)=>{
        if (def.inclusive ? payload.value <= def.value : payload.value < def.value) return;
        payload.issues.push({
            origin: $6c53c3e6ac94ab84$var$numericOriginMap[typeof payload.value] ?? origin,
            code: "too_big",
            maximum: typeof def.value === "object" ? def.value.getTime() : def.value,
            input: payload.value,
            inclusive: def.inclusive,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $6c53c3e6ac94ab84$export$8b670f58decbca18 = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckGreaterThan", (inst, def)=>{
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def);
    const origin = $6c53c3e6ac94ab84$var$numericOriginMap[typeof def.value];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        const curr = (def.inclusive ? bag.minimum : bag.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
        if (def.value > curr) {
            if (def.inclusive) bag.minimum = def.value;
            else bag.exclusiveMinimum = def.value;
        }
    });
    inst._zod.check = (payload)=>{
        if (def.inclusive ? payload.value >= def.value : payload.value > def.value) return;
        payload.issues.push({
            origin: $6c53c3e6ac94ab84$var$numericOriginMap[typeof payload.value] ?? origin,
            code: "too_small",
            minimum: typeof def.value === "object" ? def.value.getTime() : def.value,
            input: payload.value,
            inclusive: def.inclusive,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $6c53c3e6ac94ab84$export$ae602e11c1dd0628 = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckMultipleOf", (inst, def)=>{
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.onattach.push((inst)=>{
        var _a;
        (_a = inst._zod.bag).multipleOf ?? (_a.multipleOf = def.value);
    });
    inst._zod.check = (payload)=>{
        if (typeof payload.value !== typeof def.value) throw new Error("Cannot mix number and bigint in multiple_of check.");
        const isMultiple = typeof payload.value === "bigint" ? def.value !== BigInt(0) && payload.value % def.value === BigInt(0) : $c0663.floatSafeRemainder(payload.value, def.value) === 0;
        if (isMultiple) return;
        payload.issues.push({
            origin: typeof payload.value,
            code: "not_multiple_of",
            divisor: def.value,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $6c53c3e6ac94ab84$export$5c26c85ad6aed3e8 = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckNumberFormat", (inst, def)=>{
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def); // no format checks
    def.format = def.format || "float64";
    const isInt = def.format?.includes("int");
    const origin = isInt ? "int" : "number";
    const [minimum, maximum] = $c0663.NUMBER_FORMAT_RANGES[def.format];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = def.format;
        bag.minimum = minimum;
        bag.maximum = maximum;
        if (isInt) bag.pattern = $6iLpq.integer;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        if (isInt) {
            if (!Number.isInteger(input)) {
                // invalid_format issue
                // payload.issues.push({
                //   expected: def.format,
                //   format: def.format,
                //   code: "invalid_format",
                //   input,
                //   inst,
                // });
                // invalid_type issue
                payload.issues.push({
                    expected: origin,
                    format: def.format,
                    code: "invalid_type",
                    continue: false,
                    input: input,
                    inst: inst
                });
                return;
            // not_multiple_of issue
            // payload.issues.push({
            //   code: "not_multiple_of",
            //   origin: "number",
            //   input,
            //   inst,
            //   divisor: 1,
            // });
            }
            if (!Number.isSafeInteger(input)) {
                if (input > 0) // too_big
                payload.issues.push({
                    input: input,
                    code: "too_big",
                    maximum: Number.MAX_SAFE_INTEGER,
                    note: "Integers must be within the safe integer range.",
                    inst: inst,
                    origin: origin,
                    inclusive: true,
                    continue: !def.abort
                });
                else // too_small
                payload.issues.push({
                    input: input,
                    code: "too_small",
                    minimum: Number.MIN_SAFE_INTEGER,
                    note: "Integers must be within the safe integer range.",
                    inst: inst,
                    origin: origin,
                    inclusive: true,
                    continue: !def.abort
                });
                return;
            }
        }
        if (input < minimum) payload.issues.push({
            origin: "number",
            input: input,
            code: "too_small",
            minimum: minimum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
        if (input > maximum) payload.issues.push({
            origin: "number",
            input: input,
            code: "too_big",
            maximum: maximum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $6c53c3e6ac94ab84$export$a0a6d75ce7dc4d36 = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckBigIntFormat", (inst, def)=>{
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def); // no format checks
    const [minimum, maximum] = $c0663.BIGINT_FORMAT_RANGES[def.format];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = def.format;
        bag.minimum = minimum;
        bag.maximum = maximum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        if (input < minimum) payload.issues.push({
            origin: "bigint",
            input: input,
            code: "too_small",
            minimum: minimum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
        if (input > maximum) payload.issues.push({
            origin: "bigint",
            input: input,
            code: "too_big",
            maximum: maximum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $6c53c3e6ac94ab84$export$b3cec505675cf50c = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckMaxSize", (inst, def)=>{
    var _a;
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $6c53c3e6ac94ab84$var$_whenHasSize);
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        if (def.maximum < curr) inst._zod.bag.maximum = def.maximum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size <= def.maximum) return;
        payload.issues.push({
            origin: $c0663.getSizableOrigin(input),
            code: "too_big",
            maximum: def.maximum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $6c53c3e6ac94ab84$export$59fb0a2e7217c42b = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckMinSize", (inst, def)=>{
    var _a;
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $6c53c3e6ac94ab84$var$_whenHasSize);
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        if (def.minimum > curr) inst._zod.bag.minimum = def.minimum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size >= def.minimum) return;
        payload.issues.push({
            origin: $c0663.getSizableOrigin(input),
            code: "too_small",
            minimum: def.minimum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $6c53c3e6ac94ab84$export$af532c490f33cd47 = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckSizeEquals", (inst, def)=>{
    var _a;
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $6c53c3e6ac94ab84$var$_whenHasSize);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.minimum = def.size;
        bag.maximum = def.size;
        bag.size = def.size;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size === def.size) return;
        const tooBig = size > def.size;
        payload.issues.push({
            origin: $c0663.getSizableOrigin(input),
            ...tooBig ? {
                code: "too_big",
                maximum: def.size
            } : {
                code: "too_small",
                minimum: def.size
            },
            inclusive: true,
            exact: true,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $6c53c3e6ac94ab84$export$b07b097887f4c15a = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckMaxLength", (inst, def)=>{
    var _a;
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $6c53c3e6ac94ab84$var$_whenHasLength);
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        if (def.maximum < curr) inst._zod.bag.maximum = def.maximum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const units = input.length;
        // Strings are measured in Unicode code points, not UTF-16 units. A code point is at most two units, so a string that already fits in units fits in code points; only an overflow has to be counted.
        const length = typeof input === "string" && units > def.maximum ? $c0663.codePointLength(input) : units;
        if (length <= def.maximum) return;
        const origin = $c0663.getLengthableOrigin(input);
        payload.issues.push({
            origin: origin,
            code: "too_big",
            maximum: def.maximum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $6c53c3e6ac94ab84$export$cd5336aa96b8417c = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckMinLength", (inst, def)=>{
    var _a;
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $6c53c3e6ac94ab84$var$_whenHasLength);
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        if (def.minimum > curr) inst._zod.bag.minimum = def.minimum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const units = input.length;
        // A code point is one or two UTF-16 units, so fewer units than the floor can never reach it and twice the floor always clears it. Only in between is the exact count in doubt.
        const length = typeof input === "string" && units >= def.minimum && units < def.minimum * 2 ? $c0663.codePointLength(input) : units;
        if (length >= def.minimum) return;
        const origin = $c0663.getLengthableOrigin(input);
        payload.issues.push({
            origin: origin,
            code: "too_small",
            minimum: def.minimum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $6c53c3e6ac94ab84$export$ccdb9b9d477068fb = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckLengthEquals", (inst, def)=>{
    var _a;
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = $6c53c3e6ac94ab84$var$_whenHasLength);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.minimum = def.length;
        bag.maximum = def.length;
        bag.length = def.length;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const units = input.length;
        // A code point is one or two UTF-16 units, so outside `[length, length * 2]` units the target is missed either way — and missed in the same direction in both measures.
        const length = typeof input === "string" && units >= def.length && units <= def.length * 2 ? $c0663.codePointLength(input) : units;
        if (length === def.length) return;
        const origin = $c0663.getLengthableOrigin(input);
        const tooBig = length > def.length;
        payload.issues.push({
            origin: origin,
            ...tooBig ? {
                code: "too_big",
                maximum: def.length
            } : {
                code: "too_small",
                minimum: def.length
            },
            inclusive: true,
            exact: true,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $6c53c3e6ac94ab84$export$e0c7f6847ab1b629 = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckStringFormat", (inst, def)=>{
    var _a, _b;
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = def.format;
        if (def.pattern) {
            bag.patterns ?? (bag.patterns = new Set());
            bag.patterns.add(def.pattern);
        }
    });
    if (def.pattern) (_a = inst._zod).check ?? (_a.check = (payload)=>{
        def.pattern.lastIndex = 0;
        if (def.pattern.test(payload.value)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: def.format,
            input: payload.value,
            ...def.pattern ? {
                pattern: def.pattern.toString()
            } : {},
            inst: inst,
            continue: !def.abort
        });
    });
    else (_b = inst._zod).check ?? (_b.check = ()=>{});
});
const $6c53c3e6ac94ab84$export$6faea86ff718d6df = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckRegex", (inst, def)=>{
    $6c53c3e6ac94ab84$export$e0c7f6847ab1b629.init(inst, def);
    inst._zod.check = (payload)=>{
        def.pattern.lastIndex = 0;
        if (def.pattern.test(payload.value)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "regex",
            input: payload.value,
            pattern: def.pattern.toString(),
            inst: inst,
            continue: !def.abort
        });
    };
});
const $6c53c3e6ac94ab84$export$e18e268bd5c9f27a = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckLowerCase", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.lowercase);
    $6c53c3e6ac94ab84$export$e0c7f6847ab1b629.init(inst, def);
});
const $6c53c3e6ac94ab84$export$6d0944a5127e820a = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckUpperCase", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.uppercase);
    $6c53c3e6ac94ab84$export$e0c7f6847ab1b629.init(inst, def);
});
const $6c53c3e6ac94ab84$export$600021c28f0498dc = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckIncludes", (inst, def)=>{
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def);
    const escapedRegex = $c0663.escapeRegex(def.includes);
    // `String.prototype.includes(sub, position)` matches `sub` at `position`
    // OR LATER, so the pattern must allow at least `position` leading chars
    // (`{N,}`), not exactly `position` chars (`{N}`).
    const pattern = new RegExp(typeof def.position === "number" ? `^.{${def.position},}${escapedRegex}` : escapedRegex);
    def.pattern = pattern;
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.patterns ?? (bag.patterns = new Set());
        bag.patterns.add(pattern);
    });
    inst._zod.check = (payload)=>{
        if (payload.value.includes(def.includes, def.position)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "includes",
            includes: def.includes,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $6c53c3e6ac94ab84$export$8e83a74b4b83cc62 = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckStartsWith", (inst, def)=>{
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def);
    const pattern = new RegExp(`^${$c0663.escapeRegex(def.prefix)}.*`);
    def.pattern ?? (def.pattern = pattern);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.patterns ?? (bag.patterns = new Set());
        bag.patterns.add(pattern);
    });
    inst._zod.check = (payload)=>{
        if (payload.value.startsWith(def.prefix)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "starts_with",
            prefix: def.prefix,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $6c53c3e6ac94ab84$export$4a10f85c6af4e92 = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckEndsWith", (inst, def)=>{
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def);
    const pattern = new RegExp(`.*${$c0663.escapeRegex(def.suffix)}$`);
    def.pattern ?? (def.pattern = pattern);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.patterns ?? (bag.patterns = new Set());
        bag.patterns.add(pattern);
    });
    inst._zod.check = (payload)=>{
        if (payload.value.endsWith(def.suffix)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "ends_with",
            suffix: def.suffix,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
///////////////////////////////////
/////    $ZodCheckProperty    /////
///////////////////////////////////
function $6c53c3e6ac94ab84$var$handleCheckPropertyResult(result, payload, property) {
    if (result.issues.length) payload.issues.push(...$c0663.prefixIssues(property, result.issues));
}
const $6c53c3e6ac94ab84$export$d36a4eecd766dbc0 = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckProperty", (inst, def)=>{
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.check = (payload)=>{
        const result = def.schema._zod.run({
            value: payload.value[def.property],
            issues: []
        }, {});
        if (result instanceof Promise) return result.then((result)=>$6c53c3e6ac94ab84$var$handleCheckPropertyResult(result, payload, def.property));
        $6c53c3e6ac94ab84$var$handleCheckPropertyResult(result, payload, def.property);
        return;
    };
});
const $6c53c3e6ac94ab84$export$5546147f1877f806 = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckMimeType", (inst, def)=>{
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def);
    const mimeSet = new Set(def.mime);
    inst._zod.onattach.push((inst)=>{
        inst._zod.bag.mime = def.mime;
    });
    inst._zod.check = (payload)=>{
        if (mimeSet.has(payload.value.type)) return;
        payload.issues.push({
            code: "invalid_value",
            values: def.mime,
            input: payload.value.type,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $6c53c3e6ac94ab84$export$1bda1934456013d3 = /*@__PURE__*/ $59TZW.$constructor("$ZodCheckOverwrite", (inst, def)=>{
    $6c53c3e6ac94ab84$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.check = (payload)=>{
        payload.value = def.tx(payload.value);
    };
});

});
parcelRegister("59TZW", function(module, exports) {

$parcel$export(module.exports, "$constructor", function () { return $3c193b0bca955e97$export$3122533d606194de; });
$parcel$export(module.exports, "$ZodAsyncError", function () { return $3c193b0bca955e97$export$13016bcec11ba196; });
$parcel$export(module.exports, "$ZodEncodeError", function () { return $3c193b0bca955e97$export$a36d4c29b1151bde; });
$parcel$export(module.exports, "globalConfig", function () { return $3c193b0bca955e97$export$f9cd1e43211d8a4a; });
$parcel$export(module.exports, "config", function () { return $3c193b0bca955e97$export$e506a1d27d1eaa20; });

var $c0663 = parcelRequire("c0663");
var $3c193b0bca955e97$var$_a;
const $3c193b0bca955e97$export$96c94437c95d7862 = /*@__PURE__*/ Object.freeze({
    status: "aborted"
});
/* Shared descriptor for installing `_zod`; defineProperty reads it
 * synchronously, so reusing one object avoids a per-instance allocation. */ const $3c193b0bca955e97$var$_zodDesc = {
    value: undefined,
    enumerable: false
};
// null where suppressing the capture would be unrecoverable: `parse()` puts the frames back with `captureStackTrace`, so without it the throw would lose its stack. also latched to null once `stackTraceLimit` proves unassignable, which a realm can do at any point by hardening Error
let $3c193b0bca955e97$var$_E = "captureStackTrace" in Error ? Error : null;
// v8 captures a stack trace inside the Error constructor, which dominates a failed parse; costs only the frames, and parse() restores those. the constructor must RUN: Object.create is cheaper and passes instanceof, but Error.isError and util.types.isNativeError check an internal slot
function $3c193b0bca955e97$var$newError(Definition) {
    const E = $3c193b0bca955e97$var$_E;
    if (E) {
        const saved = E.stackTraceLimit;
        if (typeof saved === "number") {
            try {
                E.stackTraceLimit = 0;
            } catch  {
                $3c193b0bca955e97$var$_E = null;
                return new Definition();
            }
            try {
                return new Definition();
            } finally{
                E.stackTraceLimit = saved;
            }
        }
    }
    return new Definition();
}
/*@__NO_SIDE_EFFECTS__*/ function $3c193b0bca955e97$export$3122533d606194de(name, initializer, /** This trait's members, installed once on every prototype that composes it. They cannot be declared in the initializer above: that runs per instance, and the prototype is shared. */ proto, params) {
    // Prototype for this constructor's `_zod` internals. Lazily-derived fields (`values`, `pattern`, `optin`, …) install here once rather than as an accessor on every instance.
    const zodProto = {};
    // Assigning the fields in the constructor body is what gives instances in-object slots; building the object literally and reparenting it costs a second allocation and a generic property copy.
    function Internals(def) {
        this.def = def;
        this.constr = _;
        this.traits = new Set();
    }
    Internals.prototype = zodProto;
    const protoMembers = proto;
    // One trait's members land on every prototype whose chain composes it, so the answer is per prototype rather than per trait.
    const initialized = protoMembers && new WeakSet();
    function init(inst, def) {
        if (!inst._zod) {
            $3c193b0bca955e97$var$_zodDesc.value = new Internals(def);
            try {
                Object.defineProperty(inst, "_zod", $3c193b0bca955e97$var$_zodDesc);
            } finally{
                // Cleared even on throw, so the shared descriptor never leaks one instance's internals into the next.
                $3c193b0bca955e97$var$_zodDesc.value = undefined;
            }
        }
        if (inst._zod.traits.has(name)) return;
        inst._zod.traits.add(name);
        initializer(inst, def);
        if (initialized) {
            // `super(def)` from a user subclass gives `this` a prototype the subclass owns, and installing there would overwrite whatever the subclass declared. `constr` built the instance, so its prototype is the one below the subclass's that should carry the members. A receiver whose chain never reaches that prototype installs on its own, which for a plain object handed straight to `init` means `Object.prototype` — unchanged from before.
            const own = Object.getPrototypeOf(inst);
            const ctorProto = inst._zod.constr.prototype;
            let up = own;
            while(up && up !== ctorProto)up = Object.getPrototypeOf(up);
            const target = up ?? own;
            if (!initialized.has(target)) {
                initialized.add(target);
                (0, $c0663.members)(target, protoMembers);
            }
        }
        // support prototype modifications; for-in avoids the array allocation of Object.keys on the (usually empty) prototype
        const proto = _.prototype;
        for(const k in proto){
            if (!Object.prototype.hasOwnProperty.call(proto, k)) continue;
            if (!(k in inst)) inst[k] = proto[k].bind(inst);
        }
    }
    // doesn't work if Parent has a constructor with arguments
    const Parent = params?.Parent ?? Object;
    class Definition extends Parent {
    }
    Object.defineProperty(Definition, "name", {
        value: name
    });
    function _(def) {
        const inst = params?.Parent ? $3c193b0bca955e97$var$newError(Definition) : this;
        init(inst, def);
        const deferred = inst._zod.deferred;
        if (deferred) {
            for (const fn of deferred)fn();
            // Released: initializers run once, and the list would otherwise be retained for the schema's lifetime.
            inst._zod.deferred = undefined;
        }
        // Global post-processor hook. Internal: installed by `import "zod/compile"` to enable AOT compilation for every constructed schema. Runs last, once the instance is fully built, because it hands the instance to compile(). The post-processor is expected to be reentrancy-guarded by its own implementation.
        const pp = globalThis.__zod_globalConfig?.postProcessor;
        if (pp) pp(inst);
        return inst;
    }
    Object.defineProperty(_, "init", {
        value: init
    });
    Object.defineProperty(_, Symbol.hasInstance, {
        value: (inst)=>{
            if (params?.Parent && inst instanceof params.Parent) return true;
            return inst?._zod?.traits?.has(name);
        }
    });
    Object.defineProperty(_, "name", {
        value: name
    });
    return _;
}
const $3c193b0bca955e97$export$7d40e40c5b5a6c8f = /*@__PURE__*/ Symbol("zod_brand");
class $3c193b0bca955e97$export$13016bcec11ba196 extends Error {
    constructor(){
        super(`Encountered Promise during synchronous parse. Use .parseAsync() instead.`);
    }
}
class $3c193b0bca955e97$export$a36d4c29b1151bde extends Error {
    constructor(name){
        super(`Encountered unidirectional transform during encode: ${name}`);
        this.name = "ZodEncodeError";
    }
}
($3c193b0bca955e97$var$_a = globalThis).__zod_globalConfig ?? ($3c193b0bca955e97$var$_a.__zod_globalConfig = {});
const $3c193b0bca955e97$export$f9cd1e43211d8a4a = globalThis.__zod_globalConfig;
function $3c193b0bca955e97$export$e506a1d27d1eaa20(newConfig) {
    if (newConfig) Object.assign($3c193b0bca955e97$export$f9cd1e43211d8a4a, newConfig);
    return $3c193b0bca955e97$export$f9cd1e43211d8a4a;
}

});
parcelRegister("c0663", function(module, exports) {

$parcel$export(module.exports, "assertEqual", function () { return $8bca36c722bab397$export$27555cdfb0b84a1a; });
$parcel$export(module.exports, "assertNotEqual", function () { return $8bca36c722bab397$export$49eedac51f614f7d; });
$parcel$export(module.exports, "toZod", function () { return $8bca36c722bab397$export$e95468e219bfe076; });
$parcel$export(module.exports, "assertIs", function () { return $8bca36c722bab397$export$6fee1f82edcf4a03; });
$parcel$export(module.exports, "assertNever", function () { return $8bca36c722bab397$export$cbadc5a7223772a8; });
$parcel$export(module.exports, "assert", function () { return $8bca36c722bab397$export$a7a9523472993e97; });
$parcel$export(module.exports, "getEnumValues", function () { return $8bca36c722bab397$export$70a5d58ec00f3c11; });
$parcel$export(module.exports, "joinValues", function () { return $8bca36c722bab397$export$e79b744344f50f50; });
$parcel$export(module.exports, "stringifyPrimitive", function () { return $8bca36c722bab397$export$5859860f650378f4; });
$parcel$export(module.exports, "jsonStringifyReplacer", function () { return $8bca36c722bab397$export$f4defb13cab882b2; });
$parcel$export(module.exports, "cached", function () { return $8bca36c722bab397$export$ade7a147f5129058; });
$parcel$export(module.exports, "nullish", function () { return $8bca36c722bab397$export$69fd1b70ebae5687; });
$parcel$export(module.exports, "cleanRegex", function () { return $8bca36c722bab397$export$78d521805d6c22e4; });
$parcel$export(module.exports, "floatSafeRemainder", function () { return $8bca36c722bab397$export$7807b52a740a7117; });
$parcel$export(module.exports, "defineLazy", function () { return $8bca36c722bab397$export$d43070a5843c1e2; });
$parcel$export(module.exports, "objectClone", function () { return $8bca36c722bab397$export$103832c7353c2f50; });
$parcel$export(module.exports, "assignProp", function () { return $8bca36c722bab397$export$2e23d0571746a3fb; });
$parcel$export(module.exports, "mergeDefs", function () { return $8bca36c722bab397$export$8969f8c824382d73; });
$parcel$export(module.exports, "cloneDef", function () { return $8bca36c722bab397$export$21596dc63856f4c1; });
$parcel$export(module.exports, "getElementAtPath", function () { return $8bca36c722bab397$export$4b74d241e1cc7892; });
$parcel$export(module.exports, "promiseAllObject", function () { return $8bca36c722bab397$export$3db3408dad58da23; });
$parcel$export(module.exports, "randomString", function () { return $8bca36c722bab397$export$7fa8378418b4411e; });
$parcel$export(module.exports, "esc", function () { return $8bca36c722bab397$export$a1a11b095f88289a; });
$parcel$export(module.exports, "slugify", function () { return $8bca36c722bab397$export$c383cdd2a518017a; });
$parcel$export(module.exports, "captureStackTrace", function () { return $8bca36c722bab397$export$756e5cd2d260237b; });
$parcel$export(module.exports, "isObject", function () { return $8bca36c722bab397$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "allowsEval", function () { return $8bca36c722bab397$export$1f119cb4d720843b; });
$parcel$export(module.exports, "isPlainObject", function () { return $8bca36c722bab397$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "shallowClone", function () { return $8bca36c722bab397$export$370e8311c3cdebd9; });
$parcel$export(module.exports, "numKeys", function () { return $8bca36c722bab397$export$71667e74ba29447f; });
$parcel$export(module.exports, "getParsedType", function () { return $8bca36c722bab397$export$3e9057828ebd5c7a; });
$parcel$export(module.exports, "propertyKeyTypes", function () { return $8bca36c722bab397$export$b99c149ecf60be48; });
$parcel$export(module.exports, "primitiveTypes", function () { return $8bca36c722bab397$export$c34ffd355f76f0e4; });
$parcel$export(module.exports, "escapeRegex", function () { return $8bca36c722bab397$export$104ed90cc1a13451; });
$parcel$export(module.exports, "clone", function () { return $8bca36c722bab397$export$9cd59f9826255e47; });
$parcel$export(module.exports, "normalizeParams", function () { return $8bca36c722bab397$export$d6b7b25dfacfd300; });
$parcel$export(module.exports, "createTransparentProxy", function () { return $8bca36c722bab397$export$6ebbd8d3cb03909b; });
$parcel$export(module.exports, "optionalKeys", function () { return $8bca36c722bab397$export$240159211e66adb9; });
$parcel$export(module.exports, "NUMBER_FORMAT_RANGES", function () { return $8bca36c722bab397$export$8e78302060ccf26f; });
$parcel$export(module.exports, "BIGINT_FORMAT_RANGES", function () { return $8bca36c722bab397$export$538d1d6d5cfcb3b6; });
$parcel$export(module.exports, "pick", function () { return $8bca36c722bab397$export$357523c63a2253b9; });
$parcel$export(module.exports, "omit", function () { return $8bca36c722bab397$export$30a06c8d3562193f; });
$parcel$export(module.exports, "extend", function () { return $8bca36c722bab397$export$8b58be045bf06082; });
$parcel$export(module.exports, "safeExtend", function () { return $8bca36c722bab397$export$40c90eb222f50efb; });
$parcel$export(module.exports, "merge", function () { return $8bca36c722bab397$export$4950aa0f605343fb; });
$parcel$export(module.exports, "partial", function () { return $8bca36c722bab397$export$e45945969df8035a; });
$parcel$export(module.exports, "required", function () { return $8bca36c722bab397$export$a7a0278c004aac3f; });
$parcel$export(module.exports, "aborted", function () { return $8bca36c722bab397$export$bd75b6d981b9c7f2; });
$parcel$export(module.exports, "explicitlyAborted", function () { return $8bca36c722bab397$export$a5fe2d8610d815ec; });
$parcel$export(module.exports, "prefixIssues", function () { return $8bca36c722bab397$export$7f35a4c434118b9e; });
$parcel$export(module.exports, "unwrapMessage", function () { return $8bca36c722bab397$export$56590e5a47837d61; });
$parcel$export(module.exports, "attachSchema", function () { return $8bca36c722bab397$export$5f3bf32142eef856; });
$parcel$export(module.exports, "finalizeIssue", function () { return $8bca36c722bab397$export$c5e667bbfc286a9d; });
$parcel$export(module.exports, "getSizableOrigin", function () { return $8bca36c722bab397$export$67a7c9c676c45d2b; });
$parcel$export(module.exports, "codePointLength", function () { return $8bca36c722bab397$export$89f26bd0a2764944; });
$parcel$export(module.exports, "getLengthableOrigin", function () { return $8bca36c722bab397$export$479f5a070abeb487; });
$parcel$export(module.exports, "parsedType", function () { return $8bca36c722bab397$export$858d360cf6da2b65; });
$parcel$export(module.exports, "issue", function () { return $8bca36c722bab397$export$69ad3503f98be476; });
$parcel$export(module.exports, "cleanEnum", function () { return $8bca36c722bab397$export$9b57aa937148f32; });
$parcel$export(module.exports, "base64ToUint8Array", function () { return $8bca36c722bab397$export$f01069a3c307e50e; });
$parcel$export(module.exports, "uint8ArrayToBase64", function () { return $8bca36c722bab397$export$36bac84b1c2da9c7; });
$parcel$export(module.exports, "base64urlToUint8Array", function () { return $8bca36c722bab397$export$b9fa2551f2db41e1; });
$parcel$export(module.exports, "uint8ArrayToBase64url", function () { return $8bca36c722bab397$export$975f78e50159df6f; });
$parcel$export(module.exports, "hexToUint8Array", function () { return $8bca36c722bab397$export$6c74ef56152ffb8d; });
$parcel$export(module.exports, "uint8ArrayToHex", function () { return $8bca36c722bab397$export$c44b02fb03dbac82; });
$parcel$export(module.exports, "Class", function () { return $8bca36c722bab397$export$4c85e640eb41c31b; });
$parcel$export(module.exports, "members", function () { return $8bca36c722bab397$export$100ad4af8c8d544f; });
$parcel$export(module.exports, "own", function () { return $8bca36c722bab397$export$a97a0f27b0201230; });
$parcel$export(module.exports, "hide", function () { return $8bca36c722bab397$export$fe8985bb6374093c; });
$parcel$export(module.exports, "defineLazyInternal", function () { return $8bca36c722bab397$export$ab4d63bd6339ba82; });
$parcel$export(module.exports, "installLazyProp", function () { return $8bca36c722bab397$export$fd3ec217a5ca1bc7; });
$parcel$export(module.exports, "CONSTANT_CATCH", function () { return $8bca36c722bab397$export$2644f2739b5380cd; });
$parcel$export(module.exports, "constantCatch", function () { return $8bca36c722bab397$export$79bf7eed34458669; });

var $59TZW = parcelRequire("59TZW");
function $8bca36c722bab397$export$27555cdfb0b84a1a(val) {
    return val;
}
function $8bca36c722bab397$export$49eedac51f614f7d(val) {
    return val;
}
function $8bca36c722bab397$export$e95468e219bfe076() {
    return (schema)=>schema;
}
function $8bca36c722bab397$export$6fee1f82edcf4a03(_arg) {}
function $8bca36c722bab397$export$cbadc5a7223772a8(_x) {
    throw new Error("Unexpected value in exhaustive check");
}
function $8bca36c722bab397$export$a7a9523472993e97(_) {}
function $8bca36c722bab397$export$70a5d58ec00f3c11(entries) {
    const numericValues = Object.values(entries).filter((v)=>typeof v === "number");
    const values = Object.entries(entries).filter(([k, _])=>numericValues.indexOf(+k) === -1).map(([_, v])=>v);
    return values;
}
function $8bca36c722bab397$export$e79b744344f50f50(array, separator = "|") {
    return array.map((val)=>$8bca36c722bab397$export$5859860f650378f4(val)).join(separator);
}
function $8bca36c722bab397$export$f4defb13cab882b2(_, value) {
    if (typeof value === "bigint") return value.toString();
    return value;
}
function $8bca36c722bab397$export$ade7a147f5129058(getter) {
    const set = false;
    return {
        get value () {
            if (!set) {
                const value = getter();
                Object.defineProperty(this, "value", {
                    value: value
                });
                return value;
            }
            throw new Error("cached value already set");
        }
    };
}
function $8bca36c722bab397$export$69fd1b70ebae5687(input) {
    return input === null || input === undefined;
}
function $8bca36c722bab397$export$78d521805d6c22e4(source) {
    const start = source.startsWith("^") ? 1 : 0;
    const end = source.endsWith("$") ? source.length - 1 : source.length;
    return source.slice(start, end);
}
function $8bca36c722bab397$export$7807b52a740a7117(val, step) {
    const ratio = val / step;
    const roundedRatio = Math.round(ratio);
    // `val` and `step` each round to a double before the division rounds again, so a true decimal multiple's quotient can sit up to 1.5 of these scaled epsilons from the integer. A 1x tolerance therefore rejected 2.03 as a multiple of 0.07; 4x covers the worst case with margin.
    const tolerance = 4 * Number.EPSILON * Math.max(Math.abs(ratio), 1);
    if (Math.abs(ratio - roundedRatio) < tolerance) return 0;
    return ratio - roundedRatio;
}
const $8bca36c722bab397$var$EVALUATING = /* @__PURE__*/ Symbol("evaluating");
function $8bca36c722bab397$export$d43070a5843c1e2(object, key, getter) {
    let value = undefined;
    Object.defineProperty(object, key, {
        get () {
            if (value === $8bca36c722bab397$var$EVALUATING) // Circular reference detected, return undefined to break the cycle
            return undefined;
            if (value === undefined) {
                value = $8bca36c722bab397$var$EVALUATING;
                value = getter();
            }
            return value;
        },
        set (v) {
            Object.defineProperty(object, key, {
                value: v
            });
        // object[key] = v;
        },
        configurable: true
    });
}
function $8bca36c722bab397$export$103832c7353c2f50(obj) {
    return Object.create(Object.getPrototypeOf(obj), Object.getOwnPropertyDescriptors(obj));
}
function $8bca36c722bab397$export$2e23d0571746a3fb(target, prop, value) {
    Object.defineProperty(target, prop, {
        value: value,
        writable: true,
        enumerable: true,
        configurable: true
    });
}
function $8bca36c722bab397$export$8969f8c824382d73(...defs) {
    const mergedDescriptors = {};
    for (const def of defs){
        const descriptors = Object.getOwnPropertyDescriptors(def);
        Object.assign(mergedDescriptors, descriptors);
    }
    return Object.defineProperties({}, mergedDescriptors);
}
function $8bca36c722bab397$export$21596dc63856f4c1(schema) {
    return $8bca36c722bab397$export$8969f8c824382d73(schema._zod.def);
}
function $8bca36c722bab397$export$4b74d241e1cc7892(obj, path) {
    if (!path) return obj;
    return path.reduce((acc, key)=>acc?.[key], obj);
}
function $8bca36c722bab397$export$3db3408dad58da23(promisesObj) {
    const keys = Object.keys(promisesObj);
    const promises = keys.map((key)=>promisesObj[key]);
    return Promise.all(promises).then((results)=>{
        const resolvedObj = {};
        for(let i = 0; i < keys.length; i++)resolvedObj[keys[i]] = results[i];
        return resolvedObj;
    });
}
function $8bca36c722bab397$export$7fa8378418b4411e(length = 10) {
    const chars = "abcdefghijklmnopqrstuvwxyz";
    let str = "";
    for(let i = 0; i < length; i++)str += chars[Math.floor(Math.random() * chars.length)];
    return str;
}
function $8bca36c722bab397$export$a1a11b095f88289a(str) {
    return JSON.stringify(str);
}
function $8bca36c722bab397$export$c383cdd2a518017a(input) {
    return input.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const $8bca36c722bab397$export$756e5cd2d260237b = "captureStackTrace" in Error ? Error.captureStackTrace : (..._args)=>{};
function $8bca36c722bab397$export$a6cdc56e425d0d0a(data) {
    return typeof data === "object" && data !== null && !Array.isArray(data);
}
const $8bca36c722bab397$export$1f119cb4d720843b = /* @__PURE__*/ $8bca36c722bab397$export$ade7a147f5129058(()=>{
    // Skip the probe under `jitless`: strict CSPs report the caught `new Function` as a `securitypolicyviolation` even though the throw is swallowed.
    if ((0, $59TZW.globalConfig).jitless) return false;
    // @ts-ignore
    if (typeof navigator !== "undefined" && navigator?.userAgent?.includes("Cloudflare")) return false;
    try {
        const F = Function;
        new F("");
        return true;
    } catch (_) {
        return false;
    }
});
function $8bca36c722bab397$export$53b83ca8eaab0383(o) {
    if ($8bca36c722bab397$export$a6cdc56e425d0d0a(o) === false) return false;
    // modified constructor
    const ctor = o.constructor;
    if (ctor === undefined) return true;
    if (typeof ctor !== "function") return true;
    // modified prototype
    const prot = ctor.prototype;
    if ($8bca36c722bab397$export$a6cdc56e425d0d0a(prot) === false) return false;
    // ctor doesn't have static `isPrototypeOf`
    if (Object.prototype.hasOwnProperty.call(prot, "isPrototypeOf") === false) return false;
    return true;
}
function $8bca36c722bab397$export$370e8311c3cdebd9(o) {
    if ($8bca36c722bab397$export$53b83ca8eaab0383(o)) return {
        ...o
    };
    if (Array.isArray(o)) return [
        ...o
    ];
    if (o instanceof Map) return new Map(o);
    if (o instanceof Set) return new Set(o);
    return o;
}
function $8bca36c722bab397$export$71667e74ba29447f(data) {
    let keyCount = 0;
    for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) keyCount++;
    return keyCount;
}
const $8bca36c722bab397$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return "undefined";
        case "string":
            return "string";
        case "number":
            return Number.isNaN(data) ? "nan" : "number";
        case "boolean":
            return "boolean";
        case "function":
            return "function";
        case "bigint":
            return "bigint";
        case "symbol":
            return "symbol";
        case "object":
            if (Array.isArray(data)) return "array";
            if (data === null) return "null";
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return "promise";
            if (typeof Map !== "undefined" && data instanceof Map) return "map";
            if (typeof Set !== "undefined" && data instanceof Set) return "set";
            if (typeof Date !== "undefined" && data instanceof Date) return "date";
            // @ts-ignore
            if (typeof File !== "undefined" && data instanceof File) return "file";
            return "object";
        default:
            throw new Error(`Unknown data type: ${t}`);
    }
};
const $8bca36c722bab397$export$b99c149ecf60be48 = /* @__PURE__*/ new Set([
    "string",
    "number",
    "symbol"
]);
const $8bca36c722bab397$export$c34ffd355f76f0e4 = /* @__PURE__*/ new Set([
    "string",
    "number",
    "bigint",
    "boolean",
    "symbol",
    "undefined"
]);
function $8bca36c722bab397$export$104ed90cc1a13451(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $8bca36c722bab397$export$9cd59f9826255e47(inst, def, params) {
    const cl = new inst._zod.constr(def ?? inst._zod.def);
    if (!def || params?.parent) cl._zod.parent = inst;
    return cl;
}
function $8bca36c722bab397$export$d6b7b25dfacfd300(_params) {
    const params = _params;
    if (!params) return {};
    if (typeof params === "string") return {
        error: ()=>params
    };
    if (params?.message !== undefined) {
        if (params?.error !== undefined) throw new Error("Cannot specify both `message` and `error` params");
        params.error = params.message;
    }
    delete params.message;
    if (typeof params.error === "string") return {
        ...params,
        error: ()=>params.error
    };
    return params;
}
function $8bca36c722bab397$export$6ebbd8d3cb03909b(getter) {
    let target;
    return new Proxy({}, {
        get (_, prop, receiver) {
            target ?? (target = getter());
            return Reflect.get(target, prop, receiver);
        },
        set (_, prop, value, receiver) {
            target ?? (target = getter());
            return Reflect.set(target, prop, value, receiver);
        },
        has (_, prop) {
            target ?? (target = getter());
            return Reflect.has(target, prop);
        },
        deleteProperty (_, prop) {
            target ?? (target = getter());
            return Reflect.deleteProperty(target, prop);
        },
        ownKeys (_) {
            target ?? (target = getter());
            return Reflect.ownKeys(target);
        },
        getOwnPropertyDescriptor (_, prop) {
            target ?? (target = getter());
            return Reflect.getOwnPropertyDescriptor(target, prop);
        },
        defineProperty (_, prop, descriptor) {
            target ?? (target = getter());
            return Reflect.defineProperty(target, prop, descriptor);
        }
    });
}
function $8bca36c722bab397$export$5859860f650378f4(value) {
    if (typeof value === "bigint") return value.toString() + "n";
    if (typeof value === "string") return `"${value}"`;
    return `${value}`;
}
function $8bca36c722bab397$export$240159211e66adb9(shape) {
    return Object.keys(shape).filter((k)=>{
        return shape[k]._zod.optin !== undefined && shape[k]._zod.optout === "optional";
    });
}
const $8bca36c722bab397$export$8e78302060ccf26f = /*@__PURE__*/ (()=>({
        safeint: [
            Number.MIN_SAFE_INTEGER,
            Number.MAX_SAFE_INTEGER
        ],
        int32: [
            -2147483648,
            2147483647
        ],
        uint32: [
            0,
            4294967295
        ],
        float32: [
            -340282346638528860000000000000000000000,
            3.4028234663852886e38
        ],
        float64: [
            -Number.MAX_VALUE,
            Number.MAX_VALUE
        ]
    }))();
const $8bca36c722bab397$export$538d1d6d5cfcb3b6 = {
    int64: [
        /* @__PURE__*/ BigInt("-9223372036854775808"),
        /* @__PURE__*/ BigInt("9223372036854775807")
    ],
    uint64: [
        /* @__PURE__*/ BigInt(0),
        /* @__PURE__*/ BigInt("18446744073709551615")
    ]
};
function $8bca36c722bab397$export$357523c63a2253b9(schema, mask) {
    const currDef = schema._zod.def;
    const checks = currDef.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error(".pick() cannot be used on object schemas containing refinements");
    const def = $8bca36c722bab397$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const newShape = {};
            // `for...in` skips symbols, so a symbol in the mask would select nothing
            for (const key of Reflect.ownKeys(mask)){
                if (!Object.prototype.hasOwnProperty.call(currDef.shape, key)) throw new Error(`Unrecognized key: "${String(key)}"`);
                if (!mask[key]) continue;
                $8bca36c722bab397$export$2e23d0571746a3fb(newShape, key, currDef.shape[key]);
            }
            $8bca36c722bab397$export$2e23d0571746a3fb(this, "shape", newShape); // self-caching
            return newShape;
        },
        checks: []
    });
    return $8bca36c722bab397$export$9cd59f9826255e47(schema, def);
}
function $8bca36c722bab397$export$30a06c8d3562193f(schema, mask) {
    const currDef = schema._zod.def;
    const checks = currDef.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error(".omit() cannot be used on object schemas containing refinements");
    const def = $8bca36c722bab397$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const newShape = {
                ...schema._zod.def.shape
            };
            for (const key of Reflect.ownKeys(mask)){
                if (!Object.prototype.hasOwnProperty.call(currDef.shape, key)) throw new Error(`Unrecognized key: "${String(key)}"`);
                if (!mask[key]) continue;
                delete newShape[key];
            }
            $8bca36c722bab397$export$2e23d0571746a3fb(this, "shape", newShape); // self-caching
            return newShape;
        },
        checks: []
    });
    return $8bca36c722bab397$export$9cd59f9826255e47(schema, def);
}
function $8bca36c722bab397$export$8b58be045bf06082(schema, shape) {
    if (!$8bca36c722bab397$export$53b83ca8eaab0383(shape)) throw new Error("Invalid input to extend: expected a plain object");
    const checks = schema._zod.def.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) {
        // Only throw if new shape overlaps with existing shape. Use getOwnPropertyDescriptor to check key existence without accessing values
        const existingShape = schema._zod.def.shape;
        for (const key of Reflect.ownKeys(shape)){
            if (Object.getOwnPropertyDescriptor(existingShape, key) !== undefined) throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
        }
    }
    const def = $8bca36c722bab397$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const _shape = {
                ...schema._zod.def.shape,
                ...shape
            };
            $8bca36c722bab397$export$2e23d0571746a3fb(this, "shape", _shape); // self-caching
            return _shape;
        }
    });
    return $8bca36c722bab397$export$9cd59f9826255e47(schema, def);
}
function $8bca36c722bab397$export$40c90eb222f50efb(schema, shape) {
    if (!$8bca36c722bab397$export$53b83ca8eaab0383(shape)) throw new Error("Invalid input to safeExtend: expected a plain object");
    const def = $8bca36c722bab397$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const _shape = {
                ...schema._zod.def.shape,
                ...shape
            };
            $8bca36c722bab397$export$2e23d0571746a3fb(this, "shape", _shape); // self-caching
            return _shape;
        }
    });
    return $8bca36c722bab397$export$9cd59f9826255e47(schema, def);
}
function $8bca36c722bab397$export$4950aa0f605343fb(a, b) {
    if (!b?._zod?.def) throw new Error("Invalid input to merge: expected an object schema. To merge a plain shape, use `.extend()`.");
    if (a._zod.def.checks?.length) throw new Error(".merge() cannot be used on object schemas containing refinements. Use .safeExtend() instead.");
    const def = $8bca36c722bab397$export$8969f8c824382d73(a._zod.def, {
        get shape () {
            const _shape = {
                ...a._zod.def.shape,
                ...b._zod.def.shape
            };
            $8bca36c722bab397$export$2e23d0571746a3fb(this, "shape", _shape); // self-caching
            return _shape;
        },
        get catchall () {
            return b._zod.def.catchall;
        },
        checks: b._zod.def.checks ?? []
    });
    return $8bca36c722bab397$export$9cd59f9826255e47(a, def);
}
function $8bca36c722bab397$export$e45945969df8035a(Class, schema, mask, name = "partial") {
    const currDef = schema._zod.def;
    const checks = currDef.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error(`.${name}() cannot be used on object schemas containing refinements`);
    const def = $8bca36c722bab397$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const oldShape = schema._zod.def.shape;
            const shape = {
                ...oldShape
            };
            if (mask) for (const key of Reflect.ownKeys(mask)){
                if (!Object.prototype.hasOwnProperty.call(oldShape, key)) throw new Error(`Unrecognized key: "${String(key)}"`);
                if (!mask[key]) continue;
                // if (oldShape[key]!._zod.optin === "optional") continue;
                shape[key] = Class ? new Class({
                    type: "optional",
                    innerType: oldShape[key]
                }) : oldShape[key];
            }
            else // the spread copies symbol keys; `for...in` would not reach them
            for (const key of Reflect.ownKeys(oldShape))// if (oldShape[key]!._zod.optin === "optional") continue;
            shape[key] = Class ? new Class({
                type: "optional",
                innerType: oldShape[key]
            }) : oldShape[key];
            $8bca36c722bab397$export$2e23d0571746a3fb(this, "shape", shape); // self-caching
            return shape;
        },
        checks: []
    });
    return $8bca36c722bab397$export$9cd59f9826255e47(schema, def);
}
function $8bca36c722bab397$export$a7a0278c004aac3f(Class, schema, mask) {
    const def = $8bca36c722bab397$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const oldShape = schema._zod.def.shape;
            const shape = {
                ...oldShape
            };
            if (mask) for (const key of Reflect.ownKeys(mask)){
                if (!Object.prototype.hasOwnProperty.call(shape, key)) throw new Error(`Unrecognized key: "${String(key)}"`);
                if (!mask[key]) continue;
                // overwrite with non-optional
                shape[key] = new Class({
                    type: "nonoptional",
                    innerType: oldShape[key]
                });
            }
            else for (const key of Reflect.ownKeys(oldShape))// overwrite with non-optional
            shape[key] = new Class({
                type: "nonoptional",
                innerType: oldShape[key]
            });
            $8bca36c722bab397$export$2e23d0571746a3fb(this, "shape", shape); // self-caching
            return shape;
        }
    });
    return $8bca36c722bab397$export$9cd59f9826255e47(schema, def);
}
function $8bca36c722bab397$export$bd75b6d981b9c7f2(x, startIndex = 0) {
    if (x.aborted === true) return true;
    for(let i = startIndex; i < x.issues.length; i++){
        if (x.issues[i]?.continue !== true) return true;
    }
    return false;
}
function $8bca36c722bab397$export$a5fe2d8610d815ec(x, startIndex = 0) {
    if (x.aborted === true) return true;
    for(let i = startIndex; i < x.issues.length; i++){
        if (x.issues[i]?.continue === false) return true;
    }
    return false;
}
function $8bca36c722bab397$export$7f35a4c434118b9e(path, issues) {
    return issues.map((iss)=>{
        var _a;
        (_a = iss).path ?? (_a.path = []);
        iss.path.unshift(path);
        return iss;
    });
}
function $8bca36c722bab397$export$56590e5a47837d61(message) {
    return typeof message === "string" ? message : message?.message;
}
function $8bca36c722bab397$export$5f3bf32142eef856(issues, start, inst) {
    var _a;
    for(let i = start; i < issues.length; i++)(_a = issues[i]).schema ?? (_a.schema = inst);
}
function $8bca36c722bab397$export$c5e667bbfc286a9d(iss, ctx, config) {
    var _a;
    // A schema that raised an issue itself owns it outright, and outranks any stamp an enclosing check left in `attachSchema`. String formats and z.custom() are schema and check at once, so when they act as a check they defer to that stamp instead.
    const traits = iss.inst?._zod?.traits;
    if (traits?.has("$ZodType")) {
        if (traits.has("$ZodCheck")) (_a = iss).schema ?? (_a.schema = iss.inst);
        else iss.schema = iss.inst;
    }
    // Decreasing specificity, first map to return a message wins. `inst` is whatever raised the issue, so a check's own map outranks the owning schema's.
    const schemaError = iss.schema !== iss.inst ? iss.schema?._zod.def?.error : undefined;
    const message = iss.message ? iss.message : $8bca36c722bab397$export$56590e5a47837d61(iss.inst?._zod.def?.error?.(iss)) ?? $8bca36c722bab397$export$56590e5a47837d61(schemaError?.(iss)) ?? $8bca36c722bab397$export$56590e5a47837d61(ctx?.error?.(iss)) ?? $8bca36c722bab397$export$56590e5a47837d61(config.customError?.(iss)) ?? $8bca36c722bab397$export$56590e5a47837d61(config.localeError?.(iss)) ?? "Invalid input";
    const { inst: _inst, schema: _schema, continue: _continue, input: _input, ...rest } = iss;
    rest.path ?? (rest.path = []);
    rest.message = message;
    if (ctx?.reportInput) rest.input = _input;
    return rest;
}
function $8bca36c722bab397$export$67a7c9c676c45d2b(input) {
    if (input instanceof Set) return "set";
    if (input instanceof Map) return "map";
    // @ts-ignore
    if (input instanceof File) return "file";
    return "unknown";
}
const $8bca36c722bab397$var$highSurrogate = /[\uD800-\uDBFF]/;
function $8bca36c722bab397$export$89f26bd0a2764944(str) {
    const units = str.length;
    if (!$8bca36c722bab397$var$highSurrogate.test(str)) return units;
    let count = units;
    for(let i = 0; i < units - 1; i++)if ((str.charCodeAt(i) & 0xfc00) === 0xd800 && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
        count--;
        i++;
    }
    return count;
}
function $8bca36c722bab397$export$479f5a070abeb487(input) {
    if (Array.isArray(input)) return "array";
    if (typeof input === "string") return "string";
    return "unknown";
}
function $8bca36c722bab397$export$858d360cf6da2b65(data) {
    const t = typeof data;
    switch(t){
        case "number":
            return Number.isNaN(data) ? "nan" : "number";
        case "object":
            {
                if (data === null) return "null";
                if (Array.isArray(data)) return "array";
                const obj = data;
                if (obj && Object.getPrototypeOf(obj) !== Object.prototype && "constructor" in obj && obj.constructor) return obj.constructor.name;
            }
    }
    return t;
}
function $8bca36c722bab397$export$69ad3503f98be476(...args) {
    const [iss, input, inst] = args;
    if (typeof iss === "string") return {
        message: iss,
        code: "custom",
        input: input,
        inst: inst
    };
    return {
        ...iss
    };
}
function $8bca36c722bab397$export$9b57aa937148f32(obj) {
    return Object.entries(obj).filter(([k, _])=>{
        // return true if NaN, meaning it's not a number, thus a string key
        return Number.isNaN(Number.parseInt(k, 10));
    }).map((el)=>el[1]);
}
function $8bca36c722bab397$export$f01069a3c307e50e(base64) {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for(let i = 0; i < binaryString.length; i++)bytes[i] = binaryString.charCodeAt(i);
    return bytes;
}
function $8bca36c722bab397$export$36bac84b1c2da9c7(bytes) {
    let binaryString = "";
    for(let i = 0; i < bytes.length; i++)binaryString += String.fromCharCode(bytes[i]);
    return btoa(binaryString);
}
function $8bca36c722bab397$export$b9fa2551f2db41e1(base64url) {
    const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
    const padding = "=".repeat((4 - base64.length % 4) % 4);
    return $8bca36c722bab397$export$f01069a3c307e50e(base64 + padding);
}
function $8bca36c722bab397$export$975f78e50159df6f(bytes) {
    return $8bca36c722bab397$export$36bac84b1c2da9c7(bytes).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function $8bca36c722bab397$export$6c74ef56152ffb8d(hex) {
    const cleanHex = hex.replace(/^0x/, "");
    if (cleanHex.length % 2 !== 0) throw new Error("Invalid hex string length");
    const bytes = new Uint8Array(cleanHex.length / 2);
    for(let i = 0; i < cleanHex.length; i += 2)bytes[i / 2] = Number.parseInt(cleanHex.slice(i, i + 2), 16);
    return bytes;
}
function $8bca36c722bab397$export$c44b02fb03dbac82(bytes) {
    return Array.from(bytes).map((b)=>b.toString(16).padStart(2, "0")).join("");
}
class $8bca36c722bab397$export$4c85e640eb41c31b {
    constructor(..._args){}
}
function $8bca36c722bab397$export$100ad4af8c8d544f(proto, table) {
    for(const key in table){
        const desc = Object.getOwnPropertyDescriptor(table, key);
        // a getter installs as written, so it stays live: `description` reads through to the registry on every access. not enumerable: an object literal's is, and a prototype member never was
        if (desc.get) Object.defineProperty(proto, key, {
            ...desc,
            enumerable: false
        });
        else $8bca36c722bab397$var$defineBound(proto, key, desc.value);
    }
}
function $8bca36c722bab397$export$a97a0f27b0201230(inst, key, value, enumerable = true) {
    Object.defineProperty(inst, key, {
        configurable: true,
        writable: true,
        enumerable: enumerable,
        value: value
    });
    return value;
}
function $8bca36c722bab397$export$fe8985bb6374093c(inst, key, value) {
    return $8bca36c722bab397$export$a97a0f27b0201230(inst, key, value, false);
}
function $8bca36c722bab397$var$defineBound(proto, key, fn) {
    Object.defineProperty(proto, key, {
        configurable: true,
        get () {
            // vitest's spyOn calls a prototype getter bare to find the function it wraps, so a nullish receiver answers the raw method
            return this == null ? fn : $8bca36c722bab397$export$a97a0f27b0201230(this, key, fn.bind(this));
        },
        set (value) {
            $8bca36c722bab397$export$a97a0f27b0201230(this, key, value);
        }
    });
}
/** Returns the prototype to install on, or `undefined` if this group is already installed on it. */ function $8bca36c722bab397$var$claim(inst, sentinel) {
    const proto = Object.getPrototypeOf(inst);
    // Runs on every construction, so `in` rather than the costlier `hasOwnProperty.call`. Sentinels are keys the group itself defines.
    return sentinel in proto ? undefined : proto;
}
// The internals whose init chain is installing. A second call for the same one is a derived constructor overriding its base, so it must not construct another schema in between or the override is dropped.
let $8bca36c722bab397$var$installing;
// Set while a getter is running, so a value that resolved through a recursion break is not memoized. One shared descriptor shadows the key for the duration, which costs no per-key allocation.
let $8bca36c722bab397$var$broke = false;
const $8bca36c722bab397$var$breaker = {
    configurable: true,
    get () {
        $8bca36c722bab397$var$broke = true;
        return undefined;
    }
};
function $8bca36c722bab397$export$ab4d63bd6339ba82(inst, key, compute) {
    const proto = Object.getPrototypeOf(inst._zod);
    if (key in proto && $8bca36c722bab397$var$installing !== inst._zod) {
        // A repeat construction: everything is installed already. Cleared here so the reference is not held past the first construction of every type.
        $8bca36c722bab397$var$installing = undefined;
        return;
    }
    $8bca36c722bab397$var$installing = inst._zod;
    Object.defineProperty(proto, key, {
        configurable: true,
        get () {
            // Shadowed before computing so a re-entrant read from a recursive schema resolves to undefined instead of running the getter again.
            Object.defineProperty(this, key, $8bca36c722bab397$var$breaker);
            const outer = $8bca36c722bab397$var$broke;
            $8bca36c722bab397$var$broke = false;
            try {
                const value = compute(this);
                // A result that resolved through a recursion break is recomputed once the graph is complete; everything else memoizes, undefined included.
                if ($8bca36c722bab397$var$broke) delete this[key];
                else Object.defineProperty(this, key, {
                    configurable: true,
                    writable: true,
                    value: value
                });
                $8bca36c722bab397$var$broke = $8bca36c722bab397$var$broke || outer;
                return value;
            } catch (err) {
                // A compute that threw memoizes nothing, so a later read runs it again and fails the same way. The shadow goes with it, since leaving it installed would answer undefined for every later read.
                delete this[key];
                $8bca36c722bab397$var$broke = $8bca36c722bab397$var$broke || outer;
                throw err;
            }
        },
        set (value) {
            Object.defineProperty(this, key, {
                configurable: true,
                writable: true,
                value: value
            });
        }
    });
}
function $8bca36c722bab397$export$fd3ec217a5ca1bc7(inst, key, make, enumerable) {
    const proto = $8bca36c722bab397$var$claim(inst, key);
    if (!proto) return;
    Object.defineProperty(proto, key, {
        configurable: true,
        get () {
            // Shadowed before computing, so a re-entrant read from a self-referential shape resolves to undefined instead of running the getter again. A data property rather than an accessor: an own accessor is the dictionary-mode transition this exists to avoid.
            const desc = {
                configurable: true,
                writable: true,
                enumerable: enumerable,
                value: undefined
            };
            Object.defineProperty(this, key, desc);
            // a compute that throws leaves the shadow behind, so later reads answer undefined instead of re-throwing; `defineLazy` did the same, and `defineLazyInternal`'s delete-on-catch would cost bytes in every bundle for a case only a throwing user getter reaches
            desc.value = make(this);
            Object.defineProperty(this, key, desc);
            return desc.value;
        },
        set (value) {
            Object.defineProperty(this, key, {
                configurable: true,
                writable: true,
                enumerable: enumerable,
                value: value
            });
        }
    });
}
const $8bca36c722bab397$export$2644f2739b5380cd = "~constantCatch";
function $8bca36c722bab397$export$79bf7eed34458669(value) {
    const fn = ()=>value;
    fn[$8bca36c722bab397$export$2644f2739b5380cd] = true;
    return fn;
}

});


parcelRegister("6iLpq", function(module, exports) {

$parcel$export(module.exports, "cuid", function () { return $496932f48e9d3fc1$export$e057ec210c7d3443; });
$parcel$export(module.exports, "cuid2", function () { return $496932f48e9d3fc1$export$af5866a6cccce9f0; });
$parcel$export(module.exports, "ulid", function () { return $496932f48e9d3fc1$export$c34778236461ea95; });
$parcel$export(module.exports, "xid", function () { return $496932f48e9d3fc1$export$5eecaf20006cb6cb; });
$parcel$export(module.exports, "ksuid", function () { return $496932f48e9d3fc1$export$f49b11deeb9beb0f; });
$parcel$export(module.exports, "nanoid", function () { return $496932f48e9d3fc1$export$ac4959f4f1338dfc; });
$parcel$export(module.exports, "nanoidOfLength", function () { return $496932f48e9d3fc1$export$5e38a73263010503; });
$parcel$export(module.exports, "duration", function () { return $496932f48e9d3fc1$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "extendedDuration", function () { return $496932f48e9d3fc1$export$e30244ba59a8cd84; });
$parcel$export(module.exports, "guid", function () { return $496932f48e9d3fc1$export$46e8f25c7328f77e; });
$parcel$export(module.exports, "uuid", function () { return $496932f48e9d3fc1$export$31b40729666a4ae0; });
$parcel$export(module.exports, "uuid4", function () { return $496932f48e9d3fc1$export$19f53698e68b2496; });
$parcel$export(module.exports, "uuid6", function () { return $496932f48e9d3fc1$export$1d78c41b29712c01; });
$parcel$export(module.exports, "uuid7", function () { return $496932f48e9d3fc1$export$b3092b3ac1fa0ace; });
$parcel$export(module.exports, "email", function () { return $496932f48e9d3fc1$export$d290fa47940df19d; });
$parcel$export(module.exports, "html5Email", function () { return $496932f48e9d3fc1$export$d2c782992f0a89ee; });
$parcel$export(module.exports, "rfc5322Email", function () { return $496932f48e9d3fc1$export$54f6bc2d4fd0bb08; });
$parcel$export(module.exports, "unicodeEmail", function () { return $496932f48e9d3fc1$export$f8855510ae7521df; });
$parcel$export(module.exports, "idnEmail", function () { return $496932f48e9d3fc1$export$d402ea1c27a77371; });
$parcel$export(module.exports, "browserEmail", function () { return $496932f48e9d3fc1$export$9d1ec0311c8ce72e; });
$parcel$export(module.exports, "emoji", function () { return $496932f48e9d3fc1$export$a19185d1233fc4b2; });
$parcel$export(module.exports, "ipv4", function () { return $496932f48e9d3fc1$export$291a17a16047f284; });
$parcel$export(module.exports, "ipv6", function () { return $496932f48e9d3fc1$export$4e0c86a59c658526; });
$parcel$export(module.exports, "mac", function () { return $496932f48e9d3fc1$export$f8d11e097856efcf; });
$parcel$export(module.exports, "cidrv4", function () { return $496932f48e9d3fc1$export$fc96793d9715e5a1; });
$parcel$export(module.exports, "cidrv6", function () { return $496932f48e9d3fc1$export$b6e650831cac87fb; });
$parcel$export(module.exports, "base64", function () { return $496932f48e9d3fc1$export$b3b2de96497acc47; });
$parcel$export(module.exports, "base64url", function () { return $496932f48e9d3fc1$export$7d21597c7bc64465; });
$parcel$export(module.exports, "hostname", function () { return $496932f48e9d3fc1$export$640106f6dc7d2706; });
$parcel$export(module.exports, "domain", function () { return $496932f48e9d3fc1$export$21779e503be4cd98; });
$parcel$export(module.exports, "httpProtocol", function () { return $496932f48e9d3fc1$export$b23749f357fbda41; });
$parcel$export(module.exports, "e164", function () { return $496932f48e9d3fc1$export$2fa5ed24c9ef198e; });
$parcel$export(module.exports, "creditCard", function () { return $496932f48e9d3fc1$export$34823d8b18327f02; });
$parcel$export(module.exports, "date", function () { return $496932f48e9d3fc1$export$324d90190a8b822a; });
$parcel$export(module.exports, "time", function () { return $496932f48e9d3fc1$export$2da9be4cfdb689b1; });
$parcel$export(module.exports, "datetime", function () { return $496932f48e9d3fc1$export$7ba4466dbd0f07e1; });
$parcel$export(module.exports, "string", function () { return $496932f48e9d3fc1$export$22b082955e083ec3; });
$parcel$export(module.exports, "bigint", function () { return $496932f48e9d3fc1$export$a0f65b52274bcc00; });
$parcel$export(module.exports, "integer", function () { return $496932f48e9d3fc1$export$32744b5b3bba4764; });
$parcel$export(module.exports, "number", function () { return $496932f48e9d3fc1$export$98e628dec113755e; });
$parcel$export(module.exports, "boolean", function () { return $496932f48e9d3fc1$export$4a21f16c33752377; });
$parcel$export(module.exports, "null", function () { return $496932f48e9d3fc1$export$7b1b591b262c240; });
$parcel$export(module.exports, "undefined", function () { return $496932f48e9d3fc1$export$1db45310990710a5; });
$parcel$export(module.exports, "lowercase", function () { return $496932f48e9d3fc1$export$5b1f80f3c282648c; });
$parcel$export(module.exports, "uppercase", function () { return $496932f48e9d3fc1$export$6cfe151e6b925e83; });
$parcel$export(module.exports, "hex", function () { return $496932f48e9d3fc1$export$834dfc94dde4b3d8; });
$parcel$export(module.exports, "md5_hex", function () { return $496932f48e9d3fc1$export$7d7ef811f6d53a1; });
$parcel$export(module.exports, "md5_base64", function () { return $496932f48e9d3fc1$export$85425f7cda9f4890; });
$parcel$export(module.exports, "md5_base64url", function () { return $496932f48e9d3fc1$export$e54699b04083758c; });
$parcel$export(module.exports, "sha1_hex", function () { return $496932f48e9d3fc1$export$2f163473ef893e12; });
$parcel$export(module.exports, "sha1_base64", function () { return $496932f48e9d3fc1$export$fc9670fedfd2524a; });
$parcel$export(module.exports, "sha1_base64url", function () { return $496932f48e9d3fc1$export$5b6729b977839ffd; });
$parcel$export(module.exports, "sha256_hex", function () { return $496932f48e9d3fc1$export$a923016129fea5fb; });
$parcel$export(module.exports, "sha256_base64", function () { return $496932f48e9d3fc1$export$ebc25582a9e85396; });
$parcel$export(module.exports, "sha256_base64url", function () { return $496932f48e9d3fc1$export$9b7979bfebd9716e; });
$parcel$export(module.exports, "sha384_hex", function () { return $496932f48e9d3fc1$export$61d1fe464d10a5d1; });
$parcel$export(module.exports, "sha384_base64", function () { return $496932f48e9d3fc1$export$103403cb96133ac3; });
$parcel$export(module.exports, "sha384_base64url", function () { return $496932f48e9d3fc1$export$eeafcb7aab6a9870; });
$parcel$export(module.exports, "sha512_hex", function () { return $496932f48e9d3fc1$export$e246a4310a1ad74d; });
$parcel$export(module.exports, "sha512_base64", function () { return $496932f48e9d3fc1$export$f698997e063dbdae; });
$parcel$export(module.exports, "sha512_base64url", function () { return $496932f48e9d3fc1$export$a63330069e1b81f6; });

var $c0663 = parcelRequire("c0663");
const $496932f48e9d3fc1$export$e057ec210c7d3443 = /^[cC][0-9a-z]{6,}$/;
const $496932f48e9d3fc1$export$af5866a6cccce9f0 = /^[0-9a-z]+$/;
const $496932f48e9d3fc1$export$c34778236461ea95 = /^[0-7][0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{25}$/;
const $496932f48e9d3fc1$export$5eecaf20006cb6cb = /^[0-9a-vA-V]{20}$/;
const $496932f48e9d3fc1$export$f49b11deeb9beb0f = /^[A-Za-z0-9]{27}$/;
const $496932f48e9d3fc1$export$ac4959f4f1338dfc = /^[a-zA-Z0-9_-]{21}$/;
function $496932f48e9d3fc1$export$5e38a73263010503(length) {
    return new RegExp(`^[a-zA-Z0-9_-]{${length}}$`);
}
const $496932f48e9d3fc1$export$1f34108aa9eb96ab = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/;
const $496932f48e9d3fc1$export$e30244ba59a8cd84 = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
const $496932f48e9d3fc1$export$46e8f25c7328f77e = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/;
const $496932f48e9d3fc1$export$31b40729666a4ae0 = (version)=>{
    if (!version) return /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/;
    return new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${version}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`);
};
const $496932f48e9d3fc1$export$19f53698e68b2496 = /*@__PURE__*/ $496932f48e9d3fc1$export$31b40729666a4ae0(4);
const $496932f48e9d3fc1$export$1d78c41b29712c01 = /*@__PURE__*/ $496932f48e9d3fc1$export$31b40729666a4ae0(6);
const $496932f48e9d3fc1$export$b3092b3ac1fa0ace = /*@__PURE__*/ $496932f48e9d3fc1$export$31b40729666a4ae0(7);
const $496932f48e9d3fc1$export$d290fa47940df19d = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/;
const $496932f48e9d3fc1$export$d2c782992f0a89ee = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const $496932f48e9d3fc1$export$54f6bc2d4fd0bb08 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const $496932f48e9d3fc1$export$f8855510ae7521df = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u;
const $496932f48e9d3fc1$export$d402ea1c27a77371 = $496932f48e9d3fc1$export$f8855510ae7521df;
const $496932f48e9d3fc1$export$9d1ec0311c8ce72e = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
// Single character class, not an alternation: the two properties overlap (U+1F9B0-U+1F9B3), so `(A|B)+` backtracks exponentially on a failed match.
const $496932f48e9d3fc1$var$_emoji = `^[\\p{Extended_Pictographic}\\p{Emoji_Component}]+$`;
function $496932f48e9d3fc1$export$a19185d1233fc4b2() {
    return new RegExp($496932f48e9d3fc1$var$_emoji, "u");
}
const $496932f48e9d3fc1$export$291a17a16047f284 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $496932f48e9d3fc1$export$4e0c86a59c658526 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;
const $496932f48e9d3fc1$export$f8d11e097856efcf = (delimiter)=>{
    const escapedDelim = $c0663.escapeRegex(delimiter ?? ":");
    return new RegExp(`^(?:[0-9A-F]{2}${escapedDelim}){5}[0-9A-F]{2}$|^(?:[0-9a-f]{2}${escapedDelim}){5}[0-9a-f]{2}$`);
};
const $496932f48e9d3fc1$export$fc96793d9715e5a1 = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/;
const $496932f48e9d3fc1$export$b6e650831cac87fb = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
const $496932f48e9d3fc1$export$b3b2de96497acc47 = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/;
const $496932f48e9d3fc1$export$7d21597c7bc64465 = /^[A-Za-z0-9_-]*$/;
const $496932f48e9d3fc1$export$640106f6dc7d2706 = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/;
const $496932f48e9d3fc1$export$21779e503be4cd98 = /^(?=.{1,253}$)([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/;
const $496932f48e9d3fc1$export$b23749f357fbda41 = /^https?$/;
const $496932f48e9d3fc1$export$2fa5ed24c9ef198e = /^\+[1-9]\d{6,14}$/;
const $496932f48e9d3fc1$export$34823d8b18327f02 = /^\d(?:[ -]?\d){11,18}$/;
const $496932f48e9d3fc1$var$dateSource = `(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))`;
/** Anchors a pattern source. The interpolation lives here rather than at the call site because
 * esbuild will not drop a `@__PURE__` call whose own argument interpolates a variable, but it
 * will drop `anchor(dateSource)`. Keeping it inline pinned `date` into every bundle. */ function $496932f48e9d3fc1$var$anchor(source) {
    return new RegExp(`^${source}$`);
}
const $496932f48e9d3fc1$export$324d90190a8b822a = /*@__PURE__*/ $496932f48e9d3fc1$var$anchor($496932f48e9d3fc1$var$dateSource);
function $496932f48e9d3fc1$var$timeSource(args) {
    const hhmm = `(?:[01]\\d|2[0-3]):[0-5]\\d`;
    const regex = typeof args.precision === "number" ? args.precision === -1 ? `${hhmm}` : args.precision === 0 ? `${hhmm}:[0-5]\\d` : `${hhmm}:[0-5]\\d\\.\\d{${args.precision}}` : args.seconds ? `${hhmm}:[0-5]\\d(?:\\.\\d+)?` : `${hhmm}(?::[0-5]\\d(?:\\.\\d+)?)?`;
    return regex;
}
function $496932f48e9d3fc1$export$2da9be4cfdb689b1(args) {
    return new RegExp(`^${$496932f48e9d3fc1$var$timeSource(args)}$`);
}
function $496932f48e9d3fc1$export$7ba4466dbd0f07e1(args) {
    const opts = [
        "Z"
    ];
    // if (args.offset) opts.push(`([+-]\\d{2}:\\d{2})`);
    if (args.offset) opts.push(`([+-](?:[01]\\d|2[0-3]):[0-5]\\d)`);
    // RFC 3339 mandates seconds wherever the time carries a `Z` or an offset, so only the unqualified form `local` adds may omit them
    const qualified = `${$496932f48e9d3fc1$var$timeSource({
        precision: args.precision,
        seconds: true
    })}(?:${opts.join("|")})`;
    const timeRegex = args.local ? `${qualified}|${$496932f48e9d3fc1$var$timeSource({
        precision: args.precision
    })}` : qualified;
    return new RegExp(`^${$496932f48e9d3fc1$var$dateSource}T(?:${timeRegex})$`);
}
const $496932f48e9d3fc1$export$22b082955e083ec3 = (params)=>{
    const regex = params ? `[\\s\\S]{${params?.minimum ?? 0},${params?.maximum ?? ""}}` : `[\\s\\S]*`;
    return new RegExp(`^${regex}$`);
};
const $496932f48e9d3fc1$export$a0f65b52274bcc00 = /^-?\d+n?$/;
const $496932f48e9d3fc1$export$32744b5b3bba4764 = /^-?\d+$/;
const $496932f48e9d3fc1$export$98e628dec113755e = /^-?\d+(?:\.\d+)?$/;
const $496932f48e9d3fc1$export$4a21f16c33752377 = /^(?:true|false)$/i;
const $496932f48e9d3fc1$export$7b1b591b262c240 = /^null$/i;
const $496932f48e9d3fc1$export$1db45310990710a5 = /^undefined$/i;
const $496932f48e9d3fc1$export$5b1f80f3c282648c = /^[^A-Z]*$/;
const $496932f48e9d3fc1$export$6cfe151e6b925e83 = /^[^a-z]*$/;
const $496932f48e9d3fc1$export$834dfc94dde4b3d8 = /^[0-9a-fA-F]*$/;
// Hash regexes for different algorithms and encodings
// Helper function to create base64 regex with exact length and padding
function $496932f48e9d3fc1$var$fixedBase64(bodyLength, padding) {
    return new RegExp(`^[A-Za-z0-9+/]{${bodyLength}}${padding}$`);
}
// Helper function to create base64url regex with exact length (no padding)
function $496932f48e9d3fc1$var$fixedBase64url(length) {
    return new RegExp(`^[A-Za-z0-9_-]{${length}}$`);
}
const $496932f48e9d3fc1$export$7d7ef811f6d53a1 = /^[0-9a-fA-F]{32}$/;
const $496932f48e9d3fc1$export$85425f7cda9f4890 = /*@__PURE__*/ $496932f48e9d3fc1$var$fixedBase64(22, "==");
const $496932f48e9d3fc1$export$e54699b04083758c = /*@__PURE__*/ $496932f48e9d3fc1$var$fixedBase64url(22);
const $496932f48e9d3fc1$export$2f163473ef893e12 = /^[0-9a-fA-F]{40}$/;
const $496932f48e9d3fc1$export$fc9670fedfd2524a = /*@__PURE__*/ $496932f48e9d3fc1$var$fixedBase64(27, "=");
const $496932f48e9d3fc1$export$5b6729b977839ffd = /*@__PURE__*/ $496932f48e9d3fc1$var$fixedBase64url(27);
const $496932f48e9d3fc1$export$a923016129fea5fb = /^[0-9a-fA-F]{64}$/;
const $496932f48e9d3fc1$export$ebc25582a9e85396 = /*@__PURE__*/ $496932f48e9d3fc1$var$fixedBase64(43, "=");
const $496932f48e9d3fc1$export$9b7979bfebd9716e = /*@__PURE__*/ $496932f48e9d3fc1$var$fixedBase64url(43);
const $496932f48e9d3fc1$export$61d1fe464d10a5d1 = /^[0-9a-fA-F]{96}$/;
const $496932f48e9d3fc1$export$103403cb96133ac3 = /*@__PURE__*/ $496932f48e9d3fc1$var$fixedBase64(64, "");
const $496932f48e9d3fc1$export$eeafcb7aab6a9870 = /*@__PURE__*/ $496932f48e9d3fc1$var$fixedBase64url(64);
const $496932f48e9d3fc1$export$e246a4310a1ad74d = /^[0-9a-fA-F]{128}$/;
const $496932f48e9d3fc1$export$f698997e063dbdae = /*@__PURE__*/ $496932f48e9d3fc1$var$fixedBase64(86, "==");
const $496932f48e9d3fc1$export$a63330069e1b81f6 = /*@__PURE__*/ $496932f48e9d3fc1$var$fixedBase64url(86);

});


parcelRegister("eTOwy", function(module, exports) {

$parcel$export(module.exports, "globalRegistry", function () { return $ad8d64c726ff8218$export$bc58ce2776ecdb6f; });
var $ad8d64c726ff8218$var$_a;
const $ad8d64c726ff8218$export$26c272954616d4a2 = /*@__PURE__*/ Symbol("ZodOutput");
const $ad8d64c726ff8218$export$4159eb10f43487af = /*@__PURE__*/ Symbol("ZodInput");
class $ad8d64c726ff8218$export$dc03955eec152cc5 {
    constructor(){
        this._map = new WeakMap();
        this._idmap = new Map();
    }
    add(schema, ..._meta) {
        const meta = _meta[0];
        this._map.set(schema, meta);
        if (meta && typeof meta === "object" && "id" in meta) this._idmap.set(meta.id, schema);
        return this;
    }
    clear() {
        this._map = new WeakMap();
        this._idmap = new Map();
        return this;
    }
    remove(schema) {
        const meta = this._map.get(schema);
        if (meta && typeof meta === "object" && "id" in meta) this._idmap.delete(meta.id);
        this._map.delete(schema);
        return this;
    }
    get(schema) {
        // return this._map.get(schema) as any;
        // inherit metadata
        const p = schema._zod.parent;
        if (p) {
            const pm = {
                ...this.get(p) ?? {}
            };
            delete pm.id; // do not inherit id
            const f = {
                ...pm,
                ...this._map.get(schema)
            };
            return Object.keys(f).length ? f : undefined;
        }
        return this._map.get(schema);
    }
    has(schema) {
        return this._map.has(schema);
    }
}
function $ad8d64c726ff8218$export$4bb7493d241fd8a5() {
    return new $ad8d64c726ff8218$export$dc03955eec152cc5();
}
($ad8d64c726ff8218$var$_a = globalThis).__zod_globalRegistry ?? ($ad8d64c726ff8218$var$_a.__zod_globalRegistry = $ad8d64c726ff8218$export$4bb7493d241fd8a5());
const $ad8d64c726ff8218$export$bc58ce2776ecdb6f = globalThis.__zod_globalRegistry;

});

parcelRegister("MHJtW", function(module, exports) {

$parcel$export(module.exports, "$ZodType", function () { return $092668306e6c1914$export$f43a5c3966de8238; });
$parcel$export(module.exports, "standardProps", function () { return $092668306e6c1914$export$bcaeb817fdf064d3; });
$parcel$export(module.exports, "$ZodString", function () { return $092668306e6c1914$export$4342b4432d7b1471; });
$parcel$export(module.exports, "$ZodStringFormat", function () { return $092668306e6c1914$export$2d69a0d3057a5c7d; });
$parcel$export(module.exports, "$ZodGUID", function () { return $092668306e6c1914$export$4ca4397e3147da59; });
$parcel$export(module.exports, "$ZodUUID", function () { return $092668306e6c1914$export$8794aae384e3c177; });
$parcel$export(module.exports, "$ZodEmail", function () { return $092668306e6c1914$export$a3726aadb6108cdc; });
$parcel$export(module.exports, "$ZodURL", function () { return $092668306e6c1914$export$7e12af57cac08b7a; });
$parcel$export(module.exports, "$ZodEmoji", function () { return $092668306e6c1914$export$154cd448b85bb5a3; });
$parcel$export(module.exports, "$ZodNanoID", function () { return $092668306e6c1914$export$5a160d28c6d62c88; });
$parcel$export(module.exports, "$ZodCUID", function () { return $092668306e6c1914$export$f4f84bd3c6706e60; });
$parcel$export(module.exports, "$ZodCUID2", function () { return $092668306e6c1914$export$faf1483c11362df6; });
$parcel$export(module.exports, "$ZodULID", function () { return $092668306e6c1914$export$c5788701f4f55294; });
$parcel$export(module.exports, "$ZodXID", function () { return $092668306e6c1914$export$e721fd3317199b85; });
$parcel$export(module.exports, "$ZodKSUID", function () { return $092668306e6c1914$export$baa9849ea82bee6e; });
$parcel$export(module.exports, "$ZodISODateTime", function () { return $092668306e6c1914$export$3273e4d2df37774b; });
$parcel$export(module.exports, "$ZodISODate", function () { return $092668306e6c1914$export$75b9bf98f4d806dc; });
$parcel$export(module.exports, "$ZodISOTime", function () { return $092668306e6c1914$export$e9b9c3c2359a3ebc; });
$parcel$export(module.exports, "$ZodISODuration", function () { return $092668306e6c1914$export$d9e850ab18e4b22e; });
$parcel$export(module.exports, "$ZodIPv4", function () { return $092668306e6c1914$export$93fc833bbf7ceb99; });
$parcel$export(module.exports, "$ZodIPv6", function () { return $092668306e6c1914$export$8c939a460418a1bf; });
$parcel$export(module.exports, "$ZodMAC", function () { return $092668306e6c1914$export$747370108f97e6ea; });
$parcel$export(module.exports, "$ZodCIDRv4", function () { return $092668306e6c1914$export$e164feaf5ae5296b; });
$parcel$export(module.exports, "$ZodCIDRv6", function () { return $092668306e6c1914$export$3c3aacb740759234; });
$parcel$export(module.exports, "$ZodBase64", function () { return $092668306e6c1914$export$d7d4932079e2113d; });
$parcel$export(module.exports, "$ZodBase64URL", function () { return $092668306e6c1914$export$f5c3c3bbec012fa6; });
$parcel$export(module.exports, "$ZodE164", function () { return $092668306e6c1914$export$46d3507e8483217; });
$parcel$export(module.exports, "$ZodCreditCard", function () { return $092668306e6c1914$export$901cea49d453364b; });
$parcel$export(module.exports, "$ZodJWT", function () { return $092668306e6c1914$export$f515616cf0cda103; });
$parcel$export(module.exports, "$ZodCustomStringFormat", function () { return $092668306e6c1914$export$9dde4397c7b8a192; });
$parcel$export(module.exports, "$ZodNumber", function () { return $092668306e6c1914$export$b7292ed81eaafd49; });
$parcel$export(module.exports, "$ZodNumberFormat", function () { return $092668306e6c1914$export$2cfebe79b769ec9; });
$parcel$export(module.exports, "$ZodBoolean", function () { return $092668306e6c1914$export$828bf41e557d7dda; });
$parcel$export(module.exports, "$ZodBigInt", function () { return $092668306e6c1914$export$7600843f2a3baa73; });
$parcel$export(module.exports, "$ZodBigIntFormat", function () { return $092668306e6c1914$export$487194b75209a5dd; });
$parcel$export(module.exports, "$ZodSymbol", function () { return $092668306e6c1914$export$c9e7e1831bb8dd12; });
$parcel$export(module.exports, "$ZodUndefined", function () { return $092668306e6c1914$export$379ccf61f9830869; });
$parcel$export(module.exports, "$ZodNull", function () { return $092668306e6c1914$export$d05db4d7bc9da27d; });
$parcel$export(module.exports, "$ZodAny", function () { return $092668306e6c1914$export$de3a83ac65a18f35; });
$parcel$export(module.exports, "$ZodUnknown", function () { return $092668306e6c1914$export$37ea092643879ea0; });
$parcel$export(module.exports, "$ZodNever", function () { return $092668306e6c1914$export$4b2a18191b39c3b4; });
$parcel$export(module.exports, "$ZodVoid", function () { return $092668306e6c1914$export$6fd82db70787afbb; });
$parcel$export(module.exports, "$ZodDate", function () { return $092668306e6c1914$export$9a0ab9fbd61629f8; });
$parcel$export(module.exports, "$ZodArray", function () { return $092668306e6c1914$export$fd77bdade7d2292b; });
$parcel$export(module.exports, "$ZodObjectJIT", function () { return $092668306e6c1914$export$330feb3f8e03c085; });
$parcel$export(module.exports, "$ZodUnion", function () { return $092668306e6c1914$export$37a2350ef0bd638c; });
$parcel$export(module.exports, "$ZodXor", function () { return $092668306e6c1914$export$b04ced974a46c0b4; });
$parcel$export(module.exports, "$ZodDiscriminatedUnion", function () { return $092668306e6c1914$export$aad4f17edfb83795; });
$parcel$export(module.exports, "$ZodIntersection", function () { return $092668306e6c1914$export$2299250b426aba4b; });
$parcel$export(module.exports, "$ZodTuple", function () { return $092668306e6c1914$export$bba1b90a721dbd94; });
$parcel$export(module.exports, "$ZodRecord", function () { return $092668306e6c1914$export$cc20b90ec1a8c208; });
$parcel$export(module.exports, "$ZodMap", function () { return $092668306e6c1914$export$5ccfd30a7e358409; });
$parcel$export(module.exports, "$ZodSet", function () { return $092668306e6c1914$export$20cf27bc33a30268; });
$parcel$export(module.exports, "$ZodEnum", function () { return $092668306e6c1914$export$31462b6e6c50b618; });
$parcel$export(module.exports, "$ZodLiteral", function () { return $092668306e6c1914$export$86699355265fa258; });
$parcel$export(module.exports, "$ZodFile", function () { return $092668306e6c1914$export$1997de0576a81377; });
$parcel$export(module.exports, "$ZodTransform", function () { return $092668306e6c1914$export$14b591f873519189; });
$parcel$export(module.exports, "$ZodOptional", function () { return $092668306e6c1914$export$980e9af565c4d7aa; });
$parcel$export(module.exports, "$ZodExactOptional", function () { return $092668306e6c1914$export$384d083c2a6b693f; });
$parcel$export(module.exports, "$ZodNullable", function () { return $092668306e6c1914$export$7994573b6604ec66; });
$parcel$export(module.exports, "$ZodDefault", function () { return $092668306e6c1914$export$ae2d21004b7243f7; });
$parcel$export(module.exports, "$ZodPrefault", function () { return $092668306e6c1914$export$29a8d757258be679; });
$parcel$export(module.exports, "$ZodNonOptional", function () { return $092668306e6c1914$export$30ca726c4c50a6d7; });
$parcel$export(module.exports, "$ZodSuccess", function () { return $092668306e6c1914$export$3cc4d03e729326ea; });
$parcel$export(module.exports, "$ZodCatch", function () { return $092668306e6c1914$export$d6f8b228374f6d37; });
$parcel$export(module.exports, "$ZodNaN", function () { return $092668306e6c1914$export$528f71701e6a7aee; });
$parcel$export(module.exports, "$ZodPipe", function () { return $092668306e6c1914$export$4cb25cfde430326c; });
$parcel$export(module.exports, "$ZodCodec", function () { return $092668306e6c1914$export$c622e07db8a40b53; });
$parcel$export(module.exports, "$ZodPreprocess", function () { return $092668306e6c1914$export$200c161ed581d39b; });
$parcel$export(module.exports, "$ZodReadonly", function () { return $092668306e6c1914$export$f9f268f3fbb1601b; });
$parcel$export(module.exports, "$ZodTemplateLiteral", function () { return $092668306e6c1914$export$37ea86c57a77af54; });
$parcel$export(module.exports, "$ZodFunction", function () { return $092668306e6c1914$export$877c6e9c05ede764; });
$parcel$export(module.exports, "$ZodPromise", function () { return $092668306e6c1914$export$bdefabff0dd84ca4; });
$parcel$export(module.exports, "$ZodLazy", function () { return $092668306e6c1914$export$662fecee2efa1a66; });
$parcel$export(module.exports, "$ZodCustom", function () { return $092668306e6c1914$export$3a5d0e5e098b79ba; });

var $9iCDw = parcelRequire("9iCDw");

var $59TZW = parcelRequire("59TZW");

var $flq6A = parcelRequire("flq6A");

var $3sMCt = parcelRequire("3sMCt");

var $6iLpq = parcelRequire("6iLpq");

var $c0663 = parcelRequire("c0663");

var $1Uzgp = parcelRequire("1Uzgp");
const $092668306e6c1914$export$f43a5c3966de8238 = /*@__PURE__*/ $59TZW.$constructor("$ZodType", (inst, def)=>{
    var _a;
    inst ?? (inst = {});
    inst._zod.def = def; // set _def property
    inst._zod.bag = inst._zod.bag || {}; // initialize _bag object
    inst._zod.version = (0, $1Uzgp.version);
    const defChecks = inst._zod.def.checks;
    // if inst is itself a checks.$ZodCheck, run it as a check
    const checks = inst._zod.traits.has("$ZodCheck") ? [
        inst,
        ...defChecks ?? []
    ] : defChecks?.length ? [
        ...defChecks
    ] : [];
    for (const ch of checks)for (const fn of ch._zod.onattach)fn(inst);
    if (checks.length === 0) {
        // deferred initializer inst._zod.parse is not yet defined
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        inst._zod.deferred?.push(()=>{
            inst._zod.run = inst._zod.parse;
        });
    } else {
        const runChecks = (payload, checks, ctx)=>{
            if (payload.memo) return payload;
            let isAborted = $c0663.aborted(payload);
            let asyncResult;
            for (const ch of checks){
                if (ch._zod.def.when) {
                    if ($c0663.explicitlyAborted(payload)) continue;
                    const shouldRun = ch._zod.def.when(payload);
                    if (!shouldRun) continue;
                } else if (isAborted) continue;
                const currLen = payload.issues.length;
                const _ = ch._zod.check(payload);
                if (_ instanceof Promise && ctx?.async === false) throw new $59TZW.$ZodAsyncError();
                if (asyncResult || _ instanceof Promise) asyncResult = (asyncResult ?? Promise.resolve()).then(async ()=>{
                    await _;
                    const nextLen = payload.issues.length;
                    if (nextLen === currLen) return;
                    $c0663.attachSchema(payload.issues, currLen, inst);
                    if (!isAborted) isAborted = $c0663.aborted(payload, currLen);
                });
                else {
                    const nextLen = payload.issues.length;
                    if (nextLen === currLen) continue;
                    $c0663.attachSchema(payload.issues, currLen, inst);
                    if (!isAborted) isAborted = $c0663.aborted(payload, currLen);
                }
            }
            if (asyncResult) return asyncResult.then(()=>{
                return payload;
            });
            return payload;
        };
        const handleCanaryResult = (canary, payload, ctx)=>{
            // abort if the canary is aborted
            if ($c0663.aborted(canary)) {
                canary.aborted = true;
                return canary;
            }
            // run checks first, then
            const checkResult = runChecks(payload, checks, ctx);
            if (checkResult instanceof Promise) {
                if (ctx.async === false) throw new $59TZW.$ZodAsyncError();
                return checkResult.then((checkResult)=>inst._zod.parse(checkResult, ctx));
            }
            return inst._zod.parse(checkResult, ctx);
        };
        inst._zod.run = (payload, ctx)=>{
            if (ctx.skipChecks) return inst._zod.parse(payload, ctx);
            if (ctx.direction === "backward") {
                // run canary initial pass (no checks)
                const canary = inst._zod.parse({
                    value: payload.value,
                    issues: []
                }, {
                    ...ctx,
                    skipChecks: true
                });
                if (canary instanceof Promise) return canary.then((canary)=>{
                    return handleCanaryResult(canary, payload, ctx);
                });
                return handleCanaryResult(canary, payload, ctx);
            }
            // forward
            const result = inst._zod.parse(payload, ctx);
            if (result instanceof Promise) {
                if (ctx.async === false) throw new $59TZW.$ZodAsyncError();
                return result.then((result)=>runChecks(result, checks, ctx));
            }
            return runChecks(result, checks, ctx);
        };
    }
}, {
    // Wrappers extend this by installing a richer factory over it; reading it eagerly would defeat the laziness.
    get "~standard" () {
        return $c0663.hide(this, "~standard", $092668306e6c1914$export$bcaeb817fdf064d3(this));
    },
    set "~standard" (value){
        $c0663.own(this, "~standard", value);
    }
});
/** The Standard Schema surface for `inst`. Shared so wrappers can extend it without forcing it. */ const $092668306e6c1914$var$toStandardResult = (r)=>r.success ? {
        value: r.data
    } : {
        issues: r.error?.issues
    };
function $092668306e6c1914$export$bcaeb817fdf064d3(inst) {
    return {
        validate: (value1)=>{
            try {
                return $092668306e6c1914$var$toStandardResult((0, $3sMCt.safeParse)(inst, value1));
            } catch (_) {
                return (0, $3sMCt.safeParseAsync)(inst, value1).then($092668306e6c1914$var$toStandardResult);
            }
        },
        vendor: "zod",
        version: 1
    };
}
const $092668306e6c1914$export$4342b4432d7b1471 = /*@__PURE__*/ $59TZW.$constructor("$ZodString", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = [
        ...inst?._zod.bag?.patterns ?? []
    ].pop() ?? $6iLpq.string(inst._zod.bag);
    inst._zod.parse = (payload, _)=>{
        if (def.coerce) try {
            payload.value = String(payload.value);
        } catch (_) {}
        if (typeof payload.value === "string") return payload;
        payload.issues.push({
            expected: "string",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $092668306e6c1914$export$2d69a0d3057a5c7d = /*@__PURE__*/ $59TZW.$constructor("$ZodStringFormat", (inst, def)=>{
    // check initialization must come first
    $9iCDw.$ZodCheckStringFormat.init(inst, def);
    $092668306e6c1914$export$4342b4432d7b1471.init(inst, def);
});
const $092668306e6c1914$export$4ca4397e3147da59 = /*@__PURE__*/ $59TZW.$constructor("$ZodGUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.guid);
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
});
const $092668306e6c1914$export$8794aae384e3c177 = /*@__PURE__*/ $59TZW.$constructor("$ZodUUID", (inst, def)=>{
    if (def.version) {
        const versionMap = {
            v1: 1,
            v2: 2,
            v3: 3,
            v4: 4,
            v5: 5,
            v6: 6,
            v7: 7,
            v8: 8
        };
        const v = versionMap[def.version];
        if (v === undefined) throw new Error(`Invalid UUID version: "${def.version}"`);
        def.pattern ?? (def.pattern = $6iLpq.uuid(v));
    } else def.pattern ?? (def.pattern = $6iLpq.uuid());
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
});
const $092668306e6c1914$export$a3726aadb6108cdc = /*@__PURE__*/ $59TZW.$constructor("$ZodEmail", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.email);
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
});
const $092668306e6c1914$export$f460f59bb193614e = 1;
const $092668306e6c1914$export$95483bc06fdd8d2 = 2;
function $092668306e6c1914$export$f2bb86aa76d51ae5(trimmed, def) {
    // When normalize is off, require :// for http/https URLs. This prevents strings like "http:example.com" or "https:/path" from being silently accepted
    if (!def.normalize && def.protocol?.source === $6iLpq.httpProtocol.source && !/^https?:\/\//i.test(trimmed)) return $092668306e6c1914$export$f460f59bb193614e;
    try {
        // @ts-ignore
        return new URL(trimmed);
    } catch  {
        return $092668306e6c1914$export$95483bc06fdd8d2;
    }
}
const $092668306e6c1914$var$asciiTabOrNewline = /[\t\n\r]/g;
function $092668306e6c1914$export$165c9bc4c1279215(value1) {
    return value1.replace($092668306e6c1914$var$asciiTabOrNewline, "");
}
function $092668306e6c1914$export$1c04d86e3f4d2da0(url, hostname) {
    hostname.lastIndex = 0;
    return hostname.test(url.hostname);
}
function $092668306e6c1914$export$d090bf6bb05011ae(url, protocol) {
    protocol.lastIndex = 0;
    return protocol.test(url.protocol.endsWith(":") ? url.protocol.slice(0, -1) : url.protocol);
}
const $092668306e6c1914$export$7e12af57cac08b7a = /*@__PURE__*/ $59TZW.$constructor("$ZodURL", (inst, def)=>{
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        try {
            // Trim whitespace from input
            const trimmed = payload.value.trim();
            const url = $092668306e6c1914$export$f2bb86aa76d51ae5(trimmed, def);
            if (url === $092668306e6c1914$export$f460f59bb193614e) {
                payload.issues.push({
                    code: "invalid_format",
                    format: "url",
                    note: "Invalid URL format",
                    input: payload.value,
                    inst: inst,
                    continue: !def.abort
                });
                return;
            }
            if (url === $092668306e6c1914$export$95483bc06fdd8d2) {
                payload.issues.push({
                    code: "invalid_format",
                    format: "url",
                    input: payload.value,
                    inst: inst,
                    continue: !def.abort
                });
                return;
            }
            if (def.hostname && !$092668306e6c1914$export$1c04d86e3f4d2da0(url, def.hostname)) payload.issues.push({
                code: "invalid_format",
                format: "url",
                note: "Invalid hostname",
                pattern: def.hostname.source,
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
            if (def.protocol && !$092668306e6c1914$export$d090bf6bb05011ae(url, def.protocol)) payload.issues.push({
                code: "invalid_format",
                format: "url",
                note: "Invalid protocol",
                pattern: def.protocol.source,
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
            // Set the output value based on normalize flag
            payload.value = def.normalize ? url.href : $092668306e6c1914$export$165c9bc4c1279215(trimmed);
            return;
        } catch (_) {
            payload.issues.push({
                code: "invalid_format",
                format: "url",
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
        }
    };
});
const $092668306e6c1914$export$154cd448b85bb5a3 = /*@__PURE__*/ $59TZW.$constructor("$ZodEmoji", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.emoji());
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
});
const $092668306e6c1914$export$5a160d28c6d62c88 = /*@__PURE__*/ $59TZW.$constructor("$ZodNanoID", (inst, def)=>{
    if (def.length !== undefined && (!Number.isInteger(def.length) || def.length < 1)) throw new Error(`Invalid nanoid length: ${def.length}`);
    def.pattern ?? (def.pattern = def.length === undefined ? $6iLpq.nanoid : $6iLpq.nanoidOfLength(def.length));
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
});
const $092668306e6c1914$export$f4f84bd3c6706e60 = /*@__PURE__*/ $59TZW.$constructor("$ZodCUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.cuid);
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
});
const $092668306e6c1914$export$faf1483c11362df6 = /*@__PURE__*/ $59TZW.$constructor("$ZodCUID2", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.cuid2);
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
});
const $092668306e6c1914$export$c5788701f4f55294 = /*@__PURE__*/ $59TZW.$constructor("$ZodULID", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.ulid);
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
});
const $092668306e6c1914$export$e721fd3317199b85 = /*@__PURE__*/ $59TZW.$constructor("$ZodXID", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.xid);
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
});
const $092668306e6c1914$export$baa9849ea82bee6e = /*@__PURE__*/ $59TZW.$constructor("$ZodKSUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.ksuid);
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
});
const $092668306e6c1914$export$3273e4d2df37774b = /*@__PURE__*/ $59TZW.$constructor("$ZodISODateTime", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.datetime(def));
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
    // these two drop the offset or seconds `date-time` requires — on the bag not the def, since `z.string().check(...)` lands the format on a different schema
    if (def.local || def.precision === -1) {
        inst._zod.bag.laxFormat = true;
        inst._zod.onattach.push((s)=>{
            s._zod.bag.laxFormat = true;
        });
    }
});
const $092668306e6c1914$export$75b9bf98f4d806dc = /*@__PURE__*/ $59TZW.$constructor("$ZodISODate", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.date);
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
});
const $092668306e6c1914$export$e9b9c3c2359a3ebc = /*@__PURE__*/ $59TZW.$constructor("$ZodISOTime", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.time(def));
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
});
const $092668306e6c1914$export$d9e850ab18e4b22e = /*@__PURE__*/ $59TZW.$constructor("$ZodISODuration", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.duration);
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
});
const $092668306e6c1914$export$93fc833bbf7ceb99 = /*@__PURE__*/ $59TZW.$constructor("$ZodIPv4", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.ipv4);
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.bag.format = `ipv4`;
});
/** An IPv6 address is written with hex digits, colons and dots, and nothing else. The guard is what makes the check below an IPv6 check: `new URL("http://[...]")` parses an authority, not an address, so `@` and `\` re-delimit it and `"::@1\\"` validates against the host `0.0.0.1`. The URL parser also deletes ASCII tab, LF and CR rather than failing, which is how `"::1\n"` validated as `::1`. */ const $092668306e6c1914$var$ipv6Alphabet = /^[0-9a-fA-F:.]+$/;
function $092668306e6c1914$export$a04342fa1d51a93c(value1) {
    if (!$092668306e6c1914$var$ipv6Alphabet.test(value1)) return false;
    try {
        // @ts-ignore
        new URL(`http://[${value1}]`);
        return true;
    } catch  {
        return false;
    }
}
const $092668306e6c1914$export$8c939a460418a1bf = /*@__PURE__*/ $59TZW.$constructor("$ZodIPv6", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.ipv6);
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.bag.format = `ipv6`;
    inst._zod.check = (payload)=>{
        if (!$092668306e6c1914$export$a04342fa1d51a93c(payload.value)) payload.issues.push({
            code: "invalid_format",
            format: "ipv6",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $092668306e6c1914$export$747370108f97e6ea = /*@__PURE__*/ $59TZW.$constructor("$ZodMAC", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.mac(def.delimiter));
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.bag.format = `mac`;
});
const $092668306e6c1914$export$e164feaf5ae5296b = /*@__PURE__*/ $59TZW.$constructor("$ZodCIDRv4", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.cidrv4);
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
});
function $092668306e6c1914$export$5a4fa0b686dce6df(value1) {
    const parts = value1.split("/");
    if (parts.length !== 2) return false;
    const [address, prefix] = parts;
    if (!prefix) return false;
    const prefixNum = Number(prefix);
    if (`${prefixNum}` !== prefix) return false;
    if (prefixNum < 0 || prefixNum > 128) return false;
    return $092668306e6c1914$export$a04342fa1d51a93c(address);
}
const $092668306e6c1914$export$3c3aacb740759234 = /*@__PURE__*/ $59TZW.$constructor("$ZodCIDRv6", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.cidrv6); // not used for validation
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if (!$092668306e6c1914$export$5a4fa0b686dce6df(payload.value)) payload.issues.push({
            code: "invalid_format",
            format: "cidrv6",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
function $092668306e6c1914$export$5f5b3f6a560c676b(data) {
    if (data === "") return true;
    // atob ignores whitespace, so reject it up front.
    if (/\s/.test(data)) return false;
    if (data.length % 4 !== 0) return false;
    try {
        // @ts-ignore
        atob(data);
        return true;
    } catch  {
        return false;
    }
}
const $092668306e6c1914$export$d7d4932079e2113d = /*@__PURE__*/ $59TZW.$constructor("$ZodBase64", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.base64);
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.bag.contentEncoding = "base64";
    inst._zod.check = (payload)=>{
        if ($092668306e6c1914$export$5f5b3f6a560c676b(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "base64",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
function $092668306e6c1914$export$eb95420c5686a3be(data) {
    if (!$6iLpq.base64url.test(data)) return false;
    const base64 = data.replace(/[-_]/g, (c)=>c === "-" ? "+" : "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    return $092668306e6c1914$export$5f5b3f6a560c676b(padded);
}
const $092668306e6c1914$export$f5c3c3bbec012fa6 = /*@__PURE__*/ $59TZW.$constructor("$ZodBase64URL", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.base64url);
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.bag.contentEncoding = "base64url";
    inst._zod.check = (payload)=>{
        if ($092668306e6c1914$export$eb95420c5686a3be(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "base64url",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $092668306e6c1914$export$46d3507e8483217 = /*@__PURE__*/ $59TZW.$constructor("$ZodE164", (inst, def)=>{
    def.pattern ?? (def.pattern = $6iLpq.e164);
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
});
//////////////////////////////   ZodCreditCard   //////////////////////////////
const $092668306e6c1914$var$CC_SANITIZE = /[- ]/g;
/** Luhn checksum on a digit-only string. Adapted from valibot (MIT). */ function $092668306e6c1914$var$isLuhnAlgo(digits) {
    let length = digits.length;
    let bit = 1;
    let sum = 0;
    while(length){
        const value1 = +digits[--length];
        bit ^= 1;
        sum += bit ? [
            0,
            2,
            4,
            6,
            8,
            1,
            3,
            5,
            7,
            9
        ][value1] : value1;
    }
    return sum % 10 === 0;
}
function $092668306e6c1914$export$16723e63da389301(input) {
    if (!$6iLpq.creditCard.test(input)) return false;
    return $092668306e6c1914$var$isLuhnAlgo(input.replace($092668306e6c1914$var$CC_SANITIZE, ""));
}
const $092668306e6c1914$export$901cea49d453364b = /*@__PURE__*/ $59TZW.$constructor("$ZodCreditCard", (inst, def)=>{
    // Shape only — the Luhn check below is not expressible as a pattern, so consumers of `pattern` (JSON Schema, template literals) get the length and separator rules alone.
    def.pattern ?? (def.pattern = $6iLpq.creditCard);
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if ($092668306e6c1914$export$16723e63da389301(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "credit_card",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
function $092668306e6c1914$export$5fc0c2a4042aff0a(token, algorithm = null) {
    try {
        const tokensParts = token.split(".");
        if (tokensParts.length !== 3) return false;
        const [header] = tokensParts;
        if (!header) return false;
        // @ts-ignore
        const parsedHeader = JSON.parse(atob(header));
        if ("typ" in parsedHeader && parsedHeader?.typ !== "JWT") return false;
        if (!parsedHeader.alg) return false;
        if (algorithm && (!("alg" in parsedHeader) || parsedHeader.alg !== algorithm)) return false;
        return true;
    } catch  {
        return false;
    }
}
const $092668306e6c1914$export$f515616cf0cda103 = /*@__PURE__*/ $59TZW.$constructor("$ZodJWT", (inst, def)=>{
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if ($092668306e6c1914$export$5fc0c2a4042aff0a(payload.value, def.alg)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "jwt",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $092668306e6c1914$export$9dde4397c7b8a192 = /*@__PURE__*/ $59TZW.$constructor("$ZodCustomStringFormat", (inst, def)=>{
    $092668306e6c1914$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if (def.fn(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: def.format,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $092668306e6c1914$export$b7292ed81eaafd49 = /*@__PURE__*/ $59TZW.$constructor("$ZodNumber", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = inst._zod.bag.pattern ?? $6iLpq.number;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = Number(payload.value);
        } catch (_) {}
        const input = payload.value;
        if (typeof input === "number" && !Number.isNaN(input) && Number.isFinite(input)) return payload;
        const received = typeof input === "number" ? Number.isNaN(input) ? "NaN" : !Number.isFinite(input) ? String(input) : undefined : undefined;
        payload.issues.push({
            expected: "number",
            code: "invalid_type",
            input: input,
            inst: inst,
            ...received ? {
                received: received
            } : {}
        });
        return payload;
    };
});
const $092668306e6c1914$export$2cfebe79b769ec9 = /*@__PURE__*/ $59TZW.$constructor("$ZodNumberFormat", (inst, def)=>{
    $9iCDw.$ZodCheckNumberFormat.init(inst, def);
    $092668306e6c1914$export$b7292ed81eaafd49.init(inst, def); // no format checks
});
const $092668306e6c1914$export$828bf41e557d7dda = /*@__PURE__*/ $59TZW.$constructor("$ZodBoolean", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $6iLpq.boolean;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = Boolean(payload.value);
        } catch (_) {}
        const input = payload.value;
        if (typeof input === "boolean") return payload;
        payload.issues.push({
            expected: "boolean",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $092668306e6c1914$export$7600843f2a3baa73 = /*@__PURE__*/ $59TZW.$constructor("$ZodBigInt", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $6iLpq.bigint;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = BigInt(payload.value);
        } catch (_) {}
        if (typeof payload.value === "bigint") return payload;
        payload.issues.push({
            expected: "bigint",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $092668306e6c1914$export$487194b75209a5dd = /*@__PURE__*/ $59TZW.$constructor("$ZodBigIntFormat", (inst, def)=>{
    $9iCDw.$ZodCheckBigIntFormat.init(inst, def);
    $092668306e6c1914$export$7600843f2a3baa73.init(inst, def); // no format checks
});
const $092668306e6c1914$export$c9e7e1831bb8dd12 = /*@__PURE__*/ $59TZW.$constructor("$ZodSymbol", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "symbol") return payload;
        payload.issues.push({
            expected: "symbol",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $092668306e6c1914$export$379ccf61f9830869 = /*@__PURE__*/ $59TZW.$constructor("$ZodUndefined", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $6iLpq.undefined;
    inst._zod.values = new Set([
        undefined
    ]);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "undefined") return payload;
        payload.issues.push({
            expected: "undefined",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $092668306e6c1914$export$d05db4d7bc9da27d = /*@__PURE__*/ $59TZW.$constructor("$ZodNull", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $6iLpq.null;
    inst._zod.values = new Set([
        null
    ]);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (input === null) return payload;
        payload.issues.push({
            expected: "null",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $092668306e6c1914$export$de3a83ac65a18f35 = /*@__PURE__*/ $59TZW.$constructor("$ZodAny", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload)=>payload;
});
const $092668306e6c1914$export$37ea092643879ea0 = /*@__PURE__*/ $59TZW.$constructor("$ZodUnknown", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload)=>payload;
});
const $092668306e6c1914$export$4b2a18191b39c3b4 = /*@__PURE__*/ $59TZW.$constructor("$ZodNever", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        payload.issues.push({
            expected: "never",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $092668306e6c1914$export$6fd82db70787afbb = /*@__PURE__*/ $59TZW.$constructor("$ZodVoid", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "undefined") return payload;
        payload.issues.push({
            expected: "void",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $092668306e6c1914$export$9a0ab9fbd61629f8 = /*@__PURE__*/ $59TZW.$constructor("$ZodDate", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = new Date(payload.value);
        } catch (_err) {}
        const input = payload.value;
        const isDate = input instanceof Date;
        const isValidDate = isDate && !Number.isNaN(input.getTime());
        if (isValidDate) return payload;
        payload.issues.push({
            expected: "date",
            code: "invalid_type",
            input: input,
            ...isDate ? {
                received: "Invalid Date"
            } : {},
            inst: inst
        });
        return payload;
    };
});
function $092668306e6c1914$var$handleArrayResult(result, final, index) {
    if (result.issues.length) final.issues.push(...$c0663.prefixIssues(index, result.issues));
    final.value[index] = result.value;
}
const $092668306e6c1914$export$fd77bdade7d2292b = /*@__PURE__*/ $59TZW.$constructor("$ZodArray", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    const memo = $59TZW.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!Array.isArray(input)) {
            payload.issues.push({
                expected: "array",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        payload.value = memo ? memo.alloc(inst, payload, Array(input.length), ctx) : Array(input.length);
        const proms = [];
        for(let i = 0; i < input.length; i++){
            const item = input[i];
            const result = def.element._zod.run({
                value: item,
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>$092668306e6c1914$var$handleArrayResult(result, payload, i)));
            else $092668306e6c1914$var$handleArrayResult(result, payload, i);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload; //handleArrayResultsAsync(parseResults, final);
    };
});
function $092668306e6c1914$var$handlePropertyResult(result, final, key, input, optin, optout) {
    const isPresent = key in input;
    const isOptionalOut = optout === "optional";
    // The middle rung means "absence permitted, nothing supplied in its place", so an absent key contributes nothing — whatever the schema made of `undefined` is invented, not substituted. Only `optional` reaches this with a value: `defaulted` substitutes, and a schema that isn't optional-out has to keep the key.
    if (!isPresent && isOptionalOut && optin === "optional") return;
    if (result.issues.length) {
        // For optional-in/out schemas, ignore errors on absent keys.
        if (optin !== undefined && isOptionalOut && !isPresent) return;
        final.issues.push(...$c0663.prefixIssues(key, result.issues));
    }
    if (!isPresent && optin === undefined) {
        if (!result.issues.length) final.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [
                key
            ]
        });
        return;
    }
    if (result.value === undefined) {
        if (isPresent) final.value[key] = undefined;
    } else final.value[key] = result.value;
}
// one shared instance; a fresh [] per schema cost 56 bytes retained
const $092668306e6c1914$var$NO_SYMBOL_KEYS = [];
function $092668306e6c1914$var$normalizeDef(def) {
    const keys = Object.keys(def.shape);
    const ownSymbols = Object.getOwnPropertySymbols(def.shape);
    const symbolKeys = ownSymbols.length ? ownSymbols : $092668306e6c1914$var$NO_SYMBOL_KEYS;
    // aliases `keys` when there are no symbols, so a string-only shape keeps one array
    const allKeys = symbolKeys.length ? [
        ...keys,
        ...symbolKeys
    ] : keys;
    for (const k of allKeys){
        if (!def.shape?.[k]?._zod?.traits?.has("$ZodType")) throw new Error(`Invalid element at key "${String(k)}": expected a Zod schema`);
    }
    const okeys = $c0663.optionalKeys(def.shape);
    return {
        ...def,
        allKeys: allKeys,
        symbolKeys: symbolKeys,
        // string-only: handleCatchall matches it against `for...in`, which never yields a symbol
        keySet: new Set(keys),
        numKeys: keys.length,
        optionalKeys: new Set(okeys)
    };
}
function $092668306e6c1914$var$handleCatchall(proms, input, payload, ctx, def, inst) {
    const unrecognized = [];
    const keySet = def.keySet;
    const _catchall = def.catchall._zod;
    const t = _catchall.def.type;
    const optin = _catchall.optin;
    const optout = _catchall.optout;
    for(const key in input){
        // Must precede the __proto__ branch: a declared key is not unrecognized, even though the shape loop deliberately strips __proto__ from the parsed output.
        if (keySet.has(key)) continue;
        // Don't copy an undeclared __proto__ into the result; assignment to a plain {} would replace the result prototype. But in strict mode it is still an unknown key, so report it before skipping.
        if (key === "__proto__") {
            if (t === "never") unrecognized.push(key);
            continue;
        }
        if (t === "never") {
            unrecognized.push(key);
            continue;
        }
        const r = _catchall.run({
            value: input[key],
            issues: []
        }, ctx);
        if (r instanceof Promise) proms.push(r.then((r)=>$092668306e6c1914$var$handlePropertyResult(r, payload, key, input, optin, optout)));
        else $092668306e6c1914$var$handlePropertyResult(r, payload, key, input, optin, optout);
    }
    if (unrecognized.length) payload.issues.push({
        code: "unrecognized_keys",
        keys: unrecognized,
        input: input,
        inst: inst,
        // Describes the shape of the input, not the validity of the parsed value, so it never aborts. The parse still fails; the schema's own checks just get to run first, and an enclosing intersection can reconcile the key against a sibling operand.
        continue: true
    });
    if (!proms.length) return payload;
    return Promise.all(proms).then(()=>{
        return payload;
    });
}
// Whichever object a def's `shape` currently answers from: the one the caller passed until the first read, the frozen copy after it. Keyed by def, so a def rebuilt by a builder is simply absent rather than inheriting the source's. Read its keys with `Object.keys`, which does not invoke them — that is what lets a discriminated union check its discriminator without resolving an option whose getters reference the union being constructed.
const $092668306e6c1914$var$propShapes = new WeakMap();
const $092668306e6c1914$export$54037a1ef79a4f1a = /*@__PURE__*/ $59TZW.$constructor("$ZodObject", (inst, def)=>{
    // requires cast because technically $ZodObject doesn't extend
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    // const sh = def.shape;
    const desc = Object.getOwnPropertyDescriptor(def, "shape");
    if (!desc?.get) {
        const sh = def.shape;
        $092668306e6c1914$var$propShapes.set(def, sh);
        Object.defineProperty(def, "shape", {
            get: ()=>{
                const newSh = {
                    ...sh
                };
                Object.defineProperty(def, "shape", {
                    value: newSh
                });
                $092668306e6c1914$var$propShapes.set(def, newSh);
                return newSh;
            }
        });
    }
    const _normalized = $c0663.cached(()=>$092668306e6c1914$var$normalizeDef(def));
    $c0663.defineLazyInternal(inst, "propValues", (zod)=>{
        const shape = zod.def.shape;
        const propValues = {};
        for(const key in shape){
            const field = shape[key]._zod;
            if (field.values) {
                if (!Object.prototype.hasOwnProperty.call(propValues, key)) $c0663.assignProp(propValues, key, new Set());
                for (const v of field.values)propValues[key].add(v);
                // An omittable slot reads back as undefined at a discriminator lookup, so it has to claim undefined: two options that can both omit the key are not discriminable on it.
                if (field.optin !== undefined) propValues[key].add(undefined);
            }
        }
        return propValues;
    });
    const isObject = $c0663.isObject;
    const catchall = def.catchall;
    let value1;
    const memo = $59TZW.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        value1 ?? (value1 = _normalized.value);
        const input = payload.value;
        if (!isObject(input)) {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        payload.value = memo ? memo.alloc(inst, payload, {}, ctx) : {};
        const proms = [];
        const shape = value1.shape;
        for (const key of value1.allKeys){
            if (key === "__proto__") continue;
            const el = shape[key];
            const optin = el._zod.optin;
            const optout = el._zod.optout;
            const r = el._zod.run({
                value: input[key],
                issues: []
            }, ctx);
            if (r instanceof Promise) proms.push(r.then((r)=>$092668306e6c1914$var$handlePropertyResult(r, payload, key, input, optin, optout)));
            else $092668306e6c1914$var$handlePropertyResult(r, payload, key, input, optin, optout);
        }
        if (!catchall) return proms.length ? Promise.all(proms).then(()=>payload) : payload;
        return $092668306e6c1914$var$handleCatchall(proms, input, payload, ctx, _normalized.value, inst);
    };
});
const $092668306e6c1914$export$330feb3f8e03c085 = /*@__PURE__*/ $59TZW.$constructor("$ZodObjectJIT", (inst, def)=>{
    // requires cast because technically $ZodObject doesn't extend
    $092668306e6c1914$export$54037a1ef79a4f1a.init(inst, def);
    const superParse = inst._zod.parse;
    const _normalized = $c0663.cached(()=>$092668306e6c1914$var$normalizeDef(def));
    const memo = $59TZW.globalConfig.memoizer;
    const generateFastpass = (shape)=>{
        const normalized = _normalized.value;
        const syms = normalized.symbolKeys;
        // a symbol has no source literal, so it is read as `syms[i]` off the closed-over scope
        const doc = new (0, $flq6A.Doc)([
            "payload",
            "ctx"
        ], {
            shape: shape,
            inst: inst,
            memo: memo,
            syms: syms
        });
        const parseStr = (k)=>`shape[${k}]._zod.run({ value: input[${k}], issues: [] }, ctx)`;
        // Prefixes in place, like util.prefixIssues does for every interpreted path.
        const prefixStr = (id, k)=>`
          for (let i = 0; i < ${id}.issues.length; i++) {
            const iss = ${id}.issues[i];
            iss.path = iss.path ? [${k}, ...iss.path] : [${k}];
            payload.issues.push(iss);
          }`;
        doc.write(`const input = payload.value;`);
        const ids = Object.create(null);
        let counter = 0;
        for (const key of normalized.allKeys)ids[key] = `key_${counter++}`;
        // A: preserve key order {
        doc.write(memo ? `const newResult = memo.alloc(inst, payload, {}, ctx);` : `const newResult = {};`);
        for (const key of normalized.allKeys){
            if (key === "__proto__") continue;
            const id = ids[key];
            const k = typeof key === "symbol" ? `syms[${syms.indexOf(key)}]` : $c0663.esc(key);
            const isPresent = `${k} in input`;
            const schema = shape[key];
            const optin = schema?._zod?.optin;
            const isOptionalIn = optin !== undefined;
            const isOptionalOut = schema?._zod?.optout === "optional";
            doc.write(`const ${id} = ${parseStr(k)};`);
            if (isOptionalIn && isOptionalOut) {
                // For optional-in/out schemas, ignore errors on absent keys — and, like the interpreted path, drop the value produced alongside them. The middle rung goes further: it permits absence without supplying anything in its place, so an absent key contributes nothing at all.
                const assign = optin === "optional" ? `${id}_present` : `${id}.value !== undefined || ${id}_present`;
                doc.write(`
        const ${id}_present = ${isPresent};
        if (!${id}.issues.length || ${id}_present) {
          if (${id}.issues.length) {${prefixStr(id, k)}
          }

          if (${assign}) {
            newResult[${k}] = ${id}.value;
          }
        }

      `);
            } else if (!isOptionalIn) doc.write(`
        const ${id}_present = ${isPresent};
        if (${id}.issues.length) {${prefixStr(id, k)}
        }
        if (!${id}_present && !${id}.issues.length) {
          payload.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [${k}]
          });
        }

        if (${id}_present) {
          newResult[${k}] = ${id}.value;
        }

      `);
            else doc.write(`
        if (${id}.issues.length) {${prefixStr(id, k)}
        }
        
        if (${id}.value === undefined) {
          if (${isPresent}) {
            newResult[${k}] = undefined;
          }
        } else {
          newResult[${k}] = ${id}.value;
        }

      `);
        }
        doc.write(`payload.value = newResult;`);
        doc.write(`return payload;`);
        // closing `shape` in is what pays: turbofan specializes the parser against that one shape object, so every `shape[k]._zod.run` folds to a known callee. as a parameter it stays a generic load and measures 13% slower even with the forwarding frame gone
        return doc.compile();
    };
    let fastpass;
    const isObject = $c0663.isObject;
    const jit = !$59TZW.globalConfig.jitless;
    const allowsEval = $c0663.allowsEval;
    const fastEnabled = jit && allowsEval.value; // && !def.catchall;
    const catchall = def.catchall;
    let value1;
    inst._zod.parse = (payload, ctx)=>{
        value1 ?? (value1 = _normalized.value);
        const input = payload.value;
        if (!isObject(input)) {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        if (jit && fastEnabled && ctx?.async === false && ctx.jitless !== true) {
            // always synchronous
            if (!fastpass) fastpass = generateFastpass(def.shape);
            payload = fastpass(payload, ctx);
            if (!catchall) return payload;
            return $092668306e6c1914$var$handleCatchall([], input, payload, ctx, value1, inst);
        }
        return superParse(payload, ctx);
    };
});
function $092668306e6c1914$var$handleUnionResults(results, final, inst, ctx) {
    for (const result of results)if (result.issues.length === 0) {
        final.value = result.value;
        return final;
    }
    const nonaborted = results.filter((r)=>!$c0663.aborted(r));
    if (nonaborted.length === 1) {
        final.value = nonaborted[0].value;
        return nonaborted[0];
    }
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst: inst,
        errors: results.map((result)=>result.issues.map((iss)=>$c0663.finalizeIssue(iss, ctx, $59TZW.config())))
    });
    return final;
}
const $092668306e6c1914$export$37a2350ef0bd638c = /*@__PURE__*/ $59TZW.$constructor("$ZodUnion", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    $c0663.defineLazyInternal(inst, "optin", (zod)=>zod.def.options.some((o)=>o._zod.optin === "defaulted") ? "defaulted" : zod.def.options.some((o)=>o._zod.optin !== undefined) ? "optional" : undefined);
    $c0663.defineLazyInternal(inst, "optout", (zod)=>zod.def.options.some((o)=>o._zod.optout === "optional") ? "optional" : undefined);
    $c0663.defineLazyInternal(inst, "values", (zod)=>{
        if (zod.def.options.every((o)=>o._zod.values)) return new Set(zod.def.options.flatMap((option)=>Array.from(option._zod.values)));
        return undefined;
    });
    $c0663.defineLazyInternal(inst, "pattern", (zod)=>{
        if (zod.def.options.every((o)=>o._zod.pattern)) {
            const patterns = zod.def.options.map((o)=>o._zod.pattern);
            return new RegExp(`^(${patterns.map((p)=>$c0663.cleanRegex(p.source)).join("|")})$`);
        }
        return undefined;
    });
    const first = def.options.length === 1 ? def.options[0]._zod.run : null;
    inst._zod.parse = (payload, ctx)=>{
        if (first) return first(payload, ctx);
        let async = false;
        const results = [];
        for (const option of def.options){
            const result = option._zod.run({
                value: payload.value,
                issues: []
            }, ctx);
            if (result instanceof Promise) {
                results.push(result);
                async = true;
            } else {
                if (result.issues.length === 0) return result;
                results.push(result);
            }
        }
        if (!async) return $092668306e6c1914$var$handleUnionResults(results, payload, inst, ctx);
        return Promise.all(results).then((results)=>{
            return $092668306e6c1914$var$handleUnionResults(results, payload, inst, ctx);
        });
    };
});
function $092668306e6c1914$var$handleExclusiveUnionResults(results, final, inst, ctx) {
    const matches = [];
    for(let i = 0; i < results.length; i++)if (results[i].issues.length === 0) matches.push(i);
    if (matches.length === 1) {
        final.value = results[matches[0]].value;
        return final;
    }
    if (matches.length === 0) // No matches - same as regular union
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst: inst,
        errors: results.map((result)=>result.issues.map((iss)=>$c0663.finalizeIssue(iss, ctx, $59TZW.config())))
    });
    else // Multiple matches - exclusive union failure
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst: inst,
        errors: [],
        inclusive: false,
        matches: matches
    });
    return final;
}
const $092668306e6c1914$export$b04ced974a46c0b4 = /*@__PURE__*/ $59TZW.$constructor("$ZodXor", (inst, def)=>{
    $092668306e6c1914$export$37a2350ef0bd638c.init(inst, def);
    def.inclusive = false;
    const first = def.options.length === 1 ? def.options[0]._zod.run : null;
    inst._zod.parse = (payload, ctx)=>{
        if (first) return first(payload, ctx);
        let async = false;
        const results = [];
        for (const option of def.options){
            const result = option._zod.run({
                value: payload.value,
                issues: []
            }, ctx);
            if (result instanceof Promise) {
                results.push(result);
                async = true;
            } else results.push(result);
        }
        if (!async) return $092668306e6c1914$var$handleExclusiveUnionResults(results, payload, inst, ctx);
        return Promise.all(results).then((results)=>{
            return $092668306e6c1914$var$handleExclusiveUnionResults(results, payload, inst, ctx);
        });
    };
});
function $092668306e6c1914$export$d95dcd4112c08983(union, value1) {
    const internals = union._zod;
    let map = internals.bag.optionsMap;
    if (!map) {
        map = new Map();
        const { options: options, discriminator: discriminator } = internals.def;
        for (const option of options){
            // First declaration wins, matching the order the parse path resolves a duplicate in.
            for (const v of option._zod.propValues?.[discriminator] ?? [])if (!map.has(v)) map.set(v, option);
        }
        internals.bag.optionsMap = map;
    }
    return map.get(value1);
}
const $092668306e6c1914$export$aad4f17edfb83795 = /*@__PURE__*/ $59TZW.$constructor("$ZodDiscriminatedUnion", (inst, def)=>{
    def.inclusive = false;
    $092668306e6c1914$export$37a2350ef0bd638c.init(inst, def);
    const _super = inst._zod.parse;
    $c0663.defineLazyInternal(inst, "propValues", (zod)=>{
        const propValues = {};
        for (const option of zod.def.options){
            const pv = option._zod.propValues;
            if (!pv || Object.keys(pv).length === 0) throw new Error(`Invalid discriminated union option at index "${zod.def.options.indexOf(option)}"`);
            for (const [k, v] of Object.entries(pv)){
                if (!Object.prototype.hasOwnProperty.call(propValues, k)) $c0663.assignProp(propValues, k, new Set());
                for (const val of v)propValues[k].add(val);
            }
        }
        return propValues;
    });
    // Checked now rather than in the lookup map below, so an option that lacks the discriminator fails at the `discriminatedUnion` call instead of on the first object parsed. Options whose shape cannot be enumerated without resolving it — pipes, lazies, and objects rebuilt by a builder such as `.extend()` — are left to the map.
    def.options.forEach((option, i)=>{
        const propShape = $092668306e6c1914$var$propShapes.get(option._zod.def);
        if (propShape && !Object.prototype.hasOwnProperty.call(propShape, def.discriminator)) throw new Error(`Invalid discriminated union option at index "${i}"`);
    });
    const disc = $c0663.cached(()=>{
        const opts = def.options;
        const map = new Map();
        for (const o of opts){
            const values = o._zod.propValues?.[def.discriminator];
            if (!values || values.size === 0) throw new Error(`Invalid discriminated union option at index "${def.options.indexOf(o)}"`);
            for (const v of values){
                if (map.has(v)) throw new Error(`Duplicate discriminator value "${String(v)}"`);
                map.set(v, o);
            }
        }
        return map;
    });
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!$c0663.isObject(input)) {
            payload.issues.push({
                code: "invalid_type",
                expected: "object",
                input: input,
                inst: inst
            });
            return payload;
        }
        const opt = disc.value.get(input?.[def.discriminator]);
        if (opt) return opt._zod.run(payload, ctx);
        // Fall back to union matching when the fast discriminator path fails:
        // - explicitly enabled via unionFallback, or
        // - during backward direction (encode), since codec-based discriminators have different values in forward vs backward directions
        if (def.unionFallback || ctx.direction === "backward") return _super(payload, ctx);
        // no matching discriminator
        payload.issues.push({
            code: "invalid_union",
            errors: [],
            note: "No matching discriminator",
            discriminator: def.discriminator,
            options: Array.from(disc.value.keys()),
            input: input,
            path: [
                def.discriminator
            ],
            inst: inst
        });
        return payload;
    };
});
const $092668306e6c1914$export$2299250b426aba4b = /*@__PURE__*/ $59TZW.$constructor("$ZodIntersection", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        const left = def.left._zod.run({
            value: input,
            issues: []
        }, ctx);
        const right = def.right._zod.run({
            value: input,
            issues: []
        }, ctx);
        const async = left instanceof Promise || right instanceof Promise;
        if (async) return Promise.all([
            left,
            right
        ]).then(([left, right])=>{
            return $092668306e6c1914$var$handleIntersectionResults(payload, left, right);
        });
        return $092668306e6c1914$var$handleIntersectionResults(payload, left, right);
    };
});
function $092668306e6c1914$export$4c2c6f84c333dcbc(a, b) {
    // const aType = parse.t(a);
    // const bType = parse.t(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    if (a instanceof Date && b instanceof Date && +a === +b) return {
        valid: true,
        data: a
    };
    if ($c0663.isPlainObject(a) && $c0663.isPlainObject(b)) {
        const bKeys = Object.keys(b);
        const sharedKeys = Object.keys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        if (Object.prototype.hasOwnProperty.call(newObj, "__proto__")) delete newObj.__proto__;
        for (const key of sharedKeys){
            if (key === "__proto__") continue;
            const sharedValue = $092668306e6c1914$export$4c2c6f84c333dcbc(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false,
                mergeErrorPath: [
                    key,
                    ...sharedValue.mergeErrorPath
                ]
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return {
            valid: false,
            mergeErrorPath: []
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $092668306e6c1914$export$4c2c6f84c333dcbc(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false,
                mergeErrorPath: [
                    index,
                    ...sharedValue.mergeErrorPath
                ]
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    }
    return {
        valid: false,
        mergeErrorPath: []
    };
}
function $092668306e6c1914$var$handleIntersectionResults(result, left, right) {
    // Track which side(s) reject each key. A key rejection is reported only when BOTH sides reject it, so a key owned by one branch survives the other's key schema. strictObject reports these as unrecognized_keys; a record with an open key schema reports one invalid_key per key.
    const unrecKeys = new Map();
    let unrecIssue;
    const keyIssues = new Map();
    const collect = (iss, side)=>{
        let keys;
        if (iss.code === "unrecognized_keys" && !iss.path?.length) {
            unrecIssue ?? (unrecIssue = iss);
            keys = iss.keys;
        } else if (iss.code === "invalid_key" && iss.origin === "record" && iss.path?.length === 1) {
            const k = String(iss.path[0]);
            if (!keyIssues.has(k)) keyIssues.set(k, iss);
            keys = [
                k
            ];
        } else return false;
        for (const k of keys){
            if (!unrecKeys.has(k)) unrecKeys.set(k, {});
            unrecKeys.get(k)[side] = true;
        }
        return true;
    };
    for (const iss of left.issues)if (!collect(iss, "l")) result.issues.push(iss);
    for (const iss of right.issues)if (!collect(iss, "r")) result.issues.push(iss);
    // Report only keys rejected by BOTH sides
    const bothKeys = [
        ...unrecKeys
    ].filter(([, f])=>f.l && f.r).map(([k])=>k);
    if (bothKeys.length) {
        const aggregated = unrecIssue ? bothKeys.filter((k)=>unrecIssue.keys.includes(k)) : [];
        if (aggregated.length) result.issues.push({
            ...unrecIssue,
            keys: aggregated
        });
        for (const k of bothKeys)if (!aggregated.includes(k) && keyIssues.has(k)) result.issues.push(keyIssues.get(k));
    }
    const merged = $092668306e6c1914$export$4c2c6f84c333dcbc(left.value, right.value);
    if (!merged.valid) {
        if ($c0663.aborted(result)) return result;
        throw new Error(`Unmergable intersection. Error path: ` + `${JSON.stringify(merged.mergeErrorPath)}`);
    }
    result.value = merged.data;
    return result;
}
const $092668306e6c1914$export$bba1b90a721dbd94 = /*@__PURE__*/ $59TZW.$constructor("$ZodTuple", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    const items = def.items;
    const memo = $59TZW.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!Array.isArray(input)) {
            payload.issues.push({
                input: input,
                inst: inst,
                expected: "tuple",
                code: "invalid_type"
            });
            return payload;
        }
        payload.value = memo ? memo.alloc(inst, payload, [], ctx) : [];
        const proms = [];
        const optinStart = $092668306e6c1914$var$getTupleOptStart(items, "optin");
        const optoutStart = $092668306e6c1914$var$getTupleOptStart(items, "optout");
        if (!def.rest) {
            if (input.length < optinStart) {
                payload.issues.push({
                    code: "too_small",
                    minimum: optinStart,
                    inclusive: true,
                    input: input,
                    inst: inst,
                    origin: "array"
                });
                return payload;
            }
            if (input.length > items.length) payload.issues.push({
                code: "too_big",
                maximum: items.length,
                inclusive: true,
                input: input,
                inst: inst,
                origin: "array"
            });
        }
        // Run every item in parallel, collecting results into an indexed array. The post-processing in `handleTupleResults` walks them in order so it can decide whether an absent optional-output error can truncate the tail or must be reported to preserve required output.
        const itemResults = new Array(items.length);
        for(let i = 0; i < items.length; i++){
            const r = items[i]._zod.run({
                value: input[i],
                issues: []
            }, ctx);
            if (r instanceof Promise) proms.push(r.then((rr)=>{
                itemResults[i] = rr;
            }));
            else itemResults[i] = r;
        }
        if (def.rest) {
            let i = items.length - 1;
            const rest = input.slice(items.length);
            for (const el of rest){
                i++;
                const result = def.rest._zod.run({
                    value: el,
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((r)=>$092668306e6c1914$var$handleTupleResult(r, payload, i)));
                else $092668306e6c1914$var$handleTupleResult(result, payload, i);
            }
        }
        if (proms.length) return Promise.all(proms).then(()=>$092668306e6c1914$var$handleTupleResults(itemResults, payload, items, input, optoutStart));
        return $092668306e6c1914$var$handleTupleResults(itemResults, payload, items, input, optoutStart);
    };
});
function $092668306e6c1914$var$getTupleOptStart(items, key) {
    for(let i = items.length - 1; i >= 0; i--){
        // optin is a three-rung ladder so any rung above `undefined` permits an absent slot; optout stays two-valued.
        const omittable = key === "optin" ? items[i]._zod.optin !== undefined : items[i]._zod.optout === "optional";
        if (!omittable) return i + 1;
    }
    return 0;
}
function $092668306e6c1914$var$handleTupleResult(result, final, index) {
    if (result.issues.length) final.issues.push(...$c0663.prefixIssues(index, result.issues));
    final.value[index] = result.value;
}
function $092668306e6c1914$var$handleTupleResults(itemResults, final, items, input, optoutStart) {
    // Walk results in order. Mirror $ZodObject's swallow-on-absent-optional rule, but only after `optoutStart`: the first index where the output tuple tail can be absent.
    for(let i = 0; i < items.length; i++){
        const r = itemResults[i];
        const isPresent = i < input.length;
        // The array analog of `handlePropertyResult`'s absent-key early return: the middle rung permits absence without supplying anything in its place, so the tail truncates here instead of materializing whatever the item made of `undefined`.
        if (!isPresent && i >= optoutStart && items[i]._zod.optin === "optional") {
            final.value.length = i;
            break;
        }
        if (r.issues.length) {
            if (!isPresent && i >= optoutStart) {
                final.value.length = i;
                break;
            }
            final.issues.push(...$c0663.prefixIssues(i, r.issues));
        }
        final.value[i] = r.value;
    }
    // Drop trailing slots that produced `undefined` for absent input
    // (the array analog of an absent optional key on an object). The
    // `i >= input.length` floor is critical: an explicit `undefined`
    // *inside* the input must be preserved even when the schema is
    // optional-out (e.g. `z.string().or(z.undefined())` accepting an
    // explicit undefined value).
    for(let i = final.value.length - 1; i >= input.length; i--){
        if (items[i]._zod.optout === "optional" && final.value[i] === undefined) final.value.length = i;
        else break;
    }
    return final;
}
const $092668306e6c1914$export$cc20b90ec1a8c208 = /*@__PURE__*/ $59TZW.$constructor("$ZodRecord", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    const memo = $59TZW.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!$c0663.isPlainObject(input)) {
            payload.issues.push({
                expected: "record",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        const proms = [];
        const values = def.keyType._zod.values;
        if (values && !def.partial) {
            payload.value = memo ? memo.alloc(inst, payload, {}, ctx) : {};
            const recordKeys = new Set();
            for (const key of values)if (typeof key === "string" || typeof key === "number" || typeof key === "symbol") {
                recordKeys.add(typeof key === "number" ? key.toString() : key);
                // A declared __proto__ is stripped but is not an unrecognized key.
                if (key === "__proto__") continue;
                const keyResult = def.keyType._zod.run({
                    value: key,
                    issues: []
                }, ctx);
                if (keyResult instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
                if (keyResult.issues.length) {
                    payload.issues.push({
                        code: "invalid_key",
                        origin: "record",
                        issues: keyResult.issues.map((iss)=>$c0663.finalizeIssue(iss, ctx, $59TZW.config())),
                        input: key,
                        path: [
                            key
                        ],
                        inst: inst
                    });
                    continue;
                }
                const outKey = keyResult.value;
                if (outKey === "__proto__") continue;
                const result = def.valueType._zod.run({
                    value: input[key],
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>{
                    if (result.issues.length) payload.issues.push(...$c0663.prefixIssues(key, result.issues));
                    payload.value[outKey] = result.value;
                }));
                else {
                    if (result.issues.length) payload.issues.push(...$c0663.prefixIssues(key, result.issues));
                    payload.value[outKey] = result.value;
                }
            }
            let unrecognized;
            for(const key in input)if (!recordKeys.has(key)) {
                if (def.mode === "loose") {
                    // skip __proto__ so it can't replace the result prototype via the assignment setter on the plain {} we build into
                    if (key === "__proto__") continue;
                    payload.value[key] = input[key];
                } else {
                    unrecognized = unrecognized ?? [];
                    unrecognized.push(key);
                }
            }
            if (unrecognized && unrecognized.length > 0) payload.issues.push({
                code: "unrecognized_keys",
                input: input,
                inst: inst,
                keys: unrecognized,
                continue: true
            });
        } else {
            payload.value = memo ? memo.alloc(inst, payload, {}, ctx) : {};
            // An enumerable key schema declares which keys the record owns, so a key outside the set is unrecognized. A non-enumerable one (regex, refine) is a constraint every key must satisfy, so a failing key is invalid. Only the former is reconcilable against the other side of an intersection.
            let unrecognized;
            // Reflect.ownKeys for Symbol-key support; filter non-enumerable to match z.object()
            for (const key of Reflect.ownKeys(input)){
                if (key === "__proto__") continue;
                if (!Object.prototype.propertyIsEnumerable.call(input, key)) continue;
                let keyResult = def.keyType._zod.run({
                    value: key,
                    issues: []
                }, ctx);
                if (keyResult instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
                // Numeric string fallback: if key is a numeric string and failed, retry with Number(key). This handles z.number(), z.literal([1, 2, 3]), and unions containing numeric literals
                const checkNumericKey = typeof key === "string" && $6iLpq.number.test(key) && keyResult.issues.length;
                if (checkNumericKey) {
                    const retryResult = def.keyType._zod.run({
                        value: Number(key),
                        issues: []
                    }, ctx);
                    if (retryResult instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
                    if (retryResult.issues.length === 0) keyResult = retryResult;
                }
                if (keyResult.issues.length) {
                    if (def.mode === "loose") // Pass through unchanged
                    payload.value[key] = input[key];
                    else if (values) {
                        unrecognized = unrecognized ?? [];
                        unrecognized.push(key);
                    } else // Default "strict" behavior: error on invalid key
                    payload.issues.push({
                        code: "invalid_key",
                        origin: "record",
                        issues: keyResult.issues.map((iss)=>$c0663.finalizeIssue(iss, ctx, $59TZW.config())),
                        input: key,
                        path: [
                            key
                        ],
                        inst: inst
                    });
                    continue;
                }
                // the guard above tests the raw input key, but the key schema can normalize an ordinary key into __proto__; re-check the key we actually write under
                const outKey = keyResult.value;
                if (outKey === "__proto__") continue;
                const result = def.valueType._zod.run({
                    value: input[key],
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>{
                    if (result.issues.length) payload.issues.push(...$c0663.prefixIssues(key, result.issues));
                    payload.value[outKey] = result.value;
                }));
                else {
                    if (result.issues.length) payload.issues.push(...$c0663.prefixIssues(key, result.issues));
                    payload.value[outKey] = result.value;
                }
            }
            if (unrecognized && unrecognized.length > 0) payload.issues.push({
                code: "unrecognized_keys",
                input: input,
                inst: inst,
                keys: unrecognized,
                continue: true
            });
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
const $092668306e6c1914$export$5ccfd30a7e358409 = /*@__PURE__*/ $59TZW.$constructor("$ZodMap", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    const memo = $59TZW.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!(input instanceof Map)) {
            payload.issues.push({
                expected: "map",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        const proms = [];
        payload.value = memo ? memo.alloc(inst, payload, new Map(), ctx) : new Map();
        for (const [key, value1] of input){
            const keyResult = def.keyType._zod.run({
                value: key,
                issues: []
            }, ctx);
            const valueResult = def.valueType._zod.run({
                value: value1,
                issues: []
            }, ctx);
            if (keyResult instanceof Promise || valueResult instanceof Promise) proms.push(Promise.all([
                keyResult,
                valueResult
            ]).then(([keyResult, valueResult])=>{
                $092668306e6c1914$var$handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
            }));
            else $092668306e6c1914$var$handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function $092668306e6c1914$var$handleMapResult(keyResult, valueResult, final, key, input, inst, ctx) {
    if (keyResult.issues.length) {
        if ($c0663.propertyKeyTypes.has(typeof key)) final.issues.push(...$c0663.prefixIssues(key, keyResult.issues));
        else final.issues.push({
            code: "invalid_key",
            origin: "map",
            input: input,
            inst: inst,
            issues: keyResult.issues.map((iss)=>$c0663.finalizeIssue(iss, ctx, $59TZW.config()))
        });
    }
    if (valueResult.issues.length) {
        if ($c0663.propertyKeyTypes.has(typeof key)) final.issues.push(...$c0663.prefixIssues(key, valueResult.issues));
        else final.issues.push({
            origin: "map",
            code: "invalid_element",
            input: input,
            inst: inst,
            key: key,
            issues: valueResult.issues.map((iss)=>$c0663.finalizeIssue(iss, ctx, $59TZW.config()))
        });
    }
    final.value.set(keyResult.value, valueResult.value);
}
const $092668306e6c1914$export$20cf27bc33a30268 = /*@__PURE__*/ $59TZW.$constructor("$ZodSet", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    const memo = $59TZW.globalConfig.memoizer;
    memo?.attach(inst);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!(input instanceof Set)) {
            payload.issues.push({
                input: input,
                inst: inst,
                expected: "set",
                code: "invalid_type"
            });
            return payload;
        }
        const proms = [];
        payload.value = memo ? memo.alloc(inst, payload, new Set(), ctx) : new Set();
        for (const item of input){
            const result = def.valueType._zod.run({
                value: item,
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>$092668306e6c1914$var$handleSetResult(result, payload)));
            else $092668306e6c1914$var$handleSetResult(result, payload);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function $092668306e6c1914$var$handleSetResult(result, final) {
    if (result.issues.length) final.issues.push(...result.issues);
    final.value.add(result.value);
}
const $092668306e6c1914$export$31462b6e6c50b618 = /*@__PURE__*/ $59TZW.$constructor("$ZodEnum", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    const values = $c0663.getEnumValues(def.entries);
    const valuesSet = new Set(values);
    inst._zod.values = valuesSet;
    const patternValues = values.filter((k)=>$c0663.propertyKeyTypes.has(typeof k));
    // unmatchable fallback, RE2-safe: an empty alternation would compile to /^()$/, which matches ""
    inst._zod.pattern = new RegExp(patternValues.length ? `^(${patternValues.map((o)=>$c0663.escapeRegex(o.toString())).join("|")})$` : "^[^\\s\\S]$");
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (valuesSet.has(input)) return payload;
        payload.issues.push({
            code: "invalid_value",
            values: values,
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $092668306e6c1914$export$86699355265fa258 = /*@__PURE__*/ $59TZW.$constructor("$ZodLiteral", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    const values = new Set(def.values);
    inst._zod.values = values;
    // unmatchable fallback, RE2-safe: an empty alternation would compile to /^()$/, which matches ""
    inst._zod.pattern = new RegExp(def.values.length ? `^(${def.values.map((o)=>typeof o === "string" ? $c0663.escapeRegex(o) : o ? $c0663.escapeRegex(o.toString()) : String(o)).join("|")})$` : "^[^\\s\\S]$");
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (values.has(input)) return payload;
        payload.issues.push({
            code: "invalid_value",
            values: def.values,
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $092668306e6c1914$export$1997de0576a81377 = /*@__PURE__*/ $59TZW.$constructor("$ZodFile", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        // @ts-ignore
        if (input instanceof File) return payload;
        payload.issues.push({
            expected: "file",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $092668306e6c1914$export$14b591f873519189 = /*@__PURE__*/ $59TZW.$constructor("$ZodTransform", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.optin = "optional";
    $59TZW.globalConfig.memoizer?.guard(inst);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") throw new $59TZW.$ZodEncodeError(inst.constructor.name);
        const _out = def.transform(payload.value, payload);
        if (ctx.async) {
            const output = _out instanceof Promise ? _out : Promise.resolve(_out);
            return output.then((output)=>{
                payload.value = output;
                return payload;
            });
        }
        if (_out instanceof Promise) throw new $59TZW.$ZodAsyncError();
        payload.value = _out;
        return payload;
    };
});
function $092668306e6c1914$var$handleOptionalResult(payload, result) {
    // A substituting schema that still failed has no usable answer; yield undefined. Its issues are simply dropped: it ran on a payload of its own, so there is no shared array to truncate and nothing of the caller's to lose with it.
    payload.value = result.issues.length ? undefined : result.value;
    return payload;
}
const $092668306e6c1914$export$980e9af565c4d7aa = /*@__PURE__*/ $59TZW.$constructor("$ZodOptional", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    // .optional() propagates absence rather than substituting for it, so a defaulted inner keeps its rung.
    $c0663.defineLazyInternal(inst, "optin", (zod)=>zod.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional");
    inst._zod.optout = "optional";
    $c0663.defineLazyInternal(inst, "values", (zod)=>{
        const values = zod.def.innerType._zod.values;
        return values ? new Set([
            ...values,
            undefined
        ]) : undefined;
    });
    $c0663.defineLazyInternal(inst, "pattern", (zod)=>{
        const pattern = zod.def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${$c0663.cleanRegex(pattern.source)})?$`) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        if (payload.value === undefined) {
            // Only the top rung substitutes a value for absence; everything else leaves it intact, which is what .optional() means.
            if (def.innerType._zod.optin !== "defaulted") return payload;
            // Its own payload, for the same reason $ZodCatch gets one: a pipe forwards an unrecognized key through the caller's issues array, and this must not read that as the substituting schema failing and drop it.
            const result = def.innerType._zod.run({
                value: payload.value,
                issues: []
            }, ctx);
            if (result instanceof Promise) return result.then((result)=>$092668306e6c1914$var$handleOptionalResult(payload, result));
            return $092668306e6c1914$var$handleOptionalResult(payload, result);
        }
        return def.innerType._zod.run(payload, ctx);
    };
});
const $092668306e6c1914$export$384d083c2a6b693f = /*@__PURE__*/ $59TZW.$constructor("$ZodExactOptional", (inst, def)=>{
    // Call parent init - inherits optin/optout = "optional"
    $092668306e6c1914$export$980e9af565c4d7aa.init(inst, def);
    // Override values/pattern to NOT add undefined
    $c0663.defineLazyInternal(inst, "values", (zod)=>zod.def.innerType._zod.values);
    $c0663.defineLazyInternal(inst, "pattern", (zod)=>zod.def.innerType._zod.pattern);
    // Override parse to just delegate (no undefined handling)
    inst._zod.parse = (payload, ctx)=>{
        return def.innerType._zod.run(payload, ctx);
    };
});
const $092668306e6c1914$export$7994573b6604ec66 = /*@__PURE__*/ $59TZW.$constructor("$ZodNullable", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    $c0663.defineLazyInternal(inst, "optin", (zod)=>zod.def.innerType._zod.optin);
    $c0663.defineLazyInternal(inst, "optout", (zod)=>zod.def.innerType._zod.optout);
    $c0663.defineLazyInternal(inst, "pattern", (zod)=>{
        const pattern = zod.def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${$c0663.cleanRegex(pattern.source)}|null)$`) : undefined;
    });
    $c0663.defineLazyInternal(inst, "values", (zod)=>{
        return zod.def.innerType._zod.values ? new Set([
            ...zod.def.innerType._zod.values,
            null
        ]) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        // Forward direction (decode): allow null to pass through
        if (payload.value === null) return payload;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $092668306e6c1914$export$ae2d21004b7243f7 = /*@__PURE__*/ $59TZW.$constructor("$ZodDefault", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    // inst._zod.qin = "true";
    inst._zod.optin = "defaulted";
    $c0663.defineLazyInternal(inst, "values", (zod)=>zod.def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply defaults for undefined input
        if (payload.value === undefined) {
            payload.value = def.defaultValue;
            /**
             * $ZodDefault returns the default value immediately in forward direction.
             * It doesn't pass the default value into the validator ("prefault"). There's no reason to pass the default value through validation. The validity of the default is enforced by TypeScript statically. Otherwise, it's the responsibility of the user to ensure the default is valid. In the case of pipes with divergent in/out types, you can specify the default on the `in` schema of your ZodPipe to set a "prefault" for the pipe.   */ return payload;
        }
        // Forward direction: continue with default handling
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>$092668306e6c1914$var$handleDefaultResult(result, def));
        return $092668306e6c1914$var$handleDefaultResult(result, def);
    };
});
function $092668306e6c1914$var$handleDefaultResult(payload, def) {
    if (payload.value === undefined) payload.value = def.defaultValue;
    return payload;
}
const $092668306e6c1914$export$29a8d757258be679 = /*@__PURE__*/ $59TZW.$constructor("$ZodPrefault", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.optin = "defaulted";
    $c0663.defineLazyInternal(inst, "values", (zod)=>zod.def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply prefault for undefined input
        if (payload.value === undefined) payload.value = def.defaultValue;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $092668306e6c1914$export$30ca726c4c50a6d7 = /*@__PURE__*/ $59TZW.$constructor("$ZodNonOptional", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    $c0663.defineLazyInternal(inst, "values", (zod)=>{
        const v = zod.def.innerType._zod.values;
        return v ? new Set([
            ...v
        ].filter((x)=>x !== undefined)) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>$092668306e6c1914$var$handleNonOptionalResult(result, inst));
        return $092668306e6c1914$var$handleNonOptionalResult(result, inst);
    };
});
function $092668306e6c1914$var$handleNonOptionalResult(payload, inst) {
    if (!payload.issues.length && payload.value === undefined) payload.issues.push({
        code: "invalid_type",
        expected: "nonoptional",
        input: payload.value,
        inst: inst
    });
    return payload;
}
const $092668306e6c1914$export$3cc4d03e729326ea = /*@__PURE__*/ $59TZW.$constructor("$ZodSuccess", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") throw new $59TZW.$ZodEncodeError("ZodSuccess");
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>{
            payload.value = result.issues.length === 0;
            return payload;
        });
        payload.value = result.issues.length === 0;
        return payload;
    };
});
function $092668306e6c1914$var$handleCatchResult(payload, result, def, ctx) {
    if (!result.issues.length) {
        payload.value = result.value;
        // The value carries up, so the flag describing it has to carry with it: a back-edge into a node still being parsed must not be frozen by an enclosing readonly, and its checks belong to the node itself. Guarded so the ordinary case adds no own property.
        if (result.memo) payload.memo = true;
        return payload;
    }
    // Spread the inner's own payload, not ours: `value` has to stay the input the catch was handed, and the inner ran on a payload of its own so its issues are already private to this call.
    payload.value = def.catchValue({
        ...result,
        value: payload.value,
        error: {
            issues: result.issues.map((iss)=>$c0663.finalizeIssue(iss, ctx, $59TZW.config()))
        },
        input: payload.value
    });
    return payload;
}
const $092668306e6c1914$export$d6f8b228374f6d37 = /*@__PURE__*/ $59TZW.$constructor("$ZodCatch", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    $c0663.defineLazyInternal(inst, "optin", (zod)=>zod.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional");
    $c0663.defineLazyInternal(inst, "optout", (zod)=>zod.def.innerType._zod.optout);
    $c0663.defineLazyInternal(inst, "values", (zod)=>zod.def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply catch logic
        const result = def.innerType._zod.run({
            value: payload.value,
            issues: []
        }, ctx);
        if (result instanceof Promise) return result.then((result)=>$092668306e6c1914$var$handleCatchResult(payload, result, def, ctx));
        return $092668306e6c1914$var$handleCatchResult(payload, result, def, ctx);
    };
});
const $092668306e6c1914$export$528f71701e6a7aee = /*@__PURE__*/ $59TZW.$constructor("$ZodNaN", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "number" || !Number.isNaN(payload.value)) {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                expected: "nan",
                code: "invalid_type"
            });
            return payload;
        }
        return payload;
    };
});
const $092668306e6c1914$export$4cb25cfde430326c = /*@__PURE__*/ $59TZW.$constructor("$ZodPipe", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    $c0663.defineLazyInternal(inst, "values", (zod)=>zod.def.in._zod.values);
    $c0663.defineLazyInternal(inst, "optin", (zod)=>zod.def.in._zod.optin);
    $c0663.defineLazyInternal(inst, "optout", (zod)=>zod.def.out._zod.optout);
    $c0663.defineLazyInternal(inst, "propValues", (zod)=>zod.def.in._zod.propValues);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") {
            const right = def.out._zod.run(payload, ctx);
            if (right instanceof Promise) return right.then((right)=>$092668306e6c1914$var$handlePipeResult(right, def.in, ctx));
            return $092668306e6c1914$var$handlePipeResult(right, def.in, ctx);
        }
        const left = def.in._zod.run(payload, ctx);
        if (left instanceof Promise) return left.then((left)=>$092668306e6c1914$var$handlePipeResult(left, def.out, ctx));
        return $092668306e6c1914$var$handlePipeResult(left, def.out, ctx);
    };
});
function $092668306e6c1914$var$handlePipeResult(left, next, ctx) {
    // Any issue stops the pipe, so a failing refinement never feeds its transform. An unrecognized key is the exception: it describes the input's extra properties, not the value being piped, and an enclosing intersection may yet reconcile it.
    if (left.issues.some((iss)=>iss.code !== "unrecognized_keys")) {
        // prevent further checks
        left.aborted = true;
        return left;
    }
    return next._zod.run({
        value: left.value,
        issues: left.issues
    }, ctx);
}
const $092668306e6c1914$export$c622e07db8a40b53 = /*@__PURE__*/ $59TZW.$constructor("$ZodCodec", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    $c0663.defineLazyInternal(inst, "values", (zod)=>zod.def.in._zod.values);
    $c0663.defineLazyInternal(inst, "optin", (zod)=>zod.def.in._zod.optin);
    $c0663.defineLazyInternal(inst, "optout", (zod)=>zod.def.out._zod.optout);
    $c0663.defineLazyInternal(inst, "propValues", (zod)=>zod.def.in._zod.propValues);
    inst._zod.parse = (payload, ctx)=>{
        const direction = ctx.direction || "forward";
        if (direction === "forward") {
            const left = def.in._zod.run(payload, ctx);
            if (left instanceof Promise) return left.then((left)=>$092668306e6c1914$var$handleCodecAResult(left, def, ctx));
            return $092668306e6c1914$var$handleCodecAResult(left, def, ctx);
        } else {
            const right = def.out._zod.run(payload, ctx);
            if (right instanceof Promise) return right.then((right)=>$092668306e6c1914$var$handleCodecAResult(right, def, ctx));
            return $092668306e6c1914$var$handleCodecAResult(right, def, ctx);
        }
    };
});
function $092668306e6c1914$var$handleCodecAResult(result, def, ctx) {
    if (result.issues.length) {
        // prevent further checks
        result.aborted = true;
        return result;
    }
    const direction = ctx.direction || "forward";
    if (direction === "forward") {
        const transformed = def.transform(result.value, result);
        if (transformed instanceof Promise) return transformed.then((value1)=>$092668306e6c1914$var$handleCodecTxResult(result, value1, def.out, ctx));
        return $092668306e6c1914$var$handleCodecTxResult(result, transformed, def.out, ctx);
    } else {
        const transformed = def.reverseTransform(result.value, result);
        if (transformed instanceof Promise) return transformed.then((value1)=>$092668306e6c1914$var$handleCodecTxResult(result, value1, def.in, ctx));
        return $092668306e6c1914$var$handleCodecTxResult(result, transformed, def.in, ctx);
    }
}
function $092668306e6c1914$var$handleCodecTxResult(left, value1, nextSchema, ctx) {
    // Check if transform added any issues
    if (left.issues.length) {
        left.aborted = true;
        return left;
    }
    return nextSchema._zod.run({
        value: value1,
        issues: left.issues
    }, ctx);
}
const $092668306e6c1914$export$200c161ed581d39b = /*@__PURE__*/ $59TZW.$constructor("$ZodPreprocess", (inst, def)=>{
    $092668306e6c1914$export$4cb25cfde430326c.init(inst, def);
});
const $092668306e6c1914$export$f9f268f3fbb1601b = /*@__PURE__*/ $59TZW.$constructor("$ZodReadonly", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    $c0663.defineLazyInternal(inst, "propValues", (zod)=>zod.def.innerType._zod.propValues);
    $c0663.defineLazyInternal(inst, "values", (zod)=>zod.def.innerType._zod.values);
    $c0663.defineLazyInternal(inst, "optin", (zod)=>zod.def.innerType?._zod?.optin);
    $c0663.defineLazyInternal(inst, "optout", (zod)=>zod.def.innerType?._zod?.optout);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then($092668306e6c1914$var$handleReadonlyResult);
        return $092668306e6c1914$var$handleReadonlyResult(result);
    };
});
function $092668306e6c1914$var$handleReadonlyResult(payload) {
    // A repeat visit hands back a node that is still being built; freezing it here would make the rest of its keys fail to assign.
    if (!payload.memo) payload.value = Object.freeze(payload.value);
    return payload;
}
const $092668306e6c1914$export$37ea86c57a77af54 = /*@__PURE__*/ $59TZW.$constructor("$ZodTemplateLiteral", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    const regexParts = [];
    for (const part of def.parts){
        if (typeof part === "object" && part !== null) {
            // is Zod schema
            if (!part._zod.pattern) // if (!source)
            throw new Error(`Invalid template literal part, no pattern found: ${[
                ...part._zod.traits
            ].shift()}`);
            const source = part._zod.pattern instanceof RegExp ? part._zod.pattern.source : part._zod.pattern;
            if (!source) throw new Error(`Invalid template literal part: ${part._zod.traits}`);
            const start = source.startsWith("^") ? 1 : 0;
            const end = source.endsWith("$") ? source.length - 1 : source.length;
            regexParts.push(source.slice(start, end));
        } else if (part === null || $c0663.primitiveTypes.has(typeof part)) regexParts.push($c0663.escapeRegex(`${part}`));
        else throw new Error(`Invalid template literal part: ${part}`);
    }
    inst._zod.pattern = new RegExp(`^${regexParts.join("")}$`);
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "string") {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                expected: "string",
                code: "invalid_type"
            });
            return payload;
        }
        inst._zod.pattern.lastIndex = 0;
        if (!inst._zod.pattern.test(payload.value)) {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                code: "invalid_format",
                format: def.format ?? "template_literal",
                pattern: inst._zod.pattern.source
            });
            return payload;
        }
        return payload;
    };
});
const $092668306e6c1914$export$877c6e9c05ede764 = /*@__PURE__*/ $59TZW.$constructor("$ZodFunction", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    // Defined, not assigned: the classic prototype exposes `_def` as a getter with no setter.
    Object.defineProperty(inst, "_def", {
        value: def
    });
    inst._zod.def = def;
    inst.implement = (func)=>{
        if (typeof func !== "function") throw new Error("implement() must be called with a function");
        // Defined inline so the closure stays anonymous: binding it to a `const` first names it, which costs 256 bytes per implemented function.
        return Object.defineProperty(function(...args) {
            const parsedArgs = inst._def.input ? (0, $3sMCt.parse)(inst._def.input, args) : args;
            const result = Reflect.apply(func, this, parsedArgs);
            if (inst._def.output) return (0, $3sMCt.parse)(inst._def.output, result);
            return result;
        }, "_zod", {
            value: inst._zod,
            enumerable: false
        });
    };
    inst.implementAsync = (func)=>{
        if (typeof func !== "function") throw new Error("implementAsync() must be called with a function");
        return Object.defineProperty(async function(...args) {
            const parsedArgs = inst._def.input ? await (0, $3sMCt.parseAsync)(inst._def.input, args) : args;
            const result = await Reflect.apply(func, this, parsedArgs);
            if (inst._def.output) return await (0, $3sMCt.parseAsync)(inst._def.output, result);
            return result;
        }, "_zod", {
            value: inst._zod,
            enumerable: false
        });
    };
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "function") {
            payload.issues.push({
                code: "invalid_type",
                expected: "function",
                input: payload.value,
                inst: inst
            });
            return payload;
        }
        // Check if output is a promise type to determine if we should use async implementation
        const hasPromiseOutput = inst._def.output && inst._def.output._zod.def.type === "promise";
        if (hasPromiseOutput) payload.value = inst.implementAsync(payload.value);
        else payload.value = inst.implement(payload.value);
        return payload;
    };
    inst.input = (...args)=>{
        const F = inst.constructor;
        if (Array.isArray(args[0])) return new F({
            type: "function",
            input: new $092668306e6c1914$export$bba1b90a721dbd94({
                type: "tuple",
                items: args[0],
                rest: args[1]
            }),
            output: inst._def.output
        });
        return new F({
            type: "function",
            input: args[0],
            output: inst._def.output
        });
    };
    inst.output = (output)=>{
        const F = inst.constructor;
        return new F({
            type: "function",
            input: inst._def.input,
            output: output
        });
    };
    return inst;
});
const $092668306e6c1914$export$bdefabff0dd84ca4 = /*@__PURE__*/ $59TZW.$constructor("$ZodPromise", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        return Promise.resolve(payload.value).then((inner)=>def.innerType._zod.run({
                value: inner,
                issues: []
            }, ctx));
    };
});
const $092668306e6c1914$export$662fecee2efa1a66 = /*@__PURE__*/ $59TZW.$constructor("$ZodLazy", (inst, def)=>{
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    // Cache the resolved inner type on the shared `def` so all clones of this lazy (e.g. via `.describe()`/`.meta()`) share the same inner instance, preserving identity for cycle detection on recursive schemas.
    $c0663.defineLazy(inst._zod, "innerType", ()=>{
        const d = def;
        if (!d._cachedInner) d._cachedInner = def.getter();
        return d._cachedInner;
    });
    $c0663.defineLazyInternal(inst, "pattern", (zod)=>zod.innerType?._zod?.pattern);
    $c0663.defineLazyInternal(inst, "propValues", (zod)=>zod.innerType?._zod?.propValues);
    $c0663.defineLazyInternal(inst, "optin", (zod)=>zod.innerType?._zod?.optin ?? undefined);
    $c0663.defineLazyInternal(inst, "optout", (zod)=>zod.innerType?._zod?.optout ?? undefined);
    inst._zod.parse = (payload, ctx)=>{
        const inner = inst._zod.innerType;
        return inner._zod.run(payload, ctx);
    };
});
const $092668306e6c1914$export$3a5d0e5e098b79ba = /*@__PURE__*/ $59TZW.$constructor("$ZodCustom", (inst, def)=>{
    $9iCDw.$ZodCheck.init(inst, def);
    $092668306e6c1914$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _)=>{
        return payload;
    };
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const r = def.fn(input);
        if (r instanceof Promise) return r.then((r)=>$092668306e6c1914$var$handleRefineResult(r, payload, input, inst));
        $092668306e6c1914$var$handleRefineResult(r, payload, input, inst);
        return;
    };
});
function $092668306e6c1914$var$handleRefineResult(result, payload, input, inst) {
    if (!result) {
        const _iss = {
            code: "custom",
            input: input,
            inst: inst,
            path: [
                ...inst._zod.def.path ?? []
            ],
            continue: !inst._zod.def.abort
        };
        if (inst._zod.def.params) _iss.params = inst._zod.def.params;
        payload.issues.push($c0663.issue(_iss));
    }
}

});
parcelRegister("flq6A", function(module, exports) {

$parcel$export(module.exports, "Doc", function () { return $b2bd1120662bebcd$export$bceacc74c2212615; });
class $b2bd1120662bebcd$export$bceacc74c2212615 {
    constructor(args = [], closed = {}){
        this.content = [];
        this.indent = 0;
        this.args = args;
        this.closed = closed;
    }
    indented(fn) {
        this.indent += 1;
        fn(this);
        this.indent -= 1;
    }
    write(arg) {
        if (typeof arg === "function") {
            arg(this, {
                execution: "sync"
            });
            arg(this, {
                execution: "async"
            });
            return;
        }
        const content = arg;
        const lines = content.split("\n").filter((x)=>x);
        const minIndent = Math.min(...lines.map((x)=>x.length - x.trimStart().length));
        const dedented = lines.map((x)=>x.slice(minIndent)).map((x)=>" ".repeat(this.indent * 2) + x);
        for (const line of dedented)this.content.push(line);
    }
    compile() {
        const F = Function;
        const content = this?.content ?? [
            ``
        ];
        const factory = new F(...Object.keys(this.closed), `return function (${this.args.join(", ")}) {\n${content.join("\n")}\n};`);
        return factory(...Object.values(this.closed));
    }
}

});

parcelRegister("3sMCt", function(module, exports) {

$parcel$export(module.exports, "_parse", function () { return $2859b377197ef55d$export$dcd1bb9991b57edf; });
$parcel$export(module.exports, "parse", function () { return $2859b377197ef55d$export$98e6a39c04603d36; });
$parcel$export(module.exports, "_parseAsync", function () { return $2859b377197ef55d$export$1fcca22dc6c780d0; });
$parcel$export(module.exports, "parseAsync", function () { return $2859b377197ef55d$export$59b6f938fbf579e3; });
$parcel$export(module.exports, "_safeParse", function () { return $2859b377197ef55d$export$5ec32605bf51e98e; });
$parcel$export(module.exports, "safeParse", function () { return $2859b377197ef55d$export$b48ee232557adc37; });
$parcel$export(module.exports, "_safeParseAsync", function () { return $2859b377197ef55d$export$c08c7322f5625faf; });
$parcel$export(module.exports, "safeParseAsync", function () { return $2859b377197ef55d$export$9b07b0d6e0389261; });
$parcel$export(module.exports, "_encode", function () { return $2859b377197ef55d$export$50e4445ccc10715b; });
$parcel$export(module.exports, "_decode", function () { return $2859b377197ef55d$export$bb4a21772f43c982; });
$parcel$export(module.exports, "_encodeAsync", function () { return $2859b377197ef55d$export$9954740a1a5eaaf1; });
$parcel$export(module.exports, "_decodeAsync", function () { return $2859b377197ef55d$export$74b09e12c8956d91; });
$parcel$export(module.exports, "_safeEncode", function () { return $2859b377197ef55d$export$6d688d774257f486; });
$parcel$export(module.exports, "_safeDecode", function () { return $2859b377197ef55d$export$b2ef531a734faad5; });
$parcel$export(module.exports, "_safeEncodeAsync", function () { return $2859b377197ef55d$export$fa2ac180d22758d6; });
$parcel$export(module.exports, "_safeDecodeAsync", function () { return $2859b377197ef55d$export$f66d2b402dc6318c; });

var $59TZW = parcelRequire("59TZW");

var $1B5mT = parcelRequire("1B5mT");

var $c0663 = parcelRequire("c0663");
// Always both keys, so the `_params` read site in `_parse` sees one object shape rather than two.
function $2859b377197ef55d$var$finalizeParams(callee, params) {
    return {
        callee: params?.callee ?? callee,
        Err: params?.Err
    };
}
const $2859b377197ef55d$export$dcd1bb9991b57edf = (_Err)=>{
    const fn = (schema, value, _ctx, _params)=>{
        const ctx = _ctx ? {
            ..._ctx,
            async: false
        } : {
            async: false
        };
        const result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) throw new $59TZW.$ZodAsyncError();
        if (result.issues.length) {
            const e = new (_params?.Err ?? _Err)(result.issues.map((iss)=>$c0663.finalizeIssue(iss, ctx, $59TZW.config())));
            $c0663.captureStackTrace(e, _params?.callee ?? fn);
            throw e;
        }
        return result.value;
    };
    return fn;
};
const $2859b377197ef55d$export$98e6a39c04603d36 = /* @__PURE__*/ $2859b377197ef55d$export$dcd1bb9991b57edf($1B5mT.$ZodRealError);
const $2859b377197ef55d$export$1fcca22dc6c780d0 = (_Err)=>{
    const fn = async (schema, value, _ctx, params)=>{
        const ctx = _ctx ? {
            ..._ctx,
            async: true
        } : {
            async: true
        };
        let result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) result = await result;
        if (result.issues.length) {
            const e = new (params?.Err ?? _Err)(result.issues.map((iss)=>$c0663.finalizeIssue(iss, ctx, $59TZW.config())));
            $c0663.captureStackTrace(e, params?.callee ?? fn);
            throw e;
        }
        return result.value;
    };
    return fn;
};
const $2859b377197ef55d$export$59b6f938fbf579e3 = /* @__PURE__*/ $2859b377197ef55d$export$1fcca22dc6c780d0($1B5mT.$ZodRealError);
const $2859b377197ef55d$export$5ec32605bf51e98e = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? {
            ..._ctx,
            async: false
        } : {
            async: false
        };
        const result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) throw new $59TZW.$ZodAsyncError();
        return result.issues.length ? {
            success: false,
            error: new (_Err ?? $1B5mT.$ZodError)(result.issues.map((iss)=>$c0663.finalizeIssue(iss, ctx, $59TZW.config())))
        } : {
            success: true,
            data: result.value
        };
    };
const $2859b377197ef55d$export$b48ee232557adc37 = /* @__PURE__*/ $2859b377197ef55d$export$5ec32605bf51e98e($1B5mT.$ZodRealError);
const $2859b377197ef55d$export$c08c7322f5625faf = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? {
            ..._ctx,
            async: true
        } : {
            async: true
        };
        let result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) result = await result;
        return result.issues.length ? {
            success: false,
            error: new _Err(result.issues.map((iss)=>$c0663.finalizeIssue(iss, ctx, $59TZW.config())))
        } : {
            success: true,
            data: result.value
        };
    };
const $2859b377197ef55d$export$9b07b0d6e0389261 = /* @__PURE__*/ $2859b377197ef55d$export$c08c7322f5625faf($1B5mT.$ZodRealError);
// registry mirrors of the compiler's sentinels, so this module never imports the compiler
const $2859b377197ef55d$var$COMPILE_INVALID = /* @__PURE__ */ Symbol.for("zod.compile.invalid");
const $2859b377197ef55d$var$COMPILE_FALLBACK = /* @__PURE__ */ Symbol.for("zod.compile.fallback");
const $2859b377197ef55d$export$a22775fa5e2eebd9 = (schema, value, _ctx)=>{
    const validator = schema._zod.bag.validator;
    if (validator !== undefined && validator(value) !== $2859b377197ef55d$var$COMPILE_INVALID) return true;
    return $2859b377197ef55d$var$validateFallback(schema, value, _ctx);
};
function $2859b377197ef55d$var$validateFallback(schema, value, _ctx) {
    const ctx = _ctx ? {
        ..._ctx,
        async: false
    } : {
        async: false
    };
    const fallbackRun = schema._zod.bag.fallbackRun;
    let result;
    if (fallbackRun) {
        // skip nested fast paths on the fallback, so user callbacks keep the at-most-twice bound
        ctx[$2859b377197ef55d$var$COMPILE_FALLBACK] = true;
        result = fallbackRun({
            value: value,
            issues: []
        }, ctx);
    } else result = schema._zod.run({
        value: value,
        issues: []
    }, ctx);
    if (result instanceof Promise) throw new $59TZW.$ZodAsyncError();
    return result.issues.length === 0;
}
const $2859b377197ef55d$export$ec9e0a98ddb8e655 = async (schema, value, _ctx)=>{
    const ctx = _ctx ? {
        ..._ctx,
        async: true
    } : {
        async: true
    };
    let result = schema._zod.run({
        value: value,
        issues: []
    }, ctx);
    if (result instanceof Promise) result = await result;
    return result.issues.length === 0;
};
const $2859b377197ef55d$export$50e4445ccc10715b = (_Err)=>{
    const parse = $2859b377197ef55d$export$dcd1bb9991b57edf(_Err);
    const fn = (schema, value, _ctx, _params)=>{
        const ctx = _ctx ? {
            ..._ctx,
            direction: "backward"
        } : {
            direction: "backward"
        };
        return parse(schema, value, ctx, $2859b377197ef55d$var$finalizeParams(fn, _params));
    };
    return fn;
};
const $2859b377197ef55d$export$c564cdbbe6da493 = /* @__PURE__*/ $2859b377197ef55d$export$50e4445ccc10715b($1B5mT.$ZodRealError);
const $2859b377197ef55d$export$bb4a21772f43c982 = (_Err)=>{
    const parse = $2859b377197ef55d$export$dcd1bb9991b57edf(_Err);
    const fn = (schema, value, _ctx, _params)=>{
        return parse(schema, value, _ctx, $2859b377197ef55d$var$finalizeParams(fn, _params));
    };
    return fn;
};
const $2859b377197ef55d$export$2f872c0f2117be69 = /* @__PURE__*/ $2859b377197ef55d$export$bb4a21772f43c982($1B5mT.$ZodRealError);
const $2859b377197ef55d$export$9954740a1a5eaaf1 = (_Err)=>{
    const parseAsync = $2859b377197ef55d$export$1fcca22dc6c780d0(_Err);
    const fn = async (schema, value, _ctx, _params)=>{
        const ctx = _ctx ? {
            ..._ctx,
            direction: "backward"
        } : {
            direction: "backward"
        };
        return await parseAsync(schema, value, ctx, $2859b377197ef55d$var$finalizeParams(fn, _params));
    };
    return fn;
};
const $2859b377197ef55d$export$1a62660bbffb8f11 = /* @__PURE__*/ $2859b377197ef55d$export$9954740a1a5eaaf1($1B5mT.$ZodRealError);
const $2859b377197ef55d$export$74b09e12c8956d91 = (_Err)=>{
    const parseAsync = $2859b377197ef55d$export$1fcca22dc6c780d0(_Err);
    const fn = async (schema, value, _ctx, _params)=>{
        return await parseAsync(schema, value, _ctx, $2859b377197ef55d$var$finalizeParams(fn, _params));
    };
    return fn;
};
const $2859b377197ef55d$export$e4c183687a6ff9b = /* @__PURE__*/ $2859b377197ef55d$export$74b09e12c8956d91($1B5mT.$ZodRealError);
const $2859b377197ef55d$export$6d688d774257f486 = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? {
            ..._ctx,
            direction: "backward"
        } : {
            direction: "backward"
        };
        return $2859b377197ef55d$export$5ec32605bf51e98e(_Err)(schema, value, ctx);
    };
const $2859b377197ef55d$export$c094f85f253e4d7d = /* @__PURE__*/ $2859b377197ef55d$export$6d688d774257f486($1B5mT.$ZodRealError);
const $2859b377197ef55d$export$b2ef531a734faad5 = (_Err)=>(schema, value, _ctx)=>{
        return $2859b377197ef55d$export$5ec32605bf51e98e(_Err)(schema, value, _ctx);
    };
const $2859b377197ef55d$export$7a47376c130cfeac = /* @__PURE__*/ $2859b377197ef55d$export$b2ef531a734faad5($1B5mT.$ZodRealError);
const $2859b377197ef55d$export$fa2ac180d22758d6 = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? {
            ..._ctx,
            direction: "backward"
        } : {
            direction: "backward"
        };
        return $2859b377197ef55d$export$c08c7322f5625faf(_Err)(schema, value, ctx);
    };
const $2859b377197ef55d$export$ed163a34170fecc5 = /* @__PURE__*/ $2859b377197ef55d$export$fa2ac180d22758d6($1B5mT.$ZodRealError);
const $2859b377197ef55d$export$f66d2b402dc6318c = (_Err)=>async (schema, value, _ctx)=>{
        return $2859b377197ef55d$export$c08c7322f5625faf(_Err)(schema, value, _ctx);
    };
const $2859b377197ef55d$export$9f879005292a9bc9 = /* @__PURE__*/ $2859b377197ef55d$export$f66d2b402dc6318c($1B5mT.$ZodRealError);

});
parcelRegister("1B5mT", function(module, exports) {

$parcel$export(module.exports, "$ZodError", function () { return $129d692fe0a6b3d5$export$544878318730b1d8; });
$parcel$export(module.exports, "$ZodRealError", function () { return $129d692fe0a6b3d5$export$4e07b515db2f7672; });
$parcel$export(module.exports, "flattenError", function () { return $129d692fe0a6b3d5$export$4d7e0dfd5ca8366f; });
$parcel$export(module.exports, "formatError", function () { return $129d692fe0a6b3d5$export$7b5b869ee98c16ab; });

var $59TZW = parcelRequire("59TZW");

var $c0663 = parcelRequire("c0663");
/* Computing the message eagerly is expensive (pretty-printed JSON of all
 * issues), so defer it until first read. The accessor functions and
 * descriptors are shared across instances to keep error construction
 * cheap; the computed message is cached on the internals object. The
 * setter preserves plain assignment semantics for consumers that
 * overwrite `message`. */ function $129d692fe0a6b3d5$var$_getMessage() {
    const internals = this._zod;
    internals.message ?? (internals.message = JSON.stringify(internals.def, $c0663.jsonStringifyReplacer, 2));
    return internals.message;
}
function $129d692fe0a6b3d5$var$_setMessage(value) {
    this._zod.message = value;
}
const $129d692fe0a6b3d5$var$_messageDesc = {
    get: $129d692fe0a6b3d5$var$_getMessage,
    set: $129d692fe0a6b3d5$var$_setMessage,
    enumerable: true,
    configurable: true
};
const $129d692fe0a6b3d5$var$_zodDesc = {
    value: undefined,
    enumerable: false
};
const $129d692fe0a6b3d5$var$_issuesDesc = {
    value: undefined,
    enumerable: false
};
/* Prototypes that already carry the lazy `toString`. Seeded with the
 * intrinsics so that `init` on a foreign object — it accepts any object —
 * can never install an accessor onto a prototype we do not own. */ const $129d692fe0a6b3d5$var$_installedToString = /* @__PURE__ */ new WeakSet([
    Object.prototype,
    Error.prototype
]);
const $129d692fe0a6b3d5$var$initializer = (inst, def)=>{
    inst.name = "$ZodError";
    $129d692fe0a6b3d5$var$_zodDesc.value = inst._zod;
    Object.defineProperty(inst, "_zod", $129d692fe0a6b3d5$var$_zodDesc);
    $129d692fe0a6b3d5$var$_issuesDesc.value = def;
    Object.defineProperty(inst, "issues", $129d692fe0a6b3d5$var$_issuesDesc);
    // Clear the shared slots; a retained `value` pins the last error's issues.
    $129d692fe0a6b3d5$var$_zodDesc.value = undefined;
    $129d692fe0a6b3d5$var$_issuesDesc.value = undefined;
    Object.defineProperty(inst, "message", $129d692fe0a6b3d5$var$_messageDesc);
    /* `toString` lives as a non-enumerable lazy getter on the shared
     * prototype; on first access it caches a per-instance closure so
     * detached usage still works. */ const proto = Object.getPrototypeOf(inst);
    if (!$129d692fe0a6b3d5$var$_installedToString.has(proto)) {
        $129d692fe0a6b3d5$var$_installedToString.add(proto);
        Object.defineProperty(proto, "toString", {
            configurable: true,
            enumerable: false,
            get () {
                const value = ()=>this.message;
                Object.defineProperty(this, "toString", {
                    value: value,
                    configurable: true,
                    writable: true
                });
                return value;
            },
            set (value) {
                Object.defineProperty(this, "toString", {
                    value: value,
                    configurable: true,
                    writable: true
                });
            }
        });
    }
};
const $129d692fe0a6b3d5$export$544878318730b1d8 = (0, $59TZW.$constructor)("$ZodError", $129d692fe0a6b3d5$var$initializer);
const $129d692fe0a6b3d5$export$4e07b515db2f7672 = (0, $59TZW.$constructor)("$ZodError", $129d692fe0a6b3d5$var$initializer, undefined, {
    Parent: Error
});
/** Get-or-create `obj[key]` as an own data property. A path segment naming an inherited member
 * ("toString", "constructor") would otherwise read through to the prototype, and assigning
 * "__proto__" would hit the setter instead of creating a key. */ function $129d692fe0a6b3d5$var$node(obj, key, make) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) {
        if (key === "__proto__") Object.defineProperty(obj, key, {
            value: make(),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else obj[key] = make();
    }
    return obj[key];
}
function $129d692fe0a6b3d5$export$4d7e0dfd5ca8366f(error, mapper = (issue)=>issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of error.issues)if (sub.path.length > 0) $129d692fe0a6b3d5$var$node(fieldErrors, sub.path[0], ()=>[]).push(mapper(sub));
    else formErrors.push(mapper(sub));
    return {
        formErrors: formErrors,
        fieldErrors: fieldErrors
    };
}
function $129d692fe0a6b3d5$export$7b5b869ee98c16ab(error, mapper = (issue)=>issue.message) {
    const fieldErrors = {
        _errors: []
    };
    const processError = (error, path = [])=>{
        for (const issue of error.issues){
            if (issue.code === "invalid_union" && issue.errors.length) issue.errors.map((issues)=>processError({
                    issues: issues
                }, [
                    ...path,
                    ...issue.path
                ]));
            else if (issue.code === "invalid_key") processError({
                issues: issue.issues
            }, [
                ...path,
                ...issue.path
            ]);
            else if (issue.code === "invalid_element") processError({
                issues: issue.issues
            }, [
                ...path,
                ...issue.path
            ]);
            else {
                const fullpath = [
                    ...path,
                    ...issue.path
                ];
                if (fullpath.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < fullpath.length){
                        const el = fullpath[i];
                        const terminal = i === fullpath.length - 1;
                        // `_errors` is reserved by this legacy format, so merge a matching path segment into the current node instead of treating its array as a child.
                        if (el === "_errors") {
                            if (terminal) curr._errors.push(mapper(issue));
                            i++;
                            continue;
                        }
                        // A path element may collide with an inherited property name such as
                        // "__proto__" or "constructor". Truthiness checks read the prototype
                        // (so no node is created, then ._errors.push throws), and bracket
                        // assignment of "__proto__" hits the setter instead of creating an
                        // own key. Guard the read with hasOwnProperty and create the node
                        // with defineProperty so any path element becomes a real own key.
                        if (!Object.prototype.hasOwnProperty.call(curr, el)) Object.defineProperty(curr, el, {
                            value: {
                                _errors: []
                            },
                            enumerable: true,
                            writable: true,
                            configurable: true
                        });
                        const node = curr[el];
                        if (terminal) node._errors.push(mapper(issue));
                        curr = node;
                        i++;
                    }
                }
            }
        }
    };
    processError(error);
    return fieldErrors;
}
function $129d692fe0a6b3d5$export$93701dc89257de2f(error, mapper = (issue)=>issue.message) {
    const result = {
        errors: []
    };
    const processError = (error, path = [])=>{
        var _a;
        for (const issue of error.issues){
            if (issue.code === "invalid_union" && issue.errors.length) // regular union error
            issue.errors.map((issues)=>processError({
                    issues: issues
                }, [
                    ...path,
                    ...issue.path
                ]));
            else if (issue.code === "invalid_key") processError({
                issues: issue.issues
            }, [
                ...path,
                ...issue.path
            ]);
            else if (issue.code === "invalid_element") processError({
                issues: issue.issues
            }, [
                ...path,
                ...issue.path
            ]);
            else {
                const fullpath = [
                    ...path,
                    ...issue.path
                ];
                if (fullpath.length === 0) {
                    result.errors.push(mapper(issue));
                    continue;
                }
                let curr = result;
                let i = 0;
                while(i < fullpath.length){
                    const el = fullpath[i];
                    const terminal = i === fullpath.length - 1;
                    if (typeof el === "string") {
                        curr.properties ?? (curr.properties = {});
                        // el may collide with an inherited property name ("__proto__",
                        // "constructor", ...); ??= reads the prototype so the node is never
                        // created and curr.errors.push throws. Guard with hasOwnProperty and
                        // create the node with defineProperty so "__proto__" becomes a real
                        // own key rather than invoking the prototype setter.
                        if (!Object.prototype.hasOwnProperty.call(curr.properties, el)) Object.defineProperty(curr.properties, el, {
                            value: {
                                errors: []
                            },
                            enumerable: true,
                            writable: true,
                            configurable: true
                        });
                        curr = curr.properties[el];
                    } else {
                        curr.items ?? (curr.items = []);
                        (_a = curr.items)[el] ?? (_a[el] = {
                            errors: []
                        });
                        curr = curr.items[el];
                    }
                    if (terminal) curr.errors.push(mapper(issue));
                    i++;
                }
            }
        }
    };
    processError(error);
    return result;
}
function $129d692fe0a6b3d5$export$47768e8997ceb13a(_path) {
    const segs = [];
    const path = _path.map((seg)=>typeof seg === "object" ? seg.key : seg);
    for (const seg of path){
        if (typeof seg === "number") segs.push(`[${seg}]`);
        else if (typeof seg === "symbol") segs.push(`[${JSON.stringify(String(seg))}]`);
        else if (/[^\w$]/.test(seg)) segs.push(`[${JSON.stringify(seg)}]`);
        else {
            if (segs.length) segs.push(".");
            segs.push(seg);
        }
    }
    return segs.join("");
}
function $129d692fe0a6b3d5$export$44eaaa72d914fe8c(error) {
    const lines = [];
    // sort by path length
    const issues = [
        ...error.issues
    ].sort((a, b)=>(a.path ?? []).length - (b.path ?? []).length);
    // Process each issue
    for (const issue of issues){
        lines.push(`\u{2716} ${issue.message}`);
        if (issue.path?.length) lines.push(`  \u{2192} at ${$129d692fe0a6b3d5$export$47768e8997ceb13a(issue.path)}`);
    }
    // Convert Map to formatted string
    return lines.join("\n");
}

});


parcelRegister("1Uzgp", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $16466003bd76aafa$export$83d89fbfd8236492; });
const $16466003bd76aafa$export$83d89fbfd8236492 = {
    major: 4,
    minor: 5,
    patch: 4
};

});



parcelRegister("cxlmR", function(module, exports) {

$parcel$export(module.exports, "memoizer", function () { return $9209244b73465407$export$17ac4b5c50355589; });
class $9209244b73465407$export$a41a050c6c386536 extends Error {
    constructor(){
        super(`Cannot parse a reference cycle that closes through a transform`);
        this.name = "ZodCyclicError";
    }
}
/** Keyed off the context object every schema in one parse call already shares. */ const $9209244b73465407$var$STATE = "~memo";
const $9209244b73465407$var$NO_ISSUES = [];
// Receivers prefix paths in place, so the cache and every hand-out need their own copies.
function $9209244b73465407$var$cloneIssues(issues) {
    return issues.map((iss)=>iss.path ? {
            ...iss,
            path: iss.path.slice()
        } : {
            ...iss
        });
}
const $9209244b73465407$var$recursive = /*@__PURE__*/ new WeakMap();
/** Whether this schema's subtree contains a cycle, so one parse can re-enter it. */ function $9209244b73465407$var$isRecursive(inst, stack) {
    const cached = $9209244b73465407$var$recursive.get(inst);
    if (cached !== undefined) return cached;
    // Relative to the walk in progress, so not cached.
    if (stack.has(inst)) return true;
    stack.add(inst);
    let result = false;
    const check = (child)=>{
        if (!result && child?._zod && $9209244b73465407$var$isRecursive(child, stack)) result = true;
    };
    const def = inst._zod.def;
    const kind = def.type;
    switch(kind){
        case "object":
            // `Reflect.ownKeys` rather than `Object.keys`, so a cycle through a declared symbol key is still seen
            for (const key of Reflect.ownKeys(def.shape))check(def.shape[key]);
            check(def.catchall);
            break;
        case "array":
            check(def.element);
            break;
        case "tuple":
            for (const el of def.items)check(el);
            check(def.rest);
            break;
        case "record":
        case "map":
            check(def.keyType);
            check(def.valueType);
            break;
        case "set":
            check(def.valueType);
            break;
        case "union":
            for (const el of def.options)check(el);
            break;
        case "intersection":
            check(def.left);
            check(def.right);
            break;
        case "optional":
        case "nullable":
        case "default":
        case "prefault":
        case "catch":
        case "readonly":
        case "nonoptional":
        case "promise":
        case "success":
            check(def.innerType);
            break;
        case "pipe":
            check(def.in);
            check(def.out);
            break;
        case "function":
            check(def.input);
            check(def.output);
            break;
        // reading `_zod.innerType` resolves the getter once and caches it
        case "lazy":
            check(inst._zod.innerType);
            break;
        // a leaf by choice: `parts` are regex fragments, not data positions
        case "template_literal":
        // leaves
        case "string":
        case "number":
        case "int":
        case "boolean":
        case "bigint":
        case "symbol":
        case "undefined":
        case "null":
        case "void":
        case "never":
        case "any":
        case "unknown":
        case "date":
        case "nan":
        case "enum":
        case "literal":
        case "file":
        case "transform":
        case "custom":
            break;
        default:
            // a new built-in kind becomes a compile error here
            kind;
            // a user-defined kind can still hold children, and only its author knows where, so fall back to scanning the def — skipping accessors, since reading one can run user code
            for(const key in def){
                const desc = Object.getOwnPropertyDescriptor(def, key);
                if (!desc || desc.get) continue;
                const value = desc.value;
                if (!value || typeof value !== "object") continue;
                if (value._zod) check(value);
                else if (Array.isArray(value)) for (const el of value)check(el);
            }
    }
    stack.delete(inst);
    $9209244b73465407$var$recursive.set(inst, result);
    return result;
}
function $9209244b73465407$export$2cdda7da3ed37816(inst) {
    return $9209244b73465407$var$isRecursive(inst, new Set());
}
function $9209244b73465407$var$bucketFor(state, inst) {
    let bucket = state.buckets.get(inst);
    if (!bucket) {
        bucket = new Map();
        state.buckets.set(inst, bucket);
    }
    return bucket;
}
// Set immediately before delegating to core and cleared immediately after, so `alloc` registers only for a visit this module is driving.
let $9209244b73465407$var$handoff;
// Allocated but unfinished entries. `alloc` and the matching pop both happen in the synchronous part of a parse, so they nest even when children are async, and one stack serves every schema.
const $9209244b73465407$var$open = [];
const $9209244b73465407$var$memo = {
    alloc (_inst, payload, empty) {
        const bucket = $9209244b73465407$var$handoff;
        if (!bucket) return empty;
        $9209244b73465407$var$handoff = undefined;
        const entry = {
            value: empty,
            issues: null
        };
        bucket.set(payload.value, entry);
        $9209244b73465407$var$open.push(entry);
        return empty;
    },
    guard (inst) {
        var _a;
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        inst._zod.deferred.push(()=>{
            const base = inst._zod.parse;
            const wrapped = (payload, ctx)=>{
                // The value is a placeholder a back-edge is still waiting on, so the cycle closes through this transform. Its output can't exist in time to bind.
                if (ctx.direction !== "backward" && $9209244b73465407$export$2832d97103138047(ctx, payload.value)) throw new $9209244b73465407$export$a41a050c6c386536();
                return base(payload, ctx);
            };
            inst._zod.parse = wrapped;
            if (inst._zod.run === base) inst._zod.run = wrapped;
        });
    },
    attach (inst) {
        var _a;
        let isRecursiveInst;
        // `bucket` memoized for one parse; a recursive schema is re-entered many times and its bucket never changes
        let lastCtx;
        let lastBucket;
        // Wraps `parse` in a deferred so it sees the container's final parse. Core's own deferred copies `parse` into `run` when there are no checks, and it ran first, so `run` is patched to match; with checks, `run` reads `parse` dynamically.
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        inst._zod.deferred.push(()=>{
            const base = inst._zod.parse;
            const wrapped = (payload, ctx)=>{
                if (isRecursiveInst === undefined) {
                    isRecursiveInst = $9209244b73465407$var$isRecursive(inst, new Set());
                    if (!isRecursiveInst) {
                        // Nothing here can ever fire, so take it back out.
                        inst._zod.parse = base;
                        if (inst._zod.run === wrapped) inst._zod.run = base;
                        return base(payload, ctx);
                    }
                }
                const input = payload.value;
                if (input === null || typeof input !== "object") return base(payload, ctx);
                let state = ctx[$9209244b73465407$var$STATE];
                if (!state) {
                    state = {
                        buckets: new Map(),
                        backEdges: undefined
                    };
                    ctx[$9209244b73465407$var$STATE] = state;
                }
                let bucket;
                if (lastCtx === ctx) bucket = lastBucket;
                else {
                    bucket = $9209244b73465407$var$bucketFor(state, inst);
                    lastCtx = ctx;
                    lastBucket = bucket;
                }
                const hit = bucket.get(input);
                if (hit) {
                    payload.value = hit.value;
                    if (hit.issues) {
                        if (hit.issues.length) payload.issues.push(...$9209244b73465407$var$cloneIssues(hit.issues));
                    } else {
                        // Still being parsed: its own checks cover it, so skip them here.
                        payload.memo = true;
                        state.backEdges ?? (state.backEdges = new Set());
                        state.backEdges.add(hit.value);
                    }
                    return payload;
                }
                $9209244b73465407$var$handoff = bucket;
                const depth = $9209244b73465407$var$open.length;
                const result = base(payload, ctx);
                $9209244b73465407$var$handoff = undefined;
                // A container that rejected its input outright allocated nothing.
                const entry = $9209244b73465407$var$open.length > depth ? $9209244b73465407$var$open.pop() : undefined;
                // Both paths written out so the sync one allocates no closure. It runs once per node, and capturing here cost more than everything else combined.
                if (result instanceof Promise) return result.then((r)=>{
                    if (entry) entry.issues = r.issues.length ? $9209244b73465407$var$cloneIssues(r.issues) : $9209244b73465407$var$NO_ISSUES;
                    return r;
                });
                if (entry) entry.issues = result.issues.length ? $9209244b73465407$var$cloneIssues(result.issues) : $9209244b73465407$var$NO_ISSUES;
                return result;
            };
            inst._zod.parse = wrapped;
            if (inst._zod.run === base) inst._zod.run = wrapped;
        });
    }
};
function $9209244b73465407$export$17ac4b5c50355589() {
    return $9209244b73465407$var$memo;
}
function $9209244b73465407$export$2832d97103138047(ctx, value) {
    const backEdges = ctx[$9209244b73465407$var$STATE]?.backEdges;
    return backEdges !== undefined && value !== null && typeof value === "object" && backEdges.has(value);
}

});

parcelRegister("6iVFp", function(module, exports) {

$parcel$export(module.exports, "stringProcessor", function () { return $497127f075b386d3$export$c6950985d9de996d; });
$parcel$export(module.exports, "numberProcessor", function () { return $497127f075b386d3$export$afd08f475b2e134f; });
$parcel$export(module.exports, "booleanProcessor", function () { return $497127f075b386d3$export$f03e9163a5233fc4; });
$parcel$export(module.exports, "bigintProcessor", function () { return $497127f075b386d3$export$8810d61ae56edc9c; });
$parcel$export(module.exports, "symbolProcessor", function () { return $497127f075b386d3$export$fd2b3c73524160ce; });
$parcel$export(module.exports, "nullProcessor", function () { return $497127f075b386d3$export$7667b76b86382b1f; });
$parcel$export(module.exports, "undefinedProcessor", function () { return $497127f075b386d3$export$9838a7ce212344b0; });
$parcel$export(module.exports, "voidProcessor", function () { return $497127f075b386d3$export$b5910bb267c78233; });
$parcel$export(module.exports, "neverProcessor", function () { return $497127f075b386d3$export$694b9cd80480ac33; });
$parcel$export(module.exports, "anyProcessor", function () { return $497127f075b386d3$export$a92de72ffd9087b5; });
$parcel$export(module.exports, "unknownProcessor", function () { return $497127f075b386d3$export$4e1fea7b2e7474f; });
$parcel$export(module.exports, "dateProcessor", function () { return $497127f075b386d3$export$d044e6246fe40d06; });
$parcel$export(module.exports, "enumProcessor", function () { return $497127f075b386d3$export$a0f7e3681bbe4f0b; });
$parcel$export(module.exports, "literalProcessor", function () { return $497127f075b386d3$export$b7a483a046d3a9b; });
$parcel$export(module.exports, "nanProcessor", function () { return $497127f075b386d3$export$f33d8739d51ecc4b; });
$parcel$export(module.exports, "templateLiteralProcessor", function () { return $497127f075b386d3$export$59812826ec9f1850; });
$parcel$export(module.exports, "fileProcessor", function () { return $497127f075b386d3$export$62de47a40c7b42b0; });
$parcel$export(module.exports, "successProcessor", function () { return $497127f075b386d3$export$1e296a49315ba27a; });
$parcel$export(module.exports, "customProcessor", function () { return $497127f075b386d3$export$fe3af043a76e4dab; });
$parcel$export(module.exports, "functionProcessor", function () { return $497127f075b386d3$export$654f185ba88226ab; });
$parcel$export(module.exports, "transformProcessor", function () { return $497127f075b386d3$export$707b17683f9c9ec0; });
$parcel$export(module.exports, "mapProcessor", function () { return $497127f075b386d3$export$5e912d1710885757; });
$parcel$export(module.exports, "setProcessor", function () { return $497127f075b386d3$export$2ff44e7a32269271; });
$parcel$export(module.exports, "arrayProcessor", function () { return $497127f075b386d3$export$afeff382d55f455b; });
$parcel$export(module.exports, "objectProcessor", function () { return $497127f075b386d3$export$8cc078cf99794668; });
$parcel$export(module.exports, "unionProcessor", function () { return $497127f075b386d3$export$f387dff1d8008b49; });
$parcel$export(module.exports, "intersectionProcessor", function () { return $497127f075b386d3$export$2a29f9128b7167c3; });
$parcel$export(module.exports, "tupleProcessor", function () { return $497127f075b386d3$export$7767a398545ac85c; });
$parcel$export(module.exports, "recordProcessor", function () { return $497127f075b386d3$export$6cf7a4b4a95ef1a8; });
$parcel$export(module.exports, "nullableProcessor", function () { return $497127f075b386d3$export$452ce6f96b49219a; });
$parcel$export(module.exports, "nonoptionalProcessor", function () { return $497127f075b386d3$export$7c6ac5b60b42bfc9; });
$parcel$export(module.exports, "defaultProcessor", function () { return $497127f075b386d3$export$f76e6c36e8fb062b; });
$parcel$export(module.exports, "prefaultProcessor", function () { return $497127f075b386d3$export$1ded4e432f286ac2; });
$parcel$export(module.exports, "catchProcessor", function () { return $497127f075b386d3$export$3f81793c903cb504; });
$parcel$export(module.exports, "pipeProcessor", function () { return $497127f075b386d3$export$3a3e6911d4012a24; });
$parcel$export(module.exports, "readonlyProcessor", function () { return $497127f075b386d3$export$dd90252c562e1d9; });
$parcel$export(module.exports, "promiseProcessor", function () { return $497127f075b386d3$export$ecb899a95fe4bdc0; });
$parcel$export(module.exports, "optionalProcessor", function () { return $497127f075b386d3$export$4b1db46aa3739c48; });
$parcel$export(module.exports, "lazyProcessor", function () { return $497127f075b386d3$export$9980155f320c317b; });

var $6iLpq = parcelRequire("6iLpq");

var $itk2T = parcelRequire("itk2T");

var $c0663 = parcelRequire("c0663");
const $497127f075b386d3$var$formatMap = {
    guid: "uuid",
    url: "uri",
    datetime: "date-time",
    json_string: "json-string",
    regex: ""
};
const $497127f075b386d3$export$c6950985d9de996d = (schema, ctx, _json, _params)=>{
    const json = _json;
    json.type = "string";
    const { minimum: minimum, maximum: maximum, format: format, patterns: patterns, contentEncoding: contentEncoding, laxFormat: laxFormat } = schema._zod.bag;
    if (typeof minimum === "number") json.minLength = minimum;
    if (typeof maximum === "number") json.maxLength = maximum;
    // custom pattern overrides format
    if (format) {
        json.format = $497127f075b386d3$var$formatMap[format] ?? format;
        if (json.format === "") delete json.format; // empty format is not valid
        // `z.iso.time()` is never full-time, and `laxFormat` carries the datetime shapes that also accept what their keyword forbids
        if (format === "time" || laxFormat) delete json.format;
    }
    if (contentEncoding) json.contentEncoding = contentEncoding;
    if (patterns && patterns.size > 0) {
        const patternList = [
            ...patterns
        ];
        if (patternList.length === 1) json.pattern = patternList[0].source;
        else if (patternList.length > 1) json.allOf = [
            ...patternList.map((regex)=>({
                    ...ctx.target === "draft-07" || ctx.target === "draft-04" || ctx.target === "openapi-3.0" ? {
                        type: "string"
                    } : {},
                    pattern: regex.source
                }))
        ];
    }
};
const $497127f075b386d3$export$afd08f475b2e134f = (schema, ctx, _json, params)=>{
    const json = _json;
    const { minimum: minimum, maximum: maximum, format: format, multipleOf: multipleOf, exclusiveMaximum: exclusiveMaximum, exclusiveMinimum: exclusiveMinimum } = schema._zod.bag;
    if (typeof format === "string" && format.includes("int")) json.type = "integer";
    else json.type = "number";
    // when both minimum and exclusiveMinimum exist, pick the more restrictive one
    const exMin = typeof exclusiveMinimum === "number" && exclusiveMinimum >= (minimum ?? Number.NEGATIVE_INFINITY);
    const exMax = typeof exclusiveMaximum === "number" && exclusiveMaximum <= (maximum ?? Number.POSITIVE_INFINITY);
    const legacy = ctx.target === "draft-04" || ctx.target === "openapi-3.0";
    if (exMin) {
        if (legacy) {
            json.minimum = exclusiveMinimum;
            json.exclusiveMinimum = true;
        } else json.exclusiveMinimum = exclusiveMinimum;
    } else if (typeof minimum === "number") json.minimum = minimum;
    if (exMax) {
        if (legacy) {
            json.maximum = exclusiveMaximum;
            json.exclusiveMaximum = true;
        } else json.exclusiveMaximum = exclusiveMaximum;
    } else if (typeof maximum === "number") json.maximum = maximum;
    if (typeof multipleOf === "number") {
        // JSON Schema requires a divisor strictly greater than zero, and a non-finite one does not survive JSON at all. A negative divisor accepts exactly what its absolute value accepts, so it still maps; zero, NaN and Infinity have no keyword form.
        if (Number.isFinite(multipleOf) && multipleOf !== 0) json.multipleOf = Math.abs(multipleOf);
        else (0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, `A multipleOf divisor of ${multipleOf} cannot be represented in JSON Schema`);
    }
};
const $497127f075b386d3$export$f03e9163a5233fc4 = (_schema, _ctx, json, _params)=>{
    json.type = "boolean";
};
const $497127f075b386d3$export$8810d61ae56edc9c = (schema, ctx, json, params)=>{
    (0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, "BigInt cannot be represented in JSON Schema");
};
const $497127f075b386d3$export$fd2b3c73524160ce = (schema, ctx, json, params)=>{
    (0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, "Symbols cannot be represented in JSON Schema");
};
const $497127f075b386d3$export$7667b76b86382b1f = (_schema, ctx, json, _params)=>{
    if (ctx.target === "openapi-3.0") {
        json.type = "string";
        json.nullable = true;
        json.enum = [
            null
        ];
    } else json.type = "null";
};
const $497127f075b386d3$export$9838a7ce212344b0 = (schema, ctx, json, params)=>{
    (0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, "Undefined cannot be represented in JSON Schema");
};
const $497127f075b386d3$export$b5910bb267c78233 = (schema, ctx, json, params)=>{
    (0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, "Void cannot be represented in JSON Schema");
};
const $497127f075b386d3$export$694b9cd80480ac33 = (_schema, _ctx, json, _params)=>{
    json.not = {};
};
const $497127f075b386d3$export$a92de72ffd9087b5 = (_schema, _ctx, _json, _params)=>{
// empty schema accepts anything
};
const $497127f075b386d3$export$4e1fea7b2e7474f = (_schema, _ctx, _json, _params)=>{
// empty schema accepts anything
};
const $497127f075b386d3$export$d044e6246fe40d06 = (schema, ctx, json, params)=>{
    (0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, "Date cannot be represented in JSON Schema");
};
const $497127f075b386d3$export$a0f7e3681bbe4f0b = (schema, _ctx, json, _params)=>{
    const def = schema._zod.def;
    const values = (0, $c0663.getEnumValues)(def.entries);
    // an empty enum accepts nothing, same as z.never()
    if (values.length === 0) {
        json.not = {};
        return;
    }
    // Number enums can have both string and number values
    if (values.every((v)=>typeof v === "number")) json.type = "number";
    if (values.every((v)=>typeof v === "string")) json.type = "string";
    json.enum = values;
};
const $497127f075b386d3$export$b7a483a046d3a9b = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    // a literal with no values accepts nothing, same as z.never()
    if (def.values.length === 0) {
        json.not = {};
        return;
    }
    const vals = [];
    for (const val of def.values){
        if (val === undefined) {
            // a custom schema replaces the whole literal, so there is nothing left to accumulate
            if ((0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, "Literal `undefined` cannot be represented in JSON Schema")) return;
        // otherwise do not add to vals
        } else if (typeof val === "bigint") {
            if ((0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, "BigInt literals cannot be represented in JSON Schema")) return;
            vals.push(Number(val));
        } else vals.push(val);
    }
    if (vals.length === 0) ;
    else if (vals.length === 1) {
        const val = vals[0];
        json.type = val === null ? "null" : typeof val;
        if (ctx.target === "draft-04" || ctx.target === "openapi-3.0") json.enum = [
            val
        ];
        else json.const = val;
    } else {
        if (vals.every((v)=>typeof v === "number")) json.type = "number";
        if (vals.every((v)=>typeof v === "string")) json.type = "string";
        if (vals.every((v)=>typeof v === "boolean")) json.type = "boolean";
        if (vals.every((v)=>v === null)) json.type = "null";
        json.enum = vals;
    }
};
const $497127f075b386d3$export$f33d8739d51ecc4b = (schema, ctx, json, params)=>{
    (0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, "NaN cannot be represented in JSON Schema");
};
const $497127f075b386d3$export$59812826ec9f1850 = (schema, _ctx, json, _params)=>{
    const _json = json;
    const pattern = schema._zod.pattern;
    if (!pattern) throw new Error("Pattern not found in template literal");
    _json.type = "string";
    _json.pattern = pattern.source;
};
const $497127f075b386d3$export$62de47a40c7b42b0 = (schema, _ctx, json, _params)=>{
    const _json = json;
    const file = {
        type: "string",
        format: "binary",
        contentEncoding: "binary"
    };
    const { minimum: minimum, maximum: maximum, mime: mime } = schema._zod.bag;
    if (minimum !== undefined) file.minLength = minimum;
    if (maximum !== undefined) file.maxLength = maximum;
    if (mime) {
        if (mime.length === 1) {
            file.contentMediaType = mime[0];
            Object.assign(_json, file);
        } else {
            Object.assign(_json, file); // shared props at root
            _json.anyOf = mime.map((m)=>({
                    contentMediaType: m
                })); // only contentMediaType differs
        }
    } else Object.assign(_json, file);
};
const $497127f075b386d3$export$1e296a49315ba27a = (_schema, _ctx, json, _params)=>{
    json.type = "boolean";
};
const $497127f075b386d3$export$fe3af043a76e4dab = (schema, ctx, json, params)=>{
    (0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, "Custom types cannot be represented in JSON Schema");
};
const $497127f075b386d3$export$654f185ba88226ab = (schema, ctx, json, params)=>{
    (0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, "Function types cannot be represented in JSON Schema");
};
const $497127f075b386d3$export$707b17683f9c9ec0 = (schema, ctx, json, params)=>{
    (0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, "Transforms cannot be represented in JSON Schema");
};
const $497127f075b386d3$export$5e912d1710885757 = (schema, ctx, json, params)=>{
    (0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, "Map cannot be represented in JSON Schema");
};
const $497127f075b386d3$export$2ff44e7a32269271 = (schema, ctx, json, params)=>{
    (0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, "Set cannot be represented in JSON Schema");
};
const $497127f075b386d3$export$afeff382d55f455b = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    const { minimum: minimum, maximum: maximum } = schema._zod.bag;
    if (typeof minimum === "number") json.minItems = minimum;
    if (typeof maximum === "number") json.maxItems = maximum;
    json.type = "array";
    json.items = (0, $itk2T.process)(def.element, ctx, {
        ...params,
        path: [
            ...params.path,
            "items"
        ]
    });
};
// Transform and catch set `optin = "optional"` at runtime so the parser lets them observe an
// absent key, but their declared input type stays required. An input JSON Schema describes the
// declared type, so resolve past them to the schema that actually carries the optionality.
// Used by both `objectProcessor` (for `required`) and `tupleProcessor` (for `minItems`); see
// wiki/optionality.md, "The JSON Schema emitter reads the *static* value".
function $497127f075b386d3$var$inputOptin(schema) {
    const def = schema._zod.def;
    if (def.type === "pipe" && def.in._zod.traits.has("$ZodTransform")) return $497127f075b386d3$var$inputOptin(def.out);
    if (def.type === "catch") return $497127f075b386d3$var$inputOptin(def.innerType);
    return schema._zod.optin;
}
const $497127f075b386d3$export$8cc078cf99794668 = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    const shape = def.shape;
    // dropping it while still emitting `additionalProperties: false` would emit a schema that rejects data this one requires
    const symbolKeys = Object.getOwnPropertySymbols(shape);
    if (symbolKeys.length && (0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, "Symbol keys cannot be represented in JSON Schema")) return;
    json.type = "object";
    json.properties = {};
    for(const key in shape)// assignProp so a __proto__ key becomes an own property instead of hitting the inherited setter on the plain {} we build into
    (0, $c0663.assignProp)(json.properties, key, (0, $itk2T.process)(shape[key], ctx, {
        ...params,
        path: [
            ...params.path,
            "properties",
            key
        ]
    }));
    // required keys
    const allKeys = new Set(Object.keys(shape));
    const requiredKeys = new Set([
        ...allKeys
    ].filter((key)=>{
        const field = def.shape[key];
        if (ctx.io === "input") return $497127f075b386d3$var$inputOptin(field) === undefined;
        else return field._zod.optout === undefined;
    }));
    if (requiredKeys.size > 0) json.required = Array.from(requiredKeys);
    // catchall
    if (def.catchall?._zod.def.type === "never") // strict
    json.additionalProperties = false;
    else if (!def.catchall) // regular
    {
        if (ctx.io === "output") json.additionalProperties = false;
    } else if (def.catchall) json.additionalProperties = (0, $itk2T.process)(def.catchall, ctx, {
        ...params,
        path: [
            ...params.path,
            "additionalProperties"
        ]
    });
};
const $497127f075b386d3$export$f387dff1d8008b49 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    // Exclusive unions (inclusive === false) use oneOf (exactly one match) instead of anyOf (one or more matches). This includes both z.xor() and discriminated unions
    const isExclusive = def.inclusive === false;
    const options = def.options.map((x, i)=>(0, $itk2T.process)(x, ctx, {
            ...params,
            path: [
                ...params.path,
                isExclusive ? "oneOf" : "anyOf",
                i
            ]
        }));
    if (isExclusive) json.oneOf = options;
    else json.anyOf = options;
};
const $497127f075b386d3$export$2a29f9128b7167c3 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    const a = (0, $itk2T.process)(def.left, ctx, {
        ...params,
        path: [
            ...params.path,
            "allOf",
            0
        ]
    });
    const b = (0, $itk2T.process)(def.right, ctx, {
        ...params,
        path: [
            ...params.path,
            "allOf",
            1
        ]
    });
    const isSimpleIntersection = (val)=>"allOf" in val && Object.keys(val).length === 1;
    const allOf = [
        ...isSimpleIntersection(a) ? a.allOf : [
            a
        ],
        ...isSimpleIntersection(b) ? b.allOf : [
            b
        ]
    ];
    json.allOf = allOf;
    // Recorded innermost first, so a nested intersection has already folded by the time this one is considered. The array is the handle rather than the schema, because a wrapper that inherits this schema shares the same array; `finalize` folds every object holding it. See `foldIntersection`.
    ctx.intersections.push(allOf);
};
const $497127f075b386d3$export$7767a398545ac85c = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    json.type = "array";
    const prefixPath = ctx.target === "draft-2020-12" ? "prefixItems" : "items";
    const restPath = ctx.target === "draft-2020-12" ? "items" : ctx.target === "openapi-3.0" ? "items" : "additionalItems";
    const prefixItems = def.items.map((x, i)=>(0, $itk2T.process)(x, ctx, {
            ...params,
            path: [
                ...params.path,
                prefixPath,
                i
            ]
        }));
    const rest = def.rest ? (0, $itk2T.process)(def.rest, ctx, {
        ...params,
        path: [
            ...params.path,
            restPath,
            ...ctx.target === "openapi-3.0" ? [
                def.items.length
            ] : []
        ]
    }) : null;
    let minItems = def.items.length;
    while(minItems > 0){
        const item = def.items[minItems - 1];
        const optional = ctx.io === "input" ? $497127f075b386d3$var$inputOptin(item) !== undefined : item._zod.optout === "optional";
        if (!optional) break;
        minItems--;
    }
    const maxItems = def.items.length;
    const isClosed = !def.rest;
    if (ctx.target === "draft-2020-12") {
        json.prefixItems = prefixItems;
        if (isClosed) json.items = false;
        else if (rest) json.items = rest;
        if (minItems > 0) json.minItems = minItems;
        if (isClosed) json.maxItems = maxItems;
    } else if (ctx.target === "openapi-3.0") {
        json.items = {
            anyOf: prefixItems
        };
        if (rest) json.items.anyOf.push(rest);
        if (minItems > 0) json.minItems = minItems;
        if (isClosed) json.maxItems = maxItems;
    } else {
        json.items = prefixItems;
        if (isClosed) json.additionalItems = false;
        else if (rest) json.additionalItems = rest;
        if (minItems > 0) json.minItems = minItems;
        if (isClosed) json.maxItems = maxItems;
    }
    // explicit user-defined length checks take precedence
    const { minimum: minimum, maximum: maximum } = schema._zod.bag;
    if (typeof minimum === "number") json.minItems = minimum;
    if (typeof maximum === "number") json.maxItems = maximum;
};
/** JSON object keys are always strings, so a numeric record key schema is re-expressed over the
 * numeric-string form the record parser matches. Deferred to `finalize`, after the flatten: a key
 * behind a wrapper only carries its own `type` before then, and a union key only has its branches.
 *
 * A numeric bound cannot apply to a property name, so `minimum` and its siblings are dropped rather
 * than carried over: keeping them beside `type: "string"` reproduces the match-nothing schema this
 * exists to fix. A key that carries one therefore emits wider than the record parses — `z.record(z.number().min(5), V)`
 * accepts `"3"` — which is the deliberate trade, since throwing on it would reject an ordinary schema
 * outright. */ function $497127f075b386d3$var$stringifyKeyNames(bySchema, json, visited) {
    // an extracted key that rewrites cannot go on sharing its definition — the string form a key position needs is not the number form every other reference wants — so it inlines. One that does not rewrite keeps the `$ref`.
    if (json.$ref) {
        // a recursive key holds its own reference inside its definition, so a node already on the path is left alone rather than resolved again
        if (visited.has(json)) return json;
        visited.add(json);
        const def = bySchema.get(json)?.def;
        if (!def) return json;
        const inlined = $497127f075b386d3$var$stringifyKeyNames(bySchema, def, visited);
        return inlined === def ? json : inlined;
    }
    for (const keyword of [
        "anyOf",
        "oneOf"
    ]){
        const branches = json[keyword];
        if (!Array.isArray(branches)) continue;
        const mapped = branches.map((branch)=>$497127f075b386d3$var$stringifyKeyNames(bySchema, branch, visited));
        // rebuilding regardless would detach a key that had nothing to re-express, dropping its `$ref` and leaking the internal `id`
        if (mapped.some((branch, i)=>branch !== branches[i])) json = {
            ...json,
            [keyword]: mapped
        };
    }
    // a member that already admits a string leaves the key unconstrained, so the node's own type re-expresses only when every member is numeric
    const types = Array.isArray(json.type) ? json.type : [
        json.type
    ];
    const numericType = !types.includes("string") && types.some((t)=>t === "number" || t === "integer");
    // a heterogeneous key carries no type at all, so its numeric members are caught here instead
    const values = json.enum ?? (json.const !== undefined ? [
        json.const
    ] : undefined);
    if (!numericType && !values?.some((v)=>typeof v === "number")) return json;
    const { minimum: minimum, maximum: maximum, exclusiveMinimum: exclusiveMinimum, exclusiveMaximum: exclusiveMaximum, multipleOf: multipleOf, format: format, id: id, ...rest } = json;
    if (rest.enum) rest.enum = rest.enum.map((v)=>typeof v === "number" ? String(v) : v);
    else if (typeof rest.const === "number") rest.const = String(rest.const);
    // a heterogeneous key keeps its absent type: the stringified members already say what a key may be
    if (!numericType) return rest;
    rest.type = "string";
    if (!values) rest.pattern = (types.includes("number") ? $6iLpq.number : $6iLpq.integer).source;
    return rest;
}
/** Every record of one conversion, so the carriers are found in a single pass rather than once per record. */ const $497127f075b386d3$var$pendingRecords = new WeakMap();
function $497127f075b386d3$var$rewriteKeyNames(ctx) {
    // an extracted key is resolved by the object `extractToDef` left in its place, so the map is built once rather than searched per reference. `_zod.toJSONSchema` can hand the same object to two schemas, so the first entry carrying a body wins, as a search would have found it.
    const bySchema = new Map();
    for (const entry of ctx.seen.values())if (entry.def && !bySchema.has(entry.schema)) bySchema.set(entry.schema, entry);
    const rewrites = new Map();
    for (const record of $497127f075b386d3$var$pendingRecords.get(ctx) ?? []){
        const seen = ctx.seen.get(record);
        const names = (seen?.def ?? seen?.schema)?.propertyNames;
        if (!names || names === true || rewrites.has(names)) continue;
        const rewritten = $497127f075b386d3$var$stringifyKeyNames(bySchema, names, new Set());
        if (rewritten !== names) rewrites.set(names, rewritten);
    }
    if (!rewrites.size) return;
    // the flatten has already copied each record's own properties onto every wrapper by reference, and an extracted body is another such copy, so every carrier holding a rewritten key is updated together
    for (const entry of ctx.seen.values())for (const carrier of [
        entry.schema,
        entry.def
    ]){
        const rewritten = carrier && rewrites.get(carrier.propertyNames);
        if (rewritten) carrier.propertyNames = rewritten;
    }
}
const $497127f075b386d3$export$6cf7a4b4a95ef1a8 = (schema, ctx, _json, params)=>{
    const json = _json;
    const def = schema._zod.def;
    json.type = "object";
    // For looseRecord with regex patterns, use patternProperties. This correctly represents "only validate keys matching the pattern" semantics and composes well with allOf (intersections)
    const keyType = def.keyType;
    const keyBag = keyType._zod.bag;
    const patterns = keyBag?.patterns;
    if (def.mode === "loose" && patterns && patterns.size > 0) {
        // Use patternProperties for looseRecord with regex patterns
        const valueSchema = (0, $itk2T.process)(def.valueType, ctx, {
            ...params,
            path: [
                ...params.path,
                "patternProperties",
                "*"
            ]
        });
        json.patternProperties = {};
        for (const pattern of patterns)(0, $c0663.assignProp)(json.patternProperties, pattern.source, valueSchema);
    } else {
        // Default behavior: use propertyNames + additionalProperties
        if (ctx.target === "draft-07" || ctx.target === "draft-2020-12") {
            json.propertyNames = (0, $itk2T.process)(def.keyType, ctx, {
                ...params,
                path: [
                    ...params.path,
                    "propertyNames"
                ]
            });
            let pending = $497127f075b386d3$var$pendingRecords.get(ctx);
            if (!pending) {
                pending = [];
                $497127f075b386d3$var$pendingRecords.set(ctx, pending);
                ctx.deferred.push(()=>$497127f075b386d3$var$rewriteKeyNames(ctx));
            }
            pending.push(schema);
        }
        json.additionalProperties = (0, $itk2T.process)(def.valueType, ctx, {
            ...params,
            path: [
                ...params.path,
                "additionalProperties"
            ]
        });
    }
    // Add required for keys with discrete values (enum, literal, etc.)
    const keyValues = keyType._zod.values;
    // Every key shares one value schema, so an optional-in value makes the whole key set omittable on input. Output keeps them: the exhaustive branch assigns every key, even one whose value came back undefined.
    const omittableOnInput = ctx.io === "input" && $497127f075b386d3$var$inputOptin(def.valueType) !== undefined;
    if (keyValues && !def.partial && !omittableOnInput) {
        const validKeyValues = [
            ...keyValues
        ].filter((v)=>typeof v === "string" || typeof v === "number");
        if (validKeyValues.length > 0) json.required = validKeyValues.map(String);
    }
};
const $497127f075b386d3$export$452ce6f96b49219a = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    const inner = (0, $itk2T.process)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    if (ctx.target === "openapi-3.0") {
        seen.ref = def.innerType;
        json.nullable = true;
    } else json.anyOf = [
        inner,
        {
            type: "null"
        }
    ];
};
const $497127f075b386d3$export$7c6ac5b60b42bfc9 = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    (0, $itk2T.process)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
};
/** Round-trips a default value through JSON so the emitted schema is guaranteed to be valid JSON.
 * A BigInt has no reliable encoding, so it goes through `unrepresentable` like any other
 * unrepresentable value. Returns a sentinel when the caller must not write a default of its own. */ const $497127f075b386d3$var$UNREPRESENTABLE_DEFAULT = Symbol();
function $497127f075b386d3$var$serializeDefaultValue(value, schema, ctx, json, params) {
    let unrepresentable = false;
    const serialized = JSON.stringify(value, (_, val)=>{
        if (typeof val !== "bigint") return val;
        unrepresentable = true;
        return null;
    });
    if (!unrepresentable) return JSON.parse(serialized);
    (0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, "BigInt defaults cannot be represented in JSON Schema");
    return $497127f075b386d3$var$UNREPRESENTABLE_DEFAULT;
}
const $497127f075b386d3$export$f76e6c36e8fb062b = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, $itk2T.process)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    const value = $497127f075b386d3$var$serializeDefaultValue(def.defaultValue, schema, ctx, json, params);
    if (value !== $497127f075b386d3$var$UNREPRESENTABLE_DEFAULT) json.default = value;
};
const $497127f075b386d3$export$1ded4e432f286ac2 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, $itk2T.process)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    if (ctx.io !== "input") return;
    const value = $497127f075b386d3$var$serializeDefaultValue(def.defaultValue, schema, ctx, json, params);
    if (value !== $497127f075b386d3$var$UNREPRESENTABLE_DEFAULT) json._prefault = value;
};
const $497127f075b386d3$export$3f81793c903cb504 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, $itk2T.process)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    let catchValue;
    try {
        catchValue = def.catchValue(undefined);
    } catch  {
        (0, $itk2T.handleUnrepresentable)(schema, ctx, json, params, "Dynamic catch values are not supported in JSON Schema");
        return;
    }
    json.default = catchValue;
};
const $497127f075b386d3$export$3a3e6911d4012a24 = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    const inIsTransform = def.in._zod.traits.has("$ZodTransform");
    const innerType = ctx.io === "input" ? inIsTransform ? def.out : def.in : def.out;
    (0, $itk2T.process)(innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = innerType;
};
const $497127f075b386d3$export$dd90252c562e1d9 = (schema, ctx, json, params)=>{
    const def = schema._zod.def;
    (0, $itk2T.process)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
    json.readOnly = true;
};
const $497127f075b386d3$export$ecb899a95fe4bdc0 = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    (0, $itk2T.process)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
};
const $497127f075b386d3$export$4b1db46aa3739c48 = (schema, ctx, _json, params)=>{
    const def = schema._zod.def;
    (0, $itk2T.process)(def.innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = def.innerType;
};
const $497127f075b386d3$export$9980155f320c317b = (schema, ctx, _json, params)=>{
    const innerType = schema._zod.innerType;
    (0, $itk2T.process)(innerType, ctx, params);
    const seen = ctx.seen.get(schema);
    seen.ref = innerType;
};
const $497127f075b386d3$export$e462eec3d35f5c06 = {
    string: $497127f075b386d3$export$c6950985d9de996d,
    number: $497127f075b386d3$export$afd08f475b2e134f,
    boolean: $497127f075b386d3$export$f03e9163a5233fc4,
    bigint: $497127f075b386d3$export$8810d61ae56edc9c,
    symbol: $497127f075b386d3$export$fd2b3c73524160ce,
    null: $497127f075b386d3$export$7667b76b86382b1f,
    undefined: $497127f075b386d3$export$9838a7ce212344b0,
    void: $497127f075b386d3$export$b5910bb267c78233,
    never: $497127f075b386d3$export$694b9cd80480ac33,
    any: $497127f075b386d3$export$a92de72ffd9087b5,
    unknown: $497127f075b386d3$export$4e1fea7b2e7474f,
    date: $497127f075b386d3$export$d044e6246fe40d06,
    enum: $497127f075b386d3$export$a0f7e3681bbe4f0b,
    literal: $497127f075b386d3$export$b7a483a046d3a9b,
    nan: $497127f075b386d3$export$f33d8739d51ecc4b,
    template_literal: $497127f075b386d3$export$59812826ec9f1850,
    file: $497127f075b386d3$export$62de47a40c7b42b0,
    success: $497127f075b386d3$export$1e296a49315ba27a,
    custom: $497127f075b386d3$export$fe3af043a76e4dab,
    function: $497127f075b386d3$export$654f185ba88226ab,
    transform: $497127f075b386d3$export$707b17683f9c9ec0,
    map: $497127f075b386d3$export$5e912d1710885757,
    set: $497127f075b386d3$export$2ff44e7a32269271,
    array: $497127f075b386d3$export$afeff382d55f455b,
    object: $497127f075b386d3$export$8cc078cf99794668,
    union: $497127f075b386d3$export$f387dff1d8008b49,
    intersection: $497127f075b386d3$export$2a29f9128b7167c3,
    tuple: $497127f075b386d3$export$7767a398545ac85c,
    record: $497127f075b386d3$export$6cf7a4b4a95ef1a8,
    nullable: $497127f075b386d3$export$452ce6f96b49219a,
    nonoptional: $497127f075b386d3$export$7c6ac5b60b42bfc9,
    default: $497127f075b386d3$export$f76e6c36e8fb062b,
    prefault: $497127f075b386d3$export$1ded4e432f286ac2,
    catch: $497127f075b386d3$export$3f81793c903cb504,
    pipe: $497127f075b386d3$export$3a3e6911d4012a24,
    readonly: $497127f075b386d3$export$dd90252c562e1d9,
    promise: $497127f075b386d3$export$ecb899a95fe4bdc0,
    optional: $497127f075b386d3$export$4b1db46aa3739c48,
    lazy: $497127f075b386d3$export$9980155f320c317b
};
function $497127f075b386d3$export$395d8e19463d4f49(input, params) {
    if ("_idmap" in input) {
        // Registry case
        const registry = input;
        const ctx = (0, $itk2T.initializeContext)({
            ...params,
            processors: $497127f075b386d3$export$e462eec3d35f5c06
        });
        const defs = {};
        // First pass: process all schemas to build the seen map
        for (const entry of registry._idmap.entries()){
            const [_, schema] = entry;
            (0, $itk2T.process)(schema, ctx);
        }
        const schemas = {};
        const external = {
            registry: registry,
            uri: params?.uri,
            defs: defs
        };
        // Update the context with external configuration
        ctx.external = external;
        // Second pass: emit each schema
        for (const entry of registry._idmap.entries()){
            const [key, schema] = entry;
            (0, $itk2T.extractDefs)(ctx, schema);
            (0, $c0663.assignProp)(schemas, key, (0, $itk2T.finalize)(ctx, schema));
        }
        if (Object.keys(defs).length > 0) {
            const defsSegment = ctx.target === "draft-2020-12" ? "$defs" : "definitions";
            schemas.__shared = {
                [defsSegment]: defs
            };
        }
        return {
            schemas: schemas
        };
    }
    // Single schema case
    const ctx = (0, $itk2T.initializeContext)({
        ...params,
        processors: $497127f075b386d3$export$e462eec3d35f5c06
    });
    (0, $itk2T.process)(input, ctx);
    (0, $itk2T.extractDefs)(ctx, input);
    return (0, $itk2T.finalize)(ctx, input);
}

});
parcelRegister("itk2T", function(module, exports) {

$parcel$export(module.exports, "initializeContext", function () { return $d72a7c105b0f7633$export$881f7fb71351b304; });
$parcel$export(module.exports, "handleUnrepresentable", function () { return $d72a7c105b0f7633$export$e3c1b0b829661475; });
$parcel$export(module.exports, "process", function () { return $d72a7c105b0f7633$export$e54fe5b0f43758f7; });
$parcel$export(module.exports, "extractDefs", function () { return $d72a7c105b0f7633$export$ba2613251eadea93; });
$parcel$export(module.exports, "finalize", function () { return $d72a7c105b0f7633$export$578723aef62d92f5; });
$parcel$export(module.exports, "createStandardJSONSchemaMethod", function () { return $d72a7c105b0f7633$export$b29c48d79372468a; });
$parcel$export(module.exports, "createToJSONSchemaMethod", function () { return $d72a7c105b0f7633$export$d24eb8c1ef5f4df1; });

var $eTOwy = parcelRequire("eTOwy");

var $c0663 = parcelRequire("c0663");
function $d72a7c105b0f7633$var$assignProps(target, ...sources) {
    for (const source of sources){
        for (const key of Reflect.ownKeys(source))if (Object.prototype.propertyIsEnumerable.call(source, key)) (0, $c0663.assignProp)(target, key, source[key]);
    }
    return target;
}
function $d72a7c105b0f7633$export$881f7fb71351b304(params) {
    // Normalize target: convert old non-hyphenated versions to hyphenated versions
    let target = params?.target ?? "draft-2020-12";
    if (target === "draft-4") target = "draft-04";
    if (target === "draft-7") target = "draft-07";
    return {
        processors: params.processors ?? {},
        metadataRegistry: params?.metadata ?? (0, $eTOwy.globalRegistry),
        target: target,
        unrepresentable: params?.unrepresentable ?? "throw",
        override: params?.override ?? (()=>{}),
        io: params?.io ?? "output",
        counter: 0,
        seen: new Map(),
        sharedDefsExtractedFor: undefined,
        sharedEmitDoneFor: undefined,
        cycles: params?.cycles ?? "ref",
        reused: params?.reused ?? "inline",
        intersections: [],
        deferred: [],
        external: params?.external ?? undefined
    };
}
function $d72a7c105b0f7633$export$e3c1b0b829661475(schema, ctx, json, params, message) {
    const result = typeof ctx.unrepresentable === "function" ? ctx.unrepresentable({
        zodSchema: schema,
        path: params.path,
        message: message
    }) : ctx.unrepresentable;
    if (result === "any") return false;
    if (result === undefined || result === "throw") throw new Error(message);
    Object.assign(json, result);
    return true;
}
function $d72a7c105b0f7633$export$e54fe5b0f43758f7(schema, ctx, _params = {
    path: [],
    schemaPath: []
}) {
    var _a;
    const def = schema._zod.def;
    // check for schema in seens
    const seen = ctx.seen.get(schema);
    if (seen) {
        seen.count++;
        // check if cycle
        const isCycle = _params.schemaPath.includes(schema);
        if (isCycle) seen.cycle = _params.path;
        return seen.schema;
    }
    // initialize
    const result = {
        schema: {},
        count: 1,
        cycle: undefined,
        path: _params.path
    };
    ctx.seen.set(schema, result);
    ctx.sharedDefsExtractedFor = undefined;
    ctx.sharedEmitDoneFor = undefined;
    // custom method overrides default behavior
    const overrideSchema = schema._zod.toJSONSchema?.();
    if (overrideSchema) result.schema = overrideSchema;
    else {
        const params = {
            ..._params,
            schemaPath: [
                ..._params.schemaPath,
                schema
            ],
            path: _params.path
        };
        if (schema._zod.processJSONSchema) schema._zod.processJSONSchema(ctx, result.schema, params);
        else {
            const _json = result.schema;
            const processor = ctx.processors[def.type];
            if (!processor) throw new Error(`[toJSONSchema]: Non-representable type encountered: ${def.type}`);
            processor(schema, ctx, _json, params);
        }
        const parent = schema._zod.parent;
        if (parent) {
            // Also set ref if processor didn't (for inheritance)
            if (!result.ref) result.ref = parent;
            $d72a7c105b0f7633$export$e54fe5b0f43758f7(parent, ctx, params);
            ctx.seen.get(parent).isParent = true;
        }
    }
    // metadata
    const meta = ctx.metadataRegistry.get(schema);
    if (meta) $d72a7c105b0f7633$var$assignProps(result.schema, meta);
    if (ctx.io === "input" && $d72a7c105b0f7633$var$isTransforming(schema)) {
        // examples/defaults only apply to output type of pipe
        delete result.schema.examples;
        delete result.schema.default;
    }
    // set prefault as default
    if (ctx.io === "input" && "_prefault" in result.schema) (_a = result.schema).default ?? (_a.default = result.schema._prefault);
    delete result.schema._prefault;
    // pulling fresh from ctx.seen in case it was overwritten
    const _result = ctx.seen.get(schema);
    return _result.schema;
}
// Escape a reference token for use in a JSON Pointer fragment (RFC 6901): `~` becomes `~0` and `/` becomes `~1`. The `~` replacement must run first.
function $d72a7c105b0f7633$var$encodeJSONPointerSegment(segment) {
    return segment.replace(/~/g, "~0").replace(/\//g, "~1");
}
function $d72a7c105b0f7633$export$ba2613251eadea93(ctx, schema) {
    // iterate over seen map;
    const root = ctx.seen.get(schema);
    if (!root) throw new Error("Unprocessed schema. This is a bug in Zod.");
    // With `external` set, every registered schema resolves through the external branch of `makeURI`, so the root branch below produces the same ref the external branch would — this pass is identical whichever schema it is called with, and only needs to run once.
    if (ctx.external && ctx.sharedDefsExtractedFor === ctx.external) return;
    // Track ids to detect duplicates across different schemas
    const idToSchema = new Map();
    for (const entry of ctx.seen.entries()){
        const id = ctx.metadataRegistry.get(entry[0])?.id;
        if (id) {
            const existing = idToSchema.get(id);
            if (existing && existing !== entry[0]) throw new Error(`Duplicate schema id "${id}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
            idToSchema.set(id, entry[0]);
        }
    }
    // returns a ref to the schema defId will be empty if the ref points to an external schema (or #)
    const makeURI = (entry)=>{
        // comparing the seen objects because sometimes multiple schemas map to the same seen object. e.g. lazy
        // external is configured
        const defsSegment = ctx.target === "draft-2020-12" ? "$defs" : "definitions";
        if (ctx.external) {
            const externalId = ctx.external.registry.get(entry[0])?.id; // ?? "__shared";// `__schema${ctx.counter++}`;
            // check if schema is in the external registry
            const uriGenerator = ctx.external.uri ?? ((id)=>id);
            if (externalId) return {
                ref: uriGenerator(externalId)
            };
            // otherwise, add to __shared
            const id = entry[1].defId ?? entry[1].schema.id ?? `schema${ctx.counter++}`;
            entry[1].defId = id; // set defId so it will be reused if needed
            return {
                defId: id,
                ref: `${uriGenerator("__shared")}#/${defsSegment}/${$d72a7c105b0f7633$var$encodeJSONPointerSegment(id)}`
            };
        }
        const uriPrefix = `#`;
        const defUriPrefix = `${uriPrefix}/${defsSegment}/`;
        // an id-less root has nowhere to be extracted to, so it stays inline and self-references as `#`
        if (entry[1] === root && !entry[1].schema.id) return {
            ref: uriPrefix
        };
        // self-contained schema
        const defId = entry[1].schema.id ?? `__schema${ctx.counter++}`;
        return {
            defId: defId,
            ref: defUriPrefix + $d72a7c105b0f7633$var$encodeJSONPointerSegment(defId)
        };
    };
    // stored cached version in `def` property remove all properties, set $ref
    const extractToDef = (entry)=>{
        // if the schema is already a reference, do not extract it
        if (entry[1].schema.$ref) return;
        const seen = entry[1];
        const { ref: ref, defId: defId } = makeURI(entry);
        seen.def = {
            ...seen.schema
        };
        // defId won't be set if the schema is a reference to an external schema or if the schema is the root schema
        if (defId) seen.defId = defId;
        // wipe away all properties except $ref
        const schema = seen.schema;
        for(const key in schema)delete schema[key];
        schema.$ref = ref;
    };
    // throw on cycles
    // break cycles
    if (ctx.cycles === "throw") for (const entry of ctx.seen.entries()){
        const seen = entry[1];
        if (seen.cycle) throw new Error("Cycle detected: " + `#/${seen.cycle?.join("/")}/<root>` + '\n\nSet the `cycles` parameter to `"ref"` to resolve cyclical schemas with defs.');
    }
    // extract schemas into $defs
    for (const entry of ctx.seen.entries()){
        const seen = entry[1];
        // convert root schema to # $ref
        if (schema === entry[0]) {
            extractToDef(entry); // this has special handling for the root schema
            continue;
        }
        // extract schemas that are in the external registry
        if (ctx.external) {
            const ext = ctx.external.registry.get(entry[0])?.id;
            if (schema !== entry[0] && ext) {
                extractToDef(entry);
                continue;
            }
        }
        // extract schemas with `id` meta
        const id = ctx.metadataRegistry.get(entry[0])?.id;
        if (id) {
            extractToDef(entry);
            continue;
        }
        // break cycles
        if (seen.cycle) {
            // any
            extractToDef(entry);
            continue;
        }
        // extract reused schemas
        if (seen.count > 1) {
            if (ctx.reused === "ref") {
                extractToDef(entry);
                continue;
            }
        }
    }
    if (ctx.external) ctx.sharedDefsExtractedFor = ctx.external;
}
/** Rewrites `anyOf: [{type: "a"}, {type: "b"}]` to `type: ["a", "b"]`, which every JSON Schema draft treats as equivalent and most consumers render far better for the nullable case. Only branches that are a bare type assertion qualify — anything carrying a constraint, `$ref`, `const` or metadata is left alone. Runs after `flattenRef`, so a branch an override decorated or `$defs` extraction turned into a `$ref` is no longer bare and correctly stays in `anyOf`. `oneOf` is excluded: `integer` and `number` overlap, so "exactly one" and "at least one" are not the same there. OpenAPI 3.0 is excluded: its `type` must be a single string. */ function $d72a7c105b0f7633$var$compactTypeUnion(schema) {
    const options = schema.anyOf;
    if (!Array.isArray(options) || options.length === 0 || schema.type !== undefined) return;
    const types = [];
    for (const option of options){
        if (!option || typeof option !== "object") return;
        // A branch that is itself a compactible union folds into this one — nested `anyOf` and a flat `type` array say the same thing. Compacting it first also makes the result independent of the order this pass walks the seen map in.
        $d72a7c105b0f7633$var$compactTypeUnion(option);
        const keys = Object.keys(option);
        if (keys.length !== 1 || keys[0] !== "type") return;
        const type = option.type;
        for (const member of Array.isArray(type) ? type : [
            type
        ]){
            if (typeof member !== "string") return;
            if (!types.includes(member)) types.push(member);
        }
    }
    delete schema.anyOf;
    // A `type` array must be non-empty and unique (metaschema); a single member is spelled as a bare string.
    schema.type = types.length === 1 ? types[0] : types;
}
/** Keywords `foldIntersection` knows how to combine. Anything else — `$ref`, `patternProperties`,
 * an annotation like `description` — makes a member unfoldable, so a constraint this does not
 * understand leaves the `allOf` alone instead of being silently dropped or misattributed. */ const $d72a7c105b0f7633$var$FOLDABLE_KEYS = new Set([
    "type",
    "properties",
    "required",
    "additionalProperties"
]);
const $d72a7c105b0f7633$var$UNION_KEYS = [
    "oneOf",
    "anyOf"
];
/** A member's constraint on a key it does not declare itself. A `catchall` states one; `false`, an absent `additionalProperties`, and the empty schema a loose object emits state nothing. */ function $d72a7c105b0f7633$var$undeclaredConstraint(member) {
    const extra = member.additionalProperties;
    if (extra === undefined || extra === false || typeof extra !== "object" || extra === null) return null;
    return Object.keys(extra).length ? extra : null;
}
/** Combines object members into the single object they describe together, or returns `null` if any of them carries a keyword outside {@link FOLDABLE_KEYS}. */ function $d72a7c105b0f7633$var$foldObjects(members) {
    const objects = [];
    for (const member of members){
        // A boolean subschema is legal JSON Schema and carries no keywords to fold.
        if (typeof member !== "object" || member.type !== "object") return null;
        for(const key in member){
            if (!$d72a7c105b0f7633$var$FOLDABLE_KEYS.has(key)) return null;
        }
        objects.push(member);
    }
    const properties = {};
    const required = new Set();
    for (const object of objects){
        for(const key in object.properties){
            // `in` would report a `__proto__` key as already present via the prototype chain and skip it.
            if (Object.prototype.hasOwnProperty.call(properties, key)) continue;
            // Every member constrains this key: the ones that declare it say how, and a `catchall` member constrains it too even though it does not name it. The key has to satisfy all of them, which is the same intersection one level down.
            const parts = [];
            for (const other of objects){
                const part = other.properties?.[key] ?? $d72a7c105b0f7633$var$undeclaredConstraint(other);
                if (part === null || part === undefined) continue;
                if (!parts.some((seen)=>JSON.stringify(seen) === JSON.stringify(part))) parts.push(part);
            }
            const merged = parts.length === 1 ? parts[0] : $d72a7c105b0f7633$var$foldObjects(parts) ?? {
                allOf: parts
            };
            (0, $c0663.assignProp)(properties, key, merged);
        }
        for (const key of object.required ?? [])required.add(key);
    }
    const folded = {
        type: "object",
        properties: properties
    };
    if (required.size) folded.required = [
        ...required
    ];
    // A key no member declares is rejected only when every member rejects it, so the fold is closed only when every member is. Otherwise it carries whatever the `catchall` members demand of such a key.
    if (objects.every((object)=>object.additionalProperties === false)) folded.additionalProperties = false;
    else {
        const constraints = [];
        for (const object of objects){
            const constraint = $d72a7c105b0f7633$var$undeclaredConstraint(object);
            if (constraint && !constraints.some((seen)=>JSON.stringify(seen) === JSON.stringify(constraint))) constraints.push(constraint);
        }
        if (constraints.length === 1) folded.additionalProperties = constraints[0];
        else if (constraints.length > 1) folded.additionalProperties = {
            allOf: constraints
        };
    }
    return folded;
}
/** `additionalProperties` in an `allOf` member sees only that member's own `properties`, so two
 * closed object members reject each other's keys and the schema validates nothing. Zod's parser
 * pools the key sets instead — `handleIntersectionResults` reports a key as unrecognized only when
 * *every* side rejects it — so the emitted schema has to pool them too, and folding the members
 * into one object is the encoding that says so on every target.
 *
 * This runs from `finalize`, after `extractDefs`, which is what keeps it clear of the `$ref`
 * machinery: a member extracted into `$defs` is already a `$ref` by now and declines to fold, so it
 * keeps its reference and its own closedness rather than being inlined as a stale copy. */ function $d72a7c105b0f7633$var$foldIntersection(json) {
    const allOf = json.allOf;
    if (!Array.isArray(allOf) || allOf.length < 2) return;
    // An `override` runs before this pass and may have written object keywords onto the intersection itself. Those are deliberate, so decline rather than overwrite them.
    for (const key of $d72a7c105b0f7633$var$FOLDABLE_KEYS)if (key in json) return;
    // An intersection distributes over a union: `A & (X | Y)` is `(A & X) | (A & Y)`. Only the first union is distributed over; a second one stays among the members every branch folds against, where it fails the object check and declines the whole intersection rather than multiplying out.
    const unions = allOf.filter((m)=>$d72a7c105b0f7633$var$UNION_KEYS.some((k)=>Array.isArray(m[k])));
    let folded = null;
    if (!unions.length) folded = $d72a7c105b0f7633$var$foldObjects(allOf);
    else {
        const union = unions[0];
        const keyword = $d72a7c105b0f7633$var$UNION_KEYS.find((k)=>Array.isArray(union[k]));
        if (Object.keys(union).length !== 1) return;
        const rest = allOf.filter((m)=>m !== union);
        const branches = union[keyword].map((branch)=>$d72a7c105b0f7633$var$foldObjects([
                ...rest,
                branch
            ]));
        if (branches.some((b)=>!b)) return;
        folded = {
            [keyword]: branches
        };
    }
    if (!folded) return;
    delete json.allOf;
    $d72a7c105b0f7633$var$assignProps(json, folded);
}
function $d72a7c105b0f7633$export$578723aef62d92f5(ctx, schema) {
    const root = ctx.seen.get(schema);
    if (!root) throw new Error("Unprocessed schema. This is a bug in Zod.");
    // flatten refs - inherit properties from parent schemas
    const flattenRef = (zodSchema)=>{
        const seen = ctx.seen.get(zodSchema);
        // already processed
        if (seen.ref === null) return;
        const schema = seen.def ?? seen.schema;
        const _cached = {
            ...schema
        };
        const ref = seen.ref;
        seen.ref = null; // prevent infinite recursion
        if (ref) {
            flattenRef(ref);
            const refSeen = ctx.seen.get(ref);
            const refSchema = refSeen.schema;
            // merge referenced schema into current
            if (refSchema.$ref && (ctx.target === "draft-07" || ctx.target === "draft-04" || ctx.target === "openapi-3.0")) {
                // older drafts can't combine $ref with other properties
                schema.allOf = schema.allOf ?? [];
                schema.allOf.push(refSchema);
            } else $d72a7c105b0f7633$var$assignProps(schema, refSchema);
            // restore child's own properties (child wins)
            $d72a7c105b0f7633$var$assignProps(schema, _cached);
            const isParentRef = zodSchema._zod.parent === ref;
            // For parent chain, child is a refinement - remove parent-only properties
            if (isParentRef) for(const key in schema){
                if (key === "$ref" || key === "allOf") continue;
                if (!(key in _cached)) delete schema[key];
            }
            // When ref was extracted to $defs, remove properties that match the definition
            if (refSchema.$ref && refSeen.def) for(const key in schema){
                if (key === "$ref" || key === "allOf") continue;
                if (key in refSeen.def && JSON.stringify(schema[key]) === JSON.stringify(refSeen.def[key])) delete schema[key];
            }
        }
        // If parent was extracted (has $ref), propagate $ref to this schema. This handles cases like: readonly().meta({id}).describe() where processor sets ref to innerType but parent should be referenced
        const parent = zodSchema._zod.parent;
        if (parent && parent !== ref) {
            // Ensure parent is processed first so its def has inherited properties
            flattenRef(parent);
            const parentSeen = ctx.seen.get(parent);
            if (parentSeen?.schema.$ref) {
                schema.$ref = parentSeen.schema.$ref;
                // De-duplicate with parent's definition
                if (parentSeen.def) for(const key in schema){
                    if (key === "$ref" || key === "allOf") continue;
                    if (key in parentSeen.def && JSON.stringify(schema[key]) === JSON.stringify(parentSeen.def[key])) delete schema[key];
                }
            }
        }
        // execute overrides
        ctx.override({
            zodSchema: zodSchema,
            jsonSchema: schema,
            path: seen.path ?? []
        });
    };
    // Flattening walks the whole map and clears each `ref` as it goes, so a second call over the same map is a no-op scan. Skip it outright once it has run for a registry conversion.
    if (!ctx.external || ctx.sharedEmitDoneFor !== ctx.external) {
        for (const entry of [
            ...ctx.seen.entries()
        ].reverse())flattenRef(entry[0]);
        if (ctx.target !== "openapi-3.0") for (const entry of ctx.seen.entries())$d72a7c105b0f7633$var$compactTypeUnion(entry[1].def ?? entry[1].schema);
        for (const rewrite of ctx.deferred)rewrite();
        // After flattening, every member that was extracted is a `$ref`, so the fold sees the final shape. A schema that inherits an intersection — through `z.lazy`, or any `ref` chain — holds the same `allOf` array, so fold by array identity to catch every copy.
        if (ctx.intersections.length) {
            const carriers = new Map();
            for (const seen of ctx.seen.values())for (const json of [
                seen.schema,
                seen.def
            ]){
                const allOf = json?.allOf;
                if (!Array.isArray(allOf)) continue;
                const existing = carriers.get(allOf);
                if (existing) existing.push(json);
                else carriers.set(allOf, [
                    json
                ]);
            }
            for (const allOf of ctx.intersections)for (const json of carriers.get(allOf) ?? [])$d72a7c105b0f7633$var$foldIntersection(json);
        }
    }
    const result = {};
    if (ctx.target === "draft-2020-12") result.$schema = "https://json-schema.org/draft/2020-12/schema";
    else if (ctx.target === "draft-07") result.$schema = "http://json-schema.org/draft-07/schema#";
    else if (ctx.target === "draft-04") result.$schema = "http://json-schema.org/draft-04/schema#";
    else ctx.target;
    if (ctx.external?.uri) {
        const id = ctx.external.registry.get(schema)?.id;
        if (!id) throw new Error("Schema is missing an `id` property");
        result.$id = ctx.external.uri(id);
    }
    // when the root was extracted into $defs, `root.schema` is the `$ref` wrapper and `root.def` is the body that now lives under $defs
    $d72a7c105b0f7633$var$assignProps(result, root.defId ? root.schema : root.def ?? root.schema);
    // The `id` in `.meta()` is a Zod-specific registration tag used to extract schemas into $defs — it is not user-facing JSON Schema metadata. Strip it from the output body where it would otherwise leak. The id is preserved implicitly via the $defs key (and via $ref paths).
    const rootMetaId = ctx.metadataRegistry.get(schema)?.id;
    if (rootMetaId !== undefined && result.id === rootMetaId) delete result.id;
    // build defs object. With `external`, `defs` is the shared object every schema writes into, so the same entries are reassigned on every call. Without it, `defs` is fresh per call and must be rebuilt.
    const defs = ctx.external?.defs ?? {};
    if (!ctx.external || ctx.sharedEmitDoneFor !== ctx.external) for (const entry of ctx.seen.entries()){
        const seen = entry[1];
        if (seen.def && seen.defId) {
            if (seen.def.id === seen.defId) delete seen.def.id;
            (0, $c0663.assignProp)(defs, seen.defId, seen.def);
        }
    }
    if (ctx.external) ctx.sharedEmitDoneFor = ctx.external;
    // set definitions in result
    if (ctx.external) ;
    else if (Object.keys(defs).length > 0) {
        if (ctx.target === "draft-2020-12") result.$defs = defs;
        else result.definitions = defs;
    }
    try {
        // this "finalizes" this schema and ensures all cycles are removed each call to finalize() is functionally independent though the seen map is shared
        const finalized = JSON.parse(JSON.stringify(result));
        Object.defineProperty(finalized, "~standard", {
            value: {
                ...schema["~standard"],
                jsonSchema: {
                    input: $d72a7c105b0f7633$export$b29c48d79372468a(schema, "input", ctx.processors),
                    output: $d72a7c105b0f7633$export$b29c48d79372468a(schema, "output", ctx.processors)
                }
            },
            enumerable: false,
            writable: false
        });
        return finalized;
    } catch (_err) {
        throw new Error("Error converting schema to JSON.");
    }
}
function $d72a7c105b0f7633$var$isTransforming(_schema, _ctx) {
    const ctx = _ctx ?? {
        seen: new Set()
    };
    if (ctx.seen.has(_schema)) return false;
    ctx.seen.add(_schema);
    const def = _schema._zod.def;
    if (def.type === "transform") return true;
    if (def.type === "array") return $d72a7c105b0f7633$var$isTransforming(def.element, ctx);
    if (def.type === "set") return $d72a7c105b0f7633$var$isTransforming(def.valueType, ctx);
    if (def.type === "lazy") return $d72a7c105b0f7633$var$isTransforming(def.getter(), ctx);
    if (def.type === "promise" || def.type === "optional" || def.type === "nonoptional" || def.type === "nullable" || def.type === "readonly" || def.type === "default" || def.type === "prefault" || def.type === "catch") return $d72a7c105b0f7633$var$isTransforming(def.innerType, ctx);
    if (def.type === "intersection") return $d72a7c105b0f7633$var$isTransforming(def.left, ctx) || $d72a7c105b0f7633$var$isTransforming(def.right, ctx);
    if (def.type === "record" || def.type === "map") return $d72a7c105b0f7633$var$isTransforming(def.keyType, ctx) || $d72a7c105b0f7633$var$isTransforming(def.valueType, ctx);
    if (def.type === "pipe") {
        if (_schema._zod.traits.has("$ZodCodec")) return true;
        return $d72a7c105b0f7633$var$isTransforming(def.in, ctx) || $d72a7c105b0f7633$var$isTransforming(def.out, ctx);
    }
    if (def.type === "object") {
        for(const key in def.shape){
            if ($d72a7c105b0f7633$var$isTransforming(def.shape[key], ctx)) return true;
        }
        return false;
    }
    if (def.type === "union") {
        for (const option of def.options){
            if ($d72a7c105b0f7633$var$isTransforming(option, ctx)) return true;
        }
        return false;
    }
    if (def.type === "tuple") {
        for (const item of def.items){
            if ($d72a7c105b0f7633$var$isTransforming(item, ctx)) return true;
        }
        if (def.rest && $d72a7c105b0f7633$var$isTransforming(def.rest, ctx)) return true;
        return false;
    }
    return false;
}
const $d72a7c105b0f7633$export$d24eb8c1ef5f4df1 = (schema, processors = {})=>(params)=>{
        const ctx = $d72a7c105b0f7633$export$881f7fb71351b304({
            ...params,
            processors: processors
        });
        $d72a7c105b0f7633$export$e54fe5b0f43758f7(schema, ctx);
        $d72a7c105b0f7633$export$ba2613251eadea93(ctx, schema);
        return $d72a7c105b0f7633$export$578723aef62d92f5(ctx, schema);
    };
const $d72a7c105b0f7633$export$b29c48d79372468a = (schema, io, processors = {})=>(params)=>{
        const { libraryOptions: libraryOptions, target: target } = params ?? {};
        const ctx = $d72a7c105b0f7633$export$881f7fb71351b304({
            ...libraryOptions ?? {},
            target: target,
            io: io,
            processors: processors
        });
        $d72a7c105b0f7633$export$e54fe5b0f43758f7(schema, ctx);
        $d72a7c105b0f7633$export$ba2613251eadea93(ctx, schema);
        return $d72a7c105b0f7633$export$578723aef62d92f5(ctx, schema);
    };

});


parcelRegister("dsEDN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ccd6a4cb0c80e16$export$2e2bcd8739ae039; });

var $c0663 = parcelRequire("c0663");
const $9ccd6a4cb0c80e16$var$error = ()=>{
    const Sizable = {
        string: {
            unit: "characters",
            verb: "to have"
        },
        file: {
            unit: "bytes",
            verb: "to have"
        },
        array: {
            unit: "items",
            verb: "to have"
        },
        set: {
            unit: "items",
            verb: "to have"
        },
        map: {
            unit: "entries",
            verb: "to have"
        }
    };
    function getSizing(origin) {
        return Sizable[origin] ?? null;
    }
    const FormatDictionary = {
        regex: "input",
        email: "email address",
        url: "URL",
        emoji: "emoji",
        uuid: "UUID",
        uuidv4: "UUIDv4",
        uuidv6: "UUIDv6",
        nanoid: "nanoid",
        guid: "GUID",
        cuid: "cuid",
        cuid2: "cuid2",
        ulid: "ULID",
        xid: "XID",
        ksuid: "KSUID",
        datetime: "ISO datetime",
        date: "ISO date",
        time: "ISO time",
        duration: "ISO duration",
        ipv4: "IPv4 address",
        ipv6: "IPv6 address",
        mac: "MAC address",
        cidrv4: "IPv4 range",
        cidrv6: "IPv6 range",
        base64: "base64-encoded string",
        base64url: "base64url-encoded string",
        json_string: "JSON string",
        e164: "E.164 number",
        credit_card: "credit card number",
        jwt: "JWT",
        template_literal: "input"
    };
    // type names: missing keys = do not translate (use raw value via ?? fallback)
    const TypeDictionary = {
        // Compatibility: "nan" -> "NaN" for display
        nan: "NaN"
    };
    function getTypeName(type, input) {
        if (type === "number" && typeof input === "number" && !Number.isFinite(input)) return String(input);
        return TypeDictionary[type] ?? type;
    }
    return (issue)=>{
        switch(issue.code){
            case "invalid_type":
                {
                    const expected = getTypeName(issue.expected);
                    const receivedType = $c0663.parsedType(issue.input);
                    const received = getTypeName(receivedType, issue.input);
                    return `Invalid input: expected ${expected}, received ${received}`;
                }
            case "invalid_value":
                if (issue.values.length === 1) return `Invalid input: expected ${$c0663.stringifyPrimitive(issue.values[0])}`;
                return `Invalid option: expected one of ${$c0663.joinValues(issue.values, "|")}`;
            case "too_big":
                {
                    const adj = issue.exact ? "exactly " : issue.inclusive ? "<=" : "<";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Too big: expected ${issue.origin ?? "value"} to have ${adj}${issue.maximum.toString()} ${sizing.unit ?? "elements"}`;
                    return `Too big: expected ${issue.origin ?? "value"} to be ${adj}${issue.maximum.toString()}`;
                }
            case "too_small":
                {
                    const adj = issue.exact ? "exactly " : issue.inclusive ? ">=" : ">";
                    const sizing = getSizing(issue.origin);
                    if (sizing) return `Too small: expected ${issue.origin} to have ${adj}${issue.minimum.toString()} ${sizing.unit}`;
                    return `Too small: expected ${issue.origin} to be ${adj}${issue.minimum.toString()}`;
                }
            case "invalid_format":
                {
                    const _issue = issue;
                    if (_issue.format === "starts_with") return `Invalid string: must start with "${_issue.prefix}"`;
                    if (_issue.format === "ends_with") return `Invalid string: must end with "${_issue.suffix}"`;
                    if (_issue.format === "includes") return `Invalid string: must include "${_issue.includes}"`;
                    if (_issue.format === "regex") return `Invalid string: must match pattern ${_issue.pattern}`;
                    return `Invalid ${FormatDictionary[_issue.format] ?? issue.format}`;
                }
            case "not_multiple_of":
                return `Invalid number: must be a multiple of ${issue.divisor}`;
            case "unrecognized_keys":
                return `Unrecognized key${issue.keys.length > 1 ? "s" : ""}: ${$c0663.joinValues(issue.keys, ", ")}`;
            case "invalid_key":
                return `Invalid key in ${issue.origin}`;
            case "invalid_union":
                if (issue.options && Array.isArray(issue.options) && issue.options.length > 0) {
                    const opts = issue.options.map((o)=>`'${o}'`).join(" | ");
                    return `Invalid discriminator value. Expected ${opts}`;
                }
                if (issue.inclusive === false) return "Invalid input: more than one option matched";
                return "Invalid input";
            case "invalid_element":
                return `Invalid value in ${issue.origin}`;
            default:
                return `Invalid input`;
        }
    };
};
function $9ccd6a4cb0c80e16$export$2e2bcd8739ae039() {
    return {
        localeError: $9ccd6a4cb0c80e16$var$error()
    };
}

});

parcelRegister("eeCax", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $a5cffb13a424db59$export$98e6a39c04603d36; });
$parcel$export(module.exports, "parseAsync", function () { return $a5cffb13a424db59$export$59b6f938fbf579e3; });
$parcel$export(module.exports, "safeParse", function () { return $a5cffb13a424db59$export$b48ee232557adc37; });
$parcel$export(module.exports, "safeParseAsync", function () { return $a5cffb13a424db59$export$9b07b0d6e0389261; });
$parcel$export(module.exports, "encode", function () { return $a5cffb13a424db59$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $a5cffb13a424db59$export$2f872c0f2117be69; });
$parcel$export(module.exports, "encodeAsync", function () { return $a5cffb13a424db59$export$1a62660bbffb8f11; });
$parcel$export(module.exports, "decodeAsync", function () { return $a5cffb13a424db59$export$e4c183687a6ff9b; });
$parcel$export(module.exports, "safeEncode", function () { return $a5cffb13a424db59$export$c094f85f253e4d7d; });
$parcel$export(module.exports, "safeDecode", function () { return $a5cffb13a424db59$export$7a47376c130cfeac; });
$parcel$export(module.exports, "safeEncodeAsync", function () { return $a5cffb13a424db59$export$ed163a34170fecc5; });
$parcel$export(module.exports, "safeDecodeAsync", function () { return $a5cffb13a424db59$export$9f879005292a9bc9; });

var $3sMCt = parcelRequire("3sMCt");

var $mg3lm = parcelRequire("mg3lm");
const $a5cffb13a424db59$export$98e6a39c04603d36 = /* @__PURE__ */ $3sMCt._parse((0, $mg3lm.ZodRealError));
const $a5cffb13a424db59$export$59b6f938fbf579e3 = /* @__PURE__ */ $3sMCt._parseAsync((0, $mg3lm.ZodRealError));
const $a5cffb13a424db59$export$b48ee232557adc37 = /* @__PURE__ */ $3sMCt._safeParse((0, $mg3lm.ZodRealError));
const $a5cffb13a424db59$export$9b07b0d6e0389261 = /* @__PURE__ */ $3sMCt._safeParseAsync((0, $mg3lm.ZodRealError));
const $a5cffb13a424db59$export$c564cdbbe6da493 = /* @__PURE__ */ $3sMCt._encode((0, $mg3lm.ZodRealError));
const $a5cffb13a424db59$export$2f872c0f2117be69 = /* @__PURE__ */ $3sMCt._decode((0, $mg3lm.ZodRealError));
const $a5cffb13a424db59$export$1a62660bbffb8f11 = /* @__PURE__ */ $3sMCt._encodeAsync((0, $mg3lm.ZodRealError));
const $a5cffb13a424db59$export$e4c183687a6ff9b = /* @__PURE__ */ $3sMCt._decodeAsync((0, $mg3lm.ZodRealError));
const $a5cffb13a424db59$export$c094f85f253e4d7d = /* @__PURE__ */ $3sMCt._safeEncode((0, $mg3lm.ZodRealError));
const $a5cffb13a424db59$export$7a47376c130cfeac = /* @__PURE__ */ $3sMCt._safeDecode((0, $mg3lm.ZodRealError));
const $a5cffb13a424db59$export$ed163a34170fecc5 = /* @__PURE__ */ $3sMCt._safeEncodeAsync((0, $mg3lm.ZodRealError));
const $a5cffb13a424db59$export$9f879005292a9bc9 = /* @__PURE__ */ $3sMCt._safeDecodeAsync((0, $mg3lm.ZodRealError));

});
parcelRegister("mg3lm", function(module, exports) {

$parcel$export(module.exports, "ZodRealError", function () { return $042e81f74dad9f0c$export$42f76a3b4eb5449a; });

var $59TZW = parcelRequire("59TZW");
var $1B5mT = parcelRequire("1B5mT");

var $c0663 = parcelRequire("c0663");
/* Prototypes that already carry the lazy helper methods. Seeded with the
 * intrinsics so that `init` on a foreign object — it accepts any object —
 * can never install an accessor onto a prototype we do not own. */ const $042e81f74dad9f0c$var$_installedErrorProtos = /* @__PURE__ */ new WeakSet([
    Object.prototype,
    Error.prototype
]);
/* Helper methods live as non-enumerable lazy getters on the shared
 * prototype instead of own properties on every instance. On first
 * access the getter allocates the per-instance closure and caches it
 * as a non-enumerable own property, so detached usage still works and
 * the allocation only happens for methods actually touched. */ function $042e81f74dad9f0c$var$_lazyMethod(proto, key, make) {
    Object.defineProperty(proto, key, {
        configurable: true,
        enumerable: false,
        get () {
            const value = make(this);
            Object.defineProperty(this, key, {
                value: value,
                configurable: true,
                writable: true
            });
            return value;
        },
        set (value) {
            Object.defineProperty(this, key, {
                value: value,
                configurable: true,
                writable: true
            });
        }
    });
}
const $042e81f74dad9f0c$var$initializer = (inst, issues)=>{
    (0, $1B5mT.$ZodError).init(inst, issues);
    inst.name = "ZodError";
    const proto = Object.getPrototypeOf(inst);
    if ($042e81f74dad9f0c$var$_installedErrorProtos.has(proto)) return;
    $042e81f74dad9f0c$var$_installedErrorProtos.add(proto);
    $042e81f74dad9f0c$var$_lazyMethod(proto, "format", (self)=>(mapper)=>$1B5mT.formatError(self, mapper));
    $042e81f74dad9f0c$var$_lazyMethod(proto, "flatten", (self)=>(mapper)=>$1B5mT.flattenError(self, mapper));
    $042e81f74dad9f0c$var$_lazyMethod(proto, "addIssue", (self)=>(issue)=>{
            self.issues.push(issue);
            self.message = JSON.stringify(self.issues, $c0663.jsonStringifyReplacer, 2);
        });
    $042e81f74dad9f0c$var$_lazyMethod(proto, "addIssues", (self)=>(issues)=>{
            self.issues.push(...issues);
            self.message = JSON.stringify(self.issues, $c0663.jsonStringifyReplacer, 2);
        });
    Object.defineProperty(proto, "isEmpty", {
        configurable: true,
        enumerable: false,
        get () {
            return this.issues.length === 0;
        }
    });
};
const $042e81f74dad9f0c$export$f98dac4b251ab333 = /*@__PURE__*/ $59TZW.$constructor("ZodError", $042e81f74dad9f0c$var$initializer);
const $042e81f74dad9f0c$export$42f76a3b4eb5449a = /*@__PURE__*/ $59TZW.$constructor("ZodError", $042e81f74dad9f0c$var$initializer, undefined, {
    Parent: Error
}); // /** @deprecated Use `z.core.$ZodErrorMapCtx` instead. */
 // export type ErrorMapCtx = core.$ZodErrorMapCtx;

});




parcelRegister("fsHI4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f70dd42bf920d1f0$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $1lSPe = parcelRequire("1lSPe");

var $jQ8Ot = parcelRequire("jQ8Ot");

var $bFToE = parcelRequire("bFToE");

var $jSvAS = parcelRequire("jSvAS");

var $eL5Bg = parcelRequire("eL5Bg");
function $f70dd42bf920d1f0$export$2e2bcd8739ae039({ uri: uri }) {
    const queryString = typeof window !== 'undefined' ? window.location.search : '';
    const searchParams = new URLSearchParams(queryString);
    const pageParam = searchParams.get('wp');
    const [selectedSlug, setSelectedSlug] = (0, $8FY87.useState)(pageParam);
    const handleSelectSlug = (slug)=>{
        setSelectedSlug(slug);
        if (typeof window !== 'undefined') {
            const params = new URLSearchParams(window.location.search);
            if (slug) params.set('wp', slug);
            else params.delete('wp');
            window.history.replaceState(null, '', `?${params.toString()}`);
        }
    };
    const [isPreviewMode, setPreviewMode] = (0, $8FY87.useState)(!(0, $1lSPe.locationIsKia)() || !!pageParam);
    const handleRefetch = ()=>{
        refetch();
    };
    const activeSlug = uri || selectedSlug || pageParam;
    const { data: data, isLoading: isLoading, isError: isError, error: error, refetch: refetch, isRefetching: isRefetching } = (0, $jQ8Ot.usePage)(activeSlug || '', isPreviewMode);
    if (!activeSlug && !(0, $1lSPe.locationIsKia)()) return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "mx-auto max-w-lg",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                className: "mb-4 text-xl font-bold",
                children: "V\xe4lj en sida"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eL5Bg.default), {
                onSelect: handleSelectSlug
            })
        ]
    });
    if (isLoading && !(0, $1lSPe.locationIsKia)()) return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: "p-4",
        children: "Loading..."
    });
    if (isError) {
        console.error(error);
        if ((0, $1lSPe.locationIsKia)() && isPreviewMode === false) setPreviewMode(true);
        return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: "p-8 text-red-600",
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                    className: "font-bold",
                    children: "Error Loading Page"
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                    children: error instanceof Error ? error.message : 'Unknown Error'
                }),
                !(0, $1lSPe.locationIsKia)() || !isPreviewMode && /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                            className: "text-black",
                            children: [
                                "Det kan vara s\xe5 att denna sidan inte \xe4r publicerad och att det \xe4r d\xe4rf\xf6r du inte kan se ",
                                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                    className: "font-bold",
                                    children: "Live"
                                }),
                                ' ',
                                "verisonen."
                            ]
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                            onClick: ()=>setPreviewMode(true),
                            className: "mt-4 bg-blue-500 text-white px-4 py-2 rounded",
                            children: "Preview"
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            Boolean(uri) || (!(0, $1lSPe.locationIsKia)() ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bFToE.default), {
                isPreviewMode: isPreviewMode,
                setPreviewMode: setPreviewMode,
                databaseId: data.kiaPage.databaseId ? data.kiaPage.databaseId : undefined,
                refetch: handleRefetch,
                isRefetching: isRefetching,
                uri: activeSlug,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eL5Bg.default), {
                    selected: selectedSlug,
                    onSelect: handleSelectSlug
                })
            }) : null),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jSvAS.default), {
                blocks: data?.kiaPage?.pagebuilder?.blocks
            })
        ]
    });
}

});
parcelRegister("jQ8Ot", function(module, exports) {

$parcel$export(module.exports, "usePage", function () { return $232b0cddbb988a80$export$178e57c9fecff4cc; });

var $hgSaH = parcelRequire("hgSaH");

var $hOfQh = parcelRequire("hOfQh");

var $12bBN = parcelRequire("12bBN");
const $232b0cddbb988a80$export$178e57c9fecff4cc = (uri, isPreview = false)=>{
    return (0, $hgSaH.useQuery)({
        queryKey: [
            'page',
            uri,
            isPreview ? 'graphql' : 'json'
        ],
        queryFn: async ()=>{
            if (isPreview) return (0, $hOfQh.executeGraphql)((0, $12bBN.GetPage), {
                uri: uri
            });
            else return (0, $hOfQh.execute)(uri);
        },
        enabled: !!uri,
        retry: 0,
        staleTime: isPreview ? 0 : 300000,
        refetchOnWindowFocus: isPreview
    });
};

});
parcelRegister("hOfQh", function(module, exports) {

$parcel$export(module.exports, "execute", function () { return $dba7d97e0408b0c2$export$51396ec711da548b; });
$parcel$export(module.exports, "executeModule", function () { return $dba7d97e0408b0c2$export$47e451e0d44bbb3b; });
$parcel$export(module.exports, "executeGraphql", function () { return $dba7d97e0408b0c2$export$c24d221fbbf75fb3; });
async function $dba7d97e0408b0c2$export$51396ec711da548b(uri) {
    const url = new URL(`${"https://kia-blog.live.afonso.se"}/wp-content/uploads/headless-cache/page-${uri}.json`);
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/graphql-response+json'
        }
    });
    if (!response.ok) throw new Error('Network response was not ok');
    const json = await response.json();
    if (json.errors) throw new Error(json.errors[0].message);
    return json.data;
}
async function $dba7d97e0408b0c2$export$47e451e0d44bbb3b(uri) {
    const url = new URL(`${"https://kia-blog.live.afonso.se"}/wp-content/uploads/headless-cache/module-${uri}.json`);
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/graphql-response+json'
        }
    });
    if (!response.ok) throw new Error('Network response was not ok');
    const json = await response.json();
    if (json.errors) throw new Error(json.errors[0].message);
    return json.data;
}
async function $dba7d97e0408b0c2$export$c24d221fbbf75fb3(query, variables, cache) {
    const url = `${"https://kia-blog.live.afonso.se"}/graphql`;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/graphql-response+json'
        },
        body: JSON.stringify({
            query: query.toString(),
            variables: variables
        }),
        cache: cache ? 'force-cache' : 'no-store'
    });
    if (!response.ok) throw new Error('Network response was not ok');
    const json = await response.json();
    if (json.errors) throw new Error(json.errors[0].message);
    return json.data;
}

});

parcelRegister("12bBN", function(module, exports) {

$parcel$export(module.exports, "GetPage", function () { return $f647e07d9bc9c445$export$83846b271ff2cde; });
$parcel$export(module.exports, "GetModule", function () { return $f647e07d9bc9c445$export$9f23554e9bd83426; });
parcelRequire("btB3p");
var $dd2YO = parcelRequire("dd2YO");
const $f647e07d9bc9c445$export$83846b271ff2cde = (0, $dd2YO.graphql)(`
  query GetPageBySlug($uri: ID!) {
    kiaPage(id: $uri, idType: URI) {
      databaseId
      pagebuilder {
        blocks {
          ...PageBuilderBlocks
        }
      }
    }
  }
`);
const $f647e07d9bc9c445$export$9f23554e9bd83426 = (0, $dd2YO.graphql)(`
  query GetModuleBySlug($uri: ID!) {
    kiaModule(id: $uri, idType: URI) {
      databaseId
      pagebuilder {
        blocks {
          ...ModuleBuilderBlocks
        }
      }
    }
  }
`);

});
parcelRegister("btB3p", function(module, exports) {
$parcel$export(module.exports, "graphql", function () { return (parcelRequire("dd2YO")).graphql; });
parcelRequire("X46Bs");
parcelRequire("dd2YO");

});
parcelRegister("X46Bs", function(module, exports) {
/* eslint-disable */ function $d186908689cfabcb$export$130bc0efb3cce789(_documentNode, fragmentType) {
    return fragmentType;
}
function $d186908689cfabcb$export$4659cb8f146075(data, _fragment) {
    return data;
}
function $d186908689cfabcb$export$dbf91005d32bdf6a(queryNode, fragmentNode, data) {
    const deferredFields = queryNode.__meta__?.deferredFields;
    const fragName = fragmentNode.__meta__?.fragmentName;
    if (!deferredFields || !fragName) return true;
    const fields = deferredFields[fragName] ?? [];
    return fields.length > 0 && fields.every((field)=>data && field in data);
}

});

parcelRegister("dd2YO", function(module, exports) {

$parcel$export(module.exports, "graphql", function () { return $7e29c5686a822ec3$export$1eb4e7c0ed67b035; });
/* eslint-disable */ 
var $79zs1 = parcelRequire("79zs1");
const $7e29c5686a822ec3$var$documents = {
    "\n  query GetPageBySlug($uri: ID!) {\n    kiaPage(id: $uri, idType: URI) {\n      databaseId\n      pagebuilder {\n        blocks {\n          ...PageBuilderBlocks\n        }\n      }\n    }\n  }\n": $79zs1.GetPageBySlugDocument,
    "\n  query GetModuleBySlug($uri: ID!) {\n    kiaModule(id: $uri, idType: URI) {\n      databaseId\n      pagebuilder {\n        blocks {\n          ...ModuleBuilderBlocks\n        }\n      }\n    }\n  }\n": $79zs1.GetModuleBySlugDocument,
    "\nfragment ModuleBuilderBlocks on KiaModule_Pagebuilder_Blocks {\n__typename\n... on KiaModule_Pagebuilder_Blocks_Hero {\n__typename\neditor\neditorPosition\ncontainerWidth\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nimageMobile {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nvideo {\nmediaItemUrl\nmimeType\n}\nvideoMobile {\nmediaItemUrl\nmimeType\n}\nvideoHasControls\n}\n... on KiaModule_Pagebuilder_Blocks_Texteditor {\n__typename\nblockId\ncontainerWidth\nbgColor\ncontent\nlinks {\nlink\nlinkInNewWindow\nlinkText\nlinkType\n}\n}\n... on KiaModule_Pagebuilder_Blocks_Image {\n__typename\nblockId\ncontainerWidth\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nimageMobile {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nvideo {\nmediaItemUrl\nmimeType\n}\nvideoMobile {\nmediaItemUrl\nmimeType\n}\nvideoHasControls\n}\n... on KiaModule_Pagebuilder_Blocks_TextMedia {\n__typename\nblockId\ncontainerWidth\nmediaType\nmediaPosition\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nimageMobile {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nvideo {\nmediaItemUrl\nmimeType\n}\nvideoMobile {\nmediaItemUrl\nmimeType\n}\nyoutube\nmediaIsCover\nvideoHasAutoplay\nvideoHasControls\nlink\nlinkText\nlinkInNewWindow\nlinkType\nlinkPosition\ncontentBg\ncontent\n}\n... on KiaModule_Pagebuilder_Blocks_Gallery {\n__typename\nblockId\ncontainerWidth\ngalleryItems {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_Checklist {\n__typename\nblockId\ncontainerWidth\niconPosition\nlist {\ntext\n}\nlinks {\nlink\nlinkInNewWindow\nlinkText\nlinkType\n}\n}\n... on KiaModule_Pagebuilder_Blocks_Story {\n__typename\nblockId\ncontainerWidth\npostsToDisplay\nheading\ncategory {\nposts {\nnodes {\nid\ndatabaseId\ncontent\ntitle\nslug\nfeaturedImage {\nnode {\naltText\nsourceUrl\nmediaDetails {\nheight\nwidth\n}\n}\n}\n}\n}\n}\nselectedPosts {\n... on Post {\nid\ndatabaseId\ncontent\ntitle\nslug\nfeaturedImage {\nnode {\naltText\nsourceUrl\nmediaDetails {\nheight\nwidth\n}\n}\n}\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_ContentList {\n__typename\nblockId\ncontainerWidth\nlayout\nsmallGap\nfirstItemReversed\nlist {\ncontent\ncontentBg\nlink\nlinkInNewWindow\nlinkText\nlinkType\nlinkPosition\nmediaIsCover\nvideo {\nmediaItemUrl\nmimeType\n}\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_Nav {\nfieldGroupName\nlinks {\nlinkId\nlinkText\n}\n}\n... on KiaModule_Pagebuilder_Blocks_WowForm {\nfieldGroupName\n__typename\nterms\nsuccessModalTitle\nsuccessModalDescription\nsteps {\n... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_Text {\n__typename\ndescription\ntitle\nfieldGroupName\ntextCtaUrl\ntextCtaLabel\n}\n... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_Form {\n__typename\ndescription\ntitle\nfieldGroupName\n}\n... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_TextRules {\n__typename\nctaLabel\nctaUrl\ndescription\nfieldGroupName\ntitle\nrulesItems {\ntext\nfieldGroupName\n}\nrulesTitle\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_ColoredHero {\nbackgroundColor\nblockId\ndescription\neyebrow\nheading\ntextColor\nfieldGroupName\n}\n\n... on KiaModule_Pagebuilder_Blocks_Table {\nblockId\ncontainerWidth\ncols {\ncolLabel\n}\nrows {\nrowLabel\nrowCells {\ncellContent\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_Tabs {\n__typename\nblockId\ncontainerWidth\ntitle\ntabs {\nlabel\ncolumns {\ncontent\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_Faqs {\n__typename\nblockId\ncontainerWidth\ntitle\nfaqs {\nlabel\ncontent\n}\n}\n... on KiaModule_Pagebuilder_Blocks_Iframe {\n__typename\nblockId\ncontainerWidth\ntitle\nurl\neditor\n}\n... on KiaModule_Pagebuilder_Blocks_Logotypes {\n__typename\nblockId\ncontainerWidth\ntitle\ngallery {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_CarCarouselGrid {\n__typename\nblockId\ndisplayDescriptions\ndisplayLeasing\ndisplayCta\ndisplayPrices\nimageType\nselectedCars {\nkiaTrims\n}\n}\n... on KiaModule_Pagebuilder_Blocks_CarCarousel {\n__typename\nblockId\ndisplayDescriptions\ndisplayLeasing\ndisplayCta\ndisplayPrices\nfunctions\nbusinessEdition\nimageType\n}\n... on KiaModule_Pagebuilder_Blocks_ColumnsBlock {\n__typename\nmargins\ncolumns {\nwidth\ncolAligment\ncontent {\n... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_TextBlock {\n__typename\neditor\n}\n... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ImageBlock {\n__typename\nfocalX\nfocalY\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ButtonBlock {\n__typename\nstyle\nalignment\nlink {\nurl\ntitle\ntarget\n}\n}\n... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_VideoBlock {\n__typename\nautoplay\nvideoFile {\nsourceUrl\nmimeType\n}\nposterImage {\nsourceUrl\naltText\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_SpacerBlock {\n__typename\nheight\n}\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_Newsletter {\n__typename\nbuttonText\ndescription\nemailPlaceholder\nfieldGroupName\nheadline\nsuccessMessage\ntermsText\ntheme\n}\n... on KiaModule_Pagebuilder_Blocks_FeatureBenefitBlockWithImage {\n__typename\nbackgroundColor\ncontent\ncolor\nheadline\ntopHeadline\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_LaddboxBlock {\n__typename\ntitle\ndescription\nladdboxOptions {\ntitle\ndescription\nprice\n}\n}\n... on KiaModule_Pagebuilder_Blocks_ImageTextButton {\n__typename\ncontent\nfieldGroupName\nsubtitle\ntitle\nbuttonLink {\ntarget\ntitle\nurl\n}\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n\n}\n\n": $79zs1.ModuleBuilderBlocksFragmentDoc,
    "\nfragment PageBuilderBlocks on KiaPage_Pagebuilder_Blocks {\n__typename\n... on KiaPage_Pagebuilder_Blocks_Hero {\n__typename\neditor\neditorPosition\ncontainerWidth\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nimageMobile {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nvideo {\nmediaItemUrl\nmimeType\n}\nvideoMobile {\nmediaItemUrl\nmimeType\n}\nvideoHasControls\n}\n... on KiaPage_Pagebuilder_Blocks_Texteditor {\n__typename\nblockId\ncontainerWidth\nbgColor\ncontent\nlinks {\nlink\nlinkInNewWindow\nlinkText\nlinkType\n}\n}\n... on KiaPage_Pagebuilder_Blocks_Image {\n__typename\nblockId\ncontainerWidth\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nimageMobile {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nvideo {\nmediaItemUrl\nmimeType\n}\nvideoMobile {\nmediaItemUrl\nmimeType\n}\nvideoHasControls\n}\n... on KiaPage_Pagebuilder_Blocks_TextMedia {\n__typename\nblockId\ncontainerWidth\nmediaType\nmediaPosition\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nimageMobile {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nvideo {\nmediaItemUrl\nmimeType\n}\nvideoMobile {\nmediaItemUrl\nmimeType\n}\nyoutube\nmediaIsCover\nvideoHasAutoplay\nvideoHasControls\nlink\nlinkText\nlinkInNewWindow\nlinkType\nlinkPosition\ncontentBg\ncontent\n}\n... on KiaPage_Pagebuilder_Blocks_Gallery {\n__typename\nblockId\ncontainerWidth\ngalleryItems {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n... on KiaPage_Pagebuilder_Blocks_Checklist {\n__typename\nblockId\ncontainerWidth\niconPosition\nlist {\ntext\n}\nlinks {\nlink\nlinkInNewWindow\nlinkText\nlinkType\n}\n}\n... on KiaPage_Pagebuilder_Blocks_Story {\n__typename\nblockId\ncontainerWidth\npostsToDisplay\nheading\ncategory {\nposts {\nnodes {\nid\ndatabaseId\ncontent\ntitle\nslug\nfeaturedImage {\nnode {\naltText\nsourceUrl\nmediaDetails {\nheight\nwidth\n}\n}\n}\n}\n}\n}\nselectedPosts {\n... on Post {\nid\ndatabaseId\ncontent\ntitle\nslug\nfeaturedImage {\nnode {\naltText\nsourceUrl\nmediaDetails {\nheight\nwidth\n}\n}\n}\n}\n}\n}\n... on KiaPage_Pagebuilder_Blocks_ContentList {\n__typename\nblockId\ncontainerWidth\nlayout\nsmallGap\nfirstItemReversed\nlist {\ncontent\ncontentBg\nlink\nlinkInNewWindow\nlinkText\nlinkType\nlinkPosition\nmediaIsCover\nvideo {\nmediaItemUrl\nmimeType\n}\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n}\n... on KiaPage_Pagebuilder_Blocks_Nav {\nfieldGroupName\nlinks {\nlinkId\nlinkText\n}\n}\n... on KiaPage_Pagebuilder_Blocks_WowForm {\nfieldGroupName\n__typename\nterms\nsuccessModalTitle\nsuccessModalDescription\nsteps {\n... on KiaPage_Pagebuilder_Blocks_WowForm_Steps_Text {\n__typename\ndescription\ntitle\nfieldGroupName\ntextCtaUrl\ntextCtaLabel\n}\n... on KiaPage_Pagebuilder_Blocks_WowForm_Steps_Form {\n__typename\ndescription\ntitle\nfieldGroupName\n}\n... on KiaPage_Pagebuilder_Blocks_WowForm_Steps_TextRules {\n__typename\nctaLabel\nctaUrl\ndescription\nfieldGroupName\ntitle\nrulesItems {\ntext\nfieldGroupName\n}\nrulesTitle\n}\n}\n}\n... on KiaPage_Pagebuilder_Blocks_ColoredHero {\nbackgroundColor\nblockId\ndescription\neyebrow\nheading\ntextColor\nfieldGroupName\n}\n\n... on KiaPage_Pagebuilder_Blocks_Table {\nblockId\ncontainerWidth\ncols {\ncolLabel\n}\nrows {\nrowLabel\nrowCells {\ncellContent\n}\n}\n}\n... on KiaPage_Pagebuilder_Blocks_Tabs {\n__typename\nblockId\ncontainerWidth\ntitle\ntabs {\nlabel\ncolumns {\ncontent\n}\n}\n}\n... on KiaPage_Pagebuilder_Blocks_Faqs {\n__typename\nblockId\ncontainerWidth\ntitle\nfaqs {\nlabel\ncontent\n}\n}\n... on KiaPage_Pagebuilder_Blocks_Iframe {\n__typename\nblockId\ncontainerWidth\ntitle\nurl\neditor\n}\n... on KiaPage_Pagebuilder_Blocks_Logotypes {\n__typename\nblockId\ncontainerWidth\ntitle\ngallery {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n... on KiaPage_Pagebuilder_Blocks_CarCarouselGrid {\n__typename\nblockId\ndisplayDescriptions\ndisplayLeasing\ndisplayCta\ndisplayPrices\nimageType\nselectedCars {\nkiaTrims\n}\n}\n... on KiaPage_Pagebuilder_Blocks_CarCarousel {\n__typename\nblockId\ndisplayDescriptions\ndisplayLeasing\ndisplayCta\ndisplayPrices\nfunctions\nbusinessEdition\nimageType\n}\n... on KiaPage_Pagebuilder_Blocks_ColumnsBlock {\n__typename\nmargins\ncolumns {\nwidth\ncolAligment\ncontent {\n... on KiaPage_Pagebuilder_Blocks_ColumnsBlock_columns_Content_TextBlock {\n__typename\neditor\n}\n... on KiaPage_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ImageBlock {\n__typename\nfocalX\nfocalY\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n... on KiaPage_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ButtonBlock {\n__typename\nstyle\nalignment\nlink {\nurl\ntitle\ntarget\n}\n}\n... on KiaPage_Pagebuilder_Blocks_ColumnsBlock_columns_Content_VideoBlock {\n__typename\nautoplay\nvideoFile {\nsourceUrl\nmimeType\n}\nposterImage {\nsourceUrl\naltText\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n... on KiaPage_Pagebuilder_Blocks_ColumnsBlock_columns_Content_SpacerBlock {\n__typename\nheight\n}\n}\n}\n}\n... on KiaPage_Pagebuilder_Blocks_Newsletter {\n__typename\nbuttonText\ndescription\nemailPlaceholder\nfieldGroupName\nheadline\nsuccessMessage\ntermsText\ntheme\n}\n... on KiaPage_Pagebuilder_Blocks_FeatureBenefitBlockWithImage {\n__typename\nbackgroundColor\ncontent\ncolor\nheadline\ntopHeadline\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n... on KiaPage_Pagebuilder_Blocks_LaddboxBlock {\n__typename\ntitle\ndescription\nladdboxOptions {\ntitle\ndescription\nprice\n}\n}\n... on KiaPage_Pagebuilder_Blocks_ImageTextButton {\n__typename\ncontent\nfieldGroupName\nsubtitle\ntitle\nbuttonLink {\ntarget\ntitle\nurl\n}\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n... on KiaPage_Pagebuilder_Blocks_LayoutKiaModules {\n__typename\nglobalModule {\n... on KiaModule {\npagebuilder {\nblocks {\n...ModuleBuilderBlocks\n}\n}\n}\n}\n}\n}\nfragment ModuleBuilderBlocks on KiaModule_Pagebuilder_Blocks {\n__typename\n... on KiaModule_Pagebuilder_Blocks_Hero {\n__typename\neditor\neditorPosition\ncontainerWidth\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nimageMobile {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nvideo {\nmediaItemUrl\nmimeType\n}\nvideoMobile {\nmediaItemUrl\nmimeType\n}\nvideoHasControls\n}\n... on KiaModule_Pagebuilder_Blocks_Texteditor {\n__typename\nblockId\ncontainerWidth\nbgColor\ncontent\nlinks {\nlink\nlinkInNewWindow\nlinkText\nlinkType\n}\n}\n... on KiaModule_Pagebuilder_Blocks_Image {\n__typename\nblockId\ncontainerWidth\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nimageMobile {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nvideo {\nmediaItemUrl\nmimeType\n}\nvideoMobile {\nmediaItemUrl\nmimeType\n}\nvideoHasControls\n}\n... on KiaModule_Pagebuilder_Blocks_TextMedia {\n__typename\nblockId\ncontainerWidth\nmediaType\nmediaPosition\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nimageMobile {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\nvideo {\nmediaItemUrl\nmimeType\n}\nvideoMobile {\nmediaItemUrl\nmimeType\n}\nyoutube\nmediaIsCover\nvideoHasAutoplay\nvideoHasControls\nlink\nlinkText\nlinkInNewWindow\nlinkType\nlinkPosition\ncontentBg\ncontent\n}\n... on KiaModule_Pagebuilder_Blocks_Gallery {\n__typename\nblockId\ncontainerWidth\ngalleryItems {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_Checklist {\n__typename\nblockId\ncontainerWidth\niconPosition\nlist {\ntext\n}\nlinks {\nlink\nlinkInNewWindow\nlinkText\nlinkType\n}\n}\n... on KiaModule_Pagebuilder_Blocks_Story {\n__typename\nblockId\ncontainerWidth\npostsToDisplay\nheading\ncategory {\nposts {\nnodes {\nid\ndatabaseId\ncontent\ntitle\nslug\nfeaturedImage {\nnode {\naltText\nsourceUrl\nmediaDetails {\nheight\nwidth\n}\n}\n}\n}\n}\n}\nselectedPosts {\n... on Post {\nid\ndatabaseId\ncontent\ntitle\nslug\nfeaturedImage {\nnode {\naltText\nsourceUrl\nmediaDetails {\nheight\nwidth\n}\n}\n}\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_ContentList {\n__typename\nblockId\ncontainerWidth\nlayout\nsmallGap\nfirstItemReversed\nlist {\ncontent\ncontentBg\nlink\nlinkInNewWindow\nlinkText\nlinkType\nlinkPosition\nmediaIsCover\nvideo {\nmediaItemUrl\nmimeType\n}\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_Nav {\nfieldGroupName\nlinks {\nlinkId\nlinkText\n}\n}\n... on KiaModule_Pagebuilder_Blocks_WowForm {\nfieldGroupName\n__typename\nterms\nsuccessModalTitle\nsuccessModalDescription\nsteps {\n... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_Text {\n__typename\ndescription\ntitle\nfieldGroupName\ntextCtaUrl\ntextCtaLabel\n}\n... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_Form {\n__typename\ndescription\ntitle\nfieldGroupName\n}\n... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_TextRules {\n__typename\nctaLabel\nctaUrl\ndescription\nfieldGroupName\ntitle\nrulesItems {\ntext\nfieldGroupName\n}\nrulesTitle\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_ColoredHero {\nbackgroundColor\nblockId\ndescription\neyebrow\nheading\ntextColor\nfieldGroupName\n}\n\n... on KiaModule_Pagebuilder_Blocks_Table {\nblockId\ncontainerWidth\ncols {\ncolLabel\n}\nrows {\nrowLabel\nrowCells {\ncellContent\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_Tabs {\n__typename\nblockId\ncontainerWidth\ntitle\ntabs {\nlabel\ncolumns {\ncontent\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_Faqs {\n__typename\nblockId\ncontainerWidth\ntitle\nfaqs {\nlabel\ncontent\n}\n}\n... on KiaModule_Pagebuilder_Blocks_Iframe {\n__typename\nblockId\ncontainerWidth\ntitle\nurl\neditor\n}\n... on KiaModule_Pagebuilder_Blocks_Logotypes {\n__typename\nblockId\ncontainerWidth\ntitle\ngallery {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_CarCarouselGrid {\n__typename\nblockId\ndisplayDescriptions\ndisplayLeasing\ndisplayCta\ndisplayPrices\nimageType\nselectedCars {\nkiaTrims\n}\n}\n... on KiaModule_Pagebuilder_Blocks_CarCarousel {\n__typename\nblockId\ndisplayDescriptions\ndisplayLeasing\ndisplayCta\ndisplayPrices\nfunctions\nbusinessEdition\nimageType\n}\n... on KiaModule_Pagebuilder_Blocks_ColumnsBlock {\n__typename\nmargins\ncolumns {\nwidth\ncolAligment\ncontent {\n... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_TextBlock {\n__typename\neditor\n}\n... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ImageBlock {\n__typename\nfocalX\nfocalY\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ButtonBlock {\n__typename\nstyle\nalignment\nlink {\nurl\ntitle\ntarget\n}\n}\n... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_VideoBlock {\n__typename\nautoplay\nvideoFile {\nsourceUrl\nmimeType\n}\nposterImage {\nsourceUrl\naltText\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_SpacerBlock {\n__typename\nheight\n}\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_Newsletter {\n__typename\nbuttonText\ndescription\nemailPlaceholder\nfieldGroupName\nheadline\nsuccessMessage\ntermsText\ntheme\n}\n... on KiaModule_Pagebuilder_Blocks_FeatureBenefitBlockWithImage {\n__typename\nbackgroundColor\ncontent\ncolor\nheadline\ntopHeadline\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n... on KiaModule_Pagebuilder_Blocks_LaddboxBlock {\n__typename\ntitle\ndescription\nladdboxOptions {\ntitle\ndescription\nprice\n}\n}\n... on KiaModule_Pagebuilder_Blocks_ImageTextButton {\n__typename\ncontent\nfieldGroupName\nsubtitle\ntitle\nbuttonLink {\ntarget\ntitle\nurl\n}\nimage {\naltText\nsourceUrl\nsrcSet\nsizes\nmediaDetails {\nheight\nwidth\n}\n}\n}\n\n}\n": $79zs1.PageBuilderBlocksFragmentDoc,
    "\n  query GetLatestPosts($first: Int = 3) {\n    posts(first: $first) {\n      nodes {\n        id\n        databaseId\n        content\n        title\n        link\n        slug\n        featuredImage {\n          node {\n            altText\n            sourceUrl\n            mediaDetails {\n              height\n              width\n            }\n          }\n        }\n      }\n    }\n  }\n": $79zs1.GetLatestPostsDocument,
    "\n  query GetSlugs {\n    kiaPages(first: 100) {\n      nodes {\n        slug\n        uri\n      }\n    }\n  }\n": $79zs1.GetSlugsDocument,
    "\n  query GetModuleSlugs {\n    kiaModules(first: 100) {\n      nodes {\n        slug\n        uri\n      }\n    }\n  }\n": $79zs1.GetModuleSlugsDocument
};
function $7e29c5686a822ec3$export$1eb4e7c0ed67b035(source) {
    return $7e29c5686a822ec3$var$documents[source] ?? {};
}

});
parcelRegister("79zs1", function(module, exports) {

$parcel$export(module.exports, "ModuleBuilderBlocksFragmentDoc", function () { return $013fa4b548d7755f$export$2d93aa833885982c; });
$parcel$export(module.exports, "PageBuilderBlocksFragmentDoc", function () { return $013fa4b548d7755f$export$afa0301581912d8d; });
$parcel$export(module.exports, "GetPageBySlugDocument", function () { return $013fa4b548d7755f$export$a22063866414d174; });
$parcel$export(module.exports, "GetModuleBySlugDocument", function () { return $013fa4b548d7755f$export$e19cfb113eb09290; });
$parcel$export(module.exports, "GetLatestPostsDocument", function () { return $013fa4b548d7755f$export$d805aec1ce86d7d1; });
$parcel$export(module.exports, "GetSlugsDocument", function () { return $013fa4b548d7755f$export$f91d6ecc2975f3bc; });
$parcel$export(module.exports, "GetModuleSlugsDocument", function () { return $013fa4b548d7755f$export$c665217981744c50; });
/* eslint-disable */ var $013fa4b548d7755f$export$11e20b9046f84405 = /*#__PURE__*/ function(AuthorIdType) {
    /** The Database ID for the node */ AuthorIdType["DatabaseId"] = "DATABASE_ID";
    /** The hashed Global ID */ AuthorIdType["Id"] = "ID";
    /** The name of the node */ AuthorIdType["Name"] = "NAME";
    /** Url friendly name of the node */ AuthorIdType["Slug"] = "SLUG";
    /** The URI for the node */ AuthorIdType["Uri"] = "URI";
    return AuthorIdType;
}({});
var $013fa4b548d7755f$export$43fc15991fc9d8e4 = /*#__PURE__*/ function(AvatarRatingEnum) {
    /** Indicates a G level avatar rating level. */ AvatarRatingEnum["G"] = "G";
    /** Indicates a PG level avatar rating level. */ AvatarRatingEnum["Pg"] = "PG";
    /** Indicates an R level avatar rating level. */ AvatarRatingEnum["R"] = "R";
    /** Indicates an X level avatar rating level. */ AvatarRatingEnum["X"] = "X";
    return AvatarRatingEnum;
}({});
var $013fa4b548d7755f$export$ca51763e3033af21 = /*#__PURE__*/ function(CategoryIdType) {
    /** The Database ID for the node */ CategoryIdType["DatabaseId"] = "DATABASE_ID";
    /** The hashed Global ID */ CategoryIdType["Id"] = "ID";
    /** The name of the node */ CategoryIdType["Name"] = "NAME";
    /** Url friendly name of the node */ CategoryIdType["Slug"] = "SLUG";
    /** The URI for the node */ CategoryIdType["Uri"] = "URI";
    return CategoryIdType;
}({});
var $013fa4b548d7755f$export$494c3554999c3a9e = /*#__PURE__*/ function(CommentNodeIdTypeEnum) {
    /** Identify a resource by the Database ID. */ CommentNodeIdTypeEnum["DatabaseId"] = "DATABASE_ID";
    /** Identify a resource by the (hashed) Global ID. */ CommentNodeIdTypeEnum["Id"] = "ID";
    return CommentNodeIdTypeEnum;
}({});
var $013fa4b548d7755f$export$79f56d1f512eb984 = /*#__PURE__*/ function(CommentStatusEnum) {
    /** Comments with the Godkänd status */ CommentStatusEnum["Approve"] = "APPROVE";
    /** Comments with the Ej godkänd status */ CommentStatusEnum["Hold"] = "HOLD";
    /** Comments with the Skräppost status */ CommentStatusEnum["Spam"] = "SPAM";
    /** Comments with the Papperskorg status */ CommentStatusEnum["Trash"] = "TRASH";
    return CommentStatusEnum;
}({});
var $013fa4b548d7755f$export$674f9b4b8b67b8e6 = /*#__PURE__*/ function(CommentsConnectionOrderbyEnum) {
    /** Order by browser user agent of the commenter. */ CommentsConnectionOrderbyEnum["CommentAgent"] = "COMMENT_AGENT";
    /** Order by approval status of the comment. */ CommentsConnectionOrderbyEnum["CommentApproved"] = "COMMENT_APPROVED";
    /** Order by name of the comment author. */ CommentsConnectionOrderbyEnum["CommentAuthor"] = "COMMENT_AUTHOR";
    /** Order by e-mail of the comment author. */ CommentsConnectionOrderbyEnum["CommentAuthorEmail"] = "COMMENT_AUTHOR_EMAIL";
    /** Order by IP address of the comment author. */ CommentsConnectionOrderbyEnum["CommentAuthorIp"] = "COMMENT_AUTHOR_IP";
    /** Order by URL address of the comment author. */ CommentsConnectionOrderbyEnum["CommentAuthorUrl"] = "COMMENT_AUTHOR_URL";
    /** Order by the comment contents. */ CommentsConnectionOrderbyEnum["CommentContent"] = "COMMENT_CONTENT";
    /** Order by date/time timestamp of the comment. */ CommentsConnectionOrderbyEnum["CommentDate"] = "COMMENT_DATE";
    /** Order by GMT timezone date/time timestamp of the comment. */ CommentsConnectionOrderbyEnum["CommentDateGmt"] = "COMMENT_DATE_GMT";
    /** Order by the globally unique identifier for the comment object */ CommentsConnectionOrderbyEnum["CommentId"] = "COMMENT_ID";
    /** Order by the array list of comment IDs listed in the where clause. */ CommentsConnectionOrderbyEnum["CommentIn"] = "COMMENT_IN";
    /** Order by the comment karma score. */ CommentsConnectionOrderbyEnum["CommentKarma"] = "COMMENT_KARMA";
    /** Order by the comment parent ID. */ CommentsConnectionOrderbyEnum["CommentParent"] = "COMMENT_PARENT";
    /** Order by the post object ID. */ CommentsConnectionOrderbyEnum["CommentPostId"] = "COMMENT_POST_ID";
    /** Order by the the type of comment, such as 'comment', 'pingback', or 'trackback'. */ CommentsConnectionOrderbyEnum["CommentType"] = "COMMENT_TYPE";
    /** Order by the user ID. */ CommentsConnectionOrderbyEnum["UserId"] = "USER_ID";
    return CommentsConnectionOrderbyEnum;
}({});
var $013fa4b548d7755f$export$4d3c38621aedc1e0 = /*#__PURE__*/ function(ContentNodeIdTypeEnum) {
    /** Identify a resource by the Database ID. */ ContentNodeIdTypeEnum["DatabaseId"] = "DATABASE_ID";
    /** Identify a resource by the (hashed) Global ID. */ ContentNodeIdTypeEnum["Id"] = "ID";
    /** Identify a resource by the URI. */ ContentNodeIdTypeEnum["Uri"] = "URI";
    return ContentNodeIdTypeEnum;
}({});
var $013fa4b548d7755f$export$77bee5010ddc58c2 = /*#__PURE__*/ function(ContentTypeEnum) {
    /** The Type of Content object */ ContentTypeEnum["Attachment"] = "ATTACHMENT";
    /** The Type of Content object */ ContentTypeEnum["Faqs"] = "FAQS";
    /** The Type of Content object */ ContentTypeEnum["Globalblocks"] = "GLOBALBLOCKS";
    /** The Type of Content object */ ContentTypeEnum["GraphqlDocument"] = "GRAPHQL_DOCUMENT";
    /** The Type of Content object */ ContentTypeEnum["Kiamodules"] = "KIAMODULES";
    /** The Type of Content object */ ContentTypeEnum["Kiapages"] = "KIAPAGES";
    /** The Type of Content object */ ContentTypeEnum["Leads"] = "LEADS";
    /** The Type of Content object */ ContentTypeEnum["Page"] = "PAGE";
    /** The Type of Content object */ ContentTypeEnum["Post"] = "POST";
    return ContentTypeEnum;
}({});
var $013fa4b548d7755f$export$8178ffc9b146ca2d = /*#__PURE__*/ function(ContentTypeIdTypeEnum) {
    /** The globally unique ID */ ContentTypeIdTypeEnum["Id"] = "ID";
    /** The name of the content type. */ ContentTypeIdTypeEnum["Name"] = "NAME";
    return ContentTypeIdTypeEnum;
}({});
var $013fa4b548d7755f$export$2ce9c0d05bb6a461 = /*#__PURE__*/ function(ContentTypesOfAuthorEnum) {
    /** The Type of Content object */ ContentTypesOfAuthorEnum["Post"] = "POST";
    return ContentTypesOfAuthorEnum;
}({});
var $013fa4b548d7755f$export$a49a34181eaf7205 = /*#__PURE__*/ function(ContentTypesOfCategoryEnum) {
    /** The Type of Content object */ ContentTypesOfCategoryEnum["Post"] = "POST";
    return ContentTypesOfCategoryEnum;
}({});
var $013fa4b548d7755f$export$1d34c019b8e9e101 = /*#__PURE__*/ function(ContentTypesOfFaqsCategoryEnum) {
    /** The Type of Content object */ ContentTypesOfFaqsCategoryEnum["Faqs"] = "FAQS";
    return ContentTypesOfFaqsCategoryEnum;
}({});
var $013fa4b548d7755f$export$8e856917101f9f58 = /*#__PURE__*/ function(ContentTypesOfGraphqlDocumentGroupEnum) {
    /** The Type of Content object */ ContentTypesOfGraphqlDocumentGroupEnum["GraphqlDocument"] = "GRAPHQL_DOCUMENT";
    return ContentTypesOfGraphqlDocumentGroupEnum;
}({});
var $013fa4b548d7755f$export$f992a202a4be4a27 = /*#__PURE__*/ function(ContentTypesOfPostFormatEnum) {
    /** The Type of Content object */ ContentTypesOfPostFormatEnum["Post"] = "POST";
    return ContentTypesOfPostFormatEnum;
}({});
var $013fa4b548d7755f$export$4411cdab0308110b = /*#__PURE__*/ function(ContentTypesOfTagEnum) {
    /** The Type of Content object */ ContentTypesOfTagEnum["Post"] = "POST";
    return ContentTypesOfTagEnum;
}({});
var $013fa4b548d7755f$export$c99f2dea4eeb25ee = /*#__PURE__*/ function(FaqIdType) {
    /** Identify a resource by the Database ID. */ FaqIdType["DatabaseId"] = "DATABASE_ID";
    /** Identify a resource by the (hashed) Global ID. */ FaqIdType["Id"] = "ID";
    /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */ FaqIdType["Slug"] = "SLUG";
    /** Identify a resource by the URI. */ FaqIdType["Uri"] = "URI";
    return FaqIdType;
}({});
var $013fa4b548d7755f$export$ba0d99e4f535d616 = /*#__PURE__*/ function(FaqsCategoryIdType) {
    /** The Database ID for the node */ FaqsCategoryIdType["DatabaseId"] = "DATABASE_ID";
    /** The hashed Global ID */ FaqsCategoryIdType["Id"] = "ID";
    /** The name of the node */ FaqsCategoryIdType["Name"] = "NAME";
    /** Url friendly name of the node */ FaqsCategoryIdType["Slug"] = "SLUG";
    /** The URI for the node */ FaqsCategoryIdType["Uri"] = "URI";
    return FaqsCategoryIdType;
}({});
var $013fa4b548d7755f$export$16ad8d9c07c713b9 = /*#__PURE__*/ function(GlobalBlockIdType) {
    /** Identify a resource by the Database ID. */ GlobalBlockIdType["DatabaseId"] = "DATABASE_ID";
    /** Identify a resource by the (hashed) Global ID. */ GlobalBlockIdType["Id"] = "ID";
    /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */ GlobalBlockIdType["Slug"] = "SLUG";
    /** Identify a resource by the URI. */ GlobalBlockIdType["Uri"] = "URI";
    return GlobalBlockIdType;
}({});
var $013fa4b548d7755f$export$7379f557b6997d68 = /*#__PURE__*/ function(GraphqlDocumentGroupIdType) {
    /** The Database ID for the node */ GraphqlDocumentGroupIdType["DatabaseId"] = "DATABASE_ID";
    /** The hashed Global ID */ GraphqlDocumentGroupIdType["Id"] = "ID";
    /** The name of the node */ GraphqlDocumentGroupIdType["Name"] = "NAME";
    /** Url friendly name of the node */ GraphqlDocumentGroupIdType["Slug"] = "SLUG";
    /** The URI for the node */ GraphqlDocumentGroupIdType["Uri"] = "URI";
    return GraphqlDocumentGroupIdType;
}({});
var $013fa4b548d7755f$export$18a0b3e71e2fc64f = /*#__PURE__*/ function(GraphqlDocumentIdType) {
    /** Identify a resource by the Database ID. */ GraphqlDocumentIdType["DatabaseId"] = "DATABASE_ID";
    /** Identify a resource by the (hashed) Global ID. */ GraphqlDocumentIdType["Id"] = "ID";
    /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */ GraphqlDocumentIdType["Slug"] = "SLUG";
    /** Identify a resource by the URI. */ GraphqlDocumentIdType["Uri"] = "URI";
    return GraphqlDocumentIdType;
}({});
var $013fa4b548d7755f$export$e5293a5b4befc6c9 = /*#__PURE__*/ function(KiaModuleIdType) {
    /** Identify a resource by the Database ID. */ KiaModuleIdType["DatabaseId"] = "DATABASE_ID";
    /** Identify a resource by the (hashed) Global ID. */ KiaModuleIdType["Id"] = "ID";
    /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */ KiaModuleIdType["Slug"] = "SLUG";
    /** Identify a resource by the URI. */ KiaModuleIdType["Uri"] = "URI";
    return KiaModuleIdType;
}({});
var $013fa4b548d7755f$export$7cc6e53642379cbe = /*#__PURE__*/ function(KiaPageIdType) {
    /** Identify a resource by the Database ID. */ KiaPageIdType["DatabaseId"] = "DATABASE_ID";
    /** Identify a resource by the (hashed) Global ID. */ KiaPageIdType["Id"] = "ID";
    /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */ KiaPageIdType["Slug"] = "SLUG";
    /** Identify a resource by the URI. */ KiaPageIdType["Uri"] = "URI";
    return KiaPageIdType;
}({});
var $013fa4b548d7755f$export$54bd817dd470c315 = /*#__PURE__*/ function(LanguageCodeEnum) {
    LanguageCodeEnum["Sv"] = "SV";
    return LanguageCodeEnum;
}({});
var $013fa4b548d7755f$export$6a1f612fa4a8983e = /*#__PURE__*/ function(LanguageCodeFilterEnum) {
    LanguageCodeFilterEnum["All"] = "ALL";
    LanguageCodeFilterEnum["Default"] = "DEFAULT";
    LanguageCodeFilterEnum["Sv"] = "SV";
    return LanguageCodeFilterEnum;
}({});
var $013fa4b548d7755f$export$1cefc41c5f77e958 = /*#__PURE__*/ function(LeadIdType) {
    /** Identify a resource by the Database ID. */ LeadIdType["DatabaseId"] = "DATABASE_ID";
    /** Identify a resource by the (hashed) Global ID. */ LeadIdType["Id"] = "ID";
    /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */ LeadIdType["Slug"] = "SLUG";
    /** Identify a resource by the URI. */ LeadIdType["Uri"] = "URI";
    return LeadIdType;
}({});
var $013fa4b548d7755f$export$e69b245684e17e8a = /*#__PURE__*/ function(MediaItemIdType) {
    /** Identify a resource by the Database ID. */ MediaItemIdType["DatabaseId"] = "DATABASE_ID";
    /** Identify a resource by the (hashed) Global ID. */ MediaItemIdType["Id"] = "ID";
    /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */ MediaItemIdType["Slug"] = "SLUG";
    /** Identify a media item by its source url */ MediaItemIdType["SourceUrl"] = "SOURCE_URL";
    /** Identify a resource by the URI. */ MediaItemIdType["Uri"] = "URI";
    return MediaItemIdType;
}({});
var $013fa4b548d7755f$export$d69560792a047e8c = /*#__PURE__*/ function(MediaItemSizeEnum) {
    /** MediaItem with the large size */ MediaItemSizeEnum["Large"] = "LARGE";
    /** MediaItem with the medium size */ MediaItemSizeEnum["Medium"] = "MEDIUM";
    /** MediaItem with the medium_large size */ MediaItemSizeEnum["MediumLarge"] = "MEDIUM_LARGE";
    /** MediaItem with the thumbnail size */ MediaItemSizeEnum["Thumbnail"] = "THUMBNAIL";
    /** MediaItem with the 1536x1536 size */ MediaItemSizeEnum["1536X1536"] = "_1536X1536";
    /** MediaItem with the 2048x2048 size */ MediaItemSizeEnum["2048X2048"] = "_2048X2048";
    return MediaItemSizeEnum;
}({});
var $013fa4b548d7755f$export$b40ce973890c1db2 = /*#__PURE__*/ function(MediaItemStatusEnum) {
    /** Objects with the auto-draft status */ MediaItemStatusEnum["AutoDraft"] = "AUTO_DRAFT";
    /** Objects with the inherit status */ MediaItemStatusEnum["Inherit"] = "INHERIT";
    /** Objects with the private status */ MediaItemStatusEnum["Private"] = "PRIVATE";
    /** Objects with the trash status */ MediaItemStatusEnum["Trash"] = "TRASH";
    return MediaItemStatusEnum;
}({});
var $013fa4b548d7755f$export$814bbc556afec378 = /*#__PURE__*/ function(MenuItemNodeIdTypeEnum) {
    /** Identify a resource by the Database ID. */ MenuItemNodeIdTypeEnum["DatabaseId"] = "DATABASE_ID";
    /** Identify a resource by the (hashed) Global ID. */ MenuItemNodeIdTypeEnum["Id"] = "ID";
    return MenuItemNodeIdTypeEnum;
}({});
var $013fa4b548d7755f$export$d74d93c16fc88649 = /*#__PURE__*/ function(MenuLocationEnum) {
    /** Put the menu in the footer location */ MenuLocationEnum["Footer"] = "FOOTER";
    /** Put the menu in the main location */ MenuLocationEnum["Main"] = "MAIN";
    /** Put the menu in the mainRight location */ MenuLocationEnum["Mainright"] = "MAINRIGHT";
    return MenuLocationEnum;
}({});
var $013fa4b548d7755f$export$67dfc5eb407d8389 = /*#__PURE__*/ function(MenuNodeIdTypeEnum) {
    /** Identify a menu node by the Database ID. */ MenuNodeIdTypeEnum["DatabaseId"] = "DATABASE_ID";
    /** Identify a menu node by the (hashed) Global ID. */ MenuNodeIdTypeEnum["Id"] = "ID";
    /** Identify a menu node by the slug of menu location to which it is assigned */ MenuNodeIdTypeEnum["Location"] = "LOCATION";
    /** Identify a menu node by its name */ MenuNodeIdTypeEnum["Name"] = "NAME";
    /** Identify a menu node by its slug */ MenuNodeIdTypeEnum["Slug"] = "SLUG";
    return MenuNodeIdTypeEnum;
}({});
var $013fa4b548d7755f$export$22199fbaeeb0a3ad = /*#__PURE__*/ function(MimeTypeEnum) {
    /** application/java mime type. */ MimeTypeEnum["ApplicationJava"] = "APPLICATION_JAVA";
    /** application/msword mime type. */ MimeTypeEnum["ApplicationMsword"] = "APPLICATION_MSWORD";
    /** application/octet-stream mime type. */ MimeTypeEnum["ApplicationOctetStream"] = "APPLICATION_OCTET_STREAM";
    /** application/onenote mime type. */ MimeTypeEnum["ApplicationOnenote"] = "APPLICATION_ONENOTE";
    /** application/oxps mime type. */ MimeTypeEnum["ApplicationOxps"] = "APPLICATION_OXPS";
    /** application/pdf mime type. */ MimeTypeEnum["ApplicationPdf"] = "APPLICATION_PDF";
    /** application/rar mime type. */ MimeTypeEnum["ApplicationRar"] = "APPLICATION_RAR";
    /** application/rtf mime type. */ MimeTypeEnum["ApplicationRtf"] = "APPLICATION_RTF";
    /** application/ttaf+xml mime type. */ MimeTypeEnum["ApplicationTtafXml"] = "APPLICATION_TTAF_XML";
    /** application/vnd.apple.keynote mime type. */ MimeTypeEnum["ApplicationVndAppleKeynote"] = "APPLICATION_VND_APPLE_KEYNOTE";
    /** application/vnd.apple.numbers mime type. */ MimeTypeEnum["ApplicationVndAppleNumbers"] = "APPLICATION_VND_APPLE_NUMBERS";
    /** application/vnd.apple.pages mime type. */ MimeTypeEnum["ApplicationVndApplePages"] = "APPLICATION_VND_APPLE_PAGES";
    /** application/vnd.ms-access mime type. */ MimeTypeEnum["ApplicationVndMsAccess"] = "APPLICATION_VND_MS_ACCESS";
    /** application/vnd.ms-excel mime type. */ MimeTypeEnum["ApplicationVndMsExcel"] = "APPLICATION_VND_MS_EXCEL";
    /** application/vnd.ms-excel.addin.macroEnabled.12 mime type. */ MimeTypeEnum["ApplicationVndMsExcelAddinMacroenabled_12"] = "APPLICATION_VND_MS_EXCEL_ADDIN_MACROENABLED_12";
    /** application/vnd.ms-excel.sheet.binary.macroEnabled.12 mime type. */ MimeTypeEnum["ApplicationVndMsExcelSheetBinaryMacroenabled_12"] = "APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12";
    /** application/vnd.ms-excel.sheet.macroEnabled.12 mime type. */ MimeTypeEnum["ApplicationVndMsExcelSheetMacroenabled_12"] = "APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12";
    /** application/vnd.ms-excel.template.macroEnabled.12 mime type. */ MimeTypeEnum["ApplicationVndMsExcelTemplateMacroenabled_12"] = "APPLICATION_VND_MS_EXCEL_TEMPLATE_MACROENABLED_12";
    /** application/vnd.ms-powerpoint mime type. */ MimeTypeEnum["ApplicationVndMsPowerpoint"] = "APPLICATION_VND_MS_POWERPOINT";
    /** application/vnd.ms-powerpoint.addin.macroEnabled.12 mime type. */ MimeTypeEnum["ApplicationVndMsPowerpointAddinMacroenabled_12"] = "APPLICATION_VND_MS_POWERPOINT_ADDIN_MACROENABLED_12";
    /** application/vnd.ms-powerpoint.presentation.macroEnabled.12 mime type. */ MimeTypeEnum["ApplicationVndMsPowerpointPresentationMacroenabled_12"] = "APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12";
    /** application/vnd.ms-powerpoint.slideshow.macroEnabled.12 mime type. */ MimeTypeEnum["ApplicationVndMsPowerpointSlideshowMacroenabled_12"] = "APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12";
    /** application/vnd.ms-powerpoint.slide.macroEnabled.12 mime type. */ MimeTypeEnum["ApplicationVndMsPowerpointSlideMacroenabled_12"] = "APPLICATION_VND_MS_POWERPOINT_SLIDE_MACROENABLED_12";
    /** application/vnd.ms-powerpoint.template.macroEnabled.12 mime type. */ MimeTypeEnum["ApplicationVndMsPowerpointTemplateMacroenabled_12"] = "APPLICATION_VND_MS_POWERPOINT_TEMPLATE_MACROENABLED_12";
    /** application/vnd.ms-project mime type. */ MimeTypeEnum["ApplicationVndMsProject"] = "APPLICATION_VND_MS_PROJECT";
    /** application/vnd.ms-word.document.macroEnabled.12 mime type. */ MimeTypeEnum["ApplicationVndMsWordDocumentMacroenabled_12"] = "APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12";
    /** application/vnd.ms-word.template.macroEnabled.12 mime type. */ MimeTypeEnum["ApplicationVndMsWordTemplateMacroenabled_12"] = "APPLICATION_VND_MS_WORD_TEMPLATE_MACROENABLED_12";
    /** application/vnd.ms-write mime type. */ MimeTypeEnum["ApplicationVndMsWrite"] = "APPLICATION_VND_MS_WRITE";
    /** application/vnd.ms-xpsdocument mime type. */ MimeTypeEnum["ApplicationVndMsXpsdocument"] = "APPLICATION_VND_MS_XPSDOCUMENT";
    /** application/vnd.oasis.opendocument.chart mime type. */ MimeTypeEnum["ApplicationVndOasisOpendocumentChart"] = "APPLICATION_VND_OASIS_OPENDOCUMENT_CHART";
    /** application/vnd.oasis.opendocument.database mime type. */ MimeTypeEnum["ApplicationVndOasisOpendocumentDatabase"] = "APPLICATION_VND_OASIS_OPENDOCUMENT_DATABASE";
    /** application/vnd.oasis.opendocument.formula mime type. */ MimeTypeEnum["ApplicationVndOasisOpendocumentFormula"] = "APPLICATION_VND_OASIS_OPENDOCUMENT_FORMULA";
    /** application/vnd.oasis.opendocument.graphics mime type. */ MimeTypeEnum["ApplicationVndOasisOpendocumentGraphics"] = "APPLICATION_VND_OASIS_OPENDOCUMENT_GRAPHICS";
    /** application/vnd.oasis.opendocument.presentation mime type. */ MimeTypeEnum["ApplicationVndOasisOpendocumentPresentation"] = "APPLICATION_VND_OASIS_OPENDOCUMENT_PRESENTATION";
    /** application/vnd.oasis.opendocument.spreadsheet mime type. */ MimeTypeEnum["ApplicationVndOasisOpendocumentSpreadsheet"] = "APPLICATION_VND_OASIS_OPENDOCUMENT_SPREADSHEET";
    /** application/vnd.oasis.opendocument.text mime type. */ MimeTypeEnum["ApplicationVndOasisOpendocumentText"] = "APPLICATION_VND_OASIS_OPENDOCUMENT_TEXT";
    /** application/vnd.openxmlformats-officedocument.presentationml.presentation mime type. */ MimeTypeEnum["ApplicationVndOpenxmlformatsOfficedocumentPresentationmlPresentation"] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION";
    /** application/vnd.openxmlformats-officedocument.presentationml.slide mime type. */ MimeTypeEnum["ApplicationVndOpenxmlformatsOfficedocumentPresentationmlSlide"] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDE";
    /** application/vnd.openxmlformats-officedocument.presentationml.slideshow mime type. */ MimeTypeEnum["ApplicationVndOpenxmlformatsOfficedocumentPresentationmlSlideshow"] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW";
    /** application/vnd.openxmlformats-officedocument.presentationml.template mime type. */ MimeTypeEnum["ApplicationVndOpenxmlformatsOfficedocumentPresentationmlTemplate"] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_TEMPLATE";
    /** application/vnd.openxmlformats-officedocument.spreadsheetml.sheet mime type. */ MimeTypeEnum["ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet"] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET";
    /** application/vnd.openxmlformats-officedocument.spreadsheetml.template mime type. */ MimeTypeEnum["ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlTemplate"] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_TEMPLATE";
    /** application/vnd.openxmlformats-officedocument.wordprocessingml.document mime type. */ MimeTypeEnum["ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlDocument"] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT";
    /** application/vnd.openxmlformats-officedocument.wordprocessingml.template mime type. */ MimeTypeEnum["ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlTemplate"] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_TEMPLATE";
    /** application/wordperfect mime type. */ MimeTypeEnum["ApplicationWordperfect"] = "APPLICATION_WORDPERFECT";
    /** application/x-7z-compressed mime type. */ MimeTypeEnum["ApplicationX_7ZCompressed"] = "APPLICATION_X_7Z_COMPRESSED";
    /** application/x-gzip mime type. */ MimeTypeEnum["ApplicationXGzip"] = "APPLICATION_X_GZIP";
    /** application/x-tar mime type. */ MimeTypeEnum["ApplicationXTar"] = "APPLICATION_X_TAR";
    /** application/zip mime type. */ MimeTypeEnum["ApplicationZip"] = "APPLICATION_ZIP";
    /** audio/aac mime type. */ MimeTypeEnum["AudioAac"] = "AUDIO_AAC";
    /** audio/flac mime type. */ MimeTypeEnum["AudioFlac"] = "AUDIO_FLAC";
    /** audio/midi mime type. */ MimeTypeEnum["AudioMidi"] = "AUDIO_MIDI";
    /** audio/mpeg mime type. */ MimeTypeEnum["AudioMpeg"] = "AUDIO_MPEG";
    /** audio/ogg mime type. */ MimeTypeEnum["AudioOgg"] = "AUDIO_OGG";
    /** audio/wav mime type. */ MimeTypeEnum["AudioWav"] = "AUDIO_WAV";
    /** audio/x-matroska mime type. */ MimeTypeEnum["AudioXMatroska"] = "AUDIO_X_MATROSKA";
    /** audio/x-ms-wax mime type. */ MimeTypeEnum["AudioXMsWax"] = "AUDIO_X_MS_WAX";
    /** audio/x-ms-wma mime type. */ MimeTypeEnum["AudioXMsWma"] = "AUDIO_X_MS_WMA";
    /** audio/x-realaudio mime type. */ MimeTypeEnum["AudioXRealaudio"] = "AUDIO_X_REALAUDIO";
    /** image/avif mime type. */ MimeTypeEnum["ImageAvif"] = "IMAGE_AVIF";
    /** image/bmp mime type. */ MimeTypeEnum["ImageBmp"] = "IMAGE_BMP";
    /** image/gif mime type. */ MimeTypeEnum["ImageGif"] = "IMAGE_GIF";
    /** image/heic mime type. */ MimeTypeEnum["ImageHeic"] = "IMAGE_HEIC";
    /** image/heic-sequence mime type. */ MimeTypeEnum["ImageHeicSequence"] = "IMAGE_HEIC_SEQUENCE";
    /** image/heif mime type. */ MimeTypeEnum["ImageHeif"] = "IMAGE_HEIF";
    /** image/heif-sequence mime type. */ MimeTypeEnum["ImageHeifSequence"] = "IMAGE_HEIF_SEQUENCE";
    /** image/jpeg mime type. */ MimeTypeEnum["ImageJpeg"] = "IMAGE_JPEG";
    /** image/png mime type. */ MimeTypeEnum["ImagePng"] = "IMAGE_PNG";
    /** image/svg+xml mime type. */ MimeTypeEnum["ImageSvgXml"] = "IMAGE_SVG_XML";
    /** image/tiff mime type. */ MimeTypeEnum["ImageTiff"] = "IMAGE_TIFF";
    /** image/webp mime type. */ MimeTypeEnum["ImageWebp"] = "IMAGE_WEBP";
    /** image/x-icon mime type. */ MimeTypeEnum["ImageXIcon"] = "IMAGE_X_ICON";
    /** text/calendar mime type. */ MimeTypeEnum["TextCalendar"] = "TEXT_CALENDAR";
    /** text/css mime type. */ MimeTypeEnum["TextCss"] = "TEXT_CSS";
    /** text/csv mime type. */ MimeTypeEnum["TextCsv"] = "TEXT_CSV";
    /** text/plain mime type. */ MimeTypeEnum["TextPlain"] = "TEXT_PLAIN";
    /** text/richtext mime type. */ MimeTypeEnum["TextRichtext"] = "TEXT_RICHTEXT";
    /** text/tab-separated-values mime type. */ MimeTypeEnum["TextTabSeparatedValues"] = "TEXT_TAB_SEPARATED_VALUES";
    /** text/vtt mime type. */ MimeTypeEnum["TextVtt"] = "TEXT_VTT";
    /** video/3gpp mime type. */ MimeTypeEnum["Video_3Gpp"] = "VIDEO_3GPP";
    /** video/3gpp2 mime type. */ MimeTypeEnum["Video_3Gpp2"] = "VIDEO_3GPP2";
    /** video/avi mime type. */ MimeTypeEnum["VideoAvi"] = "VIDEO_AVI";
    /** video/divx mime type. */ MimeTypeEnum["VideoDivx"] = "VIDEO_DIVX";
    /** video/mp4 mime type. */ MimeTypeEnum["VideoMp4"] = "VIDEO_MP4";
    /** video/mpeg mime type. */ MimeTypeEnum["VideoMpeg"] = "VIDEO_MPEG";
    /** video/ogg mime type. */ MimeTypeEnum["VideoOgg"] = "VIDEO_OGG";
    /** video/quicktime mime type. */ MimeTypeEnum["VideoQuicktime"] = "VIDEO_QUICKTIME";
    /** video/webm mime type. */ MimeTypeEnum["VideoWebm"] = "VIDEO_WEBM";
    /** video/x-flv mime type. */ MimeTypeEnum["VideoXFlv"] = "VIDEO_X_FLV";
    /** video/x-matroska mime type. */ MimeTypeEnum["VideoXMatroska"] = "VIDEO_X_MATROSKA";
    /** video/x-ms-asf mime type. */ MimeTypeEnum["VideoXMsAsf"] = "VIDEO_X_MS_ASF";
    /** video/x-ms-wm mime type. */ MimeTypeEnum["VideoXMsWm"] = "VIDEO_X_MS_WM";
    /** video/x-ms-wmv mime type. */ MimeTypeEnum["VideoXMsWmv"] = "VIDEO_X_MS_WMV";
    /** video/x-ms-wmx mime type. */ MimeTypeEnum["VideoXMsWmx"] = "VIDEO_X_MS_WMX";
    return MimeTypeEnum;
}({});
var $013fa4b548d7755f$export$621a9cada4a375b = /*#__PURE__*/ function(OrderEnum) {
    /** Sort the query result set in an ascending order */ OrderEnum["Asc"] = "ASC";
    /** Sort the query result set in a descending order */ OrderEnum["Desc"] = "DESC";
    return OrderEnum;
}({});
var $013fa4b548d7755f$export$571fdc53ef0f230b = /*#__PURE__*/ function(PageIdType) {
    /** Identify a resource by the Database ID. */ PageIdType["DatabaseId"] = "DATABASE_ID";
    /** Identify a resource by the (hashed) Global ID. */ PageIdType["Id"] = "ID";
    /** Identify a resource by the URI. */ PageIdType["Uri"] = "URI";
    return PageIdType;
}({});
var $013fa4b548d7755f$export$803c7026f1dafc64 = /*#__PURE__*/ function(PluginStatusEnum) {
    /** The plugin is currently active. */ PluginStatusEnum["Active"] = "ACTIVE";
    /** The plugin is a drop-in plugin. */ PluginStatusEnum["DropIn"] = "DROP_IN";
    /** The plugin is currently inactive. */ PluginStatusEnum["Inactive"] = "INACTIVE";
    /** The plugin is a must-use plugin. */ PluginStatusEnum["MustUse"] = "MUST_USE";
    /** The plugin is technically active but was paused while loading. */ PluginStatusEnum["Paused"] = "PAUSED";
    /** The plugin was active recently. */ PluginStatusEnum["RecentlyActive"] = "RECENTLY_ACTIVE";
    /** The plugin has an upgrade available. */ PluginStatusEnum["Upgrade"] = "UPGRADE";
    return PluginStatusEnum;
}({});
var $013fa4b548d7755f$export$760b94a737599c9e = /*#__PURE__*/ function(PostFormatIdType) {
    /** The Database ID for the node */ PostFormatIdType["DatabaseId"] = "DATABASE_ID";
    /** The hashed Global ID */ PostFormatIdType["Id"] = "ID";
    /** The name of the node */ PostFormatIdType["Name"] = "NAME";
    /** Url friendly name of the node */ PostFormatIdType["Slug"] = "SLUG";
    /** The URI for the node */ PostFormatIdType["Uri"] = "URI";
    return PostFormatIdType;
}({});
var $013fa4b548d7755f$export$5679853e76bc2c1c = /*#__PURE__*/ function(PostIdType) {
    /** Identify a resource by the Database ID. */ PostIdType["DatabaseId"] = "DATABASE_ID";
    /** Identify a resource by the (hashed) Global ID. */ PostIdType["Id"] = "ID";
    /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */ PostIdType["Slug"] = "SLUG";
    /** Identify a resource by the URI. */ PostIdType["Uri"] = "URI";
    return PostIdType;
}({});
var $013fa4b548d7755f$export$6be903850edae355 = /*#__PURE__*/ function(PostObjectFieldFormatEnum) {
    /** Provide the field value directly from database. Null on unauthenticated requests. */ PostObjectFieldFormatEnum["Raw"] = "RAW";
    /** Provide the field value as rendered by WordPress. Default. */ PostObjectFieldFormatEnum["Rendered"] = "RENDERED";
    return PostObjectFieldFormatEnum;
}({});
var $013fa4b548d7755f$export$d47c01c3e331541d = /*#__PURE__*/ function(PostObjectsConnectionDateColumnEnum) {
    /** The date the comment was created in local time. */ PostObjectsConnectionDateColumnEnum["Date"] = "DATE";
    /** The most recent modification date of the comment. */ PostObjectsConnectionDateColumnEnum["Modified"] = "MODIFIED";
    return PostObjectsConnectionDateColumnEnum;
}({});
var $013fa4b548d7755f$export$9525a1922c362cd5 = /*#__PURE__*/ function(PostObjectsConnectionOrderbyEnum) {
    /** Order by author */ PostObjectsConnectionOrderbyEnum["Author"] = "AUTHOR";
    /** Order by the number of comments it has acquired */ PostObjectsConnectionOrderbyEnum["CommentCount"] = "COMMENT_COUNT";
    /** Order by publish date */ PostObjectsConnectionOrderbyEnum["Date"] = "DATE";
    /** Preserve the ID order given in the IN array */ PostObjectsConnectionOrderbyEnum["In"] = "IN";
    /** Order by the menu order value */ PostObjectsConnectionOrderbyEnum["MenuOrder"] = "MENU_ORDER";
    /** Order by last modified date */ PostObjectsConnectionOrderbyEnum["Modified"] = "MODIFIED";
    /** Preserve slug order given in the NAME_IN array */ PostObjectsConnectionOrderbyEnum["NameIn"] = "NAME_IN";
    /** Order by parent ID */ PostObjectsConnectionOrderbyEnum["Parent"] = "PARENT";
    /** Order by slug */ PostObjectsConnectionOrderbyEnum["Slug"] = "SLUG";
    /** Order by title */ PostObjectsConnectionOrderbyEnum["Title"] = "TITLE";
    return PostObjectsConnectionOrderbyEnum;
}({});
var $013fa4b548d7755f$export$517d6e80747185c7 = /*#__PURE__*/ function(PostStatusEnum) {
    /** Objects with the acf-disabled status */ PostStatusEnum["AcfDisabled"] = "ACF_DISABLED";
    /** Objects with the auto-draft status */ PostStatusEnum["AutoDraft"] = "AUTO_DRAFT";
    /** Objects with the dp-rewrite-republish status */ PostStatusEnum["DpRewriteRepublish"] = "DP_REWRITE_REPUBLISH";
    /** Objects with the draft status */ PostStatusEnum["Draft"] = "DRAFT";
    /** Objects with the future status */ PostStatusEnum["Future"] = "FUTURE";
    /** Objects with the inherit status */ PostStatusEnum["Inherit"] = "INHERIT";
    /** Objects with the pending status */ PostStatusEnum["Pending"] = "PENDING";
    /** Objects with the private status */ PostStatusEnum["Private"] = "PRIVATE";
    /** Objects with the publish status */ PostStatusEnum["Publish"] = "PUBLISH";
    /** Objects with the request-completed status */ PostStatusEnum["RequestCompleted"] = "REQUEST_COMPLETED";
    /** Objects with the request-confirmed status */ PostStatusEnum["RequestConfirmed"] = "REQUEST_CONFIRMED";
    /** Objects with the request-failed status */ PostStatusEnum["RequestFailed"] = "REQUEST_FAILED";
    /** Objects with the request-pending status */ PostStatusEnum["RequestPending"] = "REQUEST_PENDING";
    /** Objects with the trash status */ PostStatusEnum["Trash"] = "TRASH";
    return PostStatusEnum;
}({});
var $013fa4b548d7755f$export$63cd2d4aa67acde2 = /*#__PURE__*/ function(RelationEnum) {
    /** The logical AND condition returns true if both operands are true, otherwise, it returns false. */ RelationEnum["And"] = "AND";
    /** The logical OR condition returns false if both operands are false, otherwise, it returns true. */ RelationEnum["Or"] = "OR";
    return RelationEnum;
}({});
var $013fa4b548d7755f$export$4e44a557be39f676 = /*#__PURE__*/ function(SeoCardType) {
    SeoCardType["Summary"] = "summary";
    SeoCardType["SummaryLargeImage"] = "summary_large_image";
    return SeoCardType;
}({});
var $013fa4b548d7755f$export$575d0925cf630b51 = /*#__PURE__*/ function(ScriptLoadingStrategyEnum) {
    /** Use the script `async` attribute */ ScriptLoadingStrategyEnum["Async"] = "ASYNC";
    /** Use the script `defer` attribute */ ScriptLoadingStrategyEnum["Defer"] = "DEFER";
    return ScriptLoadingStrategyEnum;
}({});
var $013fa4b548d7755f$export$6beb7f79fc48eee3 = /*#__PURE__*/ function(TagIdType) {
    /** The Database ID for the node */ TagIdType["DatabaseId"] = "DATABASE_ID";
    /** The hashed Global ID */ TagIdType["Id"] = "ID";
    /** The name of the node */ TagIdType["Name"] = "NAME";
    /** Url friendly name of the node */ TagIdType["Slug"] = "SLUG";
    /** The URI for the node */ TagIdType["Uri"] = "URI";
    return TagIdType;
}({});
var $013fa4b548d7755f$export$f3e62b2072f9e75a = /*#__PURE__*/ function(TaxonomyEnum) {
    /** Taxonomy enum author */ TaxonomyEnum["Author"] = "AUTHOR";
    /** Taxonomy enum category */ TaxonomyEnum["Category"] = "CATEGORY";
    /** Taxonomy enum faqs-kategori */ TaxonomyEnum["Faqscategory"] = "FAQSCATEGORY";
    /** Taxonomy enum graphql_document_group */ TaxonomyEnum["Graphqldocumentgroup"] = "GRAPHQLDOCUMENTGROUP";
    /** Taxonomy enum post_format */ TaxonomyEnum["Postformat"] = "POSTFORMAT";
    /** Taxonomy enum post_tag */ TaxonomyEnum["Tag"] = "TAG";
    return TaxonomyEnum;
}({});
var $013fa4b548d7755f$export$48bc12b49ca8bee8 = /*#__PURE__*/ function(TaxonomyIdTypeEnum) {
    /** The globally unique ID */ TaxonomyIdTypeEnum["Id"] = "ID";
    /** The name of the taxonomy */ TaxonomyIdTypeEnum["Name"] = "NAME";
    return TaxonomyIdTypeEnum;
}({});
var $013fa4b548d7755f$export$c1a3e9bb2fdd2a6c = /*#__PURE__*/ function(TermNodeIdTypeEnum) {
    /** The Database ID for the node */ TermNodeIdTypeEnum["DatabaseId"] = "DATABASE_ID";
    /** The hashed Global ID */ TermNodeIdTypeEnum["Id"] = "ID";
    /** The name of the node */ TermNodeIdTypeEnum["Name"] = "NAME";
    /** Url friendly name of the node */ TermNodeIdTypeEnum["Slug"] = "SLUG";
    /** The URI for the node */ TermNodeIdTypeEnum["Uri"] = "URI";
    return TermNodeIdTypeEnum;
}({});
var $013fa4b548d7755f$export$fac6948324ca8e0f = /*#__PURE__*/ function(TermObjectsConnectionOrderbyEnum) {
    /** Order the connection by item count. */ TermObjectsConnectionOrderbyEnum["Count"] = "COUNT";
    /** Order the connection by description. */ TermObjectsConnectionOrderbyEnum["Description"] = "DESCRIPTION";
    /** Order the connection by name. */ TermObjectsConnectionOrderbyEnum["Name"] = "NAME";
    /** Order the connection by slug. */ TermObjectsConnectionOrderbyEnum["Slug"] = "SLUG";
    /** Order the connection by term group. */ TermObjectsConnectionOrderbyEnum["TermGroup"] = "TERM_GROUP";
    /** Order the connection by term id. */ TermObjectsConnectionOrderbyEnum["TermId"] = "TERM_ID";
    /** Order the connection by term order. */ TermObjectsConnectionOrderbyEnum["TermOrder"] = "TERM_ORDER";
    return TermObjectsConnectionOrderbyEnum;
}({});
var $013fa4b548d7755f$export$b31f10c058d51551 = /*#__PURE__*/ function(UserNodeIdTypeEnum) {
    /** The Database ID for the node */ UserNodeIdTypeEnum["DatabaseId"] = "DATABASE_ID";
    /** The Email of the User */ UserNodeIdTypeEnum["Email"] = "EMAIL";
    /** The hashed Global ID */ UserNodeIdTypeEnum["Id"] = "ID";
    /** The slug of the User */ UserNodeIdTypeEnum["Slug"] = "SLUG";
    /** The URI for the node */ UserNodeIdTypeEnum["Uri"] = "URI";
    /** The username the User uses to login with */ UserNodeIdTypeEnum["Username"] = "USERNAME";
    return UserNodeIdTypeEnum;
}({});
var $013fa4b548d7755f$export$d72f1b6ccd932372 = /*#__PURE__*/ function(UserRoleEnum) {
    /** User role with specific capabilities */ UserRoleEnum["Administrator"] = "ADMINISTRATOR";
    /** User role with specific capabilities */ UserRoleEnum["Author"] = "AUTHOR";
    /** User role with specific capabilities */ UserRoleEnum["Contributor"] = "CONTRIBUTOR";
    /** User role with specific capabilities */ UserRoleEnum["Editor"] = "EDITOR";
    /** User role with specific capabilities */ UserRoleEnum["SeoEditor"] = "SEO_EDITOR";
    /** User role with specific capabilities */ UserRoleEnum["SeoManager"] = "SEO_MANAGER";
    /** User role with specific capabilities */ UserRoleEnum["Subscriber"] = "SUBSCRIBER";
    /** User role with specific capabilities */ UserRoleEnum["Superadmin"] = "SUPERADMIN";
    return UserRoleEnum;
}({});
var $013fa4b548d7755f$export$e8cd41fc8193c8c7 = /*#__PURE__*/ function(UsersConnectionOrderbyEnum) {
    /** Order by display name */ UsersConnectionOrderbyEnum["DisplayName"] = "DISPLAY_NAME";
    /** Order by email address */ UsersConnectionOrderbyEnum["Email"] = "EMAIL";
    /** Order by login */ UsersConnectionOrderbyEnum["Login"] = "LOGIN";
    /** Preserve the login order given in the LOGIN_IN array */ UsersConnectionOrderbyEnum["LoginIn"] = "LOGIN_IN";
    /** Order by nice name */ UsersConnectionOrderbyEnum["NiceName"] = "NICE_NAME";
    /** Preserve the nice name order given in the NICE_NAME_IN array */ UsersConnectionOrderbyEnum["NiceNameIn"] = "NICE_NAME_IN";
    /** Order by registration date */ UsersConnectionOrderbyEnum["Registered"] = "REGISTERED";
    /** Order by URL */ UsersConnectionOrderbyEnum["Url"] = "URL";
    return UsersConnectionOrderbyEnum;
}({});
var $013fa4b548d7755f$export$513f1795df3579f2 = /*#__PURE__*/ function(UsersConnectionSearchColumnEnum) {
    /** The user's email address. */ UsersConnectionSearchColumnEnum["Email"] = "EMAIL";
    /** The globally unique ID. */ UsersConnectionSearchColumnEnum["Id"] = "ID";
    /** The username the User uses to login with. */ UsersConnectionSearchColumnEnum["Login"] = "LOGIN";
    /** A URL-friendly name for the user. The default is the user's username. */ UsersConnectionSearchColumnEnum["Nicename"] = "NICENAME";
    /** The URL of the user's website. */ UsersConnectionSearchColumnEnum["Url"] = "URL";
    return UsersConnectionSearchColumnEnum;
}({});
class $013fa4b548d7755f$export$1752a241e7cd2088 extends String {
    __apiType;
    value;
    __meta__;
    constructor(value, __meta__){
        super(value);
        this.value = value;
        this.__meta__ = __meta__;
    }
    toString() {
        return this.value;
    }
}
const $013fa4b548d7755f$export$2d93aa833885982c = new $013fa4b548d7755f$export$1752a241e7cd2088(`
    fragment ModuleBuilderBlocks on KiaModule_Pagebuilder_Blocks {
  __typename
  ... on KiaModule_Pagebuilder_Blocks_Hero {
    __typename
    editor
    editorPosition
    containerWidth
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    videoHasControls
  }
  ... on KiaModule_Pagebuilder_Blocks_Texteditor {
    __typename
    blockId
    containerWidth
    bgColor
    content
    links {
      link
      linkInNewWindow
      linkText
      linkType
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Image {
    __typename
    blockId
    containerWidth
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    videoHasControls
  }
  ... on KiaModule_Pagebuilder_Blocks_TextMedia {
    __typename
    blockId
    containerWidth
    mediaType
    mediaPosition
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    youtube
    mediaIsCover
    videoHasAutoplay
    videoHasControls
    link
    linkText
    linkInNewWindow
    linkType
    linkPosition
    contentBg
    content
  }
  ... on KiaModule_Pagebuilder_Blocks_Gallery {
    __typename
    blockId
    containerWidth
    galleryItems {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Checklist {
    __typename
    blockId
    containerWidth
    iconPosition
    list {
      text
    }
    links {
      link
      linkInNewWindow
      linkText
      linkType
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Story {
    __typename
    blockId
    containerWidth
    postsToDisplay
    heading
    category {
      posts {
        nodes {
          id
          databaseId
          content
          title
          slug
          featuredImage {
            node {
              altText
              sourceUrl
              mediaDetails {
                height
                width
              }
            }
          }
        }
      }
    }
    selectedPosts {
      ... on Post {
        id
        databaseId
        content
        title
        slug
        featuredImage {
          node {
            altText
            sourceUrl
            mediaDetails {
              height
              width
            }
          }
        }
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_ContentList {
    __typename
    blockId
    containerWidth
    layout
    smallGap
    firstItemReversed
    list {
      content
      contentBg
      link
      linkInNewWindow
      linkText
      linkType
      linkPosition
      mediaIsCover
      video {
        mediaItemUrl
        mimeType
      }
      image {
        altText
        sourceUrl
        srcSet
        sizes
        mediaDetails {
          height
          width
        }
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Nav {
    fieldGroupName
    links {
      linkId
      linkText
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_WowForm {
    fieldGroupName
    __typename
    terms
    successModalTitle
    successModalDescription
    steps {
      ... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_Text {
        __typename
        description
        title
        fieldGroupName
        textCtaUrl
        textCtaLabel
      }
      ... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_Form {
        __typename
        description
        title
        fieldGroupName
      }
      ... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_TextRules {
        __typename
        ctaLabel
        ctaUrl
        description
        fieldGroupName
        title
        rulesItems {
          text
          fieldGroupName
        }
        rulesTitle
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_ColoredHero {
    backgroundColor
    blockId
    description
    eyebrow
    heading
    textColor
    fieldGroupName
  }
  ... on KiaModule_Pagebuilder_Blocks_Table {
    blockId
    containerWidth
    cols {
      colLabel
    }
    rows {
      rowLabel
      rowCells {
        cellContent
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Tabs {
    __typename
    blockId
    containerWidth
    title
    tabs {
      label
      columns {
        content
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Faqs {
    __typename
    blockId
    containerWidth
    title
    faqs {
      label
      content
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Iframe {
    __typename
    blockId
    containerWidth
    title
    url
    editor
  }
  ... on KiaModule_Pagebuilder_Blocks_Logotypes {
    __typename
    blockId
    containerWidth
    title
    gallery {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_CarCarouselGrid {
    __typename
    blockId
    displayDescriptions
    displayLeasing
    displayCta
    displayPrices
    imageType
    selectedCars {
      kiaTrims
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_CarCarousel {
    __typename
    blockId
    displayDescriptions
    displayLeasing
    displayCta
    displayPrices
    functions
    businessEdition
    imageType
  }
  ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock {
    __typename
    margins
    columns {
      width
      colAligment
      content {
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_TextBlock {
          __typename
          editor
        }
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ImageBlock {
          __typename
          focalX
          focalY
          image {
            altText
            sourceUrl
            srcSet
            sizes
            mediaDetails {
              height
              width
            }
          }
        }
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ButtonBlock {
          __typename
          style
          alignment
          link {
            url
            title
            target
          }
        }
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_VideoBlock {
          __typename
          autoplay
          videoFile {
            sourceUrl
            mimeType
          }
          posterImage {
            sourceUrl
            altText
            srcSet
            sizes
            mediaDetails {
              height
              width
            }
          }
        }
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_SpacerBlock {
          __typename
          height
        }
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Newsletter {
    __typename
    buttonText
    description
    emailPlaceholder
    fieldGroupName
    headline
    successMessage
    termsText
    theme
  }
  ... on KiaModule_Pagebuilder_Blocks_FeatureBenefitBlockWithImage {
    __typename
    backgroundColor
    content
    color
    headline
    topHeadline
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_LaddboxBlock {
    __typename
    title
    description
    laddboxOptions {
      title
      description
      price
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_ImageTextButton {
    __typename
    content
    fieldGroupName
    subtitle
    title
    buttonLink {
      target
      title
      url
    }
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
}
    `, {
    "fragmentName": "ModuleBuilderBlocks"
});
const $013fa4b548d7755f$export$afa0301581912d8d = new $013fa4b548d7755f$export$1752a241e7cd2088(`
    fragment PageBuilderBlocks on KiaPage_Pagebuilder_Blocks {
  __typename
  ... on KiaPage_Pagebuilder_Blocks_Hero {
    __typename
    editor
    editorPosition
    containerWidth
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    videoHasControls
  }
  ... on KiaPage_Pagebuilder_Blocks_Texteditor {
    __typename
    blockId
    containerWidth
    bgColor
    content
    links {
      link
      linkInNewWindow
      linkText
      linkType
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_Image {
    __typename
    blockId
    containerWidth
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    videoHasControls
  }
  ... on KiaPage_Pagebuilder_Blocks_TextMedia {
    __typename
    blockId
    containerWidth
    mediaType
    mediaPosition
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    youtube
    mediaIsCover
    videoHasAutoplay
    videoHasControls
    link
    linkText
    linkInNewWindow
    linkType
    linkPosition
    contentBg
    content
  }
  ... on KiaPage_Pagebuilder_Blocks_Gallery {
    __typename
    blockId
    containerWidth
    galleryItems {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_Checklist {
    __typename
    blockId
    containerWidth
    iconPosition
    list {
      text
    }
    links {
      link
      linkInNewWindow
      linkText
      linkType
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_Story {
    __typename
    blockId
    containerWidth
    postsToDisplay
    heading
    category {
      posts {
        nodes {
          id
          databaseId
          content
          title
          slug
          featuredImage {
            node {
              altText
              sourceUrl
              mediaDetails {
                height
                width
              }
            }
          }
        }
      }
    }
    selectedPosts {
      ... on Post {
        id
        databaseId
        content
        title
        slug
        featuredImage {
          node {
            altText
            sourceUrl
            mediaDetails {
              height
              width
            }
          }
        }
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_ContentList {
    __typename
    blockId
    containerWidth
    layout
    smallGap
    firstItemReversed
    list {
      content
      contentBg
      link
      linkInNewWindow
      linkText
      linkType
      linkPosition
      mediaIsCover
      video {
        mediaItemUrl
        mimeType
      }
      image {
        altText
        sourceUrl
        srcSet
        sizes
        mediaDetails {
          height
          width
        }
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_Nav {
    fieldGroupName
    links {
      linkId
      linkText
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_WowForm {
    fieldGroupName
    __typename
    terms
    successModalTitle
    successModalDescription
    steps {
      ... on KiaPage_Pagebuilder_Blocks_WowForm_Steps_Text {
        __typename
        description
        title
        fieldGroupName
        textCtaUrl
        textCtaLabel
      }
      ... on KiaPage_Pagebuilder_Blocks_WowForm_Steps_Form {
        __typename
        description
        title
        fieldGroupName
      }
      ... on KiaPage_Pagebuilder_Blocks_WowForm_Steps_TextRules {
        __typename
        ctaLabel
        ctaUrl
        description
        fieldGroupName
        title
        rulesItems {
          text
          fieldGroupName
        }
        rulesTitle
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_ColoredHero {
    backgroundColor
    blockId
    description
    eyebrow
    heading
    textColor
    fieldGroupName
  }
  ... on KiaPage_Pagebuilder_Blocks_Table {
    blockId
    containerWidth
    cols {
      colLabel
    }
    rows {
      rowLabel
      rowCells {
        cellContent
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_Tabs {
    __typename
    blockId
    containerWidth
    title
    tabs {
      label
      columns {
        content
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_Faqs {
    __typename
    blockId
    containerWidth
    title
    faqs {
      label
      content
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_Iframe {
    __typename
    blockId
    containerWidth
    title
    url
    editor
  }
  ... on KiaPage_Pagebuilder_Blocks_Logotypes {
    __typename
    blockId
    containerWidth
    title
    gallery {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_CarCarouselGrid {
    __typename
    blockId
    displayDescriptions
    displayLeasing
    displayCta
    displayPrices
    imageType
    selectedCars {
      kiaTrims
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_CarCarousel {
    __typename
    blockId
    displayDescriptions
    displayLeasing
    displayCta
    displayPrices
    functions
    businessEdition
    imageType
  }
  ... on KiaPage_Pagebuilder_Blocks_ColumnsBlock {
    __typename
    margins
    columns {
      width
      colAligment
      content {
        ... on KiaPage_Pagebuilder_Blocks_ColumnsBlock_columns_Content_TextBlock {
          __typename
          editor
        }
        ... on KiaPage_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ImageBlock {
          __typename
          focalX
          focalY
          image {
            altText
            sourceUrl
            srcSet
            sizes
            mediaDetails {
              height
              width
            }
          }
        }
        ... on KiaPage_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ButtonBlock {
          __typename
          style
          alignment
          link {
            url
            title
            target
          }
        }
        ... on KiaPage_Pagebuilder_Blocks_ColumnsBlock_columns_Content_VideoBlock {
          __typename
          autoplay
          videoFile {
            sourceUrl
            mimeType
          }
          posterImage {
            sourceUrl
            altText
            srcSet
            sizes
            mediaDetails {
              height
              width
            }
          }
        }
        ... on KiaPage_Pagebuilder_Blocks_ColumnsBlock_columns_Content_SpacerBlock {
          __typename
          height
        }
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_Newsletter {
    __typename
    buttonText
    description
    emailPlaceholder
    fieldGroupName
    headline
    successMessage
    termsText
    theme
  }
  ... on KiaPage_Pagebuilder_Blocks_FeatureBenefitBlockWithImage {
    __typename
    backgroundColor
    content
    color
    headline
    topHeadline
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_LaddboxBlock {
    __typename
    title
    description
    laddboxOptions {
      title
      description
      price
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_ImageTextButton {
    __typename
    content
    fieldGroupName
    subtitle
    title
    buttonLink {
      target
      title
      url
    }
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_LayoutKiaModules {
    __typename
    globalModule {
      ... on KiaModule {
        pagebuilder {
          blocks {
            ...ModuleBuilderBlocks
          }
        }
      }
    }
  }
}
    fragment ModuleBuilderBlocks on KiaModule_Pagebuilder_Blocks {
  __typename
  ... on KiaModule_Pagebuilder_Blocks_Hero {
    __typename
    editor
    editorPosition
    containerWidth
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    videoHasControls
  }
  ... on KiaModule_Pagebuilder_Blocks_Texteditor {
    __typename
    blockId
    containerWidth
    bgColor
    content
    links {
      link
      linkInNewWindow
      linkText
      linkType
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Image {
    __typename
    blockId
    containerWidth
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    videoHasControls
  }
  ... on KiaModule_Pagebuilder_Blocks_TextMedia {
    __typename
    blockId
    containerWidth
    mediaType
    mediaPosition
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    youtube
    mediaIsCover
    videoHasAutoplay
    videoHasControls
    link
    linkText
    linkInNewWindow
    linkType
    linkPosition
    contentBg
    content
  }
  ... on KiaModule_Pagebuilder_Blocks_Gallery {
    __typename
    blockId
    containerWidth
    galleryItems {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Checklist {
    __typename
    blockId
    containerWidth
    iconPosition
    list {
      text
    }
    links {
      link
      linkInNewWindow
      linkText
      linkType
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Story {
    __typename
    blockId
    containerWidth
    postsToDisplay
    heading
    category {
      posts {
        nodes {
          id
          databaseId
          content
          title
          slug
          featuredImage {
            node {
              altText
              sourceUrl
              mediaDetails {
                height
                width
              }
            }
          }
        }
      }
    }
    selectedPosts {
      ... on Post {
        id
        databaseId
        content
        title
        slug
        featuredImage {
          node {
            altText
            sourceUrl
            mediaDetails {
              height
              width
            }
          }
        }
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_ContentList {
    __typename
    blockId
    containerWidth
    layout
    smallGap
    firstItemReversed
    list {
      content
      contentBg
      link
      linkInNewWindow
      linkText
      linkType
      linkPosition
      mediaIsCover
      video {
        mediaItemUrl
        mimeType
      }
      image {
        altText
        sourceUrl
        srcSet
        sizes
        mediaDetails {
          height
          width
        }
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Nav {
    fieldGroupName
    links {
      linkId
      linkText
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_WowForm {
    fieldGroupName
    __typename
    terms
    successModalTitle
    successModalDescription
    steps {
      ... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_Text {
        __typename
        description
        title
        fieldGroupName
        textCtaUrl
        textCtaLabel
      }
      ... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_Form {
        __typename
        description
        title
        fieldGroupName
      }
      ... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_TextRules {
        __typename
        ctaLabel
        ctaUrl
        description
        fieldGroupName
        title
        rulesItems {
          text
          fieldGroupName
        }
        rulesTitle
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_ColoredHero {
    backgroundColor
    blockId
    description
    eyebrow
    heading
    textColor
    fieldGroupName
  }
  ... on KiaModule_Pagebuilder_Blocks_Table {
    blockId
    containerWidth
    cols {
      colLabel
    }
    rows {
      rowLabel
      rowCells {
        cellContent
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Tabs {
    __typename
    blockId
    containerWidth
    title
    tabs {
      label
      columns {
        content
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Faqs {
    __typename
    blockId
    containerWidth
    title
    faqs {
      label
      content
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Iframe {
    __typename
    blockId
    containerWidth
    title
    url
    editor
  }
  ... on KiaModule_Pagebuilder_Blocks_Logotypes {
    __typename
    blockId
    containerWidth
    title
    gallery {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_CarCarouselGrid {
    __typename
    blockId
    displayDescriptions
    displayLeasing
    displayCta
    displayPrices
    imageType
    selectedCars {
      kiaTrims
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_CarCarousel {
    __typename
    blockId
    displayDescriptions
    displayLeasing
    displayCta
    displayPrices
    functions
    businessEdition
    imageType
  }
  ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock {
    __typename
    margins
    columns {
      width
      colAligment
      content {
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_TextBlock {
          __typename
          editor
        }
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ImageBlock {
          __typename
          focalX
          focalY
          image {
            altText
            sourceUrl
            srcSet
            sizes
            mediaDetails {
              height
              width
            }
          }
        }
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ButtonBlock {
          __typename
          style
          alignment
          link {
            url
            title
            target
          }
        }
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_VideoBlock {
          __typename
          autoplay
          videoFile {
            sourceUrl
            mimeType
          }
          posterImage {
            sourceUrl
            altText
            srcSet
            sizes
            mediaDetails {
              height
              width
            }
          }
        }
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_SpacerBlock {
          __typename
          height
        }
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Newsletter {
    __typename
    buttonText
    description
    emailPlaceholder
    fieldGroupName
    headline
    successMessage
    termsText
    theme
  }
  ... on KiaModule_Pagebuilder_Blocks_FeatureBenefitBlockWithImage {
    __typename
    backgroundColor
    content
    color
    headline
    topHeadline
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_LaddboxBlock {
    __typename
    title
    description
    laddboxOptions {
      title
      description
      price
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_ImageTextButton {
    __typename
    content
    fieldGroupName
    subtitle
    title
    buttonLink {
      target
      title
      url
    }
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
}`, {
    "fragmentName": "PageBuilderBlocks"
});
const $013fa4b548d7755f$export$a22063866414d174 = new $013fa4b548d7755f$export$1752a241e7cd2088(`
    query GetPageBySlug($uri: ID!) {
  kiaPage(id: $uri, idType: URI) {
    databaseId
    pagebuilder {
      blocks {
        ...PageBuilderBlocks
      }
    }
  }
}
    fragment ModuleBuilderBlocks on KiaModule_Pagebuilder_Blocks {
  __typename
  ... on KiaModule_Pagebuilder_Blocks_Hero {
    __typename
    editor
    editorPosition
    containerWidth
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    videoHasControls
  }
  ... on KiaModule_Pagebuilder_Blocks_Texteditor {
    __typename
    blockId
    containerWidth
    bgColor
    content
    links {
      link
      linkInNewWindow
      linkText
      linkType
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Image {
    __typename
    blockId
    containerWidth
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    videoHasControls
  }
  ... on KiaModule_Pagebuilder_Blocks_TextMedia {
    __typename
    blockId
    containerWidth
    mediaType
    mediaPosition
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    youtube
    mediaIsCover
    videoHasAutoplay
    videoHasControls
    link
    linkText
    linkInNewWindow
    linkType
    linkPosition
    contentBg
    content
  }
  ... on KiaModule_Pagebuilder_Blocks_Gallery {
    __typename
    blockId
    containerWidth
    galleryItems {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Checklist {
    __typename
    blockId
    containerWidth
    iconPosition
    list {
      text
    }
    links {
      link
      linkInNewWindow
      linkText
      linkType
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Story {
    __typename
    blockId
    containerWidth
    postsToDisplay
    heading
    category {
      posts {
        nodes {
          id
          databaseId
          content
          title
          slug
          featuredImage {
            node {
              altText
              sourceUrl
              mediaDetails {
                height
                width
              }
            }
          }
        }
      }
    }
    selectedPosts {
      ... on Post {
        id
        databaseId
        content
        title
        slug
        featuredImage {
          node {
            altText
            sourceUrl
            mediaDetails {
              height
              width
            }
          }
        }
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_ContentList {
    __typename
    blockId
    containerWidth
    layout
    smallGap
    firstItemReversed
    list {
      content
      contentBg
      link
      linkInNewWindow
      linkText
      linkType
      linkPosition
      mediaIsCover
      video {
        mediaItemUrl
        mimeType
      }
      image {
        altText
        sourceUrl
        srcSet
        sizes
        mediaDetails {
          height
          width
        }
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Nav {
    fieldGroupName
    links {
      linkId
      linkText
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_WowForm {
    fieldGroupName
    __typename
    terms
    successModalTitle
    successModalDescription
    steps {
      ... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_Text {
        __typename
        description
        title
        fieldGroupName
        textCtaUrl
        textCtaLabel
      }
      ... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_Form {
        __typename
        description
        title
        fieldGroupName
      }
      ... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_TextRules {
        __typename
        ctaLabel
        ctaUrl
        description
        fieldGroupName
        title
        rulesItems {
          text
          fieldGroupName
        }
        rulesTitle
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_ColoredHero {
    backgroundColor
    blockId
    description
    eyebrow
    heading
    textColor
    fieldGroupName
  }
  ... on KiaModule_Pagebuilder_Blocks_Table {
    blockId
    containerWidth
    cols {
      colLabel
    }
    rows {
      rowLabel
      rowCells {
        cellContent
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Tabs {
    __typename
    blockId
    containerWidth
    title
    tabs {
      label
      columns {
        content
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Faqs {
    __typename
    blockId
    containerWidth
    title
    faqs {
      label
      content
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Iframe {
    __typename
    blockId
    containerWidth
    title
    url
    editor
  }
  ... on KiaModule_Pagebuilder_Blocks_Logotypes {
    __typename
    blockId
    containerWidth
    title
    gallery {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_CarCarouselGrid {
    __typename
    blockId
    displayDescriptions
    displayLeasing
    displayCta
    displayPrices
    imageType
    selectedCars {
      kiaTrims
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_CarCarousel {
    __typename
    blockId
    displayDescriptions
    displayLeasing
    displayCta
    displayPrices
    functions
    businessEdition
    imageType
  }
  ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock {
    __typename
    margins
    columns {
      width
      colAligment
      content {
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_TextBlock {
          __typename
          editor
        }
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ImageBlock {
          __typename
          focalX
          focalY
          image {
            altText
            sourceUrl
            srcSet
            sizes
            mediaDetails {
              height
              width
            }
          }
        }
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ButtonBlock {
          __typename
          style
          alignment
          link {
            url
            title
            target
          }
        }
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_VideoBlock {
          __typename
          autoplay
          videoFile {
            sourceUrl
            mimeType
          }
          posterImage {
            sourceUrl
            altText
            srcSet
            sizes
            mediaDetails {
              height
              width
            }
          }
        }
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_SpacerBlock {
          __typename
          height
        }
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Newsletter {
    __typename
    buttonText
    description
    emailPlaceholder
    fieldGroupName
    headline
    successMessage
    termsText
    theme
  }
  ... on KiaModule_Pagebuilder_Blocks_FeatureBenefitBlockWithImage {
    __typename
    backgroundColor
    content
    color
    headline
    topHeadline
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_LaddboxBlock {
    __typename
    title
    description
    laddboxOptions {
      title
      description
      price
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_ImageTextButton {
    __typename
    content
    fieldGroupName
    subtitle
    title
    buttonLink {
      target
      title
      url
    }
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
}
fragment PageBuilderBlocks on KiaPage_Pagebuilder_Blocks {
  __typename
  ... on KiaPage_Pagebuilder_Blocks_Hero {
    __typename
    editor
    editorPosition
    containerWidth
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    videoHasControls
  }
  ... on KiaPage_Pagebuilder_Blocks_Texteditor {
    __typename
    blockId
    containerWidth
    bgColor
    content
    links {
      link
      linkInNewWindow
      linkText
      linkType
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_Image {
    __typename
    blockId
    containerWidth
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    videoHasControls
  }
  ... on KiaPage_Pagebuilder_Blocks_TextMedia {
    __typename
    blockId
    containerWidth
    mediaType
    mediaPosition
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    youtube
    mediaIsCover
    videoHasAutoplay
    videoHasControls
    link
    linkText
    linkInNewWindow
    linkType
    linkPosition
    contentBg
    content
  }
  ... on KiaPage_Pagebuilder_Blocks_Gallery {
    __typename
    blockId
    containerWidth
    galleryItems {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_Checklist {
    __typename
    blockId
    containerWidth
    iconPosition
    list {
      text
    }
    links {
      link
      linkInNewWindow
      linkText
      linkType
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_Story {
    __typename
    blockId
    containerWidth
    postsToDisplay
    heading
    category {
      posts {
        nodes {
          id
          databaseId
          content
          title
          slug
          featuredImage {
            node {
              altText
              sourceUrl
              mediaDetails {
                height
                width
              }
            }
          }
        }
      }
    }
    selectedPosts {
      ... on Post {
        id
        databaseId
        content
        title
        slug
        featuredImage {
          node {
            altText
            sourceUrl
            mediaDetails {
              height
              width
            }
          }
        }
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_ContentList {
    __typename
    blockId
    containerWidth
    layout
    smallGap
    firstItemReversed
    list {
      content
      contentBg
      link
      linkInNewWindow
      linkText
      linkType
      linkPosition
      mediaIsCover
      video {
        mediaItemUrl
        mimeType
      }
      image {
        altText
        sourceUrl
        srcSet
        sizes
        mediaDetails {
          height
          width
        }
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_Nav {
    fieldGroupName
    links {
      linkId
      linkText
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_WowForm {
    fieldGroupName
    __typename
    terms
    successModalTitle
    successModalDescription
    steps {
      ... on KiaPage_Pagebuilder_Blocks_WowForm_Steps_Text {
        __typename
        description
        title
        fieldGroupName
        textCtaUrl
        textCtaLabel
      }
      ... on KiaPage_Pagebuilder_Blocks_WowForm_Steps_Form {
        __typename
        description
        title
        fieldGroupName
      }
      ... on KiaPage_Pagebuilder_Blocks_WowForm_Steps_TextRules {
        __typename
        ctaLabel
        ctaUrl
        description
        fieldGroupName
        title
        rulesItems {
          text
          fieldGroupName
        }
        rulesTitle
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_ColoredHero {
    backgroundColor
    blockId
    description
    eyebrow
    heading
    textColor
    fieldGroupName
  }
  ... on KiaPage_Pagebuilder_Blocks_Table {
    blockId
    containerWidth
    cols {
      colLabel
    }
    rows {
      rowLabel
      rowCells {
        cellContent
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_Tabs {
    __typename
    blockId
    containerWidth
    title
    tabs {
      label
      columns {
        content
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_Faqs {
    __typename
    blockId
    containerWidth
    title
    faqs {
      label
      content
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_Iframe {
    __typename
    blockId
    containerWidth
    title
    url
    editor
  }
  ... on KiaPage_Pagebuilder_Blocks_Logotypes {
    __typename
    blockId
    containerWidth
    title
    gallery {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_CarCarouselGrid {
    __typename
    blockId
    displayDescriptions
    displayLeasing
    displayCta
    displayPrices
    imageType
    selectedCars {
      kiaTrims
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_CarCarousel {
    __typename
    blockId
    displayDescriptions
    displayLeasing
    displayCta
    displayPrices
    functions
    businessEdition
    imageType
  }
  ... on KiaPage_Pagebuilder_Blocks_ColumnsBlock {
    __typename
    margins
    columns {
      width
      colAligment
      content {
        ... on KiaPage_Pagebuilder_Blocks_ColumnsBlock_columns_Content_TextBlock {
          __typename
          editor
        }
        ... on KiaPage_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ImageBlock {
          __typename
          focalX
          focalY
          image {
            altText
            sourceUrl
            srcSet
            sizes
            mediaDetails {
              height
              width
            }
          }
        }
        ... on KiaPage_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ButtonBlock {
          __typename
          style
          alignment
          link {
            url
            title
            target
          }
        }
        ... on KiaPage_Pagebuilder_Blocks_ColumnsBlock_columns_Content_VideoBlock {
          __typename
          autoplay
          videoFile {
            sourceUrl
            mimeType
          }
          posterImage {
            sourceUrl
            altText
            srcSet
            sizes
            mediaDetails {
              height
              width
            }
          }
        }
        ... on KiaPage_Pagebuilder_Blocks_ColumnsBlock_columns_Content_SpacerBlock {
          __typename
          height
        }
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_Newsletter {
    __typename
    buttonText
    description
    emailPlaceholder
    fieldGroupName
    headline
    successMessage
    termsText
    theme
  }
  ... on KiaPage_Pagebuilder_Blocks_FeatureBenefitBlockWithImage {
    __typename
    backgroundColor
    content
    color
    headline
    topHeadline
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_LaddboxBlock {
    __typename
    title
    description
    laddboxOptions {
      title
      description
      price
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_ImageTextButton {
    __typename
    content
    fieldGroupName
    subtitle
    title
    buttonLink {
      target
      title
      url
    }
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaPage_Pagebuilder_Blocks_LayoutKiaModules {
    __typename
    globalModule {
      ... on KiaModule {
        pagebuilder {
          blocks {
            ...ModuleBuilderBlocks
          }
        }
      }
    }
  }
}`);
const $013fa4b548d7755f$export$e19cfb113eb09290 = new $013fa4b548d7755f$export$1752a241e7cd2088(`
    query GetModuleBySlug($uri: ID!) {
  kiaModule(id: $uri, idType: URI) {
    databaseId
    pagebuilder {
      blocks {
        ...ModuleBuilderBlocks
      }
    }
  }
}
    fragment ModuleBuilderBlocks on KiaModule_Pagebuilder_Blocks {
  __typename
  ... on KiaModule_Pagebuilder_Blocks_Hero {
    __typename
    editor
    editorPosition
    containerWidth
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    videoHasControls
  }
  ... on KiaModule_Pagebuilder_Blocks_Texteditor {
    __typename
    blockId
    containerWidth
    bgColor
    content
    links {
      link
      linkInNewWindow
      linkText
      linkType
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Image {
    __typename
    blockId
    containerWidth
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    videoHasControls
  }
  ... on KiaModule_Pagebuilder_Blocks_TextMedia {
    __typename
    blockId
    containerWidth
    mediaType
    mediaPosition
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    imageMobile {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
    video {
      mediaItemUrl
      mimeType
    }
    videoMobile {
      mediaItemUrl
      mimeType
    }
    youtube
    mediaIsCover
    videoHasAutoplay
    videoHasControls
    link
    linkText
    linkInNewWindow
    linkType
    linkPosition
    contentBg
    content
  }
  ... on KiaModule_Pagebuilder_Blocks_Gallery {
    __typename
    blockId
    containerWidth
    galleryItems {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Checklist {
    __typename
    blockId
    containerWidth
    iconPosition
    list {
      text
    }
    links {
      link
      linkInNewWindow
      linkText
      linkType
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Story {
    __typename
    blockId
    containerWidth
    postsToDisplay
    heading
    category {
      posts {
        nodes {
          id
          databaseId
          content
          title
          slug
          featuredImage {
            node {
              altText
              sourceUrl
              mediaDetails {
                height
                width
              }
            }
          }
        }
      }
    }
    selectedPosts {
      ... on Post {
        id
        databaseId
        content
        title
        slug
        featuredImage {
          node {
            altText
            sourceUrl
            mediaDetails {
              height
              width
            }
          }
        }
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_ContentList {
    __typename
    blockId
    containerWidth
    layout
    smallGap
    firstItemReversed
    list {
      content
      contentBg
      link
      linkInNewWindow
      linkText
      linkType
      linkPosition
      mediaIsCover
      video {
        mediaItemUrl
        mimeType
      }
      image {
        altText
        sourceUrl
        srcSet
        sizes
        mediaDetails {
          height
          width
        }
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Nav {
    fieldGroupName
    links {
      linkId
      linkText
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_WowForm {
    fieldGroupName
    __typename
    terms
    successModalTitle
    successModalDescription
    steps {
      ... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_Text {
        __typename
        description
        title
        fieldGroupName
        textCtaUrl
        textCtaLabel
      }
      ... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_Form {
        __typename
        description
        title
        fieldGroupName
      }
      ... on KiaModule_Pagebuilder_Blocks_WowForm_Steps_TextRules {
        __typename
        ctaLabel
        ctaUrl
        description
        fieldGroupName
        title
        rulesItems {
          text
          fieldGroupName
        }
        rulesTitle
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_ColoredHero {
    backgroundColor
    blockId
    description
    eyebrow
    heading
    textColor
    fieldGroupName
  }
  ... on KiaModule_Pagebuilder_Blocks_Table {
    blockId
    containerWidth
    cols {
      colLabel
    }
    rows {
      rowLabel
      rowCells {
        cellContent
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Tabs {
    __typename
    blockId
    containerWidth
    title
    tabs {
      label
      columns {
        content
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Faqs {
    __typename
    blockId
    containerWidth
    title
    faqs {
      label
      content
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Iframe {
    __typename
    blockId
    containerWidth
    title
    url
    editor
  }
  ... on KiaModule_Pagebuilder_Blocks_Logotypes {
    __typename
    blockId
    containerWidth
    title
    gallery {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_CarCarouselGrid {
    __typename
    blockId
    displayDescriptions
    displayLeasing
    displayCta
    displayPrices
    imageType
    selectedCars {
      kiaTrims
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_CarCarousel {
    __typename
    blockId
    displayDescriptions
    displayLeasing
    displayCta
    displayPrices
    functions
    businessEdition
    imageType
  }
  ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock {
    __typename
    margins
    columns {
      width
      colAligment
      content {
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_TextBlock {
          __typename
          editor
        }
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ImageBlock {
          __typename
          focalX
          focalY
          image {
            altText
            sourceUrl
            srcSet
            sizes
            mediaDetails {
              height
              width
            }
          }
        }
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ButtonBlock {
          __typename
          style
          alignment
          link {
            url
            title
            target
          }
        }
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_VideoBlock {
          __typename
          autoplay
          videoFile {
            sourceUrl
            mimeType
          }
          posterImage {
            sourceUrl
            altText
            srcSet
            sizes
            mediaDetails {
              height
              width
            }
          }
        }
        ... on KiaModule_Pagebuilder_Blocks_ColumnsBlock_columns_Content_SpacerBlock {
          __typename
          height
        }
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_Newsletter {
    __typename
    buttonText
    description
    emailPlaceholder
    fieldGroupName
    headline
    successMessage
    termsText
    theme
  }
  ... on KiaModule_Pagebuilder_Blocks_FeatureBenefitBlockWithImage {
    __typename
    backgroundColor
    content
    color
    headline
    topHeadline
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_LaddboxBlock {
    __typename
    title
    description
    laddboxOptions {
      title
      description
      price
    }
  }
  ... on KiaModule_Pagebuilder_Blocks_ImageTextButton {
    __typename
    content
    fieldGroupName
    subtitle
    title
    buttonLink {
      target
      title
      url
    }
    image {
      altText
      sourceUrl
      srcSet
      sizes
      mediaDetails {
        height
        width
      }
    }
  }
}`);
const $013fa4b548d7755f$export$d805aec1ce86d7d1 = new $013fa4b548d7755f$export$1752a241e7cd2088(`
    query GetLatestPosts($first: Int = 3) {
  posts(first: $first) {
    nodes {
      id
      databaseId
      content
      title
      link
      slug
      featuredImage {
        node {
          altText
          sourceUrl
          mediaDetails {
            height
            width
          }
        }
      }
    }
  }
}
    `);
const $013fa4b548d7755f$export$f91d6ecc2975f3bc = new $013fa4b548d7755f$export$1752a241e7cd2088(`
    query GetSlugs {
  kiaPages(first: 100) {
    nodes {
      slug
      uri
    }
  }
}
    `);
const $013fa4b548d7755f$export$c665217981744c50 = new $013fa4b548d7755f$export$1752a241e7cd2088(`
    query GetModuleSlugs {
  kiaModules(first: 100) {
    nodes {
      slug
      uri
    }
  }
}
    `);

});





parcelRegister("bFToE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e11e93138575a85$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4HHSP = parcelRequire("4HHSP");

var $km9hE = parcelRequire("km9hE");

var $8FY87 = parcelRequire("8FY87");

var $7VxdU = parcelRequire("7VxdU");
function $7e11e93138575a85$var$Toolbar({ isPreviewMode: isPreviewMode, setPreviewMode: setPreviewMode, databaseId: databaseId, isRefetching: isRefetching, refetch: refetch, uri: uri, children: children, page: page = 'page' }) {
    const [isLoading, setIsLoading] = (0, $8FY87.useState)(false);
    const [showSuccess, setShowSuccess] = (0, $8FY87.useState)(false);
    const state = (0, $8FY87.useRef)({
        fetchDone: false,
        minDone: false
    });
    const prevIsRefetching = (0, $8FY87.useRef)(isRefetching);
    const tryFinish = ()=>{
        if (state.current.fetchDone && state.current.minDone) {
            setIsLoading(false);
            setShowSuccess(true);
            setTimeout(()=>setShowSuccess(false), 2000);
        }
    };
    (0, $8FY87.useEffect)(()=>{
        if (prevIsRefetching.current && !isRefetching && isLoading) {
            state.current.fetchDone = true;
            tryFinish();
        }
        prevIsRefetching.current = isRefetching;
    }, [
        isRefetching
    ]);
    const onRefetch = ()=>{
        state.current = {
            fetchDone: false,
            minDone: false
        };
        setIsLoading(true);
        setShowSuccess(false);
        refetch();
        setTimeout(()=>{
            state.current.minDone = true;
            tryFinish();
        }, 1000);
    };
    const editUrl = databaseId ? `${"https://kia-blog.live.afonso.se"}/wp-admin/post.php?post=${databaseId}&action=edit` : '#';
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "fixed top-4 left-4 z-50 grid grid-cols-[auto_250px] gap-1",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "flex flex-col gap-1",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: "flex bg-gray-100 rounded p-1",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                        onClick: ()=>setPreviewMode(false),
                                        className: `flex-1 px-3 py-1 text-xs rounded transition-all ${!isPreviewMode ? 'bg-white text-green-700 shadow font-bold' : 'text-gray-500 hover:text-gray-700'}`,
                                        children: "Live"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                        onClick: ()=>setPreviewMode(true),
                                        className: `flex-1 px-3 py-1 text-xs rounded transition-all ${isPreviewMode ? 'bg-white text-blue-600 shadow font-bold' : 'text-gray-500 hover:text-gray-700'}`,
                                        children: "Preview"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: "flex gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                        href: editUrl,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "text-xs rounded text-white flex-1 bg-dark-blue py-1 no-underline grid place-content-center",
                                        children: "Edit"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                        className: `aspect-square grid place-content-center rounded border [&>svg]:w-4 h-6 transition-colors ${showSuccess ? 'bg-green-500 text-white border-green-500' : 'bg-white text-black border-black'} ${isLoading ? '[&>svg]:animate-spin' : ''}`,
                                        onClick: onRefetch,
                                        disabled: isLoading,
                                        children: showSuccess ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4HHSP.default), {}) : /*#__PURE__*/ (0, $2PPWI.jsx)((0, $km9hE.default), {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "opacity-25 hover:opacity-100 transition-opacity",
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $7VxdU.default), {
                page: page,
                props: `uri="${uri}"`
            })
        ]
    });
}
var $7e11e93138575a85$export$2e2bcd8739ae039 = $7e11e93138575a85$var$Toolbar;

});
parcelRegister("4HHSP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25272a914ec9d3e6$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");
const $25272a914ec9d3e6$var$CheckIconAnimated = ()=>{
    const [drawn, setDrawn] = (0, $8FY87.useState)(false);
    (0, $8FY87.useEffect)(()=>{
        requestAnimationFrame(()=>requestAnimationFrame(()=>setDrawn(true)));
    }, []);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "white",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "24",
        height: "24",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
            d: "M4 12l5 5L20 6",
            style: {
                strokeDasharray: 100,
                strokeDashoffset: drawn ? 0 : 100,
                transition: 'stroke-dashoffset 0.8s ease-in-out'
            }
        })
    });
};
var $25272a914ec9d3e6$export$2e2bcd8739ae039 = $25272a914ec9d3e6$var$CheckIconAnimated;

});

parcelRegister("km9hE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13c04ea4d094e4a4$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
const $13c04ea4d094e4a4$var$RefetchIcon = ()=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
            d: "M12 4a7.99 7.99 0 0 1 6.616 3.5H16v2h6v-6h-2V6a9.98 9.98 0 0 0-8-4C6.477 2 2 6.477 2 12h2a8 8 0 0 1 8-8m8 8a8 8 0 0 1-14.616 4.5H8v-2H2v6h2V18a9.98 9.98 0 0 0 8 4c5.523 0 10-4.477 10-10z"
        })
    });
};
var $13c04ea4d094e4a4$export$2e2bcd8739ae039 = $13c04ea4d094e4a4$var$RefetchIcon;

});

parcelRegister("7VxdU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91b599ff59c3eb0e$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $geEW9 = parcelRequire("geEW9");

var $1lSPe = parcelRequire("1lSPe");

var $kM2Bn = parcelRequire("kM2Bn");

var $fMrFX = parcelRequire("fMrFX");
const $91b599ff59c3eb0e$var$CDN_URL = 'https://kia-pages-cdn.vercel.app';
const $91b599ff59c3eb0e$var$kebabize = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
const $91b599ff59c3eb0e$var$makeIntoDataProp = (propsString = '')=>{
    if (!propsString) return '';
    const matches = propsString.match(/([a-zA-ZäöåÄÖÅ-]+)="([^"]*)"/g);
    if (!matches) return '';
    return matches.map((e)=>{
        const [key, value] = e.split(/=(.+)/);
        return `data-${$91b599ff59c3eb0e$var$kebabize(key)}=${value}`;
    }).join(' ');
};
function $91b599ff59c3eb0e$export$2e2bcd8739ae039({ page: page, props: props }) {
    if ((0, $1lSPe.locationIsKia)()) return null;
    const [isOpen, setIsOpen] = (0, $8FY87.useState)(false);
    const [includeFont, setIncludeFont] = (0, $8FY87.useState)(false);
    const [copiedValue, copy] = (0, $geEW9.useCopyToClipboard)();
    const [isCopied, setIsCopied] = (0, $8FY87.useState)(false);
    const fullSnippet = (0, $8FY87.useMemo)(()=>{
        const js = `<script type="module" src="${$91b599ff59c3eb0e$var$CDN_URL}/prod/load.js"></script>`;
        const dataAttributes = $91b599ff59c3eb0e$var$makeIntoDataProp(props);
        const fontAttribute = includeFont ? 'data-include-font' : '';
        const html = `<div id="kia-page" data-kia-page="${page}" ${dataAttributes} ${fontAttribute}></div>`.replace(/\s+/g, ' ');
        return `${js}\n${html}`;
    }, [
        page,
        props,
        includeFont
    ]);
    const handleCopy = ()=>{
        copy(fullSnippet);
        setIsCopied(true);
        setTimeout(()=>setIsCopied(false), 2000);
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                onClick: ()=>setIsOpen(true),
                className: "fixed bottom-4 right-4 z-50 rounded-lg border border-white bg-black px-4 py-2 text-sm font-medium text-white shadow-lg hover:bg-gray-900 transition-colors",
                children: "Visa kodsnutt"
            }),
            isOpen && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kM2Bn.default), {
                clickOutside: ()=>setIsOpen(false),
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "w-full max-w-lg bg-white p-6 rounded-lg shadow-xl",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                            className: "mb-2 text-center text-xl font-bold text-gray-900",
                            children: "Kodsnutt"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                            className: "mb-6 text-center text-sm ",
                            children: [
                                "Kopiera koden nedan och klistra in d\xe4r du vill att sidan ska visas.",
                                /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                    className: "text-xs italic",
                                    children: "Obs: Script-taggen beh\xf6ver bara laddas en g\xe5ng per sida."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: "flex items-center justify-between p-4 rounded-lg border mb-4",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                    className: "flex flex-col",
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                        htmlFor: "include-font",
                                        className: "text-sm font-medium cursor-pointer",
                                        children: "Inkludera Kia typsnitt"
                                    })
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("label", {
                                    className: "relative inline-flex items-center cursor-pointer",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                            type: "checkbox",
                                            id: "include-font",
                                            checked: includeFont,
                                            onChange: (e)=>setIncludeFont(e.target.checked),
                                            className: "sr-only peer"
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                            className: "w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-black/30 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-black"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: "relative mb-6 overflow-hidden rounded-lg bg-gray-900 text-white",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("pre", {
                                className: "max-h-64 overflow-auto p-4 text-xs font-mono leading-relaxed select-all",
                                children: fullSnippet
                            })
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: "flex gap-3",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                    onClick: handleCopy,
                                    className: `flex-1 rounded-md py-2.5 text-sm font-semibold transition-all ${isCopied ? 'bg-green-500 text-white' : 'bg-black text-white hover:bg-gray-800'}`,
                                    children: isCopied ? 'Kopierad!' : 'Kopiera kod'
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                    onClick: ()=>setIsOpen(false),
                                    className: "rounded-md border border-gray-300 bg-white px-6 py-2.5 text-sm font-semibold text-gray-700 hover:bg-gray-50",
                                    children: "St\xe4ng"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $fMrFX.default), {
                page: page,
                props: props
            })
        ]
    });
}

});


parcelRegister("jSvAS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa2b10e32e62b337$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $5muPu = parcelRequire("5muPu");

var $g0kcG = parcelRequire("g0kcG");

var $gjTaf = parcelRequire("gjTaf");

var $3C7AF = parcelRequire("3C7AF");

var $esPus = parcelRequire("esPus");

var $7kMse = parcelRequire("7kMse");

var $77tYj = parcelRequire("77tYj");

var $4aBZ2 = parcelRequire("4aBZ2");

var $keC7c = parcelRequire("keC7c");

var $hKQkl = parcelRequire("hKQkl");

var $vtBlO = parcelRequire("vtBlO");

var $257OE = parcelRequire("257OE");

var $c0oib = parcelRequire("c0oib");

var $kha4G = parcelRequire("kha4G");

var $g1RTM = parcelRequire("g1RTM");

var $fy17o = parcelRequire("fy17o");

var $kSlSZ = parcelRequire("kSlSZ");

var $aKzpl = parcelRequire("aKzpl");

var $5w6Da = parcelRequire("5w6Da");

var $3lJNg = parcelRequire("3lJNg");

var $jLzDD = parcelRequire("jLzDD");
const $fa2b10e32e62b337$var$BLOCK_COMPONENTS = {
    KiaPage_Pagebuilder_Blocks_Hero: (0, $keC7c.default),
    KiaPage_Pagebuilder_Blocks_ColumnsBlock: (0, $esPus.default),
    KiaPage_Pagebuilder_Blocks_Texteditor: (0, $3lJNg.default),
    KiaPage_Pagebuilder_Blocks_Image: (0, $vtBlO.default),
    KiaPage_Pagebuilder_Blocks_Checklist: (0, $gjTaf.default),
    KiaPage_Pagebuilder_Blocks_ContentList: (0, $7kMse.default),
    KiaPage_Pagebuilder_Blocks_Gallery: (0, $4aBZ2.default),
    KiaPage_Pagebuilder_Blocks_Nav: (0, $g1RTM.default),
    KiaPage_Pagebuilder_Blocks_Table: (0, $kSlSZ.default),
    KiaPage_Pagebuilder_Blocks_Tabs: (0, $aKzpl.default),
    KiaPage_Pagebuilder_Blocks_Faqs: (0, $77tYj.default),
    KiaPage_Pagebuilder_Blocks_CarCarousel: (0, $5muPu.default),
    KiaPage_Pagebuilder_Blocks_CarCarouselGrid: (0, $g0kcG.default),
    KiaPage_Pagebuilder_Blocks_LaddboxBlock: (0, $c0oib.default),
    KiaPage_Pagebuilder_Blocks_LayoutKiaModules: (0, $257OE.default),
    KiaPage_Pagebuilder_Blocks_Iframe: (0, $hKQkl.default),
    KiaPage_Pagebuilder_Blocks_Logotypes: (0, $kha4G.default),
    KiaPage_Pagebuilder_Blocks_WowForm: (0, $jLzDD.default),
    KiaPage_Pagebuilder_Blocks_ColoredHero: (0, $3C7AF.default),
    KiaPage_Pagebuilder_Blocks_Story: (0, $fy17o.default),
    KiaPage_Pagebuilder_Blocks_TextMedia: (0, $5w6Da.default)
};
function $fa2b10e32e62b337$export$2e2bcd8739ae039({ blocks: blocks }) {
    (0, $8FY87.useEffect)(()=>{
        if (!blocks || !window.location.hash) return;
        const id = decodeURIComponent(window.location.hash.slice(1));
        const raf = requestAnimationFrame(()=>{
            document.getElementById(id)?.scrollIntoView();
        });
        return ()=>cancelAnimationFrame(raf);
    }, [
        blocks
    ]);
    if (!blocks) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: blocks.map((block, index)=>{
            if (!block) return null;
            const Component = $fa2b10e32e62b337$var$BLOCK_COMPONENTS[block.__typename];
            if (Component) return /*#__PURE__*/ (0, $2PPWI.jsx)(Component, {
                ...block,
                index: index
            }, index);
            return null;
        })
    });
}

});
parcelRegister("5muPu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83d54677f531f5b1$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $5ANQT = parcelRequire("5ANQT");

var $eRN6V = parcelRequire("eRN6V");

var $cO4th = parcelRequire("cO4th");
const $83d54677f531f5b1$var$CarCarousel = ({ blockId: blockId, displayCta: displayCta, displayDescriptions: displayDescriptions, functions: functions, displayPrices: displayPrices, displayLeasing: displayLeasing, imageType: imageType, businessEdition: businessEdition })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
        id: blockId ?? undefined,
        className: "w-full my-14 lg:my-24",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eRN6V.default), {
            hideControls: true,
            privateMileages: 'true',
            imageType: (0, $5ANQT.ImageTypeEnum)[imageType],
            fields: (0, $cO4th.formatFields)(functions, displayCta, displayDescriptions, displayPrices, displayLeasing),
            onlyBusinessEdition: businessEdition === 'Visa bara Business Edition' ? 'true' : undefined,
            includeBusinessEdition: businessEdition === 'Inkludera Business Edition' ? 'true' : undefined
        })
    });
};
var $83d54677f531f5b1$export$2e2bcd8739ae039 = $83d54677f531f5b1$var$CarCarousel;

});
parcelRegister("cO4th", function(module, exports) {

$parcel$export(module.exports, "getCarModel", function () { return $2e377bcc22c7bf40$export$1a82c98403801b9e; });
$parcel$export(module.exports, "formatFields", function () { return $2e377bcc22c7bf40$export$3bdd81914afda1ef; });
const $2e377bcc22c7bf40$export$1a82c98403801b9e = (cars)=>{
    if (cars.length < 0) return null;
    const models = [];
    const trims = [];
    cars.forEach((c)=>{
        const afterSemi = c.kiaTrims?.split(';')[1];
        const [model, trim] = afterSemi?.split(',') ?? [];
        models.push(model);
        trims.push(trim);
    });
    return {
        models: models.join(','),
        trims: trims.join(',')
    };
};
const $2e377bcc22c7bf40$export$3bdd81914afda1ef = (...fields)=>{
    return fields.flat().join(',');
};

});


parcelRegister("g0kcG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91e676e6cd0b1985$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $5ANQT = parcelRequire("5ANQT");

var $e4coK = parcelRequire("e4coK");

var $cO4th = parcelRequire("cO4th");
const $91e676e6cd0b1985$var$CarCarouselGrid = ({ blockId: blockId, selectedCars: selectedCars, displayCta: displayCta, displayDescriptions: displayDescriptions, displayPrices: displayPrices, displayLeasing: displayLeasing, imageType: imageType })=>{
    const selected = (0, $cO4th.getCarModel)(selectedCars);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
        id: blockId ?? undefined,
        className: "w-full my-14 lg:my-24",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e4coK.default), {
            hideControls: true,
            modelCodes: selected.models,
            trimCodes: selected.trims,
            imageType: (0, $5ANQT.ImageTypeEnum)[imageType],
            fields: (0, $cO4th.formatFields)(displayCta, displayDescriptions, displayPrices, displayLeasing)
        })
    });
};
var $91e676e6cd0b1985$export$2e2bcd8739ae039 = $91e676e6cd0b1985$var$CarCarouselGrid;

});

parcelRegister("gjTaf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $096864d7092b610c$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $655D0 = parcelRequire("655D0");

var $9UhZO = parcelRequire("9UhZO");

var $9rGkt = parcelRequire("9rGkt");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $1lSPe = parcelRequire("1lSPe");

var $eWIyH = parcelRequire("eWIyH");
const $096864d7092b610c$var$ChecklistBlock = ({ blockId: blockId, list: list, links: links, iconPosition: iconPosition, containerWidth: containerWidth })=>{
    if (!list || list && list.length < 1) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
        id: blockId ?? undefined,
        className: "w-full my-14 lg:my-24 px-4 md:px-0",
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: `w-full ${(0, $1lSPe.getContainerClass)(containerWidth)} ${iconPosition === 'left' ? '' : 'text-center -mt-2 lg:-mt-4'}`,
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).ul, {
                    initial: "hidden",
                    whileInView: "visible",
                    viewport: (0, $51Ucj.viewPort),
                    variants: (0, $51Ucj.containerVariants),
                    className: "flex flex-col lg:flex-row gap-8",
                    children: list.map((item, i)=>/*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).li, {
                            initial: "hidden",
                            whileInView: "visible",
                            viewport: (0, $51Ucj.viewPort),
                            variants: (0, $51Ucj.itemVariants),
                            className: `editor-checklist w-full flex ${iconPosition === 'left' ? 'flex-row items-start gap-2 lg:gap-3' : 'flex-col items-center gap-2 lg:gap-3'}`,
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9UhZO.default), {
                                    className: "w-5 min-w-5 h-5 mt-0.5"
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eWIyH.default), {
                                    children: item.text
                                })
                            ]
                        }, i))
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9rGkt.default), {
                    links: links,
                    onLinkClick: (0, $655D0.trackLinkClick)
                })
            ]
        })
    });
};
var $096864d7092b610c$export$2e2bcd8739ae039 = $096864d7092b610c$var$ChecklistBlock;

});
parcelRegister("9UhZO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55a5b6bf327bc8e4$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
const $55a5b6bf327bc8e4$var$CheckIcon = (props)=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 50 50",
        fill: "currentColor",
        ...props,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
            d: "M20 35 L10 25 L12.5 22.5 L20 30 L37.5 12.5 L40 15 L20 35 Z",
            fill: "currentColor",
            stroke: "currentColor",
            strokeWidth: "4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var $55a5b6bf327bc8e4$export$2e2bcd8739ae039 = $55a5b6bf327bc8e4$var$CheckIcon;

});

parcelRegister("9rGkt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72b463e1016df478$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $fdiy9 = parcelRequire("fdiy9");
const $72b463e1016df478$var$Links = ({ links: links, onLinkClick: onLinkClick })=>{
    if (!links || links.length === 0) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: "flex flex-wrap justify-center gap-4 lg:gap-8 mt-14",
        children: links.map((item, i)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $fdiy9.default), {
                onClick: onLinkClick,
                type: item.linkType,
                url: item.link,
                linkInNewWindow: item.linkInNewWindow,
                text: item.linkText
            }, i))
    });
};
var $72b463e1016df478$export$2e2bcd8739ae039 = $72b463e1016df478$var$Links;

});
parcelRegister("fdiy9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23b9a602f2be4f9e$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
const $23b9a602f2be4f9e$var$ButtonLink = ({ type: type = 'default', text: text, url: url, linkInNewWindow: linkInNewWindow, className: className, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
        href: url,
        onClick: onClick,
        target: linkInNewWindow ? '_blank' : '_self',
        className: `flex items-center justify-center min-w-72 px-2 py-3 no-underline underline-offset-2 hover:underline ${type === 'outline' ? 'border-2 border-black' : 'bg-black text-white border-2 border-black'} ${className || ''}`,
        children: text
    });
};
var $23b9a602f2be4f9e$export$2e2bcd8739ae039 = $23b9a602f2be4f9e$var$ButtonLink;

});


parcelRegister("eWIyH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d2f5fb53fba501e$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $5Otf1 = parcelRequire("5Otf1");
parcelRequire("5U22u");
var $9Uy4V = parcelRequire("9Uy4V");
var $5U22u = parcelRequire("5U22u");

var $jAgEx = parcelRequire("jAgEx");
var $4Qpe2 = parcelRequire("4Qpe2");

var $8FY87 = parcelRequire("8FY87");

var $51Ucj = parcelRequire("51Ucj");

var $3DQDh = parcelRequire("3DQDh");
const $7d2f5fb53fba501e$var$HEADING_TAGS = new Set([
    'h1',
    'h2',
    'h3'
]);
const $7d2f5fb53fba501e$var$VOID_ELEMENTS = new Set([
    'br',
    'hr',
    'input',
    'area',
    'base',
    'col',
    'embed',
    'link',
    'meta',
    'param',
    'source',
    'track',
    'wbr'
]);
function $7d2f5fb53fba501e$var$CyclingText({ nodes: nodes }) {
    const [index, setIndex] = (0, $8FY87.useState)(0);
    const { tag: tag, props: props, content: content } = nodes[index];
    const MotionTag = (0, $4Qpe2.m)[tag];
    (0, $8FY87.useEffect)(()=>{
        const timer = setInterval(()=>{
            setIndex((i)=>(i + 1) % nodes.length);
        }, 4000);
        return ()=>clearInterval(timer);
    }, [
        nodes.length
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: "cycle-wrapper",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jAgEx.AnimatePresence), {
            mode: "wait",
            children: /*#__PURE__*/ (0, $2PPWI.jsx)(MotionTag, {
                ...props,
                initial: {
                    opacity: 0,
                    y: 5
                },
                animate: {
                    opacity: 1,
                    y: 0
                },
                exit: {
                    opacity: 0,
                    y: -10
                },
                transition: {
                    ease: [
                        0.6,
                        0,
                        0.4,
                        1
                    ],
                    duration: 0.5
                },
                children: content
            }, index)
        })
    });
}
function $7d2f5fb53fba501e$export$2e2bcd8739ae039({ children: children, variants: variants, headingVariants: headingVariants, customViewport: customViewport, stripAnchors: stripAnchors }) {
    const html = typeof children === 'string' ? children : '';
    const options = {
        replace: (domNode)=>{
            // 1. Check if node is an HTML tag (Element)
            if (domNode instanceof (0, $9Uy4V.Element) && domNode.name) {
                const TagName = domNode.name;
                // 1b. If void elements have no children/innerHTML - let the parser render them natively instead of wrapping in a motion component with a `children` prop
                if ($7d2f5fb53fba501e$var$VOID_ELEMENTS.has(TagName)) return undefined;
                // 1c. If stripAnchors is set, unwrap <a> tags (keep their content, drop the tag) -
                // needed when this content is rendered inside an outer <a>, since <a> can't nest in <a>
                if (stripAnchors && TagName === 'a') return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
                    children: (0, $9Uy4V.domToReact)(domNode.children, options)
                });
                // 2. Check if this tag exists in 'm' (e.g. m.h1, m.div, m.p)
                // We cast 'm' to any to avoid strict type errors with dynamic keys
                const MotionComponent = (0, $4Qpe2.m)[TagName];
                // 3. Pick the right variants
                const activeVariants = $7d2f5fb53fba501e$var$HEADING_TAGS.has(TagName) && headingVariants ? headingVariants : variants;
                const isAnimatedTag = $7d2f5fb53fba501e$var$HEADING_TAGS.has(TagName) && !!headingVariants;
                // 4. Handle em with lineTextVariants
                if (TagName === 'p' && domNode.attribs.class?.split(' ').includes('draw-line')) {
                    const props = (0, $9Uy4V.attributesToProps)(domNode.attribs);
                    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).p, {
                        ...props,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).span, {
                                variants: (0, $51Ucj.lineTextVariants),
                                initial: "hidden",
                                whileInView: "visible",
                                viewport: customViewport ? customViewport : (0, $51Ucj.viewPort)
                            }),
                            (0, $9Uy4V.domToReact)(domNode.children, options)
                        ]
                    });
                }
                // 5. Replace raw <img> tags with CDNImage (before the motion swap
                // below, since `m` provides an m.img that would otherwise wrap this
                // void element with children and crash)
                if (TagName === 'img') {
                    const { src: src, alt: alt, width: width, height: height, class: className, srcset: srcset, sizes: sizes, loading: loading } = domNode.attribs;
                    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5Otf1.default), {
                        src: src || '',
                        alt: alt || '',
                        width: Number(width) || 0,
                        height: Number(height) || 0,
                        className: className,
                        srcSet: srcset,
                        sizes: sizes,
                        loading: loading === 'eager' ? 'eager' : 'lazy'
                    });
                }
                // 6. Handle repeating tags cycling animation
                if (TagName === 'div' && domNode.attribs.class?.split(' ').includes('cycle-wrapper')) {
                    const childElements = domNode.children.filter((n)=>n instanceof (0, $9Uy4V.Element));
                    if (childElements.length > 1) {
                        const cyclingNodes = childElements.map((child)=>({
                                tag: child.name,
                                content: (0, $9Uy4V.domToReact)(child.children, options),
                                props: (0, $9Uy4V.attributesToProps)(child.attribs)
                            }));
                        return /*#__PURE__*/ (0, $2PPWI.jsx)($7d2f5fb53fba501e$var$CyclingText, {
                            nodes: cyclingNodes
                        });
                    }
                }
                // 7. If a Motion component exists and we have variants, swap the tag
                if (MotionComponent && activeVariants) {
                    // Convert raw HTML attributes (class="foo") to React props (className="foo")
                    const props = (0, $9Uy4V.attributesToProps)(domNode.attribs);
                    return /*#__PURE__*/ (0, $2PPWI.jsx)(MotionComponent, {
                        ...props,
                        variants: activeVariants,
                        initial: "hidden",
                        whileInView: "visible",
                        viewport: isAnimatedTag && customViewport ? customViewport : (0, $51Ucj.viewPort),
                        children: (0, $9Uy4V.domToReact)(domNode.children, options)
                    });
                }
                // 8. If a Copy URL link
                if (TagName === 'a' && domNode.attribs.class?.split(' ').includes('copy-url')) {
                    const props = (0, $9Uy4V.attributesToProps)(domNode.attribs);
                    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3DQDh.default), {
                        className: props.className,
                        children: (0, $9Uy4V.domToReact)(domNode.children, options)
                    });
                }
            }
        }
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: (0, $5U22u.default)(html, options)
    });
}

});
parcelRegister("5Otf1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $975a062f01f938d6$export$2e2bcd8739ae039; });
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable jsx-a11y/alt-text */ 
var $2PPWI = parcelRequire("2PPWI");

var $3apdT = parcelRequire("3apdT");
'use client';
const $975a062f01f938d6$var$SRCSET_WIDTHS = [
    320,
    640,
    768,
    1024,
    1280,
    1536,
    1920
];
const $975a062f01f938d6$var$getUri = (link)=>{
    if (!link) return '';
    const slug = link.replace('', '').replace('', '');
    if (slug.startsWith('http://') || slug.startsWith('https://')) try {
        return new URL(slug).pathname.replace(/\/$/, '') || '/';
    } catch  {
        return '/';
    }
    return slug === '/' ? '/' : slug.replace(/\/$/, '');
};
const $975a062f01f938d6$var$buildCdnUrl = (src, width)=>{
    const cdn = "https://story-kia.b-cdn.net";
    if (!cdn) return src;
    const normalizedCdn = cdn.replace(/\/$/, '');
    const normalizedSrc = src.replace(/^\//, '');
    const params = new URLSearchParams();
    if (width) params.set('width', String(width));
    params.set('quality', '75');
    return `${normalizedCdn}/${normalizedSrc}?${params.toString()}`;
};
const $975a062f01f938d6$var$buildSrcSet = (src, maxWidth)=>{
    const widths = $975a062f01f938d6$var$SRCSET_WIDTHS.filter((w)=>w <= maxWidth);
    if (!widths.includes(maxWidth)) widths.push(maxWidth);
    return widths.map((w)=>`${$975a062f01f938d6$var$buildCdnUrl(src, w)} ${w}w`).join(', ');
};
const $975a062f01f938d6$var$CDNImage = (props)=>{
    const slug = $975a062f01f938d6$var$getUri(props.src);
    const cdnSrc = $975a062f01f938d6$var$buildCdnUrl(slug, props.width);
    const cdnSrcSet = $975a062f01f938d6$var$buildSrcSet(slug, props.width);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3apdT.default), {
        ...props,
        src: cdnSrc,
        srcSet: cdnSrcSet
    });
};
var $975a062f01f938d6$export$2e2bcd8739ae039 = $975a062f01f938d6$var$CDNImage;

});
parcelRegister("3apdT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2434087c4fe79ec$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
function $e2434087c4fe79ec$var$Image({ src: src, width: width, height: height, sizes: sizes, srcSet: srcSet, alt: alt, loading: loading = 'eager', className: className }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        width: width,
        height: height,
        loading: loading,
        alt: alt,
        className: className
    });
}
var $e2434087c4fe79ec$export$2e2bcd8739ae039 = $e2434087c4fe79ec$var$Image;

});


parcelRegister("5U22u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63f95c7b1227f2f9$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "attributesToProps", function () { return (parcelRequire("9Uy4V")).attributesToProps; });
$parcel$export(module.exports, "domToReact", function () { return (parcelRequire("9Uy4V")).domToReact; });
$parcel$export(module.exports, "Element", function () { return (parcelRequire("9Uy4V")).Element; });

var $9Uy4V = parcelRequire("9Uy4V");
var $63f95c7b1227f2f9$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($9Uy4V))).default || (0, (/*@__PURE__*/$parcel$interopDefault($9Uy4V)));

});
parcelRegister("9Uy4V", function(module, exports) {
"use strict";
var $7373c7446e08e848$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.htmlToDOM = module.exports.domToReact = module.exports.attributesToProps = module.exports.Text = module.exports.ProcessingInstruction = module.exports.Element = module.exports.Comment = void 0;
module.exports.default = $7373c7446e08e848$var$HTMLReactParser;

var $7373c7446e08e848$var$html_dom_parser_1 = $7373c7446e08e848$var$__importDefault((parcelRequire("4UDoz")));
module.exports.htmlToDOM = $7373c7446e08e848$var$html_dom_parser_1.default;

var $7373c7446e08e848$var$attributes_to_props_1 = $7373c7446e08e848$var$__importDefault((parcelRequire("fyw4V")));
module.exports.attributesToProps = $7373c7446e08e848$var$attributes_to_props_1.default;

var $7373c7446e08e848$var$dom_to_react_1 = $7373c7446e08e848$var$__importDefault((parcelRequire("0INbj")));
module.exports.domToReact = $7373c7446e08e848$var$dom_to_react_1.default;

var $ccG9h = parcelRequire("ccG9h");
Object.defineProperty(module.exports, "Comment", {
    enumerable: true,
    get: function() {
        return $ccG9h.Comment;
    }
});
Object.defineProperty(module.exports, "Element", {
    enumerable: true,
    get: function() {
        return $ccG9h.Element;
    }
});
Object.defineProperty(module.exports, "ProcessingInstruction", {
    enumerable: true,
    get: function() {
        return $ccG9h.ProcessingInstruction;
    }
});
Object.defineProperty(module.exports, "Text", {
    enumerable: true,
    get: function() {
        return $ccG9h.Text;
    }
});
var $7373c7446e08e848$var$domParserOptions = {
    lowerCaseAttributeNames: false
};
/**
 * Converts HTML string to React elements.
 *
 * @param html - HTML string.
 * @param options - Parser options.
 * @returns - React element(s), empty array, or string.
 */ function $7373c7446e08e848$var$HTMLReactParser(html, options) {
    var _a;
    if (typeof html !== 'string') throw new TypeError('First argument must be a string');
    if (!html) return [];
    return (0, $7373c7446e08e848$var$dom_to_react_1.default)((0, $7373c7446e08e848$var$html_dom_parser_1.default)(html, (_a = options === null || options === void 0 ? void 0 : options.htmlparser2) !== null && _a !== void 0 ? _a : $7373c7446e08e848$var$domParserOptions), options);
}

});
parcelRegister("4UDoz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $feeee5cf24362edf$export$2e2bcd8739ae039; });

var $jz6zg = parcelRequire("jz6zg");

var $h04Ol = parcelRequire("h04Ol");
var $feeee5cf24362edf$var$DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>
/**
 * Parses HTML string to DOM nodes in browser.
 *
 * @param html - HTML markup.
 * @returns - DOM elements.
 */ function $feeee5cf24362edf$export$2e2bcd8739ae039(html) {
    if (typeof html !== 'string') throw new TypeError('First argument must be a string');
    if (!html) return [];
    // match directive
    var match = $feeee5cf24362edf$var$DIRECTIVE_REGEX.exec(html);
    var directive = match ? match[1] : undefined;
    return (0, $h04Ol.formatDOM)((0, $jz6zg.default)(html), null, directive);
}

});
parcelRegister("jz6zg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80724a09c0e90904$export$2e2bcd8739ae039; });

var $h04Ol = parcelRequire("h04Ol");
// constants
var $80724a09c0e90904$var$HTML = 'html';
var $80724a09c0e90904$var$HEAD = 'head';
var $80724a09c0e90904$var$BODY = 'body';
var $80724a09c0e90904$var$FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
// falls back to `parseFromString` if `createHTMLDocument` cannot be used
/* eslint-disable @typescript-eslint/no-unused-vars */ /* istanbul ignore start */ var $80724a09c0e90904$var$parseFromDocument = function(html, tagName) {
    throw new Error('This browser does not support `document.implementation.createHTMLDocument`');
};
var $80724a09c0e90904$var$parseFromString = function(html, tagName) {
    throw new Error('This browser does not support `DOMParser.prototype.parseFromString`');
};
/* istanbul ignore stop */ /* eslint-enable @typescript-eslint/no-unused-vars */ var $80724a09c0e90904$var$DOMParser = typeof window === 'object' && window.DOMParser;
/**
 * DOMParser (performance: slow).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
 */ if (typeof $80724a09c0e90904$var$DOMParser === 'function') {
    var $80724a09c0e90904$var$domParser_1 = new $80724a09c0e90904$var$DOMParser();
    var $80724a09c0e90904$var$mimeType_1 = 'text/html';
    /**
     * Creates an HTML document using `DOMParser.parseFromString`.
     *
     * @param html - The HTML string.
     * @param tagName - The element to render the HTML (with 'body' as fallback).
     * @returns - Document.
     */ $80724a09c0e90904$var$parseFromString = function(html, tagName) {
        /* istanbul ignore start */ if (tagName) html = "<".concat(tagName, ">").concat(html, "</").concat(tagName, ">");
        /* istanbul ignore stop */ return $80724a09c0e90904$var$domParser_1.parseFromString(html, $80724a09c0e90904$var$mimeType_1);
    };
    $80724a09c0e90904$var$parseFromDocument = $80724a09c0e90904$var$parseFromString;
}
/**
 * DOMImplementation (performance: fair).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
 */ // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
if (typeof document === 'object' && document.implementation) {
    var $80724a09c0e90904$var$htmlDocument_1 = document.implementation.createHTMLDocument();
    /**
     * Use HTML document created by `document.implementation.createHTMLDocument`.
     *
     * @param html - The HTML string.
     * @param tagName - The element to render the HTML (with 'body' as fallback).
     * @returns - Document
     */ $80724a09c0e90904$var$parseFromDocument = function(html, tagName) {
        /* istanbul ignore start */ if (tagName) {
            var element = $80724a09c0e90904$var$htmlDocument_1.documentElement.querySelector(tagName);
            if (element) element.innerHTML = html;
            return $80724a09c0e90904$var$htmlDocument_1;
        }
        /* istanbul ignore stop */ $80724a09c0e90904$var$htmlDocument_1.documentElement.innerHTML = html;
        return $80724a09c0e90904$var$htmlDocument_1;
    };
}
/**
 * Template (performance: fast).
 *
 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
 */ var $80724a09c0e90904$var$template = typeof document === 'object' && document.createElement('template');
var $80724a09c0e90904$var$parseFromTemplate;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
if ($80724a09c0e90904$var$template && $80724a09c0e90904$var$template.content) /**
     * Uses a template element (content fragment) to parse HTML.
     *
     * @param html - HTML string.
     * @returns - Nodes.
     */ $80724a09c0e90904$var$parseFromTemplate = function(html) {
    $80724a09c0e90904$var$template.innerHTML = html;
    return $80724a09c0e90904$var$template.content.childNodes;
};
var $80724a09c0e90904$var$createNodeList = /* istanbul ignore next */ function() {
    return document.createDocumentFragment().childNodes;
};
/**
 * Parses HTML string to DOM nodes.
 *
 * @param html - HTML markup.
 * @returns - DOM nodes.
 */ function $80724a09c0e90904$export$2e2bcd8739ae039(html) {
    var _a, _b, _c, _d, _e, _f;
    // Escape special characters before parsing
    html = (0, $h04Ol.escapeSpecialCharacters)(html);
    var match = $80724a09c0e90904$var$FIRST_TAG_REGEX.exec(html);
    var firstTagName = (_a = match === null || match === void 0 ? void 0 : match[1]) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    switch(firstTagName){
        case $80724a09c0e90904$var$HTML:
            var doc = $80724a09c0e90904$var$parseFromString(html);
            // the created document may come with filler head/body elements,
            // so make sure to remove them if they don't actually exist
            if (!(0, $h04Ol.hasOpenTag)(html, $80724a09c0e90904$var$HEAD)) {
                var element = doc.querySelector($80724a09c0e90904$var$HEAD);
                /* istanbul ignore next */ (_b = element === null || element === void 0 ? void 0 : element.parentNode) === null || _b === void 0 || _b.removeChild(element);
            }
            if (!(0, $h04Ol.hasOpenTag)(html, $80724a09c0e90904$var$BODY)) {
                var element = doc.querySelector($80724a09c0e90904$var$BODY);
                /* istanbul ignore next */ (_c = element === null || element === void 0 ? void 0 : element.parentNode) === null || _c === void 0 || _c.removeChild(element);
            }
            return doc.querySelectorAll($80724a09c0e90904$var$HTML);
        case $80724a09c0e90904$var$HEAD:
        case $80724a09c0e90904$var$BODY:
            var elements = $80724a09c0e90904$var$parseFromDocument(html).querySelectorAll(firstTagName);
            // if there's a sibling element, then return both elements
            if ((0, $h04Ol.hasOpenTag)(html, $80724a09c0e90904$var$BODY) && (0, $h04Ol.hasOpenTag)(html, $80724a09c0e90904$var$HEAD)) /* istanbul ignore next */ return (_e = (_d = elements[0].parentNode) === null || _d === void 0 ? void 0 : _d.childNodes) !== null && _e !== void 0 ? _e : $80724a09c0e90904$var$createNodeList();
            return elements;
        // low-level tag or text
        default:
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if ($80724a09c0e90904$var$parseFromTemplate) return $80724a09c0e90904$var$parseFromTemplate(html);
            /* istanbul ignore start */ var element = $80724a09c0e90904$var$parseFromDocument(html, $80724a09c0e90904$var$BODY).querySelector($80724a09c0e90904$var$BODY);
            return (_f = element === null || element === void 0 ? void 0 : element.childNodes) !== null && _f !== void 0 ? _f : $80724a09c0e90904$var$createNodeList();
    }
}

});
parcelRegister("h04Ol", function(module, exports) {

$parcel$export(module.exports, "hasOpenTag", function () { return $8088c357cbc164b2$export$92fb61f01968c1e2; });
$parcel$export(module.exports, "escapeSpecialCharacters", function () { return $8088c357cbc164b2$export$1476d5e67a64a695; });
$parcel$export(module.exports, "formatDOM", function () { return $8088c357cbc164b2$export$82ef7ce8825bcfd1; });

var $1HQVj = parcelRequire("1HQVj");

var $cI5yb = parcelRequire("cI5yb");
/**
 * Gets case-sensitive tag name.
 *
 * @param tagName - Tag name in lowercase.
 * @returns - Case-sensitive tag name.
 */ function $8088c357cbc164b2$var$getCaseSensitiveTagName(tagName) {
    return (0, $1HQVj.CASE_SENSITIVE_TAG_NAMES_MAP)[tagName];
}
/**
 * Formats DOM attributes to a hash map.
 *
 * @param attributes - List of attributes.
 * @returns - Map of attribute name to value.
 */ function $8088c357cbc164b2$export$9ca5fb17560152b9(attributes) {
    var map = {};
    var index = 0;
    var attributesLength = attributes.length;
    // `NamedNodeMap` is array-like
    for(; index < attributesLength; index++){
        var attribute = attributes[index];
        map[attribute.name] = attribute.value;
    }
    return map;
}
/**
 * Corrects the tag name if it is case-sensitive (SVG).
 * Otherwise, returns the lowercase tag name (HTML).
 *
 * @param tagName - Lowercase tag name.
 * @returns - Formatted tag name.
 */ function $8088c357cbc164b2$var$formatTagName(tagName) {
    tagName = tagName.toLowerCase();
    var caseSensitiveTagName = $8088c357cbc164b2$var$getCaseSensitiveTagName(tagName);
    if (caseSensitiveTagName) return caseSensitiveTagName;
    return tagName;
}
/**
 * Checks if an HTML string contains an opening tag (case-insensitive).
 *
 * @param html - HTML string.
 * @param tagName - Tag name to search for (e.g., 'head' or 'body').
 * @returns - Whether the tag is found.
 */ function $8088c357cbc164b2$export$92fb61f01968c1e2(html, tagName) {
    var openTag = '<' + tagName;
    var index = html.toLowerCase().indexOf(openTag);
    if (index === -1) return false;
    var char = html[index + openTag.length];
    // the character after the tag name must be '>' or whitespace (for attributes)
    return char === '>' || char === ' ' || char === '\t' || char === '\n' || char === '\r' || char === '/';
}
/**
 * Escapes special characters before parsing.
 *
 * @param html - The HTML string.
 * @returns - HTML string with escaped special characters.
 */ function $8088c357cbc164b2$export$1476d5e67a64a695(html) {
    return html.replace((0, $1HQVj.CARRIAGE_RETURN_REGEX), (0, $1HQVj.CARRIAGE_RETURN_PLACEHOLDER));
}
/**
 * Reverts escaped special characters back to actual characters.
 *
 * @param text - The text with escaped characters.
 * @returns - Text with escaped characters reverted.
 */ function $8088c357cbc164b2$export$3de0d61d5f5490a3(text) {
    return text.replace((0, $1HQVj.CARRIAGE_RETURN_PLACEHOLDER_REGEX), (0, $1HQVj.CARRIAGE_RETURN));
}
/**
 * Transforms DOM nodes to `domhandler` nodes.
 *
 * @param nodes - DOM nodes.
 * @param parent - Parent node.
 * @param directive - Directive.
 * @returns - Nodes.
 */ function $8088c357cbc164b2$export$82ef7ce8825bcfd1(nodes, parent, directive) {
    var _a, _b, _c, _d;
    if (parent === void 0) parent = null;
    var domNodes = [];
    var current;
    var index = 0;
    var nodesLength = nodes.length;
    for(; index < nodesLength; index++){
        var node = nodes[index];
        // set the node data given the type
        switch(node.nodeType){
            case 1:
                var tagName = $8088c357cbc164b2$var$formatTagName(node.nodeName);
                // script, style, or tag
                current = new (0, $cI5yb.Element)(tagName, $8088c357cbc164b2$export$9ca5fb17560152b9(node.attributes));
                current.children = $8088c357cbc164b2$export$82ef7ce8825bcfd1(// template children are on content
                tagName === 'template' ? node.content.childNodes : node.childNodes, current);
                break;
            case 3:
                current = new (0, $cI5yb.Text)($8088c357cbc164b2$export$3de0d61d5f5490a3((_a = node.nodeValue) !== null && _a !== void 0 ? _a : ''));
                break;
            case 8:
                current = new (0, $cI5yb.Comment)((_b = node.nodeValue) !== null && _b !== void 0 ? _b : '');
                break;
            default:
                continue;
        }
        // set previous node next
        var prev = (_c = domNodes[index - 1]) !== null && _c !== void 0 ? _c : null;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (prev) prev.next = current;
        // set properties for current node
        current.parent = parent;
        current.prev = prev;
        current.next = null;
        domNodes.push(current);
    }
    if (directive) {
        current = new (0, $cI5yb.ProcessingInstruction)(directive.substring(0, directive.indexOf(' ')).toLowerCase(), directive);
        current.next = (_d = domNodes[0]) !== null && _d !== void 0 ? _d : null;
        current.parent = parent;
        domNodes.unshift(current);
        if (domNodes[1]) domNodes[1].prev = domNodes[0];
    }
    return domNodes;
}

});
parcelRegister("1HQVj", function(module, exports) {

$parcel$export(module.exports, "CASE_SENSITIVE_TAG_NAMES_MAP", function () { return $7d3e7e2627559b02$export$cc7d66f4b0ad10a1; });
$parcel$export(module.exports, "CARRIAGE_RETURN", function () { return $7d3e7e2627559b02$export$c8577a025d734268; });
$parcel$export(module.exports, "CARRIAGE_RETURN_REGEX", function () { return $7d3e7e2627559b02$export$a286a29a705a8769; });
$parcel$export(module.exports, "CARRIAGE_RETURN_PLACEHOLDER", function () { return $7d3e7e2627559b02$export$f712f15951939485; });
$parcel$export(module.exports, "CARRIAGE_RETURN_PLACEHOLDER_REGEX", function () { return $7d3e7e2627559b02$export$26af1302af5935c4; });
/**
 * SVG elements are case-sensitive.
 *
 * @see https://developer.mozilla.org/docs/Web/SVG/Element#svg_elements_a_to_z
 */ var $7d3e7e2627559b02$export$fe8547a1bfbc8a99 = [
    'animateMotion',
    'animateTransform',
    'clipPath',
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'foreignObject',
    'linearGradient',
    'radialGradient',
    'textPath'
];
var $7d3e7e2627559b02$export$cc7d66f4b0ad10a1 = $7d3e7e2627559b02$export$fe8547a1bfbc8a99.reduce(function(accumulator, tagName) {
    accumulator[tagName.toLowerCase()] = tagName;
    return accumulator;
}, {});
var $7d3e7e2627559b02$export$c8577a025d734268 = '\r';
var $7d3e7e2627559b02$export$a286a29a705a8769 = new RegExp($7d3e7e2627559b02$export$c8577a025d734268, 'g');
var $7d3e7e2627559b02$export$f712f15951939485 = "__HTML_DOM_PARSER_CARRIAGE_RETURN_PLACEHOLDER_".concat(Date.now().toString(), "__");
var $7d3e7e2627559b02$export$26af1302af5935c4 = new RegExp($7d3e7e2627559b02$export$f712f15951939485, 'g');

});

parcelRegister("cI5yb", function(module, exports) {

$parcel$export(module.exports, "Text", function () { return $ce708c57d5093e73$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Comment", function () { return $ce708c57d5093e73$export$4d299b491347818a; });
$parcel$export(module.exports, "ProcessingInstruction", function () { return $ce708c57d5093e73$export$9269dce19ee35e96; });
$parcel$export(module.exports, "Element", function () { return $ce708c57d5093e73$export$db77ccec0bb4ccac; });

var $eiqxC = parcelRequire("eiqxC");
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */ class $ce708c57d5093e73$export$85c928794f8d04d4 {
    constructor(){
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get previousSibling() {
        return this.prev;
    }
    set previousSibling(prev) {
        this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ cloneNode(recursive = false) {
        return $ce708c57d5093e73$export$ae8e35ea29ddac22(this, recursive);
    }
}
/**
 * A node that contains some data.
 */ class $ce708c57d5093e73$export$c3569d91cd44d357 extends $ce708c57d5093e73$export$85c928794f8d04d4 {
    /**
     * @param data The content of the data node
     */ constructor(data){
        super();
        this.data = data;
    }
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
}
/**
 * Text within the document.
 */ class $ce708c57d5093e73$export$5f1af8db9871e1d6 extends $ce708c57d5093e73$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $eiqxC.ElementType).Text;
    }
    get nodeType() {
        return 3;
    }
}
/**
 * Comments within the document.
 */ class $ce708c57d5093e73$export$4d299b491347818a extends $ce708c57d5093e73$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $eiqxC.ElementType).Comment;
    }
    get nodeType() {
        return 8;
    }
}
/**
 * Processing instructions, including doc types.
 */ class $ce708c57d5093e73$export$9269dce19ee35e96 extends $ce708c57d5093e73$export$c3569d91cd44d357 {
    constructor(name, data){
        super(data);
        this.name = name;
        this.type = (0, $eiqxC.ElementType).Directive;
    }
    get nodeType() {
        return 1;
    }
}
/**
 * A `Node` that can have children.
 */ class $ce708c57d5093e73$export$62be934f90997196 extends $ce708c57d5093e73$export$85c928794f8d04d4 {
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ constructor(children){
        super();
        this.children = children;
    }
    // Aliases
    /** First child of the node. */ get firstChild() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */ get lastChild() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
}
class $ce708c57d5093e73$export$1f8b8f7e5c763232 extends $ce708c57d5093e73$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $eiqxC.ElementType).CDATA;
    }
    get nodeType() {
        return 4;
    }
}
/**
 * The root node of the document.
 */ class $ce708c57d5093e73$export$b34a105447964f9f extends $ce708c57d5093e73$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $eiqxC.ElementType).Root;
    }
    get nodeType() {
        return 9;
    }
}
/**
 * An element within the DOM.
 */ class $ce708c57d5093e73$export$db77ccec0bb4ccac extends $ce708c57d5093e73$export$62be934f90997196 {
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ constructor(name, attribs, children = [], type = name === "script" ? (0, $eiqxC.ElementType).Script : name === "style" ? (0, $eiqxC.ElementType).Style : (0, $eiqxC.ElementType).Tag){
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name)=>{
            var _a, _b;
            return {
                name: name,
                value: this.attribs[name],
                namespace: (_a = this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
        });
    }
}
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */ function $ce708c57d5093e73$export$3bf645f08efe3292(node) {
    return (0, $eiqxC.isTag)(node);
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */ function $ce708c57d5093e73$export$c2d65aed98d39b56(node) {
    return node.type === (0, $eiqxC.ElementType).CDATA;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */ function $ce708c57d5093e73$export$1879817ac5c922b7(node) {
    return node.type === (0, $eiqxC.ElementType).Text;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */ function $ce708c57d5093e73$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $eiqxC.ElementType).Comment;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $ce708c57d5093e73$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $eiqxC.ElementType).Directive;
}
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $ce708c57d5093e73$export$62858bae88b53fd0(node) {
    return node.type === (0, $eiqxC.ElementType).Root;
}
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */ function $ce708c57d5093e73$export$ae8e35ea29ddac22(node, recursive = false) {
    let result;
    if ($ce708c57d5093e73$export$1879817ac5c922b7(node)) result = new $ce708c57d5093e73$export$5f1af8db9871e1d6(node.data);
    else if ($ce708c57d5093e73$export$3ab01370f5e64ac8(node)) result = new $ce708c57d5093e73$export$4d299b491347818a(node.data);
    else if ($ce708c57d5093e73$export$3bf645f08efe3292(node)) {
        const children = recursive ? $ce708c57d5093e73$var$cloneChildren(node.children) : [];
        const clone = new $ce708c57d5093e73$export$db77ccec0bb4ccac(node.name, {
            ...node.attribs
        }, children);
        children.forEach((child)=>child.parent = clone);
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = {
            ...node["x-attribsNamespace"]
        };
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = {
            ...node["x-attribsPrefix"]
        };
        result = clone;
    } else if ($ce708c57d5093e73$export$c2d65aed98d39b56(node)) {
        const children = recursive ? $ce708c57d5093e73$var$cloneChildren(node.children) : [];
        const clone = new $ce708c57d5093e73$export$1f8b8f7e5c763232(children);
        children.forEach((child)=>child.parent = clone);
        result = clone;
    } else if ($ce708c57d5093e73$export$62858bae88b53fd0(node)) {
        const children = recursive ? $ce708c57d5093e73$var$cloneChildren(node.children) : [];
        const clone = new $ce708c57d5093e73$export$b34a105447964f9f(children);
        children.forEach((child)=>child.parent = clone);
        if (node["x-mode"]) clone["x-mode"] = node["x-mode"];
        result = clone;
    } else if ($ce708c57d5093e73$export$4b5d79f26e0e3ad5(node)) {
        const instruction = new $ce708c57d5093e73$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error(`Not implemented yet: ${node.type}`);
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function $ce708c57d5093e73$var$cloneChildren(childs) {
    const children = childs.map((child)=>$ce708c57d5093e73$export$ae8e35ea29ddac22(child, true));
    for(let i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});
parcelRegister("eiqxC", function(module, exports) {

$parcel$export(module.exports, "ElementType", function () { return $d602cdda80fd083b$export$b992dc138d950e31; });
$parcel$export(module.exports, "isTag", function () { return $d602cdda80fd083b$export$3bf645f08efe3292; });
/** Types of elements found in htmlparser2's DOM */ var $d602cdda80fd083b$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($d602cdda80fd083b$export$b992dc138d950e31 || ($d602cdda80fd083b$export$b992dc138d950e31 = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */ function $d602cdda80fd083b$export$3bf645f08efe3292(elem) {
    return elem.type === $d602cdda80fd083b$export$b992dc138d950e31.Tag || elem.type === $d602cdda80fd083b$export$b992dc138d950e31.Script || elem.type === $d602cdda80fd083b$export$b992dc138d950e31.Style;
}
// Exports for backwards compatibility
/** Type for the root element of a document */ $d602cdda80fd083b$export$b992dc138d950e31.Root;
/** Type for Text */ $d602cdda80fd083b$export$b992dc138d950e31.Text;
/** Type for <? ... ?> */ $d602cdda80fd083b$export$b992dc138d950e31.Directive;
/** Type for <!-- ... --> */ $d602cdda80fd083b$export$b992dc138d950e31.Comment;
/** Type for <script> tags */ $d602cdda80fd083b$export$b992dc138d950e31.Script;
/** Type for <style> tags */ $d602cdda80fd083b$export$b992dc138d950e31.Style;
/** Type for Any tag */ $d602cdda80fd083b$export$b992dc138d950e31.Tag;
/** Type for <![CDATA[ ... ]]> */ $d602cdda80fd083b$export$b992dc138d950e31.CDATA;
/** Type for <!doctype ...> */ $d602cdda80fd083b$export$b992dc138d950e31.Doctype;

});





parcelRegister("fyw4V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b532ea1aff005e2a$var$attributesToProps;

var $k1Ter = parcelRequire("k1Ter");

var $ehDhU = parcelRequire("ehDhU");
// https://react.dev/learn/sharing-state-between-components#controlled-and-uncontrolled-components
// https://developer.mozilla.org/docs/Web/HTML/Attributes
var $b532ea1aff005e2a$var$UNCONTROLLED_COMPONENT_ATTRIBUTES = [
    'checked',
    'value'
];
var $b532ea1aff005e2a$var$UNCONTROLLED_COMPONENT_NAMES = [
    'input',
    'select',
    'textarea'
];
var $b532ea1aff005e2a$var$valueOnlyInputs = {
    reset: true,
    submit: true
};
/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param attributes - HTML/SVG DOM attributes.
 * @param nodeName - DOM node name.
 * @returns - React props.
 */ function $b532ea1aff005e2a$var$attributesToProps(attributes, nodeName) {
    if (attributes === void 0) attributes = {};
    var props = {};
    var isInputValueOnly = Boolean(attributes.type && $b532ea1aff005e2a$var$valueOnlyInputs[attributes.type]);
    for(var attributeName in attributes){
        var attributeValue = attributes[attributeName];
        // ARIA (aria-*) or custom data (data-*) attribute
        if ((0, $k1Ter.isCustomAttribute)(attributeName)) {
            props[attributeName] = attributeValue;
            continue;
        }
        // convert HTML/SVG attribute to React prop
        var attributeNameLowerCased = attributeName.toLowerCase();
        var propName = $b532ea1aff005e2a$var$getPropName(attributeNameLowerCased);
        if (propName) {
            var propertyInfo = (0, $k1Ter.getPropertyInfo)(propName);
            // convert attribute to uncontrolled component prop (e.g., `value` to `defaultValue`)
            if ($b532ea1aff005e2a$var$UNCONTROLLED_COMPONENT_ATTRIBUTES.includes(propName) && $b532ea1aff005e2a$var$UNCONTROLLED_COMPONENT_NAMES.includes(nodeName) && !isInputValueOnly) propName = $b532ea1aff005e2a$var$getPropName('default' + attributeNameLowerCased);
            props[propName] = attributeValue;
            switch(propertyInfo === null || propertyInfo === void 0 ? void 0 : propertyInfo.type){
                case $k1Ter.BOOLEAN:
                    props[propName] = true;
                    break;
                case $k1Ter.OVERLOADED_BOOLEAN:
                    if (attributeValue === '') props[propName] = true;
                    break;
            }
            continue;
        }
        // preserve custom attribute if React >=16
        if ($ehDhU.PRESERVE_CUSTOM_ATTRIBUTES) props[attributeName] = attributeValue;
    }
    // transform inline style to object
    (0, $ehDhU.setStyleProp)(attributes.style, props);
    return props;
}
/**
 * Gets prop name from lowercased attribute name.
 *
 * @param attributeName - Lowercased attribute name.
 * @returns - Prop name.
 */ function $b532ea1aff005e2a$var$getPropName(attributeName) {
    return $k1Ter.possibleStandardNames[attributeName];
}

});
parcelRegister("k1Ter", function(module, exports) {

$parcel$export(module.exports, "BOOLEAN", function () { return $e94ebe8d7e9433a5$export$428cfe48a69a3b4f; }, function (v) { return $e94ebe8d7e9433a5$export$428cfe48a69a3b4f = v; });
$parcel$export(module.exports, "OVERLOADED_BOOLEAN", function () { return $e94ebe8d7e9433a5$export$91da4d9e9b612643; }, function (v) { return $e94ebe8d7e9433a5$export$91da4d9e9b612643 = v; });
$parcel$export(module.exports, "getPropertyInfo", function () { return $e94ebe8d7e9433a5$export$fd64a1f33de3651a; }, function (v) { return $e94ebe8d7e9433a5$export$fd64a1f33de3651a = v; });
$parcel$export(module.exports, "isCustomAttribute", function () { return $e94ebe8d7e9433a5$export$d89f61ed80c87270; }, function (v) { return $e94ebe8d7e9433a5$export$d89f61ed80c87270 = v; });
$parcel$export(module.exports, "possibleStandardNames", function () { return $e94ebe8d7e9433a5$export$bbecfff5ecf65cd8; }, function (v) { return $e94ebe8d7e9433a5$export$bbecfff5ecf65cd8 = v; });
var $e94ebe8d7e9433a5$export$428cfe48a69a3b4f;
var $e94ebe8d7e9433a5$export$d7e6493a7bfdb8c1;
var $e94ebe8d7e9433a5$export$4d318981b5a83836;
var $e94ebe8d7e9433a5$export$91da4d9e9b612643;
var $e94ebe8d7e9433a5$export$39307127151c9810;
var $e94ebe8d7e9433a5$export$75032a190741fbaf;
var $e94ebe8d7e9433a5$export$a0e01ba2ebef17f2;
var $e94ebe8d7e9433a5$export$fd64a1f33de3651a;
var $e94ebe8d7e9433a5$export$d89f61ed80c87270;
var $e94ebe8d7e9433a5$export$bbecfff5ecf65cd8;
'use strict';
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
const $e94ebe8d7e9433a5$var$RESERVED = 0;
// A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.
const $e94ebe8d7e9433a5$var$STRING = 1;
// A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.
const $e94ebe8d7e9433a5$var$BOOLEANISH_STRING = 2;
// A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
const $e94ebe8d7e9433a5$var$BOOLEAN = 3;
// An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.
const $e94ebe8d7e9433a5$var$OVERLOADED_BOOLEAN = 4;
// An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.
const $e94ebe8d7e9433a5$var$NUMERIC = 5;
// An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.
const $e94ebe8d7e9433a5$var$POSITIVE_NUMERIC = 6;
function $e94ebe8d7e9433a5$var$getPropertyInfo(name) {
    return $e94ebe8d7e9433a5$var$properties.hasOwnProperty(name) ? $e94ebe8d7e9433a5$var$properties[name] : null;
}
function $e94ebe8d7e9433a5$var$PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
    this.acceptsBooleans = type === $e94ebe8d7e9433a5$var$BOOLEANISH_STRING || type === $e94ebe8d7e9433a5$var$BOOLEAN || type === $e94ebe8d7e9433a5$var$OVERLOADED_BOOLEAN;
    this.attributeName = attributeName;
    this.attributeNamespace = attributeNamespace;
    this.mustUseProperty = mustUseProperty;
    this.propertyName = name;
    this.type = type;
    this.sanitizeURL = sanitizeURL;
    this.removeEmptyString = removeEmptyString;
}
// When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.
const $e94ebe8d7e9433a5$var$properties = {};
// These props are reserved by React. They shouldn't be written to the DOM.
const $e94ebe8d7e9433a5$var$reservedProps = [
    'children',
    'dangerouslySetInnerHTML',
    // TODO: This prevents the assignment of defaultValue to regular
    // elements (not just inputs). Now that ReactDOMInput assigns to the
    // defaultValue property -- do we need this?
    'defaultValue',
    'defaultChecked',
    'innerHTML',
    'suppressContentEditableWarning',
    'suppressHydrationWarning',
    'style'
];
$e94ebe8d7e9433a5$var$reservedProps.forEach((name)=>{
    $e94ebe8d7e9433a5$var$properties[name] = new $e94ebe8d7e9433a5$var$PropertyInfoRecord(name, $e94ebe8d7e9433a5$var$RESERVED, false, name, null, false, false);
});
// A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.
[
    [
        'acceptCharset',
        'accept-charset'
    ],
    [
        'className',
        'class'
    ],
    [
        'htmlFor',
        'for'
    ],
    [
        'httpEquiv',
        'http-equiv'
    ]
].forEach(([name, attributeName])=>{
    $e94ebe8d7e9433a5$var$properties[name] = new $e94ebe8d7e9433a5$var$PropertyInfoRecord(name, $e94ebe8d7e9433a5$var$STRING, false, attributeName, null, false, false);
});
// These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
[
    'contentEditable',
    'draggable',
    'spellCheck',
    'value'
].forEach((name)=>{
    $e94ebe8d7e9433a5$var$properties[name] = new $e94ebe8d7e9433a5$var$PropertyInfoRecord(name, $e94ebe8d7e9433a5$var$BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
});
// These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.
[
    'autoReverse',
    'externalResourcesRequired',
    'focusable',
    'preserveAlpha'
].forEach((name)=>{
    $e94ebe8d7e9433a5$var$properties[name] = new $e94ebe8d7e9433a5$var$PropertyInfoRecord(name, $e94ebe8d7e9433a5$var$BOOLEANISH_STRING, false, name, null, false, false);
});
// These are HTML boolean attributes.
[
    'allowFullScreen',
    'async',
    // Note: there is a special case that prevents it from being written to the DOM
    // on the client side because the browsers are inconsistent. Instead we call focus().
    'autoFocus',
    'autoPlay',
    'controls',
    'default',
    'defer',
    'disabled',
    'disablePictureInPicture',
    'disableRemotePlayback',
    'formNoValidate',
    'hidden',
    'loop',
    'noModule',
    'noValidate',
    'open',
    'playsInline',
    'readOnly',
    'required',
    'reversed',
    'scoped',
    'seamless',
    // Microdata
    'itemScope'
].forEach((name)=>{
    $e94ebe8d7e9433a5$var$properties[name] = new $e94ebe8d7e9433a5$var$PropertyInfoRecord(name, $e94ebe8d7e9433a5$var$BOOLEAN, false, name.toLowerCase(), null, false, false);
});
// These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.
[
    'checked',
    // Note: `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`. We have special logic for handling this.
    'multiple',
    'muted',
    'selected'
].forEach((name)=>{
    $e94ebe8d7e9433a5$var$properties[name] = new $e94ebe8d7e9433a5$var$PropertyInfoRecord(name, $e94ebe8d7e9433a5$var$BOOLEAN, true, name, null, false, false);
});
// These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.
[
    'capture',
    'download'
].forEach((name)=>{
    $e94ebe8d7e9433a5$var$properties[name] = new $e94ebe8d7e9433a5$var$PropertyInfoRecord(name, $e94ebe8d7e9433a5$var$OVERLOADED_BOOLEAN, false, name, null, false, false);
});
// These are HTML attributes that must be positive numbers.
[
    'cols',
    'rows',
    'size',
    'span'
].forEach((name)=>{
    $e94ebe8d7e9433a5$var$properties[name] = new $e94ebe8d7e9433a5$var$PropertyInfoRecord(name, $e94ebe8d7e9433a5$var$POSITIVE_NUMERIC, false, name, null, false, false);
});
// These are HTML attributes that must be numbers.
[
    'rowSpan',
    'start'
].forEach((name)=>{
    $e94ebe8d7e9433a5$var$properties[name] = new $e94ebe8d7e9433a5$var$PropertyInfoRecord(name, $e94ebe8d7e9433a5$var$NUMERIC, false, name.toLowerCase(), null, false, false);
});
const $e94ebe8d7e9433a5$var$CAMELIZE = /[\-\:]([a-z])/g;
const $e94ebe8d7e9433a5$var$capitalize = (token)=>token[1].toUpperCase();
// This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.
[
    'accent-height',
    'alignment-baseline',
    'arabic-form',
    'baseline-shift',
    'cap-height',
    'clip-path',
    'clip-rule',
    'color-interpolation',
    'color-interpolation-filters',
    'color-profile',
    'color-rendering',
    'dominant-baseline',
    'enable-background',
    'fill-opacity',
    'fill-rule',
    'flood-color',
    'flood-opacity',
    'font-family',
    'font-size',
    'font-size-adjust',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-weight',
    'glyph-name',
    'glyph-orientation-horizontal',
    'glyph-orientation-vertical',
    'horiz-adv-x',
    'horiz-origin-x',
    'image-rendering',
    'letter-spacing',
    'lighting-color',
    'marker-end',
    'marker-mid',
    'marker-start',
    'overline-position',
    'overline-thickness',
    'paint-order',
    'panose-1',
    'pointer-events',
    'rendering-intent',
    'shape-rendering',
    'stop-color',
    'stop-opacity',
    'strikethrough-position',
    'strikethrough-thickness',
    'stroke-dasharray',
    'stroke-dashoffset',
    'stroke-linecap',
    'stroke-linejoin',
    'stroke-miterlimit',
    'stroke-opacity',
    'stroke-width',
    'text-anchor',
    'text-decoration',
    'text-rendering',
    'underline-position',
    'underline-thickness',
    'unicode-bidi',
    'unicode-range',
    'units-per-em',
    'v-alphabetic',
    'v-hanging',
    'v-ideographic',
    'v-mathematical',
    'vector-effect',
    'vert-adv-y',
    'vert-origin-x',
    'vert-origin-y',
    'word-spacing',
    'writing-mode',
    'xmlns:xlink',
    'x-height'
].forEach((attributeName)=>{
    const name = attributeName.replace($e94ebe8d7e9433a5$var$CAMELIZE, $e94ebe8d7e9433a5$var$capitalize);
    $e94ebe8d7e9433a5$var$properties[name] = new $e94ebe8d7e9433a5$var$PropertyInfoRecord(name, $e94ebe8d7e9433a5$var$STRING, false, attributeName, null, false, false);
});
// String SVG attributes with the xlink namespace.
[
    'xlink:actuate',
    'xlink:arcrole',
    'xlink:role',
    'xlink:show',
    'xlink:title',
    'xlink:type'
].forEach((attributeName)=>{
    const name = attributeName.replace($e94ebe8d7e9433a5$var$CAMELIZE, $e94ebe8d7e9433a5$var$capitalize);
    $e94ebe8d7e9433a5$var$properties[name] = new $e94ebe8d7e9433a5$var$PropertyInfoRecord(name, $e94ebe8d7e9433a5$var$STRING, false, attributeName, 'http://www.w3.org/1999/xlink', false, false);
});
// String SVG attributes with the xml namespace.
[
    'xml:base',
    'xml:lang',
    'xml:space'
].forEach((attributeName)=>{
    const name = attributeName.replace($e94ebe8d7e9433a5$var$CAMELIZE, $e94ebe8d7e9433a5$var$capitalize);
    $e94ebe8d7e9433a5$var$properties[name] = new $e94ebe8d7e9433a5$var$PropertyInfoRecord(name, $e94ebe8d7e9433a5$var$STRING, false, attributeName, 'http://www.w3.org/XML/1998/namespace', false, false);
});
// These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.
[
    'tabIndex',
    'crossOrigin'
].forEach((attributeName)=>{
    $e94ebe8d7e9433a5$var$properties[attributeName] = new $e94ebe8d7e9433a5$var$PropertyInfoRecord(attributeName, $e94ebe8d7e9433a5$var$STRING, false, attributeName.toLowerCase(), null, false, false);
});
// These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.
const $e94ebe8d7e9433a5$var$xlinkHref = 'xlinkHref';
$e94ebe8d7e9433a5$var$properties[$e94ebe8d7e9433a5$var$xlinkHref] = new $e94ebe8d7e9433a5$var$PropertyInfoRecord('xlinkHref', $e94ebe8d7e9433a5$var$STRING, false, 'xlink:href', 'http://www.w3.org/1999/xlink', true, false);
[
    'src',
    'href',
    'action',
    'formAction'
].forEach((attributeName)=>{
    $e94ebe8d7e9433a5$var$properties[attributeName] = new $e94ebe8d7e9433a5$var$PropertyInfoRecord(attributeName, $e94ebe8d7e9433a5$var$STRING, false, attributeName.toLowerCase(), null, true, true);
});

var $4XqIy = parcelRequire("4XqIy");
var $e94ebe8d7e9433a5$require$CAMELCASE = $4XqIy.CAMELCASE;
var $e94ebe8d7e9433a5$require$SAME = $4XqIy.SAME;
var $e94ebe8d7e9433a5$require$possibleStandardNamesOptimized = $4XqIy.possibleStandardNames;
const $e94ebe8d7e9433a5$var$ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const $e94ebe8d7e9433a5$var$ATTRIBUTE_NAME_CHAR = $e94ebe8d7e9433a5$var$ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
/**
 * Checks whether a property name is a custom attribute.
 *
 * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25
 *
 * @type {(attribute: string) => boolean}
 */ const $e94ebe8d7e9433a5$var$isCustomAttribute = RegExp.prototype.test.bind(// eslint-disable-next-line no-misleading-character-class
new RegExp('^(data|aria)-[' + $e94ebe8d7e9433a5$var$ATTRIBUTE_NAME_CHAR + ']*$'));
/**
 * @type {Record<string, string>}
 */ const $e94ebe8d7e9433a5$var$possibleStandardNames = Object.keys($e94ebe8d7e9433a5$require$possibleStandardNamesOptimized).reduce((accumulator, standardName)=>{
    const propName = $e94ebe8d7e9433a5$require$possibleStandardNamesOptimized[standardName];
    if (propName === $e94ebe8d7e9433a5$require$SAME) accumulator[standardName] = standardName;
    else if (propName === $e94ebe8d7e9433a5$require$CAMELCASE) accumulator[standardName.toLowerCase()] = standardName;
    else accumulator[standardName] = propName;
    return accumulator;
}, {});
$e94ebe8d7e9433a5$export$428cfe48a69a3b4f = $e94ebe8d7e9433a5$var$BOOLEAN;
$e94ebe8d7e9433a5$export$d7e6493a7bfdb8c1 = $e94ebe8d7e9433a5$var$BOOLEANISH_STRING;
$e94ebe8d7e9433a5$export$4d318981b5a83836 = $e94ebe8d7e9433a5$var$NUMERIC;
$e94ebe8d7e9433a5$export$91da4d9e9b612643 = $e94ebe8d7e9433a5$var$OVERLOADED_BOOLEAN;
$e94ebe8d7e9433a5$export$39307127151c9810 = $e94ebe8d7e9433a5$var$POSITIVE_NUMERIC;
$e94ebe8d7e9433a5$export$75032a190741fbaf = $e94ebe8d7e9433a5$var$RESERVED;
$e94ebe8d7e9433a5$export$a0e01ba2ebef17f2 = $e94ebe8d7e9433a5$var$STRING;
$e94ebe8d7e9433a5$export$fd64a1f33de3651a = $e94ebe8d7e9433a5$var$getPropertyInfo;
$e94ebe8d7e9433a5$export$d89f61ed80c87270 = $e94ebe8d7e9433a5$var$isCustomAttribute;
$e94ebe8d7e9433a5$export$bbecfff5ecf65cd8 = $e94ebe8d7e9433a5$var$possibleStandardNames;

});
parcelRegister("4XqIy", function(module, exports) {

$parcel$export(module.exports, "SAME", function () { return $39c165afe8422f46$export$7359a57b3ac1f378; }, function (v) { return $39c165afe8422f46$export$7359a57b3ac1f378 = v; });
$parcel$export(module.exports, "CAMELCASE", function () { return $39c165afe8422f46$export$5ab28d07cff57c11; }, function (v) { return $39c165afe8422f46$export$5ab28d07cff57c11 = v; });
$parcel$export(module.exports, "possibleStandardNames", function () { return $39c165afe8422f46$export$bbecfff5ecf65cd8; }, function (v) { return $39c165afe8422f46$export$bbecfff5ecf65cd8 = v; });
// An attribute in which the DOM/SVG standard name is the same as the React prop name (e.g., 'accept').
var $39c165afe8422f46$export$7359a57b3ac1f378;
var $39c165afe8422f46$export$5ab28d07cff57c11;
var $39c165afe8422f46$export$bbecfff5ecf65cd8;
var $39c165afe8422f46$var$SAME = 0;
$39c165afe8422f46$export$7359a57b3ac1f378 = $39c165afe8422f46$var$SAME;
// An attribute in which the React prop name is the camelcased version of the DOM/SVG standard name (e.g., 'acceptCharset').
var $39c165afe8422f46$var$CAMELCASE = 1;
$39c165afe8422f46$export$5ab28d07cff57c11 = $39c165afe8422f46$var$CAMELCASE;
$39c165afe8422f46$export$bbecfff5ecf65cd8 = {
    accept: 0,
    acceptCharset: 1,
    'accept-charset': 'acceptCharset',
    accessKey: 1,
    action: 0,
    allowFullScreen: 1,
    alt: 0,
    as: 0,
    async: 0,
    autoCapitalize: 1,
    autoComplete: 1,
    autoCorrect: 1,
    autoFocus: 1,
    autoPlay: 1,
    autoSave: 1,
    capture: 0,
    cellPadding: 1,
    cellSpacing: 1,
    challenge: 0,
    charSet: 1,
    checked: 0,
    children: 0,
    cite: 0,
    class: 'className',
    classID: 1,
    className: 1,
    cols: 0,
    colSpan: 1,
    content: 0,
    contentEditable: 1,
    contextMenu: 1,
    controls: 0,
    controlsList: 1,
    coords: 0,
    crossOrigin: 1,
    dangerouslySetInnerHTML: 1,
    data: 0,
    dateTime: 1,
    default: 0,
    defaultChecked: 1,
    defaultValue: 1,
    defer: 0,
    dir: 0,
    disabled: 0,
    disablePictureInPicture: 1,
    disableRemotePlayback: 1,
    download: 0,
    draggable: 0,
    encType: 1,
    enterKeyHint: 1,
    for: 'htmlFor',
    form: 0,
    formMethod: 1,
    formAction: 1,
    formEncType: 1,
    formNoValidate: 1,
    formTarget: 1,
    frameBorder: 1,
    headers: 0,
    height: 0,
    hidden: 0,
    high: 0,
    href: 0,
    hrefLang: 1,
    htmlFor: 1,
    httpEquiv: 1,
    'http-equiv': 'httpEquiv',
    icon: 0,
    id: 0,
    innerHTML: 1,
    inputMode: 1,
    integrity: 0,
    is: 0,
    itemID: 1,
    itemProp: 1,
    itemRef: 1,
    itemScope: 1,
    itemType: 1,
    keyParams: 1,
    keyType: 1,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: 0,
    low: 0,
    manifest: 0,
    marginWidth: 1,
    marginHeight: 1,
    max: 0,
    maxLength: 1,
    media: 0,
    mediaGroup: 1,
    method: 0,
    min: 0,
    minLength: 1,
    multiple: 0,
    muted: 0,
    name: 0,
    noModule: 1,
    nonce: 0,
    noValidate: 1,
    open: 0,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: 1,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 1,
    readOnly: 1,
    referrerPolicy: 1,
    rel: 0,
    required: 0,
    reversed: 0,
    role: 0,
    rows: 0,
    rowSpan: 1,
    sandbox: 0,
    scope: 0,
    scoped: 0,
    scrolling: 0,
    seamless: 0,
    selected: 0,
    shape: 0,
    size: 0,
    sizes: 0,
    span: 0,
    spellCheck: 1,
    src: 0,
    srcDoc: 1,
    srcLang: 1,
    srcSet: 1,
    start: 0,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 1,
    target: 0,
    title: 0,
    type: 0,
    useMap: 1,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,
    about: 0,
    accentHeight: 1,
    'accent-height': 'accentHeight',
    accumulate: 0,
    additive: 0,
    alignmentBaseline: 1,
    'alignment-baseline': 'alignmentBaseline',
    allowReorder: 1,
    alphabetic: 0,
    amplitude: 0,
    arabicForm: 1,
    'arabic-form': 'arabicForm',
    ascent: 0,
    attributeName: 1,
    attributeType: 1,
    autoReverse: 1,
    azimuth: 0,
    baseFrequency: 1,
    baselineShift: 1,
    'baseline-shift': 'baselineShift',
    baseProfile: 1,
    bbox: 0,
    begin: 0,
    bias: 0,
    by: 0,
    calcMode: 1,
    capHeight: 1,
    'cap-height': 'capHeight',
    clip: 0,
    clipPath: 1,
    'clip-path': 'clipPath',
    clipPathUnits: 1,
    clipRule: 1,
    'clip-rule': 'clipRule',
    color: 0,
    colorInterpolation: 1,
    'color-interpolation': 'colorInterpolation',
    colorInterpolationFilters: 1,
    'color-interpolation-filters': 'colorInterpolationFilters',
    colorProfile: 1,
    'color-profile': 'colorProfile',
    colorRendering: 1,
    'color-rendering': 'colorRendering',
    contentScriptType: 1,
    contentStyleType: 1,
    cursor: 0,
    cx: 0,
    cy: 0,
    d: 0,
    datatype: 0,
    decelerate: 0,
    descent: 0,
    diffuseConstant: 1,
    direction: 0,
    display: 0,
    divisor: 0,
    dominantBaseline: 1,
    'dominant-baseline': 'dominantBaseline',
    dur: 0,
    dx: 0,
    dy: 0,
    edgeMode: 1,
    elevation: 0,
    enableBackground: 1,
    'enable-background': 'enableBackground',
    end: 0,
    exponent: 0,
    externalResourcesRequired: 1,
    fill: 0,
    fillOpacity: 1,
    'fill-opacity': 'fillOpacity',
    fillRule: 1,
    'fill-rule': 'fillRule',
    filter: 0,
    filterRes: 1,
    filterUnits: 1,
    floodOpacity: 1,
    'flood-opacity': 'floodOpacity',
    floodColor: 1,
    'flood-color': 'floodColor',
    focusable: 0,
    fontFamily: 1,
    'font-family': 'fontFamily',
    fontSize: 1,
    'font-size': 'fontSize',
    fontSizeAdjust: 1,
    'font-size-adjust': 'fontSizeAdjust',
    fontStretch: 1,
    'font-stretch': 'fontStretch',
    fontStyle: 1,
    'font-style': 'fontStyle',
    fontVariant: 1,
    'font-variant': 'fontVariant',
    fontWeight: 1,
    'font-weight': 'fontWeight',
    format: 0,
    from: 0,
    fx: 0,
    fy: 0,
    g1: 0,
    g2: 0,
    glyphName: 1,
    'glyph-name': 'glyphName',
    glyphOrientationHorizontal: 1,
    'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
    glyphOrientationVertical: 1,
    'glyph-orientation-vertical': 'glyphOrientationVertical',
    glyphRef: 1,
    gradientTransform: 1,
    gradientUnits: 1,
    hanging: 0,
    horizAdvX: 1,
    'horiz-adv-x': 'horizAdvX',
    horizOriginX: 1,
    'horiz-origin-x': 'horizOriginX',
    ideographic: 0,
    imageRendering: 1,
    'image-rendering': 'imageRendering',
    in2: 0,
    in: 0,
    inlist: 0,
    intercept: 0,
    k1: 0,
    k2: 0,
    k3: 0,
    k4: 0,
    k: 0,
    kernelMatrix: 1,
    kernelUnitLength: 1,
    kerning: 0,
    keyPoints: 1,
    keySplines: 1,
    keyTimes: 1,
    lengthAdjust: 1,
    letterSpacing: 1,
    'letter-spacing': 'letterSpacing',
    lightingColor: 1,
    'lighting-color': 'lightingColor',
    limitingConeAngle: 1,
    local: 0,
    markerEnd: 1,
    'marker-end': 'markerEnd',
    markerHeight: 1,
    markerMid: 1,
    'marker-mid': 'markerMid',
    markerStart: 1,
    'marker-start': 'markerStart',
    markerUnits: 1,
    markerWidth: 1,
    mask: 0,
    maskContentUnits: 1,
    maskUnits: 1,
    mathematical: 0,
    mode: 0,
    numOctaves: 1,
    offset: 0,
    opacity: 0,
    operator: 0,
    order: 0,
    orient: 0,
    orientation: 0,
    origin: 0,
    overflow: 0,
    overlinePosition: 1,
    'overline-position': 'overlinePosition',
    overlineThickness: 1,
    'overline-thickness': 'overlineThickness',
    paintOrder: 1,
    'paint-order': 'paintOrder',
    panose1: 0,
    'panose-1': 'panose1',
    pathLength: 1,
    patternContentUnits: 1,
    patternTransform: 1,
    patternUnits: 1,
    pointerEvents: 1,
    'pointer-events': 'pointerEvents',
    points: 0,
    pointsAtX: 1,
    pointsAtY: 1,
    pointsAtZ: 1,
    prefix: 0,
    preserveAlpha: 1,
    preserveAspectRatio: 1,
    primitiveUnits: 1,
    property: 0,
    r: 0,
    radius: 0,
    refX: 1,
    refY: 1,
    renderingIntent: 1,
    'rendering-intent': 'renderingIntent',
    repeatCount: 1,
    repeatDur: 1,
    requiredExtensions: 1,
    requiredFeatures: 1,
    resource: 0,
    restart: 0,
    result: 0,
    results: 0,
    rotate: 0,
    rx: 0,
    ry: 0,
    scale: 0,
    security: 0,
    seed: 0,
    shapeRendering: 1,
    'shape-rendering': 'shapeRendering',
    slope: 0,
    spacing: 0,
    specularConstant: 1,
    specularExponent: 1,
    speed: 0,
    spreadMethod: 1,
    startOffset: 1,
    stdDeviation: 1,
    stemh: 0,
    stemv: 0,
    stitchTiles: 1,
    stopColor: 1,
    'stop-color': 'stopColor',
    stopOpacity: 1,
    'stop-opacity': 'stopOpacity',
    strikethroughPosition: 1,
    'strikethrough-position': 'strikethroughPosition',
    strikethroughThickness: 1,
    'strikethrough-thickness': 'strikethroughThickness',
    string: 0,
    stroke: 0,
    strokeDasharray: 1,
    'stroke-dasharray': 'strokeDasharray',
    strokeDashoffset: 1,
    'stroke-dashoffset': 'strokeDashoffset',
    strokeLinecap: 1,
    'stroke-linecap': 'strokeLinecap',
    strokeLinejoin: 1,
    'stroke-linejoin': 'strokeLinejoin',
    strokeMiterlimit: 1,
    'stroke-miterlimit': 'strokeMiterlimit',
    strokeWidth: 1,
    'stroke-width': 'strokeWidth',
    strokeOpacity: 1,
    'stroke-opacity': 'strokeOpacity',
    suppressContentEditableWarning: 1,
    suppressHydrationWarning: 1,
    surfaceScale: 1,
    systemLanguage: 1,
    tableValues: 1,
    targetX: 1,
    targetY: 1,
    textAnchor: 1,
    'text-anchor': 'textAnchor',
    textDecoration: 1,
    'text-decoration': 'textDecoration',
    textLength: 1,
    textRendering: 1,
    'text-rendering': 'textRendering',
    to: 0,
    transform: 0,
    typeof: 0,
    u1: 0,
    u2: 0,
    underlinePosition: 1,
    'underline-position': 'underlinePosition',
    underlineThickness: 1,
    'underline-thickness': 'underlineThickness',
    unicode: 0,
    unicodeBidi: 1,
    'unicode-bidi': 'unicodeBidi',
    unicodeRange: 1,
    'unicode-range': 'unicodeRange',
    unitsPerEm: 1,
    'units-per-em': 'unitsPerEm',
    unselectable: 0,
    vAlphabetic: 1,
    'v-alphabetic': 'vAlphabetic',
    values: 0,
    vectorEffect: 1,
    'vector-effect': 'vectorEffect',
    version: 0,
    vertAdvY: 1,
    'vert-adv-y': 'vertAdvY',
    vertOriginX: 1,
    'vert-origin-x': 'vertOriginX',
    vertOriginY: 1,
    'vert-origin-y': 'vertOriginY',
    vHanging: 1,
    'v-hanging': 'vHanging',
    vIdeographic: 1,
    'v-ideographic': 'vIdeographic',
    viewBox: 1,
    viewTarget: 1,
    visibility: 0,
    vMathematical: 1,
    'v-mathematical': 'vMathematical',
    vocab: 0,
    widths: 0,
    wordSpacing: 1,
    'word-spacing': 'wordSpacing',
    writingMode: 1,
    'writing-mode': 'writingMode',
    x1: 0,
    x2: 0,
    x: 0,
    xChannelSelector: 1,
    xHeight: 1,
    'x-height': 'xHeight',
    xlinkActuate: 1,
    'xlink:actuate': 'xlinkActuate',
    xlinkArcrole: 1,
    'xlink:arcrole': 'xlinkArcrole',
    xlinkHref: 1,
    'xlink:href': 'xlinkHref',
    xlinkRole: 1,
    'xlink:role': 'xlinkRole',
    xlinkShow: 1,
    'xlink:show': 'xlinkShow',
    xlinkTitle: 1,
    'xlink:title': 'xlinkTitle',
    xlinkType: 1,
    'xlink:type': 'xlinkType',
    xmlBase: 1,
    'xml:base': 'xmlBase',
    xmlLang: 1,
    'xml:lang': 'xmlLang',
    xmlns: 0,
    'xml:space': 'xmlSpace',
    xmlnsXlink: 1,
    'xmlns:xlink': 'xmlnsXlink',
    xmlSpace: 1,
    y1: 0,
    y2: 0,
    y: 0,
    yChannelSelector: 1,
    z: 0,
    zoomAndPan: 1
};

});


parcelRegister("ehDhU", function(module, exports) {
"use strict";
var $a66120faa812a729$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.returnFirstArg = module.exports.canTextBeChildOfNode = module.exports.ELEMENTS_WITH_NO_TEXT_CHILDREN = module.exports.PRESERVE_CUSTOM_ATTRIBUTES = void 0;
module.exports.isCustomComponent = $a66120faa812a729$var$isCustomComponent;
module.exports.setStyleProp = $a66120faa812a729$var$setStyleProp;

var $8FY87 = parcelRequire("8FY87");

var $a66120faa812a729$var$style_to_js_1 = $a66120faa812a729$var$__importDefault((parcelRequire("76wUk")));
var $a66120faa812a729$var$RESERVED_SVG_MATHML_ELEMENTS = new Set([
    'annotation-xml',
    'color-profile',
    'font-face',
    'font-face-src',
    'font-face-uri',
    'font-face-format',
    'font-face-name',
    'missing-glyph'
]);
/**
 * Check if a tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param tagName - Tag name.
 * @param props - Props passed to the element.
 * @returns - Whether the tag is custom component.
 */ function $a66120faa812a729$var$isCustomComponent(tagName, props) {
    if (!tagName.includes('-')) return Boolean(props && typeof props.is === 'string');
    // These are reserved SVG and MathML elements.
    // We don't mind this whitelist too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    if ($a66120faa812a729$var$RESERVED_SVG_MATHML_ELEMENTS.has(tagName)) return false;
    return true;
}
var $a66120faa812a729$var$styleOptions = {
    reactCompat: true
};
/**
 * Sets style prop.
 *
 * @param style - Inline style.
 * @param props - Props object.
 */ function $a66120faa812a729$var$setStyleProp(style, props) {
    if (typeof style !== 'string') return;
    if (!style.trim()) {
        props.style = {};
        return;
    }
    try {
        props.style = (0, $a66120faa812a729$var$style_to_js_1.default)(style, $a66120faa812a729$var$styleOptions);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        props.style = {};
    }
}
/**
 * @see https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html
 */ module.exports.PRESERVE_CUSTOM_ATTRIBUTES = Number($8FY87.version.split('.')[0]) >= 16;
/**
 * @see https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
 */ module.exports.ELEMENTS_WITH_NO_TEXT_CHILDREN = new Set([
    'tr',
    'tbody',
    'thead',
    'tfoot',
    'colgroup',
    'table',
    'head',
    'html',
    'frameset'
]);
/**
 * Checks if the given node can contain text nodes
 *
 * @param node - Element node.
 * @returns - Whether the node can contain text nodes.
 */ var $a66120faa812a729$var$canTextBeChildOfNode = function(node) {
    return !module.exports.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(node.name);
};
module.exports.canTextBeChildOfNode = $a66120faa812a729$var$canTextBeChildOfNode;
/**
 * Returns the first argument as is.
 *
 * @param arg - The argument to be returned.
 * @returns - The input argument `arg`.
 */ var $a66120faa812a729$var$returnFirstArg = function(arg) {
    return arg;
};
module.exports.returnFirstArg = $a66120faa812a729$var$returnFirstArg;

});
parcelRegister("76wUk", function(module, exports) {
"use strict";
var $52c29eb611f03769$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};

var $52c29eb611f03769$var$style_to_object_1 = $52c29eb611f03769$var$__importDefault((parcelRequire("7xDoT")));

var $kazTw = parcelRequire("kazTw");
/**
 * Parses CSS inline style to JavaScript object (camelCased).
 */ function $52c29eb611f03769$var$StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') return output;
    (0, $52c29eb611f03769$var$style_to_object_1.default)(style, function(property, value) {
        // skip CSS comment
        if (property && value) output[(0, $kazTw.camelCase)(property, options)] = value;
    });
    return output;
}
$52c29eb611f03769$var$StyleToJS.default = $52c29eb611f03769$var$StyleToJS;
module.exports = $52c29eb611f03769$var$StyleToJS;

});
parcelRegister("7xDoT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0f2997e8b136189f$export$2e2bcd8739ae039; });

var $9MVV2 = parcelRequire("9MVV2");
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */ function $0f2997e8b136189f$export$2e2bcd8739ae039(style, iterator) {
    let styleObject = null;
    if (!style || typeof style !== 'string') return styleObject;
    const declarations = (0, $9MVV2.default)(style);
    const hasIterator = typeof iterator === 'function';
    declarations.forEach((declaration)=>{
        if (declaration.type !== 'declaration') return;
        const { property: property, value: value } = declaration;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}

});
parcelRegister("9MVV2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b747a0c0bcfc08b5$export$2e2bcd8739ae039; });
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $b747a0c0bcfc08b5$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $b747a0c0bcfc08b5$var$NEWLINE_REGEX = /\n/g;
var $b747a0c0bcfc08b5$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $b747a0c0bcfc08b5$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $b747a0c0bcfc08b5$var$COLON_REGEX = /^:\s*/;
var $b747a0c0bcfc08b5$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $b747a0c0bcfc08b5$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $b747a0c0bcfc08b5$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $b747a0c0bcfc08b5$var$NEWLINE = '\n';
var $b747a0c0bcfc08b5$var$FORWARD_SLASH = '/';
var $b747a0c0bcfc08b5$var$ASTERISK = '*';
var $b747a0c0bcfc08b5$var$EMPTY_STRING = '';
// types
var $b747a0c0bcfc08b5$var$TYPE_COMMENT = 'comment';
var $b747a0c0bcfc08b5$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ function $b747a0c0bcfc08b5$export$2e2bcd8739ae039(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($b747a0c0bcfc08b5$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($b747a0c0bcfc08b5$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) ;
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($b747a0c0bcfc08b5$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($b747a0c0bcfc08b5$var$FORWARD_SLASH != style.charAt(0) || $b747a0c0bcfc08b5$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($b747a0c0bcfc08b5$var$EMPTY_STRING != style.charAt(i) && ($b747a0c0bcfc08b5$var$ASTERISK != style.charAt(i) || $b747a0c0bcfc08b5$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($b747a0c0bcfc08b5$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $b747a0c0bcfc08b5$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($b747a0c0bcfc08b5$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($b747a0c0bcfc08b5$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($b747a0c0bcfc08b5$var$VALUE_REGEX);
        var ret = pos({
            type: $b747a0c0bcfc08b5$var$TYPE_DECLARATION,
            property: $b747a0c0bcfc08b5$var$trim(prop[0].replace($b747a0c0bcfc08b5$var$COMMENT_REGEX, $b747a0c0bcfc08b5$var$EMPTY_STRING)),
            value: val ? $b747a0c0bcfc08b5$var$trim(val[0].replace($b747a0c0bcfc08b5$var$COMMENT_REGEX, $b747a0c0bcfc08b5$var$EMPTY_STRING)) : $b747a0c0bcfc08b5$var$EMPTY_STRING
        });
        // ;
        match($b747a0c0bcfc08b5$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
}
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $b747a0c0bcfc08b5$var$trim(str) {
    return str ? str.replace($b747a0c0bcfc08b5$var$TRIM_REGEX, $b747a0c0bcfc08b5$var$EMPTY_STRING) : $b747a0c0bcfc08b5$var$EMPTY_STRING;
}

});


parcelRegister("kazTw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.camelCase = void 0;
var $eaf095bd2621407c$var$CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/;
var $eaf095bd2621407c$var$HYPHEN_REGEX = /-([a-z])/g;
var $eaf095bd2621407c$var$NO_HYPHEN_REGEX = /^[^-]+$/;
var $eaf095bd2621407c$var$VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var $eaf095bd2621407c$var$MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
/**
 * Checks whether to skip camelCase.
 */ var $eaf095bd2621407c$var$skipCamelCase = function(property) {
    return !property || $eaf095bd2621407c$var$NO_HYPHEN_REGEX.test(property) || $eaf095bd2621407c$var$CUSTOM_PROPERTY_REGEX.test(property);
};
/**
 * Replacer that capitalizes first character.
 */ var $eaf095bd2621407c$var$capitalize = function(match, character) {
    return character.toUpperCase();
};
/**
 * Replacer that removes beginning hyphen of vendor prefix property.
 */ var $eaf095bd2621407c$var$trimHyphen = function(match, prefix) {
    return "".concat(prefix, "-");
};
/**
 * CamelCases a CSS property.
 */ var $eaf095bd2621407c$var$camelCase = function(property, options) {
    if (options === void 0) options = {};
    if ($eaf095bd2621407c$var$skipCamelCase(property)) return property;
    property = property.toLowerCase();
    if (options.reactCompat) // `-ms` vendor prefix should not be capitalized
    property = property.replace($eaf095bd2621407c$var$MS_VENDOR_PREFIX_REGEX, $eaf095bd2621407c$var$trimHyphen);
    else // for non-React, remove first hyphen so vendor prefix is not capitalized
    property = property.replace($eaf095bd2621407c$var$VENDOR_PREFIX_REGEX, $eaf095bd2621407c$var$trimHyphen);
    return property.replace($eaf095bd2621407c$var$HYPHEN_REGEX, $eaf095bd2621407c$var$capitalize);
};
module.exports.camelCase = $eaf095bd2621407c$var$camelCase;

});




parcelRegister("0INbj", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */ var $0022bf026f5f7331$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0022bf026f5f7331$var$domToReact;

var $8FY87 = parcelRequire("8FY87");

var $0022bf026f5f7331$var$attributes_to_props_1 = $0022bf026f5f7331$var$__importDefault((parcelRequire("fyw4V")));

var $ehDhU = parcelRequire("ehDhU");
var $0022bf026f5f7331$var$React = {
    cloneElement: $8FY87.cloneElement,
    createElement: $8FY87.createElement,
    isValidElement: $8FY87.isValidElement
};
/**
 * Converts DOM nodes to JSX element(s).
 *
 * @param nodes - DOM nodes.
 * @param options - Options.
 * @returns - String or JSX element(s).
 */ function $0022bf026f5f7331$var$domToReact(nodes, options) {
    var _a, _b, _c, _d, _e;
    if (options === void 0) options = {};
    var reactElements = [];
    var hasReplace = typeof options.replace === 'function';
    var transform = (_a = options.transform) !== null && _a !== void 0 ? _a : $ehDhU.returnFirstArg;
    var _f = (_b = options.library) !== null && _b !== void 0 ? _b : $0022bf026f5f7331$var$React, cloneElement = _f.cloneElement, createElement = _f.createElement, isValidElement = _f.isValidElement;
    var nodesLength = nodes.length;
    for(var index = 0; index < nodesLength; index++){
        var node = nodes[index];
        // replace with custom React element (if present)
        if (hasReplace) {
            var replaceElement = (_c = options.replace) === null || _c === void 0 ? void 0 : _c.call(options, node, index);
            if (isValidElement(replaceElement)) {
                // set "key" prop for sibling elements
                // https://react.dev/learn/rendering-lists#rules-of-keys
                if (nodesLength > 1) replaceElement = cloneElement(replaceElement, {
                    key: (_d = replaceElement.key) !== null && _d !== void 0 ? _d : index
                });
                reactElements.push(transform(replaceElement, node, index));
                continue;
            }
        }
        if (node.type === 'text') {
            var isWhitespace = !node.data.trim().length;
            // We have a whitespace node that can't be nested in its parent
            // so skip it
            if (isWhitespace && node.parent && !(0, $ehDhU.canTextBeChildOfNode)(node.parent)) continue;
            // Trim is enabled and we have a whitespace node
            // so skip it
            if (options.trim && isWhitespace) continue;
            // We have a text node that's not whitespace and it can be nested
            // in its parent so add it to the results
            reactElements.push(transform(node.data, node, index));
            continue;
        }
        var element = node;
        var props = {};
        if ($0022bf026f5f7331$var$skipAttributesToProps(element)) {
            (0, $ehDhU.setStyleProp)(element.attribs.style, element.attribs);
            props = element.attribs;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        } else if (element.attribs) props = (0, $0022bf026f5f7331$var$attributes_to_props_1.default)(element.attribs, element.name);
        var children = void 0;
        switch(node.type){
            case 'script':
            case 'style':
                // prevent text in <script> or <style> from being escaped
                // https://react.dev/reference/react-dom/components/common#dangerously-setting-the-inner-html
                if (node.children[0]) props.dangerouslySetInnerHTML = {
                    __html: node.children[0].data
                };
                break;
            case 'tag':
                // setting textarea value in children is an antipattern in React
                // https://react.dev/reference/react-dom/components/textarea#caveats
                if (node.name === 'textarea' && node.children[0]) props.defaultValue = node.children[0].data;
                else if ((_e = node.children) === null || _e === void 0 ? void 0 : _e.length) // continue recursion of creating React elements (if applicable)
                children = $0022bf026f5f7331$var$domToReact(node.children, options);
                break;
            // skip all other cases (e.g., comment)
            default:
                continue;
        }
        // set "key" prop for sibling elements
        // https://react.dev/learn/rendering-lists#rules-of-keys
        if (nodesLength > 1) props.key = index;
        reactElements.push(transform(createElement(node.name, props, children), node, index));
    }
    return reactElements.length === 1 ? reactElements[0] : reactElements;
}
/**
 * Determines whether DOM element attributes should be transformed to props.
 * Web Components should not have their attributes transformed except for `style`.
 *
 * @param node - Element node.
 * @returns - Whether the node attributes should be converted to props.
 */ function $0022bf026f5f7331$var$skipAttributesToProps(node) {
    return $ehDhU.PRESERVE_CUSTOM_ATTRIBUTES && node.type === 'tag' && (0, $ehDhU.isCustomComponent)(node.name, node.attribs);
}

});

parcelRegister("ccG9h", function(module, exports) {

var $dFGUU = parcelRequire("dFGUU");

var $6MCkB = parcelRequire("6MCkB");
// Default options
const $8e274ce0e3b6c17f$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
class $8e274ce0e3b6c17f$export$ff8ccbac9225de62 {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ constructor(callback, options, elementCB){
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (0, $6MCkB.Document)(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $8e274ce0e3b6c17f$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $8e274ce0e3b6c17f$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    onparserinit(parser) {
        this.parser = parser;
    }
    // Resets the handler back to starting state
    onreset() {
        this.dom = [];
        this.root = new (0, $6MCkB.Document)(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    }
    // Signals the handler that parsing is done
    onend() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    }
    onerror(error) {
        this.handleCallback(error);
    }
    onclosetag() {
        this.lastNode = null;
        const elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    }
    onopentag(name, attribs) {
        const type = this.options.xmlMode ? (0, $dFGUU.ElementType).Tag : undefined;
        const element = new (0, $6MCkB.Element)(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    }
    ontext(data) {
        const { lastNode: lastNode } = this;
        if (lastNode && lastNode.type === (0, $dFGUU.ElementType).Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            const node = new (0, $6MCkB.Text)(data);
            this.addNode(node);
            this.lastNode = node;
        }
    }
    oncomment(data) {
        if (this.lastNode && this.lastNode.type === (0, $dFGUU.ElementType).Comment) {
            this.lastNode.data += data;
            return;
        }
        const node = new (0, $6MCkB.Comment)(data);
        this.addNode(node);
        this.lastNode = node;
    }
    oncommentend() {
        this.lastNode = null;
    }
    oncdatastart() {
        const text = new (0, $6MCkB.Text)("");
        const node = new (0, $6MCkB.CDATA)([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    }
    oncdataend() {
        this.lastNode = null;
    }
    onprocessinginstruction(name, data) {
        const node = new (0, $6MCkB.ProcessingInstruction)(name, data);
        this.addNode(node);
    }
    handleCallback(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    }
    addNode(node) {
        const parent = this.tagStack[this.tagStack.length - 1];
        const previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    }
}
var $8e274ce0e3b6c17f$export$2e2bcd8739ae039 = $8e274ce0e3b6c17f$export$ff8ccbac9225de62;

});
parcelRegister("dFGUU", function(module, exports) {

$parcel$export(module.exports, "ElementType", function () { return $9f40651bb7a70dab$export$b992dc138d950e31; });
$parcel$export(module.exports, "isTag", function () { return $9f40651bb7a70dab$export$3bf645f08efe3292; });
/** Types of elements found in htmlparser2's DOM */ var $9f40651bb7a70dab$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($9f40651bb7a70dab$export$b992dc138d950e31 || ($9f40651bb7a70dab$export$b992dc138d950e31 = {}));
function $9f40651bb7a70dab$export$3bf645f08efe3292(elem) {
    return elem.type === $9f40651bb7a70dab$export$b992dc138d950e31.Tag || elem.type === $9f40651bb7a70dab$export$b992dc138d950e31.Script || elem.type === $9f40651bb7a70dab$export$b992dc138d950e31.Style;
}
const $9f40651bb7a70dab$export$be92b6f5f03c0fe9 = $9f40651bb7a70dab$export$b992dc138d950e31.Root;
const $9f40651bb7a70dab$export$5f1af8db9871e1d6 = $9f40651bb7a70dab$export$b992dc138d950e31.Text;
const $9f40651bb7a70dab$export$befdefbdce210f91 = $9f40651bb7a70dab$export$b992dc138d950e31.Directive;
const $9f40651bb7a70dab$export$4d299b491347818a = $9f40651bb7a70dab$export$b992dc138d950e31.Comment;
const $9f40651bb7a70dab$export$2f8b47a141e57afc = $9f40651bb7a70dab$export$b992dc138d950e31.Script;
const $9f40651bb7a70dab$export$d9e45bc13d335801 = $9f40651bb7a70dab$export$b992dc138d950e31.Style;
const $9f40651bb7a70dab$export$3288d34c523a1192 = $9f40651bb7a70dab$export$b992dc138d950e31.Tag;
const $9f40651bb7a70dab$export$1f8b8f7e5c763232 = $9f40651bb7a70dab$export$b992dc138d950e31.CDATA;
const $9f40651bb7a70dab$export$31b44af36ff2c60f = $9f40651bb7a70dab$export$b992dc138d950e31.Doctype;

});

parcelRegister("6MCkB", function(module, exports) {

$parcel$export(module.exports, "Text", function () { return $4f04f5959af47e30$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Comment", function () { return $4f04f5959af47e30$export$4d299b491347818a; });
$parcel$export(module.exports, "ProcessingInstruction", function () { return $4f04f5959af47e30$export$9269dce19ee35e96; });
$parcel$export(module.exports, "CDATA", function () { return $4f04f5959af47e30$export$1f8b8f7e5c763232; });
$parcel$export(module.exports, "Document", function () { return $4f04f5959af47e30$export$b34a105447964f9f; });
$parcel$export(module.exports, "Element", function () { return $4f04f5959af47e30$export$db77ccec0bb4ccac; });

var $dFGUU = parcelRequire("dFGUU");
class $4f04f5959af47e30$export$85c928794f8d04d4 {
    constructor(){
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get previousSibling() {
        return this.prev;
    }
    set previousSibling(prev) {
        this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ cloneNode(recursive = false) {
        return $4f04f5959af47e30$export$ae8e35ea29ddac22(this, recursive);
    }
}
class $4f04f5959af47e30$export$c3569d91cd44d357 extends $4f04f5959af47e30$export$85c928794f8d04d4 {
    /**
     * @param data The content of the data node
     */ constructor(data){
        super();
        this.data = data;
    }
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
}
class $4f04f5959af47e30$export$5f1af8db9871e1d6 extends $4f04f5959af47e30$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $dFGUU.ElementType).Text;
    }
    get nodeType() {
        return 3;
    }
}
class $4f04f5959af47e30$export$4d299b491347818a extends $4f04f5959af47e30$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $dFGUU.ElementType).Comment;
    }
    get nodeType() {
        return 8;
    }
}
class $4f04f5959af47e30$export$9269dce19ee35e96 extends $4f04f5959af47e30$export$c3569d91cd44d357 {
    constructor(name, data){
        super(data);
        this.name = name;
        this.type = (0, $dFGUU.ElementType).Directive;
    }
    get nodeType() {
        return 1;
    }
}
class $4f04f5959af47e30$export$62be934f90997196 extends $4f04f5959af47e30$export$85c928794f8d04d4 {
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ constructor(children){
        super();
        this.children = children;
    }
    // Aliases
    /** First child of the node. */ get firstChild() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */ get lastChild() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
}
class $4f04f5959af47e30$export$1f8b8f7e5c763232 extends $4f04f5959af47e30$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $dFGUU.ElementType).CDATA;
    }
    get nodeType() {
        return 4;
    }
}
class $4f04f5959af47e30$export$b34a105447964f9f extends $4f04f5959af47e30$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $dFGUU.ElementType).Root;
    }
    get nodeType() {
        return 9;
    }
}
class $4f04f5959af47e30$export$db77ccec0bb4ccac extends $4f04f5959af47e30$export$62be934f90997196 {
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ constructor(name, attribs, children = [], type = name === "script" ? (0, $dFGUU.ElementType).Script : name === "style" ? (0, $dFGUU.ElementType).Style : (0, $dFGUU.ElementType).Tag){
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name)=>{
            var _a, _b;
            return {
                name: name,
                value: this.attribs[name],
                namespace: (_a = this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
        });
    }
}
function $4f04f5959af47e30$export$3bf645f08efe3292(node) {
    return (0, $dFGUU.isTag)(node);
}
function $4f04f5959af47e30$export$c2d65aed98d39b56(node) {
    return node.type === (0, $dFGUU.ElementType).CDATA;
}
function $4f04f5959af47e30$export$1879817ac5c922b7(node) {
    return node.type === (0, $dFGUU.ElementType).Text;
}
function $4f04f5959af47e30$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $dFGUU.ElementType).Comment;
}
function $4f04f5959af47e30$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $dFGUU.ElementType).Directive;
}
function $4f04f5959af47e30$export$62858bae88b53fd0(node) {
    return node.type === (0, $dFGUU.ElementType).Root;
}
function $4f04f5959af47e30$export$bd5ff50f0e53d41c(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
function $4f04f5959af47e30$export$ae8e35ea29ddac22(node, recursive = false) {
    let result;
    if ($4f04f5959af47e30$export$1879817ac5c922b7(node)) result = new $4f04f5959af47e30$export$5f1af8db9871e1d6(node.data);
    else if ($4f04f5959af47e30$export$3ab01370f5e64ac8(node)) result = new $4f04f5959af47e30$export$4d299b491347818a(node.data);
    else if ($4f04f5959af47e30$export$3bf645f08efe3292(node)) {
        const children = recursive ? $4f04f5959af47e30$var$cloneChildren(node.children) : [];
        const clone = new $4f04f5959af47e30$export$db77ccec0bb4ccac(node.name, {
            ...node.attribs
        }, children);
        children.forEach((child)=>child.parent = clone);
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = {
            ...node["x-attribsNamespace"]
        };
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = {
            ...node["x-attribsPrefix"]
        };
        result = clone;
    } else if ($4f04f5959af47e30$export$c2d65aed98d39b56(node)) {
        const children = recursive ? $4f04f5959af47e30$var$cloneChildren(node.children) : [];
        const clone = new $4f04f5959af47e30$export$1f8b8f7e5c763232(children);
        children.forEach((child)=>child.parent = clone);
        result = clone;
    } else if ($4f04f5959af47e30$export$62858bae88b53fd0(node)) {
        const children = recursive ? $4f04f5959af47e30$var$cloneChildren(node.children) : [];
        const clone = new $4f04f5959af47e30$export$b34a105447964f9f(children);
        children.forEach((child)=>child.parent = clone);
        if (node["x-mode"]) clone["x-mode"] = node["x-mode"];
        result = clone;
    } else if ($4f04f5959af47e30$export$4b5d79f26e0e3ad5(node)) {
        const instruction = new $4f04f5959af47e30$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error(`Not implemented yet: ${node.type}`);
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function $4f04f5959af47e30$var$cloneChildren(childs) {
    const children = childs.map((child)=>$4f04f5959af47e30$export$ae8e35ea29ddac22(child, true));
    for(let i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});




parcelRegister("3DQDh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5fc1ed3d912a3f1$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $jAgEx = parcelRequire("jAgEx");
var $4Qpe2 = parcelRequire("4Qpe2");

var $8FY87 = parcelRequire("8FY87");
function $c5fc1ed3d912a3f1$var$CopyUrlButton({ children: children, className: className }) {
    const [copied, setCopied] = (0, $8FY87.useState)(false);
    const timeoutRef = (0, $8FY87.useRef)(null);
    const copyCurrentUrl = async ()=>{
        const url = window.location.href;
        try {
            await navigator.clipboard.writeText(url);
        } catch  {
            const textarea = document.createElement('textarea');
            textarea.value = url;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
        }
        setCopied(true);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            setCopied(false);
        }, 3000);
    };
    (0, $8FY87.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
        type: "button",
        className: className,
        onClick: copyCurrentUrl,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                className: "underline opacity-60 hover:opacity-100",
                children: children
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jAgEx.AnimatePresence), {
                children: copied && /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).span, {
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    exit: {
                        opacity: 0
                    },
                    className: "inline-flex items-center gap-2 ml-3 text-sm copy-url__feedback",
                    "aria-live": "polite",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            fill: "currentColor",
                            className: "shrink-0 size-3",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                                d: "m10 15.17 9.192-9.191 1.414 1.414L10 17.999l-6.364-6.364 1.414-1.414z"
                            })
                        }),
                        "Kopierad"
                    ]
                })
            })
        ]
    });
}
var $c5fc1ed3d912a3f1$export$2e2bcd8739ae039 = $c5fc1ed3d912a3f1$var$CopyUrlButton;

});



parcelRegister("3C7AF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe11f515200c55ea$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $gWEat = parcelRequire("gWEat");

var $4Qpe2 = parcelRequire("4Qpe2");
function $fe11f515200c55ea$var$ColoredHero({ heading: heading, description: description, backgroundColor: backgroundColor, textColor: textColor, eyebrow: eyebrow }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
        className: "px-4 py-10 md:py-16 bg-[var(--hero-bg)] text-[var(--hero-text)]",
        style: {
            '--hero-bg': backgroundColor ?? '#05141F',
            '--hero-text': textColor ?? '#ffffff'
        },
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: "max-w-screen-kia-md mx-auto",
            children: [
                eyebrow && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                    initial: {
                        opacity: 0,
                        y: 16
                    },
                    animate: {
                        opacity: 1,
                        y: 0
                    },
                    transition: {
                        duration: 0.5,
                        ease: [
                            0.16,
                            1,
                            0.3,
                            1
                        ]
                    },
                    className: "inline-block border border-current/30 px-3 py-1 text-sm mb-6",
                    children: eyebrow
                }),
                heading && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).h1, {
                    initial: {
                        opacity: 0,
                        y: 20
                    },
                    animate: {
                        opacity: 1,
                        y: 0
                    },
                    transition: {
                        duration: 0.6,
                        delay: 0.1,
                        ease: [
                            0.16,
                            1,
                            0.3,
                            1
                        ]
                    },
                    className: "text-4xl md:text-6xl font-medium leading-tight mb-5",
                    children: heading
                }),
                description && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).p, {
                    initial: {
                        opacity: 0,
                        y: 16
                    },
                    animate: {
                        opacity: 1,
                        y: 0
                    },
                    transition: {
                        duration: 0.6,
                        delay: 0.2,
                        ease: [
                            0.16,
                            1,
                            0.3,
                            1
                        ]
                    },
                    className: "text-base font-light opacity-70 leading-relaxed",
                    dangerouslySetInnerHTML: {
                        __html: (0, (/*@__PURE__*/$parcel$interopDefault($gWEat))).sanitize(description)
                    }
                })
            ]
        })
    });
}
var $fe11f515200c55ea$export$2e2bcd8739ae039 = $fe11f515200c55ea$var$ColoredHero;

});
parcelRegister("gWEat", function(module, exports) {
/*! @license DOMPurify 3.4.14 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.14/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = true, o = false;
            try {
                if (i = (t = t.call(r)).next, 0 === l) ;
                else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = true, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    const entries = Object.entries, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    let freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    let _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(func, thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return func.apply(thisArg, args);
    };
    if (!construct) construct = function construct(Func) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const arrayIsArray = Array.isArray;
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const numberToString = unapply(Number.prototype.toString);
    const booleanToString = unapply(Boolean.prototype.toString);
    const bigintToString = typeof BigInt === 'undefined' ? null : unapply(BigInt.prototype.toString);
    const symbolToString = typeof Symbol === 'undefined' ? null : unapply(Symbol.prototype.toString);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const objectToString = unapply(Object.prototype.toString);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(Func) {
        return function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return construct(Func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        if (!arrayIsArray(array)) return set;
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const _ref2 of entries(object)){
            var _ref3 = _slicedToArray(_ref2, 2);
            const property = _ref3[0];
            const value = _ref3[1];
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (arrayIsArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * Convert non-node values into strings without depending on direct property access.
   *
   * @param value - The value to stringify.
   * @returns A string representation of the provided value.
   */ function stringifyValue(value) {
        switch(typeof value){
            case 'string':
                return value;
            case 'number':
                return numberToString(value);
            case 'boolean':
                return booleanToString(value);
            case 'bigint':
                return bigintToString ? bigintToString(value) : '0';
            case 'symbol':
                return symbolToString ? symbolToString(value) : 'Symbol()';
            case 'undefined':
                return objectToString(value);
            case 'function':
            case 'object':
                {
                    if (value === null) return objectToString(value);
                    const valueAsRecord = value;
                    const valueToString = lookupGetter(valueAsRecord, 'toString');
                    if (typeof valueToString === 'function') {
                        const stringified = valueToString(valueAsRecord);
                        return typeof stringified === 'string' ? stringified : objectToString(stringified);
                    }
                    return objectToString(value);
                }
            default:
                return objectToString(value);
        }
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    function isRegex(value) {
        try {
            regExpTest(value, '');
            return true;
        } catch (_unused) {
            return false;
        }
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'search',
        'section',
        'select',
        'shadow',
        'slot',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'enterkeyhint',
        'exportparts',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'inputmode',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'part',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'command',
        'commandfor',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'exportparts',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inert',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'part',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'slot',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dominant-baseline',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'mask-type',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'pointer-events',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-orientation',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'vector-effect',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnalign',
        'columnlines',
        'columnspacing',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lquote',
        'lspace',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    const MUSTACHE_EXPR = seal(/{{[\w\W]*|^[\w\W]*}}/g);
    const ERB_EXPR = seal(/<%[\w\W]*|^[\w\W]*%>/g);
    const TMPLIT_EXPR = seal(/\${[\w\W]*/g);
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    // Markup-significant character probes used by _sanitizeElements.
    // Shared module-level instances are safe despite the sticky /g flags:
    // unapply() resets lastIndex for RegExp receivers before every call.
    const ELEMENT_MARKUP_PROBE = seal(/<[/\w!]/g);
    const COMMENT_MARKUP_PROBE = seal(/<[/\w]/g);
    const FALLBACK_TAG_CLOSE = seal(/<\/no(script|embed|frames)/i);
    const SELF_CLOSING_TAG = seal(/\/>/i);
    // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        processingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    /* HTML-namespace elements whose child text nodes are serialized *literally*
     (unescaped) by the HTML fragment-serialization algorithm. Two reparse-mXSS
     shapes ride on that literal serialization:
       (a) an element child - a tree the HTML parser can never build, but the DOM
           API and an XML/XHTML parse can - after which a `</tag>`-bearing text
           sibling breaks the element open on reparse; and
       (b) text-only content that already carries the element's OWN end tag, e.g.
           `<style>...</style><img onerror=x>` built as a node, which the literal
           serializer emits verbatim for the HTML parser to re-open.
     Shape (a) is handled by the firstElementChild branch in _isUnsafeNode; shape
     (b) by the LITERAL_TEXT_CLOSE probe. Both read textContent (the raw-serialized
     form for these elements) rather than innerHTML, because an XML/XHTML working
     document serializes innerHTML with `<` escaped, which silently blinds the
     innerHTML-based probes (rule 1's second probe and FALLBACK_TAG_CLOSE) there.
     `script` is never allow-listed, but is kept here so the guard matches the
     serializer's own literal-text list exactly. */ const LITERAL_TEXT_ELEMENT_NAMES = [
        'style',
        'script',
        'xmp',
        'iframe',
        'noembed',
        'noframes',
        'plaintext',
        'noscript'
    ];
    const LITERAL_TEXT_ELEMENTS = freeze(addToSet({}, LITERAL_TEXT_ELEMENT_NAMES));
    /* Per-element end-tag matcher. On an HTML reparse the ONLY token that
     terminates a literal-text element's raw content is its own end tag; a foreign
     literal-text close (e.g. `</xmp>` sitting inside `<style>`) does not break
     out, so matching is per-element, not a shared alternation. The lookahead
     requires an HTML tag-name terminator (whitespace, `/` or `>`) so a longer
     name such as `</styles` is not mistaken for `</style`. */ const LITERAL_TEXT_CLOSE = function() {
        const map = {};
        arrayForEach(LITERAL_TEXT_ELEMENT_NAMES, (name)=>{
            map[name] = seal(new RegExp('</' + name + '(?=[\\t\\n\\f\\r />])', 'i'));
        });
        return freeze(map);
    }();
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    /**
   * Resolve a set-valued configuration option: a fresh set built from
   * cfg[key] when it is an own array property (seeded with a clone of
   * options.base when given, case-normalized via options.transform),
   * the fallback set otherwise.
   *
   * @param cfg the cloned, prototype-free configuration object
   * @param key the configuration property to read
   * @param fallback the set to use when the option is absent or not an array
   * @param options transform and optional base set to merge into
   * @returns the resolved set
   */ const _resolveSetOption = function _resolveSetOption(cfg, key, fallback, options) {
        return objectHasOwnProperty(cfg, key) && arrayIsArray(cfg[key]) ? addToSet(options.base ? clone(options.base) : {}, cfg[key], options.transform) : fallback;
    };
    /**
   * Resolve an object-valued configuration option: a prototype-free clone
   * of cfg[key] when it is an own, truthy object property, else a fresh
   * fallback built by makeFallback (fresh on every parse, so a previous
   * parse can never leak state into the next one).
   *
   * @param cfg the cloned, prototype-free configuration object
   * @param key the configuration property to read
   * @param makeFallback builds the fallback value when the option is absent
   * @returns the resolved object
   */ const _resolveObjectOption = function _resolveObjectOption(cfg, key, makeFallback) {
        const value = objectHasOwnProperty(cfg, key) ? cfg[key] : undefined;
        return value && typeof value === 'object' ? clone(value) : makeFallback();
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.4.14';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let document = window1.document;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        window1.DocumentFragment;
        const HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap;
        _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap;
        window1.HTMLFormElement;
        const DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        const getShadowRoot = lookupGetter(ElementPrototype, 'shadowRoot');
        const getAttributes = lookupGetter(ElementPrototype, 'attributes');
        const getNodeType = Node && Node.prototype ? lookupGetter(Node.prototype, 'nodeType') : null;
        const getNodeName = Node && Node.prototype ? lookupGetter(Node.prototype, 'nodeName') : null;
        const getOwnerDocument = Node && Node.prototype ? lookupGetter(Node.prototype, 'ownerDocument') : null;
        /* Clobber-safe nodeType / nodeName reads through the cached Node.prototype
       getters, with a direct-property fallback for environments that lack
       Node.prototype. Sites that need a different fallback (e.g. _isClobbered
       returns early on a null name) intentionally keep their own reads. */ const _readNodeType = function _readNodeType(node) {
            return getNodeType ? getNodeType(node) : node.nodeType;
        };
        const _readNodeName = function _readNodeName(node) {
            return getNodeName ? getNodeName(node) : node.nodeName;
        };
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        // The instance's own internal Trusted Types policy. Unlike a caller-supplied
        // `TRUSTED_TYPES_POLICY`, this is created at most once — Trusted Types throws
        // on duplicate policy names — and is the only policy allowed to persist
        // across configurations and survive `clearConfig()`.
        let defaultTrustedTypesPolicy;
        let defaultTrustedTypesPolicyResolved = false;
        // Tracks whether we are already inside a call to the configured Trusted Types
        // policy (`createHTML` or `createScriptURL`). If a supplied policy callback
        // itself calls `DOMPurify.sanitize` (the cause of #1422), `sanitize` would
        // re-enter the policy and recurse until the stack overflows. We detect that
        // re-entry and throw a clear, actionable error instead. The guard is shared
        // across both callbacks, because either one re-entering `sanitize` triggers
        // the same unbounded recursion.
        let IN_TRUSTED_TYPES_POLICY = 0;
        const _assertNotInTrustedTypesPolicy = function _assertNotInTrustedTypesPolicy() {
            if (IN_TRUSTED_TYPES_POLICY > 0) throw typeErrorCreate('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
        };
        const _createTrustedHTML = function _createTrustedHTML(html) {
            _assertNotInTrustedTypesPolicy();
            IN_TRUSTED_TYPES_POLICY++;
            try {
                return trustedTypesPolicy.createHTML(html);
            } finally{
                IN_TRUSTED_TYPES_POLICY--;
            }
        };
        const _createTrustedScriptURL = function _createTrustedScriptURL(scriptUrl) {
            _assertNotInTrustedTypesPolicy();
            IN_TRUSTED_TYPES_POLICY++;
            try {
                return trustedTypesPolicy.createScriptURL(scriptUrl);
            } finally{
                IN_TRUSTED_TYPES_POLICY--;
            }
        };
        // Lazily resolve (and cache) the instance's internal default policy.
        // Resolution is attempted at most once: a successful `createPolicy` cannot be
        // repeated (Trusted Types throws on duplicate names), and a failed or
        // unsupported attempt must not be retried on every parse.
        const _getDefaultTrustedTypesPolicy = function _getDefaultTrustedTypesPolicy() {
            if (!defaultTrustedTypesPolicyResolved) {
                defaultTrustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                defaultTrustedTypesPolicyResolved = true;
            }
            return defaultTrustedTypesPolicy;
        };
        const _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        const importNode = originalDocument.importNode;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        let IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
            tagCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            }
        }));
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Pristine allowlist bindings captured at setConfig() time. On the
     * persistent-config path sanitize() restores the sets from these before
     * the per-walk hook clone-guard, so a hook's in-call widening cannot
     * carry across calls. Null until setConfig() is called; reset by
     * clearConfig(). */ let SET_CONFIG_ALLOWED_TAGS = null;
        let SET_CONFIG_ALLOWED_ATTR = null;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
            // the UA (customizable <select>) — including any on* handlers — and the
            // engine re-mirrors synchronously whenever a removal changes which
            // option/selectedcontent is current, even inside DOMPurify's inert
            // DOMParser document. Hoisting its children on removal re-inserts a fresh
            // mirror target ahead of the walk, which the engine refills, looping
            // forever (DoS) and amplifying output. Dropping its content on removal
            // (rather than hoisting) breaks that cascade; the content is a duplicate
            // of the option, which is sanitized on its own. See campaign-3 F1/F6.
            'selectedcontent',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        const DEFAULT_MATHML_TEXT_INTEGRATION_POINTS = freeze([
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS);
        const DEFAULT_HTML_INTEGRATION_POINTS = freeze([
            'annotation-xml'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = _resolveSetOption(cfg, 'ALLOWED_TAGS', DEFAULT_ALLOWED_TAGS, {
                transform: transformCaseFunc
            });
            ALLOWED_ATTR = _resolveSetOption(cfg, 'ALLOWED_ATTR', DEFAULT_ALLOWED_ATTR, {
                transform: transformCaseFunc
            });
            ALLOWED_NAMESPACES = _resolveSetOption(cfg, 'ALLOWED_NAMESPACES', DEFAULT_ALLOWED_NAMESPACES, {
                transform: stringToString
            });
            URI_SAFE_ATTRIBUTES = _resolveSetOption(cfg, 'ADD_URI_SAFE_ATTR', DEFAULT_URI_SAFE_ATTRIBUTES, {
                transform: transformCaseFunc,
                base: DEFAULT_URI_SAFE_ATTRIBUTES
            });
            DATA_URI_TAGS = _resolveSetOption(cfg, 'ADD_DATA_URI_TAGS', DEFAULT_DATA_URI_TAGS, {
                transform: transformCaseFunc,
                base: DEFAULT_DATA_URI_TAGS
            });
            FORBID_CONTENTS = _resolveSetOption(cfg, 'FORBID_CONTENTS', DEFAULT_FORBID_CONTENTS, {
                transform: transformCaseFunc
            });
            FORBID_TAGS = _resolveSetOption(cfg, 'FORBID_TAGS', clone({}), {
                transform: transformCaseFunc
            });
            FORBID_ATTR = _resolveSetOption(cfg, 'FORBID_ATTR', clone({}), {
                transform: transformCaseFunc
            });
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === 'object' ? clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : IS_ALLOWED_URI; // Default regexp
            NAMESPACE = typeof cfg.NAMESPACE === 'string' ? cfg.NAMESPACE : HTML_NAMESPACE; // Default HTML namespace
            MATHML_TEXT_INTEGRATION_POINTS = _resolveObjectOption(cfg, 'MATHML_TEXT_INTEGRATION_POINTS', ()=>addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS) // Default built-in map
            );
            HTML_INTEGRATION_POINTS = _resolveObjectOption(cfg, 'HTML_INTEGRATION_POINTS', ()=>addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS) // Default built-in map
            );
            const customElementHandling = _resolveObjectOption(cfg, 'CUSTOM_ELEMENT_HANDLING', ()=>create(null));
            CUSTOM_ELEMENT_HANDLING = create(null);
            if (objectHasOwnProperty(customElementHandling, 'tagNameCheck') && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck; // Default undefined
            if (objectHasOwnProperty(customElementHandling, 'attributeNameCheck') && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck; // Default undefined
            if (objectHasOwnProperty(customElementHandling, 'allowCustomizedBuiltInElements') && typeof customElementHandling.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements; // Default undefined
            seal(CUSTOM_ELEMENT_HANDLING);
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = create(null);
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Always reset function-based ADD_TAGS / ADD_ATTR checks to prevent
       * leaking across calls when switching from function to array config */ EXTRA_ELEMENT_HANDLING.tagCheck = null;
            EXTRA_ELEMENT_HANDLING.attributeCheck = null;
            /* Merge configuration parameters */ if (objectHasOwnProperty(cfg, 'ADD_TAGS')) {
                if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
                else if (arrayIsArray(cfg.ADD_TAGS)) {
                    if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                    addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, 'ADD_ATTR')) {
                if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
                else if (arrayIsArray(cfg.ADD_ATTR)) {
                    if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                    addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, 'ADD_FORBID_CONTENTS') && arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Re-derive the active Trusted Types policy from this configuration on
            // every parse. The active policy must never be sticky closure state that
            // outlives the config that set it: a caller-supplied policy left in place
            // after `clearConfig()` — or after a later call that supplied none, or
            // `TRUSTED_TYPES_POLICY: null` — could sign a subsequent "default"
            // `RETURN_TRUSTED_TYPE` result with a foreign, possibly unsafe policy.
            // See GHSA-vxr8-fq34-vvx9.
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // A caller-supplied policy applies to this configuration only.
                const previousTrustedTypesPolicy = trustedTypesPolicy;
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`. If the supplied policy's
                // `createHTML` is circular (i.e. it calls `DOMPurify.sanitize`), this
                // throws via the re-entrancy guard. Restore the previous policy first so
                // the instance is not left in a poisoned state. See #1422.
                try {
                    emptyHTML = _createTrustedHTML('');
                } catch (error) {
                    trustedTypesPolicy = previousTrustedTypesPolicy;
                    throw error;
                }
            } else if (cfg.TRUSTED_TYPES_POLICY === null) {
                // Explicit opt-out for this call: perform no Trusted Types signing and
                // create nothing (so a strict `trusted-types` CSP that disallows a
                // `dompurify` policy can still call `sanitize` from inside its own
                // policy — see #1422). Resetting to `undefined` rather than a sticky
                // `null` also drops any previously retained caller policy, so it cannot
                // resurface on a later call, while still allowing the next config-less
                // call to restore the internal default policy. See GHSA-vxr8-fq34-vvx9.
                trustedTypesPolicy = undefined;
                emptyHTML = '';
            } else {
                // No policy supplied: keep the currently active policy if one is set — a
                // previously supplied policy is intentionally sticky across config-less
                // calls — otherwise fall back to the instance's own internal policy,
                // created at most once. (A policy supplied for a *single* call still
                // lingers by design; what must not linger is a policy whose configuration
                // has been torn down via `clearConfig()`, which restores the default.)
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _getDefaultTrustedTypesPolicy();
                // Sign internal variables only when a policy is active. A falsy policy
                // (Trusted Types unsupported, creation failed, or an explicit opt-out)
                // leaves `emptyHTML` as a plain string, so we never call `.createHTML` on
                // a non-policy and throw. See #1422.
                if (trustedTypesPolicy && typeof emptyHTML === 'string') emptyHTML = _createTrustedHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * Namespace rules for an element in the SVG namespace.
     *
     * @param tagName the element's lowercase tag name
     * @param parent the (possibly simulated) parent node
     * @param parentTagName the parent's lowercase tag name
     * @returns true if a spec-compliant parser could produce this element
     */ const _checkSvgNamespace = function _checkSvgNamespace(tagName, parent, parentTagName) {
            // The only way to switch from HTML namespace to SVG
            // is via <svg>. If it happens via any other tag, then
            // it should be killed.
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
            // The only way to switch from MathML to SVG is via <svg>
            // if the parent is either <annotation-xml> or a MathML
            // text integration point.
            if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
            // We only allow elements that are defined in SVG
            // spec. All others are disallowed in SVG namespace.
            return Boolean(ALL_SVG_TAGS[tagName]);
        };
        /**
     * Namespace rules for an element in the MathML namespace.
     *
     * @param tagName the element's lowercase tag name
     * @param parent the (possibly simulated) parent node
     * @param parentTagName the parent's lowercase tag name
     * @returns true if a spec-compliant parser could produce this element
     */ const _checkMathMlNamespace = function _checkMathMlNamespace(tagName, parent, parentTagName) {
            // The only way to switch from HTML namespace to MathML
            // is via <math>. If it happens via any other tag, then
            // it should be killed.
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
            // The only way to switch from SVG to MathML is via
            // <math> and HTML integration points
            if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
            // We only allow elements that are defined in MathML
            // spec. All others are disallowed in MathML namespace.
            return Boolean(ALL_MATHML_TAGS[tagName]);
        };
        /**
     * Namespace rules for an element in the HTML namespace.
     *
     * @param tagName the element's lowercase tag name
     * @param parent the (possibly simulated) parent node
     * @param parentTagName the parent's lowercase tag name
     * @returns true if a spec-compliant parser could produce this element
     */ const _checkHtmlNamespace = function _checkHtmlNamespace(tagName, parent, parentTagName) {
            // The only way to switch from SVG to HTML is via
            // HTML integration points, and from MathML to HTML
            // is via MathML text integration points
            if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
            if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
            // We disallow tags that are specific for MathML
            // or SVG and should never appear in HTML namespace
            return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
        };
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) return _checkSvgNamespace(tagName, parent, parentTagName);
            if (element.namespaceURI === MATHML_NAMESPACE) return _checkMathMlNamespace(tagName, parent, parentTagName);
            if (element.namespaceURI === HTML_NAMESPACE) return _checkHtmlNamespace(tagName, parent, parentTagName);
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                /* The normal detach failed — this is reached for a parentless node
           (getParentNode() is null, so .removeChild throws). Element.prototype
           .remove() is itself a spec no-op on a parentless node, so a recorded
           "removal" would otherwise hand the caller back an intact,
           payload-bearing node (e.g. a detached IN_PLACE root the mXSS canary or
           the style-with-element-child rule decided to kill). Fail closed by
           throwing — exactly as a clobbered root does at the IN_PLACE entry —
           rather than trying to "neutralize" the node via its own methods.
           Neutralizing would mean calling getAttributeNames()/removeAttribute()
           on the node, both of which a <form> root can clobber via a named child
           (and _isClobbered does not even probe getAttributeNames), so the
           neutralize step could itself be silently defeated, leaving the payload
           intact. A throw touches only the cached, clobber-safe remove() and
           getParentNode(). Generalizes GHSA-r47g-fvhr-h676 (clobbered-form root)
           to every root-kill reason. REPORT-3.
                  This lives inside the catch, so it never fires for a normally-removed
           in-tree node: those have a parent, removeChild() succeeds, and the
           catch is not entered. Only a kept (parentless) root reaches here. */ remove(node);
                if (!getParentNode(node)) throw typeErrorCreate("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
            }
        };
        /**
     * _stripAttributeNode
     *
     * Remove a single Attr node case/namespace-exactly on an attribute-teardown
     * path. Name-based removeAttribute() ASCII-lowercases its lookup key for an
     * HTML element in an HTML document and so silently misses a case-preserved
     * handler (e.g. `ONERROR` off an XML/XHTML import) - the same defect
     * _removeAttribute() was fixed for, which a name-based call would reintroduce
     * on these IN_PLACE teardown paths. Unlike _removeAttribute this does not
     * record into DOMPurify.removed: the neutralize passes intentionally do not
     * book-keep. A clobbered/detached node falls back to best-effort name-based
     * removal.
     *
     * @param element the element to strip the attribute from
     * @param attribute the Attr node to remove
     * @param name the attribute's name, for the fallback path
     */ const _stripAttributeNode = function _stripAttributeNode(element, attribute, name) {
            try {
                element.removeAttributeNode(attribute);
            } catch (_) {
                try {
                    element.removeAttribute(name);
                } catch (_) {}
            }
        };
        /**
     * _neutralizeRoot
     *
     * Fail-closed teardown of an in-place root after the sanitize walk aborts
     * (campaign-3 F2). An internal throw mid-walk — e.g. a page-registered
     * custom element's reaction detaches a node so `_forceRemove`'s deliberate
     * parentless guard throws, or any other re-entrant engine mutation — would
     * otherwise leave the caller's *live* tree half-sanitized, with everything
     * after the abort point still carrying its handlers. There is no safe way
     * to resume the walk (the tree mutated under us), so we strip the root bare:
     * remove every child and every attribute, then let the caller's catch see
     * the original error. Clobber-safe (cached `remove`/`childNodes`/`attributes`
     * getters; the root was already clobber-pre-flighted at the IN_PLACE entry).
     *
     * @param root the in-place root to empty
     */ const _neutralizeRoot = function _neutralizeRoot(root) {
            /* Strip every disallowed attribute (on* handlers included) off the whole
         subtree BEFORE detaching anything. Detaching first would hand back
         handler-bearing originals (e.g. an already-loading `<img onerror>`)
         whose queued resource event still fires in page scope after we throw.
         Clobber-safe reads; a doomed clobbered node's own attributes are
         irrelevant while its non-clobbered descendants are reached and scrubbed. */ _neutralizeSubtree(root);
            const childNodes = getChildNodes(root);
            if (childNodes) {
                const snapshot = [];
                arrayForEach(childNodes, (child)=>{
                    arrayPush(snapshot, child);
                });
                arrayForEach(snapshot, (child)=>{
                    try {
                        remove(child);
                    } catch (_) {
                    /* Best-effort teardown; a still-attached child is handled below */ }
                });
            }
            const attributes = getAttributes(root);
            if (attributes) for(let i = attributes.length - 1; i >= 0; --i){
                const attribute = attributes[i];
                const name = attribute && attribute.name;
                if (typeof name === 'string') _stripAttributeNode(root, attribute, name);
            }
        };
        /**
     * _removeAttribute
     *
     * Name-based getAttributeNode()/removeAttribute() ASCII-lowercase their
     * lookup key for HTML elements in an HTML document, so they silently miss an
     * attribute whose stored qualified name still contains uppercase ASCII
     * letters. That happens when the node came from a case-preserving source
     * (an XML/XHTML document imported via importNode(), or createAttributeNS()),
     * where e.g. `ONERROR` survives the walk: the policy check lowercases to
     * `onerror` and rejects it, but `removeAttribute('ONERROR')` looks up
     * `onerror` and finds nothing. Remove the exact Attr node instead, which is
     * case- and namespace-exact, and fall back to name-based removal only when
     * the caller could not supply the node.
     *
     * @param name an Attribute name
     * @param element a DOM node
     * @param attr the exact Attr node to remove, when the caller has it
     */ const _removeAttribute = function _removeAttribute(name, element, attr) {
            if (!attr) try {
                attr = element.getAttributeNode(name);
            } catch (_) {
                attr = null;
            }
            arrayPush(DOMPurify.removed, {
                attribute: attr || null,
                from: element
            });
            try {
                if (attr) element.removeAttributeNode(attr);
                else element.removeAttribute(name);
            } catch (_) {
                /* Clobbered or already-detached node - best-effort fall back to a
           name-based removal so the "is" handling below still runs. */ try {
                    element.removeAttribute(name);
                } catch (_) {}
            }
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _stripDisallowedAttributes
     *
     * Removes every attribute the active configuration does not allow from a
     * single element, using the same allowlist as the main attribute pass (so
     * `on*` handlers go, but no `/^on/` blocklist is introduced). Used only to
     * neutralise nodes that are being discarded from an in-place tree.
     *
     * @param element the element to strip
     */ const _stripDisallowedAttributes = function _stripDisallowedAttributes(element) {
            const attributes = getAttributes(element);
            if (!attributes) return;
            for(let i = attributes.length - 1; i >= 0; --i){
                const attribute = attributes[i];
                const name = attribute && attribute.name;
                if (typeof name !== 'string' || ALLOWED_ATTR[transformCaseFunc(name)]) continue;
                _stripAttributeNode(element, attribute, name);
            }
        };
        /**
     * _neutralizeSubtree
     *
     * Completes the audit-5 F1 fix across every removal path. The KEEP_CONTENT
     * move-hoist neutralises only disallowed-tag removals; clobber, mXSS-canary,
     * namespace, comment, processing-instruction and KEEP_CONTENT:false removals
     * all drop their subtree wholesale via `_forceRemove`. On the IN_PLACE path
     * those dropped nodes are detached from the caller's LIVE tree but a
     * handler-bearing original among them (an `<img onerror>`/`<video>` that was
     * loading) keeps its queued resource event, which fires in page scope after
     * sanitize returns. This walks a removed subtree and strips every attribute
     * the active configuration does not allow — so `on*` handlers are cancelled
     * through the SAME allowlist that governs kept nodes, not a separate `/^on/`
     * blocklist. Run synchronously before sanitize returns, i.e. before any
     * queued event can fire. Hook-free by design: these nodes leave the output,
     * so firing attribute hooks for them would be surprising. Clobber-safe reads;
     * a doomed clobbered node may shadow `removeAttribute` (its own attributes are
     * irrelevant — it is discarded — while its non-clobbered descendants, e.g.
     * the `<img>`, are reached and scrubbed).
     *
     * @param root the root of a removed subtree to neutralise
     */ const _neutralizeSubtree = function _neutralizeSubtree(root) {
            const stack = [
                root
            ];
            while(stack.length > 0){
                const node = stack.pop();
                const nodeType = _readNodeType(node);
                if (nodeType === NODE_TYPE.element) _stripDisallowedAttributes(node);
                const childNodes = getChildNodes(node);
                if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
            }
        };
        /**
     * _neutralizePatchLinkage
     *
     * IN_PLACE entry pre-pass (declarative-partial-updates / streaming
     * hardening, https://github.com/WICG/declarative-partial-updates).
     *
     * The main walk strips patch linkage (`for`/`patchsrc`) and removes range
     * markers (PIs / markup comments) node-by-node, in document order, AS it
     * reaches each node. On a live in-place root that leaves a window: from the
     * moment the root is connected until the walk arrives at a given node, that
     * node's linkage is live. A patch applied on connection/stream can fire as
     * a microtask during the walk and inject or teleport an unsanitized DOM
     * range into a region the iterator has already passed and will not revisit,
     * so the post-return "tree is sanitized" contract is violated. Sweep the
     * whole tree once up front and sever every linkage before the walk begins,
     * closing that window.
     *
     * This CANNOT undo a patch that already fired before sanitize ran — that is
     * the irreducible "do not IN_PLACE a live-connected attacker tree" caveat —
     * but it closes everything from sanitize-start onward. Gated on SAFE_FOR_XML
     * to group with the rest of the declarative-partial-updates handling and
     * stay overridable, consistent with the codebase.
     *
     * Clobber-safe traversal (cached childNodes getter); per-node try/catch so a
     * clobbered root cannot defeat the sweep of its non-clobbered descendants.
     *
     * NOTE (pending real-Chrome confirmation, see test/declarative-patch-probe
     * .html Q1): this mirrors the existing policy of keeping `for` on
     * <label>/<output>. If the shipping feature can drive a patch through a
     * surviving `for`-on-label/output + `id` pair, this pre-pass and the
     * attribute check at _isBasicCustomElement's caller must additionally drop
     * that pair on the IN_PLACE path. Left as-is until the taxonomy is verified.
     *
     * @param root the in-place root to sweep
     */ /**
     * Central policy for declarative-partial-updates patch-linkage attributes,
     * shared by the _neutralizePatchLinkage pre-pass and _isValidAttribute so
     * the two sites cannot drift: `patchsrc` always links, `for` links
     * everywhere except on <label>/<output>, and the whole policy is gated on
     * SAFE_FOR_XML (see the rationale block in _isValidAttribute).
     *
     * @param lcName the transformCaseFunc'd attribute name
     * @param lcTag the transformCaseFunc'd tag name of the carrying element
     * @return true if the attribute is patch linkage and must be dropped
     */ const _isPatchLinkageAttribute = function _isPatchLinkageAttribute(lcName, lcTag) {
            if (!SAFE_FOR_XML) return false;
            if (lcName === 'patchsrc') return true;
            return lcName === 'for' && lcTag !== 'label' && lcTag !== 'output';
        };
        const _neutralizePatchLinkage = function _neutralizePatchLinkage(root) {
            if (!SAFE_FOR_XML) return;
            const stack = [
                root
            ];
            while(stack.length > 0){
                const node = stack.pop();
                const nodeType = _readNodeType(node);
                /* Remove range markers (the target side of a patch linkage): every
           processing instruction, and any markup-bearing comment. */ if (nodeType === NODE_TYPE.processingInstruction || nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, node.data)) {
                    try {
                        remove(node);
                    } catch (_) {
                    /* Best-effort */ }
                    continue;
                }
                /* Strip patch-source attributes (the source side) off elements. */ if (nodeType === NODE_TYPE.element) {
                    const element = node;
                    const lcTag = transformCaseFunc(_readNodeName(node));
                    try {
                        if (element.hasAttribute && element.hasAttribute('patchsrc')) element.removeAttribute('patchsrc');
                        if (element.hasAttribute && element.hasAttribute('for') && _isPatchLinkageAttribute('for', lcTag)) element.removeAttribute('for');
                    } catch (_) {
                    /* Clobbered removeAttribute/hasAttribute on a doomed node — ignore */ }
                }
                const childNodes = getChildNodes(node);
                if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? _createTrustedHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            /* Read ownerDocument through the cached Node.prototype getter, never the
         direct property. HTMLFormElement has [LegacyOverrideBuiltIns], so a
         clobbering child (<input name="ownerDocument"> or a form-associated
         external input) shadows the prototype getter and makes a direct read
         return that <input>. createNodeIterator.call(<input>, ...) then throws
         "Illegal invocation", and on the IN_PLACE path that throw lands before
         the walk's fail-closed barrier - leaving the caller's live tree, with
         any already-armed handler in it, un-neutralized. The cached getter
         returns the real Document regardless of the clobber. */ const doc = getOwnerDocument ? getOwnerDocument(root) : root.ownerDocument;
            return createNodeIterator.call(doc || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * Replace template expression syntax (mustache, ERB, template
     * literal) with a space; shared by all SAFE_FOR_TEMPLATES scrub
     * sites. Order matters: mustache, then ERB, then template literal.
     *
     * @param value the string to scrub
     * @returns the scrubbed string
     */ const _stripTemplateExpressions = function _stripTemplateExpressions(value) {
            value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
            value = stringReplace(value, ERB_EXPR$1, ' ');
            value = stringReplace(value, TMPLIT_EXPR$1, ' ');
            return value;
        };
        /**
     * Strip template-engine expressions ({{...}}, ${...}, <%...%>) from the
     * character data of an element subtree. Used as the final safety net for
     * SAFE_FOR_TEMPLATES on every DOM-returning code path so that expressions
     * which only form after text-node normalization (e.g. fragments split across
     * stripped elements) cannot survive into a template-evaluating framework.
     *
     * Walks text/comment/CDATA/processing-instruction nodes and mutates `.data`
     * in place rather than round-tripping through innerHTML. This preserves
     * descendant node references (important for IN_PLACE callers), avoids a
     * serialize/reparse cycle, and reads literal character data — which means
     * `<%...%>` in text content matches the ERB regex against its real bytes
     * instead of the HTML-entity-escaped form innerHTML would produce.
     *
     * Attribute values are not visited here; SAFE_FOR_TEMPLATES handling for
     * attributes is performed during the per-node `_sanitizeAttributes` pass.
     *
     * @param node The root element whose character data should be scrubbed.
     */ const _scrubTemplateExpressions2 = function _scrubTemplateExpressions(node) {
            var _node$querySelectorAl;
            node.normalize();
            /* Clobber-safe ownerDocument read, same reasoning as _createNodeIterator:
         under SAFE_FOR_TEMPLATES this runs on the live IN_PLACE root, which may
         carry a form-named-getter override of ownerDocument. */ const doc = getOwnerDocument ? getOwnerDocument(node) : node.ownerDocument;
            const walker = createNodeIterator.call(doc || node, node, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
            let currentNode = walker.nextNode();
            while(currentNode){
                currentNode.data = _stripTemplateExpressions(currentNode.data);
                currentNode = walker.nextNode();
            }
            // NodeIterator does not descend into <template>.content per the DOM spec,
            // so we must explicitly recurse into each template's content fragment,
            // mirroring the approach used by _sanitizeShadowDOM.
            const templates = (_node$querySelectorAl = node.querySelectorAll) === null || _node$querySelectorAl === void 0 ? void 0 : _node$querySelectorAl.call(node, 'template');
            if (templates) arrayForEach(templates, (tmpl)=>{
                if (_isDocumentFragment(tmpl.content)) _scrubTemplateExpressions2(tmpl.content);
            });
        };
        /**
     * _isClobbered
     *
     * Detect DOM-clobbering on HTMLFormElement nodes. Form is the only HTML
     * interface with [LegacyOverrideBuiltIns]; a descendant element with a
     * `name` attribute matching a prototype property shadows that property
     * on direct reads. We use this check at the IN_PLACE entry-point and
     * during attribute sanitization to refuse clobbered forms.
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            // Realm-independent tag-name probe. If we can't determine the tag
            // name at all, we can't reason about clobbering — return false
            // (the caller's other defences still apply).
            const realTagName = getNodeName ? getNodeName(element) : null;
            if (typeof realTagName !== 'string') return false;
            if (transformCaseFunc(realTagName) !== 'form') return false;
            return typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || // Realm-safe NamedNodeMap detection: equality against the cached
            // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
            // makes the direct read diverge from the cached read; a clean form
            // (same-realm OR foreign-realm) has both reads pointing at the same
            // canonical NamedNodeMap.
            element.attributes !== getAttributes(element) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function' || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
            // returns the integer 1 for any Element regardless of realm; direct
            // read on a clobbered form (e.g. <input name="nodeType">) returns
            // the named child element. Cheap addition — nodeType is read from
            // an internal slot, no serialization cost — and removes a residual
            // clobbering surface used by several mXSS / PI / comment branches
            // in _sanitizeElements that compare currentNode.nodeType directly.
            element.nodeType !== getNodeType(element) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
            // "childNodes" shadows the prototype getter. Direct reads of
            // form.childNodes from a clobbered form return the named child
            // instead of the real NodeList, so any walk that reads it directly
            // skips the form's real children. Compare the direct read to the
            // cached Node.prototype getter — when the form's named-property
            // getter intercepts the read, the two values differ and we flag
            // the form. This catches every clobbering child type (input,
            // select, etc.) regardless of whether the named child happens to
            // carry a numeric .length, which a typeof-based probe would miss
            // (e.g. HTMLSelectElement.length is a defined unsigned-long).
            element.childNodes !== getChildNodes(element);
        };
        /**
     * Checks whether the given value is a DocumentFragment from any realm.
     *
     * The realm-independent replacement reads `nodeType` through the cached
     * Node.prototype getter and compares to the DOCUMENT_FRAGMENT_NODE
     * constant (11). nodeType is a numeric value resolved from the node's
     * internal slot, identical across realms for the same kind of node.
     *
     * @param value object to check
     * @return true if value is a DocumentFragment-shaped node from any realm
     */ const _isDocumentFragment = function _isDocumentFragment(value) {
            if (!getNodeType || typeof value !== 'object' || value === null) return false;
            try {
                return getNodeType(value) === NODE_TYPE.documentFragment;
            } catch (_) {
                return false;
            }
        };
        /**
     * Checks whether the given object is a DOM node, including nodes that
     * originate from a different window/realm (e.g. an iframe's
     * contentDocument). The previous `value instanceof Node` check was
     * realm-bound: nodes from a different window failed it, causing
     * sanitize() to silently stringify them and reset IN_PLACE to false,
     * returning the original node unsanitized. See GHSA-4w3q-35jp-p934.
     *
     * @param value object to check whether it's a DOM node
     * @return true if value is a DOM node from any realm
     */ const _isNode = function _isNode(value) {
            if (!getNodeType || typeof value !== 'object' || value === null) return false;
            try {
                return typeof getNodeType(value) === 'number';
            } catch (_) {
                return false;
            }
        };
        function _executeHooks(hooks, currentNode, data) {
            if (hooks.length === 0) return;
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * Structural-threat checks that condemn a node regardless of the
     * allowlists: mXSS via namespace confusion, risky CSS construction,
     * processing instructions, markup-bearing comments. Pure predicate;
     * the caller removes. Check order is load-bearing.
     *
     * @param currentNode the node to inspect
     * @param tagName the node's transformCaseFunc'd tag name
     * @return true if the node must be removed
     */ const _isUnsafeNode = function _isUnsafeNode(currentNode, tagName) {
            /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.textContent) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.innerHTML)) return true;
            /* Remove rawtext/literal-text elements whose literal serialization
         re-opens markup on an HTML reparse - shapes (a) and (b) documented at
         LITERAL_TEXT_ELEMENTS. Both are invisible to rule 1 above (which
         self-disables once there is an element child, and whose second probe
         reads the innerHTML an XML/XHTML document serializes escaped), which
         is why both probes here read textContent instead. Previously only
         `style`-with-element-child was covered; every element in
         LITERAL_TEXT_ELEMENTS shares this literal serialization and is
         equally affected. */ if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && LITERAL_TEXT_ELEMENTS[tagName] && (_isNode(currentNode.firstElementChild) || typeof currentNode.textContent === 'string' && regExpTest(LITERAL_TEXT_CLOSE[tagName], currentNode.textContent))) return true;
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.processingInstruction) return true;
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, currentNode.data)) return true;
            return false;
        };
        /**
     * Evaluate a CUSTOM_ELEMENT_HANDLING check (a RegExp or a predicate
     * function, per the validation in _parseConfig) against a name.
     * Additional arguments are forwarded to predicate functions - the
     * attributeNameCheck predicate receives the tag name as its second
     * argument. A null/absent check never matches.
     *
     * @param check the configured tagNameCheck / attributeNameCheck value
     * @param name the name to test
     * @param args extra arguments forwarded to a predicate function
     * @return true if the check matches the name
     */ const _matchesNameCheck = function _matchesNameCheck(check, name) {
            if (check instanceof RegExp) return regExpTest(check, name);
            if (check instanceof Function) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                return Boolean(check(name, ...args));
            }
            return false;
        };
        /**
     * Handle a node whose tag is forbidden or not allowlisted: keep
     * allowed custom elements (false return exits _sanitizeElements
     * early - the namespace and fallback-tag removal checks are
     * intentionally skipped for kept custom elements), else hoist
     * content per KEEP_CONTENT and remove.
     *
     * A kept custom element is the ONLY case in which this function
     * returns false, so the caller uses that return value to run the
     * afterSanitizeElements hook on the kept element and keep the
     * element-hook lifecycle consistent with normal allowlisted
     * elements (GHSA-c2j3-45gr-mqc4).
     *
     * @param currentNode the disallowed node
     * @param tagName the node's transformCaseFunc'd tag name
     * @return true if the node was removed, false if kept
     */ const _sanitizeDisallowedNode = function _sanitizeDisallowedNode(currentNode, tagName, root) {
            /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
            /* Keep content except for bad-listed elements.
           Use the cached prototype getters exclusively — the previous code
           had `|| currentNode.parentNode` / `|| currentNode.childNodes`
           fallbacks, but the cached getters always return the canonical
           value (or null for a real parent-less node), so the fallback
           path was dead in safe cases and a clobbering surface in unsafe
           ones. Falsy cached results stay falsy; the `if (childNodes &&
           parentNode)` check already gates correctly. */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                const parentNode = getParentNode(currentNode);
                const childNodes = getChildNodes(currentNode);
                if (childNodes && parentNode) {
                    const childCount = childNodes.length;
                    /* Hoist by moving each child up one level rather than deep-cloning
               it. Moving transfers every descendant exactly once, so a chain of
               nested disallowed elements costs O(n) instead of the O(n^2) that
               re-cloning the shrinking subtree at each level produced; it also
               empties the removed original, so `DOMPurify.removed` no longer
               pins whole subtrees. Moving preserves the in-place guarantee too:
               an original carrying already-queued resource events (`<img
               onerror>`, `<video>`/`<audio>` error, lazy/`onload`, …) is
               relocated and sanitised rather than left detached but still armed.
                        The sole case that must clone is removing the walk root itself.
               The result is serialised from the root's subtree, so a restrictive
               ALLOWED_TAGS that strips the root (`body` on the string path) must
               leave the content inside it, which only cloning does. In IN_PLACE
               the root is pre-validated as an allowed tag and so is never removed
               here, so that path always takes the move branch.
                        `childNodes` is live; a tail-to-head walk keeps `childNodes[i]`
               valid whether we move (drops the trailing entry) or clone (leaves
               the list intact). */ for(let i = childCount - 1; i >= 0; --i){
                        const hoisted = currentNode === root ? cloneNode(childNodes[i], true) : childNodes[i];
                        parentNode.insertBefore(hoisted, getNextSibling(currentNode));
                    }
                }
            }
            _forceRemove(currentNode);
            return true;
        };
        /**
     * Fork a hook-mutable allowlist off its shared binding the first time a
     * (possibly lazily-installed) uponSanitize* hook is about to see it, so the
     * hook cannot widen the per-instance default or the setConfig binding by
     * reference and leak past the call. Returns the set unchanged once it is
     * already call-local, so repeated calls across elements are idempotent.
     *
     * @param hookList the uponSanitize* hook array for this event
     * @param set the current ALLOWED_TAGS / ALLOWED_ATTR binding
     * @param defaultSet the per-instance DEFAULT_ALLOWED_* constant
     * @param setConfigSet the captured setConfig() binding, or null
     * @return a call-local clone if a hook is present and set is still shared,
     *   else set unchanged
     */ const _forkSharedAllowlist = function _forkSharedAllowlist(hookList, set, defaultSet, setConfigSet) {
            if (hookList.length === 0) return set;
            return set === defaultSet || set === setConfigSet ? clone(set) : set;
        };
        /**
     * Shared guard for a node that a hook has detached from the walk tree,
     * used after each element-hook site in _sanitizeElements. Detaching is a
     * long-standing user pattern (issue #469; draw.io-style foreignObject
     * filtering). Per the cached, unclobberable parentNode getter the node is
     * genuinely out of the tree, so it can reach neither the serialized
     * output nor an IN_PLACE live tree; treat it as removed and stop
     * processing it. Without this guard, the unsafe-node / namespace checks
     * would call _forceRemove on a parentless node and hit the REPORT-3
     * fail-closed throw — which exists for nodes DOMPurify wants gone but
     * *cannot* detach (clobbered / parentless roots), the opposite of a node
     * that is already safely gone. The walk root is exempt: a detached
     * IN_PLACE root is legitimate input and must still be fully sanitized,
     * and a kill-decision on it must keep hitting the REPORT-3 throw.
     *
     * Nodes detached by hooks stay the hook's responsibility for placement:
     * they are not recorded in DOMPurify.removed, so the post-walk IN_PLACE
     * pass (which iterates DOMPurify.removed) does not reach them. But a
     * hook-detached subtree can still hold a queued resource-event handler -
     * e.g. an <img onload> that began loading when the caller built the live
     * tree - which fires in page scope after sanitize returns even though the
     * handler never reached the returned tree. That is the audit-5 F1 hazard,
     * and the documented node.remove() hook pattern walks straight into it.
     * So on the IN_PLACE path we neutralize the detached subtree inline,
     * stripping its non-allow-listed attributes before returning, exactly as
     * the post-walk pass does for _forceRemove'd subtrees.
     *
     * @param currentNode the node a hook may have detached
     * @param root the current walk root
     * @return true if the node is detached and now handled, false otherwise
     */ const _handleHookDetachedNode = function _handleHookDetachedNode(currentNode, root) {
            if (currentNode === root || getParentNode(currentNode) !== null) return false;
            if (IN_PLACE) _neutralizeSubtree(currentNode);
            return true;
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode, root) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* A hook may have detached the node - treat it as removed (see
         _handleHookDetachedNode for the full rationale). */ if (_handleHookDetachedNode(currentNode, root)) return true;
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(_readNodeName(currentNode));
            /* Close the pre-walk clone-guard's timing gap: an uponSanitizeElement
         hook may have been installed after that guard sampled the hook arrays
         (e.g. lazily from beforeSanitizeElements), leaving ALLOWED_TAGS still
         aliasing a shared binding that a widening hook would mutate by
         reference. Fork it before exposing it to the hook. */ ALLOWED_TAGS = _forkSharedAllowlist(hooks.uponSanitizeElement, ALLOWED_TAGS, DEFAULT_ALLOWED_TAGS, SET_CONFIG_ALLOWED_TAGS);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* The uponSanitizeElement hook may have detached the node, exactly as
         above (see _handleHookDetachedNode for the full rationale). */ if (_handleHookDetachedNode(currentNode, root)) return true;
            /* Remove mXSS vectors, processing instructions and risky comments */ if (_isUnsafeNode(currentNode, tagName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
                const removed = _sanitizeDisallowedNode(currentNode, tagName, root);
                /* A false return means the node is a custom element kept via
           CUSTOM_ELEMENT_HANDLING - the only keep path through
           _sanitizeDisallowedNode. Run afterSanitizeElements on it so the
           element-hook lifecycle matches normal allowlisted elements: a
           security policy applied in this hook (e.g. stripping an attribute
           from every surviving element) must not silently skip kept custom
           elements (GHSA-c2j3-45gr-mqc4). This mirrors the normal-element
           tail below - the hook runs, then the walker's subsequent
           _sanitizeAttributes pass sanitizes the element's attributes. The
           deliberately skipped namespace and fallback-tag removal checks stay
           skipped; they are removal decisions, not the hook contract. */ if (removed === false) _executeHooks(hooks.afterSanitizeElements, currentNode, null);
                return removed;
            }
            /* Check whether element has a valid namespace.
         Realm-safe check (GHSA-hpcv-96wg-7vj8): use the cached Node.prototype
         nodeType getter rather than `instanceof Element`, which is realm-
         bound and short-circuits to false for any node minted in a different
         realm — letting a foreign-realm element with a forbidden namespace
         slip past the namespace check entirely. */ const nt = _readNodeType(currentNode);
            if (nt === NODE_TYPE.element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(FALLBACK_TAG_CLOSE, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ const content = _stripTemplateExpressions(currentNode.textContent);
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* FORBID_ATTR must always win, even if ADD_ATTR predicate would allow it */ if (FORBID_ATTR[lcName]) return false;
            /* Reject declarative-partial-updates patch-linkage attributes
         (https://github.com/WICG/declarative-partial-updates).
              Empirical note (Chrome 150, verified — see
         test/declarative-patch-probe-v3.html): expansion is NOT applied after
         sanitization. For the string path it fires during sanitize()'s own
         parse, so the walk sees and sanitizes the fully materialized expanded
         tree — teleports into MathML/SVG integration points included; a
         weaponized `<template for>`->`<img onerror>` comes back with the handler
         stripped. For the IN_PLACE path it fires on connection, before the walk.
         Either way DOMPurify is NOT blind to the patch.
              This removal is therefore defense-in-depth rather than the sole barrier:
         it prevents live linkage from surviving into the OUTPUT and re-expanding
         in the caller's context, and keeps behaviour deterministic if a future
         engine defers expansion. `for` is legitimate only on <label>/<output>;
         anywhere else (notably <template for>) it links the element to a patch
         target and teleports or removes an arbitrary DOM range by id/marker name.
         `patchsrc` fetches remote markup and is treated as a script-loading
         mechanism (CSP). Gated on SAFE_FOR_XML so the removal groups with the
         other structural-threat checks and stays overridable, consistent with
         the rest of the codebase. PI range markers are already removed by
         _isUnsafeNode. */ if (_isPatchLinkageAttribute(lcName, lcTag)) return false;
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && regExpTest(DATA_ATTR$1, lcName)) return true;
            /* Allow valid aria-* attributes, the value is always URI safe */ if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) return true;
            /* A name outside the allowlist is acceptable on custom-element terms
         only. The value checks below are intentionally skipped in that case:
         if the user supplied a tagNameCheck we also allow derived custom
         elements using the same test, and attributes passing the configured
         attributeNameCheck are allowed as custom elements define these at
         their own discretion. */ if (!nameIsPermitted) return(// Condition a) covers a basically valid custom element tag name whose
            // tag passes the configured tagNameCheck and whose attribute name
            // passes the configured attributeNameCheck ...
            _isBasicCustomElement(lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName, lcTag) || // Condition b) covers an `is` attribute whose value passes the
            // configured tagNameCheck while customized built-in elements are
            // allowed.
            lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value));
            /* Check value is safe. First, is attr inert? If so, is safe */ if (URI_SAFE_ATTRIBUTES[lcName]) return true;
            /* Check no script, data or unknown possibly unsafe URI
          unless we know URI values are safe for that attribute */ if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) return true;
            /* Keep image data URIs alive if src/xlink:href is allowed */ /* Further prevent gadget XSS for dynamically built script tags */ if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) return true;
            /* Allow unknown protocols: This provides support for links that
          are handled by protocol handlers which may be unknown ahead of
          time, e.g. fb:, spotify: */ if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) return true;
            /* Only an empty (binary) value remains safe at this point;
         anything else is presumed unsafe, do not add it back */ return !value;
        };
        /* Names the HTML spec reserves from valid-custom-element-name; these must
     * never be treated as basic custom elements even when a permissive
     * CUSTOM_ELEMENT_HANDLING.tagNameCheck is configured. */ const RESERVED_CUSTOM_ELEMENT_NAMES = addToSet({}, [
            'annotation-xml',
            'color-profile',
            'font-face',
            'font-face-format',
            'font-face-name',
            'font-face-src',
            'font-face-uri',
            'missing-glyph'
        ]);
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return !RESERVED_CUSTOM_ELEMENT_NAMES[stringToLowerCase(tagName)] && regExpTest(CUSTOM_ELEMENT$1, tagName);
        };
        /**
     * Wrap an attribute value in the matching Trusted Types object when
     * the active policy requires it. Namespaced attributes pass through
     * unchanged (no TT support yet, see
     * https://bugs.chromium.org/p/chromium/issues/detail?id=1305293).
     *
     * @param lcTag lowercase tag name of the containing element
     * @param lcName lowercase attribute name
     * @param namespaceURI the attribute's namespace, if any
     * @param value the attribute value to wrap
     * @return the value, wrapped when Trusted Types demand it
     */ const _applyTrustedTypesToAttribute = function _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value) {
            if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function' && !namespaceURI) switch(trustedTypes.getAttributeType(lcTag, lcName)){
                case 'TrustedHTML':
                    return _createTrustedHTML(value);
                case 'TrustedScriptURL':
                    return _createTrustedScriptURL(value);
            }
            return value;
        };
        /**
     * Write a modified attribute value back onto the element. On
     * success, re-probe for clobbering introduced by the new value and
     * remove the element when found; otherwise pop the removal entry
     * recorded by the earlier _removeAttribute (long-standing pairing
     * with the SANITIZE_NAMED_PROPS path - do not "fix" casually). On
     * failure, remove the attribute instead.
     *
     * @param currentNode the element carrying the attribute
     * @param name the attribute name as present on the element
     * @param namespaceURI the attribute's namespace, if any
     * @param value the new attribute value
     */ const _setAttributeValue = function _setAttributeValue(currentNode, name, namespaceURI, value) {
            try {
                if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                if (_isClobbered(currentNode)) _forceRemove(currentNode);
                else arrayPop(DOMPurify.removed);
            } catch (_) {
                _removeAttribute(name, currentNode);
            }
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            /* Same lazy-install guard as uponSanitizeElement (see there): fork the
         attribute allowlist off its shared binding before a hook can see it. */ ALLOWED_ATTR = _forkSharedAllowlist(hooks.uponSanitizeAttribute, ALLOWED_ATTR, DEFAULT_ALLOWED_ATTR, SET_CONFIG_ALLOWED_ATTR);
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            const lcTag = transformCaseFunc(currentNode.nodeName);
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
                const lcName = transformCaseFunc(name);
                const initValue = attrValue;
                let value = name === 'value' ? initValue : stringTrim(initValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name') && stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode, attr);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                // Else: already prefixed, leave the attribute alone — the prefix is
                // itself the clobbering protection, and re-applying it is incorrect.
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && stringMatch(value, 'href')) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                /* Did the hooks force-keep the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(SELF_CLOSING_TAG, value)) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) value = _stripTemplateExpressions(value);
                /* Is `value` valid for this attribute? */ if (!_isValidAttribute(lcTag, lcName, value)) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ value = _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value);
                /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) _setAttributeValue(currentNode, name, namespaceURI, value);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode, fragment);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected.
           Realm-safe check (GHSA-hpcv-96wg-7vj8): use nodeType against the
           DOCUMENT_FRAGMENT_NODE constant rather than instanceof, so we
           recurse into <template>.content from foreign realms too. */ if (_isDocumentFragment(shadowNode.content)) _sanitizeShadowDOM2(shadowNode.content);
                /* An element iterated here may itself host an attached
           shadow root. The default NodeIterator does not enter shadow
           trees, so a shadow root nested inside template.content was
           previously reached by no walk at all (the pre-pass at
           _sanitizeAttachedShadowRoots descends via childNodes, which
           doesn't enter template.content; the template-content recursion
           above iterates the content but never inspected shadowRoot).
           Walk it explicitly. The nodeType guard avoids reading
           shadowRoot off text / comment / CDATA / PI nodes that the
           iterator also surfaces. */ if (_readNodeType(shadowNode) === NODE_TYPE.element) {
                    const innerSr = getShadowRoot(shadowNode);
                    if (_isDocumentFragment(innerSr)) {
                        _sanitizeAttachedShadowRoots(innerSr);
                        _sanitizeShadowDOM2(innerSr);
                    }
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        /**
     * _sanitizeAttachedShadowRoots
     *
     * Walks `root` and feeds every attached shadow root we encounter into
     * the existing _sanitizeShadowDOM pipeline. The default node iterator
     * does not descend into shadow trees, so nodes inside an attached
     * shadow root would otherwise be skipped entirely.
     *
     * Two real input paths put attached shadow roots in front of us:
     *   1. IN_PLACE on a DOM node that already has shadow roots attached.
     *   2. DOM-node input where importNode(dirty, true) deep-clones the
     *      shadow root because it was created with `clonable: true`.
     *
     * This pass runs once, up front, so the main iteration loop (and the
     * existing _sanitizeShadowDOM template-content recursion) stay
     * untouched — string-input paths are not affected.
     *
     * @param root the subtree root to walk for attached shadow roots
     */ const _sanitizeAttachedShadowRoots = function _sanitizeAttachedShadowRoots(root) {
            /* Iterative (explicit stack) rather than per-child recursion. DOM APIs
         impose no depth cap, so an attacker-shaped tree (JSON/CRDT/editor data
         built straight into the DOM — the IN_PLACE surface) deeper than the JS
         call-stack budget would otherwise overflow native recursion here and
         throw at the IN_PLACE entry pre-pass, before a single node is
         sanitized, leaving the caller's live tree untouched (fail-open). See
         campaign-3 F4. A heap stack keeps depth off the call stack.
              Each work item is either a node to descend into, or a deferred
         `_sanitizeShadowDOM` for an already-walked shadow root. The deferred
         form preserves the original post-order discipline: a shadow root's
         nested shadow roots are discovered before the outer shadow is
         sanitized (which may remove hosts). Pushes are in reverse of the
         desired processing order (LIFO): template content, then children, then
         the shadow-sanitize, then the shadow walk — so the order matches the
         previous recursion exactly. */ const stack = [
                {
                    node: root,
                    shadow: null
                }
            ];
            while(stack.length > 0){
                const item = stack.pop();
                /* Deferred shadow-DOM sanitisation: runs after its subtree was walked. */ if (item.shadow) {
                    _sanitizeShadowDOM2(item.shadow);
                    continue;
                }
                const node = item.node;
                const nodeType = _readNodeType(node);
                const isElement = nodeType === NODE_TYPE.element;
                /* (pushed last → processed first) Children, snapshotted in reverse so
           the first child is processed first. Snapshotting matters because a
           hook may detach siblings mid-walk. */ const childNodes = getChildNodes(node);
                if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push({
                    node: childNodes[i],
                    shadow: null
                });
                /* (pushed before children → processed after them, matching the old
           "template content last" order) When the node is a <template>,
           descend into its content. */ if (isElement) {
                    const rootName = getNodeName ? getNodeName(node) : null;
                    if (typeof rootName === 'string' && transformCaseFunc(rootName) === 'template') {
                        const content = node.content;
                        if (_isDocumentFragment(content)) stack.push({
                            node: content,
                            shadow: null
                        });
                    }
                }
                /* Shadow root (processed first): walk its subtree, then sanitise it.
           Realm-safe check (GHSA-hpcv-96wg-7vj8): nodeType-based detection
           rather than `instanceof DocumentFragment`, which is realm-bound and
           silently skipped foreign-realm shadow roots (e.g.
           iframe.contentDocument attachShadow). */ if (isElement) {
                    const sr = getShadowRoot(node);
                    if (_isDocumentFragment(sr)) /* Push the deferred sanitise first so it pops after the shadow
               walk we push next, i.e. nested shadow roots are discovered
               before this one is sanitised. */ stack.push({
                        node: null,
                        shadow: sr
                    }, {
                        node: sr,
                        shadow: null
                    });
                }
            }
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                dirty = stringifyValue(dirty);
                if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (SET_CONFIG) {
                /* Persistent setConfig() path: _parseConfig is skipped, so the sets are
         * not re-derived per call. Restore them from the pristine bindings
         * captured at setConfig() time so a previous call's hook clone (mutated
         * below) does not carry over. */ ALLOWED_TAGS = SET_CONFIG_ALLOWED_TAGS;
                ALLOWED_ATTR = SET_CONFIG_ALLOWED_ATTR;
            } else _parseConfig(cfg);
            /* Clone the hook-mutable allowlists before the walk whenever an
       * uponSanitize* hook is registered. The hook event exposes ALLOWED_TAGS
       * and ALLOWED_ATTR by reference (as allowedTags / allowedAttributes), so
       * a hook that widens them would otherwise mutate the shared set
       * permanently: across later calls and across every element. Cloning per
       * walk keeps documented in-call widening working while scoping it to the
       * call. A single guard for both config paths - the per-call path rebinds
       * the sets in _parseConfig each call, the persistent path restores them
       * from the captured bindings just above - so the two cannot diverge. */ if (hooks.uponSanitizeElement.length > 0 || hooks.uponSanitizeAttribute.length > 0) ALLOWED_TAGS = clone(ALLOWED_TAGS);
            if (hooks.uponSanitizeAttribute.length > 0) ALLOWED_ATTR = clone(ALLOWED_ATTR);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Resolve IN_PLACE for this call without mutating persistent config.
         Writing the IN_PLACE closure variable here leaks under setConfig(),
         where _parseConfig is skipped on later calls: a single string call would
         disable in-place mode for every subsequent node call, returning a
         sanitized copy while leaving the caller's node — which in-place callers
         keep using and whose return value they ignore — unsanitized. REPORT-2. */ const inPlace = IN_PLACE && typeof dirty !== 'string' && _isNode(dirty);
            if (inPlace) {
                /* Declarative-partial-updates / streaming pre-pass: sever every patch
           linkage across the live tree BEFORE the walk, so no patch can fire
           mid-walk and inject into an already-processed region. Runs first, so
           it also covers the forbidden/clobbered roots that throw below. */ _neutralizePatchLinkage(dirty);
                /* Do some early pre-sanitization to avoid unsafe root nodes.
           Read nodeName through the cached prototype getter — a clobbering
           child named "nodeName" on the form root would otherwise shadow
           the property and let this check skip the root-allowlist
           validation entirely. */ const nn = _readNodeName(dirty);
                if (typeof nn === 'string') {
                    const tagName = transformCaseFunc(nn);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                        /* Fail closed on a live root: neutralize handlers/children before
               throwing, exactly as the mid-walk abort path does. */ _neutralizeRoot(dirty);
                        throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                    }
                }
                /* Pre-flight the root through _isClobbered. The iterator-driven
           removal path can not detach a parent-less root: _forceRemove
           falls through to Element.prototype.remove(), which per spec
           is a no-op on a node with no parent. A clobbered root would
           then survive the main loop with its attributes uninspected,
           because _sanitizeAttributes early-returns on _isClobbered. The
           result would be an attacker-controlled form, complete with any
           event-handler attributes the caller passed in, handed back to
           the application unsanitized. Refuse to sanitize such a root
           the same way we refuse a forbidden tag. GHSA-r47g-fvhr-h676. */ if (_isClobbered(dirty)) {
                    /* Fail closed on a live clobbered root before throwing.
             _neutralizeRoot's reads are clobber-safe (cached getters); the
             form's non-clobbered descendants, e.g. an armed <img>, are scrubbed. */ _neutralizeRoot(dirty);
                    throw typeErrorCreate('root node is clobbered and cannot be sanitized in-place');
                }
                /* Sanitize attached shadow roots before the main iterator runs.
           The iterator does not descend into shadow trees. Same fail-closed
           barrier as the main walk (campaign-3 F2): a custom-element reaction
           inside a shadow root could abort this pre-pass before the walk runs,
           which would otherwise leave the entire live tree unsanitized. */ try {
                    _sanitizeAttachedShadowRoots(dirty);
                } catch (error) {
                    _neutralizeRoot(dirty);
                    throw error;
                }
            } else if (_isNode(dirty)) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
                /* Clonable shadow roots are deep-cloned by importNode(); sanitize
           them before the main iterator runs, since the iterator does not
           descend into shadow trees. The walk routes every read through a
           cached prototype getter so clobbering descendants on a form root
           cannot hide a shadow host from this pass. */ _sanitizeAttachedShadowRoots(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const walkRoot = inPlace ? dirty : body;
            /* Now start iterating over the created document.
         The walk runs inside an exception barrier (campaign-3 F2): a re-entrant
         engine/custom-element mutation can detach a node mid-walk so
         `_forceRemove`'s parentless guard throws, aborting the loop. Without the
         barrier the caller's in-place tree would be left half-sanitized with the
         unvisited tail still armed. _createNodeIterator itself is inside the
         barrier too: constructing the iterator dereferences the root's document,
         and any failure there (e.g. an exotic/clobbered root) must still fail
         closed rather than skip the neutralize. On any throw we fail closed -
         strip the in-place root bare - then rethrow so the existing throw
         contract is preserved. (String/DOM-copy paths never return the partial
         body, so the propagating throw is already fail-closed there.) */ try {
                const nodeIterator = _createNodeIterator(walkRoot);
                while(currentNode = nodeIterator.nextNode()){
                    /* Sanitize tags and elements */ _sanitizeElements(currentNode, walkRoot);
                    /* Check attributes next */ _sanitizeAttributes(currentNode);
                    /* Shadow DOM detected, sanitize it.
             Realm-safe check (GHSA-hpcv-96wg-7vj8): nodeType-based detection
             instead of instanceof, so foreign-realm <template>.content is
             walked correctly. */ if (_isDocumentFragment(currentNode.content)) _sanitizeShadowDOM2(currentNode.content);
                }
            } catch (error) {
                if (inPlace) {
                    _neutralizeRoot(dirty);
                    /* Nodes _forceRemove'd earlier in the aborted walk are already
             detached from the root, so _neutralizeRoot's subtree pass does not
             reach them. Defuse them too, mirroring the success-path loop below. */ arrayForEach(DOMPurify.removed, (entry)=>{
                        if (entry.element) _neutralizeSubtree(entry.element);
                    });
                }
                throw error;
            }
            /* If we sanitized `dirty` in-place, return it. */ if (inPlace) {
                /* Fail-closed completion of the audit-5 F1 fix: every node removed from
           the caller's live tree is detached but may still hold a queued
           resource-event handler that fires in page scope after we return. The
           move-hoist covers only disallowed-tag KEEP_CONTENT removals; strip the
           non-allow-listed attributes off every other removed subtree (clobber,
           mXSS, namespace, comments, KEEP_CONTENT:false, …) so those handlers are
           cancelled before any event can fire. Runs synchronously, pre-return. */ arrayForEach(DOMPurify.removed, (entry)=>{
                    if (entry.element) _neutralizeSubtree(entry.element);
                });
                if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(dirty);
                return dirty;
            }
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(body);
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) serializedHTML = _stripTemplateExpressions(serializedHTML);
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
            SET_CONFIG_ALLOWED_TAGS = ALLOWED_TAGS;
            SET_CONFIG_ALLOWED_ATTR = ALLOWED_ATTR;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
            SET_CONFIG_ALLOWED_TAGS = null;
            SET_CONFIG_ALLOWED_ATTR = null;
            // Drop any caller-supplied Trusted Types policy so it cannot poison later
            // `RETURN_TRUSTED_TYPE` output. The internal default policy (cached, and
            // never recreated — Trusted Types throws on duplicate names) is restored by
            // the next `_parseConfig`. See GHSA-vxr8-fq34-vvx9.
            trustedTypesPolicy = defaultTrustedTypesPolicy;
            emptyHTML = '';
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            /* Reject unknown entry points. Without this, a non-hook key (e.g.
       * '__proto__') indexes off the prototype chain rather than a real
       * hook array, and arrayPush then writes to Object.prototype. Guard
       * with an own-property check against the known hook names. */ if (!objectHasOwnProperty(hooks, entryPoint)) return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (!objectHasOwnProperty(hooks, entryPoint)) return undefined;
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            if (!objectHasOwnProperty(hooks, entryPoint)) return;
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});


parcelRegister("esPus", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cea76b81b5f28f7$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $655D0 = parcelRequire("655D0");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $3eb7t = parcelRequire("3eb7t");

var $eWIyH = parcelRequire("eWIyH");
const $2cea76b81b5f28f7$var$TextBlock = ({ editor: editor })=>{
    if (!editor) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eWIyH.default), {
        variants: (0, $51Ucj.itemVariants),
        children: editor
    });
};
const $2cea76b81b5f28f7$var$ImageBlock = ({ image: image, focalX: focalX, focalY: focalY })=>{
    if (!image?.sourceUrl) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
        variants: (0, $51Ucj.itemFadeIn),
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3eb7t.default), {
            src: image.sourceUrl,
            alt: image.altText || '',
            className: "w-full h-auto object-cover shadow-sm",
            style: {
                objectPosition: `${focalX ?? 50}% ${focalY ?? 50}%`
            }
        })
    });
};
const $2cea76b81b5f28f7$var$SpacerBlock = ({ height: height })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        style: {
            height: `${height || 50}px`
        },
        "aria-hidden": "true"
    });
};
const $2cea76b81b5f28f7$var$VideoBlock = ({ videoFile: videoFile, posterImage: posterImage, autoplay: autoplay })=>{
    if (!videoFile?.sourceUrl) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: "relative w-full rounded-lg overflow-hidden shadow-sm",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("video", {
            className: "w-full h-auto block",
            poster: posterImage?.sourceUrl,
            controls: !autoplay,
            muted: autoplay,
            loop: autoplay,
            playsInline: true,
            autoPlay: autoplay,
            children: /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                src: videoFile.sourceUrl,
                type: videoFile.mimeType
            })
        })
    });
};
const $2cea76b81b5f28f7$var$ButtonBlock = ({ link: link, style: style, alignment: alignment })=>{
    if (!link?.url) return null;
    const stylesMap = {
        'Primary (Solid)': 'bg-black text-white no-underline h-12 max-w-72 w-full grid place-content-center w-fit px-2 ',
        'Secondary (Outline)': 'bg-transparent text-black no-underline h-12  max-w-72 w-full grid place-content-center w-fit px-2 border-2 border-black ',
        'Text Only': 'text-black'
    };
    const aligmentMap = {
        Bottom: 'mt-auto',
        Auto: ''
    };
    const btnClass = stylesMap[style] || stylesMap.primary;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).a, {
        href: link.url,
        onClick: (0, $655D0.trackLinkClick),
        variants: (0, $51Ucj.itemVariants),
        target: link.target || '_self',
        className: `transition-colors duration-200 hover:underline underline-offset-2 ${btnClass} ${aligmentMap[alignment]}`,
        children: link.title || 'Learn More'
    });
};
const $2cea76b81b5f28f7$var$CONTENT_COMPONENTS = {
    Page_Pagebuilder_Blocks_ColumnsBlock_columns_Content_TextBlock: $2cea76b81b5f28f7$var$TextBlock,
    Page_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ImageBlock: $2cea76b81b5f28f7$var$ImageBlock,
    Page_Pagebuilder_Blocks_ColumnsBlock_columns_Content_ButtonBlock: $2cea76b81b5f28f7$var$ButtonBlock,
    Page_Pagebuilder_Blocks_ColumnsBlock_columns_Content_VideoBlock: $2cea76b81b5f28f7$var$VideoBlock,
    Page_Pagebuilder_Blocks_ColumnsBlock_columns_Content_SpacerBlock: $2cea76b81b5f28f7$var$SpacerBlock
};
const $2cea76b81b5f28f7$var$widthMap = {
    '100% (1/1)': 'col-span-12',
    '50% (1/2)': 'col-span-12 md:col-span-6',
    '33% (1/3)': 'col-span-12 md:col-span-4',
    '66% (2/3)': 'col-span-12 md:col-span-8',
    '25% (1/4)': 'col-span-12 md:col-span-3',
    '75% (3/4)': 'col-span-12 md:col-span-9'
};
function $2cea76b81b5f28f7$export$2e2bcd8739ae039({ columns: columns }) {
    if (!columns || columns.length === 0) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
        className: "w-wrapper-columns mx-auto my-32",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
            initial: "hidden",
            whileInView: "visible",
            variants: (0, $51Ucj.containerVariants),
            viewport: (0, $51Ucj.viewPort),
            className: "md:grid md:grid-cols-12 gap-10",
            children: columns.map((col, colIndex)=>{
                const spanClass = $2cea76b81b5f28f7$var$widthMap[col?.width || '12'];
                return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: `${spanClass} first:mb-6 md:first:mb-0  flex flex-col gap-4`,
                    children: col?.content?.map((block, blockIndex)=>{
                        if (!block) return null;
                        const Component = $2cea76b81b5f28f7$var$CONTENT_COMPONENTS[block.__typename];
                        if (Component) return /*#__PURE__*/ (0, $2PPWI.jsx)(Component, {
                            ...block
                        }, blockIndex);
                        return null;
                    })
                }, colIndex);
            })
        })
    });
}

});

parcelRegister("7kMse", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64c9c61c3675c32b$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $655D0 = parcelRequire("655D0");

var $fdiy9 = parcelRequire("fdiy9");

var $5Otf1 = parcelRequire("5Otf1");

var $96iav = parcelRequire("96iav");

var $kM2Bn = parcelRequire("kM2Bn");

var $b2c0V = parcelRequire("b2c0V");

var $4y07l = parcelRequire("4y07l");

var $4Qpe2 = parcelRequire("4Qpe2");

var $8FY87 = parcelRequire("8FY87");

var $51Ucj = parcelRequire("51Ucj");

var $1lSPe = parcelRequire("1lSPe");

var $eWIyH = parcelRequire("eWIyH");
'use client';
const $64c9c61c3675c32b$var$ContentBlocks = ({ blockId: blockId, containerWidth: containerWidth, layout: layout = 'columns', firstItemReversed: firstItemReversed, list: list, smallGap: smallGap })=>{
    const [currentVideoPlaying, setCurrentVideoPlaying] = (0, $8FY87.useState)(null);
    const isLayout3Cols = layout === 'columns';
    const isLayout1Row2Cols = layout === '1row2cols';
    const isLayout2Cols = layout === '2columns';
    const isLayoutRows = layout === 'rows';
    const isLayoutAlternating = layout === 'alternating';
    if (!list || list && list.length === 0) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
        id: blockId ?? undefined,
        className: "w-full my-14 lg:my-24",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: `w-full ${(0, $1lSPe.getContainerClass)(containerWidth)}`,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).ul, {
                    initial: "hidden",
                    whileInView: "visible",
                    viewport: (0, $51Ucj.viewPort),
                    variants: (0, $51Ucj.containerVariants),
                    className: `flex ${isLayoutRows ? 'flex-col gap-8 lg:gap-6' : isLayoutAlternating ? `flex-col gap-8${smallGap ? '' : ' lg:gap-24'}` : isLayout2Cols ? 'flex-wrap gap-8 lg:gap-10' : isLayout1Row2Cols ? 'grid grid-cols-1 lg:grid-cols-2 gap-y-14 lg:gap-y-12 gap-x-12' : 'flex-col lg:flex-row gap-8 lg:gap-6'}`,
                    children: list.map((item, i)=>{
                        const contentWithBg = item.contentBg ?? false;
                        const isOdd = firstItemReversed ? (i + 1) % 2 === 0 : (i + 1) % 2 != 0;
                        return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).li, {
                            initial: "hidden",
                            whileInView: "visible",
                            viewport: (0, $51Ucj.viewPort),
                            variants: (0, $51Ucj.itemVariants),
                            className: `${isLayoutRows && contentWithBg ? 'grid grid-cols-1 lg:grid-cols-[30%,1fr]' : isLayoutRows ? 'grid grid-cols-1 lg:grid-cols-[340px,1fr] gap-4 lg:gap-12' : isLayoutAlternating ? 'grid grid-cols-1 lg:grid-cols-2 lg:items-center gap-4 lg:gap-0' : isLayout2Cols ? 'lg:basis-[calc(50%-20px)] flex flex-col gap-4 lg:gap-6' : isLayout1Row2Cols ? 'flex-1 flex flex-col gap-4 lg:gap-6 lg:first:col-span-2 first:grid first:grid-cols-1 first:lg:grid-cols-2 first:gap-x-12' : 'flex-1 flex flex-col gap-4 lg:gap-6'}`,
                            children: [
                                item.video || item.image ? /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                    className: `w-full relative ${isLayoutAlternating && item.mediaIsCover ? 'h-full' : ''} ${isLayoutAlternating ? 'aspect-[3/2]' : isLayout3Cols ? 'aspect-[4/3]' : isLayoutRows ? '' : 'aspect-video'} ${isLayoutRows && contentWithBg ? 'w-full h-full' : isLayoutRows ? 'lg:w-[340px]' : ''} ${isLayoutAlternating ? isOdd ? 'order-1' : 'order-1 lg:order-2' : ''}`,
                                    onClick: ()=>setCurrentVideoPlaying(item.video),
                                    children: item.video ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $b2c0V.default), {
                                                className: "w-16 h-16 text-white absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
                                            }),
                                            item.image ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5Otf1.default), {
                                                src: item.image.sourceUrl || '',
                                                alt: item.image.altText || '',
                                                width: item.image.mediaDetails.width || 0,
                                                height: item.image.mediaDetails.height || 0,
                                                sizes: "(max-width: 1024px) 100vw, 570px",
                                                srcSet: item.image.srcSet || '',
                                                className: "w-full h-full object-cover aspect-video"
                                            }) : /*#__PURE__*/ (0, $2PPWI.jsx)("video", {
                                                className: "w-full h-full object-cover aspect-video cursor-pointer",
                                                muted: true,
                                                playsInline: true,
                                                preload: "metadata",
                                                children: /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                                                    src: `${item.video.mediaItemUrl}#t=0.001`,
                                                    type: item.video.mimeType
                                                })
                                            })
                                        ]
                                    }) : item.image && item.image.sourceUrl ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5Otf1.default), {
                                        src: item.image.sourceUrl || '',
                                        alt: item.image.altText || '',
                                        width: item.image.mediaDetails.width || 0,
                                        height: item.image.mediaDetails.height || 0,
                                        sizes: "(max-width: 1024px) 100vw, 570px",
                                        srcSet: item.image.srcSet || '',
                                        className: `w-full ${isLayoutAlternating ? item.mediaIsCover ? 'object-cover h-full aspect-video' : 'h-auto object-contain' : isLayoutRows ? 'h-auto object-contain' : 'object-cover h-full aspect-video'}`
                                    }) : null
                                }) : null,
                                item.content && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: `flex flex-col h-full px-4 md:px-0 ${isLayoutAlternating ? 'lg:px-12 lg:justify-center' : ''} ${isLayoutAlternating ? isOdd ? 'order-2' : 'order-2 lg:order-1' : ''} ${contentWithBg ? 'p-4 lg:pl-8 lg:pr-4 lg:pt-6 lg:pb-4' : ''} editor-card ${isLayout1Row2Cols ? 'editor-card-lg' : ''}`,
                                    style: {
                                        backgroundColor: item.contentBg ? item.contentBg : 'transparent'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eWIyH.default), {
                                            children: item.content
                                        }),
                                        item.link && item.linkText && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                            className: `${isLayout2Cols || isLayout3Cols ? 'mt-auto' : ''} ${item.linkPosition === 'center' ? 'mx-auto' : item.linkPosition === 'right' ? 'max-lg:mx-auto lg:ml-auto' : 'max-lg:mx-auto lg:mr-auto'}`,
                                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $fdiy9.default), {
                                                onClick: (0, $655D0.trackLinkClick),
                                                type: item.linkType,
                                                text: item.linkText,
                                                url: item.link,
                                                linkInNewWindow: item.linkInNewWindow,
                                                className: isLayout3Cols ? 'mt-2 lg:mt-4' : 'mt-2 lg:mt-8'
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    })
                })
            }),
            currentVideoPlaying ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kM2Bn.default), {
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "flex justify-center items-center w-full h-full",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                            "aria-label": "Close window",
                            className: "absolute top-6 right-6 flex items-center justify-center w-10 h-10 hover:bg-black/10 opacity-60 hover:opacity-100 rounded-full transition-all z-10",
                            onClick: ()=>setCurrentVideoPlaying(null),
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $96iav.default), {
                                className: "w-6 h-6 text-white"
                            })
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4y07l.default), {
                            controls: true,
                            autoplay: true,
                            ...currentVideoPlaying
                        })
                    ]
                })
            }) : null
        ]
    });
};
var $64c9c61c3675c32b$export$2e2bcd8739ae039 = $64c9c61c3675c32b$var$ContentBlocks;

});
parcelRegister("4y07l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58111a413c7525c1$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $b2c0V = parcelRequire("b2c0V");
'use client';
const $58111a413c7525c1$var$VideoClip = ({ mediaItemUrl: mediaItemUrl, autoplay: autoplay, controls: controls, loop: loop = true, muted: muted = true })=>{
    const videoRef = (0, $8FY87.useRef)(null);
    const [isPlaying, setIsPlaying] = (0, $8FY87.useState)(autoplay && muted);
    const handleOnClick = ()=>{
        if (!controls && !autoplay) setIsPlaying((prev)=>!prev);
    };
    (0, $8FY87.useEffect)(()=>{
        if (!videoRef.current) return;
        if (isPlaying) videoRef.current.play();
        else videoRef.current.pause();
    }, [
        isPlaying
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: `relative overflow-hidden`,
        onClick: ()=>handleOnClick(),
        children: [
            !controls && !isPlaying ? /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "w-full h-full absolute flex justify-center items-center bg-black bg-opacity-20 z-30 top-0",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                    "aria-label": "Play video",
                    className: "cursor-pointer",
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $b2c0V.default), {
                        className: "w-16 h-16 text-white"
                    })
                })
            }) : null,
            /*#__PURE__*/ (0, $2PPWI.jsx)("video", {
                ref: videoRef,
                autoPlay: autoplay,
                controls: controls,
                loop: loop,
                muted: muted,
                playsInline: true,
                className: `w-full h-full`,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                    src: `${mediaItemUrl}#t=0.001`,
                    type: "video/mp4"
                })
            })
        ]
    });
};
var $58111a413c7525c1$export$2e2bcd8739ae039 = $58111a413c7525c1$var$VideoClip;

});


parcelRegister("77tYj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c8aae29a11fd720$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $1cAzr = parcelRequire("1cAzr");

var $4Qpe2 = parcelRequire("4Qpe2");

var $8FY87 = parcelRequire("8FY87");

var $51Ucj = parcelRequire("51Ucj");

var $1lSPe = parcelRequire("1lSPe");

var $eWIyH = parcelRequire("eWIyH");
const $6c8aae29a11fd720$var$FaqsBlock = ({ blockId: blockId, containerWidth: containerWidth, title: title, faqs: faqs })=>{
    if (!faqs?.length) return null;
    const [activeFaq, setActiveFaq] = (0, $8FY87.useState)(null);
    const toggle = (i)=>{
        setActiveFaq((prev)=>prev === i ? null : i);
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
        id: blockId ?? undefined,
        className: "w-full my-14 lg:my-24",
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
            initial: "hidden",
            whileInView: "visible",
            viewport: (0, $51Ucj.viewPort),
            variants: (0, $51Ucj.containerVariants),
            className: `w-full ${(0, $1lSPe.getContainerClass)(containerWidth)}`,
            children: [
                title && /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                    className: "mb-5 lg:mb-10",
                    children: title
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                    children: faqs.map((q, i)=>{
                        const isOpen = activeFaq === i;
                        return /*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                            className: "border-b border-neutral-300",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                                    type: "button",
                                    "aria-expanded": isOpen,
                                    onClick: ()=>toggle(i),
                                    className: "flex w-full items-center justify-between py-5 text-left",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                            children: q.label
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1cAzr.default), {
                                            className: `w-6 min-w-6 h-6 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                    className: `
                    grid transition-all duration-500 ease-in-out
                    ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}
                  `,
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "editor min-h-0 overflow-hidden",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                            className: "pb-6",
                                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eWIyH.default), {
                                                children: q.content
                                            })
                                        })
                                    })
                                })
                            ]
                        }, i);
                    })
                })
            ]
        })
    });
};
var $6c8aae29a11fd720$export$2e2bcd8739ae039 = $6c8aae29a11fd720$var$FaqsBlock;

});
parcelRegister("1cAzr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $453dcb3e118d6761$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
const $453dcb3e118d6761$var$ChevronDown = (props)=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        ...props,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
            d: "m12 13.171 4.95-4.95 1.414 1.415L12 16 5.636 9.636 7.05 8.222z"
        })
    });
};
var $453dcb3e118d6761$export$2e2bcd8739ae039 = $453dcb3e118d6761$var$ChevronDown;

});


parcelRegister("4aBZ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5b0746f2c723526$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $hUI74 = parcelRequire("hUI74");

var $1lSPe = parcelRequire("1lSPe");
const $b5b0746f2c723526$var$GalleryBlock = ({ blockId: blockId, galleryItems: galleryItems, containerWidth: containerWidth })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
        id: blockId ?? undefined,
        className: "w-full my-14 lg:my-24",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            className: `w-full h-[85vh] lg:min-h-[700px] ${(0, $1lSPe.getContainerClass)(containerWidth)}`,
            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $hUI74.default), {
                slides: galleryItems
            })
        })
    });
};
var $b5b0746f2c723526$export$2e2bcd8739ae039 = $b5b0746f2c723526$var$GalleryBlock;

});
parcelRegister("hUI74", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $807d51088b3eac18$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $5Otf1 = parcelRequire("5Otf1");

var $6B8Ld = parcelRequire("6B8Ld");

var $8FY87 = parcelRequire("8FY87");
function $807d51088b3eac18$var$Carousel({ slides: slides }) {
    const [emblaRef, emblaApi] = (0, $6B8Ld.default)({
        loop: true
    });
    const [selectedIndex, setSelectedIndex] = (0, $8FY87.useState)(0);
    const [scrollSnaps, setScrollSnaps] = (0, $8FY87.useState)([]);
    const onInit = (0, $8FY87.useCallback)((emblaApi)=>{
        setScrollSnaps(emblaApi.scrollSnapList());
    }, []);
    const onSelect = (0, $8FY87.useCallback)((api)=>{
        setSelectedIndex(api.selectedScrollSnap());
    }, []);
    (0, $8FY87.useEffect)(()=>{
        if (!emblaApi) return;
        onInit(emblaApi);
        onSelect(emblaApi);
        emblaApi.on('reInit', onInit).on('reInit', onSelect).on('select', onSelect);
        return ()=>{
            emblaApi.off('reInit', onInit).off('reInit', onSelect).off('select', onSelect);
        };
    }, [
        emblaApi,
        onInit,
        onSelect
    ]);
    const scrollPrev = (0, $8FY87.useCallback)(()=>{
        if (emblaApi) emblaApi.scrollPrev();
    }, [
        emblaApi
    ]);
    const scrollNext = (0, $8FY87.useCallback)(()=>{
        if (emblaApi) emblaApi.scrollNext();
    }, [
        emblaApi
    ]);
    const scrollTo = (0, $8FY87.useCallback)((index)=>{
        if (emblaApi) emblaApi.scrollTo(index);
    }, [
        emblaApi
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "relative w-full h-full group overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "overflow-hidden w-full h-full",
                ref: emblaRef,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: "flex w-full h-full touch-pan-y will-change-transform",
                    children: slides.map((slide, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: "relative flex-[0_0_100%] w-full h-full",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "absolute inset-0 w-full h-full overflow-hidden",
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5Otf1.default), {
                                    loading: index === 0 ? 'eager' : 'lazy',
                                    width: slide.mediaDetails.width,
                                    height: slide.mediaDetails.height,
                                    src: slide.sourceUrl,
                                    alt: slide.altText,
                                    sizes: "(max-width: 1024px) 100vw, 1280px",
                                    srcSet: slide.srcSet,
                                    className: "w-full h-full object-cover"
                                })
                            })
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                onClick: scrollPrev,
                className: "absolute left-4 top-1/2 -translate-y-1/2 z-20 p-2 bg-kia-grey/50 size-12 grid place-content-center rounded-full hover:bg-kia-grey lg:opacity-0 lg:group-hover:opacity-100 transition-all",
                "aria-label": "F\xf6reg\xe5ende slide",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        className: "sr-only",
                        children: "F\xf6reg\xe5ende slide"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                        className: "rotate-180",
                        width: "37",
                        height: "37",
                        viewBox: "0 0 37 37",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                            d: "M17 23L21.5 18.5L17 14",
                            stroke: "#000",
                            strokeWidth: "1.5"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                onClick: scrollNext,
                className: "absolute right-4 top-1/2 -translate-y-1/2 z-20 p-2 bg-kia-grey/50 size-12 grid place-content-center rounded-full  hover:bg-kia-grey lg:opacity-0 lg:group-hover:opacity-100 transition-all",
                "aria-label": "N\xe4sta slide",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        className: "sr-only",
                        children: "N\xe4sta slide"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                        width: "37",
                        height: "37",
                        viewBox: "0 0 37 37",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                            d: "M17 23L21.5 18.5L17 14",
                            stroke: "#000",
                            strokeWidth: "1.5"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex items-center gap-4",
                children: scrollSnaps.map((_, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                        onClick: ()=>scrollTo(index),
                        className: `relative h-1 overflow-hidden transition-all duration-300 ${index === selectedIndex ? 'w-8 md:w-16 bg-kia-grey' : 'w-4 md:w-8 bg-gray-500/50 hover:bg-gray-400'}`,
                        "aria-label": `G\xe5 till slide ${index + 1}`
                    }, index))
            })
        ]
    });
}
var $807d51088b3eac18$export$2e2bcd8739ae039 = $807d51088b3eac18$var$Carousel;

});


parcelRegister("keC7c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b430549df8348be$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $5Otf1 = parcelRequire("5Otf1");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $1lSPe = parcelRequire("1lSPe");

var $eWIyH = parcelRequire("eWIyH");
'use client';
const $7b430549df8348be$var$HeroBlock = ({ editor: editor, editorPosition: editorPosition, containerWidth: containerWidth, image: image, imageMobile: imageMobile, video: video, videoMobile: videoMobile, videoHasControls: videoHasControls })=>{
    const isTextInBottom = editorPosition === 'bottom';
    const isTextTop = editorPosition === 'top';
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).section, {
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        variants: (0, $51Ucj.containerVariants),
        className: "hero relative w-full overflow-hidden",
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: "relative grid h-full min-h-[85svh] lg:min-h-[800px]",
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "absolute inset-0  z-[11]",
                    children: [
                        video && video.mediaItemUrl ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("video", {
                                    autoPlay: true,
                                    muted: true,
                                    loop: true,
                                    playsInline: true,
                                    controls: videoHasControls,
                                    preload: "metadata",
                                    className: `h-full w-full object-cover ${videoMobile && videoMobile.mediaItemUrl ? 'hidden lg:block' : 'block'}`,
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                                        src: video.mediaItemUrl
                                    })
                                }),
                                videoMobile && videoMobile.mediaItemUrl ? /*#__PURE__*/ (0, $2PPWI.jsx)("video", {
                                    autoPlay: true,
                                    muted: true,
                                    loop: true,
                                    playsInline: true,
                                    controls: videoHasControls,
                                    preload: "metadata",
                                    className: "block h-full w-full object-cover lg:hidden",
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                                        src: videoMobile.mediaItemUrl
                                    })
                                }) : null
                            ]
                        }) : image && image.sourceUrl ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5Otf1.default), {
                                    src: image.sourceUrl || '',
                                    alt: image.altText || '',
                                    width: image.mediaDetails.width || 0,
                                    height: image.mediaDetails.height || 0,
                                    sizes: "(max-width: 1024px) 100vw, 100vw",
                                    srcSet: image.srcSet || '',
                                    className: `h-full w-full object-cover ${imageMobile && imageMobile.sourceUrl ? 'hidden lg:block' : 'block'}`,
                                    loading: "eager"
                                }),
                                imageMobile && imageMobile.sourceUrl ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5Otf1.default), {
                                    src: imageMobile.sourceUrl || '',
                                    alt: imageMobile.altText || '',
                                    width: imageMobile.mediaDetails.width || 0,
                                    height: imageMobile.mediaDetails.height || 0,
                                    sizes: "(max-width: 1024px) 100vw, 100vw",
                                    srcSet: imageMobile.srcSet || '',
                                    className: "block h-full w-full object-cover lg:hidden",
                                    loading: "eager"
                                }) : null
                            ]
                        }) : /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: "h-full w-full bg-neutral-900"
                        }),
                        (video || videoMobile) && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: "absolute inset-0 bg-black/35 -z-10"
                        })
                    ]
                }),
                editor && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: `relative flex justify-center w-full h-full px-4 py-4 lg:py-16 z-[12] ${isTextInBottom ? 'items-end' : isTextTop ? 'items-start' : 'items-center'}`,
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: `mx-auto text-white ${(0, $1lSPe.getContainerClass)(containerWidth)}`,
                        children: editor && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: "editor editor-display",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eWIyH.default), {
                                headingVariants: (0, $51Ucj.heroHeadingVariants),
                                variants: (0, $51Ucj.textVariants),
                                customViewport: {
                                    once: false,
                                    margin: '0px'
                                },
                                children: editor
                            })
                        })
                    })
                })
            ]
        })
    });
};
var $7b430549df8348be$export$2e2bcd8739ae039 = $7b430549df8348be$var$HeroBlock;

});

parcelRegister("hKQkl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fcc33b8fdf43e3a$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $1lSPe = parcelRequire("1lSPe");

var $eWIyH = parcelRequire("eWIyH");
const $0fcc33b8fdf43e3a$var$IframeBlock = ({ blockId: blockId, containerWidth: containerWidth, title: title, url: url, editor: editor })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
        id: blockId ?? undefined,
        className: "w-full my-14 lg:my-24",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
            initial: "hidden",
            whileInView: "visible",
            viewport: (0, $51Ucj.viewPort),
            variants: (0, $51Ucj.containerVariants),
            className: `w-full ${(0, $1lSPe.getContainerClass)(containerWidth)}`,
            children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "grid md:grid-cols-2 gap-8 editor px-4 md:px-0",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "@container editor",
                        children: [
                            title && /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                                className: "mb-5 lg:mb-10",
                                children: title
                            }),
                            url && /*#__PURE__*/ (0, $2PPWI.jsx)("iframe", {
                                src: url,
                                className: "w-full border border-neutral-200 h-[600px]"
                            })
                        ]
                    }),
                    editor && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "editor",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eWIyH.default), {
                            customViewport: {
                                once: false,
                                margin: '0px'
                            },
                            children: editor
                        })
                    })
                ]
            })
        })
    });
};
var $0fcc33b8fdf43e3a$export$2e2bcd8739ae039 = $0fcc33b8fdf43e3a$var$IframeBlock;

});

parcelRegister("vtBlO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11f63e100d92d110$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $5Otf1 = parcelRequire("5Otf1");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $1lSPe = parcelRequire("1lSPe");
const $11f63e100d92d110$var$ImageBlock = ({ blockId: blockId, containerWidth: containerWidth, image: image, imageMobile: imageMobile, video: video, videoMobile: videoMobile, videoHasControls: videoHasControls })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
        id: blockId ?? undefined,
        className: "w-full my-14 lg:my-24",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
            initial: "hidden",
            whileInView: "visible",
            viewport: (0, $51Ucj.viewPort),
            variants: (0, $51Ucj.containerVariants),
            className: `w-full ${video && video.mediaItemUrl || videoMobile && videoMobile.mediaItemUrl ? 'w-full' : (0, $1lSPe.getContainerClass)(containerWidth)}`,
            children: video && video.mediaItemUrl ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("video", {
                        autoPlay: true,
                        muted: true,
                        loop: true,
                        playsInline: true,
                        controls: videoHasControls,
                        preload: "metadata",
                        className: `h-full w-full object-cover ${videoMobile && videoMobile.mediaItemUrl ? 'hidden lg:block' : 'block'}`,
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                            src: video.mediaItemUrl
                        })
                    }),
                    videoMobile && videoMobile.mediaItemUrl ? /*#__PURE__*/ (0, $2PPWI.jsx)("video", {
                        autoPlay: true,
                        muted: true,
                        loop: true,
                        playsInline: true,
                        controls: videoHasControls,
                        preload: "metadata",
                        className: "block h-full w-full object-cover lg:hidden",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                            src: videoMobile.mediaItemUrl
                        })
                    }) : null
                ]
            }) : image && image.sourceUrl ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5Otf1.default), {
                        src: image.sourceUrl || '',
                        alt: image.altText || '',
                        width: image.mediaDetails.width || 0,
                        height: image.mediaDetails.height || 0,
                        sizes: "(max-width: 1024px) 100vw, 100vw",
                        srcSet: image.srcSet || '',
                        className: `h-full w-full object-cover ${imageMobile ? 'hidden lg:block' : 'block'}`,
                        loading: "eager"
                    }),
                    imageMobile && imageMobile.sourceUrl ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5Otf1.default), {
                        src: imageMobile.sourceUrl || '',
                        alt: imageMobile.altText || '',
                        width: imageMobile.mediaDetails.width || 0,
                        height: imageMobile.mediaDetails.height || 0,
                        sizes: "(max-width: 1024px) 100vw, 100vw",
                        srcSet: imageMobile.srcSet || '',
                        className: "block h-full w-full object-cover lg:hidden",
                        loading: "eager"
                    }) : null
                ]
            }) : null
        })
    });
};
var $11f63e100d92d110$export$2e2bcd8739ae039 = $11f63e100d92d110$var$ImageBlock;

});

parcelRegister("257OE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2cab19bb3623645$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $1uD1b = parcelRequire("1uD1b");
function $e2cab19bb3623645$var$KiaModuleBlock({ globalModule: globalModule }) {
    if (!globalModule) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: globalModule.map((module, index)=>{
            if (!module?.pagebuilder) return null;
            return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1uD1b.default), {
                ...module.pagebuilder
            }, index);
        })
    });
}
var $e2cab19bb3623645$export$2e2bcd8739ae039 = $e2cab19bb3623645$var$KiaModuleBlock;

});
parcelRegister("1uD1b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccb949bcec195a7c$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $5muPu = parcelRequire("5muPu");

var $g0kcG = parcelRequire("g0kcG");

var $gjTaf = parcelRequire("gjTaf");

var $esPus = parcelRequire("esPus");

var $7kMse = parcelRequire("7kMse");

var $77tYj = parcelRequire("77tYj");

var $4aBZ2 = parcelRequire("4aBZ2");

var $keC7c = parcelRequire("keC7c");

var $vtBlO = parcelRequire("vtBlO");

var $c0oib = parcelRequire("c0oib");

var $g1RTM = parcelRequire("g1RTM");

var $fy17o = parcelRequire("fy17o");

var $kSlSZ = parcelRequire("kSlSZ");

var $aKzpl = parcelRequire("aKzpl");

var $5w6Da = parcelRequire("5w6Da");

var $3lJNg = parcelRequire("3lJNg");
const $ccb949bcec195a7c$var$BLOCK_COMPONENTS = {
    KiaModule_Pagebuilder_Blocks_Hero: (0, $keC7c.default),
    KiaModule_Pagebuilder_Blocks_ColumnsBlock: (0, $esPus.default),
    KiaModule_Pagebuilder_Blocks_Texteditor: (0, $3lJNg.default),
    KiaModule_Pagebuilder_Blocks_Image: (0, $vtBlO.default),
    KiaModule_Pagebuilder_Blocks_Checklist: (0, $gjTaf.default),
    KiaModule_Pagebuilder_Blocks_ContentList: (0, $7kMse.default),
    KiaModule_Pagebuilder_Blocks_Gallery: (0, $4aBZ2.default),
    KiaModule_Pagebuilder_Blocks_Nav: (0, $g1RTM.default),
    KiaModule_Pagebuilder_Blocks_Table: (0, $kSlSZ.default),
    KiaModule_Pagebuilder_Blocks_Tabs: (0, $aKzpl.default),
    KiaModule_Pagebuilder_Blocks_Faqs: (0, $77tYj.default),
    KiaModule_Pagebuilder_Blocks_CarCarousel: (0, $5muPu.default),
    KiaModule_Pagebuilder_Blocks_CarCarouselGrid: (0, $g0kcG.default),
    KiaModule_Pagebuilder_Blocks_LaddboxBlock: (0, $c0oib.default),
    KiaModule_Pagebuilder_Blocks_Story: (0, $fy17o.default),
    KiaModule_Pagebuilder_Blocks_TextMedia: (0, $5w6Da.default)
};
function $ccb949bcec195a7c$export$2e2bcd8739ae039({ blocks: blocks }) {
    if (!blocks) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: blocks.map((block, index)=>{
            if (!block) return null;
            const Component = $ccb949bcec195a7c$var$BLOCK_COMPONENTS[block.__typename];
            if (Component) return /*#__PURE__*/ (0, $2PPWI.jsx)(Component, {
                ...block,
                index: index
            }, index);
            return null;
        })
    });
}

});
parcelRegister("c0oib", function(module, exports) {

$parcel$export(module.exports, "FieldError", function () { return $25fb78121eb2c613$export$f551688fc98f2e09; });
$parcel$export(module.exports, "default", function () { return $25fb78121eb2c613$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $dmJAc = parcelRequire("dmJAc");

var $k7h0Y = parcelRequire("k7h0Y");

var $elAir = parcelRequire("elAir");
const $25fb78121eb2c613$var$ownerApprovalOptions = [
    'Ja',
    'Nej',
    'Inte relevant'
];
const $25fb78121eb2c613$var$schema = (0, $elAir.object)({
    typeOfLaddbox: (0, $elAir.string)().min(1, "V\xe4lj ett alternativ"),
    firstName: (0, $elAir.string)().min(1, "F\xf6rnamn kr\xe4vs"),
    lastName: (0, $elAir.string)().min(1, "Efternamn kr\xe4vs"),
    street: (0, $elAir.string)().min(1, "Adress kr\xe4vs"),
    zipCode: (0, $elAir.string)().regex(/^\d{3}\s?\d{2}$/, 'Ange ett giltigt postnummer'),
    city: (0, $elAir.string)().min(1, "Stad/ort kr\xe4vs"),
    email: (0, $elAir.email)('Ange en giltig e-postadress'),
    cemail: (0, $elAir.email)('Ange en giltig e-postadress'),
    phone: (0, $elAir.string)().min(1, "Telefonnummer kr\xe4vs"),
    confirmedByBrf: (0, $elAir.enum)($25fb78121eb2c613$var$ownerApprovalOptions, {
        error: "V\xe4lj ett alternativ"
    })
}).refine((data)=>data.email === data.cemail, {
    message: 'E-postadresserna matchar inte',
    path: [
        'cemail'
    ]
});
const $25fb78121eb2c613$var$inputClass = 'w-full border border-kia-gray rounded px-4 py-3 text-sm focus:outline-none focus:border-black focus:ring-1 focus:ring-black transition-colors';
const $25fb78121eb2c613$var$inputErrorClass = 'w-full border border-red-400 rounded px-4 py-3 text-sm focus:outline-none focus:border-red-600 transition-colors';
const $25fb78121eb2c613$var$labelClass = 'block text-sm font-medium mb-1';
const $25fb78121eb2c613$var$errorClass = 'text-red-500 text-xs mt-1';
function $25fb78121eb2c613$export$f551688fc98f2e09({ errors: errors }) {
    if (!errors.length) return null;
    const message = errors[0]?.message ?? String(errors[0]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
        role: "alert",
        "aria-live": "polite",
        className: $25fb78121eb2c613$var$errorClass,
        children: message
    });
}
function $25fb78121eb2c613$var$LaddboxForm({ title: title, description: description, laddboxOptions: laddboxOptions }) {
    const form = (0, $k7h0Y.useForm)({
        defaultValues: {
            typeOfLaddbox: '',
            firstName: '',
            lastName: '',
            street: '',
            zipCode: '',
            city: '',
            email: '',
            cemail: '',
            phone: '',
            confirmedByBrf: undefined
        },
        onSubmit: async ({ value: value })=>{
            const res = await fetch('https://kia-nodemailer.vercel.app/api/booking', {
                method: 'POST',
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    values: value
                })
            });
            if (!res.ok) throw new Error("N\xe5got gick fel n\xe4r vi skulle ta emot din best\xe4llning, f\xf6rs\xf6k igen senare.");
        },
        validators: {
            onSubmit: $25fb78121eb2c613$var$schema
        }
    });
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
        className: "wrapper-kia-sm py-12",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "mb-8",
                children: [
                    title && /*#__PURE__*/ (0, $2PPWI.jsx)("h1", {
                        className: "font-bold text-4xl mb-1",
                        children: title
                    }),
                    description && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("form", {
                onSubmit: (e)=>{
                    e.preventDefault();
                    form.handleSubmit();
                },
                className: "flex flex-col gap-6",
                children: [
                    laddboxOptions && laddboxOptions.length > 0 && /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                        name: "typeOfLaddbox",
                        children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("fieldset", {
                                className: "grid gap-2",
                                children: [
                                    laddboxOptions.map((option, index)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("label", {
                                            className: `flex items-start justify-between gap-2 border p-4 rounded-lg transition-colors cursor-pointer has-[:checked]:border-black has-[:checked]:ring-1 has-[:checked]:ring-black has-[:focus-visible]:bg-slate-100 ${field.state.meta.errors.length ? 'border-red-400 bg-red-50/30' : 'border-kia-grey bg-slate-50/50'}`,
                                            children: [
                                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                            className: "font-semibold text-lg mb-2",
                                                            children: option?.title
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                            children: option?.description
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                            className: "font-bold",
                                                            children: option?.price
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                    type: "radio",
                                                    className: "ml-auto flex-shrink-0",
                                                    name: field.name,
                                                    value: `${option?.title} ${option?.description} ${option?.price}`,
                                                    checked: field.state.value === `${option?.title} ${option?.description} ${option?.price}`,
                                                    onBlur: field.handleBlur,
                                                    onChange: ()=>field.handleChange(`${option?.title} ${option?.description} ${option?.price}`)
                                                })
                                            ]
                                        }, index)),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)($25fb78121eb2c613$export$f551688fc98f2e09, {
                                        errors: field.state.meta.errors
                                    })
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "grid grid-cols-1 sm:grid-cols-2 gap-4",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                name: "firstName",
                                children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                className: $25fb78121eb2c613$var$labelClass,
                                                htmlFor: field.name,
                                                children: "F\xf6rnamn"
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                className: field.state.meta.errors.length ? $25fb78121eb2c613$var$inputErrorClass : $25fb78121eb2c613$var$inputClass,
                                                type: "text",
                                                id: field.name,
                                                value: field.state.value,
                                                onBlur: field.handleBlur,
                                                onChange: (e)=>field.handleChange(e.target.value)
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)($25fb78121eb2c613$export$f551688fc98f2e09, {
                                                errors: field.state.meta.errors
                                            })
                                        ]
                                    })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                name: "lastName",
                                children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                className: $25fb78121eb2c613$var$labelClass,
                                                htmlFor: field.name,
                                                children: "Efternamn"
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                className: field.state.meta.errors.length ? $25fb78121eb2c613$var$inputErrorClass : $25fb78121eb2c613$var$inputClass,
                                                type: "text",
                                                id: field.name,
                                                value: field.state.value,
                                                onBlur: field.handleBlur,
                                                onChange: (e)=>field.handleChange(e.target.value)
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)($25fb78121eb2c613$export$f551688fc98f2e09, {
                                                errors: field.state.meta.errors
                                            })
                                        ]
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                        name: "street",
                        children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                        className: $25fb78121eb2c613$var$labelClass,
                                        htmlFor: field.name,
                                        children: "Adress"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                        className: field.state.meta.errors.length ? $25fb78121eb2c613$var$inputErrorClass : $25fb78121eb2c613$var$inputClass,
                                        type: "text",
                                        id: field.name,
                                        value: field.state.value,
                                        onBlur: field.handleBlur,
                                        onChange: (e)=>field.handleChange(e.target.value)
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)($25fb78121eb2c613$export$f551688fc98f2e09, {
                                        errors: field.state.meta.errors
                                    })
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "grid grid-cols-1 sm:grid-cols-2 gap-4",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                name: "zipCode",
                                children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                className: $25fb78121eb2c613$var$labelClass,
                                                htmlFor: field.name,
                                                children: "Postnummer"
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                className: field.state.meta.errors.length ? $25fb78121eb2c613$var$inputErrorClass : $25fb78121eb2c613$var$inputClass,
                                                type: "text",
                                                id: field.name,
                                                value: field.state.value,
                                                onBlur: field.handleBlur,
                                                onChange: (e)=>field.handleChange(e.target.value)
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)($25fb78121eb2c613$export$f551688fc98f2e09, {
                                                errors: field.state.meta.errors
                                            })
                                        ]
                                    })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                name: "city",
                                children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                className: $25fb78121eb2c613$var$labelClass,
                                                htmlFor: field.name,
                                                children: "Stad/ort"
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                className: field.state.meta.errors.length ? $25fb78121eb2c613$var$inputErrorClass : $25fb78121eb2c613$var$inputClass,
                                                type: "text",
                                                id: field.name,
                                                value: field.state.value,
                                                onBlur: field.handleBlur,
                                                onChange: (e)=>field.handleChange(e.target.value)
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)($25fb78121eb2c613$export$f551688fc98f2e09, {
                                                errors: field.state.meta.errors
                                            })
                                        ]
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                        name: "email",
                        children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                        className: $25fb78121eb2c613$var$labelClass,
                                        htmlFor: field.name,
                                        children: "E-post"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                        className: field.state.meta.errors.length ? $25fb78121eb2c613$var$inputErrorClass : $25fb78121eb2c613$var$inputClass,
                                        type: "email",
                                        id: field.name,
                                        value: field.state.value,
                                        onBlur: field.handleBlur,
                                        onChange: (e)=>field.handleChange(e.target.value)
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)($25fb78121eb2c613$export$f551688fc98f2e09, {
                                        errors: field.state.meta.errors
                                    })
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                        name: "cemail",
                        children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                        className: $25fb78121eb2c613$var$labelClass,
                                        htmlFor: field.name,
                                        children: "Bekr\xe4fta e-post"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                        className: field.state.meta.errors.length ? $25fb78121eb2c613$var$inputErrorClass : $25fb78121eb2c613$var$inputClass,
                                        type: "email",
                                        id: field.name,
                                        value: field.state.value,
                                        onBlur: field.handleBlur,
                                        onChange: (e)=>field.handleChange(e.target.value)
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)($25fb78121eb2c613$export$f551688fc98f2e09, {
                                        errors: field.state.meta.errors
                                    })
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                        name: "phone",
                        children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                        className: $25fb78121eb2c613$var$labelClass,
                                        htmlFor: field.name,
                                        children: "Telefonnr"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                        className: field.state.meta.errors.length ? $25fb78121eb2c613$var$inputErrorClass : $25fb78121eb2c613$var$inputClass,
                                        type: "tel",
                                        id: field.name,
                                        value: field.state.value,
                                        onBlur: field.handleBlur,
                                        onChange: (e)=>field.handleChange(e.target.value)
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)($25fb78121eb2c613$export$f551688fc98f2e09, {
                                        errors: field.state.meta.errors
                                    })
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                        name: "confirmedByBrf",
                        children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("fieldset", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("legend", {
                                        className: `${$25fb78121eb2c613$var$labelClass} mb-2`,
                                        children: "Har installationen/produkten godk\xe4nts av fastighets\xe4garen/bostadsr\xe4ttsf\xf6reningen?"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "flex flex-col sm:flex-row gap-4",
                                        children: [
                                            'Ja',
                                            'Nej',
                                            'Inte relevant'
                                        ].map((option)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("label", {
                                                className: "flex items-center gap-2 cursor-pointer text-sm",
                                                children: [
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                        type: "radio",
                                                        name: field.name,
                                                        value: option,
                                                        checked: field.state.value === option,
                                                        onBlur: field.handleBlur,
                                                        onChange: ()=>field.handleChange(option)
                                                    }),
                                                    option
                                                ]
                                            }, option))
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)($25fb78121eb2c613$export$f551688fc98f2e09, {
                                        errors: field.state.meta.errors
                                    })
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                        className: "font-normal text-dark-blue text-xs",
                        children: [
                            "Jag samtycker till att Kia Sverige AB behandlar mina personuppgifter och delar dem med vald leverant\xf6r och installationspartner samt att installationspartnern kontaktar mig via telefon e-post eller SMS ang\xe5ende min best\xe4llning.",
                            ' ',
                            /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                href: "https://www.kia.com/se/integritetspolicy/",
                                target: "_blank",
                                rel: "noopener",
                                children: "Integritetspolicy"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "grid gap-2",
                        children: [
                            form.state.isSubmitted && !form.state.errors.length && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: "text-green-600 text-sm",
                                children: "Tack f\xf6r din best\xe4llning, vi h\xf6r av oss till dig s\xe5 snart vi kan!"
                            }),
                            form.state.errors.length > 0 && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                role: "alert",
                                "aria-live": "polite",
                                className: $25fb78121eb2c613$var$errorClass,
                                children: String(form.state.errors[0])
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                type: "submit",
                                disabled: form.state.isSubmitting,
                                className: "bg-black text-white px-8 py-3 text-sm font-medium hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center",
                                children: form.state.isSubmitting ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $dmJAc.default), {
                                    className: "animate-spin h-4 w-4"
                                }) : 'Skicka'
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $25fb78121eb2c613$export$2e2bcd8739ae039 = $25fb78121eb2c613$var$LaddboxForm;

});
parcelRegister("dmJAc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $364157be1e1840cc$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
function $364157be1e1840cc$var$Loader({ ...props }) {
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        ...props,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                d: "M18.364 5.63604L16.9497 7.05025C15.683 5.7835 13.933 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12H21C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.4853 3 16.7353 4.00736 18.364 5.63604Z"
            })
        ]
    });
}
var $364157be1e1840cc$export$2e2bcd8739ae039 = $364157be1e1840cc$var$Loader;

});


parcelRegister("g1RTM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10d25f0f1f7b411f$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $655D0 = parcelRequire("655D0");
'use client';
const $10d25f0f1f7b411f$var$NavBlock = ({ links: links })=>{
    const sentinelRef = (0, $8FY87.useRef)(null);
    const [isFixed, setIsFixed] = (0, $8FY87.useState)(false);
    (0, $8FY87.useEffect)(()=>{
        const sentinel = sentinelRef.current;
        if (!sentinel) return;
        const observer = new IntersectionObserver(([entry])=>{
            setIsFixed(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        }, {
            threshold: 0
        });
        observer.observe(sentinel);
        return ()=>observer.disconnect();
    }, []);
    if (!links?.length) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                ref: sentinelRef,
                className: "h-px",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("nav", {
                "aria-label": "Hoppa till avsnitt",
                className: `z-[51] w-full bg-white ${isFixed ? 'fixed inset-x-0 top-0 shadow' : 'relative'}`,
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: " touch-pan-x overflow-x-auto overscroll-x-contain scroll-smooth [scrollbar-width:none] [&::-webkit-scrollbar]:hidden ",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                                className: " flex min-h-14 w-max min-w-full items-center gap-8 px-6 sm:gap-10 xl:justify-center xl:gap-20 xl:px-8 ",
                                children: links.map((link, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                        className: "shrink-0",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                            onClick: (0, $655D0.trackLinkClick),
                                            className: " whitespace-nowrap text-base font-bold text-black no-underline transition hover:text-gray-500 ",
                                            href: link.linkId.includes('http') ? link.linkId : `#${link.linkId}`,
                                            children: link.linkText
                                        })
                                    }, `${link.linkId}-${index}`))
                            })
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: " pointer-events-none absolute inset-y-0 left-0 w-6 bg-gradient-to-r from-white to-transparent xl:hidden ",
                            "aria-hidden": "true"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: " pointer-events-none absolute inset-y-0 right-0 w-6 bg-gradient-to-l from-white to-transparent xl:hidden ",
                            "aria-hidden": "true"
                        })
                    ]
                })
            }),
            isFixed && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "h-14",
                "aria-hidden": "true"
            })
        ]
    });
};
var $10d25f0f1f7b411f$export$2e2bcd8739ae039 = $10d25f0f1f7b411f$var$NavBlock;

});

parcelRegister("fy17o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c9515347adbe071$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Abjy = parcelRequire("4Abjy");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $1lSPe = parcelRequire("1lSPe");

var $cVcaL = parcelRequire("cVcaL");
const $7c9515347adbe071$var$StoryBlock = ({ blockId: blockId, containerWidth: containerWidth, postsToDisplay: postsToDisplay, heading: heading, selectedPosts: selectedPosts, category: category })=>{
    const showLatestPosts = postsToDisplay !== 'latestCategory' && postsToDisplay !== 'selection';
    const { data: latestPostsData } = (0, $4Abjy.useLatestPosts)(showLatestPosts);
    const posts = postsToDisplay === 'latestCategory' && category?.posts?.nodes && category?.posts?.nodes?.length > 0 ? category?.posts?.nodes.slice(0, 3) : postsToDisplay === 'selection' && selectedPosts?.length > 0 ? selectedPosts : showLatestPosts ? latestPostsData?.posts?.nodes?.slice(0, 3) ?? null : null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).section, {
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        variants: (0, $51Ucj.containerVariants),
        id: blockId ?? undefined,
        className: "w-full my-14 lg:my-24",
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: `w-full ${(0, $1lSPe.getContainerClass)(containerWidth)}`,
            children: [
                heading && /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                    className: "mb-4 lg:mb-6",
                    children: heading
                }),
                posts && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).ul, {
                    initial: "hidden",
                    whileInView: "visible",
                    viewport: (0, $51Ucj.viewPort),
                    variants: (0, $51Ucj.containerVariants),
                    className: `flex flex-col flex-wrap gap-y-8 lg:flex-row lg:w-[calc(100%+24px)] lg:-ml-3`,
                    children: posts.map((post)=>{
                        if (!post) return null;
                        return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).li, {
                            initial: "hidden",
                            whileInView: "visible",
                            viewport: (0, $51Ucj.viewPort),
                            variants: (0, $51Ucj.itemVariants),
                            className: "basis-1/3 lg:px-3",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $cVcaL.default), {
                                post: post
                            })
                        }, post.id);
                    })
                })
            ]
        })
    });
};
var $7c9515347adbe071$export$2e2bcd8739ae039 = $7c9515347adbe071$var$StoryBlock;

});
parcelRegister("4Abjy", function(module, exports) {

$parcel$export(module.exports, "useLatestPosts", function () { return $e020d05c7813c969$export$955a9049424f970d; });

var $hgSaH = parcelRequire("hgSaH");

var $hOfQh = parcelRequire("hOfQh");

var $j4xon = parcelRequire("j4xon");
const $e020d05c7813c969$export$955a9049424f970d = (enabled = true)=>{
    return (0, $hgSaH.useQuery)({
        queryKey: [
            'latestPosts'
        ],
        queryFn: ()=>(0, $hOfQh.executeGraphql)((0, $j4xon.GetLatestPosts), {}),
        enabled: enabled,
        staleTime: 300000
    });
};

});
parcelRegister("j4xon", function(module, exports) {

$parcel$export(module.exports, "GetLatestPosts", function () { return $fa4c98f1919f367b$export$b093d84e78ca773e; });
parcelRequire("btB3p");
var $dd2YO = parcelRequire("dd2YO");
const $fa4c98f1919f367b$export$b093d84e78ca773e = (0, $dd2YO.graphql)(`
  query GetLatestPosts($first: Int = 3) {
    posts(first: $first) {
      nodes {
        id
        databaseId
        content
        title
        link
        slug
        featuredImage {
          node {
            altText
            sourceUrl
            mediaDetails {
              height
              width
            }
          }
        }
      }
    }
  }
`);

});


parcelRegister("cVcaL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3e26e5003ca885f$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $5Otf1 = parcelRequire("5Otf1");

var $eWIyH = parcelRequire("eWIyH");
const $b3e26e5003ca885f$var$PostItem = ({ post: post })=>{
    const featuredImage = post?.featuredImage?.node ? post.featuredImage.node : null;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("a", {
        href: `${"https://story.kia.se"}/${post.slug}`,
        className: "group flex flex-col w-full h-full shadow-md shadow-black/6 no-underline",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "w-full relative aspect-[4/3] overflow-hidden",
                children: featuredImage && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5Otf1.default), {
                    src: featuredImage.sourceUrl || '',
                    alt: featuredImage.altText || '',
                    width: featuredImage.mediaDetails?.width || 0,
                    height: featuredImage.mediaDetails?.height || 0,
                    sizes: "(max-width: 1024px) 100vw, 570px",
                    srcSet: featuredImage.srcSet || '',
                    className: "w-full h-full object-cover group-hover:scale-[1.025] transition-all duration-500"
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: `editor-card flex flex-col p-4 lg:p-6`,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                        className: "group-hover:underline underline-offset-2",
                        children: post.title
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "font-inherit text-sm [&_samp]:font-inherit line-clamp-3",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eWIyH.default), {
                            stripAnchors: true,
                            children: post.excerpt ? post.excerpt : post.content ? `${post.content.slice(0, 300)}` : null
                        })
                    })
                ]
            })
        ]
    });
};
var $b3e26e5003ca885f$export$2e2bcd8739ae039 = $b3e26e5003ca885f$var$PostItem;

});


parcelRegister("kSlSZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88534e2504b65632$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $1lSPe = parcelRequire("1lSPe");

var $eWIyH = parcelRequire("eWIyH");
const $88534e2504b65632$var$TableBlock = ({ blockId: blockId, containerWidth: containerWidth, cols: cols, rows: rows })=>{
    if (!cols || cols.length === 0) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).section, {
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        variants: (0, $51Ucj.containerVariants),
        id: blockId ?? undefined,
        className: "w-full my-14 lg:my-24",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            className: `w-full max-lg:overflow-x-scroll ${(0, $1lSPe.getContainerClass)(containerWidth)}`,
            children: /*#__PURE__*/ (0, $2PPWI.jsxs)("table", {
                className: "editor-table",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("tr", {
                            className: "align-baseline bg-neutral-100",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("th", {
                                    className: "max-lg:hidden min-w-52 p-4 border border-neutral-300"
                                }),
                                cols.map((col, i)=>/*#__PURE__*/ (0, $2PPWI.jsx)("th", {
                                        className: "p-4 border border-neutral-300 text-left font-normal",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eWIyH.default), {
                                            children: col.colLabel
                                        })
                                    }, i))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("tbody", {
                        children: rows.map((row, i)=>/*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("tr", {
                                        className: "lg:hidden",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("th", {
                                            colSpan: rows.length,
                                            className: "lg:min-w-52 p-4 bg-neutral-100 border border-neutral-300",
                                            children: row.rowLabel
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsxs)("tr", {
                                        className: `bg-white ${Math.abs(i % 2) == 1 ? 'lg:bg-white' : 'lg:bg-neutral-100'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("th", {
                                                className: "max-lg:hidden min-w-52 p-4 border border-neutral-300",
                                                children: row.rowLabel
                                            }),
                                            row.rowCells.map((cell, j)=>/*#__PURE__*/ (0, $2PPWI.jsx)("td", {
                                                    className: "lg:min-w-52 p-4 border border-neutral-300 text-center",
                                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eWIyH.default), {
                                                        children: cell.cellContent
                                                    })
                                                }, j))
                                        ]
                                    })
                                ]
                            }, i))
                    })
                ]
            })
        })
    });
};
var $88534e2504b65632$export$2e2bcd8739ae039 = $88534e2504b65632$var$TableBlock;

});

parcelRegister("aKzpl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2e48dd47733ed80$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $abLS4 = parcelRequire("abLS4");

var $4Qpe2 = parcelRequire("4Qpe2");

var $8FY87 = parcelRequire("8FY87");

var $51Ucj = parcelRequire("51Ucj");

var $1lSPe = parcelRequire("1lSPe");

var $eWIyH = parcelRequire("eWIyH");
const $e2e48dd47733ed80$var$TabsBlock = ({ blockId: blockId, containerWidth: containerWidth, title: title, tabs: tabs })=>{
    if (!tabs?.length) return null;
    const [activeIndex, setActiveIndex] = (0, $8FY87.useState)(0);
    const activeTab = tabs[activeIndex];
    return /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
        id: blockId ?? undefined,
        className: "w-full my-14 lg:my-24",
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: `w-full ${(0, $1lSPe.getContainerClass)(containerWidth)}`,
            children: [
                title && /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                    className: "mb-5 lg:mb-10",
                    children: title
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: "flex flex-wrap gap-2.5 mb-5 lg:mb-10",
                    children: tabs.map((tab, i)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $abLS4.default), {
                            type: i === activeIndex ? 'default' : 'outline',
                            text: tab.label,
                            onClick: ()=>setActiveIndex(i)
                        }, i))
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).ul, {
                    initial: "hidden",
                    whileInView: "visible",
                    viewport: (0, $51Ucj.viewPort),
                    variants: (0, $51Ucj.containerVariants),
                    className: "editor flex flex-col lg:flex-row gap-6 lg:gap-[8%]",
                    children: activeTab?.columns?.map((col, j)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).li, {
                            className: "flex-1",
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eWIyH.default), {
                                children: col.content
                            })
                        }, j))
                })
            ]
        })
    });
};
var $e2e48dd47733ed80$export$2e2bcd8739ae039 = $e2e48dd47733ed80$var$TabsBlock;

});
parcelRegister("abLS4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31b10df3cac582fe$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");
const $31b10df3cac582fe$var$ButtonBox = ({ type: type = 'default', text: text, onClick: onClick, className: className })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
        className: `flex items-center justify-center min-w-24 lg:min-w-40 px-4 py-5 border border-black ${type === 'outline' ? '' : 'bg-black text-white'} ${className || ''}`,
        onClick: onClick,
        children: text
    });
};
var $31b10df3cac582fe$export$2e2bcd8739ae039 = $31b10df3cac582fe$var$ButtonBox;

});


parcelRegister("5w6Da", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df557e92b8ecd34f$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $655D0 = parcelRequire("655D0");

var $9Pm4j = parcelRequire("9Pm4j");

var $fdiy9 = parcelRequire("fdiy9");

var $5Otf1 = parcelRequire("5Otf1");

var $96iav = parcelRequire("96iav");

var $kM2Bn = parcelRequire("kM2Bn");

var $b2c0V = parcelRequire("b2c0V");

var $4y07l = parcelRequire("4y07l");

var $4Qpe2 = parcelRequire("4Qpe2");

var $8FY87 = parcelRequire("8FY87");

var $51Ucj = parcelRequire("51Ucj");

var $1lSPe = parcelRequire("1lSPe");

var $eWIyH = parcelRequire("eWIyH");
'use client';
const $df557e92b8ecd34f$var$TextAndMedia = ({ blockId: blockId, containerWidth: containerWidth, mediaType: mediaType, image: image, imageMobile: imageMobile, video: video, videoMobile: videoMobile, youtube: youtube, mediaIsCover: mediaIsCover, videoHasControls: videoHasControls, videoHasAutoplay: videoHasAutoplay, mediaPosition: mediaPosition, link: link, linkText: linkText, linkInNewWindow: linkInNewWindow, linkType: linkType, linkPosition: linkPosition, contentBg: contentBg, content: content })=>{
    const [currentVideoPlaying, setCurrentVideoPlaying] = (0, $8FY87.useState)(null);
    const isImage = Boolean(mediaType === 'image' && image?.sourceUrl);
    const isVideo = Boolean(mediaType === 'video' && video?.mediaItemUrl);
    const isYoutube = Boolean(mediaType === 'youtube' && youtube);
    const youtubeId = isYoutube ? (0, $1lSPe.getYoutubeId)(youtube) : null;
    const mediaIsRight = Boolean(mediaPosition === 'right');
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
        id: blockId ?? undefined,
        className: "w-full my-14 lg:my-24",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).div, {
                initial: "hidden",
                whileInView: "visible",
                viewport: (0, $51Ucj.viewPort),
                variants: (0, $51Ucj.containerVariants),
                className: `w-full ${(0, $1lSPe.getContainerClass)(containerWidth)}`,
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "grid grid-cols-1 lg:grid-cols-2 lg:items-center gap-4 lg:gap-0",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: `relative w-full h-full ${isImage && mediaIsCover ? 'aspect-[3/2]' : ''} ${mediaIsRight ? 'order-1 lg:order-2' : 'order-1'}`,
                            children: [
                                isYoutube && youtubeId ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9Pm4j.default), {
                                    videoId: youtubeId
                                }) : null,
                                isImage ? /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: "w-full h-full",
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5Otf1.default), {
                                            src: image.sourceUrl || '',
                                            alt: image.altText || '',
                                            width: image.mediaDetails.width || 0,
                                            height: image.mediaDetails.height || 0,
                                            sizes: "(max-width: 1024px) 100vw, 50vw",
                                            srcSet: image.srcSet || '',
                                            className: `w-full ${mediaIsCover ? 'object-cover h-full' : 'object-contain'} ${imageMobile ? 'hidden lg:block' : 'block'}`,
                                            loading: "eager"
                                        }),
                                        imageMobile && imageMobile.sourceUrl ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5Otf1.default), {
                                            src: imageMobile.sourceUrl || '',
                                            alt: imageMobile.altText || '',
                                            width: imageMobile.mediaDetails.width || 0,
                                            height: imageMobile.mediaDetails.height || 0,
                                            sizes: "100vw",
                                            srcSet: imageMobile.srcSet || '',
                                            className: "block h-full w-full object-cover lg:hidden",
                                            loading: "eager"
                                        }) : null
                                    ]
                                }) : null,
                                isVideo ? /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: "w-full h-full",
                                    onClick: ()=>setCurrentVideoPlaying({
                                            mediaItemUrl: video.mediaItemUrl,
                                            mimeType: video.mimeType
                                        }),
                                    children: [
                                        !videoHasAutoplay && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                            className: "absolute flex items-center justify-center w-full h-full top-0 left-0 cursor-pointer z-10",
                                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $b2c0V.default), {
                                                className: "w-16 h-16 text-white"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("video", {
                                            autoPlay: videoHasAutoplay,
                                            controls: videoHasControls,
                                            muted: true,
                                            loop: true,
                                            playsInline: true,
                                            preload: "metadata",
                                            className: `h-full w-full aspect-video object-cover ${videoMobile && videoMobile.mediaItemUrl ? 'hidden lg:block' : 'block'}`,
                                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                                                src: `${video.mediaItemUrl}#t=0.001`,
                                                type: video.mimeType
                                            })
                                        }),
                                        videoMobile && videoMobile.mediaItemUrl ? /*#__PURE__*/ (0, $2PPWI.jsx)("video", {
                                            autoPlay: videoHasAutoplay,
                                            controls: videoHasControls,
                                            muted: true,
                                            loop: true,
                                            playsInline: true,
                                            preload: "metadata",
                                            className: "block h-full w-full aspect-video object-cover lg:hidden",
                                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("source", {
                                                src: `${videoMobile.mediaItemUrl}#t=0.001`,
                                                type: videoMobile.mimeType
                                            })
                                        }) : null
                                    ]
                                }) : null
                            ]
                        }),
                        content && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: `editor-card flex flex-col h-full px-4 md:px-0 lg:px-12 lg:justify-center order-2 lg:order-1 ${mediaIsRight ? 'order-2 lg:order-1' : 'order-2'} ${contentBg ? 'p-4 lg:pl-8 lg:pr-4 lg:pt-6 lg:pb-4' : ''}`,
                            style: {
                                backgroundColor: contentBg ? contentBg : 'transparent'
                            },
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eWIyH.default), {
                                    children: content
                                }),
                                link && linkText && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                    className: `${linkPosition === 'center' ? 'mx-auto' : linkPosition === 'right' ? 'max-lg:mx-auto lg:ml-auto' : 'max-lg:mx-auto lg:mr-auto'}`,
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $fdiy9.default), {
                                        onClick: (0, $655D0.trackLinkClick),
                                        type: linkType,
                                        text: linkText,
                                        url: link,
                                        linkInNewWindow: linkInNewWindow,
                                        className: "mt-2 lg:mt-8"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            currentVideoPlaying ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kM2Bn.default), {
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "flex justify-center items-center w-full h-full",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                            "aria-label": "Close window",
                            className: "absolute top-6 right-6 flex items-center justify-center w-10 h-10 hover:bg-black/10 opacity-60 hover:opacity-100 rounded-full transition-all z-10",
                            onClick: ()=>setCurrentVideoPlaying(null),
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $96iav.default), {
                                className: "w-6 h-6 text-white"
                            })
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4y07l.default), {
                            controls: true,
                            autoplay: true,
                            ...currentVideoPlaying
                        })
                    ]
                })
            }) : null
        ]
    });
};
var $df557e92b8ecd34f$export$2e2bcd8739ae039 = $df557e92b8ecd34f$var$TextAndMedia;

});

parcelRegister("3lJNg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3453da2b12257bd2$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $655D0 = parcelRequire("655D0");

var $9rGkt = parcelRequire("9rGkt");

var $4Qpe2 = parcelRequire("4Qpe2");

var $51Ucj = parcelRequire("51Ucj");

var $1lSPe = parcelRequire("1lSPe");

var $eWIyH = parcelRequire("eWIyH");
const $3453da2b12257bd2$var$Texteditor = ({ blockId: blockId, content: content, containerWidth: containerWidth, bgColor: bgColor, links: links })=>{
    if (!content) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4Qpe2.m).section, {
        initial: "hidden",
        whileInView: "visible",
        viewport: (0, $51Ucj.viewPort),
        variants: (0, $51Ucj.containerVariants),
        id: blockId ?? undefined,
        className: "w-full my-14 lg:my-24",
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: `w-full ${(0, $1lSPe.getContainerClass)(containerWidth)} ${bgColor ? 'p-4' : ''}`,
            style: {
                backgroundColor: bgColor ? bgColor : 'transparent'
            },
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: "editor px-4 md:px-0",
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eWIyH.default), {
                        children: content
                    })
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9rGkt.default), {
                    links: links,
                    onLinkClick: (0, $655D0.trackLinkClick)
                })
            ]
        })
    });
};
var $3453da2b12257bd2$export$2e2bcd8739ae039 = $3453da2b12257bd2$var$Texteditor;

});



parcelRegister("kha4G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84f0dc262a761bad$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $5Otf1 = parcelRequire("5Otf1");

var $1lSPe = parcelRequire("1lSPe");

var $eWIyH = parcelRequire("eWIyH");
const $84f0dc262a761bad$var$LogotypesBlock = ({ blockId: blockId, gallery: gallery, title: title, containerWidth: containerWidth })=>{
    if (!gallery || gallery.length === 0) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
        id: blockId ?? undefined,
        className: "w-full my-14 lg:my-24",
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: `w-full ${(0, $1lSPe.getContainerClass)(containerWidth)}`,
            children: [
                title && /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                    className: "mb-8 md:mb-10 text-center",
                    children: title
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: "flex flex-wrap justify-center gap-x-4 md:gap-x-8 gap-y-6 md:gap-y-8 px-4 md:px-0",
                    children: gallery.map((image, index)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: "grid justify-center gap-3 md:gap-4 w-[104px] md:w-32",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5Otf1.default), {
                                    width: 100,
                                    height: 100,
                                    src: image.sourceUrl,
                                    alt: image.altText,
                                    className: "w-[90px] md:w-[100px] h-[90px] md:h-[100px] shrink-0 object-contain"
                                }),
                                image.altText && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                    className: "font-light text-xs md:text-sm text-center text-neutral-600",
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eWIyH.default), {
                                        children: image.altText
                                    })
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
};
var $84f0dc262a761bad$export$2e2bcd8739ae039 = $84f0dc262a761bad$var$LogotypesBlock;

});

parcelRegister("jLzDD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8ea7ba1ba30bb30$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $655D0 = parcelRequire("655D0");

var $evXNI = parcelRequire("evXNI");

var $8TrCb = parcelRequire("8TrCb");
var $k7h0Y = parcelRequire("k7h0Y");

var $8FY87 = parcelRequire("8FY87");

var $c0oib = parcelRequire("c0oib");

var $44QXF = parcelRequire("44QXF");

var $kj7mx = parcelRequire("kj7mx");

var $3IOIe = parcelRequire("3IOIe");

var $ffhAG = parcelRequire("ffhAG");

var $8ISOr = parcelRequire("8ISOr");

var $i8UXi = parcelRequire("i8UXi");

var $kbggU = parcelRequire("kbggU");

var $7XuD0 = parcelRequire("7XuD0");

var $2v2JP = parcelRequire("2v2JP");
const $b8ea7ba1ba30bb30$var$RECAPTCHA_KEY = "6LcJBCAtAAAAAKUiTTGiCZxWVLEsOliHPjrMMwnb";
if (!$b8ea7ba1ba30bb30$var$RECAPTCHA_KEY) throw new Error('Missing required env var: GOOGLE_CLIENT_RECAPTCHA');
const $b8ea7ba1ba30bb30$var$stepRotations = [
    '-4deg',
    '3deg',
    '-2deg',
    '4deg',
    '-3deg'
];
function $b8ea7ba1ba30bb30$var$WowForm({ terms: terms, successModalDescription: successModalDescription, successModalTitle: successModalTitle, steps: steps }) {
    const { mutateAsync: mutateAsync } = (0, $evXNI.useContribution)();
    const { data: resellersData, isError: resellersError } = (0, $evXNI.useResellers)();
    const [selectedReseller, setSelectedReseller] = (0, $8FY87.useState)(null);
    const [selectionMode, setSelectionMode] = (0, $8FY87.useState)('idle');
    const [mapOpen, setMapOpen] = (0, $8FY87.useState)(false);
    const [termsModalOpen, setTermsModalOpen] = (0, $8FY87.useState)(false);
    const [termsAccepted, setTermsAccepted] = (0, $8FY87.useState)(false);
    const [ageConfirmed, setAgeConfirmed] = (0, $8FY87.useState)(false);
    const [successModalOpen, setSuccessModalOpen] = (0, $8FY87.useState)(false);
    const honeypotRef = (0, $8FY87.useRef)('');
    (0, $8FY87.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    (0, $8FY87.useEffect)(()=>{
        (0, $44QXF.default)();
    }, []);
    (0, $8FY87.useEffect)(()=>{
        const style = document.createElement('style');
        style.textContent = '.grecaptcha-badge { visibility: hidden; }';
        document.head.appendChild(style);
        return ()=>style.remove();
    }, []);
    const form = (0, $k7h0Y.useForm)({
        defaultValues: $i8UXi.defaultValues,
        validationLogic: (0, $8TrCb.revalidateLogic)({
            mode: 'submit',
            modeAfterSubmission: 'change'
        }),
        validators: {
            onDynamic: (0, $i8UXi.schema)
        },
        onSubmit: async ({ value: value })=>{
            if (honeypotRef.current) return;
            try {
                const recaptcha = await (0, $44QXF.default)();
                const token = await recaptcha.enterprise.execute($b8ea7ba1ba30bb30$var$RECAPTCHA_KEY, {
                    action: 'submit'
                });
                await mutateAsync({
                    ...value,
                    recaptcha_token: token
                });
                setSuccessModalOpen(true);
            } catch (error) {
                if (error instanceof (0, $evXNI.ApiError)) {
                    const data = error.data;
                    if (data?.errors) {
                        const entries = Object.entries(data.errors);
                        if (entries.every(([field])=>field === 'recaptcha_token')) form.setErrorMap({
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            onServer: "N\xe5got gick fel, f\xf6rs\xf6k igen senare."
                        });
                        else for (const [field, messages] of entries){
                            if (field === 'recaptcha_token') continue;
                            form.setFieldMeta(field, (prev)=>({
                                    ...prev,
                                    errorMap: {
                                        ...prev.errorMap,
                                        onServer: messages[0]
                                    }
                                }));
                        }
                    } else form.setErrorMap({
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        onServer: data?.message ?? "N\xe5got gick fel, f\xf6rs\xf6k igen senare."
                    });
                } else {
                    console.error(error);
                    form.setErrorMap({
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        onServer: "N\xe5got gick fel, f\xf6rs\xf6k igen senare."
                    });
                }
            }
        }
    });
    const clearServerError = (fieldName)=>{
        form.setFieldMeta(fieldName, (prev)=>({
                ...prev,
                errorMap: {
                    ...prev.errorMap,
                    onServer: undefined
                }
            }));
    };
    const resellers = (resellersData ?? []).filter((d)=>d.lat != null && d.lon != null);
    const handleResellerSelect = (reseller)=>{
        setSelectedReseller(reseller);
        form.setFieldValue('reseller_id', reseller?.id ?? 0);
        clearServerError('reseller_id');
        if (reseller) {
            if (selectionMode === 'denied' || selectionMode === 'error' || selectionMode === 'located') setMapOpen(false);
            else setSelectionMode('located');
        }
    };
    const handleGeolocate = ()=>{
        setSelectionMode('locating');
        navigator.geolocation.getCurrentPosition((pos)=>{
            if (resellers.length === 0) {
                setSelectionMode('error');
                return;
            }
            const closest = resellers.reduce((best, r)=>(0, $i8UXi.haversineKm)(pos.coords.latitude, pos.coords.longitude, r.lat, r.lon) < (0, $i8UXi.haversineKm)(pos.coords.latitude, pos.coords.longitude, best.lat, best.lon) ? r : best);
            handleResellerSelect(closest);
        }, (err)=>{
            setSelectionMode(err.code === err.PERMISSION_DENIED ? 'denied' : 'error');
            setMapOpen(true);
        });
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
        className: "text-dark-blue  relative",
        children: [
            successModalOpen && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $kbggU.SuccessModal), {
                title: successModalTitle,
                description: successModalDescription,
                onClose: ()=>{
                    setSuccessModalOpen(false);
                    form.reset();
                    setSelectedReseller(null);
                    setAgeConfirmed(false);
                    setTermsAccepted(false);
                    setSelectionMode('idle');
                }
            }),
            termsModalOpen && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $7XuD0.TermsModal), {
                content: terms ?? '',
                onAccept: ()=>{
                    setTermsAccepted(true);
                    setTermsModalOpen(false);
                },
                onDecline: ()=>setTermsModalOpen(false)
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "max-w-screen-kia-md mx-auto px-4 relative z-10",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("ol", {
                    className: "grid gap-20",
                    children: (steps ?? []).filter(Boolean).map((step, i)=>{
                        const rotate = $b8ea7ba1ba30bb30$var$stepRotations[i % $b8ea7ba1ba30bb30$var$stepRotations.length];
                        const n = String(i + 1);
                        if (step.__typename?.endsWith('_Steps_Text')) {
                            const s = step;
                            return /*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                                className: "grid grid-cols-[auto_1fr] gap-4 gap-y-0 items-start",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3IOIe.StepNumber), {
                                        n: n,
                                        rotate: rotate
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        className: "text-2xl font-semibold leading-snug self-end",
                                        children: s.title
                                    }),
                                    s.description && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "text-dark-blue/70 leading-relaxed col-start-1 col-span-2 md:col-start-2 md:col-span-1 mt-3 place-self-start",
                                        dangerouslySetInnerHTML: {
                                            __html: (0, $8ISOr.sanitize)(s.description)
                                        }
                                    }),
                                    s.textCtaUrl && /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                        className: "grid bg-dark-blue text-white border border-black hover:bg-transparent hover:text-black transition-colors py-3 no-underline place-content-center mt-8 rounded-sm col-start-1 col-span-2 md:col-start-2 md:col-span-1",
                                        href: s.textCtaUrl,
                                        onClick: (0, $655D0.trackLinkClick),
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: s.textCtaLabel ?? s.textCtaUrl
                                    })
                                ]
                            }, i);
                        }
                        if (step.__typename?.endsWith('_Steps_TextRules')) {
                            const s = step;
                            return /*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                                className: "grid grid-cols-[auto_1fr] gap-4 gap-y-0 items-start",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3IOIe.StepNumber), {
                                        n: n,
                                        rotate: rotate
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                        className: "text-2xl font-semibold leading-snug self-end",
                                        children: s.title
                                    }),
                                    s.description && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "text-dark-blue/70 leading-relaxed col-start-1 col-span-2 md:col-start-2 md:col-span-1 mt-3 place-self-start",
                                        dangerouslySetInnerHTML: {
                                            __html: (0, $8ISOr.sanitize)(s.description)
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                        className: "col-start-1 col-span-2 md:col-start-2 md:col-span-1",
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2v2JP.TiltCard), {
                                                children: [
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                                        className: "bg-dark-blue -mx-6 -mt-5 px-6 py-4 rounded-t-xl mb-5",
                                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                            className: "text-base font-bold text-white tracking-tight",
                                                            children: s.rulesTitle
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                                                        className: "divide-y divide-dark-blue/10",
                                                        children: (s.rulesItems ?? []).filter(Boolean).map((item, j)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                                                                className: "flex gap-4 items-baseline py-3.5",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                                        className: "shrink-0 w-6 h-6 rounded-full bg-dark-blue flex items-center justify-center text-xs font-bold text-white mt-0.5",
                                                                        children: j + 1
                                                                    }),
                                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                                        className: "text-dark-blue/80 text-sm",
                                                                        children: item.text
                                                                    })
                                                                ]
                                                            }, j))
                                                    })
                                                ]
                                            }),
                                            s.ctaUrl && /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                                className: "grid bg-dark-blue text-white border border-black hover:bg-transparent hover:text-black transition-colors py-3 no-underline place-content-center mt-8 rounded-sm",
                                                href: s.ctaUrl,
                                                onClick: (0, $655D0.trackLinkClick),
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: s.ctaLabel ?? s.ctaUrl
                                            })
                                        ]
                                    })
                                ]
                            }, i);
                        }
                        return /*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                            className: "grid grid-cols-[auto_1fr] gap-4 gap-y-0 items-start",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3IOIe.StepNumber), {
                                    n: n,
                                    rotate: rotate
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                                    className: "text-2xl font-semibold leading-snug self-end",
                                    children: step.title
                                }),
                                step.description && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                    className: "text-dark-blue/70 leading-relaxed col-start-1 col-span-2 md:col-start-2 md:col-span-1 mt-3",
                                    dangerouslySetInnerHTML: {
                                        __html: (0, $8ISOr.sanitize)(step.description)
                                    }
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                    className: "col-start-1 col-span-2",
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "mt-4 lg:mt-7 bg-white border border-dark-blue/10 shadow-[0_12px_40px_rgba(0,0,0,0.10)] rounded-xl px-4 lg:px-6 py-6",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("form", {
                                            onSubmit: (e)=>{
                                                e.preventDefault();
                                                e.stopPropagation();
                                                form.handleSubmit();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                    className: "grid gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                            "aria-hidden": "true",
                                                            className: "absolute -left-[9999px] opacity-0 pointer-events-none",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                                    htmlFor: "website",
                                                                    children: "Website"
                                                                }),
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                                    id: "website",
                                                                    name: "website",
                                                                    type: "text",
                                                                    tabIndex: -1,
                                                                    autoComplete: "off",
                                                                    onChange: (e)=>{
                                                                        honeypotRef.current = e.target.value;
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                                            name: "reseller_id",
                                                            children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $ffhAG.ResellerField), {
                                                                    selectionMode: selectionMode,
                                                                    selectedReseller: selectedReseller,
                                                                    mapOpen: mapOpen,
                                                                    errors: field.state.meta.errors,
                                                                    resellersAvailable: !resellersError,
                                                                    onGeolocate: handleGeolocate,
                                                                    onOpenMap: ()=>setMapOpen(true),
                                                                    onSelectReseller: handleResellerSelect
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                            className: "grid md:grid-cols-2 gap-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                                                    name: "first_name",
                                                                    children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                                                    className: (0, $i8UXi.labelClass),
                                                                                    htmlFor: field.name,
                                                                                    children: "F\xf6rnamn"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                                                    className: field.state.meta.errors.length ? (0, $i8UXi.inputErrorClass) : (0, $i8UXi.inputClass),
                                                                                    type: "text",
                                                                                    placeholder: "F\xf6rnamn",
                                                                                    id: field.name,
                                                                                    value: field.state.value,
                                                                                    onBlur: field.handleBlur,
                                                                                    onChange: (e)=>{
                                                                                        field.handleChange(e.target.value);
                                                                                        clearServerError(field.name);
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c0oib.FieldError), {
                                                                                    errors: field.state.meta.errors
                                                                                })
                                                                            ]
                                                                        })
                                                                }),
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                                                    name: "last_name",
                                                                    children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                                                    className: (0, $i8UXi.labelClass),
                                                                                    htmlFor: field.name,
                                                                                    children: "Efternamn"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                                                    className: field.state.meta.errors.length ? (0, $i8UXi.inputErrorClass) : (0, $i8UXi.inputClass),
                                                                                    type: "text",
                                                                                    placeholder: "Efternamn",
                                                                                    id: field.name,
                                                                                    value: field.state.value,
                                                                                    onBlur: field.handleBlur,
                                                                                    onChange: (e)=>{
                                                                                        field.handleChange(e.target.value);
                                                                                        clearServerError(field.name);
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c0oib.FieldError), {
                                                                                    errors: field.state.meta.errors
                                                                                })
                                                                            ]
                                                                        })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                                            name: "address",
                                                            children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                                            className: (0, $i8UXi.labelClass),
                                                                            htmlFor: field.name,
                                                                            children: "Gatuadress"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                                            className: field.state.meta.errors.length ? (0, $i8UXi.inputErrorClass) : (0, $i8UXi.inputClass),
                                                                            type: "text",
                                                                            placeholder: "Gatuadress",
                                                                            id: field.name,
                                                                            value: field.state.value,
                                                                            onBlur: field.handleBlur,
                                                                            onChange: (e)=>{
                                                                                field.handleChange(e.target.value);
                                                                                clearServerError(field.name);
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c0oib.FieldError), {
                                                                            errors: field.state.meta.errors
                                                                        })
                                                                    ]
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                            className: "grid md:grid-cols-2 gap-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                                                    name: "zip",
                                                                    children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                                                    className: (0, $i8UXi.labelClass),
                                                                                    htmlFor: field.name,
                                                                                    children: "Postnummer"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                                                    className: field.state.meta.errors.length ? (0, $i8UXi.inputErrorClass) : (0, $i8UXi.inputClass),
                                                                                    type: "text",
                                                                                    placeholder: "12345",
                                                                                    id: field.name,
                                                                                    value: field.state.value,
                                                                                    onBlur: field.handleBlur,
                                                                                    onChange: (e)=>{
                                                                                        field.handleChange(e.target.value);
                                                                                        clearServerError(field.name);
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c0oib.FieldError), {
                                                                                    errors: field.state.meta.errors
                                                                                })
                                                                            ]
                                                                        })
                                                                }),
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                                                    name: "city",
                                                                    children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                                                    className: (0, $i8UXi.labelClass),
                                                                                    htmlFor: field.name,
                                                                                    children: "Postort"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                                                    className: field.state.meta.errors.length ? (0, $i8UXi.inputErrorClass) : (0, $i8UXi.inputClass),
                                                                                    type: "text",
                                                                                    placeholder: "Postort",
                                                                                    id: field.name,
                                                                                    value: field.state.value,
                                                                                    onBlur: field.handleBlur,
                                                                                    onChange: (e)=>{
                                                                                        field.handleChange(e.target.value);
                                                                                        clearServerError(field.name);
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c0oib.FieldError), {
                                                                                    errors: field.state.meta.errors
                                                                                })
                                                                            ]
                                                                        })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                                            name: "phone",
                                                            children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                                            className: (0, $i8UXi.labelClass),
                                                                            htmlFor: field.name,
                                                                            children: "Mobiltelefonnummer"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                                            className: field.state.meta.errors.length ? (0, $i8UXi.inputErrorClass) : (0, $i8UXi.inputClass),
                                                                            type: "tel",
                                                                            placeholder: "070 123 45 67",
                                                                            id: field.name,
                                                                            value: field.state.value,
                                                                            onBlur: field.handleBlur,
                                                                            onChange: (e)=>{
                                                                                field.handleChange(e.target.value);
                                                                                clearServerError(field.name);
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c0oib.FieldError), {
                                                                            errors: field.state.meta.errors
                                                                        })
                                                                    ]
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                                            name: "email",
                                                            children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                                            className: (0, $i8UXi.labelClass),
                                                                            htmlFor: field.name,
                                                                            children: "E-postadress"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                                            className: field.state.meta.errors.length ? (0, $i8UXi.inputErrorClass) : (0, $i8UXi.inputClass),
                                                                            type: "email",
                                                                            placeholder: "din@epost.se",
                                                                            id: field.name,
                                                                            value: field.state.value,
                                                                            onBlur: field.handleBlur,
                                                                            onChange: (e)=>{
                                                                                field.handleChange(e.target.value);
                                                                                clearServerError(field.name);
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c0oib.FieldError), {
                                                                            errors: field.state.meta.errors
                                                                        })
                                                                    ]
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)(form.Field, {
                                                            name: "image",
                                                            children: (field)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $kj7mx.ImageDropField), {
                                                                    name: field.name,
                                                                    value: field.state.value,
                                                                    errors: field.state.meta.errors,
                                                                    onBlur: field.handleBlur,
                                                                    onChange: (file)=>{
                                                                        field.handleChange(file);
                                                                        clearServerError(field.name);
                                                                    }
                                                                })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                    className: "mt-4 flex flex-col gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                            className: "flex items-start gap-3 text-sm",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                                    type: "checkbox",
                                                                    id: "terms-checkbox",
                                                                    "aria-label": "Jag har l\xe4st och godk\xe4nner t\xe4vlingsvillkoren",
                                                                    checked: termsAccepted,
                                                                    onChange: ()=>termsAccepted ? setTermsAccepted(false) : setTermsModalOpen(true),
                                                                    className: "size-4 accent-dark-blue shrink-0 cursor-pointer !mt-[3px]"
                                                                }),
                                                                /*#__PURE__*/ (0, $2PPWI.jsxs)("label", {
                                                                    htmlFor: "terms-checkbox",
                                                                    children: [
                                                                        "Jag har l\xe4st och godk\xe4nner",
                                                                        ' ',
                                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>setTermsModalOpen(true),
                                                                            className: "underline underline-offset-2 font-medium text-dark-blue hover:opacity-60 transition-opacity",
                                                                            children: "t\xe4vlingsvillkoren"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                            className: "flex items-start gap-3 text-sm",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                                                    type: "checkbox",
                                                                    id: "age-checkbox",
                                                                    "aria-label": "Jag intygar att jag \xe4r 21 \xe5r eller \xe4ldre",
                                                                    checked: ageConfirmed,
                                                                    onChange: ()=>setAgeConfirmed((v)=>!v),
                                                                    className: "size-4 accent-dark-blue shrink-0 cursor-pointer !mt-[3px]"
                                                                }),
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                                                    htmlFor: "age-checkbox",
                                                                    className: "",
                                                                    children: "Jag intygar att jag \xe4r 21 \xe5r eller \xe4ldre"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                            className: "text-xs text-dark-blue/60 font-bold",
                                                            children: "T\xe4nk p\xe5 att du endast kan skicka in ett bidrag."
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                                            className: "text-xs text-dark-blue/60 border-t border-dark-blue/15 pt-3",
                                                            children: [
                                                                "Kia Sweden AB behandlar de personuppgifter du l\xe4mnar f\xf6r att administrera t\xe4vlingen, hantera ditt t\xe4vlingsbidrag och kontakta vinnare. Om du vinner kan dina uppgifter och ditt t\xe4vlingsbidrag delas med ber\xf6rd Kia \xe5terf\xf6rs\xe4ljare f\xf6r att hantera vinsten, utl\xe4mning av l\xe5nebil och eventuellt bill\xe5neavtal. Mer information om hur Kia behandlar personuppgifter finns i",
                                                                ' ',
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                                                    rel: "noopener",
                                                                    href: "https://www.kia.com/se/integritetspolicy/",
                                                                    target: "_blank",
                                                                    children: "Kias integritetspolicy."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)(form.Subscribe, {
                                                            selector: (state)=>state.isSubmitting,
                                                            children: (isSubmitting)=>/*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                                                    type: "submit",
                                                                    disabled: !termsAccepted || !ageConfirmed || isSubmitting,
                                                                    className: [
                                                                        'w-full px-2 py-3 flex items-center justify-center text-white transition-opacity',
                                                                        termsAccepted && ageConfirmed && !isSubmitting ? 'bg-black hover:underline underline-offset-2' : 'bg-black opacity-30 cursor-not-allowed'
                                                                    ].join(' '),
                                                                    children: isSubmitting ? /*#__PURE__*/ (0, $2PPWI.jsxs)("svg", {
                                                                        className: "animate-spin h-5 w-5",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        fill: "none",
                                                                        viewBox: "0 0 24 24",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $2PPWI.jsx)("circle", {
                                                                                className: "opacity-25",
                                                                                cx: "12",
                                                                                cy: "12",
                                                                                r: "10",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "4"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                                                                                className: "opacity-75",
                                                                                fill: "currentColor",
                                                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                                                            })
                                                                        ]
                                                                    }) : "T\xe4vla!"
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                            className: "flex flex-col",
                                                            children: [
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)(form.Subscribe, {
                                                                    selector: (state)=>state.submissionAttempts > 0 && Object.values(state.fieldMeta).some((m)=>m.errors.length > 0),
                                                                    children: (hasErrors)=>hasErrors && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                                            className: "text-sm text-red-500 font-medium text-center",
                                                                            children: "R\xe4tta till felen i formul\xe4ret"
                                                                        })
                                                                }),
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)(form.Subscribe, {
                                                                    selector: (state)=>state.errorMap.onServer,
                                                                    children: (serverError)=>serverError && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                                            className: "text-sm text-red-500 font-medium text-center",
                                                                            children: serverError
                                                                        })
                                                                }),
                                                                /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                                                    className: "text-xs font-bold text-dark-blue/70 leading-relaxed text-center",
                                                                    children: "Det h\xe4r formul\xe4ret skyddas av reCAPTCHA."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, i);
                    })
                })
            })
        ]
    });
}
var $b8ea7ba1ba30bb30$export$2e2bcd8739ae039 = $b8ea7ba1ba30bb30$var$WowForm;

});
parcelRegister("evXNI", function(module, exports) {

$parcel$export(module.exports, "ApiError", function () { return $fb4fb1654e91e934$export$f2e832acab1bdd79; });
$parcel$export(module.exports, "useResellers", function () { return $fb4fb1654e91e934$export$63adae3517a4eea0; });
$parcel$export(module.exports, "useContribution", function () { return $fb4fb1654e91e934$export$58d6780e01e69008; });

var $4y3RP = parcelRequire("4y3RP");
var $hgSaH = parcelRequire("hgSaH");
const $fb4fb1654e91e934$var$BASE_URL = "https://tiktok.afonso.se/api";
if (!$fb4fb1654e91e934$var$BASE_URL) throw new Error('Missing required env var: KIA_WOW_API');
class $fb4fb1654e91e934$export$f2e832acab1bdd79 extends Error {
    data;
    status;
    constructor(data, status){
        super(data?.message ?? 'Request failed'), this.data = data, this.status = status;
    }
}
function $fb4fb1654e91e934$var$toReseller(r) {
    const lat = Number(r.lat);
    const lon = Number(r.lon);
    if (!r.lat || !r.lon || isNaN(lat) || isNaN(lon)) return null;
    return {
        id: r.id,
        name: r.name,
        lat: lat,
        lon: lon
    };
}
function $fb4fb1654e91e934$export$63adae3517a4eea0() {
    return (0, $hgSaH.useQuery)({
        queryKey: [
            'resellers'
        ],
        queryFn: async ()=>{
            const response = await fetch(`${$fb4fb1654e91e934$var$BASE_URL}/resellers`);
            const data = await response.json();
            const resellers = data.map($fb4fb1654e91e934$var$toReseller).filter((r)=>r !== null);
            var r;
            return resellers.filter((r)=>r.id !== 97);
        }
    });
}
function $fb4fb1654e91e934$export$58d6780e01e69008() {
    return (0, $4y3RP.useMutation)({
        mutationFn: async (body)=>{
            const formData = new FormData();
            for (const [key, value] of Object.entries(body))if (value !== undefined && value !== null) formData.append(key, value);
            const response = await fetch(`${$fb4fb1654e91e934$var$BASE_URL}/contribution`, {
                method: 'POST',
                body: formData,
                headers: {
                    Accept: 'application/json'
                }
            });
            const data = await response.json().catch(()=>null);
            if (!response.ok) throw new $fb4fb1654e91e934$export$f2e832acab1bdd79(data, response.status);
            return data;
        }
    });
}

});
parcelRegister("4y3RP", function(module, exports) {

$parcel$export(module.exports, "useMutation", function () { return $34fd5655c8c6cea4$export$609860bf8b0084c; });

var $1a3a2 = parcelRequire("1a3a2");

var $8FY87 = parcelRequire("8FY87");

var $1MDmD = parcelRequire("1MDmD");
var $6L2cD = parcelRequire("6L2cD");
var $hPIOx = parcelRequire("hPIOx");
"use client";
//#region src/useMutation.ts
function $34fd5655c8c6cea4$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $1a3a2.useQueryClient)(queryClient);
    const [observer] = $8FY87.useState(()=>new (0, $1MDmD.MutationObserver)(client, options));
    $8FY87.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $8FY87.useSyncExternalStore($8FY87.useCallback((onStoreChange)=>observer.subscribe((0, $hPIOx.notifyManager).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $8FY87.useCallback((...args)=>{
        observer.mutate(args[0], args[1]).catch((0, $6L2cD.noop));
    }, [
        observer
    ]);
    if (result.error && (0, $6L2cD.shouldThrowError)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}

});
parcelRegister("1MDmD", function(module, exports) {

$parcel$export(module.exports, "MutationObserver", function () { return $14c8cf0c195c279c$export$d3c1860ee66f291a; });

var $3szIe = parcelRequire("3szIe");

var $6L2cD = parcelRequire("6L2cD");

var $3G2zK = parcelRequire("3G2zK");

var $hPIOx = parcelRequire("hPIOx");

var $78xtY = parcelRequire("78xtY");

var $cDQLR = parcelRequire("cDQLR");
//#region src/mutationObserver.ts
var $14c8cf0c195c279c$var$_client = /* @__PURE__ */ new WeakMap();
var $14c8cf0c195c279c$var$_currentResult = /* @__PURE__ */ new WeakMap();
var $14c8cf0c195c279c$var$_currentMutation = /* @__PURE__ */ new WeakMap();
var $14c8cf0c195c279c$var$_mutateOptions = /* @__PURE__ */ new WeakMap();
var $14c8cf0c195c279c$var$_MutationObserver_brand = /* @__PURE__ */ new WeakSet();
var $14c8cf0c195c279c$export$d3c1860ee66f291a = class extends (0, $3G2zK.Subscribable) {
    constructor(client, options){
        super();
        (0, $78xtY.t)(this, $14c8cf0c195c279c$var$_MutationObserver_brand);
        (0, $3szIe.i)(this, $14c8cf0c195c279c$var$_client, void 0);
        (0, $3szIe.i)(this, $14c8cf0c195c279c$var$_currentResult, void 0);
        (0, $3szIe.i)(this, $14c8cf0c195c279c$var$_currentMutation, void 0);
        (0, $3szIe.i)(this, $14c8cf0c195c279c$var$_mutateOptions, void 0);
        (0, $3szIe.t)($14c8cf0c195c279c$var$_client, this, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $3szIe.r)($14c8cf0c195c279c$var$_MutationObserver_brand, this, $14c8cf0c195c279c$var$_updateResult).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _classPrivateFieldGet2$1;
        const prevOptions = this.options;
        this.options = (0, $3szIe.n)($14c8cf0c195c279c$var$_client, this).defaultMutationOptions(options);
        if (!(0, $6L2cD.shallowEqualObjects)(this.options, prevOptions)) (0, $3szIe.n)($14c8cf0c195c279c$var$_client, this).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $3szIe.n)($14c8cf0c195c279c$var$_currentMutation, this),
            observer: this
        });
        if ((prevOptions === null || prevOptions === void 0 ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $6L2cD.hashKey)(prevOptions.mutationKey) !== (0, $6L2cD.hashKey)(this.options.mutationKey)) this.reset();
        else if (((_classPrivateFieldGet2$1 = (0, $3szIe.n)($14c8cf0c195c279c$var$_currentMutation, this)) === null || _classPrivateFieldGet2$1 === void 0 ? void 0 : _classPrivateFieldGet2$1.state.status) === "pending") (0, $3szIe.n)($14c8cf0c195c279c$var$_currentMutation, this).setOptions(this.options);
    }
    onSubscribe() {
        if (this.listeners.size === 1 && (0, $3szIe.n)($14c8cf0c195c279c$var$_currentMutation, this)) {
            (0, $3szIe.n)($14c8cf0c195c279c$var$_currentMutation, this).addObserver(this);
            (0, $3szIe.r)($14c8cf0c195c279c$var$_MutationObserver_brand, this, $14c8cf0c195c279c$var$_updateResult).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _classPrivateFieldGet3;
            (_classPrivateFieldGet3 = (0, $3szIe.n)($14c8cf0c195c279c$var$_currentMutation, this)) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.removeObserver(this);
        }
    }
    onMutationUpdate(action) {
        (0, $3szIe.r)($14c8cf0c195c279c$var$_MutationObserver_brand, this, $14c8cf0c195c279c$var$_updateResult).call(this);
        (0, $3szIe.r)($14c8cf0c195c279c$var$_MutationObserver_brand, this, $14c8cf0c195c279c$var$_notify).call(this, action);
    }
    getCurrentResult() {
        return (0, $3szIe.n)($14c8cf0c195c279c$var$_currentResult, this);
    }
    reset() {
        var _classPrivateFieldGet4;
        (_classPrivateFieldGet4 = (0, $3szIe.n)($14c8cf0c195c279c$var$_currentMutation, this)) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4.removeObserver(this);
        (0, $3szIe.t)($14c8cf0c195c279c$var$_currentMutation, this, void 0);
        (0, $3szIe.r)($14c8cf0c195c279c$var$_MutationObserver_brand, this, $14c8cf0c195c279c$var$_updateResult).call(this);
        (0, $3szIe.r)($14c8cf0c195c279c$var$_MutationObserver_brand, this, $14c8cf0c195c279c$var$_notify).call(this);
    }
    mutate(variables, options) {
        var _classPrivateFieldGet5;
        (0, $3szIe.t)($14c8cf0c195c279c$var$_mutateOptions, this, options);
        (_classPrivateFieldGet5 = (0, $3szIe.n)($14c8cf0c195c279c$var$_currentMutation, this)) === null || _classPrivateFieldGet5 === void 0 || _classPrivateFieldGet5.removeObserver(this);
        (0, $3szIe.t)($14c8cf0c195c279c$var$_currentMutation, this, (0, $3szIe.n)($14c8cf0c195c279c$var$_client, this).getMutationCache().build((0, $3szIe.n)($14c8cf0c195c279c$var$_client, this), this.options));
        (0, $3szIe.n)($14c8cf0c195c279c$var$_currentMutation, this).addObserver(this);
        return (0, $3szIe.n)($14c8cf0c195c279c$var$_currentMutation, this).execute(variables);
    }
};
function $14c8cf0c195c279c$var$_updateResult() {
    var _classPrivateFieldGet6;
    const state = ((_classPrivateFieldGet6 = (0, $3szIe.n)($14c8cf0c195c279c$var$_currentMutation, this)) === null || _classPrivateFieldGet6 === void 0 ? void 0 : _classPrivateFieldGet6.state) ?? (0, $cDQLR.getDefaultState)();
    (0, $3szIe.t)($14c8cf0c195c279c$var$_currentResult, this, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
}
function $14c8cf0c195c279c$var$_notify(action) {
    (0, $hPIOx.notifyManager).batch(()=>{
        if ((0, $3szIe.n)($14c8cf0c195c279c$var$_mutateOptions, this) && this.hasListeners()) {
            const variables = (0, $3szIe.n)($14c8cf0c195c279c$var$_currentResult, this).variables;
            const onMutateResult = (0, $3szIe.n)($14c8cf0c195c279c$var$_currentResult, this).context;
            const context = {
                client: (0, $3szIe.n)($14c8cf0c195c279c$var$_client, this),
                meta: this.options.meta,
                mutationKey: this.options.mutationKey
            };
            if ((action === null || action === void 0 ? void 0 : action.type) === "success") {
                try {
                    var _classPrivateFieldGet7, _classPrivateFieldGet8;
                    (_classPrivateFieldGet7 = (_classPrivateFieldGet8 = (0, $3szIe.n)($14c8cf0c195c279c$var$_mutateOptions, this)).onSuccess) === null || _classPrivateFieldGet7 === void 0 || _classPrivateFieldGet7.call(_classPrivateFieldGet8, action.data, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
                try {
                    var _classPrivateFieldGet9, _classPrivateFieldGet10;
                    (_classPrivateFieldGet9 = (_classPrivateFieldGet10 = (0, $3szIe.n)($14c8cf0c195c279c$var$_mutateOptions, this)).onSettled) === null || _classPrivateFieldGet9 === void 0 || _classPrivateFieldGet9.call(_classPrivateFieldGet10, action.data, null, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
            } else if ((action === null || action === void 0 ? void 0 : action.type) === "error") {
                try {
                    var _classPrivateFieldGet11, _classPrivateFieldGet12;
                    (_classPrivateFieldGet11 = (_classPrivateFieldGet12 = (0, $3szIe.n)($14c8cf0c195c279c$var$_mutateOptions, this)).onError) === null || _classPrivateFieldGet11 === void 0 || _classPrivateFieldGet11.call(_classPrivateFieldGet12, action.error, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
                try {
                    var _classPrivateFieldGet13, _classPrivateFieldGet14;
                    (_classPrivateFieldGet13 = (_classPrivateFieldGet14 = (0, $3szIe.n)($14c8cf0c195c279c$var$_mutateOptions, this)).onSettled) === null || _classPrivateFieldGet13 === void 0 || _classPrivateFieldGet13.call(_classPrivateFieldGet14, void 0, action.error, variables, onMutateResult, context);
                } catch (e) {
                    Promise.reject(e);
                }
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $3szIe.n)($14c8cf0c195c279c$var$_currentResult, this));
        });
    });
}

});



parcelRegister("44QXF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dde1f20752a3e98$export$2e2bcd8739ae039; });
function $5dde1f20752a3e98$var$GoogleRecaptcha() {
    const recaptcha = window.grecaptcha;
    if (recaptcha) return Promise.resolve(recaptcha);
    return new Promise((resolve, reject)=>{
        const existing = document.querySelector('script[src*="recaptcha/enterprise.js"]');
        if (existing) {
            existing.addEventListener('load', ()=>{
                resolve(window.grecaptcha);
            });
            return;
        }
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${"6LcJBCAtAAAAAKUiTTGiCZxWVLEsOliHPjrMMwnb"}&hl=sv`;
        script.async = true;
        script.defer = true;
        script.onload = ()=>resolve(window.grecaptcha);
        script.onerror = reject;
        document.body.appendChild(script);
    });
}
var $5dde1f20752a3e98$export$2e2bcd8739ae039 = $5dde1f20752a3e98$var$GoogleRecaptcha;

});

parcelRegister("kj7mx", function(module, exports) {

$parcel$export(module.exports, "ImageDropField", function () { return $39a9001bdef65dde$export$3019c26e674dcdde; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $c0oib = parcelRequire("c0oib");

var $i8UXi = parcelRequire("i8UXi");
function $39a9001bdef65dde$export$3019c26e674dcdde({ name: name, value: value, errors: errors, onBlur: onBlur, onChange: onChange }) {
    const fileInputRef = (0, $8FY87.useRef)(null);
    const [isDragging, setIsDragging] = (0, $8FY87.useState)(false);
    const hasError = errors.length > 0;
    const previewUrl = (0, $8FY87.useMemo)(()=>value ? URL.createObjectURL(value) : null, [
        value
    ]);
    const handleFiles = (files)=>{
        const file = files?.[0];
        if (file) onChange(file);
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                htmlFor: "image",
                className: (0, $i8UXi.labelClass),
                children: "Sticker"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "relative group",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        role: "button",
                        tabIndex: 0,
                        "aria-label": "Ladda upp bild",
                        onClick: ()=>fileInputRef.current?.click(),
                        onKeyDown: (e)=>(e.key === 'Enter' || e.key === ' ') && fileInputRef.current?.click(),
                        onDragEnter: (e)=>{
                            e.preventDefault();
                            setIsDragging(true);
                        },
                        onDragOver: (e)=>e.preventDefault(),
                        onDragLeave: ()=>setIsDragging(false),
                        onDrop: (e)=>{
                            e.preventDefault();
                            setIsDragging(false);
                            handleFiles(e.dataTransfer.files);
                        },
                        onBlur: onBlur,
                        className: [
                            'w-full rounded border-2 transition-colors cursor-pointer select-none overflow-hidden',
                            previewUrl ? 'border-kia-gray' : 'border-dashed px-4 py-8 text-center text-sm',
                            !previewUrl && (isDragging ? 'border-black bg-gray-50' : hasError ? 'border-red-400' : 'border-kia-gray hover:border-black')
                        ].join(' '),
                        children: previewUrl ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                                    src: previewUrl,
                                    alt: value?.name,
                                    className: "w-full max-h-64 object-contain block"
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                    className: "absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center rounded",
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                        className: "text-white text-sm font-medium",
                                        children: "Byt bild"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                    className: "font-medium",
                                    children: "Ladda upp din Sticker h\xe4r"
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                    className: "text-gray-500",
                                    children: " eller dra och sl\xe4pp h\xe4r"
                                })
                            ]
                        })
                    }),
                    previewUrl && /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            onChange(undefined);
                            if (fileInputRef.current) fileInputRef.current.value = '';
                        },
                        className: "absolute top-2 right-2 bg-white/90 rounded-full w-7 h-7 flex items-center justify-center text-sm leading-none hover:bg-white transition-colors",
                        "aria-label": "Ta bort bild",
                        children: "\xd7"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                ref: fileInputRef,
                className: "sr-only",
                type: "file",
                accept: "image/png,image/jpeg,image/bmp,image/gif,image/webp",
                id: name,
                tabIndex: -1,
                onChange: (e)=>handleFiles(e.target.files)
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c0oib.FieldError), {
                errors: errors
            })
        ]
    });
}

});
parcelRegister("i8UXi", function(module, exports) {

$parcel$export(module.exports, "schema", function () { return $a3312fd633320338$export$4902baddc787debb; });
$parcel$export(module.exports, "defaultValues", function () { return $a3312fd633320338$export$7e292eecf5a8f340; });
$parcel$export(module.exports, "inputClass", function () { return $a3312fd633320338$export$158fa1419c8cd1fd; });
$parcel$export(module.exports, "inputErrorClass", function () { return $a3312fd633320338$export$adf9644b93cc9e95; });
$parcel$export(module.exports, "labelClass", function () { return $a3312fd633320338$export$17871272d8196fd; });
$parcel$export(module.exports, "haversineKm", function () { return $a3312fd633320338$export$b02ecacb27f1cda8; });

var $elAir = parcelRequire("elAir");
const $a3312fd633320338$export$4902baddc787debb = (0, $elAir.object)({
    reseller_id: (0, $elAir.number)().min(1, "Du m\xe5ste v\xe4lja en \xe5terf\xf6rs\xe4ljare"),
    first_name: (0, $elAir.string)().min(1, "Du m\xe5ste fylla i ditt f\xf6rnamn"),
    last_name: (0, $elAir.string)().min(1, "Du m\xe5ste fylla i ditt efternamn"),
    phone: (0, $elAir.string)().min(1, "Du m\xe5ste fylla i ditt mobiltelefonnummer").refine((val)=>/^07\d{8}$/.test(val.replace(/[\s\-]/g, '')), 'Ange ett giltigt mobilnummer (t.ex. 070 123 45 67)'),
    address: (0, $elAir.string)().min(1, "Du m\xe5ste fylla i din gatuadress"),
    city: (0, $elAir.string)().min(1, "Du m\xe5ste fylla i din postort"),
    zip: (0, $elAir.string)().regex(/^\d{3}\s?\d{2}$/, 'Ange ett giltigt postnummer'),
    email: (0, $elAir.email)('Ange en giltig e-postadress'),
    image: (0, $elAir.file)({
        error: "Du m\xe5ste ladda upp en bild"
    }).max(5242880, "Bilden f\xe5r inte vara st\xf6rre \xe4n 5 MB").mime([
        'image/png',
        'image/jpeg',
        'image/bmp',
        'image/gif',
        'image/webp'
    ], "Filformatet st\xf6ds inte. V\xe4lj en PNG, JPEG, BMP, GIF eller WebP-bild")
});
const $a3312fd633320338$export$7e292eecf5a8f340 = {
    reseller_id: 0,
    first_name: '',
    last_name: '',
    phone: '',
    address: '',
    zip: '',
    city: '',
    email: '',
    image: undefined
};
const $a3312fd633320338$export$158fa1419c8cd1fd = 'w-full h-[50px] border border-kia-gray rounded px-4 py-3 text-base focus:outline-none focus:border-black focus:ring-1 focus:ring-black transition-colors';
const $a3312fd633320338$export$adf9644b93cc9e95 = 'w-full h-[50px] border border-red-400 rounded px-4 py-3 text-base focus:outline-none focus:border-red-600 transition-colors';
const $a3312fd633320338$export$17871272d8196fd = 'block text-sm font-medium mb-1';
function $a3312fd633320338$export$b02ecacb27f1cda8(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

});


parcelRegister("3IOIe", function(module, exports) {

$parcel$export(module.exports, "StepNumber", function () { return $e4cce63a635710e5$export$8400747e4d4d02ee; });

var $2PPWI = parcelRequire("2PPWI");
function $e4cce63a635710e5$export$8400747e4d4d02ee({ n: n, rotate: rotate }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: "relative flex justify-center pt-1 gap-4 row-span-2",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
            className: "font-bold select-none block text-dark-blue",
            style: {
                fontSize: 'clamp(3.5rem, 8vw, 7rem)',
                lineHeight: '0.85',
                transform: `rotate(${rotate})`
            },
            children: n
        })
    });
}

});

parcelRegister("ffhAG", function(module, exports) {

$parcel$export(module.exports, "ResellerField", function () { return $83515c500f33531f$export$8f4f0c223a7acf1d; });

var $2PPWI = parcelRequire("2PPWI");

var $jAgEx = parcelRequire("jAgEx");
var $huzw8 = parcelRequire("huzw8");
var $4NoTr = parcelRequire("4NoTr");
var $4Qpe2 = parcelRequire("4Qpe2");

var $c0oib = parcelRequire("c0oib");

var $lcXJq = parcelRequire("lcXJq");
function $83515c500f33531f$export$8f4f0c223a7acf1d({ selectionMode: selectionMode, selectedReseller: selectedReseller, mapOpen: mapOpen, errors: errors, resellersAvailable: resellersAvailable, onGeolocate: onGeolocate, onOpenMap: onOpenMap, onSelectReseller: onSelectReseller }) {
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "grid",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                className: "block text-sm font-medium mb-1",
                children: "Kia-\xe5terf\xf6rs\xe4ljare"
            }),
            selectionMode === 'idle' && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "grid gap-2",
                children: resellersAvailable ? /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                    type: "button",
                    onClick: onGeolocate,
                    className: "w-full px-4 py-3 flex items-center justify-center gap-2 border border-black text-black text-sm font-medium hover:bg-black hover:text-white transition-colors",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            "aria-hidden": "true",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                                    d: "M12 2a7 7 0 0 1 7 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 0 1 7-7z"
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("circle", {
                                    cx: "12",
                                    cy: "9",
                                    r: "2.5"
                                })
                            ]
                        }),
                        "Hitta min n\xe4rmsta Kia-\xe5terf\xf6rs\xe4ljare"
                    ]
                }) : /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                    className: "text-sm text-dark-blue/60 px-4 py-3 border border-dark-blue/20 text-center",
                    children: "Kia-\xe5terf\xf6rs\xe4ljare \xe4r inte tillg\xe4ngliga just nu. F\xf6rs\xf6k igen senare."
                })
            }),
            selectionMode === 'locating' && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "flex items-center gap-2 text-sm text-darkborder-dark-blue/70 px-4 py-3",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        className: "animate-spin inline-block",
                        children: "\u21BB"
                    }),
                    "S\xf6ker din plats\u2026"
                ]
            }),
            selectionMode === 'located' && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "grid gap-2",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4NoTr.LazyMotion), {
                        features: (0, $huzw8.domAnimation),
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jAgEx.AnimatePresence), {
                            children: mapOpen && /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
                                initial: {
                                    height: 0,
                                    opacity: 0
                                },
                                animate: {
                                    height: 'auto',
                                    opacity: 1
                                },
                                exit: {
                                    height: 0,
                                    opacity: 0
                                },
                                transition: {
                                    duration: 0.3,
                                    ease: 'easeInOut'
                                },
                                className: "overflow-hidden",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: "text-sm text-darkborder-dark-blue/70 mb-2",
                                        children: "V\xe4lj en annan \xe5terf\xf6rs\xe4ljare p\xe5 kartan."
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "h-[60vh] rounded overflow-hidden",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $lcXJq.default), {
                                            onSelectReseller: onSelectReseller
                                        })
                                    })
                                ]
                            }, "map")
                        })
                    }),
                    !mapOpen && selectedReseller && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "flex items-center justify-between border border-dark-blue rounded px-4 py-3",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                className: "text-sm font-medium flex items-center gap-2",
                                children: selectedReseller.name
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                type: "button",
                                onClick: onOpenMap,
                                className: "text-xs text-darkborder-dark-blue/60 underline hover:text-darkborder-dark-blue",
                                children: "\xc4ndra"
                            })
                        ]
                    })
                ]
            }),
            (selectionMode === 'denied' || selectionMode === 'error') && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "grid gap-2",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4NoTr.LazyMotion), {
                        features: (0, $huzw8.domAnimation),
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $jAgEx.AnimatePresence), {
                            children: mapOpen && /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4Qpe2.m).div, {
                                initial: {
                                    height: 0,
                                    opacity: 0
                                },
                                animate: {
                                    height: 'auto',
                                    opacity: 1
                                },
                                exit: {
                                    height: 0,
                                    opacity: 0
                                },
                                transition: {
                                    duration: 0.3,
                                    ease: 'easeInOut'
                                },
                                className: "overflow-hidden",
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                        className: "text-sm text-darkborder-dark-blue/70 mb-2",
                                        children: selectionMode === 'denied' ? "Du har blockerat plats\xe5tkomst. V\xe4lj en \xe5terf\xf6rs\xe4ljare p\xe5 kartan." : "Kunde inte h\xe4mta din plats. V\xe4lj en \xe5terf\xf6rs\xe4ljare p\xe5 kartan."
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: "h-[60vh] rounded overflow-hidden",
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $lcXJq.default), {
                                            onSelectReseller: onSelectReseller
                                        })
                                    })
                                ]
                            }, "map")
                        })
                    }),
                    !mapOpen && selectedReseller && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "flex items-center justify-between border border-dark-blue rounded px-4 py-3",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                className: "text-sm font-medium flex items-center gap-2",
                                children: selectedReseller.name
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                type: "button",
                                onClick: onOpenMap,
                                className: "text-xs text-darkborder-dark-blue/60 underline hover:text-darkborder-dark-blue",
                                children: "\xc4ndra"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                className: "text-xs text-dark-blue/60 font-bold mt-2",
                children: "H\xe4r kommer du h\xe4mta din Kia EV2 (l\xe5nebil) ifall du vinner. T\xe4nk p\xe5 att v\xe4lja en \xe5terf\xf6rs\xe4ljare n\xe4ra dig."
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c0oib.FieldError), {
                errors: errors
            })
        ]
    });
}

});
parcelRegister("lcXJq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58f09b5b09e27d04$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $evXNI = parcelRequire("evXNI");

var $9OEJT = parcelRequire("9OEJT");

var $8FY87 = parcelRequire("8FY87");
const $58f09b5b09e27d04$var$API_KEY = "AIzaSyA41IhZ_5jWUpMl9WaOfCo_PrP8KFRHejE";
const $58f09b5b09e27d04$var$SWEDEN_CENTER = {
    lat: 62.5,
    lng: 16.5
};
function $58f09b5b09e27d04$var$ResellerMarker({ reseller: reseller, open: open, onOpen: onOpen, onConfirm: onConfirm }) {
    const [markerRef, marker] = (0, $9OEJT.useAdvancedMarkerRef)();
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9OEJT.AdvancedMarker), {
                ref: markerRef,
                position: {
                    lat: reseller.lat,
                    lng: reseller.lon
                },
                title: reseller.name,
                onClick: ()=>onOpen(open ? null : reseller.id),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9OEJT.Pin), {
                    background: open ? '#05141f' : 'black',
                    borderColor: "#05141f",
                    glyphColor: "#ffffff"
                })
            }),
            open && marker && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9OEJT.InfoWindow), {
                anchor: marker,
                onClose: ()=>onOpen(null),
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "flex flex-col gap-2 min-w-[160px] overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            className: "font-medium text-sm text-[#05141f]",
                            children: reseller.name
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                            type: "button",
                            onClick: ()=>onConfirm(reseller),
                            className: "w-full px-3 py-1.5 bg-[#05141f] text-white text-xs font-medium hover:bg-black transition-colors",
                            children: "V\xe4lj \xe5terf\xf6rs\xe4ljare"
                        })
                    ]
                })
            })
        ]
    });
}
function $58f09b5b09e27d04$var$GoogleMap({ onSelectReseller: onSelectReseller }) {
    const { data: data, isLoading: isLoading } = (0, $evXNI.useResellers)();
    const [selectedId, setSelectedId] = (0, $8FY87.useState)(null);
    if (isLoading) return null;
    const resellers = (data ?? []).filter((d)=>d.lat != null && d.lon != null);
    const handleConfirm = (reseller)=>{
        setSelectedId(reseller.id);
        onSelectReseller?.(reseller);
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9OEJT.APIProvider), {
        apiKey: $58f09b5b09e27d04$var$API_KEY,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9OEJT.Map), {
            className: "w-full h-full",
            defaultCenter: $58f09b5b09e27d04$var$SWEDEN_CENTER,
            defaultZoom: 5,
            gestureHandling: "greedy",
            disableDefaultUI: true,
            mapId: "kia-resellers",
            children: resellers.map((reseller)=>/*#__PURE__*/ (0, $2PPWI.jsx)($58f09b5b09e27d04$var$ResellerMarker, {
                    reseller: reseller,
                    open: reseller.id === selectedId,
                    onOpen: setSelectedId,
                    onConfirm: handleConfirm
                }, reseller.id))
        })
    });
}
var $58f09b5b09e27d04$export$2e2bcd8739ae039 = $58f09b5b09e27d04$var$GoogleMap;

});
parcelRegister("9OEJT", function(module, exports) {

$parcel$export(module.exports, "APIProvider", function () { return $9f88fd1702060c93$export$434374b2a40d237; });
$parcel$export(module.exports, "Map", function () { return $9f88fd1702060c93$export$a5c7b93649eaf8f8; });
$parcel$export(module.exports, "AdvancedMarker", function () { return $9f88fd1702060c93$export$5dd2dc1fc7030ab5; });
$parcel$export(module.exports, "useAdvancedMarkerRef", function () { return $9f88fd1702060c93$export$ee72183bc46d9ec2; });
$parcel$export(module.exports, "InfoWindow", function () { return $9f88fd1702060c93$export$6cfec3928ae8881a; });
$parcel$export(module.exports, "Pin", function () { return $9f88fd1702060c93$export$656559010049c8e; });

var $8FY87 = parcelRequire("8FY87");

var $95gxM = parcelRequire("95gxM");
// This file is automatically updated by the build process.
const $9f88fd1702060c93$export$a4ad2735b021c132 = '1.9.0';
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $9f88fd1702060c93$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $9f88fd1702060c93$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
const $9f88fd1702060c93$var$MSG_REPEATED_SET_OPTIONS = (options)=>`The setOptions() function should only be called once. The options passed ` + `to the additional call (${JSON.stringify(options)}) will be ignored.`;
const $9f88fd1702060c93$var$MSG_IMPORT_LIBRARY_EXISTS = (options)=>`The google.maps.importLibrary() function is already defined, and ` + `@googlemaps/js-api-loader will use the existing function instead of ` + `overwriting it. The options passed to setOptions ` + `(${JSON.stringify(options)}) will be ignored.`;
const $9f88fd1702060c93$var$MSG_SET_OPTIONS_NOT_CALLED = "No options were set before calling importLibrary. Make sure to configure the loader using setOptions().";
const $9f88fd1702060c93$var$MSG_SCRIPT_ELEMENT_EXISTS = "There already is a script loading the Google Maps JavaScript API, and no google.maps.importLibrary function is defined. @googlemaps/js-api-loader will proceed to bootstrap the API with the specified options, but the existing script might cause problems using the API. Make sure to remove the script loading the API.";
const $9f88fd1702060c93$var$MSG_API_KEY_USED = "The 'apiKey' parameter was used in setOptions(), but 'key' is the correct parameter name. Please update your configuration.";
const $9f88fd1702060c93$var$MSG_TRUSTED_TYPES_POLICY_FAILED = (policyName, error)=>`Failed to create Trusted Types policy "${policyName}": ${error instanceof Error ? error.message : String(error)}.\n\n` + `If your Content Security Policy uses "require-trusted-types-for 'script'", ` + `allow this policy with "trusted-types ${policyName} google-maps-api-loader google-maps-api#html lit-html". ` + `The "google-maps-api-loader", "lit-html", and "google-maps-api#html" policies are required for full Maps JavaScript API execution. ` + `Falling back to a string script URL.`;
const $9f88fd1702060c93$var$__DEV__$1 = false;
const $9f88fd1702060c93$var$logDevWarning = $9f88fd1702060c93$var$__DEV__$1 ? (message)=>{
    console.warn(`[@googlemaps/js-api-loader] ${message}`);
} : ()=>{};
const $9f88fd1702060c93$var$logDevNotice = $9f88fd1702060c93$var$__DEV__$1 ? (message)=>{
    console.info(`[@googlemaps/js-api-loader] ${message}`);
} : ()=>{};
/*
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $9f88fd1702060c93$var$TRUSTED_TYPES_POLICY_NAME = "@googlemaps/js-api-loader";
const $9f88fd1702060c93$var$fallbackPolicy = {
    createScriptURL: (url)=>url
};
let $9f88fd1702060c93$var$policy;
/*
 * Tries to create a Trusted Types policy when supported. Falls back to a string passthrough
 * when Trusted Types is unsupported, blocked by CSP, or already registered.
 */ function $9f88fd1702060c93$var$getPolicy() {
    if ($9f88fd1702060c93$var$policy) return $9f88fd1702060c93$var$policy;
    const trustedTypes = globalThis.trustedTypes;
    if (!trustedTypes) {
        $9f88fd1702060c93$var$policy = $9f88fd1702060c93$var$fallbackPolicy;
        return $9f88fd1702060c93$var$policy;
    }
    try {
        $9f88fd1702060c93$var$policy = trustedTypes.createPolicy($9f88fd1702060c93$var$TRUSTED_TYPES_POLICY_NAME, {
            createScriptURL: (url)=>url
        });
    } catch (e) {
        $9f88fd1702060c93$var$logDevWarning($9f88fd1702060c93$var$MSG_TRUSTED_TYPES_POLICY_FAILED($9f88fd1702060c93$var$TRUSTED_TYPES_POLICY_NAME, e));
        $9f88fd1702060c93$var$policy = $9f88fd1702060c93$var$fallbackPolicy;
    }
    return $9f88fd1702060c93$var$policy;
}
function $9f88fd1702060c93$var$setScriptSrc(script, src) {
    script.src = $9f88fd1702060c93$var$getPolicy().createScriptURL(src);
}
/*
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $9f88fd1702060c93$var$bootstrap = (bootstrapParams)=>{
    var bootstrapPromise;
    var script;
    var bootstrapParamsKey;
    var PRODUCT_NAME = "The Google Maps JavaScript API";
    var GOOGLE = "google";
    var IMPORT_API_NAME = "importLibrary";
    var PENDING_BOOTSTRAP_KEY = "__ib__";
    var doc = document;
    var global_ = window;
    var google_ = global_[GOOGLE] || (global_[GOOGLE] = {});
    var namespace = google_.maps || (google_.maps = {});
    var libraries = new Set();
    var searchParams = new URLSearchParams();
    var triggerBootstrap = ()=>bootstrapPromise || (bootstrapPromise = new Promise(async (resolve, reject)=>{
            await (script = doc.createElement("script"));
            searchParams.set("libraries", [
                ...libraries
            ] + "");
            for(bootstrapParamsKey in bootstrapParams)searchParams.set(bootstrapParamsKey.replace(/[A-Z]/g, (g)=>"_" + g[0].toLowerCase()), bootstrapParams[bootstrapParamsKey]);
            searchParams.set("callback", GOOGLE + ".maps." + PENDING_BOOTSTRAP_KEY);
            $9f88fd1702060c93$var$setScriptSrc(script, "https://maps.googleapis.com/maps/api/js?" + searchParams);
            namespace[PENDING_BOOTSTRAP_KEY] = resolve;
            script.onerror = ()=>bootstrapPromise = reject(Error(PRODUCT_NAME + " could not load."));
            script.nonce = doc.querySelector("script[nonce]")?.nonce || "";
            doc.head.append(script);
        }));
    namespace[IMPORT_API_NAME] ? console.warn(PRODUCT_NAME + " only loads once. Ignoring:", bootstrapParams) : namespace[IMPORT_API_NAME] = (libraryName, ...args)=>libraries.add(libraryName) && triggerBootstrap().then(()=>namespace[IMPORT_API_NAME](libraryName, ...args));
};
/*
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9f88fd1702060c93$var$__DEV__ = false;
let $9f88fd1702060c93$var$setOptionsWasCalled_ = false;
/**
 * Sets the options for the Maps JavaScript API.
 *
 * Has to be called before any library is loaded.
 *
 * See https://developers.google.com/maps/documentation/javascript/load-maps-js-api#required_parameters
 * for the full documentation of available options.
 *
 * @param options The options to set.
 */ function $9f88fd1702060c93$var$setOptions(options) {
    if ($9f88fd1702060c93$var$setOptionsWasCalled_) {
        $9f88fd1702060c93$var$logDevWarning($9f88fd1702060c93$var$MSG_REPEATED_SET_OPTIONS(options));
        return;
    }
    if (options.apiKey) {
        $9f88fd1702060c93$var$logDevWarning($9f88fd1702060c93$var$MSG_API_KEY_USED);
        if (!options.key) options.key = options.apiKey;
    }
    $9f88fd1702060c93$var$installImportLibrary_(options);
    $9f88fd1702060c93$var$setOptionsWasCalled_ = true;
}
async function $9f88fd1702060c93$var$importLibrary(libraryName) {
    if (!$9f88fd1702060c93$var$setOptionsWasCalled_) $9f88fd1702060c93$var$logDevWarning($9f88fd1702060c93$var$MSG_SET_OPTIONS_NOT_CALLED);
    if (!window?.google?.maps?.importLibrary) throw new Error("google.maps.importLibrary is not installed.");
    return await google.maps.importLibrary(libraryName);
}
/**
 * The installImportLibrary_ function makes sure that a usable version of the
 * `google.maps.importLibrary` function exists.
 */ function $9f88fd1702060c93$var$installImportLibrary_(options) {
    const importLibraryExists = Boolean(window.google?.maps?.importLibrary);
    if (importLibraryExists) $9f88fd1702060c93$var$logDevNotice($9f88fd1702060c93$var$MSG_IMPORT_LIBRARY_EXISTS(options));
    else if ($9f88fd1702060c93$var$__DEV__) {
        const scriptEl = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
        if (scriptEl) $9f88fd1702060c93$var$logDevWarning($9f88fd1702060c93$var$MSG_SCRIPT_ELEMENT_EXISTS);
    }
    // If the google.maps.importLibrary function already exists, bootstrap()
    // won't do anything, so we won't call it
    if (!importLibraryExists) $9f88fd1702060c93$var$bootstrap(options);
}
const $9f88fd1702060c93$export$647ae9f9d14aeffc = {
    NOT_LOADED: 'NOT_LOADED',
    LOADING: 'LOADING',
    LOADED: 'LOADED',
    FAILED: 'FAILED',
    AUTH_FAILURE: 'AUTH_FAILURE'
};
const $9f88fd1702060c93$var$DEFAULT_SOLUTION_CHANNEL = 'GMP_visgl_rgmlibrary_v1_default';
const $9f88fd1702060c93$var$DEFAULT_INTERNAL_USAGE_ATTRIBUTION_IDS = [
    `gmp_visgl_reactgooglemaps_v${$9f88fd1702060c93$export$a4ad2735b021c132}`
];
const $9f88fd1702060c93$export$84e9974bcf67d1d = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createContext(null);
// loading the Maps JavaScript API can only happen once in the runtime, so these
// variables are kept at the module level.
let $9f88fd1702060c93$var$loadingStatus = $9f88fd1702060c93$export$647ae9f9d14aeffc.NOT_LOADED;
let $9f88fd1702060c93$var$serializedApiParams;
const $9f88fd1702060c93$var$listeners = new Set();
/**
 * Called to update the local status and notify the listeners for any mounted
 * components.
 * @internal
 */ function $9f88fd1702060c93$var$updateLoadingStatus(status) {
    if (status === $9f88fd1702060c93$var$loadingStatus) return;
    $9f88fd1702060c93$var$loadingStatus = status;
    $9f88fd1702060c93$var$listeners.forEach((listener)=>listener($9f88fd1702060c93$var$loadingStatus));
}
/**
 * Local hook to set up the map-instance management context.
 * @internal
 */ function $9f88fd1702060c93$var$useMapInstances() {
    const [mapInstances, setMapInstances] = (0, $8FY87.useState)({});
    const addMapInstance = (mapInstance, id = 'default')=>{
        setMapInstances((instances)=>Object.assign(Object.assign({}, instances), {
                [id]: mapInstance
            }));
    };
    const removeMapInstance = (id = 'default')=>{
        setMapInstances((_a)=>{
            var _b = id;
            _a[_b];
            var remaining = $9f88fd1702060c93$var$__rest(_a, [
                typeof _b === "symbol" ? _b : _b + ""
            ]);
            return remaining;
        });
    };
    const clearMapInstances = ()=>{
        setMapInstances({});
    };
    return {
        mapInstances: mapInstances,
        addMapInstance: addMapInstance,
        removeMapInstance: removeMapInstance,
        clearMapInstances: clearMapInstances
    };
}
/**
 * local hook to set up the 3D map-instance management context.
 */ function $9f88fd1702060c93$var$useMap3DInstances() {
    const [map3dInstances, setMap3DInstances] = (0, $8FY87.useState)({});
    const addMap3DInstance = (map3dInstance, id = 'default')=>{
        setMap3DInstances((instances)=>Object.assign(Object.assign({}, instances), {
                [id]: map3dInstance
            }));
    };
    const removeMap3DInstance = (id = 'default')=>{
        setMap3DInstances((_a)=>{
            var _b = id;
            _a[_b];
            var remaining = $9f88fd1702060c93$var$__rest(_a, [
                typeof _b === "symbol" ? _b : _b + ""
            ]);
            return remaining;
        });
    };
    const clearMap3DInstances = ()=>{
        setMap3DInstances({});
    };
    return {
        map3dInstances: map3dInstances,
        addMap3DInstance: addMap3DInstance,
        removeMap3DInstance: removeMap3DInstance,
        clearMap3DInstances: clearMap3DInstances
    };
}
/**
 * Local hook to handle the loading of the maps API.
 * @internal
 */ function $9f88fd1702060c93$var$useGoogleMapsApiLoader(props) {
    const { onLoad: onLoad, onError: onError, apiKey: apiKey, version: version, libraries: libraries = [], region: region, language: language, authReferrerPolicy: authReferrerPolicy, channel: channel, solutionChannel: solutionChannel, fetchAppCheckToken: fetchAppCheckToken } = props;
    const [status, setStatus] = (0, $8FY87.useState)($9f88fd1702060c93$var$loadingStatus);
    const [loadedLibraries, addLoadedLibrary] = (0, $8FY87.useReducer)((loadedLibraries, action)=>{
        return loadedLibraries[action.name] ? loadedLibraries : Object.assign(Object.assign({}, loadedLibraries), {
            [action.name]: action.value
        });
    }, {});
    const currentSerializedParams = (0, $8FY87.useMemo)(()=>{
        const params = {
            apiKey: apiKey,
            version: version,
            libraries: libraries.join(','),
            region: region,
            language: language,
            authReferrerPolicy: authReferrerPolicy,
            channel: channel,
            solutionChannel: solutionChannel
        };
        return JSON.stringify(params);
    }, [
        apiKey,
        version,
        libraries,
        region,
        language,
        authReferrerPolicy,
        channel,
        solutionChannel
    ]);
    const importLibraryCallback = (0, $8FY87.useCallback)((name)=>$9f88fd1702060c93$var$__awaiter(this, void 0, void 0, function*() {
            if (loadedLibraries[name]) return loadedLibraries[name];
            const res = yield $9f88fd1702060c93$var$importLibrary(name);
            addLoadedLibrary({
                name: name,
                value: res
            });
            return res;
        }), [
        loadedLibraries
    ]);
    // effect: we want to get notified of global loading-status changes
    (0, $8FY87.useEffect)(()=>{
        $9f88fd1702060c93$var$listeners.add(setStatus);
        // sync component state on mount (shouldn't be different from the initial state)
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional synchronization of status from singleton
        setStatus($9f88fd1702060c93$var$loadingStatus);
        return ()=>{
            $9f88fd1702060c93$var$listeners.delete(setStatus);
        };
    }, []);
    // effect: set and store options
    (0, $8FY87.useEffect)(()=>{
        (()=>$9f88fd1702060c93$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b;
                try {
                    // This indicates that the API has been loaded with a different set of parameters.
                    // While this is not blocking, it's not recommended and we should warn the user.
                    if ($9f88fd1702060c93$var$serializedApiParams && $9f88fd1702060c93$var$serializedApiParams !== currentSerializedParams) console.warn(`The Google Maps JavaScript API has already been loaded with different parameters. ` + `The new parameters will be ignored. If you need to use different parameters, ` + `please refresh the page.`);
                    const librariesToLoad = [
                        'core',
                        'maps',
                        ...libraries
                    ];
                    const options = Object.fromEntries(Object.entries({
                        key: apiKey,
                        v: version,
                        libraries: libraries,
                        region: region,
                        language: language,
                        authReferrerPolicy: authReferrerPolicy
                    }).filter(([, value])=>value !== undefined));
                    if (channel !== undefined && channel >= 0 && channel <= 999) options.channel = String(channel);
                    // solution-channel: when undefined, use the default; otherwise use
                    // an explicit value.
                    if (solutionChannel === undefined) options.solutionChannel = $9f88fd1702060c93$var$DEFAULT_SOLUTION_CHANNEL;
                    else if (solutionChannel !== '') options.solutionChannel = solutionChannel;
                    // If the google.maps namespace is already available, the API has been loaded externally.
                    if ((_b = (_a = window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary) {
                        const shouldUpdateLoadingStatus = !$9f88fd1702060c93$var$serializedApiParams;
                        if (shouldUpdateLoadingStatus) {
                            $9f88fd1702060c93$var$serializedApiParams = currentSerializedParams;
                            $9f88fd1702060c93$var$setOptions(options);
                        }
                        yield Promise.all(librariesToLoad.map((name)=>importLibraryCallback(name)));
                        if (shouldUpdateLoadingStatus) $9f88fd1702060c93$var$updateLoadingStatus($9f88fd1702060c93$export$647ae9f9d14aeffc.LOADED);
                        if (onLoad) onLoad();
                        return;
                    }
                    // Abort if the API is already loading or has been loaded.
                    if ($9f88fd1702060c93$var$loadingStatus === $9f88fd1702060c93$export$647ae9f9d14aeffc.LOADING || $9f88fd1702060c93$var$loadingStatus === $9f88fd1702060c93$export$647ae9f9d14aeffc.LOADED) {
                        if ($9f88fd1702060c93$var$loadingStatus === $9f88fd1702060c93$export$647ae9f9d14aeffc.LOADED && onLoad) onLoad();
                        return;
                    }
                    $9f88fd1702060c93$var$serializedApiParams = currentSerializedParams;
                    $9f88fd1702060c93$var$updateLoadingStatus($9f88fd1702060c93$export$647ae9f9d14aeffc.LOADING);
                    // this will actually trigger loading the maps API
                    $9f88fd1702060c93$var$setOptions(options);
                    // wait for all requested libraries (inluding 'core' and 'maps') to
                    // finish loading
                    yield Promise.all(librariesToLoad.map((name)=>importLibraryCallback(name)));
                    $9f88fd1702060c93$var$updateLoadingStatus($9f88fd1702060c93$export$647ae9f9d14aeffc.LOADED);
                    if (onLoad) onLoad();
                } catch (error) {
                    $9f88fd1702060c93$var$updateLoadingStatus($9f88fd1702060c93$export$647ae9f9d14aeffc.FAILED);
                    if (onError) onError(error);
                    else console.error('The Google Maps JavaScript API failed to load.', error);
                }
            }))();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        currentSerializedParams,
        onLoad,
        onError,
        importLibraryCallback,
        libraries
    ]);
    // set the fetchAppCheckToken if provided
    (0, $8FY87.useEffect)(()=>{
        if (status !== $9f88fd1702060c93$export$647ae9f9d14aeffc.LOADED) return;
        const settings = google.maps.Settings.getInstance();
        if (fetchAppCheckToken) settings.fetchAppCheckToken = fetchAppCheckToken;
    }, [
        status,
        fetchAppCheckToken
    ]);
    return {
        status: status,
        loadedLibraries: loadedLibraries,
        importLibrary: importLibraryCallback
    };
}
function $9f88fd1702060c93$var$useInternalUsageAttributionIds(props) {
    return (0, $8FY87.useMemo)(()=>props.disableUsageAttribution ? null : $9f88fd1702060c93$var$DEFAULT_INTERNAL_USAGE_ATTRIBUTION_IDS, [
        props.disableUsageAttribution
    ]);
}
/**
 * Component to wrap the components from this library and load the Google Maps JavaScript API
 */ const $9f88fd1702060c93$export$434374b2a40d237 = (props)=>{
    const { children: children } = props, loaderProps = $9f88fd1702060c93$var$__rest(props, [
        "children"
    ]);
    const { mapInstances: mapInstances, addMapInstance: addMapInstance, removeMapInstance: removeMapInstance, clearMapInstances: clearMapInstances } = $9f88fd1702060c93$var$useMapInstances();
    const { map3dInstances: map3dInstances, addMap3DInstance: addMap3DInstance, removeMap3DInstance: removeMap3DInstance, clearMap3DInstances: clearMap3DInstances } = $9f88fd1702060c93$var$useMap3DInstances();
    const { status: status, loadedLibraries: loadedLibraries, importLibrary: importLibrary } = $9f88fd1702060c93$var$useGoogleMapsApiLoader(loaderProps);
    const internalUsageAttributionIds = $9f88fd1702060c93$var$useInternalUsageAttributionIds(loaderProps);
    const contextValue = (0, $8FY87.useMemo)(()=>({
            mapInstances: mapInstances,
            addMapInstance: addMapInstance,
            removeMapInstance: removeMapInstance,
            clearMapInstances: clearMapInstances,
            map3dInstances: map3dInstances,
            addMap3DInstance: addMap3DInstance,
            removeMap3DInstance: removeMap3DInstance,
            clearMap3DInstances: clearMap3DInstances,
            status: status,
            loadedLibraries: loadedLibraries,
            importLibrary: importLibrary,
            internalUsageAttributionIds: internalUsageAttributionIds
        }), [
        mapInstances,
        addMapInstance,
        removeMapInstance,
        clearMapInstances,
        map3dInstances,
        addMap3DInstance,
        removeMap3DInstance,
        clearMap3DInstances,
        status,
        loadedLibraries,
        importLibrary,
        internalUsageAttributionIds
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($9f88fd1702060c93$export$84e9974bcf67d1d.Provider, {
        value: contextValue
    }, children);
};
/**
 * @internal
 * Resets module-level state for testing purposes only.
 * This should never be used in production code.
 */ function $9f88fd1702060c93$export$3672cbbeb4da7cb1() {
    $9f88fd1702060c93$var$loadingStatus = $9f88fd1702060c93$export$647ae9f9d14aeffc.NOT_LOADED;
    $9f88fd1702060c93$var$serializedApiParams = undefined;
    $9f88fd1702060c93$var$listeners.clear();
}
/**
 * Sets up effects to bind event-handlers for all event-props in MapEventProps.
 * @internal
 */ function $9f88fd1702060c93$var$useMapEvents(map, props) {
    // note: calling a useEffect hook from within a loop is prohibited by the
    // rules of hooks, but it's ok here since it's unconditional and the number
    // and order of iterations is always strictly the same.
    // (see https://legacy.reactjs.org/docs/hooks-rules.html)
    for (const propName of $9f88fd1702060c93$var$eventPropNames){
        // fixme: this cast is essentially a 'trust me, bro' for typescript, but
        //   a proper solution seems way too complicated right now
        const handler = props[propName];
        const eventType = $9f88fd1702060c93$var$propNameToEventType[propName];
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $8FY87.useEffect)(()=>{
            if (!map) return;
            if (!handler) return;
            const listener = google.maps.event.addListener(map, eventType, (ev)=>{
                handler($9f88fd1702060c93$var$createMapEvent(eventType, map, ev));
            });
            return ()=>listener.remove();
        }, [
            map,
            eventType,
            handler
        ]);
    }
}
/**
 * Create the wrapped map-events used for the event-props.
 * @param type the event type as it is specified to the maps api
 * @param map the map instance the event originates from
 * @param srcEvent the source-event if there is one.
 */ function $9f88fd1702060c93$var$createMapEvent(type, map, srcEvent) {
    var _a;
    const ev = {
        type: type,
        map: map,
        detail: {},
        stoppable: false,
        stop: ()=>{}
    };
    if ($9f88fd1702060c93$var$cameraEventTypes.includes(type)) {
        const camEvent = ev;
        const center = map.getCenter();
        const zoom = map.getZoom();
        const heading = map.getHeading() || 0;
        const tilt = map.getTilt() || 0;
        const bounds = map.getBounds();
        if (!center || !bounds || !Number.isFinite(zoom)) console.warn("[createEvent] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new");
        camEvent.detail = {
            center: (center === null || center === void 0 ? void 0 : center.toJSON()) || {
                lat: 0,
                lng: 0
            },
            zoom: zoom || 0,
            heading: heading,
            tilt: tilt,
            bounds: (bounds === null || bounds === void 0 ? void 0 : bounds.toJSON()) || {
                north: 90,
                east: 180,
                south: -90,
                west: -180
            }
        };
        return camEvent;
    } else if ($9f88fd1702060c93$var$mouseEventTypes.includes(type)) {
        if (!srcEvent) throw new Error('[createEvent] mouse events must provide a srcEvent');
        const mouseEvent = ev;
        mouseEvent.domEvent = srcEvent.domEvent;
        mouseEvent.stoppable = true;
        mouseEvent.stop = ()=>srcEvent.stop();
        mouseEvent.detail = {
            latLng: ((_a = srcEvent.latLng) === null || _a === void 0 ? void 0 : _a.toJSON()) || null,
            placeId: srcEvent.placeId
        };
        return mouseEvent;
    }
    return ev;
}
/**
 * maps the camelCased names of event-props to the corresponding event-types
 * used in the maps API.
 */ const $9f88fd1702060c93$var$propNameToEventType = {
    onBoundsChanged: 'bounds_changed',
    onCenterChanged: 'center_changed',
    onClick: 'click',
    onContextmenu: 'contextmenu',
    onDblclick: 'dblclick',
    onDrag: 'drag',
    onDragend: 'dragend',
    onDragstart: 'dragstart',
    onHeadingChanged: 'heading_changed',
    onIdle: 'idle',
    onIsFractionalZoomEnabledChanged: 'isfractionalzoomenabled_changed',
    onMapCapabilitiesChanged: 'mapcapabilities_changed',
    onMapTypeIdChanged: 'maptypeid_changed',
    onMousemove: 'mousemove',
    onMouseout: 'mouseout',
    onMouseover: 'mouseover',
    onProjectionChanged: 'projection_changed',
    onRenderingTypeChanged: 'renderingtype_changed',
    onTilesLoaded: 'tilesloaded',
    onTiltChanged: 'tilt_changed',
    onZoomChanged: 'zoom_changed',
    // note: onCameraChanged is an alias for the bounds_changed event,
    // since that is going to be fired in every situation where the camera is
    // updated.
    onCameraChanged: 'bounds_changed'
};
const $9f88fd1702060c93$var$cameraEventTypes = [
    'bounds_changed',
    'center_changed',
    'heading_changed',
    'tilt_changed',
    'zoom_changed'
];
const $9f88fd1702060c93$var$mouseEventTypes = [
    'click',
    'contextmenu',
    'dblclick',
    'mousemove',
    'mouseout',
    'mouseover'
];
const $9f88fd1702060c93$var$eventPropNames = Object.keys($9f88fd1702060c93$var$propNameToEventType);
/* eslint-disable react-hooks/refs */ // refs should not be used in render because changes to refs won't
// trigger a re-render, making them unreliable for holding state.
// In this case though, that is exactly what we want.
function $9f88fd1702060c93$var$useMemoized(value, isEqual) {
    const ref = (0, $8FY87.useRef)(value);
    if (!isEqual(value, ref.current)) ref.current = value;
    return ref.current;
}
function $9f88fd1702060c93$var$useCustomCompareEffect(effect, dependencies, isEqual) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $8FY87.useEffect)(effect, [
        $9f88fd1702060c93$var$useMemoized(dependencies, isEqual)
    ]);
}
const { getOwnPropertyNames: $9f88fd1702060c93$var$getOwnPropertyNames, getOwnPropertySymbols: $9f88fd1702060c93$var$getOwnPropertySymbols } = Object;
// eslint-disable-next-line @typescript-eslint/unbound-method
const { hasOwnProperty: $9f88fd1702060c93$var$hasOwnProperty } = Object.prototype;
/**
 * Combine two comparators into a single comparators.
 */ function $9f88fd1702060c93$var$combineComparators(comparatorA, comparatorB) {
    return function isEqual(a, b, state) {
        return comparatorA(a, b, state) && comparatorB(a, b, state);
    };
}
/**
 * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
 * for circular references to be safely included in the comparison without creating
 * stack overflows.
 */ function $9f88fd1702060c93$var$createIsCircular(areItemsEqual) {
    return function isCircular(a, b, state) {
        if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
        const { cache: cache } = state;
        const cachedA = cache.get(a);
        const cachedB = cache.get(b);
        if (cachedA && cachedB) return cachedA === b && cachedB === a;
        cache.set(a, b);
        cache.set(b, a);
        const result = areItemsEqual(a, b, state);
        cache.delete(a);
        cache.delete(b);
        return result;
    };
}
/**
 * Get the properties to strictly examine, which include both own properties that are
 * not enumerable and symbol properties.
 */ function $9f88fd1702060c93$var$getStrictProperties(object) {
    return $9f88fd1702060c93$var$getOwnPropertyNames(object).concat($9f88fd1702060c93$var$getOwnPropertySymbols(object));
}
/**
 * Whether the object contains the property passed as an own property.
 */ const $9f88fd1702060c93$var$hasOwn = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
Object.hasOwn || ((object, property)=>$9f88fd1702060c93$var$hasOwnProperty.call(object, property));
const $9f88fd1702060c93$var$PREACT_VNODE = '__v';
const $9f88fd1702060c93$var$PREACT_OWNER = '__o';
const $9f88fd1702060c93$var$REACT_OWNER = '_owner';
const { getOwnPropertyDescriptor: $9f88fd1702060c93$var$getOwnPropertyDescriptor, keys: $9f88fd1702060c93$var$keys } = Object;
/**
 * Whether the values passed are equal based on a [SameValue](https://262.ecma-international.org/7.0/#sec-samevalue) basis.
 * Simplified, this maps to if the two values are referentially equal to one another (`a === b`) or both are `NaN`.
 *
 * @note
 * When available in the environment, this is just a re-export of the global
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is) method.
 */ const $9f88fd1702060c93$var$sameValueEqual = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
Object.is || function sameValueEqual(a, b) {
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
};
/**
 * Whether the values passed are equal based on a
 * [Strict Equality Comparison](https://262.ecma-international.org/7.0/#sec-strict-equality-comparison) basis.
 * Simplified, this maps to if the two values are referentially equal to one another (`a === b`).
 *
 * @note
 * This is mainly available as a convenience function, such as being a default when a function to determine equality between
 * two objects is used.
 */ function $9f88fd1702060c93$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Whether the array buffers are equal in value.
 */ function $9f88fd1702060c93$var$areArrayBuffersEqual(a, b) {
    return a.byteLength === b.byteLength && $9f88fd1702060c93$var$areTypedArraysEqual(new Uint8Array(a), new Uint8Array(b));
}
/**
 * Whether the arrays are equal in value.
 */ function $9f88fd1702060c93$var$areArraysEqual(a, b, state) {
    let index = a.length;
    if (b.length !== index) return false;
    while(index-- > 0){
        if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
    }
    return true;
}
/**
 * Whether the dataviews are equal in value.
 */ function $9f88fd1702060c93$var$areDataViewsEqual(a, b) {
    return a.byteLength === b.byteLength && $9f88fd1702060c93$var$areTypedArraysEqual(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength));
}
/**
 * Whether the dates passed are equal in value.
 */ function $9f88fd1702060c93$var$areDatesEqual(a, b) {
    return $9f88fd1702060c93$var$sameValueEqual(a.getTime(), b.getTime());
}
/**
 * Whether the errors passed are equal in value.
 */ function $9f88fd1702060c93$var$areErrorsEqual(a, b) {
    return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
}
/**
 * Whether the `Map`s are equal in value.
 */ function $9f88fd1702060c93$var$areMapsEqual(a, b, state) {
    const size = a.size;
    if (size !== b.size) return false;
    if (!size) return true;
    const matchedIndices = new Array(size);
    const aIterable = a.entries();
    let aResult;
    let bResult;
    let index = 0;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    while(aResult = aIterable.next()){
        if (aResult.done) break;
        const bIterable = b.entries();
        let hasMatch = false;
        let matchIndex = 0;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while(bResult = bIterable.next()){
            if (bResult.done) break;
            if (matchedIndices[matchIndex]) {
                matchIndex++;
                continue;
            }
            const aEntry = aResult.value;
            const bEntry = bResult.value;
            if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                hasMatch = matchedIndices[matchIndex] = true;
                break;
            }
            matchIndex++;
        }
        if (!hasMatch) return false;
        index++;
    }
    return true;
}
/**
 * Whether the objects are equal in value.
 */ function $9f88fd1702060c93$var$areObjectsEqual(a, b, state) {
    const properties = $9f88fd1702060c93$var$keys(a);
    let index = properties.length;
    if ($9f88fd1702060c93$var$keys(b).length !== index) return false;
    // Decrementing `while` showed faster results than either incrementing or
    // decrementing `for` loop and than an incrementing `while` loop. Declarative
    // methods like `some` / `every` were not used to avoid incurring the garbage
    // cost of anonymous callbacks.
    while(index-- > 0){
        if (!$9f88fd1702060c93$var$isPropertyEqual(a, b, state, properties[index])) return false;
    }
    return true;
}
/**
 * Whether the objects are equal in value with strict property checking.
 */ function $9f88fd1702060c93$var$areObjectsEqualStrict(a, b, state) {
    const properties = $9f88fd1702060c93$var$getStrictProperties(a);
    let index = properties.length;
    if ($9f88fd1702060c93$var$getStrictProperties(b).length !== index) return false;
    let property;
    let descriptorA;
    let descriptorB;
    // Decrementing `while` showed faster results than either incrementing or
    // decrementing `for` loop and than an incrementing `while` loop. Declarative
    // methods like `some` / `every` were not used to avoid incurring the garbage
    // cost of anonymous callbacks.
    while(index-- > 0){
        property = properties[index];
        if (!$9f88fd1702060c93$var$isPropertyEqual(a, b, state, property)) return false;
        descriptorA = $9f88fd1702060c93$var$getOwnPropertyDescriptor(a, property);
        descriptorB = $9f88fd1702060c93$var$getOwnPropertyDescriptor(b, property);
        if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
    }
    return true;
}
/**
 * Whether the primitive wrappers passed are equal in value.
 */ function $9f88fd1702060c93$var$arePrimitiveWrappersEqual(a, b) {
    return $9f88fd1702060c93$var$sameValueEqual(a.valueOf(), b.valueOf());
}
/**
 * Whether the regexps passed are equal in value.
 */ function $9f88fd1702060c93$var$areRegExpsEqual(a, b) {
    return a.source === b.source && a.flags === b.flags;
}
/**
 * Whether the `Set`s are equal in value.
 */ function $9f88fd1702060c93$var$areSetsEqual(a, b, state) {
    const size = a.size;
    if (size !== b.size) return false;
    if (!size) return true;
    const matchedIndices = new Array(size);
    const aIterable = a.values();
    let aResult;
    let bResult;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    while(aResult = aIterable.next()){
        if (aResult.done) break;
        const bIterable = b.values();
        let hasMatch = false;
        let matchIndex = 0;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while(bResult = bIterable.next()){
            if (bResult.done) break;
            if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                hasMatch = matchedIndices[matchIndex] = true;
                break;
            }
            matchIndex++;
        }
        if (!hasMatch) return false;
    }
    return true;
}
/**
 * Whether the TypedArray instances are equal in value.
 */ function $9f88fd1702060c93$var$areTypedArraysEqual(a, b) {
    let index = a.byteLength;
    if (b.byteLength !== index || a.byteOffset !== b.byteOffset) return false;
    while(index-- > 0){
        if (a[index] !== b[index]) return false;
    }
    return true;
}
/**
 * Whether the URL instances are equal in value.
 */ function $9f88fd1702060c93$var$areUrlsEqual(a, b) {
    return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
}
function $9f88fd1702060c93$var$isPropertyEqual(a, b, state, property) {
    if ((property === $9f88fd1702060c93$var$REACT_OWNER || property === $9f88fd1702060c93$var$PREACT_OWNER || property === $9f88fd1702060c93$var$PREACT_VNODE) && (a.$$typeof || b.$$typeof)) return true;
    return $9f88fd1702060c93$var$hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
}
// eslint-disable-next-line @typescript-eslint/unbound-method
const $9f88fd1702060c93$var$toString = Object.prototype.toString;
/**
 * Create a comparator method based on the type-specific equality comparators passed.
 */ function $9f88fd1702060c93$var$createEqualityComparator(config) {
    const supportedComparatorMap = $9f88fd1702060c93$var$createSupportedComparatorMap(config);
    const { areArraysEqual: areArraysEqual, areDatesEqual: areDatesEqual, areFunctionsEqual: areFunctionsEqual, areMapsEqual: areMapsEqual, areNumbersEqual: areNumbersEqual, areObjectsEqual: areObjectsEqual, areRegExpsEqual: areRegExpsEqual, areSetsEqual: areSetsEqual, getUnsupportedCustomComparator: getUnsupportedCustomComparator } = config;
    /**
     * compare the value of the two objects and return true if they are equivalent in values
     */ return function comparator(a, b, state) {
        // If the items are strictly equal, no need to do a value comparison.
        if (a === b) return true;
        // If either of the items are nullish and fail the strictly equal check
        // above, then they must be unequal.
        if (a == null || b == null) return false;
        const type = typeof a;
        if (type !== typeof b) return false;
        if (type !== 'object') {
            if (type === 'number' || type === 'bigint') return areNumbersEqual(a, b, state);
            if (type === 'function') return areFunctionsEqual(a, b, state);
            // If a primitive value that is not strictly equal, it must be unequal.
            return false;
        }
        const constructor = a.constructor;
        // Checks are listed in order of commonality of use-case:
        //   1. Common complex object types (plain object, array)
        //   2. Common data values (date, regexp)
        //   3. Less-common complex object types (map, set)
        //   4. Less-common data values (promise, primitive wrappers)
        // Inherently this is both subjective and assumptive, however
        // when reviewing comparable libraries in the wild this order
        // appears to be generally consistent.
        // Constructors should match, otherwise there is potential for false positives
        // between class and subclass or custom object and POJO.
        if (constructor !== b.constructor) return false;
        // Try to fast-path equality checks for other complex object types in the
        // same realm to avoid capturing the string tag. Strict equality is used
        // instead of `instanceof` because it is more performant for the common
        // use-case. If someone is creating a subclass from a native class, it will be
        // handled with the string tag comparison.
        if (constructor === Object) return areObjectsEqual(a, b, state);
        if (constructor === Array) return areArraysEqual(a, b, state);
        if (constructor === Date) return areDatesEqual(a, b, state);
        if (constructor === RegExp) return areRegExpsEqual(a, b, state);
        if (constructor === Map) return areMapsEqual(a, b, state);
        if (constructor === Set) return areSetsEqual(a, b, state);
        if (constructor === Promise) // Avoid tag checks for promise values, since we know if they are not referentially equal
        // then they are not equal.
        return false;
        // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
        // the string tag or doing an `instanceof` in edge cases.
        if (Array.isArray(a)) return areArraysEqual(a, b, state);
        // Since this is a custom object, capture the string tag to determining its type.
        // This is reasonably performant in modern environments like v8 and SpiderMonkey.
        const tag = $9f88fd1702060c93$var$toString.call(a);
        const supportedComparator = supportedComparatorMap[tag];
        if (supportedComparator) return supportedComparator(a, b, state);
        const unsupportedCustomComparator = getUnsupportedCustomComparator && getUnsupportedCustomComparator(a, b, state, tag);
        if (unsupportedCustomComparator) return unsupportedCustomComparator(a, b, state);
        // If not matching any tags that require a specific type of comparison, then we hard-code false because
        // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
        //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
        //     comparison that can be made.
        //   - For types that can be introspected but do not have an objective definition of what
        //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
        // In all cases, these decisions should be reevaluated based on changes to the language and
        // common development practices.
        return false;
    };
}
/**
 * Create the configuration object used for building comparators.
 */ function $9f88fd1702060c93$var$createEqualityComparatorConfig({ circular: circular, createCustomConfig: createCustomConfig, strict: strict }) {
    let config = {
        areArrayBuffersEqual: $9f88fd1702060c93$var$areArrayBuffersEqual,
        areArraysEqual: strict ? $9f88fd1702060c93$var$areObjectsEqualStrict : $9f88fd1702060c93$var$areArraysEqual,
        areDataViewsEqual: $9f88fd1702060c93$var$areDataViewsEqual,
        areDatesEqual: $9f88fd1702060c93$var$areDatesEqual,
        areErrorsEqual: $9f88fd1702060c93$var$areErrorsEqual,
        areFunctionsEqual: $9f88fd1702060c93$var$strictEqual,
        areMapsEqual: strict ? $9f88fd1702060c93$var$combineComparators($9f88fd1702060c93$var$areMapsEqual, $9f88fd1702060c93$var$areObjectsEqualStrict) : $9f88fd1702060c93$var$areMapsEqual,
        areNumbersEqual: $9f88fd1702060c93$var$sameValueEqual,
        areObjectsEqual: strict ? $9f88fd1702060c93$var$areObjectsEqualStrict : $9f88fd1702060c93$var$areObjectsEqual,
        arePrimitiveWrappersEqual: $9f88fd1702060c93$var$arePrimitiveWrappersEqual,
        areRegExpsEqual: $9f88fd1702060c93$var$areRegExpsEqual,
        areSetsEqual: strict ? $9f88fd1702060c93$var$combineComparators($9f88fd1702060c93$var$areSetsEqual, $9f88fd1702060c93$var$areObjectsEqualStrict) : $9f88fd1702060c93$var$areSetsEqual,
        areTypedArraysEqual: strict ? $9f88fd1702060c93$var$combineComparators($9f88fd1702060c93$var$areTypedArraysEqual, $9f88fd1702060c93$var$areObjectsEqualStrict) : $9f88fd1702060c93$var$areTypedArraysEqual,
        areUrlsEqual: $9f88fd1702060c93$var$areUrlsEqual,
        getUnsupportedCustomComparator: undefined
    };
    if (createCustomConfig) config = Object.assign({}, config, createCustomConfig(config));
    if (circular) {
        const areArraysEqual = $9f88fd1702060c93$var$createIsCircular(config.areArraysEqual);
        const areMapsEqual = $9f88fd1702060c93$var$createIsCircular(config.areMapsEqual);
        const areObjectsEqual = $9f88fd1702060c93$var$createIsCircular(config.areObjectsEqual);
        const areSetsEqual = $9f88fd1702060c93$var$createIsCircular(config.areSetsEqual);
        config = Object.assign({}, config, {
            areArraysEqual: areArraysEqual,
            areMapsEqual: areMapsEqual,
            areObjectsEqual: areObjectsEqual,
            areSetsEqual: areSetsEqual
        });
    }
    return config;
}
/**
 * Default equality comparator pass-through, used as the standard `isEqual` creator for
 * use inside the built comparator.
 */ function $9f88fd1702060c93$var$createInternalEqualityComparator(compare) {
    return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
        return compare(a, b, state);
    };
}
/**
 * Create the `isEqual` function used by the consuming application.
 */ function $9f88fd1702060c93$var$createIsEqual({ circular: circular, comparator: comparator, createState: createState, equals: equals, strict: strict }) {
    if (createState) return function isEqual(a, b) {
        const { cache: cache = circular ? new WeakMap() : undefined, meta: meta } = createState();
        return comparator(a, b, {
            cache: cache,
            equals: equals,
            meta: meta,
            strict: strict
        });
    };
    if (circular) return function isEqual(a, b) {
        return comparator(a, b, {
            cache: new WeakMap(),
            equals: equals,
            meta: undefined,
            strict: strict
        });
    };
    const state = {
        cache: undefined,
        equals: equals,
        meta: undefined,
        strict: strict
    };
    return function isEqual(a, b) {
        return comparator(a, b, state);
    };
}
/**
 * Create a map of `toString()` values to their respective handlers for `tag`-based lookups.
 */ function $9f88fd1702060c93$var$createSupportedComparatorMap({ areArrayBuffersEqual: areArrayBuffersEqual, areArraysEqual: areArraysEqual, areDataViewsEqual: areDataViewsEqual, areDatesEqual: areDatesEqual, areErrorsEqual: areErrorsEqual, areFunctionsEqual: areFunctionsEqual, areMapsEqual: areMapsEqual, areNumbersEqual: areNumbersEqual, areObjectsEqual: areObjectsEqual, arePrimitiveWrappersEqual: arePrimitiveWrappersEqual, areRegExpsEqual: areRegExpsEqual, areSetsEqual: areSetsEqual, areTypedArraysEqual: areTypedArraysEqual, areUrlsEqual: areUrlsEqual }) {
    return {
        '[object Arguments]': areObjectsEqual,
        '[object Array]': areArraysEqual,
        '[object ArrayBuffer]': areArrayBuffersEqual,
        '[object AsyncGeneratorFunction]': areFunctionsEqual,
        '[object BigInt]': areNumbersEqual,
        '[object BigInt64Array]': areTypedArraysEqual,
        '[object BigUint64Array]': areTypedArraysEqual,
        '[object Boolean]': arePrimitiveWrappersEqual,
        '[object DataView]': areDataViewsEqual,
        '[object Date]': areDatesEqual,
        // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
        // enumerable, and therefore will give false positives if tested like a standard object.
        '[object Error]': areErrorsEqual,
        '[object Float16Array]': areTypedArraysEqual,
        '[object Float32Array]': areTypedArraysEqual,
        '[object Float64Array]': areTypedArraysEqual,
        '[object Function]': areFunctionsEqual,
        '[object GeneratorFunction]': areFunctionsEqual,
        '[object Int8Array]': areTypedArraysEqual,
        '[object Int16Array]': areTypedArraysEqual,
        '[object Int32Array]': areTypedArraysEqual,
        '[object Map]': areMapsEqual,
        '[object Number]': arePrimitiveWrappersEqual,
        '[object Object]': (a, b, state)=>// The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state),
        // For RegExp, the properties are not enumerable, and therefore will give false positives if
        // tested like a standard object.
        '[object RegExp]': areRegExpsEqual,
        '[object Set]': areSetsEqual,
        '[object String]': arePrimitiveWrappersEqual,
        '[object URL]': areUrlsEqual,
        '[object Uint8Array]': areTypedArraysEqual,
        '[object Uint8ClampedArray]': areTypedArraysEqual,
        '[object Uint16Array]': areTypedArraysEqual,
        '[object Uint32Array]': areTypedArraysEqual
    };
}
/**
 * Whether the items passed are deeply-equal in value.
 */ const $9f88fd1702060c93$var$deepEqual = $9f88fd1702060c93$var$createCustomEqual();
/**
 * Whether the items passed are deeply-equal in value based on strict comparison.
 */ $9f88fd1702060c93$var$createCustomEqual({
    strict: true
});
/**
 * Whether the items passed are deeply-equal in value, including circular references.
 */ $9f88fd1702060c93$var$createCustomEqual({
    circular: true
});
/**
 * Whether the items passed are deeply-equal in value, including circular references,
 * based on strict comparison.
 */ $9f88fd1702060c93$var$createCustomEqual({
    circular: true,
    strict: true
});
/**
 * Whether the items passed are shallowly-equal in value.
 */ $9f88fd1702060c93$var$createCustomEqual({
    createInternalComparator: ()=>$9f88fd1702060c93$var$sameValueEqual
});
/**
 * Whether the items passed are shallowly-equal in value based on strict comparison
 */ $9f88fd1702060c93$var$createCustomEqual({
    strict: true,
    createInternalComparator: ()=>$9f88fd1702060c93$var$sameValueEqual
});
/**
 * Whether the items passed are shallowly-equal in value, including circular references.
 */ $9f88fd1702060c93$var$createCustomEqual({
    circular: true,
    createInternalComparator: ()=>$9f88fd1702060c93$var$sameValueEqual
});
/**
 * Whether the items passed are shallowly-equal in value, including circular references,
 * based on strict comparison.
 */ $9f88fd1702060c93$var$createCustomEqual({
    circular: true,
    createInternalComparator: ()=>$9f88fd1702060c93$var$sameValueEqual,
    strict: true
});
/**
 * Create a custom equality comparison method.
 *
 * This can be done to create very targeted comparisons in extreme hot-path scenarios
 * where the standard methods are not performant enough, but can also be used to provide
 * support for legacy environments that do not support expected features like
 * `RegExp.prototype.flags` out of the box.
 */ function $9f88fd1702060c93$var$createCustomEqual(options = {}) {
    const { circular: circular = false, createInternalComparator: createCustomInternalComparator, createState: createState, strict: strict = false } = options;
    const config = $9f88fd1702060c93$var$createEqualityComparatorConfig(options);
    const comparator = $9f88fd1702060c93$var$createEqualityComparator(config);
    const equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : $9f88fd1702060c93$var$createInternalEqualityComparator(comparator);
    return $9f88fd1702060c93$var$createIsEqual({
        circular: circular,
        comparator: comparator,
        createState: createState,
        equals: equals,
        strict: strict
    });
}
function $9f88fd1702060c93$var$useDeepCompareEffect(effect, dependencies) {
    $9f88fd1702060c93$var$useCustomCompareEffect(effect, dependencies, $9f88fd1702060c93$var$deepEqual);
}
const $9f88fd1702060c93$var$mapOptionKeys = new Set([
    'backgroundColor',
    'clickableIcons',
    'controlSize',
    'disableDefaultUI',
    'disableDoubleClickZoom',
    'draggable',
    'draggableCursor',
    'draggingCursor',
    'fullscreenControl',
    'fullscreenControlOptions',
    'gestureHandling',
    'headingInteractionEnabled',
    'isFractionalZoomEnabled',
    'keyboardShortcuts',
    'mapTypeControl',
    'mapTypeControlOptions',
    'mapTypeId',
    'maxZoom',
    'minZoom',
    'noClear',
    'panControl',
    'panControlOptions',
    'restriction',
    'rotateControl',
    'rotateControlOptions',
    'scaleControl',
    'scaleControlOptions',
    'scrollwheel',
    'streetView',
    'streetViewControl',
    'streetViewControlOptions',
    'styles',
    'tiltInteractionEnabled',
    'zoomControl',
    'zoomControlOptions'
]);
/**
 * Internal hook to update the map-options when props are changed.
 *
 * @param map the map instance
 * @param mapProps the props to update the map-instance with
 * @internal
 */ function $9f88fd1702060c93$var$useMapOptions(map, mapProps) {
    /* eslint-disable react-hooks/exhaustive-deps --
     *
     * The following effects aren't triggered when the map is changed.
     * In that case, the values will be or have been passed to the map
     * constructor via mapOptions.
     */ const mapOptions = {};
    const keys = Object.keys(mapProps);
    for (const key of keys){
        if (!$9f88fd1702060c93$var$mapOptionKeys.has(key)) continue;
        mapOptions[key] = mapProps[key];
    }
    // update the map options when mapOptions is changed
    // Note: due to the destructuring above, mapOptions will be seen as changed
    //   with every re-render, so we're assuming the maps-api will properly
    //   deal with unchanged option-values passed into setOptions.
    $9f88fd1702060c93$var$useDeepCompareEffect(()=>{
        if (!map) return;
        map.setOptions(mapOptions);
    }, [
        mapOptions
    ]);
/* eslint-enable react-hooks/exhaustive-deps */ }
function $9f88fd1702060c93$export$e5822ec3438c5de1() {
    var _a;
    return ((_a = (0, $8FY87.useContext)($9f88fd1702060c93$export$84e9974bcf67d1d)) === null || _a === void 0 ? void 0 : _a.status) || $9f88fd1702060c93$export$647ae9f9d14aeffc.NOT_LOADED;
}
/**
 * Internal hook that updates the camera when deck.gl viewState changes.
 * @internal
 */ function $9f88fd1702060c93$var$useDeckGLCameraUpdate(map, props) {
    const { viewport: viewport, viewState: viewState } = props;
    const isDeckGlControlled = !!viewport;
    (0, $8FY87.useLayoutEffect)(()=>{
        if (!map || !viewState) return;
        const { latitude: latitude, longitude: longitude, bearing: heading, pitch: tilt, zoom: zoom } = viewState;
        map.moveCamera({
            center: {
                lat: latitude,
                lng: longitude
            },
            heading: heading,
            tilt: tilt,
            zoom: zoom + 1
        });
    }, [
        map,
        viewState
    ]);
    return isDeckGlControlled;
}
function $9f88fd1702060c93$export$82fba3567e3760d8(obj) {
    if (!obj || typeof obj !== 'object') return false;
    if (!('lat' in obj && 'lng' in obj)) return false;
    return Number.isFinite(obj.lat) && Number.isFinite(obj.lng);
}
function $9f88fd1702060c93$export$e6f27d7c3c3233eb(a, b) {
    if (!a || !b) return false;
    const A = $9f88fd1702060c93$export$988c27a52d63c3b9(a);
    const B = $9f88fd1702060c93$export$988c27a52d63c3b9(b);
    if (A.lat !== B.lat || A.lng !== B.lng) return false;
    return true;
}
function $9f88fd1702060c93$export$988c27a52d63c3b9(obj) {
    if ($9f88fd1702060c93$export$82fba3567e3760d8(obj)) return obj;
    return obj.toJSON();
}
function $9f88fd1702060c93$export$26cbfc0dea0ade67(obj) {
    if ('north' in obj && 'south' in obj && 'east' in obj && 'west' in obj) return obj;
    const ne = obj.getNorthEast().toJSON();
    const sw = obj.getSouthWest().toJSON();
    return {
        north: ne.lat,
        east: ne.lng,
        south: sw.lat,
        west: sw.lng
    };
}
function $9f88fd1702060c93$export$c0cfaae65aded47(a, b) {
    if (!a || !b) return false;
    const A = $9f88fd1702060c93$export$26cbfc0dea0ade67(a);
    const B = $9f88fd1702060c93$export$26cbfc0dea0ade67(b);
    return A.north === B.north && A.south === B.south && A.east === B.east && A.west === B.west;
}
/**
 * Compares two paths (arrays of LatLng points) for equality.
 */ function $9f88fd1702060c93$export$69485f8143efb551(a, b) {
    if (!a || !b) return a === b;
    const arrayB = 'getArray' in b ? b.getArray() : b;
    if (a.length !== arrayB.length) return false;
    for(let i = 0; i < a.length; i++){
        if (!$9f88fd1702060c93$export$e6f27d7c3c3233eb(a[i], arrayB[i])) return false;
    }
    return true;
}
/**
 * Compares two arrays of paths (for Polygon) for equality.
 */ function $9f88fd1702060c93$export$81bf7c9065d0b5e1(a, b) {
    if (!a || !b) return a === b;
    const arrayB = 'getArray' in b ? b.getArray().map((inner)=>inner.getArray()) : b;
    if (a.length !== arrayB.length) return false;
    for(let i = 0; i < a.length; i++){
        if (!$9f88fd1702060c93$export$69485f8143efb551(a[i], arrayB[i])) return false;
    }
    return true;
}
function $9f88fd1702060c93$var$useMapCameraParams(map, cameraStateRef, mapProps) {
    const center = mapProps.center ? $9f88fd1702060c93$export$988c27a52d63c3b9(mapProps.center) : null;
    let lat = null;
    let lng = null;
    if (center && Number.isFinite(center.lat) && Number.isFinite(center.lng)) {
        lat = center.lat;
        lng = center.lng;
    }
    const zoom = Number.isFinite(mapProps.zoom) ? mapProps.zoom : null;
    const heading = Number.isFinite(mapProps.heading) ? mapProps.heading : null;
    const tilt = Number.isFinite(mapProps.tilt) ? mapProps.tilt : null;
    // the following effect runs for every render of the map component and checks
    // if there are differences between the known state of the map instance
    // (cameraStateRef, which is updated by all bounds_changed events) and the
    // desired state in the props.
    (0, $8FY87.useLayoutEffect)(()=>{
        if (!map) return;
        const nextCamera = {};
        let needsUpdate = false;
        if (lat !== null && lng !== null && (cameraStateRef.current.center.lat !== lat || cameraStateRef.current.center.lng !== lng)) {
            nextCamera.center = {
                lat: lat,
                lng: lng
            };
            needsUpdate = true;
        }
        if (zoom !== null && cameraStateRef.current.zoom !== zoom) {
            nextCamera.zoom = zoom;
            needsUpdate = true;
        }
        if (heading !== null && cameraStateRef.current.heading !== heading) {
            nextCamera.heading = heading;
            needsUpdate = true;
        }
        if (tilt !== null && cameraStateRef.current.tilt !== tilt) {
            nextCamera.tilt = tilt;
            needsUpdate = true;
        }
        if (needsUpdate) map.moveCamera(nextCamera);
    });
}
const $9f88fd1702060c93$var$AuthFailureMessage = ()=>{
    const style = {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 999,
        display: 'flex',
        flexFlow: 'column nowrap',
        textAlign: 'center',
        justifyContent: 'center',
        fontSize: '.8rem',
        color: 'rgba(0,0,0,0.6)',
        background: '#dddddd',
        padding: '1rem 1.5rem'
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        style: style
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("h2", null, "Error: AuthFailure"), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("p", null, "A problem with your API key prevents the map from rendering correctly. Please make sure the value of the ", (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("code", null, "APIProvider.apiKey"), " prop is correct. Check the error-message in the console for further details."));
};
function $9f88fd1702060c93$var$useCallbackRef() {
    const [el, setEl] = (0, $8FY87.useState)(null);
    const ref = (0, $8FY87.useCallback)((value)=>setEl(value), [
        setEl
    ]);
    return [
        el,
        ref
    ];
}
/**
 * Hook to check if the Maps JavaScript API is loaded
 */ function $9f88fd1702060c93$export$71fa1727c43bf612() {
    const status = $9f88fd1702060c93$export$e5822ec3438c5de1();
    return status === $9f88fd1702060c93$export$647ae9f9d14aeffc.LOADED;
}
function $9f88fd1702060c93$var$useForceUpdate() {
    const [, forceUpdate] = (0, $8FY87.useReducer)((x)=>x + 1, 0);
    return forceUpdate;
}
function $9f88fd1702060c93$var$handleBoundsChange(map, ref) {
    const center = map.getCenter();
    const zoom = map.getZoom();
    const heading = map.getHeading() || 0;
    const tilt = map.getTilt() || 0;
    const bounds = map.getBounds();
    if (!center || !bounds || !Number.isFinite(zoom)) console.warn("[useTrackedCameraState] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new");
    // fixme: do we need the `undefined` cases for the camera-params? When are they used in the maps API?
    Object.assign(ref.current, {
        center: (center === null || center === void 0 ? void 0 : center.toJSON()) || {
            lat: 0,
            lng: 0
        },
        zoom: zoom || 0,
        heading: heading,
        tilt: tilt
    });
}
/**
 * Creates a mutable ref object to track the last known state of the map camera.
 * This is used in `useMapCameraParams` to reduce stuttering in normal operation
 * by avoiding updates of the map camera with values that have already been processed.
 */ function $9f88fd1702060c93$var$useTrackedCameraStateRef(map) {
    const forceUpdate = $9f88fd1702060c93$var$useForceUpdate();
    const ref = (0, $8FY87.useRef)({
        center: {
            lat: 0,
            lng: 0
        },
        heading: 0,
        tilt: 0,
        zoom: 0
    });
    // Record camera state with every bounds_changed event dispatched by the map.
    // This data is used to prevent feeding these values back to the
    // map-instance when a typical "controlled component" setup (state variable is
    // fed into and updated by the map).
    (0, $8FY87.useEffect)(()=>{
        if (!map) return;
        const listener = google.maps.event.addListener(map, 'bounds_changed', ()=>{
            $9f88fd1702060c93$var$handleBoundsChange(map, ref);
            // When an event is occured, we have to update during the next cycle.
            // The application could decide to ignore the event and not update any
            // camera props of the map, meaning that in that case we will have to
            // 'undo' the change to the camera.
            forceUpdate();
        });
        return ()=>listener.remove();
    }, [
        map,
        forceUpdate
    ]);
    return ref;
}
/**
 * Stores a stack of map-instances for each mapId. Whenever an
 * instance is used, it is removed from the stack while in use,
 * and returned to the stack when the component unmounts.
 * This allows us to correctly implement caching for multiple
 * maps om the same page, while reusing as much as possible.
 *
 * FIXME: while it should in theory be possible to reuse maps solely
 *   based on mapId/renderingType/colorScheme (as all other parameters can be
 *   changed at runtime), we don't yet have good enough tracking of options to
 *   reliably unset all the options that have been set.
 */ class $9f88fd1702060c93$var$CachedMapStack {
    static has(key) {
        return this.entries[key] && this.entries[key].length > 0;
    }
    static pop(key) {
        if (!this.entries[key]) return null;
        return this.entries[key].pop() || null;
    }
    static push(key, value) {
        if (!this.entries[key]) this.entries[key] = [];
        this.entries[key].push(value);
    }
}
$9f88fd1702060c93$var$CachedMapStack.entries = {};
/**
 * The main hook takes care of creating map-instances and registering them in
 * the api-provider context.
 * @return a tuple of the map-instance created (or null) and the callback
 *   ref that will be used to pass the map-container into this hook.
 * @internal
 */ function $9f88fd1702060c93$var$useMapInstance(props, context) {
    const apiIsLoaded = $9f88fd1702060c93$export$71fa1727c43bf612();
    const [map, setMap] = (0, $8FY87.useState)(null);
    const [container, containerRef] = $9f88fd1702060c93$var$useCallbackRef();
    const cameraStateRef = $9f88fd1702060c93$var$useTrackedCameraStateRef(map);
    const { id: id, defaultBounds: defaultBounds, defaultCenter: defaultCenter, defaultZoom: defaultZoom, defaultHeading: defaultHeading, defaultTilt: defaultTilt, reuseMaps: reuseMaps, renderingType: renderingType, colorScheme: colorScheme } = props, mapOptions = $9f88fd1702060c93$var$__rest(props, [
        "id",
        "defaultBounds",
        "defaultCenter",
        "defaultZoom",
        "defaultHeading",
        "defaultTilt",
        "reuseMaps",
        "renderingType",
        "colorScheme"
    ]);
    const hasZoom = props.zoom !== undefined || props.defaultZoom !== undefined;
    const hasCenter = props.center !== undefined || props.defaultCenter !== undefined;
    if (!defaultBounds && (!hasZoom || !hasCenter)) console.warn("<Map> component is missing configuration. You have to provide zoom and center (via the `zoom`/`defaultZoom` and `center`/`defaultCenter` props) or specify the region to show using `defaultBounds`. See https://visgl.github.io/react-google-maps/docs/api-reference/components/map#required");
    // apply default camera props if available and not overwritten by controlled props
    if (!mapOptions.center && defaultCenter) mapOptions.center = defaultCenter;
    if (!mapOptions.zoom && Number.isFinite(defaultZoom)) mapOptions.zoom = defaultZoom;
    if (!mapOptions.heading && Number.isFinite(defaultHeading)) mapOptions.heading = defaultHeading;
    if (!mapOptions.tilt && Number.isFinite(defaultTilt)) mapOptions.tilt = defaultTilt;
    // Handle internalUsageAttributionIds
    const customIds = mapOptions.internalUsageAttributionIds;
    if (customIds == null) // Not specified - use context default (which may be null if disabled)
    mapOptions.internalUsageAttributionIds = context.internalUsageAttributionIds;
    else // Merge context defaults with custom IDs
    mapOptions.internalUsageAttributionIds = [
        ...context.internalUsageAttributionIds || [],
        ...customIds
    ];
    for (const key of Object.keys(mapOptions))if (mapOptions[key] === undefined) delete mapOptions[key];
    const savedMapStateRef = (0, $8FY87.useRef)(undefined);
    // create the map instance and register it in the context
    (0, $8FY87.useEffect)(()=>{
        if (!container || !apiIsLoaded) return;
        const { addMapInstance: addMapInstance, removeMapInstance: removeMapInstance } = context;
        // note: colorScheme (upcoming feature) isn't yet in the typings, remove once that is fixed:
        const { mapId: mapId } = props;
        const cacheKey = `${mapId || 'default'}:${renderingType || 'default'}:${colorScheme || 'LIGHT'}`;
        let mapDiv;
        let map;
        // a cached map can end up in a broken state (e.g. when the initial
        // map-creation failed because the Maps JavaScript API didn't load
        // correctly). In that case `getDiv()` doesn't return a usable DOM node,
        // so we have to discard the cached instance instead of trying to reuse it.
        const cachedMap = reuseMaps && $9f88fd1702060c93$var$CachedMapStack.has(cacheKey) ? $9f88fd1702060c93$var$CachedMapStack.pop(cacheKey) : null;
        const cachedMapDiv = cachedMap === null || cachedMap === void 0 ? void 0 : cachedMap.getDiv();
        const reusedMap = cachedMap && cachedMapDiv instanceof Node ? cachedMap : null;
        if (reusedMap) {
            map = reusedMap;
            mapDiv = cachedMapDiv;
            container.appendChild(mapDiv);
            map.setOptions(mapOptions);
            // detaching the element from the DOM sometimes causes the map to collapse
            // and no longer render tiles that should be in view after re-attaching it.
            // Triggering moveCamera after remounting should trigger a re-layout of
            // the map.
            setTimeout(()=>map.moveCamera({}), 0);
        } else {
            // discard a broken cached instance so it doesn't get pushed back
            if (cachedMap) google.maps.event.clearInstanceListeners(cachedMap);
            mapDiv = document.createElement('div');
            mapDiv.style.height = '100%';
            container.appendChild(mapDiv);
            map = new google.maps.Map(mapDiv, Object.assign(Object.assign(Object.assign({}, mapOptions), renderingType ? {
                renderingType: renderingType
            } : {}), colorScheme ? {
                colorScheme: colorScheme
            } : {}));
        }
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setMap(map);
        addMapInstance(map, id);
        if (defaultBounds) {
            const { padding: padding } = defaultBounds, defBounds = $9f88fd1702060c93$var$__rest(defaultBounds, [
                "padding"
            ]);
            map.fitBounds(defBounds, padding);
        } else if (!hasZoom || !hasCenter) map.fitBounds({
            east: 180,
            west: -180,
            south: -90,
            north: 90
        });
        // the savedMapState is used to restore the camera parameters when the mapId is changed
        if (savedMapStateRef.current) {
            const { mapId: savedMapId, cameraState: savedCameraState } = savedMapStateRef.current;
            if (savedMapId !== mapId) map.moveCamera(savedCameraState);
        }
        return ()=>{
            savedMapStateRef.current = {
                mapId: mapId,
                // eslint-disable-next-line react-hooks/exhaustive-deps
                cameraState: cameraStateRef.current
            };
            // detach the map-div from the dom
            mapDiv.remove();
            if (reuseMaps) // push back on the stack
            $9f88fd1702060c93$var$CachedMapStack.push(cacheKey, map);
            else // remove all event-listeners to minimize the possibility of memory-leaks
            google.maps.event.clearInstanceListeners(map);
            setMap(null);
            removeMapInstance(id);
        };
    }, // some dependencies are ignored in the list below:
    //  - defaultBounds and the default* camera props will only be used once, and
    //    changes should be ignored
    //  - mapOptions has special hooks that take care of updating the options
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        container,
        apiIsLoaded,
        id,
        // these props can't be changed after initialization and require a new
        // instance to be created
        props.mapId,
        props.renderingType,
        props.colorScheme
    ]);
    return [
        map,
        containerRef,
        cameraStateRef
    ];
}
const $9f88fd1702060c93$export$477ce50570f8b557 = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createContext(null);
// ColorScheme and RenderingType are redefined here to make them usable before the
// maps API has been fully loaded.
const $9f88fd1702060c93$export$610a58c777d52843 = {
    DARK: 'DARK',
    LIGHT: 'LIGHT',
    FOLLOW_SYSTEM: 'FOLLOW_SYSTEM'
};
const $9f88fd1702060c93$export$245778257f8d6718 = {
    VECTOR: 'VECTOR',
    RASTER: 'RASTER',
    UNINITIALIZED: 'UNINITIALIZED'
};
const $9f88fd1702060c93$export$a5c7b93649eaf8f8 = (props)=>{
    const { children: children, id: id, className: className, style: style } = props;
    const context = (0, $8FY87.useContext)($9f88fd1702060c93$export$84e9974bcf67d1d);
    const loadingStatus = $9f88fd1702060c93$export$e5822ec3438c5de1();
    if (!context) throw new Error('<Map> can only be used inside an <ApiProvider> component.');
    const [map, mapRef, cameraStateRef] = $9f88fd1702060c93$var$useMapInstance(props, context);
    $9f88fd1702060c93$var$useMapCameraParams(map, cameraStateRef, props);
    $9f88fd1702060c93$var$useMapEvents(map, props);
    $9f88fd1702060c93$var$useMapOptions(map, props);
    const isDeckGlControlled = $9f88fd1702060c93$var$useDeckGLCameraUpdate(map, props);
    const isControlledExternally = !!props.controlled;
    // disable interactions with the map for externally controlled maps
    (0, $8FY87.useEffect)(()=>{
        if (!map) return;
        // fixme: this doesn't seem to belong here (and it's mostly there for convenience anyway).
        //   The reasoning is that a deck.gl canvas will be put on top of the map, rendering
        //   any default map controls pretty much useless
        if (isDeckGlControlled) map.setOptions({
            disableDefaultUI: true
        });
        // disable all control-inputs when the map is controlled externally
        if (isDeckGlControlled || isControlledExternally) map.setOptions({
            gestureHandling: 'none',
            keyboardShortcuts: false
        });
        return ()=>{
            map.setOptions({
                gestureHandling: props.gestureHandling,
                keyboardShortcuts: props.keyboardShortcuts
            });
        };
    }, [
        map,
        isDeckGlControlled,
        isControlledExternally,
        props.gestureHandling,
        props.keyboardShortcuts
    ]);
    // setup a stable cameraOptions object that can be used as dependency
    const center = props.center ? $9f88fd1702060c93$export$988c27a52d63c3b9(props.center) : null;
    let lat = null;
    let lng = null;
    if (center && Number.isFinite(center.lat) && Number.isFinite(center.lng)) {
        lat = center.lat;
        lng = center.lng;
    }
    const cameraOptions = (0, $8FY87.useMemo)(()=>{
        var _a, _b, _c;
        return {
            center: {
                lat: lat !== null && lat !== void 0 ? lat : 0,
                lng: lng !== null && lng !== void 0 ? lng : 0
            },
            zoom: (_a = props.zoom) !== null && _a !== void 0 ? _a : 0,
            heading: (_b = props.heading) !== null && _b !== void 0 ? _b : 0,
            tilt: (_c = props.tilt) !== null && _c !== void 0 ? _c : 0
        };
    }, [
        lat,
        lng,
        props.zoom,
        props.heading,
        props.tilt
    ]);
    // externally controlled mode: reject all camera changes that don't correspond to changes in props
    (0, $8FY87.useLayoutEffect)(()=>{
        if (!map || !isControlledExternally) return;
        map.moveCamera(cameraOptions);
        const listener = map.addListener('bounds_changed', ()=>{
            map.moveCamera(cameraOptions);
        });
        return ()=>listener.remove();
    }, [
        map,
        isControlledExternally,
        cameraOptions
    ]);
    const combinedStyle = (0, $8FY87.useMemo)(()=>Object.assign({
            width: '100%',
            height: '100%',
            position: 'relative',
            // when using deckgl, the map should be sent to the back
            zIndex: isDeckGlControlled ? -1 : 0
        }, style), [
        style,
        isDeckGlControlled
    ]);
    const contextValue = (0, $8FY87.useMemo)(()=>({
            map: map
        }), [
        map
    ]);
    if (loadingStatus === $9f88fd1702060c93$export$647ae9f9d14aeffc.AUTH_FAILURE) return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        style: Object.assign({
            position: 'relative'
        }, className ? {} : combinedStyle),
        className: className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($9f88fd1702060c93$var$AuthFailureMessage, null));
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", Object.assign({
        ref: mapRef,
        "data-testid": 'map',
        style: className ? undefined : combinedStyle,
        className: className
    }, id ? {
        id: id
    } : {}), map ? (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($9f88fd1702060c93$export$477ce50570f8b557.Provider, {
        value: contextValue
    }, children) : null);
};
// The deckGLViewProps flag here indicates to deck.gl that the Map component is
// able to handle viewProps from deck.gl when deck.gl is used to control the map.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$9f88fd1702060c93$export$a5c7b93649eaf8f8.deckGLViewProps = true;
const $9f88fd1702060c93$var$shownMessages = new Set();
function $9f88fd1702060c93$var$logErrorOnce(...args) {
    const key = JSON.stringify(args);
    if (!$9f88fd1702060c93$var$shownMessages.has(key)) {
        $9f88fd1702060c93$var$shownMessages.add(key);
        console.error(...args);
    }
}
/**
 * Retrieves a map-instance from the context. This is either an instance
 * identified by id or the parent map instance if no id is specified.
 * Returns null if neither can be found.
 */ const $9f88fd1702060c93$export$86f8f9f08863e403 = (id = null)=>{
    const ctx = (0, $8FY87.useContext)($9f88fd1702060c93$export$84e9974bcf67d1d);
    const { map: map } = (0, $8FY87.useContext)($9f88fd1702060c93$export$477ce50570f8b557) || {};
    if (ctx === null) {
        $9f88fd1702060c93$var$logErrorOnce("useMap(): failed to retrieve APIProviderContext. Make sure that the <APIProvider> component exists and that the component you are calling `useMap()` from is a sibling of the <APIProvider>.");
        return null;
    }
    const { mapInstances: mapInstances } = ctx;
    // if an id is specified, the corresponding map or null is returned
    if (id !== null) return mapInstances[id] || null;
    // otherwise, return the closest ancestor
    if (map) return map;
    // finally, return the default map instance
    return mapInstances['default'] || null;
};
function $9f88fd1702060c93$export$5b40cf36c69caef7(name) {
    var _a;
    const apiIsLoaded = $9f88fd1702060c93$export$71fa1727c43bf612();
    const ctx = (0, $8FY87.useContext)($9f88fd1702060c93$export$84e9974bcf67d1d);
    (0, $8FY87.useEffect)(()=>{
        if (!apiIsLoaded || !ctx) return;
        // Trigger loading the libraries via our proxy-method.
        // The returned promise is ignored, since importLibrary will update loadedLibraries
        // list in the context, triggering a re-render.
        ctx.importLibrary(name);
    }, [
        apiIsLoaded,
        ctx,
        name
    ]);
    return (_a = ctx === null || ctx === void 0 ? void 0 : ctx.loadedLibraries[name]) !== null && _a !== void 0 ? _a : null;
}
// Copyright (c) 2025 Sanity
// This file is derived from sanity-io/use-effect-event (MIT Licensed)
//
// https://github.com/sanity-io/use-effect-event
/**
 * A clone of the React namespace for reading APIs that may be missing in older
 * supported React versions. Bundlers can rewrite direct React.someNewApi reads
 * into named imports, which breaks React 17. Reading from this cloned object
 * keeps those lookups optional.
 *
 * @see https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
 */ const $9f88fd1702060c93$var$SafeReact = Object.assign({}, $8FY87);
const $9f88fd1702060c93$var$useInsertionEffect = $9f88fd1702060c93$var$SafeReact.useInsertionEffect;
const $9f88fd1702060c93$var$useSafeInsertionEffect = // React 17 doesn't have useInsertionEffect.
$9f88fd1702060c93$var$useInsertionEffect && // Preact replaces useInsertionEffect with useLayoutEffect and fires too late.
$9f88fd1702060c93$var$useInsertionEffect !== $9f88fd1702060c93$var$SafeReact.useLayoutEffect ? $9f88fd1702060c93$var$useInsertionEffect : (fn)=>{
    fn();
};
function $9f88fd1702060c93$var$forbiddenInRender() {
    throw new Error('useEffectEvent: invalid call during rendering.');
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9f88fd1702060c93$var$useEffectEventPolyfill(fn) {
    /**
     * Initialize the ref with `forbiddenInRender`, to catch illegal calls during
     * rendering. After the insertion effect ran, the ref will contain the actual
     * function, so all effects can see the actual value.
     */ const ref = (0, $8FY87.useRef)($9f88fd1702060c93$var$forbiddenInRender);
    $9f88fd1702060c93$var$useSafeInsertionEffect(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (...args)=>ref.current(...args);
}
/**
 * Uses a polyfill implementation of `useEffectEvent`. The native useEffectEvent
 * implementation was causing issues that we do not fully understand yet.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9f88fd1702060c93$var$useEffectEvent = $9f88fd1702060c93$var$useEffectEventPolyfill;
/* eslint-disable @typescript-eslint/no-explicit-any */ const $9f88fd1702060c93$var$noop$1 = ()=>{};
/**
 * Internally used to bind events to Maps JavaScript API objects.
 * @internal
 */ function $9f88fd1702060c93$var$useMapsEventListener(target, name, callback) {
    const eventFn = $9f88fd1702060c93$var$useEffectEvent(callback !== null && callback !== void 0 ? callback : $9f88fd1702060c93$var$noop$1);
    const isCallbackDefined = Boolean(callback);
    (0, $8FY87.useEffect)(()=>{
        if (!target || !name || !isCallbackDefined) return;
        const listener = google.maps.event.addListener(target, name, eventFn);
        return ()=>listener.remove();
    }, [
        target,
        name,
        isCallbackDefined
    ]);
}
/* eslint-disable react-hooks/immutability -- Google Maps API objects are designed to be mutated */ /**
 * Internally used to copy values from props into API-Objects
 * whenever they change.
 *
 * @example
 *   usePropBinding(marker, 'position', position);
 *
 * @internal
 */ function $9f88fd1702060c93$var$usePropBinding(object, prop, value) {
    (0, $8FY87.useEffect)(()=>{
        if (!object) return;
        // We use any here because GmpWritableElementProp<T[K]> is a broader type than T[K]
        // and can't be assigned directly without this cast.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        object[prop] = value;
    }, [
        object,
        prop,
        value
    ]);
}
/* eslint-disable @typescript-eslint/no-explicit-any */ const $9f88fd1702060c93$var$noop = ()=>{};
/**
 * Internally used to bind events to DOM nodes.
 * @internal
 */ function $9f88fd1702060c93$var$useDomEventListener(target, name, callback) {
    const eventFn = $9f88fd1702060c93$var$useEffectEvent(callback !== null && callback !== void 0 ? callback : $9f88fd1702060c93$var$noop);
    const isCallbackDefined = Boolean(callback);
    (0, $8FY87.useEffect)(()=>{
        if (!target || !name || !isCallbackDefined) return;
        // Note: eventFn is not guaranteed to be stable across renders, so we need
        // to use a local variable to be sure to remove the very same listener
        // function that has been added
        const listenerCallback = eventFn;
        target.addEventListener(name, listenerCallback);
        return ()=>target.removeEventListener(name, listenerCallback);
    }, [
        target,
        name,
        isCallbackDefined
    ]);
}
// Global style manager to track rendered styles and avoid duplicates
class $9f88fd1702060c93$var$GlobalStyleManager {
    constructor(){
        this.renderedStyles = new Set();
        this.styleElement = null;
    }
    getStyleElement() {
        if (!this.styleElement) {
            this.styleElement = document.createElement('style');
            this.styleElement.setAttribute('data-rgm-anchor-styles', '');
            document.head.appendChild(this.styleElement);
        }
        return this.styleElement;
    }
    addAdvancedMarkerPointerEventsOverwrite() {
        if (this.renderedStyles.has('marker-pointer-events')) return;
        const styleElement = this.getStyleElement();
        styleElement.textContent += `
      gmp-advanced-marker[data-origin='rgm'] {
        pointer-events: none !important;
      }
    `;
        this.renderedStyles.add('marker-pointer-events');
    }
    cleanup() {
        if (this.styleElement) {
            this.styleElement.remove();
            this.styleElement = null;
            this.renderedStyles.clear();
        }
    }
}
const $9f88fd1702060c93$var$globalStyleManager = new $9f88fd1702060c93$var$GlobalStyleManager();
function $9f88fd1702060c93$var$isVersionGreaterEqual(major, minor) {
    var _a;
    if (!((_a = google === null || google === void 0 ? void 0 : google.maps) === null || _a === void 0 ? void 0 : _a.version)) return undefined;
    const version = google.maps.version.split('.');
    const currentMajor = parseInt(version[0], 10);
    const currentMinor = parseInt(version[1], 10);
    return currentMajor > major || currentMajor === major && currentMinor >= minor;
}
/**
 * Copy of the `google.maps.CollisionBehavior` constants.
 * They have to be duplicated here since we can't wait for the maps API to load to be able to use them.
 */ const $9f88fd1702060c93$export$780450305ded336e = {
    REQUIRED: 'REQUIRED',
    REQUIRED_AND_HIDES_OPTIONAL: 'REQUIRED_AND_HIDES_OPTIONAL',
    OPTIONAL_AND_HIDES_LOWER_PRIORITY: 'OPTIONAL_AND_HIDES_LOWER_PRIORITY'
};
const $9f88fd1702060c93$export$14de7bb7593cd5bc = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createContext(null);
// [xPosition, yPosition] when the top left corner is [0, 0]
/**
 * @deprecated Using `anchorPosition` is deprecated.
 *   Use `anchorLeft` and `anchorTop` instead.
 */ const $9f88fd1702060c93$export$5a0544ba0e628ca7 = {
    TOP_LEFT: [
        '0%',
        '0%'
    ],
    TOP_CENTER: [
        '50%',
        '0%'
    ],
    TOP: [
        '50%',
        '0%'
    ],
    TOP_RIGHT: [
        '100%',
        '0%'
    ],
    LEFT_CENTER: [
        '0%',
        '50%'
    ],
    LEFT_TOP: [
        '0%',
        '0%'
    ],
    LEFT: [
        '0%',
        '50%'
    ],
    LEFT_BOTTOM: [
        '0%',
        '100%'
    ],
    RIGHT_TOP: [
        '100%',
        '0%'
    ],
    RIGHT: [
        '100%',
        '50%'
    ],
    RIGHT_CENTER: [
        '100%',
        '50%'
    ],
    RIGHT_BOTTOM: [
        '100%',
        '100%'
    ],
    BOTTOM_LEFT: [
        '0%',
        '100%'
    ],
    BOTTOM_CENTER: [
        '50%',
        '100%'
    ],
    BOTTOM: [
        '50%',
        '100%'
    ],
    BOTTOM_RIGHT: [
        '100%',
        '100%'
    ],
    CENTER: [
        '50%',
        '50%'
    ]
};
const $9f88fd1702060c93$export$5dd2dc1fc7030ab5 = (0, $8FY87.forwardRef)((props, ref)=>{
    const { children: children, style: style, className: className, anchorPoint: anchorPoint } = props;
    const [marker, contentContainer] = $9f88fd1702060c93$var$useAdvancedMarker(props);
    const advancedMarkerContextValue = (0, $8FY87.useMemo)(()=>marker ? {
            marker: marker
        } : null, [
        marker
    ]);
    (0, $8FY87.useImperativeHandle)(ref, ()=>marker, [
        marker
    ]);
    if (!contentContainer) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($9f88fd1702060c93$export$14de7bb7593cd5bc.Provider, {
        value: advancedMarkerContextValue
    }, (0, $95gxM.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($9f88fd1702060c93$var$MarkerContent, {
        anchorPoint: anchorPoint,
        styles: style,
        className: className
    }, children), contentContainer));
});
$9f88fd1702060c93$export$5dd2dc1fc7030ab5.displayName = 'AdvancedMarker';
function $9f88fd1702060c93$export$ee72183bc46d9ec2() {
    const [marker, setMarker] = (0, $8FY87.useState)(null);
    const refCallback = (0, $8FY87.useCallback)((m)=>{
        setMarker(m);
    }, []);
    return [
        refCallback,
        marker
    ];
}
function $9f88fd1702060c93$export$5f1640ccc146ea2d(marker) {
    return marker.content !== undefined;
}
function $9f88fd1702060c93$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
const $9f88fd1702060c93$var$MarkerContent = ({ children: children, styles: styles, className: className })=>{
    /* AdvancedMarker div that user can give styles and classes */ return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: className,
        style: styles
    }, children);
};
function $9f88fd1702060c93$var$useAdvancedMarker(props) {
    const [marker, setMarker] = (0, $8FY87.useState)(null);
    const [contentContainer, setContentContainer] = (0, $8FY87.useState)(null);
    const map = $9f88fd1702060c93$export$86f8f9f08863e403();
    const markerLibrary = $9f88fd1702060c93$export$5b40cf36c69caef7('marker');
    const { children: children, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, className: className, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, collisionBehavior: collisionBehavior, clickable: clickable, draggable: draggable, position: position, title: title, zIndex: zIndex, anchorPoint: anchorPoint, anchorLeft: anchorLeft, anchorTop: anchorTop } = props;
    const numChildren = (0, $8FY87.Children).count(children);
    // create an AdvancedMarkerElement instance and add it to the map once available
    (0, $8FY87.useEffect)(()=>{
        if (!map || !markerLibrary) return;
        const newMarker = new markerLibrary.AdvancedMarkerElement();
        newMarker.map = map;
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setMarker(newMarker);
        // create the container for marker content if there are children
        let contentElement = null;
        if (numChildren > 0) {
            contentElement = document.createElement('div');
            newMarker.content = contentElement;
            setContentContainer(contentElement);
        }
        return ()=>{
            newMarker.map = null;
            contentElement === null || contentElement === void 0 || contentElement.remove();
            setMarker(null);
            setContentContainer(null);
        };
    }, [
        map,
        markerLibrary,
        numChildren
    ]);
    // When no children are present we don't have our own wrapper div
    // which usually gets the user provided className. In this case
    // we set the className directly on the marker.content element that comes
    // with the AdvancedMarker.
    (0, $8FY87.useEffect)(()=>{
        if (!(marker === null || marker === void 0 ? void 0 : marker.content) || !$9f88fd1702060c93$var$isElementNode(marker.content) || numChildren > 0) return;
        marker.content.className = className !== null && className !== void 0 ? className : '';
    }, [
        marker,
        className,
        numChildren
    ]);
    $9f88fd1702060c93$var$useAdvancedMarkerAnchoring(marker, anchorPoint, anchorLeft, anchorTop, numChildren > 0);
    // copy other props
    $9f88fd1702060c93$var$usePropBinding(marker, 'position', position);
    $9f88fd1702060c93$var$usePropBinding(marker, 'title', title !== null && title !== void 0 ? title : '');
    $9f88fd1702060c93$var$usePropBinding(marker, 'zIndex', zIndex);
    $9f88fd1702060c93$var$usePropBinding(marker, 'collisionBehavior', collisionBehavior);
    // set gmpDraggable from props (when unspecified, it's true if any drag-event
    // callbacks are specified)
    (0, $8FY87.useEffect)(()=>{
        if (!marker) return;
        if (draggable !== undefined) marker.gmpDraggable = draggable;
        else if (onDrag || onDragStart || onDragEnd) marker.gmpDraggable = true;
        else marker.gmpDraggable = false;
    }, [
        marker,
        draggable,
        onDrag,
        onDragEnd,
        onDragStart
    ]);
    // set gmpClickable from props (when unspecified, it's true if any interactive
    // event callbacks are specified)
    (0, $8FY87.useEffect)(()=>{
        if (!marker) return;
        // when clickable is defined, we will always use its value for gmpClickable.
        // otherwise we auto-detect based on existing event-handlers.
        const gmpClickable = clickable !== undefined ? clickable : Boolean(onClick) || Boolean(onKeyDown) || Boolean(onKeyUp) || Boolean(onMouseEnter) || Boolean(onMouseLeave);
        // gmpClickable is only available in beta version of the
        // maps api (as of 2024-10-10)
        marker.gmpClickable = gmpClickable;
        // keep pointer/cursor styles in sync for markers with custom content.
        // Non-clickable custom HTML must disable pointer targeting explicitly so
        // interactions fall through to the map underneath.
        if ((marker === null || marker === void 0 ? void 0 : marker.content) && $9f88fd1702060c93$var$isElementNode(marker.content)) {
            marker.content.style.pointerEvents = gmpClickable ? 'all' : 'none';
            marker.content.style.cursor = gmpClickable && onClick ? 'pointer' : '';
        }
    }, [
        marker,
        clickable,
        onClick,
        onKeyDown,
        onKeyUp,
        onMouseEnter,
        onMouseLeave
    ]);
    $9f88fd1702060c93$var$useMapsEventListener(marker, 'drag', onDrag);
    $9f88fd1702060c93$var$useMapsEventListener(marker, 'dragstart', onDragStart);
    $9f88fd1702060c93$var$useMapsEventListener(marker, 'dragend', onDragEnd);
    $9f88fd1702060c93$var$useDomEventListener(marker, 'gmp-click', onClick);
    $9f88fd1702060c93$var$useDomEventListener(marker, 'keydown', onKeyDown);
    $9f88fd1702060c93$var$useDomEventListener(marker, 'keyup', onKeyUp);
    $9f88fd1702060c93$var$useDomEventListener(marker, 'mouseenter', onMouseEnter);
    $9f88fd1702060c93$var$useDomEventListener(marker, 'mouseleave', onMouseLeave);
    return [
        marker,
        contentContainer
    ];
}
function $9f88fd1702060c93$var$useAdvancedMarkerAnchoring(marker, anchorPoint, anchorLeft, anchorTop, hasChildren) {
    (0, $8FY87.useEffect)(()=>{
        if (!marker || !hasChildren) return;
        // The anchorLeft and anchorTop options are available since version 3.62.9c
        // With the release of 3.65 (~May 2026) there will no longer be a version
        // that doesn't support it.
        const anchorOptionsSupported = $9f88fd1702060c93$var$isVersionGreaterEqual(3, 62);
        const contentElement = marker.content;
        if (!contentElement || !$9f88fd1702060c93$var$isElementNode(contentElement)) return;
        if (anchorLeft !== undefined || anchorTop !== undefined) {
            if (!anchorOptionsSupported) console.warn("AdvancedMarker: The anchorLeft and anchorTop props are only supported in Google Maps API version 3.62 and above. " + `The current version is ${google.maps.version}.`);
            marker.anchorLeft = anchorLeft;
            marker.anchorTop = anchorTop;
            // when anchorLeft and/or anchorTop are set, we'll ignore the anchorPoint
            if (anchorPoint !== undefined) console.warn("AdvancedMarker: the anchorPoint prop is ignored when anchorLeft and/or anchorTop are set.");
            return;
        }
        if (anchorPoint !== undefined) {
            // TODO: add console.warn in a future version to inform about deprecation
            const [x, y] = anchorPoint !== null && anchorPoint !== void 0 ? anchorPoint : $9f88fd1702060c93$export$5a0544ba0e628ca7['BOTTOM'];
            // NOTE: since x and y can be any valid CSS length-percentage
            //   value, we need to use calc() to negate them.
            const translateX = `calc(-1 * ${x})`;
            const translateY = `calc(-1 * ${y})`;
            if (anchorOptionsSupported) {
                // implement anchorPoint using the new anchorLeft and anchorTop options
                marker.anchorLeft = translateX;
                marker.anchorTop = translateY;
                // reset transform from legacy implementation
                contentElement.style.transform = '';
            } else {
                // The "translate(50%, 100%)" counters and resets the default
                // anchoring of the advanced marker element from the api
                contentElement.style.transform = `translate(50%, 100%) translate(${translateX}, ${translateY})`;
                // data-origin is needed to identify the custom marker content in the
                // InfoWindow component as well as in the global CSS used to disable
                // the pointer event when anchor points are used in older Google Maps
                // versions.
                marker.dataset.origin = 'rgm';
                $9f88fd1702060c93$var$globalStyleManager.addAdvancedMarkerPointerEventsOverwrite();
            }
        }
    }, [
        marker,
        anchorPoint,
        anchorLeft,
        anchorTop,
        hasChildren
    ]);
}
function $9f88fd1702060c93$var$useCircle(props) {
    var _a, _b, _c;
    const { onClick: onClick, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onRadiusChanged: onRadiusChanged, onCenterChanged: onCenterChanged, center: center, defaultCenter: defaultCenter, radius: radius, defaultRadius: defaultRadius } = props, destructuredOptions = $9f88fd1702060c93$var$__rest(props, [
        "onClick",
        "onDrag",
        "onDragStart",
        "onDragEnd",
        "onMouseOver",
        "onMouseOut",
        "onRadiusChanged",
        "onCenterChanged",
        "center",
        "defaultCenter",
        "radius",
        "defaultRadius"
    ]);
    const [circle, setCircle] = (0, $8FY87.useState)(null);
    const map = $9f88fd1702060c93$export$86f8f9f08863e403();
    // Memoize options with automatic inference of clickable/draggable/editable
    const circleOptions = $9f88fd1702060c93$var$useMemoized(Object.assign(Object.assign({}, destructuredOptions), {
        clickable: (_a = destructuredOptions.clickable) !== null && _a !== void 0 ? _a : Boolean(onClick),
        draggable: (_b = destructuredOptions.draggable) !== null && _b !== void 0 ? _b : Boolean(onDrag || onDragStart || onDragEnd || onCenterChanged),
        editable: (_c = destructuredOptions.editable) !== null && _c !== void 0 ? _c : Boolean(onRadiusChanged)
    }), $9f88fd1702060c93$var$deepEqual);
    (0, $8FY87.useEffect)(()=>{
        if (!map) {
            if (map === undefined) console.error('<Circle> has to be inside a Map component.');
            return;
        }
        const newCircle = new google.maps.Circle(Object.assign(Object.assign({}, circleOptions), {
            center: center !== null && center !== void 0 ? center : defaultCenter,
            radius: radius !== null && radius !== void 0 ? radius : defaultRadius
        }));
        newCircle.setMap(map);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setCircle(newCircle);
        return ()=>{
            newCircle.setMap(null);
            setCircle(null);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- circle options are handled separately to avoid recreating the instance
    }, [
        map
    ]);
    $9f88fd1702060c93$var$useMapsEventListener(circle, 'click', onClick);
    $9f88fd1702060c93$var$useMapsEventListener(circle, 'drag', onDrag);
    $9f88fd1702060c93$var$useMapsEventListener(circle, 'dragstart', onDragStart);
    $9f88fd1702060c93$var$useMapsEventListener(circle, 'dragend', onDragEnd);
    $9f88fd1702060c93$var$useMapsEventListener(circle, 'mouseover', onMouseOver);
    $9f88fd1702060c93$var$useMapsEventListener(circle, 'mouseout', onMouseOut);
    $9f88fd1702060c93$var$useMapsEventListener(circle, 'radius_changed', onRadiusChanged ? ()=>{
        const newRadius = circle === null || circle === void 0 ? void 0 : circle.getRadius();
        if (newRadius !== undefined) onRadiusChanged(newRadius);
    } : null);
    $9f88fd1702060c93$var$useMapsEventListener(circle, 'center_changed', onCenterChanged ? ()=>{
        onCenterChanged(circle === null || circle === void 0 ? void 0 : circle.getCenter());
    } : null);
    (0, $8FY87.useEffect)(()=>{
        if (!circle) return;
        circle.setOptions(circleOptions);
    }, [
        circle,
        circleOptions
    ]);
    // Sync controlled center prop with the circle instance
    (0, $8FY87.useEffect)(()=>{
        if (!circle || !center) return;
        if (!$9f88fd1702060c93$export$e6f27d7c3c3233eb(center, circle.getCenter())) circle.setCenter(center);
    }, [
        circle,
        center
    ]);
    // Sync controlled radius prop with the circle instance
    (0, $8FY87.useEffect)(()=>{
        if (!circle || radius === undefined) return;
        if (radius !== circle.getRadius()) circle.setRadius(radius);
    }, [
        circle,
        radius
    ]);
    return circle;
}
const $9f88fd1702060c93$export$c89a927ffc67e6fa = (0, $8FY87.forwardRef)((props, ref)=>{
    const circle = $9f88fd1702060c93$var$useCircle(props);
    (0, $8FY87.useImperativeHandle)(ref, ()=>circle, [
        circle
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null);
});
$9f88fd1702060c93$export$c89a927ffc67e6fa.displayName = 'Circle';
function $9f88fd1702060c93$var$setValueForStyles(element, styles, prevStyles) {
    if (styles != null && typeof styles !== 'object') throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    const elementStyle = element.style;
    // without `prevStyles`, just set all values
    if (prevStyles == null) {
        if (styles == null) return;
        for(const styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            $9f88fd1702060c93$var$setValueForStyle(elementStyle, styleName, styles[styleName]);
        }
        return;
    }
    // unset all styles in `prevStyles` that aren't in `styles`
    for(const styleName in prevStyles)if (prevStyles.hasOwnProperty(styleName) && (styles == null || !styles.hasOwnProperty(styleName))) {
        // Clear style
        const isCustomProperty = styleName.indexOf('--') === 0;
        if (isCustomProperty) elementStyle.setProperty(styleName, '');
        else if (styleName === 'float') elementStyle.cssFloat = '';
        else elementStyle[styleName] = '';
    }
    // only assign values from `styles` that are different from `prevStyles`
    if (styles == null) return;
    for(const styleName in styles){
        const value = styles[styleName];
        if (styles.hasOwnProperty(styleName) && prevStyles[styleName] !== value) $9f88fd1702060c93$var$setValueForStyle(elementStyle, styleName, value);
    }
}
function $9f88fd1702060c93$var$setValueForStyle(elementStyle, styleName, value) {
    const isCustomProperty = styleName.indexOf('--') === 0;
    // falsy values will unset the style property
    if (value == null || typeof value === 'boolean' || value === '') {
        if (isCustomProperty) elementStyle.setProperty(styleName, '');
        else if (styleName === 'float') elementStyle.cssFloat = '';
        else elementStyle[styleName] = '';
    } else if (isCustomProperty) elementStyle.setProperty(styleName, value);
    else if (typeof value === 'number' && value !== 0 && !$9f88fd1702060c93$var$isUnitlessNumber(styleName)) elementStyle[styleName] = value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
    else if (styleName === 'float') elementStyle.cssFloat = value;
    else elementStyle[styleName] = ('' + value).trim();
}
// CSS properties which accept numbers but are not in units of "px".
const $9f88fd1702060c93$var$unitlessNumbers = new Set([
    'animationIterationCount',
    'aspectRatio',
    'borderImageOutset',
    'borderImageSlice',
    'borderImageWidth',
    'boxFlex',
    'boxFlexGroup',
    'boxOrdinalGroup',
    'columnCount',
    'columns',
    'flex',
    'flexGrow',
    'flexPositive',
    'flexShrink',
    'flexNegative',
    'flexOrder',
    'gridArea',
    'gridRow',
    'gridRowEnd',
    'gridRowSpan',
    'gridRowStart',
    'gridColumn',
    'gridColumnEnd',
    'gridColumnSpan',
    'gridColumnStart',
    'fontWeight',
    'lineClamp',
    'lineHeight',
    'opacity',
    'order',
    'orphans',
    'scale',
    'tabSize',
    'widows',
    'zIndex',
    'zoom',
    'fillOpacity',
    'floodOpacity',
    'stopOpacity',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth'
]);
function $9f88fd1702060c93$var$isUnitlessNumber(name) {
    return $9f88fd1702060c93$var$unitlessNumbers.has(name);
}
/**
 * Component to render an Info Window with the Maps JavaScript API
 */ const $9f88fd1702060c93$export$6cfec3928ae8881a = (props)=>{
    const { children: // content options
    children, headerContent: headerContent, style: style, className: className, pixelOffset: pixelOffset, anchor: // open options
    anchor, shouldFocus: shouldFocus, onClose: // events
    onClose, onCloseClick: onCloseClick } = props, // other options
    volatileInfoWindowOptions = $9f88fd1702060c93$var$__rest(props, [
        "children",
        "headerContent",
        "style",
        "className",
        "pixelOffset",
        "anchor",
        "shouldFocus",
        "onClose",
        "onCloseClick"
    ]);
    // ## create infowindow instance once the mapsLibrary is available.
    const mapsLibrary = $9f88fd1702060c93$export$5b40cf36c69caef7('maps');
    const [infoWindow, setInfoWindow] = (0, $8FY87.useState)(null);
    const contentContainerRef = (0, $8FY87.useRef)(null);
    const headerContainerRef = (0, $8FY87.useRef)(null);
    const infoWindowOptions = $9f88fd1702060c93$var$useMemoized(volatileInfoWindowOptions, $9f88fd1702060c93$var$deepEqual);
    // ---- initial mount: create content- and header container, create and
    // configure the InfoWindow instance
    (0, $8FY87.useEffect)(()=>{
        if (!mapsLibrary) return;
        contentContainerRef.current = document.createElement('div');
        headerContainerRef.current = document.createElement('div');
        const opts = Object.assign({}, infoWindowOptions);
        if (pixelOffset) opts.pixelOffset = new google.maps.Size(pixelOffset[0], pixelOffset[1]);
        if (headerContent) // if headerContent is specified as string we can directly forward it,
        // otherwise we'll pass the element the portal will render into
        opts.headerContent = typeof headerContent === 'string' ? headerContent : headerContainerRef.current;
        // intentionally shadowing the state variables here
        const infoWindow = new google.maps.InfoWindow(opts);
        infoWindow.setContent(contentContainerRef.current);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setInfoWindow(infoWindow);
        // unmount: remove infoWindow and content elements (note: close is called in a different effect-cleanup)
        return ()=>{
            var _a, _b;
            infoWindow.setContent(null);
            (_a = contentContainerRef.current) === null || _a === void 0 || _a.remove();
            (_b = headerContainerRef.current) === null || _b === void 0 || _b.remove();
            contentContainerRef.current = null;
            headerContainerRef.current = null;
            setInfoWindow(null);
        };
    }, // `infoWindowOptions` and other props are missing from dependencies:
    //
    // We don't want to re-create the infowindow instance
    // when the options change.
    // Updating the options is handled in the useEffect below.
    //
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        mapsLibrary
    ]);
    // ---- update className and styles for `contentContainer`
    // prevStyleRef stores previously applied style properties, so they can be
    // removed when unset
    const prevStyleRef = (0, $8FY87.useRef)(null);
    (0, $8FY87.useLayoutEffect)(()=>{
        if (!infoWindow || !contentContainerRef.current) return;
        $9f88fd1702060c93$var$setValueForStyles(contentContainerRef.current, style || null, prevStyleRef.current);
        prevStyleRef.current = style || null;
        if (className !== contentContainerRef.current.className) contentContainerRef.current.className = className || '';
    }, [
        infoWindow,
        className,
        style
    ]);
    // ---- update options
    (0, $8FY87.useEffect)(()=>{
        if (!infoWindow) return;
        const opts = Object.assign({}, infoWindowOptions);
        if (!pixelOffset) opts.pixelOffset = null;
        else opts.pixelOffset = new google.maps.Size(pixelOffset[0], pixelOffset[1]);
        if (!headerContent) opts.headerContent = null;
        else opts.headerContent = typeof headerContent === 'string' ? headerContent : headerContainerRef.current;
        infoWindow.setOptions(opts);
    }, // dependency `infoWindow` isn't needed since options are also passed
    // to the constructor when a new infoWindow is created.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        infoWindowOptions,
        pixelOffset,
        headerContent
    ]);
    // ---- bind event handlers
    $9f88fd1702060c93$var$useMapsEventListener(infoWindow, 'close', onClose);
    $9f88fd1702060c93$var$useMapsEventListener(infoWindow, 'closeclick', onCloseClick);
    // ---- open info window when content and map are available
    const map = $9f88fd1702060c93$export$86f8f9f08863e403();
    (0, $8FY87.useEffect)(()=>{
        var _a;
        // `anchor === null` means an anchor is defined but not ready yet.
        if (!map || !infoWindow || anchor === null) return;
        const isOpenedWithAnchor = !!anchor;
        const openOptions = {
            map: map
        };
        if (anchor) {
            openOptions.anchor = anchor;
            // Only do the infowindow adjusting when dealing with an AdvancedMarker
            if ($9f88fd1702060c93$export$5f1640ccc146ea2d(anchor) && anchor.content instanceof Element) {
                const anchorBcr = anchor === null || anchor === void 0 ? void 0 : anchor.getBoundingClientRect();
                // This checks whether or not the anchor has custom content with our own
                // div wrapper. If not, that means we have a regular AdvancedMarker without
                // children, or an AdvancedMarker that uses the anchorLeft/anchorTop props.
                // In that case we do not want to adjust the infowindow since it is all handled correctly
                // by the Google Maps API.
                if (anchorBcr && anchor.dataset.origin === 'rgm') {
                    // We can safely typecast here since we control that element and we know that
                    // it is a div
                    const anchorDomContent = (_a = anchor.content.firstElementChild) === null || _a === void 0 ? void 0 : _a.firstElementChild;
                    const contentBcr = anchorDomContent === null || anchorDomContent === void 0 ? void 0 : anchorDomContent.getBoundingClientRect();
                    // center infowindow above marker
                    const anchorOffsetX = contentBcr.x - anchorBcr.x + (contentBcr.width - anchorBcr.width) / 2;
                    const anchorOffsetY = contentBcr.y - anchorBcr.y;
                    const opts = Object.assign({}, infoWindowOptions);
                    opts.pixelOffset = new google.maps.Size(pixelOffset ? pixelOffset[0] + anchorOffsetX : anchorOffsetX, pixelOffset ? pixelOffset[1] + anchorOffsetY : anchorOffsetY);
                    infoWindow.setOptions(opts);
                }
            }
        }
        if (shouldFocus !== undefined) openOptions.shouldFocus = shouldFocus;
        infoWindow.open(openOptions);
        return ()=>{
            // Note: when the infowindow has an anchor, it will automatically show up again when the
            // anchor was removed from the map before infoWindow.close() is called but the it gets
            // added back to the map after that.
            // More information here: https://issuetracker.google.com/issues/343750849
            if (isOpenedWithAnchor) infoWindow.set('anchor', null);
            infoWindow.close();
        };
    }, [
        infoWindow,
        anchor,
        map,
        shouldFocus,
        infoWindowOptions,
        pixelOffset
    ]);
    /* eslint-disable react-hooks/refs -- intentional access to refs during render to avoid cascading renders when creating portals */ return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null, contentContainerRef.current && (0, $95gxM.createPortal)(children, contentContainerRef.current), headerContainerRef.current !== null && (0, $95gxM.createPortal)(headerContent, headerContainerRef.current));
/* eslint-enable react-hooks/refs */ };
/**
 * Extracts paths as a nested array from a Polygon instance.
 */ function $9f88fd1702060c93$var$getPathsArray(polygon) {
    const mvcPaths = polygon.getPaths();
    const result = [];
    for(let i = 0; i < mvcPaths.getLength(); i++)result.push(mvcPaths.getAt(i).getArray());
    return result;
}
function $9f88fd1702060c93$var$usePolygon(props) {
    var _a, _b, _c;
    const { onClick: onClick, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onPathsChanged: onPathsChanged, polygon: externalPolygon, encodedPaths: encodedPaths, paths: paths, defaultPaths: defaultPaths } = props, destructuredOptions = $9f88fd1702060c93$var$__rest(props, [
        "onClick",
        "onDrag",
        "onDragStart",
        "onDragEnd",
        "onMouseOver",
        "onMouseOut",
        "onPathsChanged",
        "polygon",
        "encodedPaths",
        "paths",
        "defaultPaths"
    ]);
    const [polygon, setPolygon] = (0, $8FY87.useState)(null);
    const map = $9f88fd1702060c93$export$86f8f9f08863e403();
    const geometryLibrary = $9f88fd1702060c93$export$5b40cf36c69caef7('geometry');
    // Track if we're programmatically updating to avoid firing onPathsChanged
    const isUpdatingRef = (0, $8FY87.useRef)(false);
    // Memoize options with automatic inference of clickable/draggable/editable
    const polygonOptions = $9f88fd1702060c93$var$useMemoized(Object.assign(Object.assign({}, destructuredOptions), {
        clickable: (_a = destructuredOptions.clickable) !== null && _a !== void 0 ? _a : Boolean(onClick),
        draggable: (_b = destructuredOptions.draggable) !== null && _b !== void 0 ? _b : Boolean(onDrag || onDragStart || onDragEnd || onPathsChanged),
        editable: (_c = destructuredOptions.editable) !== null && _c !== void 0 ? _c : Boolean(onPathsChanged)
    }), $9f88fd1702060c93$var$deepEqual);
    (0, $8FY87.useEffect)(()=>{
        if (!map) {
            if (map === undefined) console.error('<Polygon> has to be inside a Map component.');
            return;
        }
        // Use provided instance or create a new one
        let instance;
        if (externalPolygon) {
            instance = externalPolygon;
            // Apply initial paths and options to the existing instance
            const initialPaths = paths !== null && paths !== void 0 ? paths : defaultPaths;
            if (initialPaths && Array.isArray(initialPaths)) instance.setPaths(initialPaths);
            instance.setOptions(polygonOptions);
        } else {
            const initialPaths = paths !== null && paths !== void 0 ? paths : defaultPaths;
            const polygonOptionsWithPaths = Object.assign({}, polygonOptions);
            // Google Maps throws "not an Array" error if paths is undefined
            if (initialPaths && Array.isArray(initialPaths)) polygonOptionsWithPaths.paths = initialPaths;
            instance = new google.maps.Polygon(polygonOptionsWithPaths);
        }
        instance.setMap(map);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setPolygon(instance);
        return ()=>{
            instance.setMap(null);
            setPolygon(null);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- options are handled separately to avoid recreating the instance
    }, [
        map,
        externalPolygon
    ]);
    $9f88fd1702060c93$var$useMapsEventListener(polygon, 'click', onClick);
    $9f88fd1702060c93$var$useMapsEventListener(polygon, 'drag', onDrag);
    $9f88fd1702060c93$var$useMapsEventListener(polygon, 'dragstart', onDragStart);
    $9f88fd1702060c93$var$useMapsEventListener(polygon, 'mouseover', onMouseOver);
    $9f88fd1702060c93$var$useMapsEventListener(polygon, 'mouseout', onMouseOut);
    // Fire onPathsChanged on dragend (when whole polygon is dragged)
    $9f88fd1702060c93$var$useMapsEventListener(polygon, 'dragend', (e)=>{
        onDragEnd === null || onDragEnd === void 0 || onDragEnd(e);
        if (onPathsChanged && polygon && !isUpdatingRef.current) onPathsChanged($9f88fd1702060c93$var$getPathsArray(polygon));
    });
    // Subscribe to MVCArray events for vertex-level edits
    (0, $8FY87.useEffect)(()=>{
        if (!polygon || !onPathsChanged) return;
        const listeners = [];
        const mvcPaths = polygon.getPaths();
        if (typeof mvcPaths.getLength !== 'function' || typeof mvcPaths.getAt !== 'function') return;
        const handlePathsChange = ()=>{
            if (!isUpdatingRef.current) onPathsChanged($9f88fd1702060c93$var$getPathsArray(polygon));
        };
        // Subscribe to each inner path's events
        const subscribeToInnerPath = (innerPath)=>{
            listeners.push(google.maps.event.addListener(innerPath, 'insert_at', handlePathsChange));
            listeners.push(google.maps.event.addListener(innerPath, 'remove_at', handlePathsChange));
            listeners.push(google.maps.event.addListener(innerPath, 'set_at', handlePathsChange));
        };
        // Subscribe to existing inner paths
        for(let i = 0; i < mvcPaths.getLength(); i++)subscribeToInnerPath(mvcPaths.getAt(i));
        // Subscribe to outer array changes (paths added/removed)
        listeners.push(google.maps.event.addListener(mvcPaths, 'insert_at', (index)=>{
            subscribeToInnerPath(mvcPaths.getAt(index));
            handlePathsChange();
        }));
        listeners.push(google.maps.event.addListener(mvcPaths, 'set_at', (index)=>{
            subscribeToInnerPath(mvcPaths.getAt(index));
            handlePathsChange();
        }));
        listeners.push(google.maps.event.addListener(mvcPaths, 'remove_at', handlePathsChange));
        return ()=>{
            listeners.forEach((listener)=>listener.remove());
        };
    }, [
        polygon,
        onPathsChanged,
        paths,
        encodedPaths,
        polygonOptions.editable,
        polygonOptions.draggable
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (!polygon) return;
        polygon.setOptions(polygonOptions);
    }, [
        polygon,
        polygonOptions
    ]);
    // Sync controlled paths prop with the polygon instance
    (0, $8FY87.useEffect)(()=>{
        if (!polygon || !paths) return;
        if (!Array.isArray(paths)) return;
        // Normalize to nested array for comparison
        const firstPath = paths[0];
        const normalizedPaths = Array.isArray(firstPath) ? paths : [
            paths
        ];
        const currentPaths = polygon.getPaths();
        if (!$9f88fd1702060c93$export$81bf7c9065d0b5e1(normalizedPaths, currentPaths)) {
            isUpdatingRef.current = true;
            polygon.setPaths(paths);
            isUpdatingRef.current = false;
        }
    }, [
        polygon,
        paths
    ]);
    // Handle encoded paths
    (0, $8FY87.useEffect)(()=>{
        if (!polygon || !encodedPaths || !geometryLibrary) return;
        isUpdatingRef.current = true;
        const decodedPaths = encodedPaths.map((encodedPath)=>geometryLibrary.encoding.decodePath(encodedPath));
        polygon.setPaths(decodedPaths);
        isUpdatingRef.current = false;
    }, [
        polygon,
        encodedPaths,
        geometryLibrary
    ]);
    return polygon;
}
const $9f88fd1702060c93$export$7d31b617c820d435 = (0, $8FY87.forwardRef)((props, ref)=>{
    const polygon = $9f88fd1702060c93$var$usePolygon(props);
    (0, $8FY87.useImperativeHandle)(ref, ()=>polygon, [
        polygon
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null);
});
$9f88fd1702060c93$export$7d31b617c820d435.displayName = 'Polygon';
function $9f88fd1702060c93$var$usePolyline(props) {
    var _a, _b, _c;
    const { onClick: onClick, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onPathChanged: onPathChanged, polyline: externalPolyline, encodedPath: encodedPath, path: path, defaultPath: defaultPath } = props, destructuredOptions = $9f88fd1702060c93$var$__rest(props, [
        "onClick",
        "onDrag",
        "onDragStart",
        "onDragEnd",
        "onMouseOver",
        "onMouseOut",
        "onPathChanged",
        "polyline",
        "encodedPath",
        "path",
        "defaultPath"
    ]);
    const [polyline, setPolyline] = (0, $8FY87.useState)(null);
    const map = $9f88fd1702060c93$export$86f8f9f08863e403();
    const geometryLibrary = $9f88fd1702060c93$export$5b40cf36c69caef7('geometry');
    // Track if we're programmatically updating to avoid firing onPathChanged
    const isUpdatingRef = (0, $8FY87.useRef)(false);
    // Memoize options with automatic inference of clickable/draggable/editable
    const polylineOptions = $9f88fd1702060c93$var$useMemoized(Object.assign(Object.assign({}, destructuredOptions), {
        clickable: (_a = destructuredOptions.clickable) !== null && _a !== void 0 ? _a : Boolean(onClick),
        draggable: (_b = destructuredOptions.draggable) !== null && _b !== void 0 ? _b : Boolean(onDrag || onDragStart || onDragEnd || onPathChanged),
        editable: (_c = destructuredOptions.editable) !== null && _c !== void 0 ? _c : Boolean(onPathChanged)
    }), $9f88fd1702060c93$var$deepEqual);
    (0, $8FY87.useEffect)(()=>{
        if (!map) {
            if (map === undefined) console.error('<Polyline> has to be inside a Map component.');
            return;
        }
        // Use provided instance or create a new one
        let instance;
        if (externalPolyline) {
            instance = externalPolyline;
            // Apply initial path and options to the existing instance
            const initialPath = path !== null && path !== void 0 ? path : defaultPath;
            if (initialPath && Array.isArray(initialPath)) instance.setPath(initialPath);
            instance.setOptions(polylineOptions);
        } else {
            const initialPath = path !== null && path !== void 0 ? path : defaultPath;
            const polylineOptionsWithPath = Object.assign({}, polylineOptions);
            // Google Maps throws "not an Array" error if path is undefined
            if (initialPath && Array.isArray(initialPath)) polylineOptionsWithPath.path = initialPath;
            instance = new google.maps.Polyline(polylineOptionsWithPath);
        }
        instance.setMap(map);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setPolyline(instance);
        return ()=>{
            instance.setMap(null);
            setPolyline(null);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- options are handled separately to avoid recreating the instance
    }, [
        map,
        externalPolyline
    ]);
    $9f88fd1702060c93$var$useMapsEventListener(polyline, 'click', onClick);
    $9f88fd1702060c93$var$useMapsEventListener(polyline, 'drag', onDrag);
    $9f88fd1702060c93$var$useMapsEventListener(polyline, 'dragstart', onDragStart);
    $9f88fd1702060c93$var$useMapsEventListener(polyline, 'mouseover', onMouseOver);
    $9f88fd1702060c93$var$useMapsEventListener(polyline, 'mouseout', onMouseOut);
    // Fire onPathChanged on dragend (when whole polyline is dragged)
    $9f88fd1702060c93$var$useMapsEventListener(polyline, 'dragend', (e)=>{
        onDragEnd === null || onDragEnd === void 0 || onDragEnd(e);
        if (onPathChanged && polyline && !isUpdatingRef.current) onPathChanged(polyline.getPath().getArray());
    });
    // Subscribe to MVCArray events for vertex-level edits
    (0, $8FY87.useEffect)(()=>{
        if (!polyline || !onPathChanged) return;
        const mvcPath = polyline.getPath();
        if (!mvcPath) return;
        const handlePathChange = ()=>{
            if (!isUpdatingRef.current) onPathChanged(mvcPath.getArray());
        };
        const listeners = [
            google.maps.event.addListener(mvcPath, 'insert_at', handlePathChange),
            google.maps.event.addListener(mvcPath, 'remove_at', handlePathChange),
            google.maps.event.addListener(mvcPath, 'set_at', handlePathChange)
        ];
        return ()=>{
            listeners.forEach((listener)=>listener.remove());
        };
    }, [
        polyline,
        onPathChanged,
        path,
        encodedPath,
        polylineOptions.editable,
        polylineOptions.draggable
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (!polyline) return;
        polyline.setOptions(polylineOptions);
    }, [
        polyline,
        polylineOptions
    ]);
    // Sync controlled path prop with the polyline instance
    (0, $8FY87.useEffect)(()=>{
        if (!polyline || !path) return;
        const currentPath = polyline.getPath();
        if (!$9f88fd1702060c93$export$69485f8143efb551(path, currentPath)) {
            isUpdatingRef.current = true;
            polyline.setPath(path);
            isUpdatingRef.current = false;
        }
    }, [
        polyline,
        path
    ]);
    // Handle encoded path
    (0, $8FY87.useEffect)(()=>{
        if (!polyline || !encodedPath || !geometryLibrary) return;
        isUpdatingRef.current = true;
        const decodedPath = geometryLibrary.encoding.decodePath(encodedPath);
        polyline.setPath(decodedPath);
        isUpdatingRef.current = false;
    }, [
        polyline,
        encodedPath,
        geometryLibrary
    ]);
    return polyline;
}
const $9f88fd1702060c93$export$79f3ee03e63e7073 = (0, $8FY87.forwardRef)((props, ref)=>{
    const polyline = $9f88fd1702060c93$var$usePolyline(props);
    (0, $8FY87.useImperativeHandle)(ref, ()=>polyline, [
        polyline
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null);
});
$9f88fd1702060c93$export$79f3ee03e63e7073.displayName = 'Polyline';
const $9f88fd1702060c93$var$DEFAULT_CAMERA_STATE = {
    center: {
        lat: 0,
        lng: 0,
        altitude: 0
    },
    range: 0,
    heading: 0,
    tilt: 0,
    roll: 0
};
/**
 * Camera property names that correspond to gmp-*change events.
 */ const $9f88fd1702060c93$var$CAMERA_PROPS = [
    'center',
    'range',
    'heading',
    'tilt',
    'roll'
];
/**
 * Updates the camera state ref with values from the map element.
 */ function $9f88fd1702060c93$var$updateCameraState(map3d, ref, prop) {
    const value = map3d[prop];
    if (value == null) return;
    if (prop === 'center') {
        // The center property returns a LatLngAltitude object, convert to literal
        const center = value;
        ref.current.center = center.toJSON ? center.toJSON() : center;
    } else ref.current[prop] = value;
}
/**
 * Creates a mutable ref object to track the last known state of the 3D map camera.
 * This is used in `useMap3DCameraParams` to reduce stuttering by avoiding updates
 * of the map camera with values that have already been processed.
 *
 * @internal
 */ function $9f88fd1702060c93$var$useTrackedCameraStateRef3D(map3d) {
    const forceUpdate = $9f88fd1702060c93$var$useForceUpdate();
    const ref = (0, $8FY87.useRef)(Object.assign({}, $9f88fd1702060c93$var$DEFAULT_CAMERA_STATE));
    (0, $8FY87.useEffect)(()=>{
        if (!map3d) return;
        const listeners = [];
        for (const prop of $9f88fd1702060c93$var$CAMERA_PROPS){
            const eventName = `gmp-${prop}change`;
            const handler = ()=>{
                $9f88fd1702060c93$var$updateCameraState(map3d, ref, prop);
                forceUpdate();
            };
            map3d.addEventListener(eventName, handler);
            listeners.push(()=>map3d.removeEventListener(eventName, handler));
        }
        return ()=>{
            for (const removeListener of listeners)removeListener();
        };
    }, [
        map3d,
        forceUpdate
    ]);
    return ref;
}
/**
 * Hook to manage the Map3DElement instance lifecycle.
 *
 * Handles:
 * - Waiting for the 'maps3d' library to load
 * - Waiting for the 'gmp-map-3d' custom element to be defined
 * - Creating a callback ref for the element
 * - Applying initial options when the element is ready
 * - Tracking camera state
 *
 * @internal
 */ function $9f88fd1702060c93$var$useMap3DInstance(props) {
    const maps3dLib = $9f88fd1702060c93$export$5b40cf36c69caef7('maps3d');
    const [customElementReady, setCustomElementReady] = (0, $8FY87.useState)(false);
    const [, containerRef] = $9f88fd1702060c93$var$useCallbackRef();
    const [map3d, map3dRef] = $9f88fd1702060c93$var$useCallbackRef();
    const cameraStateRef = $9f88fd1702060c93$var$useTrackedCameraStateRef3D(map3d);
    (0, $8FY87.useEffect)(()=>{
        customElements.whenDefined('gmp-map-3d').then(()=>{
            setCustomElementReady(true);
        });
    }, []);
    // Apply initial options once when the element is first available
    (0, $8FY87.useEffect)(()=>{
        if (!map3d) return;
        const { center: center, heading: heading, tilt: tilt, range: range, roll: roll, defaultCenter: defaultCenter, defaultHeading: defaultHeading, defaultTilt: defaultTilt, defaultRange: defaultRange, defaultRoll: defaultRoll, id: // Non-element props to exclude
        id, style: style, className: className, children: children, onCenterChanged: onCenterChanged, onHeadingChanged: onHeadingChanged, onTiltChanged: onTiltChanged, onRangeChanged: onRangeChanged, onRollChanged: onRollChanged, onCameraChanged: onCameraChanged, onClick: onClick, onSteadyChange: onSteadyChange, onAnimationEnd: onAnimationEnd, onError: onError, mode: mode, gestureHandling: gestureHandling } = props, elementOptions = $9f88fd1702060c93$var$__rest(props, [
            "center",
            "heading",
            "tilt",
            "range",
            "roll",
            "defaultCenter",
            "defaultHeading",
            "defaultTilt",
            "defaultRange",
            "defaultRoll",
            "id",
            "style",
            "className",
            "children",
            "onCenterChanged",
            "onHeadingChanged",
            "onTiltChanged",
            "onRangeChanged",
            "onRollChanged",
            "onCameraChanged",
            "onClick",
            "onSteadyChange",
            "onAnimationEnd",
            "onError",
            "mode",
            "gestureHandling"
        ]);
        const initialCenter = center !== null && center !== void 0 ? center : defaultCenter;
        const initialHeading = heading !== null && heading !== void 0 ? heading : defaultHeading;
        const initialTilt = tilt !== null && tilt !== void 0 ? tilt : defaultTilt;
        const initialRange = range !== null && range !== void 0 ? range : defaultRange;
        const initialRoll = roll !== null && roll !== void 0 ? roll : defaultRoll;
        const initialOptions = Object.assign({}, elementOptions);
        if (initialCenter) initialOptions.center = initialCenter;
        if (initialHeading !== undefined) initialOptions.heading = initialHeading;
        if (initialTilt !== undefined) initialOptions.tilt = initialTilt;
        if (initialRange !== undefined) initialOptions.range = initialRange;
        if (initialRoll !== undefined) initialOptions.roll = initialRoll;
        Object.assign(map3d, initialOptions);
    }, // this effect should only run when the map3d element first becomes
    // available, so we skip re-running it when other props change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        map3d
    ]);
    const isReady = !!maps3dLib && customElementReady;
    return [
        map3d,
        containerRef,
        map3dRef,
        cameraStateRef,
        isReady
    ];
}
/* eslint-disable react-hooks/immutability -- Google Maps API objects are designed to be mutated */ /**
 * Converts a LatLngAltitude or LatLngAltitudeLiteral to a literal object.
 */ function $9f88fd1702060c93$var$toLatLngAltitudeLiteral(value) {
    if (!value) return null;
    // Check if it's a LatLngAltitude object with toJSON method
    if ('toJSON' in value && typeof value.toJSON === 'function') return value.toJSON();
    return value;
}
/**
 * Hook to update Map3D camera parameters when props change.
 * Compares the current camera state with props and updates only when there are differences.
 *
 * @internal
 */ function $9f88fd1702060c93$var$useMap3DCameraParams(map3d, cameraStateRef, props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const centerLiteral = $9f88fd1702060c93$var$toLatLngAltitudeLiteral(props.center);
    const lat = (_a = centerLiteral === null || centerLiteral === void 0 ? void 0 : centerLiteral.lat) !== null && _a !== void 0 ? _a : null;
    const lng = (_b = centerLiteral === null || centerLiteral === void 0 ? void 0 : centerLiteral.lng) !== null && _b !== void 0 ? _b : null;
    const altitude = (_c = centerLiteral === null || centerLiteral === void 0 ? void 0 : centerLiteral.altitude) !== null && _c !== void 0 ? _c : null;
    const range = (_d = props.range) !== null && _d !== void 0 ? _d : null;
    const heading = (_e = props.heading) !== null && _e !== void 0 ? _e : null;
    const tilt = (_f = props.tilt) !== null && _f !== void 0 ? _f : null;
    const roll = (_g = props.roll) !== null && _g !== void 0 ? _g : null;
    // Runs on every render to sync controlled camera props with the map element
    (0, $8FY87.useLayoutEffect)(()=>{
        var _a;
        if (!map3d) return;
        const currentState = cameraStateRef.current;
        if (lat !== null && lng !== null && (currentState.center.lat !== lat || currentState.center.lng !== lng || altitude !== null && currentState.center.altitude !== altitude)) map3d.center = {
            lat: lat,
            lng: lng,
            altitude: (_a = altitude !== null && altitude !== void 0 ? altitude : currentState.center.altitude) !== null && _a !== void 0 ? _a : 0
        };
        if (range !== null && currentState.range !== range) map3d.range = range;
        if (heading !== null && currentState.heading !== heading) map3d.heading = heading;
        if (tilt !== null && currentState.tilt !== tilt) map3d.tilt = tilt;
        if (roll !== null && currentState.roll !== roll) map3d.roll = roll;
    });
}
/**
 * Camera-related event types for the aggregated onCameraChanged handler.
 */ const $9f88fd1702060c93$var$CAMERA_EVENTS = [
    'gmp-centerchange',
    'gmp-headingchange',
    'gmp-tiltchange',
    'gmp-rangechange',
    'gmp-rollchange'
];
/**
 * Creates a camera changed event with current camera state.
 */ function $9f88fd1702060c93$var$createCameraEvent(map3d, type) {
    const center = map3d.center;
    // Normalize center to LatLngAltitudeLiteral
    // If center is a LatLngAltitude class instance, it has a toJSON method
    // Otherwise it's already a literal object
    let centerLiteral;
    if (center && 'toJSON' in center && typeof center.toJSON === 'function') centerLiteral = center.toJSON();
    else if (center) centerLiteral = center;
    else centerLiteral = {
        lat: 0,
        lng: 0,
        altitude: 0
    };
    return {
        type: type,
        map3d: map3d,
        detail: {
            center: centerLiteral,
            range: map3d.range || 0,
            heading: map3d.heading || 0,
            tilt: map3d.tilt || 0,
            roll: map3d.roll || 0
        }
    };
}
/**
 * Creates a click event from a LocationClickEvent or PlaceClickEvent.
 */ function $9f88fd1702060c93$var$createClickEvent(map3d, srcEvent) {
    const placeClickEvent = srcEvent;
    return {
        type: 'gmp-click',
        map3d: map3d,
        detail: {
            position: srcEvent.position || null,
            placeId: placeClickEvent.placeId
        }
    };
}
/**
 * Creates a steady change event.
 */ function $9f88fd1702060c93$var$createSteadyChangeEvent(map3d, srcEvent) {
    return {
        type: 'gmp-steadychange',
        map3d: map3d,
        detail: {
            isSteady: srcEvent.isSteady
        }
    };
}
/**
 * Hook to set up event handlers for Map3D events.
 *
 * @internal
 */ function $9f88fd1702060c93$var$useMap3DEvents(map3d, props) {
    const { onCenterChanged: onCenterChanged, onHeadingChanged: onHeadingChanged, onTiltChanged: onTiltChanged, onRangeChanged: onRangeChanged, onRollChanged: onRollChanged, onCameraChanged: onCameraChanged, onClick: onClick, onSteadyChange: onSteadyChange, onAnimationEnd: onAnimationEnd, onError: onError } = props;
    $9f88fd1702060c93$var$useMap3DEvent(map3d, 'gmp-centerchange', onCenterChanged, $9f88fd1702060c93$var$createCameraEvent);
    $9f88fd1702060c93$var$useMap3DEvent(map3d, 'gmp-headingchange', onHeadingChanged, $9f88fd1702060c93$var$createCameraEvent);
    $9f88fd1702060c93$var$useMap3DEvent(map3d, 'gmp-tiltchange', onTiltChanged, $9f88fd1702060c93$var$createCameraEvent);
    $9f88fd1702060c93$var$useMap3DEvent(map3d, 'gmp-rangechange', onRangeChanged, $9f88fd1702060c93$var$createCameraEvent);
    $9f88fd1702060c93$var$useMap3DEvent(map3d, 'gmp-rollchange', onRollChanged, $9f88fd1702060c93$var$createCameraEvent);
    // onCameraChanged aggregates all camera property change events into one handler
    (0, $8FY87.useEffect)(()=>{
        if (!map3d || !onCameraChanged) return;
        const handler = ()=>{
            onCameraChanged($9f88fd1702060c93$var$createCameraEvent(map3d, 'camerachange'));
        };
        for (const eventName of $9f88fd1702060c93$var$CAMERA_EVENTS)map3d.addEventListener(eventName, handler);
        return ()=>{
            for (const eventName of $9f88fd1702060c93$var$CAMERA_EVENTS)map3d.removeEventListener(eventName, handler);
        };
    }, [
        map3d,
        onCameraChanged
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (!map3d || !onClick) return;
        const handler = (ev)=>{
            onClick($9f88fd1702060c93$var$createClickEvent(map3d, ev));
        };
        map3d.addEventListener('gmp-click', handler);
        return ()=>map3d.removeEventListener('gmp-click', handler);
    }, [
        map3d,
        onClick
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (!map3d || !onSteadyChange) return;
        const handler = (ev)=>{
            onSteadyChange($9f88fd1702060c93$var$createSteadyChangeEvent(map3d, ev));
        };
        map3d.addEventListener('gmp-steadychange', handler);
        return ()=>map3d.removeEventListener('gmp-steadychange', handler);
    }, [
        map3d,
        onSteadyChange
    ]);
    $9f88fd1702060c93$var$useMap3DEvent(map3d, 'gmp-animationend', onAnimationEnd, (map3d, type)=>({
            type: type,
            map3d: map3d
        }));
    $9f88fd1702060c93$var$useMap3DEvent(map3d, 'gmp-error', onError, (map3d, type)=>({
            type: type,
            map3d: map3d
        }));
}
/**
 * Helper hook for individual events.
 */ function $9f88fd1702060c93$var$useMap3DEvent(map3d, eventName, handler, createEvent) {
    (0, $8FY87.useEffect)(()=>{
        if (!map3d || !handler) return;
        const listener = ()=>{
            handler(createEvent(map3d, eventName));
        };
        map3d.addEventListener(eventName, listener);
        return ()=>map3d.removeEventListener(eventName, listener);
    }, [
        map3d,
        eventName,
        handler,
        createEvent
    ]);
}
/**
 * Set of option keys that can be updated on Map3DElement.
 * Camera props (center, heading, tilt, range, roll) are handled separately.
 */ const $9f88fd1702060c93$var$MAP_3D_OPTION_KEYS = new Set([
    'bounds',
    'defaultUIHidden',
    'gestureHandling',
    'internalUsageAttributionIds',
    'maxAltitude',
    'maxHeading',
    'maxTilt',
    'minAltitude',
    'minHeading',
    'minTilt',
    'mode'
]);
/**
 * Hook to update Map3D options when props change.
 *
 * @internal
 */ function $9f88fd1702060c93$var$useMap3DOptions(map3d, props) {
    // Filter props to only include valid option keys, memoized to avoid
    // creating a new object on every render
    const options = (0, $8FY87.useMemo)(()=>{
        const result = {};
        const keys = Object.keys(props);
        for (const key of keys){
            if (!$9f88fd1702060c93$var$MAP_3D_OPTION_KEYS.has(key)) continue;
            const value = props[key];
            if (value === undefined) continue;
            result[key] = value;
        }
        return result;
    }, [
        props
    ]);
    $9f88fd1702060c93$var$useDeepCompareEffect(()=>{
        if (!map3d) return;
        Object.assign(map3d, options);
    }, [
        map3d,
        options
    ]);
}
/**
 * MapMode for specifying how the 3D map should be rendered.
 * This mirrors google.maps.maps3d.MapMode but is available without waiting for the API to load.
 */ const $9f88fd1702060c93$export$39cf3280165f92aa = {
    /** This map mode displays a transparent layer of major streets on satellite imagery. */ HYBRID: 'HYBRID',
    /** This map mode displays satellite or photorealistic imagery. */ SATELLITE: 'SATELLITE'
};
/**
 * GestureHandling for specifying how gesture events should be handled on the map.
 * This mirrors google.maps.maps3d.GestureHandling but is available without waiting for the API to load.
 */ const $9f88fd1702060c93$export$9ac34b33b94379d1 = {
    /**
     * This lets the map choose whether to use cooperative or greedy gesture handling.
     * This is the default behavior if not specified.
     */ AUTO: 'AUTO',
    /**
     * This forces cooperative mode, where modifier keys or two-finger gestures
     * are required to scroll the map.
     */ COOPERATIVE: 'COOPERATIVE',
    /**
     * This forces greedy mode, where the host page cannot be scrolled from user
     * events on the map element.
     */ GREEDY: 'GREEDY'
};
/**
 * React context for accessing the Map3D instance from child components.
 */ const $9f88fd1702060c93$export$b4118d11ca82abca = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createContext(null);
/**
 * Default styles for the map container.
 */ const $9f88fd1702060c93$var$DEFAULT_CONTAINER_STYLE = {
    width: '100%',
    height: '100%',
    position: 'relative'
};
/**
 * A React component that renders a 3D map using the Google Maps JavaScript API.
 *
 * @example
 * ```tsx
 * <APIProvider apiKey={API_KEY}>
 *   <Map3D
 *     defaultCenter={{ lat: 37.7749, lng: -122.4194, altitude: 1000 }}
 *     defaultRange={5000}
 *     defaultHeading={0}
 *     defaultTilt={45}
 *   />
 * </APIProvider>
 * ```
 */ const $9f88fd1702060c93$export$e9000d5af15800a8 = (0, $8FY87.forwardRef)((props, ref)=>{
    const { children: children, id: id, className: className, style: style } = props;
    // Verify we're inside an APIProvider
    const context = (0, $8FY87.useContext)($9f88fd1702060c93$export$84e9974bcf67d1d);
    if (!context) throw new Error('<Map3D> can only be used inside an <APIProvider> component.');
    const { addMap3DInstance: addMap3DInstance, removeMap3DInstance: removeMap3DInstance } = context;
    const [map3d, containerRef, map3dRef, cameraStateRef, isReady] = $9f88fd1702060c93$var$useMap3DInstance(props);
    $9f88fd1702060c93$var$useMap3DCameraParams(map3d, cameraStateRef, props);
    $9f88fd1702060c93$var$useMap3DEvents(map3d, props);
    $9f88fd1702060c93$var$useMap3DOptions(map3d, props);
    (0, $8FY87.useEffect)(()=>{
        if (!map3d) return;
        const instanceId = id !== null && id !== void 0 ? id : 'default';
        addMap3DInstance(map3d, instanceId);
        return ()=>{
            removeMap3DInstance(instanceId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        map3d,
        id
    ]);
    (0, $8FY87.useImperativeHandle)(ref, ()=>({
            map3d: map3d,
            flyCameraAround: (options)=>{
                map3d === null || map3d === void 0 || map3d.flyCameraAround(options);
            },
            flyCameraTo: (options)=>{
                map3d === null || map3d === void 0 || map3d.flyCameraTo(options);
            },
            stopCameraAnimation: ()=>{
                map3d === null || map3d === void 0 || map3d.stopCameraAnimation();
            }
        }), [
        map3d
    ]);
    const combinedStyle = (0, $8FY87.useMemo)(()=>Object.assign(Object.assign({}, $9f88fd1702060c93$var$DEFAULT_CONTAINER_STYLE), style), [
        style
    ]);
    const contextValue = (0, $8FY87.useMemo)(()=>({
            map3d: map3d
        }), [
        map3d
    ]);
    if (!isReady) return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", Object.assign({
        ref: containerRef,
        "data-testid": "map-3d",
        style: className ? undefined : combinedStyle,
        className: className
    }, id ? {
        id: id
    } : {}));
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", Object.assign({
        ref: containerRef,
        "data-testid": "map-3d",
        style: className ? undefined : combinedStyle,
        className: className
    }, id ? {
        id: id
    } : {}), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("gmp-map-3d", {
        ref: map3dRef,
        style: {
            width: '100%',
            height: '100%'
        }
    }, map3d && (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($9f88fd1702060c93$export$b4118d11ca82abca.Provider, {
        value: contextValue
    }, children)));
});
$9f88fd1702060c93$export$e9000d5af15800a8.displayName = 'Map3D';
const $9f88fd1702060c93$export$f2451a5061be5eec = (0, $8FY87.createContext)(null);
/**
 * Hook to access the Marker3D context.
 */ function $9f88fd1702060c93$export$77f6962a5c3dbd02() {
    return (0, $8FY87.useContext)($9f88fd1702060c93$export$f2451a5061be5eec);
}
/**
 * AltitudeMode for specifying how altitude is interpreted for 3D elements.
 * This mirrors google.maps.maps3d.AltitudeMode but is available without waiting for the API to load.
 */ const $9f88fd1702060c93$export$daecfdca8d2f39c6 = {
    /** Allows to express objects relative to the average mean sea level. */ ABSOLUTE: 'ABSOLUTE',
    /** Allows to express objects placed on the ground. */ CLAMP_TO_GROUND: 'CLAMP_TO_GROUND',
    /** Allows to express objects relative to the ground surface. */ RELATIVE_TO_GROUND: 'RELATIVE_TO_GROUND',
    /** Allows to express objects relative to the highest of ground+building+water surface. */ RELATIVE_TO_MESH: 'RELATIVE_TO_MESH'
};
/**
 * Marker3D component for displaying markers on a Map3D.
 *
 * Automatically uses Marker3DInteractiveElement when onClick is provided,
 * otherwise uses Marker3DElement.
 *
 * Children can include:
 * - `<img>` elements (automatically wrapped in <template>)
 * - `<svg>` elements (automatically wrapped in <template>)
 * - PinElement instances (passed through directly)
 *
 * @example
 * ```tsx
 * // Basic marker
 * <Marker3D position={{ lat: 37.7749, lng: -122.4194 }} label="SF" />
 *
 * // Interactive marker
 * <Marker3D
 *   position={{ lat: 37.7749, lng: -122.4194 }}
 *   onClick={() => console.log('clicked')}
 *   title="Click me"
 * />
 *
 * // Custom marker with image
 * <Marker3D position={{ lat: 37.7749, lng: -122.4194 }}>
 *   <img src="/icon.png" width={32} height={32} />
 * </Marker3D>
 * ```
 */ const $9f88fd1702060c93$export$9fe96214cc610e48 = (0, $8FY87.forwardRef)(function Marker3D(props, ref) {
    const { children: children, onClick: onClick, position: position, altitudeMode: altitudeMode, collisionBehavior: collisionBehavior, drawsWhenOccluded: drawsWhenOccluded, extruded: extruded, label: label, sizePreserved: sizePreserved, zIndex: zIndex, title: title } = props;
    const isInteractive = Boolean(onClick);
    const [marker, setMarker] = (0, $8FY87.useState)(null);
    // Track if a child component (like Pin) is handling its own content
    const [contentHandledExternally, setContentHandledExternally] = (0, $8FY87.useState)(false);
    // Create a container for rendering React children to be wrapped and relocated
    // into the parent gmp-marker-3d element.
    const contentContainer = (0, $8FY87.useMemo)(()=>{
        const container = document.createElement('div');
        container.style.display = 'none';
        document.body.appendChild(container);
        return container;
    }, []);
    // Remove the container on unmount
    (0, $8FY87.useEffect)(()=>{
        return ()=>contentContainer.remove();
    }, [
        contentContainer
    ]);
    // Callback ref that sets both internal state and forwards the ref
    const markerRef = (0, $8FY87.useCallback)((node)=>{
        setMarker(node);
        if (typeof ref === 'function') ref(node);
        else if (ref) ref.current = node;
    }, [
        ref
    ]);
    $9f88fd1702060c93$var$useDomEventListener(marker, 'gmp-click', onClick);
    // Move React children to marker's slot, wrapping img/svg in <template> as required by the API
    (0, $8FY87.useLayoutEffect)(()=>{
        if (contentHandledExternally) return;
        if (!marker || !contentContainer) return;
        while(marker.firstChild)marker.removeChild(marker.firstChild);
        const childNodes = Array.from(contentContainer.childNodes);
        for (const node of childNodes){
            if (node.nodeType !== Node.ELEMENT_NODE) continue;
            const element = node;
            const tagName = element.tagName.toLowerCase();
            if (tagName === 'img' || tagName === 'svg') {
                const template = document.createElement('template');
                template.content.appendChild(element.cloneNode(true));
                marker.appendChild(template);
            } else marker.appendChild(element.cloneNode(true));
        }
    }, [
        marker,
        contentContainer,
        children,
        contentHandledExternally
    ]);
    const contextValue = (0, $8FY87.useMemo)(()=>({
            marker: marker,
            setContentHandledExternally: setContentHandledExternally
        }), [
        marker
    ]);
    $9f88fd1702060c93$var$usePropBinding(marker, 'position', position);
    $9f88fd1702060c93$var$usePropBinding(marker, 'altitudeMode', altitudeMode);
    $9f88fd1702060c93$var$usePropBinding(marker, 'collisionBehavior', collisionBehavior);
    $9f88fd1702060c93$var$usePropBinding(marker, 'drawsWhenOccluded', drawsWhenOccluded);
    $9f88fd1702060c93$var$usePropBinding(marker, 'extruded', extruded);
    $9f88fd1702060c93$var$usePropBinding(marker, 'label', label);
    $9f88fd1702060c93$var$usePropBinding(marker, 'sizePreserved', sizePreserved);
    $9f88fd1702060c93$var$usePropBinding(marker, 'zIndex', zIndex);
    $9f88fd1702060c93$var$usePropBinding(marker, 'title', title !== null && title !== void 0 ? title : '');
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($9f88fd1702060c93$export$f2451a5061be5eec.Provider, {
        value: contextValue
    }, isInteractive ? (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("gmp-marker-3d-interactive", {
        ref: markerRef
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("gmp-marker-3d", {
        ref: markerRef
    }), (0, $95gxM.createPortal)(children, contentContainer));
});
$9f88fd1702060c93$export$9fe96214cc610e48.displayName = 'Marker3D';
/**
 * Popover component for displaying info windows on a Map3D.
 *
 * Similar to InfoWindow for 2D maps, Popover provides a way to show
 * contextual information at a specific location or attached to a marker
 * on a 3D map.
 *
 * @example
 * ```tsx
 * // Basic popover at position
 * <Popover
 *   position={{ lat: 37.7749, lng: -122.4194 }}
 *   open={isOpen}
 * >
 *   <div>Hello from San Francisco!</div>
 * </Popover>
 *
 * // Popover anchored to a marker (place as sibling, use anchor prop)
 * <Marker3D
 *   ref={markerRef}
 *   position={{ lat: 37.7749, lng: -122.4194 }}
 *   onClick={() => setOpen(true)}
 * />
 * <Popover
 *   anchor={markerRef.current}
 *   open={isOpen}
 *   onClose={() => setOpen(false)}
 * >
 *   <div>Marker info</div>
 * </Popover>
 * ```
 */ const $9f88fd1702060c93$export$5b6b19405a83ff9d = (0, $8FY87.forwardRef)(function Popover(props, ref) {
    var _a;
    const { children: children, headerContent: headerContent, style: style, className: className, open: open = true, position: position, anchor: anchor, anchorId: anchorId, altitudeMode: altitudeMode, lightDismissDisabled: lightDismissDisabled, autoPanDisabled: autoPanDisabled, onClose: onClose } = props;
    const [popover, setPopover] = (0, $8FY87.useState)(null);
    const prevStyleRef = (0, $8FY87.useRef)(null);
    // Forward the ref to the parent
    (0, $8FY87.useImperativeHandle)(ref, ()=>popover, [
        popover
    ]);
    // Observe the open attribute and call onClose when popover is automatically
    // closed by the Maps API (light dismiss)
    $9f88fd1702060c93$var$usePopoverCloseObserver(popover, open, onClose);
    // Set properties on the popover element
    $9f88fd1702060c93$var$usePropBinding(popover, 'open', open !== null && open !== void 0 ? open : false);
    $9f88fd1702060c93$var$usePropBinding(popover, 'altitudeMode', altitudeMode);
    $9f88fd1702060c93$var$usePropBinding(popover, 'lightDismissDisabled', lightDismissDisabled);
    $9f88fd1702060c93$var$usePropBinding(popover, 'autoPanDisabled', autoPanDisabled);
    // positionAnchor accepts a position, marker element, or marker ID string
    const positionAnchor = (_a = anchor !== null && anchor !== void 0 ? anchor : anchorId) !== null && _a !== void 0 ? _a : position;
    $9f88fd1702060c93$var$usePropBinding(popover, 'positionAnchor', positionAnchor);
    // Set styles via ref for compatibility with older React versions
    (0, $8FY87.useLayoutEffect)(()=>{
        if (!popover) return;
        $9f88fd1702060c93$var$setValueForStyles(popover, style || null, prevStyleRef.current);
        prevStyleRef.current = style || null;
    }, [
        popover,
        style
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("gmp-popover", {
        ref: setPopover,
        className: className
    }, headerContent && (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        slot: "header"
    }, headerContent), children);
});
$9f88fd1702060c93$export$5b6b19405a83ff9d.displayName = 'Popover';
/**
 * Custom hook to observe the open attribute of a popover element
 * and call onClose when it transitions from open to closed due to light dismiss.
 * Does not call onClose when the open prop changes programmatically.
 */ function $9f88fd1702060c93$var$usePopoverCloseObserver(popover, open, onClose) {
    const previousOpenState = (0, $8FY87.useRef)(undefined);
    const openPropRef = (0, $8FY87.useRef)(open);
    // Track the open prop value
    (0, $8FY87.useEffect)(()=>{
        openPropRef.current = open;
    }, [
        open
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (!popover || !onClose) return;
        const observer = new MutationObserver((mutations)=>{
            for (const mutation of mutations)if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                const isOpen = popover.hasAttribute('open');
                // Only call onClose when:
                // 1. Transitioning from open to closed
                // 2. The prop hasn't changed to false (meaning this was light dismiss, not programmatic)
                if (previousOpenState.current === true && !isOpen && openPropRef.current !== false) onClose();
                previousOpenState.current = isOpen;
            }
        });
        observer.observe(popover, {
            attributes: true,
            attributeFilter: [
                'open'
            ]
        });
        // Initialize the previous state
        previousOpenState.current = popover.hasAttribute('open');
        return ()=>{
            observer.disconnect();
        };
    }, [
        popover,
        onClose
    ]);
}
/**
 * Formats a location into a string representation suitable for Google Static Maps API.
 *
 * @param location - The location to format, can be either a string or an object with lat/lng properties
 * @returns A string representation of the location in the format "lat,lng" or the original string
 *
 * @example
 * // Returns "40.714728,-73.998672"
 * formatLocation({ lat: 40.714728, lng: -73.998672 })
 *
 * @example
 * // Returns "New York, NY"
 * formatLocation("New York, NY")
 */ function $9f88fd1702060c93$var$formatLocation(location) {
    return typeof location === 'string' ? location : `${location.lat},${location.lng}`;
}
// Used for removing the leading pipe from the param string
function $9f88fd1702060c93$var$formatParam(string) {
    return string.slice(1);
}
/**
 * Assembles marker parameters for static maps.
 *
 * This function takes an array of markers and groups them by their style properties.
 * It then creates a string representation of these markers, including their styles and locations,
 * which can be used as parameters for static map APIs.
 *
 * @param {StaticMapsMarker[]} [markers=[]] - An array of markers to be processed. Each marker can have properties such as color, label, size, scale, icon, anchor, and location.
 * @returns {string[]} An array of strings, each representing a group of markers with their styles and locations.
 *
 * @example
 * const markers = [
 *   { color: 'blue', label: 'A', size: 'mid', location: '40.714728,-73.998672' },
 *   { color: 'blue', label: 'B', size: 'mid', location: '40.714728,-73.998672' },
 *   { icon: 'http://example.com/icon.png', location: { lat: 40.714728, lng: -73.998672 } }
 * ];
 * const params = assembleMarkerParams(markers);
 * // Params will be an array of strings representing the marker parameters
 * Example output: [
 *   "color:blue|label:A|size:mid|40.714728,-73.998672|40.714728,-73.998672",
 *   "color:blue|label:B|size:mid|40.714728,-73.998672|40.714728,-73.998672",
 *   "icon:http://example.com/icon.png|40.714728,-73.998672"
 * ]
 */ function $9f88fd1702060c93$var$assembleMarkerParams(markers = []) {
    const markerParams = [];
    // Group markers by style
    const markersByStyle = markers === null || markers === void 0 ? void 0 : markers.reduce((styles, marker)=>{
        const { color: color = 'red', label: label, size: size, scale: scale, icon: icon, anchor: anchor } = marker;
        // Create a unique style key based on either icon properties or standard marker properties
        const relevantProps = icon ? [
            icon,
            anchor,
            scale
        ] : [
            color,
            label,
            size
        ];
        const key = relevantProps.filter(Boolean).join('-');
        styles[key] = styles[key] || [];
        styles[key].push(marker);
        return styles;
    }, {});
    Object.values(markersByStyle !== null && markersByStyle !== void 0 ? markersByStyle : {}).forEach((markers)=>{
        let markerParam = '';
        const { icon: icon } = markers[0];
        // Create marker style from first marker in group since all markers share the same style.
        Object.entries(markers[0]).forEach(([key, value])=>{
            // Determine which properties to include based on whether marker uses custom icon
            const relevantKeys = icon ? [
                'icon',
                'anchor',
                'scale'
            ] : [
                'color',
                'label',
                'size'
            ];
            if (relevantKeys.includes(key)) markerParam += `|${key}:${value}`;
        });
        // Add location coordinates for each marker in the style group
        // Handles both string locations and lat/lng object formats.
        for (const marker of markers){
            const location = typeof marker.location === 'string' ? marker.location : `${marker.location.lat},${marker.location.lng}`;
            markerParam += `|${location}`;
        }
        markerParams.push(markerParam);
    });
    return markerParams.map($9f88fd1702060c93$var$formatParam);
}
// Style properties that can be applied to paths in the Static Maps API
const $9f88fd1702060c93$var$PATH_STYLE_KEYS = [
    'color',
    'weight',
    'fillcolor',
    'geodesic'
];
/**
 * Builds the style portion of a path parameter string.
 * @param path - The path object containing style properties
 * @returns A string with style parameters in the format "|key:value"
 */ function $9f88fd1702060c93$var$buildStyleParams(path) {
    let styleParams = '';
    $9f88fd1702060c93$var$PATH_STYLE_KEYS.forEach((key)=>{
        if (path[key] !== undefined) styleParams += `|${key}:${path[key]}`;
    });
    return styleParams;
}
/**
 * Builds the coordinates portion of a path parameter string.
 * @param coordinates - Either a string or array of location objects
 * @returns A string with coordinates in the format "|lat,lng|lat,lng"
 */ function $9f88fd1702060c93$var$buildCoordinateParams(coordinates) {
    if (typeof coordinates === 'string') return `|${decodeURIComponent(coordinates)}`;
    return coordinates.map((location)=>`|${$9f88fd1702060c93$var$formatLocation(location)}`).join('');
}
/**
 * Assembles path parameters for the Static Maps API from an array of paths.
 *
 * This function constructs a string of path parameters for each path. Each path parameter string
 * includes the style properties and the coordinates of the paths.
 *
 * @param {Array<StaticMapsPath>} [paths=[]] - An array of paths to be assembled into path parameters.
 * @returns {Array<string>} An array of path parameter strings.
 *
 * @example
 * ```typescript
 * const paths = [
 *   {
 *     color: 'red',
 *     weight: 5,
 *     coordinates: [
 *       { lat: 40.714728, lng: -73.998672 },
 *       { lat: 40.718217, lng: -73.998284 }
 *     ]
 *   }
 * ];
 *
 * const pathParams = assemblePathParams(paths);
 * // Output: ['color:red|weight:5|40.714728,-73.998672|40.718217,-73.998284']
 * ```
 */ function $9f88fd1702060c93$var$assemblePathParams(paths = []) {
    return paths.map((path)=>{
        const styleParams = $9f88fd1702060c93$var$buildStyleParams(path);
        const coordinateParams = $9f88fd1702060c93$var$buildCoordinateParams(path.coordinates);
        const pathParam = styleParams + coordinateParams;
        return $9f88fd1702060c93$var$formatParam(pathParam);
    });
}
/**
 * Converts an array of Google Maps style objects into an array of style strings
 * compatible with the Google Static Maps API.
 *
 * @param styles - An array of Google Maps MapTypeStyle objects that define the styling rules
 * @returns An array of formatted style strings ready to be used with the Static Maps API
 *
 * @example
 * const styles = [{
 *   featureType: "road",
 *   elementType: "geometry",
 *   stylers: [{color: "#ff0000"}, {weight: 1}]
 * }];
 *
 * const styleStrings = assembleMapTypeStyles(styles);
 * // Returns: ["|feature:road|element:geometry|color:0xff0000|weight:1"]
 *
 * Each style string follows the format:
 * "feature:{featureType}|element:{elementType}|{stylerName}:{stylerValue}"
 *
 * Note: Color values with hexadecimal notation (#) are automatically converted
 * to the required 0x format for the Static Maps API.
 */ function $9f88fd1702060c93$var$assembleMapTypeStyles(styles) {
    return styles.map((mapTypeStyle)=>{
        const { featureType: featureType, elementType: elementType, stylers: stylers = [] } = mapTypeStyle;
        let styleString = '';
        if (featureType) styleString += `|feature:${featureType}`;
        if (elementType) styleString += `|element:${elementType}`;
        for (const styler of stylers)Object.entries(styler).forEach(([name, value])=>{
            styleString += `|${name}:${String(value).replace('#', '0x')}`;
        });
        return styleString;
    }).map($9f88fd1702060c93$var$formatParam);
}
const $9f88fd1702060c93$var$STATIC_MAPS_BASE = 'https://maps.googleapis.com/maps/api/staticmap';
/**
 * Creates a URL for the Google Static Maps API with the specified parameters.
 *
 * @param {Object} options - The configuration options for the static map
 * @param {string} options.apiKey - Your Google Maps API key (required)
 * @param {number} options.width - The width of the map image in pixels (required)
 * @param {number} options.height - The height of the map image in pixels (required)
 * @param {StaticMapsLocation} [options.center] - The center point of the map (lat/lng or address).
 *  Required if no markers or paths or "visible locations" are provided.
 * @param {number} [options.zoom] - The zoom level of the map. Required if no markers or paths or "visible locations" are provided.
 * @param {1|2|4} [options.scale] - The resolution of the map (1, 2, or 4)
 * @param {string} [options.format] - The image format (png, png8, png32, gif, jpg, jpg-baseline)
 * @param {string} [options.mapType] - The type of map (roadmap, satellite, terrain, hybrid)
 * @param {string} [options.language] - The language of the map labels
 * @param {string} [options.region] - The region code for the map
 * @param {string} [options.map_id] - The Cloud-based map style ID
 * @param {StaticMapsMarker[]} [options.markers=[]] - Array of markers to display on the map
 * @param {StaticMapsPath[]} [options.paths=[]] - Array of paths to display on the map
 * @param {StaticMapsLocation[]} [options.visible=[]] - Array of locations that should be visible on the map
 * @param {MapTypeStyle[]} [options.style=[]] - Array of style objects to customize the map appearance
 *
 * @returns {string} The complete Google Static Maps API URL
 *
 * @throws {Error} If API key is not provided
 * @throws {Error} If width or height is not provided
 *
 * @example
 * const url = createStaticMapsUrl({
 *   apiKey: 'YOUR_API_KEY',
 *   width: 600,
 *   height: 400,
 *   center: { lat: 40.714728, lng: -73.998672 },
 *   zoom: 12,
 *   markers: [
 *     {
 *       location: { lat: 40.714728, lng: -73.998672 },
 *       color: 'red',
 *       label: 'A'
 *     }
 *   ],
 *   paths: [
 *     {
 *       coordinates: [
 *         { lat: 40.714728, lng: -73.998672 },
 *         { lat: 40.719728, lng: -73.991672 }
 *       ],
 *       color: '0x0000ff',
 *       weight: 5
 *     }
 *   ],
 *   style: [
 *     {
 *       featureType: 'road',
 *       elementType: 'geometry',
 *       stylers: [{color: '#00ff00'}]
 *     }
 *   ]
 * });
 *
 * // Results in URL similar to:
 * // https://maps.googleapis.com/maps/api/staticmap?key=YOUR_API_KEY
 * // &size=600x400
 * // &center=40.714728,-73.998672&zoom=12
 * // &markers=color:red|label:A|40.714728,-73.998672
 * // &path=color:0x0000ff|weight:5|40.714728,-73.998672|40.719728,-73.991672
 * // &style=feature:road|element:geometry|color:0x00ff00
 */ function $9f88fd1702060c93$export$5b07f2165c617d35({ apiKey: apiKey, width: width, height: height, center: center, zoom: zoom, scale: scale, format: format, mapType: mapType, language: language, region: region, mapId: mapId, markers: markers = [], paths: paths = [], visible: visible = [], style: style = [] }) {
    if (!apiKey) console.warn('API key is required');
    if (!width || !height) console.warn('Width and height are required');
    const params = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        key: apiKey,
        size: `${width}x${height}`
    }, center && {
        center: $9f88fd1702060c93$var$formatLocation(center)
    }), zoom && {
        zoom: zoom
    }), scale && {
        scale: scale
    }), format && {
        format: format
    }), mapType && {
        maptype: mapType
    }), language && {
        language: language
    }), region && {
        region: region
    }), mapId && {
        map_id: mapId
    });
    const url = new URL($9f88fd1702060c93$var$STATIC_MAPS_BASE);
    // Params that don't need special handling
    Object.entries(params).forEach(([key, value])=>{
        url.searchParams.append(key, String(value));
    });
    // Assemble Markers
    for (const markerParam of $9f88fd1702060c93$var$assembleMarkerParams(markers))url.searchParams.append('markers', markerParam);
    // Assemble Paths
    for (const pathParam of $9f88fd1702060c93$var$assemblePathParams(paths))url.searchParams.append('path', pathParam);
    // Assemble visible locations
    if (visible.length) url.searchParams.append('visible', visible.map((location)=>$9f88fd1702060c93$var$formatLocation(location)).join('|'));
    // Assemble Map Type Styles
    for (const styleString of $9f88fd1702060c93$var$assembleMapTypeStyles(style))url.searchParams.append('style', styleString);
    return url.toString();
}
const $9f88fd1702060c93$export$ea9999dae6eb05c6 = (props)=>{
    const { url: url, className: className } = props;
    if (!url) throw new Error('URL is required');
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("img", {
        className: className,
        src: url,
        width: "100%"
    });
};
/**
 * Copy of the `google.maps.ControlPosition` constants.
 * They have to be duplicated here since we can't wait for the maps API to load to be able to use them.
 */ const $9f88fd1702060c93$export$90e210fd0946c45e = {
    TOP_LEFT: 1,
    TOP_CENTER: 2,
    TOP: 2,
    TOP_RIGHT: 3,
    LEFT_CENTER: 4,
    LEFT_TOP: 5,
    LEFT: 5,
    LEFT_BOTTOM: 6,
    RIGHT_TOP: 7,
    RIGHT: 7,
    RIGHT_CENTER: 8,
    RIGHT_BOTTOM: 9,
    BOTTOM_LEFT: 10,
    BOTTOM_CENTER: 11,
    BOTTOM: 11,
    BOTTOM_RIGHT: 12,
    CENTER: 13,
    BLOCK_START_INLINE_START: 14,
    BLOCK_START_INLINE_CENTER: 15,
    BLOCK_START_INLINE_END: 16,
    INLINE_START_BLOCK_CENTER: 17,
    INLINE_START_BLOCK_START: 18,
    INLINE_START_BLOCK_END: 19,
    INLINE_END_BLOCK_START: 20,
    INLINE_END_BLOCK_CENTER: 21,
    INLINE_END_BLOCK_END: 22,
    BLOCK_END_INLINE_START: 23,
    BLOCK_END_INLINE_CENTER: 24,
    BLOCK_END_INLINE_END: 25
};
const $9f88fd1702060c93$export$68000b548d3309a0 = ({ children: children, position: position, className: className })=>{
    const controlContainer = (0, $8FY87.useMemo)(()=>document.createElement('div'), []);
    const map = $9f88fd1702060c93$export$86f8f9f08863e403();
    (0, $8FY87.useEffect)(()=>{
        // eslint-disable-next-line react-hooks/immutability -- the control container DOM node is intentionally mutated from effects
        controlContainer.className = className !== null && className !== void 0 ? className : '';
    }, [
        controlContainer,
        className
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (!map) return;
        const controls = map.controls[position];
        controls.push(controlContainer);
        return ()=>{
            const controlsArray = controls.getArray();
            // controlsArray could be undefined if the map is in an undefined state (e.g. invalid API-key, see #276
            if (!controlsArray) return;
            const index = controlsArray.indexOf(controlContainer);
            controls.removeAt(index);
        };
    }, [
        controlContainer,
        map,
        position
    ]);
    return (0, $95gxM.createPortal)(children, controlContainer);
};
function $9f88fd1702060c93$var$useMarker(props) {
    const [marker, setMarker] = (0, $8FY87.useState)(null);
    const map = $9f88fd1702060c93$export$86f8f9f08863e403();
    const { onClick: onClick, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onMouseOver: onMouseOver, onMouseOut: onMouseOut } = props, markerOptions = $9f88fd1702060c93$var$__rest(props, [
        "onClick",
        "onDrag",
        "onDragStart",
        "onDragEnd",
        "onMouseOver",
        "onMouseOut"
    ]);
    const { position: position, draggable: draggable } = markerOptions;
    // create marker instance and add to the map once the map is available
    (0, $8FY87.useEffect)(()=>{
        if (!map) {
            if (map === undefined) console.error('<Marker> has to be inside a Map component.');
            return;
        }
        const newMarker = new google.maps.Marker(markerOptions);
        newMarker.setMap(map);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setMarker(newMarker);
        return ()=>{
            newMarker.setMap(null);
            setMarker(null);
        };
    // We do not want to re-render the whole marker when the options change.
    // Marker options update is handled in a useEffect below.
    // Excluding markerOptions from dependency array on purpose here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        map
    ]);
    // attach and re-attach event-handlers when any of the properties change
    (0, $8FY87.useEffect)(()=>{
        if (!marker) return;
        const m = marker;
        // Add event listeners
        const gme = google.maps.event;
        if (onClick) gme.addListener(m, 'click', onClick);
        if (onDrag) gme.addListener(m, 'drag', onDrag);
        if (onDragStart) gme.addListener(m, 'dragstart', onDragStart);
        if (onDragEnd) gme.addListener(m, 'dragend', onDragEnd);
        if (onMouseOver) gme.addListener(m, 'mouseover', onMouseOver);
        if (onMouseOut) gme.addListener(m, 'mouseout', onMouseOut);
        marker.setDraggable(Boolean(draggable));
        return ()=>{
            gme.clearInstanceListeners(m);
        };
    }, [
        marker,
        draggable,
        onClick,
        onDrag,
        onDragStart,
        onDragEnd,
        onMouseOver,
        onMouseOut
    ]);
    // update markerOptions (note the dependencies aren't properly checked
    // here, we just assume that setOptions is smart enough to not waste a
    // lot of time updating values that didn't change)
    (0, $8FY87.useEffect)(()=>{
        if (!marker) return;
        if (markerOptions) marker.setOptions(markerOptions);
    }, [
        marker,
        markerOptions
    ]);
    // update position when changed
    (0, $8FY87.useEffect)(()=>{
        // Should not update position when draggable
        if (draggable || !position || !marker) return;
        marker.setPosition(position);
    }, [
        draggable,
        position,
        marker
    ]);
    return marker;
}
/**
 * Component to render a marker on a map
 */ const $9f88fd1702060c93$export$e98856a975cab58e = (0, $8FY87.forwardRef)((props, ref)=>{
    const marker = $9f88fd1702060c93$var$useMarker(props);
    (0, $8FY87.useImperativeHandle)(ref, ()=>marker, [
        marker
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null);
});
$9f88fd1702060c93$export$e98856a975cab58e.displayName = 'Marker';
function $9f88fd1702060c93$export$89f3a749231786c6() {
    const [marker, setMarker] = (0, $8FY87.useState)(null);
    const refCallback = (0, $8FY87.useCallback)((m)=>{
        setMarker(m);
    }, []);
    return [
        refCallback,
        marker
    ];
}
/**
 * Legacy implementation of Pin component for Maps API < 3.62
 * Component to configure the appearance of an AdvancedMarker or Marker3D
 */ const $9f88fd1702060c93$var$PinLegacy = (props)=>{
    const advancedMarkerContext = (0, $8FY87.useContext)($9f88fd1702060c93$export$14de7bb7593cd5bc);
    const marker3dContext = (0, $8FY87.useContext)($9f88fd1702060c93$export$f2451a5061be5eec);
    const advancedMarker = advancedMarkerContext === null || advancedMarkerContext === void 0 ? void 0 : advancedMarkerContext.marker;
    const marker3d = marker3dContext === null || marker3dContext === void 0 ? void 0 : marker3dContext.marker;
    const setContentHandledExternally = marker3dContext === null || marker3dContext === void 0 ? void 0 : marker3dContext.setContentHandledExternally;
    const glyphContainer = (0, $8FY87.useMemo)(()=>document.createElement('div'), []);
    // Load marker library for Marker3D case (AdvancedMarker already has it loaded)
    const markerLibrary = $9f88fd1702060c93$export$5b40cf36c69caef7('marker');
    // Signal to Marker3D that we're handling content
    (0, $8FY87.useEffect)(()=>{
        if (marker3d && setContentHandledExternally) {
            setContentHandledExternally(true);
            return ()=>setContentHandledExternally(false);
        }
    }, [
        marker3d,
        setContentHandledExternally
    ]);
    // Handle Marker3D case - append PinElement directly
    (0, $8FY87.useEffect)(()=>{
        if (!marker3d || !markerLibrary) return;
        const pinViewOptions = Object.assign({}, props);
        const pinElement = new markerLibrary.PinElement(pinViewOptions);
        // Set glyph to glyph container if children are present
        if (props.children) pinElement.glyph = glyphContainer;
        // Append PinElement directly to Marker3D (not in a template)
        // PinElement is a special element that Marker3D can handle natively
        while(marker3d.firstChild)marker3d.removeChild(marker3d.firstChild);
        marker3d.append(pinElement);
        return ()=>{
        // Cleanup handled by marker3d removal
        };
    }, [
        marker3d,
        markerLibrary,
        glyphContainer,
        props
    ]);
    // Create Pin View instance for AdvancedMarker
    (0, $8FY87.useEffect)(()=>{
        var _a;
        // Skip if we're in Marker3D context
        if (marker3d) return;
        if (!advancedMarker) {
            if (advancedMarker === undefined && marker3d === undefined) console.error('The <Pin> component can only be used inside <AdvancedMarker> or <Marker3D>.');
            return;
        }
        if (props.glyph && props.children) $9f88fd1702060c93$var$logErrorOnce('The <Pin> component only uses children to render the glyph if both the glyph property and children are present.');
        if ((0, $8FY87.Children).count(props.children) > 1) $9f88fd1702060c93$var$logErrorOnce('Passing multiple children to the <Pin> component might lead to unexpected results.');
        const pinViewOptions = Object.assign({}, props);
        const pinElement = new google.maps.marker.PinElement(pinViewOptions);
        // Set glyph to glyph container if children are present (rendered via portal).
        // If both props.glyph and props.children are present, props.children takes priority.
        if (props.children) pinElement.glyph = glyphContainer;
        // Set content of Advanced Marker View to the Pin View element
        // Here we are selecting the anchor container.
        // The hierarchy is as follows:
        // "advancedMarker.content" (from google) -> "anchor container"
        const markerContent = (_a = advancedMarker.content) === null || _a === void 0 ? void 0 : _a.firstChild;
        while(markerContent === null || markerContent === void 0 ? void 0 : markerContent.firstChild)markerContent.removeChild(markerContent.firstChild);
        if (markerContent) markerContent.appendChild(pinElement.element);
    }, [
        advancedMarker,
        glyphContainer,
        marker3d,
        props
    ]);
    return (0, $95gxM.createPortal)(props.children, glyphContainer);
};
/**
 * Modern implementation of Pin component for Maps API >= 3.62
 * Uses the new custom element API with glyphSrc/glyphText properties
 * Component to configure the appearance of an AdvancedMarker or Marker3D
 */ const $9f88fd1702060c93$var$PinModern = (props)=>{
    const { children: children } = props;
    const advancedMarkerContext = (0, $8FY87.useContext)($9f88fd1702060c93$export$14de7bb7593cd5bc);
    const marker3dContext = (0, $8FY87.useContext)($9f88fd1702060c93$export$f2451a5061be5eec);
    const advancedMarker = advancedMarkerContext === null || advancedMarkerContext === void 0 ? void 0 : advancedMarkerContext.marker;
    const marker3d = marker3dContext === null || marker3dContext === void 0 ? void 0 : marker3dContext.marker;
    const setContentHandledExternally = marker3dContext === null || marker3dContext === void 0 ? void 0 : marker3dContext.setContentHandledExternally;
    const glyphContainer = (0, $8FY87.useMemo)(()=>document.createElement('div'), []);
    const markerLibrary = $9f88fd1702060c93$export$5b40cf36c69caef7('marker');
    // Signal to Marker3D that we're handling content
    (0, $8FY87.useEffect)(()=>{
        if (marker3d && setContentHandledExternally) {
            setContentHandledExternally(true);
            return ()=>setContentHandledExternally(false);
        }
    }, [
        marker3d,
        setContentHandledExternally
    ]);
    // Handle Marker3D case
    (0, $8FY87.useEffect)(()=>{
        if (!marker3d || !markerLibrary) return;
        const pinOptions = Object.assign({}, props);
        const pinElement = new markerLibrary.PinElement(pinOptions);
        // Children still rendered via portal into a container
        if (children) // In modern API, DOM children of PinElement serve as glyph
        pinElement.appendChild(glyphContainer);
        // Append PinElement directly (not .element - that's deprecated)
        while(marker3d.firstChild)marker3d.removeChild(marker3d.firstChild);
        marker3d.appendChild(pinElement);
        return ()=>{
        // Cleanup handled by marker3d removal
        };
    }, [
        marker3d,
        markerLibrary,
        glyphContainer,
        children,
        props
    ]);
    // Handle AdvancedMarker case
    (0, $8FY87.useEffect)(()=>{
        var _a;
        if (marker3d) return; // Skip if in Marker3D context
        if (!advancedMarker || !markerLibrary) {
            if (advancedMarker === undefined && marker3d === undefined) console.error('The <Pin> component can only be used inside <AdvancedMarker> or <Marker3D>.');
            return;
        }
        if ((props.glyphSrc || props.glyphText) && children) $9f88fd1702060c93$var$logErrorOnce('The <Pin> component only uses children to render the glyph if both glyphSrc/glyphText and children are present.');
        if ((0, $8FY87.Children).count(children) > 1) $9f88fd1702060c93$var$logErrorOnce('Passing multiple children to the <Pin> component might lead to unexpected results.');
        const pinOptions = Object.assign({}, props);
        const pinElement = new markerLibrary.PinElement(pinOptions);
        // Children rendered via portal into container
        if (children) pinElement.appendChild(glyphContainer);
        const markerContent = (_a = advancedMarker.content) === null || _a === void 0 ? void 0 : _a.firstChild;
        while(markerContent === null || markerContent === void 0 ? void 0 : markerContent.firstChild)markerContent.removeChild(markerContent.firstChild);
        if (markerContent) // In modern API, append PinElement directly (not .element)
        markerContent.appendChild(pinElement);
    }, [
        advancedMarker,
        markerLibrary,
        glyphContainer,
        marker3d,
        children,
        props
    ]);
    return (0, $95gxM.createPortal)(children, glyphContainer);
};
/**
 * Component to configure the appearance of an AdvancedMarker or Marker3D.
 *
 * Automatically detects the Maps API version and uses the appropriate implementation:
 * - Legacy implementation (< 3.62): Uses the original PinElement API with glyph property
 * - Modern implementation (≥ 3.62): Uses the new custom element API with glyphSrc/glyphText
 *
 * @example
 * ```tsx
 * // Basic usage
 * <AdvancedMarker position={{lat: 0, lng: 0}}>
 *   <Pin background="#FF0000" glyphColor="#FFFFFF" />
 * </AdvancedMarker>
 *
 * // With custom glyph (legacy)
 * <Pin glyph="📍" />
 *
 * // With custom glyph (modern, recommended for Maps API 3.62+)
 * <Pin glyphText="📍" />
 * <Pin glyphSrc="https://example.com/icon.png" />
 *
 * // With React children as glyph
 * <Pin>
 *   <CustomIcon />
 * </Pin>
 * ```
 */ const $9f88fd1702060c93$export$656559010049c8e = (props)=>{
    var _a;
    const markerLibrary = $9f88fd1702060c93$export$5b40cf36c69caef7('marker');
    // Detect capability after the marker library is loaded
    const isModern = (0, $8FY87.useMemo)(()=>{
        if (!markerLibrary) return false;
        // Check if <gmp-pin> custom element exists
        // This happens while loading the marker library in Maps API 3.62+
        return typeof customElements !== 'undefined' && customElements.get('gmp-pin') !== undefined;
    }, [
        markerLibrary
    ]);
    // Wait for marker library to load before rendering
    if (!markerLibrary) return null;
    // Map props based on which implementation we're using
    if (isModern) {
        // Modern: map old glyph prop to new glyphSrc/glyphText
        const { glyph: glyph, glyphSrc: glyphSrc, glyphText: glyphText } = props, restProps = $9f88fd1702060c93$var$__rest(props, [
            "glyph",
            "glyphSrc",
            "glyphText"
        ]);
        const isUrl = glyph instanceof URL || typeof glyph === 'string' && glyph.startsWith('http');
        const finalGlyphText = glyphText !== null && glyphText !== void 0 ? glyphText : typeof glyph === 'string' && !isUrl ? glyph : undefined;
        const finalGlyphSrc = glyphSrc !== null && glyphSrc !== void 0 ? glyphSrc : isUrl ? String(glyph) : undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($9f88fd1702060c93$var$PinModern, Object.assign({}, restProps, {
            glyphText: finalGlyphText,
            glyphSrc: finalGlyphSrc
        }));
    } else {
        // Legacy: map new glyphSrc/glyphText to old glyph prop
        const { glyph: glyph, glyphSrc: glyphSrc, glyphText: glyphText } = props, restProps = $9f88fd1702060c93$var$__rest(props, [
            "glyph",
            "glyphSrc",
            "glyphText"
        ]);
        const finalGlyph = (_a = glyph !== null && glyph !== void 0 ? glyph : glyphSrc) !== null && _a !== void 0 ? _a : glyphText;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($9f88fd1702060c93$var$PinLegacy, Object.assign({}, restProps, {
            glyph: finalGlyph
        }));
    }
};
function $9f88fd1702060c93$var$useRectangle(props) {
    var _a, _b, _c;
    const { onClick: onClick, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onBoundsChanged: onBoundsChanged, bounds: bounds, defaultBounds: defaultBounds } = props, destructuredOptions = $9f88fd1702060c93$var$__rest(props, [
        "onClick",
        "onDrag",
        "onDragStart",
        "onDragEnd",
        "onMouseOver",
        "onMouseOut",
        "onBoundsChanged",
        "bounds",
        "defaultBounds"
    ]);
    const [rectangle, setRectangle] = (0, $8FY87.useState)(null);
    const map = $9f88fd1702060c93$export$86f8f9f08863e403();
    // Memoize options with automatic inference of clickable/draggable/editable
    const rectangleOptions = $9f88fd1702060c93$var$useMemoized(Object.assign(Object.assign({}, destructuredOptions), {
        clickable: (_a = destructuredOptions.clickable) !== null && _a !== void 0 ? _a : Boolean(onClick),
        draggable: (_b = destructuredOptions.draggable) !== null && _b !== void 0 ? _b : Boolean(onDrag || onDragStart || onDragEnd || onBoundsChanged),
        editable: (_c = destructuredOptions.editable) !== null && _c !== void 0 ? _c : Boolean(onBoundsChanged)
    }), $9f88fd1702060c93$var$deepEqual);
    (0, $8FY87.useEffect)(()=>{
        if (!map) {
            if (map === undefined) console.error('<Rectangle> has to be inside a Map component.');
            return;
        }
        const newRectangle = new google.maps.Rectangle(Object.assign(Object.assign({}, rectangleOptions), {
            bounds: bounds !== null && bounds !== void 0 ? bounds : defaultBounds
        }));
        newRectangle.setMap(map);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setRectangle(newRectangle);
        return ()=>{
            newRectangle.setMap(null);
            setRectangle(null);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- rectangle options are handled separately to avoid recreating the instance
    }, [
        map
    ]);
    $9f88fd1702060c93$var$useMapsEventListener(rectangle, 'click', onClick);
    $9f88fd1702060c93$var$useMapsEventListener(rectangle, 'drag', onDrag);
    $9f88fd1702060c93$var$useMapsEventListener(rectangle, 'dragstart', onDragStart);
    $9f88fd1702060c93$var$useMapsEventListener(rectangle, 'dragend', onDragEnd);
    $9f88fd1702060c93$var$useMapsEventListener(rectangle, 'mouseover', onMouseOver);
    $9f88fd1702060c93$var$useMapsEventListener(rectangle, 'mouseout', onMouseOut);
    $9f88fd1702060c93$var$useMapsEventListener(rectangle, 'bounds_changed', onBoundsChanged ? ()=>{
        onBoundsChanged(rectangle === null || rectangle === void 0 ? void 0 : rectangle.getBounds());
    } : null);
    (0, $8FY87.useEffect)(()=>{
        if (!rectangle) return;
        rectangle.setOptions(rectangleOptions);
    }, [
        rectangle,
        rectangleOptions
    ]);
    // Sync controlled bounds prop with the rectangle instance
    (0, $8FY87.useEffect)(()=>{
        if (!rectangle || !bounds) return;
        if (!$9f88fd1702060c93$export$c0cfaae65aded47(bounds, rectangle.getBounds())) rectangle.setBounds(bounds);
    }, [
        rectangle,
        bounds
    ]);
    return rectangle;
}
const $9f88fd1702060c93$export$4617fb02663045ef = (0, $8FY87.forwardRef)((props, ref)=>{
    const rectangle = $9f88fd1702060c93$var$useRectangle(props);
    (0, $8FY87.useImperativeHandle)(ref, ()=>rectangle, [
        rectangle
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Fragment, null);
});
$9f88fd1702060c93$export$4617fb02663045ef.displayName = 'Rectangle';
/**
 * Hook to retrieve a Map3DElement instance from context.
 *
 * When called without an id, it returns the map from the nearest parent Map3D
 * component. When called with an id, it retrieves the map with that id from
 * the APIProvider context.
 *
 * @param id - Optional id of the map to retrieve. If not specified, returns
 *   the parent map instance or the default map instance.
 *
 * @example
 * ```tsx
 * // Get the parent Map3D instance
 * function MyComponent() {
 *   const map3d = useMap3D();
 *   // ...
 * }
 *
 * // Get a specific Map3D instance by id
 * function ControlPanel() {
 *   const mainMap = useMap3D('main-map');
 *   const miniMap = useMap3D('mini-map');
 *   // ...
 * }
 * ```
 */ function $9f88fd1702060c93$export$e9723f028e220f29(id = null) {
    const apiContext = (0, $8FY87.useContext)($9f88fd1702060c93$export$84e9974bcf67d1d);
    const map3dContext = (0, $8FY87.useContext)($9f88fd1702060c93$export$b4118d11ca82abca);
    if (apiContext === null) {
        $9f88fd1702060c93$var$logErrorOnce("useMap3D(): failed to retrieve APIProviderContext. Make sure that the <APIProvider> component exists and that the component you are calling `useMap3D()` from is a child of the <APIProvider>.");
        return null;
    }
    const { map3dInstances: map3dInstances } = apiContext;
    // Lookup priority: explicit id > parent context > default instance
    if (id !== null) return map3dInstances[id] || null;
    if (map3dContext === null || map3dContext === void 0 ? void 0 : map3dContext.map3d) return map3dContext.map3d;
    return map3dInstances['default'] || null;
}
const $9f88fd1702060c93$var$mapLinear = (x, a1, a2, b1, b2)=>b1 + (x - a1) * (b2 - b1) / (a2 - a1);
const $9f88fd1702060c93$var$getMapMaxTilt = (zoom)=>{
    if (zoom <= 10) return 30;
    if (zoom >= 15.5) return 67.5;
    // range [10...14]
    if (zoom <= 14) return $9f88fd1702060c93$var$mapLinear(zoom, 10, 14, 30, 45);
    // range [14...15.5]
    return $9f88fd1702060c93$var$mapLinear(zoom, 14, 15.5, 45, 67.5);
};
/**
 * Function to limit the tilt range of the Google map when updating the view state
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9f88fd1702060c93$export$2849c0466f0d3b14 = ({ viewState: viewState })=>{
    const pitch = viewState.pitch;
    const gmZoom = viewState.zoom + 1;
    const maxTilt = $9f88fd1702060c93$var$getMapMaxTilt(gmZoom);
    return Object.assign(Object.assign({}, viewState), {
        fovy: 25,
        pitch: Math.min(maxTilt, pitch)
    });
};

});
parcelRegister("95gxM", function(module, exports) {
'use strict';
function $69d169f7fc8722a7$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($69d169f7fc8722a7$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$69d169f7fc8722a7$var$checkDCE();

module.exports = (parcelRequire("f30MD"));

});




parcelRegister("8ISOr", function(module, exports) {

$parcel$export(module.exports, "sanitize", function () { return $bc0377a124b83e74$export$83d2e9e3e4ee39ed; });

var $gWEat = parcelRequire("gWEat");
(0, (/*@__PURE__*/$parcel$interopDefault($gWEat))).addHook('afterSanitizeAttributes', (node)=>{
    if ('target' in node) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener');
    }
});
const $bc0377a124b83e74$export$83d2e9e3e4ee39ed = (html)=>(0, (/*@__PURE__*/$parcel$interopDefault($gWEat))).sanitize(html);

});

parcelRegister("kbggU", function(module, exports) {

$parcel$export(module.exports, "SuccessModal", function () { return $5e6b653bf076ec91$export$2113e0e46f231d60; });

var $2PPWI = parcelRequire("2PPWI");

var $gWEat = parcelRequire("gWEat");

var $8FY87 = parcelRequire("8FY87");
function $5e6b653bf076ec91$export$2113e0e46f231d60({ onClose: onClose, title: title, description: description }) {
    const dialogRef = (0, $8FY87.useRef)(null);
    (0, $8FY87.useEffect)(()=>{
        dialogRef.current?.showModal();
    }, []);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("dialog", {
        ref: dialogRef,
        onCancel: onClose,
        className: "m-auto p-0 w-full max-w-md rounded-xl shadow-2xl backdrop:bg-black/60",
        "aria-label": "Tack f\xf6r ditt bidrag",
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: "flex flex-col items-center px-8 py-10 text-center",
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                    className: "text-2xl font-bold text-dark-blue mb-3",
                    children: title
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                    className: "text-dark-blue/70 leading-relaxed",
                    dangerouslySetInnerHTML: {
                        __html: (0, (/*@__PURE__*/$parcel$interopDefault($gWEat))).sanitize(description)
                    }
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                    type: "button",
                    onClick: onClose,
                    className: "mt-8 px-8 py-3 bg-dark-blue text-white text-sm font-bold rounded hover:bg-dark-blue/80 transition-colors",
                    children: "St\xe4ng"
                })
            ]
        })
    });
}

});

parcelRegister("7XuD0", function(module, exports) {

$parcel$export(module.exports, "TermsModal", function () { return $cd5205ea975c98ba$export$e5203a3ac908a7d1; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $8ISOr = parcelRequire("8ISOr");
function $cd5205ea975c98ba$export$e5203a3ac908a7d1({ content: content, onAccept: onAccept, onDecline: onDecline }) {
    const dialogRef = (0, $8FY87.useRef)(null);
    const scrollRef = (0, $8FY87.useRef)(null);
    const [hasScrolledToBottom, setHasScrolledToBottom] = (0, $8FY87.useState)(false);
    (0, $8FY87.useEffect)(()=>{
        dialogRef.current?.showModal();
    }, []);
    const handleScroll = (0, $8FY87.useCallback)(()=>{
        const el = scrollRef.current;
        if (!el) return;
        const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 8;
        if (atBottom) setHasScrolledToBottom(true);
    }, []);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("dialog", {
        ref: dialogRef,
        onCancel: onDecline,
        className: "m-auto p-0 w-full max-w-xl rounded-2xl shadow-2xl backdrop:bg-black/50",
        "aria-label": "T\xe4vlingsvillkor",
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: "bg-whitew-full flex flex-col max-h-[80dvh]",
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "px-6 pt-6 pb-4 border-b border-dark-blue/10 rounded-t-2xl",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                            className: "text-lg font-bold text-dark-blue",
                            children: "T\xe4vlingsvillkor"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            className: "text-sm text-dark-blue/60 mt-1",
                            children: "L\xe4s igenom villkoren f\xf6r att kunna godk\xe4nna."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    ref: scrollRef,
                    onScroll: handleScroll,
                    className: "flex-1 overflow-y-auto overscroll-contain px-6 py-4 text-dark-blue leading-normal max-w-none [&>p]:mb-4 [&_ul]:my-4 [&_ul_li]:list-disc [&_ul]:pl-5 [&_ol]:mb-4 [&_ol_li]:list-decimal [&_ol]:pl-5 [&_li]:mb-1 [&_ol>li]:mb-3 [&_ol>li::marker]:font-bold max-h-[500px]",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                            tabIndex: 0,
                            "aria-hidden": "true",
                            className: "sr-only"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: (0, $8ISOr.sanitize)(content)
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: "px-6 py-4 border-t border-dark-blue/10 flex gap-3 justify-end",
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                            type: "button",
                            onClick: onDecline,
                            className: "px-5 py-2.5 text-sm font-medium rounded border border-dark-blue/20 text-dark-blue hover:bg-dark-blue/5 transition-colors",
                            children: "Godk\xe4nner inte"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                            type: "button",
                            onClick: onAccept,
                            disabled: !hasScrolledToBottom,
                            className: [
                                'px-5 py-2.5 text-sm font-bold rounded transition-colors',
                                hasScrolledToBottom ? 'bg-dark-blue text-white hover:bg-dark-blue/80' : 'bg-dark-blue/20 text-dark-blue/40 cursor-not-allowed'
                            ].join(' '),
                            children: "Godk\xe4nner"
                        })
                    ]
                })
            ]
        })
    });
}

});

parcelRegister("2v2JP", function(module, exports) {

$parcel$export(module.exports, "TiltCard", function () { return $9ecbf2427172ce1e$export$ea13214d1d2eb291; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");
function $9ecbf2427172ce1e$export$ea13214d1d2eb291({ children: children }) {
    const ref = (0, $8FY87.useRef)(null);
    const [tilt, setTilt] = (0, $8FY87.useState)({
        x: 0,
        y: 0
    });
    const [active, setActive] = (0, $8FY87.useState)(false);
    const reducedMotion = typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function onMouseMove(e) {
        if (reducedMotion) return;
        const r = ref.current?.getBoundingClientRect();
        if (!r) return;
        const x = (e.clientX - r.left) / r.width;
        const y = (e.clientY - r.top) / r.height;
        setTilt({
            x: (0.5 - y) * 12,
            y: (x - 0.5) * 12
        });
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        ref: ref,
        onMouseMove: onMouseMove,
        onMouseEnter: ()=>!reducedMotion && setActive(true),
        onMouseLeave: ()=>{
            setTilt({
                x: 0,
                y: 0
            });
            setActive(false);
        },
        className: "mt-7",
        style: {
            transform: `perspective(900px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)`,
            transition: active ? 'transform 0.08s ease-out' : 'transform 0.55s ease-out',
            transformStyle: 'preserve-3d'
        },
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            className: "bg-white border border-dark-blue/10 shadow-[0_12px_40px_rgba(0,0,0,0.10)] rounded-xl px-6 py-5 overflow-hidden",
            children: children
        })
    });
}

});



parcelRegister("eL5Bg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4245021fe29d7fdd$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $dG7aN = parcelRequire("dG7aN");
function $4245021fe29d7fdd$export$2e2bcd8739ae039({ onSelect: onSelect, selected: selected, className: className = '' }) {
    const [isOpen, setOpen] = (0, $8FY87.useState)(false);
    const [selectedSlug, setSelectedSlug] = (0, $8FY87.useState)(null);
    const [searchQuery, setSearchQuery] = (0, $8FY87.useState)('');
    const containerRef = (0, $8FY87.useRef)(null);
    const { data: data, isLoading: isLoading, isError: isError } = (0, $dG7aN.useSlugs)();
    (0, $8FY87.useEffect)(()=>{
        function handleClickOutside(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) setOpen(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const handleSelect = (slug)=>{
        setSelectedSlug(slug);
        setOpen(false);
        if (onSelect) onSelect(slug);
    };
    const pages = data?.kiaPages?.nodes || [];
    const filteredPages = pages.filter((page)=>page.slug.toLowerCase().includes(searchQuery.toLowerCase()));
    if (isError) return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: "text-red-500 text-sm p-2 border border-red-200 rounded bg-red-50",
        children: "Failed to load pages. Contact Afonso."
    });
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: `relative mx-auto w-full ${className}`,
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                type: "button",
                disabled: isLoading,
                className: `
          flex items-center justify-between w-full rounded-lg border px-4 py-2.5 text-left text-sm font-medium shadow-sm transition-all
          ${isLoading ? 'bg-gray-100 cursor-wait' : 'bg-white hover:bg-gray-50 cursor-pointer'}
          ${isOpen ? 'ring-2 ring-black border-black' : 'border-gray-300'}
        `,
                onClick: ()=>setOpen(!isOpen),
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        className: !selectedSlug ? 'text-gray-500' : 'text-gray-900',
                        children: isLoading ? 'Laddar slugs...' : selectedSlug || selected || "V\xe4lj en sida"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                        className: `h-5 w-5 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`,
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        strokeWidth: 2,
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            d: "M19 9l-7 7-7-7"
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "absolute z-50 mt-1 w-full overflow-hidden rounded-md border border-gray-200 bg-white shadow-lg ring-1 ring-black ring-opacity-5",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "border-b border-gray-100 p-2",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                            autoFocus: true,
                            type: "text",
                            placeholder: "S\xf6k p\xe5 en slug",
                            className: "w-full rounded bg-gray-50 px-2 py-1.5 text-sm outline-none ring-1 ring-transparent focus:ring-black transition-all",
                            onChange: (e)=>setSearchQuery(e.target.value),
                            value: searchQuery
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                        className: "max-h-60 overflow-y-auto py-1",
                        children: filteredPages.length === 0 ? /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                            className: "px-4 py-3 text-center text-sm text-gray-500",
                            children: "No pages found."
                        }) : filteredPages.filter((p)=>p.uri).map((page)=>{
                            const isSelected = selectedSlug === page.slug;
                            return /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                    className: `
                        w-full px-4 py-2 text-left text-sm transition-colors
                        ${isSelected ? 'bg-black text-white font-semibold' : 'text-gray-700 hover:bg-gray-100'}
                      `,
                                    onClick: ()=>handleSelect(page.slug),
                                    children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                children: page.slug
                                            }),
                                            isSelected && /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                                                className: "size-4 text-white",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                strokeWidth: 2,
                                                children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    d: "M5 13l4 4L19 7"
                                                })
                                            })
                                        ]
                                    })
                                })
                            }, page.slug);
                        })
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("dG7aN", function(module, exports) {

$parcel$export(module.exports, "useSlugs", function () { return $763e8d0923c5bbb6$export$3070a361163ac452; });
$parcel$export(module.exports, "useModuleSlugs", function () { return $763e8d0923c5bbb6$export$156d3ae215d28383; });

var $hgSaH = parcelRequire("hgSaH");

var $hOfQh = parcelRequire("hOfQh");

var $31OjQ = parcelRequire("31OjQ");
const $763e8d0923c5bbb6$export$3070a361163ac452 = ()=>{
    return (0, $hgSaH.useQuery)({
        queryKey: [
            'slugs'
        ],
        queryFn: ()=>(0, $hOfQh.executeGraphql)((0, $31OjQ.GetSlugs), undefined, true)
    });
};
const $763e8d0923c5bbb6$export$156d3ae215d28383 = ()=>{
    return (0, $hgSaH.useQuery)({
        queryKey: [
            'module-slugs'
        ],
        queryFn: ()=>(0, $hOfQh.executeGraphql)((0, $31OjQ.GetModuleSlugs), undefined, true)
    });
};

});
parcelRegister("31OjQ", function(module, exports) {

$parcel$export(module.exports, "GetSlugs", function () { return $1db22ee2a120669b$export$89f8e257971d900e; });
$parcel$export(module.exports, "GetModuleSlugs", function () { return $1db22ee2a120669b$export$cebb406283fea09a; });
parcelRequire("btB3p");
var $dd2YO = parcelRequire("dd2YO");
const $1db22ee2a120669b$export$89f8e257971d900e = (0, $dd2YO.graphql)(`
  query GetSlugs {
    kiaPages(first: 100) {
      nodes {
        slug
        uri
      }
    }
  }
`);
const $1db22ee2a120669b$export$cebb406283fea09a = (0, $dd2YO.graphql)(`
  query GetModuleSlugs {
    kiaModules(first: 100) {
      nodes {
        slug
        uri
      }
    }
  }
`);

});




parcelRegister("dBwap", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea6d13da0309647c$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $1lSPe = parcelRequire("1lSPe");

var $IZa0f = parcelRequire("IZa0f");

var $bFToE = parcelRequire("bFToE");

var $1uD1b = parcelRequire("1uD1b");

var $eoHc9 = parcelRequire("eoHc9");
function $ea6d13da0309647c$export$2e2bcd8739ae039({ uri: uri }) {
    const queryString = typeof window !== 'undefined' ? window.location.search : '';
    const searchParams = new URLSearchParams(queryString);
    const pageParam = searchParams.get('wp');
    const [selectedSlug, setSelectedSlug] = (0, $8FY87.useState)(pageParam);
    const handleSelectSlug = (slug)=>{
        setSelectedSlug(slug);
        if (typeof window !== 'undefined') {
            const params = new URLSearchParams(window.location.search);
            if (slug) params.set('wp', slug);
            else params.delete('wp');
            window.history.replaceState(null, '', `?${params.toString()}`);
        }
    };
    const [isPreviewMode, setPreviewMode] = (0, $8FY87.useState)(!(0, $1lSPe.locationIsKia)() || !!pageParam);
    const handleRefetch = ()=>{
        refetch();
    };
    const activeSlug = uri || selectedSlug || pageParam;
    const { data: data, isLoading: isLoading, isError: isError, error: error, refetch: refetch, isRefetching: isRefetching } = (0, $IZa0f.useModule)(activeSlug || '', isPreviewMode);
    if (!activeSlug && !(0, $1lSPe.locationIsKia)()) return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "mx-auto max-w-lg",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                className: "mb-4 text-xl font-bold",
                children: "V\xe4lj en modul"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eoHc9.default), {
                onSelect: handleSelectSlug
            })
        ]
    });
    if (isLoading && !(0, $1lSPe.locationIsKia)()) return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: "p-4",
        children: "Loading..."
    });
    if (isError) {
        console.error(error);
        if ((0, $1lSPe.locationIsKia)() && isPreviewMode === false) setPreviewMode(true);
        return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: "p-8 text-red-600",
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                    className: "font-bold",
                    children: "Error Loading Module"
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                    children: error instanceof Error ? error.message : 'Unknown Error'
                }),
                !(0, $1lSPe.locationIsKia)() || !isPreviewMode && /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                            className: "text-black",
                            children: [
                                "Det kan vara s\xe5 att denna modulen inte \xe4r publicerad och att det \xe4r d\xe4rf\xf6r du inte kan se ",
                                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                    className: "font-bold",
                                    children: "Live"
                                }),
                                ' ',
                                "versionen."
                            ]
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                            onClick: ()=>setPreviewMode(true),
                            className: "mt-4 bg-blue-500 text-white px-4 py-2 rounded",
                            children: "Preview"
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            Boolean(uri) || (!(0, $1lSPe.locationIsKia)() ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bFToE.default), {
                isPreviewMode: isPreviewMode,
                setPreviewMode: setPreviewMode,
                databaseId: data.kiaModule.databaseId ? data.kiaModule.databaseId : undefined,
                refetch: handleRefetch,
                isRefetching: isRefetching,
                uri: activeSlug,
                page: "module",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eoHc9.default), {
                    selected: selectedSlug,
                    onSelect: handleSelectSlug
                })
            }) : null),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1uD1b.default), {
                blocks: data?.kiaModule?.pagebuilder?.blocks
            })
        ]
    });
}

});
parcelRegister("IZa0f", function(module, exports) {

$parcel$export(module.exports, "useModule", function () { return $6d8b045230e8a448$export$477d89f786b24dea; });

var $12bBN = parcelRequire("12bBN");

var $hgSaH = parcelRequire("hgSaH");

var $hOfQh = parcelRequire("hOfQh");
const $6d8b045230e8a448$export$477d89f786b24dea = (uri, isPreview = false)=>{
    return (0, $hgSaH.useQuery)({
        queryKey: [
            'module',
            uri,
            isPreview ? 'graphql' : 'json'
        ],
        queryFn: async ()=>{
            if (isPreview) return (0, $hOfQh.executeGraphql)((0, $12bBN.GetModule), {
                uri: uri
            });
            else return (0, $hOfQh.executeModule)(uri);
        },
        enabled: !!uri,
        retry: 0,
        staleTime: isPreview ? 0 : 300000,
        refetchOnWindowFocus: isPreview
    });
};

});

parcelRegister("eoHc9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e1f8e33671f22e1$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $dG7aN = parcelRequire("dG7aN");

var $8FY87 = parcelRequire("8FY87");
function $1e1f8e33671f22e1$export$2e2bcd8739ae039({ onSelect: onSelect, selected: selected, className: className = '' }) {
    const [isOpen, setOpen] = (0, $8FY87.useState)(false);
    const [selectedSlug, setSelectedSlug] = (0, $8FY87.useState)(null);
    const [searchQuery, setSearchQuery] = (0, $8FY87.useState)('');
    const containerRef = (0, $8FY87.useRef)(null);
    const { data: data, isLoading: isLoading, isError: isError } = (0, $dG7aN.useModuleSlugs)();
    (0, $8FY87.useEffect)(()=>{
        function handleClickOutside(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) setOpen(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const handleSelect = (slug)=>{
        setSelectedSlug(slug);
        setOpen(false);
        if (onSelect) onSelect(slug);
    };
    const modules = data?.kiaModules.nodes || [];
    const filteredModules = modules.filter((m)=>m.slug.toLowerCase().includes(searchQuery.toLowerCase()));
    if (isError) return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: "text-red-500 text-sm p-2 border border-red-200 rounded bg-red-50",
        children: "Failed to load modules."
    });
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: `relative mx-auto w-full ${className}`,
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                type: "button",
                disabled: isLoading,
                className: `
          flex items-center justify-between w-full rounded-lg border px-4 py-2.5 text-left text-sm font-medium shadow-sm transition-all
          ${isLoading ? 'bg-gray-100 cursor-wait' : 'bg-white hover:bg-gray-50 cursor-pointer'}
          ${isOpen ? 'ring-2 ring-black border-black' : 'border-gray-300'}
        `,
                onClick: ()=>setOpen(!isOpen),
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        className: !selectedSlug ? 'text-gray-500' : 'text-gray-900',
                        children: isLoading ? 'Laddar slugs...' : selectedSlug || selected || "V\xe4lj en modul"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                        className: `h-5 w-5 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`,
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        strokeWidth: 2,
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            d: "M19 9l-7 7-7-7"
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "absolute z-50 mt-1 w-full overflow-hidden rounded-md border border-gray-200 bg-white shadow-lg ring-1 ring-black ring-opacity-5",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "border-b border-gray-100 p-2",
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                            autoFocus: true,
                            type: "text",
                            placeholder: "S\xf6k p\xe5 en slug",
                            className: "w-full rounded bg-gray-50 px-2 py-1.5 text-sm outline-none ring-1 ring-transparent focus:ring-black transition-all",
                            onChange: (e)=>setSearchQuery(e.target.value),
                            value: searchQuery
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                        className: "max-h-60 overflow-y-auto py-1",
                        children: filteredModules.length === 0 ? /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                            className: "px-4 py-3 text-center text-sm text-gray-500",
                            children: "No modules found."
                        }) : filteredModules.filter((m)=>m.uri).map((mod)=>{
                            const isSelected = selectedSlug === mod.slug;
                            return /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                    className: `
                        w-full px-4 py-2 text-left text-sm transition-colors
                        ${isSelected ? 'bg-black text-white font-semibold' : 'text-gray-700 hover:bg-gray-100'}
                      `,
                                    onClick: ()=>handleSelect(mod.slug),
                                    children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                children: mod.slug
                                            }),
                                            isSelected && /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                                                className: "size-4 text-white",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                strokeWidth: 2,
                                                children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    d: "M5 13l4 4L19 7"
                                                })
                                            })
                                        ]
                                    })
                                })
                            }, mod.slug);
                        })
                    })
                ]
            })
        ]
    });
}

});


parcelRegister("jrLPj", function(module, exports) {

module.exports = (parcelRequire("a0MnV"))($parcel$resolve("75QQc")).then(()=>parcelRequire('l1RKA'));

});


var $dcd09f9fb6b5db90$exports = {};
$parcel$extendImportMap({
    "clzlU": "CarouselControls.8916ba42.js",
    "clEYe": "DisclaimersControls.6e6cdbd5.js",
    "a1AD2": "NewsletterControls.5a7ca9cc.js",
    "5YhI4": "matt-lack-copy.4c389562.js",
    "75QQc": "Dashboard.9aa3d144.js"
});


var $2PPWI = parcelRequire("2PPWI");
var $1599664618c62141$exports = {};
$1599664618c62141$exports = "*,:before,:after,::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:#3b82f680;--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border:0 solid #e5e7eb}:before,:after{--tw-content:\"\"}html,:host{-webkit-text-size-adjust:100%;tab-size:4;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent;font-family:ui-sans-serif,system-ui,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;line-height:1.5}body{line-height:inherit;margin:0}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;-webkit-text-decoration:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-feature-settings:normal;font-variation-settings:normal;font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-feature-settings:inherit;font-variation-settings:inherit;font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:#0000;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{margin:0;padding:0;list-style:none}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder{opacity:1;color:#9ca3af}textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}#kia-page{line-height:1.5}h1{font-size:calc(3.75 * var(--srem));font-weight:500;line-height:1}h2{font-size:calc(1.5 * var(--srem));line-height:calc(2 * var(--srem));font-weight:500}h2.large{font-size:30px;line-height:32px}h3,h4{font-size:calc(1 * var(--srem));line-height:calc(1.5 * var(--srem));font-weight:600}@media (width>=768px){h1{font-size:calc(4.5 * var(--srem));line-height:1}h2{font-size:calc(1.875 * var(--srem));line-height:calc(2.25 * var(--srem))}}a{text-decoration-line:underline}*{font-family:kiam}p{font-size:calc(1 * var(--srem));line-height:calc(1.5 * var(--srem))}.hero p{font-size:calc(1.125 * var(--srem));line-height:calc(1.75 * var(--srem))}.bg-dark-blue p,.bg-dark-blue h1,.bg-dark-blue h2,.bg-dark-blue h3,.bg-dark-blue h4{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity,1))}.bg-dark-blue svg{filter:invert()}input[type=range]{-webkit-appearance:none;background:0 0;width:100%;height:32px}input[type=range]:focus{outline:none}input[type=range]::-webkit-slider-runnable-track{cursor:pointer;background:#000;border-bottom:1px solid #000;border-radius:4px;width:100%;height:8px;animation:none}input[type=range]::-webkit-slider-thumb{cursor:pointer;-webkit-appearance:none;background:#000;border:6px solid #fff;border-radius:8px;width:20px;height:20px;margin-top:-6px;box-shadow:0 0 #000031}input[type=range]:focus::-webkit-slider-runnable-track{background:#000}input[type=range]::-moz-range-track{cursor:pointer;background:#000;border-radius:4px;width:100%;height:8px;animation:none}input[type=range]::-moz-range-thumb{cursor:pointer;background:#000;border:6px solid #fff;border-radius:8px;width:20px;height:20px;box-shadow:0 0 #000031}input[type=range]::-ms-track{cursor:pointer;color:#0000;background:0 0;border-color:#0000;width:100%;height:8px;animation:none}input[type=range]::-ms-fill-lower{background:#000;border:0 solid #010101;border-radius:8px}input[type=range]::-ms-fill-upper{background:#000;border:0 solid #010101;border-radius:8px}input[type=range]::-ms-thumb{cursor:pointer;background:#000;border:6px solid #fff;border-radius:8px;width:20px;height:20px;margin-top:1px;box-shadow:0 0 #000031}input[type=range]:focus::-ms-fill-lower{background:#000}input[type=range]:focus::-ms-fill-upper{background:#000}input[type=checkbox],input[type=radio]{appearance:none;font:inherit;color:red;background-color:#fff;border:.15em solid #000;place-content:center;width:1.15em;height:1.15em;margin:0;display:grid}input[type=checkbox]:before,input[type=radio]:before{content:\"\";width:.65em;height:.65em;transition:transform .12s ease-in-out;transform:scale(0);box-shadow:inset 1em 1em #000}input[type=checkbox]:checked:before,input[type=radio]:checked:before{transform:scale(1)}input[type=radio]:before,input[type=radio]{border-radius:50%}input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.\\!container{width:100%!important}.container{width:100%}@media (width>=640px){.\\!container{max-width:640px!important}.container{max-width:640px}}@media (width>=768px){.\\!container{max-width:768px!important}.container{max-width:768px}}@media (width>=940px){.\\!container{max-width:940px!important}.container{max-width:940px}}@media (width>=1024px){.\\!container{max-width:1024px!important}.container{max-width:1024px}}@media (width>=1140px){.\\!container{max-width:1140px!important}.container{max-width:1140px}}@media (width>=1280px){.\\!container{max-width:1280px!important}.container{max-width:1280px}}@media (width>=1536px){.\\!container{max-width:1536px!important}.container{max-width:1536px}}@media (width>=1920px){.\\!container{max-width:1920px!important}.container{max-width:1920px}}.sr-only{clip:rect(0, 0, 0, 0);white-space:nowrap;border-width:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}.pointer-events-none{pointer-events:none}.pointer-events-auto{pointer-events:auto}.visible{visibility:visible}.invisible{visibility:hidden}.static{position:static}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.sticky{position:sticky}.inset-0{inset:0}.inset-x-0{left:0;right:0}.inset-y-0{top:0;bottom:0}.-left-\\[9999px\\]{left:-9999px}.-top-1{top:calc(calc(.25 * var(--srem)) * -1)}.bottom-0{bottom:0}.bottom-10{bottom:calc(2.5 * var(--srem))}.bottom-2{bottom:calc(.5 * var(--srem))}.bottom-20{bottom:calc(5 * var(--srem))}.bottom-4{bottom:calc(1 * var(--srem))}.bottom-5{bottom:calc(1.25 * var(--srem))}.bottom-\\[-1px\\]{bottom:-1px}.bottom-\\[86px\\]{bottom:86px}.bottom-full{bottom:100%}.left-0{left:0}.left-1\\/2{left:50%}.left-2{left:calc(.5 * var(--srem))}.left-24{left:calc(6 * var(--srem))}.left-4{left:calc(1 * var(--srem))}.right-0{right:0}.right-2{right:calc(.5 * var(--srem))}.right-3{right:calc(.75 * var(--srem))}.right-3\\/4{right:75%}.right-4{right:calc(1 * var(--srem))}.right-6{right:calc(1.5 * var(--srem))}.top-0{top:0}.top-1\\/2{top:50%}.top-10{top:calc(2.5 * var(--srem))}.top-12{top:calc(3 * var(--srem))}.top-16{top:calc(4 * var(--srem))}.top-2{top:calc(.5 * var(--srem))}.top-4{top:calc(1 * var(--srem))}.top-48{top:calc(12 * var(--srem))}.top-6{top:calc(1.5 * var(--srem))}.top-\\[300px\\]{top:300px}.top-\\[65\\%\\]{top:65%}.top-\\[86px\\]{top:86px}.top-full{top:100%}.-z-10{z-index:-10}.z-0{z-index:0}.z-10{z-index:10}.z-20{z-index:20}.z-30{z-index:30}.z-40{z-index:40}.z-50{z-index:50}.z-\\[11\\]{z-index:11}.z-\\[12\\]{z-index:12}.z-\\[1\\]{z-index:1}.z-\\[51\\]{z-index:51}.-order-1{order:-1}.order-1{order:1}.order-2{order:2}.col-span-1{grid-column:span 1/span 1}.col-span-12{grid-column:span 12/span 12}.col-span-2{grid-column:span 2/span 2}.col-span-3{grid-column:span 3/span 3}.col-span-4{grid-column:span 4/span 4}.col-start-1{grid-column-start:1}.row-span-12{grid-row:span 12/span 12}.row-span-2{grid-row:span 2/span 2}.m-1{margin:calc(.25 * var(--srem))}.m-auto{margin:auto}.-mx-6{margin-left:calc(calc(1.5 * var(--srem)) * -1);margin-right:calc(calc(1.5 * var(--srem)) * -1)}.mx-1{margin-left:calc(.25 * var(--srem));margin-right:calc(.25 * var(--srem))}.mx-2{margin-left:calc(.5 * var(--srem));margin-right:calc(.5 * var(--srem))}.mx-auto{margin-left:auto;margin-right:auto}.my-1{margin-top:calc(.25 * var(--srem));margin-bottom:calc(.25 * var(--srem))}.my-10{margin-top:calc(2.5 * var(--srem));margin-bottom:calc(2.5 * var(--srem))}.my-12{margin-top:calc(3 * var(--srem));margin-bottom:calc(3 * var(--srem))}.my-14{margin-top:calc(3.5 * var(--srem));margin-bottom:calc(3.5 * var(--srem))}.my-16{margin-top:calc(4 * var(--srem));margin-bottom:calc(4 * var(--srem))}.my-2{margin-top:calc(.5 * var(--srem));margin-bottom:calc(.5 * var(--srem))}.my-3{margin-top:calc(.75 * var(--srem));margin-bottom:calc(.75 * var(--srem))}.my-32{margin-top:calc(8 * var(--srem));margin-bottom:calc(8 * var(--srem))}.my-4{margin-top:calc(1 * var(--srem));margin-bottom:calc(1 * var(--srem))}.my-6{margin-top:calc(1.5 * var(--srem));margin-bottom:calc(1.5 * var(--srem))}.\\!mt-\\[3px\\]{margin-top:3px!important}.\\!mt-auto{margin-top:auto!important}.-mt-2{margin-top:calc(calc(.5 * var(--srem)) * -1)}.-mt-5{margin-top:calc(calc(1.25 * var(--srem)) * -1)}.mb-0{margin-bottom:0}.mb-0\\.5{margin-bottom:calc(.125 * var(--srem))}.mb-1{margin-bottom:calc(.25 * var(--srem))}.mb-10{margin-bottom:calc(2.5 * var(--srem))}.mb-12{margin-bottom:calc(3 * var(--srem))}.mb-14{margin-bottom:calc(3.5 * var(--srem))}.mb-16{margin-bottom:calc(4 * var(--srem))}.mb-2{margin-bottom:calc(.5 * var(--srem))}.mb-20{margin-bottom:calc(5 * var(--srem))}.mb-3{margin-bottom:calc(.75 * var(--srem))}.mb-4{margin-bottom:calc(1 * var(--srem))}.mb-5{margin-bottom:calc(1.25 * var(--srem))}.mb-6{margin-bottom:calc(1.5 * var(--srem))}.mb-7{margin-bottom:calc(1.75 * var(--srem))}.mb-8{margin-bottom:calc(2 * var(--srem))}.mb-9{margin-bottom:calc(2.25 * var(--srem))}.mb-\\[90px\\]{margin-bottom:90px}.ml-0{margin-left:0}.ml-1{margin-left:calc(.25 * var(--srem))}.ml-2{margin-left:calc(.5 * var(--srem))}.ml-3{margin-left:calc(.75 * var(--srem))}.ml-4{margin-left:calc(1 * var(--srem))}.ml-5{margin-left:calc(1.25 * var(--srem))}.ml-auto{margin-left:auto}.mr-2{margin-right:calc(.5 * var(--srem))}.mr-3{margin-right:calc(.75 * var(--srem))}.mr-4{margin-right:calc(1 * var(--srem))}.mt-0{margin-top:0}.mt-0\\.5{margin-top:calc(.125 * var(--srem))}.mt-1{margin-top:calc(.25 * var(--srem))}.mt-10{margin-top:calc(2.5 * var(--srem))}.mt-12{margin-top:calc(3 * var(--srem))}.mt-14{margin-top:calc(3.5 * var(--srem))}.mt-16{margin-top:calc(4 * var(--srem))}.mt-2{margin-top:calc(.5 * var(--srem))}.mt-20{margin-top:calc(5 * var(--srem))}.mt-3{margin-top:calc(.75 * var(--srem))}.mt-4{margin-top:calc(1 * var(--srem))}.mt-5{margin-top:calc(1.25 * var(--srem))}.mt-6{margin-top:calc(1.5 * var(--srem))}.mt-7{margin-top:calc(1.75 * var(--srem))}.mt-8{margin-top:calc(2 * var(--srem))}.mt-9{margin-top:calc(2.25 * var(--srem))}.mt-\\[28px\\]{margin-top:28px}.mt-\\[30px\\]{margin-top:30px}.mt-\\[33px\\]{margin-top:33px}.mt-\\[7px\\]{margin-top:7px}.mt-auto{margin-top:auto}.box-border{box-sizing:border-box}.line-clamp-1{-webkit-line-clamp:1;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.line-clamp-3{-webkit-line-clamp:3;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.line-clamp-6{-webkit-line-clamp:6;-webkit-box-orient:vertical;display:-webkit-box;overflow:hidden}.\\!block{display:block!important}.block{display:block}.inline-block{display:inline-block}.inline{display:inline}.flex{display:flex}.inline-flex{display:inline-flex}.table{display:table}.grid{display:grid}.contents{display:contents}.\\!list-item{display:list-item!important}.hidden{display:none}.aspect-\\[2\\/1\\]{aspect-ratio:2}.aspect-\\[3\\/2\\]{aspect-ratio:3/2}.aspect-\\[4\\/3\\]{aspect-ratio:4/3}.aspect-\\[478\\/319\\]{aspect-ratio:478/319}.aspect-square{aspect-ratio:1}.aspect-video{aspect-ratio:16/9}.size-10{width:calc(2.5 * var(--srem));height:calc(2.5 * var(--srem))}.size-11{width:calc(2.75 * var(--srem));height:calc(2.75 * var(--srem))}.size-12{width:calc(3 * var(--srem));height:calc(3 * var(--srem))}.size-2\\.5{width:calc(.625 * var(--srem));height:calc(.625 * var(--srem))}.size-3{width:calc(.75 * var(--srem));height:calc(.75 * var(--srem))}.size-3\\.5{width:calc(.875 * var(--srem));height:calc(.875 * var(--srem))}.size-4{width:calc(1 * var(--srem));height:calc(1 * var(--srem))}.size-5{width:calc(1.25 * var(--srem));height:calc(1.25 * var(--srem))}.size-8{width:calc(2 * var(--srem));height:calc(2 * var(--srem))}.h-0\\.5{height:calc(.125 * var(--srem))}.h-1{height:calc(.25 * var(--srem))}.h-10{height:calc(2.5 * var(--srem))}.h-11{height:calc(2.75 * var(--srem))}.h-12{height:calc(3 * var(--srem))}.h-14{height:calc(3.5 * var(--srem))}.h-16{height:calc(4 * var(--srem))}.h-20{height:calc(5 * var(--srem))}.h-28{height:calc(7 * var(--srem))}.h-3{height:calc(.75 * var(--srem))}.h-4{height:calc(1 * var(--srem))}.h-5{height:calc(1.25 * var(--srem))}.h-6{height:calc(1.5 * var(--srem))}.h-7{height:calc(1.75 * var(--srem))}.h-8{height:calc(2 * var(--srem))}.h-\\[111px\\]{height:111px}.h-\\[2px\\]{height:2px}.h-\\[34px\\]{height:34px}.h-\\[48px\\]{height:48px}.h-\\[50px\\]{height:50px}.h-\\[52vh\\]{height:52vh}.h-\\[59px\\]{height:59px}.h-\\[600px\\]{height:600px}.h-\\[60vh\\]{height:60vh}.h-\\[60vw\\]{height:60vw}.h-\\[6px\\]{height:6px}.h-\\[80vh\\]{height:80vh}.h-\\[85\\%\\]{height:85%}.h-\\[85svh\\]{height:85svh}.h-\\[85vh\\]{height:85vh}.h-\\[90px\\]{height:90px}.h-auto{height:auto}.h-dvh{height:100dvh}.h-fit{height:fit-content}.h-full{height:100%}.h-px{height:1px}.h-screen{height:100vh}.max-h-60{max-height:calc(15 * var(--srem))}.max-h-64{max-height:calc(16 * var(--srem))}.max-h-\\[290px\\]{max-height:290px}.max-h-\\[300px\\]{max-height:300px}.max-h-\\[450px\\]{max-height:450px}.max-h-\\[500px\\]{max-height:500px}.max-h-\\[600px\\]{max-height:600px}.max-h-\\[800px\\]{max-height:800px}.max-h-\\[80dvh\\]{max-height:80dvh}.max-h-\\[90dvh\\]{max-height:90dvh}.max-h-\\[90vh\\]{max-height:90vh}.max-h-\\[918\\],.max-h-\\[918px\\]{max-height:918px}.max-h-full{max-height:100%}.max-h-screen{max-height:100vh}.min-h-0{min-height:0}.min-h-11{min-height:calc(2.75 * var(--srem))}.min-h-14{min-height:calc(3.5 * var(--srem))}.min-h-40{min-height:calc(10 * var(--srem))}.min-h-\\[200px\\]{min-height:200px}.min-h-\\[290px\\]{min-height:290px}.min-h-\\[340px\\]{min-height:340px}.min-h-\\[400px\\]{min-height:400px}.min-h-\\[85svh\\]{min-height:85svh}.min-h-\\[93px\\]{min-height:93px}.min-h-screen{min-height:100vh}.w-10{width:calc(2.5 * var(--srem))}.w-11{width:calc(2.75 * var(--srem))}.w-11\\/12{width:91.6667%}.w-16{width:calc(4 * var(--srem))}.w-2\\/3{width:66.6667%}.w-28{width:calc(7 * var(--srem))}.w-3{width:calc(.75 * var(--srem))}.w-32{width:calc(8 * var(--srem))}.w-4{width:calc(1 * var(--srem))}.w-44{width:calc(11 * var(--srem))}.w-5{width:calc(1.25 * var(--srem))}.w-6{width:calc(1.5 * var(--srem))}.w-64{width:calc(16 * var(--srem))}.w-7{width:calc(1.75 * var(--srem))}.w-72{width:calc(18 * var(--srem))}.w-8{width:calc(2 * var(--srem))}.w-96{width:calc(24 * var(--srem))}.w-\\[104px\\]{width:104px}.w-\\[274px\\]{width:274px}.w-\\[298px\\]{width:298px}.w-\\[300px\\]{width:300px}.w-\\[50\\%\\]{width:50%}.w-\\[600px\\]{width:600px}.w-\\[6px\\]{width:6px}.w-\\[85\\%\\]{width:85%}.w-\\[90px\\]{width:90px}.w-\\[calc\\(100\\%-1rem\\)\\]{width:calc(100% - 1rem)}.w-fit{width:fit-content}.w-full{width:100%}.w-max{width:max-content}.w-px{width:1px}.min-w-0{min-width:0}.min-w-24{min-width:calc(6 * var(--srem))}.min-w-5{min-width:calc(1.25 * var(--srem))}.min-w-52{min-width:calc(13 * var(--srem))}.min-w-6{min-width:calc(1.5 * var(--srem))}.min-w-72{min-width:calc(18 * var(--srem))}.min-w-96{min-width:calc(24 * var(--srem))}.min-w-\\[140px\\]{min-width:140px}.min-w-\\[160px\\]{min-width:160px}.min-w-\\[175px\\]{min-width:175px}.min-w-\\[330px\\]{min-width:330px}.min-w-full{min-width:100%}.max-w-3xl{max-width:calc(48 * var(--srem))}.max-w-40{max-width:calc(10 * var(--srem))}.max-w-5xl{max-width:calc(64 * var(--srem))}.max-w-72{max-width:calc(18 * var(--srem))}.max-w-7xl{max-width:calc(80 * var(--srem))}.max-w-\\[100dvw\\]{max-width:100dvw}.max-w-\\[110ch\\]{max-width:110ch}.max-w-\\[220px\\]{max-width:220px}.max-w-\\[300px\\]{max-width:300px}.max-w-\\[380px\\]{max-width:380px}.max-w-\\[440px\\]{max-width:440px}.max-w-\\[530px\\]{max-width:530px}.max-w-\\[627px\\]{max-width:627px}.max-w-\\[650px\\]{max-width:650px}.max-w-\\[700px\\]{max-width:700px}.max-w-\\[717px\\]{max-width:717px}.max-w-\\[840px\\]{max-width:840px}.max-w-\\[90\\%\\]{max-width:90%}.max-w-\\[90dvw\\]{max-width:90dvw}.max-w-full{max-width:100%}.max-w-lg{max-width:calc(32 * var(--srem))}.max-w-md{max-width:calc(28 * var(--srem))}.max-w-none{max-width:none}.max-w-prose{max-width:65ch}.max-w-screen-2xl{max-width:1536px}.max-w-screen-kia{max-width:1920px}.max-w-screen-kia-md{max-width:1140px}.max-w-screen-kia-sm{max-width:940px}.max-w-screen-sm{max-width:640px}.max-w-screen-xl{max-width:1280px}.max-w-sm{max-width:calc(24 * var(--srem))}.max-w-xl{max-width:calc(36 * var(--srem))}.max-w-xs{max-width:calc(20 * var(--srem))}.flex-1{flex:1}.flex-\\[0_0_100\\%\\]{flex:0 0 100%}.flex-\\[0_0_85vw\\]{flex:0 0 85vw}.flex-\\[0_0_90vw\\]{flex:0 0 90vw}.flex-shrink-0,.shrink-0{flex-shrink:0}.flex-grow,.grow{flex-grow:1}.basis-1\\/3{flex-basis:33.3333%}.border-collapse{border-collapse:collapse}.-translate-x-0{--tw-translate-x:-0px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-translate-x-1\\/2{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-translate-y-1\\/2{--tw-translate-y:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-rotate-180{--tw-rotate:-180deg;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rotate-180{--tw-rotate:180deg;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.transform{transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.transform-none{transform:none}@keyframes pulse{50%{opacity:.5}}.animate-pulse{animation:2s cubic-bezier(.4,0,.6,1) infinite pulse}@keyframes spin{to{transform:rotate(360deg)}}.animate-spin{animation:1s linear infinite spin}.cursor-grab{cursor:grab}.cursor-not-allowed{cursor:not-allowed}.cursor-pointer{cursor:pointer}.cursor-wait{cursor:wait}.touch-pan-x{--tw-pan-x:pan-x;touch-action:var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom)}.touch-pan-y{--tw-pan-y:pan-y;touch-action:var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom)}.select-none{-webkit-user-select:none;user-select:none}.select-all{-webkit-user-select:all;user-select:all}.resize-none{resize:none}.resize{resize:both}.snap-x{scroll-snap-type:x var(--tw-scroll-snap-strictness)}.snap-mandatory{--tw-scroll-snap-strictness:mandatory}.snap-start{scroll-snap-align:start}.snap-end{scroll-snap-align:end}.snap-center{scroll-snap-align:center}.scroll-mt-16{scroll-margin-top:calc(4 * var(--srem))}.list-outside{list-style-position:outside}.list-decimal{list-style-type:decimal}.list-disc{list-style-type:disc}.list-none{list-style-type:none}.auto-cols-\\[80vw\\]{grid-auto-columns:80vw}.grid-flow-col{grid-auto-flow:column}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.grid-cols-\\[auto\\,1fr\\],.grid-cols-\\[auto_1fr\\]{grid-template-columns:auto 1fr}.grid-cols-\\[auto_250px\\]{grid-template-columns:auto 250px}.grid-rows-\\[0fr\\]{grid-template-rows:0fr}.grid-rows-\\[1fr\\]{grid-template-rows:1fr}.grid-rows-\\[auto_1fr\\]{grid-template-rows:auto 1fr}.grid-rows-subgrid{grid-template-rows:subgrid}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.flex-col-reverse{flex-direction:column-reverse}.flex-wrap{flex-wrap:wrap}.place-content-center{place-content:center}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.items-baseline{align-items:baseline}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.justify-around{justify-content:space-around}.justify-items-start{justify-items:start}.gap-0{gap:0}.gap-0\\.5{gap:calc(.125 * var(--srem))}.gap-1{gap:calc(.25 * var(--srem))}.gap-10{gap:calc(2.5 * var(--srem))}.gap-12{gap:calc(3 * var(--srem))}.gap-14{gap:calc(3.5 * var(--srem))}.gap-16{gap:calc(4 * var(--srem))}.gap-2{gap:calc(.5 * var(--srem))}.gap-2\\.5{gap:calc(.625 * var(--srem))}.gap-20{gap:calc(5 * var(--srem))}.gap-3{gap:calc(.75 * var(--srem))}.gap-4{gap:calc(1 * var(--srem))}.gap-5{gap:calc(1.25 * var(--srem))}.gap-6{gap:calc(1.5 * var(--srem))}.gap-8{gap:calc(2 * var(--srem))}.gap-x-12{-moz-column-gap:calc(3 * var(--srem));column-gap:calc(3 * var(--srem))}.gap-x-2{-moz-column-gap:calc(.5 * var(--srem));column-gap:calc(.5 * var(--srem))}.gap-x-3{-moz-column-gap:calc(.75 * var(--srem));column-gap:calc(.75 * var(--srem))}.gap-x-4{-moz-column-gap:calc(1 * var(--srem));column-gap:calc(1 * var(--srem))}.gap-x-8{-moz-column-gap:calc(2 * var(--srem));column-gap:calc(2 * var(--srem))}.gap-y-0{row-gap:0}.gap-y-1{row-gap:calc(.25 * var(--srem))}.gap-y-10{row-gap:calc(2.5 * var(--srem))}.gap-y-14{row-gap:calc(3.5 * var(--srem))}.gap-y-3{row-gap:calc(.75 * var(--srem))}.gap-y-4{row-gap:calc(1 * var(--srem))}.gap-y-6{row-gap:calc(1.5 * var(--srem))}.gap-y-8{row-gap:calc(2 * var(--srem))}.space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-right:calc(calc(.5 * var(--srem)) * var(--tw-space-x-reverse));margin-left:calc(calc(.5 * var(--srem)) * calc(1 - var(--tw-space-x-reverse)))}.space-y-1>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(calc(.25 * var(--srem)) * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(calc(.25 * var(--srem)) * var(--tw-space-y-reverse))}.space-y-12>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(calc(3 * var(--srem)) * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(calc(3 * var(--srem)) * var(--tw-space-y-reverse))}.space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(calc(.5 * var(--srem)) * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(calc(.5 * var(--srem)) * var(--tw-space-y-reverse))}.space-y-5>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(calc(1.25 * var(--srem)) * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(calc(1.25 * var(--srem)) * var(--tw-space-y-reverse))}.space-y-6>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(calc(1.5 * var(--srem)) * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(calc(1.5 * var(--srem)) * var(--tw-space-y-reverse))}.space-y-8>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(calc(2 * var(--srem)) * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(calc(2 * var(--srem)) * var(--tw-space-y-reverse))}.divide-y>:not([hidden])~:not([hidden]){--tw-divide-y-reverse:0;border-top-width:calc(1px * calc(1 - var(--tw-divide-y-reverse)));border-bottom-width:calc(1px * var(--tw-divide-y-reverse))}.divide-dark-blue\\/10>:not([hidden])~:not([hidden]){border-color:#05141f1a}.divide-kia-grey>:not([hidden])~:not([hidden]){--tw-divide-opacity:1;border-color:rgb(247 247 247/var(--tw-divide-opacity,1))}.place-self-start{place-self:start}.self-start{align-self:flex-start}.self-end{align-self:flex-end}.self-center{align-self:center}.justify-self-end{justify-self:end}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-visible{overflow:visible}.overflow-x-auto{overflow-x:auto}.overflow-y-auto{overflow-y:auto}.overflow-y-hidden{overflow-y:hidden}.overscroll-contain{overscroll-behavior:contain}.overscroll-x-contain{overscroll-behavior-x:contain}.scroll-smooth{scroll-behavior:smooth}.truncate{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.hyphens-none{hyphens:none}.whitespace-nowrap{white-space:nowrap}.whitespace-pre-line{white-space:pre-line}.text-balance{text-wrap:balance}.break-normal{overflow-wrap:normal;word-break:normal}.rounded{border-radius:calc(.25 * var(--srem))}.rounded-2xl{border-radius:calc(1 * var(--srem))}.rounded-3xl{border-radius:calc(1.5 * var(--srem))}.rounded-\\[100px\\]{border-radius:100px}.rounded-\\[2px\\]{border-radius:2px}.rounded-full{border-radius:9999px}.rounded-lg{border-radius:calc(.5 * var(--srem))}.rounded-md{border-radius:calc(.375 * var(--srem))}.rounded-sm{border-radius:calc(.125 * var(--srem))}.rounded-xl{border-radius:calc(.75 * var(--srem))}.rounded-t-2xl{border-top-left-radius:calc(1 * var(--srem));border-top-right-radius:calc(1 * var(--srem))}.rounded-t-lg{border-top-left-radius:calc(.5 * var(--srem));border-top-right-radius:calc(.5 * var(--srem))}.rounded-t-xl{border-top-left-radius:calc(.75 * var(--srem));border-top-right-radius:calc(.75 * var(--srem))}.border{border-width:1px}.border-0{border-width:0}.border-2{border-width:2px}.border-b{border-bottom-width:1px}.border-b-0{border-bottom-width:0}.border-b-2{border-bottom-width:2px}.border-b-4{border-bottom-width:4px}.border-r{border-right-width:1px}.border-r-2{border-right-width:2px}.border-t{border-top-width:1px}.border-t-0{border-top-width:0}.border-t-2{border-top-width:2px}.border-dashed{border-style:dashed}.border-none{border-style:none}.\\!border-black{--tw-border-opacity:1!important;border-color:rgb(0 0 0/var(--tw-border-opacity,1))!important}.border-\\[\\#05141F\\]{--tw-border-opacity:1;border-color:rgb(5 20 31/var(--tw-border-opacity,1))}.border-black{--tw-border-opacity:1;border-color:rgb(0 0 0/var(--tw-border-opacity,1))}.border-black\\/20{border-color:#0003}.border-dark-blue{--tw-border-opacity:1;border-color:rgb(5 20 31/var(--tw-border-opacity,1))}.border-dark-blue\\/10{border-color:#05141f1a}.border-dark-blue\\/15{border-color:#05141f26}.border-dark-blue\\/20{border-color:#05141f33}.border-dark-blue\\/50{border-color:#05141f80}.border-gray-100{--tw-border-opacity:1;border-color:rgb(243 244 246/var(--tw-border-opacity,1))}.border-gray-200{--tw-border-opacity:1;border-color:rgb(229 231 235/var(--tw-border-opacity,1))}.border-gray-300{--tw-border-opacity:1;border-color:rgb(209 213 219/var(--tw-border-opacity,1))}.border-gray-500{--tw-border-opacity:1;border-color:rgb(107 114 128/var(--tw-border-opacity,1))}.border-green-500{--tw-border-opacity:1;border-color:rgb(34 197 94/var(--tw-border-opacity,1))}.border-kia-grey{--tw-border-opacity:1;border-color:rgb(247 247 247/var(--tw-border-opacity,1))}.border-neutral-200{--tw-border-opacity:1;border-color:rgb(229 229 229/var(--tw-border-opacity,1))}.border-neutral-300{--tw-border-opacity:1;border-color:rgb(212 212 212/var(--tw-border-opacity,1))}.border-red-200{--tw-border-opacity:1;border-color:rgb(254 202 202/var(--tw-border-opacity,1))}.border-red-300{--tw-border-opacity:1;border-color:rgb(252 165 165/var(--tw-border-opacity,1))}.border-red-400{--tw-border-opacity:1;border-color:rgb(248 113 113/var(--tw-border-opacity,1))}.border-red-500{--tw-border-opacity:1;border-color:rgb(239 68 68/var(--tw-border-opacity,1))}.border-slate-200{--tw-border-opacity:1;border-color:rgb(226 232 240/var(--tw-border-opacity,1))}.border-slate-600{--tw-border-opacity:1;border-color:rgb(71 85 105/var(--tw-border-opacity,1))}.border-white{--tw-border-opacity:1;border-color:rgb(255 255 255/var(--tw-border-opacity,1))}.border-white\\/30{border-color:#ffffff4d}.border-t-black{--tw-border-opacity:1;border-top-color:rgb(0 0 0/var(--tw-border-opacity,1))}.border-opacity-10{--tw-border-opacity:.1}.bg-\\[\\#05141F\\],.bg-\\[\\#05141f\\]{--tw-bg-opacity:1;background-color:rgb(5 20 31/var(--tw-bg-opacity,1))}.bg-\\[\\#F7F7F7\\]{--tw-bg-opacity:1;background-color:rgb(247 247 247/var(--tw-bg-opacity,1))}.bg-\\[var\\(--hero-bg\\)\\]{background-color:var(--hero-bg)}.bg-black{--tw-bg-opacity:1;background-color:rgb(0 0 0/var(--tw-bg-opacity,1))}.bg-black\\/35{background-color:#00000059}.bg-black\\/40{background-color:#0006}.bg-black\\/90{background-color:#000000e6}.bg-blue-500{--tw-bg-opacity:1;background-color:rgb(59 130 246/var(--tw-bg-opacity,1))}.bg-dark-blue{--tw-bg-opacity:1;background-color:rgb(5 20 31/var(--tw-bg-opacity,1))}.bg-dark-blue\\/20{background-color:#05141f33}.bg-dark-blue\\/50{background-color:#05141f80}.bg-gray-100{--tw-bg-opacity:1;background-color:rgb(243 244 246/var(--tw-bg-opacity,1))}.bg-gray-200{--tw-bg-opacity:1;background-color:rgb(229 231 235/var(--tw-bg-opacity,1))}.bg-gray-300{--tw-bg-opacity:1;background-color:rgb(209 213 219/var(--tw-bg-opacity,1))}.bg-gray-50{--tw-bg-opacity:1;background-color:rgb(249 250 251/var(--tw-bg-opacity,1))}.bg-gray-500\\/50{background-color:#6b728080}.bg-gray-900{--tw-bg-opacity:1;background-color:rgb(17 24 39/var(--tw-bg-opacity,1))}.bg-green-500{--tw-bg-opacity:1;background-color:rgb(34 197 94/var(--tw-bg-opacity,1))}.bg-kia-grey{--tw-bg-opacity:1;background-color:rgb(247 247 247/var(--tw-bg-opacity,1))}.bg-kia-grey\\/50{background-color:#f7f7f780}.bg-neutral-100{--tw-bg-opacity:1;background-color:rgb(245 245 245/var(--tw-bg-opacity,1))}.bg-neutral-900{--tw-bg-opacity:1;background-color:rgb(23 23 23/var(--tw-bg-opacity,1))}.bg-red-100{--tw-bg-opacity:1;background-color:rgb(254 226 226/var(--tw-bg-opacity,1))}.bg-red-50{--tw-bg-opacity:1;background-color:rgb(254 242 242/var(--tw-bg-opacity,1))}.bg-red-50\\/30{background-color:#fef2f24d}.bg-red-50\\/40{background-color:#fef2f266}.bg-slate-100{--tw-bg-opacity:1;background-color:rgb(241 245 249/var(--tw-bg-opacity,1))}.bg-slate-200{--tw-bg-opacity:1;background-color:rgb(226 232 240/var(--tw-bg-opacity,1))}.bg-slate-200\\/50{background-color:#e2e8f080}.bg-slate-50{--tw-bg-opacity:1;background-color:rgb(248 250 252/var(--tw-bg-opacity,1))}.bg-slate-50\\/50{background-color:#f8fafc80}.bg-slate-800{--tw-bg-opacity:1;background-color:rgb(30 41 59/var(--tw-bg-opacity,1))}.bg-transparent{background-color:#0000}.bg-white{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1))}.bg-white\\/90{background-color:#ffffffe6}.bg-opacity-20{--tw-bg-opacity:.2}.bg-opacity-30{--tw-bg-opacity:.3}.bg-gradient-to-l{background-image:linear-gradient(to left, var(--tw-gradient-stops))}.bg-gradient-to-r{background-image:linear-gradient(to right, var(--tw-gradient-stops))}.from-white{--tw-gradient-from:#fff var(--tw-gradient-from-position);--tw-gradient-to:#fff0 var(--tw-gradient-to-position);--tw-gradient-stops:var(--tw-gradient-from), var(--tw-gradient-to)}.to-transparent{--tw-gradient-to:transparent var(--tw-gradient-to-position)}.bg-cover{background-size:cover}.bg-center{background-position:50%}.object-contain{-o-object-fit:contain;object-fit:contain}.object-cover{-o-object-fit:cover;object-fit:cover}.object-fill{-o-object-fit:fill;object-fit:fill}.object-\\[50\\%_60\\%\\]{-o-object-position:50% 60%;object-position:50% 60%}.object-\\[center_20\\%\\]{-o-object-position:center 20%;object-position:center 20%}.object-\\[center_60\\%\\]{-o-object-position:center 60%;object-position:center 60%}.object-center{-o-object-position:center;object-position:center}.p-0{padding:0}.p-1{padding:calc(.25 * var(--srem))}.p-2{padding:calc(.5 * var(--srem))}.p-3{padding:calc(.75 * var(--srem))}.p-4{padding:calc(1 * var(--srem))}.p-6{padding:calc(1.5 * var(--srem))}.p-7{padding:calc(1.75 * var(--srem))}.p-8{padding:calc(2 * var(--srem))}.p-\\[\\.2rem\\]{padding:.2rem}.p-\\[11px\\]{padding:11px}.px-0{padding-left:0;padding-right:0}.px-0\\.5{padding-left:calc(.125 * var(--srem));padding-right:calc(.125 * var(--srem))}.px-1{padding-left:calc(.25 * var(--srem));padding-right:calc(.25 * var(--srem))}.px-10{padding-left:calc(2.5 * var(--srem));padding-right:calc(2.5 * var(--srem))}.px-2{padding-left:calc(.5 * var(--srem));padding-right:calc(.5 * var(--srem))}.px-3{padding-left:calc(.75 * var(--srem));padding-right:calc(.75 * var(--srem))}.px-4{padding-left:calc(1 * var(--srem));padding-right:calc(1 * var(--srem))}.px-5{padding-left:calc(1.25 * var(--srem));padding-right:calc(1.25 * var(--srem))}.px-6{padding-left:calc(1.5 * var(--srem));padding-right:calc(1.5 * var(--srem))}.px-8{padding-left:calc(2 * var(--srem));padding-right:calc(2 * var(--srem))}.py-0{padding-top:0;padding-bottom:0}.py-0\\.5{padding-top:calc(.125 * var(--srem));padding-bottom:calc(.125 * var(--srem))}.py-1{padding-top:calc(.25 * var(--srem));padding-bottom:calc(.25 * var(--srem))}.py-1\\.5{padding-top:calc(.375 * var(--srem));padding-bottom:calc(.375 * var(--srem))}.py-10{padding-top:calc(2.5 * var(--srem));padding-bottom:calc(2.5 * var(--srem))}.py-12{padding-top:calc(3 * var(--srem));padding-bottom:calc(3 * var(--srem))}.py-14{padding-top:calc(3.5 * var(--srem));padding-bottom:calc(3.5 * var(--srem))}.py-2{padding-top:calc(.5 * var(--srem));padding-bottom:calc(.5 * var(--srem))}.py-2\\.5{padding-top:calc(.625 * var(--srem));padding-bottom:calc(.625 * var(--srem))}.py-20{padding-top:calc(5 * var(--srem));padding-bottom:calc(5 * var(--srem))}.py-24{padding-top:calc(6 * var(--srem));padding-bottom:calc(6 * var(--srem))}.py-3{padding-top:calc(.75 * var(--srem));padding-bottom:calc(.75 * var(--srem))}.py-3\\.5{padding-top:calc(.875 * var(--srem));padding-bottom:calc(.875 * var(--srem))}.py-4{padding-top:calc(1 * var(--srem));padding-bottom:calc(1 * var(--srem))}.py-5{padding-top:calc(1.25 * var(--srem));padding-bottom:calc(1.25 * var(--srem))}.py-6{padding-top:calc(1.5 * var(--srem));padding-bottom:calc(1.5 * var(--srem))}.py-8{padding-top:calc(2 * var(--srem));padding-bottom:calc(2 * var(--srem))}.pb-10{padding-bottom:calc(2.5 * var(--srem))}.pb-12{padding-bottom:calc(3 * var(--srem))}.pb-2{padding-bottom:calc(.5 * var(--srem))}.pb-24{padding-bottom:calc(6 * var(--srem))}.pb-3{padding-bottom:calc(.75 * var(--srem))}.pb-4{padding-bottom:calc(1 * var(--srem))}.pb-5{padding-bottom:calc(1.25 * var(--srem))}.pb-6{padding-bottom:calc(1.5 * var(--srem))}.pb-8{padding-bottom:calc(2 * var(--srem))}.pl-12{padding-left:calc(3 * var(--srem))}.pl-2{padding-left:calc(.5 * var(--srem))}.pl-3{padding-left:calc(.75 * var(--srem))}.pl-4{padding-left:calc(1 * var(--srem))}.pl-5{padding-left:calc(1.25 * var(--srem))}.pr-10{padding-right:calc(2.5 * var(--srem))}.pr-2{padding-right:calc(.5 * var(--srem))}.pr-3{padding-right:calc(.75 * var(--srem))}.pr-4{padding-right:calc(1 * var(--srem))}.pr-6{padding-right:calc(1.5 * var(--srem))}.pt-0{padding-top:0}.pt-1{padding-top:calc(.25 * var(--srem))}.pt-2{padding-top:calc(.5 * var(--srem))}.pt-3{padding-top:calc(.75 * var(--srem))}.pt-4{padding-top:calc(1 * var(--srem))}.pt-5{padding-top:calc(1.25 * var(--srem))}.pt-6{padding-top:calc(1.5 * var(--srem))}.pt-8{padding-top:calc(2 * var(--srem))}.text-left{text-align:left}.text-center{text-align:center}.text-start{text-align:start}.align-baseline{vertical-align:baseline}.font-mono{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}.font-sans{font-family:ui-sans-serif,system-ui,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji}.\\!text-\\[16px\\]{font-size:16px!important}.\\!text-lg{font-size:calc(1.125 * var(--srem))!important;line-height:calc(1.75 * var(--srem))!important}.\\!text-xs{font-size:calc(.75 * var(--srem))!important;line-height:calc(1 * var(--srem))!important}.text-2xl{font-size:calc(1.5 * var(--srem));line-height:calc(2 * var(--srem))}.text-3xl{font-size:calc(1.875 * var(--srem));line-height:calc(2.25 * var(--srem))}.text-4xl{font-size:calc(2.25 * var(--srem));line-height:calc(2.5 * var(--srem))}.text-5xl{font-size:calc(3 * var(--srem));line-height:1}.text-\\[10px\\]{font-size:10px}.text-\\[12px\\]{font-size:12px}.text-\\[13px\\]{font-size:13px}.text-\\[14px\\]{font-size:14px}.text-\\[16px\\]{font-size:16px}.text-\\[17px\\]{font-size:17px}.text-\\[18px\\]{font-size:18px}.text-\\[20px\\]{font-size:20px}.text-\\[22px\\]{font-size:22px}.text-\\[23px\\]{font-size:23px}.text-\\[24px\\]{font-size:24px}.text-\\[28px\\]{font-size:28px}.text-\\[30px\\]{font-size:30px}.text-\\[32px\\]{font-size:32px}.text-\\[40px\\]{font-size:40px}.text-\\[clamp\\(14px\\,5vw\\,24px\\)\\]{font-size:clamp(14px,5vw,24px)}.text-\\[clamp\\(24px\\,6vw\\,48px\\)\\]{font-size:clamp(24px,6vw,48px)}.text-\\[clamp\\(35px\\,_4vw\\,_72px\\)\\]{font-size:clamp(35px,4vw,72px)}.text-\\[clamp\\(38px\\,8vw\\,64px\\)\\]{font-size:clamp(38px,8vw,64px)}.text-base{font-size:calc(1 * var(--srem));line-height:calc(1.5 * var(--srem))}.text-lg{font-size:calc(1.125 * var(--srem));line-height:calc(1.75 * var(--srem))}.text-sm{font-size:calc(.875 * var(--srem));line-height:calc(1.25 * var(--srem))}.text-xl{font-size:calc(1.25 * var(--srem));line-height:calc(1.75 * var(--srem))}.text-xs{font-size:calc(.75 * var(--srem));line-height:calc(1 * var(--srem))}.font-\\[300\\]{font-weight:300}.font-\\[400\\]{font-weight:400}.font-black{font-weight:900}.font-bold{font-weight:700}.font-extrabold{font-weight:800}.font-light{font-weight:300}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.font-thin{font-weight:100}.uppercase{text-transform:uppercase}.capitalize{text-transform:capitalize}.italic{font-style:italic}.tabular-nums{--tw-numeric-spacing:tabular-nums;font-variant-numeric:var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction)}.\\!leading-\\[14\\.4px\\]{line-height:14.4px!important}.\\!leading-\\[15px\\]{line-height:15px!important}.leading-\\[1\\.1\\]{line-height:1.1}.leading-\\[1\\.2\\]{line-height:1.2}.leading-\\[1\\.3\\]{line-height:1.3}.leading-\\[17px\\]{line-height:17px}.leading-\\[1\\]{line-height:1}.leading-\\[24px\\]{line-height:24px}.leading-\\[28px\\]{line-height:28px}.leading-\\[40px\\]{line-height:40px}.leading-\\[48px\\]{line-height:48px}.leading-\\[72px\\]{line-height:72px}.leading-none{line-height:1}.leading-normal{line-height:1.5}.leading-relaxed{line-height:1.625}.leading-snug{line-height:1.375}.leading-tight{line-height:1.25}.\\!tracking-\\[0\\]{letter-spacing:0!important}.tracking-\\[4px\\]{letter-spacing:4px}.tracking-tight{letter-spacing:-.025em}.tracking-wide{letter-spacing:.025em}.tracking-widest{letter-spacing:.1em}.\\!text-black{--tw-text-opacity:1!important;color:rgb(0 0 0/var(--tw-text-opacity,1))!important}.\\!text-white{--tw-text-opacity:1!important;color:rgb(255 255 255/var(--tw-text-opacity,1))!important}.text-\\[\\#05141F\\],.text-\\[\\#05141f\\]{--tw-text-opacity:1;color:rgb(5 20 31/var(--tw-text-opacity,1))}.text-\\[var\\(--hero-text\\)\\]{color:var(--hero-text)}.text-black{--tw-text-opacity:1;color:rgb(0 0 0/var(--tw-text-opacity,1))}.text-blue-600{--tw-text-opacity:1;color:rgb(37 99 235/var(--tw-text-opacity,1))}.text-cyan-700{--tw-text-opacity:1;color:rgb(14 116 144/var(--tw-text-opacity,1))}.text-dark-blue{--tw-text-opacity:1;color:rgb(5 20 31/var(--tw-text-opacity,1))}.text-dark-blue\\/40{color:#05141f66}.text-dark-blue\\/50{color:#05141f80}.text-dark-blue\\/60{color:#05141f99}.text-dark-blue\\/70{color:#05141fb3}.text-dark-blue\\/80{color:#05141fcc}.text-gray-200{--tw-text-opacity:1;color:rgb(229 231 235/var(--tw-text-opacity,1))}.text-gray-300{--tw-text-opacity:1;color:rgb(209 213 219/var(--tw-text-opacity,1))}.text-gray-400{--tw-text-opacity:1;color:rgb(156 163 175/var(--tw-text-opacity,1))}.text-gray-500{--tw-text-opacity:1;color:rgb(107 114 128/var(--tw-text-opacity,1))}.text-gray-600{--tw-text-opacity:1;color:rgb(75 85 99/var(--tw-text-opacity,1))}.text-gray-700{--tw-text-opacity:1;color:rgb(55 65 81/var(--tw-text-opacity,1))}.text-gray-800{--tw-text-opacity:1;color:rgb(31 41 55/var(--tw-text-opacity,1))}.text-gray-900{--tw-text-opacity:1;color:rgb(17 24 39/var(--tw-text-opacity,1))}.text-green-600{--tw-text-opacity:1;color:rgb(22 163 74/var(--tw-text-opacity,1))}.text-green-700{--tw-text-opacity:1;color:rgb(21 128 61/var(--tw-text-opacity,1))}.text-neutral-600{--tw-text-opacity:1;color:rgb(82 82 82/var(--tw-text-opacity,1))}.text-red-500{--tw-text-opacity:1;color:rgb(239 68 68/var(--tw-text-opacity,1))}.text-red-600{--tw-text-opacity:1;color:rgb(220 38 38/var(--tw-text-opacity,1))}.text-slate-600{--tw-text-opacity:1;color:rgb(71 85 105/var(--tw-text-opacity,1))}.text-slate-700{--tw-text-opacity:1;color:rgb(51 65 85/var(--tw-text-opacity,1))}.text-slate-900{--tw-text-opacity:1;color:rgb(15 23 42/var(--tw-text-opacity,1))}.text-white{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity,1))}.text-white\\/70{color:#ffffffb3}.underline{text-decoration-line:underline}.no-underline{text-decoration-line:none}.decoration-current{text-decoration-color:currentColor}.underline-offset-2{text-underline-offset:2px}.underline-offset-4{text-underline-offset:4px}.antialiased{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.accent-dark-blue{accent-color:#05141f}.opacity-0{opacity:0}.opacity-100{opacity:1}.opacity-25{opacity:.25}.opacity-30{opacity:.3}.opacity-50{opacity:.5}.opacity-60{opacity:.6}.opacity-70{opacity:.7}.opacity-75{opacity:.75}.opacity-80{opacity:.8}.shadow{--tw-shadow:0 1px 3px 0 #0000001a, 0 1px 2px -1px #0000001a;--tw-shadow-colored:0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.shadow-2xl{--tw-shadow:0 25px 50px -12px #00000040;--tw-shadow-colored:0 25px 50px -12px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.shadow-\\[0_12px_40px_rgba\\(0\\,0\\,0\\,0\\.10\\)\\]{--tw-shadow:0 12px 40px #0000001a;--tw-shadow-colored:0 12px 40px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.shadow-lg{--tw-shadow:0 10px 15px -3px #0000001a, 0 4px 6px -4px #0000001a;--tw-shadow-colored:0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.shadow-md{--tw-shadow:0 4px 6px -1px #0000001a, 0 2px 4px -2px #0000001a;--tw-shadow-colored:0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.shadow-sm{--tw-shadow:0 1px 2px 0 #0000000d;--tw-shadow-colored:0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.shadow-xl{--tw-shadow:0 20px 25px -5px #0000001a, 0 8px 10px -6px #0000001a;--tw-shadow-colored:0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.outline-none{outline-offset:2px;outline:2px solid #0000}.outline{outline-style:solid}.ring{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow,0 0 #0000)}.ring-1{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow,0 0 #0000)}.ring-2{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow,0 0 #0000)}.ring-black{--tw-ring-opacity:1;--tw-ring-color:rgb(0 0 0/var(--tw-ring-opacity,1))}.ring-dark-blue{--tw-ring-opacity:1;--tw-ring-color:rgb(5 20 31/var(--tw-ring-opacity,1))}.ring-transparent{--tw-ring-color:transparent}.ring-opacity-5{--tw-ring-opacity:.05}.ring-offset-1{--tw-ring-offset-width:1px}.drop-shadow-xl{--tw-drop-shadow:drop-shadow(0 20px 13px #00000008) drop-shadow(0 8px 5px #00000014);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.invert{--tw-invert:invert(100%);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-all{transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-colors{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-opacity{transition-property:opacity;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-shadow{transition-property:box-shadow;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.transition-transform{transition-property:transform;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.duration-150{transition-duration:.15s}.duration-200{transition-duration:.2s}.duration-300{transition-duration:.3s}.duration-500{transition-duration:.5s}.ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}.will-change-transform{will-change:transform}.\\@container{container-type:inline-size}.\\[scrollbar-width\\:none\\]{scrollbar-width:none}.scrollbar-hide::-webkit-scrollbar{display:none}.scrollbar-hide{scrollbar-width:none;-ms-overflow-style:none}select{appearance:none}.carousel-card p{font-size:calc(.875 * var(--srem));line-height:calc(1.25 * var(--srem))}:host{--srem:16px}.\\*\\:col-start-1>*{grid-column-start:1}.\\*\\:row-start-1>*{grid-row-start:1}.placeholder\\:text-black::placeholder{--tw-text-opacity:1;color:rgb(0 0 0/var(--tw-text-opacity,1))}.backdrop\\:bg-black\\/50::backdrop{background-color:#00000080}.backdrop\\:bg-black\\/60::backdrop{background-color:#0009}.after\\:absolute:after{content:var(--tw-content);position:absolute}.after\\:left-\\[2px\\]:after{content:var(--tw-content);left:2px}.after\\:top-\\[2px\\]:after{content:var(--tw-content);top:2px}.after\\:h-5:after{content:var(--tw-content);height:calc(1.25 * var(--srem))}.after\\:w-5:after{content:var(--tw-content);width:calc(1.25 * var(--srem))}.after\\:rounded-full:after{content:var(--tw-content);border-radius:9999px}.after\\:border:after{content:var(--tw-content);border-width:1px}.after\\:border-gray-300:after{content:var(--tw-content);--tw-border-opacity:1;border-color:rgb(209 213 219/var(--tw-border-opacity,1))}.after\\:bg-white:after{content:var(--tw-content);--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1))}.after\\:transition-all:after{content:var(--tw-content);transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.after\\:content-\\[\\'\\'\\]:after{--tw-content:\"\";content:var(--tw-content)}.first\\:mb-6:first-child{margin-bottom:calc(1.5 * var(--srem))}.first\\:grid:first-child{display:grid}.first\\:grid-cols-1:first-child{grid-template-columns:repeat(1,minmax(0,1fr))}.first\\:gap-x-12:first-child{-moz-column-gap:calc(3 * var(--srem));column-gap:calc(3 * var(--srem))}.focus-within\\:outline-none:focus-within{outline-offset:2px;outline:2px solid #0000}.hover\\:border-black:hover{--tw-border-opacity:1;border-color:rgb(0 0 0/var(--tw-border-opacity,1))}.hover\\:border-dark-blue:hover{--tw-border-opacity:1;border-color:rgb(5 20 31/var(--tw-border-opacity,1))}.hover\\:border-gray-200:hover{--tw-border-opacity:1;border-color:rgb(229 231 235/var(--tw-border-opacity,1))}.hover\\:border-gray-400:hover{--tw-border-opacity:1;border-color:rgb(156 163 175/var(--tw-border-opacity,1))}.hover\\:border-red-400:hover{--tw-border-opacity:1;border-color:rgb(248 113 113/var(--tw-border-opacity,1))}.hover\\:bg-\\[\\#05141F\\]:hover{--tw-bg-opacity:1;background-color:rgb(5 20 31/var(--tw-bg-opacity,1))}.hover\\:bg-black:hover{--tw-bg-opacity:1;background-color:rgb(0 0 0/var(--tw-bg-opacity,1))}.hover\\:bg-black\\/10:hover{background-color:#0000001a}.hover\\:bg-dark-blue\\/5:hover{background-color:#05141f0d}.hover\\:bg-dark-blue\\/80:hover{background-color:#05141fcc}.hover\\:bg-gray-100:hover{--tw-bg-opacity:1;background-color:rgb(243 244 246/var(--tw-bg-opacity,1))}.hover\\:bg-gray-400:hover{--tw-bg-opacity:1;background-color:rgb(156 163 175/var(--tw-bg-opacity,1))}.hover\\:bg-gray-50:hover{--tw-bg-opacity:1;background-color:rgb(249 250 251/var(--tw-bg-opacity,1))}.hover\\:bg-gray-800:hover{--tw-bg-opacity:1;background-color:rgb(31 41 55/var(--tw-bg-opacity,1))}.hover\\:bg-gray-900:hover{--tw-bg-opacity:1;background-color:rgb(17 24 39/var(--tw-bg-opacity,1))}.hover\\:bg-kia-grey:hover{--tw-bg-opacity:1;background-color:rgb(247 247 247/var(--tw-bg-opacity,1))}.hover\\:bg-kia-grey\\/50:hover{background-color:#f7f7f780}.hover\\:bg-slate-50:hover{--tw-bg-opacity:1;background-color:rgb(248 250 252/var(--tw-bg-opacity,1))}.hover\\:bg-transparent:hover{background-color:#0000}.hover\\:bg-white:hover{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1))}.hover\\:bg-white\\/90:hover{background-color:#ffffffe6}.hover\\:bg-opacity-50:hover{--tw-bg-opacity:.5}.hover\\:text-black:hover{--tw-text-opacity:1;color:rgb(0 0 0/var(--tw-text-opacity,1))}.hover\\:text-black\\/50:hover{color:#00000080}.hover\\:text-gray-500:hover{--tw-text-opacity:1;color:rgb(107 114 128/var(--tw-text-opacity,1))}.hover\\:text-gray-700:hover{--tw-text-opacity:1;color:rgb(55 65 81/var(--tw-text-opacity,1))}.hover\\:text-gray-900:hover{--tw-text-opacity:1;color:rgb(17 24 39/var(--tw-text-opacity,1))}.hover\\:text-white:hover{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity,1))}.hover\\:underline:hover{text-decoration-line:underline}.hover\\:decoration-transparent:hover{text-decoration-color:#0000}.hover\\:underline-offset-4:hover{text-underline-offset:4px}.hover\\:opacity-100:hover{opacity:1}.hover\\:opacity-60:hover{opacity:.6}.hover\\:shadow-sm:hover{--tw-shadow:0 1px 2px 0 #0000000d;--tw-shadow-colored:0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow,0 0 #0000), var(--tw-ring-shadow,0 0 #0000), var(--tw-shadow)}.focus\\:border-\\[\\#05141F\\]:focus{--tw-border-opacity:1;border-color:rgb(5 20 31/var(--tw-border-opacity,1))}.focus\\:border-black:focus{--tw-border-opacity:1;border-color:rgb(0 0 0/var(--tw-border-opacity,1))}.focus\\:border-red-600:focus{--tw-border-opacity:1;border-color:rgb(220 38 38/var(--tw-border-opacity,1))}.focus\\:outline-none:focus{outline-offset:2px;outline:2px solid #0000}.focus\\:ring-1:focus{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow,0 0 #0000)}.focus\\:ring-2:focus{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow,0 0 #0000)}.focus\\:ring-\\[\\#05141F\\]:focus{--tw-ring-opacity:1;--tw-ring-color:rgb(5 20 31/var(--tw-ring-opacity,1))}.focus\\:ring-black:focus{--tw-ring-opacity:1;--tw-ring-color:rgb(0 0 0/var(--tw-ring-opacity,1))}.focus\\:ring-blue-500:focus{--tw-ring-opacity:1;--tw-ring-color:rgb(59 130 246/var(--tw-ring-opacity,1))}.focus\\:ring-dark-blue\\/20:focus{--tw-ring-color:#05141f33}.focus-visible\\:outline-none:focus-visible{outline-offset:2px;outline:2px solid #0000}.focus-visible\\:outline-black:focus-visible{outline-color:#000}.focus-visible\\:ring-2:focus-visible{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow,0 0 #0000)}.active\\:cursor-grabbing:active{cursor:grabbing}.disabled\\:cursor-not-allowed:disabled{cursor:not-allowed}.disabled\\:opacity-50:disabled{opacity:.5}.group:hover .group-hover\\:scale-105{--tw-scale-x:1.05;--tw-scale-y:1.05;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.group:hover .group-hover\\:scale-\\[1\\.025\\]{--tw-scale-x:1.025;--tw-scale-y:1.025;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.group:hover .group-hover\\:bg-gray-100{--tw-bg-opacity:1;background-color:rgb(243 244 246/var(--tw-bg-opacity,1))}.group:hover .group-hover\\:text-dark-blue{--tw-text-opacity:1;color:rgb(5 20 31/var(--tw-text-opacity,1))}.group:hover .group-hover\\:text-gray-400{--tw-text-opacity:1;color:rgb(156 163 175/var(--tw-text-opacity,1))}.group:hover .group-hover\\:text-gray-500{--tw-text-opacity:1;color:rgb(107 114 128/var(--tw-text-opacity,1))}.group:hover .group-hover\\:text-gray-600{--tw-text-opacity:1;color:rgb(75 85 99/var(--tw-text-opacity,1))}.group:hover .group-hover\\:text-gray-900{--tw-text-opacity:1;color:rgb(17 24 39/var(--tw-text-opacity,1))}.group:hover .group-hover\\:underline{text-decoration-line:underline}.group:hover .group-hover\\:opacity-100{opacity:1}.peer:checked~.peer-checked\\:bg-black{--tw-bg-opacity:1;background-color:rgb(0 0 0/var(--tw-bg-opacity,1))}.peer:checked~.peer-checked\\:after\\:translate-x-full:after{content:var(--tw-content);--tw-translate-x:100%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.peer:checked~.peer-checked\\:after\\:border-white:after{content:var(--tw-content);--tw-border-opacity:1;border-color:rgb(255 255 255/var(--tw-border-opacity,1))}.peer:focus~.peer-focus\\:outline-none{outline-offset:2px;outline:2px solid #0000}.peer:focus~.peer-focus\\:ring-4{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow,0 0 #0000)}.peer:focus~.peer-focus\\:ring-black\\/30{--tw-ring-color:#0000004d}.has-\\[\\:checked\\]\\:border-black:has(:checked){--tw-border-opacity:1;border-color:rgb(0 0 0/var(--tw-border-opacity,1))}.has-\\[\\:focus-visible\\]\\:bg-slate-100:has(:focus-visible){--tw-bg-opacity:1;background-color:rgb(241 245 249/var(--tw-bg-opacity,1))}.has-\\[\\:checked\\]\\:ring-1:has(:checked){--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow,0 0 #0000)}.has-\\[\\:checked\\]\\:ring-black:has(:checked){--tw-ring-opacity:1;--tw-ring-color:rgb(0 0 0/var(--tw-ring-opacity,1))}.data-\\[layout\\=carousel\\]\\:select-none[data-layout=carousel]{-webkit-user-select:none;user-select:none}.data-\\[active\\=\\'true\\'\\]\\:bg-black[data-active=true]{--tw-bg-opacity:1;background-color:rgb(0 0 0/var(--tw-bg-opacity,1))}.data-\\[center\\=\\'true\\'\\]\\:text-center[data-center=true]{text-align:center}.data-\\[active\\=\\'true\\'\\]\\:text-white[data-active=true]{--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity,1))}.group[data-scrollable=true] .group-data-\\[scrollable\\=true\\]\\:cursor-grab{cursor:grab}.group[data-scrollable=true] .group-data-\\[scrollable\\=true\\]\\:active\\:cursor-grabbing:active{cursor:grabbing}@container (width>=700px){.\\@xlcard\\:left-6{left:calc(1.5 * var(--srem))}.\\@xlcard\\:right-auto{right:auto}.\\@xlcard\\:top-6{top:calc(1.5 * var(--srem))}.\\@xlcard\\:row-span-1{grid-row:span 1/span 1}.\\@xlcard\\:my-auto{margin-top:auto;margin-bottom:auto}.\\@xlcard\\:block{display:block}.\\@xlcard\\:flex{display:flex}.\\@xlcard\\:hidden{display:none}.\\@xlcard\\:h-full{height:100%}.\\@xlcard\\:w-\\[85\\%\\]{width:85%}.\\@xlcard\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.\\@xlcard\\:flex-col{flex-direction:column}.\\@xlcard\\:py-12{padding-top:calc(3 * var(--srem));padding-bottom:calc(3 * var(--srem))}.\\@xlcard\\:py-8{padding-top:calc(2 * var(--srem));padding-bottom:calc(2 * var(--srem))}.\\@xlcard\\:pl-0{padding-left:0}}@media not all and (width>=1024px){.max-lg\\:mx-auto{margin-left:auto;margin-right:auto}.max-lg\\:hidden{display:none}.max-lg\\:overflow-x-scroll{overflow-x:scroll}}@media not all and (width>=640px){.max-sm\\:absolute{position:absolute}.max-sm\\:left-1\\/2{left:50%}.max-sm\\:top-1\\/2{top:50%}.max-sm\\:h-full{height:100%}.max-sm\\:w-auto{width:auto}.max-sm\\:max-w-none{max-width:none}.max-sm\\:-translate-x-1\\/2{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.max-sm\\:-translate-y-1\\/2{--tw-translate-y:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.max-sm\\:pt-\\[100\\%\\]{padding-top:100%}}@media (width>=640px){.sm\\:bottom-6{bottom:calc(1.5 * var(--srem))}.sm\\:left-1\\/2{left:50%}.sm\\:left-4{left:calc(1 * var(--srem))}.sm\\:top-1\\/2{top:50%}.sm\\:top-6{top:calc(1.5 * var(--srem))}.sm\\:ml-2{margin-left:calc(.5 * var(--srem))}.sm\\:mt-0{margin-top:0}.sm\\:block{display:block}.sm\\:flex{display:flex}.sm\\:hidden{display:none}.sm\\:h-32{height:calc(8 * var(--srem))}.sm\\:h-full{height:100%}.sm\\:w-fit{width:fit-content}.sm\\:-translate-x-1\\/2{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.sm\\:transform{transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.sm\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.sm\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.sm\\:flex-row{flex-direction:row}.sm\\:flex-col{flex-direction:column}.sm\\:justify-start{justify-content:flex-start}.sm\\:justify-center{justify-content:center}.sm\\:gap-10{gap:calc(2.5 * var(--srem))}.sm\\:gap-4{gap:calc(1 * var(--srem))}.sm\\:self-start{align-self:flex-start}.sm\\:p-0{padding:0}.sm\\:\\!px-8{padding-left:calc(2 * var(--srem))!important;padding-right:calc(2 * var(--srem))!important}.sm\\:px-4{padding-left:calc(1 * var(--srem));padding-right:calc(1 * var(--srem))}.sm\\:px-7{padding-left:calc(1.75 * var(--srem));padding-right:calc(1.75 * var(--srem))}.sm\\:pb-20{padding-bottom:calc(5 * var(--srem))}.sm\\:pl-20{padding-left:calc(5 * var(--srem))}.sm\\:text-left{text-align:left}.sm\\:text-2xl{font-size:calc(1.5 * var(--srem));line-height:calc(2 * var(--srem))}.sm\\:text-4xl{font-size:calc(2.25 * var(--srem));line-height:calc(2.5 * var(--srem))}.sm\\:text-\\[20px\\]{font-size:20px}.sm\\:text-lg{font-size:calc(1.125 * var(--srem));line-height:calc(1.75 * var(--srem))}}@media (width>=768px){.md\\:pointer-events-auto{pointer-events:auto}.md\\:bottom-8{bottom:calc(2 * var(--srem))}.md\\:left-4{left:calc(1 * var(--srem))}.md\\:left-8{left:calc(2 * var(--srem))}.md\\:right-12{right:calc(3 * var(--srem))}.md\\:right-auto{right:auto}.md\\:top-8{top:calc(2 * var(--srem))}.md\\:col-span-1{grid-column:span 1/span 1}.md\\:col-span-3{grid-column:span 3/span 3}.md\\:col-span-4{grid-column:span 4/span 4}.md\\:col-span-6{grid-column:span 6/span 6}.md\\:col-span-8{grid-column:span 8/span 8}.md\\:col-span-9{grid-column:span 9/span 9}.md\\:col-start-2{grid-column-start:2}.md\\:mb-0{margin-bottom:0}.md\\:mb-10{margin-bottom:calc(2.5 * var(--srem))}.md\\:mb-20{margin-bottom:calc(5 * var(--srem))}.md\\:mb-28{margin-bottom:calc(7 * var(--srem))}.md\\:mb-4{margin-bottom:calc(1 * var(--srem))}.md\\:ml-0{margin-left:0}.md\\:mt-0{margin-top:0}.md\\:mt-10{margin-top:calc(2.5 * var(--srem))}.md\\:mt-28{margin-top:calc(7 * var(--srem))}.md\\:mt-32{margin-top:calc(8 * var(--srem))}.md\\:mt-5{margin-top:calc(1.25 * var(--srem))}.md\\:block{display:block}.md\\:grid{display:grid}.md\\:hidden{display:none}.md\\:h-0{height:0}.md\\:h-32{height:calc(8 * var(--srem))}.md\\:h-44{height:calc(11 * var(--srem))}.md\\:h-72{height:calc(18 * var(--srem))}.md\\:h-96{height:calc(24 * var(--srem))}.md\\:h-\\[100px\\]{height:100px}.md\\:w-0{width:0}.md\\:w-1\\/3{width:33.3333%}.md\\:w-16{width:calc(4 * var(--srem))}.md\\:w-2\\/3{width:66.6667%}.md\\:w-32{width:calc(8 * var(--srem))}.md\\:w-8{width:calc(2 * var(--srem))}.md\\:w-\\[100px\\]{width:100px}.md\\:w-fit{width:fit-content}.md\\:min-w-\\[380px\\]{min-width:380px}.md\\:max-w-\\[460px\\]{max-width:460px}.md\\:flex-\\[0_0_calc\\(30\\%-1rem\\)\\]{flex:0 0 calc(30% - 1rem)}.md\\:flex-\\[0_0_calc\\(50\\%-1rem\\)\\]{flex:0 0 calc(50% - 1rem)}.md\\:auto-cols-fr{grid-auto-columns:minmax(0,1fr)}.md\\:grid-cols-12{grid-template-columns:repeat(12,minmax(0,1fr))}.md\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.md\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.md\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.md\\:flex-row{flex-direction:row}.md\\:place-items-center{place-items:center}.md\\:justify-start{justify-content:flex-start}.md\\:justify-end{justify-content:flex-end}.md\\:justify-items-center{justify-items:center}.md\\:gap-0{gap:0}.md\\:gap-10{gap:calc(2.5 * var(--srem))}.md\\:gap-4{gap:calc(1 * var(--srem))}.md\\:gap-5{gap:calc(1.25 * var(--srem))}.md\\:gap-6{gap:calc(1.5 * var(--srem))}.md\\:gap-x-8{-moz-column-gap:calc(2 * var(--srem));column-gap:calc(2 * var(--srem))}.md\\:gap-y-8{row-gap:calc(2 * var(--srem))}.md\\:space-y-0>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(0px * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(0px * var(--tw-space-y-reverse))}.md\\:self-end{align-self:flex-end}.md\\:rounded-lg{border-radius:calc(.5 * var(--srem))}.md\\:border-none{border-style:none}.md\\:p-2{padding:calc(.5 * var(--srem))}.md\\:p-5{padding:calc(1.25 * var(--srem))}.md\\:p-6{padding:calc(1.5 * var(--srem))}.md\\:px-0{padding-left:0;padding-right:0}.md\\:px-1{padding-left:calc(.25 * var(--srem));padding-right:calc(.25 * var(--srem))}.md\\:px-10{padding-left:calc(2.5 * var(--srem));padding-right:calc(2.5 * var(--srem))}.md\\:px-4{padding-left:calc(1 * var(--srem));padding-right:calc(1 * var(--srem))}.md\\:px-6{padding-left:calc(1.5 * var(--srem));padding-right:calc(1.5 * var(--srem))}.md\\:py-16{padding-top:calc(4 * var(--srem));padding-bottom:calc(4 * var(--srem))}.md\\:py-2{padding-top:calc(.5 * var(--srem));padding-bottom:calc(.5 * var(--srem))}.md\\:py-20{padding-top:calc(5 * var(--srem));padding-bottom:calc(5 * var(--srem))}.md\\:pb-8{padding-bottom:calc(2 * var(--srem))}.md\\:text-2xl{font-size:calc(1.5 * var(--srem));line-height:calc(2 * var(--srem))}.md\\:text-5xl{font-size:calc(3 * var(--srem));line-height:1}.md\\:text-6xl{font-size:calc(3.75 * var(--srem));line-height:1}.md\\:text-\\[18px\\]{font-size:18px}.md\\:text-\\[22px\\]{font-size:22px}.md\\:text-\\[24px\\]{font-size:24px}.md\\:text-\\[32px\\]{font-size:32px}.md\\:text-\\[40px\\]{font-size:40px}.md\\:text-lg{font-size:calc(1.125 * var(--srem));line-height:calc(1.75 * var(--srem))}.md\\:text-sm{font-size:calc(.875 * var(--srem));line-height:calc(1.25 * var(--srem))}.md\\:text-xl{font-size:calc(1.25 * var(--srem));line-height:calc(1.75 * var(--srem))}.md\\:font-normal{font-weight:400}.md\\:first\\:mb-0:first-child{margin-bottom:0}}@media (width>=1024px){.lg\\:bottom-10{bottom:calc(2.5 * var(--srem))}.lg\\:bottom-12{bottom:calc(3 * var(--srem))}.lg\\:left-12{left:calc(3 * var(--srem))}.lg\\:left-2{left:calc(.5 * var(--srem))}.lg\\:right-2{right:calc(.5 * var(--srem))}.lg\\:top-12{top:calc(3 * var(--srem))}.lg\\:order-1{order:1}.lg\\:order-2{order:2}.lg\\:col-span-2{grid-column:span 2/span 2}.lg\\:col-span-3{grid-column:span 3/span 3}.lg\\:col-span-5{grid-column:span 5/span 5}.lg\\:my-24{margin-top:calc(6 * var(--srem));margin-bottom:calc(6 * var(--srem))}.lg\\:-ml-3{margin-left:calc(calc(.75 * var(--srem)) * -1)}.lg\\:-mt-4{margin-top:calc(calc(1 * var(--srem)) * -1)}.lg\\:mb-0{margin-bottom:0}.lg\\:mb-10{margin-bottom:calc(2.5 * var(--srem))}.lg\\:mb-20{margin-bottom:calc(5 * var(--srem))}.lg\\:mb-6{margin-bottom:calc(1.5 * var(--srem))}.lg\\:mb-auto{margin-bottom:auto}.lg\\:ml-auto{margin-left:auto}.lg\\:mr-auto{margin-right:auto}.lg\\:mt-0{margin-top:0}.lg\\:mt-2{margin-top:calc(.5 * var(--srem))}.lg\\:mt-4{margin-top:calc(1 * var(--srem))}.lg\\:mt-7{margin-top:calc(1.75 * var(--srem))}.lg\\:mt-8{margin-top:calc(2 * var(--srem))}.lg\\:block{display:block}.lg\\:grid{display:grid}.lg\\:hidden{display:none}.lg\\:aspect-video{aspect-ratio:16/9}.lg\\:size-12{width:calc(3 * var(--srem));height:calc(3 * var(--srem))}.lg\\:h-\\[60vh\\]{height:60vh}.lg\\:max-h-\\[1018px\\]{max-height:1018px}.lg\\:max-h-\\[70dvh\\]{max-height:70dvh}.lg\\:max-h-\\[900px\\]{max-height:900px}.lg\\:min-h-\\[550px\\]{min-height:550px}.lg\\:min-h-\\[700px\\]{min-height:700px}.lg\\:min-h-\\[800px\\]{min-height:800px}.lg\\:w-\\[340px\\]{width:340px}.lg\\:w-\\[calc\\(100\\%\\+24px\\)\\]{width:calc(100% + 24px)}.lg\\:w-full{width:100%}.lg\\:min-w-40{min-width:calc(10 * var(--srem))}.lg\\:min-w-52{min-width:calc(13 * var(--srem))}.lg\\:max-w-none{max-width:none}.lg\\:basis-\\[calc\\(50\\%-20px\\)\\]{flex-basis:calc(50% - 20px)}.lg\\:grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.lg\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.lg\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.lg\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.lg\\:grid-cols-8{grid-template-columns:repeat(8,minmax(0,1fr))}.lg\\:grid-cols-\\[1fr_1\\.5fr\\]{grid-template-columns:1fr 1.5fr}.lg\\:grid-cols-\\[30\\%\\,1fr\\]{grid-template-columns:30% 1fr}.lg\\:grid-cols-\\[340px\\,1fr\\]{grid-template-columns:340px 1fr}.lg\\:flex-row{flex-direction:row}.lg\\:items-center{align-items:center}.lg\\:justify-start{justify-content:flex-start}.lg\\:justify-center{justify-content:center}.lg\\:gap-0{gap:0}.lg\\:gap-10{gap:calc(2.5 * var(--srem))}.lg\\:gap-12{gap:calc(3 * var(--srem))}.lg\\:gap-24{gap:calc(6 * var(--srem))}.lg\\:gap-3{gap:calc(.75 * var(--srem))}.lg\\:gap-4{gap:calc(1 * var(--srem))}.lg\\:gap-6{gap:calc(1.5 * var(--srem))}.lg\\:gap-8{gap:calc(2 * var(--srem))}.lg\\:gap-\\[8\\%\\]{gap:8%}.lg\\:gap-x-8{-moz-column-gap:calc(2 * var(--srem));column-gap:calc(2 * var(--srem))}.lg\\:gap-y-12{row-gap:calc(3 * var(--srem))}.lg\\:place-self-center{place-self:center}.lg\\:border-t-2{border-top-width:2px}.lg\\:bg-neutral-100{--tw-bg-opacity:1;background-color:rgb(245 245 245/var(--tw-bg-opacity,1))}.lg\\:bg-white{--tw-bg-opacity:1;background-color:rgb(255 255 255/var(--tw-bg-opacity,1))}.lg\\:bg-\\[center_20\\%\\]{background-position:50% 20%}.lg\\:object-\\[center_bottom\\]{-o-object-position:center bottom;object-position:center bottom}.lg\\:p-10{padding:calc(2.5 * var(--srem))}.lg\\:p-6{padding:calc(1.5 * var(--srem))}.lg\\:p-8{padding:calc(2 * var(--srem))}.lg\\:px-0{padding-left:0;padding-right:0}.lg\\:px-10{padding-left:calc(2.5 * var(--srem));padding-right:calc(2.5 * var(--srem))}.lg\\:px-12{padding-left:calc(3 * var(--srem));padding-right:calc(3 * var(--srem))}.lg\\:px-3{padding-left:calc(.75 * var(--srem));padding-right:calc(.75 * var(--srem))}.lg\\:px-4{padding-left:calc(1 * var(--srem));padding-right:calc(1 * var(--srem))}.lg\\:px-6{padding-left:calc(1.5 * var(--srem));padding-right:calc(1.5 * var(--srem))}.lg\\:px-8{padding-left:calc(2 * var(--srem));padding-right:calc(2 * var(--srem))}.lg\\:py-16{padding-top:calc(4 * var(--srem));padding-bottom:calc(4 * var(--srem))}.lg\\:pb-0{padding-bottom:0}.lg\\:pb-4{padding-bottom:calc(1 * var(--srem))}.lg\\:pl-8{padding-left:calc(2 * var(--srem))}.lg\\:pr-4{padding-right:calc(1 * var(--srem))}.lg\\:pt-0{padding-top:0}.lg\\:pt-5{padding-top:calc(1.25 * var(--srem))}.lg\\:pt-6{padding-top:calc(1.5 * var(--srem))}.lg\\:text-left{text-align:left}.lg\\:text-5xl{font-size:calc(3 * var(--srem));line-height:1}.lg\\:text-\\[20px\\]{font-size:20px}.lg\\:text-\\[36px\\]{font-size:36px}.lg\\:text-lg{font-size:calc(1.125 * var(--srem));line-height:calc(1.75 * var(--srem))}.lg\\:text-xl{font-size:calc(1.25 * var(--srem));line-height:calc(1.75 * var(--srem))}.lg\\:opacity-0{opacity:0}.lg\\:\\[mask-image\\:linear-gradient\\(to_left\\,transparent\\,black_5\\%\\)\\]{-webkit-mask-image:linear-gradient(270deg,#0000,#000 5%);mask-image:linear-gradient(270deg,#0000,#000 5%)}.lg\\:\\[mask-image\\:linear-gradient\\(to_right\\,transparent\\,black_5\\%\\)\\]{-webkit-mask-image:linear-gradient(90deg,#0000,#000 5%);mask-image:linear-gradient(90deg,#0000,#000 5%)}.lg\\:first\\:col-span-2:first-child{grid-column:span 2/span 2}.first\\:lg\\:grid-cols-2:first-child{grid-template-columns:repeat(2,minmax(0,1fr))}.group:hover .lg\\:group-hover\\:opacity-100{opacity:1}.data-\\[layout\\=\\'row\\'\\]\\:lg\\:col-span-2[data-layout=row]{grid-column:span 2/span 2}.data-\\[layout\\=\\'col\\'\\]\\:lg\\:grid-cols-1[data-layout=col]{grid-template-columns:repeat(1,minmax(0,1fr))}.data-\\[layout\\=\\'col\\'\\]\\:lg\\:self-start[data-layout=col]{align-self:flex-start}.group[data-layout=grid] .group-data-\\[layout\\=grid\\]\\:lg\\:ml-0{margin-left:0}.group[data-layout=grid] .group-data-\\[layout\\=grid\\]\\:lg\\:grid{display:grid}.group[data-layout=carousel] .group-data-\\[layout\\=carousel\\]\\:lg\\:flex-\\[0_0_calc\\(30\\%-1rem\\)\\]{flex:0 0 calc(30% - 1rem)}.group[data-layout=grid] .group-data-\\[layout\\=grid\\]\\:lg\\:flex-none{flex:none}.group[data-layout=grid] .group-data-\\[layout\\=grid\\]\\:lg\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.group[data-layout=grid] .group-data-\\[layout\\=grid\\]\\:lg\\:gap-4{gap:calc(1 * var(--srem))}.group[data-layout=row] .group-data-\\[layout\\=\\'row\\'\\]\\:lg\\:self-center{align-self:center}.group[data-layout=col] .group-data-\\[layout\\=\\'col\\'\\]\\:lg\\:pt-4{padding-top:calc(1 * var(--srem))}.group[data-next=true] .group-data-\\[next\\=true\\]\\:lg\\:\\[mask-image\\:linear-gradient\\(to_left\\,transparent\\,black_5\\%\\)\\]{-webkit-mask-image:linear-gradient(270deg,#0000,#000 5%);mask-image:linear-gradient(270deg,#0000,#000 5%)}.group[data-prev=true] .group-data-\\[prev\\=true\\]\\:lg\\:\\[mask-image\\:linear-gradient\\(to_right\\,transparent\\,black_5\\%\\)\\]{-webkit-mask-image:linear-gradient(90deg,#0000,#000 5%);mask-image:linear-gradient(90deg,#0000,#000 5%)}}@media (width>=1280px){.xl\\:flex{display:flex}.xl\\:hidden{display:none}.xl\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.xl\\:justify-center{justify-content:center}.xl\\:gap-20{gap:calc(5 * var(--srem))}.xl\\:gap-5{gap:calc(1.25 * var(--srem))}.xl\\:px-12{padding-left:calc(3 * var(--srem));padding-right:calc(3 * var(--srem))}.xl\\:px-8{padding-left:calc(2 * var(--srem));padding-right:calc(2 * var(--srem))}.xl\\:pl-44{padding-left:calc(11 * var(--srem))}}.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar{display:none}.\\[\\&\\>p\\]\\:mb-4>p{margin-bottom:calc(1 * var(--srem))}.\\[\\&\\>svg\\]\\:size-full>svg{width:100%;height:100%}.\\[\\&\\>svg\\]\\:w-4>svg{width:calc(1 * var(--srem))}.\\[\\&\\>svg\\]\\:animate-spin>svg{animation:1s linear infinite spin}.\\[\\&_div\\:has\\(svg\\)\\]\\:self-center div:has(svg){align-self:center}.\\[\\&_li\\]\\:mb-1 li{margin-bottom:calc(.25 * var(--srem))}.\\[\\&_ol\\>li\\:\\:marker\\]\\:font-bold ol>li::marker{font-weight:700}.\\[\\&_ol\\>li\\]\\:mb-3 ol>li{margin-bottom:calc(.75 * var(--srem))}.\\[\\&_ol\\]\\:mb-4 ol{margin-bottom:calc(1 * var(--srem))}.\\[\\&_ol\\]\\:pl-5 ol{padding-left:calc(1.25 * var(--srem))}.\\[\\&_ol_li\\]\\:list-decimal ol li{list-style-type:decimal}.\\[\\&_ul\\]\\:my-4 ul{margin-top:calc(1 * var(--srem));margin-bottom:calc(1 * var(--srem))}.\\[\\&_ul\\]\\:pl-5 ul{padding-left:calc(1.25 * var(--srem))}.\\[\\&_ul_li\\]\\:list-disc ul li{list-style-type:disc}";


var $adc227c367c2f6aa$exports = {};

$parcel$export($adc227c367c2f6aa$exports, "createRoot", function () { return $adc227c367c2f6aa$export$882461b6382ed46c; }, function (v) { return $adc227c367c2f6aa$export$882461b6382ed46c = v; });
$parcel$export($adc227c367c2f6aa$exports, "hydrateRoot", function () { return $adc227c367c2f6aa$export$757ceba2d55c277e; }, function (v) { return $adc227c367c2f6aa$export$757ceba2d55c277e = v; });
var $adc227c367c2f6aa$export$882461b6382ed46c;
var $adc227c367c2f6aa$export$757ceba2d55c277e;
'use strict';

var $95gxM = parcelRequire("95gxM");
var $adc227c367c2f6aa$var$i;
$adc227c367c2f6aa$export$882461b6382ed46c = $95gxM.createRoot;
$adc227c367c2f6aa$export$757ceba2d55c277e = $95gxM.hydrateRoot;



var $ajqgY = parcelRequire("ajqgY");
class $e7c39a38cc4f3df6$var$KiaWidget extends HTMLElement {
    root = null;
    connectedCallback() {
        const shadow = this.attachShadow({
            mode: 'closed'
        });
        const container = document.createElement('div');
        container.id = 'kia-page';
        shadow.appendChild(container);
        const sheet = new CSSStyleSheet();
        sheet.replaceSync($1599664618c62141$exports);
        shadow.adoptedStyleSheets = [
            sheet
        ];
        const fonts = [
            new FontFace('kiam', 'url(https://kia-afonso-storage.b-cdn.net/fonts/DesignKB.woff2) format("woff2")', {
                style: 'normal',
                weight: '700'
            }),
            new FontFace('kiam', 'url(https://kia-afonso-storage.b-cdn.net/fonts/DesignKL.woff2) format("woff2")', {
                style: 'normal',
                weight: '400'
            }),
            new FontFace('kiam', 'url(https://kia-afonso-storage.b-cdn.net/fonts/DesignKM.woff2) format("woff2")', {
                style: 'normal',
                weight: '300'
            })
        ];
        Promise.all(fonts.map((font)=>font.load())).then((loadedFonts)=>{
            loadedFonts.forEach((loadedFont)=>{
                document.fonts.add(loadedFont);
            });
        }).catch((error)=>{
            console.error('Error loading fonts:', error);
        });
        const fontSheet = new CSSStyleSheet();
        fontSheet.replaceSync(`
      :host {
        --srem: 16px;
        font-family: kiam;
      }
    `);
        shadow.adoptedStyleSheets = [
            fontSheet,
            sheet
        ];
        this.root = (0, (/*@__PURE__*/$parcel$interopDefault($adc227c367c2f6aa$exports))).createRoot(container);
        this.renderReact();
    }
    attributeChangedCallback() {
        this.renderReact();
    }
    disconnectedCallback() {
        this.root?.unmount();
    }
    getAttributes(widgetAttributes) {
        const attributes = {};
        Array.from(widgetAttributes).forEach((attr)=>{
            const name = attr.name;
            const value = attr.value;
            attributes[name] = value === '' ? true : value;
        });
        return {
            kiaPage: attributes['kia-page'],
            heading: attributes['heading'],
            category: attributes['category'],
            tag: attributes['tag'],
            imageType: attributes['image-type'],
            fields: attributes['fields'],
            fuelId: attributes['fuel-id'],
            categoryIds: attributes['category-ids'],
            pricelist: attributes['pricelist'],
            theme: attributes['theme'],
            pdfName: attributes['pdf-name'],
            description: attributes['description'],
            buttonLabel: attributes['button-label'],
            checkboxLabel: attributes['checkbox-label'],
            emailPlaceholder: attributes['email-placeholder'],
            thankYouMessage: attributes['thank-you-message'],
            modelCode: attributes['model-code'],
            trimCodes: attributes['trim-codes'],
            modelCodes: attributes['model-codes'],
            ids: attributes['ids'],
            privateMileages: attributes['private-mileages'],
            activeTrims: attributes['active-trims'],
            availableTrims: attributes['available-trims'],
            compact: attributes['compact']
        };
    }
    renderReact() {
        if (!this.root) return;
        const props = this.getAttributes(this.attributes);
        if (!props.kiaPage) {
            this.root.render(/*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                children: "Please provide a 'page' attribute."
            }));
            return;
        }
        this.root.render(/*#__PURE__*/ (0, $2PPWI.jsx)((0, $ajqgY.default), {
            ...props
        }));
    }
}
customElements.define('kia-widget', $e7c39a38cc4f3df6$var$KiaWidget);

})();
//# sourceMappingURL=widget.js.map
